(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

require('./runtime');

require('./adyen-giving');

require('./amazon');

require('./summary');

var formPrepare = require('./pages/checkout/formPrepare');

var qrCodeMethods = ['swish', 'wechatpayQR', 'bcmc_mobile', 'pix'];
var installmentLocales = ['pt_BR', 'ja_JP', 'tr_TR', 'es_MX'];
var maskedCardNumber;
var MASKED_CC_PREFIX = '**** **** **** ';
var selectedMethod = localStorage.getItem('selectedPaymentMethod');
var componentsObj = {};
var checkoutConfiguration;
var sessionsResponse;
var paymentMethodsResponse;
var checkout;
var formErrorsExist;
var isValid;
var paypalTerminatedEarly = false;
/**
 * @function
 * @description Initializes Adyen Secured Fields  Billing events
 */
async function initializeBillingEvents() {
            $('#billing-submit').on('click', function () {
              var isAdyenPOS = document.querySelector('.payment-method-options :checked').value === 'AdyenPOS';
              var isAdyen = document.querySelector('.payment-method-options :checked').value === 'AdyenComponent';

              if (isAdyenPOS) {
                document.querySelector('#dwfrm_adyPaydata_terminalId').value = document.querySelector('#terminalList').value;
                return true;
              }

              if (isAdyen) {
                var adyenPaymentMethod = document.querySelector('#adyenPaymentMethodName');
                var selectedMethodLabel = document.querySelector("#lb_".concat(selectedMethod));
                if (selectedMethodLabel) {
                    var paymentMethodLabel = selectedMethodLabel.innerHTML;
                    adyenPaymentMethod.value = paymentMethodLabel;
                    validateComponents();
                } else {
                    adyenPaymentMethod.value = '';
                }

                formPrepare.validateForm();

                // expand the billing form if there is any invalid input field there
                if ($('#edit-billing-address').find('input.error, select.error').length) {
                    $('.edit-block-result.billing-address .edit-toggle').trigger('click');
                }

                return showValidation();
              }

            });

  if (window.sessionsResponse) {
            sessionsResponse = window.sessionsResponse;
            checkoutConfiguration = window.Configuration;

            checkoutConfiguration.onChange = function (state
            /* , component */
            ) {
              var type = state.data.paymentMethod.type;

              if (selectedMethod === "googlepay" && type === "paywithgoogle") {
                type = "googlepay";
              }

              isValid = state.isValid;

              if (!componentsObj[type]) {
                componentsObj[type] = {};
              }

              componentsObj[type].isValid = isValid;
              componentsObj[type].stateData = state.data;
            };

            checkoutConfiguration.showPayButton = false;
            checkoutConfiguration.paymentMethodsConfiguration = {
              card: getCardConfig(),
              storedCard: getCardConfig(),
              boletobancario: {
                personalDetailsRequired: true,
                // turn personalDetails section on/off
                billingAddressRequired: false,
                // turn billingAddress section on/off
                showEmailAddress: false // allow shopper to specify their email address

              },
              paywithgoogle: getGooglePayConfig(),
              googlepay: getGooglePayConfig(),
              paypal: {
                environment: window.Configuration.environment,
                showPayButton: true,
                onClick: function onClick(data, actions) {
                  if (paypalTerminatedEarly) {
                    paymentFromComponent({
                      cancelTransaction: true,
                      merchantReference: document.querySelector('#merchantReference').value
                    });
                    paypalTerminatedEarly = false;
                    return actions.resolve();
                  }

                  paypalTerminatedEarly = true;
                  $('#dwfrm_billing').trigger('submit');

                  if (document.querySelector('#billing-submit').disabled) {
                      $('#dwfrm_billing').valid();
                      return actions.reject();
                  }

                  if (formErrorsExist) {
                    paypalTerminatedEarly = false;
                    return actions.reject();
                  }
                },
                onSubmit: function onSubmit(state, component) {
                  document.querySelector('#billing-submit').disabled = true;
                  assignPaymentMethodValue();
                  paymentFromComponent(state.data, component);
                  document.querySelector('#adyenStateData').value = JSON.stringify(state.data);
                },
                onCancel: function onCancel(data, component) {
                  paypalTerminatedEarly = false;
                  paymentFromComponent({
                    cancelTransaction: true,
                    merchantReference: document.querySelector('#merchantReference').value
                  }, component);
                },
                onError: function onError(error, component) {
                  paypalTerminatedEarly = false;
                  $('#dwfrm_billing').trigger('submit');
                  paymentFromComponent({
                    cancelPaypal: true
                  }, component);
                },
                onAdditionalDetails: function onAdditionalDetails(state
                /* , component */
                ) {
                  paypalTerminatedEarly = false;
                  document.querySelector('#paymentFromComponentStateData').value = JSON.stringify(state.data);
                  $('#dwfrm_billing').trigger('submit');
                }
              },
              mbway: {
                showPayButton: true,
                onSubmit: function onSubmit(state, component) {
                  $('#dwfrm_billing').trigger('submit');
                  assignPaymentMethodValue();

                  if (formErrorsExist) {
                    return false;
                  }

                  document.getElementById('component_mbway').querySelector('button').disabled = true;
                  paymentFromComponent(state.data, component);
                  document.querySelector('#adyenStateData').value = JSON.stringify(state.data);
                },
                onError: function onError() {
                  $('#dwfrm_billing').trigger('submit');
                },
                onAdditionalDetails: function onAdditionalDetails(state
                /* , component */
                ) {
                  document.querySelector('#paymentFromComponentStateData').value = JSON.stringify(state.data);
                  $('#dwfrm_billing').trigger('submit');
                }
              },
              swish: getQRCodeConfig(),
              bcmc_mobile: getQRCodeConfig(),
              wechatpayQR: getQRCodeConfig(),
              pix: getQRCodeConfig(),
              amazonpay: getAmazonpayConfig()
            };

            if (window.googleMerchantID !== 'null' && window.Configuration.environment === 'live') {
              checkoutConfiguration.paymentMethodsConfiguration.paywithgoogle.configuration.merchantIdentifier = window.googleMerchantID;
              checkoutConfiguration.paymentMethodsConfiguration.googlepay.configuration.merchantIdentifier = window.googleMerchantID;
            }

            if (window.cardholderNameBool !== 'null') {
              checkoutConfiguration.paymentMethodsConfiguration.card.hasHolderName = true;
              checkoutConfiguration.paymentMethodsConfiguration.card.holderNameRequired = true;
            }

            checkoutConfiguration.session = {
              id: window.sessionsResponse.id,
              sessionData: window.sessionsResponse.sessionData
            };
    checkout = await AdyenCheckout(checkoutConfiguration);
    paymentMethodsResponse = checkout.paymentMethodsResponse;

            document.querySelector('#paymentMethodsList').innerHTML = '';
            renderGenericComponent();
      }
}

function zeroAuth(data, checkout) {
  $.ajax({
    url: window.zeroAuthURL,
    type: 'POST',
    contentType: 'application/; charset=utf-8',
    data: JSON.stringify(data),
    async: false,
    success: function success(data) {
      if (data.zeroAuthResult.action) {
        document.querySelector('#buttonsContainer').style.display = 'none';
        checkout.createFromAction(data.zeroAuthResult.action).mount('#newCard');
      }

      if (data.zeroAuthResult.resultCode === 'Authorised') {
        window.location.href = window.paymentInstrumentsList;
      } else if (data.zeroAuthResult.resultCode === 'Refused') {
        window.location.href = window.paymentInstrumentsListError;
      }
    }
  });
}

function paymentsDetails(state) {
  $.ajax({
    type: 'post',
    url: window.paymentsDetails,
    data: JSON.stringify({
      data: state.data
    }),
    contentType: 'application/; charset=utf-8',
    async: false,
    success: function success(data) {
      if (data.response.isSuccessful) {
        window.location.href = window.paymentInstrumentsList;
      } else if (!data.response.isFinal && _typeof(data.response.action) === 'object') {
        checkout.createFromAction(data.action).mount('#action-container');
      } else {
        window.location.href = window.paymentInstrumentsListError;
      }
    }
  });
}
/**
 * @function
 * @description Initializes Adyen Checkout My Account events
 */
async function initializeAccountEvents() {
            checkoutConfiguration = window.Configuration;

            checkoutConfiguration.onAdditionalDetails = function (state) {
              paymentsDetails(state);
            };

            checkoutConfiguration.session = window.sessionData;
  checkout = await AdyenCheckout(checkoutConfiguration);
  var newCard = document.getElementById('newCard');
  var adyenStateData;
  var isValid = false;
  var node = checkout
      .create('card', {
              hasHolderName: true,
              holderNameRequired: true,
              onChange: function onChange(state) {
                adyenStateData = state.data;
                isValid = state.isValid;
              }
            }).mount(newCard);
            $('#applyBtn').on('click', function (e) {
              e.preventDefault();

              if (!isValid) {
                node.showValidation();
                return false;
              }

              document.querySelector('#adyenStateData').value = JSON.stringify(adyenStateData);
              zeroAuth(adyenStateData, checkout);
            });
}

function assignPaymentMethodValue() {
  var adyenPaymentMethod = document.querySelector('#adyenPaymentMethodName');
  adyenPaymentMethod.value = document.querySelector("#lb_".concat(selectedMethod)).innerHTML;
}
/**
 * To avoid re-rendering components twice, unmounts existing components from payment methods list
 */


function unmountComponents() {
  var promises = Object.entries(componentsObj).map(function ([key, val]) {
    delete componentsObj[key];
    return resolveUnmount(key, val);
  });
  return Promise.all(promises);
}

function resolveUnmount(key, val) {
  try {
    return Promise.resolve(val.node.unmount("component_".concat(key)));
  } catch (e) {
    // try/catch block for val.unmount
    return Promise.resolve(false);
  }
}

function displaySelectedMethod(type) {
  selectedMethod = type;
  localStorage.setItem('selectedPaymentMethod', selectedMethod);

  if (selectedMethod !== 'paypal') {
    $('.paypal-error-message').slideUp();
  }
  resetPaymentMethod();

  if (['paypal', 'paywithgoogle', 'googlepay', 'mbway', 'amazonpay'].concat(qrCodeMethods).indexOf(type) > -1) {
    document.querySelector('#billing-submit').disabled = true;
  } else {
    document.querySelector('#billing-submit').disabled = false;
  }

  if (type !== 'onlineBanking_PL') {
    document.querySelector("#component_".concat(type)).setAttribute('style', 'display:block');
  }

  formPrepare.validateForm();
}

function resetPaymentMethod() {
  $('.additionalFields').hide();
}

function showValidation() {
  selectedMethod = localStorage.getItem('selectedPaymentMethod');
  if (componentsObj[selectedMethod] && !componentsObj[selectedMethod].isValid) {
    componentsObj[selectedMethod].node.showValidation();
    return false;
  }

  return true;
}
/**
 * Assigns stateData value to the hidden stateData input field
 * so it's sent to the backend for processing
 */


function validateComponents() {
  var stateData;

  if (componentsObj[selectedMethod] && componentsObj[selectedMethod].stateData) {
    stateData = componentsObj[selectedMethod].stateData;
  } else {
    var type = document.querySelector("#component_".concat(selectedMethod, " .type")) ? document.querySelector("#component_".concat(selectedMethod, " .type")).value : selectedMethod;
    stateData = {
      paymentMethod: {
        type: type
      }
    };
    var brandElm = document.querySelector("#component_".concat(selectedMethod, " .brand"));

    if (brandElm && brandElm.value) {
      stateData.paymentMethod.brand = brandElm.value;
    }
  }

  document.querySelector('#adyenStateData').value = JSON.stringify(stateData);
}
/**
 * Contains fallback components for payment methods that don't have an Adyen web component yet
 */


function getFallback(paymentMethod) {
  var fallback = {
    giftcard: "\n      <input type=\"hidden\" class=\"brand\" name=\"brand\" value=\"".concat(paymentMethod.brand, "\"/>\n      <input type=\"hidden\" class=\"type\" name=\"type\" value=\"").concat(paymentMethod.type, "\"/>")
  };
  return fallback[paymentMethod.type];
}
/**
 * Renders all payment methods (including card component) retrieved from Adyen session
 */
async function renderGenericComponent() {
  if (Object.keys(componentsObj).length) {
    await unmountComponents();
  }

    if (sessionsResponse.amount) {
              checkoutConfiguration.amount = sessionsResponse.amount;
              checkoutConfiguration.paymentMethodsConfiguration.paypal.amount = sessionsResponse.amount;
              checkoutConfiguration.paymentMethodsConfiguration.amazonpay.amount = sessionsResponse.amount;
              setInstallments(sessionsResponse.amount);
            }

            if (sessionsResponse.countryCode) {
              checkoutConfiguration.countryCode = sessionsResponse.countryCode;
            }

            var amazonpay = paymentMethodsResponse.paymentMethods.find(function (paymentMethod) {
              return paymentMethod.type === 'amazonpay';
            });

            if (amazonpay) {
              checkoutConfiguration.paymentMethodsConfiguration.amazonpay.configuration = amazonpay.configuration;
            }

            if (paymentMethodsResponse.storedPaymentMethods) {
              for (var i = 0; i < checkout.paymentMethodsResponse.storedPaymentMethods.length; i++) {
                paymentMethod = checkout.paymentMethodsResponse.storedPaymentMethods[i];

                if (paymentMethod.supportedShopperInteractions.includes('Ecommerce')) {
                  renderPaymentMethod(paymentMethod, true, sessionsResponse.imagePath);
                }
              }
            }

			paymentMethodsResponse.paymentMethods.forEach(function (pm) {
                if (isMethodTypeAllowed(pm.type)) {
                    renderPaymentMethod(pm, false, sessionsResponse.imagePath);
                }
            });

            var firstPaymentMethod;
            selectedMethod = localStorage.getItem('selectedPaymentMethod');
            if (selectedMethod !== 'CREDIT_ACCOUNT') {
                if (selectedMethod === 'AdyenComponent') {
                    firstPaymentMethod = document.querySelector('input[id=rb_scheme]');
                } else {
                    firstPaymentMethod = document.querySelector('input[id=rb_' + selectedMethod + ']');

                    if (!$(firstPaymentMethod) || !$(firstPaymentMethod).length) {
                        firstPaymentMethod = document.querySelector('input[id=rb_scheme]');
                    }
                }

                $(firstPaymentMethod).parent().addClass('active');
                $(firstPaymentMethod).attr('checked', true).trigger('change');

                displaySelectedMethod($(firstPaymentMethod).val());
            }
}


/**
 * checks if payment method is allowed in custom preference
*/
function isMethodTypeAllowed(methodType) {
    const allowedPaymentMethods = window.SitePreferences.ADYEN_AVAILABLE_METHODS;

    if (methodType !== 'scheme' && (!allowedPaymentMethods.length || allowedPaymentMethods.split(',').indexOf(methodType) == -1)) {
        return false;
    }

    return true;
}

function getPaymentMethodID(isStored, paymentMethod) {
  if (isStored) {
    return "storedCard".concat(paymentMethod.id);
  }

  if (paymentMethod.brand) {
    // gift cards all share the same type. Brand is used to differentiate between them
    return "".concat(paymentMethod.type, "_").concat(paymentMethod.brand);
  }

  return paymentMethod.type;
}

/**
* Sorts the payment method list items in the DOM based on their current vertical visual order.
*
* This function queries the element with the ID 'paymentMethodsList' and collects all child <li> elements
* with the class 'paymentMethod'. It then determines their current vertical positions using getBoundingClientRect(),
* sorts them by their 'top' property, and re-appends them to the parent list in the correct visual order
* if they are not already ordered. This ensures the DOM order matches the rendered visual order, which can
* be important for accessibility and keyboard navigation.
*
* @returns {void}
*/
function sortPaymentMethodsByVisualOrder() {
  const list = document.querySelector('#paymentMethodsList');
  if (!list) return;
 
  // Collect all <li> elements that represent payment methods
  const items = [...list.querySelectorAll('li.paymentMethod')];
  if (items.length < 2) return;
 
  // Map each <li> to its bounding rectangle (to read vertical position)
  const sorted = items
    .map(li => ({ li, rect: li.getBoundingClientRect() }))
    // Sort only by vertical position (top value)
    .sort((a, b) => a.rect.top - b.rect.top)
    // Extract the original <li> element after sorting
    .map(x => x.li);
 
  // If the order is already correct, do nothing
  const unchanged = items.every((li, i) => li === sorted[i]);
  if (unchanged) return;
 
  // Re-append each <li> in the new order to update the DOM
  sorted.forEach(li => list.appendChild(li));
}

function renderPaymentMethod(paymentMethod, storedPaymentMethodBool, path) {
  path = `${Urls.staticPath}/images/`;
  var paymentMethodsUI = document.querySelector('#paymentMethodsList');
  var li = document.createElement('li');
  var paymentMethodID = getPaymentMethodID(storedPaymentMethodBool, paymentMethod);
  var isSchemeNotStored = paymentMethod.type === 'scheme' && !storedPaymentMethodBool;
  var paymentMethodImage = storedPaymentMethodBool ? "".concat(path).concat(paymentMethod.brand, ".png") : "".concat(path).concat(paymentMethod.type, ".png");
  var cardImage = "".concat(path, "card.png");
  var imagePath = isSchemeNotStored ? cardImage : paymentMethodImage;
  var images = '';

  if (paymentMethod.type === 'scheme') {
    images = `<div class='images-set d-flex'>
                <img class="lazyload paymentMethod_img image-item-visa" data-src="${path}visa.svg" />
                <img class="lazyload paymentMethod_img image-item-mastercard" data-src="${path}mastercard.svg" />
                <img class="lazyload paymentMethod_img image-item-discover" data-src="${path}discover.svg" />
            `;
    if (window.locale === "en_GB" || window.locale === "it_IT") {

        images += `<img class="lazyload paymentMethod_img image-item-amex" data-src="${path}amex.svg" />`

    } else if (window.locale === "fr_FR") {

        images += ` <img class="lazyload paymentMethod_img image-item-bancaire" data-src="${path}bancaire.svg" />
                    <img class="lazyload paymentMethod_img image-item-amex" data-src="${path}amex.svg" />
                `;


    } else if (window.locale === "fr_BE" || window.locale === "nl_BE") {

        images += ` <img class="lazyload paymentMethod_img image-item-maestro" data-src="${path}maestro.svg" />
                    <img class="lazyload paymentMethod_img image-item-bancontact" data-src="${path}bancontact.svg" />
                    <img class="lazyload paymentMethod_img image-item-amex" data-src="${path}amex.svg" />
                `;
    } else if (window.locale === "de_DE") {

        images += `<img class="lazyload paymentMethod_img image-item-girocard" data-src="${path}girocard.svg" />`;
    }

    images += "</div>";
  } else {
    images = `<img class="lazyload paymentMethod_img additional-payment-image-item" data-src="${imagePath}" />`;
  }

 var label = paymentMethod.type === "scheme" && Resources.PAY_CREDIT_CARD ||
              paymentMethod.type === "paypal" && Resources.PAY_PAYPAL ||
              paymentMethod.type === "klarna" && Resources.PAY_KLARNA ||
              paymentMethod.type === "klarna_account" && Resources.PAY_KLARNA_OVER_TIME ||
              paymentMethod.type === "ideal" && Resources.PAY_IDEAL ||
              paymentMethod.type === "klarna_paynow" && Resources.PAY_KLARNA_PAY_NOW ||
              paymentMethod.name;
  var liContents = `<input class="input-radio" name="brandCode" type="radio" tabindex="0" value="${paymentMethodID}" id="rb_${paymentMethodID}"/><label id="lb_${paymentMethodID}" for="rb_${paymentMethodID}" style="float: none; width: 100%; text-align: inherit;display: flex; justify-content: space-between; align-items: center; height: 100%;">${label}${images}</label>`;

  var container = document.createElement('div');
  li.innerHTML = liContents;
  li.classList.add('paymentMethod');
  li.classList.add(paymentMethod.type);
  var node = renderCheckoutComponent(storedPaymentMethodBool, checkout, paymentMethod, container, paymentMethodID);
  container.classList.add('additionalFields');
  container.setAttribute('id', "component_".concat(paymentMethodID));
  container.setAttribute('style', 'display:none');
  li.append(container);
  paymentMethodsUI.append(li);
  if (paymentMethodID !== 'paypal') {
    paymentMethodsUI.after(container);
  } else {
    $('.form-row-button-submit').append(container);
  }

  if (paymentMethod.type !== 'paywithgoogle') {
    node && node.mount(container);
  } else {
    node.isAvailable().then(function () {
      node.mount(container);
    })["catch"](function () {}); // eslint-disable-line no-empty
  }

    if (paymentMethod.type === "scheme") {
        var cardDetailsTitle = document.createElement('h2');
        cardDetailsTitle.innerHTML = Resources.CARD_DETAILS;
        container.prepend(cardDetailsTitle);
    }


  var input = document.querySelector("#rb_".concat(paymentMethodID));

    // change submit-button text
    function insertSubmitButtonText(input) {
        var submitButton = $('#billing-submit');
        var inputLabel = $(input).next('label').text();

        if($(input).attr('value') === 'scheme') {
            submitButton.text(Resources.PAY_SECURELY);
        } else {
            submitButton.text(inputLabel);
        }
    }

  input.onchange = async function (event) {
    if (
        document.querySelector('.adyen-checkout__qr-loader') &&
        qrCodeMethods.indexOf(selectedMethod) > -1 ||
        paypalTerminatedEarly
    ) {
                paypalTerminatedEarly = false;
                paymentFromComponent({
                  cancelTransaction: true,
                  merchantReference: document.querySelector('#merchantReference').value
                });
              }
			  insertSubmitButtonText(event.target);

              displaySelectedMethod(event.target.value);

			  // force select the Adyen payment method radio button
              $('input[id="is-AdyenComponent"').prop('checked', true);

              $('.paymentMethod.active').removeClass('active');
              $(event.target).parent().addClass('active');

    };


  if (paymentMethodID === 'giropay') {
    container.innerHTML = '';
  }

  if (componentsObj[paymentMethodID] && !container.childNodes[0] && ['bcmc', 'scheme'].indexOf(paymentMethodID) === -1) {
    componentsObj[paymentMethodID].isValid = true;
  }

  sortPaymentMethodsByVisualOrder();
}

function renderCheckoutComponent(storedPaymentMethodBool, checkout, paymentMethod, container, paymentMethodID) {
  if (storedPaymentMethodBool) {
    return createCheckoutComponent(checkout, paymentMethod, container, paymentMethodID);
  }

  var fallback = getFallback(paymentMethod);

  if(paymentMethod.type === 'klarna' || paymentMethod.type === 'klarna_account' || paymentMethod.type === 'klarna_paynow') {
      var klarnaContent = `
            <div class="klarna_content">
                <h2 class="klarna_content-title">${paymentMethod.type === 'klarna' ? Resources.KLARNA_TITLE : Resources.KLARNA_ACCOUNT_TITLE}</h2>
                <p class="klarna_content-text">${paymentMethod.type === 'klarna' ? Resources.KLARNA_TEXT : Resources.KLARNA_ACCOUNT_TEXT}</p>
            </div>`;
      container.innerHTML = klarnaContent;
      return
  }

  if (fallback) {
    var template = document.createElement('template');
    template.innerHTML = fallback;
    container.append(template.content);
    return;
  }

  return createCheckoutComponent(checkout, paymentMethod, container, paymentMethodID);
}

function getPersonalDetails() {
  var shippingAddress = sessionsResponse.shippingAddress;
  return {
    firstName: shippingAddress.firstName,
    lastName: shippingAddress.lastName,
    telephoneNumber: shippingAddress.phone
  };
}

function createCheckoutComponent(checkout, paymentMethod, container, paymentMethodID) {
  try {
    var nodeData = Object.assign(paymentMethod, {
      data: Object.assign(getPersonalDetails(), {
        personalDetails: getPersonalDetails()
      }),
      visibility: {
        personalDetails: 'editable',
        billingAddress: 'hidden',
        deliveryAddress: 'hidden'
      }
    });
    var node = checkout.create(paymentMethod.type, nodeData);

    if (!componentsObj[paymentMethodID]) {
      componentsObj[paymentMethodID] = {};
    }

    componentsObj[paymentMethodID].node = node;
    return node;
  } catch (e) {} // eslint-disable-line no-empty


  return false;
}
/**
 * Makes an ajax call to the controller function PaymentFromComponent.
 * Used by certain payment methods like paypal
 */


function paymentFromComponent(data, component) {
  $.ajax({
    url: window.paymentFromComponentURL,
    type: 'post',
    data: JSON.stringify(data),
    contentType: 'application/; charset=utf-8',
    success: function success(data) {
      if (data.result && data.result.orderNo && data.result.orderToken) {
        document.querySelector('#orderToken').value = data.result.orderToken;
        document.querySelector('#merchantReference').value = data.result.orderNo;
      }

      if (data.result && data.result.fullResponse && data.result.fullResponse.action) {
        component.handleAction(data.result.fullResponse.action);
      } else {
        document.querySelector('#paymentFromComponentStateData').value = JSON.stringify('null');
        $('#dwfrm_billing').trigger('submit');
      }
    }
  }).fail(function () {});
}

$('#dwfrm_billing').submit(function (e) {
  if (['paypal', 'mbway', 'amazonpay'].concat(qrCodeMethods).indexOf(selectedMethod) > -1 && !document.querySelector('#paymentFromComponentStateData').value) {
    e.preventDefault();
    var form = $(this);
    var url = form.attr('action') + '?format=ajax';
    $.ajax({
      type: 'POST',
      url: url,
      data: form.serialize(),
      async: false,
      success: function success(data) {
        formErrorsExist = data.fieldErrors;
      }
    });
  }
});

function getQRCodeConfig() {
  return {
    showPayButton: true,
    onSubmit: function onSubmit(state, component) {
      $('#dwfrm_billing').trigger('submit');

      if (formErrorsExist) {
        return;
      }

      assignPaymentMethodValue();
      document.querySelector('#adyenStateData').value = JSON.stringify(state.data);
      paymentFromComponent(state.data, component);
    },
    onAdditionalDetails: function onAdditionalDetails(state
    /* , component */
    ) {
      document.querySelector('#paymentFromComponentStateData').value = JSON.stringify(state.data);
      $('#dwfrm_billing').trigger('submit');
    }
  };
}

function getCardConfig() {
  return {
    enableStoreDetails: showStoreDetails,
    showBrandsUnderCardNumber: false,
	hasHolderName: true,
    holderNameRequired: true,
      positionHolderNameOnTop: true,
      data: {

      },
    styles: {
        base: {
            fontSize: '16px',
            color: '#212529',
            caretColor: '#212529'
        },
        error: {
            color: '#AF1212'
        },
    },
    onBrand: function onBrand(brandObject) {
      $('#cardType').val(brandObject.brand);
    },
    onFieldValid: function onFieldValid(data) {
      if (data.endDigits) {
        maskedCardNumber = MASKED_CC_PREFIX + data.endDigits;
        $('#cardNumber').val(maskedCardNumber);
      }

	  formPrepare.validateForm();
    },
    onChange: function onChange(state) {
      isValid = state.isValid;
      var methodToUpdate = state.data.paymentMethod.storedPaymentMethodId ? "storedCard".concat(state.data.paymentMethod.storedPaymentMethodId) : selectedMethod;

      if (methodToUpdate === "onlineBanking_PL"){
        return;
      }
      $('#browserInfo').val(JSON.stringify(state.data.browserInfo));
      if (componentsObj[methodToUpdate]) {
          componentsObj[methodToUpdate].isValid = isValid;
          componentsObj[methodToUpdate].stateData = state.data;
      }
        formPrepare.validateForm();

        // if dual brand not selected, preselect the first one
        var dualBrandContainer = $('.adyen-checkout__card__dual-branding__buttons--active');
        if (dualBrandContainer.length && !dualBrandContainer.find('.adyen-checkout__card__cardNumber__brandIcon--not-selected').length) {
            dualBrandContainer.children('img').first().trigger('click');
        }
    }
  };
}

function getGooglePayConfig() {
  return {
    environment: window.Configuration.environment,
    onSubmit: function onSubmit() {
      assignPaymentMethodValue();
      document.querySelector('#billing-submit').disabled = false;
      document.querySelector('#billing-submit').click();
    },
    configuration: {
      gatewayMerchantId: window.merchantAccount
    },
    showPayButton: true,
    buttonColor: 'white'
  };
}

function getAmazonpayConfig() {
  return {
    showPayButton: true,
    productType: 'PayAndShip',
    checkoutMode: 'ProcessOrder',
    locale: window.Configuration.locale,
    returnUrl: window.returnURL,
    addressDetails: {
      name: sessionsResponse.shippingAddress.firstName + ' ' + sessionsResponse.shippingAddress.lastName,
      addressLine1: sessionsResponse.shippingAddress.address1,
      city: sessionsResponse.shippingAddress.city,
      stateOrRegion: sessionsResponse.shippingAddress.city,
      postalCode: sessionsResponse.shippingAddress.postalCode,
      countryCode: sessionsResponse.shippingAddress.country,
      phoneNumber: sessionsResponse.shippingAddress.phone
    },
    onClick: function onClick(resolve, reject) {
      $('#dwfrm_billing').trigger('submit');

      if (formErrorsExist) {
        reject();
      } else {
        assignPaymentMethodValue();
        resolve();
      }
    },
    onError: function onError() {}
  };
}

function getInstallmentValues(maxValue) {
  var values = [];

  for (var i = 1; i <= maxValue; i += 1) {
    values.push(i);
  }

  return values;
}

function setInstallments(amount) {
  try {
    if (installmentLocales.indexOf(window.Configuration.locale) < 0) {
      return;
    }
    const [minAmount, numOfInstallments] = window.installments ?
        window.installments.replace(/\[|]/g, '').split(',') : [null, null];
    if (minAmount <= amount.value) {
      checkoutConfiguration.paymentMethodsConfiguration.card.installmentOptions = {
        card: {}
      }; // eslint-disable-next-line max-len

      checkoutConfiguration.paymentMethodsConfiguration.card.installmentOptions.card.values = getInstallmentValues(numOfInstallments);
      checkoutConfiguration.paymentMethodsConfiguration.card.showInstallmentAmounts = true;
    }
  } catch (e) {} // eslint-disable-line no-empty

}
/**
 * @function
 * @description Initializes Adyen CSE billing events
 */


exports.initBilling = function () {
  initializeBillingEvents();
};

exports.initAccount = function () {
  initializeAccountEvents();
};

exports.renderGenericComponent = function () {
  renderGenericComponent();
};

},{"./adyen-giving":2,"./amazon":4,"./pages/checkout/formPrepare":45,"./runtime":90,"./summary":99,"@babel/runtime/regenerator":110}],2:[function(require,module,exports){
"use strict";

var donation;

function handleOnDonate(state, component) {
  if (!state.isValid) {
    return;
  }

  var selectedAmount = state.data.amount;
  var donationData = {
    amountValue: selectedAmount.value,
    amountCurrency: selectedAmount.currency,
    orderNo: window.orderNo,
    pspReference: window.pspReference
  };
  $.ajax({
    url: window.donateURL,
    type: 'post',
    data: JSON.stringify(donationData),
    contentType: 'application/; charset=utf-8',
    success: function success() {
      component.setStatus('success');
    }
  });
}

function handleOnCancel() {
  var adyenGiving = document.getElementById('adyenGiving');
  adyenGiving.style.transition = 'all 3s ease-in-out';
  adyenGiving.style.display = 'none';
  donation.unmount();
}

if (document.querySelector('.adyen-payment-details') && window.adyenGivingAvailable) {
  var adyenGivingNode = document.getElementById('donate-container');
  var amounts;

  try {
    amounts = JSON.parse(window.donationAmounts);
  } catch (e) {
    amounts = [];
  }

  var donationConfig = {
    amounts: amounts,
    backgroundUrl: window.adyenGivingBackgroundUrl,
    description: window.charityDescription,
    logoUrl: window.adyenGivingLogoUrl,
    name: window.charityName,
    url: window.charityWebsite,
    showCancelButton: true,
    onDonate: handleOnDonate,
    onCancel: handleOnCancel
  };
  AdyenCheckout(window.Configuration).then(function (checkout) {
    checkout.create('donation', donationConfig).mount(adyenGivingNode);
  });
}
},{}],3:[function(require,module,exports){
'use strict';

var progress = require('./progress'),
    util = require('./util');

var currentRequests = [];

/**
 * @function
 * @description Ajax request to get json response
 * @param {Boolean} async  Asynchronous or not
 * @param {String} url URI for the request
 * @param {Object} data Name/Value pair data request
 * @param {Function} callback  Callback function to be called
 */
var getJson = function (options) {
    options.url = util.toAbsoluteUrl(options.url);
    // return if no url exists or url matches a current request
    if (!options.url || currentRequests[options.url]) {
        return;
    }

    currentRequests[options.url] = true;

    // make the server call
    $.ajax({
        dataType: 'json',
        url: options.url,
        async: (typeof options.async === 'undefined' || options.async === null) ? true : options.async,
        data: options.data || {}
    })
    // success
    .done(function (response) {
        if (options.callback) {
            options.callback(response);
        }
    })
    // failed
    .fail(function (xhr, textStatus) {
        if (textStatus === 'parsererror') {
            window.alert(Resources.BAD_RESPONSE);
        }
        if (options.callback) {
            options.callback(null);
        }
    })
    // executed on success or fail
    .always(function () {
        // remove current request from hash
        if (currentRequests[options.url]) {
            delete currentRequests[options.url];
        }
    });
};
/**
 * @function
 * @description ajax request to load html response in a given container
 * @param {String} url URI for the request
 * @param {Object} data Name/Value pair data request
 * @param {Function} callback  Callback function to be called
 * @param {Object} target Selector or element that will receive content
 */
var load = function (options) {
    options.url = util.toAbsoluteUrl(options.url);
    // return if no url exists or url matches a current request
    if (!options.url || currentRequests[options.url]) {
        return;
    }

    currentRequests[options.url] = true;

    // make the server call
    $.ajax({
        dataType: 'html',
        url: util.appendParamToURL(options.url, 'format', 'ajax'),
        data: options.data,
        xhrFields: {
            withCredentials: true
        }
    })
    .done(function (response) {
        // success
        if (options.target) {
            $(options.target).empty().html(response);
        }
        if (options.callback) {
            options.callback(response);
        }
    })
    .fail(function (xhr, textStatus) {
        // failed
        if (textStatus === 'parsererror') {
            window.alert(Resources.BAD_RESPONSE);
        }
        options.callback(null, textStatus);
    })
    .always(function () {
        progress.hide();
        // remove current request from hash
        if (currentRequests[options.url]) {
            delete currentRequests[options.url];
        }
    });
};

exports.getJson = getJson;
exports.load = load;

},{"./progress":85,"./util":104}],4:[function(require,module,exports){
"use strict";

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

if (window.amazonCheckoutSessionId) {
  var handleAuthorised = function handleAuthorised(response) {
    document.querySelector('#result').value = JSON.stringify({
      pspReference: response.fullResponse.pspReference,
      resultCode: response.fullResponse.resultCode,
      paymentMethod: response.fullResponse.paymentMethod ? response.fullResponse.paymentMethod : response.fullResponse.additionalData.paymentMethod
    });
    document.querySelector('#paymentFromComponentStateData').value = JSON.stringify(response);
    document.querySelector('#showConfirmationForm').submit();
  };

  var handleError = function handleError() {
    document.querySelector('#result').value = JSON.stringify({
      error: true
    });
    document.querySelector('#paymentFromComponentStateData').value = JSON.stringify({
      error: true
    });
    document.querySelector('#showConfirmationForm').submit();
  };

  var handleAmazonResponse = function handleAmazonResponse(response, component) {
    if (response.fullResponse && response.fullResponse.action) {
      component.handleAction(response.fullResponse.action);
    } else if (response.resultCode === window.resultCodeAuthorised) {
      handleAuthorised(response);
    } else {
      // first try the amazon decline flow
      component.handleDeclineFlow(); // if this does not trigger a redirect, try the regular handleError flow

      handleError();
    }
  };

  var paymentFromComponent = function paymentFromComponent(data, component) {
    $.ajax({
      url: window.paymentFromComponentURL,
      type: 'post',
      contentType: 'application/; charset=utf-8',
      data: JSON.stringify(data),
      success: function success(response) {
        if (response.result && response.result.orderNo && response.result.orderToken) {
          document.querySelector('#orderToken').value = response.result.orderToken;
          document.querySelector('#merchantReference').value = response.result.orderNo;
        }

        handleAmazonResponse(response.result, component);
      }
    });
  };

  var mountAmazonPayComponent = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var checkout, amazonPayComponent;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return AdyenCheckout(window.Configuration);

            case 2:
              checkout = _context.sent;
              amazonPayComponent = checkout.create('amazonpay', amazonConfig).mount(amazonPayNode);
              amazonPayComponent.submit();

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function mountAmazonPayComponent() {
      return _ref.apply(this, arguments);
    };
  }();

  window.sessionsResponse = null;
  var amazonPayNode = document.getElementById('amazonContainerSG');
  var amazonConfig = {
    showOrderButton: false,
    returnUrl: window.returnURL,
    configuration: {
      merchantId: window.amazonMerchantID,
      storeId: window.amazonStoreID,
      publicKeyId: window.amazonPublicKeyID
    },
    amazonCheckoutSessionId: window.amazonCheckoutSessionId,
    onSubmit: function onSubmit(state, component) {
      document.querySelector('#adyenStateData').value = JSON.stringify(state.data);
      paymentFromComponent(state.data, component);
    },
    onAdditionalDetails: function onAdditionalDetails(state) {
      state.data.paymentMethod = 'amazonpay';
      $.ajax({
        type: 'post',
        url: window.paymentsDetailsURL,
        data: JSON.stringify({
          data: state.data,
          orderToken: document.querySelector('#orderToken').value
        }),
        contentType: 'application/; charset=utf-8',
        success: function success(data) {
          if (data.response.isSuccessful) {
            handleAuthorised(data.response);
          } else if (!data.response.isFinal && _typeof(data.response.action) === 'object') {
            checkout.createFromAction(data.action).mount('#amazonContainerSG');
          } else {
            handleError();
          }
        }
      });
    }
  };
  mountAmazonPayComponent();
}
},{"@babel/runtime/regenerator":110}],5:[function(require,module,exports){
/**
 *    (c) 2009-2014 Demandware Inc.
 *    Subject to standard usage terms and conditions
 *    For all details and documentation:
 *    https://bitbucket.com/demandware/sitegenesis
 */

'use strict';

var euGaran = require('./euGaran'),
    countries = require('./countries'),
    dialog = require('./dialog'),
    minicart = require('./minicart'),
    menu = require('./menu'),
    page = require('./page'),
    rating = require('./rating'),
    searchplaceholder = require('./searchplaceholder'),
    searchsuggest = require('./searchsuggest'),
    searchsuggestspares = require('./searchsuggestspares'),
    tooltip = require('./tooltip'),
    util = require('./util'),
    validator = require('./validator'),
    validatorResetPass = require('./validatorresetpass')(),
    gtm = require('./gtm'),
    tls = require('./tls'),
    homepage = require('./homepage'),
    tableformobile = require('./tableformobile'),
    popin = require('./popin/popin.js'),
    selectAdress = require('./selectAdress'),
    mobileWidth = 543,
    cookieScriptConsent = require('./cookieScriptConsent'),
    _ = require('lodash');

euGaran.init();
// if jQuery has not been loaded, load from google cdn
if (!window.jQuery) {
    var s = document.createElement('script');
    s.setAttribute('src', 'https://ajax.googleapis.com/ajax/libs/jquery/1.7.1/jquery.min.js');
    s.setAttribute('type', 'text/javascript');
    document.getElementsByTagName('head')[0].appendChild(s);
}

$('.bloc-iconic').each(function() {
    if ($('.product-promise-player', this).length > 0) {
        $(this).addClass('bloc-iconic--promise');
        $(this).next('.bloc-iconic').addClass('bloc-iconic--nextPlayer');
        $('.product-promise-player').parent().addClass('product-promise-bottom-block--video');
        $('.product-promise-player').parent().removeClass('product-promise-bottom-block--noPlayer');
    }
});

require('./cookieprivacy')();
require('./returnorder')();
function initializeEvents() {
    var controlKeys = ['8', '13', '46', '45', '36', '35', '38', '37', '40', '39'];

    /**
    * Handles click events on elements with the 'skip-link' class to provide accessible skip navigation.
    * Prevents the default link behavior, determines the target element by the href attribute, and shifts focus to it.
    * If the target element is not found, defaults to focusing on main content areas (#main, #maincontent, or elements with [role="main"]).
    * Ensures the target element is focusable by setting tabindex if necessary.
    * 
    * @param {Event} e - The click event triggered on a '.skip-link' element.
    */
    $(document).on('click', '.skip-link', function (e) {
        e.preventDefault();
        var href = $(this).attr('href') || '';
        var id = href.charAt(0) === '#' ? href.slice(1) : href;
        var $target = id ? $('#' + id) : $();

        if (!$target.length) {
            $target = $('#main, #maincontent, [role="main"]');
        }

        if ($target.length) {
            if (!$target.attr('tabindex')) {
                $target.attr('tabindex', '-1');
            }

            $target.focus();
        }
    });

    $('body')
        .on('keydown', 'textarea[data-character-limit]', function (e) {
            var text = $.trim($(this).val()),
                charsLimit = $(this).data('character-limit'),
                charsUsed = text.length;

            if ((charsUsed >= charsLimit) && (controlKeys.indexOf(e.which.toString()) < 0)) {
                e.preventDefault();
            }
        })
        .on('change keyup mouseup', 'textarea[data-character-limit]', function () {
            var text = $.trim($(this).val()),
                charsLimit = $(this).data('character-limit'),
                charsUsed = text.length,
                charsRemain = charsLimit - charsUsed;

            if (charsRemain < 0) {
                $(this).val(text.slice(0, charsRemain));
                charsRemain = 0;
            }

            $(this).next('div.char-count').find('.char-remain-count').html(charsRemain);
        });

    /**
     * initialize search suggestions, pending the value of the site preference(enhancedSearchSuggestions)
     * this will either init the legacy(false) or the beta versions(true) of the the search suggest feature.
     * */
    var $searchContainer = $('.header .header-search');
    searchsuggest.init($searchContainer, Resources.SIMPLE_SEARCH);

    if ($('body .seachbar-container').length && !$('.search-noResults').length) {
        var $searchContainerspares = $('body .seachbar-container-spares');
        searchsuggestspares.init($searchContainerspares, Resources.SIMPLE_SEARCH);
    }

    // add pro-bronze color to PRO inside text on PRO CLP -- need to add class to PG component 'golden-text-component'
    var proTextArray = $('#clp-category-PRO .golden-text-component .headlinebanner-text_subheading');
    replaceBronzePRP(proTextArray);

    function replaceBronzePRP(arr) {
        if(arr.length > 0) {
            var re = /PRO/gi;

            arr.each(function(index,item) {
                var sentence = $(item).html();
                var newstr = sentence.replace(re, '<span class="color-pro-bronze"><b>PRO</b></span>');
                $(item).html(newstr);
            })
        }
    }

    // add show/hide navigation elements
    $(document).on('click','.secondary-navigation .toggle, .secondary-navigation .toggle-nav', function () {
        if ($(window).width() <= mobileWidth && $(this).hasClass('toggle-nav')) {
            $(this).toggleClass('expanded').next('ul').toggle();
            $(this).find('.arrow').toggleClass('down up');
        }
    });

    if($('.content-secondary-nav').length && $(window).width() <= mobileWidth && $(window).width() !== 0) {
        var pageElement = $('.breadcrumb-element').last().text();

        $('.secondary-navigation .toggle-nav').toggleClass('expanded').next('ul').toggle();
        $('.secondary-navigation .toggle-nav').find('.arrow').toggleClass('down up');
        $('.secondary-navigation a[title="' + pageElement + '"]').closest('ul').prev().trigger('click');
    }

    function contentpage() {
        var acc = document.getElementsByClassName("accordion");
        var i;

        for (i = 0; i < acc.length; i++) {
            acc[i].addEventListener("click", function(e) {
            e.preventDefault()
                this.classList.toggle("active");
                var panel = this.nextElementSibling;
                if (panel.style.maxHeight) {
                panel.style.maxHeight = null;
                } else {
                panel.style.maxHeight = panel.scrollHeight + "px";
                }
            });
        }
    }
    if ($('.content-page').length) {
        contentpage()
    }

    // add generic toggle functionality
    $('.toggle:not(.rf-definition-label)').next('.toggle-content').addClass('d-none');
    $(document).on('click','.toggle', function () {
        var $toggler = $(this);

        if($toggler.next('.toggle-content').hasClass('d-none')) {
            $toggler.next('.toggle-content').removeClass('d-none');
            $toggler.toggleClass('expanded').next('.toggle-content').addClass('d-block');
        } else {
            $toggler.next('.toggle-content').removeClass('d-block');
            $toggler.toggleClass('expanded').next('.toggle-content').addClass('d-none');
        }

    });

    // subscribe email box
    var $subscribeEmail = $('.subscribe-email');
    if ($subscribeEmail.length > 0)    {
        $subscribeEmail.focus(function () {
            var val = $(this.val());
            if (val.length > 0 && val !== Resources.SUBSCRIBE_EMAIL_DEFAULT) {
                return; // do not animate when contains non-default value
            }

            $(this).animate({color: '#999999'}, 500, 'linear', function () {
                $(this).val('').css('color', '#333333');
            });
        }).blur(function () {
            var val = $.trim($(this.val()));
            if (val.length > 0) {
                return; // do not animate when contains value
            }
            $(this).val(Resources.SUBSCRIBE_EMAIL_DEFAULT)
                .css('color', '#999999')
                .animate({color: '#333333'}, 500, 'linear');
        });
    }

    //captcha validation
    function recaptchaShowError() {
        var form = $("#dwfrm_login").length ? $("#dwfrm_login") : $("#RegistrationForm").length ? $("#RegistrationForm") : $("#FakeCounterfits").length ? $("#FakeCounterfits") : $("#newsletter-form").length ? $("#newsletter-form") : null;
        if (form) {
            form.submit(function (e) {
                if ($(".recaptcha-error").length > 0) {
                    if (window.grecaptcha.getResponse() == "") {
                        e.preventDefault();
                        if ($(".recaptcha-error").hasClass("hide")) {
                            $(".recaptcha-error").removeClass("hide");
                        }
                    } else {
                        if (!$(".recaptcha-error").hasClass("hide")) {
                            $(".recaptcha-error").addClass("hide");
                        }
                    }
                }
            });
        }
    }

    //Makes last account box full width if there are an odd amount of boxes in account overview page
    if ($('.account-box').length % 2 == 1) {
        $('.account-box').last().parent().removeClass('col-6').addClass('col-12');
    }

    $('a.privacy-policy').on('click', function (e) {
        e.preventDefault();
        dialog.open({
            url: $(e.target).attr('href'),
            options: {
                dialogClass: 'store-modal privacy-modal',
                height: 600
            }
        });
        $('.ui-icon').removeClass('ui-button-icon-primary ui-icon ui-icon-closethick').addClass('icon icon-cross')
    });

    // links FAQ
    function initFaq () {
        // add id to questions block
        $('#faq .faq-questions').attr('id', 'faq-top');

        // add id to each faq answer
        var answers = $('#faq .faq-answers h3');
        answers.each(function (index, elem) {
            $(elem).attr('id', 'q' + ++index);
        })
    }
    initFaq()

	// subscribe email box
	function setNewsletterModelEvents(e){
		$('form button').trigger('focus');

        var newsletterCaptcha = recaptchaReInit();

		dialog.$container.off("submit").on("submit",function(ev){
			ev.preventDefault();
			if (newsletterCaptcha !== null && window.grecaptcha.getResponse(newsletterCaptcha).length === 0) {
				$('.newsletter-inputfields .recaptcha-error').removeClass('hide');
				return;
			}
			var $form = $(ev.target);
			$('<input/>').attr({
				name: 'POST',
				type: 'hidden'
			}).appendTo($form);
			var data = $form.serialize();
			var url = $form.attr('action');
			if (data.indexOf('ajax') === -1) {
				data += '&format=ajax';
			}
			$.ajax({
				type: 'POST',
				url: url,
				data: data,
				dataType: 'html',
				success: function (html) {
					dialog.$container.html(html);
					newsletterCaptcha = recaptchaReInit();
                    $('.ui-dialog').find('select, input').trigger('initLabels');
				}.bind(dialog),
				failure: function () {
					window.alert(Resources.SERVER_ERROR);
				}
			});
		}).find('form').each(function(){
			validator.initForm(this);
        });

        var newsletterValidator = $('#newsletter-form').data('validator');
        if (newsletterValidator) {
            newsletterValidator.settings.messages.dwfrm_newsletterform_confirm = {
                required: Resources.NEWSLETTER_CONFIRM_REQUIRED
            };
        }

        $('.modal-9000').scrollTop(0);
	};

    function newsletterUnsubscribeModal() {
        $(document).on('submit','.communication-preferences-form', function(event) {
            event.preventDefault();
            var $form = $(event.target);
            var data = $form.serialize();
            var url = $form.attr('action');
            if (data.indexOf('ajax') === -1) {
                data += '&format=ajax';
            }

            $.ajax({
                type: 'POST',
                url: url,
                data: data,
                dataType: 'json',
                success: function (json) {
                    dialog.open({
                        url: Urls.newsletterUnsubscribed,
                        options: {
                            height: 100,
                            draggable: false
                        }
                    });
                }.bind(dialog),
                failure: function () {
                    window.alert(Resources.SERVER_ERROR);
                }
            });
          });
    }
    newsletterUnsubscribeModal();

    function marketingNewsletterForm() {
        $(document).on('submit','.marketing-newsletter-form', function(event) {
            var $form = $(event.target);
            var data = $form.serialize();
            var url = $form.attr('action');
            if ($('#dwfrm_newsletterform_emailAddress').val() === $('#dwfrm_newsletterform_emailConfirm').val()) {
                event.preventDefault();

                $.ajax({
                    type: 'POST',
                    url: url,
                    data: data,
                    success: function (response) {
                        dialog.open({
                            html: response,
                            options: {
                                width: 715,
                                dialogClass: 'store-modal modal-9000',
                            }
                        });
                    }.bind(dialog),
                    failure: function () {
                        window.alert(Resources.SERVER_ERROR);
                    }
                });
            }
          });
    }
    marketingNewsletterForm();

    // Reinit recaptcha container
	function recaptchaReInit() {
		var recaptchaElement = $('.g-recaptcha');
		var newsletterCaptcha = null;
		if (recaptchaElement.length > 0) {
			newsletterCaptcha = window.grecaptcha.render(recaptchaElement[0], {
				'sitekey': recaptchaElement.data('sitekey'),
			});
		}

		return newsletterCaptcha;
	}

	function recaptchaLogin() {
        const $recaptchaElement = $('.login-account .g-recaptcha');
        const xmdWidth = 767;
        const lgWidth = 1200;
        // resize recaptcha for medium devices viewport
        if ($recaptchaElement.length && $(window).width() >= xmdWidth && $(window).width() <= lgWidth) {
            if (window.grecaptcha && typeof window.grecaptcha.ready === 'function') {
                $recaptchaElement.attr('data-size', 'compact');
                window.grecaptcha.ready(function () {
                    if (typeof window.grecaptcha.reset === 'function') {
                        window.grecaptcha.reset();
                    }
                });
            }
        }
    }

    recaptchaLogin();
    // recaptcha error
    recaptchaShowError();

    function newsletterModalOpen(e, content){
		e.preventDefault();
		dialog.open({
			url: $(content).attr('href'),
			callback: setNewsletterModelEvents,
			options: {
                width: 715,
                dialogClass: 'store-modal modal-9000',
            },
		})
	};

    $('.countdown-banner .countdown-findmore a, .CTA-singup-modal').click(function(e){
		newsletterModalOpen(e, this);
	});

    $('.checkout-form .mailing-list .input-checkbox').on('click', function() {
        var $this = $(this);

        if ($this.is(':checked')) {
            $this.prop( "checked", true);
        } else {
            $this.prop( "checked", false);
        }
	});

    // input label

    $(document).on('initLabels change', 'select, input', function () {
        var $this = $(this);
        if ($this.parents('.form-row').not('.form-labelTop-row')) {
            const $label = $this.siblings('label');
            if ($this.val() || ($this.attr('placeholder') !== '' && $this.attr('placeholder') !== $label.text())) {
                $label.addClass('top');
            } else {
                $label.removeClass('top');
            }
        }
    }).find('select, input').trigger('initLabels');

    $(document).on('focus', '.input-text', function () {
        var field = $(this);
        if (!field.siblings('label').hasClass('top')) {
            field.siblings('label').addClass('top');
        }
    });

    $(document).on('focusout', '.input-text', function () {
        var field = $(this);

        if (field.val() === '' && field.attr('placeholder') === '') {
            field.siblings('label').removeClass('top');
        } else {
            field.siblings('label').addClass('top');
        }
    });

    $(window).load(function () {
        if ($('input:-webkit-autofill')) {
            $('input:-webkit-autofill').siblings('label').addClass('top');
        }
        if ($('input[name$="_addressFinder"]').attr('placeholder') !== '') {
            $('input[name$="_addressFinder"]').siblings('label').addClass('top');
        }
    });

    // edit button on delivery address
    $(document).on('click keydown', '.js-toggle-edit', function(event) {
        if (event.type === 'click' || (event.type === 'keydown' && event.key === 'Enter')) {
            $(this).parent().removeClass('d-block');
            $(this).parent().addClass('d-none');

            const isMyAccountAddressForm = !$('#dwfrm_billing').length && !$('#dwfrm_singleshipping_shippingAddress').length;
            if (isMyAccountAddressForm) {
                const $addressForm = $('form.address');
                $addressForm.find('label[for$="address_manualaddress"]').trigger('click').closest('.form-row').removeClass('d-none');
                $addressForm.find('[name$="_addressFinder"]').closest('.form-row').removeClass('d-none');
                $addressForm.find('.selected-address-wrap').addClass('d-none');
            } else {
                const addressFieldLabel = $(this).parent().parent().find('.enter-address-wrapper');
                addressFieldLabel.removeClass('d-none');
                addressFieldLabel.addClass('d-flex');
            }
        }
    });

    // hide Address Finder and show Enter Address Manually
    $(document).on('click keydown', '.enter-address-btn', function(event) {
        if (event.type === 'click' || (event.type === 'keydown' && event.key === 'Enter')) {
            $('.enter-address-wrapper').removeClass('d-none').addClass('d-flex').find('select, input').trigger('initLabels');
            $('.address-finder-wrapper').removeClass('d-flex').addClass('d-none');
        }
    });

    // hide Enter Address Manually and show Address Finder
    $(document).on('click keydown', '.address-finder-btn', function(event) {
        if (event.type === 'click' || (event.type === 'keydown' && event.key === 'Enter')) {
            $('.address-finder-wrapper').removeClass('d-none').addClass('d-flex');
            $('.enter-address-wrapper').removeClass('d-flex').addClass('d-none');
        }
    });

    // billing events
    $(document).on('click keydown', '.edit-toggle', function(event) {
        if (event.type === 'click' || (event.type === 'keydown' && event.key === 'Enter')) {
            var id = $(this).data('toggle');
            var elem = $(`#${id}`);
            var wrapper = $(this).parent('.selected-address-wrap');

            elem.removeClass('d-none');
            elem.addClass('d-block');
            elem.find('.address-finder-wrapper').removeClass('d-none');

            wrapper.addClass('d-none');
        }
    })

    $('.univers-tile-content-wrapper').on('click', function (e) {
    	 var target =  $(this);
        // tagmanager_event('clickBlockUniverse', {'block_name': target.children().children("div.univers-tile-Title").html()});
    });

    $('.swiper-slide').on('click', function (e) {
    	var target =  $(this);
    	// tagmanager_event('clickBannerShowcase', {'banner_name': target.children().children().children().children("p.banner-text1").text()});
    });

    // Main navigation menu
    function mainNavigationMenu() {
        var menuCatItemEvent;
        var isLink;

        // depends on window's width the mouseenter/click event will be added
        function reportWindowSize() {

            var innerWidth = window.innerWidth;

            if(innerWidth > 1024) {
                menuCatItemEvent = 'mouseenter';
                isLink = true;
            } else {
                menuCatItemEvent = 'click';
                isLink = false;
            }
        }

        reportWindowSize();
        $(document).on(menuCatItemEvent,'.menu-category-item', function(e) {

            if(!isLink) {
                e.preventDefault();
            }

            var link = $(this).find('.menu-category-link');
            var groupid = $(this).data('menu-group');
            var $menuLevel2 = $(`.js-header-mega-${groupid}`);
            link.addClass('link-hover')

            if ($menuLevel2.text().trim() != '') {
                $menuLevel2.removeClass('d-none');
            }

            $menuLevel2.on('mouseenter', function() {
                $menuLevel2.removeClass('d-none');
                link.addClass('link-hover')
            })

            $menuLevel2.on('mouseleave', function() {
                $menuLevel2.addClass('d-none');
                link.removeClass('link-hover');
            })

            $(this).on('mouseleave', function() {
                $menuLevel2.addClass('d-none');
                link.removeClass('link-hover');
            })
        })
    }

    // menu-category-item-hamburger
    function hamburgerMenu() {
        $(document).on('click','.menu-category-item-hamburger, .countries-select-hamburger', function(e) {
            var dataid = $(this).data('menu-group');
            if (dataid === 'account') {
                return
            } else {
                if ($(`.js-hamburger-mega-${dataid}`).text() != '') {
                    e.preventDefault();
                    $('.hamburger-level-1').addClass('d-none');
                    $(`.js-hamburger-mega-${dataid}`).removeClass('d-none');
                } else {
                    return
                }
            }
        })

        $(document).on('click','.menu-hamburger-back', function(e) {
            e.preventDefault();
            $('.hamburger-level-1').removeClass('d-none');
            $('.hamburger-level-2').addClass('d-none');
        })

        $(document).on('shown.bs.collapse','#hamburgerNavigationMenu', function() {
            $('.mobile-menu-open').addClass('d-none');
            $('.mobile-menu-close').removeClass('d-none');
            $('body').addClass('menu-open');
            $('header').addClass('mobile');
        })

        $(document).on('hide.bs.collapse','#hamburgerNavigationMenu', function() {
            $('.mobile-menu-open').removeClass('d-none');
            $('.mobile-menu-close').addClass('d-none');
            $('body').removeClass('menu-open');
            $('header').removeClass('mobile');
            $('.hamburger-level-2').addClass('d-none');
            $('.hamburger-level-1').removeClass('d-none');
          })
    }

    // footer Mobile navigation menu
    function footerNavigationMobile() {
        $(document).on('click', '.footer-category-item', function() {
            $(this).siblings('.footer-category-list').toggleClass('d-none');
            $(this).find('.arrow').toggleClass('down up');
        })
    }


    if ($(window).width() > mobileWidth) {
        mainNavigationMenu();
    } else {
        hamburgerMenu();
        footerNavigationMobile();
    }

    var offset = 300,
        //duration of the top scrolling animation (in ms)
        scrollTopDuration = 700,

        $backToTop = $('.button-BackTop');

    //hide or show the "back to top" link
    $(window).scroll(function() {
        ($(this).scrollTop() > offset) ? $backToTop.addClass('button-BackTop--visible'): $backToTop.removeClass('button-BackTop--visible button-BackTop--fadeout');
    });

    //smooth scroll to top
    $backToTop.on('click', function(event){
        event.preventDefault();
        $('body,html').animate({
            scrollTop: 0
        }, scrollTopDuration
        );
    });

    if($('.countdown-banner').length > 0) {
        //countdown date from site preferences
        var countdownDate = new Date(Resources.COUNTDOWN_DATE).getTime();

        //countdown function that updates the countdown every 1 second

        var countdownTimer = setInterval(function() {
            var now = new Date().getTime();

            var distance = countdownDate - now;

            //calculation for days, hours, minutes and seconds and output the result
            var days = Math.floor(distance / (1000 * 60 * 60 * 24));
            $('.countdown-days .value').html(days);
            $('.countdown-days .text').html('DAYS');

            var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            $('.countdown-hours .value').html(hours);
            $('.countdown-hours .text').html('HOURS');

            var mins = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            $('.countdown-mins .value').html(mins);
            $('.countdown-mins .text').html('MINS');

            var secs = Math.floor((distance % (1000 * 60)) / 1000);
            $('.countdown-secs .value').html(secs);
            $('.countdown-secs .text').html('SECS');

        }, 1000);
    }
}

//pro account
function proAccountInit() {

    $(document).on('change', '#dwfrm_profile_proaccount_isProAccount', function () {
        var proAccountFields = $('#dwfrm_profile_proaccount_type, #dwfrm_profile_proaccount_organizationName, #dwfrm_profile_proaccount_organizationType, .custom-file-input, #dwfrm_profile_proaccount_organizationTypeEducation');
        if ($(this).is(':checked')) {
            $('.registration-pro-account').find('.type-pro-select').show(function () {
                $('.registration-pro-account').slideDown();
            });
            $('#dwfrm_profile_proaccount_organizationName').addClass('required');
            proAccountFields.removeClass('ignore-field');
        } else {
            $('.registration-pro-account').slideUp();
            proAccountFields.addClass('ignore-field').removeClass('valid').val('');
            $('#dwfrm_profile_proaccount_creditAccount').prop('checked', false);
            $('#dwfrm_profile_proaccount_organizationName').removeClass('required');
            $('.pro-proof-remove').trigger('click');
            $('#dwfrm_profile_proaccount_type, #dwfrm_profile_proaccount_organizationType, #dwfrm_profile_proaccount_organizationTypeEducation').val('default');
        }
    })

    $(document).on('click', '.pro-form-step', function () {
        $(this).hide();
        $('.type-pro-select').slideDown();
    });

    $(document).on('click', '.pro-form-continue', function (e) {
        e.preventDefault();
        $('#dwfrm_profile_proaccount_type').blur();

        if ($('#dwfrm_profile_proaccount_type').hasClass('valid')) {
            $(this).hide();
            $('.type-pro-continue').slideDown();
            $('#dwfrm_profile_proaccount_type').trigger('change');
        } else {
            $('#dwfrm_profile_proaccount_type').blur();
        }

    })

    $(document).on('change', '#dwfrm_profile_proaccount_type', function () {
        const eductationLabel = $('.education-name-holder').text();
        const businessLabel = $('.business-name-holder').text();
        const organizationLabel = $('label[for="dwfrm_profile_proaccount_organizationName"] span');
        const organizationTapeInput = $('#dwfrm_profile_proaccount_organizationType');
        const organizationEducationInput = $('#dwfrm_profile_proaccount_organizationTypeEducation');
        const proCreditSection = $('.type-pro-credit');
        const value = $(this).val();

        if (value === 'default') {
            $(this).blur();
        } else if (value === 'education') {
            $('.pro-type-eductaion').removeClass('d-none');
            $('.pro-type-business').addClass('d-none');
            organizationTapeInput.removeAttr('valuenotequals');
            organizationEducationInput.attr('valuenotequals', 'default');
            organizationLabel.text(eductationLabel);
        } else {
            $('.pro-type-eductaion').addClass('d-none');
            $('.pro-type-business').removeClass('d-none');
            organizationEducationInput.removeAttr('valuenotequals');
            organizationTapeInput.attr('valuenotequals', 'default');
            organizationLabel.text(businessLabel);
        }

        // credit account
        if (proCreditSection.length) {
            if (['hairBeauty', 'barber'].indexOf(value) > -1) {
                proCreditSection.slideDown();
            } else {
                proCreditSection.slideUp(function () {
                    $('#dwfrm_profile_proaccount_creditAccount').prop('checked', false);
                });
            }
        }
    });

    if ($('.pro-active').length) {
        $('#dwfrm_profile_proaccount_type').trigger('change');
    }

    // find out pro modal
    $(document).on('click', '.type-pro-modal', function (e) {
        e.preventDefault();
        dialog.open({
            url: Urls.proCreditAccount,
            options: {
                height: 'auto',
                draggable: false
            }
        });
    })

     // proof pro account create
     var proofPreview = function(input) {
        var maxFileSize = 2097152; // 2 MB

        var fileTypes = [
            "image/gif",
            "image/jpeg",
            "image/png",
            "image/jpg",
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            "application/msword",
            "application/pdf"
          ];

        if (input.files[0]) {
            var filelabel = $('.image-holder .file-label').text();

            if (input.files[0].size > maxFileSize || !fileTypes.includes(input.files[0].type)){
                $('.format-text-check').addClass('error');
                $('.image-holder').addClass('d-none');
                $('.pro-proof-remove').addClass('d-none');
                input.value = "";
             } else {
                $('.format-text-check').removeClass('error');
                $('.image-holder').removeClass('d-none');
                $('.pro-proof-remove').removeClass('d-none');
                $('.image-holder .input-text label span').text(filelabel + input.files[0].name)
                $(input).blur();
             };
        } else {
            $('.format-text-check').addClass('error');
            $('.image-holder').addClass('d-none');
            $('.pro-proof-remove').addClass('d-none');
            input.value = "";
        }

    };

    $(document).on('click','.pro-proof-remove', function (e) {
        e.preventDefault();
        $(this).addClass('d-none');
        $('.custom-file-input').val('').trigger('change');
        $('.format-text-check').removeClass('error');
        $('.image-holder').addClass('d-none');
    })

    $(document).on('change','.custom-file-input', function() {
        proofPreview(this);

        if ($(this).val() !== '') {
            $('.pro-update-file').text($('.pro-update-file').data('alternative-text'));
        } else {
            $('.pro-update-file').text($('.pro-update-file').data('text'));
        }
    }).on('mouseenter', '.custom-file-input', function () {
        $(this).siblings('button').addClass('hover');
    }).on('mouseleave', '.custom-file-input', function () {
        $(this).siblings('button').removeClass('hover');
    });;
}

if ($('.pt_account').length && ($('.primary-content').hasClass('pro') || $('.registration-pro-account').length)) {
    proAccountInit();
}

/**
 * @private
 * @function
 * @description Ensures form-level errors are announced and focusable, then shifts focus if appropriate.
 */
function initializeErrorFormAccessibility() {
    const initialErrorFocusDelayMs = 700;
    const errorFocusRetryDelayMs = 400;
    const maxErrorFocusRetries = 5;
    const invalidFieldSelector = [
        'input[aria-invalid="true"]',
        'select[aria-invalid="true"]',
        'textarea[aria-invalid="true"]',
        '.field-wrapper > input.error',
        '.field-wrapper > select.error',
        '.field-wrapper > textarea.error'
    ].join(', ');
    let visibleErrorMessages = $('.error-form:visible').filter(function () {
        return $.trim($(this).text()).length > 0;
    });
    let $invalidFields = $(invalidFieldSelector)
        .filter(':visible')
        .filter(function () {
            let $field = $(this);

            return !$field.is('[type="hidden"], [disabled], [tabindex="-1"]');
        });

    if (!visibleErrorMessages.length && !$invalidFields.length) {
        return;
    }

    visibleErrorMessages.each(function () {
        let $errorMessage = $(this);

        if (!$errorMessage.attr('role')) {
            $errorMessage.attr('role', 'alert');
        }
        if (!$errorMessage.attr('aria-live')) {
            $errorMessage.attr('aria-live', 'polite');
        }
        if (!$errorMessage.attr('aria-atomic')) {
            $errorMessage.attr('aria-atomic', 'true');
        }
        if (!$errorMessage.attr('tabindex')) {
            $errorMessage.attr('tabindex', '0');
        }
        if (!$errorMessage.attr('aria-label')) {
            let errorText = $.trim($errorMessage.text());
            if (errorText.length > 0) {
                $errorMessage.attr('aria-label', errorText);
            }
        }
    });

    /**
     * Ensures inline validation text is announced as an error for the focused field.
     *
     * @param {jQuery} $field The invalid form control that should reference its inline error.
     */
    function enhanceInlineErrorAccessibility($field) {
        let describedByIds = ($field.attr('aria-describedby') || '').split(/\s+/).filter(Boolean);

        describedByIds.forEach(function (describedById) {
            let $describedByElement = $('#' + describedById);

            if (!$describedByElement.length || !$describedByElement.hasClass('error-message')) {
                return;
            }

            if (!$describedByElement.attr('role')) {
                $describedByElement.attr('role', 'alert');
            }
            if (!$describedByElement.attr('aria-live')) {
                $describedByElement.attr('aria-live', 'assertive');
            }
            if (!$describedByElement.attr('aria-atomic')) {
                $describedByElement.attr('aria-atomic', 'true');
            }

            $field.attr('aria-errormessage', describedById);
        });
    }

    /**
     * Returns the best target to focus after the page reloads with validation errors.
     *
     * @returns {jQuery} The first invalid field, or the first visible form-level error.
     */
    function getFocusTarget() {
        if ($invalidFields.length) {
            return $invalidFields.first();
        }

        return visibleErrorMessages.first();
    }

    /**
     * Scrolls to and focuses the provided element.
     *
     * @param {jQuery} $targetElement The element that should receive focus.
     * @returns {boolean} True when the target became the active element.
     */
    function focusElement($targetElement) {
        if (!$targetElement.length || !$targetElement.is(':visible')) {
            return false;
        }

        if ($targetElement.is('input, select, textarea')) {
            enhanceInlineErrorAccessibility($targetElement);
        }

        if (!$targetElement.is('input, select, textarea, button, a, [tabindex]')) {
            $targetElement.attr('tabindex', '-1');
        }

        if (typeof $targetElement[0].scrollIntoView === 'function') {
            $targetElement[0].scrollIntoView({ block: 'center' });
        }

        if (typeof $targetElement[0].focus === 'function') {
            $targetElement[0].focus();
        } else {
            $targetElement.focus();
        }

        if (document.activeElement === $targetElement[0]) {
            $targetElement.trigger('focusin');
        }

        return document.activeElement === $targetElement[0];
    }

    /**
     * Retries focus a few times because some pages finish error rendering after load.
     *
     * @param {number} retriesRemaining Number of retries left before giving up.
     */
    function attemptFocus(retriesRemaining) {
        let $focusTarget = getFocusTarget();

        if (!$focusTarget.length || !$focusTarget.is(':visible')) {
            return;
        }

        if (!focusElement($focusTarget) && retriesRemaining > 0) {
            setTimeout(function () {
                attemptFocus(retriesRemaining - 1);
            }, errorFocusRetryDelayMs);
        }
    }

    /**
     * Delays the first focus attempt until the page has fully settled.
     */
    function queueFocusAttempt() {
        setTimeout(function () {
            attemptFocus(maxErrorFocusRetries);
        }, initialErrorFocusDelayMs);
    }

    if (document.readyState === 'complete') {
        queueFocusAttempt();
    } else {
        $(window).one('load.errorFormAccessibility', function () {
            queueFocusAttempt();
        });
    }
}

/**
 * @private
 * @function
 * @description Adds class ('js') to html for css targeting and loads js specific styles.
 */
function initializeDom() {
    // add class to html for css targeting
    $('html').addClass('js');
    if (SitePreferences.LISTING_INFINITE_SCROLL) {
        $('html').addClass('infinite-scroll');
    }
    // load js specific styles
    util.limitCharacters();
}

function iPadOrientationChange(){
    const domElements = ['.pt_order-confirmation', '.pt_checkout']
    for (var i = 0; i < domElements.length; i++) {
        if ($(domElements[i]).length && (window.innerWidth >= 768 || window.innerWidth <= 1366)) {
            window.location.reload();
        }
    }
}

function initSwipers(){
    if (document.getElementById('homepage-slider')) {
        storefront: require('./pages/storefront');
    }
    if (document.querySelector('.instagram-swiper')) {
        instagramslider: require('./pages/instagramslider');
    }
    if (document.querySelector('.iconic-slider')) {
        producticonic: require('./pages/iconicslider');
    }
    if (document.querySelector('.header-promotion-slider')) {
        promobaner: require('./pages/headerpromotion');
    }
    if (document.querySelector('.selection-swiper')) {
        selectionmoment: require('./pages/selectionmoment');
    }
    if(document.querySelector('.job-swiper')) {
        jobslider: require('./pages/jobslider');
    }
    // if (document.querySelector('.recommendations.promo')) {
    //     promo: require('./pages/product/promo');
    // }
    if (document.querySelector('.promo')) {
        promo: require('./pages/product/promo');
    }
    if (document.querySelector('.recommendations')  && !document.querySelector('.recommendations.promo')) {
        if (document.querySelector('.st450e_st460e')) {
            // require('./pages/product/st450e_st460eSwiper');
        }else{
            require('./pages/product/recommendations');
        }
    }

    if ( document.querySelector('.default-product-cross-sell')  && !document.querySelector('.recommendations.promo') ) {
        require('./pages/product/defaultProductCrossSell');
    }
    else if ( document.querySelector('.nl-product-cross-sell')  && !document.querySelector('.recommendations.promo') ) {
        recommendation: require('./pages/product/nlProductCrossSell');
    }

    if (document.getElementsByClassName('collaboraters').length) {
        recommendation: require('./slider/valeurs-engagements');
    }
    if(document.querySelector('.corpo-timeline-slider')) {
        recommendation: require('./pages/timelineslider');
    }
    if (document.querySelector('.contact-wrapper')) {
        instagramslider: require('./pages/contactus');
    }
    if (document.querySelector('#dwfrm_newsletter')) {
        newsletter: require('./pages/newsletter');
    }
    if (document.querySelector('.swiperProducts')) {
        require('./pages/sliderproduct').init();
    }

    function hideOrShowBulletsSwipers() {
        var swiperTable = $('.swiper-container').toArray();
        for (var s = 0; s < swiperTable.length; s++) {
            var swiper = swiperTable[s];
            if (swiper.id == 'homepage-slider') {
                var liSlides = swiper.querySelectorAll('li');
                if (liSlides.length > 1) {
                    continue; // #107218 homepage must havec pagination if more then 1 slide
                }
            }

            if (window.screen.availWidth > 768 && !swiper.classList.contains('my-swiper')) { // can also be window.screen.width
                if (swiper.children[0].childElementCount <= 3) {
                    $(swiper.children[1]).hide();
                }
            }else{
                $(swiper.children[1]).show();
            }
        }
    }
    hideOrShowBulletsSwipers();
    $(window).resize(function() {
        hideOrShowBulletsSwipers();
    });
}

// add bold font-weight to the selected country name
function addClassCountrySelector (elem) {
    $(elem).each(function(index, item) {
        var $item = $(item);
        var currentLocale = $('.current-locale').val();
        $item.removeClass('font-weight-bold');

        // if Austria is selected
        if($('.isAustriaSelected').val() == 'true') {
            currentLocale = 'de_AT';
        }

        if($item.data('locale') === currentLocale) {
            $item.addClass('font-weight-bold')
        }
    })
}

function counrySelectorHandler () {

    if ($('.mobile-menu-toggler').is(":visible")) {
        addClassCountrySelector('.hamburger-country-panel-ml .country-name')
    } else {
        addClassCountrySelector('.country-panel-ml .country-name')

    }
}
counrySelectorHandler()

function toggleResize() {
    if (window.innerWidth > 543) {
        $('.rf-definition-label.toggle').next('.toggle-content').removeClass('d-none');
        $('.rf-definition-label.toggle').next('.toggle-content').addClass('d-block');
        $('.rf-definition-label.toggle').addClass('expanded');
    } else {
        $('.rf-definition-label.toggle').next('.toggle-content').removeClass('d-block');
        $('.rf-definition-label.toggle').next('.toggle-content').addClass('d-none');
        $('.rf-definition-label.toggle').removeClass('expanded');

    }
}
// collapse filters only on mobile
$(window).on('load', function(){
    toggleResize();
});

$(window).on('resize', _.debounce(function () {
    toggleResize();

    //Keep dialog window in middle of screen on resize
    if($(".ui-dialog").length) {
        $(".ui-dialog").position({
            my: "center", at: "center", of: window
        });
    }
}, 500));

var pages = {
    account: require('./pages/account'),
    cart: require('./pages/cart'),
    checkout: require('./pages/checkout'),
    compare: require('./pages/compare'),
    product: require('./pages/product'),
    registry: require('./pages/registry'),
    search: require('./pages/search'),
    wishlist: require('./pages/wishlist'),
    storelocator: require('./pages/storelocator'),
    producticonic: require('./pages/producticonic'),
    promobaner: require('./pages/headerpromotion'),
    2: require('./pages/checkout/shipping'),
};

var { setBreakpoint } = require('./breakpoint');

var app = {
    init: function () {
        if (document.cookie.length === 0) {
            $('<div/>').addClass('browser-compatibility-alert').append($('<p/>').addClass('browser-error').html(Resources.COOKIES_DISABLED)).appendTo('#browser-check');
        }
        setBreakpoint() // set current breakpoint
        initializeDom();
        initializeEvents();
        initializeErrorFormAccessibility();
        // init swipers if there is one on current page
        initSwipers();
        // checkout page
        initCheckoutPage();
        appendEyeIconToPasswordFields();
        if ($('.contact-us-form')) require('./pages/contactus');
        initNewCustomerSliders();

        //init toolboxes on univers pages
        if (document.querySelector('.js-univers-topProduct-toolbox-more')) {
            producttoolbox: require('./pages/producttoolbox');
        }
        if (document.querySelector('.promo-subscription')) {
            promo: require('./pages/promo');
        }
        if (document.querySelector('.ambassador-form')) {
            ambassador: require('./pages/ambassador');
        }
        // init specific global components
        countries.init();
        tooltip.init();
        minicart.init();
        menu.init();
        validator.init();
        rating.init();
        searchplaceholder.init();
        // execute page specific initializations
        $.extend(page, window.pageContext);
        var ns = page.ns;
        if (ns && pages[ns] && pages[ns].init) {
            pages[ns].init();
        }
        // Check TLS status if indicated by site preference
        if (SitePreferences.CHECK_TLS === true) {
            tls.getUserAgent();
        }
        $('input[id$="_useAsBillingAddress"]').prop('checked', true);

        window.onorientationchange = function(){
            iPadOrientationChange();
        }

        cookieScriptConsent.init();
    }
};

// general extension functions
(function () {
    String.format = function () {
        var s = arguments[0];
        var i, len = arguments.length - 1;
        for (i = 0; i < len; i++) {
            var reg = new RegExp('\\{' + i + '\\}', 'gm');
            s = s.replace(reg, arguments[i + 1]);
        }
        return s;
    };
})();

// EXPAND HEADER SEARCH

if (window.matchMedia('(max-width: 80rem)')) {
    $('.js-SearchButton').on('click', function () {
        $('.header-container').addClass('header-container--search')
        $('.header-search').addClass('header-search-expanded')
        $('.header-searchButton-close').show()
        $('.header-search input').focus()
    });

    $('.js-CloseSearch').on('click', function () {
        $('.header-search').removeClass('header-search-expanded')
        $('.header-searchButton-close').hide()
        $('.header-container').removeClass('header-container--search')
    });
}

// STICKY HEADER function

    var header = $('.header'),
    scrollPrev = 0;
function stickyHeader() {
        var scrolled = $(window).scrollTop();

        if ( scrolled > 100 && scrolled > scrollPrev ) {
            header.addClass('out');
        } else {
            header.removeClass('out');
        }
        scrollPrev = scrolled;
}

window.addEventListener('scroll', util.throttle(stickyHeader, 100));

//ScrollTo init
$(document).on('click','a[href^="#"]:not(.skip-link)',function(){
    var the_id = $(this).attr('href');

    if ($(the_id).length > 0) {
        if (window.matchMedia('(max-width: 30rem)').matches) {
            $('html, body').animate({
                scrollTop:$(the_id).offset().top
            }, 'slow');
            return false;
        } else {
            $('html, body').animate({
                scrollTop:$(the_id).offset().top - 80
            }, 'slow');
            return false;
        }
    }
});

$('#shipping-method-list .form-row').on('click', function() {
    $('.form-row').removeClass('selected');
    $(this).addClass('selected');
});

//sticky side bar PDP page
if ($('.product-detail').length && $(window).width() > mobileWidth) {
    var $sidebar = $('.product-detail');
    var $container = $('.product-cols');
    var scrolled = $(window).scrollTop();
    var sideBottom = $sidebar.offset().top + $sidebar.height();
    var contBottom = $container.offset().top + $container.height();

    $sidebar.addClass('product-sidebar');
    window.addEventListener('scroll', util.throttle(function() {
      if (window.scrollY > contBottom) {
        $sidebar.addClass('lock');
      } else if ($sidebar.hasClass('lock')) {
        $sidebar.removeClass('scrolling');
        $sidebar.removeClass('lock');
      }

      if ($('.header').hasClass('out')) {
        $sidebar.addClass('scrolling');
      } else {
        $sidebar.removeClass('scrolling');
      }
    }, 100));
}

if (window.matchMedia('(max-width: 30rem)').matches) {
    $('.bb-tooltip').on('click', function() {
        $('.bb-tooltip-overlay').addClass('bb-tooltip-overlay--visible');
    });
    $('.bb-tooltip-overlay').on('click', function() {
        if ($(this).hasClass('bb-tooltip-overlay--visible')) {
            $(this).removeClass('bb-tooltip-overlay--visible');
        }
    });
}

//readmore-less init
new ShowMore('.element', {
    config: {
        type: "text",
        limit: 180,
        more: Resources.SHOW_MORE,
        less: Resources.SHOW_LESS
    }
});

//checkout page
function initCheckoutPage () {
    if($('.checkoutlogin').length > 0) {
        // enabling to toggle login-blocks on checkout page for mobile
        var width = window.innerWidth;
        if(width <= '554') {
            $('.block-title-btn').attr('data-toggle', 'collapse')
            $('.returning-customers .block-content').addClass('collapse')
        } else {
            $('.block-title-btn').attr('data-toggle', '')
            $('.returning-customers .block-content').removeClass('collapse')
        }
    }
}

function appendEyeIconToPasswordFields () {
    //  adding an eye icon to password field
    var checkoutPass = $('.password .field-wrapper');
    var eyeIcon = $('.js-eye-wrapper')[0];
    for (let i = 0; i < checkoutPass.length; i++) {
        checkoutPass.append(eyeIcon);
    };

    $(document).on('mousedown touchstart', '.js-eye-wrapper', function (){
        if($(this).not('.crossed')){
            $(this).addClass('crossed')
            $(this).siblings('.input-text').attr('type', 'text');
            $('iframe[title="reCAPTCHA"]').css('pointer-events', 'none');
        }
    })

    $(document).on('mouseup touchend', function(){
        var $eye = $('.js-eye-wrapper');
        if($('.js-eye-wrapper.crossed').length > 0) {
            $eye.each(function(index, item){
                $(item).removeClass('crossed')
                $(item).siblings('.input-text').attr('type', 'password');
                $('iframe[title="reCAPTCHA"]').css('pointer-events', 'auto');
            })
        }
    })
}

function initNewCustomerSliders() {
    $('.new-customer-slider').carousel({
        interval: 3000,
    });
}

// initialize app
$(document).ready(function () {
    var debug = false;
    app.init();
});

},{"./breakpoint":7,"./cookieScriptConsent":11,"./cookieprivacy":12,"./countries":13,"./dialog":14,"./euGaran":15,"./gtm":18,"./homepage":32,"./menu":35,"./minicart":36,"./page":37,"./pages/account":38,"./pages/ambassador":39,"./pages/cart":40,"./pages/checkout":47,"./pages/checkout/shipping":49,"./pages/compare":50,"./pages/contactus":51,"./pages/headerpromotion":52,"./pages/iconicslider":53,"./pages/instagramslider":54,"./pages/jobslider":55,"./pages/newsletter":56,"./pages/product":63,"./pages/product/defaultProductCrossSell":60,"./pages/product/nlProductCrossSell":64,"./pages/product/promo":68,"./pages/product/recommendations":70,"./pages/producticonic":72,"./pages/producttoolbox":73,"./pages/promo":74,"./pages/registry":75,"./pages/search":76,"./pages/selectionmoment":77,"./pages/sliderproduct":78,"./pages/storefront":79,"./pages/storelocator":80,"./pages/timelineslider":81,"./pages/wishlist":82,"./popin/popin.js":83,"./rating":87,"./returnorder":89,"./searchplaceholder":91,"./searchsuggest":92,"./searchsuggestspares":93,"./selectAdress":94,"./slider/valeurs-engagements":95,"./tableformobile":100,"./tls":102,"./tooltip":103,"./util":104,"./validator":105,"./validatorresetpass":106,"lodash":125}],6:[function(require,module,exports){
'use strict';

var dialog = require('./dialog'),
    page = require('./page'),
    util = require('./util');

var selectedList = [];
var maxItems = 1;
var bliUUID = '';

/**
 * @private
 * @function
 * description Gets a list of bonus products related to a promoted product
 */
function getBonusProducts() {
    var bonusproducts = [];

    var i, len;
    for (i = 0, len = selectedList.length; i < len; i++) {
        var p = {
            pid: selectedList[i].pid,
            qty: selectedList[i].qty,
            options: {}
        };
        var a, alen, bp = selectedList[i];
        if (bp.options) {
            for (a = 0, alen = bp.options.length; a < alen; a++) {
                var opt = bp.options[a];
                p.options = {optionName:opt.name, optionValue:opt.value};
            }
        }
        bonusproducts.push({product:p});
    }
    return {bonusproducts: bonusproducts};
}

var selectedItemTemplate = function (data) {
    var attributes = '';
    for (var attrID in data.attributes) {
        var attr = data.attributes[attrID];
        attributes += '<li data-attribute-id="' + attrID + '">\n';
        attributes += '<span class="display-name">' + attr.displayName + '</span>: ';
        attributes += '<span class="display-value">' + attr.displayValue + '</span>\n';
        attributes += '</li>';
    }
    attributes += '<li class="item-qty">\n';
    attributes += '<span class="display-name">Qty</span>: ';
    attributes += '<span class="display-value">' + data.qty + '</span>';
    return [
        '<li class="selected-bonus-item" data-uuid="' + data.uuid + '" data-pid="' + data.pid + '">',
        '<i class="remove-link fa fa-remove" title="Remove this product" href="#"></i>',
        '<div class="item-name">' + data.name + '</div>',
        '<ul class="item-attributes">',
        attributes,
        '<ul>',
        '<li>'
    ].join('\n');
};

// hide swatches that are not selected or not part of a Product Variation Group
var hideSwatches = function () {
    $('.bonus-product-item:not([data-producttype="master"]) .swatches li').not('.selected').not('.variation-group-value').hide();
    // prevent unselecting the selected variant
    $('.bonus-product-item .swatches .selected').on('click', function () {
        return false;
    });
};

/**
 * @private
 * @function
 * @description Updates the summary page with the selected bonus product
 */
function updateSummary() {
    var $bonusProductList = $('#bonus-product-list');
    if (!selectedList.length) {
        $bonusProductList.find('li.selected-bonus-item').remove();
    } else {
        var ulList = $bonusProductList.find('ul.selected-bonus-items').first();
        var i, len;
        for (i = 0, len = selectedList.length; i < len; i++) {
            var item = selectedList[i];
            var li = selectedItemTemplate(item);
            $(li).appendTo(ulList);
        }
    }

    // get remaining item count
    var remain = maxItems - selectedList.length;
    $bonusProductList.find('.bonus-items-available').text(remain);
    if (remain <= 0) {
        $bonusProductList.find('.select-bonus-item').attr('disabled', 'disabled');
    } else {
        $bonusProductList.find('.select-bonus-item').removeAttr('disabled');
    }
}

function initializeGrid () {
    var $bonusProduct = $('#bonus-product-dialog'),
        $bonusProductList = $('#bonus-product-list'),
        bliData = $bonusProductList.data('line-item-detail');
    maxItems = bliData.maxItems;
    bliUUID = bliData.uuid;

    if (bliData.itemCount >= maxItems) {
        $bonusProductList.find('.select-bonus-item').attr('disabled', 'disabled');
    }

    var cartItems = $bonusProductList.find('.selected-bonus-item');
    cartItems.each(function () {
        var ci = $(this);
        var product = {
            uuid: ci.data('uuid'),
            pid: ci.data('pid'),
            qty: ci.find('.item-qty').text(),
            name: ci.find('.item-name').html(),
            attributes: {}
        };
        var attributes = ci.find('ul.item-attributes li');
        attributes.each(function () {
            var li = $(this);
            product.attributes[li.data('attributeId')] = {
                displayName:li.children('.display-name').html(),
                displayValue:li.children('.display-value').html()
            };
        });
        selectedList.push(product);
    });

    $bonusProductList.on('click', '.bonus-product-item a[href].swatchanchor', function (e) {
        e.preventDefault();
        var url = this.href,
            $this = $(this);
        url = util.appendParamsToUrl(url, {
            'source': 'bonus',
            'format': 'ajax'
        });
        $.ajax({
            url: url,
            success: function (response) {
                $this.closest('.bonus-product-item').empty().html(response);
                hideSwatches();
            }
        });
    })
    .on('change', '.input-text', function () {
        $bonusProductList.find('.select-bonus-item').removeAttr('disabled');
        $(this).closest('.bonus-product-form').find('.quantity-error').text('');
    })
    .on('click', '.select-bonus-item', function (e) {
        e.preventDefault();
        if (selectedList.length >= maxItems) {
            $bonusProductList.find('.select-bonus-item').attr('disabled', 'disabled');
            $bonusProductList.find('.bonus-items-available').text('0');
            return;
        }

        var form = $(this).closest('.bonus-product-form'),
            detail = $(this).closest('.product-detail'),
            uuid = form.find('input[name="productUUID"]').val(),
            qtyVal = form.find('input[name="Quantity"]').val(),
            qty = (isNaN(qtyVal)) ? 1 : (+qtyVal);

        if (qty > maxItems) {
            $bonusProductList.find('.select-bonus-item').attr('disabled', 'disabled');
            form.find('.quantity-error').text(Resources.BONUS_PRODUCT_TOOMANY);
            return;
        }

        var product = {
            uuid: uuid,
            pid: form.find('input[name="pid"]').val(),
            qty: qty,
            name: detail.find('.product-name').text(),
            attributes: detail.find('.product-variations').data('attributes'),
            options: []
        };

        var optionSelects = form.find('.product-option');

        optionSelects.each(function () {
            product.options.push({
                name: this.name,
                value: $(this).val(),
                display: $(this).children(':selected').first().html()
            });
        });
        selectedList.push(product);
        updateSummary();
    })
    .on('click', '.remove-link', function (e) {
        e.preventDefault();
        var container = $(this).closest('.selected-bonus-item');
        if (!container.data('uuid')) { return; }

        var uuid = container.data('uuid');
        var i, len = selectedList.length;
        for (i = 0; i < len; i++) {
            if (selectedList[i].uuid === uuid) {
                selectedList.splice(i, 1);
                break;
            }
        }
        updateSummary();
    })
    .on('click', '.add-to-cart-bonus', function (e) {
        e.preventDefault();
        var url = util.appendParamsToUrl(Urls.addBonusProduct, {bonusDiscountLineItemUUID: bliUUID});
        var bonusProducts = getBonusProducts();
        if (bonusProducts.bonusproducts[0].product.qty > maxItems) {
            bonusProducts.bonusproducts[0].product.qty = maxItems;
        }
        // make the server call
        $.ajax({
            type: 'POST',
            dataType: 'json',
            cache: false,
            contentType: 'application/json',
            url: url,
            data: JSON.stringify(bonusProducts)
        })
        .done(function () {
            // success
            page.refresh();
        })
        .fail(function (xhr, textStatus) {
            // failed
            if (textStatus === 'parsererror') {
                window.alert(Resources.BAD_RESPONSE);
            } else {
                window.alert(Resources.SERVER_CONNECTION_ERROR);
            }
        })
        .always(function () {
            $bonusProduct.dialog('close');
        });
    })
    .on('click', '#more-bonus-products', function (e) {
        e.preventDefault();
        var uuid = $('#bonus-product-list').data().lineItemDetail.uuid;

        //get the next page of choice of bonus products
        var lineItemDetail = JSON.parse($('#bonus-product-list').attr('data-line-item-detail'));
        lineItemDetail.pageStart = lineItemDetail.pageStart + lineItemDetail.pageSize;
        $('#bonus-product-list').attr('data-line-item-detail', JSON.stringify(lineItemDetail));

        var url = util.appendParamsToUrl(Urls.getBonusProducts, {
            bonusDiscountLineItemUUID: uuid,
            format: 'ajax',
            lazyLoad: 'true',
            pageStart: lineItemDetail.pageStart,
            pageSize: $('#bonus-product-list').data().lineItemDetail.pageSize,
            bonusProductsTotal: $('#bonus-product-list').data().lineItemDetail.bpTotal
        });

        $.ajax({
            type: 'GET',
            cache: false,
            contentType: 'application/json',
            url: url
        })
        .done(function (data) {
            //add the new page to DOM and remove 'More' link if it is the last page of results
            $('#more-bonus-products').before(data);
            if ((lineItemDetail.pageStart + lineItemDetail.pageSize) >= $('#bonus-product-list').data().lineItemDetail.bpTotal) {
                $('#more-bonus-products').remove();
            }
        })
        .fail(function (xhr, textStatus) {
            if (textStatus === 'parsererror') {
                window.alert(Resources.BAD_RESPONSE);
            } else {
                window.alert(Resources.SERVER_CONNECTION_ERROR);
            }
        });
    });
}

var bonusProductsView = {
    /**
     * @function
     * @description Open the list of bonus products selection dialog
     */
    show: function (url) {
        var $bonusProduct = $('#bonus-product-dialog');
        // create the dialog
        dialog.open({
            target: $bonusProduct,
            url: url,
            options: {
                width: 795,
                title: Resources.BONUS_PRODUCTS
            },
            callback: function () {
                initializeGrid();
                hideSwatches();
            }
        });
    },
    /**
     * @function
     * @description Open bonus product promo prompt dialog
     */
    loadBonusOption: function () {
        var    self = this,
            bonusDiscountContainer = document.querySelector('.bonus-discount-container');
        if (!bonusDiscountContainer) { return; }

        // get the html from minicart, then trash it
        var bonusDiscountContainerHtml = bonusDiscountContainer.outerHTML;
        bonusDiscountContainer.parentNode.removeChild(bonusDiscountContainer);

        dialog.open({
            html: bonusDiscountContainerHtml,
            options: {
                width: 400,
                title: Resources.BONUS_PRODUCT,
                buttons: [{
                    text: Resources.SELECT_BONUS_PRODUCTS,
                    click: function () {
                        var uuid = $('.bonus-product-promo').data('lineitemid'),
                            url = util.appendParamsToUrl(Urls.getBonusProducts, {
                                bonusDiscountLineItemUUID: uuid,
                                source: 'bonus',
                                format: 'ajax',
                                lazyLoad: 'false',
                                pageStart: 0,
                                pageSize: 10,
                                bonusProductsTotal: -1
                            });
                        $(this).dialog('close');
                        self.show(url);
                    }
                }, {
                    text: Resources.NO_THANKS,
                    click: function () {
                        $(this).dialog('close');
                    }
                }]
            },
            callback: function () {
                // show hide promo details
                $('.show-promo-details').on('click', function () {
                    $('.promo-details').toggleClass('visible');
                });
            }
        });
    }
};

module.exports = bonusProductsView;

},{"./dialog":14,"./page":37,"./util":104}],7:[function(require,module,exports){
'use strict';

/**
* @function
* @description method to assign the current breakpoint to a window variable so we can pull it later
*/
function setBreakpoint() {
    $(document).on('ready', () => {
        window.currentBreakpoint = getBreakpoint();
        $(document).trigger('breakpoint:set');
    });

    window.addEventListener('resize', () => {
        // assign the current breakpoint to a window variable so we can pull it later
        window.currentBreakpoint = getBreakpoint();
        $(document).trigger('breakpoint:set');
    });
}

/**
* @function
* @description method to get the current breakpoint
*/
function getBreakpoint() {
    return window.getComputedStyle(document.body, ':before').content.replace(/"/g, '');
}

exports.setBreakpoint = setBreakpoint;

},{}],8:[function(require,module,exports){
'use strict';

var ajax = require('./ajax'),
    util = require('./util');

var $form,
    addressFinder,
    addressFinderCaption,
    address1,
    address2,
    city,
    state,
    postal,
    country,
    allFields,
    toggle,
    toggleLabel,
    containerLabel;

var cachedData = null;

function toggleFields(e) {
    if (e.target) {
        if (e.target.checked) {
            allFields.forEach(function(f) {
                f.attr('disabled', false);
            });
            addressFinder.closest('.form-row').hide();
            addressFinder.attr('disabled', 'disabled');
            toggleLabel.text($(toggle).attr('data-label-disable'));
        } else {
            allFields.forEach(function(f) {
                f.attr('disabled', 'disabled');
            });
            addressFinder.closest('.form-row').show();
            addressFinder.attr('disabled', false);
            toggleLabel.text($(toggle).attr("data-label-enable"));
        }
    }
}

function insertSelectedAddress (address) {
    if (address) {
        const $billingForm = $('#dwfrm_billing');
        const $shippingForm = $('#dwfrm_singleshipping_shippingAddress');
        const isBillingForm = $billingForm.length > 0;
        const isShippingForm = $shippingForm.length > 0;
        const isMyAccountAddressForm = !isBillingForm && !isShippingForm;

        const $addressForm = isBillingForm ? $billingForm : isShippingForm ? $shippingForm : $('form.address');
        const $addressList = isBillingForm ? $addressForm.find('#edit-billing-address .address-list') : $addressForm.find('.address-list');
        let $addressFinderWrapper = $addressForm.find('.address-finder-wrapper');

        // profile address handler
        if (isMyAccountAddressForm) {
            $addressFinderWrapper = $addressForm.find('[name$="_addressFinder"]').closest('.form-row');
        }

        const $selectedAddressWrapper = isBillingForm ? $addressForm.find('#edit-billing-address .selected-address-wrap') : $addressForm.find('.selected-address-wrap');
        const stateLabel = $addressForm.find('select[name*="_addressFields_states_state"] option[value="' + address.stateCode + '"]').text() || address.stateCode;

        $addressList.find('.address-item-address1').text(address.address1);
        $addressList.find('.address-item-address2').text(address.address2 || '');
        $addressList.find('.address-item-city').text(address.city);
        $addressList.find('.address-item-stateCode').text(stateLabel);
        $addressList.find('.address-item-postalCode').text(address.postalCode);

        $selectedAddressWrapper.removeClass('d-none');
        $selectedAddressWrapper.addClass('d-block');

        $addressFinderWrapper.addClass('d-none');

        if (isMyAccountAddressForm) {
            $addressForm.find('label[for$="address_manualaddress"]').closest('.form-row').addClass('d-none');
        }

        // Adds/removes margin from address2 if it's empty/notempty
        const $address2 = $addressList.find('.address-item-address2');
        if ($address2.text() == '') {
            $address2.addClass('mb-0');
        } else {
            $address2.removeClass('mb-0');
        }
    }
}

exports.init = function() {
    $form = $('.address');
    addressFinder=$form.find('input[name$="_addressFinder"]');
    addressFinderCaption = addressFinder.parent().find('.form-caption');
    address1 = $form.find('input[name$="_address1"]');
    address2 = $form.find('input[name$="_address2"]');
    city = $form.find('input[name$="_city"]');
    state = $form.find('input[name$="_state"], select[name$="_state"]');
    postal = $form.find('input[name$="_postal"]');
    country = $form.find('select[id$="_country"]');
    allFields = [address1,address2,city,state,postal,country];
    toggle = $form.find('input[name$="_toggleFields"]');
    toggleLabel = $form.find('label[for$="_toggleFields"]');
    containerLabel = /^(.+?)([\-|,] \d+ .+)$/;
    var countryCode = $form.data('country-code');
    addressFinder.attr('placeholder', addressFinderCaption.text());
    addressFinderCaption.hide();

    if (country.length && !country.val() && countryCode) {
        country.val(countryCode);
    }

    toggle.attr({
        'data-label-enable': Resources.ENABLE,
        'data-label-disable': Resources.DISABLE
    });

    if (SitePreferences.ENABLE_ADDRESS_FINDER === true && addressFinder.length) {
        // append class to the closest .field-wrapper to append the autocomplete container dynamically
        addressFinder.closest('.field-wrapper').addClass('ui-front');

        addressFinder.autocomplete({
            minLength: 4,
            delay: 300,
            source: function(req,res) {
                if (null === cachedData) {
                    var url = util.appendParamToURL(Urls.searchAddress, 'query', $(addressFinder).val());
                    country = $form.find('select[id$="_country"]');
                    url = util.appendParamToURL(url, 'countryCode', country.val());

                    ajax.getJson({
                        url: url,
                        callback: function(data) {
                            res(data);
                    }});
                } else {
                    res(cachedData);
                    cachedData = null;
                }
            },
            focus: function (event) {
                event.preventDefault();
            },
            select: function (e, ui) {
                if (ui.item.type !== 'Address') {
                    ajax.getJson({
                        url: util.appendParamToURL(Urls.searchAddress, 'id', ui.item.value),
                        callback: function (data) {
                            if (0 == data.length) {
                                ajax.getJson({
                                    url: util.appendParamToURL(Urls.retrieveAddress, 'id', ui.item.value),
                                    callback: function(data) {
                                        address1.val(data.address1);
                                        address2.val(data.address2);
                                        city.val(data.city);
                                        state.val(data.stateCode);
                                        postal.val(data.postalCode);
                                        setCountryVal(data.countryCode);
                                    }
                                });
                            } else {
                                cachedData = data;
                                addressFinder.autocomplete('search');
                            }
                        }
                    });
                } else {
                    ajax.getJson({
                        url: util.appendParamToURL(Urls.retrieveAddress,'id',ui.item.value),
                        callback: function(data) {
                            insertSelectedAddress(data)
                            address1.val(data.address1);
                            address2.val(data.address2);
                            city.val(data.city);
                            state.val(data.stateCode);
                            postal.val(data.postalCode);
                            setCountryVal(data.countryCode);

                            // try to select the value by the label
                            if (!state.val()) {
                                state.blur();
                                const selectedOption = state.find('option[label="' + data.stateCode + '"]');
                                if (selectedOption.length) {
                                    state.val(selectedOption.attr('value'));
                                }
                            }

                            const firstInvalidField = allFields.find(addressField => {
                                const fieldToValidate = $(addressField.selector);
                                return fieldToValidate && fieldToValidate.length ? !$(addressField.selector).valid() : false;
                            });

                            const $form = address1.closest('form');
                            $form.find('input, select').trigger('initLabels');
                            if (firstInvalidField) {
                                $form.find('.toggle-edit, .enter-address-btn, [name$="_manualaddress"], label[for$="_manualaddress"]').trigger('click');
                                firstInvalidField.focus();

                                // Disable SAVE button if some address' fields are not filled only on checkout page
                                if ($(document).find('.pt_checkout').length > 0) {
                                    $form.find('[type="submit"]').prop('disabled', true);
                                }
                            } else {
                                // trigger change in order to pre-validate the form
                                address1.trigger('change');
                            }
                        }
                    });
                }
                ui.item.value=ui.item.label;
            }
        });
        toggleFields({target:toggle.unwrap()[0]});
        toggle.on('change', toggleFields);
        $form.on('submit', function() {
            allFields.forEach(function(f) {
                f.attr('disabled', false);
            });
        });
    }

    function setCountryVal(countryCodeVal) {
        // check if received value is upper or lower case and set it accordingly
        if (country.val() === country.val().toUpperCase()) {
            country.val(countryCodeVal.toUpperCase());
        } else {
            country.val(countryCodeVal);
        }
    }
}

},{"./ajax":3,"./util":104}],9:[function(require,module,exports){
'use strict';

var page = require('./page'),
    util = require('./util'),
    TPromise = require('promise');

var _currentCategory = '',
    MAX_ACTIVE = 6;

/**
 * @private
 * @function
 * @description Verifies the number of elements in the compare container and updates it with sequential classes for ui targeting
 */
function refreshContainer() {
    var $compareContainer = $('.compare-items');
    var $compareItems = $compareContainer.find('.compare-item');
    var numActive = $compareItems.filter('.active').length;

    if (numActive < 2) {
        $('#compare-items-button').attr('disabled', 'disabled');
    } else {
        $('#compare-items-button').removeAttr('disabled');
    }

    $compareContainer.toggle(numActive > 0);
}
/**
 * @private
 * @function
 * @description Adds an item to the compare container and refreshes it
 */
function addToList(data) {
    // get the first compare-item not currently active
    var $item = $('.compare-items .compare-item').not('.active').first(),
        $productTile = $('#' + data.uuid);

    if ($item.length === 0) {
        if ($productTile.length > 0) {
            $productTile.find('.compare-check')[0].checked = false;
        }
        window.alert(Resources.COMPARE_ADD_FAIL);
        return;
    }

    // if already added somehow, return
    if ($('[data-uuid="' + data.uuid + '"]').length > 0) {
        return;
    }
    // set as active item
    $item.addClass('active')
        .attr('data-uuid', data.uuid)
        .attr('data-itemid', data.itemid)
        .data('uuid', data.uuid)
        .data('itemid', data.itemid)
        .append($(data.img).clone().addClass('compare-item-image'));
}
/**
 * @private
 * @function
 * description Removes an item from the compare container and refreshes it
 */
function removeFromList($item) {
    if ($item.length === 0) { return; }
    // remove class, data and id from item
    $item.removeClass('active')
        .removeAttr('data-uuid')
        .removeAttr('data-itemid')
        .data('uuid', '')
        .data('itemid', '')
        // remove the image
        .find('.compare-item-image').remove();
}

function addProductAjax(args) {
    var promise = new TPromise(function (resolve, reject) {
        $.ajax({
            url: Urls.compareAdd,
            data: {
                pid: args.itemid,
                category: _currentCategory
            },
            dataType: 'json'
        }).done(function (response) {
            if (!response || !response.success) {
                reject(new Error(Resources.COMPARE_ADD_FAIL));
            } else {
                resolve(response);
            }
        }).fail(function (jqxhr, status, err) {
            reject(new Error(err));
        });
    });
    return promise;
}

function removeProductAjax(args) {
    var promise = new TPromise(function (resolve, reject) {
        $.ajax({
            url: Urls.compareRemove,
            data: {
                pid: args.itemid,
                category: _currentCategory
            },
            dataType: 'json'
        }).done(function (response) {
            if (!response || !response.success) {
                reject(new Error(Resources.COMPARE_REMOVE_FAIL));
            } else {
                resolve(response);
            }
        }).fail(function (jqxhr, status, err) {
            reject(new Error(err));
        });
    });
    return promise;
}

function shiftImages() {
    return new TPromise(function (resolve) {
        var $items = $('.compare-items .compare-item');
        $items.each(function (i, item) {
            var $item = $(item);
            // last item
            if (i === $items.length - 1) {
                return removeFromList($item);
            }
            var $next = $items.eq(i + 1);
            if ($next.hasClass('active')) {
                // remove its own image
                $next.find('.compare-item-image').detach().appendTo($item);
                $item.addClass('active')
                    .attr('data-uuid', $next.data('uuid'))
                    .attr('data-itemid', $next.data('itemid'))
                    .data('uuid', $next.data('uuid'))
                    .data('itemid', $next.data('itemid'));
            }
        });
        resolve();
    });
}

/**
 * @function
 * @description Adds product to the compare table
 */
function addProduct(args) {
    var promise;
    var $items = $('.compare-items .compare-item');
    var $cb = $(args.cb);
    var numActive = $items.filter('.active').length;
    if (numActive === MAX_ACTIVE) {
        if (!window.confirm(Resources.COMPARE_CONFIRMATION)) {
            $cb[0].checked = false;
            return;
        }

        // remove product using id
        var $firstItem = $items.first();
        promise = removeItem($firstItem).then(function () {
            return shiftImages();
        });
    } else {
        promise = TPromise.resolve(0);
    }
    return promise.then(function () {
        return addProductAjax(args).then(function () {
            addToList(args);
            if ($cb && $cb.length > 0) { $cb[0].checked = true; }
            refreshContainer();
        });
    }).then(null, function () {
        if ($cb && $cb.length > 0) { $cb[0].checked = false; }
    });
}

/**
 * @function
 * @description Removes product from the compare table
 * @param {object} args - the arguments object should have the following properties: itemid, uuid and cb (checkbox)
 */
function removeProduct(args) {
    var $cb = args.cb ? $(args.cb) : null;
    return removeProductAjax(args).then(function () {
        var $item = $('[data-uuid="' + args.uuid + '"]');
        removeFromList($item);
        if ($cb && $cb.length > 0) { $cb[0].checked = false; }
        refreshContainer();
    }, function () {
        if ($cb && $cb.length > 0) { $cb[0].checked = true; }
    });
}

function removeItem($item) {
    var uuid = $item.data('uuid'),
        $productTile = $('#' + uuid);
    return removeProduct({
        itemid: $item.data('itemid'),
        uuid: uuid,
        cb: ($productTile.length === 0) ? null : $productTile.find('.compare-check')
    });
}

/**
 * @private
 * @function
 * @description Initializes the DOM-Object of the compare container
 */
function initializeDom() {
    var $compareContainer = $('.compare-items');
    _currentCategory = $compareContainer.data('category') || '';
    var $active = $compareContainer.find('.compare-item').filter('.active');
    $active.each(function () {
        var $productTile = $('#' +  $(this).data('uuid'));
        if ($productTile.length === 0) {return;}
        $productTile.find('.compare-check')[0].checked = true;
    });
    // set container state
    refreshContainer();
}

/**
 * @private
 * @function
 * @description Initializes the events on the compare container
 */
function initializeEvents() {
    // add event to buttons to remove products
    $('.compare-item').on('click', '.compare-item-remove', function () {
        removeItem($(this).closest('.compare-item'));
    });

    // Button to go to compare page
    $('#compare-items-button').on('click', function () {
        page.redirect(util.appendParamToURL(Urls.compareShow, 'category', _currentCategory));
    });

    // Button to clear all compared items
    // rely on refreshContainer to take care of hiding the container
    $('#clear-compared-items').on('click', function () {
        $('.compare-items .active').each(function () {
            removeItem($(this));
        });
    });
}

exports.init = function () {
    initializeDom();
    initializeEvents();
};

exports.addProduct = addProduct;
exports.removeProduct = removeProduct;

},{"./page":37,"./util":104,"promise":128}],10:[function(require,module,exports){
'use strict';

/**
 * @function
 * @description New cookie configs
 * @param {String} cName Cookie name
 * @param {String} cValue Cookie value
 * @param {Number} expDays Number of days before the cookie expires
 */
 function setCookie(cName, cValue, expDays) {
    let date = new Date();
    date.setTime(date.getTime() + (expDays * 24 * 60 * 60 * 1000));
    const expires = "expires=" + date.toUTCString();
    const cookie = cName + "=" + cValue + "; " + expires + ";secure";
    document.cookie = cookie;
}

/**
 * Removes cookie by name
 * @param {String} cName
 */
function deleteCookie(cName) {
    document.cookie = cName +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

/**
 * Search cookie by name and return its value
 * @param {String} cName
 * @description Gets CookieScriptConsent value and formats it
 */
 function getCookie(cName) {
    cName += '=';

    const allCookies = document.cookie.split(';');
    for (let i = 0; i < allCookies.length; i++) {
        let cookie = allCookies[i];

        while (cookie.charAt(0) == ' ') {
            cookie = cookie.substring(1, cookie.length);
        }

        if (cookie.indexOf(cName) == 0) {
            return cookie.substring(cName.length, cookie.length);
        };
    }
    return null;
}

module.exports = {
    getCookie,
    setCookie,
    deleteCookie
}

},{}],11:[function(require,module,exports){
'use strict';

const cookie = require('./cookie');

/**
 * @function
 * @description Sets the new formated cookie
 */
function init() {
    const consentCookie = cookie.getCookie('CookieScriptConsent');
    if (consentCookie) {
        const consentCookieFormattedValue = consentCookie.replace(/,/g, '');
        cookie.deleteCookie('CookieScriptConsentFormatted');
        cookie.setCookie('CookieScriptConsentFormatted', consentCookieFormattedValue, 30);
    }
}

module.exports.init = init;

},{"./cookie":10}],12:[function(require,module,exports){
'use strict';

var util = require('./util');

/**
 * @function cookieprivacy        Used to display/control the scrim containing the cookie privacy code
 **/
module.exports = function () {
	/**
	 * If we have not accepted cookies AND we're not on the Privacy Policy page, then show the notification
	 * NOTE: You will probably want to adjust the Privacy Page test to match your site's specific privacy / cookie page
	 */
	if (document.cookie.indexOf('babyliss_cookies_accepted') < 0) {
	   // check for privacy policy page
	   if ($('.layer-cookie:visible').length === 0) {
	       $('.layer-cookie').show();
	       $('.layer-cookie .layer-cookie-close').click(function () {
	           $('.layer-cookie').hide();
	           enableCookies();
	       });
	   }
	} else {
	   // Otherwise, we don't need to show the asset, just enable the cookies
	   enableCookies();
	}

	initCampaignUtm();
	
	function enableCookies() {
	   if (document.cookie.indexOf('dw=1') < 0) {
	       document.cookie = 'dw=1; path=/';
	   }
	   if (document.cookie.indexOf('babyliss_cookies_accepted') < 0) {
	       document.cookie = 'babyliss_cookies_accepted=1; path=/; expires=Fri, 31 Dec 9999 23:59:59 GMT';
	   }
	}
	
	function initCampaignUtm() {
		var utm_source = getQueryStringValue("utm_source");
		
		/**
		 * If utm_source exist, we retrieve other utm
		 */
		if (utm_source != null && utm_source) {
			var utm = {
				'utm_source' : utm_source,
				'utm_medium' : getQueryStringValue("utm_medium"),
				'utm_campaign' : getQueryStringValue("utm_campaign"),
				'utm_content' : getQueryStringValue("utm_content")
			}, perfid = getQueryStringValue("perfid"), nrycnyc8 = getQueryStringValue("nrycnyc8");
			
			if (perfid)
				utm.perfid = perfid;
			
			if (nrycnyc8)
				utm.nrycnyc8 = nrycnyc8;
			
			var paramsUTM = util.appendParamsToUrl('', utm), d = new Date();
			
			d.setTime(d.getTime() + (152*24*60*60*1000)); //152 days which correspond to 5 months
			
		    var expires = "expires="+ d.toUTCString();

			document.cookie = 'babyliss_campaign_utm=' + paramsUTM.substring(1) + '; path=/; ' + expires;

			if($('div.popup-hatch').length > 1) {
				$('a.popup-hatch-button').each(function(index, element){
					var link = element.href, id = element.dataset.id, specUtm = '';
					if (link.indexOf('utm_source') >= 0) {
						link = removeParam('utm_source', link);
						link = removeParam('utm_medium', link);
						link = removeParam('utm_campaign', link);
						link = removeParam('utm_content', link);
						if(perfid)
							link = removeParam('perfid', link);

						if (nrycnyc8)
							link = removeParam('nrycnyc8', link);
							
						if (link.indexOf('aid') >= 0)
							link = removeParam('aid', link);
					}
					if (id = '87463')
						specUtm = '&aid='+utm['utm_source']+'_';
					
					element.href = link + '&'+paramsUTM.substring(1) + specUtm;
				});
			}
			
		}
	}
	
	function getQueryStringValue (key) {
		var windowsLocation = (window.location.hash != '') ? window.location.hash : window.location.search ;
		
		return unescape(windowsLocation.replace(new RegExp("^(?:.*[&\\?]" + decodeURI(key).replace(/[\.\+\*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i"), "$1"));  
	}

	function removeParam(key, sourceURL) {
	    var rtn = sourceURL.split("?")[0],
	        param,
	        params_arr = [],
	        queryString = (sourceURL.indexOf("?") !== -1) ? sourceURL.split("?")[1] : "";
	    if (queryString !== "") {
	        params_arr = queryString.split("&");
	        for (var i = params_arr.length - 1; i >= 0; i -= 1) {
	            param = params_arr[i].split("=")[0];
	            if (param === key) {
	                params_arr.splice(i, 1);
	            }
	        }
	        rtn = rtn + "?" + params_arr.join("&");
	    }
	    return rtn;
	}
};


},{"./util":104}],13:[function(require,module,exports){
'use strict';

var helpers = require('./helpers');

/**
* Handles the closing behavior of a country selection modal panel.
* Restores focus to the last focused element if appropriate, disables tab navigation for links within the panel,
* and adds a 'closed' class to the panel for styling or accessibility purposes.
*
* @param {jQuery} countryPanel - The jQuery object representing the country selection modal panel.
* @param {HTMLElement} lastFocusedElement - The DOM element that was focused before the modal was opened.
*/
function handleClosingModal(countryPanel, lastFocusedElement) {
    if (lastFocusedElement && countryPanel.is(':focus')) {
        lastFocusedElement.focus();
    }
    countryPanel.find('a').attr('tabindex', -1);
    countryPanel.addClass('closed');
}

exports.init = function init() {
    var $document = $(document);
    var lastFocusedElement;

    $('.country-selector .current-country').on('click', function () {
        $('.country-selector .selector').toggleClass('active');
        $(this).toggleClass('selector-active');
    });

    // Country selector
    $document.on('click keydown', '.hamburger-list .country-selector, .header-promotions .country-selector, #footer .country-selector', function (e) {
        var $clickedElement = $(e.target);
        var isCountryLink = $clickedElement.closest('.country-panel').length > 0 || $clickedElement.closest('.hamburger-list').length > 0;

        if (isCountryLink && e.key !== ' ') {
            return;
        }

        if ((e.type === 'click' || e.key === ' ' || e.key === 'Enter') && !isCountryLink) {
            var $countryPanel = $(this).next('.country-panel');
            e.preventDefault();

            if ($('.mobile-menu-toggler').is(':visible')) {
                $('#hamburgerNavigationMenu').collapse('toggle');
                $('.countries-select-hamburger').trigger('click');
            } else {
                $countryPanel.toggleClass('closed');

                if (!$countryPanel.hasClass('closed')) {
                    lastFocusedElement = document.activeElement;
                    $countryPanel.find('a').attr('tabindex', 1);
                    helpers.trapFocus($countryPanel[0]);
                } else {
                    handleClosingModal($countryPanel, lastFocusedElement);
                }
            }
        }
    });

    $document.on('click keydown', function (e) {
        var $countryPanel = $('.country-panel');

        if (e.type === 'click') {
            if ($(e.target).closest('.country-panel').length > 0 || $(e.target).closest('.utility-box').length > 0) {
                return;
            }

            handleClosingModal($countryPanel, lastFocusedElement);
        } else if (e.type === 'keydown' && e.key === 'Escape') {
            handleClosingModal($countryPanel, lastFocusedElement);
        }
    });

    // if the element having the following class name appears in the DOM then add
    // clear=1 HTTP parameter to all <a href> from country-panel container
    $(document).on('click', '.country-selector a, .js-hamburger-mega-countries .menu-category-item-hamburger a', function (e) {
        const util = require('./util');
        var $this = $(this);
        var $switchLocaleBtn = $('.js-locale-warning-button');
        var $redirectURL = $this.attr('href');
        var isCartNotEmpty = $('.minicart-quantity').length && $('.minicart-quantity').data('quantity');
        var isExternalSite;
        const currentLocale = $('.js-locale-switch-warning').data('currentLocale');
        const redirectedLocale = util.getQueryStringParams(util.getQueryString($redirectURL)).nh;
        const isCountryChanged = currentLocale !== redirectedLocale && currentLocale.substring(3) !== redirectedLocale.substring(3);
        const clearBasketParam = isCountryChanged ? '&clear=1' : '';

        if ($this.hasClass('menu-category-link')) {
            isExternalSite = $this.find('.country-name img').length ? $this.find('.country-name img').attr('src').indexOf('Redirect') > -1 : false;
        } else {
            isExternalSite = $this.children('img').length ? $this.children('img').attr('src').indexOf('Redirect') > -1 : false;
        }

        // set button's href and add the clear basket parameter
        if ($redirectURL) {
            $switchLocaleBtn.attr('href', $redirectURL + clearBasketParam);
        }

        // display modal only if country was changed and cart not empty
        if (isCountryChanged && isCartNotEmpty && !isExternalSite) {
            e.preventDefault();
            $('.js-locale-switch-warning').dialog({
                width: 480,
                modal: true
            });
        } else {
            $switchLocaleBtn.trigger('click');
        }
    });

    $(document).on('click', '.locale-warning-button-close', function() {
        $('.js-locale-switch-warning').dialog('close');
    });
};

},{"./helpers":31,"./util":104}],14:[function(require,module,exports){
'use strict';

var ajax = require('./ajax'),
    util = require('./util'),
    _ = require('lodash'),
    imagesLoaded = require('imagesloaded');

var dialog = {
    /**
     * @function
     * @description Appends a dialog to a given container (target)
     * @param {Object} params  params.target can be an id selector or an jquery object
     */
    create: function (params) {
        var $target, id;

        if (_.isString(params.target)) {
            if (params.target.charAt(0) === '#') {
                $target = $(params.target);
            } else {
                $target = $('#' + params.target);
            }
        } else if (params.target instanceof jQuery) {
            $target = params.target;
        } else {
            $target = $('#dialog-container');
        }

        // if no element found, create one
        if ($target.length === 0) {
            if ($target.selector && $target.selector.charAt(0) === '#') {
                id = $target.selector.substr(1);
                $target = $('<div>').attr('id', id).addClass('dialog-content').appendTo('body');
            }
        }

        // create the dialog
        this.$container = $target;
        this.$container.dialog(_.merge({}, this.settings, params.options || {}));
    },
    /**
     * @function
     * @description Opens a dialog using the given url (params.url) or html (params.html)
     * @param {Object} params
     * @param {Object} params.url should contain the url
     * @param {String} params.html contains the html of the dialog content
     */
    open: function (params) {
        // close any open dialog except the invoked modal is klarna
        if (params.options.dialogClass !== 'klarna-modal' && params.options.dialogClass !== 'details-product-dialog' && params.options.dialogClass !== 'engraving-dialog') {
            this.close();
        }
        this.create(params);
        this.replace(params);
    },
    /**
     * @description populate the dialog with html content, then open it
     **/
    openWithContent: function (params) {
        var content, position, callback;

        if (!this.$container) { return; }
        content = params.content || params.html;
        if (!content) { return; }
        this.$container.empty().html(content);
        if (!this.$container.dialog('isOpen')) {
            this.$container.dialog('open');
        }

        if (params.options) {
            position = params.options.position;
        }
        if (!position) {
            position = this.settings.position;
        }
        imagesLoaded(this.$container).on('done', function () {
            this.$container.dialog('option', 'position', position);
        }.bind(this));

        callback = (typeof params.callback === 'function') ? params.callback : function () {};
        callback();
    },
    /**
     * @description Replace the content of current dialog
     * @param {object} params
     * @param {string} params.url - If the url property is provided, an ajax call is performed to get the content to replace
     * @param {string} params.html - If no url property is provided, use html provided to replace
     */
    replace: function (params) {
        if (!this.$container) {
            return;
        }
        if (params.url) {
            params.url = util.appendParamToURL(params.url, 'format', 'ajax');
            ajax.load({
                url: params.url,
                data: params.data,
                callback: function (response) {
                    params.content = response;
                    this.openWithContent(params);
                }.bind(this)
            });
        } else if (params.html) {
            this.openWithContent(params);
        }
    },
    /**
     * @function
     * @description Closes the dialog
     */
    close: function () {
        if (!this.$container) {
            return;
        }
        this.$container.dialog('close');
    },
    exists: function () {
        return this.$container && (this.$container.length > 0);
    },
    isActive: function () {
        return this.exists() && (this.$container.children.length > 0);
    },
    settings: {
        autoOpen: false,
        height: 'auto',
        modal: true,
        closeText: Resources.CLOSE,
        overlay: {
            opacity: 0.5,
            background: 'black'
        },
        resizable: false,
        title: '',
        width: '800',
        close: function () {
            $(this).dialog('close');
        }
    }
};

module.exports = dialog;

},{"./ajax":3,"./util":104,"imagesloaded":124,"lodash":125}],15:[function(require,module,exports){
'use strict';

var quickview = require('./quickview');

/**
 * Returns the GARAN destination URL configured for the current site.
 * @returns {string|null} The configured URL, or an empty string when it is unset.
 */
function qrDestinationURL() {
    var sitePreferences = window.SitePreferences;
    return sitePreferences ? sitePreferences.EU_GARAN_DESTINATION_URL : '';
}

/**
 * Returns the localized GARAN destination link text, falling back to the URL.
 * @returns {string|null} The localized text or configured destination URL.
 */
function qrDestinationLinkText() {
    var resourceText = window.Resources && window.Resources.GARAN_GUARANTEE_FULL_IMAGE_LINK_TEXT;
    return resourceText || qrDestinationURL();
}

/**
 * Creates the destination link shown below the GARAN label.
 * @returns {jQuery} A paragraph containing the destination link.
 */
function createDestinationLink() {
    return $('<p/>')
        .addClass('eu-garan-qr-url')
        .append(
            $('<a/>').attr({
                href: qrDestinationURL(),
                target: '_blank',
                rel: 'noopener noreferrer'
            }).text(qrDestinationLinkText())
        );
}

/**
 * Finds the product image container for a PDP or quickview element.
 * @param {jQuery} $element Element inside the image gallery.
 * @returns {jQuery} The closest product image container.
 */
function imageContainer($element) {
    var $container = $element.closest('.product-image-container');
    return $container.length ? $container : $element.closest('.quickPDP, #pdpMain');
}

/**
 * Selects a GARAN thumbnail and updates the gallery's primary image.
 * @param {jQuery} $thumbnail GARAN thumbnail wrapper to select.
 * @returns {void}
 */
function selectThumbnail($thumbnail) {
    var $container = imageContainer($thumbnail);
    var image = $thumbnail.find('.productthumbnail').data('lgimg');
    if (!image) {
        return;
    }
    $container.find('.thumb.selected').removeClass('selected');
    $thumbnail.addClass('selected');
    var $primary = $container.find('.product-primary-image .primary-image').first();
    $primary.attr({ src: image.url, 'data-src': image.url, alt: image.alt, title: image.title }).addClass('eu-garan-primary');
    $primary.closest('.main-image').addClass('eu-garan-primary-viewer').trigger('zoom.destroy').attr('href', image.hires || image.url);
    var thumbnails = $thumbnail.closest('#thumbnails')[0];
    if (thumbnails && thumbnails.swiper) {
        thumbnails.swiper.slideTo($thumbnail.index(), 0);
    }
}

/**
 * Selects the GARAN thumbnail when a quickview opens.
 * @param {jQuery} $container Quickview container.
 * @returns {void}
 */
function selectQuickview($container) {
    var $thumbnail = $container.find('.eu-garan-thumbnail').first();
    if ($thumbnail.length) {
        selectThumbnail($thumbnail);
    }
}

/**
 * Opens the GARAN label in a modal with its destination link.
 * @param {jQuery} $trigger Element that opened the modal.
 * @param {jQuery} [$labelData] Optional element containing label data attributes.
 * @returns {void}
 */
function openLabel($trigger, $labelData) {
    var $data = $labelData || $trigger.closest('[data-full-label]');
    var imageURL = $data.attr('data-full-label');
    if (!imageURL || !/^https:\/\//i.test(imageURL)) {
        return;
    }
    var $existing = $('#EuGaranDialog');
    if ($existing.length) {
        $existing.dialog('close');
    }
    var $content = $('<div/>').attr('id', 'EuGaranDialog');
    $('<img/>').attr({ src: imageURL, alt: $data.attr('data-label-alt') }).appendTo($content);
    $content.append(createDestinationLink());
    $content.appendTo(document.body).dialog({
        modal: true,
        resizable: false,
        closeOnEscape: true,
        closeText: window.Resources.CLOSE,
        title: $data.attr('data-label-alt'),
        dialogClass: 'eu-garan-modal product-image-zoom',
        width: Math.min(960, $(window).width() - 24),
        height: 'auto',
        close: function () {
            $content.dialog('destroy').remove();
            if ($trigger.length && $.contains(document, $trigger[0])) {
                $trigger.trigger('focus');
            }
        }
    });
}

/**
 * Registers GARAN gallery, badge, and modal event handlers.
 * @returns {void}
 */
function init() {
    $(function () {
        $(document).off('.euGaran')
            .on('click.euGaran', '.js-eu-garan-quickview', function (event) {
                event.preventDefault();
                event.stopPropagation();
                event.stopImmediatePropagation();
                var $trigger = $(this);
                quickview.show({
                    url: $trigger.attr('data-url'),
                    source: 'quickview',
                    callback: function () {
                        selectQuickview($('#QuickViewDialog'));
                    }
                });
            })
            .on('click.euGaran', '.js-eu-garan-overlay', function (event) {
                var $trigger = $(this);
                // On PDP the `.main-image` click already opens the existing zoom modal.
                // Avoid opening our custom dialog on top of it.
                if ($trigger.hasClass('main-image')) {
                    return;
                }
                event.preventDefault();
                event.stopPropagation();
                event.stopImmediatePropagation();
                openLabel($trigger);
            })
            .on('click.euGaran', '.eu-garan-thumbnail-control', function (event) {
                event.preventDefault();
                selectThumbnail($(this).closest('.eu-garan-thumbnail'));
            })
            .on('click.euGaran', '.productthumbnail', function () {
                if (!$(this).closest('.eu-garan-thumbnail').length) {
                    var $container = imageContainer($(this));
                    $container.find('.primary-image').removeClass('eu-garan-primary');
                    $container.find('.main-image').removeClass('eu-garan-primary-viewer');
                }
            })
            .on('dialogopen.euGaran', '#dialog-container', function () {
                var $dialog = $(this);
                var $img = $dialog.find('img').first();
                if (!$img.length) {
                    return;
                }

                // Add the destination link when the zoom modal shows the EU guarantee label.
                var expectedSrc = $('.main-image.eu-garan-primary-viewer').attr('href') || $('.eu-garan-viewer.main-image').attr('href');
                if (!expectedSrc || $img.attr('src') !== expectedSrc) {
                    return;
                }

                // Ensure we do not stack handlers/links across multiple opens.
                $img.removeAttr('role').removeAttr('tabindex');
                $dialog.find('.eu-garan-qr-url').remove();
                $img.after(createDestinationLink());
            });
    });
}

module.exports = {
    init: init,
    selectQuickview: selectQuickview,
    openLabel: openLabel
};

},{"./quickview":86}],16:[function(require,module,exports){
'use strict';

var ajax = require('./ajax'),
    util = require('./util');
/**
 * @function
 * @description Load details to a given gift certificate
 * @param {String} id The ID of the gift certificate
 * @param {Function} callback A function to called
 */
exports.checkBalance = function (id, callback) {
    // load gift certificate details
    var url = util.appendParamToURL(Urls.giftCardCheckBalance, 'giftCertificateID', id);

    ajax.getJson({
        url: url,
        callback: callback
    });
};

},{"./ajax":3,"./util":104}],17:[function(require,module,exports){
'use strict';

var ajax = require('./ajax'),
    minicart = require('./minicart'),
    util = require('./util');

var setAddToCartHandler = function (e) {
    e.preventDefault();
    var form = $(this).closest('form');

    var options = {
        url: util.ajaxUrl(form.attr('action')),
        method: 'POST',
        cache: false,
        data: form.serialize()
    };
    $.ajax(options).done(function (response) {
        if (response.success) {
            ajax.load({
                url: Urls.minicartGC,
                data: {lineItemId: response.result.lineItemId},
                callback: function (response) {
                    minicart.show(response);
                    form.find('input,textarea').val('');
                }
            });
        } else {
            form.find('span.error').hide();
            for (var id in response.errors.FormErrors) {
                var $errorEl = $('#' + id).addClass('error').removeClass('valid').next('.error');
                if (!$errorEl || $errorEl.length === 0) {
                    $errorEl = $('<span for="' + id + '" generated="true" class="error" style=""></span>');
                    $('#' + id).after($errorEl);
                }
                $errorEl.text(response.errors.FormErrors[id].replace(/\\'/g, '\'')).show();
            }
        }
    }).fail(function (xhr, textStatus) {
        // failed
        if (textStatus === 'parsererror') {
            window.alert(Resources.BAD_RESPONSE);
        } else {
            window.alert(Resources.SERVER_CONNECTION_ERROR);
        }
    });
};

exports.init = function () {
    $('#AddToBasketButton').on('click', setAddToCartHandler);
};

},{"./ajax":3,"./minicart":36,"./util":104}],18:[function(require,module,exports){
/**
 *    (c) 2009-2014 Demandware Inc.
 *    Subject to standard usage terms and conditions
 *    For all details and documentation:
 *    https://bitbucket.com/demandware/sitegenesis
 */

'use strict';

var util = require('./util');
var tagmanager_event = require('./tagmanager_event');
var scrollHomepage = require('./gtm/scrollHomepage');
var scrollUniversePage = require('./gtm/scrollUniversePage');
var scrollIconicPage = require('./gtm/scrollIconicPage');
var switchBannerHomePage = require('./gtm/switchBannerHomePage')
var clickIconicFAQQuestion = require('./gtm/clickIconicFAQQuestion')



var initializeEvents = function() {
	var debug = false;

	// GENERAL

	// clickMainMenu
	// Triggered each time a user click on main menu.
	$('.js-gtm-menu').on('click', function(e) {
		if(debug) e.preventDefault();
		var menuName = '';
		if($(this).attr('data-gtm-name')) 	menuName = $(this).attr('data-gtm-name');
		if(menuName != '')					tagmanager_event('clickMainMenu', { 'menu_name': menuName });
	});
	// // clickEventLandingMenu
	// // Triggered each time a user click on the event landing menu.
	// $('.js-gtm-landingmenu').on('click', function(e) {
	// 	if(debug) e.preventDefault();
	// });
	// clickSubNavigation
	// Triggered each time a user click on a sub-navigation.
	$('.js-gtm-submenu').on('click', function(e) {
		if(debug) e.preventDefault();
		var layer 			= '';
		var subcategory 	= '';
		var subsubcategory 	= '';
		if($(this).attr('data-gtm-layer')) 			layer = $(this).attr('data-gtm-layer');
		if($(this).attr('data-gtm-subcategory')) 	subcategory = $(this).attr('data-gtm-subcategory');
		if($(this).attr('data-gtm-subsubcategory')) subsubcategory = $(this).attr('data-gtm-subsubcategory');
		if(layer != '' && subcategory != '' && subsubcategory != '') tagmanager_event('clickSubNavigation', { 'layer': layer, 'subcategory': subcategory, 'subsubcategory': subsubcategory });
		console.log("layer: "+layer + " subcat: "+subcategory+" subsubcat: "+subsubcategory);
	});
	// clickSpecificPush
	// Triggered each time a user click on a specific push.
	$('.js-gtm-push').on('click', function(e) {
		if(debug) e.preventDefault();
		var layer 			= '';
		var pushtype	 	= '';
		var pushname	 	= '';
		var subcat 			= $(this).parents('.level-2').find('.js-gtm-submenu');
		if($(this).attr('data-gtm-pushtype')) 			pushtype = $(this).attr('data-gtm-pushtype');
		if(subcat.attr('data-gtm-layer')) 		layer = subcat.attr('data-gtm-layer');
		if($(this).find('img').attr('title'))	pushname = $(this).find('img').attr('title');
		if(layer != '' && pushtype != '' && pushname != '') tagmanager_event('clickSpecificPush', { 'layer': layer, 'push_Type': pushtype, 'push_Name': pushname });
	});

	// HOMEPAGE
	switchBannerHomePage();

	// clickBannerShowcase
	// Triggered each time a user click on the showcase banner.
	$('.js-gtm-showcase').on('click', function(e) {
		if(debug) e.preventDefault();
		var bannername = '';
		if($(this).attr('data-gtm-banner-name')) bannername = $(this).attr('data-gtm-banner-name');
		if(bannername) tagmanager_event('clickBannerShowcase', {'banner_name': bannername});
	});
	// clickBlockUniverse
	// Triggered each time a user click on a universe block.
	$('.js-gtm-universe').on('click', function(e) {
		if(debug) e.preventDefault();
		var blockname = '';
		if($(this).attr('data-gtm-block-name')) blockname = $(this).attr('data-gtm-block-name');
		if(blockname) tagmanager_event('clickBlockUniverse', {'block_name': blockname});
	});

	// clickBlockSelection
	// Triggered each time a user click on a selection block.
	require('./gtm/clickBlockSelection')();


	// PAGE UNIVERS
	scrollUniversePage();

	// clickUniverseDiscover
	// Triggered each time a user click on the "Découvrez nos produits" button on a universe page.
	$('.js-gtm-universe-discover').on('click', function(e) {
		if(debug) e.preventDefault();
		tagmanager_event('clickUniverseDiscover', {});
		// tagmanager_event('switchBanner', {});
	});
	// clickUniverseHighlight
	// Triggered each time a user click on a highlight product.
	$('.js-gtm-universe-highlight').on('click', function(e) {
		if(debug) e.preventDefault();
		var cta = '';
		if($(this).html()) cta = $(this).html();
		if(cta != '') tagmanager_event('clickUniverseHighlight', {'CTA_clicked': cta});
	});

	// clickUniverseViewProduct
	// Triggered each time a user click on the "Voir le produit" button on a universe page.
	// require('./gtm/clickUniverseViewProduct')();
	// it now use a variant event of clickThumbnail
	// clickUniverseCircle
	// Triggered each time a user click on a circle on a universe page.
	$('.js-gtm-universe-circle').on('click', function(e) {
		if(debug) e.preventDefault();
		tagmanager_event('clickUniverseCircle', {});
	});
	// clickUniverseShareInspiration
	// Triggered each time a user click on the "Partagez l'inspiration" button on a universe page.
	$('.js-gtm-inspiration').on('click', function(e) {
		if(debug) e.preventDefault();
		tagmanager_event('clickUniverseShareInspiration', {});
	});

	// PRODUCT LIST

	// sort
	// Triggered each time a user sort a page list.
	// tagmanager_event('sort', {'value': 'popularity'});

	// filter
	// Triggered each time a filter is added.
	$('body').on('click', '.js-gtm-filter', function(e) {
		if(debug) e.preventDefault();
		if(!$(this).closest('li').hasClass('selected')) {
			var filter_name = '';
			var filter_value = '';
			if($(this)) filter_name = $(this).closest('.refinement').find('.rf-definition-label').html();
			if($(this)) filter_value = $(this).clone().children().remove().end().text();
			filter_value = filter_value.replace(/(\r\n|\n|\r)/gm,"");
			if(filter_name && filter_value) tagmanager_event('filter', {'filter_name': filter_name, 'filter_value': filter_value});
		}
	});

	// ICONIC PDP

	// clickIconicFAQSeeAnswers
	// Triggered each time a user click on the "Voir les réponses" button on a iconic product page.
	$('.js-gtm-askButton').on('click', function(e) {
		if(debug) e.preventDefault();
		tagmanager_event('clickIconicFAQSeeAnswers', {});
	});
	// clickIconicFAQQuestion
	// Triggered each time a user click on a FAQ question on a iconic product page.
	// clickProductFAQQuestion
	// Triggered each time a user click on a FAQ question on a product page.
	if ( $('.js-gtm-product-faq').length || $('.product-faq-item'.length) ) clickIconicFAQQuestion();
	// clickIconicDownload
	// Triggered each time the user click on a download button  on a iconic product page.
	// clickProductDownload
	// Triggered each time the user click on a download button on a product page.
	$('.js-gtm-download').on('click', function(e) {
		if(debug) e.preventDefault();
		var document = '';
		if($(this).html()) document = $(this).html();
		if( $('#productpage_hero').val() == "true" ) {
			if(document != '') tagmanager_event('clickIconicDownload', {'document': document});
		} else {
			if(document != '') tagmanager_event('clickProductDownload', {'document': document});
		}
	});


	scrollIconicPage();


	// clickIconicAddToCart
	// Triggered each time a user click on a add to cart button on a iconic product page.
	// clickProductAddToCart
	// Triggered each time a user click on a add to cart button on a product page.
	$('.js-gtm-addToCart').on('click', function(e) {
		if(debug) e.preventDefault();
		if($('#productpage_hero').length && $('#productpage_hero').val() == "true") {
			tagmanager_event('clickIconicAddToCart', {});
		} else {
			tagmanager_event('clickProductAddToCart', {});
		}
	});

	// PDP

	// clickSwitchProduct
	// Triggered each time a user click on the switch product button.
	$('.js-gtm-switch').on('click', function(e) {
		if(debug) e.preventDefault();
		var value = '';
		if($(this).parent().hasClass('product-previous')) 	value = 'previous';
		if($(this).parent().hasClass('product-next')) 		value = 'next';
		if(value != '') tagmanager_event('clickSwitchProduct', {'value': value});
	});
	// clickColorSelector
	// Triggered each time a user click on the color selector.
	$(document).on('click', '.js-gtm-color', function(e) {
		if(debug) e.preventDefault();
		var color_name = '';
		if($(this).attr('data-gtm-color-name')) color_name = $(this).attr('data-gtm-color-name');
		if(color_name != '') tagmanager_event('clickColorSelector', {'color_name': color_name});
	});
	// clickProductChangeView
	// Triggered each time a user click on another view of the product.
	$(document).on('click', '.js-gtm-view', function(e) {
		if(debug) e.preventDefault();
		tagmanager_event('clickProductChangeView', {});
	});

	// clickProductTab
	// Triggered each time the user click on a product tab.
	require('./gtm/clickProductTab')(tagmanager_event);



	// SEARCH BAR SUGGESTION

	// clickSearchBarSearch
	// Triggered each time a user click on the search button on the search bar.
	$('.js-gtm-search').on('click', function(e) {
		if(debug) e.preventDefault();
		tagmanager_event('clickSearchBarSearch', {});
	});
	// clickSearchBarCategory
	// Triggered each time a user click on a category on the search bar.
	$('.header-search').on('click', '.js-gtm-search-category', function(e) {
		if(debug) e.preventDefault();
		var category_name = '';
		if($(this).html()) category_name = $(this).clone().children().remove().end().text();
		category_name = category_name.replace(/(\r\n|\n|\r)/gm,"");
		if(category_name) tagmanager_event('clickSearchBarCategory', {'category_name': category_name});
	});

	// clickSearchBarAutocomplete
	// Triggered each time a user click on an autocompletion on the search bar.
	require('./gtm/clickSearchBarAutocomplete')(tagmanager_event);

	require('./gtm/clickSearchBarArticle')();


	// STORE LOCATOR

	// clickStoreLocatorSearch
	// Triggered each time a user click on the search button on the store locator page.
	$('.js-gtm-storelocator-search').on('click', function(e) {
		if(debug) e.preventDefault();
		tagmanager_event('clickStoreLocatorSearch', {});
	});
	// clickStoreLocatorCity
	// Triggered each time a user enter a city or a city code on the store locator page.
	var storelocatorCityTimer = null;
	$('.js-gtm-storelocator-city').on('keydown change', function(e){
		if(debug) e.preventDefault();
		clearTimeout(storelocatorCityTimer);
		storelocatorCityTimer = setTimeout(function() {
			var value = '';
			if($('.js-gtm-storelocator-city').length) value = $('.js-gtm-storelocator-city').val();
			if(value != '') tagmanager_event('clickStoreLocatorCity', {'value': value});
		}, 1000)
	});

	// clickStoreLocatorRange
	// Triggered each time a user selecte a range on the store locator page.
	$('.js-gtm-storelocator-range').on('change', function(e){
		if(debug) e.preventDefault();
		var value = '';
		if($('.js-gtm-storelocator-range').length) value = $('.js-gtm-storelocator-range').val();
		if(value != '') tagmanager_event('clickStoreLocatorRange', {'value': value});
	});
	// clickStoreLocatorGeoloc
	// Triggered each time a user click on a geolocalisation button on the store locator page.
	$('.js-gtm-storelocator-geoloc').on('click', function(e){
		if(debug) e.preventDefault();
		tagmanager_event('clickStoreLocatorGeoloc', {});
	});
	// clickStoreLocatorBack
	// Triggered each time a user click on the "Retour à la recherche" button on the store locator page.
	$('.js-gtm-storelocator-back').on('click', function(e){
		if(debug) e.preventDefault();
		tagmanager_event('clickStoreLocatorBack', {});
	});

	// clickStoreLocatorLearnMore
	// Triggered each time a user click on the "En savoir plus" button on the store locator page.
	$('.js-gtm-storelocator-more').on('click', function(e){
		if(debug) e.preventDefault();
		var store_name = '';
		if($(this).closest('.store-raw')) store_name = $(this).closest('.store-raw').find('.store-information .store-details-link').text();
		if(store_name) tagmanager_event('clickStoreLocatorLearnMore', {'store_name': store_name});
	});

	// TEMPLATE

	// clickService
	// Triggered each time a user click on a service button.
	$('.js-gtm-footer-service').on('click', function(e) {
		if(debug) e.preventDefault();
		var service_name = '';
		if($(this).attr('data-gtm-service-name')) service_name = ($(this).attr('data-gtm-service-name'));
		if(service_name) tagmanager_event('clickService', {'service_name': service_name});
	});
	// clickFooterStoreLocator
	// Triggered each time a user click on tue store locator button in the footer.
	$('.js-gtm-footer-storelocator').on('click', function(e) {
		if(debug) e.preventDefault();
		tagmanager_event('clickFooterStoreLocator', {});
	});
	// clickFooterNewsletter
	// Triggered each time a user subscribed to the newsletter in the footer.
	$('.js-gtm-footer-newsletter').on('click', function(e) {
		if(debug) e.preventDefault();
		var tmpChoice = "";
		var choice = "";
		var parentForm = $(this).closest('form');
		var checkboxes = parentForm.find('input[type="checkbox"]:checked');
		if(checkboxes)
			checkboxes.each(function() {
				tmpChoice = $(this).closest('.checkbox').find('label span').html();
				choice += tmpChoice+" ";
			});
		if(choice) tagmanager_event('clickFooterNewsletter', {'choice': choice});
	});
	// clickFooterContact
	// Triggered each time a user click on the contact button in the footer.
	$('.js-gtm-footer-contact').on('click', function(e){
		if(debug) e.preventDefault();
		tagmanager_event('clickFooterContact', {});
	});
	// PRODUCT THUMBNAIL
	// clickThumbnail
	// Triggered each time a user click on a thumbnail.
	// data-gtm-productid="${pdict.Product.ID}" data-gtm-productname="${pdict.Product.name}" data-gtm-productsubcategory="${pdict.Category.displayName}" data-gtm-productcategory="${TopLevelCategory.displayName}"
	require('./gtm/clickThumbnail')(debug);


	// ADD TO CART

	// clickAddToCart
	require('./gtm/clickAddToCart')();

	// TrackPage Home Page
	scrollHomepage();
	if ($('#homepage-slider').length) {
		var url_page 	= '';
		var user_device = 'D';
		url_page = location.protocol + '//' + location.host + '/';
		if(util.isMobile()) user_device = 'M';
		if(url_page && user_device) tagmanager_event('HomePage', {'sv1': url_page, 'sv2': user_device});
	}

	// TrackPage Category Page
	else if ($('.category-slot').length) {
		var event_name 		= '';
		var url_page 		= '';
		var user_device 	= 'D';
		var category_name 	= '';
		var category_id 	= '';
		event_name = getTreeByBreadCrumb();
		if(event_name.length > 1) {
			event_name = event_name.join("|")
		}
		url_page = location.protocol + '//' + location.host + location.pathname;
		if(util.isMobile()) user_device = 'M';
		if($('.js-gtm-category').attr('data-gtm-category-name'))	category_name = $('.js-gtm-category').attr('data-gtm-category-name');
		if($('.js-gtm-category').attr('data-gtm-category-id'))		category_id = $('.js-gtm-category').attr('data-gtm-category-id');
		if(event_name && url_page && user_device && category_name && category_id) tagmanager_event(event_name, {'sv1': url_page, 'sv2': user_device, 'category_name': category_name, 'category_id': category_id});
	}
	// TrackPage Product Page
	else if ($('#pdpMain').length) {
		var url_page 		= '';
		var user_device 	= 'D';
		var category_name 	= '';
		var category_id 	= '';
		var product_name 	= '';
		var product_id 		= '';
		url_page = location.protocol + '//' + location.host + location.pathname;
		if(util.isMobile()) user_device = 'M';
		if($('.js-gtm-product').attr('data-gtm-category-name'))		category_name = $('.js-gtm-product').attr('data-gtm-category-name');
		if($('.js-gtm-product').attr('data-gtm-category-id'))		category_id = $('.js-gtm-product').attr('data-gtm-category-id');
		if($('.js-gtm-product').attr('data-gtm-product-name'))		product_name = $('.js-gtm-product').attr('data-gtm-product-name');
		if($('.js-gtm-product').attr('data-gtm-product-id'))		product_id = $('.js-gtm-product').attr('data-gtm-product-id');
		if(url_page && user_device && category_name && category_id && product_name && product_id) tagmanager_event('Product', {'sv1': url_page, 'sv2': user_device, 'category_name': category_name, 'category_id': category_id, 'product_name': product_name, 'product_id': product_id});
	}
	// TrackPage CMS
	else {
		var url_page 		= '';
		var user_device 	= 'D';
		url_page = location.protocol + '//' + location.host + location.pathname;
		if(util.isMobile()) user_device = 'M';
		if(url_page && user_device) tagmanager_event('CMSPage', {'sv1': url_page, 'sv2': user_device});
	}
	// RetailTrafficAmazon
	// Triggered each time a user clic on product page buy button.
	$('.js-gtm-amazon').on('click', function(e) {
		if(debug) e.preventDefault();
		var url_page 		= '';
		var user_device 	= 'D';
		var category_name 	= '';
		var category_id 	= '';
		var product_name 	= '';
		var product_id 		= '';
		url_page = location.protocol + '//' + location.host + location.pathname;
		if(util.isMobile()) user_device = 'M';
		if($('.js-gtm-product').attr('data-gtm-category-name'))		category_name = $('.js-gtm-product').attr('data-gtm-category-name');
		if($('.js-gtm-product').attr('data-gtm-category-id'))		category_id = $('.js-gtm-product').attr('data-gtm-category-id');
		if($('.js-gtm-product').attr('data-gtm-product-name'))		product_name = $('.js-gtm-product').attr('data-gtm-product-name');
		if($('.js-gtm-product').attr('data-gtm-product-id'))		product_id = $('.js-gtm-product').attr('data-gtm-product-id');
		if(url_page && user_device && category_name && category_id && product_name && product_id) tagmanager_event('RetailTrafficAmazon', {'sv1': url_page, 'sv2': user_device, 'category_name': category_name, 'category_id': category_id, 'product_name': product_name, 'product_id': product_id});
	});
	// RetailTrafficEshop
	// Triggered each time a user clic on product page buy button.
	$('.js-gtm-eshop').on('click', function(e) {
		if(debug) e.preventDefault();
		var url_page 		= '';
		var user_device 	= 'D';
		var category_name 	= '';
		var category_id 	= '';
		var product_name 	= '';
		var product_id 		= '';
		url_page = location.protocol + '//' + location.host + location.pathname;
		if(util.isMobile()) user_device = 'M';
		if($('.js-gtm-product').attr('data-gtm-category-name'))		category_name = $('.js-gtm-product').attr('data-gtm-category-name');
		if($('.js-gtm-product').attr('data-gtm-category-id'))		category_id = $('.js-gtm-product').attr('data-gtm-category-id');
		if($('.js-gtm-product').attr('data-gtm-product-name'))		product_name = $('.js-gtm-product').attr('data-gtm-product-name');
		if($('.js-gtm-product').attr('data-gtm-product-id'))		product_id = $('.js-gtm-product').attr('data-gtm-product-id');
		if(url_page && user_device && category_name && category_id && product_name && product_id) tagmanager_event('RetailTrafficEshop', {'sv1': url_page, 'sv2': user_device, 'category_name': category_name, 'category_id': category_id, 'product_name': product_name, 'product_id': product_id});
	});
	// SendForm
	$('.contactAdvice .js-gtm-contact-form').on('submit', function(e){
		if(debug) e.preventDefault();
		tagmanager_event('SendForm', {'SendForm': Resources.CONTACT_FORM_INFOS});
	});

	// SendForm
	$('.contactAccessory .js-gtm-contact-form').on('submit', function(e){
		if(debug) e.preventDefault();
		tagmanager_event('SendForm', {'SendForm': Resources.CONTACT_FORM_ACCESSORIES});
	});

	// SendForm
	$('.contactOther .js-gtm-contact-form').on('submit', function(e){
		if(debug) e.preventDefault();
		tagmanager_event('SendForm', {'label': Resources.CONTACT_FORM_OTHER});
	});
};

var getTreeByBreadCrumb = function() {
	var tree;
	if($('.breadcrumb').length)	{
		tree = new Array;
		tree.push('CategoryPage');
		$('.breadcrumb div').each(function(index) {
			if(index != 0) {
				tree.push($(this).find('a span').html());
			}
		});
	}
	return tree;
};

var app = {
    init: function () {
    	initializeEvents();
    }
};

//initialize app
app.init();

},{"./gtm/clickAddToCart":19,"./gtm/clickBlockSelection":20,"./gtm/clickIconicFAQQuestion":21,"./gtm/clickProductTab":22,"./gtm/clickSearchBarArticle":23,"./gtm/clickSearchBarAutocomplete":24,"./gtm/clickThumbnail":25,"./gtm/scrollHomepage":27,"./gtm/scrollIconicPage":28,"./gtm/scrollUniversePage":29,"./gtm/switchBannerHomePage":30,"./tagmanager_event":101,"./util":104}],19:[function(require,module,exports){
var tagmanager_event = require('../tagmanager_event');
module.exports = function () {
	// Triggered each time a userclick on a add to cart button.
	$('.js-gtm-clickAddToCart').on('click', function (e) {
		//if (debug) e.preventDefault();

		var id = '';
		var name = '';
		var price = '';
		var category = '';
		var subcategory = '';
		var reviews = '';
		var rating = '';
		var context = '';

		if ($(this).attr('data-gtm-productid')) id = $(this).attr('data-gtm-productid');
		if ($(this).attr('data-gtm-productname')) name = $(this).attr('data-gtm-productname');
		if ($(this).attr('data-gtm-price')) price = parseFloat($(this).attr('data-gtm-price'));
		if ($(this).attr('data-gtm-productcategory')) category = $(this).attr('data-gtm-productcategory');
		if ($(this).attr('data-gtm-productsubcategory')) subcategory = $(this).attr('data-gtm-productsubcategory');
		if ($(this).attr('data-gtm-context')) context = $(this).attr('data-gtm-context');
		if ($(this).attr('data-gtm-rating')) rating = $(this).attr('data-gtm-rating');
		if ($(this).attr('data-gtm-reviews')) reviews = $(this).attr('data-gtm-reviews');

		tagmanager_event('clickAddToCart', {
			'id': id,
			'name': name,
			'price': price,
			'category': subcategory,
			'subcategory': category,
			'reviews': reviews,
			'rating': rating,
			'context': context
		});
	});
}

},{"../tagmanager_event":101}],20:[function(require,module,exports){
var tagmanager_event = require('../tagmanager_event');
module.exports = function () {
	if ($('#homepage-slider').length) {
		$('.js-gtm-selection').on('click', function(e) {	
			e.preventDefault();
			var blocktype = '';
			var blockname = '';
			if($(this).find('.product-name').text()) 					blockname = $(this).find('.product-name').text();
			if ( $(this).find('.arrow-button').text() ) {
				blocktype += 'Product: ' + $(this).find('h3').text();
			}
			else if( $(this).find('.product-discover .button').text() )	blocktype += $(this).find('.product-discover .button').text() + ': ' + $(this).find('h3').text();
			if(blockname && blocktype) tagmanager_event('clickBlockSelection', {'block_name': blockname, 'block_type': blocktype});
			window.location.href = $(this).attr('href');
		});
	}
}
},{"../tagmanager_event":101}],21:[function(require,module,exports){
var tagmanager_event = require('../tagmanager_event');
function clickFaq( li ) {
	var question = li.querySelector('.product-faq-title').innerText
	if ( question && question != '' ) {
		if ( document.querySelector('.bloc-iconic') ) {
			tagmanager_event('clickIconicFAQQuestion', {'question': question});	
		}
		else{
			tagmanager_event('clickProductFAQQuestion', {'question': question});	
		}
	}
}
module.exports = function () {
	if ( $('.js-gtm-product-faq').length ) {
		$('.js-gtm-product-faq').on('click', function(e) {
			// We don't send the gtm info when we close the faq
			if (e.target.parentNode.className.indexOf("product-faq-item--visible") < 0) {
				return
			}
			clickFaq( e.target.parentNode );
		});
	} 
	else if ( $('.product-faq-item').length ){
		$(document).on('click', '.product-faq-item', function (e) {
			if ( e.target.parentNode.className.indexOf('product-faq-item--visible') > -1 ) {
				clickFaq( e.target.parentNode );
			}
		})
	}
}
},{"../tagmanager_event":101}],22:[function(require,module,exports){
"use strict";
module.exports = function (tagmanager_event) {
    const tabLink = document.querySelectorAll('.product-info .tab-nav .tab a')
    for (let i = 0; i < tabLink.length; i++) {
        tabLink[i].addEventListener('click', function (e) {
            var tab_name = '';
            if (this.innerText) tab_name = this.innerText;
            if (tab_name != '') tagmanager_event('clickProductTab', { 'tab_name': tab_name });
        });
    }
};

},{}],23:[function(require,module,exports){
var tagmanager_event = require('../tagmanager_event');
module.exports = function () {
    var debug = false
    if (debug) {
        $(document).on('click', '.hitgroup .hit a', function (e) {
            e.preventDefault();
        });
    }
    $(document).on('click', '.hitgroup .hit', function (e) {
        if (debug) {
            e.preventDefault();
            // Bien choisir sa tondeuse
        }        
        tagmanager_event('clickSearchBarArticle', {
            'article_name': this.innerText
        });
    });
}
},{"../tagmanager_event":101}],24:[function(require,module,exports){
module.exports = function (tagmanager_event) {
    $(document).on('click', '.search-product-list .search-product-item', function (e) { 
        e.preventDefault();
        var a = $(e.target).parents('a');
        var href = a.attr('href');
        var productName = a.find('.search-product-name-value').text();
        if ( productName ) {
            tagmanager_event('clickSearchBarAutocomplete', {
                'product_name': productName
            });
        }
        window.location.href = href;
    });
}
},{}],25:[function(require,module,exports){
var tagmanager_event = require('../tagmanager_event');
var debu;
function clickThumbnail(event) {
    $('.js-gtm-thumbnail').on('click', function(e){
        if(debu) e.preventDefault();
        var container_name = pageContext.ns; // HP_Selections / Universe_Selection / List_Page / Search_Results / PDP_cross_sell
        var position = '';
        var id = '';
        var name = '';
        var category = '';
        var subcategory = '';
        var reviews = '';
        var rating = '';
        var context = '';
        if($(this).closest('li')) position = $(this).closest('li').index();
        if($(this).attr('data-gtm-productid')) id = $(this).attr('data-gtm-productid');
        if($(this).attr('data-gtm-productname')) name = $(this).attr('data-gtm-productname');
        if($(this).attr('data-gtm-productcategory')) category = $(this).attr('data-gtm-productcategory');
        if($(this).attr('data-gtm-productsubcategory')) subcategory = $(this).attr('data-gtm-productsubcategory');
        if($(this).attr('data-gtm-context')) context = $(this).attr('data-gtm-context');
        if($(this).attr('data-gtm-rating')) rating = $(this).attr('data-gtm-rating');
        if($(this).attr('data-gtm-reviews')) reviews = $(this).attr('data-gtm-reviews');
        tagmanager_event( event, {
            'position': position + 1,
            'id': id,
            'name': name,
            'category': category,
            'subcategory': subcategory,
            'reviews': reviews,
            'rating': rating,
            'context': context
        });
    });
}
module.exports = function (debug) {
    debu = debug;
    if ( !$('.univers-selection-wrapper .js-gtm-thumbnail').length ) {
        clickThumbnail('clickThumbnail')
    }
    else{
        clickThumbnail('clickUniverseViewProduct')
    }
}
},{"../tagmanager_event":101}],26:[function(require,module,exports){
var tagmanager_event = require('../tagmanager_event');
function isElementInViewport(el) {
    var rect = el.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document. documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document. documentElement.clientWidth)
    );
}
module.exports= function(event){
    var screenName = '';
    $(window).on('scroll', function () {
        var elements = document.querySelectorAll('h1, h2, h3');
        for (var i = 0; i < elements.length; i++) {
            var el = elements[i];
            if ( isElementInViewport(el) ) {
                if (!i) {
                    var tmp = el.innerText;
                }else {
                    if(tmp){
                        tmp += ' + ' + el.innerText;
                    }else{
                        var tmp = el.innerText;
                    }
                }
            }
        }
        if ( tmp && tmp != screenName ) {
            screenName = tmp;

            if ( !event ) {
                event = 'scrollPage'
            }
            tagmanager_event( event, {
                'screen_name': screenName
            });
        }
    })    
}
},{"../tagmanager_event":101}],27:[function(require,module,exports){
var scrollEvent = require('./scrollEvent');
module.exports = function (event) {
    if ( $('#homepage-slider').length ) {
        scrollEvent('scrollHomepage');
    }
    else if( $('.page-bannerBg--univers').length ){
        scrollEvent('scrollUniversePage');
    }
}
},{"./scrollEvent":26}],28:[function(require,module,exports){
var scrollEvent = require('./scrollEvent');
module.exports = function (event) {
    if ( $('#productpage_hero').val() == "true" ) {
        scrollEvent('scrollIconicPage');
    }
}
},{"./scrollEvent":26}],29:[function(require,module,exports){
module.exports = function () {
    require('./scrollHomepage')('scrollUniversePage');
}
},{"./scrollHomepage":27}],30:[function(require,module,exports){
var tagmanager_event = require('../tagmanager_event');

module.exports = function () {
    setTimeout(function() {
        if(document.querySelector('#homepage-slider')){
            var bullets = document.querySelectorAll('#homepage-slider .swiper-pagination-bullet');
            bullets.forEach(function(bullet) {
                bullet.addEventListener('click', function () {
                    tagmanager_event('switchBanner', {});
                })
            });
        }
    }, 300);
}
},{"../tagmanager_event":101}],31:[function(require,module,exports){
'use strict';

/**
 * @description Parses string and returns default value if error happens
 * @param {string} str
 * @param {object} defaultValue
 * @returns {object|null}
 */
function safeParse(str, defaultValue) {
    try {
        return JSON.parse(str);
    } catch (e) {
        return defaultValue;
    }
}

/**
 * @function
 * @description method to remove container class,so that tracking can be re-initialized
 * @param {NodeList|NodeElement} container to remove the class name from
 * @param {String} classNameToRemove class name to remove
 * @param {Boolean} isCollection to be passed in case we need to remove the class name of each item from a node list passed to the method
 */
function removeClassName(container, classNameToRemove, isCollection) {
    if (!container || !classNameToRemove) return;

    if (!isCollection) {
        if (container.classList.contains(classNameToRemove)) {
            container.classList.remove(classNameToRemove);
        }

        return;
    }

    // if isCollection, remove class name for each element inside the collection
    container.forEach(element => removeClassName(element, classNameToRemove));
}

/**
 * @function
 * @description - method to disable an element and style it as disabled
 * @param {HTMLElement} element
 */
function disableElement(element) {
    if (!element) return;

    const disabledStr = 'disabled';

    if (element.disabled) return;

    element.disabled = true;

    if (element.classList.contains(disabledStr)) return;

    element.classList.add(disabledStr);
}

/**
 * @function
 * @description - method to enable an element
 * @param {HTMLElement} element
 */
function enableElement(element) {
    if (!element) return;

    const disabledStr = 'disabled';

    if (!element.disabled) return;

    element.disabled = false;
    removeClassName(element, disabledStr);
}

/**
* Traps keyboard focus within a specified container element, ensuring that tab navigation cycles
* through only the focusable elements inside the container. This is commonly used for modal dialogs
* or overlays to improve accessibility by preventing focus from escaping the container.
*
* @param {HTMLElement} container - The DOM element within which to trap keyboard focus.
*/
function trapFocus(container) {
    const focusableElements = container.querySelectorAll(
        "a[href], button, textarea, input[type=\"text\"], input[type=\"radio\"], input[type=\"checkbox\"], select"
    );
    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    container.addEventListener("keydown", function(event) {
        const isTabPressed = event.key === "Tab" || event.keyCode === 9;

        if (!isTabPressed) {
            return;
        }

        if (event.shiftKey) {
            if (document.activeElement === firstElement) {
                lastElement.focus();
                event.preventDefault();
            }
        } else {
            if (document.activeElement === lastElement) {
                firstElement.focus();
                event.preventDefault();
            }
        }
    });

    if (firstElement) {
        firstElement.focus();
    }
}

exports.safeParse = safeParse;
exports.removeClassName = removeClassName;
exports.disableElement = disableElement;
exports.enableElement = enableElement;
exports.trapFocus = trapFocus;

},{}],32:[function(require,module,exports){
'use strict';

$(document).ready(function() {
    var $docEl = $('html, body'),
        $wrap = $('#wrapper'),
        scrollTop;

    /**
    * Closes the currently active pop-in (popup) modal on the homepage.
    * Prevents the default event action, unlocks the page body for scrolling,
    * and removes the 'active' class from all elements with the 'popup' class.
    */
    function closePopin(e) {
        e.preventDefault();
        unlockBody();
        $('.popup').removeClass('active');
    }

    /**
    * Locks the body scroll by fixing the wrapper's position and preventing page scrolling.
    * Stores the current scroll position, sets the wrapper's top offset to maintain visual position,
    * and applies CSS styles to the document element to disable scrolling.
    */
    function lockBody() {
        scrollTop = window.pageYOffset;

        $wrap.css({
            top: -(scrollTop)
        });

        $docEl.css({
            height: '100%',
            overflow: 'hidden'
        });
    }

    /**
    * Restores the document body and wrapper elements to their default scroll and layout state.
    * Removes any previously set CSS restrictions on height and overflow, resets the wrapper's top position,
    * scrolls the window to the stored scroll position, and clears the scrollTop variable.
    * Typically used to re-enable scrolling after it has been programmatically locked.
    */
    function unlockBody() {
        $docEl.css({
            height: '',
            overflow: ''
        });

        $wrap.css({
            top: ''
        });

        window.scrollTo(0, scrollTop);
        window.setTimeout(function () {
            scrollTop = null;
        }, 0);
    }

    $('body').on('click', '[data-info]', function (e) {
        e.preventDefault();
        lockBody();
        $('.popup.' + $(this).data('info')).addClass('active');
    }).on('click', '.popup .close', closePopin);
});

},{}],33:[function(require,module,exports){
'use strict';

var dialog = require('./dialog');

var klarnaSliceIt = {
    init: function () {
        // Adyen - Open popup for klarna in 3 'learn more' button
        $(document).on('click','.klarna-learn-more', function (e) {
            e.preventDefault();
            dialog.open({
                url: Urls.klarnaSliceIt,
                options: {
                    dialogClass: 'klarna-modal',
                    height: 'auto',
                    draggable: false,
                    open: function () {
                        $('.ui-widget-overlay').bind('click',function(){
                            $('.klarna-modal .ui-dialog-titlebar-close').trigger('click');
                        })
                    }.bind(this)
                }
            });
        });


        // Adyen - Open popup for klarna in 3 'learn more' button
        $(document).on('click','.klarna-later-learn-more', function (e) {
            e.preventDefault();
            dialog.open({
                url: Urls.klarnaPayLater,
                options: {
                    dialogClass: 'klarna-modal',
                    height: 'auto',
                    draggable: false,
                    open: function () {
                        $('.ui-widget-overlay').bind('click',function(){
                            $('.klarna-modal .ui-dialog-titlebar-close').trigger('click');
                        })
                    }.bind(this)
                }
            });
        });
    }
};

module.exports = klarnaSliceIt;

},{"./dialog":14}],34:[function(require,module,exports){
'use strict';

var dialog = require('./dialog'),
    page = require('./page'),
    validator = require('./validator');

var login = {
    /**
     * @private
     * @function
     * @description init events for the loginPage
     */
    init: function() {
        //o-auth binding for which icon is clicked
        $('.oAuthIcon').bind('click', function() {
            $('#OAuthProvider').val(this.id);
        });

        //toggle the value of the rememberme checkbox
        $('#dwfrm_login_rememberme').bind('change', function() {
            if ($('#dwfrm_login_rememberme').attr('checked')) {
                $('#rememberme').val('true');
            } else {
                $('#rememberme').val('false');
            }
        });

        $(document).on('click', '#password-reset', function(e) {
            e.preventDefault();

            dialog.open({
                url: $(this).data('href'),
                options: {
                    dialogClass: 'store-modal login-modal',
                    width: 440,
                    open: function() {
                        validator.init();
                        var $requestPasswordForm = $('[name$="_requestpassword"]');
                        var $submit = $requestPasswordForm.find('[name$="_requestpassword_send"]');
                        $($submit).on('click', function(e) {
                            if (!$requestPasswordForm.valid()) {
                                return;
                            }

                            e.preventDefault();
                            var data = $requestPasswordForm.serialize();
                            // add form action to data
                            data += '&' + $submit.attr('name') + '=';
                            // make sure the server knows this is an ajax request
                            if (data.indexOf('ajax') === -1) {
                                data += '&format=ajax';
                            }

                            $.ajax({
                                type: 'POST',
                                url: $requestPasswordForm.attr('action'),
                                data: data,
                                success: function(response) {
                                    if (typeof response === 'object' &&
                                            !response.success &&
                                            response.csrfError) {
                                        page.redirect(Urls.csrffailed);
                                    } else if (typeof response === 'string') {
                                        dialog.$container.html(response);
                                    }
                                    dialog.$container.find('select, input').trigger('initLabels');
                                },
                                failure: function() {
                                    dialog.$container.html('<h1>' + Resources.SERVER_ERROR + '</h1>');
                                }
                            });
                        });
                    }
                }
            });
        });

        $('.account-create-link').on('click', function() {
        	if($('.account-create-content').is(':hidden')) $('.account-create-content').slideDown();
        	else $('.account-create-content').slideUp();
        });
    }
}

module.exports = login;

},{"./dialog":14,"./page":37,"./validator":105}],35:[function(require,module,exports){
'use strict';

var helpers = require('./helpers');

/**
* Retrieves the jQuery object representing the mega menu panel for a specific group by its ID.
* @param {string|number} id - The unique identifier for the menu group.
* @returns {jQuery} The jQuery object for the corresponding mega menu panel element.
*/
function panelForGroup(id) {
    return $('.js-header-mega-' + id);
}

/**
* Retrieves the trimmed string identifier for a menu item based on its 'menu-group' data attribute.
* @param {jQuery} $li - The jQuery-wrapped list item element representing a menu entry.
* @returns {string} The trimmed menu group identifier, or an empty string if not present.
*/
function idForItem($li) {
    return String($li.data('menu-group') || '').trim();
}

/**
* Retrieves all top-level menu category items from the DOM.
* @returns {jQuery} A jQuery collection of elements matching '.menu-category.level-1 > .menu-category-item'.
*/
function $topItems() {
    return $('.menu-category.level-1 > .menu-category-item');
}

/**
* Extracts the panel ID from a jQuery panel element based on its class name.
* Searches for a class matching the pattern 'js-header-mega-{id}' and returns the numeric ID.
*
* @param {jQuery} $panel - The jQuery object representing the panel element.
* @returns {(string|null)} The extracted panel ID as a string if found, otherwise null.
*/
function getPanelIdFromPanel($panel) {
    var cls = $panel.attr('class') || '';
    var m = cls.match(/js-header-mega-(\d+)/);
    return m ? m[1] : null;
}

/**
* Retrieves all visible focusable elements within a given panel.
* Focusable elements include anchor tags, buttons, and elements with tabindex="0".
*
* @param {jQuery} $panel - The jQuery object representing the panel to search within.
* @returns {jQuery} - A jQuery collection of visible focusable elements found in the panel.
*/
function focusablesInPanel($panel) {
    return $panel.find('a, button, [tabindex="0"]').filter(':visible');
}

/**
* Determines whether a given menu list item has an associated interactive panel.
* A panel is considered interactive if it contains at least one <li> element or any focusable elements.
*
* @param {jQuery} $li - The jQuery-wrapped list item to check for an interactive panel.
* @returns {boolean} True if the associated panel contains list items or focusable elements; otherwise, false.
*/
function hasInteractivePanel($li) {
    var id = idForItem($li);
    if (!id) return false;
    var $panel = panelForGroup(id);
    if (!$panel.length) return false;
    // Consider panel 'empty' if there are no LIs and no focusables
    var hasLis = $panel.find('li').length > 0;
    var hasFoci = focusablesInPanel($panel).length > 0;
    return hasLis || hasFoci;
}

/**
* Hides all level-2 menu panels and updates ARIA attributes for accessibility.
* Adds the 'd-none' class and sets 'aria-hidden' to 'true' on all elements with the 'level-2' class.
* Also sets 'aria-expanded' to 'false' on all direct '.menu-category-link' children of top menu items.
*/
function hideAllPanels() {
    $('.level-2').addClass('d-none').attr('aria-hidden', 'true');
    $topItems().each(function () {
        $(this).find('> .menu-category-link').attr('aria-expanded', 'false');
    });
}

/**
* Displays the interactive panel associated with a given menu item element.
* Ensures the panel is shown, properly identified, and accessible attributes are set.
*
* @param {jQuery} $li - The jQuery object representing the menu item list element.
* @returns {void}
*/
function showPanelFor($li) {
    if (!hasInteractivePanel($li)) return;

    var id = idForItem($li);
    if (!id) return;

    hideAllPanels();

    var $panel = panelForGroup(id);
    if (!$panel.length) return;

    if (!$panel.attr('id')) $panel.attr('id', 'mega-' + id);

    $panel.removeClass('d-none').attr('aria-hidden', 'false');
    $li.find('> .menu-category-link')
        .attr({ 'aria-expanded': 'true', 'aria-controls': 'mega-' + id });
}

/**
* Sets focus to the first direct child element with the class 'menu-category-link' within the given list item.
* @param {jQuery} $li - The jQuery object representing the list item to focus within.
*/
function focusTopItem($li) {
    $li.find('> .menu-category-link').first().focus();
}

/**
* Sets focus to the first focusable element within the panel associated with the given list item.
* @param {jQuery} $li - The jQuery object representing the list item whose panel's first focusable element should be focused.
*/
function focusFirstInPanel($li) {
    var id = idForItem($li);
    var $panel = panelForGroup(id);
    var $first = focusablesInPanel($panel).first();
    if ($first.length) $first.focus();
}

/**
* Sets focus to the last focusable element within the panel associated with the given list item.
* @param {jQuery} $li - The jQuery object representing the list item whose panel's last focusable element should be focused.
*/
function focusLastInPanel($li) {
    var id = idForItem($li);
    var $panel = panelForGroup(id);
    var $last = focusablesInPanel($panel).last();
    if ($last.length) $last.focus();
}

/**
* Returns the next visible top-level menu category item after the given list item.
* If there is no next visible item, returns the first visible top-level menu category item.
* @param {jQuery} $li - The current menu category list item as a jQuery object.
* @returns {jQuery} - The next visible menu category item, or the first one if none found.
*/
function nextTop($li) {
    var $n = $li.nextAll('.menu-category-item:visible').first();
    return $n.length ? $n : $topItems().first();
}

/**
* Returns the previous visible top-level menu category item relative to the given list item.
* If there is no previous visible item, returns the last top-level menu item.
*
* @param {jQuery} $li - The current menu category list item as a jQuery object.
* @returns {jQuery} - The previous visible menu category item, or the last top-level item if none found.
*/
function prevTop($li) {
    var $p = $li.prevAll('.menu-category-item:visible').first();
    return $p.length ? $p : $topItems().last();
}

/**
* Binds keyboard navigation and accessibility controls to the menu system.
* Handles keydown events for top-level menu items and panel items to enable keyboard navigation,
* including arrow key movement, Enter/Space activation, Escape to close, and Tab trapping within panels.
* Ensures that keyboard users can navigate, open, and close menu panels in an accessible way.
*
* @function
* @returns {void}
*/
function bindKeyboard() {
    var $document = $(document);

    // Top-level items
    $document.on('keydown', '.menu-category.level-1 > .menu-category-item > .menu-category-link', function (e) {
        var key = e.key;
        if (key === 'Spacebar') key = ' ';

        // IMPORTANT: only block Enter/Space if this item actually has a panel.
        var $li = $(this).closest('.menu-category-item');
        var hasPanel = hasInteractivePanel($li);

        // Prevent default scroll/behavior for keys we manage.
        // - Always prevent for Arrow keys + Escape
        // - Prevent for Enter/Space ONLY if there is a panel to open
        var prevent = ['ArrowDown', 'ArrowUp', 'ArrowLeft', 'ArrowRight', 'Escape'].indexOf(key) > -1
      || (hasPanel && (key === ' ' || key === 'Enter'));

        if (prevent) e.preventDefault();

        // Move across top items
        if (key === 'ArrowRight') {
            var $r = nextTop($li);
            showPanelFor($r);
            focusTopItem($r);
            return;
        }
        if (key === 'ArrowLeft') {
            var $l = prevTop($li);
            showPanelFor($l);
            focusTopItem($l);
            return;
        }

        // Open panel and dive in (only if it has content)
        if ((key === 'ArrowDown' || key === 'Enter' || key === ' ') && hasPanel) {
            showPanelFor($li);
            focusFirstInPanel($li);
            return;
        }

        // Optional: Up jumps to last inside if already open
        if (key === 'ArrowUp') {
            var expanded = $(this).attr('aria-expanded') === 'true';
            if (expanded && hasPanel) focusLastInPanel($li);
            return;
        }

        if (key === 'Escape') {
            hideAllPanels();
            // keep focus where it is
        }
    });

    // Inside panel items
    $document.on('keydown', '.level-2 a, .level-2 button, .level-2 [tabindex="0"]', function (e) {
        var key = e.key;
        if (key === 'Spacebar') key = ' ';
        var $current = $(this);
        var $panel = $current.closest('.level-2');
        var panelId = getPanelIdFromPanel($panel);
        var $topLi = panelId ? $topItems().filter('[data-menu-group="' + panelId + '"]').first() : $();

        var $focusables = focusablesInPanel($panel);
        var idx = $focusables.index($current);
        if (idx < 0) idx = 0;

        // Arrow Up/Down control (wrap)
        if (key === 'ArrowDown' || key === 'ArrowUp') {
            e.preventDefault();

            var nextIndex;

            if ($focusables.length) {
                if (key === 'ArrowDown') {
                    nextIndex = (idx + 1) % $focusables.length;
                } else {
                    nextIndex = (idx - 1 + $focusables.length) % $focusables.length;
                }
            } else {
                nextIndex = 0;
            }

            $focusables.eq(nextIndex).focus();
            return;
        }

        // NEW: Trap Tab within the panel
        if (key === 'Tab') {
            // Only trap if we actually have focusables
            if ($focusables.length) {
                e.preventDefault();
                var goingBack = e.shiftKey;
                var targetIndex = goingBack
                    ? (idx - 1 + $focusables.length) % $focusables.length
                    : (idx + 1) % $focusables.length;
                $focusables.eq(targetIndex).focus();
            }
            return;
        }

        if (key === 'Escape') {
            e.preventDefault();
            hideAllPanels();
            if ($topLi.length) focusTopItem($topLi);
        }
    });

    $('.user-account').on('keydown', function(e) {
        if (e.key === ' ' || e.key === 'Enter') {
            e.preventDefault();
            $(this).parent('.user-info').addClass('active');
            $('.user-panel').removeClass('d-none').focus();
            helpers.trapFocus(document.querySelector('.user-panel'));
        }
    });

    $document.on('keydown', function(e) {
        if (e.key === 'Escape' && $('.user-panel *').is(':focus')) {
            $('.user-info').removeClass('active');
            $('.user-panel').addClass('d-none');
            $('.user-account').focus();
        }
    });
}

/**
* Binds an event handler to close all navigation panels when focus leaves the navigation element.
* Attaches a 'focusout' event listener to the '#navigation' element, and if the newly focused element
* is not within '#navigation', triggers the hideAllPanels function.
*/
function bindFocusOutClose() {
    $(document).on('focusout', '#navigation', function () {
        setTimeout(function () {
            var active = document.activeElement;
            if (!active || !$(active).closest('#navigation').length) {
                hideAllPanels();
            }
        }, 0);
    });
}

/**
* Binds a focus event handler to top-level menu category links to close all panels if the focused item does not have an interactive panel.
* @function
* @returns {void}
*/
function bindTopFocusCloseOnEmpty() {
    $(document).on('focusin', '.menu-category.level-1 > .menu-category-item > .menu-category-link', function () {
        var $li = $(this).closest('.menu-category-item');
        if (!hasInteractivePanel($li)) {
            hideAllPanels();
        }
    });
}

/**
* Initializes the menu component by binding keyboard navigation, focus out close,
* and top focus close behaviors to the relevant menu elements.
* Calls internal helper functions to set up event listeners for accessibility and user interaction.
*/
function init() {
    bindKeyboard();
    bindFocusOutClose();
    bindTopFocusCloseOnEmpty();
}

module.exports = { init: init };

},{"./helpers":31}],36:[function(require,module,exports){
'use strict';

var util = require('./util'),
    bonusProductsView = require('./bonus-products-view'),
    helpers = require('./helpers');

var timer = {
    id: null,
    clear: function () {
        if (this.id) {
            window.clearTimeout(this.id);
            delete this.id;
        }
    },
    start: function (duration, callback) {
        this.id = setTimeout(callback, duration);
    }
};

var minicart = {
    init: function () {
        this.$el = $('#mini-cart');
        this.$content = this.$el.find('.mini-cart-content');
        this.minicartCollapseTimeout = +this.$el.data('timeout');

        if (!typeof this.minicartCollapseTimeout === 'number') {
            this.minicartCollapseTimeout = 6000;
        }

        // events
        this.$el.find('.mini-cart-total').on('mouseenter', function () {
            if (this.$content.not(':visible')) {
                this.slide();
            }
        }.bind(this));

        this.$content.on('mouseenter', function () {
            timer.clear();
        }).on('mouseleave', function () {
            timer.clear();
            timer.start(30, this.close.bind(this));
        }.bind(this));

        this.$el.find('.mini-cart-total').on('keydown', function (e) {
            if (e.key !== ' ' && e.key !== 'Enter') {
                return;
            }

            if (this.$el.find('.mini-cart-empty').length > 0) {
                return;
            }

            if (!this.$content.is(':visible')) {
                e.preventDefault();
                this.slide();
                helpers.trapFocus(this.$content[0]);
            }
        }.bind(this));

        $(document).on('keydown', function (e) {
            if (e.key === 'Escape' && this.$content.is(':visible')) {
                this.close(0);
                $('.mini-cart-link').focus();
            }
        }.bind(this));
    },
    /**
     * @function
     * @description Shows the given content in the mini cart
     * @param {String} A HTML string with the content which will be shown
     */
    show: function (html) {
        this.$el.html(html);
        util.scrollBrowser(0);
        this.init();
        this.slide();
        bonusProductsView.loadBonusOption();
    },
    /**
     * @function
     * @description Slides down and show the contents of the mini cart
     */
    slide: function () {
        timer.clear();
        // show the item
        this.$content.slideDown('slow');
        // after a time out automatically close it
        timer.start(this.minicartCollapseTimeout, this.close.bind(this));
    },
    /**
     * @function
     * @description Closes the mini cart with given delay
     * @param {Number} delay The delay in milliseconds
     */
    close: function (delay) {
        timer.clear();
        this.$content.slideUp(delay);
    }
};

module.exports = minicart;

},{"./bonus-products-view":6,"./helpers":31,"./util":104}],37:[function(require,module,exports){
'use strict';

var util = require('./util');

var page = {
    title: '',
    type: '',
    params: util.getQueryStringParams(window.location.search.substr(1)),
    redirect: function (newURL) {
        setTimeout(function () {
            window.location.href = newURL;
        }, 0);
    },
    refresh: function () {
        setTimeout(function () {
            window.location.assign(window.location.href);
        }, 500);
    }
};

module.exports = page;

},{"./util":104}],38:[function(require,module,exports){
'use strict';

var ajax = require('../ajax'),
    giftcert = require('../giftcert'),
    tooltip = require('../tooltip'),
    util = require('../util'),
    dialog = require('../dialog'),
    page = require('../page'),
    login = require('../login'),
    validator = require('../validator'),
    captureplus = require("../captureplus"),
    adyenCheckout = require('../adyen-checkout');

/**
 * @function
 * @description Initializes the events on the address form (apply, cancel, delete)
 * @param {Element} form The form which will be initialized
 */
function initializeAddressForm() {
    var $form = $('#edit-address-form');

    $form.find('input[name="format"]').remove();
    tooltip.init();
    //$("<input/>").attr({type:"hidden", name:"format", value:"ajax"}).appendTo(form);

    $form.on('click', '.apply-button', function (e) {
        e.preventDefault();
        if (!$form.valid()) {
            return false;
        }
        var url = util.appendParamToURL($form.attr('action'), 'format', 'ajax');
        var applyName = $form.find('.apply-button').attr('name');
        var options = {
            url: url,
            data: $form.serialize() + '&' + applyName + '=x',
            type: 'POST'
        };
        $.ajax(options).done(function (data) {
            if (typeof(data) !== 'string') {
                if (data.success) {
                    dialog.close();
                    page.refresh();
                } else if (data.error) {
                    page.redirect(Urls.csrffailed);
                } else {
                    window.alert(data.message);
                    return false;
                }
            } else {
                $('#dialog-container').html(data);
                account.init();
                tooltip.init();
                initializeAddressForm();
            }
        });
    })
    .on('click', '.cancel-button, .close-button', function (e) {
        e.preventDefault();
        dialog.close();
    })
    .on('click', '.delete-button', function (e) {
        e.preventDefault();
        if (window.confirm(String.format(Resources.CONFIRM_DELETE, Resources.TITLE_ADDRESS))) {
            var url = util.appendParamsToUrl(Urls.deleteAddress, {
                AddressID: $form.find('#addressid').val(),
                format: 'ajax'
            });
            $.ajax({
                url: url,
                method: 'POST',
                dataType: 'json'
            }).done(function (data) {
                if (data.status.toLowerCase() === 'ok') {
                    dialog.close();
                    page.refresh();
                } else if (data.message.length > 0) {
                    window.alert(data.message);
                    return false;
                } else {
                    dialog.close();
                    page.refresh();
                }
            });
        }
    });

    validator.init();
    if ($('input[id$="postal"]').length >= 1) {
        $('input[id$="postal"]').addClass( 'postal' ).closest('.form-row').addClass('form-row-postal');
        if (universal_variable.page.language === "es_ES") {
            $('input[id$="postal"]').addClass("espostal-islands");
        }
    }

    util.fillStates();
    captureplus.init();

    if ($form.find('input[name$="_address1"]').val()) {
        $form.find('[name$="_manualaddress"]').trigger('click');
    }

    $form.find('select, input').trigger('initLabels');
}
/**
 * @private
 * @function
 * @description Toggles the list of Orders
 */
function toggleFullOrder () {
    $('.order-items')
        .find('li.hidden:first')
        .prev('li')
        .append('<a class="toggle">View All</a>')
        .children('.toggle')
        .click(function () {
            $(this).parent().siblings('li.hidden').show();
            $(this).remove();
        });
}
/**
 * @private
 * @function
 * @description Binds the events on the address form (edit, create, delete)
 */
function initAddressEvents() {
    var addresses = $('#addresses');
    if (addresses.length === 0) { return; }

    addresses.on('click', '.address-edit, .address-create', function (e) {
        e.preventDefault();
        var title = this.title;
        var stateCode = $(this).data('state-code');

        ajax.load({
            url: this.href,
            callback: function (response) {
                if (response.indexOf("checkout-form") > 1) {
                    var positionSettingsMy = "center center";
                    var positionSettingsAt = "center center";
                    var widthSettings = '800';
                    if ($(window).width() < 767) {
                        positionSettingsMy = "top";
                        positionSettingsAt = "top";
                        widthSettings = $(window).width() * 0.95;
                    }
                    dialog.open({
                        html: response,
                        options: {
                            title: title,
                            dialogClass: "AddressFormDialog",
                            width: widthSettings,
                            position: {
                                my: positionSettingsMy,
                                at: positionSettingsAt,
                                of: window,
                                collision: "none"
                            },
                            open: function () {
                                const $formEditAddressNameInput = $('#edit-address-form fieldset').children(':first-child').find('input.input-text');
                                const $formEditAddressNameLabel = $formEditAddressNameInput.siblings('label');
                                var $manualAddress = $("input[name$='_manualaddress']");
                                var $manualAddressLabel = $manualAddress.closest(".field-wrapper").next("label");

                                initializeAddressForm();
                                if (!$('#edit-address-form').find('input[name$="_address1"]').val()) {
                                    hideManualInputs();
                                }

                                if (stateCode) {
                                    setTimeout(function () {
                                        $('#edit-address-form').find('select[name$="_state"]').val(stateCode);
                                    }, 500);
                                }

                                // add class top to the first label element in the form on modal open, as this is always focused
                                if ($formEditAddressNameInput.is(':focus') && !$formEditAddressNameLabel.hasClass('top')) {
                                    $formEditAddressNameInput.siblings('label').addClass('top');
                                }

                                if ($manualAddress.length) {
                                    $manualAddressLabel.attr("tabindex", 0);
                                    $manualAddressLabel.on("keydown", function (event) {
                                        if (event.key === "Enter") {
                                            $manualAddress.click();
                                        }
                                    });
                                }
                            }
                        },
                    });
                } else {
                    page.refresh()
                }
            }
        });
    }).on('click', '.delete', function (e) {
        e.preventDefault();
        if (window.confirm(String.format(Resources.CONFIRM_DELETE, Resources.TITLE_ADDRESS))) {
            $.ajax({
                url: util.appendParamToURL($(this).attr('href'), 'format', 'ajax'),
                dataType: 'json'
            }).done(function (data) {
                if (data.status.toLowerCase() === 'ok') {
                    page.redirect(Urls.addressesList);
                } else if (data.message.length > 0) {
                    window.alert(data.message);
                } else {
                    page.refresh();
                }
            });
        }
    });
/**
 * @private
 * @function
 * @description Hides manual addres inputs
 */
function hideManualInputs() {
    var manualFieldSelectors = ['_address1', '_address2', '_city', '_stateie', '_state', '_postal'];
    for (let fieldSelector of manualFieldSelectors) {
        var selectorString = '[name$="' + fieldSelector + '"]',
            $field = $('#edit-address-form').find(selectorString),
            $fieldRow = $field.closest('.form-row');
            $fieldRow.hide();
    }
}

}
/**
 * @private
 * @function
 * @description Binds the events of the payment methods list (delete card)
 */
function initPaymentEvents() {
    $('.add-card').on('click', function (e) {
        e.preventDefault();
        dialog.open({
            url: $(e.target).attr('href'),
            options: {
            	title: $(e.target).attr('title'),
                open: initializePaymentForm
            }
        });
    });

    var paymentList = $('.payment-list');
    if (paymentList.length === 0) { return; }

    util.setDeleteConfirmation(paymentList, String.format(Resources.CONFIRM_DELETE, Resources.TITLE_CREDITCARD));

    $('form[name="payment-remove"]').on('submit', function (e) {
        e.preventDefault();
        // override form submission in order to prevent refresh issues
        var button = $(this).find('.delete');
        $('<input/>').attr({
            type: 'hidden',
            name: button.attr('name'),
            value: button.attr('value') || 'delete card'
        }).appendTo($(this));
        var data = $(this).serialize();
        $.ajax({
            type: 'POST',
            url: $(this).attr('action'),
            data: data
        })
        .done(function () {
            page.redirect(Urls.paymentsList);
        });
    });
}

function initializePaymentForm() {
    $('#CreditCardForm').on('click', '.cancel-button', function (e) {
        e.preventDefault();
        dialog.close();
    });

    if (SitePreferences.ADYEN_SF_ENABLED) {
        adyenCheckout.initAccount();
    }
}

function initializeContainersHideEvents() {
    const $proAccSignupContainer = $('.account-box.account-pro-box').parent();
    const $checkReturnOrderContainer = $('.account-box.account-returns-box').parent();
    // assign to a variable for easier understanding
    const isReturnOrdersSubmitted = $('input[name=returnOrders]').val() !== '0';

    // if no returns submitted, hide returns section from account overview
    // and show pro-section full width
    if (!isReturnOrdersSubmitted) {
        if ($checkReturnOrderContainer.is(':visible')) {
            $checkReturnOrderContainer.hide();
        }
    }

    const isEvenVisibleItemContainers = $proAccSignupContainer.siblings(':visible').length % 2 === 0;
    // make pro account signup container full width if number of visible items is even
    if (isEvenVisibleItemContainers) {
        $proAccSignupContainer.hasClass('col-6') ? $proAccSignupContainer.removeClass('col-6').addClass('col-12') : $proAccSignupContainer.addClass('col-12');
    }
}

function addBoldOnActiveLinks() {
    var sidebarTitle = $('#secondary .account-title .account-text, #primary .account-title .account-text');

    if ($('.account-overview-container').length) {
        $('.account-overview').addClass('bold');
    } else if ($('.account-profile-details').length) {
        $('.account-details').addClass('bold');
    } else if ($('.account-order').length) {
        $('.account-orders').addClass('bold');
    } else if ($('.account-returns-title').length) {
        $('.account-returns').addClass('bold');
    } else if ($('.account-order-detail').length) {
        $('.account-orders').addClass('bold');
    } else if ($('.account-address-book').length) {
        $('.account-addresses').addClass('bold');
    } else if ($('.account-communication').length) {
        $('.account-marketing').addClass('bold');
    } else if ($('.account-pro').length) {
        $('.account-pro').addClass('bold');
    }
}

/**
* Removes the 'aria-required' attribute from all password input fields on the page.
* This function iterates over each input element of type 'password' and removes
* the 'aria-required' attribute to ensure accessibility compliance or to reset validation states.
*
* @returns {void}
*/
function removeAriaRequiredAttr() {
    $('input[type=password]').each(function() {
        $(this).removeAttr('aria-required');
    });
}

/**
* Observes all password input fields on the page and removes the 'aria-required' attribute
* whenever it is set. This is achieved by attaching a MutationObserver to each password input,
* monitoring changes to the 'aria-required' attribute, and removing it if detected.
*
* @returns {void}
*/
function observePasswordInputs() {
    const observer = new MutationObserver((mutationsList) => {
        for (let mutation of mutationsList) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'aria-required') {
                $(mutation.target).removeAttr('aria-required');
            }
        }
    });

    $('input[type=password]').each(function() {
        observer.observe(this, { attributes: true });
    });
}

$(document).ready(function() {
    // Initial removal
    removeAriaRequiredAttr();
    // Observe for future changes
    observePasswordInputs();
});

/**
 * @private
 * @function
 * @description Binds the events of the order, address and payment pages
 */
function initializeEvents() {
    toggleFullOrder();
    initAddressEvents();
    initPaymentEvents();
    addBoldOnActiveLinks();
    initializeContainersHideEvents();
    login.init();
}

var account = {
    init: function () {
        initializeEvents();
        giftcert.init();
    },
    initCartLogin: function () {
        login.init();
    }
};

module.exports = account;

},{"../adyen-checkout":1,"../ajax":3,"../captureplus":8,"../dialog":14,"../giftcert":17,"../login":34,"../page":37,"../tooltip":103,"../util":104,"../validator":105}],39:[function(require,module,exports){
/**
 * Init datepicker for the ambassador form
 */

'use strict';

$(document).ready(function() {
	initDatePicker();
});

function initDatePicker(){
	$('#dwfrm_ambassador_birthday').datepicker({
		showOtherMonths: true,
		selectOtherMonths: true,
		changeMonth: true,
	    changeYear: true,
	    yearRange: "1950:",
	    dateFormat: "mm/dd/yy"
	});
};
},{}],40:[function(require,module,exports){
'use strict';

var account = require('./account'),
    bonusProductsView = require('../bonus-products-view'),
    quickview = require('../quickview'),
    cartStoreInventory = require('../storeinventory/cart'),
    util = require('../util'),
    _ = require('lodash');

/**
 * @private
 * @function
 * @description Binds events to the cart page (edit item's details, bonus item's actions, coupon code entry)
 */
function initializeEvents() {
    if ($('input[id$="cgvAcceptance"]').length == 1) {
        $('input[id$="cgvAcceptance"]').removeAttr('checked');
    }

    $('#cart-table').on('click', '.item-edit-details a', function (e) {
        e.preventDefault();
        quickview.show({
            url: e.target.href,
            source: 'cart'
        });
    })
    .on('click', '.bonus-item-actions a, .item-details .bonusproducts a', function (e) {
        e.preventDefault();
        bonusProductsView.show(this.href);
    });

    // override enter key for coupon code entry
    $('form input[name$="_couponCode"]').on('keydown', function (e) {
        if (e.which === 13 && $(this).val().length === 0) { return false; }
    });

    //to prevent multiple submissions of the form when removing a product from the cart
    var removeItemEvent = false;
    $('button[name$="deleteProduct"]').on('click', function (e) {
        if (removeItemEvent) {
            e.preventDefault();
        } else {
            removeItemEvent = true;
        }

        appendProductLineItemFields(this);
    });

    //basket
    $(document).on('click','.quantity_btn', function(e) {
        e.preventDefault();
        var $currentButton = $(this),
            $currentitem = $currentButton.parents('.item-details'),
            $currentQty = $currentitem.find('.js-input-quanity-text'),
            $currentVal = $currentQty.val(),
            quantityAvaible = $currentButton.siblings('.js-input-quanity-text').data('available'),
            quantityMax = $currentButton.siblings('.js-input-quanity-text').data('maxquantity'),
            $newVal,
            quantityMaxTotal;

            if (quantityMax) {
                quantityMaxTotal = Math.min(quantityMax, quantityAvaible);
            } else {
                quantityMaxTotal = quantityAvaible;
            }

        if ($currentButton.hasClass('minus')) {
            if ($currentVal >= 2) {
                $newVal = parseFloat($currentVal) - 1;
            } else {
                $newVal = 1;
            }
            $currentButton.siblings('.add').removeClass('disabled');
        }else if ($currentButton.hasClass('add')) {
            if ($currentVal >= quantityMaxTotal) {
                $currentButton.addClass('disabled');
                $newVal = parseFloat($currentVal);
            } else {
                $currentButton.removeClass('disabled');
                $newVal = parseFloat($currentVal) + 1;
            }
        }
        $currentQty.val($newVal);

        if ($newVal > 1) {
            $currentitem.find('.minus').removeClass('disabled');
            if ($currentQty.val() >= quantityMaxTotal && $(this).hasClass('add')) {
                $(this).addClass('disabled');
            }
        } else {
            $currentitem.find('.minus').addClass('disabled');
        }

        appendProductLineItemFields(this);
        updateCart()
    });

    $(document).on('keydown', '.js-input-quanity-text', function(e) {
        if (e.key === 'Enter') {
            e.preventDefault();
            submitQuantity(this);
        }
    })

    // Handle enter pressing when in quantity field
    $('.js-input-quanity-text').on('keypress', function(e) {
        if(e.which == 13) {
            submitQuantity(this);
        }
    })

    // Submits cart form after quantity for product is updated
    function submitQuantity(context) {
        var $currentinput = $(context);
        var quantityAvaible = $currentinput.data('available');
        var quantityMax = $currentinput.data('maxquantity');
        var quantityMaxTotal;
        var productSku = $(context).closest('.item-details').find('.sku .value').text();

        if (quantityMax) {
            quantityMaxTotal = Math.min(quantityMax, quantityAvaible);
        } else {
            quantityMaxTotal = quantityAvaible;
        }

        if (quantityMaxTotal && $currentinput.val() > quantityMaxTotal) {
            $currentinput.siblings('.add').addClass('disabled');
            $currentinput.siblings('.minus').removeClass('disabled');
            $currentinput.val(quantityMaxTotal);

            // Add product SKU to local storage
            addEntry(productSku);

            // populate the version if exists
            var productVersion = $currentinput.closest('.cart-item').find('input[name$="productVersion"]').val();
            if (productVersion) {
                localStorage.setItem('productVersion', productVersion);
            }

            // append params here because of changing the quantity
            appendProductLineItemFields(context);

            // Submit cart form and refresh the page
            updateCart();
        } else {
            appendProductLineItemFields(context);

            $currentinput.siblings('.add').removeClass('disabled');
            // Submit cart form and refresh the page
            updateCart();
        }
    }

    // Show error under quantity field if quantity that was meant to be added exceeded allowed
    if (localStorage.getItem('exceeded') !== null) {
        var existingEntries = JSON.parse(localStorage.getItem('exceeded'));
        // Map through each product SKU that is in 'exceeded' local storage item
        existingEntries.map((item, i) => {
            let container = $(`.product-list-item span:contains(${item})`).closest('.item-details');

            // find the specific container based on the version for customized products
            var exceededProductVersion = localStorage.getItem('productVersion');
            if (exceededProductVersion) {
                for (var i = 0; i < container.length; i++) {
                    var containerItem = $(container[i]);
                    var productVersion = containerItem.closest('.cart-item').find('input[name$="productVersion"]').val();

                    if (productVersion === exceededProductVersion) {
                        container = containerItem;
                        break;
                    }
                }
            }

            container.find('.error').text(Resources.EXCEEDED_WARNING);

            // Remove SKU from 'exceeded' in local storage
            removeEntry(item);
            localStorage.removeItem('productVersion');
        });
    }

    // Add 'exceeded' allowed quantity SKU from local storage
    function addEntry(productSku) {
        // Parse any JSON previously stored in 'exceeded'
        var existingEntries = JSON.parse(localStorage.getItem('exceeded'));
        if (existingEntries == null) existingEntries = [];

        // Save 'exceeded' values back to local storage
        existingEntries.push(productSku);
        localStorage.setItem("exceeded", JSON.stringify(existingEntries));
    };

    // Remove 'exceeded' allowed quantity SKU from local storage
    function removeEntry(productSku) {
        if (localStorage.getItem('exceeded') !== null) {
            // Parse any JSON previously stored in 'exceeded'
            var existingEntries = JSON.parse(localStorage.getItem('exceeded'));
            var itemIndex = existingEntries.indexOf(productSku);

            if (itemIndex > -1) {
                // Remove current SKU from 'exceeded'
                existingEntries.splice(itemIndex, 1);
            }

            if (existingEntries.length) {
                // Save 'exceeded' values back to local storage
                localStorage.setItem("exceeded", JSON.stringify(existingEntries));
            } else {
                // Remove 'exceeded' if it's empty
                localStorage.removeItem('exceeded');
            }
        }
    }

    /**
     * Populate product information from the cart item fields to detect which item exactly we are updating on the BE
     * @param {Object} el
     */
    function appendProductLineItemFields(el) {
        var $this = $(el),
            $form = $this.closest('form');

        var productVersion = $this.closest('.cart-item').find('input[name$="productVersion"]').val();
        if (productVersion) {
            $form.attr('action', util.appendParamToURL($form.attr('action'), 'productVersion', productVersion));
        }

        var productQuantity = $this.closest('.cart-item').find('input[name$="quantity"]').val();
        if (productQuantity) {
            $form.attr('action', util.appendParamToURL($form.attr('action'), 'quantity', productQuantity));
        }

        var productID = $this.closest('.cart-item').find('.basket-pid').val();
        if (productID) {
            $form.attr('action', util.appendParamToURL($form.attr('action'), 'productID', productID));
        }
    }

    var updateCart = _.debounce(function () {
        $("#cart-items-form").trigger('submit');
    }, 500);
}

function formatTotal() {
    if ($('.price-unadjusted').text().indexOf('Catalogusprijs') > - 1) {
        /* Transform € 145,00 to € 145,- (works with a coupon) */
        var catalogusprijs = document.querySelectorAll('.price-unadjusted span');
        catalogusprijs.forEach(function (el) {
            var tmp = el.innerText.trim();
            if (tmp) {
                tmp = tmp.split(',');
                if (tmp[1] == '00') {
                    tmp = tmp[0] + ",-";
                    el.innerText = tmp;
                }
            }
        });
    }
}

exports.init = function () {
    initializeEvents();
    if (SitePreferences.STORE_PICKUP) {
        cartStoreInventory.init();
    }
    account.initCartLogin();
    formatTotal();
};

},{"../bonus-products-view":6,"../quickview":86,"../storeinventory/cart":96,"../util":104,"./account":38,"lodash":125}],41:[function(require,module,exports){
'use strict';

var util = require('../../util');
var shipping = require('./shipping');
var manualFieldSelectors = ['_address1', '_address2', '_city', '_stateie', '_state', '_postal'];

/**
 * Manual address
 * @param {*} $fieldset
 */
 function manualAddress($fieldset) {
    var isManual = $fieldset.find('[name$="_manualaddress"]:checked').length == 1;

    for (let fieldSelector of manualFieldSelectors) {
        var selectorString = '[name$="' + fieldSelector + '"]',
            $field = $fieldset.find(selectorString),
            $fieldRow = $field.closest('.form-row');
        if (isManual) {
            // Display the manual address fields
            $fieldRow.show();
        } else {
            // Hide the manual address fields
            $fieldRow.hide();
        }
    }
    if (isManual) {
        // Display the manual address fields
        $('input[name$="_addressFinder"], input[name$="_manualaddress"]').closest('.form-row').hide();
        $('.address-finder-btn').removeClass('d-none');
    } else {
        // Hide the manual address fields
        $('input[name$="_addressFinder"], input[name$="_manualaddress"]').closest('.form-row').show();
        $('.address-finder-btn').addClass('d-none');
    }
}

$(document).on('change', 'input[name$="_manualaddress"]', function () {
    manualAddress($('#edit-address-form'));
}).on("click keypress", ".address-finder-btn", function (event) {
    if (event.type === "click" || (event.type === "keypress" && event.key === "Enter")) {
        $("input[name$='_manualaddress']").trigger("click");
    }
});


/**
 * Update address fileds in collapsed DELIVERY ADDRESS section when address is changed
 */
function updateCollapsedAddress() {
    const $inputFields = $('.address-manually-fields').children('.form-labelTop-row');
    const $collapsedAddress = $('.address-list');

    const $addressFinderWrapperToHide = $('.address-finder-wrapper, .enter-address-wrapper');
    const $selectedAddressWrapper = $('.address .selected-address-wrap');

    for (let i = 0; i < $inputFields.length; i++) {
        let anInput = $inputFields.eq(i).find('input').val();
        if (!anInput) {
            anInput = $inputFields.eq(i).find('select option:selected').text();
        }
        const $address2 = $collapsedAddress.children().eq(i).closest('.address-item-address2');

        $collapsedAddress.children().eq(i).text(`${anInput}`);
        if ($address2.length) {
            if (anInput == '') {
                $address2.addClass('mb-0');
            } else {
                $address2.removeClass('mb-0');
            }
        }
    }

    $selectedAddressWrapper.removeClass('d-none');
    $selectedAddressWrapper.addClass('d-block');

    $addressFinderWrapperToHide.removeClass('d-flex').addClass('d-none');
}

/**
 * @function
 * @description Selects the first address from the list of addresses
 */
exports.init = function () {
    var $form = $('form.address');
    // select address from list
    $('select[name$="_addressList"]', $form).on('change', function () {
        var selected = $(this).children(':selected').first();
        var selectedAddress = $(selected).data('address');
        if (!selectedAddress) {
            // clear delivery address form fields when 'Add new Address' selected
            $form.find('input[name$="_addressFinder"]').val('');
            $form.find('.enter-address-wrapper input').val('');
            $form.find('input[name*="_addToAddressBook"]').prop( 'checked', false );
            $form.find('.enter-address-wrapper').removeClass('d-none').addClass('d-flex');
            $form.find('.selected-address-wrap').removeClass('d-flex').addClass('d-none');

            $form.find('[type="submit"]').prop('disabled', true);
            return;
        }
        util.fillAddressFields(selectedAddress, $form);
        setTimeout(function () {
            updateCollapsedAddress();
            shipping.updateShippingMethodList();
            // re-validate the form
            $form.validate().form();
            $form.find('select, input').trigger('initLabels');
        }, 500);
    });

    // reset the form errors when the logged in user chooses one of his addresses in the address dropdown list
    $('.address .select-address select').on('change', function() {
        $form.validate().resetForm();
    })

    $form.on('submit', function (e) {
        const $this = $(this);

        // show the address fields in order to revalidate the form before submit
        $this.validate().form();
        if (!$this.valid()) {
            e.preventDefault();
            $this.find('.toggle-edit, .enter-address-btn').trigger('click');
            $this.find('input.error').first().trigger('focus');
            $form.find('[type="submit"]').prop('disabled', true);
            return;
        }
    });
};

},{"../../util":104,"./shipping":49}],42:[function(require,module,exports){
'use strict';

/**
* Removes all parent elements of elements with the 'isapplepay' selector from the DOM.
* Iterates over each matched element and removes its parent node, effectively removing the Apple Pay button containers from the page.
*/
function removeButtons() {
    var $isApplePayButton = $('isapplepay');

    if ($isApplePayButton.length) {
        $isApplePayButton.each(function () {
            $(this).parent().remove();
        });
    }
}

/**
* Initializes the Apple Pay buttons on the checkout page.
* This function triggers the setup process for Apple Pay integration by calling the initApplePayButtons function.
* @returns {void}
*/
function init() {
    if (!isApplePaySession()) {
        removeButtons();
        return;
    }

    var $applepayCheckoutWrapper = $('.apple-pay-checkout-wrapper');
    var $acceptPrivacyPolicy = $('#dwfrm_billing_paymentMethods_acceptPrivacyPolicy');

    var $codiceFiscale = $('#dwfrm_billing_codiceFiscal');
    var isItaly = $codiceFiscale.length;

    /**
    * If by any chance the checkbox is already checked on page load, adjust data-disabled
    * Reproduces when Apple Pay button is clicked with terms checkbox checked, interface is closed and we come back to Shipping section
    * Take into consideration the value of Codice Fiscale input
    *
    * @function
    * @memberof document
    * @listens document#ready
    */
    $(document).ready(function () {
        var acceptPrivacyIsChecked = $acceptPrivacyPolicy.is(':checked');
        var isCodiceFiscaleWithError = $codiceFiscale.hasClass('error');

        if (acceptPrivacyIsChecked && !isItaly || acceptPrivacyIsChecked && isItaly && !isCodiceFiscaleWithError) {
            $applepayCheckoutWrapper.attr('data-disabled', false);
        } else {
            $applepayCheckoutWrapper.attr('data-disabled', true);
        }
    });

    /**
    * Handles the change event for the privacy policy acceptance checkbox during Apple Pay checkout.
    * Enables or disables the Apple Pay checkout button based on the privacy policy acceptance,
    * country selection (Italy or not), and the validity of the Codice Fiscale field.
    * If the user is in Italy, additional validation is performed on the Codice Fiscale input,
    * displaying error messages and updating UI classes as necessary.
    *
    * @listens change
    * @returns {void}
    */
    $acceptPrivacyPolicy.on('change', function() {
        var isChecked = $(this).is(':checked');
        var isCodiceFiscaleValid = isItaly ? $codiceFiscale.valid() : false;

        // if accept privacy checkbox is checked, and codice fiscale value for Italy is not empty and without error
        if (isChecked && !isItaly || isChecked && isItaly && isCodiceFiscaleValid) {
            $applepayCheckoutWrapper.attr('data-disabled', false);

            // if by any chance the error was present on the codice fiscale, remove it
            if (isItaly) {
                $codiceFiscale.removeClass('error');
                $codiceFiscale.siblings('.error').text('');
            }
        // if accept privacy checkbox is checked, and codice fiscale for Italy is empty or has errors
        // ensure Apple Pay button stays disabled and existing error text is displayed
        } else if (isChecked && isItaly && !isCodiceFiscaleValid) {
            $applepayCheckoutWrapper.attr('data-disabled', true);
            $codiceFiscale.addClass('error');
            $codiceFiscale.siblings('.error').removeClass('form-caption');
            $codiceFiscale.siblings('.error').text(Resources.VALIDATE_FISCALCODE); // eslint-disable-line
        // if any other situation, ensure it is disabled
        } else {
            $applepayCheckoutWrapper.attr('data-disabled', true);
        }
    });

    /**
    * Handles the 'input' event on the $codiceFiscale input field to enable or disable the Apple Pay checkout button.
    * Checks if the user is in Italy, whether the codice fiscale input has errors, and if the privacy policy is accepted.
    * Sets the 'data-disabled' attribute on the Apple Pay checkout wrapper accordingly.
    *
    * This listener ensures that, if a valid codice fiscale is entered and the privacy policy checkbox is checked,
    * the Apple Pay checkout button is enabled.
    *
    * @listens input
    * @returns {void}
    */
    $codiceFiscale.on('input', function() {
        var isCodiceFiscaleValid = isItaly ? $codiceFiscale.valid() : false;

        if (isItaly && isCodiceFiscaleValid && $acceptPrivacyPolicy.is(':checked')) {
            $applepayCheckoutWrapper.attr('data-disabled', false);
        } else if (isItaly) {
            $applepayCheckoutWrapper.attr('data-disabled', true);
        }
    });

    /**
    * Attaches a click event handler to the Apple Pay checkout wrapper that triggers an AJAX POST request
    * to update the checkout form data on the backend. This ensures the order contains the most up-to-date
    * customer information, especially when the billing address differs from the shipping address.
    *
    * @param {jQuery} $applepayCheckoutWrapper - The jQuery object representing the Apple Pay checkout wrapper element.
    * @param {jQuery} $checkoutForm - The jQuery object representing the checkout form element.
    * @fires ajax - Sends serialized checkout form data to the backend endpoint specified by Urls.applePayCheckoutFormData.
    */
    if ($applepayCheckoutWrapper.length) {
        var $checkoutForm = $('.checkout-form');

        if ($checkoutForm.length) {
            $applepayCheckoutWrapper.on('click', function () {
                $.ajax({
                    url: Urls.applePayCheckoutFormData, // eslint-disable-line no-undef
                    type: 'post',
                    data: $checkoutForm.serialize()
                });
            });
        }
    }
}

/**
* Determines if the current browser session supports Apple Pay and if Apple Pay can be used.
* Checks for the presence of the required Apple Pay objects and the ability to make payments.
* @returns {boolean} True if Apple Pay is available and can make payments; otherwise, false.
*/
function isApplePaySession() {
    return window.dw && window.dw.applepay && window.ApplePaySession && window.ApplePaySession.canMakePayments();
}

module.exports = {
    init: init,
    isApplePaySession: isApplePaySession
};

},{}],43:[function(require,module,exports){
'use strict';

var ajax = require('../../ajax'),
    formPrepare = require('./formPrepare'),
    giftcard = require('../../giftcard'),
    util = require('../../util'),
    captureplus = require("../../captureplus"),
    adyenCheckout = require('../../adyen-checkout'),
    applepay = require('./applepay');

/**
* @function
* @description Changes the payment type or issuerId of the selected payment method
* @param {String, Boolean} value of payment type or issuerId and a test value to see which one it is, to which the payment type or issuerId should be changed to
*/
function updatePaymentType(selectedPayType, issuerType) {
    if(issuerType){
        $('#dwfrm_adyPaydata_issuer').val(selectedPayType);
    }
    else{
        $('input[name="brandCode"]').removeAttr('checked');
        $('input[value=' + selectedPayType + ']').prop('checked', 'checked');
    }
    // if the payment type has hidden fields reveal it
    $('#component_' + selectedPayType).show();
    formPrepare.validateForm();
}


/**
 * @function
 * @description Fills the Credit Card form with the passed data-parameter and clears the former cvn input
 * @param {Object} data The Credit Card data (holder, type, masked number, expiration month/year)
 */
function setCCFields(data) {
    var $creditCard = $('[data-method="CREDIT_CARD"]');
    $creditCard.find('input[name$="creditCard_owner"]').val(data.holder).trigger('change');
    $creditCard.find('select[name$="_type"]').val(data.type).trigger('change');
    $creditCard.find('input[name*="_creditCard_number"]').val(data.maskedNumber).trigger('change');
    $creditCard.find('[name$="_month"]').val(data.expirationMonth).trigger('change');
    $creditCard.find('[name$="_year"]').val(data.expirationYear).trigger('change');
    $creditCard.find('input[name$="_cvn"]').val('').trigger('change');
    $creditCard.find('[name$="creditCard_selectedCardID"]').val(data.selectedCardID).trigger('change');
}

/**
 * @function
 * @description Updates the credit card form with the attributes of a given card
 * @param {String} cardID the credit card ID of a given card
 */
function populateCreditCardForm(cardID) {
    // load card details
    var url = util.appendParamToURL(Urls.billingSelectCC, 'creditCardUUID', cardID);
    ajax.getJson({
        url: url,
        callback: function (data) {
            if (!data) {
                window.alert(Resources.CC_LOAD_ERROR);
                return false;
            }
            setCCFields(data);
        }
    });
}

$('input[name="brandCode"]').on('change', function () {
    $('#dwfrm_adyPaydata_issuer').val('');
    $('.checkoutComponent').hide();
    $("#component_".concat($(this).val())).show();
  });

/**
 * @function
 * @description Changes the payment method form depending on the passed paymentMethodID
 * @param {String} paymentMethodID the ID of the payment method, to which the payment method form should be changed to
 */
function updatePaymentMethod(paymentMethodID) {
    var $paymentMethods = $('.paymentMethod');
    $paymentMethods.removeClass('payment-method-expanded');
    localStorage.setItem('selectedPaymentMethod', paymentMethodID);

    var $selectedPaymentMethod = $paymentMethods.filter('[data-method="' + paymentMethodID + '"]');
    if ($selectedPaymentMethod.length === 0) {
        $selectedPaymentMethod = $('[data-method="Custom"]');
    }
    $selectedPaymentMethod.addClass('payment-method-expanded');

    // ensure checkbox of payment method is checked
    $('input[name$="_selectedPaymentMethodID"]').removeAttr('checked');

    // remove Adyen selected payment method
    $('#paymentMethodsList input:checked').removeAttr('checked')
    $('.paymentMethod.active').removeClass('active');
    $('.additionalFields').hide();

    $('input[value=' + paymentMethodID + ']').prop('checked', 'checked').closest('.paymentMethod').addClass('active');

    // show or hide apple pay button based on payment method selection
    var $applepayCheckoutWrapper = $('.apple-pay-checkout-wrapper');
    var isApplePayEnabledForCountry = SitePreferences.APPLE_PAY_ENABLED_COUNTRY && applepay.isApplePaySession();
    if (paymentMethodID === 'DW_APPLE_PAY' && $applepayCheckoutWrapper.length && isApplePayEnabledForCountry) {
        $('#billing-submit').addClass('d-none');
        $applepayCheckoutWrapper.show();
    } else if (paymentMethodID !== 'AdyenComponent') {
        $('#billing-submit').removeClass('d-none');
        $('#billing-submit').text($selectedPaymentMethod.find('label').text());

        if ($applepayCheckoutWrapper.length) {
            $applepayCheckoutWrapper.hide();
        }
    }

    formPrepare.validateForm();
}

util.fillStates();

// chose the right state after ajax
setTimeout(function () {
    var manualFields = $('.address-manually-fields');
    var stateCode = manualFields.data('state-code');
    var $stateSelect = manualFields.find('select[name$="_state"]');
    if ($stateSelect.length && stateCode !== $stateSelect.val()) {
        $stateSelect.val(stateCode).trigger('change');
    }
}, 500);

/**
 * @function
 * @description Changes the payment type or issuerId of the selected payment method
 * @param {String, Boolean} value of payment type or issuerId and a test value to see
 * which one it is, to which the payment type or issuerId should be changed to
 */


 function updatePaymentType(selectedPayType, issuerType) {
    if (issuerType) {
      $('#dwfrm_adyPaydata_issuer').val(selectedPayType);
    } else {
      $('input[name="brandCode"]').removeAttr('checked');
      $("input[value=".concat(selectedPayType, "]")).prop('checked', 'checked');
    } // if the payment type has hidden fields reveal it
  
  
    $("#component_".concat(selectedPayType)).show();
    formPrepare.validateForm();
  }

/**
 * @function
 * @description loads billing address, Gift Certificates, Coupon and Payment methods
 */
exports.init = function () {
    var $checkoutForm = $('.checkout-billing');
    var $addGiftCert = $('#add-giftcert');
    var $giftCertCode = $('input[name$="_giftCertCode"]');
    var $addCoupon = $('#add-coupon');
    var $couponCode = $('input[name$="_couponCode"]');
    var $selectPaymentMethod = $('.payment-method-options');
    var selectedPaymentMethod = localStorage.getItem('selectedPaymentMethod') || $selectPaymentMethod.find(':checked').val();
    var $billingForm = $('#edit-billing-address');
    var $payType = $('[name="brandCode"]');
    var $issuer = $('.issuer');
    var selectedPayType = $payType.find(':checked').val();

    formPrepare.init({
        formSelector: 'form[id$="billing"]',
        continueSelector: '[name$="billing_save"]'
    });


    // expand the form if there is no address populated or there is an error
    if (!$billingForm.find('input[name$="_address1"]').val() || $billingForm.find('input.error').length || window.location.href.indexOf('edit=true') > -1) {
        $('.edit-block-result.billing-address').find('.edit-toggle').trigger('click');

        // show manual address fields if edit is triggered from the URL
        if (window.location.href.indexOf('edit=true') > -1 || $billingForm.find('input.error').length) {
            $('#edit-billing-address .enter-address-btn').trigger('click');
        }
    }

    var $payType = $('[name="brandCode"]');
    var $issuer = $('.issuer');
    var selectedPayType = $payType.find(':checked').val();

   // default payment method to 'CREDIT_CARD'
									  
   updatePaymentMethod(selectedPaymentMethod || 'CREDIT_CARD');
    $selectPaymentMethod.on('click', 'input[type="radio"]', function () {
        if (!$(this).closest('.active').length) {
            updatePaymentMethod($(this).val());

            if ($(this).val() == 'Adyen' && $payType.length > 0) {
                // set payment type of Adyen to the first one
                updatePaymentType((selectedPayType) ? selectedPayType : $payType[0].value, false);
            } else {
                $payType.removeAttr('checked');
            }
        }
    });


  $issuer.on('change', function () {
    updatePaymentType($(this).val(), true);
  });
  $payType.on('change', function () {
    $('#selectedIssuer').val('');
    $issuer.hide();
    $('.checkoutComponent').hide();
    $("#component_".concat($(this).val())).show();

    if ($(this).siblings('.issuer').length > 0) {
      $('#selectedIssuer').val($(this).siblings('.issuer').val());
      $(this).siblings('.issuer').show();
    }
  });

    // select credit card from list
    $('#creditCardList').on('change', function () {
        var cardUUID = $(this).val();
        if (!cardUUID) {return;}
        populateCreditCardForm(cardUUID);

        // remove server side error
        $('.required.error').removeClass('error');
        $('.error-message').remove();
    });

    $('#check-giftcert').on('click', function (e) {
        e.preventDefault();
        var $balance = $('.balance');
        if ($giftCertCode.length === 0 || $giftCertCode.val().length === 0) {
            var error = $balance.find('span.error');
            if (error.length === 0) {
                error = $('<span>').addClass('error').appendTo($balance);
            }
            error.html(Resources.GIFT_CERT_MISSING);
            return;
        }

        giftcard.checkBalance($giftCertCode.val(), function (data) {
            if (!data || !data.giftCertificate) {
                $balance.html(Resources.GIFT_CERT_INVALID).removeClass('success').addClass('error');
                return;
            }
            $balance.html(Resources.GIFT_CERT_BALANCE + ' ' + data.giftCertificate.balance).removeClass('error').addClass('success');
        });
    });

    $addGiftCert.on('click', function (e) {
        e.preventDefault();
        var code = $giftCertCode.val(),
            $error = $checkoutForm.find('.giftcert-error');
        if (code.length === 0) {
            $error.html(Resources.GIFT_CERT_MISSING);
            return;
        }

        var url = util.appendParamsToUrl(Urls.redeemGiftCert, {giftCertCode: code, format: 'ajax'});
        $.getJSON(url, function (data) {
            var fail = false;
            var msg = '';
            if (!data) {
                msg = Resources.BAD_RESPONSE;
                fail = true;
            } else if (!data.success) {
                msg = data.message.split('<').join('&lt;').split('>').join('&gt;');
                fail = true;
            }
            if (fail) {
                $error.html(msg);
                return;
            } else {
                window.location.assign(Urls.billing);
            }
        });
    });

    $addCoupon.on('click', function (e) {
        e.preventDefault();

        $('.coupon-error, .redemption').html('');

        var $error = $('.coupon-error'),
            code = $couponCode.val();
        var $success = $('.redemption');
        if (code.length === 0) {
            $error.html(Resources.COUPON_CODE_MISSING);
            return;
        }

        var url = util.appendParamsToUrl(Urls.addCoupon, {couponCode: code, format: 'ajax'});

        $.getJSON(url, function (data) {
            var fail = false;
            var msg = '';

            if (!data) {
                msg = Resources.BAD_RESPONSE;
                fail = true;
            } else if (!data.success) {
                msg = data.message.split('<').join('&lt;').split('>').join('&gt;');
                fail = true;
            }

            if (fail) {
            	$error.html(msg);
                return;
            }
            else if (data && data.success == true) {
        		$success.html('<span class="success">' + data.message + '</span>');
            }

            //basket check for displaying the payment section, if the adjusted total of the basket is 0 after applying the coupon
            //this will force a page refresh to display the coupon message based on a parameter message
            if (data.success && data.baskettotal === 0) {
                window.location.assign(Urls.billing);
            }
        });
    });

    // trigger events on enter
    $couponCode.on('keydown', function (e) {
        if (e.which === 13) {
            e.preventDefault();
            $addCoupon.click();
        }
    });
    $giftCertCode.on('keydown', function (e) {
        if (e.which === 13) {
            e.preventDefault();
            $addGiftCert.click();
        }
    });
    if (SitePreferences.ADYEN_SF_ENABLED && !window.amazonCheckoutSessionId) {
        adyenCheckout.initBilling();
    }

    $payType.on('change', function() {
        $('#selectedIssuer').val("");
        $issuer.hide();
        $('.checkoutComponent').hide();
        $('#component_' + $(this).val()).show();
        if ($(this).siblings( ".issuer").length > 0) {
            $('#selectedIssuer').val($(this).siblings( ".issuer" ).val());
            $(this).siblings('.issuer').show();
        }
    });

    var $useAsBillingAddressInput = $('#dwfrm_singleshipping_shippingAddress_useAsBillingAddress');
    $useAsBillingAddressInput.prop('checked', true);
    $useAsBillingAddressInput.attr('checked', 'checked');

    captureplus.init();

    // mouse over effect on paypal button hover
    $(document).on('mouseenter', '#component_paypal', function (e) {
        e.preventDefault();
        $('#billing-submit').addClass('hover');
    }).on('mouseleave', '#component_paypal', function (e) {
        e.preventDefault();
        $('#billing-submit').removeClass('hover');
    });
};

},{"../../adyen-checkout":1,"../../ajax":3,"../../captureplus":8,"../../giftcard":16,"../../util":104,"./applepay":42,"./formPrepare":45}],44:[function(require,module,exports){
'use strict';

var util = require('../../util');
var dialog = require('../../dialog');
var shipping = require('./shipping');

// Coordinates
var latitude = '';
var longitude = '';

// Address fields
var $form = $('.address');
var $city = $form.find('input[name$="_city"]');
var $postal = $form.find('input[name$="_postal"]');
var $country = $form.find('select[id$="_country"]');
var $address1 = $form.find('input[name$="_address1"]');
var $address2 = $form.find('input[name$="_address2"]');
var $state = $form.find('input[name$="_state"], select[name$="_state"]');

/**
* Initializes event listeners for DPD shipping method radio buttons.
* When a DPD shipping method is selected, sends an AJAX POST request with the selected shipping method value.
* Logs the selected shipping method and the AJAX response or error to the console.
* Intended to be called on page load to enable DPD shipping method selection handling.
*/
function init() {
    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
            // the customer accepts and the browser provides the coordinates
            (position) => {
                latitude = position.coords.latitude;
                longitude = position.coords.longitude;
            },
            // the customer denies or doesn't confirm, then there are no coordinates and no variable reassignment
            () => {}
        );
    }

    $(document).on('click', '.pudo-no-selected-location-button, .pudo-edit-selected-location', function() {
        getDPDPudoLocations(true);
    });

    // this will only work while an address is not selected on the address list
    // after that, when a shipping method is changed, this event is rebinded on shipping.js
    var $shippingMethodList = $('#shipping-method-list');
    $shippingMethodList.find('[name$="_shippingMethodID"]').on('click', shipping.handleShippingMethodClick);

    // if DEL_DPD shipping method and a Pudo point are selected on page load, disable address fields and list
    var $selectedMethod = $('input[name="dwfrm_singleshipping_shippingAddress_shippingMethodID"]:checked');
    var isDPDShippingSelectedOnForm = $selectedMethod.length && $selectedMethod.val().includes('DEL_DPD');
    if ($('.pudo-chosen-location').hasClass('pudo-chosen') || isDPDShippingSelectedOnForm) {
        disableAddressList();
        disableAddressFields();
        hideAddToAddressBook();
        hideUseBillingAddressCheckbox();

        // if no address yet on the form, open form
        if (!$address1.val() && !$city.val() && !$postal.val()) {
            // open shipping address form
            $('.enter-address-btn, .toggle-edit').trigger('click');
        } else {
            showAddressSummary();
        }

        if ($form.valid()) {
            $('button[name="dwfrm_singleshipping_shippingAddress_save"]').prop('disabled', false);
        } else {
            $form.find('input.error').first().trigger('focus');
        }
    }

    // fires whenever the States-GetStates AJAX finishes and the state dropdown is updated
    $(document).ajaxComplete(function (event, xhr, settings) {
        if (settings.url && settings.url.indexOf('States-GetStates') > -1) {
            $(document).trigger('state-list-updated');
        }
    });
}

/**
* Retrieves DPD PUDO (Pick Up Drop Off) locations based on the user's address form input.
* Gathers address details from the checkout form, logs them for debugging, and sends an AJAX GET request
* to fetch available DPD PUDO locations using a mock address (to be updated). Handles the response by
* logging success or error, and includes placeholders for displaying results or error messages in the UI.
*
* @returns {void}
*/
function getDPDPudoLocations(isItFromButtons) {
    if (!isItFromButtons && $('.pudo-chosen-location').hasClass('pudo-chosen')) {
        return;
    }

    var streetAddress = $address1.val() || '';
    if ($address2.val()) {
        streetAddress += ' ' + $address2.val();
    }

    // disable proceed to payment button
    $('button[name="dwfrm_singleshipping_shippingAddress_save"]').prop('disabled', true);

    var url = createGetDPDLocationsURL(Urls.getDPDPudoLocations, { // eslint-disable-line no-undef
        streetAddress: streetAddress,
        city: $city.val() || '',
        postalCode: $postal.val() || '',
        countryCode: $country.val() || '',
        latitude: latitude || '',
        longitude: longitude || ''
    });

    dialog.open({
        url: url,
        options: {
            width: 850,
            height: Math.round($(window).height() * 0.9),
            dialogClass: 'pudo-locations-modal',
            closeOnEscape: true,
            modal: true,
            position: {
                my: 'center',
                at: 'center',
                of: window
            },
            open: function() {
                $('html').addClass('no-scroll');
                initPudoModalListeners();
            }
        }
    });
}

/**
* Initializes event listeners for the DPD PUDO (Pick-Up Drop-Off) modal interactions on the checkout page.
* Handles user actions such as selecting a PUDO location, searching for locations by postal code, and closing the modal.
* On location selection, updates the UI with the chosen PUDO details, sends the selection to the backend, and updates delivery address fields.
* Also manages form validation, visibility of UI elements, and disables billing address options when a PUDO location is chosen.
*
* @returns {void}
*/
function initPudoModalListeners() {
    $('.pudo-location-select').on('click', function() {
        // Retrieve the PUDO location ID from the data attribute
        var $this = $(this);
        var pudoLocationId = $this.data('pudo-id');
        var pudoLocationName = $this.data('pudo-name');
        var pudoLocationCity = $this.data('pudo-city');
        var pudoLocationAddress = $this.data('pudo-address');
        var pudoLocationCountry = $this.data('pudo-country');
        var pudoLocationPostalCode = $this.data('pudo-postalcode');

        if (!pudoLocationId || !pudoLocationAddress || !pudoLocationCity || !pudoLocationPostalCode) {
            return;
        }

        var $useAsBillingAddressInput = $('#dwfrm_singleshipping_shippingAddress_useAsBillingAddress');
        var isCheckedUseAsBillingAddress = $useAsBillingAddressInput.prop('checked');

        $.ajax({
            url: Urls.savePudoLocation, // eslint-disable-line no-undef
            type: 'POST',
            data: {
                pudoLocationId: pudoLocationId,
                pudoLocationName: pudoLocationName,
                pudoLocationAddress: pudoLocationAddress,
                pudoLocationPostalCode: pudoLocationPostalCode,
                pudoLocationCity: pudoLocationCity,
                pudoLocationCountry: pudoLocationCountry,
                isCheckedUseAsBillingAddress: isCheckedUseAsBillingAddress,
                address1: $address1.val(),
                address2: $address2.val(),
                city: $city.val(),
                postalCode: $postal.val(),
                state: $state.length ? $state.val() : '',
                country: $country.val()
            },
            success: function(response) {
                if (!response.success) {
                    var $buttonDiv = $this.closest('.pudo-location-button');
                    $this.prop('disabled', true);
                    $buttonDiv.find('.pudo-saving-error').removeClass('hide').html(response.errorMessage);
                    return;
                }

                dialog.close();

                // update delivery address in form
                $city.val(pudoLocationCity);
                $state.val(response.stateCode);
                $address1.val(pudoLocationAddress);
                $postal.val(pudoLocationPostalCode);
                $country.val(pudoLocationCountry.toLowerCase()).trigger('change');

                $('.pudo-chosen-name').text(pudoLocationName);
                $('.pudo-chosen-city').text(pudoLocationCity);
                $('.pudo-chosen-address').text(pudoLocationAddress);
                $('.pudo-chosen-postalcode').text(pudoLocationPostalCode);

                var $pudoChosenLocation = $('.pudo-chosen-location');
                $pudoChosenLocation.removeClass('hide');
                $pudoChosenLocation.addClass('pudo-chosen');
                $pudoChosenLocation.attr('data-pudo-chosen-id', pudoLocationId);

                $('.pudo-data').removeClass('hide');
                $('.pudo-edit-selected-location').removeClass('hide');
                $('.pudo-no-selected-location-error').addClass('hide');

                // update delivery address summary
                $('.address-item-city').text(pudoLocationCity);
                $('.address-item-address1').text(pudoLocationAddress);
                $('.address-summary-pudo-name').text(pudoLocationName).show();
                $('.address-item-postalCode').text(pudoLocationPostalCode);
                if ($state.length && response.stateName) {
                    $('.address-item-stateCode').text(response.stateName);
                }

                showAddressSummary();

                // only modify state after ajax to give time to update the form values when there's more than one country
                $(document).one('state-list-updated', function () {
                    if ($state.length && response && response.stateCode) {
                        $state.val(response.stateCode);
                    }

                    // if the state code returned doesn't exist in the form, try with state name
                    if ($state.length && response && !$state.val() || !response.stateCode) {
                        // if there's no state code, then select the option using the state name
                        $state.blur();
                        var selectedOption = $state.find('option[label="' + response.stateName + '"]');
                        if (selectedOption.length) {
                            $state.val(selectedOption.attr('value'));
                        }
                    }
                });

                // disable the checkbox that uses shipping address as the billing address in case a pudo location was chosen
                disableAddressList();
                disableAddressFields();
                hideAddToAddressBook();
                hideUseBillingAddressCheckbox();

                $('html').removeClass('no-scroll');

                // enable payment button if form is valid; otherwise, focus on input with error
                if ($form.valid()) {
                    $('button[name="dwfrm_singleshipping_shippingAddress_save"]').prop('disabled', false);
                } else {
                    $form.find('input.error').first().trigger('focus');
                }
            }
        });
    });

    $('.pudo-postal-search-input').on('input', function() {
        var $postalErrorEl = $('.pudo-postal-code-error-message');
        var $postalInput = $('.pudo-postal-search-input');
        var countryCode = $country.val() || '';

        isPudoSearchPostalCodeValid($postalInput, $postalErrorEl, countryCode, true);
    });

    $('.pudo-postal-search-container').on('submit', function(event) {
        event.preventDefault();

        var $postalErrorEl = $('.pudo-postal-code-error-message');
        var $postalInput = $('.pudo-postal-search-input');
        var postalCode = $postalInput.val();
        var countryCode = $country.val() || '';

        if (!isPudoSearchPostalCodeValid($postalInput, $postalErrorEl, countryCode, false)) {
            return;
        }

        var newUrl = createGetDPDLocationsURL(Urls.getDPDPudoLocations, { // eslint-disable-line no-undef
            postalCode: postalCode || '',
            countryCode: $country.val() || ''
        });

        dialog.replace({
            url: newUrl,
            callback: function() {
                initPudoModalListeners();
            }
        });
    });

    $('.pudo-locations-modal .ui-dialog-titlebar-close').on('click', function() {
        $('html').removeClass('no-scroll');
        dialog.close();

        if (!$('.pudo-chosen-location').hasClass('pudo-chosen')) {
            $('.pudo-data').removeClass('hide');
            $('.pudo-no-selected-location-error').removeClass('hide');

            // disable address modification functionality as DPD method is chosen
            disableAddressList();
            clearAddressFields();
            disableAddressFields();
            hideAddToAddressBook();
            hideUseBillingAddressCheckbox();

            // open shipping address form
            $('.enter-address-btn, .toggle-edit').trigger('click');
        // enable payment button if form is valid; otherwise, focus on input with error
        } else if ($form.valid()) {
            $('button[name="dwfrm_singleshipping_shippingAddress_save"]').prop('disabled', false);
        } else {
            $form.find('input.error').first().trigger('focus');
        }
    });
}

// HELPER FUNCTIONS

/**
* Validates the postal code input for PUDO (Pick Up Drop Off) search based on the selected country.
*
* @param {jQuery} $input - The jQuery object representing the postal code input field.
* @param {jQuery} $errorEl - The jQuery object representing the element to display error messages.
* @param {string} countryCode - The ISO country code used to select the appropriate postal code pattern.
* @param {boolean} isInputEvent - Indicates if the validation is triggered by an input event (true) or another event (false).
* @returns {boolean} - Returns true if the postal code is valid or empty (when not required), otherwise false.
*/
function isPudoSearchPostalCodeValid($input, $errorEl, countryCode, isInputEvent) {
    var postalCode = $input.val();

    if (!postalCode) {
        // if user removes postal code till the input is empty, consider it valid (as it's not required)
        if (isInputEvent) {
            $input.removeClass('error');
            $errorEl.html('');
        } else {
            $input.addClass('error');
            $errorEl.html(Resources.INVALID_POSTAL); // eslint-disable-line no-undef
        }

        return false;
    }

    var pattern = window.Patterns.postal[countryCode];
    var regex = new RegExp(pattern);
    var isValid = regex.test(postalCode);

    if (!isValid) {
        $input.addClass('error');
        $errorEl.html(Resources.INVALID_POSTAL); // eslint-disable-line no-undef

        return false;
    }

    $input.removeClass('error');
    $errorEl.html('');

    return true;
}

/**
* Hides the "Use as Billing Address" checkbox on the shipping address form.
* This function unchecks and hides the checkbox element with the ID
* 'dwfrm_singleshipping_shippingAddress_useAsBillingAddress' by updating its value,
* checked property, and hiding its containing form row.
*/
function hideUseBillingAddressCheckbox() {
    var $useAsBillingAddressInput = $('#dwfrm_singleshipping_shippingAddress_useAsBillingAddress');
    $useAsBillingAddressInput.removeAttr('checked');
    $useAsBillingAddressInput.prop('checked', false);
    $useAsBillingAddressInput.closest('.form-row').addClass('d-none');
}

/**
* Hides the "Add to Address Book" checkbox in the shipping address form.
* Sets its value to false, unchecks it, and hides its containing form row.
* This function is typically used to prevent users from saving a shipping address during checkout.
*/
function hideAddToAddressBook() {
    var $addToAddressBook = $('#dwfrm_singleshipping_shippingAddress_addToAddressBook');
    $addToAddressBook.removeAttr('checked');
    $addToAddressBook.prop('checked', false);
    $addToAddressBook.closest('.form-row').hide();
}

/**
* Disables all address-related input fields in the checkout form.
* This function sets the 'disabled' property to true for city, state, postal code,
* country, address line 1, and address line 2 input elements, preventing user interaction.
* Assumes that the variables $city, $state, $postal, $country, $address1, and $address2
* are jQuery objects referencing the respective input fields.
*/
function disableAddressFields() {
    $city.prop('disabled', true);
    $state.prop('disabled', true);
    $postal.prop('disabled', true);
    $country.prop('disabled', true);
    $address1.prop('disabled', true);
    $address2.prop('disabled', true);
}

/**
* Clears all address input fields by setting their values to empty strings.
* This function resets the city, state, postal code, country, address line 1, and address line 2 fields.
* Assumes that $city, $state, $postal, $country, $address1, and $address2 are jQuery objects referencing the respective input elements.
*/
function clearAddressFields() {
    $city.val('');
    $state.val('');
    $postal.val('');
    $address1.val('');
    $address2.val('');
}

/**
* Disables the address list dropdown in the single shipping form and clears its selected value.
* This function sets the value of the address list to an empty string and disables the input,
* preventing users from selecting or changing addresses during the checkout process.
*/
function disableAddressList() {
    $('#dwfrm_singleshipping_addressList').val('');
    $('#dwfrm_singleshipping_addressList').prop('disabled', true);

    $('.address-finder-btn').hide();
}

/**
* Displays the address summary section and hides the address form and edit button in the checkout page.
* Manipulates DOM elements to show the selected address, clear the address finder input,
* and hide address entry and editing UI components.
*
* @returns {void}
*/
function showAddressSummary() {
    // show address summary
    $('.selected-address-wrap').removeClass('d-none').addClass('d-block');

    // hide address form and edit button
    $('#dwfrm_singleshipping_shippingAddress_addressFields_addressFinder').val('');
    $('.address-finder-wrapper').removeClass('d-flex').addClass('d-none');
    $('.enter-address-wrapper').removeClass('d-flex').addClass('d-none');
    $('.js-toggle-edit').addClass('d-none');
}

/**
* Appends address object parameters to a given URL as query parameters.
* @param {string} url - The base URL to which address parameters will be appended.
* @param {Object} addressObj - An object containing address key-value pairs to be added as query parameters.
* @returns {string} The resulting URL with all address parameters appended.
*/
function createGetDPDLocationsURL(url, addressObj) {
    Object.keys(addressObj).forEach(function(key) {
        url = util.appendParamToURL(url, key, addressObj[key]);
    });

    return url;
}

/**
* Removes DPD PUDO (Pick-Up Drop-Off) information from the checkout form.
* Re-enables the shipping address fields, clears the PUDO name summary, and hides PUDO-specific data.
* This function is typically used when the customer changes their shipping method or cancels a PUDO selection.
*/
function removeDPDPudoInformation() {
    // enable back shipping address fields and remove Pudo content
    $address1.prop('disabled', false).val('');
    $address2.prop('disabled', false).val('');
    $city.prop('disabled', false).val('');
    $postal.prop('disabled', false).val('');
    $state.prop('disabled', false).val('');
    $country.prop('disabled', false); // don't remove country value so other shipping methods continue to be applicable

    $('#dwfrm_singleshipping_addressList').prop('disabled', false);
    $('button[name="dwfrm_singleshipping_shippingAddress_save"]').prop('disabled', false);
    $('.address-finder-btn').show();

    // remove pudo name
    $('.address-summary-pudo-name').text('');

    // hide pudo data
    $('.pudo-data').addClass('hide');
    $('.pudo-chosen-name').text('');
    $('.pudo-chosen-city').text('');
    $('.pudo-chosen-address').text('');
    $('.pudo-chosen-postalcode').text('');
    $('.pudo-edit-selected-location').addClass('hide');

    var $pudoChosenLocation = $('.pudo-chosen-location');
    $pudoChosenLocation.addClass('hide');
    $pudoChosenLocation.removeClass('pudo-chosen');
    $pudoChosenLocation.attr('data-pudo-chosen-id', '');
}

module.exports = {
    init: init,
    getDPDPudoLocations: getDPDPudoLocations,
    removeDPDPudoInformation: removeDPDPudoInformation
};

},{"../../dialog":14,"../../util":104,"./shipping":49}],45:[function(require,module,exports){
'use strict';

var _ = require('lodash');

var $form, $continue, $requiredInputs, $requiredCheckboxes, validator;

var hasEmptyRequired = function () {
    // filter out only the visible fields
    var requiredValues = $requiredInputs.filter(':visible').map(function () {
        return $(this).hasClass('error') ? '' : $(this).val();
    });

    var notCheckedRrequiredCheckboxes = $requiredCheckboxes.filter(':visible').map(function () {
        return $(this).is(":not(:checked)");
    });

    // validate credit card fields
    var selectedPaymentMethod = localStorage.getItem('selectedPaymentMethod');
    var isAdyenComponentValid = true;
    if (selectedPaymentMethod && selectedPaymentMethod == 'scheme') {
        var allAdyenFields = document.querySelectorAll('#component_scheme .adyen-checkout__field');
        if (allAdyenFields && allAdyenFields.length) {
            var validComponentItemsCount = document.querySelectorAll('#component_scheme .adyen-checkout__field--valid, #component_scheme .adyen-checkout__field__cvc--optional, #component_scheme .CardInput-module_adyen-checkout__card__cvc__input--hidden__VIlHV').length;
            var componentItemsCount = allAdyenFields.length;
            isAdyenComponentValid = componentItemsCount > 0 && componentItemsCount === validComponentItemsCount;
        }
    }

    return _(requiredValues).includes('') || _(notCheckedRrequiredCheckboxes).includes(true) || !isAdyenComponentValid;
};

var validateForm = function () {
    // only validate form when all required fields are filled to avoid
    // throwing errors on empty form
    if (!validator) {
        return;
    }

    if (!hasEmptyRequired()) {
        if (validator.form()) {
            $continue.removeAttr('disabled');
        }
    } else {
        $continue.attr('disabled', 'disabled');
    }
};

var validateEl = function () {
    if ($(this).val() === '') {
        $continue.attr('disabled', 'disabled');
    } else {
        // enable continue button on last required field that is valid
        // only validate single field
        if (validator.element(this) && !hasEmptyRequired()) {
            $continue.removeAttr('disabled');
        } else {
            $continue.attr('disabled', 'disabled');
        }
    }
};

var init = function (opts) {
    if (!opts.formSelector || !opts.continueSelector) {
        throw new Error('Missing form and continue action selectors.');
    }
    $form = $(opts.formSelector);
    $continue = $(opts.continueSelector);
    validator = $form.validate();
    $requiredInputs = $('.required', $form).find(':input');
    $requiredCheckboxes = $('.required', $form).find(':checkbox');
    validateForm();
    // start listening
    $requiredInputs.on('change', validateEl);
    $requiredInputs.filter('input').on('keyup', _.debounce(validateEl, 200));
};

exports.init = init;
exports.validateForm = validateForm;
exports.validateEl = validateEl;

},{"lodash":125}],46:[function(require,module,exports){
'use strict';

function init() {
    // GIFT BAGS
    const $giftBagForm = $('.gift-bag-form');
    if ($giftBagForm.length) {
        var $expandGiftBagForm = $('.gift-block a');
        var $giftBagCheckbox = $('.gift-bag-checkbox input');
        var $giftBagMessageContainer = $('.gift-bag-msg-container');
        var $giftMsgInput = $giftBagMessageContainer.find('textarea');
        var $giftBagItems = $('.gift-bag-items input');
        var $giftBagImage = $('.gift-bag-image');

        // expand the whole section
        $(document).on('shown.bs.collapse', '#giftBagForm', function() {
            // preselect the first radio button if there is none selected
            if (!$giftBagItems.filter(':checked').length) {
                $giftBagItems.first().closest('.bonus-product-item').trigger('click').find('input').trigger('change');
            }
        });

        // on change the main selection, expand the rest of the form
        $giftBagCheckbox.on('change', function () {
            $giftBagMessageContainer.slideToggle(function () {
                $giftBagMessageContainer.toggleClass('expanded');
                changeGiftBagImage($giftBagItems.filter(':checked').siblings('.primary-image-large'));
            });
        });

        function changeGiftBagImage(image) {
            $giftBagImage.stop().fadeOut(function () {
                const clonedImage = image.clone();
                clonedImage.attr('src', clonedImage.data('src'));
                clonedImage.load(function () {
                    $giftBagImage.css('min-height', $(this).height());
                });
                $giftBagImage.html(clonedImage.removeClass('visually-hidden')).fadeIn();
            });
        }

        $('.bonus-product-item').on('mouseenter', function () {
            if (!$(this).find('input:checked').length) {
                const largeImage = $(this).find('.primary-image-large');
                changeGiftBagImage(largeImage);
            }
        }).on('mouseleave', function () {
            if (!$(this).find('input:checked').length) {
                const largeImage = $giftBagItems.filter(':checked').first().siblings('.primary-image-large');
                changeGiftBagImage(largeImage);
            }
        }).on('click', function () {
            if (!$(this).hasClass('selected')) {
                $('.bonus-product-item.selected').removeClass('selected').find('input').prop('checked', false);
                $(this).addClass('selected').find('input').prop('checked', true);
            }
        });

        // if we have already selected bag, expand the whole section + form
        if ($giftBagCheckbox.is(':checked')) {
            $expandGiftBagForm.trigger('click');

            // select the item and show image
            const selectedBonusLineItem = $giftBagItems.filter(':checked').closest('.bonus-product-item');
            selectedBonusLineItem.trigger('click');
            changeGiftBagImage(selectedBonusLineItem.find('.primary-image-large'));

            $giftBagMessageContainer.slideToggle(function () {
                $giftBagMessageContainer.toggleClass('expanded');
            });
        }

        // textarea chars validation
        var charsLimit = $giftMsgInput.data('char-limit');
        $giftMsgInput.on('keydown', function(e) {
            var charsUsed = $(this).val().length;
            var controlKeys = ['8', '13', '46', '45', '36', '35', '38', '37', '40', '39'];

            if (charsUsed >= charsLimit && (controlKeys.indexOf(e.which.toString()) < 0)) {
                e.preventDefault();
            }
        });

        // textarea chars countdown
        $giftMsgInput.on('change keyup mouseup', function() {
            var charsUsed = $(this).val().length;
            var charsRemain = charsLimit - charsUsed;

            if (charsRemain < 0) {
                $(this).val($(this).val().slice(0, charsLimit));
                charsRemain = 0;
            }

            $('.gift-bag-limit-counter').text(charsRemain);
        });

        if ($giftMsgInput.val().length) {
            $giftMsgInput.trigger('change');
        }
    }
};

module.exports = {
    init: init
};

},{}],47:[function(require,module,exports){
'use strict';

var address = require('./address'),
    billing = require('./billing'),
    multiship = require('./multiship'),
    shipping = require('./shipping'),
    login = require('../../login'),
    applepay = require('./applepay');
/**
 * @function Initializes the page events depending on the checkout stage (shipping/billing)
 */
exports.init = function () {
    address.init();
    if ($('.checkout-shipping').length > 0) {
        shipping.init();
    } else if ($('.checkout-multi-shipping').length > 0) {
        multiship.init();
    } else {
        billing.init();
    }

    if ($('.login-form').length) {
        login.init();
    }

    // init Apple Pay
    applepay.init();

    //if on the order review page and there are products that are not available diable the submit order button
    if ($('.order-summary-footer').length > 0) {
        if ($('.notavailable').length > 0) {
            $('.order-summary-footer .submit-order .button-fancy-large').attr('disabled', 'disabled');
        }
    }
};

},{"../../login":34,"./address":41,"./applepay":42,"./billing":43,"./multiship":48,"./shipping":49}],48:[function(require,module,exports){
'use strict';

var address = require('./address'),
    formPrepare = require('./formPrepare'),
    dialog = require('../../dialog'),
    util = require('../../util'),
    validator = require('../../validator');

/**
 * @function
 * @description capture add edit adddress form events
 */
function addEditAddress(target) {
    var $addressForm = $('form[name$="multishipping_editAddress"]'),
        $addressDropdown = $addressForm.find('select[name$=_addressList]'),
        $addressList = $addressForm.find('.address-list'),
        add = true,
        originalUUID,
        resetOptionValue = false,
        selectedAddressUUID = $(target).parent().siblings('.select-address').val();

    $addressDropdown.on('change', function (e) {
        e.preventDefault();

        var selectedAddress = $addressList.find('select').val();
        if (selectedAddress !== 'newAddress') {
            selectedAddress = $.grep($addressList.data('addresses'), function (add) {
                return add.UUID === selectedAddress;
            })[0];
            add = false;
            resetOptionValue = false;
            // proceed to fill the form with the selected address
            util.fillAddressFields(selectedAddress, $addressForm);
        } else if  (selectedAddress === 'newAddress') {
            add = true;
            resetOptionValue = true;
            $addressForm.find('.input-text, .input-select').val('');
        } else {
            //reset the form if the value of the option is not a UUID
            $addressForm.find('.input-text, .input-select').val('');
        }
    });

    $addressForm.on('click', '.cancel', function (e) {
        e.preventDefault();
        dialog.close();
    });

    $addressForm.on('submit', function (e) {
        e.preventDefault();
        if (!$addressForm.valid()) {
            return false;
        }

        $.getJSON(Urls.addEditAddress, $addressForm.serialize(), function (response) {
            if (!response.success) {
                $('#multiaddresserror').html(Resources.COULD_NOT_SAVE_ADDRESS);
                return;
            }
            $('#multiaddresserror').toggleClass('hidden', response.success);

            var address = response.address,
                $shippingAddress = $(target).closest('.shippingaddress'),
                $select = $shippingAddress.find('.select-address'),
                $selected = $select.find('option:selected'),
                newOption = '<option value="' + address.UUID + '">' +
                    ((address.ID) ? '(' + address.ID + ')' : address.firstName + ' ' + address.lastName) + ', ' +
                    address.address1 + ', ' + address.city + ', ' + address.stateCode + ', ' + address.postalCode +
                    '</option>';
            dialog.close();

            if (address.UUID !== originalUUID) {
                resetOptionValue = true;
            }

            if (add) {
                $('.shippingaddress select').removeClass('no-option').append(newOption);
                $('.no-address').hide();
            } else {
                $('.shippingaddress select').find('option[value="' + address.UUID + '"]').html(newOption);
            }
            // if there's no previously selected option, select it
            if ($selected.length === 0 || $selected.val() === '' || resetOptionValue) {
                $select.find('option[value="' + address.UUID + '"]').prop('selected', 'selected').trigger('change');
            }
        });
    });

    //preserve the uuid of the option for the hop up form
    if (selectedAddressUUID) {
        //update the form with selected address
        $addressList.find('option').each(function () {
            //check the values of the options
            if ($(this).attr('value') === selectedAddressUUID) {
                $(this).prop('selected', 'selected');
                $addressDropdown.trigger('change');
            }
        });
        originalUUID = selectedAddressUUID;
    }

    validator.init();
}

/**
 * @function
 * @description shows gift message box in multiship, and if the page is the multi shipping address page it will call initmultishipshipaddress() to initialize the form
 */
exports.init = function () {
    if ($('.cart-row .shippingaddress .select-address').length > 0) {
        formPrepare.init({
            continueSelector: '[name$="addressSelection_save"]',
            formSelector: '[id$="multishipping_addressSelection"]'
        });
    }
    $('.edit-address').on('click', 'span', function (e) {
        dialog.open({url: this.attributes.href.value,  options: {open: function () {
            address.init();
            addEditAddress(e.target);
        }}});
    });
};

},{"../../dialog":14,"../../util":104,"../../validator":105,"./address":41,"./formPrepare":45}],49:[function(require,module,exports){
'use strict';

var ajax = require('../../ajax'),
    formPrepare = require('./formPrepare'),
    progress = require('../../progress'),
    tooltip = require('../../tooltip'),
    util = require('../../util'),
    captureplus = require("../../captureplus"),
    giftbags = require('./giftbags'),
    dpd = require('./dpd');

var shippingMethods;
var colissimoMap=null;
var mapReady=false;
var colissimoPoints=null;
var markers=[];
var lastinfo=null;
var selectedPoint=null;
var oldPostalCode=null;

/**
 * @function
 * @description Initializes gift message box, if shipment is gift
 */
function giftMessageBox() {
    // show gift message box, if shipment is gift
    $('.gift-message-text').toggleClass('hidden', $('input[name$="_shippingAddress_isGift"]:checked').val() !== 'true');
}

/**
 * @function
 * @description updates the order summary based on a possibly recalculated basket after a shipping promotion has been applied
 */
function updateSummary() {
    var $summary = $('#secondary.summary');
    // indicate progress
    progress.show($summary);

    // load the updated summary area
    $summary.load(Urls.summaryRefreshURL, function () {
        // hide edit shipping method link
        $summary.fadeIn('fast');
        $summary.find('.checkout-mini-cart .minishipment .header a').hide();
        $summary.find('.order-totals-table .order-shipping .label a').hide();
    });
}

/**
 * @function
 * @description Helper method which constructs a URL for an AJAX request using the
 * entered address information as URL request parameters.
 */
function getShippingMethodURL(url, extraParams) {
    var $form = $('.checkout-shipping');
    var params = {
        address1: $form.find('input[name$="_address1"]').val(),
        address2: $form.find('input[name$="_address2"]').val(),
        countryCode: $form.find('select[id$="_country"]').val(),
        stateCode: $form.find('select[id$="_state"]').val(),
        postalCode: $form.find('input[name$="_postal"]').val(),
        city: $form.find('input[name$="_city"]').val()
    };
    return util.appendParamsToUrl(url, $.extend(params, extraParams));
}

/**
 * @function
 * @description selects a shipping method for the default shipment and updates the summary section on the right hand side
 * @param
 */
function selectShippingMethod(shippingMethodID) {
    // nothing entered
    if (!shippingMethodID) {
        return;
    }
    // attempt to set shipping method
    var url = getShippingMethodURL(Urls.selectShippingMethodsList, {shippingMethodID: shippingMethodID});
    ajax.getJson({
        url: url,
        callback: function (data) {
            updateSummary();
            if (!data || !data.shippingMethodID) {
                window.alert('Couldn\'t select shipping method.');
                return false;
            }
            // display promotion in UI and update the summary section,
            // if some promotions were applied
            $('.shippingpromotions').empty();


            // if (data.shippingPriceAdjustments && data.shippingPriceAdjustments.length > 0) {
            //     var len = data.shippingPriceAdjustments.length;
            //     for (var i=0; i < len; i++) {
            //         var spa = data.shippingPriceAdjustments[i];
            //     }
            // }
            refreshColissimo();
        }
    });
}

/**
 * @function
 * @description Make an AJAX request to the server to retrieve the list of applicable shipping methods
 * based on the merchandise in the cart and the currently entered shipping address
 * (the address may be only partially entered).  If the list of applicable shipping methods
 * has changed because new address information has been entered, then issue another AJAX
 * request which updates the currently selected shipping method (if needed) and also updates
 * the UI.
 */
function updateShippingMethodList() {
    var $shippingMethodList = $('#shipping-method-list');
    if (!$shippingMethodList || $shippingMethodList.length === 0) { return; }
    var url = getShippingMethodURL(Urls.shippingMethodsJSON);

    ajax.getJson({
        url: url,
        callback: function (data) {
            if (!data) {
                window.alert('Couldn\'t get list of applicable shipping methods.');
                return false;
            }
            if (shippingMethods && shippingMethods.toString() === data.toString()) {
                // No need to update the UI.  The list has not changed.
            	refreshColissimo();
                return true;
            }

            // We need to update the UI.  The list has changed.
            // Cache the array of returned shipping methods.
            shippingMethods = data;
            // indicate progress
            progress.show($shippingMethodList);

            // load the shipping method form
            refreshColissimo();
            var smlUrl = getShippingMethodURL(Urls.shippingMethodsList);
            $shippingMethodList.load(smlUrl, function () {
                $shippingMethodList.fadeIn('fast');
                // rebind the radio buttons onclick function to a handler.
                $shippingMethodList.find('[name$="_shippingMethodID"]').click(handleShippingMethodClick);

                // update the summary
                updateSummary();
                progress.hide();
                tooltip.init();
                //if nothing is selected in the shipping methods select the first one
                if ($shippingMethodList.find('.input-radio:checked').length === 0) {
                    $shippingMethodList.find('.input-radio:first').prop('checked', 'checked');
                }
            });
        }
    });
}

/**
* Handles the click event on a shipping method selection input.
* Determines if the selected shipping method is a DPD delivery and updates the UI and shipping information accordingly.
* - If a PUDO location is chosen and the selected method is not DPD, it removes DPD PUDO information, opens the shipping address form, disables the proceed to payment button, and updates the shipping method.
* - If the selected method is DPD, it fetches DPD PUDO locations.
* Finally, it always updates the selected shipping method.
*
* @returns {void}
*/
function handleShippingMethodClick() {
    var shippingMethodID = $(this).val();

    var isClickedShippingDPD = shippingMethodID.includes('DEL_DPD');
    var $pudoChosenLocation = $('.pudo-chosen-location');
    var $pudoNoSelectedLocationError = $('.pudo-no-selected-location-error');
    var isDPDRendered = $pudoChosenLocation.length && $pudoNoSelectedLocationError.length || false;

    // if shipping method is changed from DPD to another
    var isDPDCurrentlySelected = isDPDRendered && ($pudoChosenLocation.hasClass('pudo-chosen') || !$pudoNoSelectedLocationError.hasClass('hide'));
    if (!isClickedShippingDPD && isDPDCurrentlySelected) {
        dpd.removeDPDPudoInformation();

        // open shipping address form
        $('.enter-address-btn, .toggle-edit').trigger('click');

        // disable proceed to payment button
        $('button[name="dwfrm_singleshipping_shippingAddress_save"]').prop('disabled', true);

        var $useAsBillingAddressInput = $('#dwfrm_singleshipping_shippingAddress_useAsBillingAddress');
        $useAsBillingAddressInput.closest('.form-row').removeClass('d-none');

        var $addToAddressBook = $('#dwfrm_singleshipping_shippingAddress_addToAddressBook');
        $addToAddressBook.closest('.form-row').show();
    } else if (isClickedShippingDPD) {
        dpd.getDPDPudoLocations(false);
    }

    selectShippingMethod(shippingMethodID);

    // Remove 'selected' class from all shipping methods and add it to the selected one
    $('[name$="_shippingMethodID"]').closest('.form-row').removeClass('selected');
    $(this).closest('.form-row').addClass('selected');

    // if changing the shipping method is enough for the checkout form to be valid, enable payment button
    var $form = $('form.address');
    if ($form.validate().checkForm() && !isClickedShippingDPD) {
        $('button[name="dwfrm_singleshipping_shippingAddress_save"]').prop('disabled', false);
    }
}

function refreshColissimo(){
    if("colissimo"===$('.checkout-shipping [name$="_shippingMethodID"]:checked').val()){
        ajax.getJson({
            url: getShippingMethodURL(Urls.getColissimoAddresses, {}),
            callback: function (data) {
            	colissimoPoints=data.locations;
            	updateMapAttempt();
            }
        });
    }
}
function updateMapAttempt(){
	var shipform=$('.checkout-shipping');
	if(false===mapReady||oldPostalCode!==shipform.find('input[id$="_postal"]').val()){
		if("colissimo"!==shipform.find('[name$="_shippingMethodID"]:checked').val()){
			return;
		}
		var geocoder=new google.maps.Geocoder();
		geocoder.geocode({
			"address": shipform.find('input[name$="_postal"]').val(),
			"componentRestrictions":{"country":shipform.find('select[id$="_country"]').val().toLocaleUpperCase()}
		},function(results,status){
			if(google.maps.GeocoderStatus.OK===status){
				if(mapReady){
					colissimoMap.panTo(results[0].geometry.location);
				}else{
					$("#colissimoMap").show();
					colissimoMap=new google.maps.Map(document.getElementById("colissimoMap"),{
					    center: results[0].geometry.location,
					    zoom: 12
					});
					mapReady=true;
				}
				oldPostalCode=shipform.find('input[id$="_postal"]').val();
				updateMapAttempt();
			}
		});
	}
	else if(null!==colissimoMap&&null!==colissimoPoints){
		for(var i=0;i<markers.length;i++) {
			markers[i].setMap(null);
		}
		markers=[];
		for(var i=0;i<colissimoPoints.length;i++){
			markers.push(addMarker(colissimoPoints[i]));
		}
	}
}
function addMarker(colissimoPoint){
	var days=["<br/>dimanche : ","<br/>lundi : ","<br/>mardi : ","<br/>mercredi : ","<br/>jeudi : ","<br/>vendredi : ","<br/>samedi : "];
	var infocontent="<h1>"+colissimoPoint.name+"</h1>";
	if(colissimoPoint.accessible){
		infocontent+='<span class="accessible-icon">&#x267F;</span>'
	}
	infocontent+="<p>"+colissimoPoint.address1;
	if(0!==colissimoPoint.address2.length){
		infocontent+="<br/>"+colissimoPoint.address2;
	}
	infocontent+="<br/>"+colissimoPoint.postal+" "+colissimoPoint.city+"</p>";

	var hours="<p>Horaires Ouverture :";
	for (var x=0;x<colissimoPoint.hours.length;x++){
		hours+=days[x]+colissimoPoint.hours[x];
	}
	infocontent+=hours+"</p>";

	infocontent+="<button data-colissimoid='"+colissimoPoint.ID+"' onclick='setColissimoID(event)'>"+Resources.RESOURCE_SELECT+"</button>";
	var infowindow=new google.maps.InfoWindow({
		content:infocontent
	});
	var mark=new google.maps.Marker({
		position:new google.maps.LatLng(new Number(colissimoPoint.lat),new Number(colissimoPoint.lon)),
		map:colissimoMap,
		icon:$("#colissimoMap").data("colissimo-icon")
	});
	mark.addListener("click",function(a,b,c){
		if(null!==lastinfo){
			lastinfo.close();
		}
		infowindow.open(colissimoMap,mark);
		lastinfo=infowindow;
		/*google.maps.event.addListener(infowindow,'domready',function(){
			$(this).find("button").on("click",function(e){
				$('input[id$="_colissimoPointID"]').val(e.dataset.colissimoid);
			});
		});*/
	});
	return mark;
}

exports.init = function () {

    util.fillStates();

    // choose the right state after ajax
    setTimeout(function () {
        var manualFields = $('.address-manually-fields');
        var stateCode = manualFields.data('state-code');
        var $stateSelect = manualFields.find('select[name$="_state"]');
        if ($stateSelect.length) {
            if (stateCode !== $stateSelect.val()) {
                $stateSelect.val(stateCode).trigger('change');
            }

            $('.address-item-stateCode').text($stateSelect.find('option:selected').text());
        }
    }, 500);

    formPrepare.init({
        continueSelector: '[name$="shippingAddress_save"]',
        formSelector:'[id$="singleshipping_shippingAddress"]'
    });

    captureplus.init();
    giftbags.init();
    dpd.init();

    const $manualAddressCont = $('.address-manually-fields');
    if ($manualAddressCont.attr('data-locale') === 'DK' || $manualAddressCont.attr('data-locale') === 'SE') {
        const $postalField = $manualAddressCont.find('.postal');
        $postalField.on('keyup paste change', function() {
            var newValue = $(this).val().replace(/[^0-9 ]/g,'');
            $(this).val(newValue);
        })
    }
};

exports.updateShippingMethodList = updateShippingMethodList;
exports.handleShippingMethodClick = handleShippingMethodClick;

},{"../../ajax":3,"../../captureplus":8,"../../progress":85,"../../tooltip":103,"../../util":104,"./dpd":44,"./formPrepare":45,"./giftbags":46}],50:[function(require,module,exports){
'use strict';

var addProductToCart = require('./product/addToCart'),
    ajax = require('../ajax'),
    page = require('../page'),
    productTile = require('../product-tile'),
    quickview = require('../quickview');

/**
 * @private
 * @function
 * @description Binds the click events to the remove-link and quick-view button
 */
function initializeEvents() {
    $('#compare-table').on('click', '.remove-link', function (e) {
        e.preventDefault();
        ajax.getJson({
            url: this.href,
            callback: function () {
                page.refresh();
            }
        });
    })
    .on('click', '.open-quick-view', function (e) {
        e.preventDefault();
        var url = $(this).closest('.product').find('.thumb-link').attr('href');
        quickview.show({
            url: url,
            source: 'quickview'
        });
    });

    $('#compare-category-list').on('change', function () {
        $(this).closest('form').submit();
    });
}

exports.init = function () {
    productTile.init();
    initializeEvents();
    addProductToCart();
};

},{"../ajax":3,"../page":37,"../product-tile":84,"../quickview":86,"./product/addToCart":57}],51:[function(require,module,exports){
'use strict';
var ajax = require('../ajax'),
    util = require('../util');

function initializeContactPage() {
    const fileSizeLimit = {
        '1': parseFloat(Resources.RESOURCE_FILEUPLOAD_LIMIT_1),
        '2': parseFloat(Resources.RESOURCE_FILEUPLOAD_LIMIT_2),
    };
    const fileUploadRestriction = {
        '1': Resources.RESOURCE_FILEUPLOAD_RESTRICTION_1,
        '2': Resources.RESOURCE_FILEUPLOAD_RESTRICTION_2,
    };
    const fileUploadOptional = {
        '1': Resources.RESOURCE_FILEUPLOAD_OPTIONNAL_1,
        '2': Resources.RESOURCE_FILEUPLOAD_OPTIONNAL_2,
    };

    var $contactusCategory = $('select#dwfrm_contactus_category'),
        $productRef = $('#dwfrm_contactus_productref'),
        $productRefText = $('#dwfrm_contactus_productreftext'),
        $productRefWrap = $('.productref-wrap');

    if ($('div.contact-wrapper').length && $contactusCategory.length) {

        $contactusCategory.on('change', function() {
            var element = $(this),
                categoryID = element.find(':selected').val(),
                html = '<option class="select-option" value="">'+Resources.RESOURCE_SELECT+'</option>';

                $productRef.find('option').remove().end().html(html);
            if (categoryID != '') {

                var url = util.appendParamToURL(element.data('url'), 'categoryID', categoryID),
                    elementBinded = element.data('binded');

                if (url && categoryID !== 'Other') {
                    ajax.getJson({
                        url: url,
                        callback: function (data) {
                            if (!data || !data.data) {
                                return false;
                            } else {
                                $.each(data.data, function(key, value) {
                                    var valueJson = JSON.parse(value);
                                    html += '<option class="select-option" data-parentid="'+valueJson.parentid+'" data-active="'+valueJson.active+'" value="'+valueJson.id+'">'+valueJson.displayName+'</option>';
                                });
                                html += '<option class="select-option" value="Other">'+Resources.CONTACT_PRODUCT_OTHER+'</option>';
                                buildSelect(elementBinded, html);
                            }
                        }
                    });
                    $productRef.removeClass('js-other hidden');
                    $productRefText.addClass('hidden');
                } else {
                    $productRef.addClass('js-other hidden');
                    $productRefText.removeClass('hidden');
                    $productRefWrap.removeClass('other-active');
                    $('#RegistrationForm').validate();
                }
            }

            if ($('.contactInfoMessage--visible').length > 0) {
                $('.contactInfoMessage').removeClass('contactInfoMessage--visible');
                $('.js-GotoProduct').removeClass('contactInfoMessage--visible');
                $('.js-SelectRef > .select-option').detach();
            }
        });

        $('.js-SelectRef').on('change', function() {
            var element = $(this), productID = element.find(':selected').val();
            if (productID === 'TW1000E' || productID === 'HEROTW110E' || productID === '6000E' || productID === 'HERO6000E') {
                $('.contactInfoMessage').addClass('contactInfoMessage--visible');
                if (document.querySelector('.contactAdvice')) {
                    $('.js-GotoProduct').addClass('contactInfoMessage--visible');
                }
                $productRefText.addClass('hidden');
                $productRefWrap.removeClass('other-active');
            } else if (productID === 'Other') {
                $productRefText.removeClass('hidden');
                $productRefWrap.addClass('other-active');
            } else {
                $('.contactInfoMessage').removeClass('contactInfoMessage--visible');
                if (document.querySelector('.contactAdvice')) {
                    $('.js-GotoProduct').addClass('contactInfoMessage--visible');
                }
                $productRefText.addClass('hidden');
                $productRefWrap.removeClass('other-active');
            }
        });
    }

    /**
     * Upload image functionality
     */
    var totalFileSum = 0;
    var clonedId = 0;
    var addedFiles = [];
    const maxFileTotalSize = SitePreferences.MAX_FILE_SIZE_TOTAL * 1024 * 1024;
    const exeededTotalBlock = $('.exeeded-total');
    const uploadBtn = $('.button-upload');
    const imageInputs = $('#imageInputs');

    $('.img-upload').on('change', function () {
        const trimmedAcceptableExtensions = [];
        const acceptableExtensions = SitePreferences.ACCEPTABLE_IMAGE_EXTENSIONS.split(',');
        const uploadMoreLabel = Resources.UPLOAD_ANOTHER_IMAGE_LABEL;
        const maxFileSize = SitePreferences.MAX_FILE_SIZE * 1024 * 1024;
        const img = $(this)[0].files[0];
        const fileExtension = img ? util.getFileExtension(img.name).toLowerCase() : null;
        const fileSize = img.size;
        const displayedNames = $('#displayFileNames');
        const exeededSizeBlock = $('.exeeded-size');
        const imLsTextRemove =  Resources.FILELIST_TEXT_REMOVE;
        const imLsTextFile = Resources.FILELIST_TEXT_FILE;

        acceptableExtensions.map(item => {
            return trimmedAcceptableExtensions.push(item.split(' ').join(''));
        });

        if (fileSize > maxFileSize) {
            exeededSizeBlock.removeClass('d-none');
        } else if ((totalFileSum + fileSize) > maxFileTotalSize) {
            exeededTotalBlock.removeClass('d-none');
        } else if (trimmedAcceptableExtensions.includes(fileExtension) && !addedFiles.includes(img.name)) {
            const clonedInput = $(this).clone();
            totalFileSum += fileSize;

            exeededSizeBlock.addClass('d-none');
            exeededTotalBlock.addClass('d-none');
            addedFiles.push(img.name);

            displayedNames.append(`<div class="image-list">
                                        <div class="field-wrapper">
                                            <div class="input-text valid">
                                                <label>
                                                    <span class="to-remove" data-id="prefix-${clonedId}">${imLsTextFile} ${img.name}</span>
                                                </label>
                                                <i class="validated"></i>
                                            </div>
                                            <span type="button" class="remove-me">${imLsTextRemove}</span>
                                        </div>
                                    </div>`);

            clonedInput.attr('id', 'prefix-' + clonedId);
            clonedInput.attr('name', 'prefix-' + clonedId);
            clonedId++;
            uploadBtn.find('label').text(uploadMoreLabel);
            imageInputs.append(clonedInput);

            this.value = null;
        }
    });
    /**
     * Remove uploaded image
     */
    $('#displayFileNames').on('click', function(e) {
        const isRemove = $(e.target);
        const uploadImageLabel = Resources.UPLOAD_IMAGE_LABEL;

        if (isRemove.hasClass('remove-me')) {
            const itemData = isRemove.prev().find('.to-remove').attr('data-id');
            const inputToDelete = imageInputs.find(`#${itemData}`);

            isRemove.parent().remove();
            imageInputs.find(`#${itemData}`).remove();
            uploadBtn.find('input').val(null);

            addedFiles.splice(addedFiles.indexOf(inputToDelete[0].files[0].name), 1);
            totalFileSum -= inputToDelete[0].files[0].size;

            if (addedFiles.length < 1) {
                uploadBtn.find('label').text(uploadImageLabel);
            }

            if (totalFileSum < maxFileTotalSize) {
                exeededTotalBlock.addClass('d-none');
            }
        }
    });

    /**
     * Show error if emails don't match
     */
    $('#dwfrm_contactuscustom_confirmEmail').on('blur', function() {
        if ($(this).val() !== $('#dwfrm_contactuscustom_email').val() && $(this).hasClass('valid')) {
            const emailMatchError = Resources.EMAIL_MATCH_ERROR;
            $(this).removeClass('valid').addClass('error');
            $(this).siblings('.form-caption').text(emailMatchError);
        } else {
            $(this).siblings('.form-caption').text('');
        };
    });

    /**
     * Exception case for some product
     */
    if ($('div.contact-wrapper').length && $('select#dwfrm_contactus_productref').length) {
        $('select#dwfrm_contactus_productref').on('change', function(){
            var element = $(this), productID = element.find(':selected').val(),
                elementToDisplay = $('#dwfrm_contactus_reference').parents('div.form-row'),
                url = util.appendParamToURL(element.data('url'), 'pid', productID);

            if (element.find(':selected').data('active') == false) {
                url = '#';
                if (document.querySelector('.contactAdvice') && $('.js-GotoProduct').hasClass('contactInfoMessage--visible'))
                    $('.js-GotoProduct').removeClass('contactInfoMessage--visible');
            }

            if (element.find(':selected').data('parentid') != '')
                url = util.appendParamToURL(element.data('url'), 'pid', element.find(':selected').data('parentid'));

            $('#link-to-product-page').find('a')[0].href = url;

            if (productID === '6000E' || productID === 'HERO6000E'){
                elementToDisplay.show();
            } else {
                elementToDisplay.hide();
            }
        });
    }

    /**
     * check file extension before uploading them
     */
    $("#RegistrationForm").submit(function(e) {
        var allowUpload = false, nbFiles = 0;
        var sizeLimitType = '1';
        var proofPurchase = 0;
        var otherFileSize = 0;

        if ($('input[name="dwfrm_contactus_typeFrm"]').val() == 'sav') {
            /**
             * Checking proof of purchase FILE
             */
            var filename_proofFAKE = $('input[name="dwfrm_contactus_proofPurchase"]').parent('div').prev().find('#fileuploadurl').val();
            if (filename_proofFAKE != '') {
                var extension = filename_proofFAKE.substr((filename_proofFAKE.lastIndexOf('.') +1));
                if (extension != '') {
                    var otherFiles = $('#dwfrm_contactus_otherFile')[0].files;
                    otherFileSize = otherFiles.length > 0 ? otherFiles[0].size/1024/1024 : 0;
                    var filesize = ($('input[name="dwfrm_contactus_proofPurchase"]')[0].files.length > 0) ? $('input[name="dwfrm_contactus_proofPurchase"]')[0].files[0].size/1024/1024 : 0;
                    var proofPurchaseSize = filesize + otherFileSize;
                    sizeLimitType = (proofPurchaseSize.toFixed(2) > fileSizeLimit['1'] && otherFileSize > 0) ? '2' : '1';
                    proofPurchase = filesize;

                    switch (extension.toLowerCase()) {
                        case 'jpg':
                        case 'jpeg':
                        case 'png':
                        case 'gif':
                        case 'pdf':
                        case 'docx':
                        case 'doc':
                        case 'odt':
                            allowUpload = true;
                        break;
                        default:
                            allowUpload = false;
                    }

                    // file size restriction
                    var isProofPurchase = otherFileSize == 0 || (otherFileSize > 0 && filesize >= otherFileSize);
                    if (isProofPurchase && proofPurchaseSize.toFixed(2) > fileSizeLimit[sizeLimitType]) {
                        allowUpload = false;
                    }
                }
            }

            if (!allowUpload) {
                $('input[name="dwfrm_contactus_proofPurchase"]').parent('div').parent('div').find('div.js-FileUpload-Error span').html(fileUploadRestriction[sizeLimitType]).css({'color' : '#c41f35', 'font-size' : 'calc(12rem / 16)'});
            } else {
                $('input[name="dwfrm_contactus_proofPurchase"]').parent('div').parent('div').find('div.js-FileUpload-Error span').html('');
            }

            var $inputOptionnal = $('#dwfrm_contactus_otherFile').parent('div').prev().find('#fileuploadurl');
            var allowUploadOptionnal = true;

            if ($inputOptionnal.length > 0) {
                var filename = $inputOptionnal.val();
                if (filename != '') {
                    var extension = filename.substr((filename.lastIndexOf('.') +1));
                    if (extension != '') {
                        var realInputFile = $inputOptionnal.parent('div').next().find('input[type="file"]')[0];
                        var filesize = ($(realInputFile)[0].files.length > 0) ? $(realInputFile)[0].files[0].size/1024/1024 : 0;
                        var optionalSize = filesize + proofPurchase;
                        sizeLimitType = (optionalSize.toFixed(2) > fileSizeLimit['1'] && proofPurchase > 0) ? '2' : '1';

                        switch (extension.toLowerCase()) {
                            case 'jpg':
                            case 'jpeg':
                            case 'png':
                            case 'gif':
                            case 'pdf':
                            case 'docx':
                            case 'doc':
                            case 'odt':
                                allowUploadOptionnal = true;
                            break;
                            default:
                                allowUploadOptionnal = false;
                        }

                        // file size restriction
                        var isInputOptional = proofPurchase == 0 || (proofPurchase > 0 && filesize > proofPurchase);
                        if (isInputOptional && optionalSize.toFixed(2) > fileSizeLimit[sizeLimitType]) {
                            allowUploadOptionnal = false;
                        }
                    }
                }
            }

            var $otherFileError = $('input[name="dwfrm_contactus_otherFile"]').parent('div').parent('div').next();
            if (!allowUploadOptionnal) {
                $otherFileError.html(fileUploadRestriction[sizeLimitType]).css({'color' : '#c41f35', 'font-size' : 'calc(12rem / 16)'});
            } else {
                $otherFileError.html('');
            }

            if (!allowUpload || !allowUploadOptionnal) {
                return false;
            }
        } else if ($('input[name="dwfrm_contactuscustom_typeFrm"]').val() == 'accessories') {

            var $inputOptionnal = $('#dwfrm_contactuscustom_otherFile').parent('div').prev().find('#fileuploadurl');
            var allowUploadOptionnal = true;

            if ($inputOptionnal.length > 0) {
                var filename = $inputOptionnal.val();
                if (filename != '') {
                    var extension = filename.substr((filename.lastIndexOf('.') +1));
                    if (extension != '') {
                        var realInputFile = $inputOptionnal.parent('div').next().find('input[type="file"]')[0];
                        var filesize = ($(realInputFile)[0].files.length > 0) ? $(realInputFile)[0].files[0].size/1024/1024 : 0;
                        if(extension.toLowerCase() != 'jpg' && extension.toLowerCase() != 'jpeg' && extension.toLowerCase() != 'png' && extension.toLowerCase() != 'gif' && extension.toLowerCase() != 'pdf' && extension.toLowerCase() != 'docx' && extension.toLowerCase() != 'doc' && extension.toLowerCase() != 'odt') {
                            allowUploadOptionnal = false;
                        }

                        // file size restriction
                        if (filesize.toFixed(2) > fileSizeLimit['1']) {
                            allowUploadOptionnal = false;
                        }
                    }
                }
            }

            if (!allowUploadOptionnal) {
                $('div.js-FileUpload-Error').find('span').html(fileUploadOptional[sizeLimitType]).css({'color' : '#c41f35', 'font-size' : 'calc(12rem / 16)'});
            } else {
                $('div.js-FileUpload-Error').find('span').html('');
            }

            if (!allowUploadOptionnal) {
                return false;
            }
        } else if ($('input[name="dwfrm_contactuscustom_typeFrm"]').val() == 'other') {

           var $inputOptionnal = $('#dwfrm_contactuscustom_otherFile').parent('div').prev().find('#fileuploadurl');
           var allowUploadOptionnal = true;

           if ($inputOptionnal.length > 0) {
               var filename = $inputOptionnal.val();
               if (filename != '') {
                   var extension = filename.substr((filename.lastIndexOf('.') +1));
                   if (extension != '') {
                       var realInputFile = $inputOptionnal.parent('div').next().find('input[type="file"]')[0];
                       var filesize = ($(realInputFile)[0].files.length > 0) ? $(realInputFile)[0].files[0].size/1024/1024 : 0;
                       if (extension.toLowerCase() != 'jpg' && extension.toLowerCase() != 'jpeg' && extension.toLowerCase() != 'png' && extension.toLowerCase() != 'gif' && extension.toLowerCase() != 'pdf' && extension.toLowerCase() != 'docx' && extension.toLowerCase() != 'doc' && extension.toLowerCase() != 'odt') {
                           allowUploadOptionnal = false;
                       }

                       // file size restriction
                       if (filesize.toFixed(2) > fileSizeLimit['1']) {
                           allowUploadOptionnal = false;
                       }
                   }
               }
           }

           if (!allowUploadOptionnal) {
               $('div.js-FileUpload-Error').find('span').html(fileUploadOptional[sizeLimitType]).css({'color' : '#c41f35', 'font-size' : 'calc(12rem / 16)'});
           } else {
               $('div.js-FileUpload-Error').find('span').html('');
           }

           if (!allowUploadOptionnal) {
               return false;
           }

        } else if ($('input[name="dwfrm_contactuscustom_typeFrm"]').val() == 'career') {
            var filename_proofFAKE = $('input[name="dwfrm_contactuscustom_otherFile"]').parent('div').prev().find('#fileuploadurl').val();
            if (filename_proofFAKE != '') {
                var extension = filename_proofFAKE.substr((filename_proofFAKE.lastIndexOf('.') +1));

                if (extension != '') {
                    var filesize = ($('input[name="dwfrm_contactuscustom_otherFile"]')[0].files.length > 0) ? $('input[name="dwfrm_contactuscustom_otherFile"]')[0].files[0].size/1024/1024 : 0;
                    switch(extension.toLowerCase()) {
                        case 'jpg':
                        case 'jpeg':
                        case 'png':
                        case 'gif':
                        case 'pdf':
                        case 'docx':
                        case 'doc':
                        case 'odt':
                            allowUpload = true;
                        break;
                        default:
                            allowUpload = false;
                    }

                    // file size restriction
                    if (filesize.toFixed(2) > fileSizeLimit['1']) {
                        allowUpload = false;
                    }
                }
            }

            if (!allowUpload) {
                $('input[name="dwfrm_contactuscustom_otherFile"]').parent('div').parent('div').find('div.js-FileUpload-Error span').html(fileUploadRestriction[sizeLimitType]).css({'color' : '#c41f35', 'font-size' : 'calc(12rem / 16)'});
            } else {
                $('input[name="dwfrm_contactuscustom_otherFile"]').parent('div').parent('div').find('div.js-FileUpload-Error span').html('');
            }
        }
    });

    $("#dwfrm_contactuslight_message, #dwfrm_contactus_message").on('keyup',function() {
        var messageInput = $(this);
        messageInput.valid();

        var message = messageInput.val();
        var numberOfLineBreaks = (message.match(/\n/g)||[]).length;
        var messageLength = message.length + numberOfLineBreaks;

        if (messageLength > 15000)
            messageInput.val(message.slice(0, (15000-messageLength)));

        if (messageLength >= 14999)
            $('span#dwfrm_contactus_message-info').show();
        else
            $('span#dwfrm_contactus_message-info').hide();
    });

    $('select[name="select-country-contactus"]').change(function(){
        var id = $(this).val();
        $('div.country-info').hide();
        $('#'+id).show();
    });

    $('.contact-form .contact-news .input-checkbox').on('click', function() {
        $('.contact-form .contact-news .input-checkbox').prop( "checked", false);
        $(this).prop( "checked", true);
    });
}

function buildSelect(element, html) {
    var element = $('#'+element);
    if (element.length) {
        element.find('option').remove().end().html(html);
    }
    if (element.selector == '#dwfrm_contactus_productref') {
        if ($('.stores span').text() == "SERVICE") {
            var isNlSite = true;
        }
        if ($('.lang-selector').attr('data-start') == 'fr_BE' || $('.lang-selector').attr('data-start') == 'nl_BE'){
                var isBESite = true;
        }
        if($('.lang-selector') || isNlSite){
            if ( isBESite || isNlSite) {
                if (Resources.RESOURCE_SELECT_OTHER == undefined) {
                    var other = 'Other';
                }else{
                    var other = Resources.RESOURCE_SELECT_OTHER;
                }
                $( '<option class="select-option select" value="' + other + '">' + other + '</option>' ).insertAfter( '#dwfrm_contactus_productref option:last-child' );
            }
        }
    }
}

function isValidEmailAddress(emailAddress) {
    var pattern = /^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
    return pattern.test(emailAddress);
}

if ($('.form-row').length) {
    $('.form-row').on('change', '.js-Upload' , function(e) {
        var filenameIn = $(this).val();
        var filenameOut = filenameIn.split('\\').pop();
        $(this, e.delegateTarget).parent().prev().find('.js-FileUpload').val(filenameOut);
        $('.js-FileUpload', e.delegateTarget).parent().next('.file-upload').hide();
        $('.file-upload-name', e.delegateTarget).addClass('file-upload-name--visible')
    });
}

if ($('.file-upload-name').length) {
    $('.file-upload-name').on('click', '.file-upload-icon', function(e) {
        $('.js-FileUpload', e.delegateTarget).val(null);
        $('.js-FileUpload', e.delegateTarget).parent().next('.file-upload').show();
        $(this).parent().removeClass('file-upload-name--visible')
    });
}

if ($('.other-Files').length) {
    $('.other-Files').on('change', function() {
        $('.other-FilesUpload').show();
    });
}

if (window.matchMedia('(max-width: 65rem)').matches) {
    listToSelect()
} else {
    $('contact-type select').remove();
    $('.contact-type-List').show();
}

function listToSelect() {
    var total = $('.contact-type-List li').size();
    $('.contact-type').addClass('contact-form');
    $('<select/>').addClass('input-select input-select--choice').appendTo('.contact-type');
    $('.input-select--choice').append('<option>'+Resources.RESOURCE_SELECT_HEAD+'</option>');

    for (var i = 0; i < total; i++){
        $('.input-select--choice').append('<option/>');
    }

    $('.input-select--choice > option').each(function(index){
        var content = $('.contact-type-List li:eq('+index+')').text();
        var location = $('.contact-type-List li:eq('+index+') a').attr('href');
        $(this).text(content).val(location);
    });

    $('.contact-type-List').hide();

    $('.contact-type select').bind('change', function () {
        var url = $(this).val();
        if (url != '') {
            window.location = url;
        }
        return false;
    });
}

initializeContactPage();

},{"../ajax":3,"../util":104}],52:[function(require,module,exports){
'use strict';

var Swiper = require('swiper');
var mySwiper = undefined;

function initIconicSwiper() {
    var mobileWidth = 543;
    var screenWidth = $(window).width();
    if (screenWidth < mobileWidth && mySwiper == undefined) {
        $('.header-promotion-slider').show();
        mySwiper = new Swiper('.header-promotion-slider', {
            centeredSlides: true,
            slidesPerView: 'auto',
            spaceBetween: 20,
            initialSlide: 0,
            centerInsufficientSlides: true,
        });
    } else if (screenWidth > mobileWidth && mySwiper != undefined) {
        mySwiper.destroy();
        mySwiper = undefined;
    }
}

//Swiper plugin initialization
initIconicSwiper();

},{"swiper":145}],53:[function(require,module,exports){
'use strict';

var Swiper = require('swiper');
var mySwiper = undefined;

function initIconicSwiper() {
    var screenWidth = $(window).width();
    if (screenWidth < 480 && mySwiper == undefined) {
        $('.iconic-slider .swiper-pagination').show();
        mySwiper = new Swiper('.iconic-slider', {
            centeredSlides: true,
            slidesPerView: 'auto',
            paginationClickable: true,
            spaceBetween: 20,
            initialSlide: 0,
            pagination: '.bloc-conseil .swiper-pagination'
        });
    } else if (screenWidth > 480 && mySwiper != undefined) {
        mySwiper.destroy();
        mySwiper = undefined;
        $('.product-conseil.swiper-wrapper').removeAttr('style');
        $('.product-conseil-item.swiper-slide').removeAttr('style');
        $('.iconic-slider .swiper-pagination').hide();
    }
}

//Swiper plugin initialization
initIconicSwiper();

//Swiper plugin initialization on window resize
$(window).on('resize', function(e){
    initIconicSwiper();
    if (e.target.innerWidth > 480) {
        $('.iconic-slider .swiper-pagination-bullets').hide();
    }
    if (e.target.innerWidth < 480) {
        $('.iconic-slider .swiper-pagination-bullets').show();
    }
});

},{"swiper":145}],54:[function(require,module,exports){
'use strict';

var Swiper = require('swiper');
var instagramSwiper = undefined;

function initInstagramSwiper() {
    var screenWidth = $(window).width();
    if(screenWidth < 480 && instagramSwiper == undefined) { 
    	$('.instagram-swiper .swiper-pagination').show();
    	instagramSwiper = new Swiper('.instagram-swiper', {
        	slidesPerView: 'auto',
	        paginationClickable: true,
	        spaceBetween: 0,
	        centeredSlides: true,
	        pagination: '.instagram-swiper .swiper-pagination',
        });
    } else if (screenWidth > 480 && instagramSwiper != undefined) {
    	instagramSwiper.destroy();
    	instagramSwiper = undefined;
        $('.univers-instagram-img-list').removeAttr('style');
    	$('.instagram-swiper .swiper-pagination').hide();
    }        
}

//Swiper plugin initialization
initInstagramSwiper();

//Swiper plugin initialization on window resize
$(window).on('resize', function(){
	initInstagramSwiper();        
});


},{"swiper":145}],55:[function(require,module,exports){
'use strict';

var Swiper = require('swiper');
var jobSwiper = undefined;

function initJobSwiper() {
    var screenWidth = $(window).width();
    if(screenWidth < 800 && jobSwiper == undefined) {
    	$('.job-swiper .swiper-pagination').show();
    	jobSwiper = new Swiper('.job-swiper', {
        	slidesPerView: 'auto',
	        paginationClickable: true,
	        spaceBetween: 0,
	        pagination: '.job-swiper .swiper-pagination',
	        breakpoints: {
	            800: {
	                slidesPerView: 2,
	            },
	            480: {
	                slidesPerView: 1,
	            },
	        }
        });
    } else if (screenWidth > 800 && jobSwiper != undefined) {
    	jobSwiper.destroy();
    	jobSwiper = undefined;
        $('.corp-jobs-grid.swiper-wrapper').removeAttr('style');
        $('.job-swiper .corpo-jobs-item').removeAttr('style');
    	$('.job-swiper .swiper-pagination').hide();
    }
}

//Swiper plugin initialization
initJobSwiper();

//Swiper plugin initialization on window resize
$(window).on('resize', function(){
	initJobSwiper();        
});
},{"swiper":145}],56:[function(require,module,exports){
'use strict';

var ajax = require('../ajax'),
	util = require('../util');

function initializeNewsletter() {

	/**
	 * Init jquery.validate for newsletter form
	 */
    $('#dwfrm_newsletter').validate({
        errorElement: "span",
        errorPlacement: function (error, element) {
        	$('#newsletter-error-message').html(error);
        },
        submitHandler: function(form) {
        	submitNewsletterForm();
    	}
	});

	/**
	 * Toggle only one selected
	 */
    $('#dwfrm_newsletter .input-checkbox').on('click', function() {
		$('#dwfrm_newsletter .input-checkbox').prop( "checked", false);
		$(this).prop( "checked", true);
	});

    /**
     * Send Google Tag when click on form
     */
	document.getElementById('dwfrm_newsletter_newslettersent').addEventListener("click", function(e) {
	    var dataFrm = $('#dwfrm_newsletter').serializeArray();
	    var choice = [];

	    $(dataFrm).each(function() {
	        if (this.name=='dwfrm_newsletter_cboxbabyliss')
	            choice.push('Babyliss');

	        if (this.name=='dwfrm_newsletter_cboxbabylissForMen')
				choice.push('Babyliss for Men');

			if (this.name=='dwfrm_newsletter_cboxboth')
				choice.push('Babyliss and Babyliss for Men');
	    });

	    // tagmanager_event('clickFooterNewsletter', {'choice': choice.join(',')});
	});

	/**
	 * Validate field on change
	 */
	$('#dwfrm_newsletter_email').on('change', function() {
    	var messageInput = $(this);
    	messageInput.valid();
	});
}

/**
 * Submit function form newsletter Form
 */
function submitNewsletterForm() {
    ajax.getJson({
        url: $('#dwfrm_newsletter')[0].action,
        data: $('#dwfrm_newsletter').serialize(),
        callback: function (data) {
        	if (data.data == true) {
        		$('#dwfrm_newsletter_response').css('color', '#74b01e');
        		$('#dwfrm_newsletter_response').html(Resources.NEWSLETTER_SUB_OK);
        	} else if (data.data == false) {
        		$('#dwfrm_newsletter_response').css('color', '#c41f35');
        		$('#dwfrm_newsletter_response').html(Resources.NEWSLETTER_SUB_FAIL);
        	}
        }
    });
}

initializeNewsletter();

},{"../ajax":3,"../util":104}],57:[function(require,module,exports){
'use strict';

var dialog = require('../../dialog'),
    minicart = require('../../minicart'),
    availability = require('./availability'),
    page = require('../../page'),
    util = require('../../util'),
    Promise = require('promise'),
    _ = require('lodash');
var { hasEngravableProductCustomizationBtn } = require('./engravableProductCustomization');

/**
 * @description Make the AJAX request to add an item to cart
 * @param {Element} form The form element that contains the item quantity and ID data
 * @returns {Promise}
 */
var addItemToCart = function (form, params) {
    var $form = $(form),
        $qty = $form.find('input[name="Quantity"]');
    if ($qty.length === 0 || isNaN($qty.val()) || parseInt($qty.val(), 10) === 0) {
        $qty.val('1');
    }

    return Promise.resolve($.ajax({
        type: 'POST',
        url: util.ajaxUrl(Urls.addProduct),
        data: {
            ...util.getQueryStringParams($form.serialize()),
            ...params
        }
    })).then(function (response) {
        return response;
    });
};

/**
 * @description Handler to handle the add to cart event
 */
var addToCart = function (e, callback, ...params) {
    e.preventDefault();
    var $form = $(this).closest('form');
    var $productCustomizationForm = $('.product-customization-form');

    if ($productCustomizationForm.length) {
        // the form should be additionally checked because the event is triggered on document
        // the params are passed with array containing one item of params because of the way the event is triggered
        $form = $productCustomizationForm;
        params = params[0];
    }

    addItemToCart($form, params).then(function (response) {
        var $uuid = $form.find('input[name="uuid"]');
        if ($uuid.length > 0 && $uuid.val().length > 0) {
            page.refresh();
        } else {
            if (response.success) {
                // do not close quickview if adding individual item that is part of product set
                // @TODO should notify the user some other way that the add action has completed successfully
                if (!$(this).hasClass('sub-product-item')) {
                    $('.ui-dialog-content').dialog('close');
                }

                minicart.show(decodeURIComponent(response.HTML));
                availability();

                if ($('.pt_cart').length) {
                    page.refresh();
                }
            }

            // handle custom errors when necessary
            if (typeof (callback) === 'function') {
                callback(response);
            }

            // trigger event for engravable product logic after add to cart finished,
            // if engravable product customization button present on page
            if (hasEngravableProductCustomizationBtn()) {
                $(document).trigger('engravableProduct:updateAvailability');
            }
        }
    }.bind(this));
};

/**
 * @description Handler to handle the add all items to cart event
 */
var addAllToCart = function (e) {
    e.preventDefault();
    var $productForms = $('#product-set-list').find('form').toArray();

    Promise.all(_.map($productForms, addItemToCart))
        .then(function (responses) {
            dialog.close();
            // show the final response only, which would include all the other items
            minicart.show(responses[responses.length - 1]);
        });
};

/**
 * @function
 * @description Binds the click event to a given target for the add-to-cart handling
 */
module.exports = function () {
    $('.add-to-cart[disabled]').attr('title', $('.availability-msg').text());
    $(document.body).off('click', '.product-detail .add-to-cart, .product-row_btn-container .add-to-cart').on('click', '.product-detail .add-to-cart, .product-row_btn-container .add-to-cart', addToCart);
    $(document).off('productCustomizeAddToCart').on('productCustomizeAddToCart', addToCart);
    $('#add-all-to-cart').on('click', addAllToCart);
    if (   $(".duplicate button.button-pink").length && $('.product-add-to-cart #add-all-to-cart').length   ) {
        $(".duplicate button.button-pink").on('click', function (e) {
            $('.product-add-to-cart #add-all-to-cart').trigger('click');
        })
    }
    if (   $('.product-add-to-cart #hatchLink').length && $('.duplicate a.hatchLink').length  ) {
        $(".duplicate a.hatchLink").on('click', function (e) {
            e.preventDefault();
            $('.product-add-to-cart #hatchLink').trigger('click');
        })
    }
};

},{"../../dialog":14,"../../minicart":36,"../../page":37,"../../util":104,"./availability":58,"./engravableProductCustomization":61,"lodash":125,"promise":128}],58:[function(require,module,exports){
'use strict';

var ajax =  require('../../ajax'),
    util = require('../../util');

var { hasEngravableProductCustomizationBtn } = require('./engravableProductCustomization');

var updateContainer = function (data, qtyEl) {
    var $pdpMain = $('#pdpMain, #product-customization-modal');
    var $pdpForm = qtyEl && qtyEl.length ? qtyEl.closest('form') : $pdpMain.find('.pdpForm');

    var $availabilityContainer = $pdpMain.find('div.availability');
    var $availabilityMessage = $pdpForm.find('.availability-msg');
    var $addToCart = $pdpForm.find('#add-to-cart, .add-to-cart, .engraving-atb-button');
    var $inventoryContainer = $pdpForm.find('.inventory');
    var $btnMinus = $pdpForm.find('.fa-minus-square-o');
    var $qtyContainer = $pdpForm.find('.quantity input#Quantity');

    if ($('.spares-pdp').length) {
        $addToCart = $('[data-productid=' + data.pid + ']');
        $btnMinus = qtyEl.siblings('.fa-minus-square-o');
        $inventoryContainer = qtyEl.closest('.inventory');
    }

    if (data && data.statusQuantity > 1) {
        $btnMinus.removeClass('disabled');
    } else {
        $btnMinus.addClass('disabled');
    }

    if (!data) {
        $availabilityMessage.html(window.Resources.ITEM_STATUS_NOTAVAILABLE);
        $addToCart.removeAttr('disabled');
        $addToCart.show();
        $availabilityContainer.find('.availability-qty-available').html();
        $availabilityContainer.find('.availability-msg').show();
        return;
    }

    $addToCart.attr('disabled', 'disabled');
    let availabilityMessageText = '';

    $qtyContainer.removeClass('error');
    $availabilityContainer.find('.not-available-msg-temp').remove();

    if (data.levels.IN_STOCK > 0) {
        availabilityMessageText = $availabilityMessage.find('.in-stock-msg');
        if (availabilityMessageText.length === 0) {
            availabilityMessageText = $('<p/>').addClass('in-stock-msg').appendTo($availabilityMessage);
        }

        if (data.levels.PREORDER == 0 && data.levels.BACKORDER == 0) {
            if (data.maxQtyMsg.length === 0 && !data.hasOwnProperty('decimalError')) {
                $addToCart.removeAttr('disabled');
                $addToCart.show();
                $inventoryContainer.show();
            } else {
                availabilityMessageText = $availabilityMessage.find('.not-available-msg');
                if (availabilityMessageText.length === 0) {
                    availabilityMessageText = $('<p/>').addClass('not-available-msg').addClass('not-available-msg-temp').appendTo($availabilityMessage);
                } else {
                    availabilityMessageText.addClass('not-available-msg-temp');
                }
                var decimalError = data.hasOwnProperty('decimalError') ? data.decimalError : data.maxQtyMsg;
                $qtyContainer.addClass('error');
                availabilityMessageText.text(decimalError).show();
            }
        } else {
            availabilityMessageText.text(data.levels.inStockMsg);
        }

        var klarnaPriceEl = $('.klarnasliceit-info span');
        var klarnaQuantity = $('#Quantity').val();
        var klarnaPrice = klarnaPriceEl.data('price');

        if (klarnaPriceEl.length) {
            klarnaPrice = (klarnaPrice * klarnaQuantity / window.SitePreferences.KLARNA_INSTALLMENTS).toFixed(2);
            klarnaPriceEl.html(klarnaPriceEl.data('priceformat').replace('#.##', klarnaPrice));
        }
    }

    if (data.levels.PREORDER > 0) {
        availabilityMessageText = $availabilityMessage.find('.preorder-msg');
        if (availabilityMessageText.length === 0) {
            availabilityMessageText = $('<p/>').addClass('preorder-msg').appendTo($availabilityMessage);
        }
        if (data.levels.IN_STOCK == 0 && data.levels.BACKORDER == 0 && data.levels.NOT_AVAILABLE >= 0) {
            availabilityMessageText.text(data.levels.resources.PREORDER);
        } else {
            availabilityMessageText.text(data.preOrderMsg);
        }
    }

    if (data.levels.BACKORDER > 0) {
        availabilityMessageText = $availabilityMessage.find('.backorder-msg');
        if (availabilityMessageText.length === 0) {
            availabilityMessageText = $('<p/>').addClass('backorder-msg').appendTo($availabilityMessage);
        }
        if (data.levels.IN_STOCK == 0 && data.levels.PREORDER == 0 && data.levels.NOT_AVAILABLE >= 0) {
            availabilityMessageText.text(data.levels.BACKORDER);
        } else {
            availabilityMessageText.text(data.backOrderMsg);
        }
    }

    if (data.inStockDate != '') {
        availabilityMessageText = $availabilityMessage.find('.in-stock-date-msg');
        if (availabilityMessageText.length === 0) {
            availabilityMessageText = $('<p/>').addClass('in-stock-date-msg').appendTo($availabilityMessage);
        }
        availabilityMessageText.text(String.format(data.levels.IN_STOCK_DATE, data.inStockDate));
    }

    if (data.levels.NOT_AVAILABLE > 0) {
        availabilityMessageText = $availabilityMessage.find('.not-available-msg');
        if (availabilityMessageText.length === 0) {
            availabilityMessageText = $('<p/>').addClass('not-available-msg').appendTo($availabilityMessage);
        }
    }

    // update the engravable product's button availability respect to addToCart button's
    if (hasEngravableProductCustomizationBtn()) {
        $(document).trigger('engravableProduct:updateAvailability');
    }
};

var getAvailability = function () {
    var productID,
        productVersion;
    var $quantitySelector = $(this);

    if (!$('.spares-pdp').length && !$quantitySelector.closest('.product-customization-modal').length) {
        productID = $('#pid').val() || $('.product-number span[itemprop="productID"]').text();
        productVersion = $('input[name="productVersion"]').val();

        if (!$quantitySelector || !$quantitySelector.length) {
            $quantitySelector = $('input[name="Quantity"]');
        }
    } else {
        productID = $quantitySelector.closest('.pdpForm').find('#pid').val();
    }

    var params = {
        pid: productID,
        Quantity: $quantitySelector.val()
    };

    if (window.location.href.indexOf('editVersion') === -1) {
        params.productVersion = productVersion;
    }

    ajax.getJson({
        url: util.appendParamsToUrl(window.Urls.getAvailability, params),
        callback: (data) => {
            updateContainer(data, $quantitySelector);
        }
    });
};

module.exports = function () {
    $(document).on('change keyup', 'input[name="Quantity"]', getAvailability);
    if (!$('.spares-pdp').length) {
        getAvailability();
    }
};

},{"../../ajax":3,"../../util":104,"./engravableProductCustomization":61}],59:[function(require,module,exports){
'use strict';

/**
 * Adapted version of pdpSummary.js from Bazaarvoice SFRA cartridge.
 * Additional reference: https://docs.bazaarvoice.com/articles/ratings-reviews/integrate-bazaarvoice-ugc-into-your-pdp/a/h4__302208069
*/

module.exports = function () {
    $(document).ready(function () {
        // when user has clicked the ratings from the Quick View, identify parameter to scroll down to the Reviews section
        var searchParams = new URLSearchParams(window.location.search);
        if (searchParams.has('viewreviews')) {
            setTimeout(function() {
                var $reviewsContainer = $('#collapseTwo');
                if ($reviewsContainer && $reviewsContainer.length) {
                    $reviewsContainer.show();
                    $reviewsContainer[0].scrollIntoView({ behavior: 'smooth' });
                }
            }, 1000);
        }

        window.bvCallback = function (BV) {
            if (typeof BV !== 'undefined') {
                BV.swat_reviews.on('show', function () {
                    // if user clicks on the ratings from the Quick View, add parameter to the URL and redirect
                    if ($('#pdpMain').hasClass('quickPDP')) {
                        var productURL = $('.USP-link').attr('href');
                        window.location = productURL + '?viewreviews=true';
                        return;
                    }

                    $('#collapseTwo').show();
                });
            }
        };
    });
};

},{}],60:[function(require,module,exports){
/* http://idangero.us/swiper/api/ lydstyl */
'use strict';
var swiper = new Swiper('.default-product-cross-sell .swiper-container', {
    speed: 400,
    paginationClickable: true,
    pagination: '.swiper-pagination',
    slidesPerView: 3,
    breakpoints: {
        768: {
            slidesPerView: 2,
        },
        425: {
            slidesPerView: 1,
        }
    }
});

},{}],61:[function(require,module,exports){
'use strict';

const constants = Object.freeze({
    SMALL_BREAKPOINT: 'small', // left here for future use
    LARGE_BREAKPOINT: 'large',
    ENGRAVABLE_BTN_SELECTOR_NAME: '.add-engraving-btn-container button'
});

/**
 * @function
 * @description - method to set the engravable product image inside the customization modal, based on the current breakpoint
 * we set the breakpoints using setBreakpoint() method
 */
function setEngravableProductImage() {
    if (!window.currentBreakpoint) return;

    const engravableProductImageEl = document.querySelector('.engravable-product-container .engravable-product-image');

    if (!engravableProductImageEl) return;

    const {
        safeParse,
        removeClassName
    } = require('../../helpers');
    const engravableProductImagesObj = engravableProductImageEl.hasAttribute('data-engravable-product-images') && safeParse(engravableProductImageEl.getAttribute('data-engravable-product-images'));

    if (!engravableProductImagesObj) return;

    const {
        engravingProductMobileImage,
        engravingProductDesktopImage
    } = engravableProductImagesObj;
    const hiddenClassName = 'invisible';

    switch (window.currentBreakpoint) {
        case constants.LARGE_BREAKPOINT:
            engravableProductImageEl.setAttribute('src', engravingProductDesktopImage);
            removeClassName(engravableProductImageEl, hiddenClassName);
            break;
        default:
            // default case is for small breakpoint
            engravableProductImageEl.setAttribute('src', engravingProductMobileImage);
            removeClassName(engravableProductImageEl, hiddenClassName);
    }
}

/**
 * @function
 * @description - method to handle all event bindings for engravable product customization
 * @param {Boolean} - isInitialInit - to be passed for initial init, for example product page => index.js
 * @
 */
function handleEngravableProductEvents(isInitialInit) {
    if (!isInitialInit) {
        $(document).on('breakpoint:set', () => setEngravableProductImage());
    }

    $(document).off('engravableProduct:updateAvailability').on('engravableProduct:updateAvailability', () => {
        // update the engravable product's button availability
        handleCustomizationButtonAvailabilityState();
    });
}

/**
 * @function
 * @description - handler for button state
 */
function handleCustomizationButtonAvailabilityState() {
    const engravableProductCustomizationBtn = document.querySelector(constants.ENGRAVABLE_BTN_SELECTOR_NAME);
    const addToCartBtn = document.querySelector('.add-to-cart');

    if (!engravableProductCustomizationBtn || !addToCartBtn) return;

    const isNormalProductAddToCartBtnDisabled = addToCartBtn.hasAttribute('disabled') && addToCartBtn.disabled;

    // if the normal product add to cart button is disabled, then disable the engravable product add to cart button as well
    // and skip the AJAX call below
    if (isNormalProductAddToCartBtnDisabled) {
        const { disableElement } = require('../../helpers');
        disableElement(engravableProductCustomizationBtn);
        return;
    }

    const targetUrl = engravableProductCustomizationBtn.hasAttribute('data-availability-url') && engravableProductCustomizationBtn.getAttribute('data-availability-url');

    // do nothing if the url is not present
    // this is the case, where it is an editVersion
    if (!targetUrl) return;

    const ajax = require('../../ajax');

    ajax.getJson({
        url: targetUrl,
        /**
         * Callback function to update the availability of the engraving add to cart button
         * @param {Object} data - The data received from the callback
         */
        callback: (data) => {
            updateEngravingCustomizationBtnAvailabilityState(engravableProductCustomizationBtn, data);
        }
    });
}

/**
* Updates the availability of the engraving add to cart button
* @param {HTMLElement} container - the container element for the add to cart button
* @param {Object} data - the data object containing the engravable product availability
*/
function updateEngravingCustomizationBtnAvailabilityState(container, data) {
    if (!container) return;

    const {
        disableElement,
        enableElement
    } = require('../../helpers');
    const { isEngravableProductAvailable } = data;

    if (isEngravableProductAvailable) {
        enableElement(container);
        return;
    }

    disableElement(container);
}

/**
 * @function
 * @description - method to initialize functionality for engravable product customization
 */
function initEngravableProductCustomization() {
    setEngravableProductImage();
    handleEngravableProductEvents();
}

/**
 * @function
 * @description - method to check if engravable product customization button is present on the page
 * @returns {Boolean}
 */
function hasEngravableProductCustomizationBtn() {
    return document.querySelector(`${constants.ENGRAVABLE_BTN_SELECTOR_NAME}`) !== null;
}

exports.initEngravableProductCustomization = initEngravableProductCustomization;
exports.handleEngravableProductEvents = handleEngravableProductEvents;
exports.hasEngravableProductCustomizationBtn = hasEngravableProductCustomizationBtn;

},{"../../ajax":3,"../../helpers":31}],62:[function(require,module,exports){
"use strict";
var dialog = require("../../dialog");
var util = require("../../util");
var qs = require("qs");
var url = require("url");
var _ = require("lodash");
var mobileWidth = 543;
var screenWidth = $(window).width();

var zoomMediaQuery = matchMedia("(min-width: 960px)");

/**
 * @description Enables the zoom viewer on the product detail page
 * @param zmq {Media Query List}
 */
function loadZoom(zmq) {
    var $imgZoom = $("#pdpMain .main-image").toArray();
    var hiresUrl;
    if (dialog.isActive()) {
        $imgZoom = $(".quickPDP .main-image").toArray();
    }
    for (var i = 0; i < $imgZoom.length; i++) {
        if ($($imgZoom[i]).hasClass("eu-garan-viewer") || $($imgZoom[i]).closest(".product-image-container").find(".eu-garan-thumbnail.selected").length) {
            $($imgZoom[i]).trigger("zoom.destroy");
            continue;
        }
        if (!zmq) {
            zmq = zoomMediaQuery;
        }
        if ($imgZoom.length === 0 || util.isMobile() || !zoomMediaQuery.matches) {
            // remove zoom
            $($imgZoom[i]).trigger("zoom.destroy");
            return;
        }
        hiresUrl = $imgZoom[i].getAttribute("href");

        if (hiresUrl &&hiresUrl !== "null" && hiresUrl.indexOf("noimagelarge") === -1 && zoomMediaQuery.matches) {
            $($imgZoom[i]).zoom({
                url: hiresUrl,
            });
        }
    }
}

zoomMediaQuery.addListener(loadZoom);

/**
 * @description Sets the main image attributes and the href for the surrounding <a> tag
 * @param {Object} atts Object with url, alt, title and hires properties
 */
function setMainImage(atts) {
    var isEuGaran = $(".quickPDP .eu-garan-thumbnail.selected").length > 0;
    $(".quickPDP .primary-image").toggleClass("eu-garan-primary", isEuGaran);
    $(".quickPDP .main-image").toggleClass("eu-garan-primary-viewer", isEuGaran);
    $(".quickPDP .primary-image").attr({
        src: atts.url,
        alt: atts.alt,
        title: atts.title,
    });
    updatePinButton(atts.url);
    if (dialog.isActive() && !util.isMobile()) {
        if (atts.url != "") {
            $(".quickPDP .main-image").attr("href", atts.url);
        }
        document.getElementsByClassName("product-image main-image")[0].addEventListener("click", function (event) {
                event.preventDefault();
            });
        loadZoom();
    }

}

function updatePinButton(imageUrl) {
    var pinButton = document.querySelector(".share-icon[data-share=pinterest]");
    if (!pinButton) {
        return;
    }
    var newUrl = imageUrl;
    if (!imageUrl) {
        newUrl = document
            .querySelector("#pdpMain .primary-image")
            .getAttribute("src");
    }
    var href = url.parse(pinButton.href);
    var query = qs.parse(href.query);
    query.media = url.resolve(window.location.href, newUrl);
    query.url = window.location.href;
    var newHref = url.format(
        _.extend({}, href, {
            query: query, // query is only used if search is absent
            search: qs.stringify(query),
        })
    );
    pinButton.href = newHref;
}

/**
 * @description Replaces the images in the image container, for eg. when a different color was clicked.
 */
function replaceImages() {
    var $newImages = $("#update-images"),
        $imageContainer = $("#pdpMain .product-image-container");
    if ($newImages.length === 0) {
        return;
    }

    $imageContainer.html($newImages.html());
    $newImages.remove();
    loadZoom();
}

/* @module image
 * @description this module handles the primary image viewer on PDP
 **/

function swiperImages() {
    var swiperImg = require("swiper");
    var swiperImg = new Swiper("#product-primary-image-slider", {
        slidesPerView: 1,
        pagination: ".swiper-pagination",
        paginationClickable: true,
        onInit: function (swiper) {
            var index_currentSlide = swiper.realIndex;
            var currentSlide = swiper.slides[index_currentSlide];

            if ($(currentSlide).hasClass("video-slider")) {
                var iframe = $(currentSlide).find("iframe");
                var player = new Vimeo.Player(iframe);
                player.play();
                resizeplayer(player);
            }
        },
        onSlideChangeEnd: function (swiper) {
            var index_currentSlide = swiper.realIndex;
            var currentSlide = swiper.slides[index_currentSlide];
            var containerSwiper = swiper.container[0];
            var videoSlide = $(containerSwiper).find("iframe");

            if (videoSlide.length) {
                var lastSlideIndex = swiper.slides.length - 2;
                var lastSlide = swiper.slides[lastSlideIndex];
                var isLastVideoSlide = $(lastSlide).hasClass("video-slider");
                var isFirstVideoSlide
                if (swiper.slides.length < 3 && $('#product-primary-image-slider .swiper-wrapper').find('.swiper-slide').first().data('video-position') == 1) {
                    isFirstVideoSlide = $('#product-primary-image-slider .swiper-wrapper').find('.swiper-slide').first().hasClass('video-slider');
                } else {
                    isFirstVideoSlide = false;
                }
                var player = new Vimeo.Player(videoSlide);
                if ($(currentSlide).hasClass("video-slider") && !isLastVideoSlide) {
                    player.play();
                } else if ((isLastVideoSlide && !isFirstVideoSlide) && lastSlideIndex == swiper.realIndex - 1 ) {
                    player.play();
                } else if (isFirstVideoSlide && lastSlideIndex == swiper.realIndex) {
                    player.play();
                } else {
                    player.pause();
                }
                resizeplayer(player);

                if ($('.product-video').length) {
                    var video = new Vimeo.Player($('.product-video iframe'))
                    resizeplayer(video);
                }
            }
        },
    });
    if ($("#product-primary-image-slider .swiper-slide").length === 1) {
        $("#product-primary-image-slider .swiper-pagination").hide();
    }
}

$(document).on("click", ".video-slider", function () {
    var iframe = $(this).find("iframe");
    var player = new Vimeo.Player(iframe);

    player.getPaused().then(function (paused) {
        if (paused) {
            player.play();
        } else {
            player.pause();
        }
    });
});

function resizeplayer(player) {
    $(window).on('resize', util.throttle(function () {
        player.getPaused().then(function (paused) {
            if (!paused) {
                player.pause();
            }
        });
    }, 500));
}

function swiperThumbnails() {
    var perView = 4;
    if (window.document.documentElement.clientWidth < 1366) perView = 3;
    var swiperThumb = require("swiper");
    var swiperThumb = new Swiper("#thumbnails", {
        slidesPerView: perView,
        slidesPerGroup: perView,
        spaceBetween: 15,
        nextButton: "#thumbnails-button-next",
        prevButton: "#thumbnails-button-prev",
        paginationClickable: true,
    });
}

function videoProduct() {
    var videoIDElem = [...document.querySelectorAll(".product-video")].map(
        (elem) => createPlayer(elem.dataset.vimeoId)
    );
    function createPlayer(elementId) {
        var elementID = "video-player-" + elementId;
        var options = {
            id: elementId,
            width: "100%",
            height: "100%",
            loop: false,
            responsive: false,
            controls: true,
            muted: true
        };
        var player = new Vimeo.Player(elementID, options);
        player.play();
        resizeplayer(player);
    }
}

function imageModal() {
    $(document).on("click",".main-image", function (e) {
        e.preventDefault();
        var imgUrl = $(this).attr("href");
        var imgAlt = $(this).find("img").attr("alt");
        $("#dialog-container").dialog("destroy").remove();
        var $dialog = $('<div id="dialog-container" class="dialog-content ui-dialog-content ui-widget-content product-image-zoom" ><img class="m-auto d-flex" src="' + imgUrl + '"  alt="' + imgAlt + '" /></div>');
        if ($(this).next(".product-video").length) {
            var imgUrl = $(this).data("video-href");
            var videoHeight = 960;
            $dialog = $('<div id="dialog-container" class="dialog-content ui-dialog-content ui-widget-content product-image-zoom mt-5" ><iframe src="' + imgUrl + '" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" data-vimeo-autoplay="true" allowfullscreen="" style="width:100%;height:100%;" title="Vanishing Point" data-ready="true"></iframe></div>');
        }
        $dialog.dialog({
            autoOpen: false,
            resizeable: false,
            modal: true,
            width: 960,
            height: videoHeight,
            closeOnEscape: true,
            dialogClass: "zoom modal-custom-position",
            close: function () {
                $(this).dialog("destroy");
            },
            open: function () {
                $('.ui-widget-overlay').bind('click',function(){
                    $('.zoom .ui-dialog-titlebar-close').trigger('click');
                })
            }.bind(this)
        });
        $dialog.dialog("open");
    });

}

function swiperVideos() {
    if ($("#product-main-video-slider .swiper-slide").length > 1) {
        var swiper = require("swiper");
        var swiper = new Swiper("#product-main-video-slider", {
            slidesPerView: 2,
            spaceBetween: 24,
            paginationClickable: true,
            pagination: ".swiper-pagination",
            nextButton: ".swiper-button-next",
            prevButton: ".swiper-button-prev",
            breakpoints: {
                768: {
                    slidesPerView: 1,
                    pagination: false,
                },
            },
        });
    } else {
        $(".video-block").addClass("single-video");
        $("#product-main-video-slider").addClass("one-slide");
        $("#product-main-video-slider .swiper-button-prev").addClass("d-none");
        $("#product-main-video-slider .swiper-button-next").addClass("d-none");
    }

    if ($("#product-main-video-slider .swiper-slide").length && $("#product-main-video-slider .swiper-slide").length < 3 && screenWidth > mobileWidth && swiper != undefined) {
        $("#product-main-video-slider .swiper-pagination").addClass("d-none");
        swiper.destroy();
    }

    if ($("#product-main-video-slider .swiper-slide").length === 1 && swiper != undefined) {
        swiper.destroy();
    }

    var videoIDElem = [...document.querySelectorAll(".product-video-slider"),].map((elem) => createPlayer(elem.dataset.vimeoId));
    function createPlayer(elementId) {
        if (elementId) {
            var elementID = "video-player-" + elementId;
            var options = {
                id: elementId,
                width: "100%",
                height: "100%",
                loop: true,
                responsive: true,
                controls: true,
            };
            var player = new Vimeo.Player(elementID, options);
            player.getVideoTitle().then(function (title) {
                $("#" + elementID).closest(".product-video-slider").append('<div class="videoTitle">' + title + "</div>");
                player.setVolume(0.7);
            });
        }
    }
}

/**
* Initializes thumbnail images by setting their 'alt' attribute to match the 'alt' attribute
* of the element with the class 'primary-image'. This enhances accessibility by ensuring
* all zoomable images have descriptive alternative text.
*
* @function thumbsInit
* @returns {void}
*/
function thumbsInit() {
	$('.zoomImg').each(function() {
		$(this).attr('alt', $('.primary-image').attr('alt'));
	});
};

/**
 * @description by default, this function sets up zoom and event handler for thumbnail click
 **/
module.exports = function () {
    $(window).on('load', function() {
        thumbsInit();
    });

    if (dialog.isActive()) {
        var perView = 4;
        if (window.document.documentElement.clientWidth < 1025) perView = 4;
        if (window.document.documentElement.clientWidth > 768 && $("#thumbnails .swiper-wrapper .thumb").length > perView) {
            $("#thumbnails, #thumbnails-button-next, #thumbnails-button-prev").addClass("swiper-active");
            swiperThumbnails();
            $(window).resize(function () {
                if ($(window).width() > 800 || $(window).width() < 1400) {
                    location.reload();
                }
            });
        }

        if (window.document.documentElement.clientWidth > 768 && $("#thumbnails .swiper-wrapper .thumb").length == perView) {
            $('.thumbnails-wrapper > #thumbnails').find('.swiper-wrapper').addClass('justify-content-start');
        }
        // handle product thumbnail click event
        $(document).on("click", ".productthumbnail", function () {
            $(this).closest(".product-thumbnails").find(".thumb.selected").removeClass("selected");
            $(this).closest(".thumb").addClass("selected");

            setMainImage($(this).data("lgimg"));
        });
    } else {
        if (screenWidth > mobileWidth) {
            videoProduct();
        } else {
            swiperImages();
        }
        swiperVideos();
    }
    imageModal()
    updatePinButton();
    loadZoom();
};

module.exports.loadZoom = loadZoom;
module.exports.setMainImage = setMainImage;
module.exports.replaceImages = replaceImages;
module.exports.swiperImages = swiperImages;
module.exports.swiperThumbnails = swiperThumbnails;

},{"../../dialog":14,"../../util":104,"lodash":125,"qs":137,"swiper":145,"url":146}],63:[function(require,module,exports){
'use strict';

const dialog = require('../../dialog'),
    productStoreInventory = require('../../storeinventory/product'),
    tooltip = require('../../tooltip'),
    util = require('../../util'),
    addToCart = require('./addToCart'),
    availability = require('./availability'),
    image = require('./image'),
    productNav = require('./productNav'),
    productSet = require('./productSet'),
    variant = require('./variant'),
    storelocator = require('../storelocator'),
    TPromise = require('promise'),
    klarnaSliceIt = require('../../klarnasliceit'),
    productCustomization = require('./productCustomization'),
    quantity = require('./quantity'),
    bazaarvoice = require('./bazaarvoice');

const {
    handleEngravableProductEvents,
    hasEngravableProductCustomizationBtn
} = require('./engravableProductCustomization');

/**
 * @description Initialize product detail page with reviews, recommendation and product navigation.
 */
function initializeDom() {
    productNav();
    tooltip.init();
    if ($('.tab-content').length == 1) {
        $('.tab-content').addClass('active');
    }
}

/**
 * @description Initialize event handlers on product detail page
 */
function initializeEvents() {
    var $pdpMain = $('#pdpMain');
    addToCart();
    availability();
    variant();
    image();
    productSet();
    klarnaSliceIt.init();
    storelocator.init();
    bazaarvoice();
    if (window.SitePreferences.STORE_PICKUP) {
        productStoreInventory.init();
    }

    // Add to Wishlist and Add to Gift Registry links behaviors
    $pdpMain.on('click', '[data-action="wishlist"], [data-action="gift-registry"]', function () {
        var data = util.getQueryStringParams($('.pdpForm').serialize());

        if (data.cartAction) {
            delete data.cartAction;
        }

        var url = util.appendParamsToUrl(this.href, data);
        this.setAttribute('href', url);
    });

    // product options
    $pdpMain.on('change', '.product-options select', function () {
        var salesPrice = $pdpMain.find('.product-add-to-cart .price-sales');
        var selectedItem = $(this).children().filter(':selected').first();
        salesPrice.text(selectedItem.data('combined'));
    });

    // prevent default behavior of thumbnail link and add this Button
    $pdpMain.on('click', '.thumbnail-link, .unselectable a', function (e) {
        e.preventDefault();
    });

    $('.size-chart-link a').on('click', function (e) {
        e.preventDefault();
        dialog.open({
            url: $(e.target).attr('href')
        });
    });

    $(document).on('click', '#submit-notification', function(e) {
        e.preventDefault();
        var jqt = $(this);
        var input = jqt.parent().find('#notify-email');
        var email = input.val();

        $('.notify-submit-fields .notify-submit-error').addClass('d-none');

        if (email === '') {
            input.addClass('error');
            $('.enter-email').removeClass('d-none');
            return false;
        }
        if (!/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email)) {
            if (this.checkValidity) {
                this.checkValidity();
            }

            input.addClass('error');
            $('.novalid-email').removeClass('d-none');

            return false;
        }
        var product = jqt.parent().find('#product').val();
        TPromise.resolve($.ajax({
            type: 'POST',
            url: jqt.data('action'),
            data: {
                email: email,
                product: product
            }
        })).then(function() {
            $('.notify-submit-fields').hide();
            $('.notify-response').show();
        }, function() {
            alert('Unable to add you to the notification list.');
        });
    });
    // initialize QTY input events
    quantity.init();
}

/**
 * @description Initialize Product Reviews
 */
function initializeProductReviews() {
    $(document).on('submit', '#write-review-form', function (e) {
        e.preventDefault();
        var responseElement = $('p#dwfrm-product-review-response');
        var dwfrm_productreview = $('#write-review-form');

        if (!dwfrm_productreview.valid()) {
            return false;
        }

        if (!isValidEmailAddress(dwfrm_productreview.find('input#dwfrm_productreview_email').val())) {
            responseElement = $(dwfrm_productreview).parent('div');
        }

        var data = dwfrm_productreview.serialize();
        // add form action to data
        data += '&' + dwfrm_productreview.attr('name') + '=';
        // make sure the server knows this is an ajax request
        data += '&format=ajax&dwfrm_productreview_send=Envoyer';

        $.ajax({
            type: 'POST',
            url: dwfrm_productreview.attr('action'),
            data: data,
            success: function (response) {
                $(dwfrm_productreview).remove();
                $(responseElement).html(response);
                dialog.$container.html(responseElement);
                return false;
            },
            failure: function () {
                return false;
            }
        });
        return false;
    });
}

/**
 * @description Validate Email Address
 * @param {*} emailAddress
 * @returns Boolean
 */
function isValidEmailAddress(emailAddress) {
    var pattern = /^([a-z\d!#$%&'*+\-/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i; // eslint-disable-line no-control-regex
    return pattern.test(emailAddress);
}

/**
 * @description Initialize Double Button event
 */
function initDoubleButton() {
    $('#hatchLink, #hatchBlue').on('click', function(event) {
        event.preventDefault();
        if ($('.hatchLink').length == 2) { // 2 products with hatch link on the same page
            showHatch($(this).parents('.product-gamme-item').data('pid')); // eslint-disable-line no-undef
        } else {
            if ($('div.product-gamme-item').length > 1) {
                showHatch($(this).parents('.product-gamme-item').data('pid')); // eslint-disable-line no-undef
                return;
            }

            showHatch(); // eslint-disable-line no-undef
        }
    });
}

/**
 * @description Show Reviews Modal
 */
function showReviewDialog() {
    if (window.location.href.indexOf('sc_wr=') >= 0) {
        var pid = $('.product-number span').data('masterid');

        var influencer = '';
        if (window.location.href.indexOf('influencer=') >= 0) {
            influencer = '&influencer=true';
        }

        dialog.open({
            url: window.Urls.writereview + '?pid=' + pid + influencer,
            options: {
                dialogClass: 'review-modal',
                width: 700,
                height: 'auto',
                draggable: false
            }
        });
    }
}

/**
 * @description Document ready event to show sellable online section when the sellable online flag is there
 */
function showSellableOnline() {
    if ($('#hdnSellableOnline').val() === 'true') {
        $('.js-sellableonline-section').show();
        $('.js-notsellableonline-section').hide();
    } else {
        $('.js-sellableonline-section').hide();
        $('.js-notsellableonline-section').show();
    }
}

$('.dropdown-button').on('keydown', function(event) {
    if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        $(this).click();
    }
});

var product = {
    initializeEvents,
    init: function () {
        initializeDom();
        initializeEvents();
        initializeProductReviews();
        initDoubleButton();
        showReviewDialog();
        productCustomization.init();
        showSellableOnline();

        if (hasEngravableProductCustomizationBtn()) {
            handleEngravableProductEvents(true);
        }
    },
    showSellableOnline
};

module.exports = product;

},{"../../dialog":14,"../../klarnasliceit":33,"../../storeinventory/product":98,"../../tooltip":103,"../../util":104,"../storelocator":80,"./addToCart":57,"./availability":58,"./bazaarvoice":59,"./engravableProductCustomization":61,"./image":62,"./productCustomization":65,"./productNav":66,"./productSet":67,"./quantity":69,"./variant":71,"promise":128}],64:[function(require,module,exports){
/* http://idangero.us/swiper/api/ lydstyl */
'use strict';
var swiper = new Swiper('.nl-product-cross-sell .swiper-container', {
    speed: 400,
    spaceBetween: 100,
    paginationClickable: true,
    pagination: '.swiper-pagination',
    slidesPerView: 3,
    breakpoints: {
        768: {
            slidesPerView: 2,
        },
        425: {
            slidesPerView: 1,
        }
    }
});
},{}],65:[function(require,module,exports){
'use strict';

const { forEach } = require('lodash');
const ENGRAVING_DEFAULT_SIZE_VALUE = '4';
var dialog = require('../../dialog'),
    availability = require('./availability'),
    util = require('../../util'),
    validator = require('../../validator'),
    quantity = require('./quantity');

var { initEngravableProductCustomization } = require('./engravableProductCustomization');
var { safeParse } = require('../../helpers');

var productCustomization = {
    initializeEvents: function () {
        var $pdpMain = $('#pdpMain');

        // initialize the customization modal
        $pdpMain.on('click', '.pdp-customize-modal-button-wrapper', (e) => {
            e.preventDefault();
            this.showCustomizationModal();
        });

        if (window.location.href.indexOf('editVersion=') > -1) {
            this.showCustomizationModal();
        }
    },

    showCustomizationModal: function () {
        var url = $('.product-detail').find('.pdp-customize-modal-button-wrapper').attr('data-href');
        var closeModaltriggered = false;

        dialog.open({
            target: '#product-customization-modal',
            url: url,
            options: {
                dialogClass: 'product-customization-modal',
                height: $(window).height(),
                width: $(window).width(),
                draggable: 'false',
                open: function () {
                    // in order to use validation on customization modal
                    validator.init();
                    // we check if product's customization modal is for engravable product
                    const engravableProductCustomizationContainer = this.querySelector(':scope .engravable-product-container');

                    // if engravable product customization container, init additional functionality
                    if (engravableProductCustomizationContainer) {
                        initEngravableProductCustomization();
                    }

                    if ($('#hdnSellableOnline').val() === 'true') {
                        $('.js-sellableonline-section').show();
                        $('.js-notsellableonline-section').hide();
                    } else {
                        $('.js-sellableonline-section').hide();
                        $('.js-notsellableonline-section').show();
                    }
                }
            }
        });

        if ($('.product-customization-modal')) {
            $('#product-customization-modal').dialog({
                beforeClose: function () {
                    if (!window.Alpine.store('app').allStepsCompleted && $('.carousel-container .step-completed').length && !closeModaltriggered) {
                        let $dialog = $('#reset-app');
                        $dialog.dialog({
                            autoOpen: false,
                            resizeable: false,
                            modal: true,
                            width: 716,
                            height: 'auto',
                            closeOnEscape: true,
                            dialogClass: 'reset-app-modal',
                            close: function () {
                                $(this).dialog('destroy');
                            },
                            closeText: window.Resources.CLOSE,
                            open: function () { }
                        });

                        $dialog.dialog('open');

                        $(document).on('click', '.js-no-clear', function () {
                            $('.reset-app-modal .ui-dialog-titlebar-close').trigger('click');
                        });

                        $(document).on('click', '.js-clear', function () {
                            if (window.location.href.indexOf('editVersion=') > -1) {
                                window.location.href = util.removeParamFromURL(window.location.href, 'editVersion');
                            } else {
                                closeModaltriggered = true;
                                $('.ui-dialog-content').dialog('close');
                                window.Alpine.store('app').bodyOverflow = false;
                                $('.reset-app-modal .ui-dialog-titlebar-close').trigger('click');
                            }
                        });

                        return false;
                    }
                },
                close: function () {
                    window.Alpine.store('app').bodyOverflow = false;
                    window.Alpine.store('app').clearAllSteps();
                }
            });
        }
    },

    initAlpine: () => {
        document.addEventListener('alpine:init', () => {
            window.Alpine.store('app', {
                init() {
                    let defaultStepMsg = document.querySelectorAll('[data-defaultmsg]');
                    let stepElements = document.querySelectorAll('[data-stepname]');
                    let $this = this;
                    this.isEngravableProduct = document.querySelector('.engravable-product-container') !== null;

                    // initialize swiper only for full custom fx products
                    if (!this.isEngravableProduct) {
                        this.swiper = new window.Swiper('.my-swiper', {
                            loop: false,
                            slidesPerView: 1,
                            spaceBetween: 0,
                            noSwiping: true,
                            touchRatio: 0,
                            allowTouchMove: false,
                            noSwipingClass: 'swiper-slide',
                            onSlideChangeStart: function (swiper) {
                                setTimeout(() => {
                                    if ($this.isSlideChanged) {
                                        // execute below logic if slider has been initialized once
                                        $this.isSlideChanged = false;
                                        $this.activeIndex = swiper.activeIndex;
                                        $this.triggerIncompleteStepsMsg = null;
                                        $this.showClearLabelIfStepsCompleted();
                                        $this.checkIfSummary();

                                        if ($this.isEngravingCustomizationStep()) {
                                            setTimeout(() => {
                                                $this.engravingStart();
                                            }, 500);
                                        }
                                    }
                                });

                                // fix to always clear the state as sometimes this remains false because onSlideChangeEnd is not always triggered
                                setTimeout(() => {
                                    if (!$this.isSlideChanged) {
                                        $this.isSlideChanged = true;
                                    }
                                }, 500);
                            },
                            onSlideChangeEnd: function () {
                                // we assign true, after the start method logic has been executed and set variable to false
                                // in order to run the logic on next init
                                $this.isSlideChanged = true;
                            }
                        });
                    }

                    this.createObjectBasedOnSteps();

                    forEach(this.steps.stepdata, (step, index) => {
                        step.selectedOptionName = defaultStepMsg ? defaultStepMsg[index].dataset.defaultmsg : '';
                        step.stepName = stepElements[index].dataset.stepname;
                        step.alternateColorProducts = stepElements[index].dataset.alternateColorProducts ? stepElements[index].dataset.alternateColorProducts.split(',') : '';
                    });

                    this.selected = 1;

                    const grabbedData = document.querySelector('.product-customization-container').dataset.option;
                    var grabbedStepData = grabbedData ? JSON.parse(grabbedData) : null;

                    if (grabbedStepData) {
                        this.showClearLabel = true;
                        for (let grabbedStepDataItem in grabbedStepData) {
                            let getSelectedOptionName = document.querySelectorAll("[data-pid='" + grabbedStepData[grabbedStepDataItem] + "']")[0];
                            this.steps.stepdata[grabbedStepDataItem].completed = true;
                            this.steps.stepdata[grabbedStepDataItem].selectedOption = grabbedStepData[grabbedStepDataItem];
                            this.steps.stepdata[grabbedStepDataItem].selectedOptionName = getSelectedOptionName.dataset.name;
                            this.steps.stepdata[grabbedStepDataItem].selectedOptionColor = getSelectedOptionName.dataset.color;
                        }
                    }

                    $('body').off('click', '.product-customization-container .add-to-cart').on('click', '.product-customization-container .add-to-cart', function (event) {
                        event.preventDefault();
                        $this.checkIfAllStepsCompleted();
                    });

                    $('.engraving-atb-button').off('click').on('click', function (event) {
                        event.preventDefault();
                        $this.engravingFinishForEngravableOnlyProducts(event);
                    });

                    $('.engraving-size-wrapper .quantity-button-custom').off('click').on('click', function (event) {
                        event.preventDefault();
                        $this.sizeSelect(event);
                    });

                    $('.customization-main-title').off('click').on('click', () => {
                        this.toggleMainSection();
                    });

                    let isEngravingInEditVersion = $('.product-customization-container').attr('data-engraving') === 'true';
                    const isEditVersion = window.location.href.indexOf('editVersion=') > -1;

                    $('.engraving-yes').off('click').on('click', function (e) {
                        e.preventDefault();

                        // update this check as it might be wiped as part of the clear all method
                        isEngravingInEditVersion = $('.product-customization-container').attr('data-engraving') === 'true';

                        if (!isEditVersion || (isEditVersion && !isEngravingInEditVersion)) {
                            // show engraving customization container
                            $this.engraving = true;
                        }
                    });

                    if (!isEditVersion || (isEditVersion && !isEngravingInEditVersion)) {
                        // do nothing
                    } else {
                        for (let item in this.steps.stepdata) {
                            const optionItem = this.steps.stepdata[item];

                            if (optionItem.stepName === 'Engraving') {
                                const selectedEngravingOptionsObj = document.querySelector('.product-customization-container').dataset.engravingoptions ?
                                    JSON.parse(document.querySelector('.product-customization-container').dataset.engravingoptions) : null;

                                // engraving on edit version pre-fill summary fields with selected engraving data
                                optionItem.completed = true;
                                optionItem.engraving = true;
                                optionItem.size = selectedEngravingOptionsObj.Size;
                                optionItem.font = selectedEngravingOptionsObj.Font;
                                optionItem.text = selectedEngravingOptionsObj.Text;
                                optionItem.selectedOptionName = `${selectedEngravingOptionsObj.Text} ${window.Resources.ENGRAVING_FONT} - ${selectedEngravingOptionsObj.Font} / ${window.Resources.ENGRAVING_SIZE} - ${selectedEngravingOptionsObj.Size}`;
                                optionItem.selectedOption = optionItem.stepName;
                                break;
                            }
                        }

                        this.engravingComplete = true;
                    }

                    setTimeout(function () {
                        // trigger engraving font button in order to set the font data
                        $('.engraving-fonts-section .button-size.active').trigger('initFontSelection', true);
                    }, 500);

                    $('.engraving-fonts-section .button-size.active').off('initFontSelection').on('initFontSelection', function (event, isInitFontSelection) {
                        $this.fontSelect(event, isInitFontSelection);
                    });

                    $(document).off('font:loaded').on('font:loaded', () => $this.engravingStart());

                    $('.item-options[data-stepname="Engraving"]').off('click').on('click', () => {
                        this.enableSizeSelector();
                    });

                    // the below is needed to cover special case,
                    // where the qty events are not triggered in the modal
                    quantity.init();

                    // do not execute below logic for engravableProduct modal, where we do not set the swiper
                    // check line 120
                    if (this.isEngravableProduct) return;

                    // fix implemented for turning portrait to landscape on mobile devices to resize swiper
                    $(window).off('resize.customFX').on('resize.customFX', () => {
                        if (this.swiper) {
                            $('.swiper-container .slide-margin-controller').css('opacity', '0');

                            setTimeout(() => {
                                this.swiper.update();

                                if (this.activeIndex === 0) {
                                    this.swiper.slideNext(0, false);
                                    this.swiper.slidePrev(0, false);
                                } else {
                                    this.swiper.slidePrev(0, false);
                                    this.swiper.slideNext(0, false);
                                }

                                $('.swiper-container .slide-margin-controller').css('opacity', '1');
                            }, 300);
                        }
                    });
                },

                flex: 1,
                swiper: null,
                isSlideChanged: true,
                activeIndex: 0,
                selected: null,
                tabOpened: false,
                triggerIncompleteStepsMsg: null,
                showClearLabel: false,
                showSummary: false,
                allStepsCompleted: false,
                bodyOverflow: true,
                // engraving options
                engraving: document.querySelector('.product-customization-container').dataset.engraving === 'true',
                engravingTextError: false,
                engravingCheckboxError: false,
                engravingComplete: false,
                engravingTextInput: '',
                fontOptionsData: {},
                steps: {
                    stepdata: [],

                    getStepSelectField(e) {
                        // index of item to push data in stepdata object to
                        const optionIndex = e.currentTarget.dataset.step - 1;

                        // engraving
                        if (e.target.classList.contains('engraving-confirm-button')) {
                            const text = document.getElementById('engraving-area').value;
                            const font = document.querySelector('.button-size.active').textContent;
                            const size = document.querySelector('.input-engraving-size').value;

                            this.stepdata[optionIndex].completed = true;
                            this.stepdata[optionIndex].engraving = true;
                            this.stepdata[optionIndex].size = size;
                            this.stepdata[optionIndex].font = font;
                            this.stepdata[optionIndex].text = text;
                            this.stepdata[optionIndex].selectedOptionName = `${text} ${window.Resources.ENGRAVING_FONT} - ${font} / ${window.Resources.ENGRAVING_SIZE} - ${size}`;
                            this.stepdata[optionIndex].selectedOption = 'Engraving';
                        } else {
                            this.stepdata[optionIndex].completed = true;
                            this.stepdata[optionIndex].selectedOption = e.currentTarget.dataset.pid;
                            this.stepdata[optionIndex].selectedOptionName = e.currentTarget.dataset.name;
                            this.stepdata[optionIndex].selectedOptionColor = e.currentTarget.dataset.color;
                        }
                    },

                    getProductDetailModal(e) {
                        dialog.open({
                            target: '#details-product-dialog',
                            url: e.currentTarget.dataset.aid,
                            options: {
                                dialogClass: `${e.target.className === 'engraving-link' ? 'engraving-dialog' : 'details-product-dialog'}`,
                                width: e.target.className === 'engraving-link' ? 716 : 795
                            }
                        });
                    }

                },
                /**
                 * This function removes the validation error message for engraving text area input
                 * @returns {undefined}
                 */
                showEngravingCustomError() {
                    const $engravingTextAreaInputContainer = $('.engraving-textarea-section .engraving-area');

                    // remove other validation error message if present
                    if ($engravingTextAreaInputContainer.hasClass('error')) {
                        $engravingTextAreaInputContainer.siblings('span.error').text('');
                    }
                },
                enableSizeSelector() {
                    const $disabledSizeSelector = $('.engraving-size-wrapper input.input-engraving-size').siblings('.disabled');
                    const $sizeInput = $('.engraving-size-wrapper input.input-engraving-size');
                    // enable size increase disabled button if present
                    if ($disabledSizeSelector.length) {
                        $disabledSizeSelector.removeClass('disabled');
                    }

                    // set disable button if input value equals to min or max
                    if (+$sizeInput.val() <= +$sizeInput.attr('min')) {
                        $sizeInput.siblings('.fa-minus-square-o').addClass('disabled');
                    } else if (+$sizeInput.val() >= +$sizeInput.attr('max')) {
                        $sizeInput.siblings('.fa-plus-square-o').addClass('disabled');
                    }
                },
                fontSelect(e, isInitFontSelection) {
                    const $sizeInput = $('.engraving-size-wrapper input.input-engraving-size');
                    const selectedFontBtn = e.currentTarget;
                    const editVersionEngravingData = document.querySelector('.input-engraving-size').dataset.editversiondata ? JSON.parse(document.querySelector('.input-engraving-size').dataset.editversiondata) : null;

                    // remove active class button by default
                    for (const button of document.querySelectorAll('.button-size')) {
                        button.classList.remove('active');
                    }

                    // assign active class on font select
                    selectedFontBtn.classList.add('active');

                    // set font data from map
                    this.fontOptionsData = JSON.parse(selectedFontBtn.dataset.options);

                    // order is not guaranteed in JSON objects, therefore we turn it into array and sort it
                    const sizePixelMappingArr = Object.keys(this.fontOptionsData.sizePixelMapping).sort((elem1, elem2) => elem1 - elem2);
                    // set default size of 4 if existing in map
                    const defaultValInMap = sizePixelMappingArr.filter(item => item === ENGRAVING_DEFAULT_SIZE_VALUE);

                    // assign min and max for size input
                    $sizeInput.attr('min', sizePixelMappingArr[0]);
                    $sizeInput.attr('max', sizePixelMappingArr[sizePixelMappingArr.length - 1]);

                    // the default method will be set on the min value
                    let defaultInputVal = $sizeInput.attr('min');

                    if (defaultValInMap.length) {
                        // assign default size value of 4, if present in map
                        defaultInputVal = defaultValInMap[0];
                        // edit version size logic
                        if (editVersionEngravingData && editVersionEngravingData.Font === this.fontOptionsData.font) {
                            defaultInputVal = editVersionEngravingData.Size;
                        }
                    } else {
                        // if no default setting in map we disable the decrease button
                        $sizeInput.siblings('.fa-minus-square-o').addClass('disabled');
                    }

                    // set size input value on initial init or if value is smaller than min or bigger than max
                    if (isInitFontSelection || ($sizeInput.val() < parseInt($sizeInput.attr('min')) || $sizeInput.val() > parseInt($sizeInput.attr('max')))) {
                        $sizeInput.val(defaultInputVal);
                    }

                    this.enableSizeSelector();

                    if (isInitFontSelection) return;

                    this.engravingStart();
                },
                sizeSelect(e) {
                    const $sizeSelector = $(e.target);
                    const $sizeField = $sizeSelector.siblings('input.input-engraving-size');
                    let sizeVal = parseInt($sizeField.val());

                    if ($sizeSelector.length && !$sizeSelector.hasClass('disabled')) {
                        if ($sizeSelector.hasClass('fa-minus-square-o')) {
                            sizeVal -= 1;
                            // remove disabled class on increase size button
                            $sizeSelector.siblings('.fa-plus-square-o').removeClass('disabled');
                        } else {
                            sizeVal += 1;
                            // remove disabled class on decrease size button
                            $sizeSelector.siblings('.fa-minus-square-o').removeClass('disabled');
                        }

                        if (sizeVal < parseInt($sizeField.attr('min')) || sizeVal > parseInt($sizeField.attr('max'))) {
                            // disable sizeSelector if value smaller or bigger than min or max is reached
                            $sizeSelector.addClass('disabled');
                        } else if (sizeVal === parseInt($sizeField.attr('min')) || sizeVal === parseInt($sizeField.attr('max'))) {
                            // set size value and disable sizeSelector if value equals to min or max
                            $sizeField.val(sizeVal);
                            $sizeSelector.addClass('disabled');
                        } else {
                            // set size value
                            $sizeField.val(sizeVal);
                        }
                    }

                    this.engravingStart();
                },
                toggleMainSection() {
                    this.tabOpened = !this.tabOpened;
                },
                /**
                 * @function
                 * @description - method to initialize the engraving canvas functionality
                 */
                engravingStart() {
                    if (!this.fontOptionsData) return;

                    this.engravingTextError = false;

                    const engravingImgFrame = $('.engraving-frame');
                    const text = document.getElementById('engraving-area').value;
                    const $inputSize = $('.engraving-size-wrapper input.input-engraving-size');
                    const inputSizeVal = $inputSize.val();

                    // engraving options
                    const {
                        defaultColor,
                        alternateColor,
                        sizePixelMapping,
                        fontid
                    } = this.fontOptionsData;

                    const canvas = engravingImgFrame[0];
                    const context = canvas.getContext('2d');

                    // if engravable product, then set canvas width and height as it runs with absolute numbers.
                    if (this.isEngravableProduct) {
                        canvas.width = engravingImgFrame.width();
                        canvas.height = engravingImgFrame.height();
                    }

                    const x = canvas.width / 2;
                    const y = canvas.height / 2;
                    context.clearRect(0, 0, canvas.width, canvas.height);

                    context.font = `normal ${sizePixelMapping[inputSizeVal]}px ${fontid}`;
                    context.textAlign = 'center';
                    context.textBaseline = 'middle';

                    // check if we have alternate item selected
                    var allCompletedSteps = this.getAllCompletedSteps();
                    var alternativeColorItemSelected = allCompletedSteps.find(step => step.alternateColorProducts.indexOf(step.selectedOption) > -1);
                    if (alternativeColorItemSelected) {
                        context.strokeStyle = alternateColor;
                        context.strokeText(text, x, y);
                    }

                    context.fillStyle = defaultColor;
                    context.fillText(text, x, y);

                    // get text size metrics
                    const metrics = context.measureText(text);
                    const textHeight = parseInt(metrics.actualBoundingBoxAscent.toFixed(0)) + parseInt(metrics.actualBoundingBoxDescent.toFixed(0));
                    const textWidth = parseInt(metrics.actualBoundingBoxLeft.toFixed(0)) + parseInt(metrics.actualBoundingBoxRight.toFixed(0));

                    if (text) {
                        if (textWidth > canvas.width || textHeight > canvas.height) {
                            this.engravingTextError = true;
                            this.showEngravingCustomError();
                        }
                    }
                    this.engravingTextInput = text;

                    // check if canvas is completed and blank
                    if (canvas.classList.contains('complete') && this.isCanvasBlank(canvas)) {
                        // if blank canvas, trigger click on the active font in order to redraw the selected engraving text
                        document.querySelector('.engraving-fonts-section button.active').click();
                    }
                },
                /**
                 * @function
                 * @method - method to work out if canvas element is blank
                 * @param {HTMLElement} canvas - canvas element
                 * @returns {Boolean} true if canvas blank
                 */
                isCanvasBlank(canvas) {
                    const context = canvas.getContext('2d');

                    const pixelBuffer = new Uint32Array(
                        context.getImageData(0, 0, canvas.width, canvas.height).data.buffer
                    );

                    return !pixelBuffer.some(color => color !== 0);
                },
                engravingFinish(e) {
                    const $engravingTextInput = $('.engraving-textarea-section .engraving-area');

                    // validate engraving inputs
                    if (!$engravingTextInput.valid() || !$engravingTextInput.val()) {
                        $engravingTextInput.valid();
                        return;
                    }

                    // validate engraving checkbox
                    if (!document.querySelector('.engrav-checkbox input.input-checkbox').checked) {
                        this.engravingCheckboxError = true;
                        this.engravingComplete = false;
                    } else {
                        // if all valid, add engraving to order
                        this.swiper.slideNext();
                        this.steps.getStepSelectField(e);
                        this.engravingCheckboxError = false;
                        this.engravingComplete = true;
                    }
                },
                /**
                 * Function to handle engraving finish for engravable only products
                 * @param {Event} e - The event object
                 * @returns {undefined}
                 */
                engravingFinishForEngravableOnlyProducts(e) {
                    e.preventDefault();
                    const $engravingTextInput = $('.engraving-textarea-section .engraving-area');

                    // validate engraving inputs
                    if (!$engravingTextInput.valid() || !$engravingTextInput.val()) {
                        $engravingTextInput.valid();
                        return;
                    }

                    // validate engraving checkbox
                    if (!document.querySelector('.engrav-checkbox input.input-checkbox').checked) {
                        this.engravingCheckboxError = true;
                        this.engravingComplete = false;
                    } else {
                        // if all valid, add engraving to order
                        this.steps.getStepSelectField(e);
                        this.engravingCheckboxError = false;
                        this.engravingComplete = true;
                        this.checkIfAllStepsCompleted();
                    }
                },
                clearAllSteps() {
                    const defaultStepMsg = document.querySelectorAll('[data-defaultmsg]');
                    const allStepElements = document.querySelectorAll('[data-stepname]');
                    const $this = this;

                    this.selected = 1;
                    this.showClearLabel = false;
                    this.showSummary = false;
                    this.activeIndex = 0;
                    this.tabOpened = false;
                    this.engraving = false;
                    this.engravingCheckboxError = false;

                    forEach(this.steps.stepdata, (step, index) => {
                        step.completed = false;
                        step.selectedOption = null;
                        step.stepName = allStepElements[index].dataset.stepname;
                        step.selectedOptionName = defaultStepMsg ? defaultStepMsg[index].dataset.defaultmsg : '';
                        step.selectedOptionColor = '';
                        step.engraving = false;
                        step.size = '';
                        step.font = '';
                        step.text = '';
                    });

                    $('.engraving-size-wrapper input.input-engraving-size').val(ENGRAVING_DEFAULT_SIZE_VALUE);
                    $('.button-size').first().trigger('click');
                    document.getElementById('engraving-area').value = '';
                    const engravingCheckbox = document.querySelector('.engrav-checkbox .input-checkbox');

                    if (engravingCheckbox) {
                        engravingCheckbox.checked = false;
                    }

                    $('.product-customization-container').attr('data-engraving', 'false');

                    // do not execute below logic for engravableProduct modal, where we do not set the swiper
                    // check line 120
                    if (!$this.swiper) return;

                    setTimeout(() => {
                        $this.swiper.update();
                        $this.swiper.slideTo(0, 0, true);
                    }, 100);
                },
                /**
                 * Opens the clear dialog
                 * @returns {undefined}
                 */
                openClearDialog() {
                    let $dialog = $('#clear-dialog');
                    $dialog.dialog({
                        autoOpen: false,
                        resizeable: false,
                        modal: true,
                        width: 716,
                        height: 'auto',
                        closeOnEscape: true,
                        dialogClass: 'clear-modal-dialog',
                        close: function (ev) {
                            $(this).dialog('destroy');
                            ev.target.classList.add('d-none');
                        },
                        closeText: window.Resources.CLOSE,
                        open: function (ev) {
                            ev.target.classList.remove('d-none');
                        }
                    });

                    $dialog.dialog('open');

                    $(document).on('click', '.js-close-dialog', function (e) {
                        e.preventDefault();
                        $(this).closest('.clear-modal-dialog .ui-dialog-content').dialog('close');
                    });
                },

                showStepProgress() {
                    let dataSteps = document.querySelector('[data-steps]').dataset.steps;
                    let activeIndex = this.activeIndex;
                    let allSlides = dataSteps;
                    let currentStep = '';

                    if ((activeIndex + 1) <= allSlides) {
                        currentStep = (activeIndex + 1) + '/' + allSlides + ' ' + this.steps.stepdata[activeIndex].stepName;
                    } else {
                        currentStep = document.querySelector('.summary-title').textContent;
                    }

                    return currentStep;
                },

                checkIfAllStepsCompleted() {
                    var completedSteps = [];
                    var productVersion = document.querySelector('.product-customization-container').dataset.version;
                    let dataSteps = parseInt(document.querySelector('[data-steps]').dataset.steps);
                    let selectedEngravingDetails = '';

                    forEach(this.steps.stepdata, (step) => {
                        step.completed = step.stepName === document.querySelector('[data-engravingtitle]').dataset.engravingtitle ? true : step.completed;

                        if (!step.completed) {
                            this.triggerIncompleteStepsMsg = true;
                        } else {
                            completedSteps.push(step.selectedOption);

                            if (step.engraving && step.size && step.font && step.text) {
                                selectedEngravingDetails = `Font: ${step.font}|Size: ${step.size}|Text: ${step.text}`;
                            }
                        }
                    });

                    if (completedSteps.length === dataSteps) {
                        let editObject = {
                            options: completedSteps.filter(function (f) { return f !== 'Engraving'; }),
                            productVersion,
                            engraving: selectedEngravingDetails
                        };
                        this.allStepsCompleted = true;
                        $(document).trigger('productCustomizeAddToCart', [this.atbCallback, editObject]);
                    }
                },

                /**
                 * Get all completed steps
                 * @returns {Array} allCompletedSteps - Array of completed steps
                 */
                getAllCompletedSteps() {
                    const allCompletedSteps = [];

                    forEach(this.steps.stepdata, (step) => {
                        if (step && step.completed) {
                            allCompletedSteps.push(step);
                        }
                    });

                    return allCompletedSteps;
                },

                atbCallback(response) {
                    if (!response.success) {
                        if (response.notAvailableGroupParts && response.notAvailableGroupParts.length) {
                            response.notAvailableGroupParts.map(function (itemGroup) {
                                const { groupID, availableMsg } = itemGroup;
                                const groupEl = $(`.item-options[data-step-id="${groupID}"]`);

                                groupEl.find('.title-details').find('.selected-image-color, svg').hide();
                                groupEl.find('.title-details .custom-step-default-msg').addClass('error-missing').html(`${availableMsg}`);

                                // remove the custom error class once click on another option
                                // bind the event to the document as the separate options are not bindable to click because of the app
                                $(document).on(`click.removeCustomError.${groupID}`, function (e) {
                                    const classToCheck = `.option-container[data-option-group-id="${groupID}"]`;
                                    const $this = $(e.target);
                                    const $linkEl = $this.is('a') ? $this : $this.closest('a');
                                    const optionName = $linkEl.find('span.product-option-name').html();

                                    if ($this.closest(classToCheck).length && !$linkEl.find('.no-stock').length) {
                                        groupEl.find('.title-details').find('.selected-image-color, svg').show();
                                        groupEl.find('.title-details .custom-step-default-msg').html(optionName).removeClass('error-missing');

                                        // remove the event in the end
                                        $(document).off(`click.removeCustomError.${groupID}`);
                                    }
                                });

                                return itemGroup;
                            });
                        } else if (response.error) {
                            $('.not-available-msg.basket-error').html(response.error).show();
                        }
                    } else {
                        const updateCardBtnUrl = $('.product-customization-container').find('.add-to-cart, .engraving-atb-button').attr('data-href');
                        if (updateCardBtnUrl) {
                            window.location.replace(updateCardBtnUrl);
                        }

                        $('.product-customization-form').remove();
                    }
                },

                /**
                 * This function checks if any steps in the stepdata array are marked as completed and sets the showClearLabel property accordingly.
                 * @returns {undefined}
                 */
                showClearLabelIfStepsCompleted() {
                    forEach(this.steps.stepdata, (step) => {
                        if (step && step.completed) {
                            this.showClearLabel = true;
                        }
                    });
                },

                checkIfSummary() {
                    let dataSteps = document.querySelector('[data-steps]').dataset.steps;
                    var activeIndex = this.activeIndex + 1;
                    var allSlides = dataSteps;

                    if (activeIndex > allSlides) {
                        this.showSummary = true;
                        this.tabOpened = true;
                        availability();
                    } else {
                        this.showSummary = false;
                    }
                },
                /**
                 * Check if the current step is an engraving customization step
                 * @returns {boolean} - True if the current step is an engraving customization step, false otherwise
                 */
                isEngravingCustomizationStep(isEngravingEdit) {
                    // on engraving edit version we return true to avoid the check
                    if (isEngravingEdit) return true;

                    const engravingTitleContainer = document.querySelector('[data-engravingtitle]');

                    const engravingTitle = engravingTitleContainer && engravingTitleContainer.dataset.engravingtitle;

                    if (!engravingTitle) return false;
                    // checks if section step title equals section title
                    return this.steps.stepdata[this.activeIndex] &&
                        this.steps.stepdata[this.activeIndex].stepName == engravingTitle;
                },
                /**
                 * Create an object based on the number of steps
                 * @returns {undefined}
                 */
                createObjectBasedOnSteps() {
                    let steps = document.querySelector('[data-steps]').dataset.steps;
                    let obj = {};
                    for (let i = 0; i < steps; i++) {
                        // create object based on steps
                        obj[i] = {
                            completed: false,
                            selectedOption: this.isEngravableProduct ? this.isEngravableProduct : null, // for fully customizable products, this value will be set at false
                            stepName: null,
                            selectedOptionName: null,
                            selectedOptionColor: ''
                        };
                    }

                    this.steps.stepdata = obj;
                }
            });
        });
    },

    init: function () {
        this.initializeEvents();
        this.initAlpine();

        document.addEventListener('alpine:initialized', () => {
            const engravableProductCustomizationContainer = document.querySelector('.engravable-product-container');

            // if engravable product customization container exists, init additional functionality
            if (engravableProductCustomizationContainer) {
                deferEngravingDrawingExecutionAfterFontsLoaded(10);
            }
        });
    }
};

/**
 * @function
 * @description - method to init custom event in order to trigger engraving canvas drawing execution after fonts loaded
 * @param {Number} maxInitAttempts
 * @returns
 */
function deferEngravingDrawingExecutionAfterFontsLoaded(maxInitAttempts) {
    if (!maxInitAttempts) return;

    const completedEngravingFrameEl = document.querySelector('.engraving-frame.complete') ||
        document.querySelector('.engraving-frame.engravable-product-edit');

    // execute only if engraving frame is completed
    if (!completedEngravingFrameEl) return;

    const selectedFontBtnEl = document.querySelector('.engraving-fonts-section button.active');
    const inputSize = document.querySelector('.engraving-size-wrapper input.input-engraving-size');

    if (!selectedFontBtnEl || !inputSize) return;

    const inputSizeVal = inputSize.value;
    const fontOptionsData = selectedFontBtnEl.hasAttribute('data-options') && safeParse(selectedFontBtnEl.getAttribute('data-options'));

    if (!fontOptionsData) return;

    const {
        sizePixelMapping,
        fontid
    } = fontOptionsData;

    // trigger custom event if selected font loaded
    if (document.fonts.check(`${sizePixelMapping[inputSizeVal]}px ${fontid}`)) {
        $(document).trigger('font:loaded');
        return;
    }

    maxInitAttempts--;

    setTimeout(() => {
        // execute the method recursively after 0.5s
        deferEngravingDrawingExecutionAfterFontsLoaded(maxInitAttempts);
    }, 500);
}

module.exports = productCustomization;

},{"../../dialog":14,"../../helpers":31,"../../util":104,"../../validator":105,"./availability":58,"./engravableProductCustomization":61,"./quantity":69,"lodash":125}],66:[function(require,module,exports){
'use strict';

var ajax = require('../../ajax'),
    util = require('../../util');

/**
 * @description loads product's navigation
 **/
module.exports = function () {
	//put .pdpForm for ecommerce site and pdpMain for corporate
    var $pidInput = $('#pdpMain input[name="pid"]').last(),
        $navContainer = $('#product-nav-container');
    
    // if no hash exists, or no pid exists, or nav container does not exist, return 
    if (window.location.hash.length <= 1 || $pidInput.length === 0 || $navContainer.length === 0) {
        return;
    }

    var pid = $pidInput.val(),
        hash = window.location.hash.substr(1),
        url = util.appendParamToURL(Urls.productNav + '?' + hash, 'pid', pid);

    ajax.load({
        url: url,
        target: $navContainer
    });
};

},{"../../ajax":3,"../../util":104}],67:[function(require,module,exports){
'use strict';

var ajax = require('../../ajax'),
    tooltip = require('../../tooltip'),
    util = require('../../util');

module.exports = function () {
    var $addToCart = $('#add-to-cart'),
        $addAllToCart = $('#add-all-to-cart'),
        $productSetList = $('#product-set-list');

    var updateAddToCartButtons = function () {
        if ($productSetList.find('.add-to-cart[disabled]').length > 0) {
            $addAllToCart.attr('disabled', 'disabled');
            // product set does not have an add-to-cart button, but product bundle does
            $addToCart.attr('disabled', 'disabled');
        } else {
            $addAllToCart.removeAttr('disabled');
            $addToCart.removeAttr('disabled');
        }
    };

    if ($productSetList.length > 0) {
        updateAddToCartButtons();
    }
    // click on swatch for product set
    $productSetList.on('click', '.product-set-item .swatchanchor', function (e) {
        e.preventDefault();
        if ($(this).parents('li').hasClass('unselectable')) { return; }
        var url = Urls.getSetItem + this.search;
        var $container = $(this).closest('.product-set-item');
        var qty = $container.find('form input[name="Quantity"]').first().val();

        ajax.load({
            url: util.appendParamToURL(url, 'Quantity', isNaN(qty) ? '1' : qty),
            target: $container,
            callback: function () {
                updateAddToCartButtons();
                tooltip.init();
            }
        });
    });
};

},{"../../ajax":3,"../../tooltip":103,"../../util":104}],68:[function(require,module,exports){

'use strict';
var swiper = require('swiper');
function initPromoSwiper() {
    var mySwiper = new Swiper('.promo .swiper-container', {
        pagination: '.promo .swiper-container .swiper-pagination',
        paginationClickable: true,
        breakpoints: {
            425: {
                slidesPerView: 1
            },
            768: {
                slidesPerView: 2
            },
            2560: {
                slidesPerView: 4
            }
        }
    });
}
initPromoSwiper();
},{"swiper":145}],69:[function(require,module,exports){
'use strict';

/**
* Converts a quantity string to a number
* @param {string} quantityString - the quantity string to be converted
* @returns {number} - the converted number
*/
function convertQuantityStringToNumber(quantityString) {
    if (quantityString.trim() === '') {
        return 0;
    }
    return parseFloat(quantityString);
}

module.exports = {
    init: () => {
        // decrease quantity
        $(document).off('click', '.quantity-button.fa-minus-square-o').on('click', '.quantity-button.fa-minus-square-o', function (e) {
            e.preventDefault();
            var $Quantity = $(this).siblings('[name="Quantity"]');
            var currentQuantity = $Quantity.val();
            currentQuantity = convertQuantityStringToNumber(currentQuantity);
            var targetQuantity = currentQuantity - 1;
            if (targetQuantity > 0) {
                currentQuantity > 1 ? $Quantity.val(targetQuantity) : $Quantity.val(0);
                $Quantity.trigger('change');
            }
        });
        // increase quantity
        $(document).off('click', '.quantity-button.fa-plus-square-o').on('click', '.quantity-button.fa-plus-square-o', function (e) {
            e.preventDefault();
            var $Quantity = $(this).siblings('[name="Quantity"]');
            var currentQuantity = $Quantity.val();
            currentQuantity = convertQuantityStringToNumber(currentQuantity);
            $Quantity.val(currentQuantity + 1);
            $Quantity.trigger('change');
        });
        // on enter key press trigger add selected qty to cart
        $(document).off('keypress', 'input[name="Quantity"]').on('keypress', 'input[name="Quantity"]', function (e) {
            var keycode = (e.keyCode ? e.keyCode : e.which);
            if (keycode === 13) {
                e.preventDefault();
                $(this).closest('form').find('.add-to-cart').trigger('click');
                return false;
            }
        });
    }
};

},{}],70:[function(require,module,exports){
'use strict';

var swiper = require('swiper');
var recommandationSwiper = undefined;

function initRecommandationSwiper() {
	/* http://idangero.us/swiper/api/ */
	function initLydSwiper() {
		if($(window).width() > 1024 && $('.promotion-content-container').length) return;
		if (!document.querySelector('.promotion-content-container')){
			if (lydSwiper != undefined && $('.recommendations .swiper-container').length) {
				lydSwiper.destroy();
			}
			var lydSwiper = recommandationSwiper = new Swiper('.recommendations .swiper-container', {
				speed: 400,
				//spaceBetween: 100,
				paginationClickable: true,
				pagination: '.recommendations .swiper-container .swiper-pagination',
				breakpoints: {
					480: {
						slidesPerView: 1,
						initialSlide: 0,
					},
					768:{
						slidesPerView: 2,
						initialSlide: 0,
						spaceBetween: 0,
					},
					1024: {
						slidesPerView: 3,
						initialSlide: 0,
						spaceBetween: 0,
						pagination:'',
					},
					1440: {
						slidesPerView: 3,
						initialSlide: 0,
						pagination:'',
					},
					10060: {
						slidesPerView: 3,
						initialSlide: 0,
						pagination:'',
					}
				}
			});
			var screenWidth = $(window).width();
			if (!document.querySelector('.promotion-content-container')) {
				if (screenWidth >= 1024 && lydSwiper != undefined && $('.recommendations .swiper-container').length) {
					if (lydSwiper.length > 1) {
						lydSwiper.forEach(function (swiper) {
							swiper.destroy();
						});
					}else{
						lydSwiper.destroy();
					}

					// lydSwiper.destroy();
					$(".lydSwiper .swiper-slide").css('width', 'auto').css('margin', '0 0px');
					var wrapperWidth = $('.recommendations .swiper-wrapper').css('width').split('p')[0];
					var slideNb = $(".lydSwiper .swiper-slide").length;
					var slideWidth = wrapperWidth / slideNb;
					$(".lydSwiper .swiper-slide").css('width', slideWidth + 'px');
				}
			}
		}else{
			if (document.querySelector('.promotion-content-container')) {
				if(lydSwiper) lydSwiper.destroy();
				var lydSwiper = new Swiper('.promotion-content-container .recommendations .swiper-container', {
					pagination: '.promotion-content-container .recommendations .swiper-container .swiper-pagination',
					paginationClickable: true,
					initialSlide: 0,
					breakpoints: {
						480: {
							slidesPerView: 1,
						},
						768:{
							slidesPerView: 'auto',
							spaceBetween: 0,
						},
						1024: {
							slidesPerView: 'auto',
							spaceBetween: 200,
						},
						1440: {
							slidesPerView: 'auto',
						},
						2560: {
							slidesPerView: 'auto',
						}
					}
				});
			}
		}
	}
	initLydSwiper();
	$( window ).resize(function() {
		initLydSwiper();
	});
}
function initRecommandationSwiperMobile() {
	var swiper = new Swiper('.recommendations .swiper-container', {
		pagination: '.recommendations .swiper-container .swiper-pagination',
		paginationClickable: true
	});
	var previousIndex = swiper.activeIndex;
}

//Swiper plugin initialization
var screenWidth = $(window).width();
if (screenWidth <= 768) {
	initRecommandationSwiperMobile();
}else{
	initRecommandationSwiper();
}

module.exports.initRecommandationSwiper = initRecommandationSwiper;

},{"swiper":145}],71:[function(require,module,exports){
'use strict';

var ajax = require('../../ajax'),
	image = require('./image'),
	recommendations = require('./recommendations'),
    progress = require('../../progress'),
    productStoreInventory = require('../../storeinventory/product'),
    tooltip = require('../../tooltip'),
    util = require('../../util'),
	dialog = require('../../dialog');


/**
 * @description update product content with new variant from href, load new content to #product-content panel
 * @param {String} href - url of the new product variant
 **/
var updateContent = function (href) {
	var index = require('./index');

    var $pdpForm = $('.pdpForm');
    var $pdpMain= $('.pdpMain');
    var qty = $pdpForm.find('input[name="Quantity"]').first().val();
    var params = {
        Quantity: isNaN(qty) ? '1' : qty,
        format: 'ajax',
        productlistid: $pdpForm.find('input[name="productlistid"]').first().val()
    };

    progress.show($('#pdpMain'));

    ajax.load({
        url: util.appendParamsToUrl(href, params),
        target: $('#pdpMain'),
        callback: function () {
            if (SitePreferences.STORE_PICKUP) {
                productStoreInventory.init();
            }
            image.replaceImages();
            tooltip.init();
            var $pdpMain = $('#pdpMain');
            // hover on swatch - should update main image with swatch image
            $pdpMain.on('click', '.tab-label', function () {
               var tabNum = ($(this).attr("for"));
        	  $(".tab-content").removeClass("active").promise().done(function() {
        		    $(".tab-content[data-tab="+tabNum+"]").addClass("active");
        	  });
            });
        	//index.initializeHatch();
            index.showSellableOnline();
        	image.swiperImages();
        	recommendations.initRecommandationSwiper();
        	reloadSwiper();
        }
    });
};

function reloadSwiper() {
	// #104087
	$('#thumbnails, #thumbnails-button-next, #thumbnails-button-prev').addClass('swiper-active');
	var perView = 5;
	if(window.document.documentElement.clientWidth < 1366) perView = 4;
	var swiperThumb = require('swiper');
	var swiperThumb = new Swiper('#thumbnails', {
		slidesPerView: perView,
		slidesPerGroup: perView,
		spaceBetween: 30,
		nextButton: '#thumbnails-button-next',
        prevButton: '#thumbnails-button-prev',
        paginationClickable: true
	});

	// AVIS
	if ($('.product-ratings-slider').length) {
		var swiper = new Swiper('.product-ratings-slider', {
			nextButton: '.icon-arrowRight',
		    prevButton: '.icon-arrowLeft',
		    spaceBetween: 100,
		    slidesPerView: 3,
		    breakpoints: {
				1040: {
					slidesPerView: 2,
		            spaceBetween: 45,
		            autoHeight: false
		        },
		        480: {
					slidesPerView: 1,
		            spaceBetween: 0,
		            autoHeight: true
		        }
		    }
		});
		var swiper = new Swiper('.product-ratings-slider', {
			nextButton: '.icon-arrowRight',
		    prevButton: '.icon-arrowLeft',
		    spaceBetween: 100,
		    slidesPerView: 3,
		    breakpoints: {
				1040: {
					slidesPerView: 2,
		            spaceBetween: 45,
		            autoHeight: false
		        },
		        480: {
					slidesPerView: 1,
		            spaceBetween: 0,
		            autoHeight: true
		        }
		    }
		});
	}

	if ($('.product-faq-title').length) {
		var faqTrigger = $('.product-faq-title');

		faqTrigger.on('click', function(event){
			var faqContainer = $(this).next('.product-faq-container');
		    event.preventDefault();
		    if (!faqContainer.is(':visible')){
		        faqContainer.slideDown(200)
				.end()
				.parent('.product-faq-item')
				.addClass('product-faq-item--visible');
		        $('.product-faq-container').not(faqContainer)
				.slideUp()
				.parent('.product-faq-item')
				.removeClass('product-faq-item--visible');
		    } else {
				faqContainer.slideUp()
				.parent('.product-faq-item')
				.removeClass('product-faq-item--visible');
		    }
		});
	}


	if ($('#thumbnails').length && !util.isMobile() && $('#thumbnails .swiper-wrapper .thumb').length > 3) {
    	$('#thumbnails, #thumbnails-button-next, #thumbnails-button-prev').addClass('swiper-active');

		var swiperThumb = new Swiper('#thumbnails', {
			slidesPerView: 5,
			slidesPerGroup: 5,
			spaceBetween: 30,
			nextButton: '#thumbnails-button-next',
	        prevButton: '#thumbnails-button-prev',
	        paginationClickable: true
		});
	}

	var imgNb = $('.product-image-container .product-thumbnails .thumb').length;
	if(imgNb <= 5){
		$('.product-col-1.product-image-container #thumbnails .swiper-wrapper').css('justify-content', 'center');
		$('.product-col-1.product-image-container #thumbnails .swiper-wrapper .thumb.swiper-slide').css('width', '86px').css('height', '117px');
		if ($( document ).width() < 1024 ) { // keep previous and next button for ipad landsape and bigger screens
			$('.product-image-container .swiper-button-next, .product-image-container .swiper-button-prev').hide();
		}
		if ($( document ).width() >= 1024 && $( document ).width() <= 1440 && imgNb < 4) {
			$('.product-image-container .swiper-button-next, .product-image-container .swiper-button-prev').hide();
		}
		if ($( document ).width() > 1440 && imgNb <= 5) {
			$('.product-image-container .swiper-button-next, .product-image-container .swiper-button-prev').hide();
		}
	}
}

function carouselVideos() {
	var mobileWidth = 543;
	var screenWidth = $(window).width();
	var swiper;

	var swiperSlideLength = $('#product-main-carousel-video .swiper-slide').length;

	if (swiperSlideLength > 1) {
		setTimeout(() => {
			swiper = new Swiper('#product-main-carousel-video', {
				slidesPerView: 4,
				spaceBetween: 15,
				loop: swiperSlideLength > 4,
				autoplay: SitePreferences.VIDEO_CAROUSEL_AUTO_PLAY_DELAY,
				paginationClickable: true,
				pagination: ".swiper-pagination",
				nextButton: ".swiper-button-next",
				prevButton: ".swiper-button-prev",
				breakpoints: {
					768: {
						slidesPerView: 1.2,
						spaceBetween: 10,
						paginationClickable: true,
						centeredSlides: true,
						centeredSlidesBounds: true
					}
				}
			});

			if (swiperSlideLength < 5 && screenWidth > mobileWidth) {
				$("#product-main-carousel-video .swiper-button-prev").addClass("d-none");
				$("#product-main-carousel-video .swiper-button-next").addClass("d-none");
				$("#product-main-carousel-video .swiper-pagination").addClass("d-none");
			}
		}, 2000);
    } else {
        $(".video-block").addClass("single-video");
        $("#product-main-carousel-video").addClass("one-slide");
        $("#product-main-carousel-video .swiper-button-prev").addClass("d-none");
        $("#product-main-carousel-video .swiper-button-next").addClass("d-none");
    }

    if ($("#product-main-carousel-video .swiper-slide").length && $("#product-main-carousel-video .swiper-slide").length < 3 && screenWidth > mobileWidth && swiper != undefined) {
        $("#product-main-carousel-video .swiper-pagination").addClass("d-none");
        swiper.destroy();
    }

    if ($("#product-main-carousel-video .swiper-slide").length === 1 && swiper != undefined) {
        swiper.destroy();
    }
}

module.exports = function () {
    var $pdpMain = $('#pdpMain');
    // hover on swatch - should update main image with swatch image
    $pdpMain.on('mouseenter mouseleave', '.swatchanchor', function () {
        var largeImg = $(this).data('lgimg'),
            $imgZoom = $pdpMain.find('.main-image'),
            $mainImage = $pdpMain.find('.primary-image');

        if (!largeImg) { return; }
        // store the old data from main image for mouseleave handler
        $(this).data('lgimg', {
            hires: $imgZoom.attr('href'),
            url: $mainImage.attr('src'),
            alt: $mainImage.attr('alt'),
            title: $mainImage.attr('title')
        });
        // set the main image
        image.setMainImage(largeImg);
    });

    // click on swatch - should replace product content with new variant
    $pdpMain.on('click', '.product-detail .swatchanchor', function (e) {
        e.preventDefault();
        if ($(this).parents('li').hasClass('unselectable')) { return; }
        updateContent(this.href);
    });

    // change drop down variation attribute - should replace product content with new variant
    $pdpMain.on('change', '.variation-select', function () {
        if ($(this).val().length === 0) { return; }
		updateContent($(this).val());
    });

	if ($(window).width() > 767) {
		$(document).on("click", ".js-open-video", function (e) {
			e.stopPropagation();
			dialog.open({
				url: $(this).data('video-url'),
				options: {
					dialogClass: 'pdp-video-modal',
					height: 'auto',
					closeOnEscape: true,
				},
				callback: function () {
					$('.ui-dialog-titlebar-close').on('click', function() {
						$('.pdp-video-modal .product-video-slider').empty();
					});

					$(document).on('keyup', function(e) {
						if (e.key === 'Escape') {
							$('.pdp-video-modal .product-video-slider').empty();
						}
					})
				}
			});
		});
	}


	carouselVideos();
};

},{"../../ajax":3,"../../dialog":14,"../../progress":85,"../../storeinventory/product":98,"../../tooltip":103,"../../util":104,"./image":62,"./index":63,"./recommendations":70,"swiper":145}],72:[function(require,module,exports){
'use strict';

// FAQ ACCORDION

var faqTrigger = $('.product-faq-title');

faqTrigger.on('click', function(event){
    var faqContainer = $(this).next('.product-faq-container');
    event.preventDefault();
    if (!faqContainer.is(':visible')){
        faqContainer.slideDown(200)
                    .end()
                    .parent('.product-faq-item')
                    .addClass('product-faq-item--visible');
        $('.product-faq-container').not(faqContainer)
                                   .slideUp()
                                   .parent('.product-faq-item')
                                   .removeClass('product-faq-item--visible');
    } else {
        faqContainer.slideUp()
                    .parent('.product-faq-item')
                    .removeClass('product-faq-item--visible');
    }

    if(document.getElementById('productpage_hero') == null) {
    	//Google Push Event for FAQ
    	// tagmanager_event('clickProductFAQQuestion', {'question': $( this ).html()});
    } else if(document.getElementById('productpage_hero')) {
    	// tagmanager_event('clickIconicFAQQuestion', {'question': $( this ).html()});
    }
});

// CARACTERISTIQUE ACCORDION
$('.product-carac-item').on('click', function() {
    $(this).toggleClass('product-carac-item--visible')
    $(this).find('.product-carac-container').toggleClass('product-carac-container--open')
    return false;
});

// AVIS
var swiper = new Swiper('.product-ratings-slider', {
    nextButton: '.icon-arrowRight',
    prevButton: '.icon-arrowLeft',
    spaceBetween: 100,
    slidesPerView: 3,
    breakpoints: {
        1040: {
            slidesPerView: 2,
            spaceBetween: 45,
        },
        480: {
            slidesPerView: 1,
            spaceBetween: 10,
        }
    }
});

function reviewWordCount(str) {
    var reviewLength = str.text().length;
    var maxCharacters = 230;
    var minCharacters = 0;
    var textToReduce = str[0];
    var reviewLengthCropped = textToReduce.innerHTML.substring(maxCharacters , reviewLength)
    var reviewRestCropped = "<span class='reviewLengthCropped'>" + reviewLengthCropped + "<span> <span class='reviewLengthCropped js-reviewLengthCropped-less'><span class='reviewLengthCropped-see'>" + Resources.REVIEW_VIEWLESS + "</span></span>";
    var linkToAdd = "<span class='js-reviewLengthCropped-more'>... <span class='reviewLengthCropped-see'>" + Resources.REVIEW_VIEWMORE + "</span></span>" + reviewRestCropped;

    if (reviewLength > maxCharacters) {
        textToReduce.innerHTML = textToReduce.innerHTML.substring(minCharacters, maxCharacters) + linkToAdd;
    }

    $('.js-reviewLengthCropped-more').on('click', function () {
        $(this).hide();
        $(this).parent('.product-ratings-testimonial').find('.reviewLengthCropped').css('display','inline');
    });

    $('.js-reviewLengthCropped-less').on('click', function () {
        $(this).hide();
        $(this).parents('.product-ratings-testimonial').find('.reviewLengthCropped').slideUp();
        $(this).parents('.product-ratings-testimonial').find('.js-reviewLengthCropped-more').show();
    });
}

$(".product-ratings-testimonial").each(function(){
	reviewWordCount($(this));
})

function detectAgent() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/android/i.test(userAgent)) {
        $('.product-appli-button--ios').hide();
    } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        $('.product-appli-button--android').hide();
    } else {
        return false;
    }
}

$(window).on('load', function(){
    detectAgent()
});

var switched = false;
var updateTables = function() {
    if (($(window).width() < 1040) && !switched){
        switched = true;
        $('.product-skin-tableResponsive').each(function(i, element) {
            splitTable($(element));
        });
        return true;
    } else if (switched && ($(window).width() > 1040)) {
        switched = false;
        $('.product-skin-tableResponsive').each(function(i, element) {
            unsplitTable($(element));
        });
    }
};

$(window).load(updateTables);
$(window).on('redraw', function(){
    switched=false; updateTables();
}); // An event to listen for
$(window).on('resize', updateTables);


function splitTable(original) {
    original.wrap('<div class="product-skin-tableWrapper" />');

    var copy = original.clone();
    copy.find('td:not(:first-child), th:not(:first-child)').css('display', 'none');
    copy.removeClass('product-skin-tableResponsive');

    original.closest('.product-skin-tableWrapper').append(copy);
    copy.wrap('<div class="product-skin-tableFixed" />');
    original.wrap('<div class="product-skin-tableScroll" />');

    setCellHeights(original, copy);
}

function unsplitTable(original) {
    original.closest('.product-skin-tableWrapper').find('.product-skin-tableFixed').remove();
    original.unwrap();
    original.unwrap();
}

function setCellHeights(original, copy) {
    var tr = original.find('tr'),
        rowCopy = copy.find('tr'),
        heights = [];

    tr.each(function (index) {
        var self = $(this),
            tx = self.find('th, td');

        tx.each(function () {
            var height = $(this).outerHeight(true);
            heights[index] = heights[index] || 0;
            if (height > heights[index]) heights[index] = height;
        });

    });

    rowCopy.each(function (index) {
        $(this).height(heights[index]);
    });
}

},{}],73:[function(require,module,exports){
'use strict';

function initTopProductToolbox() {
	$(".js-univers-topProduct-toolbox-more").on( "click", function() {
		//init all more buttons
		$('.univers-topProduct-toolbox-box').fadeOut();
		$(".js-univers-topProduct-toolbox-more").not(this).parents(".univers-topProduct-toolbox-listItem").removeClass('active');
		$(".js-univers-topProduct-toolbox-more").not(this).find('.univers-topProduct-toolbox-button').html('+');
		
		//init the clicked button
		var activeToolBox = $(this).parents(".univers-topProduct-toolbox-listItem");
		
		if (activeToolBox.hasClass('active')){
			activeToolBox.removeClass('active')
			activeToolBox.find('.univers-topProduct-toolbox-box').fadeOut();
			activeToolBox.find('.univers-topProduct-toolbox-button').html('+');
		} else {
			activeToolBox.addClass('active')
			activeToolBox.find('.univers-topProduct-toolbox-box').fadeIn();
			activeToolBox.find('.univers-topProduct-toolbox-button').html('');
		}
	});
	
	$('.js-univers-topProduct-toolbox-close').on( 'click', function() {
		$('.univers-topProduct-toolbox-listItem').removeClass('active');
		$('.univers-topProduct-toolbox-button').html('+');
		$('.univers-topProduct-toolbox-box').fadeOut();
    	$('.univers-topProduct-toolbox-button').fadeIn();
	});
}

//Little toolbox infos initialization
initTopProductToolbox();
},{}],74:[function(require,module,exports){
'use strict';

var loaded = false;

var $form = $('#dwfrm_promosubscription');

var autocomplete;

var componentForm = {
	street_number: 'short_name',
	route: 'long_name',
	locality: 'long_name',
	administrative_area_level_1: 'short_name',
	country: 'long_name',
	postal_code: 'short_name',
	postal_code_prefix: 'short_name'
};

$(document).ready(function() {
	initUploadEvent();
	initSubmitEvent();
	displayFileName();
	displayAddress();
	preventSubmitOnEnter();
	initDatePicker();
	initUpload();
	initAutocomplete();
});

function initUpload() {
	if ($('.file-upload').length) {
		$('.file-upload').on('change', '.js-Upload' , function(e) {
			var thisUpload = $(this).parent().parent();
			var filenameIn = $(this).val();
			var filenameOut = filenameIn.split('\\').pop();
			$(thisUpload).find('.js-FileUpload').val(filenameOut);
			$(thisUpload).find('.file-upload').hide();
			$(thisUpload).find('.file-upload-name').addClass('file-upload-name--visible');
		});
	}

	if ($('.file-upload-name').length) {
		$('.file-upload-name').on('click', '.file-upload-icon', function(e) {
			$('.js-FileUpload', e.delegateTarget).val(null);
		    $('.js-FileUpload', e.delegateTarget).parent().next('.file-upload').show();
		    $(this).parent().removeClass('file-upload-name--visible');
		});
	}
}

function preventSubmitOnEnter() {
	$(window).keydown(function(event) {
		if ((event.keyCode == 13)) {
			event.preventDefault();
			return false;
		}
	});
}

function displayAddress() {
	if (document.querySelector('input[name="dwfrm_promosubscription_addressinfo_street"]').value != "") {
		document.getElementById('autocomplete-promo').value = document.querySelector('input[name="dwfrm_promosubscription_addressinfo_streetnumber"]').value + " " + document.querySelector('input[name="dwfrm_promosubscription_addressinfo_street"]').value;
	}
}

function displayFileName() {
	if (document.querySelector('input[name="dwfrm_promosubscription_purchaseinfo_receipt"]').files) {
		var file = document.querySelector('input[name="dwfrm_promosubscription_purchaseinfo_receipt"]').files[0];
		$form.find('#promofileuploadurl')[0].innerHTML = file ? file.name : "";
	}
}

function initUploadEvent() {
	$('#main').on('change', 'input[name="dwfrm_promosubscription_purchaseinfo_receipt"]', function() {
		loaded = false;
		$form.find('textarea')[0].value != "";
		var file = document.querySelector('input[name="dwfrm_promosubscription_purchaseinfo_receipt"]').files[0];
		$form.find('#promofileuploadurl')[0].innerHTML = file.name;

		var reader = new FileReader();
		reader.readAsDataURL(file);
		reader.onload = function() {
			$form.find('textarea')[0].value = reader.result;
			loaded = true;
		};
		reader.onerror = function(error) {
			loaded = false;
		};
	});
}

function initSubmitEvent() {
	$('#main').on('submit', '.promo-subscription', function() {
		
		var allowUpload, nbFiles = 0;
    	var filename_receipt = $('input[name="dwfrm_promosubscription_purchaseinfo_receipt"]').parent('div').prev().find('#fileuploadurl').val();
    	
    	if (filename_receipt != '') {
    		var extension = filename_receipt.substr((filename_receipt.lastIndexOf('.') +1));
   		    if (extension != '') {
	    		var filesize = ($('input[name="dwfrm_promosubscription_purchaseinfo_receipt"]')[0].files.length > 0) ? $('input[name="dwfrm_promosubscription_purchaseinfo_receipt"]')[0].files[0].size/1024/1024 : 0;
   		    	switch(extension.toLowerCase()) {
		    	    case 'jpg':
		    	    case 'jpeg':
	    	       	case 'png':
	    	       	case 'gif':
	    	       	case 'pdf':
		    	       	allowUpload = true;
		    	       	break;
		    	    default:
		    	    	allowUpload = false;
   		    	}

    		    // file size restriction < 2Mb
    		    if (filesize.toFixed(2) > 1.00)	allowUpload = false;
		    }
		}
		
		if (!allowUpload) 	$('input[name="dwfrm_promosubscription_purchaseinfo_receipt"]').parent('div').parent('div').find('div.js-FileUpload-Error span').html(Resources.RESOURCE_FILEUPLOAD_RESTRICTION).css({'color' : '#c41f35', 'font-size' : 'calc(12rem / 16)'});
		else 				$('input[name="dwfrm_promosubscription_purchaseinfo_receipt"]').parent('div').parent('div').find('div.js-FileUpload-Error span').html('');
		
		if (!allowUpload) return false;
		
		var file = document.querySelector('input[name="dwfrm_promosubscription_purchaseinfo_receipt"]').files[0];
		$form.find('#promofileuploadurl')[0].innerHTML = file ? file.name : "<span style=\"font-size:25px; font-weight:bold; color:red;\"> X</span>";
		return loaded || $form.find('textarea')[0].value != "";
	});
}

function initAutocomplete() {
	autocomplete = new google.maps.places.Autocomplete(
		(document.getElementById('autocomplete-promo')), { // Adress field
			types: ['geocode']
		});

	document.getElementById('autocomplete-promo').addEventListener("focus", geolocate);
	autocomplete.addListener('place_changed', fillInAddress);
}

function geolocate() {
	if (navigator.geolocation) {
		navigator.geolocation.getCurrentPosition(function(position) {
			var geolocation = {
				lat: position.coords.latitude,
				lng: position.coords.longitude
			};
			var circle = new google.maps.Circle({
				center: geolocation,
				radius: position.coords.accuracy
			});
			autocomplete.setBounds(circle.getBounds());
		});
	}
}

function fillInAddress() {
	var place = autocomplete.getPlace();
	for (var component in componentForm) {
		if(document.getElementById(component) != null){
			document.getElementById(component).value = '';
			document.getElementById(component).disabled = false;
		}
	}
	if (place.address_components) {
		for (var i = 0; i < place.address_components.length; i++) {
			var addressType = place.address_components[i].types[0];
			if(addressType == 'postal_code_prefix'){
				// Solving issue #102068 (address: Rotsvlinder 32)
				addressType = 'postal_code';
			}
			var vaval = place.address_components[i][componentForm[addressType]];
			if (componentForm[addressType] && $form.find('#' + addressType)[0] != undefined) {
				var val = place.address_components[i][componentForm[addressType]];
				$form.find('#' + addressType)[0].value = val;
			}
		}
	}
	// In case issue #102068 (address: Rotsvlinder 32) is not completely solved
	document.getElementById('street_number').removeAttribute('readonly');
	document.getElementById('route').removeAttribute('readonly');
	document.getElementById('postal_code').removeAttribute('readonly');
	document.getElementById('locality').removeAttribute('readonly');
};

function initDatePicker() {
	$('#dwfrm_promosubscription_addressinfo_birthday, #dwfrm_promosubscription_purchaseinfo_purchasedate').datepicker({
		showOtherMonths: true,
		selectOtherMonths: true,
		changeMonth: true,
	    changeYear: true,
	    yearRange: "1950:",
	    dateFormat: "mm/dd/yy"
	});
};
},{}],75:[function(require,module,exports){
'use strict';

var addProductToCart = require('./product/addToCart'),
    ajax = require('../ajax'),
    login = require('../login'),
    quickview = require('../quickview'),
    util = require('../util');

/**
 * @function
 * @description Loads address details to a given address and fills the address form
 * @param {String} addressID The ID of the address to which data will be loaded
 */
function populateForm(addressID, $form) {
    // load address details
    var url = Urls.giftRegAdd + addressID;
    ajax.getJson({
        url: url,
        callback: function (data) {
            if (!data || !data.address) {
                window.alert(Resources.REG_ADDR_ERROR);
                return false;
            }
            // fill the form
            $form.find('[name$="_addressid"]').val(data.address.ID);
            $form.find('[name$="_firstname"]').val(data.address.firstName);
            $form.find('[name$="_lastname"]').val(data.address.lastName);
            $form.find('[name$="_address1"]').val(data.address.address1);
            $form.find('[name$="_address2"]').val(data.address.address2);
            $form.find('[name$="_city"]').val(data.address.city);
            $form.find('[name$="_country"]').val(data.address.countryCode).trigger('change');
            $form.find('[name$="_postal"]').val(data.address.postalCode);
            $form.find('[name$="_state"]').val(data.address.stateCode);
            $form.find('[name$="_phone"]').val(data.address.phone);
            // $form.parent('form').validate().form();
        }
    });
}

/**
 * @private
 * @function
 * @description Initializes events for the gift registration
 */
function initializeEvents() {
    var $eventAddressForm = $('form[name$="_giftregistry"]'),
        $beforeAddress = $eventAddressForm.find('fieldset[name="address-before"]'),
        $afterAddress = $eventAddressForm.find('fieldset[name="address-after"]');

    $('.usepreevent').on('click', function () {
        // filter out storefront toolkit
        $(':input', $beforeAddress).not('[id^="ext"]').not('select[name$="_addressBeforeList"]').each(function () {
            var fieldName = $(this).attr('name'),
                $afterField = $afterAddress.find('[name="' + fieldName.replace('Before', 'After') + '"]');
            $afterField.val($(this).val()).trigger('change');
        });
    });
    $eventAddressForm.on('change', 'select[name$="_addressBeforeList"]', function () {
        var addressID = $(this).val();
        if (addressID.length === 0) { return; }
        populateForm(addressID, $beforeAddress);
    })
    .on('change', 'select[name$="_addressAfterList"]', function () {
        var addressID = $(this).val();
        if (addressID.length === 0) { return; }
        populateForm(addressID, $afterAddress);
    });

    $('.item-list').on('click', '.item-edit-details a', function (e) {
        e.preventDefault();
        var productListID = $('input[name=productListID]').val();
        quickview.show({
            url: e.target.href,
            source: 'giftregistry',
            productlistid: productListID
        });
    });
}

exports.init = function () {
    initializeEvents();
    addProductToCart();
    login.init();
    util.setDeleteConfirmation('.item-list', String.format(Resources.CONFIRM_DELETE, Resources.TITLE_GIFTREGISTRY));
};

},{"../ajax":3,"../login":34,"../quickview":86,"../util":104,"./product/addToCart":57}],76:[function(require,module,exports){
'use strict';

var compareWidget = require('../compare-widget'),
    productTile = require('../product-tile'),
    progress = require('../progress'),
    util = require('../util'),
    sliderproduct = require('./sliderproduct');

function clearFilters() {
    if (window.location.href.match(/\?./)) {
        var paramsString = window.location.href.split('?')[1];

        var paramsArr = paramsString.split('&');

        var newArr = paramsArr.filter(item => {
            if(!item.match(/^q=/) && !item.match(/^lang=/) && !item.match(/^srule=/) && !item.match(/^start=/) && !item.match(/^sz=/)) {
                return item
            }
        })

        if (newArr.length > 0) {
            $('.js-clear-refinement').parent('.clear-refinement').show();
        }
    }
}

function infiniteScroll() {
    // getting the hidden div, which is the placeholder for the next page
    var loadingPlaceHolder = $('.infinite-scroll-placeholder[data-loading-state="unloaded"]');
    // get url hidden in DOM
    var gridUrl = loadingPlaceHolder.attr('data-grid-url');

    if (loadingPlaceHolder.length === 1 && util.elementInViewport(loadingPlaceHolder.get(0), 250)) {
        // switch state to 'loading'
        // - switches state, so the above selector is only matching once
        // - shows loading indicator
        loadingPlaceHolder.attr('data-loading-state', 'loading');
        loadingPlaceHolder.addClass('infinite-scroll-loading');


        // named wrapper function, which can either be called, if cache is hit, or ajax repsonse is received
        var fillEndlessScrollChunk = function (html) {
            loadingPlaceHolder.removeClass('infinite-scroll-loading');
            loadingPlaceHolder.attr('data-loading-state', 'loaded');
            $('div.search-result-content-wrapper').find('ul#search-result-items:first').append(html);
        };

        // old condition for caching was `'sessionStorage' in window && sessionStorage["scroll-cache_" + gridUrl]`
        // it was removed to temporarily address RAP-2649

        $.ajax({
            type: 'GET',
            dataType: 'html',
            url: gridUrl,
            success: function (response) {
                // put response into cache
                try {
                    sessionStorage['scroll-cache_' + gridUrl] = response;
                } catch (e) {
                    // nothing to catch in case of out of memory of session storage
                    // it will fall back to load via ajax
                }
                // update UI
                fillEndlessScrollChunk(response);
                productTile.init();
            }
        });
    }
}
/**
 * @private
 * @function
 * @description replaces breadcrumbs, lefthand nav and product listing with ajax and puts a loading indicator over the product listing
 */
function updateProductListing(url, sort) {
    if (!url || url === window.location.href) {
        return;
    }
    progress.show($('.search-result-content'));
    $('#main').load(util.appendParamToURL(url, 'format', 'ajax', 'issort', sort), function () {
        compareWidget.init();
        productTile.init();
        progress.hide();
        history.pushState(undefined, '', url);

        sliderproduct.init();

        // if any refinement checked
        if ($(window).width() <= 543) {
            $('.rf-definition-label.toggle').next('.toggle-content').addClass('d-none');
            $('.rf-definition-label.toggle').next('.toggle-content').removeClass('d-block');
            $('.rf-definition-label.toggle').removeClass('expanded');
            $('.toggle-content ul li.selected').closest('.toggle-content').removeClass('d-none').addClass('d-block');
            $('.toggle-content ul li.selected').closest('.toggle-content').siblings('.rf-definition-label').addClass('expanded');
        }
        clearFilters();
    });
}

/**
 * @private
 * @function
 * @description Initializes events for the following elements:<br/>
 * <p>refinement blocks</p>
 * <p>updating grid: refinements, pagination, breadcrumb</p>
 * <p>item click</p>
 * <p>sorting changes</p>
 */
function initializeEvents() {
    var $main = $('#main');
    // compare checked
	//    $main.on('click', 'input[type="checkbox"].compare-check', function () {
	//        var cb = $(this);
	//        var tile = cb.closest('.product-tile');
	//
	//        var func = this.checked ? compareWidget.addProduct : compareWidget.removeProduct;
	//        var itemImg = tile.find('.product-image a img').first();
	//        func({
	//            itemid: tile.data('itemid'),
	//            uuid: tile[0].id,
	//            img: itemImg,
	//            cb: cb
	//        });
	//
	//    });

    // handle toggle refinement blocks
	//    $main.on('click', '.refinement h3', function () {
	//        $(this).toggleClass('expanded')
	//        .siblings('ul').toggle();
	//    });

    // handle events for updating grid
    $main.on('click', '.refinements a, .pagination a, .breadcrumb-refinement-value a', function (e) {
        // don't intercept for category and folder refinements, as well as unselectable
        if ($(this).parents('.category-refinement').length > 0 || $(this).parents('.folder-refinement').length > 0 || $(this).parent().hasClass('unselectable')) {
            return;
        }
        e.preventDefault();
        updateProductListing(this.href);
    });

    // handle keyboard event Space key activate price refinement links
    $main.on('keydown', '.refinement-link.price-refinement', function (e) {
        var key = e.key || e.which;
        if (key === ' ' || key === 'Spacebar' || key === 'Space' || e.keyCode === 32) {
            e.preventDefault();
            $(this).trigger('click');
        }
    });

    clearFilters();

    // handle events item click. remove params.
    $(document).on('click', '.js-clear-refinement', function (e) {
        var href = window.location.href.split("?")[0];

        var paramsString = window.location.href.split("?")[1].split('&');

        var newArr = paramsString.filter(item => {
            if(item.match(/^q=/) || item.match(/^lang=/) || item.match(/^srule=/) || item.match(/^start=/) || item.match(/^sz=/)) {
                return item
            }
        })
        var arr = newArr.join('&');
        window.location.href = href + '?' + arr;
    });

    // handle events item click. display filters layer (on mobile)
    function filtersLayer() {
    	if (window.matchMedia("(max-width: 50rem)").matches) {
        	$main.on('click', '.js-search-result-options-filters.active', function (e) {
            	$('#secondary.refinements').slideUp();
            	$(this).removeClass('active');
            });
        	$main.on('click', '.js-search-result-options-filters:not(.active)', function (e) {
            	$('#secondary.refinements').slideDown();
            	$(this).addClass('active');
            });
    	} else {
        	$('#secondary.refinements').attr('style','');
        	$('.js-search-result-options-filters').removeClass('active');
    	}
    }
    window.onresize = function() {
    	filtersLayer();
    }
    filtersLayer();

    // handle events item click. append params.
    $main.on('click', 'li.grid-tile div:not(".quickviewbutton")', function (e) {
        var a = $(this);
        // get current page refinement values
        var wl = window.location;

        var qsParams = (wl.search.length > 1) ? util.getQueryStringParams(wl.search.substr(1)) : {};
        var hashParams = (wl.hash.length > 1) ? util.getQueryStringParams(wl.hash.substr(1)) : {};

        // merge hash params with querystring params
        var params = $.extend(hashParams, qsParams);
        if (!params.start) {
            params.start = 0;
        }
        // get the index of the selected item and save as start parameter
        var tile = a.children('.product-tile');
        var idx = tile.data('idx') ? + tile.data('idx') : 0;

        // convert params.start to integer and add index
        params.start = (+params.start) + (idx + 1);
        // set the hash and allow normal action to continue
        a[0].hash = $.param(params);
    });

    // handle sorting change
    $main.on('change', '.sort-by select', function (e) {
        e.preventDefault();
        var sort = true;
        updateProductListing($(this).find('option:selected').val(), sort);
    })
    .on('change', '.items-per-page select', function () {
        var refineUrl = $(this).find('option:selected').val();
        if (refineUrl === 'INFINITE_SCROLL') {
            $('html').addClass('infinite-scroll').removeClass('disable-infinite-scroll');
        } else {
            $('html').addClass('disable-infinite-scroll').removeClass('infinite-scroll');
            updateProductListing(refineUrl);
        }
    });

    $(document).on('click','.select-box', function() {
        var $this = $(this);
        if ( $('.select-box').attr('data-open') == 'false' ) {
            $('.select-box').attr('data-open', true);
            $this.closest('.sort-block-wrapper').find('.arrow').removeClass('down').addClass('up');
            $(document).on('mouseup', waitForCloseClick);
        } else {
            $('.select-box').attr('data-open', false);
        }
    });

    function waitForCloseClick() {
        $(document).unbind('mouseup');
        $('.select-box').closest('.sort-block-wrapper').find('.arrow').removeClass('up').addClass('down');
        setTimeout( function(){
            $('.select-box').attr('data-open', false );
        }, 1);
        return false;
    }

    /**
     *
     */
    $(document).on('click','#secondary .refinement ul li', function (e) {
    	 var target = $( e.target );
    	 var stateRefinement = checkStateRefinement(target);

    	 if(target.prop("tagName")!="A")
    		 {
    		 target=target.parent().parent();
    		 }

    	 if(!stateRefinement){
    		 googleTagEventRefinement(target);
    	 }
    });
}


/**
 * Check the state of refinement item in product list
 */
function googleTagEventRefinement(refinement){

	var refinementName = refinement.parent().parent().parent().children("h3").text().replace(/(\r\n|\n|\r)/gm,"");
	var refinementValue = refinement.text().replace(/(\r\n|\n|\r)/gm,"");

	if(refinementName != null && refinementValue != null){
		/* tagmanager_event('filter', {
		    'filter_name': refinementName,
		    'filter_value': refinementValue
		}); */
	}

}

function addEventsRefineBar() {
    $(document).on('click', '.refinements-mob-open', function(){
        var mobMenu = $('.refinements-mob-menu');
        if(!mobMenu.hasClass('refinements-mob-menu-active')){
            mobMenu.addClass('refinements-mob-menu-active');

            if(!$('.overlap').hasClass('overlap-active')) {
                $('.overlap').addClass('overlap-active')
            }

            $('body').addClass('menu-open');
        }

    })

    $(document).on('click', '.refinements-mob-close, .overlap-active, .refinement-clear-block .close-button', function(){
        var mobMenu = $('.refinements-mob-menu');
        if(mobMenu.hasClass('refinements-mob-menu-active')){
            mobMenu.removeClass('refinements-mob-menu-active');

            if($('.overlap').hasClass('overlap-active')) {
                $('.overlap').removeClass('overlap-active')
            }

            $('body').removeClass('menu-open');
        }

    })
}

/**
 * Check the state of refinement item in product list
 */
function checkStateRefinement(refinement){
	return refinement.parent().hasClass( "selected" );
}

exports.init = function () {
    compareWidget.init();
    if (SitePreferences.LISTING_INFINITE_SCROLL) {
        $(window).on('scroll', infiniteScroll);
    }
    productTile.init();
    initializeEvents();
    addEventsRefineBar();
};

},{"../compare-widget":9,"../product-tile":84,"../progress":85,"../util":104,"./sliderproduct":78}],77:[function(require,module,exports){
'use strict';

var Swiper = require('swiper');
var selectionSwiper = undefined;

function initSelectionSwiper() {
    var screenWidth = $(window).width();
    if(screenWidth <= 768 && selectionSwiper == undefined) {
    	$('.selection-swiper .swiper-pagination').show();
    	selectionSwiper = new Swiper('.selection-swiper', {
        	slidesPerView: 'auto',
	        paginationClickable: true,
	        spaceBetween: 0,
	        initialSlide: 1,
	        centeredSlides: true,
	        pagination: '.selection-swiper .swiper-pagination',
        });
    } else if (screenWidth > 768 && selectionSwiper != undefined) {
		selectionSwiper.destroy();
    	selectionSwiper = undefined;
        $('.selection-grid.swiper-wrapper').removeAttr('style');
    	$('.selection-swiper .swiper-pagination').hide();
    }
}

function isMoreSelection() {
	if (window.matchMedia("(min-width: 50rem) and (max-width: 65rem)").matches) {
		if ($('.selection-grid li').length < 9) {
			$('.selection-button-container').hide();
		} else {
			$('.selection-button-container').show();
		}
	} else if (window.matchMedia("(max-width: 30rem)").matches){
		$('.js-selection-button').hide();
	} else {
		if ($('.selection-grid li').length < 8) {
			$('.selection-button-container').hide();
		} else {
			$('.selection-button-container').show();
		}
	}
}

$('.js-selection-button').on( "click", function() {
	$('.selection-grid .hp-slot-product-selection:nth-child(8n)').toggle();
	var text = $(this).text();
    $(this).text(
        text == "En voir plus" ? "En voir moins" : "En voir plus");
});

function showSelectionItem() {
	$('.js-selection-button').text('En voir moins');
	if (window.matchMedia("(max-width: 50rem)").matches) {
		$('.selection-grid .hp-slot-product-selection:nth-child(n + 8)').show();				
	} else if (window.matchMedia("(max-width: 65rem)").matches) {
		$('.selection-grid .hp-slot-product-selection:nth-child(8n)').attr('style', '')
		$('.selection-grid .hp-slot-product-selection:nth-child(n + 9)').show();	
	} else {
		$('.selection-grid .hp-slot-product-selection:nth-child(n + 8)').show();		
	}	
}

function hideSelectionItem() {
	$('.js-selection-button').text('En voir plus');
	if (window.matchMedia("(max-width: 50rem)").matches) {
		$('.selection-grid .hp-slot-product-selection:nth-child(n + 8)').hide();				
	} else if (window.matchMedia("(max-width: 65rem)").matches) {
		$('.selection-grid .hp-slot-product-selection:nth-child(8n)').attr('style', '')
		$('.selection-grid .hp-slot-product-selection:nth-child(n + 9)').hide();	
		
	} else {
		$('.selection-grid .hp-slot-product-selection:nth-child(n + 8)').hide();		
	}
}

$('.js-selection-button').on( "click", function() {
	if	($(this).hasClass('show')) {
		$(this).removeClass('show');
		hideSelectionItem();
	} else {
		$(this).addClass('show');
		showSelectionItem();
	}
});

//Swiper plugin initialization
initSelectionSwiper();
isMoreSelection();

//Swiper plugin initialization on window resize
$(window).on('resize', function(){
	initSelectionSwiper();
	isMoreSelection();
});

},{"swiper":145}],78:[function(require,module,exports){
'use strict';

var productTile = require('../product-tile');

module.exports.init = function() {
    if ($('.swiperProducts').length) {
        var mobileWidth = 543;
        var screenWidth = $(window).width();
        var swiperIDElem = [...document.querySelectorAll('.swiperProducts')].map((elem) => createSwiper(elem.id));

        function createSwiper(elementeid) {
            var elementID = '#' + elementeid;
            var element = $(elementID);
            var isloop = element.data('loop');

            // remove empty sliders first
            element.find('.swiper-slide').each(function (index, el) {
                var slider = $(el);
                if (!slider.html().trim().length) {
                    slider.remove();
                }
            });


            const swiper = new Swiper(elementID, {
                slidesPerView: 4,
                paginationClickable: true,
                spaceBetween: 38,
                loop: isloop,
                pagination: '.swiper-pagination',
                nextButton: '.swiper-button-next',
                prevButton: '.swiper-button-prev',
                breakpoints: {
                    768: {
                        slidesPerView: 1,
                        pagination: false
                    }
                },
                onInit: function (swiper) {
                    let bvTimeout;
                    const tabIndexValue = productTile.isQuickviewEnabled() ? '0' : '-1';

                    // Enable tab on slides' actionable children (desktop only), skip duplicates
                    $('.swiper-slide').not('.swiper-slide-duplicate').find('.product-tile-hover, .quickview').attr('tabindex', tabIndexValue);
                    // For duplicate slides remove them from tab order
                    $('.swiper-slide-duplicate').find('.product-tile-hover, .quickview').attr('tabindex', '-1');

                    // Enable tab on slides, skip duplicates
                    $('.swiper-slide a').not('.product-link').attr('tabindex', '0');
                    $('.swiper-slide-duplicate a').attr('tabindex', '-1');

                    function copyReviewStarsToDuplicates(swiper) {
                        const isBVLoaded = window.$BV && $(swiper.container).find('.bv-stars-container').length;
                        if (isBVLoaded) {
                            clearInterval(bvTimeout);

                            for (let i = 0; i < swiper.slides.length; i++) {
                                const $item = $(swiper.slides[i]);

                                const $thisElementReviews = $item.find('.bv-cleanslate').parent();
                                if ($thisElementReviews.length) {
                                    const index = $item.data('swiper-slide-index');
                                    const $otherElements = $(swiper.container).find('.swiper-slide[data-swiper-slide-index="' + index + '"]').not($item);

                                    if ($otherElements.length) {
                                        for (let j = 0; j < $otherElements.length; j++) {
                                            const $otherElement = $($otherElements[j]);
                                            const $otherElementReviews = $otherElement.find('#' + $thisElementReviews.attr('id'));
                                            if ($otherElementReviews.length && !$otherElementReviews.find('.bv-cleanslate').length) {
                                                $otherElementReviews.replaceWith($thisElementReviews.clone());
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }

                    bvTimeout = setInterval(function () {
                        copyReviewStarsToDuplicates(swiper);
                    }, 100);
                },
            });

            if ($(`${elementID} .swiper-slide`).length < 4 && screenWidth > mobileWidth) {
                swiper.destroy();
                $(`${elementID} .swiper-wrapper`).addClass('justify-content-center');
            }

            if ($(`${elementID} .swiper-slide`).length <= 4 && screenWidth > mobileWidth) {
                $('.swiper-pagination').remove();
            } 
        }
        productTile.init();
    }
}

},{"../product-tile":84}],79:[function(require,module,exports){
'use strict';
var Swiper = require('swiper');
var tagmanager_event = require('../tagmanager_event');

var swiper = new Swiper('#homepage-slider', {
    pagination: '#homepage-slider .swiper-pagination',
    paginationClickable: true,
    autoplay: 6000,
    speed: 800,
    autoplayDisableOnInteraction: false
});


var previousIndex = swiper.activeIndex;
},{"../tagmanager_event":101,"swiper":145}],80:[function(require,module,exports){
'use strict';
var dialog = require('../dialog'),
	util = require('../util');

exports.init = function () {
    $('.store-details-link').on('click', function (e) {
        e.preventDefault();
        dialog.open({
            url: $(e.target).attr('href'),
            options: {
                width: 'auto',
                dialogClass: 'store-modal'
            }
        });
        $('.ui-icon').removeClass('ui-button-icon-primary ui-icon ui-icon-closethick').addClass('icon icon-cross')
    });
    
    
    /**
     * Utilisation de la geolocalisation pour le store locator
     */
    if ($('form#dwfrm_storelocator_geoloc').length) {
        var inputLat = $('input[name="dwfrm_storelocator_coordGpsLat"]');
        var inputLng = $('input[name="dwfrm_storelocator_coordGpsLng"]');

        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function(position) {
                inputLat.val(position.coords.latitude);
                inputLng.val(position.coords.longitude);
            }, function (err) {
                console.warn('ERROR (' + err.code + '): ' + err.message);
            });
        }
        
        $('form#dwfrm_storelocator_geoloc').on('submit', function() {
            if (!inputLat.val() || !inputLng.val()) {
            	alert(Resources.GEOLOC_FAIL);
            	return false;
            }
        });
    }

    /**
     * appel à l'API google pour l'autocompletion de l'adresse et du CP
     */
    
    if ($('form#dwfrm_storelocator_postalCode_city').length) {
    	
    	var placeSearch, autocomplete, elementAutoCpl = /** @type {!HTMLInputElement} */($('input[name="dwfrm_storelocator_postalCode__city"]')[0]);
    	var countryCode = 'fr';
    	if ($('input[name="dwfrm_storelocator_countryCode"]').length) {
            countryCode = ($('input[name="dwfrm_storelocator_countryCode"]')[0]).value;
    	}
    	
    	var defaultLocation = Resources.CODE_POSTAL;    	
    	if ($('input[name="dwfrm_storelocator_defaultLocation"]').length) {
            defaultLocation = ($('input[name="dwfrm_storelocator_defaultLocation"]')[0]).value;
    	}
        elementAutoCpl.placeholder = defaultLocation;
        
        autocomplete = new google.maps.places.Autocomplete(
        		elementAutoCpl,
                {
                	types: ['geocode'],	
                	componentRestrictions: {country: countryCode}
                });
                autocomplete.addListener('place_changed', function() {
                    var place = autocomplete.getPlace();
                    var storelocLat = place.geometry.location.lat();
                    var storelocLng = place.geometry.location.lng();
                    $('input[name="dwfrm_storelocator_coordLat"]').val(storelocLat);
                    $('input[name="dwfrm_storelocator_coordLng"]').val(storelocLng);
                });
               
        
        
        if($('#dwfrm_storelocator_countryRestriction')){
        	var restriction = $('#dwfrm_storelocator_countryRestriction').val();
        	$('#dwfrm_storelocator_countryCode').val(restriction);
        	
        	$('#dwfrm_storelocator_countryRestriction').on('change', function() {
            	restriction = $('#dwfrm_storelocator_countryRestriction').val();   
            	$('#dwfrm_storelocator_countryCode').val(restriction);
            	
            	autocomplete.setComponentRestrictions({'country' : restriction});
            	
            })
        }        
        
        // if we only put a zipcode number
        $('input[name="dwfrm_storelocator_postalCode__city"]').on('change', function (e) {
            var cpWithoutGoogle = $('input[name="dwfrm_storelocator_postalCode__city"]').val();
            if (cpWithoutGoogle * 0 == 0) {
                var postal_code = cpWithoutGoogle;
                $('input[name="dwfrm_storelocator_postalCode"]').val(postal_code);
                return;
            }
        })

        // if we use autocomplete
        autocomplete.addListener('place_changed', fillCoorGps);


        /** $('input[name="dwfrm_storelocator_postalCode__city"]').keypress(function (e) {
            if (e.keyCode == 13) {
                e.preventDefault();
                $(e.target).blur();
                if($(".pac-container .pac-item:first span:eq(3)").text() == "")
                    var firstResult = $(".pac-container .pac-item:first .pac-item-query").text();
                else
                    var firstResult = $(".pac-container .pac-item:first .pac-item-query").text() + ", " + $(".pac-container .pac-item:first span:eq(3)").text();

                var geocoder = new google.maps.Geocoder();
                geocoder.geocode({"address":firstResult }, function(results, status) {
                    if (status == google.maps.GeocoderStatus.OK) {
                        var placeName = results[0];
                        e.target.value = firstResult;
                        fillCoorGps(placeName);
                        document.getElementById("dwfrm_storelocator_postalCode_city").submit();
                        return false;
                    }
                });
            }

        });*/

        $('input[name="dwfrm_storelocator_postalCode__city"]').keypress(function(e) {
    	  if (e.which == 13) {
              e.preventDefault();
              return false;
    	  }
    	});
    }

	function fillCoorGps() {
	    // Get the place details from the autocomplete object.
        var place = autocomplete.getPlace(), postal_code;
	    if (place.geometry) {
	    	var longitudePlace = place.geometry.location.lng(), latitudePlace = place.geometry.location.lat();
	    	var url = "https://maps.googleapis.com/maps/api/geocode/json?latlng="+latitudePlace+','+longitudePlace;

	    	$.getJSON(
    			url
			)
			.done(function(data){
				$.each(data.results, function(key, val){
					$.each(val.address_components, function(addr_key, addr_val) {
						if (addr_val.types[0] == 'postal_code') {
							postal_code = addr_val.long_name;
							return false;
						}
					});
                });
                
                var comps = place.address_components;
                for (var i = 0; i < comps.length; i++) {
                    var comp = comps[i];
                    if (comp.types.indexOf('postal_code') > -1) {
                        postal_code = comp.short_name;
                        $('input[name="dwfrm_storelocator_postalCode"]').val(postal_code);
                        return;
                    }
                }
                for (var i = 0; i < comps.length; i++) {
                    if (comp.short_name * 0 == 0 ) {
                        postal_code = comp.short_name;
                        $('input[name="dwfrm_storelocator_postalCode"]').val(postal_code);
                        return;
                    }
                }
			});
	    } else {
	    	if ($('input[name="dwfrm_storelocator_city"]').length)
	    		$('input[name="dwfrm_storelocator_city"]')[0].placeholder = Resources.CODE_POSTAL;
	    }
	}
};
},{"../dialog":14,"../util":104}],81:[function(require,module,exports){
/* handling clicks on next / prev / year buttons*/
const prevButton = document.querySelector('#corpo-timeline-control--prev');
const nextButton = document.querySelector('#corpo-timeline-control--next');
prevButton.addEventListener('click', timelineGoPrev);
nextButton.addEventListener('click', timelineGoNext);
const yearButtons = document.querySelectorAll('.corpo-timeline-YearItem');

for (var i = 0; i < yearButtons.length; i++) {
	yearButtons[i].addEventListener('click', goToSlide);
}

var currentYearItem = document.querySelector('.corpo-timeline-YearItem--active');
var currentSlide = document.querySelector('.corpo-timeline-slide--active');
var currentSlideIndex = 0;

const slider = document.querySelector('.corpo-timeline-slides');
const slide = document.querySelector('.corpo-timeline-slide');
const slideList = document.querySelectorAll('.corpo-timeline-slide');
var running = false;

initTimeLineSwiper();

function initTimeLineSwiper() {
	slideWidth = document.querySelector('.corpo-timeline-slidesWrapper').offsetWidth;
	for (var i = 0; i < slideList.length; i++) {
		slideList[i].style.width = (slideWidth) + 'px';
	}
	/* defining a slide's size */
	slider.style.width = (slideWidth*slideList.length) + 'px';

	/* initlializing the slider position */
	timelineMoveSlide();
}

function goToSlide(e) {
	const clickedEl = e.currentTarget;
	for (var i = 0; i < yearButtons.length; i++) {
		if (yearButtons[i].getAttribute('data-target') === clickedEl.getAttribute('data-target')){
			currentSlideIndex = i;
			timelineUpdateCurrentSlide();
			timelineUpdateYearButton();
		}
		timelineCheckLimits(); 
	}
	slider.style.left = - currentSlideIndex * slideWidth + 'px';
}

function timelineGoNext() {
	if (!running) {
		running = true;
		currentSlideIndex ++;
		timelineMoveSlide();
		prevButton.classList.remove('corpo-timeline-control--hidden');
		setTimeout(function(){
			running = false;
		}, 401)
	}
}

function timelineGoPrev(e) {
	if (!running) {
		running = true;
		currentSlideIndex --;
		timelineMoveSlide();
		nextButton.classList.remove('corpo-timeline-control--hidden');
		setTimeout(function(){
			running = false;
		}, 401)
	}
}

function timelineMoveSlide() {
	timelineUpdateYearButton();
	timelineUpdateCurrentSlide();
	slider.style.left = - currentSlideIndex * slideWidth + 'px';
	timelineCheckLimits();
}

function timelineCheckLimits() {
	if(currentSlideIndex === slideList.length - 1) {
		nextButton.classList.add('corpo-timeline-control--hidden')
	} else {
		nextButton.classList.remove('corpo-timeline-control--hidden')
	}
	if(currentSlideIndex === 0) {
		prevButton.classList.add('corpo-timeline-control--hidden')
	} else {
		prevButton.classList.remove('corpo-timeline-control--hidden')
	}
}

function timelineUpdateYearButton() {
	currentYearItem.classList.remove('corpo-timeline-YearItem--active');
    currentYearItem = yearButtons[currentSlideIndex];
    currentYearItem.classList.add('corpo-timeline-YearItem--active');
    const siblings = document.querySelectorAll('.corpo-timeline-YearItem--sibling')
    for (var i = 0; i < siblings.length; i++) {                    
    	siblings[i].classList.remove('corpo-timeline-YearItem--sibling')
    }
    if(currentSlideIndex < slideList.length - 1) {
    	yearButtons[currentSlideIndex + 1].classList.add('corpo-timeline-YearItem--sibling');
    }
    if(currentSlideIndex > 0 ) {
    	yearButtons[currentSlideIndex - 1].classList.add('corpo-timeline-YearItem--sibling');
    }    
}

function timelineUpdateCurrentSlide() {
	currentSlide.classList.remove('corpo-timeline-slide--active');
    currentSlide = slideList[currentSlideIndex];
    currentSlide.classList.add('corpo-timeline-slide--active');
}
  
window.onresize = function() {
	  initTimeLineSwiper();
};

},{}],82:[function(require,module,exports){
'use strict';

var addProductToCart = require('./product/addToCart'),
    page = require('../page'),
    login = require('../login'),
    util = require('../util');

exports.init = function () {
    addProductToCart();
    $('#editAddress').on('change', function () {
        page.redirect(util.appendParamToURL(Urls.wishlistAddress, 'AddressID', $(this).val()));
    });

    //add js logic to remove the , from the qty feild to pass regex expression on client side
    $('.option-quantity-desired input').on('focusout', function () {
        $(this).val($(this).val().replace(',', ''));
    });

    login.init();

};

},{"../login":34,"../page":37,"../util":104,"./product/addToCart":57}],83:[function(require,module,exports){
var popinAsset = document.querySelector('#popin .content-asset');
if (popinAsset) {
    var setCookie = require('../tls').setCookie;

    function cookieExists() {
        var cookies = document.cookie.split(';');
        for (var i = 0; i < cookies.length; i++) {
            var tokens = cookies[i].split('=');
            var cookieKey = tokens[0].trim();
            if (cookieKey === 'popin') {
                return true;
            }
        }
        return false;
    }

    if ( !cookieExists() ) {
        var popin = document.getElementById('popin');
        popin.style.display = 'flex'; // show popin
        var button = document.querySelector('#popin button');
        button.addEventListener('click', function (e) {
            popin.style.display = 'none';
            setCookie('popin', 'true', 6 * 60);
        })
    }
}
},{"../tls":102}],84:[function(require,module,exports){
'use strict';

var imagesLoaded = require('imagesloaded'),
    quickview = require('./quickview'),
    euGaran = require('./euGaran'),
    quickviewMininumWidth = 1360;

/**
 * Determines whether quick view should be interactive for the current viewport.
 *
 * @returns {boolean} True when quick view should be focusable/actionable.
 */
function isQuickviewEnabled() {
    return !$('.mobile-menu-toggler').is(':visible') && $(window).width() >= quickviewMininumWidth;
}

/**
 * Updates quick view-related tabindex values based on the current viewport.
 *
 * @param {jQuery} [$scope] - Optional context used to limit the updated elements.
 */
function updateQuickviewTabIndex($scope) {
    const $context = $scope || $(document);
    const tabIndexValue = isQuickviewEnabled() ? '0' : '-1';

    $context.find('.quickviewbutton').not('.swiper-slide-duplicate .quickviewbutton').attr('tabindex', tabIndexValue);
    $context.find('.swiper-slide-duplicate .quickviewbutton').attr('tabindex', '-1');
    $context.find('.product-tile-hover[tabindex]').not('.swiper-slide-duplicate .product-tile-hover').attr('tabindex', 0);
}

function initQuickViewButtons() {
    $(document).on('click keydown', '.quickviewbutton', function (e) {
        if (isQuickviewEnabled()) {
            if (e.type === 'keydown') {
                var code = e.which || e.keyCode;
                if (code !== 13 && code !== 32) {
                    return;
                }
            }

            e.preventDefault();
            quickview.show({
                url: $(this).attr('data-href'),
                source: 'quickview'
            });
        }
    });
}

function gridViewToggle() {
    $('.toggle-grid').on('click', function () {
        $('.search-result-content').toggleClass('wide-tiles');
        $(this).toggleClass('wide');
    });
}

/**
 * @private
 * @function
 * @description Initializes events on the product-tile for the following elements:
 * - swatches
 * - thumbnails
 */
function initializeEvents() {
    initQuickViewButtons();
    gridViewToggle();
    updateQuickviewTabIndex();
    $(window).off('resize.quickviewtabindex').on('resize.quickviewtabindex', function () {
        updateQuickviewTabIndex();
    });
    $('.swatch-list').on('mouseleave', function () {
        // Restore current thumb image
        var $tile = $(this).closest('.product-tile'),
            $thumb = $tile.find('.product-image .thumb-link img').eq(0),
            data = $thumb.data('current');

        $thumb.attr({
            src: data.src,
            alt: data.alt,
            title: data.title
        });
    });

    $(document).on('mouseenter touchstart keydown', '.product-tile-hover', function (e) {
        if (e.type === 'keydown') {
            var code = e.which || e.keyCode;
            var $anchorLink = $(this).closest('a').attr('href');

            if (code !== 13 && code !== 32) {
                return;
            }

            e.preventDefault();

            if ($anchorLink.length > 0) {
                window.location.href = $anchorLink;
            }
        }

        var $img = $(this).find('.hover-img');
        if (!$img.attr('src')) {
            $img.attr('src', $img.data('imagesrc'));
        }
    })

    $('.swatch-list .swatch').on('click', function (e) {
        e.preventDefault();
        if ($(this).hasClass('selected')) { return; }

        var $tile = $(this).closest('.product-tile');
        $(this).closest('.swatch-list').find('.swatch.selected').removeClass('selected');
        $(this).addClass('selected');
        $tile.find('.thumb-link').attr('href', $(this).attr('href'));
        $tile.find('name-link').attr('href', $(this).attr('href'));

        var data = $(this).children('img').filter(':first').data('thumb');
        var $thumb = $tile.find('.product-image .thumb-link img').eq(0);
        var currentAttrs = {
            src: data.src,
            alt: data.alt,
            title: data.title
        };
        $thumb.attr(currentAttrs);
        $thumb.data('current', currentAttrs);
    }).on('mouseenter', function () {
        // get current thumb details
        var $tile = $(this).closest('.product-tile'),
            $thumb = $tile.find('.product-image .thumb-link img').eq(0),
            data = $(this).children('img').filter(':first').data('thumb'),
            current = $thumb.data('current');

        // If this is the first time, then record the current img
        if (!current) {
            $thumb.data('current', {
                src: $thumb[0].src,
                alt: $thumb[0].alt,
                title: $thumb[0].title
            });
        }

        // Set the tile image to the values provided on the swatch data attributes
        $thumb.attr({
            src: data.src,
            alt: data.alt,
            title: data.title
        });
    });
}

exports.init = function () {
    var $tiles = $('.tiles-container .product-tile');

    if ($tiles.length === 0) { return; }
    imagesLoaded('.tiles-container').on('done', function () {
        $tiles.each(function (idx) {
                $(this).data('idx', idx);
            });
    });

    initializeEvents();
};

exports.updateQuickviewTabIndex = updateQuickviewTabIndex;
exports.isQuickviewEnabled = isQuickviewEnabled;

},{"./euGaran":15,"./quickview":86,"imagesloaded":124}],85:[function(require,module,exports){
'use strict';

var $loader;

/**
 * @function
 * @description Shows an AJAX-loader on top of a given container
 * @param {Element} container The Element on top of which the AJAX-Loader will be shown
 */
var show = function (container) {
    var target = (!container || $(container).length === 0) ? $('body') : $(container);
    $loader = $loader || $('.loader');

    if ($loader.length === 0) {
        $loader = $('<div/>').addClass('loader')
            .append($('<div/>').addClass('loader-indicator'), $('<div/>').addClass('loader-bg'));
    }
    return $loader.appendTo(target).show();
};
/**
 * @function
 * @description Hides an AJAX-loader
 */
var hide = function () {
    if ($loader) {
        $loader.hide();
    }
};

exports.show = show;
exports.hide = hide;

},{}],86:[function(require,module,exports){
'use strict';

var dialog = require('./dialog'),
    product = require('./pages/product'),
    util = require('./util'),
    _ = require('lodash');


var makeUrl = function (url, source, productListID) {
    if (source) {
        url = util.appendParamToURL(url, 'source', source);
    }
    if (productListID) {
        url = util.appendParamToURL(url, 'productlistid', productListID);
    }
    return url;
};

var removeParam = function (url) {
    if (url.indexOf('?') !== -1) {
        return url.substring(0, url.indexOf('?'));
    } else {
        return url;
    }
};

var quickview = {
    init: function () {
        if (!this.exists()) {
            this.$container = $('<div/>').attr('id', 'QuickViewDialog').appendTo(document.body);
        }
        this.productLinks = $('#search-result-items .thumb-link').map(function (index, thumbLink) {
            return $(thumbLink).attr('href');
        });
    },

    setup: function (qvUrl) {
        var $btnNext = $('.quickview-next'),
            $btnPrev = $('.quickview-prev');

        product.initializeEvents();

        this.productLinkIndex = _(this.productLinks).findIndex(function (url) {
            return removeParam(url) === removeParam(qvUrl);
        });

        // hide the buttons on the compare page or when there are no other products
        if (this.productLinks.length <= 1 || $('.compareremovecell').length > 0) {
            $btnNext.hide();
            $btnPrev.hide();
            return;
        }

        if (this.productLinkIndex === this.productLinks.length - 1) {
            $btnNext.attr('disabled', 'disabled');
        }
        if (this.productLinkIndex === 0) {
            $btnPrev.attr('disabled', 'disabled');
        }

        $btnNext.on('click', function (e) {
            e.preventDefault();
            this.navigateQuickview(1);
        }.bind(this));
        $btnPrev.on('click', function (e) {
            e.preventDefault();
            this.navigateQuickview(-1);
        }.bind(this));
    },

    /**
     * @param {Number} step - How many products away from current product to navigate to. Negative number means navigate backward
     */
    navigateQuickview: function (step) {
        // default step to 0
        this.productLinkIndex += (step ? step : 0);
        var url = makeUrl(this.productLinks[this.productLinkIndex], 'quickview');
        dialog.replace({
            url: url,
            callback: this.setup.bind(this, url)
        });
    },

    /**
     * @description show quick view dialog
     * @param {Object} options
     * @param {String} options.url - url of the product details
     * @param {String} options.source - source of the dialog to be appended to URL
     * @param {String} options.productlistid - to be appended to URL
     * @param {Function} options.callback - callback once the dialog is opened
     */
    show: function (options) {
        var url;
        if (!this.exists()) {
            this.init();
        }
        url = makeUrl(options.url, options.source, options.productlistid);

        dialog.open({
            target: this.$container,
            url: url,
            options: {
                width: 990,
                dialogClass: "quickview-modal",
                title: Resources.QUICK_VIEW_POPUP,
                open: function () {
                    this.setup(url);
                    $('.ui-widget-overlay').bind('click',function(){
                        $('.quickview-modal .ui-dialog-titlebar-close').trigger('click');
                    })
                    if (typeof options.callback === 'function') { options.callback(); }
                    product.showSellableOnline();
                }.bind(this)
            }
        });
    },
    exists: function () {
        return this.$container && (this.$container.length > 0);
    }
};

module.exports = quickview;

},{"./dialog":14,"./pages/product":63,"./util":104,"lodash":125}],87:[function(require,module,exports){
'use strict';

/**
 * copied from https://github.com/darkskyapp/string-hash
 */
function hashFn(str) {
    var hash = 5381,
        i = str.length;

    while (i) {
        hash = (hash * 33) ^ str.charCodeAt(--i);
    }
    /* JavaScript does bitwise operations (like XOR, above) on 32-bit signed
    * integers. Since we want the results to be always positive, convert the
    * signed int to an unsigned by doing an unsigned bitshift. */
    return hash >>> 0;
}

/**
 * Create rating based on hash ranging from 2-5
 * @param pid
 */
function getRating(pid) {
    return hashFn(pid.toString()) % 30 / 10 + 2;
}

module.exports = {
    init: function () {
        // $('.product-review').each(function (index, review) {
        //     var pid = $(review).data('pid');
        //     if (!pid) {
        //         return;
        //     }
        //     // rating range from 2 - 5
        //     var rating = getRating(pid);
        //     var baseRating = Math.floor(rating);
        //     var starsCount = 0;
        //     for (var i = 0; i < baseRating; i++) {
        //         $('.rating', review).append('<i class="fa fa-star"></i>');
        //         starsCount++;
        //     }
        //     // give half star for anything in between
        //     if (rating > baseRating) {
        //         $('.rating', review).append('<i class="fa fa-star-half-o"></i>');
        //         starsCount++;
        //     }
        //     if (starsCount < 5) {
        //         for (var j = 0; j < 5 - starsCount; j++) {
        //             $('.rating', review).append('<i class="fa fa-star-o"></i>');
        //         }
        //     }
        // });
    }
};

},{}],88:[function(require,module,exports){
module.exports = window.Patterns;

},{}],89:[function(require,module,exports){
'use strict';

module.exports = function() {
	function enhanceErrorForm($element) {
		if (!$element.attr('role')) {
			$element.attr('role', 'alert');
		}
		if (!$element.attr('aria-live')) {
			$element.attr('aria-live', 'polite');
		}
		if (!$element.attr('aria-atomic')) {
			$element.attr('aria-atomic', 'true');
		}
		if (!$element.attr('tabindex')) {
			$element.attr('tabindex', '0');
		}
		if (!$element.attr('aria-label')) {
			let errorText = $.trim($element.text());
			if (errorText.length > 0) {
				$element.attr('aria-label', errorText);
			}
		}
	}

	$(document).on('submit', '#order-items-form', function(e) {
		e.preventDefault();
		var $form = $(this);
		var windowReference = window.open();

        $.ajax({
            url: $form.attr('action'),
			type: $form.attr('method'),
            data: $form.serialize(),
            success: function( data ) {
				if (data.url.toString().length > 0) {
					// open new tab workaround for IOS devices
					windowReference.location = data.url.toString();
				}

				if ( data.rmano.toString().length > 0 ) {
					//Need to move this to a resource
					let $message = $('.return-rma-message');
					$message.removeClass('d-none');
					$('.return-rma-order').html(data.rmano.toString());
					enhanceErrorForm($message);
					$message.focus();
				}
			},
            error: function(xhr, err) {
                alert('Error');
			}
        });
        return false;
	});
	// Show and Hide Submit Order Return Button
	$('.line-item-return .input-checkbox, .returnqty-input input.input-text').on('keyup change', function() {
		// disable submit return form button by default
		$('button#return-items').attr('disabled', true);
		$('.return-reason-action').addClass('inactive');

		if (checkOrderReturnInputsValidity()) {
			$('button#return-items').attr('disabled', false);
			$('.return-reason-action').removeClass('inactive');
		}
	});
	// checks user input on order return form
	function checkOrderReturnInputsValidity() {
		const $allItemRows = $('.order-item-row');
		const $allInValidItemRows = $allItemRows.filter((index, item) => {
			const $userInput = $(item).find('.returnqty-input input');
			const isCheckedReturnCheckbox = $(item).find('.line-item-return .input-checkbox').is(':checked');

			return !$userInput.val() || (!$userInput.valid() || !isCheckedReturnCheckbox);
		});

		const $allEmptyItemRows = $allItemRows.filter((index, item) => {
			const $userInput = $(item).find('.returnqty-input input');
			const isCheckedReturnCheckbox = $(item).find('.line-item-return .input-checkbox').is(':checked');

			return !$userInput.val() && !isCheckedReturnCheckbox;
		});

		return $allEmptyItemRows.length < $allItemRows.length && $allInValidItemRows.length - $allEmptyItemRows.length === 0;
	}

    $(document).on('submit', '#order-items-form-eu', function(e) {
        e.preventDefault();
        var $form = $(this);

        $.ajax({
            url: $form.attr('action'),
            type: $form.attr('method'),
            data: $form.serialize(),
            success: function(data) {
                if (data.success) {
                    var $duplicateMessage = $('.eu-return-duplicate-message');
                    var $confirmation = $('.eu-return-confirmation');
                    $confirmation.addClass('d-none');
                    $duplicateMessage.addClass('d-none');

                    if (data.returnAlreadyRequested) {
                        $duplicateMessage.find('.eu-return-duplicate-product-name').text(
                            data.productNames.join(', ')
                        );
                        $duplicateMessage.removeClass('d-none');
                    } else {
                        var submittedAt = new Date(data.submittedAt);
                        $confirmation.find('.eu-return-submission-date').text(submittedAt.toLocaleString());
                        $confirmation.removeClass('d-none');
                    }
                }
            },
            error: function(xhr, err) {
                alert('Error');
            }
        });
        return false;
    });
};

},{}],90:[function(require,module,exports){
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
  typeof module === "object" ? module.exports : {}
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  Function("r", "regeneratorRuntime = r")(runtime);
}

},{}],91:[function(require,module,exports){
'use strict';

/**
 * @private
 * @function
 * @description Binds event to the place holder (.blur)
 */
function initializeEvents() {
    $('#q').focus(function () {
        var input = $(this);
        if (input.val() === input.attr('placeholder')) {
            input.val('');
        }
    })
    .blur(function () {
        var input = $(this);
        if (input.val() === '' || input.val() === input.attr('placeholder')) {
            input.val(input.attr('placeholder'));
        }
    })
    .blur();
}

exports.init = initializeEvents;

},{}],92:[function(require,module,exports){
'use strict';

var util = require('./util');

var currentQuery = null,
    lastQuery = null,
    runningQuery = null,
    listTotal = -1,
    listCurrent = -1,
    delay = 30,
    $resultsContainer,
    mobileWidth = 543;
/**
 * @function
 * @description Handles keyboard's arrow keys
 * @param keyCode Code of an arrow key to be handled
 */
function handleArrowKeys(keyCode) {
    switch (keyCode) {
        case 38:
            // keyUp
            listCurrent = (listCurrent <= 0) ? (listTotal - 1) : (listCurrent - 1);
            break;
        case 40:
            // keyDown
            listCurrent = (listCurrent >= listTotal - 1) ? 0 : listCurrent + 1;
            break;
        default:
            // reset
            listCurrent = -1;
            return false;
    }

    $resultsContainer.children().removeClass('selected').eq(listCurrent).addClass('selected');
    $('input[name="q"]').val($resultsContainer.find('.selected .suggestionterm').first().text());
    return true;
}

var searchsuggest = {
    /**
     * @function
     * @description Configures parameters and required object instances
     */
    init: function (container, defaultValue) {
        var $searchContainer = $(container);
        var $searchForm = $searchContainer.find('form[name="simpleSearch"]');
        var $searchField = $searchForm.find('input[name="q"]');

        // disable browser auto complete
        $searchField.attr('autocomplete', 'off');

        // on focus listener (clear default value)
        $searchField.focus(function () {
            if (!$resultsContainer) {
                // create results container if needed
                $resultsContainer = $('<div/>').attr('id', 'search-suggestions').appendTo($searchContainer);
            }
            if ($searchField.val() === defaultValue) {
                $searchField.val('');
            }
        });

        $(document).on('click', function (e) {
            if ($resultsContainer && $resultsContainer.has(e.target).length === 0 || e.target.classList.contains('close-suggestions')) {
                setTimeout(this.clearResults, 200);
            }
        }.bind(this));
        // on key up listener, pro checkbox
        $(document).on('click', '.suggestion-checkbox-pro' ,function () {
            $searchField.trigger('pro:change');
        })

        $(document).on('touchstart','.search-suggestion-wrapper', function () {
            if ($(window).width() < mobileWidth && $searchField.attr('name') === 'q') {
                $searchField.blur()
            }
        })

        $searchField.on('keyup pro:change',function (e) {
            // get keyCode (window.event is for IE)
            var keyCode = e.keyCode || window.event.keyCode;

            // check and treat up and down arrows
            if (handleArrowKeys(keyCode)) {
                return;
            }
            // check for an ENTER or ESC
            if (keyCode === 13 || keyCode === 27) {
                this.clearResults();
                return;
            }

            currentQuery = $searchField.val().trim();

            // no query currently running, init an update
            if (!runningQuery) {
                runningQuery = currentQuery;
                setTimeout(this.suggest.bind(this), delay);
            }
        }.bind(this));
    },

    /**
     * @function
     * @description trigger suggest action
     */
    suggest: function () {
        // check whether query to execute (runningQuery) is still up to date and had not changed in the meanwhile
        // (we had a little delay)
        if (runningQuery !== currentQuery) {
            // update running query to the most recent search phrase
            runningQuery = currentQuery;
        }

        // if the current search phrase is has length less then 3 chars just return
         if (runningQuery.length < 3) {
            this.clearResults();
            runningQuery = null;
            return;
        }
        // build the request url
        var reqUrl = util.appendParamToURL(Urls.searchsuggest, 'q', runningQuery);
        if ($('.suggestion-checkbox-pro').is(':checked')) {
            reqUrl = reqUrl + '&proProductsOnly=true';
        }

        // execute server call
        $.get(reqUrl, function (data) {
            var suggestionHTML = data,
                ansLength = suggestionHTML.trim().length;

            // if there are results populate the results div
            if (ansLength === 0) {
                this.clearResults();
            } else {
                // update the results div
                $resultsContainer.html(suggestionHTML).fadeIn(200);
                if ($(window).width() < mobileWidth) {
                    $('body').addClass('menu-open');
                }
                $('header').find('.search-view-all').addClass('d-md-block');
            }

            // record the query that has been executed
            lastQuery = runningQuery;
            // reset currently running query
            runningQuery = null;

            // check for another required update (if current search phrase is different from just executed call)
            if (currentQuery !== lastQuery) {
                // ... and execute immediately if search has changed while this server call was in transit
                runningQuery = currentQuery;
                setTimeout(this.suggest.bind(this), delay);
            }
            this.hideLeftPanel();
        }.bind(this));
    },
    /**
     * @function
     * @description
     */
    clearResults: function () {
        if (!$resultsContainer) { return; }
        $resultsContainer.fadeOut(200, function () {$resultsContainer.empty();});
        $('body').removeClass('menu-open');
        $('header').find('.search-view-all').removeClass('d-md-block');
    },
    /**
     * @function
     * @description
     */
    hideLeftPanel: function () {
        //hide left panel if there is only a matching suggested custom phrase
        if ($('.search-suggestion-left-panel-hit').length === 1 && $('.search-phrase-suggestion a').text().replace(/(^[\s]+|[\s]+$)/g, '').toUpperCase() === $('.search-suggestion-left-panel-hit a').text().toUpperCase()) {
            $('.search-suggestion-left-panel').css('display', 'none');
            $('.search-suggestion-wrapper-full').addClass('search-suggestion-wrapper');
            $('.search-suggestion-wrapper').removeClass('search-suggestion-wrapper-full');
        }
    }
};

module.exports = searchsuggest;

},{"./util":104}],93:[function(require,module,exports){
'use strict';

var util = require('./util');

var currentQuery = null,
    lastQuery = null,
    runningQuery = null,
    listTotal = -1,
    listCurrent = -1,
    delay = 30,
    $resultsContainer,
    mobileWidth = 543;
/**
 * @function
 * @description Handles keyboard's arrow keys
 * @param keyCode Code of an arrow key to be handled
 */
function handleArrowKeys(keyCode) {
    switch (keyCode) {
        case 38:
            // keyUp
            listCurrent = (listCurrent <= 0) ? (listTotal - 1) : (listCurrent - 1);
            break;
        case 40:
            // keyDown
            listCurrent = (listCurrent >= listTotal - 1) ? 0 : listCurrent + 1;
            break;
        default:
            // reset
            listCurrent = -1;
            return false;
    }

    $resultsContainer.children().removeClass('selected').eq(listCurrent).addClass('selected');
    $('input[name="searchspares"]').val($resultsContainer.find('.selected .suggestionterm').first().text());
    return true;
}

var searchsuggestspares = {
    /**
     * @function
     * @description Configures parameters and required object instances
     */
    init: function (container, defaultValue) {
        var $searchContainer = $(container);
        var $searchForm = $searchContainer.find('form[name="simpleSearch"]');
        var $searchField = $searchForm.find('input[name="searchspares"]');

        // disable browser auto complete
        $searchField.attr('autocomplete', 'off');

        // on focus listener (clear default value)
        $searchField.focus(function () {
            if (!$resultsContainer) {
                // create results container if needed
                $resultsContainer = $('<div/>').attr('id', 'search-suggestions').appendTo($searchContainer);
            }
            if ($searchField.val() === defaultValue) {
                $searchField.val('');
            }
        });

        $(document).on('click', function (e) {
            if ($resultsContainer && $resultsContainer.has(e.target).length === 0 || e.target.classList.contains('close-suggestions')) {
                setTimeout(this.clearResults, 200);
            }
        }.bind(this));
        // on key up listener, pro checkbox
        $(document).on('click', '.suggestion-checkbox-pro' ,function () {
            $searchField.trigger('pro:change');
        })

        $searchField.on('keyup pro:change',function (e) {
            // get keyCode (window.event is for IE)
            var keyCode = e.keyCode || window.event.keyCode;

            // check and treat up and down arrows
            if (handleArrowKeys(keyCode)) {
                return;
            }
            // check for an ENTER or ESC
            if (keyCode === 13 || keyCode === 27) {
                this.clearResults();
                return;
            }

            currentQuery = $searchField.val().trim();

            // no query currently running, init an update
            if (!runningQuery) {
                runningQuery = currentQuery;
                setTimeout(this.suggest.bind(this), delay);
            }
        }.bind(this));
    },

    /**
     * @function
     * @description trigger suggest action
     */
    suggest: function () {
        // check whether query to execute (runningQuery) is still up to date and had not changed in the meanwhile
        // (we had a little delay)
        if (runningQuery !== currentQuery) {
            // update running query to the most recent search phrase
            runningQuery = currentQuery;
        }

        // if the current search phrase is has length less then 3 chars just return
         if (runningQuery.length < 3) {
            this.clearResults();
            runningQuery = null;
            return;
        }
        // build the request url
        var reqUrl = util.appendParamToURL(Urls.searchsuggest, 'searchspares', runningQuery);
        if ($('.suggestion-checkbox-pro').is(':checked')) {
            reqUrl = reqUrl + '&proProductsOnly=true';
        }

        // execute server call
        $.get(reqUrl, function (data) {
            var suggestionHTML = data,
                ansLength = suggestionHTML.trim().length;

            // if there are results populate the results div
            if (ansLength === 0) {
                this.clearResults();
            } else {
                // update the results div
                $resultsContainer.html(suggestionHTML).fadeIn(200);
            }

            // record the query that has been executed
            lastQuery = runningQuery;
            // reset currently running query
            runningQuery = null;

            // check for another required update (if current search phrase is different from just executed call)
            if (currentQuery !== lastQuery) {
                // ... and execute immediately if search has changed while this server call was in transit
                runningQuery = currentQuery;
                setTimeout(this.suggest.bind(this), delay);
            }
            this.hideLeftPanel();
        }.bind(this));
    },
    /**
     * @function
     * @description
     */
    clearResults: function () {
        if (!$resultsContainer) { return; }
        $resultsContainer.fadeOut(200, function () {$resultsContainer.empty();});
        $('body').removeClass('menu-open');
        $('header').find('.search-view-all').removeClass('d-md-block');
    },
    /**
     * @function
     * @description
     */
    hideLeftPanel: function () {
        //hide left panel if there is only a matching suggested custom phrase
        if ($('.search-suggestion-left-panel-hit').length === 1 && $('.search-phrase-suggestion a').text().replace(/(^[\s]+|[\s]+$)/g, '').toUpperCase() === $('.search-suggestion-left-panel-hit a').text().toUpperCase()) {
            $('.search-suggestion-left-panel').css('display', 'none');
            $('.search-suggestion-wrapper-full').addClass('search-suggestion-wrapper');
            $('.search-suggestion-wrapper').removeClass('search-suggestion-wrapper-full');
        }
    }
};

module.exports = searchsuggestspares;

},{"./util":104}],94:[function(require,module,exports){
'use strict';

if (document.querySelector('.select-address select')) {
    var selector = document.querySelector('.select-address select');
    selector.addEventListener("change", function(e) {
        var options = document.querySelectorAll('.select-address select option');
        var selectedOption;
        options.forEach( function(option) {
            if(option.value === e.target.value){
                selectedOption = option;
            }
        });

        // if the customer choose to add new address
        if (!selectedOption.value) {
            return;
        }

        var address = JSON.parse(selectedOption.dataset.address);
        var inputs = document.querySelectorAll('#primary input');
        Object.keys(address).forEach(function(ad) {
            if (ad === 'stateCode' && document.querySelector('select[id$="addressFields_states_state"]')) {
                document.querySelector('select[id$="addressFields_states_state"]').value = address[ad];
            }
            inputs.forEach( function(input) {
                if (input.id.indexOf(ad) > -1) {
                    input.value = address[ad];
                }
                if ( (input.id.indexOf('postal') > -1) && ad == 'postalCode' ) {
                    input.value = address[ad];
                }
            });
        });
        if (document.querySelector('select[id$="addressFields_country"]') && address.countryCode) {
            document.querySelector('select[id$="addressFields_country"]').value = address.countryCode;
        }
    });
}

},{}],95:[function(require,module,exports){
/* http://idangero.us/swiper/api/ lydstyl this slider is in the content asset valeurs-engagements*/

'use strict';

var initialWinWidth = $(window).width();
var maxMobileScreen = 768;

if (initialWinWidth <= maxMobileScreen) {
    var swiperButtons = document.querySelectorAll('.swiper-collaboraters [class|=swiper-button]')
    swiperButtons.forEach(function (button) {
        button.style.position = 'absolute';
    });
}

},{}],96:[function(require,module,exports){
'use strict';

var inventory = require('./');

var cartInventory = {
    setSelectedStore: function (storeId) {
        var $selectedStore = $('.store-tile.' + storeId),
            $lineItem = $('.cart-row[data-uuid="' + this.uuid + '"]'),
            storeAddress = $selectedStore.find('.store-address').html(),
            storeStatus = $selectedStore.find('.store-status').data('status'),
            storeStatusText = $selectedStore.find('.store-status').text();
        this.selectedStore = storeId;

        $lineItem.find('.instore-delivery .selected-store-address')
            .data('storeId', storeId)
            .attr('data-store-id', storeId)
            .html(storeAddress);
        $lineItem.find('.instore-delivery .selected-store-availability')
            .data('status', storeStatus)
            .attr('data-status', storeStatus)
            .text(storeStatusText);
        $lineItem.find('.instore-delivery .delivery-option').removeAttr('disabled').trigger('click');
    },
    cartSelectStore: function (selectedStore) {
        var self = this;
        inventory.getStoresInventory(this.uuid).then(function (stores) {
            inventory.selectStoreDialog({
                stores: stores,
                selectedStoreId: selectedStore,
                selectedStoreText: Resources.SELECTED_STORE,
                continueCallback: function () {},
                selectStoreCallback: self.setSelectedStore.bind(self)
            });
        }).done();
    },
    setDeliveryOption: function (value, storeId) {
        // set loading state
        $('.item-delivery-options')
            .addClass('loading')
            .children().hide();

        var data = {
            plid: this.uuid,
            storepickup: (value === 'store' ? true : false)
        };
        if (value === 'store') {
            data.storepickup = true;
            data.storeid = storeId;
        } else {
            data.storepickup = false;
        }
        $.ajax({
            url: Urls.setStorePickup,
            data: data,
            success: function () {
                // remove loading state
                $('.item-delivery-options')
                    .removeClass('loading')
                    .children().show();
            }
        });
    },
    init: function () {
        var self = this;
        $('.item-delivery-options .set-preferred-store').on('click', function (e) {
            e.preventDefault();
            self.uuid = $(this).data('uuid');
            var selectedStore = $(this).closest('.instore-delivery').find('.selected-store-address').data('storeId');
            if (!User.zip) {
                inventory.zipPrompt(function () {
                    self.cartSelectStore(selectedStore);
                });
            } else {
                self.cartSelectStore(selectedStore);
            }
        });
        $('.item-delivery-options .delivery-option').on('click', function () {
            // reset the uuid
            var selectedStore = $(this).closest('.instore-delivery').find('.selected-store-address').data('storeId');
            self.uuid = $(this).closest('.cart-row').data('uuid');
            self.setDeliveryOption($(this).val(), selectedStore);
        });
    }
};

module.exports = cartInventory;

},{"./":97}],97:[function(require,module,exports){
'use strict';

var _ = require('lodash'),
    dialog = require('../dialog'),
    TPromise = require('promise'),
    util = require('../util');

var newLine = '\n';
var storeTemplate = function (store, selectedStoreId, selectedStoreText) {
    return [
        '<li class="store-tile ' + store.storeId + (store.storeId === selectedStoreId ? ' selected' : '') + '">',
        '    <p class="store-address">',
        '        ' + store.address1 + '<br/>',
        '        ' + store.city + ', ' + store.stateCode + ' ' + store.postalCode,
        '    </p>',
        '    <p class="store-status" data-status="' + store.statusclass + '">' + store.status + '</p>',
        '    <button class="select-store-button" data-store-id="' + store.storeId + '"' +
        (store.statusclass !== 'store-in-stock' ? 'disabled="disabled"' : '') + '>',
        '        ' + (store.storeId === selectedStoreId ? selectedStoreText : Resources.SELECT_STORE),
        '    </button>',
        '</li>'
    ].join(newLine);
};

var storeListTemplate = function (stores, selectedStoreId, selectedStoreText) {
    if (stores && stores.length) {
        return [
            '<div class="store-list-container">',
            '<ul class="store-list">',
            _.map(stores, function (store) {
                return storeTemplate(store, selectedStoreId, selectedStoreText);
            }).join(newLine),
            '</ul>',
            '</div>',
            '<div class="store-list-pagination">',
            '</div>'
        ].join(newLine);
    } else {
        return '<div class="no-results">' + Resources.INVALID_ZIP + '</div>';
    }
};

var zipPromptTemplate = function () {
    return [
        '<div id="preferred-store-panel">',
        '    <input type="text" id="user-zip" placeholder="' + Resources.ENTER_ZIP + '" name="zipCode"/>',
        '</div>'
    ].join(newLine);
};

/**
 * @description test whether zipcode is valid for either US or Canada
 * @return {Boolean} true if the zipcode is valid for either country, false if it's invalid for both
 **/
var validateZipCode = function (zipCode) {
    var regexes = {
            canada: /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVWXYZ]( )?\d[ABCEGHJKLMNPRSTVWXYZ]\d$/i,
            usa: /^\d{5}(-\d{4})?$/
        },
        valid = false;
    if (!zipCode) { return; }
    _.each(regexes, function (re) {
        var regexp = new RegExp(re);
        valid = regexp.test(zipCode);
    });
    return valid;
};

var storeinventory = {
    zipPrompt: function (callback) {
        var self = this;
        dialog.open({
            html: zipPromptTemplate(),
            options: {
                title: Resources.STORE_NEAR_YOU,
                width: 500,
                buttons: [{
                    text: Resources.SEARCH,
                    click: function () {
                        var zipCode = $('#user-zip').val();
                        if (validateZipCode(zipCode)) {
                            self.setUserZip(zipCode);
                            if (callback) {
                                callback(zipCode);
                            }
                        }
                    }
                }],
                open: function () {
                    $('#user-zip').on('keypress', function (e) {
                        if (e.which === 13) {
                            // trigger the search button
                            $('.ui-dialog-buttonset .ui-button').trigger('click');
                        }
                    });
                }
            }
        });
    },
    getStoresInventory: function (pid) {
        return TPromise.resolve($.ajax({
            url: util.appendParamsToUrl(Urls.storesInventory, {
                pid: pid,
                zipCode: User.zip
            }),
            dataType: 'json'
        }));
    },
    /**
     * @description open the dialog to select store
     * @param {Array} options.stores
     * @param {String} options.selectedStoreId
     * @param {String} options.selectedStoreText
     * @param {Function} options.continueCallback
     * @param {Function} options.selectStoreCallback
     **/
    selectStoreDialog: function (options) {
        var self = this,
            stores = options.stores,
            selectedStoreId = options.selectedStoreId,
            selectedStoreText = options.selectedStoreText,
            storeList = storeListTemplate(stores, selectedStoreId, selectedStoreText);
        dialog.open({
            html: storeList,
            options: {
                title: Resources.SELECT_STORE + ' - ' + User.zip,
                buttons: [{
                    text: Resources.CHANGE_LOCATION,
                    click: function () {
                        self.setUserZip(null);
                        // trigger the event to start the process all over again
                        $('.set-preferred-store').trigger('click');
                    }.bind(this)
                }, {
                    text: Resources.CONTINUE,
                    click: function () {
                        if (options.continueCallback) {
                            options.continueCallback(stores);
                        }
                        dialog.close();
                    }
                }],
                open: function () {
                    $('.select-store-button').on('click', function (e) {
                        e.preventDefault();
                        var storeId = $(this).data('storeId');
                        // if the store is already selected, don't select again
                        if (storeId === selectedStoreId) { return; }
                        $('.store-list .store-tile.selected').removeClass('selected')
                            .find('.select-store-button').text(Resources.SELECT_STORE);
                        $(this).text(selectedStoreText)
                            .closest('.store-tile').addClass('selected');
                        if (options.selectStoreCallback) {
                            options.selectStoreCallback(storeId);
                        }
                    });
                }
            }
        });
    },
    setUserZip: function (zip) {
        User.zip = zip;
        $.ajax({
            type: 'POST',
            url: Urls.setZipCode,
            data: {
                zipCode: zip
            }
        });
    },
    shippingLoad: function () {
        var $checkoutForm = $('.address');
        $checkoutForm.off('click');
    }
};

module.exports = storeinventory;

},{"../dialog":14,"../util":104,"lodash":125,"promise":128}],98:[function(require,module,exports){
'use strict';

var _ = require('lodash'),
    inventory = require('./');

var newLine = '\n';
var pdpStoreTemplate = function (store) {
    return [
        '<li class="store-list-item ' + (store.storeId === User.storeId ? ' selected' : '') + '">',
        '    <div class="store-address">' + store.address1 + ', ' + store.city + ' ' + store.stateCode +
        ' ' + store.postalCode + '</div>',
        '    <div class="store-status" data-status="' + store.statusclass + '">' + store.status + '</div>',
        '</li>'
    ].join(newLine);
};
var pdpStoresListingTemplate = function (stores) {
    if (stores && stores.length) {
        return [
            '<div class="store-list-pdp-container">',
            (stores.length > 1 ? '    <a class="stores-toggle collapsed" href="#">' + Resources.SEE_MORE + '</a>' : ''),
            '    <ul class="store-list-pdp">',
            _.map(stores, pdpStoreTemplate).join(newLine),
            '    </ul>',
            '</div>'
        ].join(newLine);
    }
};

var storesListing = function (stores) {
    // list all stores on PDP page
    if ($('.store-list-pdp-container').length) {
        $('.store-list-pdp-container').remove();
    }
    $('.availability-results').append(pdpStoresListingTemplate(stores));
};

var productInventory = {
    setPreferredStore: function (storeId) {
        User.storeId = storeId;
        $.ajax({
            url: Urls.setPreferredStore,
            type: 'POST',
            data: {storeId: storeId}
        });
    },
    productSelectStore: function () {
        var self = this;
        inventory.getStoresInventory(this.pid).then(function (stores) {
            inventory.selectStoreDialog({
                stores: stores,
                selectedStoreId: User.storeId,
                selectedStoreText: Resources.PREFERRED_STORE,
                continueCallback: storesListing,
                selectStoreCallback: self.setPreferredStore
            });
        }).done();
    },
    init: function () {
        var $availabilityContainer = $('.availability-results'),
            self = this;
        this.pid = $('input[name="pid"]').val();

        $('#product-content .set-preferred-store').on('click', function (e) {
            e.preventDefault();
            if (!User.zip) {
                inventory.zipPrompt(function () {
                    self.productSelectStore();
                });
            } else {
                self.productSelectStore();
            }
        });

        if ($availabilityContainer.length) {
            if (User.storeId) {
                inventory.getStoresInventory(this.pid).then(storesListing);
            }

            // See more or less stores in the listing
            $availabilityContainer.on('click', '.stores-toggle', function (e) {
                e.preventDefault();
                $('.store-list-pdp .store-list-item').toggleClass('visible');
                if ($(this).hasClass('collapsed')) {
                    $(this).text(Resources.SEE_LESS);
                } else {
                    $(this).text(Resources.SEE_MORE);
                }
                $(this).toggleClass('collapsed');
            });
        }
    }
};
module.exports = productInventory;

},{"./":97,"lodash":125}],99:[function(require,module,exports){
// This script is executed only on the checkout summary page
if ((document.querySelector('.pt_checkout') || window.location.pathname.includes('billing') || window.location.pathname.toLowerCase().includes('shipping') || window.location.pathname.includes('Adyen-ShowConfirmation')) && window.isAdyenPayment) {
    var AdyenCheckout = require('@adyen/adyen-web');

    async function handleAction(action) {
        window.Configuration.onAdditionalDetails = onAdditionalDetails;
        const checkout = await AdyenCheckout(window.Configuration);
        const actionContainer = document.getElementById('action-container');
        checkout.createFromAction(action).mount(actionContainer);
    }

    // onAdditionalDetails event handler to be included in Adyen Component configuration
    var onAdditionalDetails = function (state) {
        $.ajax({
            type: 'POST',
            url: window.paymentsDetailsURL,
            data: JSON.stringify({
                data: state.data,
                orderToken: window.orderToken
            }),
            contentType: 'application/json; charset=utf-8',
            async: false,
            success: function (data) {
                if (!data.response.isFinal && typeof data.response.action === 'object') {
                    handleAction(data.action);
                } else {
                    window.location.href = data.response.redirectUrl;
                }
            }
        });
    };

    // serializes form data and submits to place order. Then proceeds to handle the result
    function placeOrder(formId) {
        const form = $('#' + formId);

        $.ajax({
            method: 'POST',
            url: window.summarySubmitUrl,
            data: $(form).serialize(),
            success: function(data) {
                if (data.action) {
                    window.orderToken = data.orderToken;
                    document.getElementById('action-modal-SG').style.display = 'block';
                    handleAction(data.action);
                } else if (data.continueUrl) {
                    window.location.href = data.continueUrl;
                } else {
                    $(`#${formId} [type="submit"]`).trigger('click');
                }
            },
            error: function() {
            }
        });
    }

    window.addEventListener('load', function () {
        $('#dwfrm_billing').one('submit', function (event) {
            if ($('.payment-method-options').find(':checked').val() !== 'PayPal') {
                event.preventDefault();
                placeOrder('dwfrm_billing');
            }
        });

        $('#summary-form').one('submit', function (event) {
            event.preventDefault();
            placeOrder('summary-form');
        });
    });
}

},{"@adyen/adyen-web":107}],100:[function(require,module,exports){
'use strict';

var tables = [];
    $('table.cgv-table').each(function() {
        var table = [];
        var thead = [];
        $( this ).find('thead tr th').each(function(i){ 
            var cell = $.trim( $( this ).text() );
            thead.push(cell);
        });
        table.push(thead);

        $( this ).find('tbody tr').each(function () {
            var row = [];
            $( this ).find('td').each(function () {
                var td = $.trim( $( this ).text() );
                row.push(td);
            });
            table.push(row);
        });
        tables.push(table);
    });

    tables.forEach( function(table, index) {
        var insertAfterTable = $('table.cgv-table').eq( index )
        var mobileTable = $( '<ul class="mobile-table"></ul>' );
        for (var i = 1; i < table.length; i++) { 
            var row = table[i];
            var li = '<li>';
            li += '<div class="h7">' + row[0] + '</div>';
            for (var j = 1; j < row.length; j++) {
                var header = table[0][j];
                var cell = row[j];
                if (cell == '') {
                    header = ''
                }
                if (header) {
                    li += '<div class="h8">' + header + '</div>';
                    li += "<p>" + cell + "</p>";
                }
            }
            li += '</li>';
            mobileTable.append( li );
        }
        mobileTable.insertAfter( insertAfterTable );
    });
},{}],101:[function(require,module,exports){
'use strict';

var tagmanager_event = function(event_name, event_data) {
	var debug = false;
	if(debug) alert('tagmanager: ' + event_name);
	if(debug) alert(JSON.stringify(event_data));
	try {
		for(var parameter in event_data) {
			var eventParam = {};
			eventParam[event_name + '_' + parameter] = event_data[parameter];
			window.dataLayer.push(eventParam);
		}
		window.dataLayer.push({event: event_name});
		// Pour l'espace de recette
		// console.log({eventData: event_data, event: event_name});
	} catch(e) {}
};

module.exports = tagmanager_event;
},{}],102:[function(require,module,exports){
'use strict';

/**
 * Checks the TLS and displays a warning if appropriate
 * @function getUserAgent Checks the TLS and displays a warning if appropriate
 **/
function getUserAgent() {
    // Use an external service to check the TLS of the browser
    // NOTE: this implementation uses https://www.howsmyssl.com
    //     you may also wish to consider the API available at https://www.ssllabs.com/projects/ssllabs-apis/index.html
    var url = 'https://www.howsmyssl.com/a/check';
    var cookieName = 'dw_TLSWarning';
    var cookieValue = getCookie(cookieName);

    // Test to see if this browser has already been flagged by looking at its cookies
    if (!cookieValue) {
        getTLS(url, function (message) {
            if (message.length > 0) {
                showWarning(message[0]);

                // the browser is bad - set the cookie to true (for 15 minutes)
                setCookie(cookieName, 'true', 15);
            } else {
                // else the browser is good, set the cookie to false (for 30 days) so we don't check again
                setCookie(cookieName, 'false', 60 * 24 * 30);
            }
        });
    } else if (cookieValue === 'true') {
        // if we already know that this is an invalid browser, show the warning
        showWarning(Resources.TLS_WARNING);
    }
}

/**
 * Calls out to the TLS service and calls the callback with a message (if necessary)
 * @function getTLS
 *
 * @param {string} url - URL of external TLS-checking API
 * @param {function} callback - function to call with response
 **/
function getTLS(url, callback) {
    var message = [];

    // First, see if the browser is among the suspect browsers to see if a TLS check is necessary
    var userAgent = navigator.userAgent;

    /** This list derived from https://www.ssllabs.com/ssltest/clients.html **/
    var badBrowsers = ['MSIE 6.0','MSIE 7.0','MSIE 8.0','MSIE 9.0','MSIE 10.0',
                       'Android 2.3.7', 'Android 4.0.4', 'Android 4.1.1', 'Android 4.2.2', 'Android 4.3',
                       'Safari 5.1.9 / OS X 10.6.8', 'Safari 6.0.4 / OS X 10.8.4 '];
    function checkTLSLevel(data) {
        // If we can determine the TLS level, check to see if it's less than 1.2
        if (parseFloat(data.tls_version.split(' ')[1]) < 1.1) {
            message.push(Resources.TLS_WARNING);
            callback(message);

            //If you want to track statistics on bad TLS hits, include this call
            $.ajax({url: Urls.TLSBadTLS});
        }
    }

    function reportBadBrowser () {
        // If the TLS level cannot be determined just report that this browser is suspect
        message.push(Resources.TLS_WARNING);
        callback(message);

        //If you want to track statistics on deprecated browsers, include this call
        $.ajax({url: Urls.TLSBadBrowser});
    }

    for (var i = 0; i < badBrowsers.length; i++) {
        if (userAgent.match(badBrowsers[i])) {
            // It's a suspect browser, let's see what it's TLS level is
            $.ajax({
                url: url
            }).done(checkTLSLevel).fail(reportBadBrowser);
            break;
        }
    }

    /** For testing purposes, uncomment this block
        message.push(Resources.TLS_WARNING);
    **/
    callback(message);
}

/**
 * @function showWarning turns on the browser-compatibility-alert and sets the message
 *
 * @param {string} message - the message that will be shown upon detection of a bad browser
 **/
function showWarning(message) {
    $('<div/>').addClass('browser-compatibility-alert').append($('<p/>').addClass('browser-error').html(message)).appendTo('#browser-check');
}

/**
 * @function getCookie
 *
 * @param {string} key - The cookie name
 * @returns {string} value - the value of the cookie if found, null otherwise
 **/
function getCookie(key) {
    var cookies = document.cookie.split(';');
    for (var i = 0; i < cookies.length; i++) {
        var tokens = cookies[i].split('=');
        var cookieKey = tokens[0].trim();
        if (cookieKey === key) {
            return tokens[1];
        }
    }
    return '';
}

/**
 * @function setCookie
 *
 * @param {string} key - The cookie name
 * @param {string} value - The cookie value
 * @param {integer} minutes - The number of minutes to expire the cookie
 **/
function setCookie (key, value, minutes) {
    var date = new Date();
    date.setTime(date + (minutes * 60 * 1000));
    document.cookie = key + '=' + value + '; expires=' + date.toGMTString() + '; path=/';
}

/**
 * Export the getUserAgent function
 */
exports.getUserAgent = getUserAgent;
exports.setCookie = setCookie;

},{}],103:[function(require,module,exports){
'use strict';

/**
 * @function
 * @description Initializes the tooltip-content and layout
 */
exports.init = function () {
    $(document).tooltip({
        items: '.tooltip',
        track: true,
        content: function () {
            return $(this).find('.tooltip-content').html();
        }
    });

    $('.share-link').on('click', function (e) {
        e.preventDefault();
        var target = $(this).data('target');
        if (!target) {
            return;
        }
        $(target).toggleClass('active');
    });
};

},{}],104:[function(require,module,exports){
'use strict';

var ajax = require("./ajax");
var _ = require('lodash');
var Swiper = require('swiper');

var swiper = new Swiper('.footer-slider', {
    slidesPerView: 'auto',
    nextButton: '.icon-arrowRight',
    prevButton: '.icon-arrowLeft',
    autoplay: 1500,
    loop: true,
    centeredSlides: true,
    autoplayDisableOnInteraction: false,
    spaceBetween: 30
});

var util = {
    /**
     * @function
     * @description appends the parameter with the given name and value to the given url and returns the changed url
     * @param {String} url the url to which the parameter will be added
     * @param {String} name the name of the parameter
     * @param {String} value the value of the parameter
     */
    appendParamToURL: function (url, name, value, name2, value2) {
        // quit if the param already exists
        if (url.indexOf(name + '=') !== -1) {
            return url;
        }
        var separator = url.indexOf('?') !== -1 ? '&' : '?';
        if (name2 && value2) {
            return url + separator + name + '=' + encodeURIComponent(value) + separator + name2 + '=' + encodeURIComponent(value2);
        } else {
            return url + separator + name + '=' + encodeURIComponent(value);
        }
    },

    /**
     * @function
     * @description remove the parameter and its value from the given url and returns the changed url
     * @param {String} url the url from which the parameter will be removed
     * @param {String} name the name of parameter that will be removed from url
     */
    removeParamFromURL: function (url, name) {
        if (url.indexOf('?') === -1 || url.indexOf(name + '=') === -1) {
            return url;
        }
        var hash;
        var params;
        var domain = url.split('?')[0];
        var paramUrl = url.split('?')[1];
        var newParams = [];
        // if there is a hash at the end, store the hash
        if (paramUrl.indexOf('#') > -1) {
            hash = paramUrl.split('#')[1] || '';
            paramUrl = paramUrl.split('#')[0];
        }
        params = paramUrl.split('&');
        for (var i = 0; i < params.length; i++) {
            // put back param to newParams array if it is not the one to be removed
            if (params[i].split('=')[0] !== name) {
                newParams.push(params[i]);
            }
        }
        return domain + '?' + newParams.join('&') + (hash ? '#' + hash : '');
    },

    /**
     * @function
     * @description appends the parameters to the given url and returns the changed url
     * @param {String} url the url to which the parameters will be added
     * @param {Object} params
     */
    appendParamsToUrl: function (url, params) {
        var _url = url;
        _.each(params, function (value, name) {
            _url = this.appendParamToURL(_url, name, value);
        }.bind(this));
        return _url;
    },
    /**
     * @function
     * @description extract the query string from URL
     * @param {String} url the url to extra query string from
     **/
    getQueryString: function (url) {
        var qs;
        if (!_.isString(url)) { return; }
        var a = document.createElement('a');
        a.href = url;
        if (a.search) {
            qs = a.search.substr(1); // remove the leading ?
        }
        return qs;
    },
    /**
     * @function
     * @description
     * @param {String}
     * @param {String}
     */
    elementInViewport: function (el, offsetToTop) {
        var top = el.offsetTop,
            left = el.offsetLeft,
            width = el.offsetWidth,
            height = el.offsetHeight;

        while (el.offsetParent) {
            el = el.offsetParent;
            top += el.offsetTop;
            left += el.offsetLeft;
        }

        if (typeof(offsetToTop) !== 'undefined') {
            top -= offsetToTop;
        }

        if (window.pageXOffset !== null) {
            return (
                top < (window.pageYOffset + window.innerHeight) &&
                left < (window.pageXOffset + window.innerWidth) &&
                (top + height) > window.pageYOffset &&
                (left + width) > window.pageXOffset
            );
        }

        if (document.compatMode === 'CSS1Compat') {
            return (
                top < (window.document.documentElement.scrollTop + window.document.documentElement.clientHeight) &&
                left < (window.document.documentElement.scrollLeft + window.document.documentElement.clientWidth) &&
                (top + height) > window.document.documentElement.scrollTop &&
                (left + width) > window.document.documentElement.scrollLeft
            );
        }
    },

    /**
     * @function
     * @description Appends the parameter 'format=ajax' to a given path
     * @param {String} path the relative path
     */
    ajaxUrl: function (path) {
        return this.appendParamToURL(path, 'format', 'ajax');
    },

    /**
     * @function
     * @description
     * @param {String} url
     */
    toAbsoluteUrl: function (url) {
        if (url.indexOf('http') !== 0 && url.charAt(0) !== '/') {
            url = '/' + url;
        }
        return url;
    },
    /**
     * @function
     * @description Loads css dynamically from given urls
     * @param {Array} urls Array of urls from which css will be dynamically loaded.
     */
    loadDynamicCss: function (urls) {
        var i, len = urls.length;
        for (i = 0; i < len; i++) {
            this.loadedCssFiles.push(this.loadCssFile(urls[i]));
        }
    },

    /**
     * @function
     * @description Loads css file dynamically from given url
     * @param {String} url The url from which css file will be dynamically loaded.
     */
    loadCssFile: function (url) {
        return $('<link/>').appendTo($('head')).attr({
            type: 'text/css',
            rel: 'stylesheet'
        }).attr('href', url); // for i.e. <9, href must be added after link has been appended to head
    },
    // array to keep track of the dynamically loaded CSS files
    loadedCssFiles: [],

    /**
     * @function
     * @description Removes all css files which were dynamically loaded
     */
    clearDynamicCss: function () {
        var i = this.loadedCssFiles.length;
        while (0 > i--) {
            $(this.loadedCssFiles[i]).remove();
        }
        this.loadedCssFiles = [];
    },
    /**
     * @function
     * @description Extracts all parameters from a given query string into an object
     * @param {String} qs The query string from which the parameters will be extracted
     */
    getQueryStringParams: function (qs) {
        if (!qs || qs.length === 0) { return {}; }
        var params = {},
            unescapedQS = decodeURIComponent(qs);
        // Use the String::replace method to iterate over each
        // name-value pair in the string.
        unescapedQS.replace(new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
            function ($0, $1, $2, $3) {
                params[$1] = $3;
            }
        );
        return params;
    },

    fillAddressFields: function (address, $form) {
        $form.find('[name$="country"]').val(address.countryCode);
        util.fillStates();
        $form.find('[name$="country"]').trigger('change');

        // wait for state ajax to end before applying the changes
        setTimeout(function () {
            for (var field in address) {
                if (field === 'ID' || field === 'UUID' || field === 'key') {
                    continue;
                }
                // if the key in address object ends with 'Code', remove that suffix
                // keys that ends with 'Code' are postalCode, stateCode and countryCode
                $form.find('[name$="' + field.replace('Code', '') + '"]').val(address[field]);
                // update the state fields
                if (['countryCode', 'stateCode'].indexOf(field) > -1) {
                    // retrigger state selection after country has changed
                    // this results in duplication of the state code, but is a necessary evil
                    // for now because sometimes countryCode comes after stateCode
                    $form.find('[name$="state"]').val(address.stateCode);
                }
            }
        }, 500);
    },
    /**
     * @function
     * @description Updates the number of the remaining character
     * based on the character limit in a text area
     */
    limitCharacters: function () {
        $('form').find('textarea[data-character-limit]').each(function () {
            var characterLimit = $(this).data('character-limit');
            var charCountHtml = String.format(Resources.CHAR_LIMIT_MSG,
                '<span class="char-remain-count">' + characterLimit + '</span>',
                '<span class="char-allowed-count">' + characterLimit + '</span>');
            var charCountContainer = $(this).next('div.char-count');
            if (charCountContainer.length === 0) {
                charCountContainer = $('<div class="char-count"/>').insertAfter($(this));
            }
            charCountContainer.html(charCountHtml);
            // trigger the keydown event so that any existing character data is calculated
            $(this).change();
        });
    },
    /**
     * @function
     * @description Binds the onclick-event to a delete button on a given container,
     * which opens a confirmation box with a given message
     * @param {String} container The name of element to which the function will be bind
     * @param {String} message The message the will be shown upon a click
     */
    setDeleteConfirmation: function (container, message) {
        $(container).on('click', '.delete', function () {
            return window.confirm(message);
        });
    },
    /**
     * @function
     * @description Scrolls a browser window to a given x point
     * @param {String} The x coordinate
     */
    scrollBrowser: function (xLocation) {
        $('html, body').animate({scrollTop: xLocation}, 500);
    },

    isMobile: function () {
        var mobileAgentHash = ['mobile', 'tablet', 'phone', 'ipad', 'ipod', 'android', 'blackberry', 'windows ce', 'opera mini', 'palm'];
        var    idx = 0;
        var isMobile = false;
        var userAgent = (navigator.userAgent).toLowerCase();

        while (mobileAgentHash[idx] && !isMobile) {
            isMobile = (userAgent.indexOf(mobileAgentHash[idx]) >= 0);
            idx++;
        }
        return isMobile;
    },

    fillStates: function() {
        $('select[name$="_country"]').on('change', function() {
            var statesField = $('select[name$="_states_state"');
            if (statesField.length > 0) {
                ajax.getJson({
                    url: util.appendParamsToUrl(Urls.getStates, {
                        countryCode: $(this).val()
                    }),
                    callback: function (data) {
                        if (data && data.states && data.states.length > 0) {
                            var stateCurrentValue = $(statesField).val();
                            $(statesField).empty();

                            data.states.forEach(function(state){
                                $(statesField).append('<option class="select-option" label="' + state.label + '" value="' + state.value + '">' + state.label + '</option>');
                            });

                            if ($(statesField).children('option[value="' + stateCurrentValue + '"]').length > 0) {
                                $(statesField).val(stateCurrentValue);
                            }
                        }
                    }
                });
            }
        })

        $('select[name$="_country"]').trigger('change');
    },

    throttle: function(fn, wait) {
        var time = Date.now();
        return function() {
          if ((time + wait - Date.now()) < 0) {
            fn();
            time = Date.now();
          }
        }
    },
    /**
     * @function
     * @description returns the file extension
     * @param {String} the file name
     */
     getFileExtension: function(fileName) {
        return fileName.substring(fileName.lastIndexOf('.') + 1, fileName.length) || fileName;
    }
};

module.exports = util;

},{"./ajax":3,"lodash":125,"swiper":145}],105:[function(require,module,exports){
"use strict";

var regex = require("./regex");

// global form validator settings
var settings = {
    ignore: '.adyen-checkout__card__holderName__input, .ignore-field', // allowing hidden fields to be validated and skip the adyen card name field as it's validate in different way
	errorClass: "error",
	errorElement: "span",
	onkeyup: false,
	onfocusout: function (element) {
		if (!this.checkable(element)) {
			this.element(element);
		}
    },
    /**
     * Keeps inline validation messages attached to the related field for screen readers.
     *
     * @param {jQuery} error Rendered error element from jQuery Validate.
     * @param {jQuery} element Field that owns the error.
     */
    errorPlacement: function (error, element) {
        // remove any other error messages for this field before showing the new one
        // as we might have some custom errors from the server-side
        let $customErrorMessages = $(element).siblings('span.error');
        let generatedFieldCounter = 0;

        if ($customErrorMessages.length) {
            $customErrorMessages.remove();
        }

        // Generate unique ID for error message if not present
        let fieldId = element.attr('id');
        if (!fieldId) {
            generatedFieldCounter += 1;
            fieldId = 'field_' + generatedFieldCounter;
            element.attr('id', fieldId);
        }
        let errorId = fieldId + '_error';
        let currentDescribedByIds = (element.attr('aria-describedby') || '').split(/\s+/).filter(Boolean);
        let mergedDescribedByIds = currentDescribedByIds.filter(function (describedById) {
            return describedById !== errorId;
        });
        mergedDescribedByIds.push(errorId);

        error.attr('id', errorId);
        element.attr('aria-describedby', mergedDescribedByIds.join(' '));
        element.attr('aria-invalid', 'true');
        element.attr('aria-errormessage', errorId);

        error.insertAfter(element);
	},
	success: function (element) {
		if ($(element).length) {
			$(element).closest("div.error").removeClass("error");
			element.attr('aria-invalid', 'false');
			let currentDescribedBy = (element.attr('aria-describedby') || '').split(/\s+/).filter(Boolean);
			let currentErrorId = (element.attr('id') || '') + '_error';
			let describedByWithoutError = currentDescribedBy.filter(function (describedById) {
				return describedById !== currentErrorId;
			});
			if (describedByWithoutError.length) {
				element.attr('aria-describedby', describedByWithoutError.join(' '));
			} else {
				element.removeAttr('aria-describedby');
			}
			element.removeAttr('aria-errormessage');
		}
	},
	invalidHandler: function (event, validator) {
		if (validator.errorList.length > 0) {
			let firstInvalidElement = validator.errorList[0].element;

			// Delay focus slightly so screen readers can pick up the updated error state.
			setTimeout(function () {
				if (typeof firstInvalidElement.scrollIntoView === 'function') {
					firstInvalidElement.scrollIntoView({ block: 'center' });
				}

				$(firstInvalidElement).focus();
			}, 700);
		}
	}
};
/**
 * @function
 * @description Validates a given phone number against the countries phone regex
 * @param {String} value The phone number which will be validated
 * @param {String} el The input field
 */
var validatePhone = function (value, el) {
	var country = $(el)
		.closest("form")
		.find(".country");

	if (country.length === 0 || !country.val()) {
		return true;
	}

	var countryValue = country.val().toLowerCase();
	if (!regex.phone[countryValue]) {
		return true;
	}

	if (countryValue === 'fr' || countryValue === 'nl' || countryValue === 'be' || countryValue === 'lu') {
		value = value.replace(/\s+/g, '');
		$(el).val(value);

		if (countryValue === 'be') {
			$.extend($.validator.messages, { phone: Resources.INVALID_PHONE_BE });
		} else {
			$.extend($.validator.messages, { phone: Resources.INVALID_PHONE });
		}
	}

	var rgx = new RegExp(regex.phone[countryValue]);

	var isOptional = this.optional(el);
	var isValid = rgx.test($.trim(value));

	return isOptional || isValid;
};

/**
 * @function
 * @description Validates that a credit card owner is not a Credit card number
 * @param {String} value The owner field which will be validated
 * @param {String} el The input field
 */
var validateOwner = function (value) {
	var rgx = new RegExp(regex.notCC);
	var isValid = rgx.test($.trim(value));
	return isValid;
};

/**
 * @function
 * @description Validates address 1 and address 2 fields
 * @param {String} value The address field which will be validated
 * @param {String} el The input field
 */
var validateAddress = function (value) {
    return value.length <= SitePreferences.ADDRESS_FIELD_LIMIT;
};

/**
 * @function
 * @description Validates the Codice Fiscale (used on italian sites)
 * @param {String} value The owner field which will be validated
 * @param {String} el The input field
 */
var validateFiscalCode = function (value, el) {
	var country = $(el).closest("form").find(".country");
	var countryCode = country.val().toLowerCase();
	var isValid = true;
	const $failedFormValidationMsgContainer = $(el).closest('.primary-content').siblings('.billing-form-validation-error');

	if (value || countryCode !== 'es') {
		var rgx = new RegExp(regex.fiscalCode[countryCode]);
		isValid = rgx.test($.trim(value));
	}
	// if a valid fiscal code value is entered and the general billing form error message is present, hide error message
	if ($failedFormValidationMsgContainer.length && isValid) {
		$failedFormValidationMsgContainer.slideUp();
	}

	return isValid;
};

/**
 * @function
 * @description Validates the email address
 * @param {String} value The email field which will be validated
 * @param {String} el The input field
 */
 var validateEmail = function (value, el) {
	var isValid = true;
	var rgx = new RegExp(regex.email);
	isValid = rgx.test($.trim(value));
	return isValid;
};

/**
 * Add phone validation method to jQuery validation plugin.
 * Text fields must have 'phone' css class to be validated as phone
 */

$('input[id$="postal"]').addClass("postal");

if (universal_variable.page.language === "nl_NL") {
	$(".contact-wrapper [id$=postalcode]").addClass("postal");
	$(".contact-wrapper [id$=postalCode]").addClass("postal");
}

if (universal_variable.page.language === "es_ES") {
	$('input[id$="postal"]').addClass("espostal-islands");
}
/**
 * @function
 * @description Validates a given postcode against the countries postcode regex
 * @param {String} value The postcode which will be validated
 * @param {String} el The input field
 */
var validatePostal = function (value, el) {
	var country = $(el)
		.closest("form")
		.find(".country");

	if (!country.length && universal_variable.page.language === "nl_NL") {
		country = universal_variable.page.language
			.substr(universal_variable.page.language.length - 2)
			.toLowerCase();
		var rgx = new RegExp(regex.postal[country], 'i');
	} else {
		var rgx = new RegExp(regex.postal[country.val().toLowerCase()], 'i');
	}

	var countryValue = country.val().toLowerCase();
	if (countryValue === 'at') {
		$.extend($.validator.messages, {postal: Resources.INVALID_POSTAL_AT});
	} else if (value.trim().length < 3) {
		$.extend($.validator.messages, {postal: Resources.INVALID_POSTCODE_FORMAT});
	} else {
		$.extend($.validator.messages, {postal: Resources.INVALID_POSTAL});
	}

	var isValid = rgx.test($.trim(value));
	if (isValid) {
		return true;
	} else {
		return false;
	}
};

/**
 * @function
 * @description Validates name format
 */
 var validateName = function (value) {
	var validNameFormatRegex = /[^\p{L}\p{Mn}\p{Pd}\\'\x2019\s]/u;

	if (validNameFormatRegex.test($.trim(value))) {
		return false;
	}
	 return true;
};

/**
 * @function
 * @description Validates name format
 */
 var validateOrganizationName = function (value) {
	var validOrganizationNameFormatRegex = new RegExp(regex.organizationName);

	if (!validOrganizationNameFormatRegex.test($.trim(value))) {
		return false;
	}
	 return true;
};

/**
 * Add name validation method to jQuery validation plugin.
 * Text fields must have '<name>' css class to be validated as name
 */
$.validator.addMethod('firstName', validateName, Resources.INVALID_FIRST_NAME_FORMAT);
$.validator.addMethod('lastName', validateName, Resources.INVALID_LAST_NAME_FORMAT);
$.validator.addMethod('firstname', validateName, Resources.INVALID_FIRST_NAME_FORMAT);
$.validator.addMethod('lastname', validateName, Resources.INVALID_LAST_NAME_FORMAT);
$.validator.addMethod('organizationName', validateOrganizationName, Resources.INVALID_FIRST_NAME_FORMAT);

$.validator.addMethod("phone", validatePhone, Resources.INVALID_PHONE);
$.validator.addMethod('fiscal-code', validateFiscalCode, Resources.VALIDATE_FISCALCODE);
$.validator.addMethod('email', validateEmail, Resources.VALIDATE_EMAIL);
/**
 * Add postcode validation method to jQuery validation plugin.
 * Text fields must have 'postal' css class to be validated as postcode
 */
$.validator.addMethod("postal", validatePostal, Resources.INVALID_POSTAL);

/**
 * Add CCOwner validation method to jQuery validation plugin.
 * Text fields must have 'owner' css class to be validated as not a credit card
 */
$.validator.addMethod("owner", validateOwner, Resources.INVALID_OWNER);

/**
 * Add address validation method to jQuery validation plugin.
 * Text fields must have 'address' css class to be validated as not a credit card
 */
$.validator.addMethod('address', validateAddress, Resources.VALIDATE_MAXLENGT_ADDRESS);

/**
 * Add gift cert amount validation method to jQuery validation plugin.
 * Text fields must have 'gift-cert-amont' css class to be validated
 */
$.validator.addMethod(
	"gift-cert-amount",
	function (value, el) {
		var isOptional = this.optional(el);
		var isValid =
			!isNaN(value) &&
			parseFloat(value) >= 5 &&
			parseFloat(value) <= 5000;
		return isOptional || isValid;
	},
	Resources.GIFT_CERT_AMOUNT_INVALID
);

/**
 * Add validation method to jQuery validation plugin.
 * Text fields must have 'js-other' css class to be validated
 */
$.validator.addMethod(
	"js-other",
	function (value, el) {
		var isValid = $('#dwfrm_contactus_category').find(':selected').val() === 'other'

		return isValid;
	},
	Resources.GIFT_CERT_AMOUNT_INVALID
);

/**
 * Add positive number validation method to jQuery validation plugin.
 * Text fields must have 'positivenumber' css class to be validated as positivenumber
 */
$.validator.addMethod(
	"positivenumber",
	function (value) {
		if ($.trim(value).length === 0) {
			return true;
		}
		return !isNaN(value) && Number(value) >= 0;
	},
	""
); // '' should be replaced with error message if needed



/**
 * Add additional postal code validation to exclude canaries islands and get custom error message for them
 * Input field must have 'espostal-islands' css class to be validated as es canary islands exclusiveness
 * The follwing are being excluded:
 * 35XXX-Las Palmas de Gran Canaria
 * 38XXX-Santa Cruz de Tenerife
 * 51XXX-Ceuta
 * 52XXX-Melilla
 */
if (universal_variable.page.language === "es_ES") {
	var isOneOfCanariesIslands = function (value, el) {
		var rgx = /^(?:35|38|51|52)\d{3}$/;

		var isForbiddenIsland = rgx.test($.trim(value));
		return !isForbiddenIsland;
	};

	$.validator.addMethod(
		"espostal-islands",
		isOneOfCanariesIslands,
		Resources.VALIDATE_CANARYISLANDS
	);
}

/**
 * Add custom max length validation method to jQuery validation plugin.
 * Text fields must have 'positivenumber' css class to be validated as positivenumber
 */
 $.validator.addMethod(
	"custom-max-length",
	function (value, el) {
		return typeof $(el).data('maxlength') === 'undefined' || $.trim(value).length <= $(el).data('maxlength');
	},
	function (value, el) {
		return $.validator.format(Resources.VALIDATE_MAXLENGTH, $(el).data('maxlength') || 35);
	}
);

$.validator.addMethod("valueNotEquals", function(value, element, arg){
	return arg !== value;
}, Resources.VALIDATE_REQUIRED);

$.validator.addMethod("maxReturnQty", function (value, element) {
	if (value.trim().length) {
		return parseInt($(element).attr('maxReturnQty')) >= parseInt(value);
	}
	return true;
}, Resources.VALIDATE_RETURN_MAX_QTY);

$.validator.addMethod("newsletterRequired", function (value, element) {
	return $(element).is(':checked');
}, Resources.VALIDATE_NEWSLETTER_CONFIRM);

$.validator.addMethod('latin-only', function(value) {
    var isValid = true;
    var re = /[^\u0000-\u00ff]|<|>|\/|\\/g;

    if (re.test(value)) {
        $.validator.messages['latin-only'] = Resources.VALIDATE_LATIN + ' "' + value.match(re).join(', ') + '"';
        isValid = false;
    }

    return isValid;
});

/**
 * Validate confirm password input
 */
$.validator.addMethod('password-repeat', function (value, element) {
	const $userPassword = $(element).closest('div.password-wrapper').prevAll('div.password-wrapper').find('input[type="password"]');

	if (value.trim().length && value.trim().length >= $userPassword.attr('minlength')) {
		return  $userPassword.val().trim() === value.trim();
	}
	return true;
}, Resources.VALIDATE_PASSWORD_CONFIRMATION);

/**
 * Validate engraving input for Alpha Numeric + Accented chars
 */
$.validator.addMethod('engraving-area', function (value) {
	if (!value) {
		return false;
	}

	const engravingRgx = new RegExp(regex.engraving);

	return engravingRgx.test(value.trim());
}, Resources.INVALID_ENGRAVING_INPUT);

$.extend($.validator.messages, {
    required: function (param, element) {
        let labelText = '';
        if (element && element.id) {
            labelText = $.trim($('label[for="' + element.id + '"]').first().text())
                .replace(/\*/g, '')
                .replace(/\s+/g, ' ');
            if (labelText.length > 0) {
                labelText = labelText.toLowerCase();
            }
        }

        let inputName = element && (element.name || element.id);
        let fieldName = labelText || inputName || 'value';

        let customMessage = $.trim(Resources.VALIDATE_CUSTOM_REQUIRED || '');
        let defaultMessage = $.trim(Resources.VALIDATE_REQUIRED || '');

        let hasResolvedCustomMessage =
            customMessage &&
            customMessage !== 'validate.custom.required';

        if (hasResolvedCustomMessage) {
            if (customMessage.indexOf('{0}') !== -1) {
                return $.validator.format(customMessage, fieldName);
            }

            return customMessage + ' ' + fieldName;
        }

        if (defaultMessage) {
            return defaultMessage;
        }
    },
	remote: Resources.VALIDATE_REMOTE,
	url: Resources.VALIDATE_URL,
	date: Resources.VALIDATE_DATE,
	dateISO: Resources.VALIDATE_DATEISO,
	number: Resources.VALIDATE_NUMBER,
	digits: Resources.VALIDATE_DIGITS,
	creditcard: Resources.VALIDATE_CREDITCARD,
	equalTo: Resources.VALIDATE_EQUALTO,
	maxlength: $.validator.format(Resources.VALIDATE_MAXLENGTH),
	minlength: $.validator.format(Resources.VALIDATE_MINLENGTH), // used for Zip code but where ? // class input-text  required error // minlength="4" and not 5
	rangelength: $.validator.format(Resources.VALIDATE_RANGELENGTH),
	range: $.validator.format(Resources.VALIDATE_RANGE),
	max: $.validator.format(Resources.VALIDATE_MAX),
	min: $.validator.format(Resources.VALIDATE_MIN)
});

var validator = {
	regex: regex,
	settings: settings,
	init: function () {
		var self = this;
        $("form:not(.suppress)").each(function () {
			$(this).validate(self.settings);
		});
	},
	initForm: function (f) {
		$(f).validate(this.settings);
	}
};

module.exports = validator;

},{"./regex":88}],106:[function(require,module,exports){
module.exports = function () {
    if (document.querySelector('.set-new-password-box')) {
        var firstInputs = document.querySelectorAll('.set-new-password-box input');
        var error = document.querySelector('.set-new-password-box .form-caption');
        var button = document.querySelector('.set-new-password-box button');
        firstInputs.forEach( function(input) {
            input.addEventListener('change', function (e) {
                if ( e.target.value.length >= 8 && firstInputs[0].value === firstInputs[1].value ) {
                    error.style.color = "black";
                }
                else{
                    error.style.color = "red";
                }
            })
        });
    }
}

},{}],107:[function(require,module,exports){
(function (process,global){(function (){
!function(e,t){"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):(e="undefined"!=typeof globalThis?globalThis:e||self).AdyenCheckout=t()}(this,(function(){"use strict";var e="undefined"!=typeof globalThis?globalThis:"undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{};function t(e){return e&&e.__esModule&&Object.prototype.hasOwnProperty.call(e,"default")?e.default:e}var r={},a={get exports(){return r},set exports(e){r=e}},n={},o={get exports(){return n},set exports(e){n=e}},i=function(e){return e&&e.Math==Math&&e},l=i("object"==typeof globalThis&&globalThis)||i("object"==typeof window&&window)||i("object"==typeof self&&self)||i("object"==typeof e&&e)||function(){return this}()||Function("return this")(),c=function(e){try{return!!e()}catch(e){return!0}},s=!c((function(){var e=function(){}.bind();return"function"!=typeof e||e.hasOwnProperty("prototype")})),u=s,d=Function.prototype,p=d.apply,f=d.call,m="object"==typeof Reflect&&Reflect.apply||(u?f.bind(p):function(){return f.apply(p,arguments)}),h=s,v=Function.prototype,y=v.call,g=h&&v.bind.bind(y,y),b=h?g:function(e){return function(){return y.apply(e,arguments)}},k=b,C=k({}.toString),_=k("".slice),N=function(e){return _(C(e),8,-1)},P=N,w=b,S=function(e){if("Function"===P(e))return w(e)},x="object"==typeof document&&document.all,E={all:x,IS_HTMLDDA:void 0===x&&void 0!==x},A=E.all,D=E.IS_HTMLDDA?function(e){return"function"==typeof e||e===A}:function(e){return"function"==typeof e},I={},F=!c((function(){return 7!=Object.defineProperty({},1,{get:function(){return 7}})[1]})),R=s,O=Function.prototype.call,T=R?O.bind(O):function(){return O.apply(O,arguments)},B={},j={}.propertyIsEnumerable,z=Object.getOwnPropertyDescriptor,M=z&&!j.call({1:2},1);B.f=M?function(e){var t=z(this,e);return!!t&&t.enumerable}:j;var L,V,U=function(e,t){return{enumerable:!(1&e),configurable:!(2&e),writable:!(4&e),value:t}},K=c,H=N,q=Object,W=b("".split),Y=K((function(){return!q("z").propertyIsEnumerable(0)}))?function(e){return"String"==H(e)?W(e,""):q(e)}:q,G=function(e){return null==e},J=G,Q=TypeError,Z=function(e){if(J(e))throw Q("Can't call method on "+e);return e},$=Y,X=Z,ee=function(e){return $(X(e))},te=D,re=E.all,ae=E.IS_HTMLDDA?function(e){return"object"==typeof e?null!==e:te(e)||e===re}:function(e){return"object"==typeof e?null!==e:te(e)},ne={},oe=ne,ie=l,le=D,ce=function(e){return le(e)?e:void 0},se=function(e,t){return arguments.length<2?ce(oe[e])||ce(ie[e]):oe[e]&&oe[e][t]||ie[e]&&ie[e][t]},ue=b({}.isPrototypeOf),de="undefined"!=typeof navigator&&String(navigator.userAgent)||"",pe=l,fe=de,me=pe.process,he=pe.Deno,ve=me&&me.versions||he&&he.version,ye=ve&&ve.v8;ye&&(V=(L=ye.split("."))[0]>0&&L[0]<4?1:+(L[0]+L[1])),!V&&fe&&(!(L=fe.match(/Edge\/(\d+)/))||L[1]>=74)&&(L=fe.match(/Chrome\/(\d+)/))&&(V=+L[1]);var ge=V,be=ge,ke=c,Ce=!!Object.getOwnPropertySymbols&&!ke((function(){var e=Symbol();return!String(e)||!(Object(e)instanceof Symbol)||!Symbol.sham&&be&&be<41})),_e=Ce&&!Symbol.sham&&"symbol"==typeof Symbol.iterator,Ne=se,Pe=D,we=ue,Se=Object,xe=_e?function(e){return"symbol"==typeof e}:function(e){var t=Ne("Symbol");return Pe(t)&&we(t.prototype,Se(e))},Ee=String,Ae=function(e){try{return Ee(e)}catch(e){return"Object"}},De=D,Ie=Ae,Fe=TypeError,Re=function(e){if(De(e))return e;throw Fe(Ie(e)+" is not a function")},Oe=Re,Te=G,Be=function(e,t){var r=e[t];return Te(r)?void 0:Oe(r)},je=T,ze=D,Me=ae,Le=TypeError,Ve={},Ue={get exports(){return Ve},set exports(e){Ve=e}},Ke=l,He=Object.defineProperty,qe=function(e,t){try{He(Ke,e,{value:t,configurable:!0,writable:!0})}catch(r){Ke[e]=t}return t},We="__core-js_shared__",Ye=l[We]||qe(We,{}),Ge=Ye;(Ue.exports=function(e,t){return Ge[e]||(Ge[e]=void 0!==t?t:{})})("versions",[]).push({version:"3.29.1",mode:"pure",copyright:"\xa9 2014-2023 Denis Pushkarev (zloirock.ru)",license:"https://github.com/zloirock/core-js/blob/v3.29.1/LICENSE",source:"https://github.com/zloirock/core-js"});var Je=Z,Qe=Object,Ze=function(e){return Qe(Je(e))},$e=Ze,Xe=b({}.hasOwnProperty),et=Object.hasOwn||function(e,t){return Xe($e(e),t)},tt=b,rt=0,at=Math.random(),nt=tt(1..toString),ot=function(e){return"Symbol("+(void 0===e?"":e)+")_"+nt(++rt+at,36)},it=Ve,lt=et,ct=ot,st=Ce,ut=_e,dt=l.Symbol,pt=it("wks"),ft=ut?dt.for||dt:dt&&dt.withoutSetter||ct,mt=function(e){return lt(pt,e)||(pt[e]=st&&lt(dt,e)?dt[e]:ft("Symbol."+e)),pt[e]},ht=T,vt=ae,yt=xe,gt=Be,bt=function(e,t){var r,a;if("string"===t&&ze(r=e.toString)&&!Me(a=je(r,e)))return a;if(ze(r=e.valueOf)&&!Me(a=je(r,e)))return a;if("string"!==t&&ze(r=e.toString)&&!Me(a=je(r,e)))return a;throw Le("Can't convert object to primitive value")},kt=TypeError,Ct=mt("toPrimitive"),_t=function(e,t){if(!vt(e)||yt(e))return e;var r,a=gt(e,Ct);if(a){if(void 0===t&&(t="default"),r=ht(a,e,t),!vt(r)||yt(r))return r;throw kt("Can't convert object to primitive value")}return void 0===t&&(t="number"),bt(e,t)},Nt=xe,Pt=function(e){var t=_t(e,"string");return Nt(t)?t:t+""},wt=ae,St=l.document,xt=wt(St)&&wt(St.createElement),Et=function(e){return xt?St.createElement(e):{}},At=Et,Dt=!F&&!c((function(){return 7!=Object.defineProperty(At("div"),"a",{get:function(){return 7}}).a})),It=F,Ft=T,Rt=B,Ot=U,Tt=ee,Bt=Pt,jt=et,zt=Dt,Mt=Object.getOwnPropertyDescriptor;I.f=It?Mt:function(e,t){if(e=Tt(e),t=Bt(t),zt)try{return Mt(e,t)}catch(e){}if(jt(e,t))return Ot(!Ft(Rt.f,e,t),e[t])};var Lt=c,Vt=D,Ut=/#|\.prototype\./,Kt=function(e,t){var r=qt[Ht(e)];return r==Yt||r!=Wt&&(Vt(t)?Lt(t):!!t)},Ht=Kt.normalize=function(e){return String(e).replace(Ut,".").toLowerCase()},qt=Kt.data={},Wt=Kt.NATIVE="N",Yt=Kt.POLYFILL="P",Gt=Kt,Jt=Re,Qt=s,Zt=S(S.bind),$t=function(e,t){return Jt(e),void 0===t?e:Qt?Zt(e,t):function(){return e.apply(t,arguments)}},Xt={},er=F&&c((function(){return 42!=Object.defineProperty((function(){}),"prototype",{value:42,writable:!1}).prototype})),tr=ae,rr=String,ar=TypeError,nr=function(e){if(tr(e))return e;throw ar(rr(e)+" is not an object")},or=F,ir=Dt,lr=er,cr=nr,sr=Pt,ur=TypeError,dr=Object.defineProperty,pr=Object.getOwnPropertyDescriptor,fr="enumerable",mr="configurable",hr="writable";Xt.f=or?lr?function(e,t,r){if(cr(e),t=sr(t),cr(r),"function"==typeof e&&"prototype"===t&&"value"in r&&hr in r&&!r[hr]){var a=pr(e,t);a&&a[hr]&&(e[t]=r.value,r={configurable:mr in r?r[mr]:a[mr],enumerable:fr in r?r[fr]:a[fr],writable:!1})}return dr(e,t,r)}:dr:function(e,t,r){if(cr(e),t=sr(t),cr(r),ir)try{return dr(e,t,r)}catch(e){}if("get"in r||"set"in r)throw ur("Accessors not supported");return"value"in r&&(e[t]=r.value),e};var vr=Xt,yr=U,gr=F?function(e,t,r){return vr.f(e,t,yr(1,r))}:function(e,t,r){return e[t]=r,e},br=l,kr=m,Cr=S,_r=D,Nr=I.f,Pr=Gt,wr=ne,Sr=$t,xr=gr,Er=et,Ar=function(e){var t=function(r,a,n){if(this instanceof t){switch(arguments.length){case 0:return new e;case 1:return new e(r);case 2:return new e(r,a)}return new e(r,a,n)}return kr(e,this,arguments)};return t.prototype=e.prototype,t},Dr=function(e,t){var r,a,n,o,i,l,c,s,u,d=e.target,p=e.global,f=e.stat,m=e.proto,h=p?br:f?br[d]:(br[d]||{}).prototype,v=p?wr:wr[d]||xr(wr,d,{})[d],y=v.prototype;for(o in t)a=!(r=Pr(p?o:d+(f?".":"#")+o,e.forced))&&h&&Er(h,o),l=v[o],a&&(c=e.dontCallGetSet?(u=Nr(h,o))&&u.value:h[o]),i=a&&c?c:t[o],a&&typeof l==typeof i||(s=e.bind&&a?Sr(i,br):e.wrap&&a?Ar(i):m&&_r(i)?Cr(i):i,(e.sham||i&&i.sham||l&&l.sham)&&xr(s,"sham",!0),xr(v,o,s),m&&(Er(wr,n=d+"Prototype")||xr(wr,n,{}),xr(wr[n],o,i),e.real&&y&&(r||!y[o])&&xr(y,o,i)))},Ir=ot,Fr=Ve("keys"),Rr=function(e){return Fr[e]||(Fr[e]=Ir(e))},Or=!c((function(){function e(){}return e.prototype.constructor=null,Object.getPrototypeOf(new e)!==e.prototype})),Tr=et,Br=D,jr=Ze,zr=Or,Mr=Rr("IE_PROTO"),Lr=Object,Vr=Lr.prototype,Ur=zr?Lr.getPrototypeOf:function(e){var t=jr(e);if(Tr(t,Mr))return t[Mr];var r=t.constructor;return Br(r)&&t instanceof r?r.prototype:t instanceof Lr?Vr:null},Kr=b,Hr=Re,qr=D,Wr=String,Yr=TypeError,Gr=function(e,t,r){try{return Kr(Hr(Object.getOwnPropertyDescriptor(e,t)[r]))}catch(e){}},Jr=nr,Qr=function(e){if("object"==typeof e||qr(e))return e;throw Yr("Can't set "+Wr(e)+" as a prototype")},Zr=Object.setPrototypeOf||("__proto__"in{}?function(){var e,t=!1,r={};try{(e=Gr(Object.prototype,"__proto__","set"))(r,[]),t=r instanceof Array}catch(e){}return function(r,a){return Jr(r),Qr(a),t?e(r,a):r.__proto__=a,r}}():void 0),$r={},Xr=Math.ceil,ea=Math.floor,ta=Math.trunc||function(e){var t=+e;return(t>0?ea:Xr)(t)},ra=ta,aa=function(e){var t=+e;return t!=t||0===t?0:ra(t)},na=aa,oa=Math.max,ia=Math.min,la=function(e,t){var r=na(e);return r<0?oa(r+t,0):ia(r,t)},ca=aa,sa=Math.min,ua=function(e){return e>0?sa(ca(e),9007199254740991):0},da=function(e){return ua(e.length)},pa=ee,fa=la,ma=da,ha=function(e){return function(t,r,a){var n,o=pa(t),i=ma(o),l=fa(a,i);if(e&&r!=r){for(;i>l;)if((n=o[l++])!=n)return!0}else for(;i>l;l++)if((e||l in o)&&o[l]===r)return e||l||0;return!e&&-1}},va={includes:ha(!0),indexOf:ha(!1)},ya={},ga=et,ba=ee,ka=va.indexOf,Ca=ya,_a=b([].push),Na=function(e,t){var r,a=ba(e),n=0,o=[];for(r in a)!ga(Ca,r)&&ga(a,r)&&_a(o,r);for(;t.length>n;)ga(a,r=t[n++])&&(~ka(o,r)||_a(o,r));return o},Pa=["constructor","hasOwnProperty","isPrototypeOf","propertyIsEnumerable","toLocaleString","toString","valueOf"],wa=Na,Sa=Pa.concat("length","prototype");$r.f=Object.getOwnPropertyNames||function(e){return wa(e,Sa)};var xa={};xa.f=Object.getOwnPropertySymbols;var Ea=se,Aa=$r,Da=xa,Ia=nr,Fa=b([].concat),Ra=Ea("Reflect","ownKeys")||function(e){var t=Aa.f(Ia(e)),r=Da.f;return r?Fa(t,r(e)):t},Oa=et,Ta=Ra,Ba=I,ja=Xt,za={},Ma=Na,La=Pa,Va=Object.keys||function(e){return Ma(e,La)},Ua=F,Ka=er,Ha=Xt,qa=nr,Wa=ee,Ya=Va;za.f=Ua&&!Ka?Object.defineProperties:function(e,t){qa(e);for(var r,a=Wa(t),n=Ya(t),o=n.length,i=0;o>i;)Ha.f(e,r=n[i++],a[r]);return e};var Ga,Ja=se("document","documentElement"),Qa=nr,Za=za,$a=Pa,Xa=ya,en=Ja,tn=Et,rn="prototype",an="script",nn=Rr("IE_PROTO"),on=function(){},ln=function(e){return"<"+an+">"+e+"</"+an+">"},cn=function(e){e.write(ln("")),e.close();var t=e.parentWindow.Object;return e=null,t},sn=function(){try{Ga=new ActiveXObject("htmlfile")}catch(e){}var e,t,r;sn="undefined"!=typeof document?document.domain&&Ga?cn(Ga):(t=tn("iframe"),r="java"+an+":",t.style.display="none",en.appendChild(t),t.src=String(r),(e=t.contentWindow.document).open(),e.write(ln("document.F=Object")),e.close(),e.F):cn(Ga);for(var a=$a.length;a--;)delete sn[rn][$a[a]];return sn()};Xa[nn]=!0;var un=Object.create||function(e,t){var r;return null!==e?(on[rn]=Qa(e),r=new on,on[rn]=null,r[nn]=e):r=sn(),void 0===t?r:Za.f(r,t)},dn=ae,pn=gr,fn=Error,mn=b("".replace),hn=String(fn("zxcasd").stack),vn=/\n\s*at [^:]*:[^\n]*/,yn=vn.test(hn),gn=U,bn=!c((function(){var e=Error("a");return!("stack"in e)||(Object.defineProperty(e,"stack",gn(1,7)),7!==e.stack)})),kn=gr,Cn=function(e,t){if(yn&&"string"==typeof e&&!fn.prepareStackTrace)for(;t--;)e=mn(e,vn,"");return e},_n=bn,Nn=Error.captureStackTrace,Pn={},wn=Pn,Sn=mt("iterator"),xn=Array.prototype,En=function(e){return void 0!==e&&(wn.Array===e||xn[Sn]===e)},An={};An[mt("toStringTag")]="z";var Dn="[object z]"===String(An),In=Dn,Fn=D,Rn=N,On=mt("toStringTag"),Tn=Object,Bn="Arguments"==Rn(function(){return arguments}()),jn=In?Rn:function(e){var t,r,a;return void 0===e?"Undefined":null===e?"Null":"string"==typeof(r=function(e,t){try{return e[t]}catch(e){}}(t=Tn(e),On))?r:Bn?Rn(t):"Object"==(a=Rn(t))&&Fn(t.callee)?"Arguments":a},zn=jn,Mn=Be,Ln=G,Vn=Pn,Un=mt("iterator"),Kn=function(e){if(!Ln(e))return Mn(e,Un)||Mn(e,"@@iterator")||Vn[zn(e)]},Hn=T,qn=Re,Wn=nr,Yn=Ae,Gn=Kn,Jn=TypeError,Qn=function(e,t){var r=arguments.length<2?Gn(e):t;if(qn(r))return Wn(Hn(r,e));throw Jn(Yn(e)+" is not iterable")},Zn=T,$n=nr,Xn=Be,eo=function(e,t,r){var a,n;$n(e);try{if(!(a=Xn(e,"return"))){if("throw"===t)throw r;return r}a=Zn(a,e)}catch(e){n=!0,a=e}if("throw"===t)throw r;if(n)throw a;return $n(a),r},to=$t,ro=T,ao=nr,no=Ae,oo=En,io=da,lo=ue,co=Qn,so=Kn,uo=eo,po=TypeError,fo=function(e,t){this.stopped=e,this.result=t},mo=fo.prototype,ho=function(e,t,r){var a,n,o,i,l,c,s,u=r&&r.that,d=!(!r||!r.AS_ENTRIES),p=!(!r||!r.IS_RECORD),f=!(!r||!r.IS_ITERATOR),m=!(!r||!r.INTERRUPTED),h=to(t,u),v=function(e){return a&&uo(a,"normal",e),new fo(!0,e)},y=function(e){return d?(ao(e),m?h(e[0],e[1],v):h(e[0],e[1])):m?h(e,v):h(e)};if(p)a=e.iterator;else if(f)a=e;else{if(!(n=so(e)))throw po(no(e)+" is not iterable");if(oo(n)){for(o=0,i=io(e);i>o;o++)if((l=y(e[o]))&&lo(mo,l))return l;return new fo(!1)}a=co(e,n)}for(c=p?e.next:a.next;!(s=ro(c,a)).done;){try{l=y(s.value)}catch(e){uo(a,"throw",e)}if("object"==typeof l&&l&&lo(mo,l))return l}return new fo(!1)},vo=jn,yo=String,go=function(e){if("Symbol"===vo(e))throw TypeError("Cannot convert a Symbol value to a string");return yo(e)},bo=go,ko=Dr,Co=ue,_o=Ur,No=Zr,Po=function(e,t,r){for(var a=Ta(t),n=ja.f,o=Ba.f,i=0;i<a.length;i++){var l=a[i];Oa(e,l)||r&&Oa(r,l)||n(e,l,o(t,l))}},wo=un,So=gr,xo=U,Eo=function(e,t){dn(t)&&"cause"in t&&pn(e,"cause",t.cause)},Ao=function(e,t,r,a){_n&&(Nn?Nn(e,t):kn(e,"stack",Cn(r,a)))},Do=ho,Io=function(e,t){return void 0===e?arguments.length<2?"":t:bo(e)},Fo=mt("toStringTag"),Ro=Error,Oo=[].push,To=function(e,t){var r,a=Co(Bo,this);No?r=No(Ro(),a?_o(this):Bo):(r=a?this:wo(Bo),So(r,Fo,"Error")),void 0!==t&&So(r,"message",Io(t)),Ao(r,To,r.stack,1),arguments.length>2&&Eo(r,arguments[2]);var n=[];return Do(e,Oo,{that:n}),So(r,"errors",n),r};No?No(To,Ro):Po(To,Ro,{name:!0});var Bo=To.prototype=wo(Ro.prototype,{constructor:xo(1,To),message:xo(1,""),name:xo(1,"AggregateError")});ko({global:!0,constructor:!0,arity:2},{AggregateError:To});var jo,zo,Mo,Lo=D,Vo=l.WeakMap,Uo=Lo(Vo)&&/native code/.test(String(Vo)),Ko=l,Ho=ae,qo=gr,Wo=et,Yo=Ye,Go=Rr,Jo=ya,Qo="Object already initialized",Zo=Ko.TypeError,$o=Ko.WeakMap;if(Uo||Yo.state){var Xo=Yo.state||(Yo.state=new $o);Xo.get=Xo.get,Xo.has=Xo.has,Xo.set=Xo.set,jo=function(e,t){if(Xo.has(e))throw Zo(Qo);return t.facade=e,Xo.set(e,t),t},zo=function(e){return Xo.get(e)||{}},Mo=function(e){return Xo.has(e)}}else{var ei=Go("state");Jo[ei]=!0,jo=function(e,t){if(Wo(e,ei))throw Zo(Qo);return t.facade=e,qo(e,ei,t),t},zo=function(e){return Wo(e,ei)?e[ei]:{}},Mo=function(e){return Wo(e,ei)}}var ti,ri,ai,ni={set:jo,get:zo,has:Mo,enforce:function(e){return Mo(e)?zo(e):jo(e,{})},getterFor:function(e){return function(t){var r;if(!Ho(t)||(r=zo(t)).type!==e)throw Zo("Incompatible receiver, "+e+" required");return r}}},oi=F,ii=et,li=Function.prototype,ci=oi&&Object.getOwnPropertyDescriptor,si=ii(li,"name"),ui={EXISTS:si,PROPER:si&&"something"===function(){}.name,CONFIGURABLE:si&&(!oi||oi&&ci(li,"name").configurable)},di=gr,pi=function(e,t,r,a){return a&&a.enumerable?e[t]=r:di(e,t,r),e},fi=c,mi=D,hi=ae,vi=un,yi=Ur,gi=pi,bi=mt("iterator"),ki=!1;[].keys&&("next"in(ai=[].keys())?(ri=yi(yi(ai)))!==Object.prototype&&(ti=ri):ki=!0);var Ci=!hi(ti)||fi((function(){var e={};return ti[bi].call(e)!==e}));mi((ti=Ci?{}:vi(ti))[bi])||gi(ti,bi,(function(){return this}));var _i={IteratorPrototype:ti,BUGGY_SAFARI_ITERATORS:ki},Ni=jn,Pi=Dn?{}.toString:function(){return"[object "+Ni(this)+"]"},wi=Dn,Si=Xt.f,xi=gr,Ei=et,Ai=Pi,Di=mt("toStringTag"),Ii=function(e,t,r,a){if(e){var n=r?e:e.prototype;Ei(n,Di)||Si(n,Di,{configurable:!0,value:t}),a&&!wi&&xi(n,"toString",Ai)}},Fi=_i.IteratorPrototype,Ri=un,Oi=U,Ti=Ii,Bi=Pn,ji=function(){return this},zi=function(e,t,r,a){var n=t+" Iterator";return e.prototype=Ri(Fi,{next:Oi(+!a,r)}),Ti(e,n,!1,!0),Bi[n]=ji,e},Mi=Dr,Li=T,Vi=ui,Ui=zi,Ki=Ur,Hi=Ii,qi=pi,Wi=Pn,Yi=_i,Gi=Vi.PROPER,Ji=Yi.BUGGY_SAFARI_ITERATORS,Qi=mt("iterator"),Zi="keys",$i="values",Xi="entries",el=function(){return this},tl=function(e,t,r,a,n,o,i){Ui(r,t,a);var l,c,s,u=function(e){if(e===n&&h)return h;if(!Ji&&e in f)return f[e];switch(e){case Zi:case $i:case Xi:return function(){return new r(this,e)}}return function(){return new r(this)}},d=t+" Iterator",p=!1,f=e.prototype,m=f[Qi]||f["@@iterator"]||n&&f[n],h=!Ji&&m||u(n),v="Array"==t&&f.entries||m;if(v&&(l=Ki(v.call(new e)))!==Object.prototype&&l.next&&(Hi(l,d,!0,!0),Wi[d]=el),Gi&&n==$i&&m&&m.name!==$i&&(p=!0,h=function(){return Li(m,this)}),n)if(c={values:u($i),keys:o?h:u(Zi),entries:u(Xi)},i)for(s in c)(Ji||p||!(s in f))&&qi(f,s,c[s]);else Mi({target:t,proto:!0,forced:Ji||p},c);return i&&f[Qi]!==h&&qi(f,Qi,h,{name:n}),Wi[t]=h,c},rl=function(e,t){return{value:e,done:t}},al=ee,nl=function(){},ol=Pn,il=ni,ll=(Xt.f,tl),cl=rl,sl="Array Iterator",ul=il.set,dl=il.getterFor(sl);ll(Array,"Array",(function(e,t){ul(this,{type:sl,target:al(e),index:0,kind:t})}),(function(){var e=dl(this),t=e.target,r=e.kind,a=e.index++;return!t||a>=t.length?(e.target=void 0,cl(void 0,!0)):cl("keys"==r?a:"values"==r?t[a]:[a,t[a]],!1)}),"values");ol.Arguments=ol.Array;nl(),nl(),nl();var pl="undefined"!=typeof process&&"process"==N(process),fl=Xt,ml=function(e,t,r){return fl.f(e,t,r)},hl=se,vl=ml,yl=F,gl=mt("species"),bl=function(e){var t=hl(e);yl&&t&&!t[gl]&&vl(t,gl,{configurable:!0,get:function(){return this}})},kl=ue,Cl=TypeError,_l=function(e,t){if(kl(t,e))return e;throw Cl("Incorrect invocation")},Nl=D,Pl=Ye,wl=b(Function.toString);Nl(Pl.inspectSource)||(Pl.inspectSource=function(e){return wl(e)});var Sl=Pl.inspectSource,xl=b,El=c,Al=D,Dl=jn,Il=Sl,Fl=function(){},Rl=[],Ol=se("Reflect","construct"),Tl=/^\s*(?:class|function)\b/,Bl=xl(Tl.exec),jl=!Tl.exec(Fl),zl=function(e){if(!Al(e))return!1;try{return Ol(Fl,Rl,e),!0}catch(e){return!1}},Ml=function(e){if(!Al(e))return!1;switch(Dl(e)){case"AsyncFunction":case"GeneratorFunction":case"AsyncGeneratorFunction":return!1}try{return jl||!!Bl(Tl,Il(e))}catch(e){return!0}};Ml.sham=!0;var Ll,Vl,Ul,Kl,Hl=!Ol||El((function(){var e;return zl(zl.call)||!zl(Object)||!zl((function(){e=!0}))||e}))?Ml:zl,ql=Hl,Wl=Ae,Yl=TypeError,Gl=function(e){if(ql(e))return e;throw Yl(Wl(e)+" is not a constructor")},Jl=nr,Ql=Gl,Zl=G,$l=mt("species"),Xl=function(e,t){var r,a=Jl(e).constructor;return void 0===a||Zl(r=Jl(a)[$l])?t:Ql(r)},ec=b([].slice),tc=TypeError,rc=function(e,t){if(e<t)throw tc("Not enough arguments");return e},ac=/(?:ipad|iphone|ipod).*applewebkit/i.test(de),nc=l,oc=m,ic=$t,lc=D,cc=et,sc=c,uc=Ja,dc=ec,pc=Et,fc=rc,mc=ac,hc=pl,vc=nc.setImmediate,yc=nc.clearImmediate,gc=nc.process,bc=nc.Dispatch,kc=nc.Function,Cc=nc.MessageChannel,_c=nc.String,Nc=0,Pc={},wc="onreadystatechange";sc((function(){Ll=nc.location}));var Sc=function(e){if(cc(Pc,e)){var t=Pc[e];delete Pc[e],t()}},xc=function(e){return function(){Sc(e)}},Ec=function(e){Sc(e.data)},Ac=function(e){nc.postMessage(_c(e),Ll.protocol+"//"+Ll.host)};vc&&yc||(vc=function(e){fc(arguments.length,1);var t=lc(e)?e:kc(e),r=dc(arguments,1);return Pc[++Nc]=function(){oc(t,void 0,r)},Vl(Nc),Nc},yc=function(e){delete Pc[e]},hc?Vl=function(e){gc.nextTick(xc(e))}:bc&&bc.now?Vl=function(e){bc.now(xc(e))}:Cc&&!mc?(Kl=(Ul=new Cc).port2,Ul.port1.onmessage=Ec,Vl=ic(Kl.postMessage,Kl)):nc.addEventListener&&lc(nc.postMessage)&&!nc.importScripts&&Ll&&"file:"!==Ll.protocol&&!sc(Ac)?(Vl=Ac,nc.addEventListener("message",Ec,!1)):Vl=wc in pc("script")?function(e){uc.appendChild(pc("script"))[wc]=function(){uc.removeChild(this),Sc(e)}}:function(e){setTimeout(xc(e),0)});var Dc={set:vc,clear:yc},Ic=function(){this.head=null,this.tail=null};Ic.prototype={add:function(e){var t={item:e,next:null},r=this.tail;r?r.next=t:this.head=t,this.tail=t},get:function(){var e=this.head;if(e)return null===(this.head=e.next)&&(this.tail=null),e.item}};var Fc,Rc,Oc,Tc,Bc,jc=Ic,zc=/ipad|iphone|ipod/i.test(de)&&"undefined"!=typeof Pebble,Mc=/web0s(?!.*chrome)/i.test(de),Lc=l,Vc=$t,Uc=I.f,Kc=Dc.set,Hc=jc,qc=ac,Wc=zc,Yc=Mc,Gc=pl,Jc=Lc.MutationObserver||Lc.WebKitMutationObserver,Qc=Lc.document,Zc=Lc.process,$c=Lc.Promise,Xc=Uc(Lc,"queueMicrotask"),es=Xc&&Xc.value;if(!es){var ts=new Hc,rs=function(){var e,t;for(Gc&&(e=Zc.domain)&&e.exit();t=ts.get();)try{t()}catch(e){throw ts.head&&Fc(),e}e&&e.enter()};qc||Gc||Yc||!Jc||!Qc?!Wc&&$c&&$c.resolve?((Tc=$c.resolve(void 0)).constructor=$c,Bc=Vc(Tc.then,Tc),Fc=function(){Bc(rs)}):Gc?Fc=function(){Zc.nextTick(rs)}:(Kc=Vc(Kc,Lc),Fc=function(){Kc(rs)}):(Rc=!0,Oc=Qc.createTextNode(""),new Jc(rs).observe(Oc,{characterData:!0}),Fc=function(){Oc.data=Rc=!Rc}),es=function(e){ts.head||Fc(),ts.add(e)}}var as=es,ns=function(e){try{return{error:!1,value:e()}}catch(e){return{error:!0,value:e}}},os=l.Promise,is="object"==typeof Deno&&Deno&&"object"==typeof Deno.version,ls=!is&&!pl&&"object"==typeof window&&"object"==typeof document,cs=l,ss=os,us=D,ds=Gt,ps=Sl,fs=mt,ms=ls,hs=is,vs=ge,ys=ss&&ss.prototype,gs=fs("species"),bs=!1,ks=us(cs.PromiseRejectionEvent),Cs=ds("Promise",(function(){var e=ps(ss),t=e!==String(ss);if(!t&&66===vs)return!0;if(!ys.catch||!ys.finally)return!0;if(!vs||vs<51||!/native code/.test(e)){var r=new ss((function(e){e(1)})),a=function(e){e((function(){}),(function(){}))};if((r.constructor={})[gs]=a,!(bs=r.then((function(){}))instanceof a))return!0}return!t&&(ms||hs)&&!ks})),_s={CONSTRUCTOR:Cs,REJECTION_EVENT:ks,SUBCLASSING:bs},Ns={},Ps=Re,ws=TypeError,Ss=function(e){var t,r;this.promise=new e((function(e,a){if(void 0!==t||void 0!==r)throw ws("Bad Promise constructor");t=e,r=a})),this.resolve=Ps(t),this.reject=Ps(r)};Ns.f=function(e){return new Ss(e)};var xs,Es,As=Dr,Ds=pl,Is=l,Fs=T,Rs=pi,Os=Ii,Ts=bl,Bs=Re,js=D,zs=ae,Ms=_l,Ls=Xl,Vs=Dc.set,Us=as,Ks=function(e,t){try{1==arguments.length?console.error(e):console.error(e,t)}catch(e){}},Hs=ns,qs=jc,Ws=ni,Ys=os,Gs=_s,Js=Ns,Qs="Promise",Zs=Gs.CONSTRUCTOR,$s=Gs.REJECTION_EVENT,Xs=Ws.getterFor(Qs),eu=Ws.set,tu=Ys&&Ys.prototype,ru=Ys,au=tu,nu=Is.TypeError,ou=Is.document,iu=Is.process,lu=Js.f,cu=lu,su=!!(ou&&ou.createEvent&&Is.dispatchEvent),uu="unhandledrejection",du=function(e){var t;return!(!zs(e)||!js(t=e.then))&&t},pu=function(e,t){var r,a,n,o=t.value,i=1==t.state,l=i?e.ok:e.fail,c=e.resolve,s=e.reject,u=e.domain;try{l?(i||(2===t.rejection&&yu(t),t.rejection=1),!0===l?r=o:(u&&u.enter(),r=l(o),u&&(u.exit(),n=!0)),r===e.promise?s(nu("Promise-chain cycle")):(a=du(r))?Fs(a,r,c,s):c(r)):s(o)}catch(e){u&&!n&&u.exit(),s(e)}},fu=function(e,t){e.notified||(e.notified=!0,Us((function(){for(var r,a=e.reactions;r=a.get();)pu(r,e);e.notified=!1,t&&!e.rejection&&hu(e)})))},mu=function(e,t,r){var a,n;su?((a=ou.createEvent("Event")).promise=t,a.reason=r,a.initEvent(e,!1,!0),Is.dispatchEvent(a)):a={promise:t,reason:r},!$s&&(n=Is["on"+e])?n(a):e===uu&&Ks("Unhandled promise rejection",r)},hu=function(e){Fs(Vs,Is,(function(){var t,r=e.facade,a=e.value;if(vu(e)&&(t=Hs((function(){Ds?iu.emit("unhandledRejection",a,r):mu(uu,r,a)})),e.rejection=Ds||vu(e)?2:1,t.error))throw t.value}))},vu=function(e){return 1!==e.rejection&&!e.parent},yu=function(e){Fs(Vs,Is,(function(){var t=e.facade;Ds?iu.emit("rejectionHandled",t):mu("rejectionhandled",t,e.value)}))},gu=function(e,t,r){return function(a){e(t,a,r)}},bu=function(e,t,r){e.done||(e.done=!0,r&&(e=r),e.value=t,e.state=2,fu(e,!0))},ku=function(e,t,r){if(!e.done){e.done=!0,r&&(e=r);try{if(e.facade===t)throw nu("Promise can't be resolved itself");var a=du(t);a?Us((function(){var r={done:!1};try{Fs(a,t,gu(ku,r,e),gu(bu,r,e))}catch(t){bu(r,t,e)}})):(e.value=t,e.state=1,fu(e,!1))}catch(t){bu({done:!1},t,e)}}};Zs&&(ru=function(e){Ms(this,au),Bs(e),Fs(xs,this);var t=Xs(this);try{e(gu(ku,t),gu(bu,t))}catch(e){bu(t,e)}},au=ru.prototype,(xs=function(e){eu(this,{type:Qs,done:!1,notified:!1,parent:!1,reactions:new qs,rejection:!1,state:0,value:void 0})}).prototype=Rs(au,"then",(function(e,t){var r=Xs(this),a=lu(Ls(this,ru));return r.parent=!0,a.ok=!js(e)||e,a.fail=js(t)&&t,a.domain=Ds?iu.domain:void 0,0==r.state?r.reactions.add(a):Us((function(){pu(a,r)})),a.promise})),Es=function(){var e=new xs,t=Xs(e);this.promise=e,this.resolve=gu(ku,t),this.reject=gu(bu,t)},Js.f=lu=function(e){return e===ru||undefined===e?new Es(e):cu(e)}),As({global:!0,constructor:!0,wrap:!0,forced:Zs},{Promise:ru}),Os(ru,Qs,!1,!0),Ts(Qs);var Cu=mt("iterator"),_u=!1;try{var Nu=0,Pu={next:function(){return{done:!!Nu++}},return:function(){_u=!0}};Pu[Cu]=function(){return this},Array.from(Pu,(function(){throw 2}))}catch(lL){}var wu=function(e,t){if(!t&&!_u)return!1;var r=!1;try{var a={};a[Cu]=function(){return{next:function(){return{done:r=!0}}}},e(a)}catch(e){}return r},Su=os,xu=_s.CONSTRUCTOR||!wu((function(e){Su.all(e).then(void 0,(function(){}))})),Eu=T,Au=Re,Du=Ns,Iu=ns,Fu=ho;Dr({target:"Promise",stat:!0,forced:xu},{all:function(e){var t=this,r=Du.f(t),a=r.resolve,n=r.reject,o=Iu((function(){var r=Au(t.resolve),o=[],i=0,l=1;Fu(e,(function(e){var c=i++,s=!1;l++,Eu(r,t,e).then((function(e){s||(s=!0,o[c]=e,--l||a(o))}),n)})),--l||a(o)}));return o.error&&n(o.value),r.promise}});var Ru=Dr,Ou=_s.CONSTRUCTOR;os&&os.prototype,Ru({target:"Promise",proto:!0,forced:Ou,real:!0},{catch:function(e){return this.then(void 0,e)}});var Tu=T,Bu=Re,ju=Ns,zu=ns,Mu=ho;Dr({target:"Promise",stat:!0,forced:xu},{race:function(e){var t=this,r=ju.f(t),a=r.reject,n=zu((function(){var n=Bu(t.resolve);Mu(e,(function(e){Tu(n,t,e).then(r.resolve,a)}))}));return n.error&&a(n.value),r.promise}});var Lu=T,Vu=Ns;Dr({target:"Promise",stat:!0,forced:_s.CONSTRUCTOR},{reject:function(e){var t=Vu.f(this);return Lu(t.reject,void 0,e),t.promise}});var Uu=nr,Ku=ae,Hu=Ns,qu=function(e,t){if(Uu(e),Ku(t)&&t.constructor===e)return t;var r=Hu.f(e);return(0,r.resolve)(t),r.promise},Wu=Dr,Yu=os,Gu=_s.CONSTRUCTOR,Ju=qu,Qu=se("Promise"),Zu=!Gu;Wu({target:"Promise",stat:!0,forced:true},{resolve:function(e){return Ju(Zu&&this===Qu?Yu:this,e)}});var $u=T,Xu=Re,ed=Ns,td=ns,rd=ho;Dr({target:"Promise",stat:!0,forced:xu},{allSettled:function(e){var t=this,r=ed.f(t),a=r.resolve,n=r.reject,o=td((function(){var r=Xu(t.resolve),n=[],o=0,i=1;rd(e,(function(e){var l=o++,c=!1;i++,$u(r,t,e).then((function(e){c||(c=!0,n[l]={status:"fulfilled",value:e},--i||a(n))}),(function(e){c||(c=!0,n[l]={status:"rejected",reason:e},--i||a(n))}))})),--i||a(n)}));return o.error&&n(o.value),r.promise}});var ad=T,nd=Re,od=se,id=Ns,ld=ns,cd=ho,sd="No one promise resolved";Dr({target:"Promise",stat:!0,forced:xu},{any:function(e){var t=this,r=od("AggregateError"),a=id.f(t),n=a.resolve,o=a.reject,i=ld((function(){var a=nd(t.resolve),i=[],l=0,c=1,s=!1;cd(e,(function(e){var u=l++,d=!1;c++,ad(a,t,e).then((function(e){d||s||(s=!0,n(e))}),(function(e){d||s||(d=!0,i[u]=e,--c||o(new r(i,sd)))}))})),--c||o(new r(i,sd))}));return i.error&&o(i.value),a.promise}});var ud=Dr,dd=os,pd=c,fd=se,md=D,hd=Xl,vd=qu,yd=dd&&dd.prototype;ud({target:"Promise",proto:!0,real:!0,forced:!!dd&&pd((function(){yd.finally.call({then:function(){}},(function(){}))}))},{finally:function(e){var t=hd(this,fd("Promise")),r=md(e);return this.then(r?function(r){return vd(t,e()).then((function(){return r}))}:e,r?function(r){return vd(t,e()).then((function(){throw r}))}:e)}});var gd=b,bd=aa,kd=go,Cd=Z,_d=gd("".charAt),Nd=gd("".charCodeAt),Pd=gd("".slice),wd=function(e){return function(t,r){var a,n,o=kd(Cd(t)),i=bd(r),l=o.length;return i<0||i>=l?e?"":void 0:(a=Nd(o,i))<55296||a>56319||i+1===l||(n=Nd(o,i+1))<56320||n>57343?e?_d(o,i):a:e?Pd(o,i,i+2):n-56320+(a-55296<<10)+65536}},Sd={codeAt:wd(!1),charAt:wd(!0)},xd=Sd.charAt,Ed=go,Ad=ni,Dd=tl,Id=rl,Fd="String Iterator",Rd=Ad.set,Od=Ad.getterFor(Fd);Dd(String,"String",(function(e){Rd(this,{type:Fd,string:Ed(e),index:0})}),(function(){var e,t=Od(this),r=t.string,a=t.index;return a>=r.length?Id(void 0,!0):(e=xd(r,a),t.index+=e.length,Id(e,!1))}));var Td=ne.Promise,Bd={CSSRuleList:0,CSSStyleDeclaration:0,CSSValueList:0,ClientRectList:0,DOMRectList:0,DOMStringList:0,DOMTokenList:1,DataTransferItemList:0,FileList:0,HTMLAllCollection:0,HTMLCollection:0,HTMLFormElement:0,HTMLSelectElement:0,MediaList:0,MimeTypeArray:0,NamedNodeMap:0,NodeList:1,PaintRequestList:0,Plugin:0,PluginArray:0,SVGLengthList:0,SVGNumberList:0,SVGPathSegList:0,SVGPointList:0,SVGStringList:0,SVGTransformList:0,SourceBufferList:0,StyleSheetList:0,TextTrackCueList:0,TextTrackList:0,TouchList:0},jd=l,zd=jn,Md=gr,Ld=Pn,Vd=mt("toStringTag");for(var Ud in Bd){var Kd=jd[Ud],Hd=Kd&&Kd.prototype;Hd&&zd(Hd)!==Vd&&Md(Hd,Vd,Ud),Ld[Ud]=Ld.Array}var qd=Td,Wd=qd,Yd=Ns,Gd=ns;Dr({target:"Promise",stat:!0,forced:!0},{try:function(e){var t=Yd.f(this),r=Gd(e);return(r.error?t.reject:t.resolve)(r.value),t.promise}});var Jd=Wd;!function(e){e.exports=Jd}(o),function(e){e.exports=n}(a);var Qd=t(r);function Zd(e,t,r,a,n,o,i){try{var l=e[o](i),c=l.value}catch(e){return void r(e)}l.done?t(c):Qd.resolve(c).then(a,n)}function $d(e){return function(){var t=this,r=arguments;return new Qd((function(a,n){var o=e.apply(t,r);function i(e){Zd(o,a,n,i,l,"next",e)}function l(e){Zd(o,a,n,i,l,"throw",e)}i(void 0)}))}}var Xd={},ep={get exports(){return Xd},set exports(e){Xd=e}},tp={},rp={get exports(){return tp},set exports(e){tp=e}},ap={},np={get exports(){return ap},set exports(e){ap=e}},op={},ip={get exports(){return op},set exports(e){op=e}},lp=N,cp=Array.isArray||function(e){return"Array"==lp(e)},sp=TypeError,up=function(e){if(e>9007199254740991)throw sp("Maximum allowed index exceeded");return e},dp=Pt,pp=Xt,fp=U,mp=function(e,t,r){var a=dp(t);a in e?pp.f(e,a,fp(0,r)):e[a]=r},hp=cp,vp=Hl,yp=ae,gp=mt("species"),bp=Array,kp=function(e){var t;return hp(e)&&(t=e.constructor,(vp(t)&&(t===bp||hp(t.prototype))||yp(t)&&null===(t=t[gp]))&&(t=void 0)),void 0===t?bp:t},Cp=function(e,t){return new(kp(e))(0===t?0:t)},_p=c,Np=ge,Pp=mt("species"),wp=function(e){return Np>=51||!_p((function(){var t=[];return(t.constructor={})[Pp]=function(){return{foo:1}},1!==t[e](Boolean).foo}))},Sp=Dr,xp=c,Ep=cp,Ap=ae,Dp=Ze,Ip=da,Fp=up,Rp=mp,Op=Cp,Tp=wp,Bp=ge,jp=mt("isConcatSpreadable"),zp=Bp>=51||!xp((function(){var e=[];return e[jp]=!1,e.concat()[0]!==e})),Mp=function(e){if(!Ap(e))return!1;var t=e[jp];return void 0!==t?!!t:Ep(e)};Sp({target:"Array",proto:!0,arity:1,forced:!zp||!Tp("concat")},{concat:function(e){var t,r,a,n,o,i=Dp(this),l=Op(i,0),c=0;for(t=-1,a=arguments.length;t<a;t++)if(Mp(o=-1===t?i:arguments[t]))for(n=Ip(o),Fp(c+n),r=0;r<n;r++,c++)r in o&&Rp(l,c,o[r]);else Fp(c+1),Rp(l,c++,o);return l.length=c,l}});var Lp={},Vp=la,Up=da,Kp=mp,Hp=Array,qp=Math.max,Wp=function(e,t,r){for(var a=Up(e),n=Vp(t,a),o=Vp(void 0===r?a:r,a),i=Hp(qp(o-n,0)),l=0;n<o;n++,l++)Kp(i,l,e[n]);return i.length=l,i},Yp=N,Gp=ee,Jp=$r.f,Qp=Wp,Zp="object"==typeof window&&window&&Object.getOwnPropertyNames?Object.getOwnPropertyNames(window):[];Lp.f=function(e){return Zp&&"Window"==Yp(e)?function(e){try{return Jp(e)}catch(e){return Qp(Zp)}}(e):Jp(Gp(e))};var $p={},Xp=mt;$p.f=Xp;var ef=ne,tf=et,rf=$p,af=Xt.f,nf=function(e){var t=ef.Symbol||(ef.Symbol={});tf(t,e)||af(t,e,{value:rf.f(e)})},of=T,lf=se,cf=mt,sf=pi,uf=function(){var e=lf("Symbol"),t=e&&e.prototype,r=t&&t.valueOf,a=cf("toPrimitive");t&&!t[a]&&sf(t,a,(function(e){return of(r,this)}),{arity:1})},df=$t,pf=Y,ff=Ze,mf=da,hf=Cp,vf=b([].push),yf=function(e){var t=1==e,r=2==e,a=3==e,n=4==e,o=6==e,i=7==e,l=5==e||o;return function(c,s,u,d){for(var p,f,m=ff(c),h=pf(m),v=df(s,u),y=mf(h),g=0,b=d||hf,k=t?b(c,y):r||i?b(c,0):void 0;y>g;g++)if((l||g in h)&&(f=v(p=h[g],g,m),e))if(t)k[g]=f;else if(f)switch(e){case 3:return!0;case 5:return p;case 6:return g;case 2:vf(k,p)}else switch(e){case 4:return!1;case 7:vf(k,p)}return o?-1:a||n?n:k}},gf={forEach:yf(0),map:yf(1),filter:yf(2),some:yf(3),every:yf(4),find:yf(5),findIndex:yf(6),filterReject:yf(7)},bf=Dr,kf=l,Cf=T,_f=b,Nf=F,Pf=Ce,wf=c,Sf=et,xf=ue,Ef=nr,Af=ee,Df=Pt,If=go,Ff=U,Rf=un,Of=Va,Tf=$r,Bf=Lp,jf=xa,zf=I,Mf=Xt,Lf=za,Vf=B,Uf=pi,Kf=ml,Hf=Ve,qf=ya,Wf=ot,Yf=mt,Gf=$p,Jf=nf,Qf=uf,Zf=Ii,$f=ni,Xf=gf.forEach,em=Rr("hidden"),tm="Symbol",rm="prototype",am=$f.set,nm=$f.getterFor(tm),om=Object[rm],im=kf.Symbol,lm=im&&im[rm],cm=kf.TypeError,sm=kf.QObject,um=zf.f,dm=Mf.f,pm=Bf.f,fm=Vf.f,mm=_f([].push),hm=Hf("symbols"),vm=Hf("op-symbols"),ym=Hf("wks"),gm=!sm||!sm[rm]||!sm[rm].findChild,bm=Nf&&wf((function(){return 7!=Rf(dm({},"a",{get:function(){return dm(this,"a",{value:7}).a}})).a}))?function(e,t,r){var a=um(om,t);a&&delete om[t],dm(e,t,r),a&&e!==om&&dm(om,t,a)}:dm,km=function(e,t){var r=hm[e]=Rf(lm);return am(r,{type:tm,tag:e,description:t}),Nf||(r.description=t),r},Cm=function(e,t,r){e===om&&Cm(vm,t,r),Ef(e);var a=Df(t);return Ef(r),Sf(hm,a)?(r.enumerable?(Sf(e,em)&&e[em][a]&&(e[em][a]=!1),r=Rf(r,{enumerable:Ff(0,!1)})):(Sf(e,em)||dm(e,em,Ff(1,{})),e[em][a]=!0),bm(e,a,r)):dm(e,a,r)},_m=function(e,t){Ef(e);var r=Af(t),a=Of(r).concat(Sm(r));return Xf(a,(function(t){Nf&&!Cf(Nm,r,t)||Cm(e,t,r[t])})),e},Nm=function(e){var t=Df(e),r=Cf(fm,this,t);return!(this===om&&Sf(hm,t)&&!Sf(vm,t))&&(!(r||!Sf(this,t)||!Sf(hm,t)||Sf(this,em)&&this[em][t])||r)},Pm=function(e,t){var r=Af(e),a=Df(t);if(r!==om||!Sf(hm,a)||Sf(vm,a)){var n=um(r,a);return!n||!Sf(hm,a)||Sf(r,em)&&r[em][a]||(n.enumerable=!0),n}},wm=function(e){var t=pm(Af(e)),r=[];return Xf(t,(function(e){Sf(hm,e)||Sf(qf,e)||mm(r,e)})),r},Sm=function(e){var t=e===om,r=pm(t?vm:Af(e)),a=[];return Xf(r,(function(e){!Sf(hm,e)||t&&!Sf(om,e)||mm(a,hm[e])})),a};Pf||(im=function(){if(xf(lm,this))throw cm("Symbol is not a constructor");var e=arguments.length&&void 0!==arguments[0]?If(arguments[0]):void 0,t=Wf(e),r=function(e){this===om&&Cf(r,vm,e),Sf(this,em)&&Sf(this[em],t)&&(this[em][t]=!1),bm(this,t,Ff(1,e))};return Nf&&gm&&bm(om,t,{configurable:!0,set:r}),km(t,e)},Uf(lm=im[rm],"toString",(function(){return nm(this).tag})),Uf(im,"withoutSetter",(function(e){return km(Wf(e),e)})),Vf.f=Nm,Mf.f=Cm,Lf.f=_m,zf.f=Pm,Tf.f=Bf.f=wm,jf.f=Sm,Gf.f=function(e){return km(Yf(e),e)},Nf&&Kf(lm,"description",{configurable:!0,get:function(){return nm(this).description}})),bf({global:!0,constructor:!0,wrap:!0,forced:!Pf,sham:!Pf},{Symbol:im}),Xf(Of(ym),(function(e){Jf(e)})),bf({target:tm,stat:!0,forced:!Pf},{useSetter:function(){gm=!0},useSimple:function(){gm=!1}}),bf({target:"Object",stat:!0,forced:!Pf,sham:!Nf},{create:function(e,t){return void 0===t?Rf(e):_m(Rf(e),t)},defineProperty:Cm,defineProperties:_m,getOwnPropertyDescriptor:Pm}),bf({target:"Object",stat:!0,forced:!Pf},{getOwnPropertyNames:wm}),Qf(),Zf(im,tm),qf[em]=!0;var xm=Ce&&!!Symbol.for&&!!Symbol.keyFor,Em=Dr,Am=se,Dm=et,Im=go,Fm=Ve,Rm=xm,Om=Fm("string-to-symbol-registry"),Tm=Fm("symbol-to-string-registry");Em({target:"Symbol",stat:!0,forced:!Rm},{for:function(e){var t=Im(e);if(Dm(Om,t))return Om[t];var r=Am("Symbol")(t);return Om[t]=r,Tm[r]=t,r}});var Bm=Dr,jm=et,zm=xe,Mm=Ae,Lm=xm,Vm=Ve("symbol-to-string-registry");Bm({target:"Symbol",stat:!0,forced:!Lm},{keyFor:function(e){if(!zm(e))throw TypeError(Mm(e)+" is not a symbol");if(jm(Vm,e))return Vm[e]}});var Um=cp,Km=D,Hm=N,qm=go,Wm=b([].push),Ym=Dr,Gm=se,Jm=m,Qm=T,Zm=b,$m=c,Xm=D,eh=xe,th=ec,rh=function(e){if(Km(e))return e;if(Um(e)){for(var t=e.length,r=[],a=0;a<t;a++){var n=e[a];"string"==typeof n?Wm(r,n):"number"!=typeof n&&"Number"!=Hm(n)&&"String"!=Hm(n)||Wm(r,qm(n))}var o=r.length,i=!0;return function(e,t){if(i)return i=!1,t;if(Um(this))return t;for(var a=0;a<o;a++)if(r[a]===e)return t}}},ah=Ce,nh=String,oh=Gm("JSON","stringify"),ih=Zm(/./.exec),lh=Zm("".charAt),ch=Zm("".charCodeAt),sh=Zm("".replace),uh=Zm(1..toString),dh=/[\uD800-\uDFFF]/g,ph=/^[\uD800-\uDBFF]$/,fh=/^[\uDC00-\uDFFF]$/,mh=!ah||$m((function(){var e=Gm("Symbol")();return"[null]"!=oh([e])||"{}"!=oh({a:e})||"{}"!=oh(Object(e))})),hh=$m((function(){return'"\\udf06\\ud834"'!==oh("\udf06\ud834")||'"\\udead"'!==oh("\udead")})),vh=function(e,t){var r=th(arguments),a=rh(t);if(Xm(a)||void 0!==e&&!eh(e))return r[1]=function(e,t){if(Xm(a)&&(t=Qm(a,this,nh(e),t)),!eh(t))return t},Jm(oh,null,r)},yh=function(e,t,r){var a=lh(r,t-1),n=lh(r,t+1);return ih(ph,e)&&!ih(fh,n)||ih(fh,e)&&!ih(ph,a)?"\\u"+uh(ch(e,0),16):e};oh&&Ym({target:"JSON",stat:!0,arity:3,forced:mh||hh},{stringify:function(e,t,r){var a=th(arguments),n=Jm(mh?vh:oh,null,a);return hh&&"string"==typeof n?sh(n,dh,yh):n}});var gh=xa,bh=Ze;Dr({target:"Object",stat:!0,forced:!Ce||c((function(){gh.f(1)}))},{getOwnPropertySymbols:function(e){var t=gh.f;return t?t(bh(e)):[]}}),nf("asyncIterator"),nf("hasInstance"),nf("isConcatSpreadable"),nf("iterator"),nf("match"),nf("matchAll"),nf("replace"),nf("search"),nf("species"),nf("split");var kh=uf;nf("toPrimitive"),kh();var Ch=se,_h=Ii;nf("toStringTag"),_h(Ch("Symbol"),"Symbol"),nf("unscopables"),Ii(l.JSON,"JSON",!0);var Nh=ne.Symbol;nf("dispose");var Ph=Nh;nf("asyncDispose");var wh=Dr,Sh=b,xh=se("Symbol"),Eh=xh.keyFor,Ah=Sh(xh.prototype.valueOf);wh({target:"Symbol",stat:!0},{isRegistered:function(e){try{return void 0!==Eh(Ah(e))}catch(e){return!1}}});for(var Dh=Dr,Ih=Ve,Fh=se,Rh=b,Oh=xe,Th=mt,Bh=Fh("Symbol"),jh=Bh.isWellKnown,zh=Fh("Object","getOwnPropertyNames"),Mh=Rh(Bh.prototype.valueOf),Lh=Ih("wks"),Vh=0,Uh=zh(Bh),Kh=Uh.length;Vh<Kh;Vh++)try{var Hh=Uh[Vh];Oh(Bh[Hh])&&Th(Hh)}catch(lL){}Dh({target:"Symbol",stat:!0,forced:!0},{isWellKnown:function(e){if(jh&&jh(e))return!0;try{for(var t=Mh(e),r=0,a=zh(Lh),n=a.length;r<n;r++)if(Lh[a[r]]==t)return!0}catch(e){}return!1}}),nf("matcher"),nf("metadataKey"),nf("observable"),nf("metadata"),nf("patternMatch"),nf("replaceAll");var qh=Ph;!function(e){e.exports=qh}(ip),function(e){e.exports=op}(np);var Wh=t(ap),Yh={},Gh={get exports(){return Yh},set exports(e){Yh=e}},Jh={},Qh={get exports(){return Jh},set exports(e){Jh=e}},Zh=$p.f("iterator"),$h=Zh;!function(e){e.exports=$h}(Qh),function(e){e.exports=Jh}(Gh);var Xh=t(Yh);!function(e){var t=ap,r=Yh;function a(n){return e.exports=a="function"==typeof t&&"symbol"==typeof r?function(e){return typeof e}:function(e){return e&&"function"==typeof t&&e.constructor===t&&e!==t.prototype?"symbol":typeof e},e.exports.__esModule=!0,e.exports.default=e.exports,a(n)}e.exports=a,e.exports.__esModule=!0,e.exports.default=e.exports}(rp);var ev={},tv={get exports(){return ev},set exports(e){ev=e}},rv={},av={get exports(){return rv},set exports(e){rv=e}},nv={},ov={get exports(){return nv},set exports(e){nv=e}},iv=Dr,lv=F,cv=Xt.f;iv({target:"Object",stat:!0,forced:Object.defineProperty!==cv,sham:!lv},{defineProperty:cv});var sv=ne.Object,uv=ov.exports=function(e,t,r){return sv.defineProperty(e,t,r)};sv.defineProperty.sham&&(uv.sham=!0);var dv=nv,pv=dv;!function(e){e.exports=pv}(av),function(e){e.exports=rv}(tv);var fv=t(ev),mv={},hv={get exports(){return mv},set exports(e){mv=e}},vv={},yv={get exports(){return vv},set exports(e){vv=e}};Dr({target:"Object",stat:!0,sham:!F},{create:un});var gv=ne.Object,bv=function(e,t){return gv.create(e,t)},kv=bv,Cv=kv;!function(e){e.exports=Cv}(yv),function(e){e.exports=vv}(hv);var _v=t(mv),Nv={},Pv={get exports(){return Nv},set exports(e){Nv=e}},wv={},Sv={get exports(){return wv},set exports(e){wv=e}},xv=Ze,Ev=Ur,Av=Or;Dr({target:"Object",stat:!0,forced:c((function(){Ev(1)})),sham:!Av},{getPrototypeOf:function(e){return Ev(xv(e))}});var Dv=ne.Object.getPrototypeOf;!function(e){e.exports=Dv}(Sv),function(e){e.exports=wv}(Pv);var Iv=t(Nv),Fv={},Rv={get exports(){return Fv},set exports(e){Fv=e}},Ov={},Tv={get exports(){return Ov},set exports(e){Ov=e}},Bv=c,jv=function(e,t){var r=[][e];return!!r&&Bv((function(){r.call(null,t||function(){return 1},1)}))},zv=gf.forEach,Mv=jv("forEach")?[].forEach:function(e){return zv(this,e,arguments.length>1?arguments[1]:void 0)};Dr({target:"Array",proto:!0,forced:[].forEach!=Mv},{forEach:Mv});var Lv=ne,Vv=function(e){return Lv[e+"Prototype"]},Uv=Vv("Array").forEach,Kv=jn,Hv=et,qv=ue,Wv=Uv,Yv=Array.prototype,Gv={DOMTokenList:!0,NodeList:!0},Jv=function(e){var t=e.forEach;return e===Yv||qv(Yv,e)&&t===Yv.forEach||Hv(Gv,Kv(e))?Wv:t},Qv=Jv;!function(e){e.exports=Qv}(Tv),function(e){e.exports=Ov}(Rv);var Zv={},$v={get exports(){return Zv},set exports(e){Zv=e}},Xv={},ey={get exports(){return Xv},set exports(e){Xv=e}};Dr({target:"Object",stat:!0},{setPrototypeOf:Zr});var ty=ne.Object.setPrototypeOf;!function(e){e.exports=ty}(ey),function(e){e.exports=Xv}($v);var ry=t(Zv),ay={},ny={get exports(){return ay},set exports(e){ay=e}},oy={},iy={get exports(){return oy},set exports(e){oy=e}},ly=Dr,cy=cp,sy=b([].reverse),uy=[1,2];ly({target:"Array",proto:!0,forced:String(uy)===String(uy.reverse())},{reverse:function(){return cy(this)&&(this.length=this.length),sy(this)}});var dy=Vv("Array").reverse,py=ue,fy=dy,my=Array.prototype,hy=function(e){var t=e.reverse;return e===my||py(my,e)&&t===my.reverse?fy:t},vy=hy;!function(e){e.exports=vy}(iy),function(e){e.exports=oy}(ny);var yy={},gy={get exports(){return yy},set exports(e){yy=e}},by={},ky={get exports(){return by},set exports(e){by=e}},Cy=Dr,_y=cp,Ny=Hl,Py=ae,wy=la,Sy=da,xy=ee,Ey=mp,Ay=mt,Dy=ec,Iy=wp("slice"),Fy=Ay("species"),Ry=Array,Oy=Math.max;Cy({target:"Array",proto:!0,forced:!Iy},{slice:function(e,t){var r,a,n,o=xy(this),i=Sy(o),l=wy(e,i),c=wy(void 0===t?i:t,i);if(_y(o)&&(r=o.constructor,(Ny(r)&&(r===Ry||_y(r.prototype))||Py(r)&&null===(r=r[Fy]))&&(r=void 0),r===Ry||void 0===r))return Dy(o,l,c);for(a=new(void 0===r?Ry:r)(Oy(c-l,0)),n=0;l<c;l++,n++)l in o&&Ey(a,n,o[l]);return a.length=n,a}});var Ty=Vv("Array").slice,By=ue,jy=Ty,zy=Array.prototype,My=function(e){var t=e.slice;return e===zy||By(zy,e)&&t===zy.slice?jy:t},Ly=My;!function(e){e.exports=Ly}(ky),function(e){e.exports=by}(gy);var Vy=t(yy);!function(e){var t=tp.default,a=ev,n=ap,o=mv,i=Nv,l=Fv,c=Zv,s=r,u=ay,d=yy;function p(){e.exports=p=function(){return r},e.exports.__esModule=!0,e.exports.default=e.exports;var r={},f=Object.prototype,m=f.hasOwnProperty,h=a||function(e,t,r){e[t]=r.value},v="function"==typeof n?n:{},y=v.iterator||"@@iterator",g=v.asyncIterator||"@@asyncIterator",b=v.toStringTag||"@@toStringTag";function k(e,t,r){return a(e,t,{value:r,enumerable:!0,configurable:!0,writable:!0}),e[t]}try{k({},"")}catch(e){k=function(e,t,r){return e[t]=r}}function C(e,t,r,a){var n=t&&t.prototype instanceof P?t:P,i=o(n.prototype),l=new B(a||[]);return h(i,"_invoke",{value:F(e,r,l)}),i}function _(e,t,r){try{return{type:"normal",arg:e.call(t,r)}}catch(e){return{type:"throw",arg:e}}}r.wrap=C;var N={};function P(){}function w(){}function S(){}var x={};k(x,y,(function(){return this}));var E=i&&i(i(j([])));E&&E!==f&&m.call(E,y)&&(x=E);var A=S.prototype=P.prototype=o(x);function D(e){var t;l(t=["next","throw","return"]).call(t,(function(t){k(e,t,(function(e){return this._invoke(t,e)}))}))}function I(e,r){function a(n,o,i,l){var c=_(e[n],e,o);if("throw"!==c.type){var s=c.arg,u=s.value;return u&&"object"==t(u)&&m.call(u,"__await")?r.resolve(u.__await).then((function(e){a("next",e,i,l)}),(function(e){a("throw",e,i,l)})):r.resolve(u).then((function(e){s.value=e,i(s)}),(function(e){return a("throw",e,i,l)}))}l(c.arg)}var n;h(this,"_invoke",{value:function(e,t){function o(){return new r((function(r,n){a(e,t,r,n)}))}return n=n?n.then(o,o):o()}})}function F(e,t,r){var a="suspendedStart";return function(n,o){if("executing"===a)throw new Error("Generator is already running");if("completed"===a){if("throw"===n)throw o;return z()}for(r.method=n,r.arg=o;;){var i=r.delegate;if(i){var l=R(i,r);if(l){if(l===N)continue;return l}}if("next"===r.method)r.sent=r._sent=r.arg;else if("throw"===r.method){if("suspendedStart"===a)throw a="completed",r.arg;r.dispatchException(r.arg)}else"return"===r.method&&r.abrupt("return",r.arg);a="executing";var c=_(e,t,r);if("normal"===c.type){if(a=r.done?"completed":"suspendedYield",c.arg===N)continue;return{value:c.arg,done:r.done}}"throw"===c.type&&(a="completed",r.method="throw",r.arg=c.arg)}}}function R(e,t){var r=t.method,a=e.iterator[r];if(void 0===a)return t.delegate=null,"throw"===r&&e.iterator.return&&(t.method="return",t.arg=void 0,R(e,t),"throw"===t.method)||"return"!==r&&(t.method="throw",t.arg=new TypeError("The iterator does not provide a '"+r+"' method")),N;var n=_(a,e.iterator,t.arg);if("throw"===n.type)return t.method="throw",t.arg=n.arg,t.delegate=null,N;var o=n.arg;return o?o.done?(t[e.resultName]=o.value,t.next=e.nextLoc,"return"!==t.method&&(t.method="next",t.arg=void 0),t.delegate=null,N):o:(t.method="throw",t.arg=new TypeError("iterator result is not an object"),t.delegate=null,N)}function O(e){var t={tryLoc:e[0]};1 in e&&(t.catchLoc=e[1]),2 in e&&(t.finallyLoc=e[2],t.afterLoc=e[3]),this.tryEntries.push(t)}function T(e){var t=e.completion||{};t.type="normal",delete t.arg,e.completion=t}function B(e){this.tryEntries=[{tryLoc:"root"}],l(e).call(e,O,this),this.reset(!0)}function j(e){if(e){var t=e[y];if(t)return t.call(e);if("function"==typeof e.next)return e;if(!isNaN(e.length)){var r=-1,a=function t(){for(;++r<e.length;)if(m.call(e,r))return t.value=e[r],t.done=!1,t;return t.value=void 0,t.done=!0,t};return a.next=a}}return{next:z}}function z(){return{value:void 0,done:!0}}return w.prototype=S,h(A,"constructor",{value:S,configurable:!0}),h(S,"constructor",{value:w,configurable:!0}),w.displayName=k(S,b,"GeneratorFunction"),r.isGeneratorFunction=function(e){var t="function"==typeof e&&e.constructor;return!!t&&(t===w||"GeneratorFunction"===(t.displayName||t.name))},r.mark=function(e){return c?c(e,S):(e.__proto__=S,k(e,b,"GeneratorFunction")),e.prototype=o(A),e},r.awrap=function(e){return{__await:e}},D(I.prototype),k(I.prototype,g,(function(){return this})),r.AsyncIterator=I,r.async=function(e,t,a,n,o){void 0===o&&(o=s);var i=new I(C(e,t,a,n),o);return r.isGeneratorFunction(t)?i:i.next().then((function(e){return e.done?e.value:i.next()}))},D(A),k(A,b,"Generator"),k(A,y,(function(){return this})),k(A,"toString",(function(){return"[object Generator]"})),r.keys=function(e){var t=Object(e),r=[];for(var a in t)r.push(a);return u(r).call(r),function e(){for(;r.length;){var a=r.pop();if(a in t)return e.value=a,e.done=!1,e}return e.done=!0,e}},r.values=j,B.prototype={constructor:B,reset:function(e){var t;if(this.prev=0,this.next=0,this.sent=this._sent=void 0,this.done=!1,this.delegate=null,this.method="next",this.arg=void 0,l(t=this.tryEntries).call(t,T),!e)for(var r in this)"t"===r.charAt(0)&&m.call(this,r)&&!isNaN(+d(r).call(r,1))&&(this[r]=void 0)},stop:function(){this.done=!0;var e=this.tryEntries[0].completion;if("throw"===e.type)throw e.arg;return this.rval},dispatchException:function(e){if(this.done)throw e;var t=this;function r(r,a){return o.type="throw",o.arg=e,t.next=r,a&&(t.method="next",t.arg=void 0),!!a}for(var a=this.tryEntries.length-1;a>=0;--a){var n=this.tryEntries[a],o=n.completion;if("root"===n.tryLoc)return r("end");if(n.tryLoc<=this.prev){var i=m.call(n,"catchLoc"),l=m.call(n,"finallyLoc");if(i&&l){if(this.prev<n.catchLoc)return r(n.catchLoc,!0);if(this.prev<n.finallyLoc)return r(n.finallyLoc)}else if(i){if(this.prev<n.catchLoc)return r(n.catchLoc,!0)}else{if(!l)throw new Error("try statement without catch or finally");if(this.prev<n.finallyLoc)return r(n.finallyLoc)}}}},abrupt:function(e,t){for(var r=this.tryEntries.length-1;r>=0;--r){var a=this.tryEntries[r];if(a.tryLoc<=this.prev&&m.call(a,"finallyLoc")&&this.prev<a.finallyLoc){var n=a;break}}n&&("break"===e||"continue"===e)&&n.tryLoc<=t&&t<=n.finallyLoc&&(n=null);var o=n?n.completion:{};return o.type=e,o.arg=t,n?(this.method="next",this.next=n.finallyLoc,N):this.complete(o)},complete:function(e,t){if("throw"===e.type)throw e.arg;return"break"===e.type||"continue"===e.type?this.next=e.arg:"return"===e.type?(this.rval=this.arg=e.arg,this.method="return",this.next="end"):"normal"===e.type&&t&&(this.next=t),N},finish:function(e){for(var t=this.tryEntries.length-1;t>=0;--t){var r=this.tryEntries[t];if(r.finallyLoc===e)return this.complete(r.completion,r.afterLoc),T(r),N}},catch:function(e){for(var t=this.tryEntries.length-1;t>=0;--t){var r=this.tryEntries[t];if(r.tryLoc===e){var a=r.completion;if("throw"===a.type){var n=a.arg;T(r)}return n}}throw new Error("illegal catch attempt")},delegateYield:function(e,t,r){return this.delegate={iterator:j(e),resultName:t,nextLoc:r},"next"===this.method&&(this.arg=void 0),N}},r}e.exports=p,e.exports.__esModule=!0,e.exports.default=e.exports}(ep);var Uy=Xd(),Ky=Uy;try{regeneratorRuntime=Uy}catch(e){"object"==typeof globalThis?globalThis.regeneratorRuntime=Uy:Function("r","regeneratorRuntime = r")(Uy)}var Hy={},qy={get exports(){return Hy},set exports(e){Hy=e}},Wy=Ze,Yy=Va;Dr({target:"Object",stat:!0,forced:c((function(){Yy(1)}))},{keys:function(e){return Yy(Wy(e))}});var Gy=ne.Object.keys;!function(e){e.exports=Gy}(qy);var Jy=t(Hy),Qy={},Zy={get exports(){return Qy},set exports(e){Qy=e}},$y=ne.Object.getOwnPropertySymbols;!function(e){e.exports=$y}(Zy);var Xy=t(Qy),eg={},tg={get exports(){return eg},set exports(e){eg=e}},rg={},ag={get exports(){return rg},set exports(e){rg=e}},ng=Dr,og=c,ig=ee,lg=I.f,cg=F;ng({target:"Object",stat:!0,forced:!cg||og((function(){lg(1)})),sham:!cg},{getOwnPropertyDescriptor:function(e,t){return lg(ig(e),t)}});var sg=ne.Object,ug=ag.exports=function(e,t){return sg.getOwnPropertyDescriptor(e,t)};sg.getOwnPropertyDescriptor.sham&&(ug.sham=!0);var dg=rg;!function(e){e.exports=dg}(tg);var pg=t(eg),fg={},mg={get exports(){return fg},set exports(e){fg=e}},hg=Ra,vg=ee,yg=I,gg=mp;Dr({target:"Object",stat:!0,sham:!F},{getOwnPropertyDescriptors:function(e){for(var t,r,a=vg(e),n=yg.f,o=hg(a),i={},l=0;o.length>l;)void 0!==(r=n(a,t=o[l++]))&&gg(i,t,r);return i}});var bg=ne.Object.getOwnPropertyDescriptors;!function(e){e.exports=bg}(mg);var kg=t(fg),Cg={},_g={get exports(){return Cg},set exports(e){Cg=e}},Ng={},Pg={get exports(){return Ng},set exports(e){Ng=e}},wg=Dr,Sg=F,xg=za.f;wg({target:"Object",stat:!0,forced:Object.defineProperties!==xg,sham:!Sg},{defineProperties:xg});var Eg=ne.Object,Ag=Pg.exports=function(e,t){return Eg.defineProperties(e,t)};Eg.defineProperties.sham&&(Ag.sham=!0);var Dg=Ng;!function(e){e.exports=Dg}(_g);var Ig=t(Cg),Fg={},Rg={get exports(){return Fg},set exports(e){Fg=e}};!function(e){e.exports=dv}(Rg);var Og=t(Fg);function Tg(e){return Tg="function"==typeof Wh&&"symbol"==typeof Xh?function(e){return typeof e}:function(e){return e&&"function"==typeof Wh&&e.constructor===Wh&&e!==Wh.prototype?"symbol":typeof e},Tg(e)}function Bg(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}var jg={},zg={get exports(){return jg},set exports(e){jg=e}},Mg={},Lg={get exports(){return Mg},set exports(e){Mg=e}},Vg=$p.f("toPrimitive");!function(e){e.exports=Vg}(Lg),function(e){e.exports=Mg}(zg);var Ug=t(jg);function Kg(e){var t=function(e,t){if("object"!==Tg(e)||null===e)return e;var r=e[Ug];if(void 0!==r){var a=r.call(e,t||"default");if("object"!==Tg(a))return a;throw new TypeError("@@toPrimitive must return a primitive value.")}return("string"===t?String:Number)(e)}(e,"string");return"symbol"===Tg(t)?t:String(t)}function Hg(e,t){for(var r=0;r<t.length;r++){var a=t[r];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),fv(e,Kg(a.key),a)}}function qg(e,t,r){return t&&Hg(e.prototype,t),r&&Hg(e,r),fv(e,"prototype",{writable:!1}),e}function Wg(e,t,r){return(t=Kg(t))in e?fv(e,t,{value:r,enumerable:!0,configurable:!0,writable:!0}):e[t]=r,e}var Yg={},Gg={get exports(){return Yg},set exports(e){Yg=e}};!function(e){e.exports=Jv}(Gg);var Jg=t(Yg),Qg={},Zg={get exports(){return Qg},set exports(e){Qg=e}},$g=gf.filter;Dr({target:"Array",proto:!0,forced:!wp("filter")},{filter:function(e){return $g(this,e,arguments.length>1?arguments[1]:void 0)}});var Xg=Vv("Array").filter,eb=ue,tb=Xg,rb=Array.prototype,ab=function(e){var t=e.filter;return e===rb||eb(rb,e)&&t===rb.filter?tb:t};!function(e){e.exports=ab}(Zg);var nb=t(Qg),ob={},ib={get exports(){return ob},set exports(e){ob=e}},lb=va.includes;Dr({target:"Array",proto:!0,forced:c((function(){return!Array(1).includes()}))},{includes:function(e){return lb(this,e,arguments.length>1?arguments[1]:void 0)}});var cb=Vv("Array").includes,sb=ae,ub=N,db=mt("match"),pb=function(e){var t;return sb(e)&&(void 0!==(t=e[db])?!!t:"RegExp"==ub(e))},fb=TypeError,mb=mt("match"),hb=Dr,vb=function(e){if(pb(e))throw fb("The method doesn't accept regular expressions");return e},yb=Z,gb=go,bb=function(e){var t=/./;try{"/./"[e](t)}catch(r){try{return t[mb]=!1,"/./"[e](t)}catch(e){}}return!1},kb=b("".indexOf);hb({target:"String",proto:!0,forced:!bb("includes")},{includes:function(e){return!!~kb(gb(yb(this)),gb(vb(e)),arguments.length>1?arguments[1]:void 0)}});var Cb=Vv("String").includes,_b=ue,Nb=cb,Pb=Cb,wb=Array.prototype,Sb=String.prototype,xb=function(e){var t=e.includes;return e===wb||_b(wb,e)&&t===wb.includes?Nb:"string"==typeof e||e===Sb||_b(Sb,e)&&t===Sb.includes?Pb:t};!function(e){e.exports=xb}(ib);var Eb=t(ob),Ab={},Db={get exports(){return Ab},set exports(e){Ab=e}},Ib=Vv("Array").concat,Fb=ue,Rb=Ib,Ob=Array.prototype,Tb=function(e){var t=e.concat;return e===Ob||Fb(Ob,e)&&t===Ob.concat?Rb:t};!function(e){e.exports=Tb}(Db);var Bb=t(Ab),jb={},zb={get exports(){return jb},set exports(e){jb=e}},Mb=b,Lb=Re,Vb=ae,Ub=et,Kb=ec,Hb=s,qb=Function,Wb=Mb([].concat),Yb=Mb([].join),Gb={},Jb=Hb?qb.bind:function(e){var t=Lb(this),r=t.prototype,a=Kb(arguments,1),n=function(){var r=Wb(a,Kb(arguments));return this instanceof n?function(e,t,r){if(!Ub(Gb,t)){for(var a=[],n=0;n<t;n++)a[n]="a["+n+"]";Gb[t]=qb("C,a","return new C("+Yb(a,",")+")")}return Gb[t](e,r)}(t,r.length,r):t.apply(e,r)};return Vb(r)&&(n.prototype=r),n},Qb=Jb;Dr({target:"Function",proto:!0,forced:Function.bind!==Qb},{bind:Qb});var Zb=Vv("Function").bind,$b=ue,Xb=Zb,ek=Function.prototype,tk=function(e){var t=e.bind;return e===ek||$b(ek,e)&&t===ek.bind?Xb:t};!function(e){e.exports=tk}(zb);var rk=t(jb),ak={},nk={get exports(){return ak},set exports(e){ak=e}};!function(e){e.exports=qd}(nk);var ok=t(ak),ik={},lk={get exports(){return ik},set exports(e){ik=e}},ck=Dr,sk=gf.find,uk="find",dk=!0;uk in[]&&Array(1)[uk]((function(){dk=!1})),ck({target:"Array",proto:!0,forced:dk},{find:function(e){return sk(this,e,arguments.length>1?arguments[1]:void 0)}});var pk=Vv("Array").find,fk=ue,mk=pk,hk=Array.prototype,vk=function(e){var t=e.find;return e===hk||fk(hk,e)&&t===hk.find?mk:t};!function(e){e.exports=vk}(lk);var yk=t(ik),gk={},bk={get exports(){return gk},set exports(e){gk=e}},kk={},Ck={get exports(){return kk},set exports(e){kk=e}};Dr({target:"Array",stat:!0},{isArray:cp});var _k=ne.Array.isArray,Nk=_k;!function(e){e.exports=Nk}(Ck),function(e){e.exports=kk}(bk);var Pk=t(gk);var wk={},Sk={get exports(){return wk},set exports(e){wk=e}},xk={},Ek={get exports(){return xk},set exports(e){xk=e}},Ak=Kn;!function(e){e.exports=Ak}(Ek),function(e){e.exports=xk}(Sk);var Dk=t(wk);var Ik={},Fk={get exports(){return Ik},set exports(e){Ik=e}},Rk={},Ok={get exports(){return Rk},set exports(e){Rk=e}},Tk=nr,Bk=eo,jk=$t,zk=T,Mk=Ze,Lk=function(e,t,r,a){try{return a?t(Tk(r)[0],r[1]):t(r)}catch(t){Bk(e,"throw",t)}},Vk=En,Uk=Hl,Kk=da,Hk=mp,qk=Qn,Wk=Kn,Yk=Array,Gk=function(e){var t=Mk(e),r=Uk(this),a=arguments.length,n=a>1?arguments[1]:void 0,o=void 0!==n;o&&(n=jk(n,a>2?arguments[2]:void 0));var i,l,c,s,u,d,p=Wk(t),f=0;if(!p||this===Yk&&Vk(p))for(i=Kk(t),l=r?new this(i):Yk(i);i>f;f++)d=o?n(t[f],f):t[f],Hk(l,f,d);else for(u=(s=qk(t,p)).next,l=r?new this:[];!(c=zk(u,s)).done;f++)d=o?Lk(s,n,[c.value,f],!0):c.value,Hk(l,f,d);return l.length=f,l},Jk=Gk;Dr({target:"Array",stat:!0,forced:!wu((function(e){Array.from(e)}))},{from:Jk});var Qk=ne.Array.from,Zk=Qk;!function(e){e.exports=Zk}(Ok),function(e){e.exports=Rk}(Fk);var $k=t(Ik);function Xk(e,t){(null==t||t>e.length)&&(t=e.length);for(var r=0,a=new Array(t);r<t;r++)a[r]=e[r];return a}function eC(e,t){var r;if(e){if("string"==typeof e)return Xk(e,t);var a=Vy(r=Object.prototype.toString.call(e)).call(r,8,-1);return"Object"===a&&e.constructor&&(a=e.constructor.name),"Map"===a||"Set"===a?$k(e):"Arguments"===a||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a)?Xk(e,t):void 0}}function tC(e,t){return function(e){if(Pk(e))return e}(e)||function(e,t){var r=null==e?null:void 0!==Wh&&Dk(e)||e["@@iterator"];if(null!=r){var a,n,o,i,l=[],c=!0,s=!1;try{if(o=(r=r.call(e)).next,0===t){if(Object(r)!==r)return;c=!1}else for(;!(c=(a=o.call(r)).done)&&(l.push(a.value),l.length!==t);c=!0);}catch(e){s=!0,n=e}finally{try{if(!c&&null!=r.return&&(i=r.return(),Object(i)!==i))return}finally{if(s)throw n}}return l}}(e,t)||eC(e,t)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function rC(e){return function(e){if(Pk(e))return Xk(e)}(e)||function(e){if(void 0!==Wh&&null!=Dk(e)||null!=e["@@iterator"])return $k(e)}(e)||eC(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}var aC={},nC={get exports(){return aC},set exports(e){aC=e}},oC=Dr,iC=va.indexOf,lC=jv,cC=S([].indexOf),sC=!!cC&&1/cC([1],1,-0)<0;oC({target:"Array",proto:!0,forced:sC||!lC("indexOf")},{indexOf:function(e){var t=arguments.length>1?arguments[1]:void 0;return sC?cC(this,e,t)||0:iC(this,e,t)}});var uC=Vv("Array").indexOf,dC=ue,pC=uC,fC=Array.prototype,mC=function(e){var t=e.indexOf;return e===fC||dC(fC,e)&&t===fC.indexOf?pC:t};!function(e){e.exports=mC}(nC);var hC=t(aC),vC={},yC={get exports(){return vC},set exports(e){vC=e}},gC=Re,bC=Ze,kC=Y,CC=da,_C=TypeError,NC=function(e){return function(t,r,a,n){gC(r);var o=bC(t),i=kC(o),l=CC(o),c=e?l-1:0,s=e?-1:1;if(a<2)for(;;){if(c in i){n=i[c],c+=s;break}if(c+=s,e?c<0:l<=c)throw _C("Reduce of empty array with no initial value")}for(;e?c>=0:l>c;c+=s)c in i&&(n=r(n,i[c],c,o));return n}},PC={left:NC(!1),right:NC(!0)}.left;Dr({target:"Array",proto:!0,forced:!pl&&ge>79&&ge<83||!jv("reduce")},{reduce:function(e){var t=arguments.length;return PC(this,e,t,t>1?arguments[1]:void 0)}});var wC=Vv("Array").reduce,SC=ue,xC=wC,EC=Array.prototype,AC=function(e){var t=e.reduce;return e===EC||SC(EC,e)&&t===EC.reduce?xC:t};!function(e){e.exports=AC}(yC);var DC=t(vC),IC={},FC={get exports(){return IC},set exports(e){IC=e}},RC=Vv("Array").values,OC=jn,TC=et,BC=ue,jC=RC,zC=Array.prototype,MC={DOMTokenList:!0,NodeList:!0},LC=function(e){var t=e.values;return e===zC||BC(zC,e)&&t===zC.values||TC(MC,OC(e))?jC:t};!function(e){e.exports=LC}(FC);var VC=t(IC),UC={},KC={get exports(){return UC},set exports(e){UC=e}},HC=gf.map;Dr({target:"Array",proto:!0,forced:!wp("map")},{map:function(e){return HC(this,e,arguments.length>1?arguments[1]:void 0)}});var qC=Vv("Array").map,WC=ue,YC=qC,GC=Array.prototype,JC=function(e){var t=e.map;return e===GC||WC(GC,e)&&t===GC.map?YC:t};!function(e){e.exports=JC}(KC);var QC=t(UC),ZC={payButton:"Pay","payButton.redirecting":"Redirecting...","payButton.with":"Pay %{value} with %{maskedData}",close:"Close",storeDetails:"Save for my next payment","creditCard.holderName":"Name on card","creditCard.holderName.placeholder":"J. Smith","creditCard.holderName.invalid":"Invalid cardholder name","creditCard.numberField.title":"Card number","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"Expiry date","creditCard.expiryDateField.placeholder":"MM/YY","creditCard.expiryDateField.month":"Month","creditCard.expiryDateField.month.placeholder":"MM","creditCard.expiryDateField.year.placeholder":"YY","creditCard.expiryDateField.year":"Year","creditCard.cvcField.title":"CVC / CVV","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"Remember for next time","creditCard.cvcField.placeholder.4digits":"4 digits","creditCard.cvcField.placeholder.3digits":"3 digits","creditCard.taxNumber.placeholder":"YYMMDD / 0123456789",installments:"Number of installments",installmentOption:"%{times}x %{partialValue}",installmentOptionMonths:"%{times} months","installments.oneTime":"One time payment","installments.installments":"Installments payment","installments.revolving":"Revolving payment","sepaDirectDebit.ibanField.invalid":"Invalid account number","sepaDirectDebit.nameField.placeholder":"J. Smith","sepa.ownerName":"Holder Name","sepa.ibanNumber":"Account Number (IBAN)","error.title":"Error","error.subtitle.redirect":"Redirect failed","error.subtitle.payment":"Payment failed","error.subtitle.refused":"Payment refused","error.message.unknown":"An unknown error occurred","errorPanel.title":"Existing errors","idealIssuer.selectField.title":"Bank","idealIssuer.selectField.placeholder":"Select your bank","creditCard.success":"Payment Successful",loading:"Loading\u2026",continue:"Continue",continueTo:"Continue to","wechatpay.timetopay":"You have %@ to pay","wechatpay.scanqrcode":"Scan QR code",personalDetails:"Personal details",companyDetails:"Company details","companyDetails.name":"Company name","companyDetails.registrationNumber":"Registration number",socialSecurityNumber:"Social security number",firstName:"First name","firstName.invalid":"First name is not valid",infix:"Prefix",lastName:"Last name","lastName.invalid":"Last name is not valid",mobileNumber:"Mobile number","mobileNumber.invalid":"Invalid mobile number",city:"City",postalCode:"Postal code","postalCode.optional":"Postal code (optional)",countryCode:"Country Code",telephoneNumber:"Telephone number",dateOfBirth:"Date of birth",shopperEmail:"Email address",gender:"Gender",male:"Male",female:"Female",billingAddress:"Billing address",street:"Street",stateOrProvince:"State or province",country:"Country",houseNumberOrName:"House number",separateDeliveryAddress:"Specify a separate delivery address",deliveryAddress:"Delivery Address",zipCode:"Zip code",apartmentSuite:"Apartment / Suite",provinceOrTerritory:"Province or Territory",cityTown:"City / Town",address:"Address",state:"State","field.title.optional":"(optional)","creditCard.cvcField.title.optional":"CVC / CVV (optional)","issuerList.wallet.placeholder":"Select your wallet",privacyPolicy:"Privacy policy","afterPay.agreement":"I agree with the %@ of AfterPay",paymentConditions:"payment conditions",openApp:"Open the app","voucher.readInstructions":"Read instructions","voucher.introduction":"Thank you for your purchase, please use the following coupon to complete your payment.","voucher.expirationDate":"Expiration Date","voucher.alternativeReference":"Alternative Reference","dragonpay.voucher.non.bank.selectField.placeholder":"Select your provider","dragonpay.voucher.bank.selectField.placeholder":"Select your bank","voucher.paymentReferenceLabel":"Payment Reference","voucher.surcharge":"Incl. %@ surcharge","voucher.introduction.doku":"Thank you for your purchase, please use the following information to complete your payment.","voucher.shopperName":"Shopper Name","voucher.merchantName":"Merchant","voucher.introduction.econtext":"Thank you for your purchase, please use the following information to complete your payment.","voucher.telephoneNumber":"Phone Number","voucher.shopperReference":"Shopper Reference","voucher.collectionInstitutionNumber":"Collection Institution Number","voucher.econtext.telephoneNumber.invalid":"Telephone number must be 10 or 11 digits long","boletobancario.btnLabel":"Generate Boleto","boleto.sendCopyToEmail":"Send a copy to my email","button.copy":"Copy","button.download":"Download","boleto.socialSecurityNumber":"CPF/CNPJ","boleto.socialSecurityNumber.invalid":"Field is not valid","creditCard.storedCard.description.ariaLabel":"Stored card ends in %@","voucher.entity":"Entity",donateButton:"Donate",notNowButton:"Not now",thanksForYourSupport:"Thanks for your support!",preauthorizeWith:"Preauthorize with",confirmPreauthorization:"Confirm preauthorization",confirmPurchase:"Confirm purchase",applyGiftcard:"Redeem",giftcardBalance:"Gift card balance",deductedBalance:"Deducted balance","creditCard.pin.title":"Pin","creditCard.encryptedPassword.label":"First 2 digits of card password","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"Invalid password","creditCard.taxNumber":"Cardholder birthdate or Corporate registration number","creditCard.taxNumber.label":"Cardholder birthdate (YYMMDD) or Corporate registration number (10 digits)","creditCard.taxNumber.labelAlt":"Corporate registration number (10 digits)","creditCard.taxNumber.invalid":"Invalid Cardholder birthdate or Corporate registration number","storedPaymentMethod.disable.button":"Remove","storedPaymentMethod.disable.confirmation":"Remove stored payment method","storedPaymentMethod.disable.confirmButton":"Yes, remove","storedPaymentMethod.disable.cancelButton":"Cancel","ach.bankAccount":"Bank account","ach.accountHolderNameField.title":"Account holder name","ach.accountHolderNameField.placeholder":"J. Smith","ach.accountHolderNameField.invalid":"Invalid account holder name","ach.accountNumberField.title":"Account number","ach.accountNumberField.invalid":"Invalid account number","ach.accountLocationField.title":"ABA routing number","ach.accountLocationField.invalid":"Invalid ABA routing number","ach.savedBankAccount":"Saved bank account","select.state":"Select state","select.stateOrProvince":"Select state or province","select.provinceOrTerritory":"Select province or territory","select.country":"Select country","select.noOptionsFound":"No options found","select.filter.placeholder":"Search...","telephoneNumber.invalid":"Invalid telephone number",qrCodeOrApp:"or","paypal.processingPayment":"Processing payment...",generateQRCode:"Generate QR code","await.waitForConfirmation":"Waiting for confirmation","mbway.confirmPayment":"Confirm your payment on the MB WAY app","shopperEmail.invalid":"Invalid email address","dateOfBirth.format":"DD/MM/YYYY","dateOfBirth.invalid":"You must be at least 18 years old","blik.confirmPayment":"Open your banking app to confirm the payment.","blik.invalid":"Enter 6 numbers","blik.code":"6-digit code","blik.help":"Get the code from your banking app.","swish.pendingMessage":"After you scan, the status can be pending for up to 10 minutes. Attempting to pay again within this time may result in multiple charges.","field.valid":"Field valid","field.invalid":"Field not valid","error.va.gen.01":"Incomplete field","error.va.gen.02":"Field not valid","error.va.sf-cc-num.01":"Card number is not valid","error.va.sf-cc-num.02":"Card number field is empty","error.va.sf-cc-num.03":"Unsupported card number entered","error.va.sf-cc-num.04":"Card number is the wrong length","error.va.sf-cc-dat.01":"Expiry date: card too old","error.va.sf-cc-dat.02":"Expiry date: date too far in the future","error.va.sf-cc-dat.03":"Expiry date: your card expires before check out date","error.va.sf-cc-dat.04":"Expiry date field is empty","error.va.sf-cc-dat.05":"Expiry date is the wrong length","error.va.sf-cc-mth.01":"Expiry month field is empty","error.va.sf-cc-yr.01":"Expiry year field is empty","error.va.sf-cc-yr.02":"Expiry year is the wrong length","error.va.sf-cc-cvc.01":"Security code field is empty","error.va.sf-cc-cvc.02":"Security code is the wrong length","error.va.sf-ach-num.01":"Bank account number field is empty","error.va.sf-ach-num.02":"Bank account number is the wrong length","error.va.sf-ach-loc.01":"Bank routing number field is empty","error.va.sf-ach-loc.02":"Bank routing number is the wrong length","error.va.sf-kcp-pwd.01":"Password field is empty","error.va.sf-kcp-pwd.02":"Password is the wrong length","error.giftcard.no-balance":"This gift card has zero balance","error.giftcard.card-error":"In our records we have no gift card with this number","error.giftcard.currency-error":"Gift cards are only valid in the currency they were issued in","amazonpay.signout":"Sign out from Amazon","amazonpay.changePaymentDetails":"Change payment details","partialPayment.warning":"Select another payment method to pay the remaining","partialPayment.remainingBalance":"Remaining balance will be %{amount}","bankTransfer.beneficiary":"Beneficiary","bankTransfer.iban":"IBAN","bankTransfer.bic":"BIC","bankTransfer.reference":"Reference","bankTransfer.introduction":"Continue to create a new bank transfer payment. You can use the details in the following screen to finalize this payment.","bankTransfer.instructions":"Thank you for your purchase, please use the following information to complete your payment.","bacs.accountHolderName":"Bank account holder name","bacs.accountHolderName.invalid":"Invalid bank account holder name","bacs.accountNumber":"Bank account number","bacs.accountNumber.invalid":"Invalid bank account number","bacs.bankLocationId":"Sort code","bacs.bankLocationId.invalid":"Invalid sort code","bacs.consent.amount":"I agree that the above amount will be deducted from my bank account.","bacs.consent.account":"I confirm the account is in my name and I am the only signatory required to authorise the Direct Debit on this account.",edit:"Edit","bacs.confirm":"Confirm and pay","bacs.result.introduction":"Download your Direct Debit Instruction (DDI / Mandate)","download.pdf":"Download PDF","creditCard.encryptedCardNumber.aria.iframeTitle":"Iframe for secured card number","creditCard.encryptedCardNumber.aria.label":"Card number","creditCard.encryptedExpiryDate.aria.iframeTitle":"Iframe for secured card expiry date","creditCard.encryptedExpiryDate.aria.label":"Expiry date","creditCard.encryptedExpiryMonth.aria.iframeTitle":"Iframe for secured card expiry month","creditCard.encryptedExpiryMonth.aria.label":"Expiry month","creditCard.encryptedExpiryYear.aria.iframeTitle":"Iframe for secured card expiry year","creditCard.encryptedExpiryYear.aria.label":"Expiry year","creditCard.encryptedSecurityCode.aria.iframeTitle":"Iframe for secured card security code","creditCard.encryptedSecurityCode.aria.label":"Security code","creditCard.encryptedPassword.aria.iframeTitle":"Iframe for secured card password","creditCard.encryptedPassword.aria.label":"First 2 digits of card password","giftcard.encryptedCardNumber.aria.iframeTitle":"Iframe for secured gift card number","giftcard.encryptedCardNumber.aria.label":"Gift card number","giftcard.encryptedSecurityCode.aria.iframeTitle":"Iframe for secured gift card security code","giftcard.encryptedSecurityCode.aria.label":"Gift card security code",giftcardTransactionLimit:"Max. %{amount} allowed per transaction on this gift card","ach.encryptedBankAccountNumber.aria.iframeTitle":"Iframe for secured bank account number","ach.encryptedBankAccountNumber.aria.label":"Bank account","ach.encryptedBankLocationId.aria.iframeTitle":"Iframe for secured bank routing number","ach.encryptedBankLocationId.aria.label":"Bank routing number","pix.instructions":"Open the app with the PIX registered key, choose Pay with PIX and scan the QR Code or copy and paste the code","twint.saved":"saved",orPayWith:"or pay with",invalidFormatExpects:"Invalid format. Expected format: %{format}","upi.qrCodeWaitingMessage":"Scan the QR code using your preferred UPI app to complete the payment","upi.vpaWaitingMessage":"Open your UPI app to confirm the payment","upi.modeSelection":"Make a selection on how you would like to use UPI.","onlineBanking.termsAndConditions":"By continuing you agree with the %#terms and conditions%#","ctp.loading.poweredByCtp":"Powered by Click to Pay","ctp.loading.intro":"We are checking to see if you have any saved cards with Click to Pay...","ctp.login.title":"Continue to Click to Pay","ctp.login.subtitle":"Enter the email address that is connected to Click to Pay to continue.","ctp.login.inputLabel":"Email","ctp.logout.notYou":"Not you?","ctp.logout.notYourCards":"Not your cards?","ctp.logout.notYourCard":"Not your card?","ctp.logout.notYourProfile":"Not your profile?","ctp.otp.fieldLabel":"One time code","ctp.otp.resendCode":"Resend code","ctp.otp.codeResent":"Code resent","ctp.otp.title":"Access your Click to Pay cards","ctp.otp.subtitle":"Enter the code %@ sent to %@ to verify it\u2018s you.","ctp.emptyProfile.message":"No cards registered in this Click to Pay profile","ctp.separatorText":"or use","ctp.cards.title":"Complete payment with Click to Pay","ctp.cards.subtitle":"Select a card to use.","ctp.cards.expiredCard":"Expired","ctp.manualCardEntry":"Manual card entry","ctp.aria.infoModalButton":"What is Click to Pay","ctp.infoPopup.title":"Click to Pay brings the ease of contactless, online","ctp.infoPopup.subtitle":"A fast, secure payment method supported by Mastercard, Visa and other payment cards.","ctp.infoPopup.benefit1":"Click to Pay uses encryption to keep your information safe and secure","ctp.infoPopup.benefit2":"Use it with merchants worldwide","ctp.infoPopup.benefit3":"Set up once for hassle-free payments in the future","ctp.errors.AUTH_INVALID":"Authentication Invalid","ctp.errors.NOT_FOUND":"No account found, enter a valid email or continue using manual card entry","ctp.errors.ID_FORMAT_UNSUPPORTED":"Format not supported","ctp.errors.FRAUD":"The user account was locked or disabled","ctp.errors.CONSUMER_ID_MISSING":"Consumer identity is missing in the request","ctp.errors.ACCT_INACCESSIBLE":"This account is currently not available, e.g it is locked","ctp.errors.CODE_INVALID":"Incorrect verification code","ctp.errors.CODE_EXPIRED":"This code has expired","ctp.errors.RETRIES_EXCEEDED":"The limit for the number of retries for OTP generation was exceeded","ctp.errors.OTP_SEND_FAILED":"The OTP could not be sent to the recipient","ctp.errors.REQUEST_TIMEOUT":"Something went wrong, try again or use the manual card entry","ctp.errors.UNKNOWN_ERROR":"Something went wrong, try again or use the manual card entry","ctp.errors.SERVICE_ERROR":"Something went wrong, try again or use the manual card entry","ctp.errors.SERVER_ERROR":"Something went wrong, try again or use the manual card entry","ctp.errors.INVALID_PARAMETER":"Something went wrong, try again or use the manual card entry","ctp.errors.AUTH_ERROR":"Something went wrong, try again or use the manual card entry","paymentMethodsList.aria.label":"Choose a payment method"},$C=Object.freeze({__proto__:null,default:ZC}),XC="en-US",e_=ZC,t_={ar:function(){return Promise.resolve().then((function(){return b3}))},"cs-CZ":function(){return Promise.resolve().then((function(){return k3}))},"da-DK":function(){return Promise.resolve().then((function(){return C3}))},"de-DE":function(){return Promise.resolve().then((function(){return _3}))},"el-GR":function(){return Promise.resolve().then((function(){return N3}))},"en-US":function(){return Promise.resolve().then((function(){return $C}))},"es-ES":function(){return Promise.resolve().then((function(){return P3}))},"fi-FI":function(){return Promise.resolve().then((function(){return w3}))},"fr-FR":function(){return Promise.resolve().then((function(){return S3}))},"hr-HR":function(){return Promise.resolve().then((function(){return x3}))},"hu-HU":function(){return Promise.resolve().then((function(){return E3}))},"it-IT":function(){return Promise.resolve().then((function(){return A3}))},"ja-JP":function(){return Promise.resolve().then((function(){return D3}))},"ko-KR":function(){return Promise.resolve().then((function(){return I3}))},"nl-NL":function(){return Promise.resolve().then((function(){return F3}))},"no-NO":function(){return Promise.resolve().then((function(){return R3}))},"pl-PL":function(){return Promise.resolve().then((function(){return O3}))},"pt-BR":function(){return Promise.resolve().then((function(){return T3}))},"pt-PT":function(){return Promise.resolve().then((function(){return B3}))},"ro-RO":function(){return Promise.resolve().then((function(){return j3}))},"ru-RU":function(){return Promise.resolve().then((function(){return z3}))},"sk-SK":function(){return Promise.resolve().then((function(){return M3}))},"sl-SI":function(){return Promise.resolve().then((function(){return L3}))},"sv-SE":function(){return Promise.resolve().then((function(){return V3}))},"zh-CN":function(){return Promise.resolve().then((function(){return U3}))},"zh-TW":function(){return Promise.resolve().then((function(){return K3}))}};function r_(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function a_(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=r_(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=r_(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}var n_=function(e){return e.toLowerCase().substring(0,2)};function o_(e){var t=e.replace("_","-");if(new RegExp("([a-z]{2})([-])([A-Z]{2})").test(t))return t;var r=tC(t.split("-"),2),a=r[0],n=r[1];if(!a||!n)return null;var o=[a.toLowerCase(),n.toUpperCase()].join("-");return 5===o.length?o:null}function i_(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:[];if(!e||e.length<1||e.length>5)return XC;var r=o_(e);return hC(t).call(t,r)>-1?r:function(e,t){return e&&"string"==typeof e&&yk(t).call(t,(function(t){return n_(t)===n_(e)}))||null}(r||e,t)}var l_=function(e,t){return e.replace(/%{(\w+)}/g,(function(e,r){return t[r]||""}))},c_=function(){var e=$d(Ky.mark((function e(t){var r,a,n,o=arguments;return Ky.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return r=o.length>1&&void 0!==o[1]?o[1]:{},a=i_(t,Jy(t_))||XC,e.next=4,t_[a]();case 4:return n=e.sent,e.abrupt("return",a_(a_(a_({},e_),n.default),!!r[t]&&r[t]));case 6:case"end":return e.stop()}}),e)})));return function(t){return e.apply(this,arguments)}}(),s_=function(e,t){var r=e.split(/%#(.*?)%#/gm);if(t.length!==Math.floor(r.length/2))throw Error("The number of functions provided does not match the number of elements in the translation string.");return QC(r).call(r,(function(e,r){var a=Math.floor(r/2);return r%2==0?e:t[a](e)}))},u_={},d_={get exports(){return u_},set exports(e){u_=e}},p_="\t\n\v\f\r \xa0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029\ufeff",f_=Z,m_=go,h_=p_,v_=b("".replace),y_=RegExp("^["+h_+"]+"),g_=RegExp("(^|[^"+h_+"])["+h_+"]+$"),b_=function(e){return function(t){var r=m_(f_(t));return 1&e&&(r=v_(r,y_,"")),2&e&&(r=v_(r,g_,"$1")),r}},k_={start:b_(1),end:b_(2),trim:b_(3)},C_=l,__=c,N_=b,P_=go,w_=k_.trim,S_=p_,x_=C_.parseInt,E_=C_.Symbol,A_=E_&&E_.iterator,D_=/^[+-]?0x/i,I_=N_(D_.exec),F_=8!==x_(S_+"08")||22!==x_(S_+"0x16")||A_&&!__((function(){x_(Object(A_))}))?function(e,t){var r=w_(P_(e));return x_(r,t>>>0||(I_(D_,r)?16:10))}:x_;Dr({global:!0,forced:parseInt!=F_},{parseInt:F_});var R_=ne.parseInt;!function(e){e.exports=R_}(d_);var O_=t(u_),T_={IDR:1,JPY:1,KRW:1,VND:1,BYR:1,CVE:1,DJF:1,GHC:1,GNF:1,KMF:1,PYG:1,RWF:1,UGX:1,VUV:1,XAF:1,XOF:1,XPF:1,MRO:10,BHD:1e3,IQD:1e3,JOD:1e3,KWD:1e3,OMR:1e3,LYD:1e3,TND:1e3};function B_(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}var j_=function(e,t){var r=function(e){return T_[e]||100}(t);return O_(String(e),10)/r},z_=function(e,t,r){var a=arguments.length>3&&void 0!==arguments[3]?arguments[3]:{},n=e.toString(),o=j_(n,r),i=t.replace("_","-"),l=function(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=B_(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=B_(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}({style:"currency",currency:r,currencyDisplay:"symbol"},a);try{return o.toLocaleString(i,l)}catch(e){return n}};function M_(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}var L_=function(){function e(){var t,r,a=this,n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:XC,o=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};Bg(this,e),Wg(this,"supportedLocales",void 0),Wg(this,"locale",void 0),Wg(this,"languageCode",void 0),Wg(this,"translations",e_),Wg(this,"customTranslations",void 0),Wg(this,"loaded",void 0);var i=Jy(t_);this.customTranslations=function(){var e,t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},r=arguments.length>1?arguments[1]:void 0;return DC(e=Jy(t)).call(e,(function(e,a){var n=o_(a)||i_(a,r);return n&&(e[n]=t[a]),e}),{})}(o,i);var l=Jy(this.customTranslations);this.supportedLocales=nb(t=Bb(r=[]).call(r,rC(i),rC(l))).call(t,(function(e,t,r){return hC(r).call(r,e)===t})),this.locale=o_(n)||i_(n,this.supportedLocales)||XC;var c=tC(this.locale.split("-"),1)[0];this.languageCode=c,this.loaded=c_(this.locale,this.customTranslations).then((function(e){a.translations=e}))}return qg(e,[{key:"get",value:function(e,t){var r=function(e,t){var r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{values:{},count:0},a="".concat(t,"__plural"),n=function(e){var r;return Bb(r="".concat(t,"__")).call(r,e)};return Object.prototype.hasOwnProperty.call(e,n(r.count))?l_(e[n(r.count)],VC(r)):Object.prototype.hasOwnProperty.call(e,a)&&r.count>1?l_(e[a],VC(r)):Object.prototype.hasOwnProperty.call(e,t)?l_(e[t],VC(r)):null}(this.translations,e,t);return null!==r?r:e}},{key:"amount",value:function(e,t,r){return z_(e,this.locale,t,r)}},{key:"date",value:function(e){var t=function(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=M_(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=M_(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}({year:"numeric",month:"2-digit",day:"2-digit"},arguments.length>1&&void 0!==arguments[1]?arguments[1]:{});return new Date(e).toLocaleDateString(this.locale,t)}}]),e}(),V_={},U_={get exports(){return V_},set exports(e){V_=e}},K_=Dr,H_=m,q_=Jb,W_=Gl,Y_=nr,G_=ae,J_=un,Q_=c,Z_=se("Reflect","construct"),$_=Object.prototype,X_=[].push,eN=Q_((function(){function e(){}return!(Z_((function(){}),[],e)instanceof e)})),tN=!Q_((function(){Z_((function(){}))})),rN=eN||tN;K_({target:"Reflect",stat:!0,forced:rN,sham:rN},{construct:function(e,t){W_(e),Y_(t);var r=arguments.length<3?e:W_(arguments[2]);if(tN&&!eN)return Z_(e,t,r);if(e==r){switch(t.length){case 0:return new e;case 1:return new e(t[0]);case 2:return new e(t[0],t[1]);case 3:return new e(t[0],t[1],t[2]);case 4:return new e(t[0],t[1],t[2],t[3])}var a=[null];return H_(X_,a,t),new(H_(q_,e,a))}var n=r.prototype,o=J_(G_(n)?n:$_),i=H_(e,o,t);return G_(i)?i:o}});var aN=ne.Reflect.construct;!function(e){e.exports=aN}(U_);var nN=t(V_),oN={},iN={get exports(){return oN},set exports(e){oN=e}},lN={},cN={get exports(){return lN},set exports(e){lN=e}},sN=F,uN=b,dN=T,pN=c,fN=Va,mN=xa,hN=B,vN=Ze,yN=Y,gN=Object.assign,bN=Object.defineProperty,kN=uN([].concat),CN=!gN||pN((function(){if(sN&&1!==gN({b:1},gN(bN({},"a",{enumerable:!0,get:function(){bN(this,"b",{value:3,enumerable:!1})}}),{b:2})).b)return!0;var e={},t={},r=Symbol(),a="abcdefghijklmnopqrst";return e[r]=7,a.split("").forEach((function(e){t[e]=e})),7!=gN({},e)[r]||fN(gN({},t)).join("")!=a}))?function(e,t){for(var r=vN(e),a=arguments.length,n=1,o=mN.f,i=hN.f;a>n;)for(var l,c=yN(arguments[n++]),s=o?kN(fN(c),o(c)):fN(c),u=s.length,d=0;u>d;)l=s[d++],sN&&!dN(i,c,l)||(r[l]=c[l]);return r}:gN,_N=CN;Dr({target:"Object",stat:!0,arity:2,forced:Object.assign!==_N},{assign:_N});var NN=ne.Object.assign,PN=NN;!function(e){e.exports=PN}(cN),function(e){e.exports=lN}(iN);var wN=t(oN),SN={},xN={get exports(){return SN},set exports(e){SN=e}},EN={},AN={get exports(){return EN},set exports(e){EN=e}},DN=tk;!function(e){e.exports=DN}(AN),function(e){e.exports=EN}(xN);var IN=t(SN);function FN(){var e;return FN=wN?IN(e=wN).call(e):function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var a in r)Object.prototype.hasOwnProperty.call(r,a)&&(e[a]=r[a])}return e},FN.apply(this,arguments)}function RN(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function ON(e,t){var r;return ON=ry?IN(r=ry).call(r):function(e,t){return e.__proto__=t,e},ON(e,t)}function TN(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=_v(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),fv(e,"prototype",{writable:!1}),t&&ON(e,t)}function BN(e,t){if(t&&("object"===Tg(t)||"function"==typeof t))return t;if(void 0!==t)throw new TypeError("Derived constructors may only return object or undefined");return RN(e)}function jN(e){var t;return jN=ry?IN(t=Iv).call(t):function(e){return e.__proto__||Iv(e)},jN(e)}var zN,MN,LN,VN,UN,KN,HN={},qN=[],WN=/acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i;function YN(e,t){for(var r in t)e[r]=t[r];return e}function GN(e){var t=e.parentNode;t&&t.removeChild(e)}function JN(e,t,r){var a,n,o,i={};for(o in t)"key"==o?a=t[o]:"ref"==o?n=t[o]:i[o]=t[o];if(arguments.length>2&&(i.children=arguments.length>3?zN.call(arguments,2):r),"function"==typeof e&&null!=e.defaultProps)for(o in e.defaultProps)void 0===i[o]&&(i[o]=e.defaultProps[o]);return QN(e,i,a,n,null)}function QN(e,t,r,a,n){var o={type:e,props:t,key:r,ref:a,__k:null,__:null,__b:0,__e:null,__d:void 0,__c:null,__h:null,constructor:void 0,__v:null==n?++LN:n};return null==n&&null!=MN.vnode&&MN.vnode(o),o}function ZN(e){return e.children}function $N(e,t){this.props=e,this.context=t}function XN(e,t){if(null==t)return e.__?XN(e.__,e.__.__k.indexOf(e)+1):null;for(var r;t<e.__k.length;t++)if(null!=(r=e.__k[t])&&null!=r.__e)return r.__e;return"function"==typeof e.type?XN(e):null}function eP(e){var t,r;if(null!=(e=e.__)&&null!=e.__c){for(e.__e=e.__c.base=null,t=0;t<e.__k.length;t++)if(null!=(r=e.__k[t])&&null!=r.__e){e.__e=e.__c.base=r.__e;break}return eP(e)}}function tP(e){(!e.__d&&(e.__d=!0)&&VN.push(e)&&!rP.__r++||UN!==MN.debounceRendering)&&((UN=MN.debounceRendering)||setTimeout)(rP)}function rP(){for(var e;rP.__r=VN.length;)e=VN.sort((function(e,t){return e.__v.__b-t.__v.__b})),VN=[],e.some((function(e){var t,r,a,n,o,i;e.__d&&(o=(n=(t=e).__v).__e,(i=t.__P)&&(r=[],(a=YN({},n)).__v=n.__v+1,dP(i,n,a,t.__n,void 0!==i.ownerSVGElement,null!=n.__h?[o]:null,r,null==o?XN(n):o,n.__h),pP(r,n),n.__e!=o&&eP(n)))}))}function aP(e,t,r,a,n,o,i,l,c,s){var u,d,p,f,m,h,v,y=a&&a.__k||qN,g=y.length;for(r.__k=[],u=0;u<t.length;u++)if(null!=(f=r.__k[u]=null==(f=t[u])||"boolean"==typeof f?null:"string"==typeof f||"number"==typeof f||"bigint"==typeof f?QN(null,f,null,null,f):Array.isArray(f)?QN(ZN,{children:f},null,null,null):f.__b>0?QN(f.type,f.props,f.key,f.ref?f.ref:null,f.__v):f)){if(f.__=r,f.__b=r.__b+1,null===(p=y[u])||p&&f.key==p.key&&f.type===p.type)y[u]=void 0;else for(d=0;d<g;d++){if((p=y[d])&&f.key==p.key&&f.type===p.type){y[d]=void 0;break}p=null}dP(e,f,p=p||HN,n,o,i,l,c,s),m=f.__e,(d=f.ref)&&p.ref!=d&&(v||(v=[]),p.ref&&v.push(p.ref,null,f),v.push(d,f.__c||m,f)),null!=m?(null==h&&(h=m),"function"==typeof f.type&&f.__k===p.__k?f.__d=c=nP(f,c,e):c=iP(e,f,p,y,m,c),"function"==typeof r.type&&(r.__d=c)):c&&p.__e==c&&c.parentNode!=e&&(c=XN(p))}for(r.__e=h,u=g;u--;)null!=y[u]&&hP(y[u],y[u]);if(v)for(u=0;u<v.length;u++)mP(v[u],v[++u],v[++u])}function nP(e,t,r){for(var a,n=e.__k,o=0;n&&o<n.length;o++)(a=n[o])&&(a.__=e,t="function"==typeof a.type?nP(a,t,r):iP(r,a,a,n,a.__e,t));return t}function oP(e,t){return t=t||[],null==e||"boolean"==typeof e||(Array.isArray(e)?e.some((function(e){oP(e,t)})):t.push(e)),t}function iP(e,t,r,a,n,o){var i,l,c;if(void 0!==t.__d)i=t.__d,t.__d=void 0;else if(null==r||n!=o||null==n.parentNode)e:if(null==o||o.parentNode!==e)e.appendChild(n),i=null;else{for(l=o,c=0;(l=l.nextSibling)&&c<a.length;c+=1)if(l==n)break e;e.insertBefore(n,o),i=o}return void 0!==i?i:n.nextSibling}function lP(e,t,r){"-"===t[0]?e.setProperty(t,r):e[t]=null==r?"":"number"!=typeof r||WN.test(t)?r:r+"px"}function cP(e,t,r,a,n){var o;e:if("style"===t)if("string"==typeof r)e.style.cssText=r;else{if("string"==typeof a&&(e.style.cssText=a=""),a)for(t in a)r&&t in r||lP(e.style,t,"");if(r)for(t in r)a&&r[t]===a[t]||lP(e.style,t,r[t])}else if("o"===t[0]&&"n"===t[1])o=t!==(t=t.replace(/Capture$/,"")),t=t.toLowerCase()in e?t.toLowerCase().slice(2):t.slice(2),e.l||(e.l={}),e.l[t+o]=r,r?a||e.addEventListener(t,o?uP:sP,o):e.removeEventListener(t,o?uP:sP,o);else if("dangerouslySetInnerHTML"!==t){if(n)t=t.replace(/xlink(H|:h)/,"h").replace(/sName$/,"s");else if("href"!==t&&"list"!==t&&"form"!==t&&"tabIndex"!==t&&"download"!==t&&t in e)try{e[t]=null==r?"":r;break e}catch(e){}"function"==typeof r||(null==r||!1===r&&-1==t.indexOf("-")?e.removeAttribute(t):e.setAttribute(t,r))}}function sP(e){this.l[e.type+!1](MN.event?MN.event(e):e)}function uP(e){this.l[e.type+!0](MN.event?MN.event(e):e)}function dP(e,t,r,a,n,o,i,l,c){var s,u,d,p,f,m,h,v,y,g,b,k,C,_,N,P=t.type;if(void 0!==t.constructor)return null;null!=r.__h&&(c=r.__h,l=t.__e=r.__e,t.__h=null,o=[l]),(s=MN.__b)&&s(t);try{e:if("function"==typeof P){if(v=t.props,y=(s=P.contextType)&&a[s.__c],g=s?y?y.props.value:s.__:a,r.__c?h=(u=t.__c=r.__c).__=u.__E:("prototype"in P&&P.prototype.render?t.__c=u=new P(v,g):(t.__c=u=new $N(v,g),u.constructor=P,u.render=vP),y&&y.sub(u),u.props=v,u.state||(u.state={}),u.context=g,u.__n=a,d=u.__d=!0,u.__h=[],u._sb=[]),null==u.__s&&(u.__s=u.state),null!=P.getDerivedStateFromProps&&(u.__s==u.state&&(u.__s=YN({},u.__s)),YN(u.__s,P.getDerivedStateFromProps(v,u.__s))),p=u.props,f=u.state,d)null==P.getDerivedStateFromProps&&null!=u.componentWillMount&&u.componentWillMount(),null!=u.componentDidMount&&u.__h.push(u.componentDidMount);else{if(null==P.getDerivedStateFromProps&&v!==p&&null!=u.componentWillReceiveProps&&u.componentWillReceiveProps(v,g),!u.__e&&null!=u.shouldComponentUpdate&&!1===u.shouldComponentUpdate(v,u.__s,g)||t.__v===r.__v){for(u.props=v,u.state=u.__s,t.__v!==r.__v&&(u.__d=!1),u.__v=t,t.__e=r.__e,t.__k=r.__k,t.__k.forEach((function(e){e&&(e.__=t)})),b=0;b<u._sb.length;b++)u.__h.push(u._sb[b]);u._sb=[],u.__h.length&&i.push(u);break e}null!=u.componentWillUpdate&&u.componentWillUpdate(v,u.__s,g),null!=u.componentDidUpdate&&u.__h.push((function(){u.componentDidUpdate(p,f,m)}))}if(u.context=g,u.props=v,u.__v=t,u.__P=e,k=MN.__r,C=0,"prototype"in P&&P.prototype.render){for(u.state=u.__s,u.__d=!1,k&&k(t),s=u.render(u.props,u.state,u.context),_=0;_<u._sb.length;_++)u.__h.push(u._sb[_]);u._sb=[]}else do{u.__d=!1,k&&k(t),s=u.render(u.props,u.state,u.context),u.state=u.__s}while(u.__d&&++C<25);u.state=u.__s,null!=u.getChildContext&&(a=YN(YN({},a),u.getChildContext())),d||null==u.getSnapshotBeforeUpdate||(m=u.getSnapshotBeforeUpdate(p,f)),N=null!=s&&s.type===ZN&&null==s.key?s.props.children:s,aP(e,Array.isArray(N)?N:[N],t,r,a,n,o,i,l,c),u.base=t.__e,t.__h=null,u.__h.length&&i.push(u),h&&(u.__E=u.__=null),u.__e=!1}else null==o&&t.__v===r.__v?(t.__k=r.__k,t.__e=r.__e):t.__e=fP(r.__e,t,r,a,n,o,i,c);(s=MN.diffed)&&s(t)}catch(e){t.__v=null,(c||null!=o)&&(t.__e=l,t.__h=!!c,o[o.indexOf(l)]=null),MN.__e(e,t,r)}}function pP(e,t){MN.__c&&MN.__c(t,e),e.some((function(t){try{e=t.__h,t.__h=[],e.some((function(e){e.call(t)}))}catch(e){MN.__e(e,t.__v)}}))}function fP(e,t,r,a,n,o,i,l){var c,s,u,d=r.props,p=t.props,f=t.type,m=0;if("svg"===f&&(n=!0),null!=o)for(;m<o.length;m++)if((c=o[m])&&"setAttribute"in c==!!f&&(f?c.localName===f:3===c.nodeType)){e=c,o[m]=null;break}if(null==e){if(null===f)return document.createTextNode(p);e=n?document.createElementNS("http://www.w3.org/2000/svg",f):document.createElement(f,p.is&&p),o=null,l=!1}if(null===f)d===p||l&&e.data===p||(e.data=p);else{if(o=o&&zN.call(e.childNodes),s=(d=r.props||HN).dangerouslySetInnerHTML,u=p.dangerouslySetInnerHTML,!l){if(null!=o)for(d={},m=0;m<e.attributes.length;m++)d[e.attributes[m].name]=e.attributes[m].value;(u||s)&&(u&&(s&&u.__html==s.__html||u.__html===e.innerHTML)||(e.innerHTML=u&&u.__html||""))}if(function(e,t,r,a,n){var o;for(o in r)"children"===o||"key"===o||o in t||cP(e,o,null,r[o],a);for(o in t)n&&"function"!=typeof t[o]||"children"===o||"key"===o||"value"===o||"checked"===o||r[o]===t[o]||cP(e,o,t[o],r[o],a)}(e,p,d,n,l),u)t.__k=[];else if(m=t.props.children,aP(e,Array.isArray(m)?m:[m],t,r,a,n&&"foreignObject"!==f,o,i,o?o[0]:r.__k&&XN(r,0),l),null!=o)for(m=o.length;m--;)null!=o[m]&&GN(o[m]);l||("value"in p&&void 0!==(m=p.value)&&(m!==e.value||"progress"===f&&!m||"option"===f&&m!==d.value)&&cP(e,"value",m,d.value,!1),"checked"in p&&void 0!==(m=p.checked)&&m!==e.checked&&cP(e,"checked",m,d.checked,!1))}return e}function mP(e,t,r){try{"function"==typeof e?e(t):e.current=t}catch(e){MN.__e(e,r)}}function hP(e,t,r){var a,n;if(MN.unmount&&MN.unmount(e),(a=e.ref)&&(a.current&&a.current!==e.__e||mP(a,null,t)),null!=(a=e.__c)){if(a.componentWillUnmount)try{a.componentWillUnmount()}catch(e){MN.__e(e,t)}a.base=a.__P=null,e.__c=void 0}if(a=e.__k)for(n=0;n<a.length;n++)a[n]&&hP(a[n],t,r||"function"!=typeof e.type);r||null==e.__e||GN(e.__e),e.__=e.__e=e.__d=void 0}function vP(e,t,r){return this.constructor(e,r)}function yP(e,t,r){var a,n,o;MN.__&&MN.__(e,t),n=(a="function"==typeof r)?null:r&&r.__k||t.__k,o=[],dP(t,e=(!a&&r||t).__k=JN(ZN,null,[e]),n||HN,HN,void 0!==t.ownerSVGElement,!a&&r?[r]:n?null:t.firstChild?zN.call(t.childNodes):null,o,!a&&r?r:n?n.__e:t.firstChild,a),pP(o,e)}function gP(e,t){var r={__c:t="__cC"+KN++,__:e,Consumer:function(e,t){return e.children(t)},Provider:function(e){var r,a;return this.getChildContext||(r=[],(a={})[t]=this,this.getChildContext=function(){return a},this.shouldComponentUpdate=function(e){this.props.value!==e.value&&r.some(tP)},this.sub=function(e){r.push(e);var t=e.componentWillUnmount;e.componentWillUnmount=function(){r.splice(r.indexOf(e),1),t&&t.call(e)}}),e.children}};return r.Provider.__=r.Consumer.contextType=r}zN=qN.slice,MN={__e:function(e,t,r,a){for(var n,o,i;t=t.__;)if((n=t.__c)&&!n.__)try{if((o=n.constructor)&&null!=o.getDerivedStateFromError&&(n.setState(o.getDerivedStateFromError(e)),i=n.__d),null!=n.componentDidCatch&&(n.componentDidCatch(e,a||{}),i=n.__d),i)return n.__E=n}catch(t){e=t}throw e}},LN=0,$N.prototype.setState=function(e,t){var r;r=null!=this.__s&&this.__s!==this.state?this.__s:this.__s=YN({},this.state),"function"==typeof e&&(e=e(YN({},r),this.props)),e&&YN(r,e),null!=e&&this.__v&&(t&&this._sb.push(t),tP(this))},$N.prototype.forceUpdate=function(e){this.__v&&(this.__e=!0,e&&this.__h.push(e),tP(this))},$N.prototype.render=ZN,VN=[],rP.__r=0,KN=0;var bP=function(e,t){var r=t.split(".");return DC(r).call(r,(function(e,t){return e&&e[t]?e[t]:void 0}),e)},kP=qg((function e(){var t=this;Bg(this,e),Wg(this,"events",{}),Wg(this,"on",(function(e,r){t.events[e]=t.events[e]||[],t.events[e].push(r)})),Wg(this,"off",(function(e,r){var a;t.events[e]&&(t.events[e]=DC(a=t.events[e]).call(a,(function(e,t){return t!==r&&e.push(t),e}),[]))})),Wg(this,"emit",(function(e,r){var a;t.events[e]&&Jg(a=t.events[e]).call(a,(function(e){e(r)}))}))}));function CP(){return"xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g,(function(e){var t=16*Math.random()|0;return("x"==e?t:3&t|8).toString(16)}))}function _P(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function NP(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=_P(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=_P(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}var PP=function(){function e(t){var r;Bg(this,e),Wg(this,"_id",Bb(r="".concat(this.constructor.type,"-")).call(r,CP())),Wg(this,"props",void 0),Wg(this,"state",void 0),Wg(this,"_node",void 0),Wg(this,"_component",void 0),Wg(this,"eventEmitter",new kP),Wg(this,"_parentInstance",void 0),this.props=this.formatProps(NP(NP({},this.constructor.defaultProps),{},{setStatusAutomatically:!0},t)),this._parentInstance=this.props._parentInstance,this._node=null,this.state={}}return qg(e,[{key:"formatProps",value:function(e){return e}},{key:"formatData",value:function(){return{}}},{key:"setState",value:function(e){this.state=NP(NP({},this.state),e)}},{key:"data",get:function(){var e=bP(this.props,"modules.risk.data"),t=bP(this.props,"modules.analytics.checkoutAttemptId"),r=this.state.order||this.props.order,a=this.formatData();return a.paymentMethod&&t&&(a.paymentMethod.checkoutAttemptId=t),NP(NP(NP(NP({},e&&{riskData:{clientData:e}}),r&&{order:{orderData:r.orderData,pspReference:r.pspReference}}),a),{},{clientStateDataIndicator:!0})}},{key:"render",value:function(){throw new Error("Payment method cannot be rendered.")}},{key:"mount",value:function(e){var t,r="string"==typeof e?document.querySelector(e):e;if(!r)throw new Error("Component could not mount. Root node was not found.");this._node?this.unmount():this.props.modules&&this.props.modules.analytics&&!this.props.isDropin&&this.props.modules.analytics.send({containerWidth:this._node&&this._node.offsetWidth,component:null!==(t=this.constructor.analyticsType)&&void 0!==t?t:this.constructor.type,flavor:"components"});return this._node=r,this._component=this.render(),yP(this._component,r),this}},{key:"update",value:function(e){return this.props=this.formatProps(NP(NP({},this.props),e)),this.state={},this.unmount().mount(this._node)}},{key:"remount",value:function(e){if(!this._node)throw new Error("Component is not mounted.");return yP(e||this.render(),this._node,null),this}},{key:"unmount",value:function(){return this._node&&yP(null,this._node),this}},{key:"remove",value:function(){this.unmount(),this._parentInstance&&this._parentInstance.remove(this)}}]),e}();Wg(PP,"defaultProps",{});var wP={},SP={get exports(){return wP},set exports(e){wP=e}},xP={},EP={get exports(){return xP},set exports(e){xP=e}},AP=$y;!function(e){e.exports=AP}(EP),function(e){e.exports=xP}(SP);var DP=t(wP),IP={},FP={get exports(){return IP},set exports(e){IP=e}},RP={},OP={get exports(){return RP},set exports(e){RP=e}},TP=mC;!function(e){e.exports=TP}(OP),function(e){e.exports=RP}(FP);var BP=t(IP),jP={},zP={get exports(){return jP},set exports(e){jP=e}},MP={},LP={get exports(){return MP},set exports(e){MP=e}},VP=Gy;!function(e){e.exports=VP}(LP),function(e){e.exports=MP}(zP);var UP=t(jP);function KP(e,t){if(null==e)return{};var r,a,n=function(e,t){if(null==e)return{};var r,a,n={},o=UP(e);for(a=0;a<o.length;a++)r=o[a],BP(t).call(t,r)>=0||(n[r]=e[r]);return n}(e,t);if(DP){var o=DP(e);for(a=0;a<o.length;a++)r=o[a],BP(t).call(t,r)>=0||Object.prototype.propertyIsEnumerable.call(e,r)&&(n[r]=e[r])}return n}var HP="https://checkoutshopper-live.adyen.com/checkoutshopper/",qP=["amount","secondaryAmount","countryCode","environment","loadingContext","i18n","modules","order","session","clientKey","showPayButton","installmentOptions","onPaymentCompleted","beforeRedirect","beforeSubmit","onSubmit","onActionHandled","onAdditionalDetails","onCancel","onChange","onError","onBalanceCheck","onOrderRequest","onOrderCreated","setStatusAutomatically"],WP=["loadingContext","extension"];function YP(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}var GP=function(e){var t=e.loadingContext,r=void 0===t?HP:t,a=e.extension,n=void 0===a?"svg":a,o=KP(e,WP);return function(e){var t=function(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=YP(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=YP(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}({extension:n,loadingContext:r,imageFolder:"logos/",parentFolder:"",name:e},o);return function(e){var t,r,a,n,o,i,l=e.name,c=e.loadingContext,s=e.imageFolder,u=void 0===s?"":s,d=e.parentFolder,p=void 0===d?"":d,f=e.extension,m=e.size,h=void 0===m?"":m,v=e.subFolder,y=void 0===v?"":v;return Bb(t=Bb(r=Bb(a=Bb(n=Bb(o=Bb(i="".concat(c,"images/")).call(i,u)).call(o,y)).call(n,p)).call(a,l)).call(r,h,".")).call(t,f)}(t)}},JP={},QP={get exports(){return JP},set exports(e){JP=e}},ZP="function"==typeof Bun&&Bun&&"string"==typeof Bun.version,$P=l,XP=m,ew=D,tw=ZP,rw=de,aw=ec,nw=rc,ow=$P.Function,iw=/MSIE .\./.test(rw)||tw&&function(){var e=$P.Bun.version.split(".");return e.length<3||0==e[0]&&(e[1]<3||3==e[1]&&0==e[2])}(),lw=function(e,t){var r=t?2:1;return iw?function(a,n){var o=nw(arguments.length,1)>r,i=ew(a)?a:ow(a),l=o?aw(arguments,r):[],c=o?function(){XP(i,this,l)}:i;return t?e(c,n):e(c)}:e},cw=Dr,sw=l,uw=lw(sw.setInterval,!0);cw({global:!0,bind:!0,forced:sw.setInterval!==uw},{setInterval:uw});var dw=Dr,pw=l,fw=lw(pw.setTimeout,!0);dw({global:!0,bind:!0,forced:pw.setTimeout!==fw},{setTimeout:fw});var mw=ne.setTimeout;!function(e){e.exports=mw}(QP);var hw=t(JP),vw={},yw={get exports(){return vw},set exports(e){vw=e}};!function(e){e.exports=_k}(yw);var gw=t(vw),bw={},kw={get exports(){return bw},set exports(e){bw=e}};!function(e){!function(){var t={}.hasOwnProperty;function r(){for(var e=[],a=0;a<arguments.length;a++){var n=arguments[a];if(n){var o=Tg(n);if("string"===o||"number"===o)e.push(n);else if(gw(n)){if(n.length){var i=r.apply(null,n);i&&e.push(i)}}else if("object"===o){var l;if(n.toString!==Object.prototype.toString&&!Eb(l=n.toString.toString()).call(l,"[native code]")){e.push(n.toString());continue}for(var c in n)t.call(n,c)&&n[c]&&e.push(c)}}}return e.join(" ")}e.exports?(r.default=r,e.exports=r):window.classNames=r}()}(kw);var Cw,_w,Nw,Pw,ww=bw,Sw=function(e){var t=e.inline,r=void 0!==t&&t,a=e.size,n=void 0===a?"large":a;return JN("div",{className:"adyen-checkout__spinner__wrapper ".concat(r?"adyen-checkout__spinner__wrapper--inline":"")},JN("div",{className:"adyen-checkout__spinner adyen-checkout__spinner--".concat(n)}))},xw=0,Ew=[],Aw=[],Dw=MN.__b,Iw=MN.__r,Fw=MN.diffed,Rw=MN.__c,Ow=MN.unmount;function Tw(e,t){MN.__h&&MN.__h(_w,e,xw||t),xw=0;var r=_w.__H||(_w.__H={__:[],__h:[]});return e>=r.__.length&&r.__.push({__V:Aw}),r.__[e]}function Bw(e){return xw=1,jw(Qw,e)}function jw(e,t,r){var a=Tw(Cw++,2);if(a.t=e,!a.__c&&(a.__=[r?r(t):Qw(void 0,t),function(e){var t=a.__N?a.__N[0]:a.__[0],r=a.t(t,e);t!==r&&(a.__N=[r,a.__[1]],a.__c.setState({}))}],a.__c=_w,!_w.u)){_w.u=!0;var n=_w.shouldComponentUpdate;_w.shouldComponentUpdate=function(e,t,r){if(!a.__c.__H)return!0;var o=a.__c.__H.__.filter((function(e){return e.__c}));if(o.every((function(e){return!e.__N})))return!n||n.call(this,e,t,r);var i=!1;return o.forEach((function(e){if(e.__N){var t=e.__[0];e.__=e.__N,e.__N=void 0,t!==e.__[0]&&(i=!0)}})),!(!i&&a.__c.props===e)&&(!n||n.call(this,e,t,r))}}return a.__N||a.__}function zw(e,t){var r=Tw(Cw++,3);!MN.__s&&Jw(r.__H,t)&&(r.__=e,r.i=t,_w.__H.__h.push(r))}function Mw(e,t){var r=Tw(Cw++,4);!MN.__s&&Jw(r.__H,t)&&(r.__=e,r.i=t,_w.__h.push(r))}function Lw(e){return xw=5,Vw((function(){return{current:e}}),[])}function Vw(e,t){var r=Tw(Cw++,7);return Jw(r.__H,t)?(r.__V=e(),r.i=t,r.__h=e,r.__V):r.__}function Uw(e,t){return xw=8,Vw((function(){return e}),t)}function Kw(e){var t=_w.context[e.__c],r=Tw(Cw++,9);return r.c=e,t?(null==r.__&&(r.__=!0,t.sub(_w)),t.props.value):e.__}function Hw(){for(var e;e=Ew.shift();)if(e.__P&&e.__H)try{e.__H.__h.forEach(Yw),e.__H.__h.forEach(Gw),e.__H.__h=[]}catch(t){e.__H.__h=[],MN.__e(t,e.__v)}}MN.__b=function(e){_w=null,Dw&&Dw(e)},MN.__r=function(e){Iw&&Iw(e),Cw=0;var t=(_w=e.__c).__H;t&&(Nw===_w?(t.__h=[],_w.__h=[],t.__.forEach((function(e){e.__N&&(e.__=e.__N),e.__V=Aw,e.__N=e.i=void 0}))):(t.__h.forEach(Yw),t.__h.forEach(Gw),t.__h=[])),Nw=_w},MN.diffed=function(e){Fw&&Fw(e);var t=e.__c;t&&t.__H&&(t.__H.__h.length&&(1!==Ew.push(t)&&Pw===MN.requestAnimationFrame||((Pw=MN.requestAnimationFrame)||Ww)(Hw)),t.__H.__.forEach((function(e){e.i&&(e.__H=e.i),e.__V!==Aw&&(e.__=e.__V),e.i=void 0,e.__V=Aw}))),Nw=_w=null},MN.__c=function(e,t){t.some((function(e){try{e.__h.forEach(Yw),e.__h=e.__h.filter((function(e){return!e.__||Gw(e)}))}catch(r){t.some((function(e){e.__h&&(e.__h=[])})),t=[],MN.__e(r,e.__v)}})),Rw&&Rw(e,t)},MN.unmount=function(e){Ow&&Ow(e);var t,r=e.__c;r&&r.__H&&(r.__H.__.forEach((function(e){try{Yw(e)}catch(e){t=e}})),r.__H=void 0,t&&MN.__e(t,r.__v))};var qw="function"==typeof requestAnimationFrame;function Ww(e){var t,r=function(){clearTimeout(a),qw&&cancelAnimationFrame(t),setTimeout(e)},a=setTimeout(r,100);qw&&(t=requestAnimationFrame(r))}function Yw(e){var t=_w,r=e.__c;"function"==typeof r&&(e.__c=void 0,r()),_w=t}function Gw(e){var t=_w;e.__c=e.__(),_w=t}function Jw(e,t){return!e||e.length!==t.length||t.some((function(t,r){return t!==e[r]}))}function Qw(e,t){return"function"==typeof t?t(e):t}var Zw=gP({i18n:new L_,loadingContext:"",commonProps:{}});function $w(){return Kw(Zw)}function Xw(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}var eS=function(e){TN(r,e);var t=Xw(r);function r(){var e,a;Bg(this,r);for(var n=arguments.length,o=new Array(n),i=0;i<n;i++)o[i]=arguments[i];return Wg(RN(a=t.call.apply(t,Bb(e=[this]).call(e,o))),"onClick",(function(e){e.preventDefault(),a.props.disabled||a.props.onClick(e,{complete:a.complete})})),Wg(RN(a),"complete",(function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:1e3;a.setState({completed:!0}),hw((function(){a.setState({completed:!1})}),e)})),a}return qg(r,[{key:"render",value:function(e,t){var r,a,n=e.classNameModifiers,o=void 0===n?[]:n,i=e.disabled,l=e.href,c=e.icon,s=e.inline,u=e.label,d=e.status,p=e.variant,f=t.completed,m=$w().i18n,h=c?JN("img",{className:"adyen-checkout__button__icon",src:c,alt:"","aria-hidden":"true"}):"",v=Bb(r=[]).call(r,rC(o),rC("primary"!==p?[p]:[]),rC(s?["inline"]:[]),rC(f?["completed"]:[]),rC("loading"===d||"redirect"===d?["loading"]:[])),y=ww(Bb(a=["adyen-checkout__button"]).call(a,rC(QC(v).call(v,(function(e){return"adyen-checkout__button--".concat(e)}))))),g={loading:JN(Sw,{size:"medium"}),redirect:JN("span",{className:"adyen-checkout__button__content"},JN(Sw,{size:"medium",inline:!0}),m.get("payButton.redirecting")),default:JN("span",{className:"adyen-checkout__button__content"},h,JN("span",{className:"adyen-checkout__button__text"},u))},b=g[d]||g.default;return l?JN("a",{className:y,href:l,disabled:i,target:this.props.target,rel:this.props.rel},b):JN("button",{className:y,type:"button",disabled:i,onClick:this.onClick},b,"loading"!==d&&"redirect"!==d&&this.props.children)}}]),r}($N);Wg(eS,"defaultProps",{status:"default",variant:"primary",disabled:!1,label:"",inline:!1,target:"_self",onClick:function(){}});var tS=function(e,t){return null!=t&&t.value&&null!=t&&t.currency?e.amount(t.value,t.currency,{currencyDisplay:t.currencyDisplay||"symbol"}):""},rS=function(e,t){var r;return Bb(r="".concat(e.get("payButton")," ")).call(r,tS(e,t))},aS=function(e){return JN("span",{className:"checkout-secondary-button__text"},e.label)},nS=["amount","secondaryAmount","classNameModifiers","label"],oS=function(e){var t,r=e.amount,a=e.secondaryAmount,n=e.classNameModifiers,o=void 0===n?[]:n,i=e.label,l=KP(e,nS),c=$w().i18n,s=r&&{}.hasOwnProperty.call(r,"value")&&0===r.value,u=s?c.get("confirmPreauthorization"):rS(c,r),d=!s&&!i&&r&&a&&Jy(a).length?function(e,t){var r,a=t&&null!=t&&t.value&&null!=t&&t.currency?e.amount(t.value,t.currency,{currencyDisplay:t.currencyDisplay||"symbol"}):"",n=a.length?"/ ":"";return Bb(r="".concat(n)).call(r,a)}(c,a):null;return JN(eS,FN({},l,{disabled:l.disabled||"loading"===l.status,classNameModifiers:Bb(t=[]).call(t,rC(o),["pay"]),label:i||u}),d&&JN(aS,{label:d}))},iS=["action","resultCode","sessionData","order","sessionResult"];var lS={},cS={get exports(){return lS},set exports(e){lS=e}},sS={},uS={get exports(){return sS},set exports(e){sS=e}},dS={},pS={get exports(){return dS},set exports(e){dS=e}},fS=c((function(){if("function"==typeof ArrayBuffer){var e=new ArrayBuffer(8);Object.isExtensible(e)&&Object.defineProperty(e,"a",{value:8})}})),mS=c,hS=ae,vS=N,yS=fS,gS=Object.isExtensible,bS=mS((function(){gS(1)}))||yS?function(e){return!!hS(e)&&((!yS||"ArrayBuffer"!=vS(e))&&(!gS||gS(e)))}:gS,kS=!c((function(){return Object.isExtensible(Object.preventExtensions({}))})),CS=Dr,_S=b,NS=ya,PS=ae,wS=et,SS=Xt.f,xS=$r,ES=Lp,AS=bS,DS=kS,IS=!1,FS=ot("meta"),RS=0,OS=function(e){SS(e,FS,{value:{objectID:"O"+RS++,weakData:{}}})},TS=pS.exports={enable:function(){TS.enable=function(){},IS=!0;var e=xS.f,t=_S([].splice),r={};r[FS]=1,e(r).length&&(xS.f=function(r){for(var a=e(r),n=0,o=a.length;n<o;n++)if(a[n]===FS){t(a,n,1);break}return a},CS({target:"Object",stat:!0,forced:!0},{getOwnPropertyNames:ES.f}))},fastKey:function(e,t){if(!PS(e))return"symbol"==typeof e?e:("string"==typeof e?"S":"P")+e;if(!wS(e,FS)){if(!AS(e))return"F";if(!t)return"E";OS(e)}return e[FS].objectID},getWeakData:function(e,t){if(!wS(e,FS)){if(!AS(e))return!0;if(!t)return!1;OS(e)}return e[FS].weakData},onFreeze:function(e){return DS&&IS&&AS(e)&&!wS(e,FS)&&OS(e),e}};NS[FS]=!0;var BS=Dr,jS=l,zS=dS,MS=c,LS=gr,VS=ho,US=_l,KS=D,HS=ae,qS=Ii,WS=Xt.f,YS=gf.forEach,GS=F,JS=ni.set,QS=ni.getterFor,ZS=function(e,t,r){var a,n=-1!==e.indexOf("Map"),o=-1!==e.indexOf("Weak"),i=n?"set":"add",l=jS[e],c=l&&l.prototype,s={};if(GS&&KS(l)&&(o||c.forEach&&!MS((function(){(new l).entries().next()})))){var u=(a=t((function(t,r){JS(US(t,u),{type:e,collection:new l}),null!=r&&VS(r,t[i],{that:t,AS_ENTRIES:n})}))).prototype,d=QS(e);YS(["add","clear","delete","forEach","get","has","set","keys","values","entries"],(function(e){var t="add"==e||"set"==e;!(e in c)||o&&"clear"==e||LS(u,e,(function(r,a){var n=d(this).collection;if(!t&&o&&!HS(r))return"get"==e&&void 0;var i=n[e](0===r?0:r,a);return t?this:i}))})),o||WS(u,"size",{configurable:!0,get:function(){return d(this).collection.size}})}else a=r.getConstructor(t,e,n,i),zS.enable();return qS(a,e,!1,!0),s[e]=a,BS({global:!0,forced:!0},s),o||r.setStrong(a,e,n),a},$S=pi,XS=function(e,t,r){for(var a in t)r&&r.unsafe&&e[a]?e[a]=t[a]:$S(e,a,t[a],r);return e},ex=un,tx=ml,rx=XS,ax=$t,nx=_l,ox=G,ix=ho,lx=tl,cx=rl,sx=bl,ux=F,dx=dS.fastKey,px=ni.set,fx=ni.getterFor,mx={getConstructor:function(e,t,r,a){var n=e((function(e,n){nx(e,o),px(e,{type:t,index:ex(null),first:void 0,last:void 0,size:0}),ux||(e.size=0),ox(n)||ix(n,e[a],{that:e,AS_ENTRIES:r})})),o=n.prototype,i=fx(t),l=function(e,t,r){var a,n,o=i(e),l=c(e,t);return l?l.value=r:(o.last=l={index:n=dx(t,!0),key:t,value:r,previous:a=o.last,next:void 0,removed:!1},o.first||(o.first=l),a&&(a.next=l),ux?o.size++:e.size++,"F"!==n&&(o.index[n]=l)),e},c=function(e,t){var r,a=i(e),n=dx(t);if("F"!==n)return a.index[n];for(r=a.first;r;r=r.next)if(r.key==t)return r};return rx(o,{clear:function(){for(var e=i(this),t=e.index,r=e.first;r;)r.removed=!0,r.previous&&(r.previous=r.previous.next=void 0),delete t[r.index],r=r.next;e.first=e.last=void 0,ux?e.size=0:this.size=0},delete:function(e){var t=this,r=i(t),a=c(t,e);if(a){var n=a.next,o=a.previous;delete r.index[a.index],a.removed=!0,o&&(o.next=n),n&&(n.previous=o),r.first==a&&(r.first=n),r.last==a&&(r.last=o),ux?r.size--:t.size--}return!!a},forEach:function(e){for(var t,r=i(this),a=ax(e,arguments.length>1?arguments[1]:void 0);t=t?t.next:r.first;)for(a(t.value,t.key,this);t&&t.removed;)t=t.previous},has:function(e){return!!c(this,e)}}),rx(o,r?{get:function(e){var t=c(this,e);return t&&t.value},set:function(e,t){return l(this,0===e?0:e,t)}}:{add:function(e){return l(this,e=0===e?0:e,e)}}),ux&&tx(o,"size",{configurable:!0,get:function(){return i(this).size}}),n},setStrong:function(e,t,r){var a=t+" Iterator",n=fx(t),o=fx(a);lx(e,t,(function(e,t){px(this,{type:a,target:e,state:n(e),kind:t,last:void 0})}),(function(){for(var e=o(this),t=e.kind,r=e.last;r&&r.removed;)r=r.previous;return e.target&&(e.last=r=r?r.next:e.state.first)?cx("keys"==t?r.key:"values"==t?r.value:[r.key,r.value],!1):(e.target=void 0,cx(void 0,!0))}),r?"entries":"values",!r,!0),sx(t)}};ZS("Map",(function(e){return function(){return e(this,arguments.length?arguments[0]:void 0)}}),mx);var hx=ne.Map,vx=$t,yx=T,gx=Re,bx=Gl,kx=G,Cx=ho,_x=[].push,Nx=function(e){var t,r,a,n,o=arguments.length,i=o>1?arguments[1]:void 0;return bx(this),(t=void 0!==i)&&gx(i),kx(e)?new this:(r=[],t?(a=0,n=vx(i,o>2?arguments[2]:void 0),Cx(e,(function(e){yx(_x,r,n(e,a++))}))):Cx(e,_x,{that:r}),new this(r))};Dr({target:"Map",stat:!0,forced:!0},{from:Nx});var Px=ec,wx=function(){return new this(Px(arguments))};Dr({target:"Map",stat:!0,forced:!0},{of:wx});var Sx=Ae,xx=function(e){if("object"==typeof e&&"size"in e&&"has"in e&&"get"in e&&"set"in e&&"delete"in e&&"entries"in e)return e;throw TypeError(Sx(e)+" is not a map")},Ex=function(e,t){return 1==t?function(t,r){return t[e](r)}:function(t,r,a){return t[e](r,a)}},Ax=se("Map"),Dx={Map:Ax,set:Ex("set",2),get:Ex("get",1),has:Ex("has",1),remove:Ex("delete",1),proto:Ax.prototype},Ix=xx,Fx=Dx.remove;Dr({target:"Map",proto:!0,real:!0,forced:!0},{deleteAll:function(){for(var e,t=Ix(this),r=!0,a=0,n=arguments.length;a<n;a++)e=Fx(t,arguments[a]),r=r&&e;return!!r}});var Rx=xx,Ox=Dx.get,Tx=Dx.has,Bx=Dx.set;Dr({target:"Map",proto:!0,real:!0,forced:!0},{emplace:function(e,t){var r,a,n=Rx(this);return Tx(n,e)?(r=Ox(n,e),"update"in t&&(r=t.update(r,e,n),Bx(n,e,r)),r):(a=t.insert(e,n),Bx(n,e,a),a)}});var jx=T,zx=function(e,t,r){for(var a,n,o=r||e.next;!(a=jx(o,e)).done;)if(void 0!==(n=t(a.value)))return n},Mx=function(e,t,r){return r?zx(e.entries(),(function(e){return t(e[1],e[0])})):e.forEach(t)},Lx=$t,Vx=xx,Ux=Mx;Dr({target:"Map",proto:!0,real:!0,forced:!0},{every:function(e){var t=Vx(this),r=Lx(e,arguments.length>1?arguments[1]:void 0);return!1!==Ux(t,(function(e,a){if(!r(e,a,t))return!1}),!0)}});var Kx=$t,Hx=xx,qx=Mx,Wx=Dx.Map,Yx=Dx.set;Dr({target:"Map",proto:!0,real:!0,forced:!0},{filter:function(e){var t=Hx(this),r=Kx(e,arguments.length>1?arguments[1]:void 0),a=new Wx;return qx(t,(function(e,n){r(e,n,t)&&Yx(a,n,e)})),a}});var Gx=$t,Jx=xx,Qx=Mx;Dr({target:"Map",proto:!0,real:!0,forced:!0},{find:function(e){var t=Jx(this),r=Gx(e,arguments.length>1?arguments[1]:void 0),a=Qx(t,(function(e,a){if(r(e,a,t))return{value:e}}),!0);return a&&a.value}});var Zx=$t,$x=xx,Xx=Mx;Dr({target:"Map",proto:!0,real:!0,forced:!0},{findKey:function(e){var t=$x(this),r=Zx(e,arguments.length>1?arguments[1]:void 0),a=Xx(t,(function(e,a){if(r(e,a,t))return{key:a}}),!0);return a&&a.key}});var eE=Dr,tE=T,rE=D,aE=Re,nE=ho,oE=Dx.Map,iE=b([].push);eE({target:"Map",stat:!0,forced:!0},{groupBy:function(e,t){var r=new(rE(this)?this:oE);aE(t);var a=aE(r.has),n=aE(r.get),o=aE(r.set);return nE(e,(function(e){var i=t(e);tE(a,r,i)?iE(tE(n,r,i),e):tE(o,r,i,[e])})),r}});var lE=function(e,t){return e===t||e!=e&&t!=t},cE=xx,sE=Mx;Dr({target:"Map",proto:!0,real:!0,forced:!0},{includes:function(e){return!0===sE(cE(this),(function(t){if(lE(t,e))return!0}),!0)}});var uE=T,dE=ho,pE=D,fE=Re,mE=Dx.Map;Dr({target:"Map",stat:!0,forced:!0},{keyBy:function(e,t){var r=new(pE(this)?this:mE);fE(t);var a=fE(r.set);return dE(e,(function(e){uE(a,r,t(e),e)})),r}});var hE=xx,vE=Mx;Dr({target:"Map",proto:!0,real:!0,forced:!0},{keyOf:function(e){var t=vE(hE(this),(function(t,r){if(t===e)return{key:r}}),!0);return t&&t.key}});var yE=$t,gE=xx,bE=Mx,kE=Dx.Map,CE=Dx.set;Dr({target:"Map",proto:!0,real:!0,forced:!0},{mapKeys:function(e){var t=gE(this),r=yE(e,arguments.length>1?arguments[1]:void 0),a=new kE;return bE(t,(function(e,n){CE(a,r(e,n,t),e)})),a}});var _E=$t,NE=xx,PE=Mx,wE=Dx.Map,SE=Dx.set;Dr({target:"Map",proto:!0,real:!0,forced:!0},{mapValues:function(e){var t=NE(this),r=_E(e,arguments.length>1?arguments[1]:void 0),a=new wE;return PE(t,(function(e,n){SE(a,n,r(e,n,t))})),a}});var xE=xx,EE=ho,AE=Dx.set;Dr({target:"Map",proto:!0,real:!0,arity:1,forced:!0},{merge:function(e){for(var t=xE(this),r=arguments.length,a=0;a<r;)EE(arguments[a++],(function(e,r){AE(t,e,r)}),{AS_ENTRIES:!0});return t}});var DE=Re,IE=xx,FE=Mx,RE=TypeError;Dr({target:"Map",proto:!0,real:!0,forced:!0},{reduce:function(e){var t=IE(this),r=arguments.length<2,a=r?void 0:arguments[1];if(DE(e),FE(t,(function(n,o){r?(r=!1,a=n):a=e(a,n,o,t)})),r)throw RE("Reduce of empty map with no initial value");return a}});var OE=$t,TE=xx,BE=Mx;Dr({target:"Map",proto:!0,real:!0,forced:!0},{some:function(e){var t=TE(this),r=OE(e,arguments.length>1?arguments[1]:void 0);return!0===BE(t,(function(e,a){if(r(e,a,t))return!0}),!0)}});var jE=Re,zE=xx,ME=TypeError,LE=Dx.get,VE=Dx.has,UE=Dx.set;Dr({target:"Map",proto:!0,real:!0,forced:!0},{update:function(e,t){var r=zE(this),a=arguments.length;jE(t);var n=VE(r,e);if(!n&&a<3)throw ME("Updating absent value");var o=n?LE(r,e):jE(a>2?arguments[2]:void 0)(e,r);return UE(r,e,t(o,e,r)),r}});var KE=T,HE=Re,qE=D,WE=nr,YE=TypeError,GE=function(e,t){var r,a=WE(this),n=HE(a.get),o=HE(a.has),i=HE(a.set),l=arguments.length>2?arguments[2]:void 0;if(!qE(t)&&!qE(l))throw YE("At least one callback required");return KE(o,a,e)?(r=KE(n,a,e),qE(t)&&(r=t(r),KE(i,a,e,r))):qE(l)&&(r=l(),KE(i,a,e,r)),r};Dr({target:"Map",proto:!0,real:!0,forced:!0},{upsert:GE}),Dr({target:"Map",proto:!0,real:!0,name:"upsert",forced:!0},{updateOrInsert:GE});var JE=hx;!function(e){e.exports=JE}(uS),function(e){e.exports=sS}(cS);var QE=t(lS);var ZE={},$E={get exports(){return ZE},set exports(e){ZE=e}},XE={},eA={get exports(){return XE},set exports(e){XE=e}},tA=aN;!function(e){e.exports=tA}(eA),function(e){e.exports=XE}($E);var rA=t(ZE);function aA(e,t,r){var a;(function(){if("undefined"==typeof Reflect||!rA)return!1;if(rA.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(rA(Boolean,[],(function(){}))),!0}catch(e){return!1}})()?aA=IN(a=rA).call(a):aA=function(e,t,r){var a=[null];a.push.apply(a,t);var n=new(IN(Function).apply(e,a));return r&&ON(n,r.prototype),n};return aA.apply(null,arguments)}function nA(e){var t="function"==typeof QE?new QE:void 0;return nA=function(e){if(null===e||!function(e){var t;return-1!==BP(t=Function.toString.call(e)).call(t,"[native code]")}(e))return e;if("function"!=typeof e)throw new TypeError("Super expression must either be null or a function");if(void 0!==t){if(t.has(e))return t.get(e);t.set(e,r)}function r(){return aA(e,arguments,jN(this).constructor)}return r.prototype=_v(e.prototype,{constructor:{value:r,enumerable:!1,writable:!0,configurable:!0}}),ON(r,e)},nA(e)}function oA(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}var iA=function(e){TN(r,e);var t=oA(r);function r(e,a,n){var o;return Bg(this,r),Wg(RN(o=t.call(this,a)),"cause",void 0),o.name=r.errorTypes[e],o.cause=null==n?void 0:n.cause,o}return qg(r)}(nA(Error));function lA(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=arguments.length>1?arguments[1]:void 0;return Object.prototype.hasOwnProperty.call(e,t)}function cA(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function sA(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=cA(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=cA(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}function uA(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}Wg(iA,"errorTypes",{NETWORK_ERROR:"NETWORK_ERROR",CANCEL:"CANCEL",IMPLEMENTATION_ERROR:"IMPLEMENTATION_ERROR",ERROR:"ERROR"});var dA=function(e){TN(r,e);var t=uA(r);function r(e){var a,n,o,i,l,c,s,u,d,p;return Bg(this,r),Wg(RN(p=t.call(this,e)),"componentRef",void 0),Wg(RN(p),"elementRef",void 0),Wg(RN(p),"handleError",(function(e){p.setElementStatus("ready"),p.props.onError&&p.props.onError(e,p.elementRef)})),Wg(RN(p),"handleAdditionalDetails",(function(e){return p.props.onAdditionalDetails?p.props.onAdditionalDetails(e,p.elementRef):p.props.session&&p.submitAdditionalDetails(e.data),e})),Wg(RN(p),"handleOrder",(function(e){p.updateParent({order:e.order}),p.props.onPaymentCompleted&&p.props.onPaymentCompleted(e,p.elementRef)})),Wg(RN(p),"handleFinalResult",(function(e){if(p.props.setStatusAutomatically){var t=function(e){switch(e.resultCode){case"Authorised":case"Received":case"Pending":return["success"];case"Cancelled":case"Error":case"Refused":return["error"]}}(e),r=tC(t,2),a=r[0],n=r[1];a&&p.setElementStatus(a,n)}return p.props.onPaymentCompleted&&p.props.onPaymentCompleted(e,p.elementRef),e})),Wg(RN(p),"setComponentRef",(function(e){p.componentRef=e})),Wg(RN(p),"payButton",(function(e){return JN(oS,FN({},e,{amount:p.props.amount,secondaryAmount:p.props.secondaryAmount,onClick:p.submit}))})),p.submit=rk(a=p.submit).call(a,RN(p)),p.setState=rk(n=p.setState).call(n,RN(p)),p.onValid=rk(o=p.onValid).call(o,RN(p)),p.onComplete=rk(i=p.onComplete).call(i,RN(p)),p.onSubmit=rk(l=p.onSubmit).call(l,RN(p)),p.handleAction=rk(c=p.handleAction).call(c,RN(p)),p.handleOrder=rk(s=p.handleOrder).call(s,RN(p)),p.handleResponse=rk(u=p.handleResponse).call(u,RN(p)),p.setElementStatus=rk(d=p.setElementStatus).call(d,RN(p)),p.elementRef=e&&e.elementRef||RN(p),p}return qg(r,[{key:"setState",value:function(e){this.state=sA(sA({},this.state),e),this.onChange()}},{key:"onChange",value:function(){var e=this.isValid,t={data:this.data,errors:this.state.errors,valid:this.state.valid,isValid:e};return this.props.onChange&&this.props.onChange(t,this.elementRef),e&&this.onValid(),t}},{key:"onSubmit",value:function(){var e=this;this.props.isInstantPayment&&this.elementRef.closeActivePaymentMethod();if(this.props.setStatusAutomatically&&this.setElementStatus("loading"),this.props.onSubmit)this.props.onSubmit({data:this.data,isValid:this.isValid},this.elementRef);else if(this._parentInstance.session){var t=this.props.beforeSubmit?new ok((function(t,r){return e.props.beforeSubmit(e.data,e.elementRef,{resolve:t,reject:r})})):ok.resolve(this.data);t.then((function(t){return e.submitPayment(t)})).catch((function(){e.elementRef.setStatus("ready")}))}else this.handleError(new iA("IMPLEMENTATION_ERROR","Could not submit the payment"))}},{key:"onValid",value:function(){var e={data:this.data};return this.props.onValid&&this.props.onValid(e,this.elementRef),e}},{key:"onComplete",value:function(e){this.props.onComplete&&this.props.onComplete(e,this.elementRef)}},{key:"submit",value:function(){this.isValid?this.onSubmit():this.showValidation()}},{key:"showValidation",value:function(){return this.componentRef&&this.componentRef.showValidation&&this.componentRef.showValidation(),this}},{key:"setElementStatus",value:function(e,t){var r;return null===(r=this.elementRef)||void 0===r||r.setStatus(e,t),this}},{key:"setStatus",value:function(e,t){var r;return null!==(r=this.componentRef)&&void 0!==r&&r.setStatus&&this.componentRef.setStatus(e,t),this}},{key:"submitPayment",value:function(e){var t=this;return this._parentInstance.session.submitPayment(e).then(this.handleResponse).catch((function(e){return t.handleError(e)}))}},{key:"submitAdditionalDetails",value:function(e){return this._parentInstance.session.submitDetails(e).then(this.handleResponse).catch(this.handleError)}},{key:"handleAction",value:function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};if(!e||!e.type){if(lA(e,"action")&&lA(e,"resultCode"))throw new Error('handleAction::Invalid Action - the passed action object itself has an "action" property and a "resultCode": have you passed in the whole response object by mistake?');throw new Error('handleAction::Invalid Action - the passed action object does not have a "type" property')}var r=this._parentInstance.createFromAction(e,sA(sA(sA({},this.elementRef.props),t),{},{onAdditionalDetails:this.handleAdditionalDetails}));return r?(this.unmount(),r.mount(this._node)):null}},{key:"handleResponse",value:function(e){var t,r,a=function(e){var t,r=[],a=DC(t=Jy(e)).call(t,(function(t,a){return Eb(iS).call(iS,a)?t[a]=e[a]:r.push(a),t}),{});return r.length&&console.warn("The following properties should not be passed to the client: ".concat(r.join(", "))),a}(e);a.action?this.elementRef.handleAction(a.action):(null===(t=a.order)||void 0===t||null===(r=t.remainingAmount)||void 0===r?void 0:r.value)>0?this.handleOrder(a):this.elementRef.handleFinalResult(a)}},{key:"updateParent",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};return this.elementRef._parentInstance.update(e)}},{key:"isValid",get:function(){return!1}},{key:"icon",get:function(){var e;return null!==(e=this.props.icon)&&void 0!==e?e:GP({loadingContext:this.props.loadingContext})(this.constructor.type)}},{key:"displayName",get:function(){return this.props.name||this.constructor.type}},{key:"accessibleName",get:function(){return this.displayName}},{key:"type",get:function(){return this.props.type||this.constructor.type}}]),r}(PP),pA={},fA={get exports(){return pA},set exports(e){pA=e}},mA=ne,hA=m;mA.JSON||(mA.JSON={stringify:JSON.stringify});var vA=function(e,t,r){return hA(mA.JSON.stringify,null,arguments)},yA=vA;!function(e){e.exports=yA}(fA);var gA=t(pA);function bA(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}var kA=function(e){TN(r,e);var t=bA(r);function r(){var e,a;Bg(this,r);for(var n=arguments.length,o=new Array(n),i=0;i<n;i++)o[i]=arguments[i];return Wg(RN(a=t.call.apply(t,Bb(e=[this]).call(e,o))),"iframeEl",void 0),a}return qg(r,[{key:"iframeOnLoad",value:function(){this.props.callback&&"function"==typeof this.props.callback&&this.props.callback(this.iframeEl.contentWindow)}},{key:"componentDidMount",value:function(){var e;if(this.iframeEl.addEventListener)this.iframeEl.addEventListener("load",rk(e=this.iframeOnLoad).call(e,this),!1);else if(this.iframeEl.attachEvent){var t;this.iframeEl.attachEvent("onload",rk(t=this.iframeOnLoad).call(t,this))}else{var r;this.iframeEl.onload=rk(r=this.iframeOnLoad).call(r,this)}}},{key:"componentWillUnmount",value:function(){var e;if(this.iframeEl.removeEventListener)this.iframeEl.removeEventListener("load",rk(e=this.iframeOnLoad).call(e,this),!1);else if(this.iframeEl.detachEvent){var t;this.iframeEl.detachEvent("onload",rk(t=this.iframeOnLoad).call(t,this))}else this.iframeEl.onload=null}},{key:"render",value:function(e){var t=this,r=e.name,a=e.src,n=e.width,o=e.height,i=e.minWidth,l=e.minHeight,c=e.allow,s=e.title,u=e.classNameModifiers,d=nb(u).call(u,(function(e){return!!e}));return JN("iframe",{ref:function(e){t.iframeEl=e},allow:c,className:ww("adyen-checkout__iframe","adyen-checkout__iframe--".concat(r),d.length&&QC(u).call(u,(function(e){var t;return Bb(t="adyen-checkout__iframe--".concat(r,"-")).call(t,e)}))),name:r,src:a,width:n,height:o,style:{border:0},frameBorder:"0",title:s,referrerpolicy:"origin","min-width":i,"min-height":l})}}]),r}($N);Wg(kA,"defaultProps",{width:"0",height:"0",minWidth:"0",minHeight:"0",src:null,allow:null,title:"components iframe",classNameModifiers:[]});var CA=function(e,t,r){var a,n=new ok((function(n,o){a=hw((function(){o(r)}),e),t.then((function(e){clearTimeout(a),n(e)})).catch((function(e){clearTimeout(a),o(e)}))}));return{promise:n,cancel:function(){clearTimeout(a)}}},_A="deviceFingerprint",NA={result:{type:_A,value:"df-timedOut"},errorCode:"timeout"},PA="unknownError",wA={timeout:"iframe loading timed out",wrongOrigin:"Result did not come from the expected origin",wrongDataType:"Result data was not of the expected type",missingProperty:"Result data did not contain the expected properties",unknownError:"An unknown error occurred"},SA=function(e,t,r,a){return function(r){var n={};if((r.origin||r.originalEvent.origin)!==e)return"Message was not sent from the expected domain";if("string"!=typeof r.data)return"Event data was not of type string";if(!r.data.length)return"Invalid event data string";try{var o=JSON.parse(r.data);if(!lA(o,"type")||o.type!==a)return"Event data was not of expected type";t(o)}catch(e){return n.type="".concat(a,"-JSON-parse-error"),n.comment="failed to JSON parse event.data",n.extraInfo="event.data = ".concat(r.data),n.eventDataRaw=r.data,console.debug("get-process-message-handler::CATCH::Un-parseable JSON:: parseErrorObj=",n),!1}return!0}},xA=function(e){var t,r,a,n=/^(?:([A-Za-z]+):)?(\/{0,3})([0-9.\-A-Za-z]+)(?::(\d+))?(?:\/([^?#]*))?(?:\?([^#]*))?(?:#(.*))?$/.exec(e);if(!n)return null;var o=tC(n,5),i=o[1],l=o[2],c=o[3],s=o[4];return i&&l&&c?Bb(t=Bb(r=Bb(a="".concat(i,":")).call(a,l)).call(r,c)).call(t,s?":".concat(s):""):null};function EA(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}var AA=function(e){TN(r,e);var t=EA(r);function r(e){var a;return Bg(this,r),Wg(RN(a=t.call(this,e)),"postMessageDomain",void 0),Wg(RN(a),"processMessageHandler",void 0),Wg(RN(a),"deviceFingerPrintPromise",void 0),a.postMessageDomain=xA(a.props.loadingContext)||a.props.loadingContext,a}return qg(r,[{key:"getDfpPromise",value:function(){var e=this;return new ok((function(t,r){e.processMessageHandler=SA(e.postMessageDomain,t,0,_A),window.addEventListener("message",e.processMessageHandler)}))}},{key:"componentDidMount",value:function(){var e=this;this.deviceFingerPrintPromise=CA(2e4,this.getDfpPromise(),NA),this.deviceFingerPrintPromise.promise.then((function(t){e.props.onCompleteFingerprint(t),window.removeEventListener("message",e.processMessageHandler)})).catch((function(t){e.props.onErrorFingerprint(t),window.removeEventListener("message",e.processMessageHandler)}))}},{key:"render",value:function(e){var t=e.dfpURL;return JN("div",{className:"adyen-checkout-risk__device-fingerprint"},JN(kA,{name:"dfIframe",src:t,allow:"geolocation; microphone; camera;",title:"devicefingerprinting iframe"}))}}]),r}($N);function DA(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}var IA=function(e){TN(r,e);var t=DA(r);function r(e){var a,n,o;(Bg(this,r),a=t.call(this,e),e.clientKey)&&(a.state={status:"retrievingFingerPrint",dfpURL:Bb(n=Bb(o="".concat(a.props.loadingContext,"assets/html/")).call(o,e.clientKey,"/dfp.")).call(n,"1.0.0",".html")});return a}return qg(r,[{key:"setStatusComplete",value:function(e){var t=this;this.setState({status:"complete"},(function(){t.props.onComplete(e)}))}},{key:"render",value:function(e,t){var r=this,a=e.loadingContext,n=t.dfpURL;return"retrievingFingerPrint"===this.state.status?JN("div",{className:"adyen-checkout-risk__device-fingerprint--wrapper",style:{position:"absolute",width:0,height:0}},JN(AA,{loadingContext:a,dfpURL:n,onCompleteFingerprint:function(e){r.setStatusComplete(e)},onErrorFingerprint:function(e){var t;r.props.onError({errorCode:t=e.errorCode,message:wA[t]||wA[PA],type:_A}),r.setStatusComplete(e.result)}})):null}}]),r}($N);Wg(IA,"defaultProps",{onComplete:function(){},onError:function(){}});var FA={},RA={get exports(){return FA},set exports(e){FA=e}};!function(e){e.exports=My}(RA);var OA=t(FA),TA={decode:function(e){return!!TA.isBase64(e)&&(!!TA.isBase64(e)&&(t=e,decodeURIComponent(QC(Array.prototype).call(window.atob(t),(function(e){var t;return"%".concat(OA(t="00".concat(e.charCodeAt(0).toString(16))).call(t,-2))})).join(""))));var t},encode:function(e){return window.btoa(e)},isBase64:function(e){return!!e&&(!(e.length%4)&&window.btoa(window.atob(e))===e)}};function BA(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function jA(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=BA(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=BA(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}function zA(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}var MA=function(e){TN(r,e);var t=zA(r);function r(e){var a;Bg(this,r),Wg(RN(a=t.call(this,e)),"nodeRiskContainer",null),Wg(RN(a),"onComplete",(function(e){var t,r=jA(jA({},a.state.data),{},(Wg(t={},e.type,e.value),Wg(t,"persistentCookie",e.persistentCookie),Wg(t,"components",e.components),t));a.setState({data:r,isValid:!0}),a.props.risk.onComplete(a.data),a.cleanUp()})),Wg(RN(a),"onError",(function(e){a.props.risk.onError(e),a.cleanUp()})),Wg(RN(a),"cleanUp",(function(){a.nodeRiskContainer&&a.nodeRiskContainer.parentNode&&a.nodeRiskContainer.parentNode.removeChild(a.nodeRiskContainer)}));var n=Wg({},_A,null);return a.setState({data:n}),!0===a.props.risk.enabled&&(document.querySelector(a.props.risk.node)?(a.nodeRiskContainer=document.createElement("div"),document.querySelector(a.props.risk.node).appendChild(a.nodeRiskContainer),a.mount(a.nodeRiskContainer)):a.onError({message:"RiskModule node was not found"})),a}return qg(r,[{key:"formatProps",value:function(e){return jA(jA({},e),{},{risk:jA(jA({},r.defaultProps.risk),e.risk)})}},{key:"isValid",get:function(){return this.state.isValid}},{key:"data",get:function(){if(this.isValid){var e=jA({version:"1.0.0"},this.state.data);return TA.encode(gA(e))}return!1}},{key:"componentWillUnmount",value:function(){this.cleanUp()}},{key:"render",value:function(){return JN(IA,FN({},this.props,{loadingContext:this.props.loadingContext,onComplete:this.onComplete,onError:this.onError}))}}]),r}(PP);Wg(MA,"type","risk"),Wg(MA,"defaultProps",{risk:{enabled:!0,onComplete:function(){},onError:function(){},node:"body"}});var LA={},VA={get exports(){return LA},set exports(e){LA=e}},UA={},KA={get exports(){return UA},set exports(e){UA=e}},HA=et,qA=T,WA=ae,YA=nr,GA=function(e){return void 0!==e&&(HA(e,"value")||HA(e,"writable"))},JA=I,QA=Ur;Dr({target:"Reflect",stat:!0},{get:function e(t,r){var a,n,o=arguments.length<3?t:arguments[2];return YA(t)===o?t[r]:(a=JA.f(t,r))?GA(a)?a.value:void 0===a.get?void 0:qA(a.get,o):WA(n=QA(t))?e(n,r,o):void 0}});var ZA=ne.Reflect.get;!function(e){e.exports=ZA}(KA),function(e){e.exports=UA}(VA);var $A=t(LA),XA={},eD={get exports(){return XA},set exports(e){XA=e}},tD={},rD={get exports(){return tD},set exports(e){tD=e}},aD=dg;!function(e){e.exports=aD}(rD),function(e){e.exports=tD}(eD);var nD=t(XA);function oD(){var e;"undefined"!=typeof Reflect&&$A?oD=IN(e=$A).call(e):oD=function(e,t,r){var a=function(e,t){for(;!Object.prototype.hasOwnProperty.call(e,t)&&null!==(e=jN(e)););return e}(e,t);if(a){var n=nD(a,t);return n.get?n.get.call(arguments.length<3?e:r):n.value}};return oD.apply(this,arguments)}var iD={},lD={get exports(){return iD},set exports(e){iD=e}},cD=gf.every;Dr({target:"Array",proto:!0,forced:!jv("every")},{every:function(e){return cD(this,e,arguments.length>1?arguments[1]:void 0)}});var sD=Vv("Array").every,uD=ue,dD=sD,pD=Array.prototype,fD=function(e){var t=e.every;return e===pD||uD(pD,e)&&t===pD.every?dD:t};!function(e){e.exports=fD}(lD);var mD=t(iD);function hD(e){var t,r=e.children,a=e.classNameModifiers,n=void 0===a?[]:a,o=e.label,i=e.readonly,l=void 0!==i&&i,c=$w().i18n;return JN("div",{className:ww(Bb(t=["adyen-checkout__fieldset"]).call(t,rC(QC(n).call(n,(function(e){return"adyen-checkout__fieldset--".concat(e)}))),[{"adyen-checkout__fieldset--readonly":l}]))},o&&JN("div",{className:"adyen-checkout__fieldset__title"},c.get(o)),JN("div",{className:"adyen-checkout__fieldset__fields"},r))}var vD=function(e){var t=e.type,r=e.className,a=void 0===r?"":r,n=e.alt,o=void 0===n?"":n,i=e.height,l=e.width,c=$w().loadingContext,s=GP({loadingContext:c,imageFolder:"components/"})(t);return JN("img",{className:ww("adyen-checkout__icon",a),alt:o,src:s,height:i,width:l})},yD="encryptedCardNumber",gD="encryptedExpiryDate",bD="encryptedExpiryMonth",kD="encryptedExpiryYear",CD="encryptedSecurityCode",_D="encryptedPassword",ND="encryptedPin",PD="encryptedBankAccountNumber",wD="encryptedBankLocationId",SD="encryptedSecurityCode3digits",xD="encryptedSecurityCode4digits",ED="giftcard",AD="4.4.1",DD=["amex","mc","visa"],ID=["ach",ED],FD=[yD,gD,bD,kD,CD,_D],RD=[PD,wD];Bb(FD).call(FD,RD);var OD,TD,BD=["bcmc"],jD="required",zD="optional",MD="hidden",LD=jD,VD=zD,UD=MD,KD=jD,HD=zD,qD=MD,WD="data-cse",YD="data-info",GD="data-uid",JD=["accel","pulse","star","nyce"],QD="-ariaError",ZD="incomplete field",$D="Unsupported card entered",XD="Card number field empty",eI="Expiry date field empty",tI="Expiry year field empty",rI="Expiry month field empty",aI="Security code field empty",nI="KCP password field empty",oI="ACH bank account field empty",iI="ACH bank location field empty",lI=(Wg(OD={},ZD,"error.va.gen.01"),Wg(OD,"field not valid","error.va.gen.02"),Wg(OD,"luhn check failed","error.va.sf-cc-num.01"),Wg(OD,XD,"error.va.sf-cc-num.02"),Wg(OD,$D,"error.va.sf-cc-num.03"),Wg(OD,"Card number not filled correctly","error.va.sf-cc-num.04"),Wg(OD,"Card too old","error.va.sf-cc-dat.01"),Wg(OD,"Date too far in future","error.va.sf-cc-dat.02"),Wg(OD,"Your card expires before check out date","error.va.sf-cc-dat.03"),Wg(OD,eI,"error.va.sf-cc-dat.04"),Wg(OD,"Expiry date not filled correctly","error.va.sf-cc-dat.05"),Wg(OD,tI,"error.va.sf-cc-yr.01"),Wg(OD,"Expiry year not filled correctly","error.va.sf-cc-yr.02"),Wg(OD,rI,"error.va.sf-cc-mth.01"),Wg(OD,aI,"error.va.sf-cc-cvc.01"),Wg(OD,"Security code not filled correctly","error.va.sf-cc-cvc.02"),Wg(OD,nI,"error.va.sf-kcp-pwd.01"),Wg(OD,"KCP password not filled correctly","error.va.sf-kcp-pwd.02"),Wg(OD,oI,"error.va.sf-ach-num.01"),Wg(OD,"ACH bank account not filled correctly","error.va.sf-ach-num.02"),Wg(OD,iI,"error.va.sf-ach-loc.01"),Wg(OD,"ACH bank location id not filled correctly","error.va.sf-ach-loc.02"),OD),cI=lI[ZD],sI=(Wg(TD={},yD,lI[XD]),Wg(TD,gD,lI[eI]),Wg(TD,bD,lI[rI]),Wg(TD,kD,lI[tI]),Wg(TD,CD,lI[aI]),Wg(TD,_D,lI[nI]),Wg(TD,PD,lI[oI]),Wg(TD,wD,lI[iI]),TD),uI={},dI={get exports(){return uI},set exports(e){uI=e}},pI=Dr,fI=Date,mI=b(fI.prototype.getTime);pI({target:"Date",stat:!0},{now:function(){return mI(new fI)}});var hI=ne.Date.now;!function(e){e.exports=hI}(dI);var vI=t(uI),yI=vI(),gI=function(){var e;return yI+=1,Bb(e="".concat(arguments.length>0&&void 0!==arguments[0]?arguments[0]:"field","-")).call(e,yI)};function bI(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}var kI=function(e){var t=e.children,r=e.className,a=e.classNameModifiers,n=e.dir,o=e.disabled,i=e.errorMessage,l=e.helper,c=e.inputWrapperModifiers,s=e.isCollatingErrors,u=e.isLoading,d=e.isValid,p=e.label,f=e.labelEndAdornment,m=e.name,h=e.onBlur,v=e.onFieldBlur,y=e.onFocus,g=e.onFocusField,b=e.showValidIcon,k=e.useLabelElement,C=e.filled,_=e.focused,N=e.i18n,P=Lw(gI("adyen-checkout-".concat(m))),w=tC(Bw(!1),2),S=w[0],x=w[1],E=tC(Bw(!1),2),A=E[0],D=E[1];null!=_&&x(!!_),null!=C&&D(!!C);var I=Uw((function(e){x(!0),null==y||y(e)}),[y]),F=Uw((function(e){x(!1),null==h||h(e),null==v||v(e)}),[h,v]),R=Uw((function(){var e,r,a;return JN(ZN,null,"string"==typeof p&&JN("span",{className:ww({"adyen-checkout__label__text":!0,"adyen-checkout__label__text--error":i}),"data-id":m},p),"function"==typeof p&&p(),f&&JN("span",{className:"adyen-checkout__label-adornment--end"},f),l&&JN("span",{className:"adyen-checkout__helper-text"},l),JN("div",{className:ww(Bb(e=["adyen-checkout__input-wrapper"]).call(e,rC(QC(c).call(c,(function(e){return"adyen-checkout__input-wrapper--".concat(e)}))))),dir:n},QC(r=oP(t)).call(r,(function(e){var t=function(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=bI(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=bI(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}({isValid:d,onFocusHandler:I,onBlurHandler:F,isInvalid:!!i},m&&{uniqueId:P.current});return function(e,t,r){var a,n,o,i=YN({},e.props);for(o in t)"key"==o?a=t[o]:"ref"==o?n=t[o]:i[o]=t[o];return arguments.length>2&&(i.children=arguments.length>3?zN.call(arguments,2):r),QN(e.type,i,a||e.key,n||e.ref,null)}(e,t)})),u&&JN("span",{className:"adyen-checkout-input__inline-validation adyen-checkout-input__inline-validation--loading"},JN(Sw,{size:"small"})),d&&!1!==b&&JN("span",{className:"adyen-checkout-input__inline-validation adyen-checkout-input__inline-validation--valid"},JN(vD,{type:"checkmark",alt:null==N?void 0:N.get("field.valid")})),i&&JN("span",{className:"adyen-checkout-input__inline-validation adyen-checkout-input__inline-validation--invalid"},JN(vD,{type:"field_error",alt:null==N?void 0:N.get("error.title")}))),i&&"string"==typeof i&&i.length&&JN("span",{className:"adyen-checkout__error-text",id:Bb(a="".concat(P.current)).call(a,QD),"aria-hidden":s?"true":null,"aria-live":s?null:"polite"},i))}),[t,i,u,d,p,I,F]),O=Uw((function(e){var t=e.onFocusField,r=e.focused,a=e.filled,n=e.disabled,o=e.name,i=e.uniqueId,l=e.useLabelElement,c=e.children,s={onClick:t,className:ww({"adyen-checkout__label":!0,"adyen-checkout__label--focused":r,"adyen-checkout__label--filled":a,"adyen-checkout__label--disabled":n})};return l?JN("label",FN({},s,{htmlFor:o&&i}),c):JN("div",FN({},s,{role:"form"}),c)}),[]);return JN("div",{className:ww("adyen-checkout__field",r,QC(a).call(a,(function(e){return"adyen-checkout__field--".concat(e)})),{"adyen-checkout__field--error":i,"adyen-checkout__field--valid":d})},JN(O,{onFocusField:g,name:m,disabled:o,filled:A,focused:S,useLabelElement:k,uniqueId:P.current},R()))};kI.defaultProps={className:"",classNameModifiers:[],inputWrapperModifiers:[],useLabelElement:!0};var CI=function(e){var t=e.data,r=t.name,a=t.registrationNumber;return JN(hD,{classNameModifiers:["companyDetails"],label:"companyDetails",readonly:!0},r&&"".concat(r," "),a&&"".concat(a," "))},_I={},NI={get exports(){return _I},set exports(e){_I=e}},PI=ui.PROPER,wI=c,SI=p_,xI=function(e){return wI((function(){return!!SI[e]()||"\u200b\x85\u180e"!=="\u200b\x85\u180e"[e]()||PI&&SI[e].name!==e}))},EI=k_.trim;Dr({target:"String",proto:!0,forced:xI("trim")},{trim:function(){return EI(this)}});var AI=Vv("String").trim,DI=ue,II=AI,FI=String.prototype,RI=function(e){var t=e.trim;return"string"==typeof e||e===FI||DI(FI,e)&&t===FI.trim?II:t};!function(e){e.exports=RI}(NI);var OI=t(_I),TI=["onCreateRef"],BI=["classNameModifiers","uniqueId","isInvalid","isValid","isCollatingErrors"];function jI(e){var t,r=e.onCreateRef,a=KP(e,TI),n=a.autoCorrect,o=a.classNameModifiers,i=a.isInvalid,l=a.isValid,c=a.readonly,s=void 0===c?null:c,u=a.spellCheck,d=a.type,p=a.uniqueId,f=a.isCollatingErrors,m=a.disabled,h=Lw(null);zw((function(){null==r||r(h.current)}),[h.current,r]),Object.prototype.hasOwnProperty.call(a,"onChange")&&console.error("Error: Form fields that rely on InputBase may not have an onChange property");var v=Uw((function(e){a.onInput(e)}),[a.onInput]),y=Uw((function(e){null!=a&&a.onKeyUp&&a.onKeyUp(e)}),[null==a?void 0:a.onKeyUp]),g=Uw((function(e){var t,r,n;(null==a||null===(t=a.onBlurHandler)||void 0===t||t.call(a,e),a.trimOnBlur)&&(e.target.value=OI(n=e.target.value).call(n));null==a||null===(r=a.onBlur)||void 0===r||r.call(a,e)}),[a.onBlur,a.onBlurHandler]),b=Uw((function(e){var t;null==a||null===(t=a.onFocusHandler)||void 0===t||t.call(a,e)}),[a.onFocusHandler]),k=ww("adyen-checkout__input",["adyen-checkout__input--".concat(d)],a.className,{"adyen-checkout__input--invalid":i,"adyen-checkout__input--valid":l},QC(o).call(o,(function(e){return"adyen-checkout__input--".concat(e)})));a.classNameModifiers,a.uniqueId,a.isInvalid,a.isValid,a.isCollatingErrors;var C=KP(a,BI);return JN("input",FN({id:p},C,{"aria-required":C.required,type:d,className:k,readOnly:s,spellCheck:u,autoCorrect:n,"aria-describedby":f?null:Bb(t="".concat(p)).call(t,QD),"aria-invalid":i,onInput:v,onBlur:g,onFocus:b,onKeyUp:y,disabled:m,ref:h}))}function zI(e){return JN(jI,FN({classNameModifiers:["large"]},e,{"aria-required":e.required,type:"text"}))}jI.defaultProps={type:"text",classNameModifiers:[]};var MI=function(){var e=document.createElement("input");return e.setAttribute("type","date"),"date"===e.type},LI=function(e){var t=e.replace(/\D|\s/g,"").replace(/^(00)(.*)?/,"01$2").replace(/^(3[2-9])(.*)?/,"0$1$2").replace(/^([4-9])(.*)?/,"0$1").replace(/^([0-9]{2})(00)(.*)?/,"$101").replace(/^(3[01])(02)(.*)?/,"29$2").replace(/^([0-9]{2})([2-9]|1[3-9])(.*)?/,"$10$2").replace(/^([0-9]{2})([0-9]{2})([0-9])/,"$1/$2/$3").replace(/^([0-9]{2})([0-9])/,"$1/$2"),r=tC(t.split("/"),3),a=r[0],n=void 0===a?"":a,o=r[1],i=void 0===o?"":o,l=r[2],c=void 0===l?"":l;return 4===c.length&&"29"===n&&"02"===i&&(Number(c)%4!=0||"00"===c.substr(2,2)&&Number(c)%400!=0)?t.replace(/^29/,"28"):t},VI=function(){var e,t,r=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"";if(-1===hC(r).call(r,"/"))return r;var a=tC(r.split("/"),3),n=a[0],o=void 0===n?"":n,i=a[1],l=void 0===i?"":i,c=a[2],s=void 0===c?"":c;return o&&l&&s?Bb(e=Bb(t="".concat(s,"-")).call(t,l,"-")).call(e,o):null};function UI(e){return JN(jI,Vw(MI,[])?FN({},e,{type:"date"}):FN({},e,{onInput:function(t){var r=t.target.value;t.target.value=LI(r),e.onInput(t)},maxLength:10}))}function KI(e){return JN(jI,FN({},e,{type:"tel"}))}function HI(e){return JN(jI,FN({},e,{type:"email",autoCapitalize:"off"}))}var qI={},WI={get exports(){return qI},set exports(e){qI=e}},YI=m,GI=ee,JI=aa,QI=da,ZI=jv,$I=Math.min,XI=[].lastIndexOf,eF=!!XI&&1/[1].lastIndexOf(1,-0)<0,tF=ZI("lastIndexOf"),rF=eF||!tF?function(e){if(eF)return YI(XI,this,arguments)||0;var t=GI(this),r=QI(t),a=r-1;for(arguments.length>1&&(a=$I(a,JI(arguments[1]))),a<0&&(a=r+a);a>=0;a--)if(a in t&&t[a]===e)return a||0;return-1}:XI;Dr({target:"Array",proto:!0,forced:rF!==[].lastIndexOf},{lastIndexOf:rF});var aF=Vv("Array").lastIndexOf,nF=ue,oF=aF,iF=Array.prototype,lF=function(e){var t=e.lastIndexOf;return e===iF||nF(iF,e)&&t===iF.lastIndexOf?oF:t};!function(e){e.exports=lF}(WI);var cF=t(qI);function sF(e){var t=e.items,r=e.i18n,a=e.name,n=e.onChange,o=e.value,i=e.isInvalid,l=e.uniqueId,c=null==l?void 0:l.replace(/[0-9]/g,"").substring(0,cF(l).call(l,"-"));return JN("div",{className:"adyen-checkout__radio_group"},QC(t).call(t,(function(t){var l=gI(c);return JN("div",{key:t.id,className:"adyen-checkout__radio_group__input-wrapper"},JN("input",{id:l,type:"radio",checked:o===t.id,className:"adyen-checkout__radio_group__input",name:a,onChange:n,onClick:n,value:t.id}),JN("label",{className:ww(["adyen-checkout__label__text","adyen-checkout__radio_group__label",e.className,{"adyen-checkout__radio_group__label--invalid":i}]),htmlFor:l},r.get(t.name)))})))}sF.defaultProps={onChange:function(){},items:[]};var uF=["classNameModifiers","label","isInvalid","onChange"];function dF(e){var t=e.classNameModifiers,r=void 0===t?[]:t,a=e.label,n=e.isInvalid,o=e.onChange,i=KP(e,uF);return JN("label",{className:"adyen-checkout__checkbox"},JN("input",FN({},i,{className:ww(["adyen-checkout__checkbox__input",[i.className],{"adyen-checkout__checkbox__input--invalid":n},QC(r).call(r,(function(e){return"adyen-checkout__input--".concat(e)}))]),type:"checkbox",onChange:o})),JN("span",{className:"adyen-checkout__checkbox__label"},a))}dF.defaultProps={onChange:function(){}};var pF={"adyen-checkout__dropdown":"Select-module_adyen-checkout__dropdown__0Mj-n","adyen-checkout__dropdown__button":"Select-module_adyen-checkout__dropdown__button__yTyqq","adyen-checkout__dropdown__button--active":"Select-module_adyen-checkout__dropdown__button--active__Ej-JR","adyen-checkout__filter-input":"Select-module_adyen-checkout__filter-input__CwPBS","adyen-checkout__dropdown__list":"Select-module_adyen-checkout__dropdown__list__YtEzj","adyen-checkout__dropdown__list--active":"Select-module_adyen-checkout__dropdown__list--active__Gegw2","adyen-checkout__dropdown__element":"Select-module_adyen-checkout__dropdown__element__ORU4-"};function fF(e){var t,r=e.backgroundUrl,a=void 0===r?"":r,n=e.className,o=void 0===n?"":n,i=e.classNameModifiers,l=void 0===i?[]:i,c=e.src,s=void 0===c?"":c,u=e.alt,d=void 0===u?"":u,p=e.showOnError,f=void 0!==p&&p,m=tC(Bw(!1),2),h=m[0],v=m[1],y=Lw(null),g=function(){v(!0)},b=ww.apply(void 0,Bb(t=[[o],"adyen-checkout__image",{"adyen-checkout__image--loaded":h}]).call(t,rC(QC(l).call(l,(function(e){return"adyen-checkout__image--".concat(e)})))));return zw((function(){var e=a?new Image:y.current;e.src=a||s,e.onload=g,v(!!e.complete)}),[]),a?JN("div",FN({style:{backgroundUrl:a}},e,{className:b})):JN("img",FN({},e,{alt:d,ref:y,className:b,onError:function(){v(f)}}))}var mF=["filterable","toggleButtonRef"];function hF(e){var t=e.filterable,r=e.toggleButtonRef,a=KP(e,mF);return JN(t?"div":"button",FN({},a,{ref:r}))}function vF(e){var t,r=$w().i18n,a=e.active,n=e.readonly,o=e.showList;return JN(hF,{"aria-disabled":n,"aria-expanded":o,"aria-haspopup":"listbox",className:ww((t={"adyen-checkout__dropdown__button":!0},Wg(t,pF["adyen-checkout__dropdown__button"],!0),Wg(t,"adyen-checkout__dropdown__button--readonly",n),Wg(t,"adyen-checkout__dropdown__button--active",o),Wg(t,pF["adyen-checkout__dropdown__button--active"],o),Wg(t,"adyen-checkout__dropdown__button--invalid",e.isInvalid),Wg(t,"adyen-checkout__dropdown__button--valid",e.isValid),Wg(t,"adyen-checkout__dropdown__button--disabled",a.disabled),t)),filterable:e.filterable,onClick:n?null:e.toggleList,onKeyDown:n?null:e.onButtonKeyDown,role:e.filterable?"button":null,tabIndex:"0",title:a.name||e.placeholder,toggleButtonRef:e.toggleButtonRef,type:e.filterable?null:"button","aria-describedby":e.ariaDescribedBy,id:e.id},o&&e.filterable?JN("input",{"aria-autocomplete":"list","aria-controls":e.selectListId,"aria-expanded":o,"aria-owns":e.selectListId,autoComplete:"off",className:ww("adyen-checkout__filter-input",[pF["adyen-checkout__filter-input"]]),onInput:e.onInput,placeholder:r.get("select.filter.placeholder"),ref:e.filterInputRef,role:"combobox",type:"text"}):JN(ZN,null,a.icon&&JN(fF,{className:"adyen-checkout__dropdown__button__icon",src:a.icon,alt:a.name}),JN("span",{className:"adyen-checkout__dropdown__button__text"},a.selectedOptionName||a.name||e.placeholder),a.secondaryText&&JN("span",{className:"adyen-checkout__dropdown__button__secondary-text"},a.secondaryText)))}var yF=["item","selected"],gF=function(e){var t=e.item,r=e.selected,a=KP(e,yF);return JN("li",{"aria-disabled":!!t.disabled,"aria-selected":r,className:ww(["adyen-checkout__dropdown__element",pF["adyen-checkout__dropdown__element"],{"adyen-checkout__dropdown__element--active":r,"adyen-checkout__dropdown__element--disabled":!!t.disabled}]),"data-disabled":!0===t.disabled||null,"data-value":t.id,onClick:a.onSelect,onKeyDown:a.onKeyDown,role:"option",tabIndex:-1},t.icon&&JN(fF,{className:"adyen-checkout__dropdown__element__icon",alt:t.name,src:t.icon}),JN("span",{className:"adyen-checkout__dropdown__element__text"},t.name),t.secondaryText&&JN("span",{className:"adyen-checkout__dropdown__element__secondary-text"},t.secondaryText),r&&JN(vD,{type:"checkmark",height:14,width:14}))},bF=["active","items","showList","textFilter"];function kF(e){var t,r=e.active,a=e.items,n=e.showList,o=e.textFilter,i=KP(e,bF),l=$w().i18n,c=nb(a).call(a,(function(e){var t;return!o||Eb(t=e.name.toLowerCase()).call(t,o)}));return JN("ul",{className:ww((t={test:!0,"adyen-checkout__dropdown__list":!0},Wg(t,pF["adyen-checkout__dropdown__list"],!0),Wg(t,"adyen-checkout__dropdown__list--active",n),Wg(t,pF["adyen-checkout__dropdown__list--active"],n),t)),id:i.selectListId,ref:i.selectListRef,role:"listbox"},c.length?QC(c).call(c,(function(e){return JN(gF,{item:e,key:e.id,onKeyDown:i.onKeyDown,onSelect:i.onSelect,selected:e.id===r.id})})):JN("div",{className:"adyen-checkout__dropdown__element adyen-checkout__dropdown__element--no-options"},l.get("select.noOptionsFound")))}var CF={arrowDown:"ArrowDown",arrowUp:"ArrowUp",enter:"Enter",escape:"Escape",space:" ",tab:"Tab"};function _F(e){var t,r,a=e.items,n=void 0===a?[]:a,o=e.className,i=void 0===o?"":o,l=e.classNameModifiers,c=void 0===l?[]:l,s=e.filterable,u=void 0===s||s,d=e.readonly,p=void 0!==d&&d,f=e.onChange,m=void 0===f?function(){}:f,h=e.selected,v=e.name,y=e.isInvalid,g=e.isValid,b=e.placeholder,k=e.uniqueId,C=e.isCollatingErrors,_=Lw(null),N=Lw(null),P=Lw(null),w=Lw(null),S=tC(Bw(null),2),x=S[0],E=S[1],A=tC(Bw(!1),2),D=A[0],I=A[1],F=Vw((function(){return"select-".concat(CP())}),[]),R=yk(n).call(n,(function(e){return e.id===h}))||{},O=function(){E(null),I(!1),P.current&&P.current.focus()},T=function(e){e.preventDefault();var t=w.current.contains(e.currentTarget)?e.currentTarget:w.current.firstElementChild;if(!t.getAttribute("data-disabled")){O();var r=t.getAttribute("data-value");m({target:{value:r,name:v}})}},B=function(e){var t;(e.composedPath?!Eb(t=e.composedPath()).call(t,N.current):!N.current.contains(e.target))&&(E(null),I(!1))};return zw((function(){D&&u&&_.current&&_.current.focus()}),[D]),zw((function(){return document.addEventListener("click",B,!1),function(){document.removeEventListener("click",B,!1)}}),[]),JN("div",{className:ww(Bb(t=["adyen-checkout__dropdown",pF["adyen-checkout__dropdown"],i]).call(t,rC(QC(c).call(c,(function(e){return"adyen-checkout__dropdown--".concat(e)}))))),ref:N},JN(vF,{id:null!=k?k:null,active:R,filterInputRef:_,filterable:u,isInvalid:y,isValid:g,onButtonKeyDown:function(e){var t;if(e.key===CF.enter&&u&&D&&x)T(e);else if(e.key===CF.escape)O();else if(!Eb(t=[CF.arrowUp,CF.arrowDown,CF.enter]).call(t,e.key)&&(e.key!==CF.space||u&&D))(e.shiftKey&&e.key===CF.tab||e.key===CF.tab)&&O();else{var r;e.preventDefault(),I(!0),null!==(r=w.current)&&void 0!==r&&r.firstElementChild&&w.current.firstElementChild.focus()}},onInput:function(e){var t=e.target.value;E(t.toLowerCase())},placeholder:b,readonly:p,selectListId:F,showList:D,toggleButtonRef:P,toggleList:function(e){e.preventDefault(),I(!D)},ariaDescribedBy:!C&&k?Bb(r="".concat(k)).call(r,QD):null}),JN(kF,{active:R,items:n,onKeyDown:function(e){var t=e.target;switch(e.key){case CF.escape:e.preventDefault(),O();break;case CF.space:case CF.enter:T(e);break;case CF.arrowDown:e.preventDefault(),t.nextElementSibling&&t.nextElementSibling.focus();break;case CF.arrowUp:e.preventDefault(),t.previousElementSibling?t.previousElementSibling.focus():u&&_.current&&_.current.focus();break;case CF.tab:O()}},onSelect:T,selectListId:F,selectListRef:w,showList:D,textFilter:x}))}_F.defaultProps={className:"",classNameModifiers:[],filterable:!0,items:[],readonly:!1,onChange:function(){}};var NF=function(e,t){var r={boolean:dF,radio:sF,select:_F,date:UI,emailAddress:HI,tel:KI,text:zI,default:zI};return JN(r[e]||r.default,t)};function PF(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function wF(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=PF(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=PF(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}var SF=function(e){var t=e.name,r=e.registrationNumber;return wF({},(t||r)&&{company:wF(wF({},t&&{name:t}),r&&{registrationNumber:r})})},xF=function(){function e(t,r,a,n){var o;Bg(this,e),Wg(this,"shouldValidate",void 0),Wg(this,"isValid",void 0),Wg(this,"errorMessage",void 0),this.shouldValidate=Eb(o=t.modes).call(o,a),this.isValid=t.validate(r,n),this.errorMessage=t.errorMessage}return qg(e,[{key:"hasError",value:function(){return arguments.length>0&&void 0!==arguments[0]&&arguments[0]?!this.isValid&&this.shouldValidate:null!=this.isValid&&!this.isValid&&this.shouldValidate}}]),e}();function EF(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function AF(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=EF(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=EF(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}var DF=function(){function e(t){Bg(this,e),Wg(this,"validationResults",void 0),this.validationResults=t}return qg(e,[{key:"isValid",get:function(){var e;return DC(e=this.validationResults).call(e,(function(e,t){return e&&t.isValid}),!0)}},{key:"hasError",value:function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];return Boolean(this.getError(e))}},{key:"getError",value:function(){var e,t=arguments.length>0&&void 0!==arguments[0]&&arguments[0];return yk(e=this.validationResults).call(e,(function(e){return e.hasError(t)}))}},{key:"getAllErrors",value:function(){var e;return nb(e=this.validationResults).call(e,(function(e){return e.hasError()}))}}]),e}(),IF=function(){function e(t){Bg(this,e),Wg(this,"rules",{default:{validate:function(){return!0},modes:["blur","input"]}}),this.setRules(t)}return qg(e,[{key:"setRules",value:function(e){this.rules=AF(AF({},this.rules),e)}},{key:"getRulesFor",value:function(e){var t,r=null!==(t=this.rules[e])&&void 0!==t?t:this.rules.default;return gw(r)||(r=[r]),r}},{key:"validate",value:function(e,t){var r=e.key,a=e.value,n=e.mode,o=void 0===n?"blur":n,i=this.getRulesFor(r),l=QC(i).call(i,(function(e){return new xF(e,a,o,t)}));return new DF(l)}}]),e}(),FF={},RF={get exports(){return FF},set exports(e){FF=e}},OF=F,TF=b,BF=Va,jF=ee,zF=TF(B.f),MF=TF([].push),LF=function(e){return function(t){for(var r,a=jF(t),n=BF(a),o=n.length,i=0,l=[];o>i;)r=n[i++],OF&&!zF(a,r)||MF(l,e?[r,a[r]]:a[r]);return l}},VF={entries:LF(!0),values:LF(!1)},UF=VF.values;Dr({target:"Object",stat:!0},{values:function(e){return UF(e)}});var KF=ne.Object.values;!function(e){e.exports=KF}(RF);var HF=t(FF);function qF(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function WF(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=qF(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=qF(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}var YF=function(e,t){var r,a;return DC(r=nb(a=Jy(e)).call(a,(function(e){return!Eb(t).call(t,e)}))).call(r,(function(t,r){return t[r]=e[r],t}),{})},GF=function(e,t,r,a,n){return DC(t).call(t,(function(e,t){var o,i,l;return WF(WF({},e),{},Wg({},t,null!==(o=null!==(i=null!==(l=e[t])&&void 0!==l?l:null==n?void 0:n[t])&&void 0!==i?i:null==a?void 0:a[t])&&void 0!==o?o:r))}),e)};function JF(e){var t=e.schema,r=e.defaultData,a=e.processField,n=e.fieldProblems,o=function(e){var t,o;if(void 0===r[e])return{valid:!1,errors:null,data:null,fieldProblems:null!==(t=null==n?void 0:n[e])&&void 0!==t?t:null};var i=tC(a({key:e,value:r[e],mode:"blur"},{state:{data:r}}),2),l=i[0],c=i[1];return{valid:c.isValid&&!(null!=n&&n[e])||!1,errors:c.hasError()?c.getError():null,data:l,fieldProblems:null!==(o=null==n?void 0:n[e])&&void 0!==o?o:null}},i=DC(t).call(t,(function(e,t){var r=o(t),a=r.valid,n=r.errors,i=r.data,l=r.fieldProblems;return{valid:WF(WF({},e.valid),{},Wg({},t,a)),errors:WF(WF({},e.errors),{},Wg({},t,n)),data:WF(WF({},e.data),{},Wg({},t,i)),fieldProblems:WF(WF({},e.fieldProblems),{},Wg({},t,l))}}),{data:{},valid:{},errors:{},fieldProblems:{}});return{schema:t,data:i.data,valid:i.valid,errors:i.errors,fieldProblems:i.fieldProblems}}function QF(e){var t=e.rules,r=void 0===t?{}:t,a=e.formatters,n=void 0===a?{}:a,o=e.defaultData,i=void 0===o?{}:o,l=e.fieldProblems,c=void 0===l?{}:l,s=e.schema,u=void 0===s?[]:s,d=Vw((function(){return new IF(r)}),[r]),p=function(e,t){var r=e.key,a=e.value,o=e.mode,i=null==n?void 0:n[r],l=function(e){return e&&"formatterFn"in e}(i)?i.formatterFn:i,c=l&&"function"==typeof l?l(null!=a?a:"",t):a;return[c,d.validate({key:r,value:c,mode:o},t)]},f=jw(function(e){return function(t,r){var a=r.type,n=r.key,o=r.value,i=r.mode,l=r.schema,c=r.defaultData,s=r.formValue,u=r.selectedSchema,d=r.fieldProblems,p=u||t.schema;switch(a){case"setData":return WF(WF({},t),{},{data:WF(WF({},t.data),{},Wg({},n,o))});case"setValid":return WF(WF({},t),{},{valid:WF(WF({},t.valid),{},Wg({},n,o))});case"setErrors":return WF(WF({},t),{},{errors:WF(WF({},t.errors),{},Wg({},n,o))});case"setFieldProblems":var f,m;return null!==(f=null==t||null===(m=t.schema)||void 0===m?void 0:DC(m).call(m,(function(e,r){var a,n;return WF(WF({},e),{},{fieldProblems:WF(WF({},t.fieldProblems),{},Wg({},r,null!==(a=null==d?void 0:d[r])&&void 0!==a?a:null)),valid:WF(WF({},t.valid),{},Wg({},r,(null===(n=t.valid)||void 0===n?void 0:n[r])&&!d[r]))})}),t))&&void 0!==f?f:t;case"updateField":var h=tC(e({key:n,value:o,mode:i},{state:t}),2),v=h[0],y=h[1],g=t.data[n],b=WF({},t.fieldProblems);return g!==v&&(b[n]=null),WF(WF({},t),{},{data:WF(WF({},t.data),{},Wg({},n,v)),errors:WF(WF({},t.errors),{},Wg({},n,y.hasError()?y.getError():null)),valid:WF(WF({},t.valid),{},Wg({},n,y.isValid&&!b[n]||!1)),fieldProblems:b});case"mergeForm":var k,C=WF(WF({},t),{},{data:WF(WF({},t.data),s.data),errors:WF(WF({},t.errors),s.errors),valid:WF(WF({},t.valid),s.valid),fieldProblems:WF(WF({},t.fieldProblems),s.fieldProblems)});return C.valid&&(C.isValid=mD(k=HF(C.valid)).call(k,(function(e){return e}))),C;case"setSchema":var _,N,P,w,S=JF({schema:l,defaultData:c,processField:e,fieldProblems:d}),x=nb(_=t.schema).call(_,(function(e){return!Eb(l).call(l,e)})),E=nb(l).call(l,(function(e){var r;return!Eb(r=t.schema).call(r,e)})),A={data:YF(t.data,E),errors:YF(t.errors,E),valid:YF(t.valid,E)},D=GF(YF(t.data,x),E,null,S.data,null===(N=t.local)||void 0===N?void 0:N.data),I=GF(YF(t.valid,x),E,!1,S.valid,null===(P=t.local)||void 0===P?void 0:P.valid),F=GF(YF(t.errors,x),E,null,S.errors,null===(w=t.local)||void 0===w?void 0:w.errors);return WF(WF({},t),{},{schema:l,data:D,valid:I,errors:F,local:A});case"validateForm":var R=DC(p).call(p,(function(r,a){var n=tC(e({key:a,value:t.data[a],mode:"blur"},{state:t}),2)[1];return{valid:WF(WF({},r.valid),{},Wg({},a,n.isValid&&!t.fieldProblems[a]||!1)),errors:WF(WF({},r.errors),{},Wg({},a,n.hasError(!0)?n.getError(!0):null))}}),{valid:t.valid,errors:t.errors});return WF(WF({},t),{},{valid:R.valid,errors:R.errors});default:throw new Error("Undefined useForm action")}}}(p),{defaultData:i,schema:null!=u?u:[],processField:p,fieldProblems:c},JF),m=tC(f,2),h=m[0],v=m[1],y=Vw((function(){var e;return DC(e=h.schema).call(e,(function(e,t){return e&&h.valid[t]}),!0)}),[h.schema,h.valid]),g=Uw((function(){v({type:"validateForm",selectedSchema:arguments.length>0&&void 0!==arguments[0]?arguments[0]:null})}),[]),b=Uw((function(e,t){return v({type:"setErrors",key:e,value:t})}),[]),k=Uw((function(e,t){return v({type:"setValid",key:e,value:t})}),[]),C=Uw((function(e,t){return v({type:"setData",key:e,value:t})}),[]),_=Uw((function(e){return v({type:"setSchema",schema:e,defaultData:i})}),[h.schema]),N=Uw((function(e){return v({type:"mergeForm",formValue:e})}),[]),P=Uw((function(e){return v({type:"setFieldProblems",fieldProblems:e})}),[h.schema]);return zw((function(){P(null!=c?c:{})}),[gA(c)]),{handleChangeFor:function(e,t){return function(r){var a=function(e,t){return t.target?"checkbox"===t.target.type?!h.data[e]:t.target.value:t}(e,r);v({type:"updateField",key:e,value:a,mode:t})}},triggerValidation:g,setSchema:_,setData:C,setValid:k,setErrors:b,isValid:y,mergeForm:N,setFieldProblems:P,schema:h.schema,valid:h.valid,errors:h.errors,data:h.data,fieldProblems:h.fieldProblems}}function ZF(e){var t,r=e.label,a=void 0===r?"":r,n=e.namePrefix,o=e.requiredFields,i=e.visibility,l=$w().i18n,c=QF({schema:o,rules:e.validationRules,defaultData:e.data}),s=c.handleChangeFor,u=c.triggerValidation,d=c.data,p=c.valid,f=c.errors,m=c.isValid,h=Lw({});Jy(h.current).length||(null===(t=e.setComponentRef)||void 0===t||t.call(e,h.current));h.current.showValidation=function(){u()};var v=function(e){var t;return Bb(t="".concat(n?"".concat(n,"."):"")).call(t,e)},y=function(e){return function(t){var r=t.target.name.split("".concat(n,".")).pop();s(r,e)(t)}};return zw((function(){var t=SF(d);e.onChange({data:t,valid:p,errors:f,isValid:m})}),[d,p,f,m]),"hidden"===i?null:"readOnly"===i?JN(CI,FN({},e,{data:d})):JN(hD,{classNameModifiers:[a],label:a},Eb(o).call(o,"name")&&JN(kI,{label:l.get("companyDetails.name"),classNameModifiers:["name"],errorMessage:!!f.name,i18n:l},NF("text",{name:v("name"),value:d.name,classNameModifiers:["name"],onInput:y("input"),onBlur:y("blur"),spellCheck:!1})),Eb(o).call(o,"registrationNumber")&&JN(kI,{label:l.get("companyDetails.registrationNumber"),classNameModifiers:["registrationNumber"],errorMessage:!!f.registrationNumber,i18n:l},NF("text",{name:v("registrationNumber"),value:d.registrationNumber,classNameModifiers:["registrationNumber"],onInput:y("input"),onBlur:y("blur"),spellCheck:!1})))}ZF.defaultProps={data:{},onChange:function(){},visibility:"editable",requiredFields:["name","registrationNumber"],validationRules:{default:{validate:function(e){return e&&e.length>0},modes:["blur"]}}};var $F=function(e){var t=e.data,r=t.firstName,a=t.lastName,n=t.shopperEmail,o=t.telephoneNumber;return JN(hD,{classNameModifiers:["personalDetails"],label:"personalDetails",readonly:!0},r&&"".concat(r," "),a&&"".concat(a," "),n&&JN(ZN,null,JN("br",null),n),o&&JN(ZN,null,JN("br",null),o))},XF=/^\s*[\w\-+_]+(\.[\w\-+_]+)*@[\w\-+_]+\.[\w\-+_]+(\.[\w-+_]+)*\s*$/,eR=/^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s./0-9]*$/,tR={default:{validate:function(e){return e&&e.length>0},errorMessage:"error.va.gen.02",modes:["blur"]},firstName:{validate:function(e){return e&&e.length>0},errorMessage:"firstName.invalid",modes:["blur"]},lastName:{validate:function(e){return e&&e.length>0},errorMessage:"lastName.invalid",modes:["blur"]},dateOfBirth:{validate:function(e){return function(e){if(!e)return!1;var t=VI(e),r=vI()-Date.parse(t);return new Date(r).getFullYear()-1970>=18}(e)},errorMessage:"dateOfBirth.invalid",modes:["blur"]},telephoneNumber:{validate:function(e){return eR.test(e)},errorMessage:"telephoneNumber.invalid",modes:["blur"]},shopperEmail:{validate:function(e){return XF.test(e)},errorMessage:"shopperEmail.invalid",modes:["blur"]}};function rR(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function aR(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=rR(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=rR(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}var nR=function(e){var t=e.firstName,r=e.lastName,a=e.gender,n=e.dateOfBirth,o=e.shopperEmail,i=e.telephoneNumber;return aR(aR(aR(aR({},(t||r)&&{shopperName:aR(aR(aR({},t&&{firstName:t}),r&&{lastName:r}),a&&{gender:a})}),n&&{dateOfBirth:VI(n)}),o&&{shopperEmail:o}),i&&{telephoneNumber:i})};function oR(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function iR(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=oR(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=oR(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}var lR,cR,sR;function uR(e){var t,r=e.label,a=void 0===r?"":r,n=e.namePrefix,o=e.placeholders,i=e.requiredFields,l=e.visibility,c=$w().i18n,s=Lw({});Jy(s.current).length||(null===(t=e.setComponentRef)||void 0===t||t.call(e,s.current));var u=Vw(MI,[]),d=QF({schema:i,rules:iR(iR({},tR),e.validationRules),defaultData:e.data}),p=d.handleChangeFor,f=d.triggerValidation,m=d.data,h=d.valid,v=d.errors,y=d.isValid;s.current.showValidation=function(){f()};var g=function(e){return function(t){var r=t.target.name.split("".concat(n,".")).pop();p(r,e)(t)}},b=function(e){var t;return Bb(t="".concat(n?"".concat(n,"."):"")).call(t,e)},k=function(e){return e&&e.errorMessage?c.get(e.errorMessage):!!e};return zw((function(){var t=nR(m);e.onChange({data:t,valid:h,errors:v,isValid:y})}),[m,h,v,y]),"hidden"===l?null:"readOnly"===l?JN($F,FN({},e,{data:m})):JN(ZN,null,JN(hD,{classNameModifiers:["personalDetails"],label:a},Eb(i).call(i,"firstName")&&JN(kI,{label:c.get("firstName"),classNameModifiers:["col-50","firstName"],errorMessage:k(v.firstName),name:"firstName",i18n:c},NF("text",{name:b("firstName"),value:m.firstName,classNameModifiers:["firstName"],onInput:g("input"),onBlur:g("blur"),placeholder:o.firstName,spellCheck:!1,required:!0})),Eb(i).call(i,"lastName")&&JN(kI,{label:c.get("lastName"),classNameModifiers:["col-50","lastName"],errorMessage:k(v.lastName),name:"lastName",i18n:c},NF("text",{name:b("lastName"),value:m.lastName,classNameModifiers:["lastName"],onInput:g("input"),onBlur:g("blur"),placeholder:o.lastName,spellCheck:!1,required:!0})),Eb(i).call(i,"gender")&&JN(kI,{errorMessage:!!v.gender,classNameModifiers:["gender"],name:"gender",useLabelElement:!1},NF("radio",{i18n:c,name:b("gender"),value:m.gender,items:[{id:"MALE",name:"male"},{id:"FEMALE",name:"female"}],classNameModifiers:["gender"],onInput:g("input"),onChange:g("blur"),required:!0})),Eb(i).call(i,"dateOfBirth")&&JN(kI,{label:c.get("dateOfBirth"),classNameModifiers:["col-50","lastName"],errorMessage:k(v.dateOfBirth),helper:u?null:c.get("dateOfBirth.format"),name:"dateOfBirth",i18n:c},NF("date",{name:b("dateOfBirth"),value:m.dateOfBirth,classNameModifiers:["dateOfBirth"],onInput:g("input"),onBlur:g("blur"),placeholder:o.dateOfBirth,required:!0})),Eb(i).call(i,"shopperEmail")&&JN(kI,{label:c.get("shopperEmail"),classNameModifiers:["shopperEmail"],errorMessage:k(v.shopperEmail),dir:"ltr",name:"emailAddress",i18n:c},NF("emailAddress",{name:b("shopperEmail"),value:m.shopperEmail,classNameModifiers:["shopperEmail"],onInput:g("input"),onBlur:g("blur"),placeholder:o.shopperEmail,required:!0})),Eb(i).call(i,"telephoneNumber")&&JN(kI,{label:c.get("telephoneNumber"),classNameModifiers:["telephoneNumber"],errorMessage:k(v.telephoneNumber),dir:"ltr",name:"telephoneNumber",i18n:c},NF("tel",{name:b("telephoneNumber"),value:m.telephoneNumber,classNameModifiers:["telephoneNumber"],onInput:g("input"),onBlur:g("blur"),placeholder:o.telephoneNumber,required:!0}))),!1)}uR.defaultProps={data:{},onChange:function(){},placeholders:{},requiredFields:["firstName","lastName","gender","dateOfBirth","shopperEmail","telephoneNumber"],validationRules:tR,visibility:"editable"};var dR="N/A",pR=["street","houseNumberOrName","postalCode","city","stateOrProvince","country"],fR=pR[0],mR=pR[1],hR=pR[2],vR=pR[3],yR=pR[4],gR=pR[5],bR={AU:{hasDataset:!0,labels:(lR={},Wg(lR,mR,"apartmentSuite"),Wg(lR,yR,"state"),Wg(lR,fR,"address"),lR),optionalFields:[mR],placeholders:Wg({},yR,"select.state"),schema:[gR,fR,mR,vR,[[yR,50],[hR,50]]]},BR:{hasDataset:!0,labels:Wg({},yR,"state"),placeholders:Wg({},yR,"select.state")},CA:{hasDataset:!0,labels:(cR={},Wg(cR,mR,"apartmentSuite"),Wg(cR,yR,"provinceOrTerritory"),Wg(cR,fR,"address"),cR),optionalFields:[mR],schema:[gR,fR,mR,[[vR,70],[hR,30]],yR]},GB:{labels:Wg({},vR,"cityTown"),schema:[gR,[[mR,30],[fR,70]],[[vR,70],[hR,30]],yR]},US:{hasDataset:!0,labels:(sR={},Wg(sR,hR,"zipCode"),Wg(sR,mR,"apartmentSuite"),Wg(sR,yR,"state"),Wg(sR,fR,"address"),sR),optionalFields:[mR],placeholders:Wg({},yR,"select.state"),schema:[gR,fR,mR,vR,[[yR,50],[hR,50]]]},default:{optionalFields:[],placeholders:Wg({},yR,"select.provinceOrTerritory"),schema:[gR,[[fR,70],[mR,30]],[[hR,30],[vR,70]],yR]}},kR={default:{labels:Wg({},hR,"zipCode"),schema:[hR]}},CR=Jy(bR),_R=function(e){var t=e.data,r=e.label,a=t.street,n=t.houseNumberOrName,o=t.city,i=t.postalCode,l=t.stateOrProvince,c=t.country;return JN(hD,{classNameModifiers:[r],label:r,readonly:!0},!!a&&a,n&&", ".concat(n,","),JN("br",null),i&&"".concat(i),o&&", ".concat(o),l&&l!==dR&&", ".concat(l),c&&", ".concat(c," "))},NR={},PR={get exports(){return NR},set exports(e){NR=e}},wR=Ze,SR=la,xR=da,ER=function(e){for(var t=wR(this),r=xR(t),a=arguments.length,n=SR(a>1?arguments[1]:void 0,r),o=a>2?arguments[2]:void 0,i=void 0===o?r:SR(o,r);i>n;)t[n++]=e;return t};Dr({target:"Array",proto:!0},{fill:ER});var AR=Vv("Array").fill,DR=ue,IR=AR,FR=Array.prototype,RR=function(e){var t=e.fill;return e===FR||DR(FR,e)&&t===FR.fill?IR:t};!function(e){e.exports=RR}(PR);var OR=t(NR),TR={},BR={get exports(){return TR},set exports(e){TR=e}},jR=k_.start,zR=xI("trimStart")?function(){return jR(this)}:"".trimStart;Dr({target:"String",proto:!0,name:"trimStart",forced:"".trimLeft!==zR},{trimLeft:zR});Dr({target:"String",proto:!0,name:"trimStart",forced:"".trimStart!==zR},{trimStart:zR});var MR=Vv("String").trimLeft,LR=ue,VR=MR,UR=String.prototype,KR=function(e){var t=e.trimStart;return"string"==typeof e||e===UR||LR(UR,e)&&t===UR.trimStart?VR:t};!function(e){e.exports=KR}(BR);var HR=t(TR),qR=function(e,t,r,a){var n,o,i,l;if(a&&null!==(n=e[r])&&void 0!==n&&null!==(o=n[t])&&void 0!==o&&o.formatterFn)return null;var c=null===(i=e[r])||void 0===i||null===(l=i[t])||void 0===l?void 0:l.maxlength;return c||30},WR=function(e){return!(null!=e&&!/^[\s]*$/.test(e))},YR="?\\-\\+_=!@#$%^&*(){}~<>\\[\\]\\/\\\\",GR=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"g";return new RegExp("[".concat(e,"]"),t)};(function(e,t){var r;new RegExp(Bb(r="^[".concat(t?"^":"")).call(r,e,"]+$"))})(YR,!0);var JR=function(e){var t;return{formatterFn:function(t){return t.replace(GR("^\\d","g"),"").substr(0,e)},format:OR(t=new Array(e)).call(t,"9").join(""),maxlength:e}},QR=GR(YR),ZR=function(e){return function(e){return HR(e).call(e).replace(/\s+/g," ")}(e).replace(QR,"")},$R={postalCode:{formatterFn:function(e,t){var r,a=t.state.data.country,n=null===(r=XR[a])||void 0===r?void 0:r.postalCode.formatterFn;return n?n(e):e}},street:{formatterFn:ZR},houseNumberOrName:{formatterFn:ZR},city:{formatterFn:ZR}},XR={AT:{postalCode:JR(4)},AU:{postalCode:JR(4)},BE:{postalCode:JR(4)},BG:{postalCode:JR(4)},BR:{postalCode:JR(8)},CA:{postalCode:{format:"A9A 9A9 or A9A9A9",maxlength:7}},CH:{postalCode:JR(4)},CY:{postalCode:JR(4)},CZ:{postalCode:{format:"999 99",maxlength:6}},DE:{postalCode:JR(5)},DK:{postalCode:{format:"9999",maxlength:7}},EE:{postalCode:JR(5)},ES:{postalCode:JR(5)},FI:{postalCode:JR(5)},FR:{postalCode:JR(5)},GB:{postalCode:{formatterFn:function(e){return e.replace(GR(YR),"").substr(0,8)},format:"AA99 9AA or A99 9AA or A9 9AA",maxlength:8}},GR:{postalCode:{format:"999 99",maxlength:6}},HR:{postalCode:{format:"[1-5]9999",maxlength:5}},HU:{postalCode:JR(4)},IE:{postalCode:{format:"A99 A999",maxlength:8}},IS:{postalCode:JR(3)},IT:{postalCode:JR(5)},LI:{postalCode:JR(4)},LT:{postalCode:{format:"9999 or 99999 or LT-99999",maxlength:8}},LU:{postalCode:JR(4)},LV:{postalCode:{format:"9999 or LV-9999",maxlength:7}},MC:{postalCode:{format:"980NN",maxlength:5}},MT:{postalCode:{format:"AA99 or AAA99 or AA9999 or AAA9999",maxlength:8}},MY:{postalCode:JR(5)},NL:{postalCode:{format:"9999AA",maxlength:7}},NZ:{postalCode:JR(4)},NO:{postalCode:JR(4)},PL:{postalCode:{formatterFn:function(e){var t=e.replace(GR("^\\d-","g"),""),r=hC(t).call(t,"-")>-1?6:5;return t.substr(0,r)},format:"99999 or 99-999",maxlength:6}},PT:{postalCode:{formatterFn:function(e){return e.replace(GR("^\\d-","g"),"").substr(0,8)},format:"9999-999",maxlength:8}},RO:{postalCode:JR(6)},SI:{postalCode:{format:"9999 or SI-9999",maxlength:7}},SE:{postalCode:JR(5)},SG:{postalCode:JR(6)},SK:{postalCode:{format:"99999 or SK-99999",maxlength:8}},JP:{postalCode:{format:"999-9999",maxlength:8}},US:{postalCode:{formatterFn:function(e){var t=e.replace(GR("^\\d-","g"),""),r=hC(t).call(t,"-")>-1?10:5;return t.substr(0,r)},format:"99999 or 99999-9999"}}},eO=function(e){return{pattern:new RegExp("\\d{".concat(e,"}"))}},tO=function(e,t,r){if(t){var a,n;if(r.postalCode.errorMessage={translationKey:"invalidFormatExpects",translationObject:{values:{format:(null===(a=XR[t])||void 0===a?void 0:a.postalCode.format)||null}}},WR(e))return null;var o=null===(n=rO[t])||void 0===n?void 0:n.pattern;return o?o.test(e):!!e}return!WR(e)||null},rO={AT:eO(4),AU:eO(4),BE:{pattern:/(?:(?:[1-9])(?:\d{3}))/},BG:eO(4),BR:eO(8),CA:{pattern:/(?:[ABCEGHJ-NPRSTVXY]\d[A-Z][ -]?\d[A-Z]\d)/},CH:{pattern:/[1-9]\d{3}/},CY:eO(4),CZ:{pattern:/\d{3}\s?\d{2}/},DE:eO(5),DK:eO(4),EE:eO(5),ES:{pattern:/(?:0[1-9]|[1-4]\d|5[0-2])\d{3}/},FI:eO(5),FR:eO(5),GB:{pattern:/^([A-Za-z][A-Ha-hK-Yk-y]?[0-9][A-Za-z0-9]? ?[0-9][A-Za-z]{2}|[Gg][Ii][Rr] ?0[Aa]{2})$/},GE:eO(4),GR:{pattern:/^\d{3}\s{0,1}\d{2}$/},HR:{pattern:/^([1-5])[0-9]{4}$/},HU:eO(4),IE:{pattern:/(?:^[AC-FHKNPRTV-Y][0-9]{2}|D6W)[ -]?[0-9AC-FHKNPRTV-Y]{4}/},IS:eO(3),IT:eO(5),LI:eO(4),LT:{pattern:/^(LT-\d{5})$/},LU:eO(4),LV:{pattern:/^(LV-)[0-9]{4}$/},MC:{pattern:/^980\d{2}$/},MT:{pattern:/^[A-Za-z]{3}\d{4}$/},MY:eO(5),NL:{pattern:/(?:NL-)?(?:[1-9]\d{3} ?(?:[A-EGHJ-NPRTVWXZ][A-EGHJ-NPRSTVWXZ]|S[BCEGHJ-NPRTVWXZ]))/},NO:eO(4),PL:{pattern:/^\d{2}[-]{0,1}\d{3}$/},PT:{pattern:/^([1-9]\d{3})([- ]?(\d{3})? *)$/},RO:eO(6),SI:eO(4),SE:eO(5),SG:eO(6),SK:eO(5),US:eO(5)},aO=function(e){var t={postalCode:{modes:["blur"],validate:function(r){return tO(r,e,t)},errorMessage:lI[ZD]}};return t},nO=function(e){var t={postalCode:{modes:["blur"],validate:function(e,r){var a=r.state.data.country;return tO(e,a,t)},errorMessage:lI[ZD]},houseNumberOrName:{validate:function(t,r){var a,n,o=null===(a=r.state)||void 0===a||null===(n=a.data)||void 0===n?void 0:n.country;return o&&e.countryHasOptionalField(o,"houseNumberOrName")||!WR(t)||null},modes:["blur"],errorMessage:lI[ZD]},default:{validate:function(e){return!WR(e)||null},modes:["blur"],errorMessage:lI[ZD]}};return t},oO={},iO={get exports(){return oO},set exports(e){oO=e}},lO={},cO={get exports(){return lO},set exports(e){lO=e}},sO=l;Dr({global:!0,forced:sO.globalThis!==sO},{globalThis:sO});var uO={},dO={get exports(){return uO},set exports(e){uO=e}};!function(e){e.exports=l}(dO);var pO=uO;!function(e){e.exports=pO}(cO),function(e){e.exports=lO}(iO);var fO=t(oO),mO={},hO={get exports(){return mO},set exports(e){mO=e}};!function(e){e.exports=Nh}(hO);var vO=t(mO),yO={},gO={get exports(){return yO},set exports(e){yO=e}};!function(e){e.exports=Zh}(gO);var bO=t(yO),kO={},CO={get exports(){return kO},set exports(e){kO=e}},_O=Dr,NO=c,PO=Lp.f;_O({target:"Object",stat:!0,forced:NO((function(){return!Object.getOwnPropertyNames(1)}))},{getOwnPropertyNames:PO});var wO=ne.Object,SO=function(e){return wO.getOwnPropertyNames(e)};!function(e){e.exports=SO}(CO);var xO=t(kO),EO={},AO={get exports(){return EO},set exports(e){EO=e}},DO=Vv("Array").entries,IO=jn,FO=et,RO=ue,OO=DO,TO=Array.prototype,BO={DOMTokenList:!0,NodeList:!0},jO=function(e){var t=e.entries;return e===TO||RO(TO,e)&&t===TO.entries||FO(BO,IO(e))?OO:t};!function(e){e.exports=jO}(AO);var zO=t(EO),MO={},LO={get exports(){return MO},set exports(e){MO=e}},VO=c,UO=mt("iterator"),KO=!VO((function(){var e=new URL("b?a=1&b=2&c=3","http://a"),t=e.searchParams,r="";return e.pathname="c%20d",t.forEach((function(e,a){t.delete("b"),r+=a+e})),!e.toJSON||!t.size&&true||!t.sort||"http://a/c%20d?a=1&c=3"!==e.href||"3"!==t.get("c")||"a=1"!==String(new URLSearchParams("?a=1"))||!t[UO]||"a"!==new URL("https://a@b").username||"b"!==new URLSearchParams(new URLSearchParams("a=b")).get("a")||"xn--e1aybc"!==new URL("http://\u0442\u0435\u0441\u0442").host||"#%D0%B1"!==new URL("http://a#\u0431").hash||"a1c3"!==r||"x"!==new URL("http://x",void 0).host})),HO=Wp,qO=Math.floor,WO=function(e,t){var r=e.length,a=qO(r/2);return r<8?YO(e,t):GO(e,WO(HO(e,0,a),t),WO(HO(e,a),t),t)},YO=function(e,t){for(var r,a,n=e.length,o=1;o<n;){for(a=o,r=e[o];a&&t(e[a-1],r)>0;)e[a]=e[--a];a!==o++&&(e[a]=r)}return e},GO=function(e,t,r,a){for(var n=t.length,o=r.length,i=0,l=0;i<n||l<o;)e[i+l]=i<n&&l<o?a(t[i],r[l])<=0?t[i++]:r[l++]:i<n?t[i++]:r[l++];return e},JO=WO,QO=Dr,ZO=l,$O=T,XO=b,eT=F,tT=KO,rT=pi,aT=ml,nT=XS,oT=Ii,iT=zi,lT=ni,cT=_l,sT=D,uT=et,dT=$t,pT=jn,fT=nr,mT=ae,hT=go,vT=un,yT=U,gT=Qn,bT=Kn,kT=rc,CT=JO,_T=mt("iterator"),NT="URLSearchParams",PT=NT+"Iterator",wT=lT.set,ST=lT.getterFor(NT),xT=lT.getterFor(PT),ET=Object.getOwnPropertyDescriptor,AT=function(e){if(!eT)return ZO[e];var t=ET(ZO,e);return t&&t.value},DT=AT("fetch"),IT=AT("Request"),FT=AT("Headers"),RT=IT&&IT.prototype,OT=FT&&FT.prototype,TT=ZO.RegExp,BT=ZO.TypeError,jT=ZO.decodeURIComponent,zT=ZO.encodeURIComponent,MT=XO("".charAt),LT=XO([].join),VT=XO([].push),UT=XO("".replace),KT=XO([].shift),HT=XO([].splice),qT=XO("".split),WT=XO("".slice),YT=/\+/g,GT=Array(4),JT=function(e){return GT[e-1]||(GT[e-1]=TT("((?:%[\\da-f]{2}){"+e+"})","gi"))},QT=function(e){try{return jT(e)}catch(t){return e}},ZT=function(e){var t=UT(e,YT," "),r=4;try{return jT(t)}catch(e){for(;r;)t=UT(t,JT(r--),QT);return t}},$T=/[!'()~]|%20/g,XT={"!":"%21","'":"%27","(":"%28",")":"%29","~":"%7E","%20":"+"},eB=function(e){return XT[e]},tB=function(e){return UT(zT(e),$T,eB)},rB=iT((function(e,t){wT(this,{type:PT,iterator:gT(ST(e).entries),kind:t})}),"Iterator",(function(){var e=xT(this),t=e.kind,r=e.iterator.next(),a=r.value;return r.done||(r.value="keys"===t?a.key:"values"===t?a.value:[a.key,a.value]),r}),!0),aB=function(e){this.entries=[],this.url=null,void 0!==e&&(mT(e)?this.parseObject(e):this.parseQuery("string"==typeof e?"?"===MT(e,0)?WT(e,1):e:hT(e)))};aB.prototype={type:NT,bindURL:function(e){this.url=e,this.update()},parseObject:function(e){var t,r,a,n,o,i,l,c=bT(e);if(c)for(r=(t=gT(e,c)).next;!(a=$O(r,t)).done;){if(o=(n=gT(fT(a.value))).next,(i=$O(o,n)).done||(l=$O(o,n)).done||!$O(o,n).done)throw BT("Expected sequence with length 2");VT(this.entries,{key:hT(i.value),value:hT(l.value)})}else for(var s in e)uT(e,s)&&VT(this.entries,{key:s,value:hT(e[s])})},parseQuery:function(e){if(e)for(var t,r,a=qT(e,"&"),n=0;n<a.length;)(t=a[n++]).length&&(r=qT(t,"="),VT(this.entries,{key:ZT(KT(r)),value:ZT(LT(r,"="))}))},serialize:function(){for(var e,t=this.entries,r=[],a=0;a<t.length;)e=t[a++],VT(r,tB(e.key)+"="+tB(e.value));return LT(r,"&")},update:function(){this.entries.length=0,this.parseQuery(this.url.query)},updateURL:function(){this.url&&this.url.update()}};var nB=function(){cT(this,oB);var e=wT(this,new aB(arguments.length>0?arguments[0]:void 0));eT||(this.length=e.entries.length)},oB=nB.prototype;if(nT(oB,{append:function(e,t){kT(arguments.length,2);var r=ST(this);VT(r.entries,{key:hT(e),value:hT(t)}),eT||this.length++,r.updateURL()},delete:function(e){kT(arguments.length,1);for(var t=ST(this),r=t.entries,a=hT(e),n=0;n<r.length;)r[n].key===a?HT(r,n,1):n++;eT||(this.length=r.length),t.updateURL()},get:function(e){kT(arguments.length,1);for(var t=ST(this).entries,r=hT(e),a=0;a<t.length;a++)if(t[a].key===r)return t[a].value;return null},getAll:function(e){kT(arguments.length,1);for(var t=ST(this).entries,r=hT(e),a=[],n=0;n<t.length;n++)t[n].key===r&&VT(a,t[n].value);return a},has:function(e){kT(arguments.length,1);for(var t=ST(this).entries,r=hT(e),a=0;a<t.length;)if(t[a++].key===r)return!0;return!1},set:function(e,t){kT(arguments.length,1);for(var r,a=ST(this),n=a.entries,o=!1,i=hT(e),l=hT(t),c=0;c<n.length;c++)(r=n[c]).key===i&&(o?HT(n,c--,1):(o=!0,r.value=l));o||VT(n,{key:i,value:l}),eT||(this.length=n.length),a.updateURL()},sort:function(){var e=ST(this);CT(e.entries,(function(e,t){return e.key>t.key?1:-1})),e.updateURL()},forEach:function(e){for(var t,r=ST(this).entries,a=dT(e,arguments.length>1?arguments[1]:void 0),n=0;n<r.length;)a((t=r[n++]).value,t.key,this)},keys:function(){return new rB(this,"keys")},values:function(){return new rB(this,"values")},entries:function(){return new rB(this,"entries")}},{enumerable:!0}),rT(oB,_T,oB.entries,{name:"entries"}),rT(oB,"toString",(function(){return ST(this).serialize()}),{enumerable:!0}),eT&&aT(oB,"size",{get:function(){return ST(this).entries.length},configurable:!0,enumerable:!0}),oT(nB,NT),QO({global:!0,constructor:!0,forced:!tT},{URLSearchParams:nB}),!tT&&sT(FT)){var iB=XO(OT.has),lB=XO(OT.set),cB=function(e){if(mT(e)){var t,r=e.body;if(pT(r)===NT)return t=e.headers?new FT(e.headers):new FT,iB(t,"content-type")||lB(t,"content-type","application/x-www-form-urlencoded;charset=UTF-8"),vT(e,{body:yT(0,hT(r)),headers:yT(0,t)})}return e};if(sT(DT)&&QO({global:!0,enumerable:!0,dontCallGetSet:!0,forced:!0},{fetch:function(e){return DT(e,arguments.length>1?cB(arguments[1]):{})}}),sT(IT)){var sB=function(e){return cT(this,RT),new IT(e,arguments.length>1?cB(arguments[1]):{})};RT.constructor=sB,sB.prototype=RT,QO({global:!0,constructor:!0,dontCallGetSet:!0,forced:!0},{Request:sB})}}var uB={URLSearchParams:nB,getState:ST},dB=ne.URLSearchParams;!function(e){e.exports=dB}(LO);var pB=t(MO),fB={},mB={get exports(){return fB},set exports(e){fB=e}};!function(e){e.exports=kv}(mB);var hB=t(fB),vB=void 0!==fO&&fO||"undefined"!=typeof self&&self||void 0!==vB&&vB,yB={searchParams:"URLSearchParams"in vB,iterable:"Symbol"in vB&&"iterator"in vO,blob:"FileReader"in vB&&"Blob"in vB&&function(){try{return new Blob,!0}catch(e){return!1}}(),formData:"FormData"in vB,arrayBuffer:"ArrayBuffer"in vB};if(yB.arrayBuffer)var gB=["[object Int8Array]","[object Uint8Array]","[object Uint8ClampedArray]","[object Int16Array]","[object Uint16Array]","[object Int32Array]","[object Uint32Array]","[object Float32Array]","[object Float64Array]"],bB=ArrayBuffer.isView||function(e){return e&&hC(gB).call(gB,Object.prototype.toString.call(e))>-1};function kB(e){if("string"!=typeof e&&(e=String(e)),/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(e)||""===e)throw new TypeError('Invalid character in header field name: "'+e+'"');return e.toLowerCase()}function CB(e){return"string"!=typeof e&&(e=String(e)),e}function _B(e){var t={next:function(){var t=e.shift();return{done:void 0===t,value:t}}};return yB.iterable&&(t[bO]=function(){return t}),t}function NB(e){if(this.map={},e instanceof NB)Jg(e).call(e,(function(e,t){this.append(t,e)}),this);else if(gw(e))Jg(e).call(e,(function(e){this.append(e[0],e[1])}),this);else if(e){var t;Jg(t=xO(e)).call(t,(function(t){this.append(t,e[t])}),this)}}function PB(e){if(e.bodyUsed)return ok.reject(new TypeError("Already read"));e.bodyUsed=!0}function wB(e){return new ok((function(t,r){e.onload=function(){t(e.result)},e.onerror=function(){r(e.error)}}))}function SB(e){var t=new FileReader,r=wB(t);return t.readAsArrayBuffer(e),r}function xB(e){if(OA(e))return OA(e).call(e,0);var t=new Uint8Array(e.byteLength);return t.set(new Uint8Array(e)),t.buffer}function EB(){return this.bodyUsed=!1,this._initBody=function(e){var t;this.bodyUsed=this.bodyUsed,this._bodyInit=e,e?"string"==typeof e?this._bodyText=e:yB.blob&&Blob.prototype.isPrototypeOf(e)?this._bodyBlob=e:yB.formData&&FormData.prototype.isPrototypeOf(e)?this._bodyFormData=e:yB.searchParams&&pB.prototype.isPrototypeOf(e)?this._bodyText=e.toString():yB.arrayBuffer&&yB.blob&&((t=e)&&DataView.prototype.isPrototypeOf(t))?(this._bodyArrayBuffer=xB(e.buffer),this._bodyInit=new Blob([this._bodyArrayBuffer])):yB.arrayBuffer&&(ArrayBuffer.prototype.isPrototypeOf(e)||bB(e))?this._bodyArrayBuffer=xB(e):this._bodyText=e=Object.prototype.toString.call(e):this._bodyText="",this.headers.get("content-type")||("string"==typeof e?this.headers.set("content-type","text/plain;charset=UTF-8"):this._bodyBlob&&this._bodyBlob.type?this.headers.set("content-type",this._bodyBlob.type):yB.searchParams&&pB.prototype.isPrototypeOf(e)&&this.headers.set("content-type","application/x-www-form-urlencoded;charset=UTF-8"))},yB.blob&&(this.blob=function(){var e=PB(this);if(e)return e;if(this._bodyBlob)return ok.resolve(this._bodyBlob);if(this._bodyArrayBuffer)return ok.resolve(new Blob([this._bodyArrayBuffer]));if(this._bodyFormData)throw new Error("could not read FormData body as blob");return ok.resolve(new Blob([this._bodyText]))},this.arrayBuffer=function(){if(this._bodyArrayBuffer){var e,t=PB(this);return t||(ArrayBuffer.isView(this._bodyArrayBuffer)?ok.resolve(OA(e=this._bodyArrayBuffer.buffer).call(e,this._bodyArrayBuffer.byteOffset,this._bodyArrayBuffer.byteOffset+this._bodyArrayBuffer.byteLength)):ok.resolve(this._bodyArrayBuffer))}return this.blob().then(SB)}),this.text=function(){var e=PB(this);if(e)return e;if(this._bodyBlob)return function(e){var t=new FileReader,r=wB(t);return t.readAsText(e),r}(this._bodyBlob);if(this._bodyArrayBuffer)return ok.resolve(function(e){for(var t=new Uint8Array(e),r=new Array(t.length),a=0;a<t.length;a++)r[a]=String.fromCharCode(t[a]);return r.join("")}(this._bodyArrayBuffer));if(this._bodyFormData)throw new Error("could not read FormData body as text");return ok.resolve(this._bodyText)},yB.formData&&(this.formData=function(){return this.text().then(IB)}),this.json=function(){return this.text().then(JSON.parse)},this}NB.prototype.append=function(e,t){e=kB(e),t=CB(t);var r=QC(this)[e];QC(this)[e]=r?r+", "+t:t},NB.prototype.delete=function(e){delete QC(this)[kB(e)]},NB.prototype.get=function(e){return e=kB(e),this.has(e)?QC(this)[e]:null},NB.prototype.has=function(e){return QC(this).hasOwnProperty(kB(e))},NB.prototype.set=function(e,t){QC(this)[kB(e)]=CB(t)},NB.prototype.forEach=function(e,t){for(var r in QC(this))QC(this).hasOwnProperty(r)&&e.call(t,QC(this)[r],r,this)},NB.prototype.keys=function(){var e=[];return Jg(this).call(this,(function(t,r){e.push(r)})),_B(e)},NB.prototype.values=function(){var e=[];return Jg(this).call(this,(function(t){e.push(t)})),_B(e)},NB.prototype.entries=function(){var e=[];return Jg(this).call(this,(function(t,r){e.push([r,t])})),_B(e)},yB.iterable&&(NB.prototype[bO]=zO(NB.prototype));var AB=["DELETE","GET","HEAD","OPTIONS","POST","PUT"];function DB(e,t){if(!(this instanceof DB))throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');var r=(t=t||{}).body;if(e instanceof DB){if(e.bodyUsed)throw new TypeError("Already read");this.url=e.url,this.credentials=e.credentials,t.headers||(this.headers=new NB(e.headers)),this.method=e.method,this.mode=e.mode,this.signal=e.signal,r||null==e._bodyInit||(r=e._bodyInit,e.bodyUsed=!0)}else this.url=String(e);if(this.credentials=t.credentials||this.credentials||"same-origin",!t.headers&&this.headers||(this.headers=new NB(t.headers)),this.method=function(e){var t=e.toUpperCase();return hC(AB).call(AB,t)>-1?t:e}(t.method||this.method||"GET"),this.mode=t.mode||this.mode||null,this.signal=t.signal||this.signal,this.referrer=null,("GET"===this.method||"HEAD"===this.method)&&r)throw new TypeError("Body not allowed for GET or HEAD requests");if(this._initBody(r),!("GET"!==this.method&&"HEAD"!==this.method||"no-store"!==t.cache&&"no-cache"!==t.cache)){var a=/([?&])_=[^&]*/;if(a.test(this.url))this.url=this.url.replace(a,"$1_="+(new Date).getTime());else{this.url+=(/\?/.test(this.url)?"&":"?")+"_="+(new Date).getTime()}}}function IB(e){var t,r=new FormData;return Jg(t=OI(e).call(e).split("&")).call(t,(function(e){if(e){var t=e.split("="),a=t.shift().replace(/\+/g," "),n=t.join("=").replace(/\+/g," ");r.append(decodeURIComponent(a),decodeURIComponent(n))}})),r}function FB(e,t){if(!(this instanceof FB))throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');t||(t={}),this.type="default",this.status=void 0===t.status?200:t.status,this.ok=this.status>=200&&this.status<300,this.statusText=void 0===t.statusText?"":""+t.statusText,this.headers=new NB(t.headers),this.url=t.url||"",this._initBody(e)}DB.prototype.clone=function(){return new DB(this,{body:this._bodyInit})},EB.call(DB.prototype),EB.call(FB.prototype),FB.prototype.clone=function(){return new FB(this._bodyInit,{status:this.status,statusText:this.statusText,headers:new NB(this.headers),url:this.url})},FB.error=function(){var e=new FB(null,{status:0,statusText:""});return e.type="error",e};var RB=[301,302,303,307,308];FB.redirect=function(e,t){if(-1===hC(RB).call(RB,t))throw new RangeError("Invalid status code");return new FB(null,{status:t,headers:{location:e}})};var OB=vB.DOMException;try{new OB}catch(e){OB=function(e,t){this.message=e,this.name=t;var r=Error(e);this.stack=r.stack},OB.prototype=hB(Error.prototype),OB.prototype.constructor=OB}function TB(e,t){return new ok((function(r,a){var n=new DB(e,t);if(n.signal&&n.signal.aborted)return a(new OB("Aborted","AbortError"));var o,i,l,c=new XMLHttpRequest;function s(){c.abort()}(c.onload=function(){var e,t,a,n,o,i={status:c.status,statusText:c.statusText,headers:(e=c.getAllResponseHeaders()||"",n=new NB,o=e.replace(/\r?\n[\t ]+/g," "),Jg(t=QC(a=o.split("\r")).call(a,(function(e){return 0===hC(e).call(e,"\n")?e.substr(1,e.length):e}))).call(t,(function(e){var t,r=e.split(":"),a=OI(t=r.shift()).call(t);if(a){var o,i=OI(o=r.join(":")).call(o);n.append(a,i)}})),n)};i.url="responseURL"in c?c.responseURL:i.headers.get("X-Request-URL");var l="response"in c?c.response:c.responseText;hw((function(){r(new FB(l,i))}),0)},c.onerror=function(){hw((function(){a(new TypeError("Network request failed"))}),0)},c.ontimeout=function(){hw((function(){a(new TypeError("Network request failed"))}),0)},c.onabort=function(){hw((function(){a(new OB("Aborted","AbortError"))}),0)},c.open(n.method,function(e){try{return""===e&&vB.location.href?vB.location.href:e}catch(t){return e}}(n.url),!0),"include"===n.credentials?c.withCredentials=!0:"omit"===n.credentials&&(c.withCredentials=!1),"responseType"in c)&&(yB.blob?c.responseType="blob":yB.arrayBuffer&&n.headers.get("Content-Type")&&-1!==hC(o=n.headers.get("Content-Type")).call(o,"application/octet-stream")&&(c.responseType="arraybuffer"));!t||"object"!==Tg(t.headers)||t.headers instanceof NB?Jg(i=n.headers).call(i,(function(e,t){c.setRequestHeader(t,e)})):Jg(l=xO(t.headers)).call(l,(function(e){c.setRequestHeader(e,CB(t.headers[e]))}));n.signal&&(n.signal.addEventListener("abort",s),c.onreadystatechange=function(){4===c.readyState&&n.signal.removeEventListener("abort",s)}),c.send(void 0===n._bodyInit?null:n._bodyInit)}))}TB.polyfill=!0,vB.fetch||(vB.fetch=TB,vB.Headers=NB,vB.Request=DB,vB.Response=FB);var BB="undefined"!=typeof window&&"fetch"in window?window.fetch:TB;function jB(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function zB(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=jB(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=jB(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}function MB(e){return e&&e.errorCode&&e.errorType&&e.message&&e.status}function LB(e,t){var r,a=e.headers,n=void 0===a?[]:a,o=e.errorLevel,i=void 0===o?"warn":o,l=e.loadingContext,c=void 0===l?HP:l,s=e.method,u=void 0===s?"GET":s,d=e.path,p=zB({method:u,mode:"cors",cache:"default",credentials:"same-origin",headers:zB({Accept:"application/json, text/plain, */*","Content-Type":"POST"===u?"application/json":"text/plain"},n),redirect:"follow",referrerPolicy:"no-referrer-when-downgrade"},t&&{body:gA(t)}),f=Bb(r="".concat(c)).call(r,d);return BB(f,p).then(function(){var t=$d(Ky.mark((function t(r){var a;return Ky.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return t.next=2,r.json();case 2:if(a=t.sent,!r.ok){t.next=5;break}return t.abrupt("return",a);case 5:if(!MB(a)){t.next=8;break}return VB(a.message,i),t.abrupt("return");case 8:return VB(e.errorMessage||"Service at ".concat(f," is not available"),i),t.abrupt("return");case 11:case"end":return t.stop()}}),t)})));return function(e){return t.apply(this,arguments)}}()).catch((function(t){var r;if(t instanceof iA)throw t;VB(e.errorMessage||Bb(r="Call to ".concat(f," failed. Error= ")).call(r,t),i)}))}function VB(e,t){switch(t){case"silent":break;case"info":case"warn":case"error":console[t](e);break;default:throw new iA("NETWORK_ERROR",e)}}function UB(e,t){return LB(zB(zB({},e),{},{method:"POST"}),t)}function KB(e,t,r){var a;return function(e,t){return LB(zB(zB({},e),{},{method:"GET"}),t)}({loadingContext:t,errorLevel:"warn",errorMessage:"Dataset ".concat(e," is not available"),path:r?Bb(a="datasets/".concat(e,"/")).call(a,r,".json"):"datasets/".concat(e,".json")})}function HB(e){var t=e.classNameModifiers,r=e.label,a=e.onDropdownChange,n=e.readOnly,o=e.selectedCountry,i=e.specifications,l=e.value,c=$w(),s=c.i18n,u=c.loadingContext,d=c.commonProps.isCollatingErrors,p=tC(Bw([]),2),f=p[0],m=p[1],h=tC(Bw(!1),2),v=h[0],y=h[1],g=i.getPlaceholderKeyForField("stateOrProvince",o);return Mw((function(){if(!o||!i.countryHasDataset(o))return m([]),void y(!0);KB("states/".concat(o),u,s.locale).then((function(e){var t=e&&e.length?e:[];m(t),y(!0)})).catch((function(){m([]),y(!0)}))}),[o]),v&&f.length?JN(kI,{label:r,classNameModifiers:t,errorMessage:e.errorMessage,isValid:!!l,showValidIcon:!1,name:"stateOrProvince",isCollatingErrors:d,i18n:s},NF("select",{name:"stateOrProvince",onChange:a,selected:l,placeholder:s.get(g),items:f,readonly:n&&!!l,isCollatingErrors:d})):null}function qB(e){var t=e.allowedCountries,r=void 0===t?[]:t,a=e.classNameModifiers,n=void 0===a?[]:a,o=e.errorMessage,i=e.onDropdownChange,l=e.value,c=$w(),s=c.i18n,u=c.loadingContext,d=c.commonProps.isCollatingErrors,p=tC(Bw([]),2),f=p[0],m=p[1],h=tC(Bw(!1),2),v=h[0],y=h[1],g=tC(Bw(e.readOnly),2),b=g[0],k=g[1];return Mw((function(){KB("countries",u,s.locale).then((function(e){var t=r.length?nb(e).call(e,(function(e){return Eb(r).call(r,e.id)})):e;m(t||[]),k(1===t.length||b),y(!0)})).catch((function(e){console.error(e),m([]),y(!0)}))}),[]),v?JN(kI,{name:"country",label:s.get("country"),errorMessage:o,classNameModifiers:n,isValid:!!l,showValidIcon:!1,isCollatingErrors:d,i18n:s},NF("select",{onChange:i,name:"country",placeholder:s.get("select.country"),selected:l,items:f,readonly:b&&!!l,isCollatingErrors:d})):null}function WB(e){var t,r=$w(),a=r.i18n,n=r.commonProps.isCollatingErrors,o=e.classNameModifiers,i=void 0===o?[]:o,l=e.data,c=e.errors,s=e.valid,u=e.fieldName,d=e.onInput,p=e.onBlur,f=e.trimOnBlur,m=e.maxlength,h=e.disabled,v=l[u],y=l.country,g=e.specifications.countryHasOptionalField(y,u),b=e.specifications.getKeyForField(u,y),k=g?" ".concat(a.get("field.title.optional")):"",C=Bb(t="".concat(a.get(b))).call(t,k),_=function(e,t,r){var a,n;if("object"===Tg(null===(a=e[t])||void 0===a?void 0:a.errorMessage)){var o=e[t].errorMessage,i=o.translationKey,l=o.translationObject;return r.get(i,l)}return r.get(null===(n=e[t])||void 0===n?void 0:n.errorMessage)||!!e[t]}(c,u,a);switch(u){case"country":return JN(qB,{allowedCountries:e.allowedCountries,classNameModifiers:i,label:C,errorMessage:_,onDropdownChange:e.onDropdownChange,value:v});case"stateOrProvince":return JN(HB,{classNameModifiers:i,label:C,errorMessage:_,onDropdownChange:e.onDropdownChange,selectedCountry:y,specifications:e.specifications,value:v});default:return JN(kI,{label:C,classNameModifiers:i,errorMessage:_,isValid:s[u],name:u,isCollatingErrors:n,i18n:a},NF("text",{classNameModifiers:i,name:u,value:v,onInput:d,onBlur:p,isCollatingErrors:n,maxlength:m,trimOnBlur:f,disabled:h}))}}var YB={},GB={get exports(){return YB},set exports(e){YB=e}},JB=cp,QB=da,ZB=up,$B=$t,XB=function(e,t,r,a,n,o,i,l){for(var c,s,u=n,d=0,p=!!i&&$B(i,l);d<a;)d in r&&(c=p?p(r[d],d,t):r[d],o>0&&JB(c)?(s=QB(c),u=XB(e,t,c,s,u,o-1)-1):(ZB(u+1),e[u]=c),u++),d++;return u},ej=XB,tj=Ze,rj=da,aj=aa,nj=Cp;Dr({target:"Array",proto:!0},{flat:function(){var e=arguments.length?arguments[0]:void 0,t=tj(this),r=rj(t),a=nj(t,0);return a.length=ej(a,t,t,r,0,void 0===e?1:aj(e)),a}});var oj=Vv("Array").flat,ij=ue,lj=oj,cj=Array.prototype,sj=function(e){var t=e.flat;return e===cj||ij(cj,e)&&t===cj.flat?lj:t};!function(e){e.exports=sj}(GB);var uj=t(YB);function dj(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function pj(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=dj(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=dj(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}var fj=function(){function e(t){Bg(this,e),Wg(this,"specifications",void 0),this.specifications=pj(pj({},bR),t)}return qg(e,[{key:"countryHasDataset",value:function(e){var t,r;return!(null===(t=this.specifications)||void 0===t||null===(r=t[e])||void 0===r||!r.hasDataset)}},{key:"countryHasOptionalField",value:function(e,t){var r,a,n;return!(null===(r=this.specifications)||void 0===r||null===(a=r[e])||void 0===a||null===(n=a.optionalFields)||void 0===n||!Eb(n).call(n,t))}},{key:"getAddressSchemaForCountry",value:function(e){var t,r;return(null===(t=this.specifications)||void 0===t||null===(r=t[e])||void 0===r?void 0:r.schema)||this.specifications.default.schema}},{key:"getAddressLabelsForCountry",value:function(e){var t,r;return(null===(t=this.specifications)||void 0===t||null===(r=t[e])||void 0===r?void 0:r.labels)||this.specifications.default.labels}},{key:"getOptionalFieldsForCountry",value:function(e){var t,r,a;return(null===(t=this.specifications)||void 0===t||null===(r=t[e])||void 0===r?void 0:r.optionalFields)||(null===(a=this.specifications.default)||void 0===a?void 0:a.optionalFields)||[]}},{key:"getKeyForField",value:function(e,t){var r,a,n,o,i,l;return(null===(r=this.specifications)||void 0===r||null===(a=r[t])||void 0===a||null===(n=a.labels)||void 0===n?void 0:n[e])||(null===(o=this.specifications)||void 0===o||null===(i=o.default)||void 0===i||null===(l=i.labels)||void 0===l?void 0:l[e])||e}},{key:"getPlaceholderKeyForField",value:function(e,t){var r,a,n,o,i,l;return(null===(r=this.specifications)||void 0===r||null===(a=r[t])||void 0===a||null===(n=a.placeholders)||void 0===n?void 0:n[e])||(null===(o=this.specifications)||void 0===o||null===(i=o.default)||void 0===i||null===(l=i.placeholders)||void 0===l?void 0:l[e])}},{key:"getAddressSchemaForCountryFlat",value:function(e){var t,r;return nb(t=uj(r=this.getAddressSchemaForCountry(e)).call(r,2)).call(t,(function(e){return"string"==typeof e}))}}]),e}();function mj(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function hj(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=mj(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=mj(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}function vj(e){var t;$w().i18n;var r,a=e.label,n=void 0===a?"":a,o=e.requiredFields,i=e.visibility,l=e.iOSFocusedField,c=void 0===l?null:l,s=Lw({});Jy(s.current).length||(null===(r=e.setComponentRef)||void 0===r||r.call(e,s.current));var u=Vw((function(){return new fj(e.specifications)}),[e.specifications]),d=nb(t=u.getAddressSchemaForCountryFlat(e.countryCode)).call(t,(function(e){return Eb(o).call(o,e)})),p=QF({schema:d,defaultData:e.data,rules:e.validationRules||nO(u),formatters:$R}),f=p.data,m=p.errors,h=p.valid,v=p.isValid,y=p.handleChangeFor,g=p.triggerValidation;s.current.showValidation=function(){g()};var b=nb(d).call(d,(function(e){return!c||e===c}));if(zw((function(){var e=u.countryHasDataset(f.country)?"":dR,t=hj(hj({},f),{},{stateOrProvince:e});Jg(o).call(o,(function(e){var r;y(e,"input")(null!==(r=t[e])&&void 0!==r?r:"")})),t.postalCode&&y("postalCode","blur")(f.postalCode)}),[f.country]),zw((function(){var e=Eb(o).call(o,"stateOrProvince"),t=f.country&&u.countryHasDataset(f.country),r=e&&t,a=f.stateOrProvince||(r?"":dR);y("stateOrProvince","input")(a)}),[]),zw((function(){var t=u.getOptionalFieldsForCountry(f.country),r=DC(pR).call(pR,(function(r,a){var n=Eb(t).call(t,a),i=Eb(o).call(o,a),l=f[a],c=e.data[a],s=n&&!l||!i?i||l||!c?dR:c:l;return null!=s&&s.length&&(r[a]=s),r}),{});e.onChange({data:r,valid:h,errors:m,isValid:v})}),[f,h,m,v]),"hidden"===i)return null;if("readOnly"===i)return JN(_R,{data:f,label:n});var k=function(t,r){var a,n=r.classNameModifiers,i=void 0===n?[]:n;return Eb(o).call(o,t)?JN(WB,{key:t,allowedCountries:e.allowedCountries,classNameModifiers:Bb(a=[]).call(a,rC(i),[t]),data:f,errors:m,valid:h,fieldName:t,onInput:y(t,"input"),onBlur:y(t,"blur"),onDropdownChange:y(t,"blur"),specifications:u,maxlength:qR(XR,t,f.country,!0),trimOnBlur:!0,disabled:!Eb(b).call(b,t)}):null},C=u.getAddressSchemaForCountry(f.country);return JN(ZN,null,JN(hD,{classNameModifiers:[n],label:n},QC(C).call(C,(function(e){return e instanceof Array?JN("div",{className:"adyen-checkout__field-group"},QC(t=e).call(t,(function(e){var t=tC(e,2),r=t[0],a=t[1];return k(r,{classNameModifiers:["col-".concat(a)]})}))):k(e,{});var t}))),!1)}vj.defaultProps={countryCode:null,validationRules:null,data:{},onChange:function(){},visibility:"editable",requiredFields:pR,specifications:{}};var yj=["errorMessage","label","onChange","i18n"];function gj(e){var t,r,a,n=e.errorMessage,o=e.label,i=e.onChange,l=e.i18n,c=KP(e,yj);return JN(kI,{classNameModifiers:["consentCheckbox"],errorMessage:n,i18n:l},JN(dF,{name:"consentCheckbox",classNameModifiers:Bb(t=[]).call(t,rC(null!==(r=c.classNameModifiers)&&void 0!==r?r:c.classNameModifiers=[]),["consentCheckbox"]),onInput:i,value:null==c||null===(a=c.data)||void 0===a?void 0:a.consentCheckbox,label:o,checked:c.checked}))}var bj=["companyDetails","personalDetails","billingAddress","deliveryAddress","bankAccount"],kj=function(e,t){var r,a;return DC(r=nb(a=Jy(t)).call(a,(function(t){return e[t]}))).call(r,(function(e,r){return e[r]=t[r],e}),{})},Cj=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};return DC(bj).call(bj,(function(r,a){var n="hidden"!==e[a],o="deliveryAddress"===a,i="hidden"===(null==e?void 0:e.billingAddress);return r[a]=n&&(!o||i||function(){return Jy(arguments.length>0&&void 0!==arguments[0]?arguments[0]:{}).length>1}(t[a])),r}),{})},_j={AD:{length:24,structure:"F04F04A12",example:"AD9912345678901234567890"},AE:{length:23,structure:"F03F16",example:"AE993331234567890123456"},AL:{length:28,structure:"F08A16",example:"AL47212110090000000235698741"},AT:{length:20,structure:"F05F11",example:"AT611904300234573201"},AZ:{length:28,structure:"U04A20",example:"AZ21NABZ00000000137010001944"},BA:{length:20,structure:"F03F03F08F02",example:"BA391290079401028494"},BE:{length:16,structure:"F03F07F02",example:"BE68 5390 0754 7034"},BG:{length:22,structure:"U04F04F02A08",example:"BG80BNBG96611020345678"},BH:{length:22,structure:"U04A14",example:"BH67BMAG00001299123456"},BR:{length:29,structure:"F08F05F10U01A01",example:"BR9700360305000010009795493P1"},CH:{length:21,structure:"F05A12",example:"CH9300762011623852957"},CR:{length:22,structure:"F04F14",example:"CR72012300000171549015"},CY:{length:28,structure:"F03F05A16",example:"CY17002001280000001200527600"},CZ:{length:24,structure:"F04F06F10",example:"CZ6508000000192000145399"},DE:{length:22,structure:"F08F10",example:"DE00123456789012345678"},DK:{length:18,structure:"F04F09F01",example:"DK5000400440116243"},DO:{length:28,structure:"U04F20",example:"DO28BAGR00000001212453611324"},EE:{length:20,structure:"F02F02F11F01",example:"EE382200221020145685"},ES:{length:24,structure:"F04F04F01F01F10",example:"ES9121000418450200051332"},FI:{length:18,structure:"F06F07F01",example:"FI2112345600000785"},FO:{length:18,structure:"F04F09F01",example:"FO6264600001631634"},FR:{length:27,structure:"F05F05A11F02",example:"FR1420041010050500013M02606"},GB:{length:22,structure:"U04F06F08",example:"GB29NWBK60161331926819"},GE:{length:22,structure:"U02F16",example:"GE29NB0000000101904917"},GI:{length:23,structure:"U04A15",example:"GI75NWBK000000007099453"},GL:{length:18,structure:"F04F09F01",example:"GL8964710001000206"},GR:{length:27,structure:"F03F04A16",example:"GR1601101250000000012300695"},GT:{length:28,structure:"A04A20",example:"GT82TRAJ01020000001210029690"},HR:{length:21,structure:"F07F10",example:"HR1210010051863000160"},HU:{length:28,structure:"F03F04F01F15F01",example:"HU42117730161111101800000000"},IE:{length:22,structure:"U04F06F08",example:"IE29AIBK93115212345678"},IL:{length:23,structure:"F03F03F13",example:"IL620108000000099999999"},IS:{length:26,structure:"F04F02F06F10",example:"IS140159260076545510730339"},IT:{length:27,structure:"U01F05F05A12",example:"IT60X0542811101000000123456"},KW:{length:30,structure:"U04A22",example:"KW81CBKU0000000000001234560101"},KZ:{length:20,structure:"F03A13",example:"KZ86125KZT5004100100"},LB:{length:28,structure:"F04A20",example:"LB62099900000001001901229114"},LC:{length:32,structure:"U04F24",example:"LC07HEMM000100010012001200013015"},LI:{length:21,structure:"F05A12",example:"LI21088100002324013AA"},LT:{length:20,structure:"F05F11",example:"LT121000011101001000"},LU:{length:20,structure:"F03A13",example:"LU280019400644750000"},LV:{length:21,structure:"U04A13",example:"LV80BANK0000435195001"},MC:{length:27,structure:"F05F05A11F02",example:"MC5811222000010123456789030"},MD:{length:24,structure:"U02A18",example:"MD24AG000225100013104168"},ME:{length:22,structure:"F03F13F02",example:"ME25505000012345678951"},MK:{length:19,structure:"F03A10F02",example:"MK07250120000058984"},MR:{length:27,structure:"F05F05F11F02",example:"MR1300020001010000123456753"},MT:{length:31,structure:"U04F05A18",example:"MT84MALT011000012345MTLCAST001S"},MU:{length:30,structure:"U04F02F02F12F03U03",example:"MU17BOMM0101101030300200000MUR"},NL:{length:18,structure:"U04F10",example:"NL99BANK0123456789"},NO:{length:15,structure:"F04F06F01",example:"NO9386011117947"},PK:{length:24,structure:"U04A16",example:"PK36SCBL0000001123456702"},PL:{length:28,structure:"F08F16",example:"PL00123456780912345678901234"},PS:{length:29,structure:"U04A21",example:"PS92PALS000000000400123456702"},PT:{length:25,structure:"F04F04F11F02",example:"PT50000201231234567890154"},RO:{length:24,structure:"U04A16",example:"RO49AAAA1B31007593840000"},RS:{length:22,structure:"F03F13F02",example:"RS35260005601001611379"},SA:{length:24,structure:"F02A18",example:"SA0380000000608010167519"},SE:{length:24,structure:"F03F16F01",example:"SE4550000000058398257466"},SI:{length:19,structure:"F05F08F02",example:"SI56263300012039086"},SK:{length:24,structure:"F04F06F10",example:"SK3112000000198742637541"},SM:{length:27,structure:"U01F05F05A12",example:"SM86U0322509800000000270100"},ST:{length:25,structure:"F08F11F02",example:"ST68000100010051845310112"},TL:{length:23,structure:"F03F14F02",example:"TL380080012345678910157"},TN:{length:24,structure:"F02F03F13F02",example:"TN5910006035183598478831"},TR:{length:26,structure:"F05F01A16",example:"TR330006100519786457841326"},VG:{length:24,structure:"U04F16",example:"VG96VPVG0000012345678901"},XK:{length:20,structure:"F04F10F02",example:"XK051212012345678906"},AO:{length:25,structure:"F21",example:"AO69123456789012345678901"},BF:{length:27,structure:"F23",example:"BF2312345678901234567890123"},BI:{length:16,structure:"F12",example:"BI41123456789012"},BJ:{length:28,structure:"F24",example:"BJ39123456789012345678901234"},CI:{length:28,structure:"U01F23",example:"CI17A12345678901234567890123"},CM:{length:27,structure:"F23",example:"CM9012345678901234567890123"},CV:{length:25,structure:"F21",example:"CV30123456789012345678901"},DZ:{length:24,structure:"F20",example:"DZ8612345678901234567890"},IR:{length:26,structure:"F22",example:"IR861234568790123456789012"},JO:{length:30,structure:"A04F22",example:"JO15AAAA1234567890123456789012"},MG:{length:27,structure:"F23",example:"MG1812345678901234567890123"},ML:{length:28,structure:"U01F23",example:"ML15A12345678901234567890123"},MZ:{length:25,structure:"F21",example:"MZ25123456789012345678901"},QA:{length:29,structure:"U04A21",example:"QA30AAAA123456789012345678901"},SN:{length:28,structure:"U01F23",example:"SN52A12345678901234567890123"},UA:{length:29,structure:"F25",example:"UA511234567890123456789012345"}},Nj=function(e){var t;return OI(t=e.replace(/\W/gi,"").replace(/(.{4})(?!$)/g,"$1 ")).call(t)},Pj=function(e){return e.replace(/[^a-zA-Z0-9]/g,"").toUpperCase()},wj=function(e,t){return function(e,t){var r;if(null===t||!_j[t]||!_j[t].structure)return!1;var a=_j[t].structure,n=QC(r=a.match(/(.{3})/g)).call(r,(function(e){var t,r,a=OA(e).call(e,0,1),n=O_(OA(e).call(e,1),10);switch(a){case"A":r="0-9A-Za-z";break;case"B":r="0-9A-Z";break;case"C":r="A-Za-z";break;case"F":r="0-9";break;case"L":r="a-z";break;case"U":r="A-Z";break;case"W":r="0-9a-z"}return Bb(t="([".concat(r,"]{")).call(t,n,"})")}));return new RegExp("^".concat(n.join(""),"$"))}(0,t)},Sj=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null;return e&&_j[e]&&_j[e].example?Nj(_j[e].example):"AB00 1234 5678 9012 3456 7890"},xj=function(e){return OA(e).call(e,0,2)};function Ej(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:null;this.status=e,this.code=t}var Aj=function(e){var t=Pj(e),r=function(e){var t,r=e,a="A".charCodeAt(0),n="Z".charCodeAt(0);return r=(r=r.toUpperCase()).substr(4)+r.substr(0,4),QC(t=r.split("")).call(t,(function(e){var t=e.charCodeAt(0);return t>=a&&t<=n?t-a+10:e})).join("")}(t),a=1===function(e){for(var t,r=e;r.length>2;)t=OA(r).call(r,0,9),r=O_(t,10)%97+OA(r).call(r,t.length);return O_(r,10)%97}(r);return a&&function(e){var t=OA(e).call(e,0,2),r=wj(0,t);return r.test&&r.test(OA(e).call(e,4))||!1}(t)},Dj=function(e){var t=Pj(e);if(e.length<2)return new Ej("no-validate","TOO_SHORT");var r=function(e){return!(!e||!_j[e])&&_j[e]}(xj(t));return r?t.length>r.length?new Ej("invalid","TOO_LONG"):t.length===r.length?Aj(e)?new Ej("valid","VALID"):new Ej("invalid","INVALID_IBAN"):new Ej("no-validate","UNKNOWN"):new Ej("invalid","INVALID_COUNTRY")},Ij=function(e){return!WR(e)||null};function Fj(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function Rj(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=Fj(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=Fj(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}function Oj(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}var Tj={isValid:!1,errorMessage:"ach.accountHolderNameField.invalid",error:"ach.accountHolderNameField.invalid"},Bj={isValid:!1,errorMessage:"sepaDirectDebit.ibanField.invalid",error:"sepaDirectDebit.ibanField.invalid"},jj=function(e){TN(r,e);var t=Oj(r);function r(e){var a,n,o,i;if(Bg(this,r),Wg(RN(i=t.call(this,e)),"ibanNumber",void 0),Wg(RN(i),"setData",(function(e,t,r){i.setState((function(r){return{data:Rj(Rj({},r.data),{},Wg({},e,t))}}),r)})),Wg(RN(i),"setError",(function(e,t,r){i.setState((function(r){return{errors:Rj(Rj({},r.errors),{},Wg({},e,t))}}),r)})),Wg(RN(i),"setValid",(function(e,t,r){i.setState((function(r){return{valid:Rj(Rj({},r.valid),{},Wg({},e,t))}}),r)})),Wg(RN(i),"handleHolderInput",(function(e){i.setState((function(t){return{data:Rj(Rj({},t.data),{},{ownerName:e})}}),(function(){var e=Ij(i.state.data.ownerName),t=null==e||e?null:Tj;i.setError("holder",t,i.onChange)}))})),Wg(RN(i),"handleIbanInput",(function(e){var t=e.target.value,r=Pj(t),a=Nj(r),n=Dj(a).status,o=xj(r),l=e.target.selectionStart,c=i.state.data.ibanNumber,s=function(e,t,r){if(0===e||!t.length)return 0;var a=t.length-r.length,n=a>0,o=function(e,t){return/\s/.test(e.charAt(t))},i=e-a;return n&&(o(t,i+1)||o(t,i))?e+1:!n&&o(t,e-1)?e-1:e}(l,a,c);i.setState((function(e){return{data:Rj(Rj({},e.data),{},{ibanNumber:a,countryCode:o}),errors:Rj(Rj({},e.errors),{},{iban:"invalid"===n?Bj:null}),valid:Rj(Rj({},e.valid),{},{iban:"valid"===n})}}),(function(){e.target.setSelectionRange(s,s),i.onChange()}))})),Wg(RN(i),"handleIbanBlur",(function(e){var t=e.target.value;if(t.length>0){var r=Dj(t).status;i.setError("iban","valid"!==r?Bj:null,i.onChange)}})),i.state={status:"ready",data:{ownerName:(null==e||null===(a=e.data)||void 0===a?void 0:a.ownerName)||"",ibanNumber:(null==e||null===(n=e.data)||void 0===n?void 0:n.ibanNumber)||"",countryCode:(null==e||null===(o=e.data)||void 0===o?void 0:o.countryCode)||""},isValid:!1,cursor:0,errors:{},valid:{}},i.state.data.ibanNumber){var l=Pj(i.state.data.ibanNumber);i.state.data.ibanNumber=Nj(l)}if(i.state.data.ibanNumber||i.state.data.ownerName){var c=i.props.holderName?Ij(i.state.data.ownerName):"",s=(i.state.data.ibanNumber?"valid"===Dj(i.state.data.ibanNumber).status:"")&&c,u={data:i.state.data,isValid:s};i.props.onChange(u)}return i}return qg(r,[{key:"setStatus",value:function(e){this.setState({status:e})}},{key:"onChange",value:function(){var e=!this.props.holderName||Ij(this.state.data.ownerName),t="valid"===Dj(this.state.data.ibanNumber).status&&e,r={data:this.state.data,isValid:t,errors:this.state.errors};this.props.onChange(r)}},{key:"showValidation",value:function(){var e=Dj(this.state.data.ibanNumber).status,t=Ij(this.state.data.ownerName);this.setError("iban","valid"!==e?Bj:null);var r=t?null:Tj;this.setError("holder",r,this.onChange)}},{key:"render",value:function(e,t){var r=this,a=e.placeholders,n=e.countryCode,o=t.data,i=t.errors,l=t.valid,c=$w().i18n;return JN(hD,{classNameModifiers:["iban-input"],label:this.props.label},this.props.holderName&&JN(kI,{className:"adyen-checkout__field--owner-name",label:c.get("sepa.ownerName"),filled:o.ownerName&&o.ownerName.length,errorMessage:!!i.holder&&c.get(i.holder.error),dir:"ltr",i18n:c},NF("text",{name:"ownerName",className:"adyen-checkout__iban-input__owner-name",placeholder:"ownerName"in a?a.ownerName:c.get("sepaDirectDebit.nameField.placeholder"),value:o.ownerName,"aria-invalid":!!this.state.errors.holder,"aria-label":c.get("sepa.ownerName"),onInput:function(e){return r.handleHolderInput(e.target.value)}})),JN(kI,{className:"adyen-checkout__field--iban-number",label:c.get("sepa.ibanNumber"),errorMessage:!!i.iban&&c.get(i.iban.error),filled:o.ibanNumber&&o.ibanNumber.length,isValid:l.iban,onBlur:this.handleIbanBlur,dir:"ltr",i18n:c},NF("text",{ref:function(e){r.ibanNumber=e},name:"ibanNumber",className:"adyen-checkout__iban-input__iban-number",classNameModifiers:["large"],placeholder:"ibanNumber"in a?a.ibanNumber:Sj(n),value:o.ibanNumber,onInput:this.handleIbanInput,"aria-invalid":!!this.state.errors.iban,"aria-label":c.get("sepa.ibanNumber"),autocorrect:"off",spellcheck:!1})),this.props.showPayButton&&this.props.payButton({status:this.state.status}))}}]),r}($N);function zj(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function Mj(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=zj(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=zj(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}function Lj(e){var t,r,a=e.countryCode,n=e.visibility,o=$w().i18n,i=Lw({});Jy(i.current).length||(null===(r=e.setComponentRef)||void 0===r||r.call(e,i.current));var l=tC(Bw(Cj(n,e.data)),2),c=l[0],s=l[1],u=Lw(DC(bj).call(bj,(function(e,t){return e[t]=function(e){u[t].current=e},e}),{})).current,d=!!e.consentCheckboxLabel,p=!d&&mD(t=Jy(c)).call(t,(function(e){return!c[e]})),f="editable"===n.deliveryAddress&&"hidden"!==n.billingAddress,m=tC(Bw(Mj(Mj({},e.data),d&&{consentCheckbox:!1})),2),h=m[0],v=m[1],y=tC(Bw({}),2),g=y[0],b=y[1],k=tC(Bw({}),2),C=k[0],_=k[1],N=tC(Bw("ready"),2),P=N[0],w=N[1];i.current.showValidation=function(){Jg(bj).call(bj,(function(e){u[e].current&&u[e].current.showValidation()})),b(Mj({},d&&{consentCheckbox:!h.consentCheckbox}))},i.current.setStatus=w,zw((function(){var t=function(){var e;return mD(e=Jy(c)).call(e,(function(e){return!c[e]||!!C[e]}))}(),r=!d||!!C.consentCheckbox,a=t&&r,n=kj(c,h);e.onChange({data:n,errors:g,valid:C,isValid:a})}),[h,c]);var S=function(e){return function(t){v((function(r){return Mj(Mj({},r),{},Wg({},e,t.data))})),_((function(r){return Mj(Mj({},r),{},Wg({},e,t.isValid))})),b((function(r){return Mj(Mj({},r),{},Wg({},e,t.errors))}))}};return JN("div",{className:"adyen-checkout__open-invoice"},c.companyDetails&&JN(ZF,{data:e.data.companyDetails,label:"companyDetails",onChange:S("companyDetails"),setComponentRef:u.companyDetails,visibility:n.companyDetails}),c.personalDetails&&JN(uR,{data:e.data.personalDetails,requiredFields:e.personalDetailsRequiredFields,label:"personalDetails",onChange:S("personalDetails"),setComponentRef:u.personalDetails,visibility:n.personalDetails}),c.bankAccount&&JN(jj,{holderName:!0,label:"bankAccount",data:h.bankAccount,onChange:S("bankAccount"),ref:u.bankAccount}),c.billingAddress&&JN(vj,{allowedCountries:e.allowedCountries,countryCode:a,requiredFields:e.billingAddressRequiredFields,specifications:e.billingAddressSpecification,data:h.billingAddress,label:"billingAddress",onChange:S("billingAddress"),setComponentRef:u.billingAddress,visibility:n.billingAddress}),f&&JN(dF,{label:o.get("separateDeliveryAddress"),checked:c.deliveryAddress,classNameModifiers:["separateDeliveryAddress"],name:"separateDeliveryAddress",onChange:function(){s((function(e){return Mj(Mj({},e),{},{deliveryAddress:!c.deliveryAddress})}))}}),c.deliveryAddress&&JN(vj,{allowedCountries:e.allowedCountries,countryCode:a,data:h.deliveryAddress,label:"deliveryAddress",onChange:S("deliveryAddress"),setComponentRef:u.deliveryAddress,visibility:n.deliveryAddress}),d&&JN(gj,{data:h,errorMessage:!!g.consentCheckbox,label:e.consentCheckboxLabel,onChange:function(e){var t=e.target.checked;v((function(e){return Mj(Mj({},e),{},{consentCheckbox:t})})),_((function(e){return Mj(Mj({},e),{},{consentCheckbox:t})})),b((function(e){return Mj(Mj({},e),{},{consentCheckbox:!t})}))},i18n:o}),e.showPayButton&&e.payButton({status:P,classNameModifiers:rC(p?["standalone"]:[]),label:o.get("confirmPurchase")}))}function Vj(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}Wg(jj,"defaultProps",{onChange:function(){},countryCode:null,holderName:!0,placeholders:{},label:null});var Uj=function(e){TN(r,e);var t=Vj(r);function r(){var e,a;Bg(this,r);for(var n=arguments.length,o=new Array(n),i=0;i<n;i++)o[i]=arguments[i];return Wg(RN(a=t.call.apply(t,Bb(e=[this]).call(e,o))),"state",{loaded:!1}),a}return qg(r,[{key:"componentDidMount",value:function(){var e=this;this.props.i18n?this.props.i18n.loaded.then((function(){e.setState({loaded:!0})})):this.setState({loaded:!0})}},{key:"render",value:function(e){var t=e.children;return this.state.loaded?JN(Zw.Provider,{value:{i18n:this.props.i18n,loadingContext:this.props.loadingContext,commonProps:this.props.commonProps||{}}},oP(t)):null}}]),r}($N);function Kj(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function Hj(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=Kj(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=Kj(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}function qj(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}var Wj=function(e){TN(r,e);var t=qj(r);function r(){return Bg(this,r),t.apply(this,arguments)}return qg(r,[{key:"isValid",get:function(){return!!this.state.isValid}},{key:"formatProps",value:function(e){var t,a,n=e.countryCode||(null===(t=e.data)||void 0===t||null===(a=t.billingAddress)||void 0===a?void 0:a.countryCode);return Hj(Hj({},e),{},{allowedCountries:[n],visibility:Hj(Hj({},r.defaultProps.visibility),e.visibility),data:Hj(Hj({},e.data),{},{billingAddress:Hj(Hj({},e.data.billingAddress),{},{country:n}),deliveryAddress:Hj(Hj({},e.data.deliveryAddress),{},{country:n})})})}},{key:"formatData",value:function(){var e=this.state.data,t=void 0===e?{}:e,r=t.companyDetails,a=void 0===r?{}:r,n=t.personalDetails,o=void 0===n?{}:n,i=t.billingAddress,l=t.deliveryAddress,c=t.bankAccount;return Hj(Hj(Hj(Hj(Hj({paymentMethod:{type:this.constructor.type}},o),a),c&&{bankAccount:{iban:c.ibanNumber,ownerName:c.ownerName,countryCode:c.countryCode}}),i&&{billingAddress:i}),(l||i)&&{deliveryAddress:l||i})}},{key:"render",value:function(){return JN(Uj,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},JN(Lj,FN({setComponentRef:this.setComponentRef},this.props,this.state,{onChange:this.setState,onSubmit:this.submit,payButton:this.payButton})))}}]),r}(dA);function Yj(e){var t=$w().i18n,r=t.get("paymentConditions"),a=tC(t.get("afterPay.agreement").split("%@"),2),n=a[0],o=a[1];return n&&o?JN(ZN,null,n,JN("a",{className:"adyen-checkout__link",target:"_blank",rel:"noopener noreferrer",href:e.url},r),o):JN("span",{className:"adyen-checkout__checkbox__label"},t.get("privacyPolicy"))}Wg(Wj,"defaultProps",{onChange:function(){},data:{companyDetails:{},personalDetails:{},billingAddress:{},deliveryAddress:{},bankAccount:{}},visibility:{companyDetails:"hidden",personalDetails:"editable",billingAddress:"editable",deliveryAddress:"editable",bankAccount:"hidden"}});var Gj="https://www.afterpay.nl/en/algemeen/pay-with-afterpay/payment-conditions",Jj="https://www.afterpay.be/be/footer/betalen-met-afterpay/betalingsvoorwaarden",Qj="https://www.afterpay.nl/nl/algemeen/betalen-met-afterpay/betalingsvoorwaarden",Zj=["BE","NL"];function $j(e,t){var r;return"en"===(null==t?void 0:OA(r=t.toLowerCase()).call(r,0,2))?Gj:"be"===(null==e?void 0:e.toLowerCase())?Jj:Qj}function Xj(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function ez(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=Xj(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=Xj(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}function tz(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}var rz=function(e){TN(r,e);var t=tz(r);function r(){return Bg(this,r),t.apply(this,arguments)}return qg(r,[{key:"formatProps",value:function(e){var t;return ez(ez({},oD(jN(r.prototype),"formatProps",this).call(this,e)),{},{allowedCountries:e.countryCode?[e.countryCode]:Zj,consentCheckboxLabel:JN(Yj,{url:$j(e.countryCode,null===(t=e.i18n)||void 0===t?void 0:t.locale)})})}}]),r}(Wj);function az(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function nz(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=az(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=az(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}function oz(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}Wg(rz,"type","afterpay_default");var iz=function(e){TN(r,e);var t=oz(r);function r(){return Bg(this,r),t.apply(this,arguments)}return qg(r,[{key:"formatProps",value:function(e){return nz(nz({},oD(jN(r.prototype),"formatProps",this).call(this,e)),{},{allowedCountries:e.countryCode?[e.countryCode]:Zj,consentCheckboxLabel:JN(Yj,{url:"https://www.afterpay.nl/nl/algemeen/zakelijke-partners/betalingsvoorwaarden-zakelijk"})})}}]),r}(Wj);function lz(){var e=bP(window,"screen.colorDepth")||"",t=!!bP(window,"navigator.javaEnabled")&&window.navigator.javaEnabled(),r=bP(window,"screen.height")||"",a=bP(window,"screen.width")||"",n=bP(window,"navigator.userAgent")||"";return{acceptHeader:"*/*",colorDepth:e,language:bP(window,"navigator.language")||bP(window,"navigator.browserLanguage")||"en",javaEnabled:t,screenHeight:r,screenWidth:a,userAgent:n,timeZoneOffset:(new Date).getTimezoneOffset()}}Wg(iz,"type","afterpay_b2b"),Wg(iz,"defaultProps",{onChange:function(){},data:{companyDetails:{},personalDetails:{},billingAddress:{},deliveryAddress:{}},visibility:{companyDetails:"editable",personalDetails:"editable",billingAddress:"editable",deliveryAddress:"editable"}});var cz="v1/AmazonPayUtility/getCheckoutDetails",sz="v1/AmazonPayUtility/signString",uz="v1/AmazonPayUtility/updateCheckoutSession",dz="https://static-eu.payments-amazon.com/checkout.js",pz="https://static-na.payments-amazon.com/checkout.js",fz="en_GB",mz="en_US",hz={EU:"EUR",UK:"GBP",US:"USD"},vz=["en_GB","de_DE","fr_FR","it_IT","es_ES"],yz=["en_US"];function gz(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function bz(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=gz(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=gz(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}function kz(e,t){var r=function(e){return"US"===e?yz:vz}(t),a=Eb(r).call(r,e)?e:function(e){return"US"===e?mz:fz}(t);return a}function Cz(e){return"noTagline"===e?"C0001":null}function _z(e){var t=e.addressDetails,r=e.cancelUrl,a=e.checkoutMode,n=e.deliverySpecifications,o=e.returnUrl,i=e.merchantMetadata,l=e.chargePermissionType,c=e.recurringMetadata,s=e.configuration.storeId,u="ProcessOrder"===a,d=u?function(e){return{amount:String(j_(e.value,e.currency)),currencyCode:e.currency}}(e.amount):null;return bz(bz(bz(bz(bz({storeId:s,chargePermissionType:l,webCheckoutDetails:bz(bz(bz({},u?{checkoutResultReturnUrl:o}:{checkoutReviewReturnUrl:o}),r&&{checkoutCancelUrl:r}),u&&{checkoutMode:a})},u&&{paymentDetails:{chargeAmount:d,paymentIntent:"Confirm",presentmentCurrency:d.currencyCode,totalOrderAmount:d}}),c&&{recurringMetadata:c}),i&&{merchantMetadata:i}),n&&{deliverySpecifications:n}),t&&{addressDetails:t})}function Nz(e,t,r){var a;return UB({loadingContext:e,path:Bb(a="".concat(cz,"?clientKey=")).call(a,t)},r)}function Pz(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function wz(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=Pz(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=Pz(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}function Sz(e){var t=this,r=$w().loadingContext,a=e.amazonRef,n=e.configuration,o=void 0===n?{}:n,i=tC(Bw(null),2),l=i[0],c=i[1],s=_z(e),u=function(e){var t;return bz(bz(bz({},e.buttonColor&&{buttonColor:e.buttonColor}),e.design&&{design:Cz(e.design)}),{},{checkoutLanguage:kz(e.locale,e.configuration.region),ledgerCurrency:hz[e.configuration.region]||e.currency||(null===(t=e.amount)||void 0===t?void 0:t.currency),merchantId:e.configuration.merchantId,productType:e.productType,placement:e.placement,sandbox:"TEST"===e.environment})}(e),d=function(){new ok(e.onClick).then(t.initCheckout).catch((function(r){e.onError&&e.onError(r,t.componentRef)}))};return this.initCheckout=function(){var e={payloadJSON:gA(s),publicKeyId:o.publicKeyId,signature:l};a.Pay.initCheckout(wz(wz({},u),{},{createCheckoutSessionConfig:e}))},zw((function(){var n=e.clientKey;(function(e,t,r){var a;return UB({loadingContext:e,path:Bb(a="".concat(sz,"?clientKey=")).call(a,t)},{stringToSign:gA(r)})})(r,n,s).then((function(t){if(null==t||!t.signature)return console.error("Could not get AmazonPay signature");c(t.signature),e.showPayButton&&a.Pay.renderButton("#amazonPayButton",u).onClick(d)})).catch((function(r){console.error(r),e.onError&&e.onError(r,t.componentRef)}))}),[]),e.showPayButton?JN("div",{className:"adyen-checkout__amazonpay__button",id:"amazonPayButton"}):null}function xz(e){var t=$w().i18n,r=e.amazonRef,a=e.amazonCheckoutSessionId;return zw((function(){var e={amazonCheckoutSessionId:a,changeAction:"changeAddress"};r.Pay.bindChangeAction(".adyen-checkout__amazonpay__button--changeAddress",e)}),[]),JN("button",{type:"button",className:"adyen-checkout__button adyen-checkout__button--ghost adyen-checkout__amazonpay__button--changeAddress"},t.get("amazonpay.changePaymentDetails"))}function Ez(e){var t=this,r=$w(),a=r.i18n,n=r.loadingContext;return this.createOrder=function(){var r=e.amazonCheckoutSessionId,a=e.amount,o=e.clientKey,i=e.chargePermissionType,l=e.publicKeyId,c=e.region,s=e.recurringMetadata,u=e.returnUrl;(function(e,t,r){var a;return UB({loadingContext:e,path:Bb(a="".concat(uz,"?clientKey=")).call(a,t)},r)})(n,o,{amount:a,chargePermissionType:i,checkoutResultReturnUrl:u,checkoutSessionId:r,publicKeyId:l,recurringMetadata:s,region:c}).then((function(e){var t;if(null==e||null===(t=e.action)||void 0===t||!t.type)return console.error(e.errorMessage||"Could not get the AmazonPay URL");"redirect"===e.action.type&&window.location.assign(e.action.url)})).catch((function(r){e.onError&&e.onError(r,t.componentRef)}))},JN(eS,{classNameModifiers:["standalone","pay"],label:a.get("confirmPurchase"),onClick:this.createOrder})}function Az(e){return JN("button",{type:"button",className:"adyen-checkout__button  adyen-checkout__button--ghost adyen-checkout__amazonpay__button--signOut",onClick:function(){new ok(e.onSignOut).then((function(){e.amazonRef.Pay.signout()})).catch(console.error)}},$w().i18n.get("amazonpay.signout"))}var Dz={},Iz={get exports(){return Dz},set exports(e){Dz=e}};!function(e){e.exports=NN}(Iz);var Fz=t(Dz),Rz=qg((function e(t){var r=this,a=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"body",n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},o=arguments.length>3&&void 0!==arguments[3]?arguments[3]:{};Bg(this,e),Wg(this,"src",void 0),Wg(this,"node",void 0),Wg(this,"attributes",void 0),Wg(this,"dataAttributes",void 0),Wg(this,"isScriptLoadCalled",!1),Wg(this,"script",void 0),Wg(this,"load",(function(){if(!r.isScriptLoadCalled)return new ok((function(e,t){var a=function(){r.script.setAttribute("data-script-loaded","true"),e()},n=function(){r.remove(),t(new Error("Unable to load script ".concat(r.src)))};r.isScriptLoadCalled=!0;var o=document.querySelector(r.node);if(r.script=o.querySelector('script[src="'.concat(r.src,'"]')),r.script&&r.script.getAttribute("data-script-loaded"))e();else{if(r.script)return r.script.addEventListener("load",a),void r.script.addEventListener("error",n);r.script=document.createElement("script"),Fz(r.script,r.attributes),Fz(r.script.dataset,r.dataAttributes),r.script.src=r.src,r.script.async=!0,r.script.addEventListener("load",a),r.script.addEventListener("error",n),o.appendChild(r.script)}}))})),Wg(this,"remove",(function(){return r.script.parentNode&&r.script.parentNode.removeChild(r.script)})),this.src=t,this.node=a,this.attributes=n,this.dataAttributes=o}));function Oz(e){var t,r,a=tC(Bw("pending"),2),n=a[0],o=a[1],i=Lw(null),l=Lw(null),c=function(){o("ready")};return this.submit=function(){return i.current&&i.current.initCheckout?i.current.initCheckout():l.current&&l.current.createOrder?l.current.createOrder():void 0},zw((function(){var t="US"===e.configuration.region?pz:dz,r=new Rz(t);return window.amazon?c():r.load().then(c),function(){r.remove()}}),[]),"pending"===n?JN("div",{className:"adyen-checkout__amazonpay"},JN("div",{className:"adyen-checkout__amazonpay__status adyen-checkout__amazonpay__status--pending"},JN(Sw,null))):e.showSignOutButton?JN("div",{className:"adyen-checkout__amazonpay"},JN(Az,{amazonRef:window.amazon,onSignOut:e.onSignOut})):e.amazonCheckoutSessionId?JN("div",{className:"adyen-checkout__amazonpay"},e.showOrderButton&&JN(Ez,{amazonCheckoutSessionId:e.amazonCheckoutSessionId,amount:e.amount,chargePermissionType:e.chargePermissionType,recurringMetadata:e.recurringMetadata,clientKey:e.clientKey,onError:e.onError,publicKeyId:null===(t=e.configuration)||void 0===t?void 0:t.publicKeyId,region:null===(r=e.configuration)||void 0===r?void 0:r.region,returnUrl:e.returnUrl,ref:l}),e.showChangePaymentDetailsButton&&JN(xz,{amazonCheckoutSessionId:e.amazonCheckoutSessionId,amazonRef:window.amazon})):JN("div",{className:"adyen-checkout__amazonpay"},JN(Sz,FN({},e,{amazonRef:window.amazon,ref:i})))}var Tz={cancelUrl:"undefined"!=typeof window?window.location.href:"",configuration:{},environment:"TEST",locale:"en_GB",placement:"Cart",productType:"PayAndShip",returnUrl:"undefined"!=typeof window?window.location.href:"",showOrderButton:!0,showChangePaymentDetailsButton:!1,showSignOutButton:!1,showPayButton:!0,onClick:function(e){return e()},onSignOut:function(e){return e()}};function Bz(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function jz(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=Bz(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=Bz(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}function zz(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}var Mz=function(e){TN(r,e);var t=zz(r);function r(){return Bg(this,r),t.apply(this,arguments)}return qg(r,[{key:"formatProps",value:function(e){return jz(jz({},e),{},{checkoutMode:e.isDropin?"ProcessOrder":e.checkoutMode,environment:e.environment.toUpperCase(),locale:e.locale.replace("-","_"),productType:e.isDropin&&!e.addressDetails?"PayOnly":e.productType})}},{key:"formatData",value:function(){var e=this.props.amazonCheckoutSessionId;return{paymentMethod:jz({type:r.type},e&&{checkoutSessionId:e}),browserInfo:this.browserInfo}}},{key:"getShopperDetails",value:function(){var e=this.props,t=e.amazonCheckoutSessionId,r=e.configuration,a=void 0===r?{}:r,n=e.loadingContext,o=e.clientKey;return t?Nz(n,o,{checkoutSessionId:t,getDeliveryAddress:!0,publicKeyId:a.publicKeyId,region:a.region}):console.error("Could not shopper details. Missing checkoutSessionId.")}},{key:"handleDeclineFlow",value:function(){var e=this,t=this.props,r=t.amazonCheckoutSessionId,a=t.configuration,n=void 0===a?{}:a,o=t.loadingContext,i=t.clientKey;if(!r)return console.error("Could handle the decline flow. Missing checkoutSessionId.");Nz(o,i,{checkoutSessionId:r,getDeclineFlowUrl:!0,publicKeyId:n.publicKeyId,region:n.region}).then((function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};if(null==e||!e.declineFlowUrl)throw e;window.location.assign(e.declineFlowUrl)})).catch((function(t){e.props.onError&&e.props.onError(t,e.componentRef)}))}},{key:"isValid",get:function(){return!0}},{key:"browserInfo",get:function(){return lz()}},{key:"submit",value:function(){var e=this.data,t=this.isValid,r=this.props.onSubmit,a=void 0===r?function(){}:r;return this.componentRef&&this.componentRef.submit?this.componentRef.submit():a({data:e,isValid:t},this)}},{key:"render",value:function(){var e=this;return JN(Uj,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},JN(Oz,FN({ref:function(t){e.componentRef=t}},this.props)))}}]),r}(dA);Wg(Mz,"type","amazonpay"),Wg(Mz,"defaultProps",Tz);var Lz={"apple-pay":"ApplePayButton-module_apple-pay__gYjuP","apple-pay-button":"ApplePayButton-module_apple-pay-button__l5g-d","apple-pay-button-black":"ApplePayButton-module_apple-pay-button-black__istwW","apple-pay-button-white":"ApplePayButton-module_apple-pay-button-white__-wLaE","apple-pay-button-white-with-line":"ApplePayButton-module_apple-pay-button-white-with-line__MlRq7","apple-pay-button--type-plain":"ApplePayButton-module_apple-pay-button--type-plain__ycfNl","apple-pay-button--type-buy":"ApplePayButton-module_apple-pay-button--type-buy__9m8AB","apple-pay-button--type-donate":"ApplePayButton-module_apple-pay-button--type-donate__HmRdK","apple-pay-button--type-check-out":"ApplePayButton-module_apple-pay-button--type-check-out__XdGWd","apple-pay-button--type-book":"ApplePayButton-module_apple-pay-button--type-book__-v-VY","apple-pay-button--type-subscribe":"ApplePayButton-module_apple-pay-button--type-subscribe__WxWIF","apple-pay-button--type-add-money":"ApplePayButton-module_apple-pay-button--type-add-money__zeBA8","apple-pay-button--type-contribute":"ApplePayButton-module_apple-pay-button--type-contribute__G3E8e","apple-pay-button--type-order":"ApplePayButton-module_apple-pay-button--type-order__ggI6j","apple-pay-button--type-reload":"ApplePayButton-module_apple-pay-button--type-reload__QbgLd","apple-pay-button--type-rent":"ApplePayButton-module_apple-pay-button--type-rent__VzC-E","apple-pay-button--type-support":"ApplePayButton-module_apple-pay-button--type-support__6EjmY","apple-pay-button--type-tip":"ApplePayButton-module_apple-pay-button--type-tip__bdzGK","apple-pay-button--type-top-up":"ApplePayButton-module_apple-pay-button--type-top-up__Eb3qR"};function Vz(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}var Uz=function(e){TN(r,e);var t=Vz(r);function r(){return Bg(this,r),t.apply(this,arguments)}return qg(r,[{key:"render",value:function(e){var t=e.buttonColor,r=e.buttonType;return JN("button",{type:"button","aria-label":this.props.i18n.get("payButton"),lang:this.props.i18n.languageCode,className:ww("adyen-checkout__applepay__button","adyen-checkout__applepay__button--".concat(t),"adyen-checkout__applepay__button--".concat(r),[Lz["apple-pay"]],[Lz["apple-pay-button"]],[Lz["apple-pay-button-".concat(t)]],[Lz["apple-pay-button--type-".concat(r)]]),onClick:this.props.onClick})}}]),r}($N);function Kz(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function Hz(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=Kz(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=Kz(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}Wg(Uz,"defaultProps",{onClick:function(){},buttonColor:"black",buttonType:"plain"});var qz=function(){function e(t,r){var a=this;Bg(this,e),Wg(this,"session",void 0),this.session=new ApplePaySession(r.version,t),this.session.onvalidatemerchant=function(e){return a.onvalidatemerchant(e,r.onValidateMerchant)},this.session.onpaymentauthorized=function(e){return a.onpaymentauthorized(e,r.onPaymentAuthorized)},this.session.oncancel=function(e){return a.oncancel(e,r.onCancel)},"function"==typeof r.onPaymentMethodSelected&&(this.session.onpaymentmethodselected=function(e){return a.onpaymentmethodselected(e,r.onPaymentMethodSelected)}),"function"==typeof r.onShippingContactSelected&&(this.session.onshippingcontactselected=function(e){return a.onshippingcontactselected(e,r.onShippingContactSelected)}),"function"==typeof r.onShippingMethodSelected&&(this.session.onshippingmethodselected=function(e){return a.onshippingmethodselected(e,r.onShippingMethodSelected)})}return qg(e,[{key:"begin",value:function(){return this.session.begin()}},{key:"onvalidatemerchant",value:function(e,t){var r=this;new ok((function(r,a){return t(r,a,e.validationURL)})).then((function(e){r.session.completeMerchantValidation(e)})).catch((function(e){console.error(e),r.session.abort()}))}},{key:"onpaymentauthorized",value:function(e,t){var r=this;return new ok((function(r,a){return t(r,a,e)})).then((function(e){var t;r.session.completePayment(Hz(Hz({},e),{},{status:null!==(t=null==e?void 0:e.status)&&void 0!==t?t:ApplePaySession.STATUS_SUCCESS}))})).catch((function(e){var t;r.session.completePayment(Hz(Hz({},e),{},{status:null!==(t=null==e?void 0:e.status)&&void 0!==t?t:ApplePaySession.STATUS_FAILURE}))}))}},{key:"onpaymentmethodselected",value:function(e,t){var r=this;return new ok((function(r,a){return t(r,a,e)})).then((function(e){r.session.completePaymentMethodSelection(e)})).catch((function(e){r.session.completePaymentMethodSelection(e)}))}},{key:"onshippingcontactselected",value:function(e,t){var r=this;return new ok((function(r,a){return t(r,a,e)})).then((function(e){r.session.completeShippingContactSelection(e)})).catch((function(e){r.session.completeShippingContactSelection(e)}))}},{key:"onshippingmethodselected",value:function(e,t){var r=this;return new ok((function(r,a){return t(r,a,e)})).then((function(e){r.session.completeShippingMethodSelection(e)})).catch((function(e){r.session.completeShippingMethodSelection(e)}))}},{key:"oncancel",value:function(e,t){return t(e)}}]),e}(),Wz={amount:{currency:"USD",value:0},countryCode:"US",totalPriceStatus:"final",totalPriceLabel:void 0,configuration:{merchantName:"",merchantId:""},initiative:"web",lineItems:void 0,merchantCapabilities:["supports3DS"],shippingMethods:void 0,shippingType:void 0,supportedCountries:void 0,supportedNetworks:["amex","discover","masterCard","visa"],requiredBillingContactFields:void 0,requiredShippingContactFields:void 0,billingContact:void 0,shippingContact:void 0,applicationData:void 0,onClick:function(e){return e()},onAuthorized:function(e){return e()},onPaymentMethodSelected:null,onShippingContactSelected:null,onShippingMethodSelected:null,buttonType:"plain",buttonColor:"black",showPayButton:!0},Yz=["countryCode","companyName","amount"],Gz=function(e){var t=e.countryCode;e.companyName;var r=e.amount,a=KP(e,Yz),n=function(e){return String(j_(e.value,e.currency))}(r);return{countryCode:t,currencyCode:r.currency,total:{label:a.totalPriceLabel,amount:n,type:a.totalPriceStatus},lineItems:a.lineItems,shippingMethods:a.shippingMethods,shippingType:a.shippingType,merchantCapabilities:a.merchantCapabilities,supportedCountries:a.supportedCountries,supportedNetworks:a.supportedNetworks,requiredShippingContactFields:a.requiredShippingContactFields,requiredBillingContactFields:a.requiredBillingContactFields,billingContact:a.billingContact,shippingContact:a.shippingContact,applicationData:a.applicationData}};function Jz(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function Qz(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=Jz(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=Jz(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}function Zz(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}var $z=function(e){TN(a,e);var t,r=Zz(a);function a(e){var t,n,o,i;return Bg(this,a),(i=r.call(this,e)).startSession=rk(t=i.startSession).call(t,RN(i)),i.submit=rk(n=i.submit).call(n,RN(i)),i.validateMerchant=rk(o=i.validateMerchant).call(o,RN(i)),i}return qg(a,[{key:"formatProps",value:function(e){var t,r,a,n,o=this,i=e.version||function(e){for(var t=[],r=e;r>0;r--)t.push(r);return yk(t).call(t,(function(e){return e&&window.ApplePaySession&&ApplePaySession.supportsVersion(e)}))}(11),l=null!==(t=e.brands)&&void 0!==t&&t.length?(a=e.brands,n={mc:"masterCard",amex:"amex",visa:"visa",elodebit:"elo",elo:"elo",interac:"interac",discover:"discover",jcb:"jcb",electron:"electron",maestro:"maestro",girocard:"girocard",cartebancaire:"cartesBancaires"},DC(a).call(a,(function(e,t){return n[t]&&!Eb(e).call(e,n[t])&&e.push(n[t]),e}),[])):e.supportedNetworks;return Qz(Qz({},e),{},{configuration:e.configuration,supportedNetworks:l,version:i,totalPriceLabel:e.totalPriceLabel||(null===(r=e.configuration)||void 0===r?void 0:r.merchantName),onCancel:function(e){return o.handleError(new iA("CANCEL",e))}})}},{key:"formatData",value:function(){return{paymentMethod:Qz({type:a.type},this.state)}}},{key:"submit",value:function(){return this.startSession(this.props.onAuthorized)}},{key:"startSession",value:function(e){var t=this,r=this.props,n=r.version,o=r.onValidateMerchant,i=r.onCancel,l=r.onPaymentMethodSelected,c=r.onShippingMethodSelected,s=r.onShippingContactSelected;return new ok((function(e,r){return t.props.onClick(e,r)})).then((function(){var r=Gz(Qz({companyName:t.props.configuration.merchantName},t.props)),u=new qz(r,{version:n,onCancel:i,onPaymentMethodSelected:l,onShippingMethodSelected:c,onShippingContactSelected:s,onValidateMerchant:o||t.validateMerchant,onPaymentAuthorized:function(r,n,o){o.payment.token&&o.payment.token.paymentData&&t.setState({applePayToken:btoa(gA(o.payment.token.paymentData))}),oD(jN(a.prototype),"submit",t).call(t),e(r,n,o)}});u.begin()}))}},{key:"validateMerchant",value:(t=$d(Ky.mark((function e(t,r){var a,n,o,i,l,c,s,u,d,p,f,m,h,v,y;return Ky.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return n=window.location.hostname,o=this.props,i=o.clientKey,l=o.configuration,c=o.loadingContext,s=o.initiative,u=l.merchantName,d=l.merchantId,p=Bb(a="".concat("v1/applePay/sessions","?clientKey=")).call(a,i),f={loadingContext:c,path:p},m={displayName:u,domainName:n,initiative:s,merchantIdentifier:d},e.prev=6,e.next=9,UB(f,m);case 9:h=e.sent,(v=TA.decode(h.data))||r("Could not decode Apple Pay session"),y=JSON.parse(v),t(y),e.next=19;break;case 16:e.prev=16,e.t0=e.catch(6),r("Could not get Apple Pay session");case 19:case"end":return e.stop()}}),e,this,[[6,16]])}))),function(e,r){return t.apply(this,arguments)})},{key:"isValid",get:function(){return!0}},{key:"isAvailable",value:function(){return"https:"!==document.location.protocol?ok.reject(new iA("IMPLEMENTATION_ERROR","Trying to start an Apple Pay session from an insecure document")):this.props.onValidateMerchant||this.props.clientKey?window.ApplePaySession&&ApplePaySession.canMakePayments()&&ApplePaySession.supportsVersion(this.props.version)?ok.resolve(!0):ok.reject(new iA("ERROR","Apple Pay is not available on this device")):ok.reject(new iA("IMPLEMENTATION_ERROR","clientKey was not provided"))}},{key:"render",value:function(){var e=this;return this.props.showPayButton?JN(Uz,{i18n:this.props.i18n,buttonColor:this.props.buttonColor,buttonType:this.props.buttonType,onClick:function(t){t.preventDefault(),e.submit()}}):null}}]),a}(dA);function Xz(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function eM(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=Xz(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=Xz(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}Wg($z,"type","applepay"),Wg($z,"defaultProps",Wz);var tM={labels:Wg({},fR,"address"),schema:[fR,[[gR,70],[hR,30]]]},rM=["ID","PH","TH","VN","JP","TW","KR","SG","MY","HK"],aM=DC(CR).call(CR,(function(e,t){return eM(eM({},e),{},Wg({},t,tM))}),{default:tM});function nM(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function oM(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=nM(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=nM(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}function iM(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}var lM=function(e){TN(r,e);var t=iM(r);function r(){return Bg(this,r),t.apply(this,arguments)}return qg(r,[{key:"formatProps",value:function(e){return oM(oM({},oD(jN(r.prototype),"formatProps",this).call(this,oM(oM({},e),{visibility:{deliveryAddress:"hidden",companyDetails:"hidden"}}))),{},{allowedCountries:rM,personalDetailsRequiredFields:["firstName","lastName","telephoneNumber"],billingAddressRequiredFields:["country","street","postalCode"],billingAddressSpecification:aM})}}]),r}(Wj);function cM(e){var t=e.name,r=e.id,a=e.icon,n=e.onClick,o=e.selected,i=void 0!==o&&o;return JN("button",{type:"button",className:ww("adyen-checkout__issuer-button",{"adyen-checkout__issuer-button--selected":i}),"aria-label":t,"aria-pressed":i,onClick:n,value:r},!!a&&JN(fF,{className:"adyen-checkout__issuer-button-img",alt:t,src:a}),JN("span",{className:"adyen-checkout__issuer-button-text"},t))}Wg(lM,"type","atome");var sM=function(e){var t=e.items,r=void 0===t?[]:t,a=e.selectedIssuerId,n=e.onChange,o=$w().i18n,i=Uw((function(e){var t=e.currentTarget.value;Og(e.target,"value",{value:t}),n(e)}),[n]);return JN("div",{className:"adyen-checkout__issuer-button-group",role:"group","aria-label":o.get("idealIssuer.selectField.placeholder")},QC(r).call(r,(function(e){return JN(cM,FN({key:e.id},e,{selected:a===e.id,onClick:i}))})))};function uM(e){var t,r=e.label,a=void 0===r?"qrCodeOrApp":r,n=e.classNames,o=void 0===n?[]:n,i=$w().i18n;return JN("div",{className:ww.apply(void 0,Bb(t=["adyen-checkout__content-separator"]).call(t,rC(o)))},i.get(a))}var dM=["items","placeholder","issuer","highlightedIds"];function pM(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}var fM,mM=function(e,t){var r,a,n=e.issuer,o=e.items,i=null===(r=yk(o).call(o,(function(e){return e.id===n})))||void 0===r?void 0:r.name;return n&&i?Bb(a="".concat(t.get("continueTo")," ")).call(a,i):t.get("continue")},hM=["issuer"],vM={issuer:{validate:function(e){return!!e&&e.length>0},modes:["blur"]}};function yM(e){var t,r=e.items,a=e.placeholder,n=void 0===a?"idealIssuer.selectField.placeholder":a,o=e.issuer,i=e.highlightedIds,l=void 0===i?[]:i,c=KP(e,dM),s=$w().i18n,u=QF({schema:hM,defaultData:{issuer:o},rules:vM}),d=u.handleChangeFor,p=u.triggerValidation,f=u.data,m=u.valid,h=u.errors,v=u.isValid,y=tC(Bw("ready"),2),g=y[0],b=y[1],k=tC(Bw(fM.Dropdown),2),C=k[0],_=k[1];this.setStatus=function(e){b(e)};var N=Uw((function(e){return function(t){_(e),d("issuer")(t)}}),[d]);zw((function(){c.onChange({data:f,valid:m,errors:h,isValid:v})}),[f,m,h,v]),this.showValidation=function(){p()};var P=DC(r).call(r,(function(e,t){return Eb(l).call(l,t.id)&&e.highlightedItems.push(function(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=pM(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=pM(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}({},t)),e}),{highlightedItems:[]}),w=P.highlightedItems;return JN("div",{className:"adyen-checkout__issuer-list"},!!w.length&&JN(ZN,null,JN(sM,{selectedIssuerId:C===fM.ButtonGroup?f.issuer:null,items:w,onChange:N(fM.ButtonGroup)}),JN(uM,null)),JN(kI,{errorMessage:!!h.issuer,classNameModifiers:["issuer-list"]},NF("select",{items:r,selected:C===fM.Dropdown?f.issuer:null,placeholder:s.get(n),name:"issuer",className:"adyen-checkout__issuer-list__dropdown",onChange:N(fM.Dropdown)})),c.showPayButton&&c.payButton({status:g,label:mM({issuer:f.issuer,items:Bb(t=[]).call(t,rC(r),rC(w))},s)}),c.termsAndConditionsUrl&&JN("div",{className:"adyen-checkout__issuer-list__termsAndConditions"},JN("p",{className:"adyen-checkout__helper-text"},s_(s.get("onlineBanking.termsAndConditions"),[function(e){return JN("a",{href:c.termsAndConditionsUrl,target:"_blank",rel:"noopener noreferrer"},e)}]))))}function gM(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}!function(e){e[e.ButtonGroup=0]="ButtonGroup",e[e.Dropdown=1]="Dropdown"}(fM||(fM={})),yM.defaultProps={onChange:function(){}};var bM=function(e,t){return function(r){if(!r)return null;var a=function(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=gM(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=gM(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}({parentFolder:r?"".concat(t,"/"):"",type:r||t},e);return GP(a)(r)}},kM=["payButton","onSubmit","amount","name"];function CM(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function _M(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=CM(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=CM(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}function NM(e){var t=e.payButton,r=e.onSubmit,a=e.amount,n=void 0===a?null:a,o=e.name,i=KP(e,kM),l=$w().i18n,c=tC(Bw("ready"),2),s=c[0],u=c[1];this.setStatus=function(e){u(e)};return JN(ZN,null,t(_M(_M({},i),{},{status:s,classNameModifiers:["standalone"],label:function(){var e,t;return n&&{}.hasOwnProperty.call(n,"value")&&0===n.value?Bb(e="".concat(l.get("preauthorizeWith")," ")).call(e,o):Bb(t="".concat(l.get("continueTo")," ")).call(t,o)}(),onClick:r})))}function PM(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function wM(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=PM(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=PM(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}function SM(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}var xM=function(e){TN(r,e);var t=SM(r);function r(e){var a;if(Bg(this,r),(a=t.call(this,e)).props.showImage){var n,o=bM({loadingContext:a.props.loadingContext},a.constructor.type);a.props.issuers=QC(n=a.props.issuers).call(n,(function(e){return wM(wM({},e),{},{icon:o(e.id)})}))}return a}return qg(r,[{key:"formatProps",value:function(e){var t,r=e.details&&e.details.length&&(yk(t=e.details).call(t,(function(e){return"issuer"===e.key}))||{}).items||e.issuers||[];return wM(wM({},e),{},{issuers:r})}},{key:"formatData",value:function(){var e,t;return{paymentMethod:{type:this.constructor.type,issuer:null===(e=this.state)||void 0===e||null===(t=e.data)||void 0===t?void 0:t.issuer}}}},{key:"isValid",get:function(){var e;return 0===this.props.issuers.length||!(null===(e=this.state)||void 0===e||!e.isValid)}},{key:"brands",get:function(){var e;return this.props.showPaymentMethodItemImages?QC(e=this.props.issuers).call(e,(function(e){return{icon:e.icon,name:e.id}})):[]}},{key:"render",value:function(){var e=this;return JN(Uj,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},this.props.issuers.length>0?JN(yM,FN({ref:function(t){e.componentRef=t},items:this.props.issuers,highlightedIds:this.props.highlightedIssuers},this.props,this.state,{onChange:this.setState,onSubmit:this.submit,payButton:this.payButton})):JN(NM,FN({name:this.props.name},this.props,{onSubmit:this.submit,payButton:this.payButton,ref:function(t){e.componentRef=t}})))}}]),r}(dA);function EM(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function AM(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=EM(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=EM(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}function DM(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}Wg(xM,"defaultProps",{showImage:!0,onValid:function(){},issuers:[],highlightedIssuers:[],loadingContext:HP,showPaymentMethodItemImages:!1});var IM=function(e){TN(r,e);var t=DM(r);function r(){return Bg(this,r),t.apply(this,arguments)}return qg(r,[{key:"formatProps",value:function(e){return AM(AM({},oD(jN(r.prototype),"formatProps",this).call(this,e)),{},{showImage:!1})}}]),r}(xM);function FM(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function RM(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=FM(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=FM(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}function OM(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}Wg(IM,"type","billdesk_online");var TM=function(e){TN(r,e);var t=OM(r);function r(){return Bg(this,r),t.apply(this,arguments)}return qg(r,[{key:"formatProps",value:function(e){return RM(RM({},oD(jN(r.prototype),"formatProps",this).call(this,e)),{},{showImage:!1,placeholder:"issuerList.wallet.placeholder"})}}]),r}(xM);Wg(TM,"type","billdesk_wallet");var BM={},jM={get exports(){return BM},set exports(e){BM=e}},zM=VF.entries;Dr({target:"Object",stat:!0},{entries:function(e){return zM(e)}});var MM=ne.Object.entries;!function(e){e.exports=MM}(jM);var LM=t(BM),VM=function(e,t){return t===gD?(e[bD]=!1,e[kD]=!1):e[t]=!1,e},UM=function(e,t){return function(r,a){var n=!0!==t.valid[a]?function(e,t){return 1!==t||e!==bD&&e!==kD?e:gD}(a,e):null;return n=function(e,t,r){var a=DC(r).call(r,(function(r,a){return r.isFieldOfType||(r.isFieldOfType=e===a,r.fieldIsValid=!t.errors[a]),r}),{isFieldOfType:!1,fieldIsValid:!1}),n=a.isFieldOfType,o=a.fieldIsValid,i=e===CD?"cvcPolicy":"expiryDatePolicy",l="cvcPolicy"===i?VD:HD,c="cvcPolicy"===i?UD:qD;return(t[i]===l||t[i]===c)&&o&&n?null:e}(n,t,[CD,gD,bD,kD]),n&&!Eb(r).call(r,n)&&r.push(n),r}},KM=qg((function e(t){Bg(this,e),Wg(this,"callbacks",void 0),Wg(this,"config",void 0),Wg(this,"props",void 0),Wg(this,"state",void 0),Wg(this,"validateForm",void 0),Wg(this,"handleBrandFromBinLookup",void 0),Wg(this,"callbacksHandler",void 0),Wg(this,"configHandler",void 0),Wg(this,"createCardSecuredFields",void 0),Wg(this,"createNonCardSecuredFields",void 0),Wg(this,"createSecuredFields",void 0),Wg(this,"destroySecuredFields",void 0),Wg(this,"handleIOSTouchEvents",void 0),Wg(this,"destroyTouchendListener",void 0),Wg(this,"destroyTouchstartListener",void 0),Wg(this,"handleBinValue",void 0),Wg(this,"handleEncryption",void 0),Wg(this,"handleFocus",void 0),Wg(this,"handleIframeConfigFeedback",void 0),Wg(this,"handleValidation",void 0),Wg(this,"handleSFShiftTab",void 0),Wg(this,"handleShiftTab",void 0),Wg(this,"isConfigured",void 0),Wg(this,"postMessageToAllIframes",void 0),Wg(this,"processAutoComplete",void 0),Wg(this,"processBrand",void 0),Wg(this,"sendBrandToCardSF",void 0),Wg(this,"sendExpiryDatePolicyToSF",void 0),Wg(this,"setFocusOnFrame",void 0),Wg(this,"setupSecuredField",void 0),Wg(this,"touchendListener",void 0),Wg(this,"touchstartListener",void 0),Wg(this,"encryptedAttrName",void 0),Wg(this,"hasRedundantCVCField",void 0),Wg(this,"isSingleBrandedCard",void 0),Wg(this,"securityCode",void 0),this.props=t,this.state={},this.config={},this.callbacks={}})),HM={},qM={get exports(){return HM},set exports(e){HM=e}};Dr({target:"Number",stat:!0},{isNaN:function(e){return e!=e}});var WM=ne.Number.isNaN;!function(e){e.exports=WM}(qM);var YM=t(HM),GM=Object.prototype.toString;function JM(e){return"object"===Tg(e)&&null!==e&&"[object Array]"===Object.prototype.toString.call(e)}function QM(e){return null!=e}function ZM(e){return!1!==e&&QM(e)}function $M(e){return!!e&&"object"===Tg(e)}function XM(e,t){var r,a=Tg(e),n=Tg(t);return e&&t&&"object"===a&&a===n?Jy(e).length===Jy(t).length&&mD(r=Jy(e)).call(r,(function(r){return XM(e[r],t[r])})):e===t}function eL(e){return!ZM(e)||(!(!("number"==typeof(t=e)||$M(t)&&"[object Number]"===GM.call(t))||0!==e&&!YM(e))||(!(!JM(e)&&!function(e){return"string"==typeof e||$M(e)&&"[object String]"===GM.call(e)}(e)||0!==e.length)||!(!$M(e)||0!==Jy(e).length)));var t}function tL(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];var a=t,n=a.shift();return function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];return n.apply(this,Bb(a).call(a,t))}}var rL,aL,nL,oL,iL=function(e){return JM(e)&&e.length?e:DD},lL="undefined"!=typeof window&&window.console&&window.console.error&&rk(rL=window.console.error).call(rL,window.console);"undefined"!=typeof window&&window.console&&window.console.info&&rk(aL=window.console.info).call(aL,window.console);var cL="undefined"!=typeof window&&window.console&&window.console.log&&rk(nL=window.console.log).call(nL,window.console),sL="undefined"!=typeof window&&window.console&&window.console.warn&&rk(oL=window.console.warn).call(oL,window.console);function uL(e){var t,r,a,n,o;this.config.cardGroupTypes=iL(e.cardGroupTypes);var i=e.loadingContext;if(i){var l;this.config.loadingContext="/"===(l=i).charAt(l.length-1)?i:"".concat(i,"/"),this.config.isCreditCardType=!1===Eb(ID).call(ID,e.type),this.config.iframeUIConfig=e.iframeUIConfig,this.config.allowedDOMAccess=!(!1===e.allowedDOMAccess||"false"===e.allowedDOMAccess),this.config.autoFocus=!(!1===e.autoFocus||"false"===e.autoFocus),this.config.showWarnings=!0===e.showWarnings||"true"===e.showWarnings,this.config.trimTrailingSeparator=!(!1===e.trimTrailingSeparator||"false"===e.trimTrailingSeparator),this.config.keypadFix=!(!1===e.keypadFix||"false"===e.keypadFix),this.config.legacyInputMode=e.legacyInputMode||null,this.config.minimumExpiryDate=e.minimumExpiryDate||null,this.config.implementationType=e.implementationType,this.config.isCollatingErrors=e.isCollatingErrors,this.config.sfLogAtStart=!0===window._b$dl;var c=this.config.isCreditCardType?"card":e.type;hC(c).call(c,"sepa")>-1&&(c="iban");var s=btoa(window.location.origin),u=!!e.forceCompat||!("function"==typeof window.TextEncoder),d=Bb(t="".concat(c)).call(t,u?"Compat":"");this.config.iframeSrc=Bb(r=Bb(a=Bb(n=Bb(o="".concat(this.config.loadingContext,"securedfields/")).call(o,e.clientKey,"/")).call(n,AD,"/securedFields.html?type=")).call(a,d,"&d=")).call(r,s),this.config.maskSecurityCode=e.maskSecurityCode,this.config.disableIOSArrowKeys=e.disableIOSArrowKeys}else sL("WARNING Config :: no loadingContext has been specified!")}var dL=function(){};function pL(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};this.callbacks.onLoad=e.onLoad?e.onLoad:dL,this.callbacks.onConfigSuccess=e.onConfigSuccess?e.onConfigSuccess:dL,this.callbacks.onFieldValid=e.onFieldValid?e.onFieldValid:dL,this.callbacks.onAllValid=e.onAllValid?e.onAllValid:dL,this.callbacks.onBrand=e.onBrand?e.onBrand:dL,this.callbacks.onError=e.onError?e.onError:dL,this.callbacks.onFocus=e.onFocus?e.onFocus:dL,this.callbacks.onBinValue=e.onBinValue?e.onBinValue:dL,this.callbacks.onAutoComplete=e.onAutoComplete?e.onAutoComplete:dL,this.callbacks.onAdditionalSFConfig=e.onAdditionalSFConfig?e.onAdditionalSFConfig:dL,this.callbacks.onAdditionalSFRemoved=e.onAdditionalSFRemoved?e.onAdditionalSFRemoved:dL,this.callbacks.onTouchstartIOS=e.onTouchstartIOS?e.onTouchstartIOS:dL}var fL=function(e){return{fieldType:e.fieldType,encryptedFieldName:e.encryptedFieldName,uid:e.uuid,valid:e.isValid,type:e.txVariant,rootNode:e.rootNode}},mL=function(e){var t,r,a,n=e.fieldType,o=e.txVariant,i=e.rootNode,l=n===gD,c=[],s=["encryptedExpiryMonth","encryptedExpiryYear"],u=l?2:1;for(t=0;t<u;t+=1){var d;a=l?s[t]:n,r=Bb(d="".concat(o,"-encrypted-")).call(d,a);var p=fL({fieldType:n,encryptedFieldName:l?a:n,uuid:r,isValid:!1,txVariant:o,rootNode:i});c.push(p)}return c},hL=function(e){var t,r,a,n,o,i=e.fieldType,l=e.txVariant,c=e.rootNode,s=e.encryptedObjArr,u=[];for(t=0;t<s.length;t+=1){var d;n=(a=s[t]).encryptedFieldName,r=Bb(d="".concat(l,"-encrypted-")).call(d,n),o=a.blob;var p=fL({fieldType:i,encryptedFieldName:n,uuid:r,isValid:!0,txVariant:l,rootNode:c});p.blob=o,u.push(p)}return u},vL=function(e,t){var r=[];return e&&"function"==typeof e.querySelectorAll&&(r=OA([]).call(e.querySelectorAll(t))),r},yL=function(e,t){if(e)return e.querySelector(t)},gL=function(e,t){if(e)return e.getAttribute(t)},bL=function(e,t,r,a){if("function"!=typeof e.addEventListener){if(!e.attachEvent)throw new Error(": Unable to bind ".concat(t,"-event"));e.attachEvent("on".concat(t),r)}else e.addEventListener(t,r,a)},kL=function(e,t,r,a){if("function"==typeof e.addEventListener)e.removeEventListener(t,r,a);else{if(!e.attachEvent)throw new Error(": Unable to unbind ".concat(t,"-event"));e.detachEvent("on".concat(t),r)}},CL=function(e,t){var r=yL(e,"#".concat(t));r&&e.removeChild(r)},_L=function(e,t,r){var a,n,o,i,l,c,s,u,d;for(a=0;a<e.length;a+=1){var p,f=e[a];o=f.encryptedFieldName,n=Bb(p="".concat(t,"-encrypted-")).call(p,o),i=f.blob,c=o,s=i,d=void 0,(d=yL(l=r,"#".concat(u=n)))||((d=document.createElement("input")).type="hidden",d.name=c,d.id=u,l.appendChild(d)),d.setAttribute("value",s)}},NL=function(e,t,r,a,n){if(!lA(e,"error"))return null;var o=t,i={rootNode:a,fieldType:e.fieldType,error:null,type:null},l=""!==e.error;return l||o.hasError?o.errorType===lI[$D]?null:(i.error=l?e.error:"",i.type=r,o.hasError=l,o.errorType=i.error,n(i),i):null};function PL(e){var t,r=e.fieldType;if("card"===this.state.type&&lA(e,"cvcPolicy")&&QM(e.cvcPolicy)&&lA(this.state.securedFields,CD)&&(this.state.securedFields[CD].cvcPolicy=e.cvcPolicy),NL(e,this.state.securedFields[r],this.state.type,this.props.rootNode,this.callbacks.onError),this.state.securedFields[r].isEncrypted){t=mL({fieldType:r,txVariant:this.state.type,rootNode:this.props.rootNode}),r===yD&&(t[0].endDigits="");for(var a=0,n=t.length;a<n;a+=1)this.config.allowedDOMAccess&&CL(this.props.rootNode,t[a].uid),this.callbacks.onFieldValid(t[a]);this.state.securedFields[r].isEncrypted=!1}this.validateForm(),lA(e,"brand")&&this.processBrand(e)}var wL,SL=function(e,t,r){if(t){var a=gA(e);t.postMessage(a,r)}};function xL(e,t){var r;return(null===(r=e.securedFields[t])||void 0===r?void 0:r.iframeContentWindow)||null}function EL(e){var t,r,a=e.fieldType;this.config.autoFocus&&("year"!==e.type&&a!==kD||this.setFocusOnFrame(CD),a===bD&&this.setFocusOnFrame(kD));var n=e[a];this.state.securedFields[a].isEncrypted=!0,this.config.allowedDOMAccess&&_L(n,this.state.type,this.props.rootNode),NL({error:"",fieldType:a},this.state.securedFields[a],this.state.type,this.props.rootNode,this.callbacks.onError);var o=hL({fieldType:a,txVariant:this.state.type,rootNode:this.props.rootNode,encryptedObjArr:n});if(a===bD&&lA(this.state.securedFields,kD)){var i={txVariant:this.state.type,code:e.code,blob:n[0].blob,fieldType:kD,numKey:this.state.securedFields[kD].numKey};SL(i,xL(this.state,kD),this.config.loadingContext)}for(a===yD&&ZM(e.endDigits)&&(o[0].endDigits=e.endDigits),a===yD&&ZM(e.issuerBin)&&(o[0].issuerBin=+e.issuerBin),t=0,r=o.length;t<r;t+=1)this.callbacks.onFieldValid(o[t]);this.validateForm()}var AL={__NO_BRAND:"noBrand",cards:[]};AL.cards.push({cardType:"mc",startingRules:[51,52,53,54,55,22,23,24,25,26,27],permittedLengths:[16],pattern:/^(5[1-5][0-9]{0,14}|2[2-7][0-9]{0,14})$/,securityCode:"CVC"}),AL.cards.push({cardType:"visadankort",startingRules:[4571],permittedLengths:[16],pattern:/^(4571)[0-9]{0,12}$/}),AL.cards.push({cardType:"visa",startingRules:[4],permittedLengths:[13,16,19],pattern:/^4[0-9]{0,18}$/,securityCode:"CVV"}),AL.cards.push({cardType:"amex",startingRules:[34,37],permittedLengths:[15],pattern:/^3[47][0-9]{0,13}$/,securityCode:"CID"}),AL.cards.push({cardType:"diners",startingRules:[36],permittedLengths:[14],pattern:/^(36)[0-9]{0,12}$/}),AL.cards.push({cardType:"maestrouk",startingRules:[6759],permittedLengths:[16,18,19],pattern:/^(6759)[0-9]{0,15}$/}),AL.cards.push({cardType:"solo",startingRules:[6767],permittedLengths:[16,18,19],pattern:/^(6767)[0-9]{0,15}$/}),AL.cards.push({cardType:"laser",startingRules:[6304,6706,677117,677120],permittedLengths:[16,17,18,19],pattern:/^(6304|6706|6709|6771)[0-9]{0,15}$/,cvcPolicy:"optional"}),AL.cards.push({cardType:"discover",startingRules:[6011,644,645,646,647,648,649,65],permittedLengths:[16],pattern:/^(6011[0-9]{0,12}|(644|645|646|647|648|649)[0-9]{0,13}|65[0-9]{0,14})$/}),AL.cards.push({cardType:"jcb",startingRules:[3528,3529,353,354,355,356,357,358],permittedLengths:[16,19],pattern:/^(352[8,9]{1}[0-9]{0,15}|35[4-8]{1}[0-9]{0,16})$/,securityCode:"CAV"}),AL.cards.push({cardType:"bcmc",startingRules:[6703,479658,606005],permittedLengths:[16,17,18,19],pattern:/^((6703)[0-9]{0,15}|(479658|606005)[0-9]{0,13})$/,cvcPolicy:"hidden"}),AL.cards.push({cardType:"bijcard",startingRules:[5100081],permittedLengths:[16],pattern:/^(5100081)[0-9]{0,9}$/}),AL.cards.push({cardType:"dankort",startingRules:[5019],permittedLengths:[16],pattern:/^(5019)[0-9]{0,12}$/}),AL.cards.push({cardType:"hipercard",startingRules:[606282],permittedLengths:[16],pattern:/^(606282)[0-9]{0,10}$/}),AL.cards.push({cardType:"cup",startingRules:[62,81],permittedLengths:[14,15,16,17,18,19],pattern:/^(62|81)[0-9]{0,17}$/}),AL.cards.push({cardType:"maestro",startingRules:[50,56,57,58,6],permittedLengths:[16,17,18,19],pattern:/^(5[0|6-8][0-9]{0,17}|6[0-9]{0,18})$/,cvcPolicy:"optional"}),AL.cards.push({cardType:"elo",startingRules:[506699,50670,50671,50672,50673,50674,50675,50676,506770,506771,506772,506773,506774,506775,506776,506777,506778,401178,438935,451416,457631,457632,504175,627780,636297,636368],permittedLengths:[16],pattern:/^((((506699)|(506770)|(506771)|(506772)|(506773)|(506774)|(506775)|(506776)|(506777)|(506778)|(401178)|(438935)|(451416)|(457631)|(457632)|(504175)|(627780)|(636368)|(636297))[0-9]{0,10})|((50676)|(50675)|(50674)|(50673)|(50672)|(50671)|(50670))[0-9]{0,11})$/}),AL.cards.push({cardType:"uatp",startingRules:[1],permittedLengths:[15],pattern:/^1[0-9]{0,14}$/,cvcPolicy:"optional"}),AL.cards.push({cardType:"cartebancaire",startingRules:[4,5,6],permittedLengths:[16],pattern:/^[4-6][0-9]{0,15}$/}),AL.cards.push({cardType:"visaalphabankbonus",startingRules:[450903],permittedLengths:[16],pattern:/^(450903)[0-9]{0,10}$/}),AL.cards.push({cardType:"mcalphabankbonus",startingRules:[510099],permittedLengths:[16],pattern:/^(510099)[0-9]{0,10}$/}),AL.cards.push({cardType:"hiper",startingRules:[637095,637568,637599,637609,637612],permittedLengths:[16],pattern:/^(637095|637568|637599|637609|637612)[0-9]{0,10}$/}),AL.cards.push({cardType:"oasis",startingRules:[982616],permittedLengths:[16],pattern:/^(982616)[0-9]{0,10}$/,cvcPolicy:"optional"}),AL.cards.push({cardType:"karenmillen",startingRules:[98261465],permittedLengths:[16],pattern:/^(98261465)[0-9]{0,8}$/,cvcPolicy:"optional"}),AL.cards.push({cardType:"warehouse",startingRules:[982633],permittedLengths:[16],pattern:/^(982633)[0-9]{0,10}$/,cvcPolicy:"optional"}),AL.cards.push({cardType:"mir",startingRules:[220],permittedLengths:[16,17,18,19],pattern:/^(220)[0-9]{0,16}$/}),AL.cards.push({cardType:"codensa",startingRules:[590712],permittedLengths:[16],pattern:/^(590712)[0-9]{0,10}$/}),AL.cards.push({cardType:"naranja",startingRules:[377798,377799,402917,402918,527571,527572,589562],permittedLengths:[16,17,18,19],pattern:/^(37|40|5[28])([279])\d*$/}),AL.cards.push({cardType:"cabal",startingRules:[589657,600691,603522,6042,6043,636908],permittedLengths:[16,17,18,19],pattern:/^(58|6[03])([03469])\d*$/}),AL.cards.push({cardType:"shopping",startingRules:[2799,589407,603488],permittedLengths:[16,17,18,19],pattern:/^(27|58|60)([39])\d*$/}),AL.cards.push({cardType:"argencard",startingRules:[501],permittedLengths:[16,17,18,19],pattern:/^(50)(1)\d*$/}),AL.cards.push({cardType:"troy",startingRules:[9792],permittedLengths:[16],pattern:/^(97)(9)\d*$/}),AL.cards.push({cardType:"forbrugsforeningen",startingRules:[600722],permittedLengths:[16],pattern:/^(60)(0)\d*$/}),AL.cards.push({cardType:"vpay",startingRules:[401,408,413,434,435,437,439,441,442,443,444,446,447,455,458,460,461,463,466,471,479,482,483,487],permittedLengths:[13,14,15,16,17,18,19],pattern:/^(40[1,8]|413|43[4,5]|44[1,2,3,4,6,7]|45[5,8]|46[0,1,3,6]|47[1,9]|48[2,3,7])[0-9]{0,16}$/}),AL.cards.push({cardType:"rupay",startingRules:[508528],permittedLengths:[16],pattern:/^(100003|508(2|[5-9])|60(69|[7-8])|652(1[5-9]|[2-5][0-9]|8[5-9])|65300[3-4]|8172([0-1]|[3-5]|7|9)|817(3[3-8]|40[6-9]|410)|35380([0-2]|[5-6]|9))[0-9]{0,12}$/});var DL={detectCard:function(e,t){var r,a,n;if(t){var o,i;if((r=nb(o=nb(i=AL.cards).call(i,(function(e){return Eb(t).call(t,e.cardType)}))).call(o,(function(t){return lA(t,"pattern")&&e.match(t.pattern)}))).length){if(1===r.length)return r[0];for(a=0,n=r.length;a<n;a+=1)if(!r[a].longestRule){var l,c=DC(l=r[a].startingRules).call(l,(function(e,t){return e>t?e:t}));r[a].longestRule=String(c).length}return DC(r).call(r,(function(e,t){return e.longestRule>=t.longestRule?e:t}))}return{cardType:AL.__NO_BRAND}}return{cardType:AL.__NO_BRAND}},detectCardLength:function(e,t){var r,a,n,o=0,i=!1,l=t,c=e.cardType!==AL.__NO_BRAND?e.permittedLengths[e.permittedLengths.length-1]:0;if(c&&l>c&&(o=l.length-c)>0&&(n=l=l.substring(0,l.length-o)),Jg(r=e.permittedLengths).call(r,(function(e){l.length===e&&(i=!0)})),l.length===c){var s=Math.floor(l.length/4);a=c+(l.length%4>0?s:s-1),"amex"===e.cardType.toLowerCase()&&(a=c+2)}return{shortenedNewValue:n,maxLength:a,reachedValidLength:i}},getShortestPermittedCardLength:function(){if(!wL){var e,t=[];Jg(e=AL.cards).call(e,(function(e){t=Bb(t).call(t,e.permittedLengths)})),wL=Math.min.apply(null,t)}return wL},getCardByBrand:function(e){var t;return nb(t=AL.cards).call(t,(function(t){return t.cardType===e}))[0]},isGenericCardType:function(e){if(!e)throw new Error("Error: isGenericCardType: type param has not been specified");return"card"===e||"scheme"===e},__NO_BRAND:AL.__NO_BRAND,allCards:AL.cards};function IL(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function FL(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=IL(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=IL(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}var RL=function(e){var t,r=(Wg(t={},yD,e.get&&e.get("creditCard.numberField.placeholder")),Wg(t,gD,e.get&&e.get("creditCard.expiryDateField.placeholder")),Wg(t,bD,e.get&&e.get("creditCard.expiryDateField.month.placeholder")),Wg(t,kD,e.get&&e.get("creditCard.expiryDateField.year.placeholder")),Wg(t,CD,e.get&&e.get("creditCard.cvcField.placeholder")),Wg(t,SD,e.get&&e.get("creditCard.cvcField.placeholder.3digits")),Wg(t,xD,e.get&&e.get("creditCard.cvcField.placeholder.4digits")),Wg(t,_D,e.get&&e.get("creditCard.encryptedPassword.placeholder")),Wg(t,PD,e.get&&e.get("ach.accountNumberField.placeholder")),Wg(t,wD,e.get&&e.get("ach.accountLocationId.placeholder")),t);return"ach.accountNumberField.placeholder"===r[PD]&&(r[PD]=""),"ach.accountLocationId.placeholder"===r[wD]&&(r[wD]=""),r},OL=function(e,t){var r="card"===e?"nocard":e||"nocard";return GP({type:r,extension:"svg",loadingContext:t})(r)};function TL(e){return"object"===Tg(e)&&null!==e&&"[object Array]"===Object.prototype.toString.call(e)}function BL(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];var a=TL(t[0])?t[0]:t;return{from:function(e){var t;return DC(t=QC(a).call(a,(function(t){return t in e?Wg({},t,e[t]):{}}))).call(t,(function(e,t){return FL(FL({},e),t)}),{})}}}function jL(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];var a=TL(t[0])?t[0]:t;return{from:function(e){var t,r=nb(t=Jy(e)).call(t,(function(e){return!Eb(a).call(a,e)}));return BL.apply(void 0,rC(r)).from(e)}}}function zL(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}var ML=function(e){var t,r=lI[e];return r||((r=yk(t=Jy(lI)).call(t,(function(t){return lI[t]===e})))||e)},LL=function(e,t){var r=function(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=zL(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=zL(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}({},e);return r.error=r.error?r.error:function(e){var t=Jy(lI);return DC(t).call(t,(function(t,r){var a=lI[r];return(hC(a).call(a,"sf-")>-1||hC(a).call(a,"gen.01")>-1)&&(t[a]=e.get(a)),t}),{})}(t),r};function VL(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function UL(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=VL(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=VL(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}function KL(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function HL(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=KL(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=KL(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}function qL(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function WL(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=qL(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=qL(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}function YL(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}var GL,JL=function(e){TN(r,e);var t=YL(r);function r(e,a){var n;Bg(this,r),n=t.call(this);var o=["fieldType","iframeSrc","cvcPolicy","expiryDatePolicy","loadingContext","holderEl"],i=jL(o).from(e);n.sfConfig=WL(WL(WL({},n.sfConfig),i),{},{iframeUIConfig:WL({},i.iframeUIConfig)});var l=BL(o).from(e);return n.fieldType=l.fieldType,n.cvcPolicy=l.cvcPolicy,n.expiryDatePolicy=l.expiryDatePolicy,n.iframeSrc=l.iframeSrc,n.loadingContext=l.loadingContext,n.holderEl=l.holderEl,n.isValid=!1,n.iframeContentWindow=null,n.numKey=function(){if(!window.crypto)return 4294967296*Math.random()|0;var e=new Uint32Array(1);return window.crypto.getRandomValues(e),e[0]}(),n.isEncrypted=!1,n.hasError=!1,n.errorType="",BN(n,n.init(a))}return qg(r,[{key:"init",value:function(e){var t=function(e,t,r){var a,n,o,i=Eb(a=["ach","giftcard"]).call(a,e.txVariant)?e.txVariant:"creditCard",l=r.get(Bb(n="".concat(i,".")).call(n,t,".aria.iframeTitle")),c=r.get(Bb(o="".concat(i,".")).call(o,t,".aria.label")),s=r.locale,u=LL({iframeTitle:l,label:c},r);return UL(UL({},s&&{lang:s}),{},Wg({},t,u))}(this.sfConfig,this.fieldType,e);this.sfConfig.iframeUIConfig.ariaConfig=t;var r=function(e,t,r){var a,n=e.txVariant,o=RL(r);return HL(HL(HL({},t!==CD&&Wg({},t,o[t])),t===CD&&n===ED&&Wg({},t,o[t])),t===CD&&n!==ED&&(Wg(a={},SD,o[SD]),Wg(a,xD,o[xD]),a))}(this.sfConfig,this.fieldType,e);this.sfConfig.iframeUIConfig.placeholders=r;var a=function(e){var t=e.src,r=e.title,a=void 0===r?"iframe element":r,n=e.policy,o=void 0===n?"origin":n,i=e.styleStr,l=void 0===i?"border: none; height:100%; width:100%; overflow:hidden;":i,c=document.createElement("iframe");c.setAttribute("src",t),c.setAttribute("class","js-iframe"),""===a||0===OI(a).call(a).length||"none"===a?c.setAttribute("role","presentation"):c.setAttribute("title",a),c.setAttribute("allowtransparency","true"),c.setAttribute("style",l),c.setAttribute("referrerpolicy",o);var s=document.createTextNode("<p>Your browser does not support iframes.</p>");return c.appendChild(s),c}({src:this.iframeSrc,title:t[this.fieldType].iframeTitle,policy:"origin"});this.holderEl.appendChild(a);var n=yL(this.holderEl,".js-iframe");return n&&(this.iframeContentWindow=n.contentWindow,this.iframeOnLoadListener=this.iframeOnLoadListenerFn,bL(n,"load",this.iframeOnLoadListener,!1)),this.iframeRef=n,this}},{key:"iframeOnLoadListenerFn",value:function(){this.postMessageListener=this.postMessageListenerFn,bL(window,"message",this.postMessageListener,!1);var e={fieldType:this.fieldType,extraFieldData:this.sfConfig.extraFieldData,uid:this.sfConfig.uid,cvcPolicy:this.cvcPolicy,expiryDatePolicy:this.expiryDatePolicy,numKey:this.numKey,txVariant:this.sfConfig.txVariant,cardGroupTypes:this.sfConfig.cardGroupTypes,iframeUIConfig:this.sfConfig.iframeUIConfig,sfLogAtStart:this.sfConfig.sfLogAtStart,trimTrailingSeparator:this.sfConfig.trimTrailingSeparator,isCreditCardType:this.sfConfig.isCreditCardType,showWarnings:this.sfConfig.showWarnings,legacyInputMode:this.sfConfig.legacyInputMode,minimumExpiryDate:this.sfConfig.minimumExpiryDate,implementationType:this.sfConfig.implementationType,isCollatingErrors:this.sfConfig.isCollatingErrors,maskSecurityCode:this.sfConfig.maskSecurityCode,disableIOSArrowKeys:this.sfConfig.disableIOSArrowKeys};window._b$dl&&console.log("### SecuredField:::: onIframeLoaded:: created configObj=",e),SL(e,this.iframeContentWindow,this.loadingContext),this.onIframeLoadedCallback()}},{key:"postMessageListenerFn",value:function(e){if(function(e,t,r){var a=e.origin,n=hC(t).call(t,"/checkoutshopper/"),o=n>-1?t.substring(0,n):t,i=o.length-1;return"/"===o.charAt(i)&&(o=o.substring(0,i)),a===o||(r&&(sL("WARNING postMessageValidation: postMessage listener for iframe::origin mismatch!\n Received message with origin:",a,"but the only allowed origin for messages to CSF is",o),sL("### event.data=",e.data)),!1)}(e,this.loadingContext,this.sfConfig.showWarnings)){var t;try{t=JSON.parse(e.data)}catch(t){return function(e){var t;return e.data&&e.data.type&&"string"==typeof e.data.type&&hC(t=e.data.type).call(t,"webpack")>-1}(e)?void(this.sfConfig.showWarnings&&cL("### SecuredField::postMessageListenerFn:: PARSE FAIL - WEBPACK")):function(e){var t;return e.data&&"string"==typeof e.data&&hC(t=e.data).call(t,"cvox")>-1}(e)?void(this.sfConfig.showWarnings&&cL("### SecuredField::postMessageListenerFn:: PARSE FAIL - CHROMEVOX")):void(this.sfConfig.showWarnings&&cL("### SecuredField::postMessageListenerFn:: PARSE FAIL - UNKNOWN REASON: event.data=",e.data))}if(lA(t,"action")&&lA(t,"numKey"))if(this.numKey===t.numKey)switch(t.action){case"encryption":this.isValid=!0,this.onEncryptionCallback(t);break;case"config":window._b$dl&&console.log("### SecuredField::postMessageListenerFn:: configured - calling onConfigCallback",t.fieldType),this.onConfigCallback(t);break;case"focus":this.onFocusCallback(t);break;case"binValue":this.onBinValueCallback(t);break;case"touch":this.onTouchstartCallback(t);break;case"shifttab":this.onShiftTabCallback(t);break;case"autoComplete":this.onAutoCompleteCallback(t);break;default:this.isValid=!1,this.onValidationCallback(t)}else this.sfConfig.showWarnings&&sL("WARNING SecuredField :: postMessage listener for iframe :: data mismatch! (Probably a message from an unrelated securedField)");else this.sfConfig.showWarnings&&sL("WARNING SecuredField :: postMessage listener for iframe :: data mismatch!")}}},{key:"destroy",value:function(){kL(window,"message",this.postMessageListener,!1),kL(this.iframeRef,"load",this.iframeOnLoadListener,!1),this.iframeContentWindow=null,function(e){for(;e.firstChild;)e.removeChild(e.firstChild)}(this.holderEl)}},{key:"isOptionalOrHidden",value:function(){if(this.fieldType===gD||this.fieldType===bD||this.fieldType===kD)switch(this.expiryDatePolicy){case qD:return!0;case HD:return!this.hasError;default:return!1}if(this.fieldType===CD)switch(this.cvcPolicy){case UD:return!0;case VD:return!this.hasError;default:return!1}return!1}},{key:"onIframeLoaded",value:function(e){return this.onIframeLoadedCallback=e,this}},{key:"onEncryption",value:function(e){return this.onEncryptionCallback=e,this}},{key:"onValidation",value:function(e){return this.onValidationCallback=e,this}},{key:"onConfig",value:function(e){return this.onConfigCallback=e,this}},{key:"onFocus",value:function(e){return this.onFocusCallback=e,this}},{key:"onBinValue",value:function(e){return this.onBinValueCallback=e,this}},{key:"onTouchstart",value:function(e){return this.onTouchstartCallback=e,this}},{key:"onShiftTab",value:function(e){return this.onShiftTabCallback=e,this}},{key:"onAutoComplete",value:function(e){return this.onAutoCompleteCallback=e,this}},{key:"errorType",get:function(){return this._errorType},set:function(e){this._errorType=e}},{key:"hasError",get:function(){return this._hasError},set:function(e){this._hasError=e}},{key:"isValid",get:function(){if(this.fieldType===CD)switch(this.cvcPolicy){case UD:return!0;case VD:return!this.hasError;default:return this._isValid}if(this.fieldType===gD||this.fieldType===bD||this.fieldType===kD)switch(this.expiryDatePolicy){case qD:return!0;case HD:return!this.hasError;default:return this._isValid}return this._isValid},set:function(e){this._isValid=e}},{key:"cvcPolicy",get:function(){return this._cvcPolicy},set:function(e){this.fieldType===CD&&e!==this.cvcPolicy&&(this._cvcPolicy=e,this.hasError&&"isValidated"===this.errorType&&(this.hasError=!1))}},{key:"expiryDatePolicy",get:function(){return this._expiryDatePolicy},set:function(e){this.fieldType!==gD&&this.fieldType!==bD&&this.fieldType!==kD||e!==this.expiryDatePolicy&&(this._expiryDatePolicy=e,this.hasError&&"isValidated"===this.errorType&&(this.hasError=!1))}},{key:"iframeContentWindow",get:function(){return this._iframeContentWindow},set:function(e){this._iframeContentWindow=e}},{key:"isEncrypted",get:function(){return this._isEncrypted},set:function(e){this._isEncrypted=e}},{key:"numKey",get:function(){return this._numKey},set:function(e){this._numKey=e}},{key:"iframeOnLoadListener",get:function(){return this._iframeOnLoadListener},set:function(e){this._iframeOnLoadListener=rk(e).call(e,this)}},{key:"postMessageListener",get:function(){return this._postMessageListener},set:function(e){this._postMessageListener=rk(e).call(e,this)}}]),r}(qg((function e(){Bg(this,e),Wg(this,"sfConfig",void 0),Wg(this,"fieldType",void 0),Wg(this,"iframeSrc",void 0),Wg(this,"loadingContext",void 0),Wg(this,"holderEl",void 0),Wg(this,"iframeRef",void 0),Wg(this,"loadToConfigTimeout",void 0),Wg(this,"_errorType",void 0),Wg(this,"_hasError",void 0),Wg(this,"_isValid",void 0),Wg(this,"_cvcPolicy",void 0),Wg(this,"_expiryDatePolicy",void 0),Wg(this,"_iframeContentWindow",void 0),Wg(this,"_isEncrypted",void 0),Wg(this,"_numKey",void 0),Wg(this,"_iframeOnLoadListener",void 0),Wg(this,"_postMessageListener",void 0),Wg(this,"onIframeLoadedCallback",void 0),Wg(this,"onConfigCallback",void 0),Wg(this,"onEncryptionCallback",void 0),Wg(this,"onValidationCallback",void 0),Wg(this,"onFocusCallback",void 0),Wg(this,"onBinValueCallback",void 0),Wg(this,"onTouchstartCallback",void 0),Wg(this,"onShiftTabCallback",void 0),Wg(this,"onAutoCompleteCallback",void 0),this.sfConfig={}})));function QL(){this.encryptedAttrName=WD;var e=vL(this.props.rootNode,"[".concat(this.encryptedAttrName,"]"));return GL=LD,this.config.isCreditCardType?(this.isSingleBrandedCard=!1,this.securityCode="",this.createCardSecuredFields(e),e.length):(this.createNonCardSecuredFields(e),e.length)}function ZL(e){return $L.apply(this,arguments)}function $L(){return $L=$d(Ky.mark((function e(t){var r,a;return Ky.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:r=0;case 1:if(!(r<t.length)){e.next=8;break}return a=t[r],e.next=5,this.setupSecuredField(a).catch((function(e){window._b$dl&&console.log("Secured fields setup failure. e=",e)}));case 5:r++,e.next=1;break;case 8:case"end":return e.stop()}}),e,this)}))),$L.apply(this,arguments)}function XL(e){return eV.apply(this,arguments)}function eV(){return eV=$d(Ky.mark((function e(t){var r,a,n,o,i,l=this;return Ky.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:"card"===(r=this.state.type)&&1===this.config.cardGroupTypes.length&&(r=this.config.cardGroupTypes[0],this.state.type=r),this.isSingleBrandedCard="card"!==r,this.isSingleBrandedCard&&(QM(a=DL.getCardByBrand(r))?(GL=a.cvcPolicy||LD,this.securityCode=a.securityCode):this.state.type="unrecognised-single-brand"),n=0;case 5:if(!(n<t.length)){e.next=14;break}return o=t[n],window._b$dl&&console.log("\nAbout to set up securedField:",o),e.next=10,this.setupSecuredField(o).catch((function(e){window._b$dl&&console.log("Secured fields setup failure. e=",e)}));case 10:window._b$dl&&console.log("Finished setting up securedField:",o);case 11:n++,e.next=5;break;case 14:window._b$dl&&console.log("Finished setting up all securedFields"),this.isSingleBrandedCard&&(i={type:this.state.type,rootNode:this.props.rootNode,brand:r,cvcPolicy:GL,cvcText:this.securityCode},hw((function(){l.callbacks.onBrand(i)}),0));case 16:case"end":return e.stop()}}),e,this)}))),eV.apply(this,arguments)}function tV(e){var t=this;return new ok((function(r,a){var n=gL(e,t.encryptedAttrName);n===kD&&(t.state.hasSeparateDateFields=!0);var o={fieldType:n,extraFieldData:gL(e,YD),uid:gL(e,GD),cvcPolicy:GL,holderEl:e,expiryDatePolicy:KD,txVariant:t.state.type,cardGroupTypes:t.config.cardGroupTypes,iframeUIConfig:t.config.iframeUIConfig?t.config.iframeUIConfig:{},sfLogAtStart:t.config.sfLogAtStart,trimTrailingSeparator:t.config.trimTrailingSeparator,isCreditCardType:t.config.isCreditCardType,iframeSrc:t.config.iframeSrc,loadingContext:t.config.loadingContext,showWarnings:t.config.showWarnings,legacyInputMode:t.config.legacyInputMode,minimumExpiryDate:t.config.minimumExpiryDate,implementationType:t.config.implementationType,isCollatingErrors:t.config.isCollatingErrors,maskSecurityCode:t.config.maskSecurityCode,disableIOSArrowKeys:t.config.disableIOSArrowKeys},i=new JL(o,t.props.i18n).onIframeLoaded((function(){var e;if(t.state.iframeCount+=1,window._b$dl&&console.log("### createSecuredFields::onIframeLoaded:: this.state.iframeCount=",t.state.iframeCount),t.state.iframeCount>t.state.numIframes)throw t.destroySecuredFields(),new iA("ERROR",Bb(e="One or more securedFields has just loaded new content. This should never happen. securedFields have been removed.\n                        iframe load count=".concat(t.state.iframeCount,". Expected count:")).call(e,t.state.numIframes));if(i.loadToConfigTimeout=hw((function(){a({type:i.fieldType,failReason:"sf took too long to config"})}),6e3),t.state.iframeCount===t.state.originalNumIframes){t.callbacks.onLoad({iframesLoaded:!0})}})).onConfig((function(e){t.handleIframeConfigFeedback(e),clearTimeout(i.loadToConfigTimeout),i.loadToConfigTimeout=null,r(e)})).onFocus((function(e){t.handleFocus(e)})).onBinValue((function(e){t.handleBinValue(e)})).onTouchstart((function(e){t.config.disableIOSArrowKeys&&t.callbacks.onTouchstartIOS({fieldType:e.fieldType}),t.postMessageToAllIframes({fieldType:e.fieldType,fieldClick:!0})})).onShiftTab((function(e){t.handleSFShiftTab(e.fieldType)})).onEncryption((function(e){t.handleEncryption(e)})).onValidation((function(e){t.handleValidation(e)})).onAutoComplete((function(e){t.processAutoComplete(e)}));t.state.securedFields[n]=i}))}var rV="undefined"!=typeof navigator&&/(android)/i.test(navigator.userAgent),aV="undefined"!=typeof navigator&&function(){var e=navigator.userAgent,t=hC(e).call(e,"MSIE ");if(t>0)return O_(e.substring(t+5,hC(e).call(e,".",t)),10);if(hC(e).call(e,"Trident/")>0){var r=hC(e).call(e,"rv:");return O_(e.substring(r+3,hC(e).call(e,".",r)),10)}var a=hC(e).call(e,"Edge/");return a>0&&O_(e.substring(a+5,hC(e).call(e,".",a)),10)}(),nV={__IS_ANDROID:rV,__IS_IE:aV,__IS_IOS:"undefined"!=typeof navigator&&/iphone|ipod|ipad/i.test(navigator.userAgent),__IS_FIREFOX:"undefined"!=typeof navigator&&/(firefox)/i.test(navigator.userAgent),__IS_SAFARI:"undefined"!=typeof navigator&&/(safari)/i.test(navigator.userAgent)&&!/(chrome)/i.test(navigator.userAgent)},oV=function(e){return"selectionStart"in e?e.selectionStart:0};var iV=function(e){var t=e.target;if(t instanceof HTMLInputElement||HTMLTextAreaElement&&t instanceof HTMLTextAreaElement){var r=t.value,a=oV(t),n=!1;a===r.length&&(a-=1,n=!0),t.value=r,t.setSelectionRange&&(t.focus(),t.setSelectionRange(a,a),n&&(a+=1,hw((function(){t.setSelectionRange(a,a)}),0)))}else{if(this.config.keypadFix){var o=this.props.rootNode,i=document.createElement("input");i.style.width="1px",i.style.height="1px",i.style.opacity="0",i.style.fontSize="18px",o.appendChild(i),i.focus(),o.removeChild(i)}}this.destroyTouchendListener(),this.state.registerFieldForIos=!1,this.postMessageToAllIframes({fieldType:"webInternalElement",fieldClick:!0})},lV=function(e){var t=e.target;if(t instanceof HTMLInputElement||t instanceof HTMLSpanElement){var r,a,n;this.postMessageToAllIframes({fieldType:"webInternalElement",checkoutTouchEvent:!0});var o=null!==(r=t.getAttribute("name"))&&void 0!==r?r:t.getAttribute("data-id");null===(a=(n=this.callbacks).onTouchstartIOS)||void 0===a||a.call(n,{fieldType:"webInternalElement",name:o})}},cV=function(){var e=yL(document,"body");e.style.cursor="pointer",bL(e,"touchend",this.touchendListener),this.state.registerFieldForIos=!0},sV=function(){if(nV.__IS_IOS){var e=yL(document,"body");e.style.cursor="auto",kL(e,"touchend",this.touchendListener)}},uV=function(){nV.__IS_IOS&&kL(document,"touchstart",this.touchstartListener)},dV=function(e,t,r){return function(e){var t=!(arguments.length>1&&void 0!==arguments[1])||arguments[1],r=OA(Array.prototype).call(vL(document,"*[data-cse], a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), object, embed, *[tabindex], *[contenteditable]")),a=[];Jg(r).call(r,(function(e){var t=e.getAttribute("tabindex"),r=!t||O_(t,10)>=0,n=e.getBoundingClientRect(),o=n.width>0&&n.height>0;r&&o&&a.push(e)}));var n=function(e,t){for(var r=0;r<e.length;r+=1)if(t(e[r]))return r;return-1}(a,(function(t){return t===e||e.contains(t)}));return a[n+(t?-1:1)]}(yL(t,"[data-cse=".concat(e,"]")),r)};var pV=!1,fV=function(e){e&&(e.focus(),e.blur(),e.focus())};var mV=function(){return nV.__IS_FIREFOX||nV.__IS_IE&&nV.__IS_IE<=11};var hV=function(e){var t;switch(this.state.type){case"ach":t=function(e){var t;return e===wD&&(t=PD),{fieldToFocus:t,additionalField:void 0}}(e);break;case"giftcard":t=function(e,t){var r,a;switch(e){case yD:r=dV(yD,t);break;case CD:a=yD}return{fieldToFocus:a,additionalField:r}}(e,this.props.rootNode);break;default:t=this.state.isKCP?function(e,t,r){var a,n;switch(e){case yD:a=dV(yD,t);break;case gD:case bD:n=yD;break;case kD:n=bD;break;case CD:n=r?kD:gD;break;case _D:case ND:a=dV(e,t)}return{fieldToFocus:n,additionalField:a}}(e,this.props.rootNode,this.state.hasSeparateDateFields):function(e,t,r,a){var n,o;switch(e){case yD:n=dV(yD,t);break;case gD:case bD:o=yD;break;case kD:o=bD;break;case CD:1===a?n=dV(CD,t):o=r?kD:gD}return{fieldToFocus:o,additionalField:n}}(e,this.props.rootNode,this.state.hasSeparateDateFields,this.state.numIframes)}var r=t.fieldToFocus,a=t.additionalField;r?this.setFocusOnFrame(r,pV):a&&fV(a)},vV=function(e){mV()&&this.handleShiftTab(e)};function yV(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function gV(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=yV(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=yV(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}function bV(e){if(lA(this.state.securedFields,yD)){var t=gV(gV({txVariant:this.state.type},e),{},{fieldType:yD,numKey:this.state.securedFields[yD].numKey});SL(t,xL(this.state,yD),this.config.loadingContext)}}function kV(e){var t=this,r=lA(this.state.securedFields,bD)&&lA(this.state.securedFields,kD)?[bD,kD]:[gD];Jg(r).call(r,(function(r){var a=gV(gV({txVariant:t.state.type},e),{},{fieldType:r,numKey:t.state.securedFields[r].numKey});SL(a,xL(t.state,r),t.config.loadingContext)}))}function CV(e,t){var r,a,n="card"===this.state.type;if(!e||!Jy(e).length)return n?(this.sendBrandToCardSF({brand:"reset"}),this.sendExpiryDatePolicyToSF({expiryDatePolicy:KD})):t&&this.processBrand(gV(gV({},t),{},{fieldType:yD})),void("card"===this.state.type&&lA(this.state.securedFields,gD)&&(this.state.securedFields[gD].expiryDatePolicy=KD));var o=e.supportedBrands[0],i=o.brand,l=null!==(r=o.expiryDatePolicy)&&void 0!==r?r:!0===o.showExpiryDate?KD:qD,c={brand:i,cvcPolicy:o.cvcPolicy,expiryDatePolicy:l,cvcText:"Security code",showSocialSecurityNumber:null!==(a=o.showSocialSecurityNumber)&&void 0!==a&&a,fieldType:yD};if(this.processBrand(c),n){var s=gV({brand:i,enableLuhnCheck:!1!==e.supportedBrands[0].enableLuhnCheck},(null==o?void 0:o.panLength)&&{panLength:null==o?void 0:o.panLength});this.sendBrandToCardSF(s),this.sendExpiryDatePolicyToSF({expiryDatePolicy:l})}lA(this.state.securedFields,CD)&&(this.state.securedFields[CD].cvcPolicy=o.cvcPolicy),lA(this.state.securedFields,gD)?this.state.securedFields[gD].expiryDatePolicy=l:lA(this.state.securedFields,bD)&&lA(this.state.securedFields,kD)&&(this.state.securedFields[bD].expiryDatePolicy=l,this.state.securedFields[kD].expiryDatePolicy=l),this.validateForm()}function _V(e,t,r){var a=e.csfState,n=e.csfConfig;if(lA(a.securedFields,t)){var o={txVariant:a.type,fieldType:t,focus:!0,numKey:a.securedFields[t].numKey};SL(o,xL(a,t),n.loadingContext)}}function NV(e,t){var r=e.csfState,a=e.csfConfig,n=Jy(t||{});if(n.length){var o=Jy(r.securedFields);Jg(o).call(o,(function(e){var o={txVariant:r.type,fieldType:e,numKey:r.securedFields[e].numKey};Jg(n).call(n,(function(e){o[e]=t[e]})),SL(o,xL(r,e),a.loadingContext)}))}}var PV=function(e,t){return!XM(e,t)};function wV(e,t){var r=e.csfState,a=e.csfConfig,n=e.csfProps,o=e.csfCallbacks;if(t.fieldType===yD){var i={brand:t.brand,cvcPolicy:t.cvcPolicy,expiryDatePolicy:t.expiryDatePolicy,showSocialSecurityNumber:t.showSocialSecurityNumber},l=PV(i,r.brand);if(!l)return null;var c="card"===r.type||"bcmc"===r.type;if(c&&l&&(r.brand=i,lA(r.securedFields,CD))){var s={txVariant:r.type,brand:i.brand,fieldType:CD,cvcPolicy:t.cvcPolicy,numKey:r.securedFields[CD].numKey};SL(s,xL(r,CD),a.loadingContext)}var u=c?BL(["brand","cvcPolicy","cvcText","expiryDatePolicy","showSocialSecurityNumber"]).from(t):null;if(u&&u.brand){var d=u;d.type=r.type,d.rootNode=n.rootNode,o.onBrand(d)}return!0}return!1}function SV(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function xV(e,t){var r=e.csfState,a=e.csfConfig,n=e.csfCallbacks;if("cc-name"===t.name){var o=function(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=SV(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=SV(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}({},t);delete o.numKey;var i=o;n.onAutoComplete(i)}if("cc-exp"===t.name){var l,c=t.value.replace(/[^0-9]/gi,"/").split("/");if(2!==c.length)return;1===c[0].length&&(c[0]="0".concat(c[0]));var s=c[0],u=c[1].substr(2),d=Bb(l="".concat(s,"/")).call(l,u);if(lA(r.securedFields,gD)){var p={txVariant:r.type,fieldType:gD,autoComplete:d,numKey:r.securedFields[gD].numKey};return void SL(p,xL(r,gD),a.loadingContext)}if(lA(r.securedFields,bD)){var f={txVariant:r.type,fieldType:bD,autoComplete:s,numKey:r.securedFields[bD].numKey};SL(f,xL(r,bD),a.loadingContext)}lA(r.securedFields,kD)&&hw((function(){var e={txVariant:r.type,fieldType:kD,autoComplete:u,numKey:r.securedFields[kD].numKey};SL(e,xL(r,kD),a.loadingContext)}),0)}}function EV(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function AV(e,t){var r=e.csfState,a=e.csfProps,n=e.csfCallbacks,o=function(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=EV(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=EV(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}({},t);delete o.numKey,o.rootNode=a.rootNode,o.type=r.type;var i=o.fieldType;o.focus?r.currentFocusObject!==i&&(r.currentFocusObject=i,nV.__IS_IOS&&!r.registerFieldForIos&&this.handleIOSTouchEvents()):r.currentFocusObject===i&&(r.currentFocusObject=null);var l=o;l.currentFocusObject=r.currentFocusObject,n.onFocus(l)}function DV(e,t,r){var a=e.csfState,n=e.csfCallbacks;if(a.iframeConfigCount+=1,window._b$dl&&console.log("### handleIframeConfigFeedback::csfState.iframeConfigCount:: ",a.iframeConfigCount,"who=",r.fieldType),a.isConfigured){var o={additionalIframeConfigured:!0,fieldType:r.fieldType,type:a.type};n.onAdditionalSFConfig(o)}else if(a.iframeConfigCount===a.originalNumIframes)return t(),!0;return!1}function IV(e,t){var r=e.csfState,a=e.csfConfig,n=e.csfProps,o=e.csfCallbacks;r.isConfigured=!0;var i={iframesConfigured:!0,type:r.type,rootNode:n.rootNode};if(o.onConfigSuccess(i),1===r.numIframes&&a.isCreditCardType){if("card"===r.type)return void lL("ERROR: Payment method with a single secured field - but 'type' has not been set to a specific card brand");var l,c=DL.getCardByBrand(r.type);if(c)(null!==(l=c.cvcPolicy)&&void 0!==l?l:LD)!==LD&&t()}}var FV=function(e){for(var t=Jy(e),r=0,a=t.length;r<a;r+=1){if(!e[t[r]].isValid)return!1}return!0};function RV(e){var t=e.csfState,r=e.csfProps,a=e.csfCallbacks,n=FV(t.securedFields),o=n!==t.allValid;if(t.allValid=n,n||o){var i={allValid:n,type:t.type,rootNode:r.rootNode};a.onAllValid(i)}}function OV(e,t){var r=e.csfState,a=e.csfCallbacks,n=t.binValue,o=t.encryptedBin,i=t.uuid,l={binValue:n,type:r.type};o&&(l.encryptedBin=o,l.uuid=i),a.onBinValue(l)}function TV(){var e=this;this.postMessageToAllIframes({destroy:!0});var t=Jy(this.state.securedFields);Jg(t).call(t,(function(t){var r=e.state.securedFields[t];r&&r.destroy(),e.state.securedFields[t]=null})),this.destroyTouchendListener(),this.destroyTouchstartListener(),this.state.securedFields={}}function BV(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}var jV=function(){sL("".concat(arguments.length>0&&void 0!==arguments[0]?arguments[0]:"You cannot use secured fields"," - they are not yet configured. Use the 'onConfigSuccess' callback to know when this has happened."))},zV=function(e){TN(r,e);var t=BV(r);function r(e){var a,n,o;Bg(this,r),(o=t.call(this,e)).state={type:o.props.type,brand:"card"!==o.props.type?{brand:o.props.type,cvcPolicy:"required"}:{brand:null,cvcPolicy:"required"},allValid:void 0,numIframes:0,originalNumIframes:0,iframeCount:0,iframeConfigCount:0,isConfigured:!1,hasSeparateDateFields:!1,currentFocusObject:null,registerFieldForIos:!1,securedFields:{},isKCP:!1};var i={csfState:o.state,csfConfig:o.config,csfProps:o.props,csfCallbacks:o.callbacks};return o.configHandler=uL,o.callbacksHandler=pL,o.validateForm=tL(RV,i),o.isConfigured=tL(IV,i,o.validateForm),o.handleIframeConfigFeedback=tL(DV,i,o.isConfigured),o.processBrand=tL(wV,i),o.handleValidation=PL,o.handleEncryption=EL,o.createSecuredFields=QL,o.createNonCardSecuredFields=ZL,o.createCardSecuredFields=XL,o.setupSecuredField=tV,o.postMessageToAllIframes=tL(NV,i),o.setFocusOnFrame=tL(_V,i),o.handleFocus=tL(AV,i),o.handleIOSTouchEvents=cV,o.touchendListener=rk(a=iV).call(a,RN(o)),o.destroyTouchendListener=sV,o.touchstartListener=rk(n=lV).call(n,RN(o)),o.destroyTouchstartListener=uV,o.handleSFShiftTab=vV,o.handleShiftTab=hV,o.destroySecuredFields=TV,o.processAutoComplete=tL(xV,i),o.handleBinValue=tL(OV,i),o.handleBrandFromBinLookup=CV,o.sendBrandToCardSF=bV,o.sendExpiryDatePolicyToSF=kV,o.init(),o}return qg(r,[{key:"init",value:function(){this.configHandler(this.props),this.callbacksHandler(this.props.callbacks);var e=this.createSecuredFields();this.state.numIframes=this.state.originalNumIframes=e,this.state.isKCP=!!this.props.isKCP,nV.__IS_IOS&&this.config.disableIOSArrowKeys&&bL(document,"touchstart",this.touchstartListener)}},{key:"createReturnObject",value:function(){var e=this;return{updateStyles:function(t){e.state.isConfigured?e.postMessageToAllIframes({styleObject:t}):sL("You cannot update the secured fields styling - they are not yet configured. Use the 'onConfigSuccess' callback to know when this has happened.")},setFocusOnFrame:function(t){e.state.isConfigured?e.setFocusOnFrame(t):jV("You cannot set focus on any secured field")},isValidated:function(t,r){if(e.state.isConfigured){if(lA(e.state.securedFields,t)){e.state.securedFields[t].hasError=!0,""===e.state.securedFields[t].errorType&&(e.state.securedFields[t].errorType="isValidated");var a={txVariant:e.state.type,fieldType:t,externalValidation:!0,code:r,numKey:e.state.securedFields[t].numKey};SL(a,xL(e.state,t),e.config.loadingContext)}}else jV("You cannot set validated on any secured field")},hasUnsupportedCard:function(t,r){if(e.state.isConfigured){if(lA(e.state.securedFields,t)){e.state.securedFields[t].hasError=!!r,e.state.securedFields[t].errorType=r;var a={txVariant:e.state.type,fieldType:t,unsupportedCard:!!r,code:r,numKey:e.state.securedFields[t].numKey};SL(a,xL(e.state,t),e.config.loadingContext)}}else jV("You cannot set hasUnsupportedCard on any secured field")},destroy:function(){e.state.isConfigured?e.destroySecuredFields():jV("You cannot destroy secured fields")},brandsFromBinLookup:function(t,r){if(!e.config.isCreditCardType)return null;e.state.isConfigured?e.handleBrandFromBinLookup(t,r):jV("You cannot set pass brands to secured fields")},addSecuredField:function(t){var r=yL(e.props.rootNode,'[data-cse="'.concat(t,'"]'));r&&(e.state.numIframes+=1,e.setupSecuredField(r))},removeSecuredField:function(t){if(e.state.securedFields[t]){e.state.securedFields[t].destroy(),delete e.state.securedFields[t],e.state.numIframes-=1,e.state.iframeCount-=1;var r={additionalIframeRemoved:!0,fieldType:t,type:e.state.type};e.callbacks.onAdditionalSFRemoved(r)}},setKCPStatus:function(t){e.state.isKCP=t},sfIsOptionalOrHidden:function(t){return e.state.securedFields[t].isOptionalOrHidden()}}}}]),r}(KM);function MV(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}var LV=function(e){if(!e)throw new Error("No securedFields configuration object defined");var t=function(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=MV(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=MV(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}({},e);try{var r=DL.isGenericCardType(t.type);t.type=r?"card":t.type}catch(e){t.type="card"}if(!lA(t,"rootNode"))return lL('ERROR: SecuredFields configuration object is missing a "rootNode" property');if(eL(t.clientKey))return sL('WARNING: AdyenCheckout configuration object is missing a "clientKey" property.');var a=VV(t.rootNode);return a?(t.rootNode=a,new zV(t).createReturnObject()):lL("ERROR: SecuredFields cannot find a valid rootNode element for ".concat(t.type))},VV=function(e){var t;return"object"===Tg(e)&&(t=e),"string"!=typeof e||(t=yL(document,e))?t:null};function UV(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function KV(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=UV(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=UV(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}function HV(e,t,r,a){return(t!==zD&&t!==MD||0!==r[e])&&a[e]}var qV=function(e){this.numCharsInField[e.fieldType]=e.numChars,this.props.onFocus(e)},WV=function(e){var t=this;return!this.state.detectedUnsupportedBrands&&(this.setState({isSfpValid:e.allValid},(function(){t.props.onChange(t.state,{event:"handleOnAllValid"}),t.props.onAllValid(e)})),!0)},YV=function(e){var t=this;this.setState({autoCompleteName:e.value},(function(){t.props.onChange(t.state,{event:"handleOnAutoComplete",fieldType:e.fieldType}),t.setState({autoCompleteName:null})})),this.props.onAutoComplete(e)},GV=function(e){var t=this;return(!this.state.detectedUnsupportedBrands||e.fieldType!==yD)&&(this.setState((function(t){var r;return{data:KV(KV({},t.data),{},Wg({},e.encryptedFieldName,e.blob)),valid:KV(KV({},t.valid),{},Wg({},e.encryptedFieldName,e.valid)),errors:KV(KV({},t.errors),{},Wg({},e.fieldType,null!==(r=t.errors[e.fieldType])&&void 0!==r&&r))}}),(function(){t.props.onChange(t.state,{event:"handleOnFieldValid",fieldType:e.fieldType}),t.props.onFieldValid(e)})),!0)},JV=function(e){var t=this;clearTimeout(this.csfLoadFailTimeout),this.csfLoadFailTimeout=null,this.props.onLoad(e),this.csfConfigFailTimeout=hw((function(){"ready"!==t.state.status&&(t.setState({status:"csfConfigFailure"}),t.props.onError(new iA("ERROR","secured fields have failed to configure")))}),this.csfConfigFailTimeoutMS)},QV=function(e){var t=this;clearTimeout(this.csfConfigFailTimeout),this.csfConfigFailTimeout=null,this.setState({status:"ready"},(function(){t.props.onConfigSuccess(e)}))},ZV=function(e){var t=this;this.setState((function(r){var a,n,o=HV(CD,e.cvcPolicy,t.numCharsInField,r.errors),i=1===t.numDateFields?HV(gD,e.expiryDatePolicy,t.numCharsInField,r.errors):null,l=2===t.numDateFields?HV(bD,e.expiryDatePolicy,t.numCharsInField,r.errors):null,c=2===t.numDateFields?HV(kD,e.expiryDatePolicy,t.numCharsInField,r.errors):null;return{brand:e.brand,cvcPolicy:null!==(a=e.cvcPolicy)&&void 0!==a?a:LD,showSocialSecurityNumber:e.showSocialSecurityNumber,errors:KV(KV(KV(KV(KV({},r.errors),QM(o)&&Wg({},CD,o)),QM(i)&&Wg({},gD,i)),QM(l)&&Wg({},bD,l)),QM(c)&&Wg({},kD,c)),expiryDatePolicy:null!==(n=e.expiryDatePolicy)&&void 0!==n?n:KD}}),(function(){var r,a;t.props.onChange(t.state,{event:"handleOnBrand"});var n=null!==(r=null===(a=t.props.brandsConfiguration[e.brand])||void 0===a?void 0:a.icon)&&void 0!==r?r:OL(e.brand,t.props.loadingContext);t.props.onBrand(KV(KV({},e),{},{brandImageUrl:n}))}))},$V=function(e){var t=this,r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:null,a=e.error;return this.setState((function(t){return KV(KV(KV({errors:KV(KV({},t.errors),{},Wg({},e.fieldType,a||!1))},r&&{data:KV(KV({},t.data),{},Wg({},yD,void 0))}),r&&{valid:KV(KV({},t.valid),{},Wg({},yD,!1))}),r&&{isSfpValid:!1})}),(function(){t.props.onChange(t.state,{event:"handleOnError",fieldType:e.fieldType})})),!0},XV=function(){var e=this;this.setState({status:"ready"},(function(){return e.props.onChange({isSfpValid:!0})}))},eU=function(e){var t,r;null===(t=(r=this.props).disableIOSArrowKeys)||void 0===t||t.call(r,e)};function tU(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function rU(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=tU(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=tU(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}function aU(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}var nU,oU=function(e){TN(r,e);var t=aU(r);function r(e){var a,n,o,i,l,c,s,u,d,p,f,m,h,v,y,g,b;Bg(this,r),Wg(RN(b=t.call(this,e)),"csfLoadFailTimeout",void 0),Wg(RN(b),"csfLoadFailTimeoutMS",void 0),Wg(RN(b),"csfConfigFailTimeout",void 0),Wg(RN(b),"csfConfigFailTimeoutMS",void 0),Wg(RN(b),"numCharsInField",void 0),Wg(RN(b),"rootNode",void 0),Wg(RN(b),"numDateFields",void 0),Wg(RN(b),"csf",void 0),Wg(RN(b),"handleOnLoad",void 0),Wg(RN(b),"handleOnConfigSuccess",void 0),Wg(RN(b),"handleOnFieldValid",void 0),Wg(RN(b),"handleOnAllValid",void 0),Wg(RN(b),"handleOnBrand",void 0),Wg(RN(b),"handleFocus",void 0),Wg(RN(b),"handleOnError",void 0),Wg(RN(b),"handleOnAutoComplete",void 0),Wg(RN(b),"handleOnNoDataRequired",void 0),Wg(RN(b),"handleOnTouchstartIOS",void 0),Wg(RN(b),"state",void 0),Wg(RN(b),"props",void 0),Wg(RN(b),"issuingCountryCode",void 0),Wg(RN(b),"setRootNode",(function(e){b.rootNode=e}));var k={status:"loading",brand:e.type,errors:{},valid:{},data:{},cvcPolicy:LD,expiryDatePolicy:KD,isSfpValid:!1,hasKoreanFields:e.hasKoreanFields};return b.state=k,b.csfLoadFailTimeout=null,b.csfLoadFailTimeoutMS=3e4,b.csfConfigFailTimeout=null,b.csfConfigFailTimeoutMS=15e3,b.numCharsInField={},b.handleOnLoad=rk(a=JV).call(a,RN(b)),b.handleOnConfigSuccess=rk(n=QV).call(n,RN(b)),b.handleOnFieldValid=rk(o=GV).call(o,RN(b)),b.handleOnAllValid=rk(i=WV).call(i,RN(b)),b.handleOnBrand=rk(l=ZV).call(l,RN(b)),b.handleFocus=rk(c=qV).call(c,RN(b)),b.handleOnError=rk(s=$V).call(s,RN(b)),b.handleOnNoDataRequired=rk(u=XV).call(u,RN(b)),b.handleOnAutoComplete=rk(d=YV).call(d,RN(b)),b.handleOnTouchstartIOS=rk(p=eU).call(p,RN(b)),b.processBinLookupResponse=rk(f=b.processBinLookupResponse).call(f,RN(b)),b.setFocusOn=rk(m=b.setFocusOn).call(m,RN(b)),b.updateStyles=rk(h=b.updateStyles).call(h,RN(b)),b.handleUnsupportedCard=rk(v=b.handleUnsupportedCard).call(v,RN(b)),b.showValidation=rk(y=b.showValidation).call(y,RN(b)),b.destroy=rk(g=b.destroy).call(g,RN(b)),b}return qg(r,[{key:"componentDidMount",value:function(){var e=this;this.props.rootNode&&this.setRootNode(this.props.rootNode);var t=function(e){var t;return e?QC(t=OA(Array.prototype).call(e.querySelectorAll('[data-cse*="encrypted"]'))).call(t,(function(e){return e.getAttribute("data-cse")})):[]}(this.rootNode),r=DC(t).call(t,VM,{});this.setState({valid:r}),Jg(t).call(t,(function(t){e.numCharsInField[t]=0})),this.numDateFields=nb(t).call(t,(function(e){return e.match(/Expiry/)})).length,t.length?(this.destroy(),this.initializeCSF(this.rootNode)):this.handleOnNoDataRequired()}},{key:"componentDidUpdate",value:function(){this.checkForKCPFields()}},{key:"componentWillUnmount",value:function(){this.csf=null}},{key:"initializeCSF",value:function(e){var t=this,r=this.props.loadingContext,a={rootNode:e,type:this.props.type,clientKey:this.props.clientKey,cardGroupTypes:this.props.brands,allowedDOMAccess:this.props.allowedDOMAccess,autoFocus:this.props.autoFocus,trimTrailingSeparator:this.props.trimTrailingSeparator,loadingContext:r,keypadFix:this.props.keypadFix,showWarnings:this.props.showWarnings,iframeUIConfig:{sfStyles:this.props.styles},i18n:this.props.i18n,callbacks:{onLoad:this.handleOnLoad,onConfigSuccess:this.handleOnConfigSuccess,onFieldValid:this.handleOnFieldValid,onAllValid:this.handleOnAllValid,onBrand:this.handleOnBrand,onError:this.handleOnError,onFocus:this.handleFocus,onBinValue:this.props.onBinValue,onAutoComplete:this.handleOnAutoComplete,onAdditionalSFConfig:this.props.onAdditionalSFConfig,onAdditionalSFRemoved:this.props.onAdditionalSFRemoved,onTouchstartIOS:this.handleOnTouchstartIOS},isKCP:this.state.hasKoreanFields,legacyInputMode:this.props.legacyInputMode,minimumExpiryDate:this.props.minimumExpiryDate,implementationType:this.props.implementationType||"components",isCollatingErrors:this.props.isCollatingErrors,forceCompat:this.props.forceCompat,maskSecurityCode:this.props.maskSecurityCode,disableIOSArrowKeys:!!this.props.disableIOSArrowKeys};this.csf=LV(a),this.csfLoadFailTimeout=hw((function(){"ready"!==t.state.status&&(t.setState({status:"csfLoadFailure"}),t.props.onError(new iA("ERROR","secured field iframes have failed to load")))}),this.csfLoadFailTimeoutMS)}},{key:"checkForKCPFields",value:function(){var e=this,t=!1;if(this.props.koreanAuthenticationRequired&&(t=this.issuingCountryCode?"kr"===this.issuingCountryCode:"kr"===this.props.countryCode),this.state.hasKoreanFields&&!t){this.setState((function(e){return{data:rU(rU({},e.data),{},Wg({},_D,void 0)),valid:rU(rU({},e.valid),{},Wg({},_D,!1)),errors:rU(rU({},e.errors),{},Wg({},_D,!1)),hasKoreanFields:!1}}),(function(){e.props.onChange(e.state)})),this.csf.removeSecuredField(_D),this.csf.setKCPStatus(!1)}if(!this.state.hasKoreanFields&&t){this.setState((function(e){return{valid:rU(rU({},e.valid),{},Wg({},_D,!1)),hasKoreanFields:!0,isSfpValid:!1}}),(function(){e.props.onChange(e.state)})),this.csf.addSecuredField(_D),this.csf.setKCPStatus(!0)}}},{key:"getChildContext",value:function(){return{i18n:this.props.i18n}}},{key:"handleUnsupportedCard",value:function(e){var t=!!e.error;return t&&this.setState({detectedUnsupportedBrands:e.detectedBrands}),e.rootNode=this.rootNode,this.handleOnError(e,t),this.csf&&this.csf.hasUnsupportedCard(yD,e.error),t}},{key:"setFocusOn",value:function(e){this.csf&&this.csf.setFocusOnFrame(e)}},{key:"updateStyles",value:function(e){this.csf&&this.csf.updateStyles(e)}},{key:"sfIsOptionalOrHidden",value:function(e){return this.csf.sfIsOptionalOrHidden(e)}},{key:"destroy",value:function(){this.csf&&this.csf.destroy()}},{key:"showValidation",value:function(){var e,t,r=this,a=this.numDateFields,n=this.state;Jg(e=DC(t=Jy(n.valid)).call(t,UM(a,n),[])).call(e,(function(e){var t=function(e,t,r){return{rootNode:t,fieldType:e,error:bP(r,"errors.".concat(e))||sI[e]||cI,type:"card"}}(e,r.rootNode,n);r.handleOnError(t,!!n.detectedUnsupportedBrands),r.csf&&r.csf.isValidated&&r.csf.isValidated(e,t.error)}))}},{key:"mapErrorsToValidationRuleResult",value:function(){var e=this,t=Jy(this.state.errors);return DC(t).call(t,(function(t,r){return e.state.errors[r]?t[r]=rU({isValid:!1,errorMessage:ML(e.state.errors[r]),errorI18n:e.props.i18n.get(e.state.errors[r]),error:e.state.errors[r],rootNode:e.rootNode},e.state.detectedUnsupportedBrands&&{detectedBrands:e.state.detectedUnsupportedBrands}):t[r]=null,t}),{})}},{key:"processBinLookupResponse",value:function(e,t){var r,a=this;if(this.state.detectedUnsupportedBrands&&(this.setState((function(e){return{errors:rU(rU({},e.errors),{},Wg({},yD,!1)),detectedUnsupportedBrands:null}})),this.csf&&e)){this.handleUnsupportedCard({type:"card",fieldType:"encryptedCardNumber",error:""})}this.issuingCountryCode=null==e||null===(r=e.issuingCountryCode)||void 0===r?void 0:r.toLowerCase();var n=(null==t?void 0:t.brand)&&Eb(BD).call(BD,t.brand);n&&this.setState(t,(function(){a.props.onChange(a.state)})),this.csf&&this.csf.brandsFromBinLookup(e,n?t:null)}},{key:"render",value:function(e,t){return e.render({setRootNode:this.setRootNode,setFocusOn:this.setFocusOn},t)}}]),r}($N);Wg(oU,"defaultProps",{type:"card",keypadFix:!0,rootNode:null,loadingContext:null,brands:[],allowedDOMAccess:!1,showWarnings:!1,autoFocus:!0,trimTrailingSeparator:!0,onChange:function(){},onLoad:function(){},onConfigSuccess:function(){},onAllValid:function(){},onFieldValid:function(){},onBrand:function(){},onError:function(){},onBinValue:function(){},onFocus:function(){},onAutoComplete:function(){},styles:{}}),function(e){e.full="full",e.partial="partial",e.none="none"}(nU||(nU={}));var iU={type:"card",setComponentRef:function(){},hasHolderName:!1,holderNameRequired:!1,enableStoreDetails:!1,hasCVC:!0,showBrandIcon:!0,showBrandsUnderCardNumber:!0,positionHolderNameOnTop:!1,billingAddressRequired:!1,billingAddressMode:nU.full,billingAddressRequiredFields:["street","houseNumberOrName","postalCode","city","stateOrProvince","country"],installmentOptions:{},configuration:{koreanAuthenticationRequired:!1,socialSecurityNumberMode:"auto"},autoFocus:!0,isPayButtonPrimaryVariant:!0,disableIOSArrowKeys:!0,onLoad:function(){},onConfigSuccess:function(){},onAllValid:function(){},onFieldValid:function(){},onBrand:function(){},onError:function(){},onBinValue:function(){},onBlur:function(){},onFocus:function(){},onChange:function(){},data:{billingAddress:{}},styles:{},placeholders:{},SRConfig:{}},lU={base:{caretColor:"#0075FF"}},cU=11;function sU(e){var t;return OI(t=e.replace(/[^0-9]/g,"")).call(t)}function uU(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"";if("string"!=typeof e)return"";var t=sU(e),r=t.length>cU?function(e){return e.replace(/^(\d{2})(\d{3})(\d{3})?(\d{4})?(\d{1,2})?$/g,(function(e,t,r,a){var n,o,i,l,c=arguments.length>4&&void 0!==arguments[4]?arguments[4]:"",s=arguments.length>5&&void 0!==arguments[5]?arguments[5]:"";return Bb(n=Bb(o=Bb(i=Bb(l="".concat(t,".")).call(l,r,".")).call(i,a,"/")).call(o,c)).call(n,s.length?"-".concat(s):"")}))}(t):function(e){return e.replace(/\W/gi,"").replace(/(\d{3})(?!$)/g,"$1.").replace(/(.{11}).(\d{1,2})$/g,"$1-$2")}(t);return r}function dU(e){return/(^\d{3}\.\d{3}\.\d{3}-\d{2}$)|(^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$)/.test(e)}var pU={socialSecurityNumber:uU},fU={socialSecurityNumber:[{modes:["blur"],validate:function(e){return WR(e)?null:dU(e)},errorMessage:"boleto.socialSecurityNumber.invalid"}],taxNumber:[{modes:["blur"],validate:function(e){return WR(e)?null:6===(null==e?void 0:e.length)||10===(null==e?void 0:e.length)},errorMessage:"creditCard.taxNumber.invalid"}],holderName:[{modes:["blur"],validate:function(e){return!WR(e)||null},errorMessage:"creditCard.holderName.invalid"}],default:[{modes:["blur"],validate:function(e){return!!e&&"string"==typeof e&&OI(e).call(e).length>0}}]},mU={},hU={get exports(){return mU},set exports(e){mU=e}};!function(e){e.exports=hy}(hU);var vU=t(mU);function yU(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}var gU=function(e,t){return DC(e).call(e,(function(e,r){return e||Eb(t).call(t,r.brand)}),!1)},bU=function(e){return QC(e).call(e,(function(e){return function(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=yU(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=yU(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}({},e)}))},kU=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"mc",r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:"visa",a=bU(e);return a[0].brand!==t&&a[0].brand!==r&&vU(a).call(a),a.length=1,a};function CU(e,t,r){var a=arguments.length>3&&void 0!==arguments[3]?arguments[3]:{},n=e.type,o=e.cvcPolicy,i=t.sfp,l=r.dualBrandSelectElements,c=r.setDualBrandSelectElements,s=r.setSelectedBrandValue,u=r.issuingCountryCode,d=r.setIssuingCountryCode;return{processBinLookup:function(e,t){var r,l,u,p,f=null!=e&&e.issuingCountryCode?e.issuingCountryCode.toLowerCase():null;if(d(f),!e||!Jy(e).length){c([]),s("");var m=t&&"card"!==n?n:null;return i.current.processBinLookupResponse(e,{brand:m,cvcPolicy:o}),void(a.current=0)}if(null!==(r=e.supportedBrands)&&void 0!==r&&r.length){var h=gU(e.supportedBrands,JD),v=h?kU(e.supportedBrands):bU(e.supportedBrands);if(v.length>1){var y=(l=tC(v,2),u=l[0],p=l[1],{dualBrandSelectElements:[{id:u.brand,brandObject:u},{id:p.brand,brandObject:p}],selectedBrandValue:"",leadBrand:u});c(y.dualBrandSelectElements),s(y.selectedBrandValue),i.current.processBinLookupResponse({issuingCountryCode:e.issuingCountryCode,supportedBrands:[y.leadBrand]}),y.leadBrand.panLength>0&&(a.current=y.leadBrand.panLength)}else c([]),s(""),h||s(v[0].brand),i.current.processBinLookupResponse({issuingCountryCode:e.issuingCountryCode,supportedBrands:v}),v[0].panLength>0&&(a.current=v[0].panLength)}},handleDualBrandSelection:function(e){var t=e;if(e instanceof Event){var r=e.target;t=r.getAttribute("data-value")||r.getAttribute("alt")}s(t);var a=DC(l).call(l,(function(e,r){return r.brandObject.brand===t&&e.push(r.brandObject),e}),[]);i.current.processBinLookupResponse({issuingCountryCode:u,supportedBrands:a})}}}var _U={},NU={get exports(){return _U},set exports(e){_U=e}},PU=Ae,wU=TypeError,SU=de.match(/firefox\/(\d+)/i),xU=!!SU&&+SU[1],EU=/MSIE|Trident/.test(de),AU=de.match(/AppleWebKit\/(\d+)\./),DU=!!AU&&+AU[1],IU=Dr,FU=b,RU=Re,OU=Ze,TU=da,BU=function(e,t){if(!delete e[t])throw wU("Cannot delete property "+PU(t)+" of "+PU(e))},jU=go,zU=c,MU=JO,LU=jv,VU=xU,UU=EU,KU=ge,HU=DU,qU=[],WU=FU(qU.sort),YU=FU(qU.push),GU=zU((function(){qU.sort(void 0)})),JU=zU((function(){qU.sort(null)})),QU=LU("sort"),ZU=!zU((function(){if(KU)return KU<70;if(!(VU&&VU>3)){if(UU)return!0;if(HU)return HU<603;var e,t,r,a,n="";for(e=65;e<76;e++){switch(t=String.fromCharCode(e),e){case 66:case 69:case 70:case 72:r=3;break;case 68:case 71:r=4;break;default:r=2}for(a=0;a<47;a++)qU.push({k:t+a,v:r})}for(qU.sort((function(e,t){return t.v-e.v})),a=0;a<qU.length;a++)t=qU[a].k.charAt(0),n.charAt(n.length-1)!==t&&(n+=t);return"DGBEFHACIJK"!==n}}));IU({target:"Array",proto:!0,forced:GU||!JU||!QU||!ZU},{sort:function(e){void 0!==e&&RU(e);var t=OU(this);if(ZU)return void 0===e?WU(t):WU(t,e);var r,a,n=[],o=TU(t);for(a=0;a<o;a++)a in t&&YU(n,t[a]);for(MU(n,function(e){return function(t,r){return void 0===r?-1:void 0===t?1:void 0!==e?+e(t,r)||0:jU(t)>jU(r)?1:-1}}(e)),r=TU(n),a=0;a<r;)t[a]=n[a++];for(;a<o;)BU(t,a++);return t}});var $U=Vv("Array").sort,XU=ue,eK=$U,tK=Array.prototype,rK=function(e){var t=e.sort;return e===tK||XU(tK,e)&&t===tK.sort?eK:t};!function(e){e.exports=rK}(NU);var aK=t(_U),nK="holderName",oK="socialSecurityNumber",iK=[yD,gD,CD],lK=[nK,yD,gD,CD],cK=[yD,gD,CD,nK],sK=["taxNumber",_D],uK=Bb(iK).call(iK,sK),dK=Bb(lK).call(lK,sK),pK=Bb(cK).call(cK,sK),fK=Bb(iK).call(iK,[oK]),mK=Bb(lK).call(lK,[oK]),hK=Bb(cK).call(cK,[oK]),vK=function(e,t){return GP({type:"card"===e?"nocard":e||"nocard",extension:"svg",loadingContext:t})(e)},yK=function(e){var t,r=e.errors,a=e.layout,n=e.i18n,o=e.countrySpecificLabels,i=DC(t=LM(r)).call(t,(function(e,t){var r=tC(t,2),n=r[0];return r[1]&&(e.push(n),aK(e).call(e,(function(e,t){return hC(a).call(a,e)-hC(a).call(a,t)}))),e}),[]);if(!i||!i.length)return null;var l=QC(i).call(i,(function(e){var t,a=function(e,t,r){switch(e){case"socialSecurityNumber":return t.get("boleto.".concat(e));case"street":case"houseNumberOrName":case"postalCode":case"stateOrProvince":case"city":case"country":return null!=r&&r[e]?t.get(null==r?void 0:r[e]):t.get(e);case yD:case gD:case CD:case _D:case"holderName":case"taxNumber":return null;default:var a,n,o=Eb(a=["ach","giftcard"]).call(a,e)?e:"creditCard";return t.get(Bb(n="".concat(o,".")).call(n,e,".aria.label"))}}(e,n,o),i=lA(r[e],"errorI18n")?r[e].errorI18n:n.get(r[e].errorMessage);return a?Bb(t="".concat(a,": ")).call(t,i,"."):i}));return l.length?{errorMessages:l,fieldList:i}:null},gK="LoadingWrapper-module_loading-input__form__ffCKa",bK="LoadingWrapper-module_loading-input__form--loading__7GmVo",kK="LoadingWrapper-module_loading-input__spinner__GxA51",CK="LoadingWrapper-module_loading-input__spinner--active__ENNBS",_K=function(e){var t,r=e.children,a=e.status,n=ww("adyen-checkout__loading-input__form",gK,Wg({},bK,"loading"===a));return JN("div",{style:{position:"relative"}},JN("div",{className:ww((Wg(t={},kK,!0),Wg(t,CK,"loading"===a),t))},JN(Sw,null)),JN("div",{className:n},r))};function NK(e){var t=e.frontCVC,r=void 0!==t&&t;return JN("div",{className:ww({"adyen-checkout__card__cvc__hint__wrapper":!0,"adyen-checkout__field__cvc--front-hint":!!r,"adyen-checkout__field__cvc--back-hint":!r}),"aria-hidden":!0},JN("svg",{className:"adyen-checkout__card__cvc__hint adyen-checkout__card__cvc__hint--front",width:"27",height:"18",viewBox:"0 0 27 18",fill:"none",xmlns:"http://www.w3.org/2000/svg"},JN("path",{d:"M0 3C0 1.34315 1.34315 0 3 0H24C25.6569 0 27 1.34315 27 3V15C27 16.6569 25.6569 18 24 18H3C1.34315 18 0 16.6569 0 15V3Z",fill:"#E6E9EB"}),JN("rect",{x:"4",y:"12",width:"19",height:"2",fill:"#B9C4C9"}),JN("rect",{x:"4",y:"4",width:"4",height:"4",rx:"1",fill:"white"}),JN("rect",{className:"adyen-checkout__card__cvc__hint__location",x:"16.5",y:"4.5",width:"7",height:"5",rx:"2.5",stroke:"#C12424"})),JN("svg",{className:"adyen-checkout__card__cvc__hint adyen-checkout__card__cvc__hint--back",width:"27",height:"18",viewBox:"0 0 27 18",fill:"none",xmlns:"http://www.w3.org/2000/svg"},JN("path",{d:"M27 4.00001V3.37501C27 2.4799 26.6444 1.62146 26.0115 0.988518C25.3786 0.355581 24.5201 0 23.625 0H3.375C2.47989 0 1.62145 0.355581 0.988514 0.988518C0.355579 1.62146 0 2.4799 0 3.37501V4.00001H27Z",fill:"#E6E9EB"}),JN("path",{d:"M0 6.99994V14.6666C0 15.5507 0.355579 16.3985 0.988514 17.0237C1.62145 17.6488 2.47989 18 3.375 18H23.625C24.5201 18 25.3786 17.6488 26.0115 17.0237C26.6444 16.3985 27 15.5507 27 14.6666V6.99994H0Z",fill:"#E6E9EB"}),JN("rect",{y:"4.00012",width:"27",height:"3.00001",fill:"#687282"}),JN("path",{d:"M4 11C4 10.4477 4.44772 10 5 10H21C22.1046 10 23 10.8954 23 12C23 13.1046 22.1046 14 21 14H5C4.44771 14 4 13.5523 4 13V11Z",fill:"white"}),JN("rect",{className:"adyen-checkout__card__cvc__hint__location",x:"16.5",y:"9.5",width:"7",height:"5",rx:"2.5",stroke:"#C12424"})))}var PK={"card-input__wrapper":"CardInput-module_card-input__wrapper__wXSCw","card-input__icon":"CardInput-module_card-input__icon__3Cz5M","card-input__form":"CardInput-module_card-input__form__fRo1r","card-input__spinner":"CardInput-module_card-input__spinner__-j2Qi","card-input__spinner--active":"CardInput-module_card-input__spinner--active__slD7w","card-input__form--loading":"CardInput-module_card-input__form--loading__rrmdj","adyen-checkout__input":"CardInput-module_adyen-checkout__input__11tlB","adyen-checkout__card__cvc__input--hidden":"CardInput-module_adyen-checkout__card__cvc__input--hidden__VIlHV","adyen-checkout__card__exp-date__input--hidden":"CardInput-module_adyen-checkout__card__exp-date__input--hidden__evi6-","adyen-checkout__card__exp-cvc__exp-date__input--hidden":"CardInput-module_adyen-checkout__card__exp-cvc__exp-date__input--hidden__YC3VT","revolving-plan-installments__disabled":"CardInput-module_revolving-plan-installments__disabled__VhNj2"};function wK(e){var t;return JN("span",(Wg(t={},WD,e.encryptedFieldType),Wg(t,YD,e["data-info"]),Wg(t,GD,e.uniqueId),Wg(t,"className",e.className),t),e.children)}function SK(e){var t,r,a=e.label,n=e.onFocusField,o=void 0===n?function(){}:n,i=e.error,l=void 0===i?"":i,c=e.className,s=void 0===c?"":c,u=e.classNameModifiers,d=void 0===u?[]:u,p=e.focused,f=e.filled,m=e.isValid,h=e.frontCVC,v=void 0!==h&&h,y=e.cvcPolicy,g=void 0===y?LD:y,b=$w(),k=b.i18n,C=b.commonProps.isCollatingErrors,_=ww(s,(Wg(t={"adyen-checkout__field__cvc":!0},PK["adyen-checkout__card__cvc__input--hidden"],g===UD),Wg(t,"adyen-checkout__field__cvc--optional",g===VD),t)),N=ww(Wg({"adyen-checkout__input":!0,"adyen-checkout__input--small":!0,"adyen-checkout__card__cvc__input":!0,"adyen-checkout__input--error":l,"adyen-checkout__input--focus":p,"adyen-checkout__input--valid":m},PK["adyen-checkout__input"],!0)),P=g!==VD?a:k.get("creditCard.cvcField.title.optional");return JN(kI,{label:P,focused:p,filled:f,classNameModifiers:Bb(r=[]).call(r,rC(d),["securityCode"]),onFocusField:function(){return o(CD)},className:_,errorMessage:l,isValid:m,dir:"ltr",name:CD,isCollatingErrors:C,i18n:k},JN(wK,{encryptedFieldType:CD,className:N}),JN(NK,{frontCVC:v}))}function xK(e){var t,r,a,n=e.brand,o=e.hasCVC,i=e.onFocusField,l=e.errors,c=e.valid,s=e.cvcPolicy,u=e.focusedElement,d=e.lastFour,p=e.expiryMonth,f=e.expiryYear,m=$w().i18n,h=m.get("creditCard.storedCard.description.ariaLabel").replace("%@",d);return JN("div",{className:"adyen-checkout__card__form adyen-checkout__card__form--oneClick","aria-label":Bb(t=Bb(r=Bb(a="".concat(h," ")).call(a,m.get("creditCard.expiryDateField.title")," ")).call(r,p,"/")).call(t,f)},JN("div",{className:"adyen-checkout__card__exp-cvc adyen-checkout__field-wrapper"},JN(kI,{label:m.get("creditCard.expiryDateField.title"),className:"adyen-checkout__field--50",classNameModifiers:["storedCard"],disabled:!0},JN("div",{className:"adyen-checkout__input adyen-checkout__input--disabled adyen-checkout__card__exp-date__input--oneclick",dir:"ltr"},p," / ",f)),o&&JN(SK,{cvcPolicy:s,error:function(e,t){return e[t]?m.get(e[t]):null}(l,CD),focused:"encryptedSecurityCode"===u,filled:!!c.encryptedSecurityCode||!!l.encryptedSecurityCode,isValid:!!c.encryptedSecurityCode,label:m.get("creditCard.cvcField.title"),onFocusField:i,className:"adyen-checkout__field--50",classNameModifiers:["storedCard"],frontCVC:"amex"===n})))}function EK(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function AK(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=EK(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=EK(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}function DK(e){var t,r,a,n,o=$w().i18n,i=e.amount,l=e.brand,c=e.onChange,s=e.type,u=e.installmentOptions[l]||e.installmentOptions.card,d=tC(Bw((null==u?void 0:u.preselectedValue)||(null==u?void 0:VC(u)[0])),2),p=d[0],f=d[1],m=tC(Bw("onetime"),2),h=m[0],v=m[1],y=null==u||null===(t=u.plans)||void 0===t?void 0:Eb(t).call(t,"revolving"),g=function(e){var t=e.target.value;f(Number(t))},b=function(e){var t,r,a;return"amount"===s?(t="installmentOption",r={count:e,values:{times:e,partialValue:(a=e,o.amount(i.value/a,i.currency))}}):(t="installmentOptionMonths",r={count:e,values:{times:e}}),{id:e,name:i.value?o.get(t,r):"".concat(e)}};return zw((function(){var e,t=null!=u&&null!==(e=VC(u))&&void 0!==e&&Eb(e).call(e,p)?p:null==u?void 0:VC(u)[0];f(t)}),[l]),zw((function(){var e=AK(AK({value:p},y&&"revolving"===h&&{plan:h,value:1}),y&&"onetime"===h&&{value:1});c(u?e:{value:null})}),[p,u,h]),u?0===i.value?null:JN("div",{className:"adyen-checkout__installments"},y?JN(hD,{classNameModifiers:["revolving-plan"],label:""},JN(sF,{items:[{id:"onetime",name:"installments.oneTime"},{id:"installments",name:"installments.installments"},{id:"revolving",name:"installments.revolving"}],i18n:o,onChange:function(e){var t=e.currentTarget.getAttribute("value");v(t)},value:h}),JN(kI,{className:"".concat("installments"!==h?PK["revolving-plan-installments__disabled"]:PK["revolving-plan-installments"]),classNameModifiers:["revolving-plan-installments"]},NF("select",{filterable:!1,items:QC(n=VC(u)).call(n,b),selected:p,onChange:g,name:"installments"}))):JN(kI,{label:o.get("installments"),classNameModifiers:["installments"]},NF("select",{filterable:!1,items:QC(r=VC(u)).call(r,b),selected:p,onChange:g,name:"installments",readonly:1===(null==u||null===(a=VC(u))||void 0===a?void 0:a.length)}))):null}function IK(e){var t=e.id,r=void 0===t?"ariaConsolidatedErrorField":t,a=e.heading,n=void 0===a?"Errors:":a,o=e.errors,i=e.callbackFn,l=void 0===i?null:i,c=e.showPanel,s=void 0!==c&&c;if(!o)return null;var u=o.errorMessages;return zw((function(){null==l||l(o)}),[o]),JN("div",{className:s?"adyen-checkout-error-panel":"adyen-checkout-error-panel--sr-only",id:r,"aria-live":"polite"},JN("div",{className:"adyen-checkout-error-panel__wrapper"},JN("div",{className:"adyen-checkout-error-panel__header"},JN("span",{className:"adyen-checkout-error-panel__title"},n)),QC(u).call(u,(function(e){return JN("div",{key:e,className:"adyen-checkout-error-panel__error"},e)}))))}DK.defaultProps={brand:"",amount:{},onChange:function(){}};var FK,RK={},OK={get exports(){return RK},set exports(e){RK=e}},TK=b,BK=2147483647,jK=/[^\0-\u007E]/,zK=/[.\u3002\uFF0E\uFF61]/g,MK="Overflow: input needs wider integers to process",LK=RangeError,VK=TK(zK.exec),UK=Math.floor,KK=String.fromCharCode,HK=TK("".charCodeAt),qK=TK([].join),WK=TK([].push),YK=TK("".replace),GK=TK("".split),JK=TK("".toLowerCase),QK=function(e){return e+22+75*(e<26)},ZK=function(e,t,r){var a=0;for(e=r?UK(e/700):e>>1,e+=UK(e/t);e>455;)e=UK(e/35),a+=36;return UK(a+36*e/(e+38))},$K=function(e){var t=[];e=function(e){for(var t=[],r=0,a=e.length;r<a;){var n=HK(e,r++);if(n>=55296&&n<=56319&&r<a){var o=HK(e,r++);56320==(64512&o)?WK(t,((1023&n)<<10)+(1023&o)+65536):(WK(t,n),r--)}else WK(t,n)}return t}(e);var r,a,n=e.length,o=128,i=0,l=72;for(r=0;r<e.length;r++)(a=e[r])<128&&WK(t,KK(a));var c=t.length,s=c;for(c&&WK(t,"-");s<n;){var u=BK;for(r=0;r<e.length;r++)(a=e[r])>=o&&a<u&&(u=a);var d=s+1;if(u-o>UK((BK-i)/d))throw LK(MK);for(i+=(u-o)*d,o=u,r=0;r<e.length;r++){if((a=e[r])<o&&++i>BK)throw LK(MK);if(a==o){for(var p=i,f=36;;){var m=f<=l?1:f>=l+26?26:f-l;if(p<m)break;var h=p-m,v=36-m;WK(t,KK(QK(m+h%v))),p=UK(h/v),f+=36}WK(t,KK(QK(p))),l=ZK(i,d,s==c),i=0,s++}}i++,o++}return qK(t,"")},XK=Dr,eH=F,tH=KO,rH=l,aH=$t,nH=b,oH=pi,iH=ml,lH=_l,cH=et,sH=CN,uH=Gk,dH=Wp,pH=Sd.codeAt,fH=function(e){var t,r,a=[],n=GK(YK(JK(e),zK,"."),".");for(t=0;t<n.length;t++)r=n[t],WK(a,VK(jK,r)?"xn--"+$K(r):r);return qK(a,".")},mH=go,hH=Ii,vH=rc,yH=uB,gH=ni,bH=gH.set,kH=gH.getterFor("URL"),CH=yH.URLSearchParams,_H=yH.getState,NH=rH.URL,PH=rH.TypeError,wH=rH.parseInt,SH=Math.floor,xH=Math.pow,EH=nH("".charAt),AH=nH(/./.exec),DH=nH([].join),IH=nH(1..toString),FH=nH([].pop),RH=nH([].push),OH=nH("".replace),TH=nH([].shift),BH=nH("".split),jH=nH("".slice),zH=nH("".toLowerCase),MH=nH([].unshift),LH="Invalid scheme",VH="Invalid host",UH="Invalid port",KH=/[a-z]/i,HH=/[\d+-.a-z]/i,qH=/\d/,WH=/^0x/i,YH=/^[0-7]+$/,GH=/^\d+$/,JH=/^[\da-f]+$/i,QH=/[\0\t\n\r #%/:<>?@[\\\]^|]/,ZH=/[\0\t\n\r #/:<>?@[\\\]^|]/,$H=/^[\u0000-\u0020]+/,XH=/(^|[^\u0000-\u0020])[\u0000-\u0020]+$/,eq=/[\t\n\r]/g,tq=function(e){var t,r,a,n;if("number"==typeof e){for(t=[],r=0;r<4;r++)MH(t,e%256),e=SH(e/256);return DH(t,".")}if("object"==typeof e){for(t="",a=function(e){for(var t=null,r=1,a=null,n=0,o=0;o<8;o++)0!==e[o]?(n>r&&(t=a,r=n),a=null,n=0):(null===a&&(a=o),++n);return n>r&&(t=a,r=n),t}(e),r=0;r<8;r++)n&&0===e[r]||(n&&(n=!1),a===r?(t+=r?":":"::",n=!0):(t+=IH(e[r],16),r<7&&(t+=":")));return"["+t+"]"}return e},rq={},aq=sH({},rq,{" ":1,'"':1,"<":1,">":1,"`":1}),nq=sH({},aq,{"#":1,"?":1,"{":1,"}":1}),oq=sH({},nq,{"/":1,":":1,";":1,"=":1,"@":1,"[":1,"\\":1,"]":1,"^":1,"|":1}),iq=function(e,t){var r=pH(e,0);return r>32&&r<127&&!cH(t,e)?e:encodeURIComponent(e)},lq={ftp:21,file:null,http:80,https:443,ws:80,wss:443},cq=function(e,t){var r;return 2==e.length&&AH(KH,EH(e,0))&&(":"==(r=EH(e,1))||!t&&"|"==r)},sq=function(e){var t;return e.length>1&&cq(jH(e,0,2))&&(2==e.length||"/"===(t=EH(e,2))||"\\"===t||"?"===t||"#"===t)},uq=function(e){return"."===e||"%2e"===zH(e)},dq={},pq={},fq={},mq={},hq={},vq={},yq={},gq={},bq={},kq={},Cq={},_q={},Nq={},Pq={},wq={},Sq={},xq={},Eq={},Aq={},Dq={},Iq={},Fq=function(e,t,r){var a,n,o,i=mH(e);if(t){if(n=this.parse(i))throw PH(n);this.searchParams=null}else{if(void 0!==r&&(a=new Fq(r,!0)),n=this.parse(i,null,a))throw PH(n);(o=_H(new CH)).bindURL(this),this.searchParams=o}};Fq.prototype={type:"URL",parse:function(e,t,r){var a,n,o,i,l,c=this,s=t||dq,u=0,d="",p=!1,f=!1,m=!1;for(e=mH(e),t||(c.scheme="",c.username="",c.password="",c.host=null,c.port=null,c.path=[],c.query=null,c.fragment=null,c.cannotBeABaseURL=!1,e=OH(e,$H,""),e=OH(e,XH,"$1")),e=OH(e,eq,""),a=uH(e);u<=a.length;){switch(n=a[u],s){case dq:if(!n||!AH(KH,n)){if(t)return LH;s=fq;continue}d+=zH(n),s=pq;break;case pq:if(n&&(AH(HH,n)||"+"==n||"-"==n||"."==n))d+=zH(n);else{if(":"!=n){if(t)return LH;d="",s=fq,u=0;continue}if(t&&(c.isSpecial()!=cH(lq,d)||"file"==d&&(c.includesCredentials()||null!==c.port)||"file"==c.scheme&&!c.host))return;if(c.scheme=d,t)return void(c.isSpecial()&&lq[c.scheme]==c.port&&(c.port=null));d="","file"==c.scheme?s=Pq:c.isSpecial()&&r&&r.scheme==c.scheme?s=mq:c.isSpecial()?s=gq:"/"==a[u+1]?(s=hq,u++):(c.cannotBeABaseURL=!0,RH(c.path,""),s=Aq)}break;case fq:if(!r||r.cannotBeABaseURL&&"#"!=n)return LH;if(r.cannotBeABaseURL&&"#"==n){c.scheme=r.scheme,c.path=dH(r.path),c.query=r.query,c.fragment="",c.cannotBeABaseURL=!0,s=Iq;break}s="file"==r.scheme?Pq:vq;continue;case mq:if("/"!=n||"/"!=a[u+1]){s=vq;continue}s=bq,u++;break;case hq:if("/"==n){s=kq;break}s=Eq;continue;case vq:if(c.scheme=r.scheme,n==FK)c.username=r.username,c.password=r.password,c.host=r.host,c.port=r.port,c.path=dH(r.path),c.query=r.query;else if("/"==n||"\\"==n&&c.isSpecial())s=yq;else if("?"==n)c.username=r.username,c.password=r.password,c.host=r.host,c.port=r.port,c.path=dH(r.path),c.query="",s=Dq;else{if("#"!=n){c.username=r.username,c.password=r.password,c.host=r.host,c.port=r.port,c.path=dH(r.path),c.path.length--,s=Eq;continue}c.username=r.username,c.password=r.password,c.host=r.host,c.port=r.port,c.path=dH(r.path),c.query=r.query,c.fragment="",s=Iq}break;case yq:if(!c.isSpecial()||"/"!=n&&"\\"!=n){if("/"!=n){c.username=r.username,c.password=r.password,c.host=r.host,c.port=r.port,s=Eq;continue}s=kq}else s=bq;break;case gq:if(s=bq,"/"!=n||"/"!=EH(d,u+1))continue;u++;break;case bq:if("/"!=n&&"\\"!=n){s=kq;continue}break;case kq:if("@"==n){p&&(d="%40"+d),p=!0,o=uH(d);for(var h=0;h<o.length;h++){var v=o[h];if(":"!=v||m){var y=iq(v,oq);m?c.password+=y:c.username+=y}else m=!0}d=""}else if(n==FK||"/"==n||"?"==n||"#"==n||"\\"==n&&c.isSpecial()){if(p&&""==d)return"Invalid authority";u-=uH(d).length+1,d="",s=Cq}else d+=n;break;case Cq:case _q:if(t&&"file"==c.scheme){s=Sq;continue}if(":"!=n||f){if(n==FK||"/"==n||"?"==n||"#"==n||"\\"==n&&c.isSpecial()){if(c.isSpecial()&&""==d)return VH;if(t&&""==d&&(c.includesCredentials()||null!==c.port))return;if(i=c.parseHost(d))return i;if(d="",s=xq,t)return;continue}"["==n?f=!0:"]"==n&&(f=!1),d+=n}else{if(""==d)return VH;if(i=c.parseHost(d))return i;if(d="",s=Nq,t==_q)return}break;case Nq:if(!AH(qH,n)){if(n==FK||"/"==n||"?"==n||"#"==n||"\\"==n&&c.isSpecial()||t){if(""!=d){var g=wH(d,10);if(g>65535)return UH;c.port=c.isSpecial()&&g===lq[c.scheme]?null:g,d=""}if(t)return;s=xq;continue}return UH}d+=n;break;case Pq:if(c.scheme="file","/"==n||"\\"==n)s=wq;else{if(!r||"file"!=r.scheme){s=Eq;continue}if(n==FK)c.host=r.host,c.path=dH(r.path),c.query=r.query;else if("?"==n)c.host=r.host,c.path=dH(r.path),c.query="",s=Dq;else{if("#"!=n){sq(DH(dH(a,u),""))||(c.host=r.host,c.path=dH(r.path),c.shortenPath()),s=Eq;continue}c.host=r.host,c.path=dH(r.path),c.query=r.query,c.fragment="",s=Iq}}break;case wq:if("/"==n||"\\"==n){s=Sq;break}r&&"file"==r.scheme&&!sq(DH(dH(a,u),""))&&(cq(r.path[0],!0)?RH(c.path,r.path[0]):c.host=r.host),s=Eq;continue;case Sq:if(n==FK||"/"==n||"\\"==n||"?"==n||"#"==n){if(!t&&cq(d))s=Eq;else if(""==d){if(c.host="",t)return;s=xq}else{if(i=c.parseHost(d))return i;if("localhost"==c.host&&(c.host=""),t)return;d="",s=xq}continue}d+=n;break;case xq:if(c.isSpecial()){if(s=Eq,"/"!=n&&"\\"!=n)continue}else if(t||"?"!=n)if(t||"#"!=n){if(n!=FK&&(s=Eq,"/"!=n))continue}else c.fragment="",s=Iq;else c.query="",s=Dq;break;case Eq:if(n==FK||"/"==n||"\\"==n&&c.isSpecial()||!t&&("?"==n||"#"==n)){if(".."===(l=zH(l=d))||"%2e."===l||".%2e"===l||"%2e%2e"===l?(c.shortenPath(),"/"==n||"\\"==n&&c.isSpecial()||RH(c.path,"")):uq(d)?"/"==n||"\\"==n&&c.isSpecial()||RH(c.path,""):("file"==c.scheme&&!c.path.length&&cq(d)&&(c.host&&(c.host=""),d=EH(d,0)+":"),RH(c.path,d)),d="","file"==c.scheme&&(n==FK||"?"==n||"#"==n))for(;c.path.length>1&&""===c.path[0];)TH(c.path);"?"==n?(c.query="",s=Dq):"#"==n&&(c.fragment="",s=Iq)}else d+=iq(n,nq);break;case Aq:"?"==n?(c.query="",s=Dq):"#"==n?(c.fragment="",s=Iq):n!=FK&&(c.path[0]+=iq(n,rq));break;case Dq:t||"#"!=n?n!=FK&&("'"==n&&c.isSpecial()?c.query+="%27":c.query+="#"==n?"%23":iq(n,rq)):(c.fragment="",s=Iq);break;case Iq:n!=FK&&(c.fragment+=iq(n,aq))}u++}},parseHost:function(e){var t,r,a;if("["==EH(e,0)){if("]"!=EH(e,e.length-1))return VH;if(t=function(e){var t,r,a,n,o,i,l,c=[0,0,0,0,0,0,0,0],s=0,u=null,d=0,p=function(){return EH(e,d)};if(":"==p()){if(":"!=EH(e,1))return;d+=2,u=++s}for(;p();){if(8==s)return;if(":"!=p()){for(t=r=0;r<4&&AH(JH,p());)t=16*t+wH(p(),16),d++,r++;if("."==p()){if(0==r)return;if(d-=r,s>6)return;for(a=0;p();){if(n=null,a>0){if(!("."==p()&&a<4))return;d++}if(!AH(qH,p()))return;for(;AH(qH,p());){if(o=wH(p(),10),null===n)n=o;else{if(0==n)return;n=10*n+o}if(n>255)return;d++}c[s]=256*c[s]+n,2!=++a&&4!=a||s++}if(4!=a)return;break}if(":"==p()){if(d++,!p())return}else if(p())return;c[s++]=t}else{if(null!==u)return;d++,u=++s}}if(null!==u)for(i=s-u,s=7;0!=s&&i>0;)l=c[s],c[s--]=c[u+i-1],c[u+--i]=l;else if(8!=s)return;return c}(jH(e,1,-1)),!t)return VH;this.host=t}else if(this.isSpecial()){if(e=fH(e),AH(QH,e))return VH;if(t=function(e){var t,r,a,n,o,i,l,c=BH(e,".");if(c.length&&""==c[c.length-1]&&c.length--,(t=c.length)>4)return e;for(r=[],a=0;a<t;a++){if(""==(n=c[a]))return e;if(o=10,n.length>1&&"0"==EH(n,0)&&(o=AH(WH,n)?16:8,n=jH(n,8==o?1:2)),""===n)i=0;else{if(!AH(10==o?GH:8==o?YH:JH,n))return e;i=wH(n,o)}RH(r,i)}for(a=0;a<t;a++)if(i=r[a],a==t-1){if(i>=xH(256,5-t))return null}else if(i>255)return null;for(l=FH(r),a=0;a<r.length;a++)l+=r[a]*xH(256,3-a);return l}(e),null===t)return VH;this.host=t}else{if(AH(ZH,e))return VH;for(t="",r=uH(e),a=0;a<r.length;a++)t+=iq(r[a],rq);this.host=t}},cannotHaveUsernamePasswordPort:function(){return!this.host||this.cannotBeABaseURL||"file"==this.scheme},includesCredentials:function(){return""!=this.username||""!=this.password},isSpecial:function(){return cH(lq,this.scheme)},shortenPath:function(){var e=this.path,t=e.length;!t||"file"==this.scheme&&1==t&&cq(e[0],!0)||e.length--},serialize:function(){var e=this,t=e.scheme,r=e.username,a=e.password,n=e.host,o=e.port,i=e.path,l=e.query,c=e.fragment,s=t+":";return null!==n?(s+="//",e.includesCredentials()&&(s+=r+(a?":"+a:"")+"@"),s+=tq(n),null!==o&&(s+=":"+o)):"file"==t&&(s+="//"),s+=e.cannotBeABaseURL?i[0]:i.length?"/"+DH(i,"/"):"",null!==l&&(s+="?"+l),null!==c&&(s+="#"+c),s},setHref:function(e){var t=this.parse(e);if(t)throw PH(t);this.searchParams.update()},getOrigin:function(){var e=this.scheme,t=this.port;if("blob"==e)try{return new Rq(e.path[0]).origin}catch(e){return"null"}return"file"!=e&&this.isSpecial()?e+"://"+tq(this.host)+(null!==t?":"+t:""):"null"},getProtocol:function(){return this.scheme+":"},setProtocol:function(e){this.parse(mH(e)+":",dq)},getUsername:function(){return this.username},setUsername:function(e){var t=uH(mH(e));if(!this.cannotHaveUsernamePasswordPort()){this.username="";for(var r=0;r<t.length;r++)this.username+=iq(t[r],oq)}},getPassword:function(){return this.password},setPassword:function(e){var t=uH(mH(e));if(!this.cannotHaveUsernamePasswordPort()){this.password="";for(var r=0;r<t.length;r++)this.password+=iq(t[r],oq)}},getHost:function(){var e=this.host,t=this.port;return null===e?"":null===t?tq(e):tq(e)+":"+t},setHost:function(e){this.cannotBeABaseURL||this.parse(e,Cq)},getHostname:function(){var e=this.host;return null===e?"":tq(e)},setHostname:function(e){this.cannotBeABaseURL||this.parse(e,_q)},getPort:function(){var e=this.port;return null===e?"":mH(e)},setPort:function(e){this.cannotHaveUsernamePasswordPort()||(""==(e=mH(e))?this.port=null:this.parse(e,Nq))},getPathname:function(){var e=this.path;return this.cannotBeABaseURL?e[0]:e.length?"/"+DH(e,"/"):""},setPathname:function(e){this.cannotBeABaseURL||(this.path=[],this.parse(e,xq))},getSearch:function(){var e=this.query;return e?"?"+e:""},setSearch:function(e){""==(e=mH(e))?this.query=null:("?"==EH(e,0)&&(e=jH(e,1)),this.query="",this.parse(e,Dq)),this.searchParams.update()},getSearchParams:function(){return this.searchParams.facade},getHash:function(){var e=this.fragment;return e?"#"+e:""},setHash:function(e){""!=(e=mH(e))?("#"==EH(e,0)&&(e=jH(e,1)),this.fragment="",this.parse(e,Iq)):this.fragment=null},update:function(){this.query=this.searchParams.serialize()||null}};var Rq=function(e){var t=lH(this,Oq),r=vH(arguments.length,1)>1?arguments[1]:void 0,a=bH(t,new Fq(e,!1,r));eH||(t.href=a.serialize(),t.origin=a.getOrigin(),t.protocol=a.getProtocol(),t.username=a.getUsername(),t.password=a.getPassword(),t.host=a.getHost(),t.hostname=a.getHostname(),t.port=a.getPort(),t.pathname=a.getPathname(),t.search=a.getSearch(),t.searchParams=a.getSearchParams(),t.hash=a.getHash())},Oq=Rq.prototype,Tq=function(e,t){return{get:function(){return kH(this)[e]()},set:t&&function(e){return kH(this)[t](e)},configurable:!0,enumerable:!0}};if(eH&&(iH(Oq,"href",Tq("serialize","setHref")),iH(Oq,"origin",Tq("getOrigin")),iH(Oq,"protocol",Tq("getProtocol","setProtocol")),iH(Oq,"username",Tq("getUsername","setUsername")),iH(Oq,"password",Tq("getPassword","setPassword")),iH(Oq,"host",Tq("getHost","setHost")),iH(Oq,"hostname",Tq("getHostname","setHostname")),iH(Oq,"port",Tq("getPort","setPort")),iH(Oq,"pathname",Tq("getPathname","setPathname")),iH(Oq,"search",Tq("getSearch","setSearch")),iH(Oq,"searchParams",Tq("getSearchParams")),iH(Oq,"hash",Tq("getHash","setHash"))),oH(Oq,"toJSON",(function(){return kH(this).serialize()}),{enumerable:!0}),oH(Oq,"toString",(function(){return kH(this).serialize()}),{enumerable:!0}),NH){var Bq=NH.createObjectURL,jq=NH.revokeObjectURL;Bq&&oH(Rq,"createObjectURL",aH(Bq,NH)),jq&&oH(Rq,"revokeObjectURL",aH(jq,NH))}hH(Rq,"URL"),XK({global:!0,constructor:!0,forced:!tH,sham:!eH},{URL:Rq});var zq=ne.URL;!function(e){e.exports=zq}(OK);var Mq=t(RK),Lq=function(e){var t,r=arguments.length>1&&void 0!==arguments[1]&&arguments[1];try{t=new Mq(e)}catch(e){return!1}return r&&"http:"===t.protocol||"https:"===t.protocol};function Vq(e){var t=e.disclaimer,r="string"==typeof t.message,a="string"==typeof t.linkText;if(!r||!a)return null;var n=tC(t.message.split("%{linkText}"),2),o=n[0],i=n[1];return Lq(t.link)?JN("span",{className:"adyen-checkout-disclaimer__label"},o,JN("a",{className:"adyen-checkout__link",target:"_blank",rel:"noopener noreferrer",href:t.link},t.linkText),i):null}var Uq=function(e){var t=e.collateErrors,r=e.errorFieldId,a=e.sfpState,n=e.setFocusOn,o=e.cvcPolicy,i=e.focusedElement,l=e.hasInstallments,c=e.handleInstallments,s=e.showAmountsInInstallments,u=e.amount,d=e.hasCVC,p=e.installmentOptions,f=e.lastFour,m=e.expiryMonth,h=e.expiryYear,v=e.mergedSRErrors,y=e.handleErrorPanelFocus,g=e.moveFocus,b=e.showPanel,k=e.disclaimerMessage,C=$w().i18n;return JN(_K,{status:a.status},t&&JN(IK,{id:r,heading:C.get("errorPanel.title"),errors:v,callbackFn:g?y:null,showPanel:b}),JN(xK,{errors:a.errors,brand:a.brand,hasCVC:d,cvcPolicy:o,onFocusField:n,focusedElement:i,status:a.status,valid:a.valid,lastFour:f,expiryMonth:m,expiryYear:h}),l&&JN(DK,{amount:u,brand:a.brand,installmentOptions:p,onChange:c,type:s?"amount":"months"}),k&&JN(Vq,{disclaimer:k}))};function Kq(e){var t,r,a=e.brand,n=e.brandsConfiguration,o=void 0===n?{}:n,i=$w().loadingContext,l="card"===a?"nocard":a,c=null!==(t=null===(r=o[a])||void 0===r?void 0:r.icon)&&void 0!==t?t:vK(l,i);return JN("img",{className:"".concat(PK["card-input__icon"]," adyen-checkout__card__cardNumber__brandIcon"),onError:function(e){e.target.style.cssText="display: none"},alt:a,src:c,"aria-hidden":"true"})}var Hq=function(e){var t,r,a,n=e.brand,o=e.onClick,i=e.dataValue,l=e.notSelected,c=e.brandsConfiguration,s=void 0===c?{}:c,u=$w().loadingContext,d="card"===n?"nocard":n,p=null!==(t=null===(r=s[n])||void 0===r?void 0:r.icon)&&void 0!==t?t:vK(d,u);return JN("img",{className:Bb(a="".concat(PK["card-input__icon"]," ")).call(a,l?"adyen-checkout__card__cardNumber__brandIcon--not-selected":""," adyen-checkout__card__cardNumber__brandIcon"),onError:function(e){e.target.style.cssText="display: none"},alt:n,src:p,onClick:o,"data-value":i,"aria-hidden":"true"})};function qq(e){var t,r=$w(),a=r.i18n,n=r.commonProps.isCollatingErrors,o=e.error,i=void 0===o?"":o,l=e.isValid,c=void 0!==l&&l,s=e.onFocusField,u=void 0===s?function(){}:s,d=e.dualBrandingElements,p=e.dualBrandingChangeHandler,f=e.dualBrandingSelected;return JN(kI,{label:e.label,focused:e.focused,filled:e.filled,classNameModifiers:["cardNumber"],onFocusField:function(){return u(yD)},errorMessage:i,isValid:c,dir:"ltr",name:yD,isCollatingErrors:n,showValidIcon:!1,i18n:a},JN(wK,{encryptedFieldType:yD,className:ww((t={"adyen-checkout__input":!0,"adyen-checkout__input--large":!0,"adyen-checkout__card__cardNumber__input":!0},Wg(t,PK["adyen-checkout__input"],!0),Wg(t,"adyen-checkout__input--error",i),Wg(t,"adyen-checkout__input--focus",e.focused),Wg(t,"adyen-checkout__input--valid",c),Wg(t,"adyen-checkout__card__cardNumber__input--noBrand",!e.showBrandIcon),t))},e.showBrandIcon&&!d&&JN(Kq,{brandsConfiguration:e.brandsConfiguration,brand:e.brand})),d&&!i&&JN("div",{className:ww(["adyen-checkout__card__dual-branding__buttons",{"adyen-checkout__card__dual-branding__buttons--active":c}])},QC(d).call(d,(function(t){return JN(Hq,{key:t.id,brand:t.id,brandsConfiguration:e.brandsConfiguration,onClick:p,dataValue:t.id,notSelected:""!==f&&f!==t.id})}))))}function Wq(e){var t,r,a=e.label,n=e.focused,o=e.filled,i=e.onFocusField,l=e.className,c=void 0===l?"":l,s=e.error,u=void 0===s?"":s,d=e.isValid,p=void 0!==d&&d,f=e.expiryDatePolicy,m=void 0===f?KD:f,h=$w(),v=h.i18n,y=h.loadingContext,g=h.commonProps.isCollatingErrors,b=ww(c,(Wg(t={"adyen-checkout__field__exp-date":!0},PK["adyen-checkout__card__exp-date__input--hidden"],m===qD),Wg(t,"adyen-checkout__field__exp-date--optional",m===HD),t)),k=m!==HD?a:Bb(r="".concat(a," ")).call(r,v.get("field.title.optional"));return JN(kI,{label:k,classNameModifiers:["expiryDate"],className:b,focused:n,filled:o,onFocusField:function(){return i(gD)},errorMessage:u,isValid:p,dir:"ltr",name:"encryptedExpiryDate",isCollatingErrors:g,i18n:v},JN(wK,{encryptedFieldType:gD,className:ww("adyen-checkout__input","adyen-checkout__input--small","adyen-checkout__card__exp-date__input",[PK["adyen-checkout__input"]],{"adyen-checkout__input--error":u,"adyen-checkout__input--focus":n,"adyen-checkout__input--valid":p})}),JN("div",{className:ww("adyen-checkout__field__exp-date_hint_wrapper",[PK["checkout__field__exp-date_hint_wrapper"]],{"adyen-checkout__field__exp-date_hint_wrapper--hidden":u||p})},JN("img",{src:GP({loadingContext:y,imageFolder:"components/"})("expiry_date_hint"),className:"adyen-checkout__field__exp-date_hint",alt:k})))}var Yq=function(e){var t=e.brands,r=e.activeBrand;return null!=t&&t.length?JN("span",{className:ww("adyen-checkout__card__brands",{"adyen-checkout__card__brands--hidden":"card"!==r})},QC(t).call(t,(function(e){return JN("span",{key:e.name,className:"adyen-checkout__card__brands__brand-wrapper"},JN(fF,{src:e.icon,alt:""}))}))):null};function Gq(e){var t=e.brand,r=e.brandsIcons,a=e.brandsConfiguration,n=e.dualBrandingElements,o=e.dualBrandingChangeHandler,i=e.dualBrandingSelected,l=e.errors,c=e.focusedElement,s=e.hasCVC,u=e.cvcPolicy,d=e.expiryDatePolicy,p=e.onFocusField,f=e.showBrandIcon,m=e.showBrandsUnderCardNumber,h=e.valid,v=$w().i18n,y=function(e,t){return e[t]?v.get(e[t]):null},g=null==r?void 0:nb(r).call(r,(function(e){return!(null!=JD&&Eb(JD).call(JD,e.name))}));return JN("div",{className:"adyen-checkout__card__form"},JN(qq,{brand:t,brandsConfiguration:a,error:y(l,yD),focused:c===yD,isValid:!!h.encryptedCardNumber,label:v.get("creditCard.numberField.title"),onFocusField:p,filled:!!l.encryptedCardNumber||!!h.encryptedCardNumber,showBrandIcon:f,dualBrandingElements:n,dualBrandingChangeHandler:o,dualBrandingSelected:i}),m&&JN(Yq,{activeBrand:t,brands:g}),JN("div",{className:ww("adyen-checkout__card__exp-cvc adyen-checkout__field-wrapper",Wg({},PK["adyen-checkout__card__exp-cvc__exp-date__input--hidden"],d===qD))},JN(Wq,{error:y(l,gD),focused:c===gD,isValid:!!h.encryptedExpiryMonth&&!!h.encryptedExpiryYear,filled:!!l.encryptedExpiryDate||!!h.encryptedExpiryYear,label:v.get("creditCard.expiryDateField.title"),onFocusField:p,className:"adyen-checkout__field--50",expiryDatePolicy:d}),s&&JN(SK,{error:y(l,CD),focused:c===CD,cvcPolicy:u,isValid:!!h.encryptedSecurityCode,filled:!!l.encryptedSecurityCode||!!h.encryptedSecurityCode,label:v.get("creditCard.cvcField.title"),onFocusField:p,className:"adyen-checkout__field--50",frontCVC:"amex"===t})))}function Jq(e){var t,r=$w(),a=r.i18n,n=r.commonProps.isCollatingErrors,o=Vw((function(){var t;return(null===(t=e.value)||void 0===t?void 0:t.length)>6?a.get("creditCard.taxNumber.labelAlt"):a.get("creditCard.taxNumber.label")}),[e.value]);return JN("div",{className:"adyen-checkout__card__kcp-authentication"},JN(kI,{label:o,filled:e.filled,classNameModifiers:["kcp-taxNumber"],errorMessage:e.error&&a.get("creditCard.taxNumber.invalid"),isValid:e.isValid,dir:"ltr",name:"kcpTaxNumberOrDOB",isCollatingErrors:n},NF("tel",{name:"kcpTaxNumberOrDOB",className:"adyen-checkout__card__kcp-taxNumber__input ".concat(PK["adyen-checkout__input"]),placeholder:a.get("creditCard.taxNumber.placeholder"),maxLength:10,minLength:6,autoComplete:!1,value:e.value,required:!0,onBlur:e.onBlur,onInput:e.onInput,isCollatingErrors:n,disabled:e.disabled})),JN(kI,{label:a.get("creditCard.encryptedPassword.label"),focused:"encryptedPassword"===e.focusedElement,filled:e.filled,classNameModifiers:["50","koreanAuthentication-encryptedPassword"],onFocusField:function(){return e.onFocusField("encryptedPassword")},errorMessage:e.encryptedPasswordState.errors&&a.get(String(e.encryptedPasswordState.errors)),isValid:e.encryptedPasswordState.valid,dir:"ltr",name:"encryptedPassword",isCollatingErrors:n},JN(wK,{encryptedFieldType:"encryptedPassword",className:ww((t={"adyen-checkout__input":!0,"adyen-checkout__input--large":!0},Wg(t,PK["adyen-checkout__input"],!0),Wg(t,"adyen-checkout__input--error",e.encryptedPasswordState.errors),Wg(t,"adyen-checkout__input--valid",e.encryptedPasswordState.valid),Wg(t,"adyen-checkout__input--focus","encryptedPassword"===e.focusedElement),t))})))}function Qq(e){var t=e.onBlur,r=e.onInput,a=e.valid,n=void 0!==a&&a,o=e.error,i=void 0===o?null:o,l=e.data,c=void 0===l?"":l,s=e.required,u=void 0!==s&&s,d=e.disabled,p=void 0!==d&&d,f=$w(),m=f.i18n,h=f.commonProps.isCollatingErrors;return JN(kI,{label:"".concat(m.get("boleto.socialSecurityNumber")),classNameModifiers:["socialSecurityNumber"],errorMessage:i&&i.errorMessage?m.get(i.errorMessage):!!i,isValid:Boolean(n),name:"socialSecurityNumber",isCollatingErrors:h},NF("text",{name:"socialSecurityNumber",autocorrect:"off",spellcheck:!1,value:c,maxLength:18,onInput:r,onBlur:t,required:u,isCollatingErrors:h,disabled:p}))}var Zq=["storeDetails"];function $q(e){var t=e.storeDetails,r=void 0!==t&&t,a=KP(e,Zq),n=$w().i18n,o=tC(Bw(r),2),i=o[0],l=o[1];return zw((function(){a.onChange(i)}),[i]),JN("div",{className:"adyen-checkout__store-details"},NF("boolean",{onChange:function(e){l(e.target.checked)},label:n.get("storeDetails"),value:i,name:"storeDetails"}))}function Xq(e){var t=e.onBlur,r=e.onInput,a=e.placeholder,n=e.value,o=e.required,i=e.error,l=void 0!==i&&i,c=e.isValid,s=e.disabled,u=$w(),d=u.i18n,p=u.commonProps.isCollatingErrors;return JN(kI,{label:d.get("creditCard.holderName"),className:"adyen-checkout__card__holderName",errorMessage:l&&d.get("creditCard.holderName.invalid"),isValid:!!c,name:"holderName",isCollatingErrors:p,i18n:d},NF("text",{name:"holderName",className:"adyen-checkout__card__holderName__input ".concat(PK["adyen-checkout__input"]),placeholder:a||d.get("creditCard.holderName.placeholder"),autocomplete:"cc-name",value:n,required:o,onBlur:t,onInput:r,isCollatingErrors:p,disabled:s}))}var eW=function(e){var t=e.data,r=e.valid,a=e.errors,n=e.handleChangeFor,o=e.sfpState,i=e.setFocusOn,l=e.collateErrors,c=e.errorFieldId,s=e.cvcPolicy,u=e.focusedElement,d=e.hasInstallments,p=e.handleInstallments,f=e.showAmountsInInstallments,m=e.brandsIcons,h=e.mergedSRErrors,v=e.moveFocus,y=e.showPanel,g=e.handleErrorPanelFocus,b=e.formData,k=e.formErrors,C=e.formValid,_=e.expiryDatePolicy,N=e.dualBrandSelectElements,P=e.extensions,w=e.selectedBrandValue,S=e.showKCP,x=e.showBrazilianSSN,E=e.socialSecurityNumber,A=e.handleOnStoreDetails,D=e.billingAddress,I=e.handleAddress,F=e.setAddressRef,R=e.partialAddressSchema,O=e.amount,T=e.billingAddressRequired,B=e.billingAddressRequiredFields,j=e.billingAddressAllowedCountries,z=e.billingAddressValidationRules,M=void 0===z?null:z,L=e.brandsConfiguration,V=e.enableStoreDetails,U=e.hasCVC,K=e.hasHolderName,H=e.holderNameRequired,q=e.installmentOptions,W=e.placeholders,Y=e.positionHolderNameOnTop,G=e.showBrandIcon,J=e.showBrandsUnderCardNumber,Q=e.iOSFocusedField,Z=e.disclaimerMessage,$=$w().i18n,X=JN(Xq,{required:H,placeholder:W.holderName,value:b.holderName,error:!!k.holderName&&H,isValid:!!C.holderName,onBlur:n("holderName","blur"),onInput:n("holderName","input"),disabled:Q&&"holderName"!==Q});return JN(_K,{status:o.status},l&&JN(IK,{id:c,heading:$.get("errorPanel.title"),errors:h,callbackFn:v?g:null,showPanel:y}),K&&Y&&X,JN(Gq,{showBrandIcon:G,showBrandsUnderCardNumber:J,brand:o.brand,brandsIcons:m,brandsConfiguration:L,focusedElement:u,onFocusField:i,hasCVC:U,cvcPolicy:s,expiryDatePolicy:_,errors:o.errors,valid:o.valid,dualBrandingElements:N.length>0&&N,dualBrandingChangeHandler:P.handleDualBrandSelection,dualBrandingSelected:w}),K&&!Y&&X,S&&JN(Jq,{onFocusField:i,focusedElement:u,encryptedPasswordState:{data:o.encryptedPassword,valid:!!o.valid&&o.valid.encryptedPassword,errors:!!o.errors&&o.errors.encryptedPassword},value:t.taxNumber,error:!!a.taxNumber,isValid:!!r.taxNumber,onBlur:n("taxNumber","blur"),onInput:n("taxNumber","input"),disabled:Q&&"kcpTaxNumberOrDOB"!==Q}),x&&JN("div",{className:"adyen-checkout__card__socialSecurityNumber"},JN(Qq,{onBlur:n("socialSecurityNumber","blur"),onInput:n("socialSecurityNumber","input"),error:null==a?void 0:a.socialSecurityNumber,valid:null==r?void 0:r.socialSecurityNumber,data:E,required:!0,disabled:Q&&"socialSecurityNumber"!==Q})),V&&JN($q,{onChange:A}),d&&JN(DK,{amount:O,brand:o.brand,installmentOptions:q,onChange:p,type:f?"amount":"months"}),T&&JN(vj,{label:"billingAddress",data:D,onChange:I,allowedCountries:j,requiredFields:B,setComponentRef:F,validationRules:M,specifications:R,iOSFocusedField:Q}),Z&&JN(Vq,{disclaimer:Z}))},tW={},rW={get exports(){return tW},set exports(e){tW=e}},aW=Dr,nW=gf.findIndex,oW="findIndex",iW=!0;oW in[]&&Array(1)[oW]((function(){iW=!1})),aW({target:"Array",proto:!0,forced:iW},{findIndex:function(e){return nW(this,e,arguments.length>1?arguments[1]:void 0)}});var lW=Vv("Array").findIndex,cW=ue,sW=lW,uW=Array.prototype,dW=function(e){var t=e.findIndex;return e===uW||cW(uW,e)&&t===uW.findIndex?sW:t};!function(e){e.exports=dW}(rW);var pW=t(tW),fW={},mW={get exports(){return fW},set exports(e){fW=e}};!function(e){e.exports=Qk}(mW);var hW=t(fW);function vW(e,t){var r=void 0!==vO&&Dk(e)||e["@@iterator"];if(!r){if(gw(e)||(r=function(e,t){var r;if(!e)return;if("string"==typeof e)return yW(e,t);var a=OA(r=Object.prototype.toString.call(e)).call(r,8,-1);"Object"===a&&e.constructor&&(a=e.constructor.name);if("Map"===a||"Set"===a)return hW(e);if("Arguments"===a||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a))return yW(e,t)}(e))||t&&e&&"number"==typeof e.length){r&&(e=r);var a=0,n=function(){};return{s:n,n:function(){return a>=e.length?{done:!0}:{done:!1,value:e[a++]}},e:function(e){function t(t){return e.apply(this,arguments)}return t.toString=function(){return e.toString()},t}((function(e){throw e})),f:n}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}var o,i=!0,l=!1;return{s:function(){r=r.call(e)},n:function(){var e=r.next();return i=e.done,e},e:function(e){function t(t){return e.apply(this,arguments)}return t.toString=function(){return e.toString()},t}((function(e){l=!0,o=e})),f:function(){try{i||null==r.return||r.return()}finally{if(l)throw o}}}}function yW(e,t){(null==t||t>e.length)&&(t=e.length);for(var r=0,a=new Array(t);r<t;r++)a[r]=e[r];return a}var gW=function(e,t){var r=e;if("taxNumber"===r&&(r="kcpTaxNumberOrDOB"),"country"===r||"stateOrProvince"===r){var a=yL(t.current.rootNode,".adyen-checkout__field--".concat(r," .adyen-checkout__dropdown__button"));null==a||a.focus()}else{var n=yL(t.current.rootNode,'[name="'.concat(r,'"]'));null==n||n.focus()}},bW=["billingAddress"];function kW(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function CW(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=kW(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=kW(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}var _W=function(e){var t,r,a,n,o=Lw(null),i=Lw(!1),l=Lw(null),c=function(e){l.current=e},s=Lw({});Jy(s.current).length||e.setComponentRef(s.current);var u=Lw(0),d=Lw(!1),p="creditCardErrors",f=e.SRConfig,m=f.collateErrors,h=f.moveFocus,v=f.showPanel,y=Vw((function(){return new fj(e.specifications)}),[e.specifications]);s.current.sfp=o;var g=tC(Bw("ready"),2),b=g[0],k=g[1],C=tC(Bw({}),2),_=C[0],N=C[1],P=tC(Bw(CW({},e.holderNameRequired&&{holderName:!1})),2),w=P[0],S=P[1],x=tC(Bw(CW({},e.hasHolderName&&{holderName:null!==(t=e.data.holderName)&&void 0!==t?t:""})),2),E=x[0],A=x[1],D=tC(Bw(null),2),I=D[0],F=D[1],R=tC(Bw(""),2),O=R[0],T=R[1],B=tC(Bw(!1),2),j=B[0],z=B[1],M=tC(Bw(KD),2),L=M[0],V=M[1],U=tC(Bw(LD),2),K=U[0],H=U[1],q=tC(Bw(null),2),W=q[0],Y=q[1],G=tC(Bw([]),2),J=G[0],Q=G[1],Z=tC(Bw(""),2),$=Z[0],X=Z[1],ee=e.billingAddressMode!==nU.none&&e.billingAddressRequired,te=e.billingAddressMode==nU.partial?kR:null,re=Lw(te&&(null===(r=e.data)||void 0===r||null===(a=r.billingAddress)||void 0===a?void 0:a.country)),ae=tC(Bw(!1),2),ne=ae[0],oe=ae[1],ie=tC(Bw(ee?e.data.billingAddress:null),2),le=ie[0],ce=ie[1],se=tC(Bw(!1),2),ue=se[0],de=se[1],pe=tC(Bw(""),2),fe=pe[0],me=pe[1],he=tC(Bw({value:null}),2),ve=he[0],ye=he[1],ge=tC(Bw(null),2),be=ge[0],ke=ge[1],Ce=QF({schema:[],defaultData:e.data,formatters:pU,rules:fU}),_e=Ce.handleChangeFor,Ne=Ce.triggerValidation,Pe=Ce.data,we=Ce.valid,Se=Ce.errors,xe=Ce.setSchema,Ee=Ce.setData,Ae=Ce.setValid,De=Ce.setErrors,Ie=!!Jy(e.installmentOptions).length&&"debit"!==e.fundingSource,Fe=null===(n=e.showInstallmentAmounts)||void 0===n||n,Re="kr"===(null!=W?W:e.countryCode),Oe=e.configuration.koreanAuthenticationRequired&&Re,Te=ue&&"auto"===e.configuration.socialSecurityNumberMode||"show"===e.configuration.socialSecurityNumberMode,Be=function(e,t,r){return function(a){e(a.currentFocusObject),!0===a.focus?t(a):r(a)}}(T,e.onFocus,e.onBlur),je=function(){return function(e){var t=e.props,r=e.showKCP,a=e.showBrazilianSSN,n=e.countrySpecificSchemas,o=void 0===n?null:n,i=e.billingAddressRequiredFields,l=void 0===i?null:i,c=iK,s=t.hasHolderName&&t.holderNameRequired;if(s&&(c=t.positionHolderNameOnTop?lK:cK),r&&(c=uK,s&&(c=t.positionHolderNameOnTop?dK:pK)),a&&(c=fK,s&&(c=t.positionHolderNameOnTop?mK:hK)),o){var u,d=nb(u=uj(o).call(o,2)).call(u,(function(e){return"number"!=typeof e})),p=d;l&&(p=nb(d).call(d,(function(e){return Eb(l).call(l,e)}))),c=Bb(iK).call(iK,p),s&&(c=t.positionHolderNameOnTop?Bb(lK).call(lK,p):Bb(cK).call(cK,p))}return c}(CW({props:e,showKCP:Oe,showBrazilianSSN:Te},e.billingAddressRequired&&{countrySpecificSchemas:y.getAddressSchemaForCountry(null==le?void 0:le.country),billingAddressRequiredFields:e.billingAddressRequiredFields}))},ze=Uw((function(e){var t="webInternalElement"!==e.fieldType?e.fieldType:e.name;ke(t)}),[]),Me=function(e,t,r){return function(a){if(e.current){var n=a.fieldList[0];Eb(FD).call(FD,n)?(r({currentFocusObject:n}),t.current.setFocusOn(n)):gW(n,t),e.current=!1}}}(i,o,Be),Le=function(e,t,r){return function(a){e("billingAddress",a.data),t("billingAddress",a.isValid),r("billingAddress",a.errors)}}(Ee,Ae,De),Ve=function(e,t,r){return function(){e.current||(e.current=!0,ok.resolve().then((function(){var a,n=pW(r).call(r,(function(e){return e===yD})),o=vW(OA(r).call(r,n+1));try{for(o.s();!(a=o.n()).done;){var i=a.value;if(!Eb(FD).call(FD,i)){gW(i,t);break}if(!t.current.sfIsOptionalOrHidden(i)){t.current.setFocusOn(i);break}}}catch(e){o.e(e)}finally{o.f()}e.current=!1})))}}(d,o,je()),Ue=Vw((function(){return CU(e,{sfp:o},{dualBrandSelectElements:J,setDualBrandSelectElements:Q,setSelectedBrandValue:X,issuingCountryCode:W,setIssuingCountryCode:Y},u)}),[J,W]);s.current.showValidation=function(){F(null),o.current.showValidation(),Ne(["holderName","socialSecurityNumber","taxNumber"]),null!=l&&l.current&&l.current.showValidation(),i.current=!0},s.current.processBinLookupResponse=function(e,t){Ue.processBinLookup(e,t)},s.current.setStatus=k,zw((function(){return s.current.setFocusOn=o.current.setFocusOn,s.current.updateStyles=o.current.updateStyles,s.current.handleUnsupportedCard=o.current.handleUnsupportedCard,function(){o.current.destroy()}}),[]),zw((function(){var t,r=Bb(t=[]).call(t,rC(e.hasHolderName?["holderName"]:[]),rC(Te?["socialSecurityNumber"]:[]),rC(Oe?["taxNumber"]:[]),rC(ee?["billingAddress"]:[]));xe(r)}),[e.hasHolderName,Te,Oe]),zw((function(){var t,r;F(null),A(CW(CW({},E),{},{holderName:null!==(t=Pe.holderName)&&void 0!==t?t:"",taxNumber:Pe.taxNumber})),me(Pe.socialSecurityNumber),ee&&ce(CW({},Pe.billingAddress)),S(CW(CW({},w),{},{holderName:!e.holderNameRequired||we.holderName,socialSecurityNumber:!!we.socialSecurityNumber&&we.socialSecurityNumber,taxNumber:!!we.taxNumber&&we.taxNumber,billingAddress:!!we.billingAddress&&we.billingAddress}));var a=!!Se.billingAddress&&DC(r=LM(Se.billingAddress)).call(r,(function(e,t){var r=tC(t,2)[1];return e||null!=r}),!1);N(CW(CW({},_),{},{holderName:e.holderNameRequired&&Se.holderName?Se.holderName:null,socialSecurityNumber:Te&&Se.socialSecurityNumber?Se.socialSecurityNumber:null,taxNumber:Oe&&Se.taxNumber?Se.taxNumber:null,billingAddress:ee&&a?Se.billingAddress:null}))}),[Pe,we,Se]),zw((function(){var t=w.holderName,r=j,a=!ee||w.billingAddress,n=!Oe||!!w.taxNumber&&!!w.encryptedPassword,i=!Te||!!w.socialSecurityNumber,l=r&&t&&a&&n&&i,c=o.current.mapErrorsToValidationRuleResult(),s=CW(CW({},_),c),u=s.billingAddress,d=CW(CW({},KP(s,bW)),u),p=yK({errors:d,layout:je(),i18n:e.i18n,countrySpecificLabels:y.getAddressLabelsForCountry(null==le?void 0:le.country)});F(p),e.onChange({data:E,valid:w,errors:s,isValid:l,billingAddress:le,selectedBrandValue:$,storePaymentMethod:ne,socialSecurityNumber:fe,installments:ve})}),[E,w,_,$,ne,ve]);var Ke=e.storedPaymentMethodId?Uq:eW;return JN(ZN,null,JN(oU,FN({ref:o},function(e){return{allowedDOMAccess:e.allowedDOMAccess,autoFocus:e.autoFocus,brands:e.brands,brandsConfiguration:e.brandsConfiguration,clientKey:e.clientKey,countryCode:e.countryCode,forceCompat:e.forceCompat,i18n:e.i18n,implementationType:e.implementationType,keypadFix:e.keypadFix,legacyInputMode:e.legacyInputMode,loadingContext:e.loadingContext,minimumExpiryDate:e.minimumExpiryDate,onAdditionalSFConfig:e.onAdditionalSFConfig,onAdditionalSFRemoved:e.onAdditionalSFRemoved,onAllValid:e.onAllValid,onAutoComplete:e.onAutoComplete,onBinValue:e.onBinValue,onConfigSuccess:e.onConfigSuccess,onError:e.onError,onFieldValid:e.onFieldValid,onLoad:e.onLoad,showWarnings:e.showWarnings,trimTrailingSeparator:e.trimTrailingSeparator,maskSecurityCode:e.maskSecurityCode}}(e),{styles:CW(CW({},lU),e.styles),koreanAuthenticationRequired:e.configuration.koreanAuthenticationRequired,hasKoreanFields:!(!e.configuration.koreanAuthenticationRequired||"kr"!==e.countryCode),onChange:function(t,r){var a;if(F(null),t.autoCompleteName){if(!e.hasHolderName)return;var n=(i="blur",c=DC(l=fU["holderName"]).call(l,(function(e,t){var r;return e.length||Eb(r=t.modes).call(r,i)&&e.push(t.validate),e}),[]),c[0]),o=n(t.autoCompleteName)?t.autoCompleteName:null;o&&(Ee("holderName",o),Ae("holderName",!0),De("holderName",null))}else{var i,l,c;e.autoFocus&&u.current>0&&(!w.encryptedCardNumber&&null!==(a=t.valid)&&void 0!==a&&a.encryptedCardNumber||w.encryptedCardNumber&&t.valid.encryptedCardNumber&&"handleOnBrand"===r.event)&&Ve(),A(CW(CW({},E),t.data)),N(CW(CW({},_),t.errors)),S(CW(CW({},w),t.valid)),z(t.isSfpValid),H(t.cvcPolicy),de(t.showSocialSecurityNumber),V(t.expiryDatePolicy)}},onBrand:e.onBrand,onFocus:Be,type:e.brand,isCollatingErrors:m,disableIOSArrowKeys:e.disableIOSArrowKeys?ze:null,render:function(t,r){var a,n,o=t.setRootNode,i=t.setFocusOn;return JN("div",{ref:o,className:ww((n={"adyen-checkout__card-input":!0},Wg(n,PK["card-input__wrapper"],!0),Wg(n,"adyen-checkout__card-input--".concat(null!==(a=e.fundingSource)&&void 0!==a?a:"credit"),!0),Wg(n,"adyen-checkout__card-input--loading","loading"===b),n)),role:m&&"form","aria-describedby":m?p:null},JN(Ke,FN({},function(e){return{amount:e.amount,billingAddressRequired:e.billingAddressRequired,billingAddressRequiredFields:e.billingAddressRequiredFields,billingAddressAllowedCountries:e.billingAddressAllowedCountries,brandsConfiguration:e.brandsConfiguration,enableStoreDetails:e.enableStoreDetails,hasCVC:e.hasCVC,hasHolderName:e.hasHolderName,holderNameRequired:e.holderNameRequired,installmentOptions:e.installmentOptions,placeholders:e.placeholders,positionHolderNameOnTop:e.positionHolderNameOnTop,showBrandIcon:e.showBrandIcon,showBrandsUnderCardNumber:e.showBrandsUnderCardNumber,lastFour:e.lastFour,expiryMonth:e.expiryMonth,expiryYear:e.expiryYear,disclaimerMessage:e.disclaimerMessage}}(e),{data:E,valid:w,errors:_,handleChangeFor:_e,focusedElement:O,setFocusOn:i,sfpState:r,collateErrors:m,errorFieldId:p,cvcPolicy:K,hasInstallments:Ie,showAmountsInInstallments:Fe,handleInstallments:ye,brandsIcons:e.brandsIcons,mergedSRErrors:I,moveFocus:h,showPanel:v,handleErrorPanelFocus:Me,formData:Pe,formErrors:Se,formValid:we,expiryDatePolicy:L,dualBrandSelectElements:J,extensions:Ue,selectedBrandValue:$,showKCP:Oe,showBrazilianSSN:Te,socialSecurityNumber:fe,handleOnStoreDetails:oe,setAddressRef:c,billingAddress:le,billingAddressValidationRules:te&&aO(re.current),partialAddressSchema:te,handleAddress:Le,iOSFocusedField:be})))}})),e.showPayButton&&e.payButton({status:b,variant:e.isPayButtonPrimaryVariant?"primary":"secondary",icon:GP({loadingContext:e.loadingContext,imageFolder:"components/"})("lock")}))};function NW(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}_W.defaultProps=iU;var PW=function(e){var t=null;return function(r){if(!1!==e.props.doBinLookup){if(r.encryptedBin&&e.props.clientKey)t=r.uuid,UB({loadingContext:e.props.loadingContext,path:"v3/bin/binLookup?token=".concat(e.props.clientKey)},{type:e.props.type,supportedBrands:e.props.brands||DD,encryptedBin:r.encryptedBin,requestId:r.uuid}).then((function(a){var n;if((null==a?void 0:a.requestId)===t)if(null!==(n=a.brands)&&void 0!==n&&n.length){var o,i,l=DC(o=a.brands).call(o,(function(e,t){return e.detectedBrands.push(t.brand),!0===t.supported?(e.supportedBrands.push(t),e):e}),{supportedBrands:[],detectedBrands:[]});if(l.supportedBrands.length)return e.processBinLookupResponse(function(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=NW(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=NW(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}({issuingCountryCode:a.issuingCountryCode,supportedBrands:l.supportedBrands},a.showSocialSecurityNumber?{showSocialSecurityNumber:a.showSocialSecurityNumber}:{})),void e.onBinLookup({type:r.type,detectedBrands:l.detectedBrands,supportedBrands:QC(i=l.supportedBrands).call(i,(function(e){return e.brand})),supportedBrandsRaw:l.supportedBrands,brands:e.props.brands||DD,issuingCountryCode:a.issuingCountryCode});if(l.detectedBrands.length){var c={type:"card",fieldType:"encryptedCardNumber",error:ML($D),detectedBrands:l.detectedBrands};return e.handleUnsupportedCard(c),void e.onBinLookup({type:r.type,detectedBrands:l.detectedBrands,supportedBrands:null,brands:e.props.brands||DD})}}else e.onBinLookup({type:r.type,detectedBrands:null,supportedBrands:null,brands:e.props.brands||DD}),e.processBinLookupResponse({},!0);else null!=a&&a.requestId||e.props.onError(a||{errorType:"binLookup",message:"unknownError"})}));else if(t){e.processBinLookupResponse(null,!0),t=null;e.handleUnsupportedCard({type:"card",fieldType:"encryptedCardNumber",error:""}),e.onBinLookup({isReset:!0})}e.props.onBinValue&&e.props.onBinValue(r)}else e.props.onBinValue&&e.props.onBinValue(r)}};function wW(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}var SW=function(e){TN(r,e);var t=wW(r);function r(e,a,n){var o,i,l;Bg(this,r),Wg(RN(l=t.call(this)),"reason",void 0),Wg(RN(l),"message",void 0),Wg(RN(l),"source",void 0),Wg(RN(l),"scheme",void 0);var c="error"in e?null==e||null===(o=e.error)||void 0===o?void 0:o.message:null==e?void 0:e.message,s="error"in e?null==e||null===(i=e.error)||void 0===i?void 0:i.reason:null==e?void 0:e.reason;return l.message=c,l.reason=s,l.source=a,l.scheme=n,l}return qg(r)}(nA(Error)),xW=function(){function e(t,r){if(Bg(this,e),Wg(this,"schemeSdk",void 0),Wg(this,"schemeName",void 0),Wg(this,"customSdkConfiguration",void 0),Wg(this,"sdkUrl",void 0),Wg(this,"scriptElement",null),!t)throw Error("AbstractSrcInitiator: Invalid SDK URL");this.sdkUrl=t,this.customSdkConfiguration=r}var t,r,a,n,o,i;return qg(e,[{key:"loadSdkScript",value:(i=$d(Ky.mark((function e(){return Ky.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(this.isSdkIsAvailableOnWindow()){e.next=4;break}return this.scriptElement=new Rz(this.sdkUrl),e.next=4,this.scriptElement.load();case 4:this.assignSdkReference();case 5:case"end":return e.stop()}}),e,this)}))),function(){return i.apply(this,arguments)})},{key:"removeSdkScript",value:function(){this.scriptElement.remove()}},{key:"checkout",value:(o=$d(Ky.mark((function e(t){var r;return Ky.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.prev=0,e.next=3,this.schemeSdk.checkout(t);case 3:return r=e.sent,e.abrupt("return",r);case 7:throw e.prev=7,e.t0=e.catch(0),new SW(e.t0,"checkout",this.schemeName);case 11:case"end":return e.stop()}}),e,this,[[0,7]])}))),function(e){return o.apply(this,arguments)})},{key:"unbindAppInstance",value:(n=$d(Ky.mark((function e(){return Ky.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,this.schemeSdk.unbindAppInstance();case 2:return e.abrupt("return",e.sent);case 3:case"end":return e.stop()}}),e,this)}))),function(){return n.apply(this,arguments)})},{key:"isRecognized",value:(a=$d(Ky.mark((function e(){var t;return Ky.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.prev=0,e.next=3,this.schemeSdk.isRecognized();case 3:return t=e.sent,e.abrupt("return",t);case 7:throw e.prev=7,e.t0=e.catch(0),new SW(e.t0,"isRecognized",this.schemeName);case 11:case"end":return e.stop()}}),e,this,[[0,7]])}))),function(){return a.apply(this,arguments)})},{key:"initiateIdentityValidation",value:(r=$d(Ky.mark((function e(){var t;return Ky.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.prev=0,e.next=3,this.schemeSdk.initiateIdentityValidation();case 3:return t=e.sent,e.abrupt("return",t);case 7:throw e.prev=7,e.t0=e.catch(0),new SW(e.t0,"initiateIdentityValidation",this.schemeName);case 11:case"end":return e.stop()}}),e,this,[[0,7]])}))),function(){return r.apply(this,arguments)})},{key:"getSrcProfile",value:(t=$d(Ky.mark((function e(t){var r;return Ky.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.prev=0,e.next=3,this.schemeSdk.getSrcProfile({idTokens:t});case 3:return r=e.sent,e.abrupt("return",r);case 7:throw e.prev=7,e.t0=e.catch(0),new SW(e.t0,"getSrcProfile",this.schemeName);case 11:case"end":return e.stop()}}),e,this,[[0,7]])}))),function(e){return t.apply(this,arguments)})}]),e}();function EW(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function AW(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=EW(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=EW(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}function DW(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}var IW={email:"EMAIL",telephoneNumber:"MOBILE_NUMBER"},FW=function(e){TN(o,e);var t,r,a,n=DW(o);function o(e,t){var r,a;return Bg(this,o),Wg(RN(a=n.call(this,Eb(r=e.toLowerCase()).call(r,"live")?"https://assets.secure.checkout.visa.com/checkout-widget/resources/js/src-i-adapter/visa-sdk.js?v2":"https://sandbox-assets.secure.checkout.visa.com/checkout-widget/resources/js/src-i-adapter/visa-sdk.js?v2",t)),"schemeName","visa"),a}return qg(o,[{key:"isSdkIsAvailableOnWindow",value:function(){var e;return!(null===(e=window.vAdapters)||void 0===e||!e.VisaSRCI)}},{key:"assignSdkReference",value:function(){this.schemeSdk=new window.vAdapters.VisaSRCI}},{key:"init",value:(a=$d(Ky.mark((function e(t,r){var a;return Ky.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return a=AW(AW(AW({},t),(n=this.customSdkConfiguration,o=void 0,i=void 0,l=void 0,o=n.dpaLocale,i=void 0===o?"en_US":o,l=n.dpaPresentationName,{dpaTransactionOptions:{dpaLocale:i,payloadTypeIndicator:"NON_PAYMENT",customInputData:{checkoutOrchestator:"merchant"}},dpaData:{dpaPresentationName:void 0===l?"":l}})),{},{srciTransactionId:r}),e.next=3,this.schemeSdk.init(a);case 3:case"end":return e.stop()}var n,o,i,l}),e,this)}))),function(e,t){return a.apply(this,arguments)})},{key:"identityLookup",value:(r=$d(Ky.mark((function e(t){var r,a,n,o;return Ky.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return r=t.identityValue,a=t.type,e.prev=1,n={identityValue:r,type:IW[a]},e.next=5,this.schemeSdk.identityLookup(n);case 5:return o=e.sent,e.abrupt("return",o);case 9:throw e.prev=9,e.t0=e.catch(1),new SW(e.t0,"identityLookup",this.schemeName);case 13:case"end":return e.stop()}}),e,this,[[1,9]])}))),function(e){return r.apply(this,arguments)})},{key:"completeIdentityValidation",value:(t=$d(Ky.mark((function e(t){var r;return Ky.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.prev=0,e.next=3,this.schemeSdk.completeIdentityValidation(t);case 3:return r=e.sent,e.abrupt("return",r);case 7:throw e.prev=7,e.t0=e.catch(0),new SW(e.t0,"completeIdentityValidation",this.schemeName);case 11:case"end":return e.stop()}}),e,this,[[0,7]])}))),function(e){return t.apply(this,arguments)})}]),o}(xW);function RW(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function OW(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=RW(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=RW(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}function TW(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}var BW,jW={email:"EMAIL_ADDRESS",telephoneNumber:"MOBILE_PHONE_NUMBER"},zW=function(e){TN(o,e);var t,r,a,n=TW(o);function o(e,t){var r,a;return Bg(this,o),Wg(RN(a=n.call(this,Eb(r=e.toLowerCase()).call(r,"live")?"https://src.mastercard.com/sdk/srcsdk.mastercard.js":"https://sandbox.src.mastercard.com/sdk/srcsdk.mastercard.js",t)),"schemeName","mc"),a}return qg(o,[{key:"isSdkIsAvailableOnWindow",value:function(){return!!window.SRCSDK_MASTERCARD}},{key:"assignSdkReference",value:function(){this.schemeSdk=window.SRCSDK_MASTERCARD}},{key:"init",value:(a=$d(Ky.mark((function e(t,r){var a;return Ky.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return a=OW(OW(OW({},t),(n=this.customSdkConfiguration,o=void 0,i=void 0,l=void 0,o=n.dpaLocale,i=void 0===o?"en_US":o,l=n.dpaPresentationName,{dpaTransactionOptions:{dpaLocale:i,paymentOptions:{dynamicDataType:"CARD_APPLICATION_CRYPTOGRAM_SHORT_FORM"},consumerNameRequested:!0,customInputData:{"com.mastercard.dcfExperience":"PAYMENT_SETTINGS"},confirmPayment:!1},dpaData:{dpaPresentationName:void 0===l?"":l}})),{},{srciTransactionId:r}),e.next=3,this.schemeSdk.init(a);case 3:case"end":return e.stop()}var n,o,i,l}),e,this)}))),function(e,t){return a.apply(this,arguments)})},{key:"identityLookup",value:(r=$d(Ky.mark((function e(t){var r,a,n,o;return Ky.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return r=t.identityValue,a=t.type,e.prev=1,n={identityValue:r,identityType:jW[a]},e.next=5,this.schemeSdk.identityLookup({consumerIdentity:n});case 5:return o=e.sent,e.abrupt("return",o);case 9:throw e.prev=9,e.t0=e.catch(1),new SW(e.t0,"identityLookup",this.schemeName);case 13:case"end":return e.stop()}}),e,this,[[1,9]])}))),function(e){return r.apply(this,arguments)})},{key:"completeIdentityValidation",value:(t=$d(Ky.mark((function e(t){var r;return Ky.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.prev=0,e.next=3,this.schemeSdk.completeIdentityValidation({validationData:t});case 3:return r=e.sent,e.abrupt("return",r);case 7:throw e.prev=7,e.t0=e.catch(0),new SW(e.t0,"completeIdentityValidation",this.schemeName);case 11:case"end":return e.stop()}}),e,this,[[0,7]])}))),function(e){return t.apply(this,arguments)})}]),o}(xW),MW=function(e){return"fulfilled"===e.status},LW=function(e){return"rejected"===e.status},VW={visa:FW,mc:zW,default:null},UW=function(e,t,r){var a=VW[e]||VW.default;return a?new a(t,r):null},KW=function(){function e(t,r){var a=r.dpaLocale,n=void 0===a?"en_US":a,o=r.dpaPresentationName,i=void 0===o?"":o;Bg(this,e),Wg(this,"schemes",void 0),Wg(this,"customSdkConfiguration",void 0),this.schemes=t,this.customSdkConfiguration={dpaLocale:n,dpaPresentationName:i}}var t;return qg(e,[{key:"load",value:(t=$d(Ky.mark((function e(t){var r=this;return Ky.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(this.schemes){e.next=2;break}throw new iA("ERROR","ClickToPay -> SrcSdkLoader: There are no schemes set to be loaded");case 2:return e.abrupt("return",new ok((function(e,a){var n,o=QC(n=r.schemes).call(n,(function(e){return UW(e,t,r.customSdkConfiguration)})),i=QC(o).call(o,(function(e){return e.loadSdkScript()}));ok.allSettled(i).then((function(t){mD(t).call(t,LW)&&a(new iA("ERROR","ClickToPay -> SrcSdkLoader # Unable to load network schemes: ".concat(r.schemes.toString())));var n=nb(o).call(o,(function(e,r){return MW(t[r])}));e(n)}))})));case 3:case"end":return e.stop()}}),e,this)}))),function(e){return t.apply(this,arguments)})}]),e}(),HW={mc:"Mastercard",visa:"Visa"},qW=function(){function e(t,r,a){Bg(this,e),Wg(this,"dateOfCardLastUsed",void 0),Wg(this,"panLastFour",void 0),Wg(this,"srcDigitalCardId",void 0),Wg(this,"scheme",void 0),Wg(this,"artUri",void 0),Wg(this,"srcCorrelationId",void 0),Wg(this,"tokenId",void 0),Wg(this,"isExpired",void 0),Wg(this,"panExpirationMonth",void 0),Wg(this,"panExpirationYear",void 0),Wg(this,"descriptorName",void 0),Wg(this,"status",null),this.dateOfCardLastUsed=t.dateOfCardLastUsed,this.panLastFour=t.panLastFour,this.srcDigitalCardId=t.srcDigitalCardId,this.descriptorName=t.digitalCardData.descriptorName,this.tokenId=t.tokenId,this.scheme=r,this.artUri=t.digitalCardData.artUri,this.srcCorrelationId=a,this.panExpirationMonth=t.panExpirationMonth,this.panExpirationYear=t.panExpirationYear,this.status=t.digitalCardData.status,this.isExpired=this.confirmCardIsExpired()}return qg(e,[{key:"title",get:function(){return this.descriptorName||HW[this.scheme]}},{key:"isDcfPopupEmbedded",get:function(){return"mc"===this.scheme}},{key:"confirmCardIsExpired",value:function(){if("ACTIVE"!==this.status)return!0;if(!this.panExpirationYear&&!this.panExpirationMonth)return!1;var e=[(new Date).getMonth()+1,(new Date).getFullYear()],t=e[0],r=e[1];return!(Number(this.panExpirationYear)>r)&&!(Number(this.panExpirationYear)===r&&Number(this.panExpirationMonth)>=t)}}]),e}(),WW="ctpIframe";function YW(e,t,r){var a,n=e.scheme,o=e.tokenId,i=e.srcDigitalCardId,l=e.srcCorrelationId;return"visa"===n?o?{srcScheme:n,srcCorrelationId:l,srcTokenReference:Eb(a=r.toLowerCase()).call(a,"live")?o:"987654321"}:{srcScheme:n,srcCheckoutPayload:t.checkoutResponse,srcCorrelationId:l}:{srcScheme:n,srcDigitalCardId:i,srcCorrelationId:l}}function GW(e,t){var r,a=t.profiles,n=t.srcCorrelationId,o=DC(a).call(a,(function(e,r){var a,o,i=QC(a=r.maskedCards).call(a,(function(e){return new qW(e,t.scheme,n)}));return Bb(o=[]).call(o,rC(e),rC(i))}),[]);return Bb(r=[]).call(r,rC(e),rC(o))}function JW(e,t){return new Date(t.dateOfCardLastUsed).getTime()-new Date(e.dateOfCardLastUsed).getTime()}function QW(e,t){return t.isExpired?e.expiredCards.push(t):e.availableCards.push(t),e}function ZW(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function $W(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=ZW(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=ZW(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}!function(e){e.Idle="Idle",e.Loading="Loading",e.ShopperIdentified="ShopperIdentified",e.OneTimePassword="OneTimePassword",e.Ready="Ready",e.Login="Login",e.NotAvailable="NotAvailable"}(BW||(BW={}));var XW=function(){function e(t,r,a,n){Bg(this,e),Wg(this,"sdkLoader",void 0),Wg(this,"schemesConfig",void 0),Wg(this,"shopperIdentity",void 0),Wg(this,"environment",void 0),Wg(this,"srciTransactionId",CP()),Wg(this,"sdks",void 0),Wg(this,"validationSchemeSdk",null),Wg(this,"stateSubscriber",void 0),Wg(this,"state",BW.Idle),Wg(this,"shopperCards",null),Wg(this,"identityValidationData",null),this.sdkLoader=r,this.schemesConfig=t,this.shopperIdentity=n,this.environment=a}var t,r,a,n,o,i,l,c,s;return qg(e,[{key:"schemes",get:function(){return this.sdkLoader.schemes}},{key:"initialize",value:(s=$d(Ky.mark((function e(){var t,r,a,n,o,i,l;return Ky.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return this.setState(BW.Loading),e.prev=1,e.next=4,this.sdkLoader.load(this.environment);case 4:return this.sdks=e.sent,e.next=7,this.initiateSdks();case 7:return e.next=9,this.verifyIfShopperIsRecognized();case 9:if(t=e.sent,r=t.recognized,a=void 0!==r&&r,n=t.idTokens,o=void 0===n?null:n,!a){e.next=19;break}return e.next=17,this.getShopperProfile(o);case 17:return this.setState(BW.Ready),e.abrupt("return");case 19:if(this.shopperIdentity){e.next=22;break}return this.setState(BW.NotAvailable),e.abrupt("return");case 22:return e.next=24,this.verifyIfShopperIsEnrolled(this.shopperIdentity);case 24:if(!e.sent.isEnrolled){e.next=29;break}return this.setState(BW.ShopperIdentified),e.abrupt("return");case 29:this.setState(BW.NotAvailable),e.next=36;break;case 32:e.prev=32,e.t0=e.catch(1),e.t0 instanceof SW?console.warn(Bb(i=Bb(l="Error at ClickToPayService: Reason: ".concat(e.t0.reason," / Source: ")).call(l,e.t0.source," / Scheme: ")).call(i,e.t0.scheme)):console.warn(e.t0),this.setState(BW.NotAvailable);case 36:case"end":return e.stop()}}),e,this,[[1,32]])}))),function(){return s.apply(this,arguments)})},{key:"subscribeOnStateChange",value:function(e){this.stateSubscriber=e}},{key:"startIdentityValidation",value:(c=$d(Ky.mark((function e(){var t,r;return Ky.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(this.validationSchemeSdk){e.next=2;break}throw Error("startIdentityValidation: No ValidationSDK set for the validation process");case 2:return e.next=4,this.validationSchemeSdk.initiateIdentityValidation();case 4:t=e.sent,r=t.maskedValidationChannel,this.identityValidationData={maskedShopperContact:r.replace(/\*/g,"\u2022"),selectedNetwork:HW[this.validationSchemeSdk.schemeName]},this.setState(BW.OneTimePassword);case 8:case"end":return e.stop()}}),e,this)}))),function(){return c.apply(this,arguments)})},{key:"finishIdentityValidation",value:(l=$d(Ky.mark((function e(t){var r;return Ky.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(this.validationSchemeSdk){e.next=2;break}throw Error("finishIdentityValidation: No ValidationSDK set for the validation process");case 2:return e.next=4,this.validationSchemeSdk.completeIdentityValidation(t);case 4:return r=e.sent,e.next=7,this.getShopperProfile([r.idToken]);case 7:this.setState(BW.Ready),this.validationSchemeSdk=null;case 9:case"end":return e.stop()}}),e,this)}))),function(e){return l.apply(this,arguments)})},{key:"checkout",value:(i=$d(Ky.mark((function e(t){var r,a,n;return Ky.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(t){e.next=2;break}throw Error("ClickToPayService # checkout: Missing card data");case 2:return a=yk(r=this.sdks).call(r,(function(e){return e.schemeName===t.scheme})),e.next=5,a.checkout($W({srcDigitalCardId:t.srcDigitalCardId,srcCorrelationId:t.srcCorrelationId},t.isDcfPopupEmbedded&&{windowRef:window.frames[WW]}));case 5:if("COMPLETE"===(n=e.sent).dcfActionCode){e.next=8;break}throw new iA("ERROR","Checkout through Scheme DCF did not complete. DCF Action code received: ".concat(n.dcfActionCode));case 8:return e.abrupt("return",YW(t,n,this.environment));case 9:case"end":return e.stop()}}),e,this)}))),function(e){return i.apply(this,arguments)})},{key:"logout",value:(o=$d(Ky.mark((function e(){var t,r;return Ky.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(this.sdks){e.next=2;break}throw new iA("ERROR","ClickToPayService is not initialized");case 2:return r=QC(t=this.sdks).call(t,(function(e){return e.unbindAppInstance()})),e.next=5,ok.all(r);case 5:this.shopperCards=null,this.identityValidationData=null,this.validationSchemeSdk=null,this.setState(BW.Login);case 9:case"end":return e.stop()}}),e,this)}))),function(){return o.apply(this,arguments)})},{key:"verifyIfShopperIsEnrolled",value:(n=$d(Ky.mark((function e(t){var r,a=this;return Ky.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return r=t.shopperEmail,e.abrupt("return",new ok((function(e,t){var n,o=QC(n=a.sdks).call(n,(function(n){var o=n.identityLookup({identityValue:r,type:"email"});return o.then((function(t){t.consumerPresent&&!a.validationSchemeSdk&&(a.setSdkForPerformingShopperIdentityValidation(n),e({isEnrolled:!0}))})).catch((function(e){t(e)})),o}));ok.allSettled(o).then((function(){e({isEnrolled:!1})}))})));case 2:case"end":return e.stop()}}),e)}))),function(e){return n.apply(this,arguments)})},{key:"setState",value:function(e){var t;this.state=e,null===(t=this.stateSubscriber)||void 0===t||t.call(this,this.state)}},{key:"setSdkForPerformingShopperIdentityValidation",value:function(e){this.validationSchemeSdk=e}},{key:"getShopperProfile",value:(a=$d(Ky.mark((function e(t){var r=this;return Ky.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.abrupt("return",new ok((function(e,a){var n,o=QC(n=r.sdks).call(n,(function(e){return e.getSrcProfile(t)}));ok.allSettled(o).then((function(t){var n;mD(t).call(t,LW)&&a(t[0].reason);var o,i,l,c,s,u,d=nb(n=QC(t).call(t,(function(e,t){return MW(e)&&$W($W({},e.value),{},{scheme:r.sdks[t].schemeName})}))).call(n,(function(e){return!!e}));r.shopperCards=(c=DC(i=DC(o=d).call(o,GW,[])).call(i,QW,{availableCards:[],expiredCards:[]}),s=c.availableCards,u=c.expiredCards,Bb(l=[]).call(l,rC(aK(s).call(s,JW)),rC(aK(u).call(u,JW)))),e()}))})));case 1:case"end":return e.stop()}}),e)}))),function(e){return a.apply(this,arguments)})},{key:"verifyIfShopperIsRecognized",value:(r=$d(Ky.mark((function e(){var t=this;return Ky.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.abrupt("return",new ok((function(e,r){var a,n=QC(a=t.sdks).call(a,(function(t){var a=t.isRecognized();return a.then((function(t){return t.recognized&&e(t)})).catch((function(e){return r(e)})),a}));ok.allSettled(n).then((function(){return e({recognized:!1})}))})));case 1:case"end":return e.stop()}}),e)}))),function(){return r.apply(this,arguments)})},{key:"initiateSdks",value:(t=$d(Ky.mark((function e(){var t,r,a=this;return Ky.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return r=QC(t=this.sdks).call(t,(function(e){var t=a.schemesConfig[e.schemeName];return e.init(t,a.srciTransactionId)})),e.next=3,ok.all(r);case 3:case"end":return e.stop()}}),e,this)}))),function(){return t.apply(this,arguments)})}]),e}();function eY(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function tY(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=eY(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=eY(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}var rY=function(e,t){var r=tY({},e&&{shopperEmail:e});return Jy(r).length>0?r:null},aY=function(e){if(!e)return null;var t=e.visaSrciDpaId,r=e.visaSrcInitiatorId,a=e.mcDpaId,n=e.mcSrcClientId,o=tY(tY({},a&&n&&{mc:{srciDpaId:a,srcInitiatorId:n}}),t&&r&&{visa:{srciDpaId:t,srcInitiatorId:r}});return 0===Jy(o).length?null:o},nY=gP({status:null,onSubmit:null,onSetStatus:null,onError:null,amount:null,configuration:null,isCtpPrimaryPaymentMethod:null,setIsCtpPrimaryPaymentMethod:null,logoutShopper:null,ctpState:null,cards:[],schemes:[],otpMaskedContact:null,otpNetwork:null,checkout:null,verifyIfShopperIsEnrolled:null,startIdentityValidation:null,finishIdentityValidation:null}),oY=function(e){var t,r,a=e.clickToPayService,n=e.amount,o=e.configuration,i=e.children,l=e.setClickToPayRef,c=e.onSubmit,s=e.onSetStatus,u=e.onError,d=tC(Bw(a),1)[0],p=tC(Bw((null==a?void 0:a.state)||BW.NotAvailable),2),f=p[0],m=p[1],h=tC(Bw(null),2),v=h[0],y=h[1],g=tC(Bw("ready"),2),b=g[0],k=g[1],C=Lw({});zw((function(){l(C.current),C.current.setStatus=k}),[]),zw((function(){null==d||d.subscribeOnStateChange((function(e){return m(e)}))}),[d]);var _=Uw(function(){var e=$d(Ky.mark((function e(t){return Ky.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,null==d?void 0:d.finishIdentityValidation(t);case 2:case"end":return e.stop()}}),e)})));return function(t){return e.apply(this,arguments)}}(),[d]),N=Uw($d(Ky.mark((function e(){var t;return Ky.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,null==d?void 0:d.startIdentityValidation();case 2:return t=e.sent,e.abrupt("return",t);case 4:case"end":return e.stop()}}),e)}))),[d]),P=Uw(function(){var e=$d(Ky.mark((function e(t){return Ky.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,null==d?void 0:d.checkout(t);case 2:return e.abrupt("return",e.sent);case 3:case"end":return e.stop()}}),e)})));return function(t){return e.apply(this,arguments)}}(),[d]),w=Uw(function(){var e=$d(Ky.mark((function e(t){return Ky.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,null==d?void 0:d.verifyIfShopperIsEnrolled(t);case 2:return e.abrupt("return",e.sent);case 3:case"end":return e.stop()}}),e)})));return function(t){return e.apply(this,arguments)}}(),[d]),S=Uw($d(Ky.mark((function e(){return Ky.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,null==d?void 0:d.logout();case 2:case"end":return e.stop()}}),e)}))),[d]);return JN(nY.Provider,{value:{status:b,onSubmit:c,onError:u,onSetStatus:s,amount:n,configuration:o,isCtpPrimaryPaymentMethod:v,setIsCtpPrimaryPaymentMethod:y,ctpState:f,verifyIfShopperIsEnrolled:w,cards:null==d?void 0:d.shopperCards,schemes:null==d?void 0:d.schemes,otpMaskedContact:null==d||null===(t=d.identityValidationData)||void 0===t?void 0:t.maskedShopperContact,otpNetwork:null==d||null===(r=d.identityValidationData)||void 0===r?void 0:r.selectedNetwork,checkout:P,logoutShopper:S,startIdentityValidation:N,finishIdentityValidation:_}},i)};function iY(){return Kw(nY)}var lY={otp:{validate:function(e){return!!e&&e.length>0},errorMessage:"",modes:["blur"]},default:{validate:function(e){return!!e&&e.length>0},errorMessage:"",modes:["blur"]}},cY=function(e){var t=e.onError,r=e.onResendCode,a=e.disabled,n=tC(Bw(null),2),o=n[0],i=n[1],l=tC(Bw(!1),2),c=l[0],s=l[1],u=$w().i18n,d=iY().startIdentityValidation;zw((function(){var e=null;return o>0&&(e=hw((function(){return i(o-1)}),1e3)),function(){return clearTimeout(e)}}),[o]),zw((function(){var e=null;return c&&(e=hw((function(){s(!1),i(60)}),2e3)),function(){return clearTimeout(e)}}),[c]);var p=Uw(function(){var e=$d(Ky.mark((function e(a){return Ky.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return a.preventDefault(),e.prev=1,r(),s(!0),e.next=6,d();case 6:e.next=13;break;case 8:e.prev=8,e.t0=e.catch(1),t(e.t0.reason),i(0),s(!1);case 13:case"end":return e.stop()}}),e,null,[[1,8]])})));return function(t){return e.apply(this,arguments)}}(),[d,t,r]);return c?JN("div",{className:"adyen-checkout-ctp__otp-resend-code--confirmation"},u.get("ctp.otp.codeResent"),JN(vD,{type:"checkmark",height:14,width:14})):o>0?JN("div",{className:"adyen-checkout-ctp__otp-resend-code--disabled"},u.get("ctp.otp.resendCode")," -"," ",JN("span",{className:"adyen-checkout-ctp__otp-resend-code-counter"}," ",o>0&&"".concat(o,"s")," ")):JN("div",{role:"link",tabIndex:0,className:ww("adyen-checkout-ctp__otp-resend-code",{"adyen-checkout-ctp__otp-resend-code--disabled":a}),onClick:p},u.get("ctp.otp.resendCode"))},sY=function(e){var t=$w().i18n,r=iY().configuration.disableOtpAutoFocus,a=tC(Bw(null),2),n=a[0],o=a[1],i=QF({schema:["otp"],rules:lY}),l=i.handleChangeFor,c=i.data,s=i.triggerValidation,u=i.valid,d=i.errors,p=i.isValid,f=i.setData,m=Lw({validateInput:null}),h=tC(Bw(null),2),v=h[0],y=h[1],g=tC(Bw(!1),2),b=g[0],k=g[1],C=Uw((function(){k(!0),s()}),[s]);zw((function(){c.otp&&k(!0)}),[c.otp]),zw((function(){!r&&v&&v.focus()}),[v,r]),zw((function(){m.current.validateInput=C,e.onSetInputHandlers(m.current)}),[C,e.onSetInputHandlers]);var _=Uw((function(){f("otp",""),o(null),r||v.focus(),e.onResendCode()}),[e.onResendCode,v,r]),N=Uw((function(e){var r=t.get("ctp.errors.".concat(e));r&&o(r)}),[t]),P=Uw((function(t){"Enter"===t.key&&e.onPressEnter()}),[e.onPressEnter]);return zw((function(){e.onChange({data:c,valid:u,errors:d,isValid:p})}),[c,u,d]),JN(kI,{name:"oneTimePassword",label:t.get("ctp.otp.fieldLabel"),labelEndAdornment:!e.hideResendOtpButton&&JN(cY,{disabled:e.isValidatingOtp,onError:N,onResendCode:_}),errorMessage:b?n||e.errorMessage||!!d.otp:null,classNameModifiers:["otp"]},NF("text",{name:"otp",autocorrect:"off",spellcheck:!1,value:c.otp,disabled:e.disabled,onInput:l("otp","input"),onBlur:l("otp","blur"),onKeyUp:P,onCreateRef:y}))},uY=function(e){var t=e.modalElement,r=e.isOpen,a=e.isDismissible,n=e.focusFirst,o=e.focusAfterClose,i=e.onClose;!function(e){var t=e.rootElement,r=e.focusFirst,a=e.shouldTrap,n=void 0===a||a,o=tC(Bw(r),2),i=o[0],l=o[1];zw((function(){n&&(null==i||i.focus())}),[i,n]),zw((function(){if(n){var e=t.querySelectorAll('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])'),a=e[0],o=e[e.length-1];l(r||a);var i=function(e){if("Tab"===e.key||9===e.keyCode)return e.shiftKey&&document.activeElement===a?(o.focus(),void e.preventDefault()):document.activeElement===o?(a.focus(),void e.preventDefault()):void 0};return t.addEventListener("keydown",i),function(){l(null),t.removeEventListener("keydown",i)}}}),[t,r,n])}({rootElement:t,shouldTrap:r,focusFirst:n});var l=Uw((function(){o.focus(),i()}),[i,o]),c=Uw((function(e){a&&e.target instanceof HTMLElement&&!t.contains(e.target)&&l()}),[l,a,t]);return zw((function(){if(r&&t){var e=function(e){("Escape"===e.key||"Esc"===e.key||27===e.keyCode)&&l()};return t.addEventListener("keydown",e),function(){return t.removeEventListener("keydown",e)}}}),[r,t,l]),{closeModal:l,handleClickOutside:c}},dY=["children","classNameModifiers","isOpen","onClose","isDismissible","labelledBy","describedBy","focusFirst","focusAfterClose"],pY=function(e){var t=e.children,r=e.classNameModifiers,a=void 0===r?[]:r,n=e.isOpen,o=e.onClose,i=e.isDismissible,l=void 0===i||i,c=e.labelledBy,s=e.describedBy,u=e.focusFirst,d=e.focusAfterClose,p=KP(e,dY),f=Lw(),m=uY({modalElement:f.current,isOpen:n,isDismissible:l,focusFirst:u,focusAfterClose:d,onClose:o}),h=m.closeModal,v=m.handleClickOutside;return JN("div",FN({className:ww("adyen-checkout__modal-wrapper",QC(a).call(a,(function(e){return"adyen-checkout__modal-wrapper--".concat(e)})),{"adyen-checkout__modal-wrapper--open":n}),role:"dialog","aria-labelledby":c,"aria-describedby":s,"aria-modal":"true","aria-hidden":!n,onClick:v},p),JN("div",{className:"adyen-checkout__modal",ref:f},t({onCloseModal:h})))},fY=function(e){var t=e.classNameModifiers,r=void 0===t?[]:t,a=$w().loadingContext,n=iY().schemes,o=GP({loadingContext:a})("ctp"),i=GP({loadingContext:a,imageFolder:"components/"})("pipe");return JN("div",{className:ww("adyen_checkout-ctp__brand-wrapper",QC(r).call(r,(function(e){return"adyen_checkout-ctp__brand-wrapper--".concat(e)})))},JN(fF,{className:"adyen_checkout-ctp__brand-logo",src:o,alt:"Logo of Click to Pay"}),JN(fF,{className:"adyen_checkout-ctp__brand-pipe",src:i,alt:""}),QC(n).call(n,(function(e){return JN(fF,{key:e,className:ww("adyen_checkout-ctp__brand-scheme","adyen_checkout-ctp__brand-scheme-".concat(e)),src:GP({loadingContext:a})(e),alt:"Logo of ".concat(HW[e])})})))},mY=vI();function hY(){return"adyen-".concat(mY+=1)}var vY=function(e){var t=e.isOpen,r=e.onClose,a=e.focusAfterClose,n=Lw(),o=$w(),i=o.i18n,l=o.loadingContext,c=hY(),s=hY();return JN(pY,{onClose:r,isOpen:t,classNameModifiers:["ctp"],labelledBy:c,describedBy:s,focusFirst:n.current,focusAfterClose:a},(function(e){var t=e.onCloseModal;return JN(ZN,null,JN(fF,{className:"adyen-checkout__ctp-modal-header-image",src:GP({loadingContext:l,imageFolder:"components/"})("ctp_landscape"),alt:""}),JN("h1",{id:c,className:"adyen-checkout__ctp-modal-title"},i.get("ctp.infoPopup.title")),JN("div",{id:s},JN("p",{tabIndex:-1,ref:n,className:"adyen-checkout__ctp-modal-text"},i.get("ctp.infoPopup.subtitle")),JN("ul",{className:"adyen-checkout__ctp-modal-text adyen-checkout__ctp-modal-benefits",type:"disc"},JN("li",null,i.get("ctp.infoPopup.benefit1")),JN("li",null,i.get("ctp.infoPopup.benefit2")),JN("li",null,i.get("ctp.infoPopup.benefit3"))),JN(fY,{classNameModifiers:["popup"]})),JN(eS,{onClick:t,label:i.get("close")}))}))},yY=function(){var e=tC(Bw(!1),2),t=e[0],r=e[1],a=Lw(),n=$w(),o=n.i18n,i=n.loadingContext,l=GP({loadingContext:i,imageFolder:"components/"})("info"),c=Uw((function(){r(!1)}),[]);return JN(ZN,null,JN("button",{ref:a,onClick:Uw((function(){r(!0)}),[]),className:"adyen-web__ctp-info-button","aria-label":o.get("ctp.aria.infoModalButton"),type:"button"},JN(fF,{height:"15",src:l,ariaHidden:!0})),JN(vY,{isOpen:t,onClose:c,focusAfterClose:a.current}))},gY=function(){var e,t=iY(),r=t.ctpState,a=t.logoutShopper,n=t.status,o=t.cards,i=$w().i18n;if(!1===Eb(e=[BW.Ready,BW.OneTimePassword]).call(e,r))return null;var l=Vw((function(){return r===BW.Ready&&o.length>1?i.get("ctp.logout.notYourCards"):r===BW.Ready&&1===o.length?i.get("ctp.logout.notYourCard"):r===BW.Ready&&0===o.length?i.get("ctp.logout.notYourProfile"):i.get("ctp.logout.notYou")}),[i,r]);return JN("span",{role:"button",tabIndex:0,className:ww("adyen-checkout-ctp__section-logout-button",{"adyen-checkout-ctp__section-logout-button--disabled":"loading"===n}),onClick:a},l)},bY=function(e){var t=e.children;return JN("div",{className:"adyen-checkout-ctp__section"},JN("div",{className:"adyen-checkout-ctp__section-brand"},JN(fY,null),JN(gY,null)),t)};bY.Title=function(e){var t=e.endAdornment;return JN("div",{className:"adyen-checkout-ctp__section-header"},JN("h1",{className:"adyen-checkout-ctp__section-header-title"},e.children),t&&JN("span",{className:"adyen-checkout-ctp__section-header-adornment"},t))},bY.Text=function(e){return JN("p",{className:"adyen-checkout-ctp__section-text"},e.children)};var kY=function(e){var t=e.onDisplayCardComponent,r=$w().i18n,a=iY(),n=a.finishIdentityValidation,o=a.otpMaskedContact,i=a.otpNetwork,l=a.isCtpPrimaryPaymentMethod,c=tC(Bw(null),2),s=c[0],u=c[1],d=tC(Bw(!1),2),p=d[0],f=d[1],m=tC(Bw(!1),2),h=m[0],v=m[1],y=tC(Bw(null),2),g=y[0],b=y[1],k=tC(Bw(null),2),C=k[0],_=k[1],N=tC(Bw(!1),2),P=N[0],w=N[1],S=Uw((function(e){_(e)}),[]),x=Uw((function(e){var t=e.data,r=e.isValid;u(t.otp),f(r)}),[]),E=Uw((function(){b(null)}),[]),A=Uw($d(Ky.mark((function e(){return Ky.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(b(null),p){e.next=4;break}return C.validateInput(),e.abrupt("return");case 4:return v(!0),e.prev=5,e.next=8,n(s);case 8:e.next=15;break;case 10:e.prev=10,e.t0=e.catch(5),b(null===e.t0||void 0===e.t0?void 0:e.t0.reason),v(!1),"ACCT_INACCESSIBLE"===(null===e.t0||void 0===e.t0?void 0:e.t0.reason)&&(w(!0),null==t||t());case 15:case"end":return e.stop()}}),e,null,[[5,10]])}))),[s,p,C,t]),D=r.get("ctp.otp.subtitle").split("%@");return JN(ZN,null,JN(bY.Title,{endAdornment:JN(yY,null)},r.get("ctp.otp.title")),JN(bY.Text,null,D[0]," ",i," ",D[1],JN("span",{className:"adyen-checkout-ctp__otp-subtitle--highlighted"},o),D[2]),JN(sY,{hideResendOtpButton:P,onChange:x,onSetInputHandlers:S,disabled:h,errorMessage:g&&r.get("ctp.errors.".concat(g)),onPressEnter:A,onResendCode:E,isValidatingOtp:h}),JN(eS,{disabled:P,label:r.get("continue"),variant:l?"primary":"secondary",onClick:A,status:h&&"loading"}))},CY=function(e){var t=e.card,r=e.errorMessage,a=$w(),n=a.loadingContext,o=a.i18n;return JN(ZN,null,JN("div",{className:"adyen-checkout-ctp__card-list-single-card"},JN(fF,{src:t.artUri||GP({loadingContext:n})(t.scheme),height:24,className:"adyen-checkout-ctp__card-image"}),JN("span",{className:ww({"adyen-checkout-ctp__card-list-single-card-expired":t.isExpired})},t.title," ","\u2022\u2022\u2022\u2022 ".concat(t.panLastFour)),t.isExpired&&JN("span",{className:"adyen-checkout-ctp__expired-label"},o.get("ctp.cards.expiredCard"))),r&&JN("div",{className:"adyen-checkout__error-text"},r))},_Y=function(){return window.matchMedia("(max-width: 768px)").matches&&/Android|iPhone|iPod/.test(navigator.userAgent)},NY=["srcDigitalCardId"],PY=function(e){var t=e.cardSelected,r=e.cards,a=e.errorMessage,n=e.onChangeCard,o=$w(),i=o.i18n,l=o.loadingContext,c=iY().status,s=QF({schema:NY,defaultData:{srcDigitalCardId:t.srcDigitalCardId}}),u=s.handleChangeFor,d=s.data,p=Vw((function(){return QC(r).call(r,(function(e){var t;return{icon:e.artUri||GP({loadingContext:l})(e.scheme),name:Bb(t="".concat(_Y()?"":e.title," \u2022\u2022\u2022\u2022 ")).call(t,e.panLastFour," "),secondaryText:e.isExpired&&i.get("ctp.cards.expiredCard"),id:e.srcDigitalCardId,disabled:e.isExpired}}))}),[r]);return zw((function(){var e=d.srcDigitalCardId,t=yk(r).call(r,(function(t){return t.srcDigitalCardId===e}));n(t)}),[d,n]),JN(kI,{name:"clickToPayCards",errorMessage:a},NF("select",{items:p,selected:d.srcDigitalCardId,name:"cards",filterable:!1,className:"adyen-checkout-ctp__cards-list-dropdown",readonly:"loading"===c,onChange:u("srcDigitalCardId")}))};function wY(e,t){if(!e)return null;var r=t.get("ctp.errors.".concat(e));return Eb(r).call(r,"ctp.errors")?t.get("ctp.errors.UNKNOWN_ERROR"):r}function SY(e,t,r){return r?_Y()?null:e.get("payButton.with",{values:{value:tS(e,t),maskedData:"\u2022\u2022\u2022\u2022 ".concat(null==r?void 0:r.panLastFour)}}):e.get("payButton")}var xY=function(e){var t=e.onDisplayCardComponent,r=$w(),a=r.loadingContext,n=r.i18n,o=iY(),i=o.amount,l=o.cards,c=o.checkout,s=o.isCtpPrimaryPaymentMethod,u=o.status,d=o.onSubmit,p=o.onSetStatus,f=o.onError,m=tC(Bw(yk(l).call(l,(function(e){return!e.isExpired}))||l[0]),2),h=m[0],v=m[1],y=tC(Bw(null),2),g=y[0],b=y[1],k=mD(l).call(l,(function(e){return e.isExpired}));zw((function(){(0===l.length||k)&&(null==t||t())}),[t,k,l]);var C=Uw($d(Ky.mark((function e(){var t,r,a;return Ky.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(h){e.next=2;break}return e.abrupt("return");case 2:return e.prev=2,b(null),p("loading"),e.next=7,c(h);case 7:t=e.sent,d(t),e.next=15;break;case 11:e.prev=11,e.t0=e.catch(2),e.t0 instanceof SW&&(b(null===e.t0||void 0===e.t0?void 0:e.t0.reason),console.warn(Bb(r=Bb(a="CtP - Checkout: Reason: ".concat(null===e.t0||void 0===e.t0?void 0:e.t0.reason," / Source: ")).call(a,null===e.t0||void 0===e.t0?void 0:e.t0.source," / Scheme: ")).call(r,null===e.t0||void 0===e.t0?void 0:e.t0.scheme))),f(e.t0);case 15:case"end":return e.stop()}}),e,null,[[2,11]])}))),[c,h]),_=Uw((function(e){v(e)}),[]),N="loading"===u&&h.isDcfPopupEmbedded,P="loading"!==u||!N;return JN(ZN,null,JN(kA,{name:WW,height:"380",width:"100%",classNameModifiers:[N?"":"hidden"]}),P&&JN(ZN,null,JN(bY.Title,null,n.get("ctp.cards.title")),JN(bY.Text,null,n.get("ctp.cards.subtitle")),0===l.length&&JN("div",{className:"adyen-checkout-ctp__empty-cards"},n.get("ctp.emptyProfile.message")),1===l.length&&JN(CY,{card:l[0],errorMessage:wY(g,n)}),l.length>1&&JN(PY,{cardSelected:h,cards:l,onChangeCard:_,errorMessage:wY(g,n)}),JN(oS,{disabled:k,amount:i,label:SY(n,i,h),status:u,variant:s?"primary":"secondary",icon:0!==l.length&&GP({loadingContext:a,imageFolder:"components/"})(s?"lock":"lock_black"),onClick:C})))},EY=function(){var e=$w(),t=e.i18n,r=e.loadingContext;return JN(ZN,null,JN(fF,{className:"adyen-checkout-ctp__loading-image",src:GP({loadingContext:r,extension:"gif",imageFolder:"components/"})("ctp_loader"),alt:"",height:120}),JN("div",{className:"adyen-checkout-ctp__loading-subtitle"},t.get("ctp.loading.intro")))},AY={shopperLogin:{validate:function(e){return!!e&&e.length>0},errorMessage:"",modes:["blur"]},default:{validate:function(e){return!!e&&e.length>0},errorMessage:"",modes:["blur"]}},DY=function(e){var t=$w().i18n,r=QF({schema:["shopperLogin"],rules:AY}),a=r.handleChangeFor,n=r.data,o=r.triggerValidation,i=r.valid,l=r.errors,c=r.isValid,s=Lw({validateInput:null}),u=tC(Bw(!1),2),d=u[0],p=u[1],f=Uw((function(){p(!0),o()}),[o]);zw((function(){n.shopperLogin&&p(!0)}),[n.shopperLogin]),zw((function(){s.current.validateInput=f,e.onSetInputHandlers(s.current)}),[f,e.onSetInputHandlers]);var m=Uw((function(t){"Enter"===t.key&&e.onPressEnter()}),[e.onPressEnter]);return zw((function(){e.onChange({data:n,valid:i,errors:l,isValid:c})}),[n,i,l]),JN(kI,{name:"shopperLogin",label:t.get("ctp.login.inputLabel"),errorMessage:d?e.errorMessage||!!l.shopperLogin:null,classNameModifiers:["shopperLogin"]},NF("text",{name:"shopperLogin",autocorrect:"off",spellcheck:!1,value:n.shopperLogin,disabled:e.disabled,onInput:a("shopperLogin","input"),onBlur:a("shopperLogin","blur"),onKeyUp:m}))},IY=function(){var e=$w().i18n,t=iY(),r=t.isCtpPrimaryPaymentMethod,a=t.setIsCtpPrimaryPaymentMethod,n=t.verifyIfShopperIsEnrolled,o=t.startIdentityValidation,i=tC(Bw(null),2),l=i[0],c=i[1],s=tC(Bw(!1),2),u=s[0],d=s[1],p=tC(Bw(null),2),f=p[0],m=p[1],h=tC(Bw(!1),2),v=h[0],y=h[1],g=tC(Bw(null),2),b=g[0],k=g[1],C=Uw((function(e){k(e)}),[]),_=Uw((function(e){var t,r=e.data,n=e.isValid;c(r.shopperLogin),d(n),(null==r||null===(t=r.shopperLogin)||void 0===t?void 0:t.length)>0&&a(!0)}),[]),N=Uw($d(Ky.mark((function e(){var t,r,a;return Ky.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(m(null),u){e.next=4;break}return b.validateInput(),e.abrupt("return");case 4:return y(!0),e.prev=5,e.next=8,n({shopperEmail:l});case 8:if(t=e.sent,!t.isEnrolled){e.next=15;break}return e.next=13,o();case 13:e.next=17;break;case 15:m("NOT_FOUND"),y(!1);case 17:e.next=24;break;case 19:e.prev=19,e.t0=e.catch(5),e.t0 instanceof SW&&console.warn(Bb(r=Bb(a="CtP - Login error: Reason: ".concat(null===e.t0||void 0===e.t0?void 0:e.t0.reason," / Source: ")).call(a,null===e.t0||void 0===e.t0?void 0:e.t0.source," / Scheme: ")).call(r,null===e.t0||void 0===e.t0?void 0:e.t0.scheme)),m(null===e.t0||void 0===e.t0?void 0:e.t0.reason),y(!1);case 24:case"end":return e.stop()}}),e,null,[[5,19]])}))),[n,o,l,u,b]);return JN(ZN,null,JN(bY.Title,{endAdornment:JN(yY,null)},e.get("ctp.login.title")),JN(bY.Text,null,e.get("ctp.login.subtitle")),JN(DY,{onChange:_,onSetInputHandlers:C,disabled:v,errorMessage:f&&e.get("ctp.errors.".concat(f)),onPressEnter:N}),JN(eS,{label:e.get("continue"),variant:r?"primary":"secondary",onClick:N,status:v&&"loading"}))},FY=function(e){var t,r=e.onDisplayCardComponent,a=iY(),n=a.ctpState,o=a.startIdentityValidation,i=a.logoutShopper;return zw((function(){function e(){return e=$d(Ky.mark((function e(){var t,r;return Ky.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.prev=0,e.next=3,o();case 3:e.next=9;break;case 5:e.prev=5,e.t0=e.catch(0),e.t0 instanceof SW&&console.warn(Bb(t=Bb(r="CtP - Identity Validation error: Reason: ".concat(null===e.t0||void 0===e.t0?void 0:e.t0.reason," / Source: ")).call(r,null===e.t0||void 0===e.t0?void 0:e.t0.source," / Scheme: ")).call(t,null===e.t0||void 0===e.t0?void 0:e.t0.scheme)),i();case 9:case"end":return e.stop()}}),e,null,[[0,5]])}))),e.apply(this,arguments)}n===BW.ShopperIdentified&&function(){e.apply(this,arguments)}()}),[n]),n===BW.NotAvailable?null:JN(bY,null,Eb(t=[BW.Loading,BW.ShopperIdentified]).call(t,n)&&JN(EY,null),n===BW.OneTimePassword&&JN(kY,{onDisplayCardComponent:r}),n===BW.Ready&&JN(xY,{onDisplayCardComponent:r}),n===BW.Login&&JN(IY,null))},RY=function(e){var t=e.children,r=$w().i18n,a=tC(Bw(null),2),n=a[0],o=a[1],i=iY(),l=i.ctpState,c=i.isCtpPrimaryPaymentMethod,s=i.setIsCtpPrimaryPaymentMethod,u=i.status,d=null===n&&null===c;zw((function(){if(d){if(l===BW.ShopperIdentified||l===BW.Ready)return o(!1),void s(!0);l===BW.NotAvailable&&(o(!0),s(!1))}}),[l,d]);var p=Uw((function(){o(!0),s(!1)}),[]);return l===BW.NotAvailable?t():l===BW.Loading||l===BW.ShopperIdentified?JN(FY,null):JN(ZN,null,JN(FY,{onDisplayCardComponent:p}),JN(uM,{classNames:["adyen-checkout-ctp__separator"],label:r.get("ctp.separatorText")}),n?t(!c):JN(eS,{variant:"secondary",disabled:"loading"===u,label:r.get("ctp.manualCardEntry"),onClick:p}))},OY=["amount","configuration","clickToPayService","setClickToPayRef","onSetStatus","onSubmit","onError"],TY=function(e){var t=e.amount,r=e.configuration,a=e.clickToPayService,n=e.setClickToPayRef,o=e.onSetStatus,i=e.onSubmit,l=e.onError,c=KP(e,OY);return JN(oY,{configuration:r,amount:t,clickToPayService:a,setClickToPayRef:n,onSetStatus:o,onSubmit:i,onError:l},JN(RY,null,c.children))};function BY(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function jY(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=BY(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=BY(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}function zY(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}var MY=function(e){TN(r,e);var t=zY(r);function r(e){var a,n;(Bg(this,r),Wg(RN(a=t.call(this,e)),"clickToPayService",void 0),Wg(RN(a),"clickToPayRef",null),Wg(RN(a),"setClickToPayRef",(function(e){a.clickToPayRef=e})),Wg(RN(a),"onBrand",(function(e){a.eventEmitter.emit("brand",jY(jY({},e),{},{brand:"card"===e.brand?null:e.brand})),a.props.onBrand&&a.props.onBrand(e)})),Wg(RN(a),"handleClickToPaySubmit",(function(e){a.setState({data:jY({},e),valid:{},errors:{},isValid:!0}),a.submit()})),Wg(RN(a),"onBinValue",PW(RN(a))),e._disableClickToPay)||(a.clickToPayService=function(e,t,r){var a=aY(e);if(!a)return null;var n=rY(null==t?void 0:t.shopperEmail,null==t?void 0:t.telephoneNumber),o=Jy(a),i=new KW(o,{dpaLocale:null==t?void 0:t.locale,dpaPresentationName:null==t?void 0:t.merchantDisplayName});return new XW(a,i,r,n)}(a.props.configuration,a.props.clickToPayConfiguration,a.props.environment),null===(n=a.clickToPayService)||void 0===n||n.initialize());return a}return qg(r,[{key:"setStatus",value:function(e,t){var r,a;return null!==(r=this.componentRef)&&void 0!==r&&r.setStatus&&this.componentRef.setStatus(e,t),null!==(a=this.clickToPayRef)&&void 0!==a&&a.setStatus&&this.clickToPayRef.setStatus(e,t),this}},{key:"formatProps",value:function(e){var t,r,a,n,o,i,l,c,s,u,d,p,f,m,h,v,y,g,b,k,C=e.SRConfig,_=C.collateErrors,N=void 0===_||_,P=C.moveFocus,w=void 0!==P&&P,S=C.showPanel,x=void 0!==S&&S;return jY(jY({},e),{},{holderNameRequired:!!e.hasHolderName&&e.holderNameRequired,hasCVC:!(e.brand&&"bcmc"===e.brand||e.hideCVC),billingAddressRequired:!e.storedPaymentMethodId&&e.billingAddressRequired,type:"scheme"===e.type?"card":e.type,countryCode:e.countryCode?e.countryCode.toLowerCase():null,configuration:jY(jY({},e.configuration),{},{socialSecurityNumberMode:null!==(t=null===(r=e.configuration)||void 0===r?void 0:r.socialSecurityNumberMode)&&void 0!==t?t:"auto"}),brandsConfiguration:e.brandsConfiguration||(null===(a=e.configuration)||void 0===a?void 0:a.brandsConfiguration)||{},icon:e.icon||(null===(n=e.configuration)||void 0===n?void 0:n.icon),SRConfig:{collateErrors:N,moveFocus:w,showPanel:x},installmentOptions:(null===(o=e.session)||void 0===o||null===(i=o.configuration)||void 0===i?void 0:i.installmentOptions)||e.installmentOptions,enableStoreDetails:(null===(l=e.session)||void 0===l||null===(c=l.configuration)||void 0===c?void 0:c.enableStoreDetails)||e.enableStoreDetails,clickToPayConfiguration:jY(jY({},e.clickToPayConfiguration),{},{disableOtpAutoFocus:(null===(s=e.clickToPayConfiguration)||void 0===s?void 0:s.disableOtpAutoFocus)||!1,shopperEmail:(null===(u=e.clickToPayConfiguration)||void 0===u?void 0:u.shopperEmail)||(null==e||null===(d=e._parentInstance)||void 0===d||null===(p=d.options)||void 0===p||null===(f=p.session)||void 0===f?void 0:f.shopperEmail),telephoneNumber:(null===(m=e.clickToPayConfiguration)||void 0===m?void 0:m.telephoneNumber)||(null==e||null===(h=e._parentInstance)||void 0===h||null===(v=h.options)||void 0===v||null===(y=v.session)||void 0===y?void 0:y.telephoneNumber),locale:(null===(g=e.clickToPayConfiguration)||void 0===g?void 0:g.locale)||(null===(b=e.i18n)||void 0===b||null===(k=b.locale)||void 0===k?void 0:k.replace("-","_"))})})}},{key:"formatData",value:function(){var e,t=this.state.selectedBrandValue||this.props.brand,a=this.props.enableStoreDetails&&void 0!==this.state.storePaymentMethod;return jY(jY(jY(jY(jY({paymentMethod:jY(jY(jY(jY({type:r.type},this.state.data),this.props.storedPaymentMethodId&&{storedPaymentMethodId:this.props.storedPaymentMethodId}),t&&{brand:t}),this.props.fundingSource&&{fundingSource:this.props.fundingSource})},this.state.billingAddress&&{billingAddress:this.state.billingAddress}),this.state.socialSecurityNumber&&{socialSecurityNumber:this.state.socialSecurityNumber}),a&&{storePaymentMethod:Boolean(this.state.storePaymentMethod)}),("revolving"===(null==(e=this.state.installments)?void 0:e.plan)||(null==e?void 0:e.value)>1)&&{installments:this.state.installments}),{},{browserInfo:this.browserInfo,origin:!!window&&window.location.origin})}},{key:"updateStyles",value:function(e){var t;return null!==(t=this.componentRef)&&void 0!==t&&t.updateStyles&&this.componentRef.updateStyles(e),this}},{key:"setFocusOn",value:function(e){var t;return null!==(t=this.componentRef)&&void 0!==t&&t.setFocusOn&&this.componentRef.setFocusOn(e),this}},{key:"processBinLookupResponse",value:function(e){var t,r=arguments.length>1&&void 0!==arguments[1]&&arguments[1];return null!==(t=this.componentRef)&&void 0!==t&&t.processBinLookupResponse&&this.componentRef.processBinLookupResponse(e,r),this}},{key:"handleUnsupportedCard",value:function(e){var t;return null!==(t=this.componentRef)&&void 0!==t&&t.handleUnsupportedCard&&this.componentRef.handleUnsupportedCard(e),this}},{key:"onBinLookup",value:function(e){if(!e.isReset){var t=jL("supportedBrandsRaw").from(e);this.props.onBinLookup(t)}}},{key:"isValid",get:function(){return!!this.state.isValid}},{key:"icon",get:function(){var e;return null!==(e=this.props.icon)&&void 0!==e?e:GP({loadingContext:this.props.loadingContext})(this.brand)}},{key:"brands",get:function(){var e=this.props,t=e.brands,r=e.loadingContext,a=e.brandsConfiguration;return t?QC(t).call(t,(function(e){var t,n;return{icon:null!==(t=null===(n=a[e])||void 0===n?void 0:n.icon)&&void 0!==t?t:GP({loadingContext:r})(e),name:e}})):[]}},{key:"brand",get:function(){return this.props.brand||this.props.type}},{key:"displayName",get:function(){return this.props.storedPaymentMethodId?"\u2022\u2022\u2022\u2022 ".concat(this.props.lastFour):this.props.name||r.type}},{key:"accessibleName",get:function(){return(this.props.name||r.type)+(this.props.storedPaymentMethodId?" "+this.props.i18n.get("creditCard.storedCard.description.ariaLabel").replace("%@",this.props.lastFour):"")}},{key:"browserInfo",get:function(){return lz()}},{key:"renderCardInput",value:function(){var e=!(arguments.length>0&&void 0!==arguments[0])||arguments[0];return JN(_W,FN({setComponentRef:this.setComponentRef},this.props,this.state,{onChange:this.setState,onSubmit:this.submit,payButton:this.payButton,onBrand:this.onBrand,onBinValue:this.onBinValue,brand:this.brand,brandsIcons:this.brands,isPayButtonPrimaryVariant:e}))}},{key:"render",value:function(){var e=this;return JN(Uj,{i18n:this.props.i18n,loadingContext:this.props.loadingContext,commonProps:{isCollatingErrors:this.props.SRConfig.collateErrors}},JN(TY,{amount:this.props.amount,configuration:this.props.clickToPayConfiguration,clickToPayService:this.clickToPayService,setClickToPayRef:this.setClickToPayRef,onSetStatus:this.setElementStatus,onSubmit:this.handleClickToPaySubmit,onError:this.handleError},(function(t){return e.renderCardInput(t)})))}}]),r}(dA);function LY(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function VY(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=LY(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=LY(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}function UY(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}Wg(MY,"type","scheme"),Wg(MY,"defaultProps",{onBinLookup:function(){},showBrandsUnderCardNumber:!0,SRConfig:{},_disableClickToPay:!1});var KY=function(e){TN(r,e);var t=UY(r);function r(e){var a;return Bg(this,r),Wg(RN(a=t.call(this,e)),"onBrand",(function(e){a.props.onBrand&&a.props.onBrand(e)})),a}return qg(r,[{key:"formatProps",value:function(e){return VY(VY({},oD(jN(r.prototype),"formatProps",this).call(this,e)),{},{type:"bcmc",cvcPolicy:UD})}}]),r}(MY);function HY(e){var t=e.description,r=void 0===t?"":t,a=e.name,n=void 0===a?"":a,o=e.logoUrl,i=void 0===o?"":o,l=e.url,c=void 0===l?"":l,s=e.backgroundUrl,u=void 0===s?"":s;return JN("div",{className:"adyen-checkout__campaign-container"},JN(fF,{className:"adyen-checkout__campaign-background-image",style:{backgroundImage:"linear-gradient(0, #000, #0003), url(".concat(u,")")},backgroundUrl:u}),JN("div",{className:"adyen-checkout__campaign-content"},i&&JN("img",{src:i,className:"adyen-checkout__campaign-logo",alt:n}),n&&JN("div",{className:"adyen-checkout__campaign-title"},n),r&&JN("div",{className:"adyen-checkout__campaign-description"},r,c&&" \u203a")))}function qY(e){var t=e.url;return JN("div",{className:"adyen-checkout__campaign"},!t&&JN(HY,e),t&&JN("a",{href:t,className:"adyen-checkout__campaign-link",target:"_blank",rel:"noopener noreferrer"},JN(HY,e)))}Wg(KY,"defaultProps",VY(VY({},MY.defaultProps),{},{brands:["bcmc","maestro","visa"]}));var WY=function(e){var t=e.options,r=void 0===t?[]:t,a=e.name,n=e.onChange;return JN("div",{className:"adyen-checkout__button-group"},QC(r).call(r,(function(e,t){var r,o=e.label,i=e.selected,l=e.value,c=e.disabled;return JN("label",{key:Bb(r="".concat(a)).call(r,t),className:ww({"adyen-checkout__button":!0,"adyen-checkout__button--selected":i,"adyen-checkout__button--disabled":c})},JN("input",{type:"radio",className:"adyen-checkout__button-group__input",value:l,checked:i,onChange:n,disabled:c}),JN("span",{className:"adyen-checkout__button-text"},o))})))};function YY(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function GY(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=YY(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=YY(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}function JY(e){var t,r=e.amounts,a=e.onCancel,n=e.onDonate,o=e.showCancelButton,i=void 0===o||o,l=$w(),c=l.i18n,s=l.loadingContext,u=r.currency,d=tC(Bw("ready"),2),p=d[0],f=d[1],m=tC(Bw(!1),2),h=m[0],v=m[1],y=tC(Bw({currency:u,value:null}),2),g=y[0],b=y[1];this.setStatus=function(e){f(e)};var k=Uw((function(e,t){return c.amount(e,t)}),[c]);return zw((function(){e.onChange({data:{amount:g},isValid:h})}),[g,h]),"error"===p?JN("div",{className:"adyen-checkout__adyen-giving"},JN(fF,{className:"adyen-checkout__status__icon adyen-checkout__status__icon--error",src:GP({loadingContext:s,imageFolder:"components/"})("error"),alt:c.get("error.message.unknown")}),JN("div",{className:"adyen-checkout__status__text"},c.get("error.message.unknown"))):"success"===p?JN("div",{className:"adyen-checkout__adyen-giving"},JN(fF,{className:"adyen-checkout__status__icon adyen-checkout__status__icon--success",src:GP({loadingContext:s,imageFolder:"components/"})("heart"),alt:c.get("thanksForYourSupport")}),JN("div",{className:"adyen-checkout__status__text"},c.get("thanksForYourSupport"))):JN("div",{className:"adyen-checkout__adyen-giving"},JN(qY,e),JN("div",{className:"adyen-checkout__adyen-giving-actions"},JN("div",{className:"adyen-checkout__amounts"},JN(WY,{options:QC(t=VC(r)).call(t,(function(e){return{value:e,label:k(e,u),disabled:"loading"===p,selected:e===g.value}})),name:"amount",onChange:function(e){var t=e.target,r=O_(t.value,10);v(!0),b((function(e){return GY(GY({},e),{},{value:r})}))}})),JN(eS,{classNameModifiers:["donate"],onClick:function(){f("loading"),n({data:{amount:g}})},label:c.get("donateButton"),disabled:!g.value,status:p}),i&&JN(eS,{classNameModifiers:["decline"],variant:"ghost",onClick:function(){f("loading"),a({data:{amount:g},isValid:h})},disabled:"loading"===p,label:"".concat(c.get("notNowButton")," \u203a")})))}function QY(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function ZY(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=QY(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=QY(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}function $Y(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}JY.defaultProps={onCancel:function(){},onChange:function(){},onDonate:function(){},amounts:{},showCancelButton:!0};var XY=function(e){TN(r,e);var t=$Y(r);function r(e){var a,n;return Bg(this,r),Wg(RN(n=t.call(this,e)),"handleRef",(function(e){n.componentRef=e})),n.donate=rk(a=n.donate).call(a,RN(n)),n}return qg(r,[{key:"data",get:function(){return this.state.data}},{key:"isValid",get:function(){return this.state.isValid}},{key:"setState",value:function(e){this.state=ZY(ZY({},this.state),e)}},{key:"donate",value:function(){var e=this.data,t=this.isValid;this.props.onDonate({data:e,isValid:t},this)}},{key:"render",value:function(){return JN(Uj,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},JN(JY,FN({},this.props,{ref:this.handleRef,onChange:this.setState,onDonate:this.donate})))}}]),r}(dA);function eG(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function tG(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}Wg(XY,"type","donation"),Wg(XY,"defaultProps",{onCancel:function(){},onDonate:function(){}});var rG=function(e){TN(r,e);var t=tG(r);function r(){var e,a;Bg(this,r);for(var n=arguments.length,o=new Array(n),i=0;i<n;i++)o[i]=arguments[i];return Wg(RN(a=t.call.apply(t,Bb(e=[this]).call(e,o))),"postForm",void 0),a}return qg(r,[{key:"componentDidMount",value:function(){var e=this,t=new ok((function(t,r){return e.props.beforeRedirect(t,r,function(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=eG(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=eG(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}({url:e.props.url,method:e.props.method},e.props.data?{data:e.props.data}:{}))}));t.then((function(){e.postForm?e.postForm.submit():window.location.assign(e.props.url)})).catch((function(){}))}},{key:"render",value:function(e){var t,r=this,a=e.url,n=e.method,o=e.data,i=void 0===o?{}:o;return"POST"===n?JN("form",{method:"post",action:a,style:{display:"none"},ref:function(e){r.postForm=e}},QC(t=Jy(i)).call(t,(function(e){return JN("input",{type:"hidden",name:e,key:e,value:i[e]})}))):null}}]),r}($N);function aG(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function nG(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=aG(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=aG(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}function oG(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}Wg(rG,"defaultProps",{beforeRedirect:function(e){return e()},method:"GET"});var iG=function(e){TN(r,e);var t=oG(r);function r(){return Bg(this,r),t.apply(this,arguments)}return qg(r,[{key:"formatProps",value:function(e){return nG(nG({},e),{},{showButton:!!e.showPayButton})}},{key:"formatData",value:function(){return{paymentMethod:{type:this.props.type}}}},{key:"isValid",get:function(){return!0}},{key:"icon",get:function(){return GP({loadingContext:this.props.loadingContext})(this.props.type)}},{key:"render",value:function(){var e=this;return this.props.url&&this.props.method?JN(rG,this.props):this.props.showButton?JN(Uj,FN({},this.props,{loadingContext:this.props.loadingContext}),JN(NM,FN({},this.props,{onSubmit:this.submit,payButton:this.payButton,ref:function(t){e.componentRef=t}}))):null}}]),r}(dA);function lG(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function cG(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=lG(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=lG(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}function sG(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}Wg(iG,"type","redirect"),Wg(iG,"defaultProps",{type:iG.type,showPayButton:!0});var uG=function(e){TN(r,e);var t=sG(r);function r(){return Bg(this,r),t.apply(this,arguments)}return qg(r,[{key:"formatProps",value:function(e){var t;return cG(cG({},e),{},{showPayButton:null!==(t=e.showButton)&&void 0!==t?t:e.showPayButton})}},{key:"formatData",value:function(){return{paymentMethod:{type:r.type}}}},{key:"displayName",get:function(){return this.props.name||this.constructor.type}},{key:"render",value:function(){var e=this;return this.props.showPayButton?JN(Uj,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},JN(NM,FN({},this.props,{name:this.displayName,onSubmit:this.submit,payButton:this.payButton,ref:function(t){e.componentRef=t}}))):null}}]),r}(iG);Wg(uG,"type","giropay");var dG={API_VERSION:2,API_VERSION_MINOR:0,GATEWAY:"adyen",URL:"https://pay.google.com/gp/p/js/pay.js"},pG=["amount","countryCode","totalPriceStatus"],fG=["configuration"];function mG(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function hG(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=mG(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=mG(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}function vG(e){var t=e.amount,r=e.countryCode,a=void 0===r?"US":r,n=e.totalPriceStatus,o=void 0===n?"FINAL":n,i=KP(e,pG),l=String(j_(t.value,t.currency));return hG({countryCode:a,currencyCode:t.currency,totalPrice:l,totalPriceStatus:o},i.transactionInfo)}function yG(e){var t=e.configuration,r=KP(e,fG);return{apiVersion:dG.API_VERSION,apiVersionMinor:dG.API_VERSION_MINOR,transactionInfo:vG(r),merchantInfo:hG(hG({merchantId:t.merchantId,merchantName:t.merchantName},t.merchantOrigin?{merchantOrigin:t.merchantOrigin}:{}),t.authJwt?{authJwt:t.authJwt}:{}),allowedPaymentMethods:[{type:"CARD",tokenizationSpecification:{type:"PAYMENT_GATEWAY",parameters:{gateway:dG.GATEWAY,gatewayMerchantId:t.gatewayMerchantId}},parameters:{allowedAuthMethods:r.allowedAuthMethods,allowedCardNetworks:r.allowedCardNetworks,allowPrepaidCards:r.allowPrepaidCards,allowCreditCards:r.allowCreditCards,billingAddressRequired:r.billingAddressRequired,billingAddressParameters:r.billingAddressParameters}}],emailRequired:r.emailRequired,shippingAddressRequired:r.shippingAddressRequired,shippingAddressParameters:r.shippingAddressParameters,shippingOptionRequired:r.shippingOptionRequired,shippingOptionParameters:r.shippingOptionParameters,callbackIntents:r.callbackIntents}}var gG=["en","ar","bg","ca","cs","da","de","el","es","et","fi","fr","hr","id","it","ja","ko","ms","nl","no","pl","pt","ru","sk","sl","sr","sv","th","tr","uk","zh"];var bG=function(){function e(t){Bg(this,e),Wg(this,"paymentsClient",void 0);var r=function(){switch((arguments.length>0&&void 0!==arguments[0]?arguments[0]:"TEST").toLowerCase()){case"production":case"live":case"live-au":case"live-apse":case"live-us":case"live-in":return"PRODUCTION";default:return"TEST"}}(t.environment);this.paymentsClient=this.getGooglePaymentsClient({environment:r,paymentDataCallbacks:t.paymentDataCallbacks})}var t;return qg(e,[{key:"getGooglePaymentsClient",value:(t=$d(Ky.mark((function e(t){var r,a;return Ky.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(null!==(r=window.google)&&void 0!==r&&r.payments){e.next=4;break}return a=new Rz(dG.URL),e.next=4,a.load();case 4:return e.abrupt("return",new google.payments.api.PaymentsClient(t));case 5:case"end":return e.stop()}}),e)}))),function(e){return t.apply(this,arguments)})},{key:"isReadyToPay",value:function(e){return this.paymentsClient?this.paymentsClient.then((function(t){return t.isReadyToPay((a=(r=e).allowedAuthMethods,n=r.allowedCardNetworks,o=r.existingPaymentMethodRequired,i=void 0!==o&&o,{apiVersion:dG.API_VERSION,apiVersionMinor:dG.API_VERSION_MINOR,allowedPaymentMethods:[{type:"CARD",parameters:{allowedAuthMethods:a,allowedCardNetworks:n},tokenizationSpecification:{type:"PAYMENT_GATEWAY",parameters:{}}}],existingPaymentMethodRequired:i}));var r,a,n,o,i})):ok.reject(new Error("Google Pay is not available"))}},{key:"prefetchPaymentData",value:function(e){if(!this.paymentsClient)throw new Error("Google Pay is not available");var t=yG(e);this.paymentsClient.then((function(e){return e.prefetchPaymentData(t)}))}},{key:"initiatePayment",value:function(e){if(!this.paymentsClient)throw new Error("Google Pay is not available");var t=yG(e);return this.paymentsClient.then((function(e){return e.loadPaymentData(t)}))}}]),e}();function kG(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}var CG=function(e){TN(r,e);var t=kG(r);function r(){var e,a;Bg(this,r);for(var n=arguments.length,o=new Array(n),i=0;i<n;i++)o[i]=arguments[i];return Wg(RN(a=t.call.apply(t,Bb(e=[this]).call(e,o))),"paywithgoogleWrapper",void 0),Wg(RN(a),"clicked",!1),Wg(RN(a),"handleClick",(function(e){e.preventDefault(),e.stopPropagation(),a.clicked||(a.props.onClick(e),a.clicked=!0,hw((function(){a.clicked=!1}),300))})),a}return qg(r,[{key:"componentDidMount",value:function(){var e=this,t=this.props,r=t.buttonColor,a=t.buttonType,n=t.buttonLocale,o=t.buttonSizeMode,i=t.buttonRootNode;t.paymentsClient.then((function(t){return t.createButton({onClick:e.handleClick,buttonType:a,buttonColor:r,buttonLocale:n,buttonSizeMode:o,buttonRootNode:i})})).then((function(t){e.paywithgoogleWrapper.appendChild(t)}))}},{key:"render",value:function(){var e=this;return JN("span",{className:"adyen-checkout__paywithgoogle",ref:function(t){e.paywithgoogleWrapper=t}})}}]),r}($N);Wg(CG,"defaultProps",{buttonColor:"default",buttonType:"long",buttonSizeMode:"static"});var _G={environment:"TEST",existingPaymentMethodRequired:!1,buttonColor:"default",buttonType:"long",buttonSizeMode:void 0,showPayButton:!0,configuration:{gatewayMerchantId:"",merchantId:"",merchantName:""},amount:{value:0,currency:"USD"},countryCode:"US",totalPriceStatus:"FINAL",onAuthorized:function(e){return e},onClick:function(e){return e()},allowedAuthMethods:["PAN_ONLY","CRYPTOGRAM_3DS"],allowedCardNetworks:["AMEX","DISCOVER","JCB","MASTERCARD","VISA"],allowCreditCards:!0,allowPrepaidCards:!0,billingAddressRequired:!1,billingAddressParameters:void 0,emailRequired:!1,shippingAddressRequired:!1,shippingAddressParameters:void 0,shippingOptionRequired:!1,shippingOptionParameters:void 0,paymentMethods:[]};function NG(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function PG(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=NG(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=NG(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}function wG(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}var SG=function(e){TN(r,e);var t=wG(r);function r(){var e,a,n;Bg(this,r);for(var o=arguments.length,i=new Array(o),l=0;l<o;l++)i[l]=arguments[l];return Wg(RN(n=t.call.apply(t,Bb(e=[this]).call(e,i))),"googlePay",new bG(n.props)),Wg(RN(n),"submit",(function(){var e=n.props.onAuthorized,t=void 0===e?function(){}:e;return new ok((function(e,t){return n.props.onClick(e,t)})).then((function(){return n.googlePay.initiatePayment(n.props)})).then((function(e){return n.setState({googlePayToken:e.paymentMethodData.tokenizationData.token,googlePayCardNetwork:e.paymentMethodData.info.cardNetwork}),oD((a=RN(n),jN(r.prototype)),"submit",a).call(a),t(e)})).catch((function(e){"CANCELED"===e.statusCode?n.handleError(new iA("CANCEL",e.toString(),{cause:e})):n.handleError(new iA("ERROR",e.toString(),{cause:e}))}))})),Wg(RN(n),"isAvailable",(function(){return n.isReadyToPay().then((function(e){if(!e.result)throw new Error("Google Pay is not available");if(!1===e.paymentMethodPresent)throw new Error("Google Pay - No paymentMethodPresent");return!0})).catch((function(){return!1}))})),Wg(RN(n),"isReadyToPay",(function(){return n.googlePay.isReadyToPay(n.props)})),Wg(RN(n),"prefetch",(function(){return n.googlePay.prefetchPaymentData(n.props)})),n}return qg(r,[{key:"formatProps",value:function(e){var t,r,a,n,o,i,l=null!==(t=e.brands)&&void 0!==t&&t.length?(o=e.brands,i={mc:"MASTERCARD",amex:"AMEX",visa:"VISA",interac:"INTERAC",discover:"DISCOVER"},DC(o).call(o,(function(e,t){return i[t]&&!Eb(e).call(e,i[t])&&e.push(i[t]),e}),[])):e.allowedCardNetworks,c=null!==(r=e.buttonSizeMode)&&void 0!==r?r:e.isDropin?"fill":"static",s=function(){var e=(arguments.length>0&&void 0!==arguments[0]?arguments[0]:"").toLowerCase().substring(0,2);return Eb(gG).call(gG,e)?e:null}(null!==(a=e.buttonLocale)&&void 0!==a?a:null===(n=e.i18n)||void 0===n?void 0:n.locale);return PG(PG({},e),{},{showButton:!0===e.showPayButton,configuration:e.configuration,allowedCardNetworks:l,buttonSizeMode:c,buttonLocale:s})}},{key:"formatData",value:function(){var e;return{paymentMethod:PG({type:null!==(e=this.props.type)&&void 0!==e?e:r.type},this.state),browserInfo:this.browserInfo}}},{key:"isValid",get:function(){return!!this.state.googlePayToken}},{key:"browserInfo",get:function(){return lz()}},{key:"icon",get:function(){var e;return null!==(e=this.props.icon)&&void 0!==e?e:GP({loadingContext:this.props.loadingContext})("googlepay")}},{key:"render",value:function(){return this.props.showPayButton?JN(CG,{buttonColor:this.props.buttonColor,buttonType:this.props.buttonType,buttonSizeMode:this.props.buttonSizeMode,buttonLocale:this.props.buttonLocale,buttonRootNode:this.props.buttonRootNode,paymentsClient:this.googlePay.paymentsClient,onClick:this.submit}):null}}]),r}(dA);function xG(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}Wg(SG,"type","paywithgoogle"),Wg(SG,"defaultProps",_G);var EG=function(e){TN(r,e);var t=xG(r);function r(){return Bg(this,r),t.apply(this,arguments)}return qg(r)}(xM);Wg(EG,"type","entercash");var AG={telephoneNumber:[{validate:function(e){return!!e&&e.length<=11},errorMessage:"voucher.econtext.telephoneNumber.invalid",modes:["input","blur"]},{validate:function(e){return!!e&&eR.test(e)&&(10===e.length||11===e.length)},errorMessage:"voucher.econtext.telephoneNumber.invalid",modes:["blur"]}]},DG=["personalDetailsRequired","data","onChange","showPayButton","payButton"];function IG(e){var t,r=e.personalDetailsRequired,a=void 0===r||r,n=e.data,o=e.onChange,i=e.showPayButton,l=e.payButton,c=KP(e,DG),s=Lw(null),u=$w().i18n,d=tC(Bw("ready"),2),p=d[0],f=d[1],m=Lw({});Jy(m.current).length||(null===(t=c.setComponentRef)||void 0===t||t.call(c,m.current));return m.current.showValidation=function(){var e;null===(e=s.current)||void 0===e||e.showValidation()},m.current.setStatus=f,JN("div",{className:"adyen-checkout__econtext-input__field"},!!a&&JN(uR,{data:n,requiredFields:["firstName","lastName","telephoneNumber","shopperEmail"],onChange:o,namePrefix:"econtext",setComponentRef:function(e){s.current=e},validationRules:AG}),i&&l({status:p,label:u.get("confirmPurchase")}))}function FG(e){var t,r,a=(t=e,(r=document.createElement("textArea")).readOnly=!0,r.value=t,document.body.appendChild(r),r);if(window.navigator.userAgent.match(/ipad|iphone/i)){var n=document.createRange();n.selectNodeContents(a);var o=window.getSelection();o.removeAllRanges(),o.addRange(n),a.setSelectionRange(0,999999)}else a.select();document.execCommand("copy"),document.body.removeChild(a)}var RG=["voucherDetails","className"];function OG(e){var t,r=e.voucherDetails,a=void 0===r?[]:r,n=e.className,o=void 0===n?"":n,i=KP(e,RG),l=$w(),c=l.i18n,s=l.loadingContext;return JN("div",{className:ww("adyen-checkout__voucher-result","adyen-checkout__voucher-result--".concat(i.paymentMethodType),o)},JN("div",{className:"adyen-checkout__voucher-result__top"},JN("div",{className:"adyen-checkout__voucher-result__image"},!!i.imageUrl&&JN("span",{className:"adyen-checkout__voucher-result__image__wrapper"},JN("img",{alt:i.paymentMethodType,className:"adyen-checkout__voucher-result__image__brand",src:i.imageUrl})),!!i.issuerImageUrl&&JN("span",{className:"adyen-checkout__voucher-result__image__wrapper"},JN("img",{alt:i.paymentMethodType,className:"adyen-checkout__voucher-result__image__issuer",src:i.issuerImageUrl}))),JN("div",{className:"adyen-checkout__voucher-result__introduction"},i.introduction," ",i.instructionsUrl&&JN("a",{className:"adyen-checkout__link adyen-checkout__link--voucher-result-instructions",href:i.instructionsUrl,target:"_blank",rel:"noopener noreferrer"},c.get("voucher.readInstructions")," \u203a")),i.amount&&JN("div",{className:"adyen-checkout__voucher-result__amount"},i.amount,i.surcharge&&JN("span",{className:"adyen-checkout__voucher-result__surcharge"},"(",c.get("voucher.surcharge").replace("%@",i.surcharge),")"))),i.reference&&JN("div",{className:"adyen-checkout__voucher-result__separator"},JN("div",{className:"adyen-checkout__voucher-result__separator__inner"}),JN("div",{className:"adyen-checkout__voucher-result__code__label"},JN("span",{className:"adyen-checkout__voucher-result__code__label__text"},c.get("voucher.paymentReferenceLabel")))),JN("div",{className:"adyen-checkout__voucher-result__bottom"},i.reference&&JN("div",{className:"adyen-checkout__voucher-result__code"},i.barcode&&JN("img",{alt:c.get("voucher.paymentReferenceLabel"),className:"adyen-checkout__voucher-result__code__barcode",src:i.barcode}),JN("span",null,i.reference)),(!!i.downloadUrl||!!i.copyBtn)&&JN("ul",{className:"adyen-checkout__voucher-result__actions"},!!i.copyBtn&&JN("li",{className:"adyen-checkout__voucher-result__actions__item"},JN(eS,{inline:!0,variant:"action",onClick:function(e,t){var r=t.complete;FG(i.reference),r()},icon:GP({loadingContext:s,imageFolder:"components/"})("copy"),label:c.get("button.copy")})),!!i.downloadUrl&&JN("li",{className:"adyen-checkout__voucher-result__actions__item"},JN(eS,{inline:!0,variant:"action",href:i.downloadUrl,icon:GP({loadingContext:s,imageFolder:"components/"})("download"),label:i.downloadButtonText||c.get("button.download"),target:"_blank",rel:"noopener noreferrer"}))),JN("ul",{className:"adyen-checkout__voucher-result__details"},QC(t=nb(a).call(a,(function(e){var t=e.label,r=e.value;return!!t&&!!r}))).call(t,(function(e,t){var r=e.label,a=e.value;return JN("li",{key:t,className:"adyen-checkout__voucher-result__details__item"},JN("span",{className:"adyen-checkout__voucher-result__details__label"},r),JN("span",{className:"adyen-checkout__voucher-result__details__value"},a))})))))}var TG=function(e){var t=e.reference,r=e.totalAmount,a=e.expiresAt,n=e.paymentMethodType,o=e.maskedTelephoneNumber,i=e.instructionsUrl,l=e.collectionInstitutionNumber,c=$w(),s=c.loadingContext,u=c.i18n;return JN(OG,{paymentMethodType:n,reference:t,introduction:u.get("voucher.introduction.econtext"),imageUrl:GP({loadingContext:s})(n),instructionsUrl:i,amount:r&&u.amount(r.value,r.currency),voucherDetails:[{label:u.get("voucher.collectionInstitutionNumber"),value:l},{label:u.get("voucher.expirationDate"),value:u.date(a)},{label:u.get("voucher.telephoneNumber"),value:o}],copyBtn:!0})};function BG(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function jG(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=BG(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=BG(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}function zG(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}var MG=function(e){TN(r,e);var t=zG(r);function r(){return Bg(this,r),t.apply(this,arguments)}return qg(r,[{key:"isValid",get:function(){return!this.props.personalDetailsRequired||!!this.state.isValid}},{key:"formatData",value:function(){return jG(jG({},this.state.data),{},{paymentMethod:{type:this.props.type||r.type}})}},{key:"icon",get:function(){return GP({loadingContext:this.props.loadingContext})(this.props.type)}},{key:"render",value:function(){var e=this;return JN(Uj,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},this.props.reference?JN(TG,FN({ref:function(t){e.componentRef=t}},this.props)):JN(IG,FN({setComponentRef:this.setComponentRef},this.props,{onChange:this.setState,onSubmit:this.submit,payButton:this.payButton})))}}]),r}(dA);Wg(MG,"type","econtext"),Wg(MG,"defaultProps",{personalDetailsRequired:!0});var LG=["ES","FR"];function VG(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function UG(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=VG(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=VG(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}function KG(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}var HG=function(e){TN(r,e);var t=KG(r);function r(){return Bg(this,r),t.apply(this,arguments)}return qg(r,[{key:"formatProps",value:function(e){return UG(UG({},oD(jN(r.prototype),"formatProps",this).call(this,e)),{},{allowedCountries:e.countryCode?[e.countryCode]:LG})}}]),r}(Wj);function qG(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function WG(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=qG(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=qG(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}function YG(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}Wg(HG,"type","facilypay_3x");var GG=function(e){TN(r,e);var t=YG(r);function r(){return Bg(this,r),t.apply(this,arguments)}return qg(r,[{key:"formatProps",value:function(e){return WG(WG({},oD(jN(r.prototype),"formatProps",this).call(this,e)),{},{allowedCountries:e.countryCode?[e.countryCode]:LG})}}]),r}(Wj);function JG(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function QG(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=JG(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=JG(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}function ZG(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}Wg(GG,"type","facilypay_4x");var $G=function(e){TN(r,e);var t=ZG(r);function r(){return Bg(this,r),t.apply(this,arguments)}return qg(r,[{key:"formatProps",value:function(e){return QG(QG({},oD(jN(r.prototype),"formatProps",this).call(this,e)),{},{allowedCountries:e.countryCode?[e.countryCode]:LG})}}]),r}(Wj);function XG(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function eJ(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=XG(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=XG(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}function tJ(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}Wg($G,"type","facilypay_6x");var rJ=function(e){TN(r,e);var t=tJ(r);function r(){return Bg(this,r),t.apply(this,arguments)}return qg(r,[{key:"formatProps",value:function(e){return eJ(eJ({},oD(jN(r.prototype),"formatProps",this).call(this,e)),{},{allowedCountries:e.countryCode?[e.countryCode]:LG})}}]),r}(Wj);function aJ(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function nJ(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=aJ(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=aJ(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}function oJ(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}Wg(rJ,"type","facilypay_10x");var iJ=function(e){TN(r,e);var t=oJ(r);function r(){return Bg(this,r),t.apply(this,arguments)}return qg(r,[{key:"formatProps",value:function(e){return nJ(nJ({},oD(jN(r.prototype),"formatProps",this).call(this,e)),{},{allowedCountries:e.countryCode?[e.countryCode]:LG})}}]),r}(Wj);function lJ(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}Wg(iJ,"type","facilypay_12x");var cJ=function(e){TN(r,e);var t=lJ(r);function r(){return Bg(this,r),t.apply(this,arguments)}return qg(r)}(xM);Wg(cJ,"type","ideal");var sJ=["black","white"],uJ=["en_US","en_AU","en_GB","fr_CA","es_ES","it_IT","fr_FR","de_DE","pt_BR","zh_CN","da_DK","zh_HK","id_ID","he_IL","ja_JP","ko_KR","nl_NL","no_NO","pl_PL","pt_PT","ru_RU","sv_SE","th_TH","zh_TW"];function dJ(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function pJ(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=dJ(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=dJ(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}var fJ=function(e){var t,r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};return"paypal"===e?pJ({},r):DC(t=Jy(r)).call(t,(function(e,t){var a=r[t];return("color"!==t||Eb(sJ).call(sJ,a))&&(e[t]=a),e}),{})},mJ=function(e){var t=e.amount,r=e.countryCode,a=e.debug,n=e.environment,o=void 0===n?"":n,i=e.locale,l=e.configuration,c=e.commit,s=e.vault,u=function(e){var t=e?e.replace("-","_"):null;return Eb(uJ).call(uJ,t)?t:null}(i),d=t?t.currency:null,p="test"===o.toLowerCase(),f=p?"AXy9hIzWB6h_LjZUHjHmsbsiicSIbL4GKOrcgomEedVjduUinIU4C2llxkW5p0OG0zTNgviYFceaXEnj":"AU0Z-TP9t5_9196agaBN6ZD3UAwypdP1IX8ZYH3PcNNAQMXUTDQlChruXqQEhyI6-NKBKowN6ydkj477",m=l.merchantId,h=l.intent;return pJ(pJ(pJ(pJ(pJ(pJ(pJ({},m&&{"merchant-id":m}),u&&{locale:u}),r&&p&&{"buyer-country":r}),a&&p&&{debug:a}),d&&{currency:d}),h&&{intent:h}),{},{commit:c,vault:s,"client-id":f,"integration-date":"2020-02-01","enable-funding":"paylater",components:"buttons,funding-eligibility"})},hJ=function(e){var t,r,a=mJ(e),n=decodeURIComponent(QC(t=Jy(a)).call(t,(function(e){var t;return Bb(t="".concat(e,"=")).call(t,a[e])})).join("&"));return Bb(r="".concat("https://www.paypal.com/sdk/js","?")).call(r,n)},vJ=["onInit","onApprove","onClick","onCancel","onError","onShippingChange","onSubmit","isProcessingPayment","paypalRef","style"];function yJ(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function gJ(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=yJ(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=yJ(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}function bJ(e){var t,r=e.onInit,a=e.onApprove,n=e.onClick,o=e.onCancel,i=e.onError,l=e.onShippingChange,c=e.onSubmit,s=e.isProcessingPayment,u=e.paypalRef,d=e.style,p=KP(e,vJ),f=$w().i18n,m="tokenize"===(null===(t=p.configuration)||void 0===t?void 0:t.intent),h=Lw(null),v=Lw(null),y=Lw(null),g=function(e,t){var s=u.Buttons(gJ(gJ(gJ({},m&&{createBillingAgreement:c}),!m&&{createOrder:c,onShippingChange:l}),{},{fundingSource:e,style:fJ(e,d),onInit:r,onClick:n,onCancel:o,onError:i,onApprove:a}));s.isEligible()&&s.render(t.current)};return zw((function(){var e=u.FUNDING,t=e.PAYPAL,r=e.CREDIT,a=e.PAYLATER;g(t,h),p.blockPayPalCreditButton||g(r,v),p.blockPayPalPayLaterButton||g(a,y)}),[]),JN("div",{className:ww("adyen-checkout__paypal__buttons",{"adyen-checkout__paypal-processing":s})},JN("div",{className:"adyen-checkout__paypal__button adyen-checkout__paypal__button--paypal",ref:h}),JN("div",{className:"adyen-checkout__paypal__button adyen-checkout__paypal__button--credit",ref:v}),JN("div",{className:"adyen-checkout__paypal__button adyen-checkout__paypal__button--pay-later",ref:y}),s&&JN("div",{className:"adyen-checkout__paypal"},JN("div",{className:"adyen-checkout__paypal__status adyen-checkout__paypal__status--processing"},JN(Sw,{size:"medium",inline:!0})," ",f.get("paypal.processingPayment"))))}var kJ=["onApprove","onCancel","onChange","onError","onSubmit"];function CJ(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function _J(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=CJ(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=CJ(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}function NJ(e){var t=e.onApprove,r=e.onCancel,a=e.onChange,n=e.onError,o=e.onSubmit,i=KP(e,kJ),l=tC(Bw("pending"),2),c=l[0],s=l[1];this.setStatus=s;var u=Uw((function(e,r){s("processing"),t(e,r)}),[t]),d=function(){s("ready")};return zw((function(){var e=hJ(i),t=_J({},i.cspNonce&&{nonce:i.cspNonce}),r=_J({},i.cspNonce&&{cspNonce:i.cspNonce}),a=new Rz(e,"body",t,r);return a.load().then(d),function(){a.remove()}}),[]),JN("div",{className:"adyen-checkout__paypal"},"pending"===c?JN("div",{className:"adyen-checkout__paypal__status adyen-checkout__paypal__status--pending"},JN(Sw,null)):JN(bJ,FN({},i,{onCancel:r,onChange:a,onError:n,onSubmit:o,onApprove:u,isProcessingPayment:"processing"===c,paypalRef:window.paypal})))}var PJ="No token was provided",wJ="Calling submit() is not supported for this payment method",SJ="The instance of the PayPal component being used is not the same which started the payment";function xJ(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function EJ(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=xJ(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=xJ(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}var AJ=function(e){var t=e.paypalAddressObject;if(!t)return null;var r=function(){var e,t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null,r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:null;return t&&r?Bb(e="".concat(t,", ")).call(e,r):t||(r||null)}(t.address_line_1,t.address_line_2),a=EJ(EJ(EJ(EJ(EJ({},r&&{street:r}),t.admin_area_1&&{stateOrProvince:t.admin_area_1}),t.admin_area_2&&{city:t.admin_area_2}),t.postal_code&&{postalCode:t.postal_code}),t.country_code&&{country:t.country_code});return Jy(a).length>0?a:null};function DJ(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function IJ(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=DJ(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=DJ(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}function FJ(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}var RJ=function(e){TN(r,e);var t=FJ(r);function r(e){var a,n;return Bg(this,r),Wg(RN(n=t.call(this,e)),"paymentData",null),Wg(RN(n),"resolve",null),Wg(RN(n),"reject",null),Wg(RN(n),"submit",(function(){n.handleError(new iA("IMPLEMENTATION_ERROR",wJ))})),Wg(RN(n),"handleAction",(function(e){return n.updateWithAction(e)})),Wg(RN(n),"updateWithAction",(function(e){if(e.paymentMethodType!==n.type)throw new Error("Invalid Action");return e.paymentData&&(n.paymentData=e.paymentData),e.sdkData&&e.sdkData.token?n.handleResolve(e.sdkData.token):n.handleReject(PJ),null})),Wg(RN(n),"handleCancel",(function(){n.handleError(new iA("CANCEL"))})),Wg(RN(n),"handleOnApprove",(function(e,t){var r=n.props.onShopperDetails,a={data:{details:e,paymentData:n.paymentData}};if(r)return t.order.get().then((function(e){var t=function(e){var t,r,a,n,o,i,l,c,s,u,d,p,f,m;if(!e)return null;var h={firstName:null==e||null===(t=e.payer)||void 0===t||null===(r=t.name)||void 0===r?void 0:r.given_name,lastName:null==e||null===(a=e.payer)||void 0===a||null===(n=a.name)||void 0===n?void 0:n.surname},v=null==e||null===(o=e.payer)||void 0===o?void 0:o.email_address,y=null==e||null===(i=e.payer)||void 0===i||null===(l=i.address)||void 0===l?void 0:l.country_code,g=null==e||null===(c=e.payer)||void 0===c||null===(s=c.phone)||void 0===s||null===(u=s.phone_number)||void 0===u?void 0:u.national_number,b=null==e||null===(d=e.payer)||void 0===d?void 0:d.birth_date,k=AJ({paypalAddressObject:null==e||null===(p=e.payer)||void 0===p?void 0:p.address}),C=AJ({paypalAddressObject:null==e||null===(f=e.purchase_units)||void 0===f||null===(m=f[0].shipping)||void 0===m?void 0:m.address}),_=EJ(EJ(EJ(EJ(EJ(EJ(EJ({},h.firstName&&{shopperName:h}),v&&{shopperEmail:v}),b&&{dateOfBirth:b}),g&&{telephoneNumber:g}),y&&{countryCode:y}),k&&{billingAddress:k}),C&&{shippingAddress:C});return Jy(_).length>0?_:null}(e);return new ok((function(a,n){return r(t,e,{resolve:a,reject:n})}))})).then((function(){return n.handleAdditionalDetails(a)})).catch((function(e){return n.handleError(new iA("ERROR","Something went wrong while parsing PayPal Order",{cause:e}))}));n.handleAdditionalDetails(a)})),n.handleSubmit=rk(a=n.handleSubmit).call(a,RN(n)),n}return qg(r,[{key:"formatProps",value:function(e){var t,r=e.configuration,a=r.merchantId,n=r.intent,o=0===(null===(t=e.amount)||void 0===t?void 0:t.value)?"tokenize":e.intent||n,i="tokenize"===o||e.vault;return IJ(IJ({},e),{},{vault:i,configuration:{intent:o,merchantId:a}})}},{key:"formatData",value:function(){return{paymentMethod:{type:r.type,subtype:r.subtype}}}},{key:"isValid",get:function(){return!0}},{key:"handleResolve",value:function(e){if(!this.resolve)return this.handleError(new iA("ERROR",SJ));this.resolve(e)}},{key:"handleReject",value:function(e){if(!this.reject)return this.handleError(new iA("ERROR",SJ));this.reject(new Error(e))}},{key:"handleSubmit",value:function(){var e=this;return oD(jN(r.prototype),"submit",this).call(this),new ok((function(t,r){e.resolve=t,e.reject=r}))}},{key:"render",value:function(){var e=this;return this.props.showPayButton?JN(Uj,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},JN(NJ,FN({ref:function(t){e.componentRef=t}},this.props,{onCancel:this.handleCancel,onChange:this.setState,onApprove:this.handleOnApprove,onError:function(t){e.handleError(new iA("ERROR",t.toString(),{cause:t}))},onSubmit:this.handleSubmit}))):null}}]),r}(dA);function OJ(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function TJ(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=OJ(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=OJ(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}function BJ(e){var t,r,a=$w().i18n,n=tC(Bw("ready"),2),o=n[0],i=n[1],l=!(null==e||null===(t=e.items)||void 0===t||!t.length),c=QF({schema:Bb(r=[]).call(r,rC(l?["phonePrefix"]:[]),["phoneNumber"]),defaultData:TJ({},l?{phonePrefix:e.selected}:{}),rules:{phoneNumber:{modes:["blur"],errorMessage:"error.va.gen.01",validate:function(e){return(null==e?void 0:e.length)>6}}}}),s=c.handleChangeFor,u=c.triggerValidation,d=c.data,p=c.valid,f=c.errors,m=c.isValid;return zw((function(){e.onChange({data:d,valid:p,errors:f,isValid:m})}),[d,p,f,m]),this.showValidation=u,this.setStatus=i,JN("div",{className:"adyen-checkout__phone-input"},JN(kI,{errorMessage:!!f.phoneNumber,label:a.get(e.phoneLabel),className:ww({"adyen-checkout__input--phone-number":!0}),inputWrapperModifiers:["phoneInput"]},JN("div",{className:"adyen-checkout__input-wrapper"},JN("div",{className:ww({"adyen-checkout__input":!0,"adyen-checkout__input--invalid":!!f.phoneNumber})},!!l&&JN(kI,{inputWrapperModifiers:["phoneInput"]},NF("select",{className:"adyen-checkout__dropdown--small adyen-checkout__countryFlag",filterable:!1,items:e.items,name:e.prefixName,onChange:s("phonePrefix"),placeholder:a.get("infix"),selected:d.phonePrefix}),JN("div",{className:"adyen-checkout__phoneNumber"},JN("div",null,d.phonePrefix),JN("input",{type:"tel",name:e.phoneName,value:d.phoneNumber,onInput:s("phoneNumber","input"),onBlur:s("phoneNumber","blur"),placeholder:"123 456 789",className:"adyen-checkout__input adyen-checkout__input--phoneNumber",autoCorrect:"off"})))))),this.props.showPayButton&&this.props.payButton({status:o}))}Wg(RJ,"type","paypal"),Wg(RJ,"subtype","sdk"),Wg(RJ,"defaultProps",{environment:"TEST",status:"loading",showPayButton:!0,merchantId:"",cspNonce:null,intent:null,commit:!0,vault:!1,style:{height:48},blockPayPalCreditButton:!1,blockPayPalPayLaterButton:!1,configuration:{merchantId:"",intent:null},onInit:function(){},onClick:function(){},onCancel:function(){},onError:function(){},onShippingChange:function(){}}),BJ.defaultProps={phoneLabel:"telephoneNumber"};var jJ={},zJ={get exports(){return jJ},set exports(e){jJ=e}},MJ=Dr,LJ=b,VJ=la,UJ=RangeError,KJ=String.fromCharCode,HJ=String.fromCodePoint,qJ=LJ([].join);MJ({target:"String",stat:!0,arity:1,forced:!!HJ&&1!=HJ.length},{fromCodePoint:function(e){for(var t,r=[],a=arguments.length,n=0;a>n;){if(t=+arguments[n++],VJ(t,1114111)!==t)throw UJ(t+" is not a valid code point");r[n]=t<65536?KJ(t):KJ(55296+((t-=65536)>>10),t%1024+56320)}return qJ(r,"")}});var WJ=ne.String.fromCodePoint;!function(e){e.exports=WJ}(zJ);var YJ=t(jJ);function GJ(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function JJ(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=GJ(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=GJ(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}var QJ,ZJ=function(e,t){if(e&&t){var r=yk(e).call(e,(function(e){return e.code===t}));return!!r&&r.id}return!1},$J=[{id:"+7",name:"Russian Federation",code:"RU"},{id:"+9955",name:"Georgia",code:"GE"},{id:"+507",name:"Panama",code:"PA"},{id:"+44",name:"United Kingdom",code:"GB"},{id:"+992",name:"Tajikistan",code:"TJ"},{id:"+370",name:"Lithuania",code:"LT"},{id:"+972",name:"Israel",code:"IL"},{id:"+996",name:"Kyrgyzstan",code:"KG"},{id:"+380",name:"Ukraine",code:"UA"},{id:"+84",name:"Viet Nam",code:"VN"},{id:"+90",name:"Turkey",code:"TR"},{id:"+994",name:"Azerbaijan",code:"AZ"},{id:"+374",name:"Armenia",code:"AM"},{id:"+371",name:"Latvia",code:"LV"},{id:"+91",name:"India",code:"IN"},{id:"+66",name:"Thailand",code:"TH"},{id:"+373",name:"Moldova",code:"MD"},{id:"+1",name:"United States",code:"US"},{id:"+81",name:"Japan",code:"JP"},{id:"+998",name:"Uzbekistan",code:"UZ"},{id:"+77",name:"Kazakhstan",code:"KZ"},{id:"+375",name:"Belarus",code:"BY"},{id:"+372",name:"Estonia",code:"EE"},{id:"+40",name:"Romania",code:"RO"},{id:"+82",name:"Korea",code:"KR"}];function XJ(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function eQ(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=XJ(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=XJ(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}function tQ(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}var rQ=function(e){TN(r,e);var t=tQ(r);function r(){return Bg(this,r),t.apply(this,arguments)}return qg(r,[{key:"isValid",get:function(){return!!this.state.isValid}},{key:"formatProps",value:function(e){return eQ(eQ({onValid:function(){}},e),{},{selected:ZJ(e.items,e.countryCode)})}},{key:"formatData",value:function(){return{paymentMethod:{type:r.type,"qiwiwallet.telephoneNumberPrefix":this.state.data?this.state.data.phonePrefix:"","qiwiwallet.telephoneNumber":this.state.data?this.state.data.phoneNumber:""}}}},{key:"render",value:function(){var e=this;return JN(Uj,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},JN(BJ,FN({ref:function(t){e.componentRef=t}},this.props,this.state,{phoneLabel:"mobileNumber",onChange:this.setState,onSubmit:this.submit,payButton:this.payButton})))}}]),r}(dA);function aQ(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function nQ(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=aQ(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=aQ(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}Wg(rQ,"type","qiwiwallet"),Wg(rQ,"defaultProps",{items:nb(QJ=QC($J).call($J,(function(e){var t,r;if(!e)throw new Error("No item passed");if(!e.code||!e.id)return!1;var a=e.code.toUpperCase().replace(/./g,(function(e){return YJ?YJ(e.charCodeAt(0)+127397):""}));return JJ(JJ({},e),{},{name:Bb(t=Bb(r="".concat(a," ")).call(r,e.name," (")).call(t,e.id,")"),selectedOptionName:a})}))).call(QJ,(function(e){return!1!==e})),countryCode:$J[0].code,prefixName:"qiwiwallet.telephoneNumberPrefix",phoneName:"qiwiwallet.telephoneNumber"});function oQ(e){var t=this,r=Lw(null),a=tC(Bw({}),2),n=a[0],o=a[1],i=tC(Bw({}),2),l=i[0],c=i[1],s=tC(Bw({}),2),u=s[0],d=s[1],p=tC(Bw(!1),2),f=p[0],m=p[1],h=tC(Bw(null),2),v=h[0],y=h[1],g=tC(Bw([]),2),b=g[0],k=g[1],C=tC(Bw(""),2),_=C[0],N=C[1],P=Vw((function(){return CU(e,{sfp:r},{dualBrandSelectElements:b,setDualBrandSelectElements:k,setSelectedBrandValue:N,issuingCountryCode:v,setIssuingCountryCode:y})}),[b,v]);return this.processBinLookupResponse=function(e,t){P.processBinLookup(e,t)},this.dualBrandingChangeHandler=P.handleDualBrandSelection,zw((function(){return t.setFocusOn=r.current.setFocusOn,t.updateStyles=r.current.updateStyles,t.showValidation=r.current.showValidation,t.handleUnsupportedCard=r.current.handleUnsupportedCard,function(){r.current.destroy()}}),[]),zw((function(){var t=r.current.mapErrorsToValidationRuleResult();e.onChange({data:u,valid:l,errors:nQ(nQ({},n),t),isValid:f,selectedBrandValue:_})}),[u,l,n,_]),JN(oU,FN({ref:r},iQ(e),{onChange:function(e){d(nQ(nQ({},u),e.data)),o(nQ(nQ({},n),e.errors)),c(nQ(nQ({},l),e.valid)),m(e.isSfpValid)},render:function(){return null}}))}oQ.defaultProps={onChange:function(){},onError:function(){}};var iQ=function(e){return{allowedDOMAccess:e.allowedDOMAccess,autoFocus:e.autoFocus,brands:e.brands,brandsConfiguration:e.brandsConfiguration,clientKey:e.clientKey,i18n:e.i18n,implementationType:e.implementationType,keypadFix:e.keypadFix,legacyInputMode:e.legacyInputMode,loadingContext:e.loadingContext,minimumExpiryDate:e.minimumExpiryDate,onAdditionalSFConfig:e.onAdditionalSFConfig,onAdditionalSFRemoved:e.onAdditionalSFRemoved,onAllValid:e.onAllValid,onAutoComplete:e.onAutoComplete,onBinValue:e.onBinValue,onBrand:e.onBrand,onConfigSuccess:e.onConfigSuccess,onError:e.onError,onFieldValid:e.onFieldValid,onFocus:e.onFocus,onLoad:e.onLoad,rootNode:e.rootNode,showWarnings:e.showWarnings,styles:e.styles,trimTrailingSeparator:e.trimTrailingSeparator,type:e.type}};function lQ(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function cQ(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=lQ(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=lQ(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}function sQ(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}var uQ=function(e){TN(r,e);var t=sQ(r);function r(){var e,a;Bg(this,r);for(var n=arguments.length,o=new Array(n),i=0;i<n;i++)o[i]=arguments[i];return Wg(RN(a=t.call.apply(t,Bb(e=[this]).call(e,o))),"onBinValue",PW(RN(a))),a}return qg(r,[{key:"formatProps",value:function(e){return cQ(cQ({},e),{},{type:"scheme"===e.type||"securedfields"===e.type?"card":e.type})}},{key:"formatData",value:function(){var e=this.state.selectedBrandValue||this.props.brand;return{paymentMethod:cQ(cQ({type:r.type},this.state.data),e&&{brand:e}),browserInfo:this.browserInfo}}},{key:"updateStyles",value:function(e){var t;return null!==(t=this.componentRef)&&void 0!==t&&t.updateStyles&&this.componentRef.updateStyles(e),this}},{key:"setFocusOn",value:function(e){var t;return null!==(t=this.componentRef)&&void 0!==t&&t.setFocusOn&&this.componentRef.setFocusOn(e),this}},{key:"processBinLookupResponse",value:function(e){var t;return null!==(t=this.componentRef)&&void 0!==t&&t.processBinLookupResponse&&this.componentRef.processBinLookupResponse(e),this}},{key:"dualBrandingChangeHandler",value:function(e){var t;return null!==(t=this.componentRef)&&void 0!==t&&t.dualBrandingChangeHandler&&this.componentRef.dualBrandingChangeHandler(e),this}},{key:"handleUnsupportedCard",value:function(e){var t;return null!==(t=this.componentRef)&&void 0!==t&&t.handleUnsupportedCard&&this.componentRef.handleUnsupportedCard(e),this}},{key:"onBinLookup",value:function(e){var t,r=this,a=cQ({},e);(a.rootNode=this._node,a.isReset)||(a.supportedBrandsRaw=null===(t=e.supportedBrandsRaw)||void 0===t?void 0:QC(t).call(t,(function(e){var t,a;return e.brandImageUrl=null!==(t=null===(a=r.props.brandsConfiguration[e.brand])||void 0===a?void 0:a.icon)&&void 0!==t?t:OL(e.brand,r.props.loadingContext),e})));this.props.onBinLookup(a)}},{key:"isValid",get:function(){return!!this.state.isValid}},{key:"icon",get:function(){return GP({loadingContext:this.props.loadingContext})(this.props.type)}},{key:"browserInfo",get:function(){return lz()}},{key:"render",value:function(){var e=this;return JN(Uj,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},JN(oQ,FN({ref:function(t){e.componentRef=t}},this.props,this.state,{rootNode:this._node,onChange:this.setState,onBinValue:this.onBinValue,implementationType:"custom"})))}}]),r}(dA);function dQ(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function pQ(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}Wg(uQ,"type","scheme"),Wg(uQ,"analyticsType","custom-scheme"),Wg(uQ,"defaultProps",{onBinLookup:function(){},brandsConfiguration:{}});var fQ=function(e){TN(r,e);var t=pQ(r);function r(){return Bg(this,r),t.apply(this,arguments)}return qg(r,[{key:"formatProps",value:function(e){return function(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=dQ(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=dQ(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}({holderName:!0},e)}},{key:"formatData",value:function(){return{paymentMethod:{type:r.type,iban:this.state.data.ibanNumber,ownerName:this.state.data.ownerName}}}},{key:"isValid",get:function(){return!!this.state.isValid}},{key:"render",value:function(){var e=this;return JN(Uj,FN({},this.props,{loadingContext:this.props.loadingContext}),JN(jj,FN({ref:function(t){e.componentRef=t}},this.props,{onChange:this.setState,onSubmit:this.submit,payButton:this.payButton})))}}]),r}(dA);function mQ(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}Wg(fQ,"type","sepadirectdebit");var hQ=function(e){TN(r,e);var t=mQ(r);function r(){var e,a;Bg(this,r);for(var n=arguments.length,o=new Array(n),i=0;i<n;i++)o[i]=arguments[i];return Wg(RN(a=t.call.apply(t,Bb(e=[this]).call(e,o))),"formEl",void 0),a}return qg(r,[{key:"componentDidMount",value:function(){this.formEl.submit()}},{key:"render",value:function(e){var t=this,r=e.name,a=e.action,n=e.target,o=e.inputName,i=e.inputValue;return JN("form",{ref:function(e){t.formEl=e},method:"POST",className:ww(["adyen-checkout__threeds2__form","adyen-checkout__threeds2__form--".concat(r)]),name:r,action:a,target:n,style:{display:"none"}},JN("input",{name:o,value:i}))}}]),r}($N),vQ={result:{transStatus:"U"},type:"challengeResult",errorCode:"timeout"},yQ={result:{threeDSCompInd:"N"},type:"fingerPrintResult",errorCode:"timeout"},gQ="unknownError",bQ={timeout:"ThreeDS2 timed out",wrongOrigin:"Result came in the right format but not from the expected origin",HTMLElementError:"No proper HTML element was passed",wrongDataType:"Result data was not of the expected type",missingProperty:"Result data did not contain the expected properties",unknownError:"An unknown error occurred"},kQ={"01":["250px","400px"],"02":["390px","400px"],"03":["500px","600px"],"04":["600px","400px"],"05":["100%","100%"]},CQ=function(e){var t=TA.decode(e);try{return t&&JSON.parse(t)}catch(e){throw new Error("Could not decode token")}},_Q=function(e){if(!e||!Jy(e).length)throw new Error("No (populated) data object to encode");return TA.encode(gA(e))},NQ=function(e){var t=1===e.length?"0".concat(e):e;return Object.prototype.hasOwnProperty.call(kQ,t)?t:"02"},PQ=function(e,t,r){var a;return{data:(a={},Wg(a,e,_Q({threeDSCompInd:t.threeDSCompInd})),Wg(a,"paymentData",r),a)}},wQ=function(e,t,r){return{data:{details:{"threeds2.fingerprint":_Q(t)},paymentData:r}}},SQ=function(e,t,r){return{data:{details:Wg({},e,_Q({transStatus:t,authorisationToken:r}))}}},xQ=function(e,t,r){return{data:{details:{"threeds2.challengeResult":_Q({transStatus:t})},paymentData:r}}},EQ=function(e,t){return{errorCode:e,message:bQ[e]||t||bQ[gQ]}},AQ=function(e){var t=window.btoa(e).split("=")[0];return t=(t=t.replace(/\+/g,"-")).replace(/\//g,"_")},DQ=["elementRef"],IQ=["createFromAction","onAdditionalDetails"];function FQ(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}var RQ="threeDSIframe",OQ=function(e){TN(r,e);var t=FQ(r);function r(e){var a;Bg(this,r),Wg(RN(a=t.call(this,e)),"processMessageHandler",void 0),Wg(RN(a),"challengePromise",void 0),Wg(RN(a),"iframeCallback",(function(){a.setState({status:"iframeLoaded"}),a.props.onActionHandled({componentType:"3DS2Challenge",actionDescription:"challenge-iframe-loaded"})}));var n=gA(a.props.cReqData),o=AQ(n);return a.state={base64URLencodedData:o},a}return qg(r,[{key:"get3DS2ChallengePromise",value:function(){var e=this;return new ok((function(t,r){e.processMessageHandler=SA(e.props.postMessageDomain,t,0,"challengeResult"),window.addEventListener("message",e.processMessageHandler)}))}},{key:"componentDidMount",value:function(){var e=this;this.challengePromise=CA(6e5,this.get3DS2ChallengePromise(),vQ),this.challengePromise.promise.then((function(t){window.removeEventListener("message",e.processMessageHandler),e.props.onCompleteChallenge(t)})).catch((function(t){window.removeEventListener("message",e.processMessageHandler),e.props.onErrorChallenge(t)}))}},{key:"componentWillUnmount",value:function(){this.challengePromise&&this.challengePromise.cancel(),window.removeEventListener("message",this.processMessageHandler)}},{key:"render",value:function(e,t){var r=e.acsURL,a=e.cReqData,n=e.iframeSizeArr,o=t.base64URLencodedData,i=t.status,l=tC(n,2),c=l[0],s=l[1];return JN("div",{className:ww(["adyen-checkout__threeds2__challenge","adyen-checkout__threeds2__challenge--".concat(a.challengeWindowSize)])},"iframeLoaded"!==i&&JN(Sw,null),JN(kA,{name:RQ,width:c,height:s,callback:this.iframeCallback}),JN(hQ,{name:"cReqForm",action:r,target:RQ,inputName:"creq",inputValue:o}))}}]),r}($N);function TQ(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}var BQ=function(e){TN(r,e);var t=TQ(r);function r(e){var a;if(Bg(this,r),(a=t.call(this,e)).props.token){var n=function(e){var t,r=e.token,a=e.size,n=CQ(r),o=n.acsTransID,i=n.acsURL,l=n.messageVersion,c=n.threeDSNotificationURL,s=n.threeDSServerTransID,u=xA(c);return{acsURL:i,cReqData:{acsTransID:o,messageVersion:l,threeDSServerTransID:s,messageType:"CReq",challengeWindowSize:NQ(a)},iframeSizeArr:(t=a,kQ[NQ(t)]),postMessageDomain:u}}({token:a.props.token,size:a.props.challengeWindowSize||a.props.size}),o=n.cReqData,i=o.acsTransID,l=o.messageVersion,c=o.threeDSServerTransID;if(!(n.acsURL&&i&&l&&c))return a.setStatusError({errorInfo:"Challenge Data missing one or more of the following properties (acsURL | acsTransID | messageVersion | threeDSServerTransID)",errorObj:n}),BN(a);a.state={status:"retrievingChallengeToken",challengeData:n,errorInfo:null}}else a.setStatusError({errorInfo:"Missing challengeToken parameter"});return a}return qg(r,[{key:"setStatusComplete",value:function(e){var t=this;this.setState({status:"complete"},(function(){var r=(t.props.useOriginalFlow?xQ:SQ)(t.props.dataKey,e.transStatus,t.props.paymentData);t.props.onComplete(r)}))}},{key:"setStatusError",value:function(e){this.setState({status:"error",errorInfo:e.errorInfo}),this.props.onError(e)}},{key:"render",value:function(e,t){var r=this,a=e.onActionHandled,n=t.challengeData;return"retrievingChallengeToken"===this.state.status?JN(OQ,FN({onCompleteChallenge:function(e){if(lA(e.result,"errorCode")&&e.result.errorCode.length){var t=EQ(e.result.errorCode,e.result.errorDescription);r.props.onError(t)}r.setStatusComplete(e.result)},onErrorChallenge:function(e){if(lA(e,"errorCode")){var t=EQ(e.errorCode);return r.props.onError(t),void r.setStatusComplete(e.result)}}},n,{onActionHandled:a})):"error"===this.state.status?JN("div",{className:"adyen-checkout__threeds2-challenge-error"},JN(fF,{className:"adyen-checkout__status__icon adyen-checkout__status__icon--error",src:GP({loadingContext:this.props.loadingContext,imageFolder:"components/"})("error"),alt:""}),JN("div",{className:"adyen-checkout__status__text"},this.state.errorInfo?this.state.errorInfo:this.props.i18n.get("error.message.unknown"))):null}}]),r}($N);function jQ(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}Wg(BQ,"defaultProps",{onComplete:function(){},onError:function(){},onActionHandled:function(){}});var zQ=function(e){TN(r,e);var t=jQ(r);function r(){return Bg(this,r),t.apply(this,arguments)}return qg(r,[{key:"onComplete",value:function(e){oD(jN(r.prototype),"onComplete",this).call(this,e),this.unmount()}},{key:"render",value:function(){if(!QM(this.props.paymentData)){var e=lA(this.props,"useOriginalFlow")?"paymentData":"authorisationToken";return this.props.onError({errorCode:"threeds2.challenge",message:"No ".concat(e," received. Challenge cannot proceed")}),null}return JN(BQ,FN({},this.props,{onComplete:this.onComplete}))}}]),r}(dA);function MQ(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}Wg(zQ,"type","threeDS2Challenge"),Wg(zQ,"defaultProps",{dataKey:"threeDSResult",size:"02",type:"ChallengeShopper"});var LQ="threeDSMethodIframe",VQ=function(e){TN(r,e);var t=MQ(r);function r(e){var a;Bg(this,r),Wg(RN(a=t.call(this,e)),"processMessageHandler",void 0),Wg(RN(a),"fingerPrintPromise",void 0);var n=a.props,o=n.threeDSServerTransID,i=n.threeDSMethodNotificationURL,l=gA({threeDSServerTransID:o,threeDSMethodNotificationURL:i}),c=AQ(l);return a.state={base64URLencodedData:c},a}return qg(r,[{key:"get3DS2MethodPromise",value:function(){var e=this;return new ok((function(t,r){e.processMessageHandler=SA(e.props.postMessageDomain,t,0,"fingerPrintResult"),window.addEventListener("message",e.processMessageHandler)}))}},{key:"componentDidMount",value:function(){var e=this;this.fingerPrintPromise=CA(1e4,this.get3DS2MethodPromise(),yQ),this.fingerPrintPromise.promise.then((function(t){window.removeEventListener("message",e.processMessageHandler),e.props.onCompleteFingerprint(t)})).catch((function(t){window.removeEventListener("message",e.processMessageHandler),e.props.onErrorFingerprint(t)}))}},{key:"componentWillUnmount",value:function(){this.fingerPrintPromise&&this.fingerPrintPromise.cancel(),window.removeEventListener("message",this.processMessageHandler)}},{key:"render",value:function(e,t){var r=e.threeDSMethodURL,a=e.onActionHandled,n=t.base64URLencodedData;return JN("div",{className:"adyen-checkout__3ds2-device-fingerprint"},this.props.showSpinner&&JN(Sw,null),JN("div",{style:{display:"none"}},JN(kA,{name:LQ,callback:function(){a({componentType:"3DS2Fingerprint",actionDescription:"fingerprint-iframe-loaded"})}}),JN(hQ,{name:"threeDSMethodForm",action:r,target:LQ,inputName:"threeDSMethodData",inputValue:n})))}}]),r}($N);function UQ(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}Wg(VQ,"defaultProps",{showSpinner:!0});var KQ=function(e){TN(r,e);var t=UQ(r);function r(e){var a;Bg(this,r);var n=(a=t.call(this,e)).props,o=n.token,i=n.notificationURL;if(o){var l=function(e){var t=e.token,r=e.notificationURL,a=CQ(t),n=a.threeDSMethodNotificationURL,o=a.threeDSMethodUrl,i=r||n;return{threeDSServerTransID:a.threeDSServerTransID,threeDSMethodURL:o,threeDSMethodNotificationURL:i,postMessageDomain:xA(i)}}({token:o,notificationURL:i});a.state={status:"init",fingerPrintData:l}}else a.state={status:"error"},a.props.onError({errorCode:a.props.dataKey,message:"Missing fingerprintToken parameter"});return a}return qg(r,[{key:"componentDidMount",value:function(){if(!this.state.fingerPrintData||!this.state.fingerPrintData.threeDSMethodURL)return this.setStatusComplete({threeDSCompInd:"U"}),void console.debug("### PrepareFingerprint3DS2::exiting:: no fingerPrintData or no threeDSMethodURL");this.setState({status:"retrievingFingerPrint"})}},{key:"setStatusComplete",value:function(e){var t=this;this.setState({status:"complete"},(function(){var r=(t.props.useOriginalFlow?wQ:PQ)(t.props.dataKey,e,t.props.paymentData);t.props.onComplete(r)}))}},{key:"render",value:function(e,t){var r=this,a=e.showSpinner,n=e.onActionHandled,o=t.fingerPrintData;return"retrievingFingerPrint"===this.state.status?JN(VQ,FN({onCompleteFingerprint:function(e){r.setStatusComplete(e.result)},onErrorFingerprint:function(e){var t=EQ(e.errorCode);console.debug("### PrepareFingerprint3DS2::fingerprint timed-out:: errorCodeObject=",t),r.setStatusComplete(e.result)},showSpinner:a},o,{onActionHandled:n})):null}}]),r}($N);function HQ(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function qQ(e){var t=this,r=e.data;UB({path:"v1/submitThreeDS2Fingerprint?token=".concat(this.props.clientKey),loadingContext:this.props.loadingContext,errorLevel:"fatal"},function(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=HQ(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=HQ(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}({},r)).then((function(e){var r,a,n,o=null!==(r=t.props.elementRef)&&void 0!==r?r:t;if(o){if(e.action||e.details){if("completed"===e.type){var i=e.details;return t.onComplete({data:{details:i}})}return"threeDS2"===(null===(a=e.action)||void 0===a?void 0:a.type)?o.handleAction(e.action,BL("challengeWindowSize").from(t.props)):"redirect"===(null===(n=e.action)||void 0===n?void 0:n.type)?o.handleAction(e.action):void 0}console.error("Handled Error::callSubmit3DS2Fingerprint::FAILED:: resData=",e)}else console.error("Handled Error::callSubmit3DS2Fingerprint::FAILED:: actionHandler=",o)})).catch((function(e){t.handleError(e)}))}function WQ(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}Wg(KQ,"type","scheme"),Wg(KQ,"defaultProps",{onComplete:function(){},onError:function(){},paymentData:"",showSpinner:!0,onActionHandled:function(){}});var YQ=function(e){TN(r,e);var t=WQ(r);function r(){var e,a;Bg(this,r);for(var n=arguments.length,o=new Array(n),i=0;i<n;i++)o[i]=arguments[i];return Wg(RN(a=t.call.apply(t,Bb(e=[this]).call(e,o))),"callSubmit3DS2Fingerprint",rk(qQ).call(qQ,RN(a))),a}return qg(r,[{key:"onComplete",value:function(e){oD(jN(r.prototype),"onComplete",this).call(this,e),this.unmount()}},{key:"render",value:function(){return QM(this.props.paymentData)?JN(KQ,FN({},this.props,{onComplete:this.props.useOriginalFlow?this.onComplete:this.callSubmit3DS2Fingerprint})):(this.props.onError({errorCode:r.defaultProps.dataKey,message:"No paymentData received. Fingerprinting cannot proceed"}),null)}}]),r}(dA);Wg(YQ,"type","threeDS2Fingerprint"),Wg(YQ,"defaultProps",{dataKey:"fingerprintResult",type:"IdentifyShopper"});var GQ={},JQ={get exports(){return GQ},set exports(e){GQ=e}},QQ=ne.setInterval;!function(e){e.exports=QQ}(JQ);var ZQ=t(GQ),$Q={},XQ={get exports(){return $Q},set exports(e){$Q=e}},eZ=aa,tZ=go,rZ=Z,aZ=RangeError,nZ=function(e){var t=tZ(rZ(this)),r="",a=eZ(e);if(a<0||a==1/0)throw aZ("Wrong number of repetitions");for(;a>0;(a>>>=1)&&(t+=t))1&a&&(r+=t);return r};Dr({target:"String",proto:!0},{repeat:nZ});var oZ=Vv("String").repeat,iZ=ue,lZ=oZ,cZ=String.prototype,sZ=function(e){var t=e.repeat;return"string"==typeof e||e===cZ||iZ(cZ,e)&&t===cZ.repeat?lZ:t};!function(e){e.exports=sZ}(XQ);var uZ=t($Q),dZ=function(e){var t,r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:2;if(0===r)return e;var a=String(e);return a.length>=r?a:OA(t=uZ("0").call("0",r)+a).call(t,-1*r)},pZ=function(e,t){var r=new Date,a=t.getTime()-r.getTime(),n=a/1e3,o=function(e,t,r){var a=r.getTime()-e.getTime();return 100-Math.round(100*(t.getTime()-e.getTime())/a)}(e,r,t);return{total:a,minutes:dZ(Math.floor(n/60%60)),seconds:dZ(Math.floor(n%60)),completed:a<=0,percentage:o}};function fZ(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function mZ(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}var hZ=function(e){TN(r,e);var t=mZ(r);function r(e){var a;Bg(this,r),Wg(RN(a=t.call(this,e)),"interval",void 0);var n=6e4*a.props.minutesFromNow,o=(new Date).getTime();return a.state={startTime:new Date(o),endTime:new Date(o+n),minutes:"-",seconds:"-"},a}return qg(r,[{key:"tick",value:function(){var e=pZ(this.state.startTime,this.state.endTime);if(e.completed)return this.props.onCompleted(),this.clearInterval();var t={minutes:e.minutes,seconds:e.seconds,percentage:e.percentage};return this.setState(function(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=fZ(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=fZ(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}({},t)),this.props.onTick(t),t}},{key:"clearInterval",value:function(e){function t(){return e.apply(this,arguments)}return t.toString=function(){return e.toString()},t}((function(){clearInterval(this.interval),delete this.interval}))},{key:"componentDidMount",value:function(){var e=this;this.interval=ZQ((function(){e.tick()}),1e3)}},{key:"componentWillUnmount",value:function(){this.clearInterval()}},{key:"render",value:function(){return JN("span",{className:"adyen-checkout__countdown"},JN("span",{className:"countdown__minutes"},this.state.minutes),JN("span",{className:"countdown__separator"},":"),JN("span",{className:"countdown__seconds"},this.state.seconds))}}]),r}($N);function vZ(e,t,r){if(!e||!t)throw new Error("Could not check the payment status");return UB({loadingContext:r,path:"services/PaymentInitiation/v1/status?clientKey=".concat(t)},{paymentData:e})}function yZ(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function gZ(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=yZ(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=yZ(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}Wg(hZ,"defaultProps",{onTick:function(){},onCompleted:function(){}});var bZ=function(e){switch(e.resultCode.toLowerCase()){case"refused":case"error":case"cancelled":return{type:"error",props:gZ(gZ({},e),{},{message:"error.subtitle.refused"})};case"unknown":return{type:"error",props:gZ(gZ({},e),{},{message:"error.message.unknown"})};case"pending":case"received":return{type:e.resultCode.toLowerCase(),props:e};default:return{type:"success",props:e}}},kZ=function(e){if(!e.type&&e.resultCode)return bZ(e);if(!e.type)return{type:"error",props:e};switch(e.type.toLowerCase()){case"pending":return{type:"pending",props:e};case"complete":return bZ(e);default:return{type:"error",props:e}}};function CZ(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}var _Z=function(e){TN(r,e);var t=CZ(r);function r(e){var a;return Bg(this,r),Wg(RN(a=t.call(this,e)),"interval",void 0),Wg(RN(a),"statusInterval",(function(){a.checkStatus(),a.setState({timePassed:a.state.timePassed+a.props.delay}),a.state.timePassed>=a.props.throttleTime&&a.setState({delay:a.props.throttledInterval})})),Wg(RN(a),"redirectToApp",(function(e){window.location.assign(e)})),Wg(RN(a),"onTick",(function(e){a.setState({percentage:e.percentage})})),Wg(RN(a),"onTimeUp",(function(){a.setState({expired:!0}),clearInterval(a.interval),a.props.onError(new iA("ERROR","Payment Expired"))})),Wg(RN(a),"onComplete",(function(e){clearInterval(a.interval),a.setState({completed:!0,loading:!1});var t={data:{details:{payload:e.props.payload},paymentData:a.props.paymentData}};a.props.onComplete(t,RN(a))})),Wg(RN(a),"onError",(function(e){if(clearInterval(a.interval),a.setState({expired:!0,loading:!1}),e.props.payload){var t={data:{details:{payload:e.props.payload},paymentData:a.props.paymentData}};a.props.onComplete(t,RN(a))}var r=new iA("ERROR","error result with no payload in response");return a.props.onError(r)})),Wg(RN(a),"checkStatus",(function(){var e=a.props;return vZ(e.paymentData,e.clientKey,e.loadingContext).then(kZ).catch((function(e){return{type:"network-error",props:e}})).then((function(e){switch(e.type){case"success":a.onComplete(e);break;case"error":a.onError(e);break;default:a.setState({loading:!1})}return e}))})),a.state={buttonStatus:"default",completed:!1,delay:e.delay,expired:!1,loading:!0,percentage:100,timePassed:0},a}return qg(r,[{key:"componentDidMount",value:function(){this.interval=ZQ(this.statusInterval,this.state.delay)}},{key:"componentDidUpdate",value:function(e,t){t.delay!==this.state.delay&&(clearInterval(this.interval),this.interval=ZQ(this.statusInterval,this.state.delay))}},{key:"componentWillUnmount",value:function(){clearInterval(this.interval)}},{key:"render",value:function(e,t){var r,a,n,o,i=this,l=e.amount,c=e.url,s=e.brandLogo,u=e.countdownTime,d=e.type,p=e.onActionHandled,f=t.expired,m=t.completed,h=t.loading,v=$w(),y=v.i18n,g=v.loadingContext,b=this.props.qrCodeData?Bb(r=Bb(a="".concat(g)).call(a,"barcode.shtml?barcodeType=qrCode&fileType=png&data=")).call(r,this.props.qrCodeData):this.props.qrCodeImage,k=function(e,t){return JN("div",{className:"adyen-checkout__qr-loader adyen-checkout__qr-loader--result"},JN("img",{className:"adyen-checkout__qr-loader__icon adyen-checkout__qr-loader__icon--result",src:GP({loadingContext:g,imageFolder:"components/"})(e),alt:y.get(t)}),JN("div",{className:"adyen-checkout__qr-loader__subtitle adyen-checkout__qr-loader__subtitle--result"},y.get(t)))};if(f)return k("error","error.subtitle.payment");if(m)return k("success","creditCard.success");if(h)return JN("div",{className:"adyen-checkout__qr-loader"},s&&JN("img",{alt:d,src:s,className:"adyen-checkout__qr-loader__brand-logo"}),JN(Sw,null));var C=y.get("wechatpay.timetopay").split("%@");return JN("div",{className:Bb(n="\n                    adyen-checkout__qr-loader\n                    adyen-checkout__qr-loader--".concat(d,"\n                    ")).call(n,QC(o=this.props.classNameModifiers).call(o,(function(e){return"adyen-checkout__qr-loader--".concat(e)})),"\n                ")},s&&JN("img",{src:s,alt:d,className:"adyen-checkout__qr-loader__brand-logo"}),JN("div",{className:"adyen-checkout__qr-loader__subtitle"},y.get(this.props.introduction)),JN("img",{src:b,alt:y.get("wechatpay.scanqrcode"),onLoad:function(){p({componentType:i.props.type,actionDescription:"qr-code-loaded"})}}),l&&l.value&&l.currency&&JN("div",{className:"adyen-checkout__qr-loader__payment_amount"},y.amount(l.value,l.currency)),JN("div",{className:"adyen-checkout__qr-loader__progress"},JN("span",{className:"adyen-checkout__qr-loader__percentage",style:{width:"".concat(this.state.percentage,"%")}})),JN("div",{className:"adyen-checkout__qr-loader__countdown"},C[0],"\xa0",JN(hZ,{minutesFromNow:u,onTick:this.onTick,onCompleted:this.onTimeUp}),"\xa0",C[1]),this.props.instructions&&JN("div",{className:"adyen-checkout__qr-loader__instructions"},y.get(this.props.instructions)),this.props.copyBtn&&JN("div",{className:"adyen-checkout__qr-loader__actions"},JN(eS,{inline:!0,variant:"action",onClick:function(e,t){var r=t.complete;FG(i.props.qrCodeData),r()},icon:GP({loadingContext:g,imageFolder:"components/"})("copy"),label:y.get("button.copy")})),c&&JN("div",{className:"adyen-checkout__qr-loader__app-link"},JN(uM,null),JN(eS,{classNameModifiers:["qr-loader"],onClick:function(){return i.redirectToApp(c)},label:y.get("openApp")})))}}]),r}($N);function NZ(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function PZ(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=NZ(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=NZ(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}function wZ(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}Wg(_Z,"defaultProps",{delay:2e3,countdownTime:15,onError:function(){},onComplete:function(){},throttleTime:6e4,classNameModifiers:[],throttledInterval:1e4,introduction:"wechatpay.scanqrcode"});var SZ=function(e){TN(r,e);var t=wZ(r);function r(){return Bg(this,r),t.apply(this,arguments)}return qg(r,[{key:"formatData",value:function(){return{paymentMethod:PZ({type:this.props.type||this.constructor.type},this.state.data)}}},{key:"isValid",get:function(){return!0}},{key:"renderQRCode",value:function(){var e=this;return JN(Uj,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},JN(_Z,FN({ref:function(t){e.componentRef=t}},this.props,{type:this.constructor.type,brandLogo:this.props.brandLogo||this.icon,delay:this.props.delay,onComplete:this.onComplete,countdownTime:this.props.countdownTime,instructions:this.props.instructions,onActionHandled:this.props.onActionHandled})))}},{key:"render",value:function(){var e=this;return this.props.paymentData?this.renderQRCode():this.props.showPayButton?JN(Uj,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},JN(NM,{name:this.displayName,onSubmit:this.submit,payButton:this.payButton,ref:function(t){e.componentRef=t}})):null}}]),r}(dA);Wg(SZ,"defaultProps",{qrCodeImage:"",amount:null,paymentData:null,onError:function(){},onComplete:function(){},onActionHandled:function(){}});function xZ(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function EZ(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}var AZ=function(e){TN(r,e);var t=EZ(r);function r(){return Bg(this,r),t.apply(this,arguments)}return qg(r,[{key:"formatProps",value:function(e){return function(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=xZ(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=xZ(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}({delay:2e3,countdownTime:15},oD(jN(r.prototype),"formatProps",this).call(this,e))}}]),r}(SZ);Wg(AZ,"type","wechatpayQR");function DZ(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function IZ(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}var FZ=function(e){TN(r,e);var t=IZ(r);function r(){return Bg(this,r),t.apply(this,arguments)}return qg(r,[{key:"formatProps",value:function(e){return function(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=DZ(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=DZ(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}({delay:2e3,countdownTime:3},oD(jN(r.prototype),"formatProps",this).call(this,e))}}]),r}(SZ);Wg(FZ,"type","paynow");function RZ(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function OZ(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}var TZ=function(e){TN(r,e);var t=OZ(r);function r(){return Bg(this,r),t.apply(this,arguments)}return qg(r,[{key:"formatProps",value:function(e){return function(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=RZ(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=RZ(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}({delay:2e3,countdownTime:15,buttonLabel:window.matchMedia("(max-width: 768px)").matches&&/Android|iPhone|iPod/.test(navigator.userAgent)?"openApp":"generateQRCode"},oD(jN(r.prototype),"formatProps",this).call(this,e))}}]),r}(SZ);function BZ(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}Wg(TZ,"type","bcmc_mobile");var jZ=function(e){TN(r,e);var t=BZ(r);function r(){return Bg(this,r),t.apply(this,arguments)}return qg(r)}(xM);function zZ(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}Wg(jZ,"type","molpay_ebanking_fpx_MY");var MZ=function(e){TN(r,e);var t=zZ(r);function r(){return Bg(this,r),t.apply(this,arguments)}return qg(r)}(xM);function LZ(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}Wg(MZ,"type","molpay_ebanking_TH");var VZ=function(e){TN(r,e);var t=LZ(r);function r(){return Bg(this,r),t.apply(this,arguments)}return qg(r)}(xM);function UZ(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function KZ(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=UZ(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=UZ(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}function HZ(e){var t,r,a=$w().i18n,n=function(){var t=["dragonpay_ebanking","dragonpay_otc_banking","dragonpay_otc_non_banking"];return hC(t).call(t,e.type)>-1},o=QF({schema:Bb(t=[]).call(t,rC(n()?["issuer"]:[]),["shopperEmail"]),rules:{issuer:{validate:function(e){return n()&&!!e},modes:["input","blur"]}}}),i=o.handleChangeFor,l=o.triggerValidation,c=o.data,s=o.valid,u=o.errors,d=o.isValid,p=bM({},e.type),f=QC(r=e.items).call(r,(function(e){return KZ(KZ({},e),{},{icon:p(e.id&&e.id.toLowerCase())})})),m=function(e){return"dragonpay_otc_non_banking"===e?"dragonpay.voucher.non.bank.selectField.placeholder":"dragonpay.voucher.bank.selectField.placeholder"};zw((function(){e.onChange({isValid:d,data:c,valid:s,errors:u})}),[d,c,s,u]);var h=tC(Bw("ready"),2),v=h[0],y=h[1];return this.setStatus=y,this.showValidation=l,JN("div",{className:"adyen-checkout__dragonpay-input__field"},JN(kI,{label:a.get("shopperEmail"),errorMessage:!!u.shopperEmail},NF("emailAddress",{name:"dragonpay.shopperEmail",autoCorrect:"off",value:c.shopperEmail,className:"adyen-checkout__input--large",spellCheck:!1,onInput:i("shopperEmail","input"),onBlur:i("shopperEmail","blur")})),n()&&JN(kI,{label:a.get(m(e.type)),errorMessage:!!u.issuer},NF("select",{items:f,selected:c.issuer,placeholder:a.get(m(e.type)),name:"issuer",className:"adyen-checkout__dropdown--large adyen-checkout__issuer-list__dropdown",onChange:i("issuer")})),e.showPayButton&&e.payButton({status:v,label:a.get("confirmPurchase")}))}function qZ(e){var t=e.reference,r=e.totalAmount,a=e.surcharge,n=e.expiresAt,o=e.alternativeReference,i=e.instructionsUrl,l=e.icon,c=e.issuer,s=e.paymentMethodType,u=$w(),d=u.loadingContext,p=u.i18n,f="dragonpay_otc_philippines"!==s?bM({loadingContext:d},s)(c.toLowerCase()):null;return JN(OG,{reference:t,paymentMethodType:s,introduction:p.get("voucher.introduction"),imageUrl:l,issuerImageUrl:f,instructionsUrl:i,amount:r&&p.amount(r.value,r.currency),surcharge:a&&p.amount(a.value,a.currency),voucherDetails:[{label:p.get("voucher.expirationDate"),value:p.date(n)},{label:p.get("voucher.alternativeReference"),value:o}],copyBtn:!0})}function WZ(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function YZ(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=WZ(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=WZ(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}function GZ(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}Wg(VZ,"type","molpay_ebanking_VN"),HZ.defaultProps={data:{},items:[],onChange:function(){}};var JZ=function(e){TN(r,e);var t=GZ(r);function r(){return Bg(this,r),t.apply(this,arguments)}return qg(r,[{key:"isValid",get:function(){return!!this.state.isValid}},{key:"formatData",value:function(){var e=this.state.data,t=e.issuer,a=e.shopperEmail;return YZ(YZ({},a&&{shopperEmail:a}),{},{paymentMethod:YZ(YZ({},t&&{issuer:t}),{},{type:this.props.type||r.type})})}},{key:"formatProps",value:function(e){var t,r,a;return YZ(YZ({},e),{},{issuers:null!==(t=null===(r=e.details)||void 0===r||null===(a=yk(r).call(r,(function(e){return"issuer"===e.key})))||void 0===a?void 0:a.items)&&void 0!==t?t:e.issuers})}},{key:"render",value:function(){var e=this;return JN(Uj,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},this.props.reference?JN(qZ,FN({ref:function(t){e.componentRef=t},icon:this.icon},this.props)):JN(HZ,FN({ref:function(t){e.componentRef=t},items:this.props.issuers},this.props,{onChange:this.setState,onSubmit:this.submit,payButton:this.payButton})))}}]),r}(dA);function QZ(e){var t,r=Lw(null),a=$w().i18n,n=tC(Bw("ready"),2),o=n[0],i=n[1],l=Lw({});Jy(l.current).length||(null===(t=e.setComponentRef)||void 0===t||t.call(e,l.current));return l.current.showValidation=function(){var e;null===(e=r.current)||void 0===e||e.showValidation()},l.current.setStatus=i,JN("div",{className:"adyen-checkout__doku-input__field"},JN(uR,{data:e.data,requiredFields:["firstName","lastName","shopperEmail"],onChange:e.onChange,namePrefix:"doku",setComponentRef:function(e){r.current=e}}),e.showPayButton&&e.payButton({status:o,label:a.get("confirmPurchase")}))}Wg(JZ,"type","dragonpay");var ZZ=function(e){var t=e.reference,r=e.expiresAt,a=e.instructionsUrl,n=e.shopperName,o=e.merchantName,i=e.totalAmount,l=e.paymentMethodType,c=$w(),s=c.loadingContext,u=c.i18n;return JN(OG,{paymentMethodType:l,reference:t,introduction:u.get("voucher.introduction.doku"),imageUrl:GP({loadingContext:s})(l),instructionsUrl:a,amount:i&&u.amount(i.value,i.currency),voucherDetails:[{label:u.get("voucher.expirationDate"),value:u.date(r)},{label:u.get("voucher.shopperName"),value:n},{label:u.get("voucher.merchantName"),value:o}],copyBtn:!0})};function $Z(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function XZ(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=$Z(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=$Z(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}function e$(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}var t$=function(e){TN(r,e);var t=e$(r);function r(){return Bg(this,r),t.apply(this,arguments)}return qg(r,[{key:"isValid",get:function(){return!!this.state.isValid}},{key:"formatData",value:function(){return XZ(XZ({},this.state.data),{},{paymentMethod:{type:this.props.type||r.type}})}},{key:"icon",get:function(){return GP({loadingContext:this.props.loadingContext})(this.props.type)}},{key:"render",value:function(){var e=this;return JN(Uj,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},this.props.reference?JN(ZZ,FN({ref:function(t){e.componentRef=t}},this.props)):JN(QZ,FN({setComponentRef:this.setComponentRef},this.props,{onChange:this.setState,onSubmit:this.submit,payButton:this.payButton})))}}]),r}(dA);Wg(t$,"type","doku");var r$={socialSecurityNumber:{validate:dU,errorMessage:"",modes:["blur"]},shopperEmail:tR.shopperEmail,default:{validate:function(e){return!!e&&e.length>0},errorMessage:"",modes:["blur"]}},a$={socialSecurityNumber:function(e){return uU(e)}};function n$(e){var t=e.errors,r=e.value,a=e.onInput,n=e.onBlur,o=$w().i18n,i=tC(Bw(!1),2),l=i[0],c=i[1];return JN("div",{className:ww("adyen-checkout__fieldset","adyen-checkout__fieldset--sendCopyToEmail",e.classNames)},JN(kI,{classNameModifiers:["sendCopyToEmail"]},NF("boolean",{onChange:function(t){c(t.target.checked),e.onToggle(l)},label:o.get("boleto.sendCopyToEmail"),name:"sendCopyToEmail",value:l})),l&&JN(kI,{label:o.get("shopperEmail"),classNameModifiers:["shopperEmail"],errorMessage:t},NF("emailAddress",{name:"shopperEmail",autoCorrect:"off",spellCheck:!1,value:r,onInput:a,onBlur:n})))}function o$(e){var t=e.i18n,r=e.data,a=e.handleChangeFor,n=e.errors,o=e.valid;return JN("div",{className:"adyen-checkout__fieldset adyen-checkout__fieldset--address adyen-checkout__fieldset--personalDetails"},JN("div",{className:"adyen-checkout__fieldset__title"},t.get("personalDetails")),JN("div",{className:"adyen-checkout__fieldset__fields"},JN(kI,{label:t.get("firstName"),classNameModifiers:["firstName","col-50"],errorMessage:!!n.firstName},NF("text",{name:"firstName",autocorrect:"off",spellcheck:!1,value:r.firstName,onInput:a("firstName","input"),onBlur:a("firstName","blur")})),JN(kI,{label:t.get("lastName"),classNameModifiers:["lastName","col-50"],errorMessage:!!n.lastName},NF("text",{name:"lastName",autocorrect:"off",spellcheck:!1,value:r.lastName,onInput:a("lastName","input"),onBlur:a("lastName","blur")})),JN(Qq,{data:r.socialSecurityNumber,error:n.socialSecurityNumber,valid:o.socialSecurityNumber,onInput:a("socialSecurityNumber","input"),onBlur:a("socialSecurityNumber","blur")})))}function i$(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function l$(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=i$(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=i$(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}function c$(e){var t=$w().i18n,r=Lw(null),a=QF({schema:["firstName","lastName","socialSecurityNumber","billingAddress","shopperEmail"],defaultData:e.data,rules:r$,formatters:a$}),n=a.handleChangeFor,o=a.triggerValidation,i=a.setSchema,l=a.setData,c=a.setValid,s=a.setErrors,u=a.data,d=a.valid,p=a.errors,f=a.isValid,m=tC(Bw(!1),2),h=m[0],v=m[1];zw((function(){var t,r=Bb(t=[]).call(t,rC(e.personalDetailsRequired?["firstName","lastName","socialSecurityNumber"]:[]),rC(e.billingAddressRequired?["billingAddress"]:[]),rC(h?["shopperEmail"]:[]));i(r)}),[h,e.personalDetailsRequired,e.billingAddressRequired]);var y,g=tC(Bw("ready"),2),b=g[0],k=g[1],C=Lw({});Jy(C.current).length||(null===(y=e.setComponentRef)||void 0===y||y.call(e,C.current));C.current.showValidation=function(){o(),e.billingAddressRequired&&r.current.showValidation()},C.current.setStatus=k,zw((function(){var t=!e.billingAddressRequired||Boolean(d.billingAddress);e.onChange({data:u,valid:d,errors:p,isValid:f&&t})}),[u,d,p]);var _=rC(e.personalDetailsRequired||e.billingAddressRequired||e.showEmailAddress?[]:["standalone"]);return JN("div",{className:"adyen-checkout__boleto-input__field"},e.personalDetailsRequired&&JN(o$,{i18n:t,data:u,handleChangeFor:n,errors:p,valid:d}),e.billingAddressRequired&&JN(vj,{allowedCountries:["BR"],label:"billingAddress",data:l$(l$({},e.data.billingAddress),{},{country:"BR"}),onChange:function(e){l("billingAddress",e.data),c("billingAddress",e.isValid),s("billingAddress",e.errors)},requiredFields:["country","street","houseNumberOrName","postalCode","city","stateOrProvince"],setComponentRef:function(e){r.current=e}}),e.showEmailAddress&&JN(n$,{value:u.shopperEmail,errors:p.shopperEmail,onToggle:function(){return v(!h)},onInput:n("shopperEmail","input"),onBlur:n("shopperEmail","blur")}),e.showPayButton&&e.payButton({status:b,label:t.get("boletobancario.btnLabel"),classNameModifiers:_}))}c$.defaultProps={data:{},showEmailAddress:!0,personalDetailsRequired:!0,billingAddressRequired:!0};var s$=function(e){var t,r=$w(),a=r.i18n,n=r.loadingContext,o=e.reference,i=e.expiresAt,l=e.totalAmount,c=e.paymentMethodType,s=e.downloadUrl,u=o.replace(/[^\d]/g,"").replace(/^(\d{4})(\d{5})\d{1}(\d{10})\d{1}(\d{10})\d{1}(\d{15})$/,"$1$5$2$3$4");return JN(OG,{reference:o,paymentMethodType:"boletobancario",barcode:Bb(t="".concat(n,"barcode.shtml?data=")).call(t,u,"&barcodeType=BT_Int2of5A&fileType=png"),introduction:a.get("voucher.introduction"),imageUrl:GP({loadingContext:n})(c),amount:l&&a.amount(l.value,l.currency),voucherDetails:[{label:a.get("voucher.expirationDate"),value:a.date(i)}],downloadUrl:s,copyBtn:!0})};function u$(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function d$(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=u$(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=u$(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}function p$(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}var f$=function(e){TN(r,e);var t=p$(r);function r(){var e,a;Bg(this,r);for(var n=arguments.length,o=new Array(n),i=0;i<n;i++)o[i]=arguments[i];return Wg(RN(a=t.call.apply(t,Bb(e=[this]).call(e,o))),"handleRef",(function(e){a.componentRef=e})),a}return qg(r,[{key:"isValid",get:function(){return!!this.state.isValid}},{key:"formatData",value:function(){var e=this.state.data,t=void 0===e?{}:e,a=t.billingAddress,n=t.shopperEmail,o=t.firstName,i=t.lastName,l=t.socialSecurityNumber,c=void 0===l?"":l;return d$(d$(d$(d$({paymentMethod:{type:this.props.type||r.type}},a&&{billingAddress:a}),n&&{shopperEmail:n}),o&&i&&{shopperName:{firstName:o,lastName:i}}),c&&{socialSecurityNumber:sU(c)})}},{key:"render",value:function(){return JN(Uj,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},this.props.reference?JN(s$,FN({ref:this.handleRef,icon:this.icon},this.props)):JN(c$,FN({setComponentRef:this.handleRef},this.props,{onChange:this.setState,onSubmit:this.submit,payButton:this.payButton})))}}]),r}(dA);Wg(f$,"type","boletobancario");var m$=function(e){var t,r,a=$w(),n=a.i18n,o=a.loadingContext,i=e.alternativeReference,l=e.reference,c=e.expiresAt,s=e.merchantReference,u=e.totalAmount,d=e.paymentMethodType,p=e.downloadUrl,f=Bb(t="".concat(o,"barcode.shtml?data=")).call(t,l,"&barcodeType=BT_Code128C&fileType=png"),m=Bb(r=[]).call(r,rC(c?[{label:n.get("voucher.expirationDate"),value:n.date(c)}]:[]),rC(s?[{label:n.get("voucher.shopperReference"),value:s}]:[]),rC(i?[{label:n.get("voucher.alternativeReference"),value:i}]:[]));return JN(OG,{amount:u&&n.amount(u.value,u.currency),barcode:f,copyBtn:!0,downloadUrl:p,imageUrl:GP({loadingContext:o})(d),introduction:n.get("voucher.introduction"),paymentMethodType:"oxxo",reference:l,voucherDetails:m})};function h$(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function v$(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=h$(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=h$(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}function y$(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}var g$=function(e){TN(r,e);var t=y$(r);function r(){var e,a;Bg(this,r);for(var n=arguments.length,o=new Array(n),i=0;i<n;i++)o[i]=arguments[i];return Wg(RN(a=t.call.apply(t,Bb(e=[this]).call(e,o))),"handleRef",(function(e){a.componentRef=e})),a}return qg(r,[{key:"isValid",get:function(){return!0}},{key:"formatData",value:function(){return{paymentMethod:{type:this.props.type||r.type}}}},{key:"render",value:function(){var e;return JN(Uj,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},this.props.reference?JN(m$,FN({ref:this.handleRef},this.props)):this.props.showPayButton&&this.payButton(v$(v$({},this.props),{},{classNameModifiers:["standalone"],label:Bb(e="".concat(this.props.i18n.get("continueTo")," ")).call(e,this.props.name),onClick:this.submit})))}}]),r}(dA);Wg(g$,"type","oxxo"),Wg(g$,"defaultProps",{showPayButton:!1,name:"Oxxo"});var b$=function(e){var t,r=$w(),a=r.i18n,n=r.loadingContext,o=e.entity,i=e.reference,l=e.expiresAt,c=e.merchantReference,s=e.totalAmount,u=e.paymentMethodType,d=e.downloadUrl,p=Bb(t=[]).call(t,rC(o?[{label:a.get("voucher.entity"),value:o}]:[]),rC(l?[{label:a.get("voucher.expirationDate"),value:a.date(l)}]:[]),rC(c?[{label:a.get("voucher.shopperReference"),value:c}]:[]));return JN(OG,{amount:s&&a.amount(s.value,s.currency),barcode:null,copyBtn:!0,downloadUrl:d,imageUrl:GP({loadingContext:n})(u),introduction:a.get("voucher.introduction"),paymentMethodType:"multibanco",reference:i,voucherDetails:p})};function k$(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function C$(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=k$(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=k$(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}function _$(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}var N$=function(e){TN(r,e);var t=_$(r);function r(){var e,a;Bg(this,r);for(var n=arguments.length,o=new Array(n),i=0;i<n;i++)o[i]=arguments[i];return Wg(RN(a=t.call.apply(t,Bb(e=[this]).call(e,o))),"handleRef",(function(e){a.componentRef=e})),a}return qg(r,[{key:"isValid",get:function(){return!0}},{key:"formatProps",value:function(e){return C$(C$({},e),{},{name:e.name||"Multibanco"})}},{key:"formatData",value:function(){return{paymentMethod:{type:this.props.type||r.type}}}},{key:"render",value:function(){var e=this;return this.props.reference?JN(Uj,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},JN(b$,FN({ref:this.handleRef},this.props))):this.props.showPayButton?JN(Uj,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},JN(NM,{name:this.displayName,amount:this.props.amount,payButton:this.payButton,onSubmit:this.submit,ref:function(t){e.componentRef=t}})):null}}]),r}(dA);function P$(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}Wg(N$,"type","multibanco"),Wg(N$,"defaultProps",{showPayButton:!0});var w$=function(e){TN(r,e);var t=P$(r);function r(){return Bg(this,r),t.apply(this,arguments)}return qg(r)}(xM);function S$(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function x$(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=S$(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=S$(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}function E$(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}Wg(w$,"type","dotpay");var A$=function(e){TN(r,e);var t=E$(r);function r(){return Bg(this,r),t.apply(this,arguments)}return qg(r,[{key:"formatProps",value:function(e){return x$(x$({},oD(jN(r.prototype),"formatProps",this).call(this,e)),{},{showImage:!1})}}]),r}(xM);function D$(e){var t=e.children,r=e.classNames,a=void 0===r?[]:r,n=e.type,o=void 0===n?"error":n,i=e.icon;return JN("div",{className:ww("adyen-checkout__alert-message","adyen-checkout__alert-message--".concat(o),a)},i&&JN(vD,{className:"adyen-checkout__alert-message__icon",type:i}),t)}Wg(A$,"type","eps");var I$=["brand","amount","balance","transactionLimit"];function F$(e){e.brand;var t=e.amount,r=e.balance,a=e.transactionLimit,n=KP(e,I$),o=$w().i18n,i=t.value>(null==a?void 0:a.value)?a:t,l=(null==r?void 0:r.value)-(null==i?void 0:i.value);return JN("div",{className:"adyen-checkout__giftcard-result"},JN("ul",{className:"adyen-checkout__giftcard-result__balance"},JN("li",{className:"adyen-checkout__giftcard-result__balance__item"},JN("span",{className:"adyen-checkout__giftcard-result__balance__title"},o.get("giftcardBalance")),JN("span",{className:"adyen-checkout__giftcard-result__balance__value adyen-checkout__giftcard-result__balance__value--amount"},o.amount(r.value,r.currency))),a&&a.value&&JN("li",{className:"adyen-checkout__giftcard-result__balance__item"},JN("span",{className:"adyen-checkout__giftcard-result__balance__title adyen-checkout__giftcard-result__balance__title--transactionLimit"},o.get("giftcardTransactionLimit",{values:{amount:o.amount(a.value,a.currency)}})))),this.props.showPayButton&&this.props.payButton({amount:i,status:n.status,onClick:n.onSubmit}),JN("p",{className:"adyen-checkout__giftcard-result__remaining-balance"},o.get("partialPayment.remainingBalance",{values:{amount:o.amount(l,r.currency)}})))}var R$=function(e){var t,r=e.i18n,a=e.classNameModifiers,n=e.sfpState,o=e.getCardErrorMessage,i=e.focusedElement,l=e.setFocusOn;return JN(kI,{label:r.get("creditCard.numberField.title"),classNameModifiers:Bb(t=["number"]).call(t,rC(a)),errorMessage:o(n),focused:"encryptedCardNumber"===i,onFocusField:function(){return l("encryptedCardNumber")},dir:"ltr",name:"encryptedCardNumber"},JN(wK,{encryptedFieldType:"encryptedCardNumber","data-info":'{"length":"15-32", "maskInterval":4}',className:ww({"adyen-checkout__input":!0,"adyen-checkout__input--large":!0,"adyen-checkout__card__cardNumber__input":!0,"adyen-checkout__input--error":o(n),"adyen-checkout__input--focus":"encryptedCardNumber"===i})}))},O$=function(e){var t,r=e.i18n,a=e.classNameModifiers,n=e.sfpState,o=e.focusedElement,i=e.setFocusOn;return JN(kI,{label:r.get("creditCard.pin.title"),classNameModifiers:Bb(t=["pin"]).call(t,rC(a)),errorMessage:n.errors.encryptedSecurityCode&&r.get(n.errors.encryptedSecurityCode),focused:"encryptedSecurityCode"===o,onFocusField:function(){return i("encryptedSecurityCode")},dir:"ltr",name:"encryptedSecurityCode"},JN(wK,{encryptedFieldType:"encryptedSecurityCode","data-info":'{"length":"3-10", "maskInterval": 0}',className:ww({"adyen-checkout__input":!0,"adyen-checkout__input--large":!0,"adyen-checkout__card__cvc__input":!0,"adyen-checkout__input--error":n.errors.encryptedSecurityCode,"adyen-checkout__input--focus":"encryptedSecurityCode"===o})}))};function T$(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}var B$=function(e){TN(r,e);var t=T$(r);function r(){var e,a;Bg(this,r);for(var n=arguments.length,o=new Array(n),i=0;i<n;i++)o[i]=arguments[i];return Wg(RN(a=t.call.apply(t,Bb(e=[this]).call(e,o))),"state",{status:"ready",data:{},balance:null,transactionLimit:null,focusedElement:!1,isValid:!1}),Wg(RN(a),"sfp",void 0),Wg(RN(a),"onChange",(function(e){a.props.onChange({data:e.data,isValid:e.isSfpValid})})),Wg(RN(a),"showValidation",(function(){a.sfp.showValidation()})),Wg(RN(a),"handleFocus",(function(e){a.setState({focusedElement:e.currentFocusObject}),!0===e.focus?a.props.onFocus(e):a.props.onBlur(e)})),Wg(RN(a),"setBalance",(function(e){var t=e.balance,r=e.transactionLimit;a.setState({balance:t,transactionLimit:r})})),a}return qg(r,[{key:"setStatus",value:function(e){this.setState({status:e})}},{key:"render",value:function(e,t){var r,a=this,n=t.focusedElement,o=t.balance,i=t.transactionLimit,l=$w().i18n,c=(null==i?void 0:i.value)<(null==o?void 0:o.value)?i:o,s=(null==c?void 0:c.value)>=(null===(r=this.props.amount)||void 0===r?void 0:r.value);if(c&&s)return JN(F$,FN({balance:o,transactionLimit:i,onSubmit:e.onSubmit},e));var u=function(e){if(e.errors.encryptedCardNumber)return l.get(e.errors.encryptedCardNumber);switch(a.state.status){case"no-balance":return l.get("error.giftcard.no-balance");case"card-error":return l.get("error.giftcard.card-error");case"currency-error":return l.get("error.giftcard.currency-error");default:return null}};return JN("div",{className:"adyen-checkout__giftcard"},"error"===this.state.status&&JN(D$,{icon:"cross"},l.get("error.message.unknown")),JN(oU,FN({},this.props,{ref:function(e){a.sfp=e},onChange:this.onChange,onFocus:this.handleFocus,type:ED,render:function(e,t){var r=e.setRootNode,o=e.setFocusOn;return a.props.fieldsLayoutComponent({i18n:l,pinRequired:a.props.pinRequired,focusedElement:n,getCardErrorMessage:u,setRootNode:r,setFocusOn:o,sfpState:t})}})),this.props.showPayButton&&this.props.payButton({status:this.state.status,onClick:this.props.onBalanceCheck,label:l.get("applyGiftcard")}))}}]),r}($N);function j$(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function z$(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=j$(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=j$(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}function M$(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}Wg(B$,"defaultProps",{pinRequired:!0,expiryDateRequired:!1,onChange:function(){},onFocus:function(){},onBlur:function(){},fieldsLayoutComponent:function(e){var t=e.setRootNode,r=e.pinRequired;return JN("div",{ref:t,className:"adyen-checkout__field-wrapper"},JN(R$,FN({},e,{classNameModifiers:r?["70"]:["100"]})),r&&JN(O$,FN({},e,{classNameModifiers:["30"]})))}});var L$=function(e){TN(r,e);var t=M$(r);function r(){var e,a;Bg(this,r);for(var n=arguments.length,o=new Array(n),i=0;i<n;i++)o[i]=arguments[i];return Wg(RN(a=t.call.apply(t,Bb(e=[this]).call(e,o))),"handleBalanceCheck",(function(e){return a.props.onBalanceCheck?new ok((function(t,r){a.props.onBalanceCheck(t,r,e)})):a.props.session?a.props.session.checkBalance(e):void 0})),Wg(RN(a),"onOrderRequest",(function(e){return a.props.onOrderRequest?new ok((function(t,r){a.props.onOrderRequest(t,r,e)})):a.props.session?a.props.session.createOrder():void 0})),Wg(RN(a),"handleOrder",(function(e){var t=e.order;if(a.updateParent({order:t}),a.props.session&&a.props.onOrderCreated)return a.props.onOrderCreated(t)})),Wg(RN(a),"onBalanceCheck",(function(){return a.props.session||a.props.onBalanceCheck?a.isValid?(a.setStatus("loading"),void a.handleBalanceCheck(a.formatData()).then((function(e){var t,r=e.balance,n=e.transactionLimit,o=void 0===n?{}:n;if(!r)throw new Error("card-error");if((null==r?void 0:r.currency)!==(null===(t=a.props.amount)||void 0===t?void 0:t.currency))throw new Error("currency-error");if((null==r?void 0:r.value)<=0)throw new Error("no-balance");if(a.componentRef.setBalance({balance:r,transactionLimit:o}),a.props.amount.value>r.value||a.props.amount.value>o.value)return a.props.order?a.submit():a.onOrderRequest(a.data).then((function(e){a.setState({order:{orderData:e.orderData,pspReference:e.pspReference}}),a.submit()}));a.props.onRequiringConfirmation&&a.props.onRequiringConfirmation()})).catch((function(e){a.setStatus((null==e?void 0:e.message)||"error"),a.props.onError&&a.handleError(new iA("ERROR",e))}))):(a.showValidation(),!1):a.submit()})),Wg(RN(a),"payButton",(function(e){return JN(oS,e)})),a}return qg(r,[{key:"formatProps",value:function(e){return z$(z$({},null==e?void 0:e.configuration),e)}},{key:"formatData",value:function(){var e,t;return{paymentMethod:{type:this.constructor.type,brand:this.props.brand,encryptedCardNumber:null===(e=this.state.data)||void 0===e?void 0:e.encryptedCardNumber,encryptedSecurityCode:null===(t=this.state.data)||void 0===t?void 0:t.encryptedSecurityCode}}}},{key:"isValid",get:function(){return!!this.state.isValid}},{key:"icon",get:function(){var e;return(null===(e=this.props.brandsConfiguration[this.props.brand])||void 0===e?void 0:e.icon)||this.props.icon||GP({loadingContext:this.props.loadingContext})(this.props.brand)}},{key:"displayName",get:function(){var e;return(null===(e=this.props.brandsConfiguration[this.props.brand])||void 0===e?void 0:e.name)||this.props.name}},{key:"balanceCheck",value:function(){return this.onBalanceCheck()}},{key:"render",value:function(){var e=this;return JN(Uj,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},JN(B$,FN({ref:function(t){e.componentRef=t}},this.props,{onChange:this.setState,onBalanceCheck:this.onBalanceCheck,onSubmit:this.submit,payButton:this.payButton})))}}]),r}(dA);function V$(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}Wg(L$,"type","giftcard"),Wg(L$,"defaultProps",{brandsConfiguration:{}});var U$=function(e){TN(r,e);var t=V$(r);function r(){return Bg(this,r),t.apply(this,arguments)}return qg(r)}(iG);function K$(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function H$(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=K$(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=K$(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}function q$(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}Wg(U$,"type","vipps"),Wg(U$,"defaultProps",{type:U$.type,showPayButton:!0,name:"Vipps"});var W$=function(e){TN(r,e);var t=q$(r);function r(){return Bg(this,r),t.apply(this,arguments)}return qg(r,[{key:"formatProps",value:function(e){return H$(H$({},oD(jN(r.prototype),"formatProps",this).call(this,e)),{},{showImage:!1})}}]),r}(xM);function Y$(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function G$(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=Y$(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=Y$(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}function J$(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}Wg(W$,"type","payu_IN_cashcard");var Q$=function(e){TN(r,e);var t=J$(r);function r(){return Bg(this,r),t.apply(this,arguments)}return qg(r,[{key:"formatProps",value:function(e){return G$(G$({},oD(jN(r.prototype),"formatProps",this).call(this,e)),{},{showImage:!1})}}]),r}(xM);Wg(Q$,"type","payu_IN_nb");var Z$=["AT","CH","DE","NL"];function $$(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function X$(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=$$(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=$$(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}function eX(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}var tX=function(e){TN(r,e);var t=eX(r);function r(){return Bg(this,r),t.apply(this,arguments)}return qg(r,[{key:"formatProps",value:function(e){return X$(X$({},oD(jN(r.prototype),"formatProps",this).call(this,e)),{},{allowedCountries:e.countryCode?[e.countryCode]:Z$})}}]),r}(Wj);function rX(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function aX(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}Wg(tX,"type","ratepay");var nX=function(e){TN(r,e);var t=aX(r);function r(){return Bg(this,r),t.apply(this,arguments)}return qg(r,[{key:"formatProps",value:function(e){return function(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=rX(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=rX(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}({delay:2e3,countdownTime:3,instructions:"swish.pendingMessage"},oD(jN(r.prototype),"formatProps",this).call(this,e))}}]),r}(SZ);Wg(nX,"type","swish");var oX={},iX={get exports(){return oX},set exports(e){oX=e}};ZS("Set",(function(e){return function(){return e(this,arguments.length?arguments[0]:void 0)}}),mx);var lX=ne.Set;!function(e){e.exports=lX}(iX);var cX=t(oX),sX=function(e){var t=e.paymentMethodComponent,r=e.isLoaded;return t&&r?JN("div",{className:"adyen-checkout__payment-method__details__content"},t):null},uX={"adyen-checkout__payment-methods-list":"DropinComponent-module_adyen-checkout__payment-methods-list__mAjAm","adyen-checkout__payment-method":"DropinComponent-module_adyen-checkout__payment-method__nWdwg","adyen-checkout__payment-method__details":"DropinComponent-module_adyen-checkout__payment-method__details__-rsW7","adyen-checkout__payment-method__image":"DropinComponent-module_adyen-checkout__payment-method__image__nB80V","adyen-checkout__payment-method__image__wrapper":"DropinComponent-module_adyen-checkout__payment-method__image__wrapper__6NWzA","adyen-checkout__payment-method--selected":"DropinComponent-module_adyen-checkout__payment-method--selected__6egZF"},dX=["googlepay","paywithgoogle"],pX=function(e){var t=e.src,r=e.altDescription,a=e.type,n=e.disabled,o=void 0!==n&&n;return JN("span",{className:ww("adyen-checkout__payment-method__image__wrapper",uX["adyen-checkout__payment-method__image__wrapper"],{"adyen-checkout__payment-method__image__wrapper--outline":!Eb(dX).call(dX,a),"adyen-checkout__payment-method__image__wrapper--disabled":!!o})},JN(fF,{className:"adyen-checkout__payment-method__image ".concat(uX["adyen-checkout__payment-method__image"]),src:t,alt:r}))},fX=function(e){var t=e.id,r=e.open,a=e.onDisable,n=e.onCancel,o=$w().i18n;return JN("div",{id:t,"aria-hidden":!r,className:ww({"adyen-checkout__payment-method__disable-confirmation":!0,"adyen-checkout__payment-method__disable-confirmation--open":r})},JN("div",{className:"adyen-checkout__payment-method__disable-confirmation__content"},o.get("storedPaymentMethod.disable.confirmation"),JN("div",{className:"adyen-checkout__payment-method__disable-confirmation__buttons"},JN("button",{type:"button",className:ww("adyen-checkout__button","adyen-checkout__payment-method__disable-confirmation__button","adyen-checkout__payment-method__disable-confirmation__button--remove"),disabled:!r,onClick:a},o.get("storedPaymentMethod.disable.confirmButton")),JN("button",{type:"button",className:ww("adyen-checkout__button","adyen-checkout__payment-method__disable-confirmation__button","adyen-checkout__payment-method__disable-confirmation__button--cancel"),disabled:!r,onClick:n},o.get("storedPaymentMethod.disable.cancelButton")))))},mX=function(e){var t=e.allowedBrands;if(e.isPaymentMethodSelected)return null;var r=function(e){var t=e.length<=4?e:OA(e).call(e,0,3);return{visibleBrands:t,leftBrandsAmount:e.length-t.length}}(t),a=r.visibleBrands,n=r.leftBrandsAmount;return JN("span",{className:"adyen-checkout__payment-method__brands"},QC(a).call(a,(function(e){return JN(pX,{key:e.name,altDescription:e.name,type:e.name,src:e.icon})})),0!==n&&JN("span",{className:"adyen-checkout__payment-method__brand-number"},"+",n))},hX=function(e){var t=e.activeBrand,r=e.brands,a=e.excludedUIBrands,n=e.isPaymentMethodSelected,o=e.isCompactView,i=void 0===o||o,l=nb(r).call(r,(function(e){return!(null!=a&&Eb(a).call(a,e.name))}));return i?JN(mX,{allowedBrands:l,isPaymentMethodSelected:n}):JN("span",{className:"adyen-checkout__payment-method__brands"},QC(l).call(l,(function(e){return JN(pX,{key:e.name,altDescription:e.name,type:e.name,src:e.icon,disabled:t&&t!==e.name})})))},vX=function(e){var t=e.displayName,r=e.additionalInfo,a=e.isSelected;return JN("div",{className:"adyen-checkout__payment-method__name_wrapper"},JN("span",{className:ww({"adyen-checkout__payment-method__name":!0,"adyen-checkout__payment-method__name--selected":a})},t),JN("div",{className:ww({"adyen-checkout__payment-method__additional-info":!0,"adyen-checkout__payment-method__additional-info--selected":a})},r))};function yX(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}var gX=function(e){TN(r,e);var t=yX(r);function r(){var e,a;Bg(this,r);for(var n=arguments.length,o=new Array(n),i=0;i<n;i++)o[i]=arguments[i];return Wg(RN(a=t.call.apply(t,Bb(e=[this]).call(e,o))),"state",{showDisableStoredPaymentMethodConfirmation:!1,activeBrand:null}),Wg(RN(a),"toggleDisableConfirmation",(function(){a.setState({showDisableStoredPaymentMethodConfirmation:!a.state.showDisableStoredPaymentMethodConfirmation})})),Wg(RN(a),"onDisableStoredPaymentMethod",(function(){a.props.onDisableStoredPaymentMethod(a.props.paymentMethod),a.toggleDisableConfirmation()})),Wg(RN(a),"handleOnListItemClick",(function(){var e=a.props;(0,e.onSelect)(e.paymentMethod)})),a}return qg(r,[{key:"componentDidMount",value:function(){var e=this;this.props.paymentMethod.eventEmitter.on("brand",(function(t){e.setState({activeBrand:t.brand})}))}},{key:"componentWillUnmount",value:function(){var e=this;this.props.paymentMethod.eventEmitter.off("brand",(function(t){e.setState({activeBrand:t.brand})}))}},{key:"render",value:function(e,t){var r,a,n=e.paymentMethod,o=e.isSelected,i=e.isDisablingPaymentMethod,l=e.isLoaded,c=e.isLoading,s=e.standalone,u=t.activeBrand,d=$w().i18n;if(!n)return null;var p=ww((Wg(a={"adyen-checkout__payment-method":!0},uX["adyen-checkout__payment-method"],!0),Wg(a,"adyen-checkout__payment-method--".concat(n.props.type),!0),Wg(a,"adyen-checkout__payment-method--".concat(null!==(r=n.props.fundingSource)&&void 0!==r?r:"credit"),!0),Wg(a,"adyen-checkout__payment-method--selected",o),Wg(a,uX["adyen-checkout__payment-method--selected"],o),Wg(a,"adyen-checkout__payment-method--loading",c),Wg(a,"adyen-checkout__payment-method--disabling",i),Wg(a,"adyen-checkout__payment-method--confirming",this.state.showDisableStoredPaymentMethodConfirmation),Wg(a,"adyen-checkout__payment-method--standalone",s),Wg(a,uX["adyen-checkout__payment-method--loading"],c),Wg(a,n._id,!0),Wg(a,this.props.className,!0),a)),f=this.props.showRemovePaymentMethodButton&&n.props.oneClick&&o,m="remove-".concat(n._id),h="container-".concat(n._id),v="button-".concat(n._id),y=!n.props.oneClick&&n.brands&&n.brands.length>0;return JN("li",{key:n._id,className:p,onClick:this.handleOnListItemClick},JN("div",{className:"adyen-checkout__payment-method__header"},JN("button",{className:"adyen-checkout__payment-method__header__title",id:v,role:"radio","aria-checked":o,type:"button"},JN("span",{className:ww({"adyen-checkout__payment-method__radio":!0,"adyen-checkout__payment-method__radio--selected":o}),"aria-hidden":"true"}),JN(pX,{altDescription:n.props.name,type:n.type,src:n.icon}),JN(vX,{displayName:n.displayName,isSelected:o,additionalInfo:n.additionalInfo})),f&&JN("button",{type:"button",className:"adyen-checkout__button adyen-checkout__button--inline adyen-checkout__button--link",onClick:this.toggleDisableConfirmation,"aria-expanded":this.state.showDisableStoredPaymentMethodConfirmation,"aria-controls":m},d.get("storedPaymentMethod.disable.button")),y&&JN(hX,{activeBrand:u,brands:n.brands,excludedUIBrands:JD,isPaymentMethodSelected:o,isCompactView:n.props.showBrandsUnderCardNumber})),JN("div",{className:"adyen-checkout__payment-method__details ".concat(uX["adyen-checkout__payment-method__details"]),id:h,role:"region","aria-labelledby":v},f&&JN(fX,{id:m,open:this.state.showDisableStoredPaymentMethodConfirmation,onDisable:this.onDisableStoredPaymentMethod,onCancel:this.toggleDisableConfirmation}),JN(sX,{paymentMethodComponent:n.render(),isLoaded:l})))}}]),r}($N);Wg(gX,"defaultProps",{paymentMethod:null,isSelected:!1,isLoaded:!1,isLoading:!1,showDisableStoredPaymentMethodConfirmation:!1});var bX=function(e){var t,r=e.order,a=e.orderStatus,n=e.onOrderCancel,o=$w(),i=o.loadingContext,l=o.i18n;return JN("div",null,JN("ul",{className:"adyen-checkout__order-payment-methods-list"},null==a||null===(t=a.paymentMethods)||void 0===t?void 0:QC(t).call(t,(function(e,t){var a;return JN("li",{key:Bb(a="".concat(e.type,"-")).call(a,t),className:"adyen-checkout__order-payment-method"},JN("div",{className:"adyen-checkout__order-payment-method__header"},JN("div",{className:"adyen-checkout__payment-method__header__title"},JN(pX,{altDescription:e.name,type:e.type,src:GP({loadingContext:i})(e.type)}),"\u2022\u2022\u2022\u2022 ",e.lastFour),n&&JN("button",{type:"button",className:"adyen-checkout__button adyen-checkout__button--inline adyen-checkout__button--link",onClick:function(){n({order:r})}},l.get("storedPaymentMethod.disable.button"))),JN("div",{className:"adyen-checkout__order-payment-method__details"},JN("div",{className:"adyen-checkout__order-payment-method__deducted-amount"},JN("div",{className:"adyen-checkout__order-payment-method__deducted-amount__label"},l.get("deductedBalance")),JN("div",{className:"adyen-checkout__order-payment-method__deducted-amount__value"},l.amount(e.amount.value,e.amount.currency)))))}))),a.remainingAmount&&JN("div",{className:"adyen-checkout__order-remaining-amount"},l.get("partialPayment.warning")," ",JN("strong",null,l.amount(a.remainingAmount.value,a.remainingAmount.currency))))};function kX(e){var t=e.paymentMethods,r=$w().i18n;return JN(ZN,null,JN("ul",{className:"adyen-checkout__instant-payment-methods-list"},QC(t).call(t,(function(e){return JN("li",{key:e.type},e.render())}))),JN(uM,{label:r.get("orPayWith")}))}function CX(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}var _X=function(e){TN(r,e);var t=CX(r);function r(){return Bg(this,r),t.apply(this,arguments)}return qg(r,[{key:"componentDidMount",value:function(){if(this.props.paymentMethods[0]){var e=this.props.paymentMethods[0];(this.props.openFirstStoredPaymentMethod&&!0===bP(e,"props.oneClick")||this.props.openFirstPaymentMethod)&&this.props.onSelect(e)}}},{key:"render",value:function(e){var t,r=this,a=e.paymentMethods,n=e.instantPaymentMethods,o=e.activePaymentMethod,i=e.cachedPaymentMethods,l=e.isLoading,c=e.isDisablingPaymentMethod,s=$w().i18n,u=ww((Wg(t={},uX["adyen-checkout__payment-methods-list"],!0),Wg(t,"adyen-checkout__payment-methods-list",!0),Wg(t,"adyen-checkout__payment-methods-list--loading",l),t));return JN(ZN,null,this.props.orderStatus&&JN(bX,{order:this.props.order,orderStatus:this.props.orderStatus,onOrderCancel:this.props.onOrderCancel}),!!n.length&&JN(kX,{paymentMethods:n}),JN("ul",{className:u,role:"radiogroup","aria-label":s.get("paymentMethodsList.aria.label"),required:!0},QC(a).call(a,(function(e,t,n){var s=o&&o._id===e._id,u=e._id in i,d=o&&n[t+1]&&o._id===n[t+1]._id;return JN(gX,{className:ww({"adyen-checkout__payment-method--next-selected":d}),standalone:1===a.length,paymentMethod:e,isSelected:s,isDisablingPaymentMethod:s&&c,isLoaded:u,isLoading:l,onSelect:r.props.onSelect,key:e._id,showRemovePaymentMethodButton:r.props.showRemovePaymentMethodButton,onDisableStoredPaymentMethod:r.props.onDisableStoredPaymentMethod})}))))}}]),r}($N);Wg(_X,"defaultProps",{instantPaymentMethods:[],paymentMethods:[],activePaymentMethod:null,cachedPaymentMethods:{},orderStatus:null,onSelect:function(){},onDisableStoredPaymentMethod:function(){},isDisablingPaymentMethod:!1,isLoading:!1});var NX=function(e){var t=e.message,r=$w(),a=r.i18n,n=r.loadingContext;return JN("div",{className:"adyen-checkout__status adyen-checkout__status--success"},JN(fF,{height:"88",className:"adyen-checkout__status__icon",src:GP({loadingContext:n,extension:"gif",imageFolder:"components/"})("success"),alt:a.get(t||"creditCard.success")}),JN("span",{className:"adyen-checkout__status__text"},a.get(t||"creditCard.success")))},PX=function(e){var t=e.message,r=$w(),a=r.loadingContext,n=r.i18n;return JN("div",{className:"adyen-checkout__status adyen-checkout__status--error"},JN(fF,{className:"adyen-checkout__status__icon",src:GP({loadingContext:a,extension:"gif",imageFolder:"components/"})("error"),alt:n.get(t||"error.message.unknown"),height:"88"}),JN("span",{className:"adyen-checkout__status__text"},n.get(t||"error.message.unknown")))};function wX(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function SX(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=wX(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=wX(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}function xX(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}var EX=function(e){TN(r,e);var t=xX(r);function r(){var e,a;Bg(this,r);for(var n=arguments.length,o=new Array(n),i=0;i<n;i++)o[i]=arguments[i];return Wg(RN(a=t.call.apply(t,Bb(e=[this]).call(e,o))),"state",{elements:[],instantPaymentElements:[],orderStatus:null,isDisabling:!1,status:{type:"loading",props:void 0},activePaymentMethod:null,cachedPaymentMethods:{}}),Wg(RN(a),"prepareDropinData",(function(){var e=a.props,t=e.order,r=e.clientKey,n=e.loadingContext,o=tC(a.props.onCreateElements(),3),i=o[0],l=o[1],c=o[2],s=t?function(e,t){return UB({path:"v1/order/status?clientKey=".concat(e.clientKey),loadingContext:e.loadingContext},{orderData:t.orderData})}({clientKey:r,loadingContext:n},t):null;ok.all([i,l,c,s]).then((function(e){var t,r=tC(e,4),n=r[0],o=r[1],i=r[2],l=r[3];a.setState({instantPaymentElements:i,elements:Bb(t=[]).call(t,rC(n),rC(o)),orderStatus:l}),a.setStatus("ready"),a.props.modules.analytics&&a.props.modules.analytics.send({containerWidth:a.base&&a.base.offsetWidth,paymentMethods:QC(o).call(o,(function(e){return e.props.type})),component:"dropin",flavor:"dropin"})})),a.onOrderCancel=a.getOnOrderCancel()})),Wg(RN(a),"setStatus",(function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};a.setState({status:{type:e,props:t}})})),Wg(RN(a),"setActivePaymentMethod",(function(e){a.setState((function(t){return{activePaymentMethod:e,cachedPaymentMethods:SX(SX({},t.cachedPaymentMethods),{},Wg({},e._id,!0))}}))})),Wg(RN(a),"handleOnSelectPaymentMethod",(function(e){var t=a.state.activePaymentMethod;a.setActivePaymentMethod(e),(t&&t._id!==e._id||!t)&&a.props.onSelect(e)})),Wg(RN(a),"handleDisableStoredPaymentMethod",(function(e){a.setState({isDisabling:!0}),new ok((function(t,r){return a.props.onDisableStoredPaymentMethod(e.props.storedPaymentMethodId,t,r)})).then((function(){a.setState((function(t){var r;return{elements:nb(r=t.elements).call(r,(function(t){return t._id!==e._id}))}})),a.setState({isDisabling:!1})})).catch((function(){a.setState({isDisabling:!1})}))})),Wg(RN(a),"getOnOrderCancel",(function(){return a.props.onOrderCancel?function(e){a.props.onOrderCancel(e)}:a.props.session?function(e){return a.props.session.cancelOrder(e).then((function(){return a.props._parentInstance.update({order:null})})).catch((function(e){return a.setStatus((null==e?void 0:e.message)||"error")}))}:null})),Wg(RN(a),"onOrderCancel",void 0),a}return qg(r,[{key:"componentDidMount",value:function(){this.prepareDropinData()}},{key:"componentDidUpdate",value:function(e,t){t.status.type!==this.state.status.type&&this.state.activePaymentMethod&&this.state.activePaymentMethod.setStatus(this.state.status.type),"ready"===this.state.status.type&&"ready"!==t.status.type&&this.props.onReady&&this.props.onReady()}},{key:"closeActivePaymentMethod",value:function(){this.setState({activePaymentMethod:null})}},{key:"render",value:function(e,t){var r,a,n,o,i=t.elements,l=t.instantPaymentElements,c=t.status,s=t.activePaymentMethod,u=t.cachedPaymentMethods,d="loading"===c.type,p="redirect"===c.type;switch(c.type){case"success":return JN(NX,{message:null===(r=c.props)||void 0===r?void 0:r.message});case"error":return JN(PX,{message:null===(a=c.props)||void 0===a?void 0:a.message});case"custom":return null===(n=c.props)||void 0===n||null===(o=n.component)||void 0===o?void 0:o.render();default:return JN("div",{className:"adyen-checkout__dropin adyen-checkout__dropin--".concat(c.type)},p&&c.props.component&&c.props.component.render(),d&&c.props&&c.props.component&&c.props.component.render(),i&&!!i.length&&JN(_X,{isLoading:d||p,isDisablingPaymentMethod:this.state.isDisabling,paymentMethods:i,instantPaymentMethods:l,activePaymentMethod:s,cachedPaymentMethods:u,order:this.props.order,orderStatus:this.state.orderStatus,onOrderCancel:this.onOrderCancel,onSelect:this.handleOnSelectPaymentMethod,openFirstPaymentMethod:this.props.openFirstPaymentMethod,openFirstStoredPaymentMethod:this.props.openFirstStoredPaymentMethod,onDisableStoredPaymentMethod:this.handleDisableStoredPaymentMethod,showRemovePaymentMethodButton:this.props.showRemovePaymentMethodButton}))}}}]),r}($N);var AX=["androidpay","samsungpay"],DX=function(e){return!Eb(AX).call(AX,e.constructor.type)},IX=function(e){return!!e},FX=function(e){if(e.isAvailable){var t=new ok((function(e,t){return hw(t,5e3)}));return ok.race([e.isAvailable(),t])}return ok.resolve(!!e)},RX=function(){var e,t,r,a=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],n=arguments.length>1?arguments[1]:void 0,o=arguments.length>2?arguments[2]:void 0,i=nb(e=nb(t=QC(a).call(a,(function(e){return o(e,n)}))).call(t,IX)).call(e,DX),l=QC(r=QC(i).call(i,FX)).call(r,(function(e){return e.catch((function(e){return e}))}));return ok.all(l).then((function(e){return nb(i).call(i,(function(t,r){return!0===e[r]}))}))};function OX(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function TX(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=OX(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=OX(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}function BX(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function jX(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=BX(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=BX(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}function zX(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function MX(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=zX(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=zX(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}function LX(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}var VX=["paywithgoogle","googlepay","applepay"],UX=function(e){TN(r,e);var t=LX(r);function r(e){var a,n,o;return Bg(this,r),Wg(RN(o=t.call(this,e)),"dropinRef",null),Wg(RN(o),"componentFromAction",void 0),Wg(RN(o),"handleCreate",(function(){var e=o.props,t=e.paymentMethods,r=e.storedPaymentMethods,a=e.showStoredPaymentMethods,n=e.showPaymentMethods,i=e.instantPaymentMethods,l=function(e){return{beforeSubmit:e.beforeSubmit,onSubmit:e.onSubmit,elementRef:e.elementRef,showPayButton:e.showPayButton,isDropin:!0}}(MX(MX({},o.props),{},{elementRef:o.elementRef})),c=a?function(){var e=arguments.length>2?arguments[2]:void 0;return RX(arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],TX(TX({},arguments.length>1?arguments[1]:void 0),{},{oneClick:!0}),e)}(r,l,o._parentInstance.create):[],s=n?RX(t,l,o._parentInstance.create):[],u=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],t=arguments.length>1?arguments[1]:void 0,r=arguments.length>2?arguments[2]:void 0;return e.length?RX(e,jX(jX({},t),{},{isInstantPayment:!0,showPayButton:!0}),r):[]}(i,l,o._parentInstance.create);return[c,s,u]})),Wg(RN(o),"handleOrder",(function(e){var t=e.order;o.updateParent({order:t})})),o.submit=rk(a=o.submit).call(a,RN(o)),o.handleAction=rk(n=o.handleAction).call(n,RN(o)),o}return qg(r,[{key:"formatProps",value:function(e){var t,a,n=nb(t=hW(new cX(e.instantPaymentTypes))).call(t,(function(e){return Eb(VX).call(VX,e)})),o=DC(n).call(n,(function(t,r){var a,n,o=yk(a=e.paymentMethods).call(a,(function(e){return e.type===r}));return o?Bb(n=[]).call(n,rC(t),[o]):t}),[]),i=nb(a=e.paymentMethods).call(a,(function(e){var t=e.type;return!Eb(n).call(n,t)}));return MX(MX({},oD(jN(r.prototype),"formatProps",this).call(this,e)),{},{instantPaymentTypes:n,instantPaymentMethods:o,paymentMethods:i})}},{key:"isValid",get:function(){return!!this.dropinRef&&!!this.dropinRef.state.activePaymentMethod&&!!this.dropinRef.state.activePaymentMethod.isValid}},{key:"showValidation",value:function(){return this.dropinRef.state.activePaymentMethod&&this.dropinRef.state.activePaymentMethod.showValidation(),this}},{key:"setStatus",value:function(e){var t,r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};return null===(t=this.dropinRef)||void 0===t||t.setStatus(e,r),this}},{key:"activePaymentMethod",get:function(){var e,t;return null!==(e=this.dropinRef)&&void 0!==e&&e.state||null!==(t=this.dropinRef)&&void 0!==t&&t.state.activePaymentMethod?this.dropinRef.state.activePaymentMethod:null}},{key:"data",get:function(){return this.activePaymentMethod?this.dropinRef.state.activePaymentMethod.data:null}},{key:"submit",value:function(){if(!this.activePaymentMethod)throw new Error("No active payment method.");this.activePaymentMethod.submit()}},{key:"handleAction",value:function(e){var t,a,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};if(!e||!e.type){if(lA(e,"action")&&lA(e,"resultCode"))throw new Error('handleAction::Invalid Action - the passed action object itself has an "action" property and a "resultCode": have you passed in the whole response object by mistake?');throw new Error('handleAction::Invalid Action - the passed action object does not have a "type" property')}if("redirect"!==e.type&&null!==(t=this.activePaymentMethod)&&void 0!==t&&t.updateWithAction)return this.activePaymentMethod.updateWithAction(e);this.elementRef instanceof r&&(n=MX(MX({},null===(a=this.elementRef.activePaymentMethod)||void 0===a?void 0:a.props),n));var o=this._parentInstance.createFromAction(e,MX(MX({},n),{},{elementRef:this.elementRef,onAdditionalDetails:this.handleAdditionalDetails,isDropin:!0}));return o?(this.setStatus(o.props.statusType,{component:o}),this.componentFromAction=o,this):null}},{key:"closeActivePaymentMethod",value:function(){this.dropinRef.closeActivePaymentMethod()}},{key:"render",value:function(){var e=this;return JN(Uj,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},JN(EX,FN({},this.props,{onChange:this.setState,elementRef:this.elementRef,onCreateElements:this.handleCreate,ref:function(t){e.dropinRef=t}})))}}]),r}(dA);Wg(UX,"type","dropin"),Wg(UX,"defaultProps",{isDropin:!0,onReady:function(){},onComplete:function(){},onCancel:function(){},onError:function(){},onSelect:function(){},onDisableStoredPaymentMethod:null,onChange:function(){},instantPaymentMethods:[],amount:{},installmentOptions:{},paymentMethodsConfiguration:{},openFirstPaymentMethod:!0,openFirstStoredPaymentMethod:!0,showStoredPaymentMethods:!0,showPaymentMethods:!0,showRemoveStoredPaymentMethodButton:!1,showPayButton:!0});var KX={"sf-input__wrapper":"AchInput-module_sf-input__wrapper__lfdiv","adyen-checkout__input":"AchInput-module_adyen-checkout__input__8WwCR"},HX=function(e){var t,r=e.id,a=e.dataInfo,n=e.className,o=void 0===n?"":n,i=e.label,l=e.focused,c=e.filled,s=e.errorMessage,u=void 0===s?"":s,d=e.isValid,p=void 0!==d&&d,f=e.onFocusField,m=e.dir,h=r.charAt(0).toUpperCase()+OA(r).call(r,1),v="encrypted".concat(h);return JN(kI,{label:i,focused:l,filled:c,classNameModifiers:[r],onFocusField:function(){return f(v)},errorMessage:u,isValid:p,className:o,dir:m,name:r},JN(wK,{encryptedFieldType:v,"data-info":a,className:ww((t={"adyen-checkout__input":!0,"adyen-checkout__input--large":!0},Wg(t,KX["adyen-checkout__input"],!0),Wg(t,"adyen-checkout__input--error",u.length),Wg(t,"adyen-checkout__input--focus",l),Wg(t,"adyen-checkout__input--valid",p),t))}))},qX=function(e){var t=e.focusedElement,r=e.onFocusField,a=e.errors,n=e.valid,o=$w().i18n;return JN("div",{className:"adyen-checkout__ach-sf__form adyen-checkout__field-wrapper"},JN(HX,{id:"bankAccountNumber",focused:"encryptedBankAccountNumber"===t,isValid:!!n.encryptedBankAccountNumber,label:o.get("ach.accountNumberField.title"),onFocusField:r,filled:!!a.encryptedBankAccountNumber||!!n.encryptedBankAccountNumber,errorMessage:!!a.encryptedBankAccountNumber&&o.get(a.encryptedBankAccountNumber),dataInfo:'{"length":"4-17"}',className:"adyen-checkout__field--50",dir:"ltr"}),JN(HX,{id:"bankLocationId",focused:"encryptedBankLocationId"===t,isValid:!!n.encryptedBankLocationId,label:o.get("ach.accountLocationField.title"),onFocusField:r,filled:!!a.encryptedBankLocationId||!!n.encryptedBankLocationId,errorMessage:!!a.encryptedBankLocationId&&o.get(a.encryptedBankLocationId),dataInfo:'{"length":9}',className:"adyen-checkout__field--50",dir:"ltr"}))},WX={base:{caretColor:"#0075FF"}};function YX(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function GX(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=YX(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=YX(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}function JX(e){return!(arguments.length>1&&void 0!==arguments[1]&&arguments[1])||!!e&&"string"==typeof e&&OI(e).call(e).length>0}function QX(e){var t,r=this,a=$w().i18n,n=e.hasHolderName&&(!!e.holderName||!!e.data.holderName),o=tC(Bw({}),2),i=o[0],l=o[1],c=tC(Bw(GX({},e.holderNameRequired&&{holderName:n})),2),s=c[0],u=c[1],d=tC(Bw(GX({},e.hasHolderName&&{holderName:e.holderName||e.data.holderName})),2),p=d[0],f=d[1],m=tC(Bw(e.billingAddressRequired?e.data.billingAddress:null),2),h=m[0],v=m[1],y=tC(Bw(!1),2),g=y[0],b=y[1],k=tC(Bw(""),2),C=k[0],_=k[1],N=tC(Bw(!1),2),P=N[0],w=N[1],S=function(e){v(GX(GX({},h),e.data)),u(GX(GX({},s),{},{billingAddress:e.isValid}))},x=function(t){var r=t.target.value;f(GX(GX({},p),{},{holderName:r})),l(GX(GX({},i),{},{holderName:!!e.holderNameRequired&&!JX(r)})),u(GX(GX({},s),{},{holderName:!e.holderNameRequired||JX(r,e.holderNameRequired)}))},E=Lw(null),A=Lw(null),D=function(e){A.current=e},I=tC(Bw("ready"),2),F=I[0],R=I[1],O=Lw({});Jy(O.current).length||(null===(t=e.setComponentRef)||void 0===t||t.call(e,O.current));return O.current.showValidation=function(){E.current.showValidation(),e.holderNameRequired&&!s.holderName&&l(GX(GX({},i),{},{holderName:!0})),A.current&&A.current.showValidation()},O.current.setStatus=R,zw((function(){return r.setFocusOn=E.current.setFocusOn,r.updateStyles=E.current.updateStyles,function(){E.current.destroy()}}),[]),zw((function(){var t=JX(p.holderName,e.holderNameRequired),r=g,a=!e.billingAddressRequired||Boolean(s.billingAddress),n=r&&t&&a;e.onChange({data:p,isValid:n,billingAddress:h,storePaymentMethod:P})}),[p,s,i,P]),JN("div",{className:"adyen-checkout__ach"},JN(oU,FN({ref:E},ZX(e),{styles:GX(GX({},WX),e.styles),onChange:function(t){var r=t,a=r.autoCompleteName?r.autoCompleteName:p.holderName;f(GX(GX(GX({},p),r.data),{},{holderName:a})),l(GX(GX({},i),r.errors)),u(GX(GX(GX({},s),r.valid),{},{holderName:!e.holderNameRequired||JX(a,e.holderNameRequired)})),b(r.isSfpValid)},onFocus:function(t){var r=!0===t.focus;_(t.currentFocusObject),r?e.onFocus(t):e.onBlur(t)},render:function(t,r){var n=t.setRootNode,o=t.setFocusOn;return JN("div",{ref:n,className:"adyen-checkout__ach-input ".concat(KX["sf-input__wrapper"])},JN(_K,{status:r.status},JN("div",{className:ww(["adyen-checkout__fieldset","adyen-checkout__fieldset--ach"])},JN("div",{className:"adyen-checkout__fieldset__title"},a.get("ach.bankAccount")),e.hasHolderName&&JN(kI,{label:a.get("ach.accountHolderNameField.title"),className:"adyen-checkout__pm__holderName",errorMessage:!!i.holderName&&a.get("ach.accountHolderNameField.invalid"),isValid:!!s.holderName,name:"holderName"},NF("text",{className:"adyen-checkout__pm__holderName__input ".concat(KX["adyen-checkout__input"]),placeholder:e.placeholders.holderName||a.get("ach.accountHolderNameField.placeholder"),value:p.holderName,required:e.holderNameRequired,onInput:x})),JN(qX,{focusedElement:C,onFocusField:o,errors:r.errors,valid:r.valid})),e.billingAddressRequired&&JN(vj,{label:"billingAddress",data:h,onChange:S,allowedCountries:e.billingAddressAllowedCountries,requiredFields:e.billingAddressRequiredFields,setComponentRef:D}),e.enableStoreDetails&&JN($q,{onChange:w})))}})),e.showPayButton&&e.payButton({status:F,label:a.get("confirmPurchase")}))}QX.defaultProps={type:"ach",hasHolderName:!0,holderNameRequired:!0,billingAddressRequired:!0,billingAddressAllowedCountries:["US","PR"],onLoad:function(){},onConfigSuccess:function(){},onAllValid:function(){},onFieldValid:function(){},onError:function(){},onBlur:function(){},onFocus:function(){},onChange:function(){},holderName:"",data:{holderName:"",billingAddress:{}},styles:{},placeholders:{}};var ZX=function(e){return{allowedDOMAccess:e.allowedDOMAccess,autoFocus:e.autoFocus,clientKey:e.clientKey,i18n:e.i18n,keypadFix:e.keypadFix,legacyInputMode:e.legacyInputMode,loadingContext:e.loadingContext,onAllValid:e.onAllValid,onConfigSuccess:e.onConfigSuccess,onError:e.onError,onFieldValid:e.onFieldValid,onFocus:e.onFocus,onLoad:e.onLoad,showWarnings:e.showWarnings,styles:e.styles,type:e.type,forceCompat:e.forceCompat}};function $X(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function XX(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=$X(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=$X(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}function e0(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}var t0=function(e){TN(r,e);var t=e0(r);function r(){return Bg(this,r),t.apply(this,arguments)}return qg(r,[{key:"formatProps",value:function(e){var t;return XX(XX({},e),{},{holderNameRequired:null!==(t=e.hasHolderName)&&void 0!==t?t:e.holderNameRequired})}},{key:"formatData",value:function(){var e,t=!!this.props.storedPaymentMethodId,a=XX(XX({type:r.type},this.state.data),{},{ownerName:null===(e=this.state.data)||void 0===e?void 0:e.holderName},t&&{storedPaymentMethodId:this.props.storedPaymentMethodId});return delete a.holderName,XX(XX({paymentMethod:a},this.state.billingAddress&&{billingAddress:this.state.billingAddress}),this.state.storePaymentMethod&&{storePaymentMethod:this.state.storePaymentMethod})}},{key:"updateStyles",value:function(e){return this.componentRef&&this.componentRef.updateStyles&&this.componentRef.updateStyles(e),this}},{key:"setFocusOn",value:function(e){return this.componentRef&&this.componentRef.setFocusOn&&this.componentRef.setFocusOn(e),this}},{key:"isValid",get:function(){return!!this.props.storedPaymentMethodId||!!this.state.isValid}},{key:"displayName",get:function(){var e;return this.props.storedPaymentMethodId&&this.props.bankAccountNumber?"\u2022\u2022\u2022\u2022 ".concat(OA(e=this.props.bankAccountNumber).call(e,-4)):this.props.name}},{key:"additionalInfo",get:function(){return this.props.storedPaymentMethodId?this.props.i18n.get("ach.savedBankAccount"):""}},{key:"render",value:function(){var e=this;return JN(Uj,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},this.props.storedPaymentMethodId?JN(NM,{name:this.displayName,amount:this.props.amount,payButton:this.payButton,onSubmit:this.submit,ref:function(t){e.componentRef=t}}):JN(QX,FN({setComponentRef:this.setComponentRef},this.props,{onChange:this.setState,onSubmit:this.submit,payButton:this.payButton})))}}]),r}(dA);Wg(t0,"type","ach");var r0=/\b(2\d{1}|(9(3|6|2|1)))\d{7}\b/,a0=/^(\d){4,}$/,n0={phoneNumber:{modes:["blur"],validate:function(e,t){var r="+351"===t.state.data.phonePrefix?r0:a0;return WR(e)?null:r.test(e)},errorMessage:"invalidPhoneNumber"},phonePrefix:{modes:["blur"],validate:function(e){return!!e},errorMessage:"invalidCountryCode"}},o0={phoneNumber:{formatterFn:function(e){return e.replace(GR("^\\d","g"),"")}}};function i0(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function l0(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=i0(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=i0(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}function c0(e){var t,r,a,n,o,i,l=$w(),c=l.i18n,s=l.commonProps.isCollatingErrors,u=e.requiredFields||Bb(t=[]).call(t,rC(null!=e&&null!==(r=e.items)&&void 0!==r&&r.length?["phonePrefix"]:[]),["phoneNumber"]),d=Eb(u).call(u,"phonePrefix")&&!(null==e||null===(a=e.items)||void 0===a||!a.length),p=Eb(u).call(u,"phoneNumber"),f=QF(l0(l0({i18n:c},e),{},{schema:u,defaultData:e.data,rules:n0,formatters:o0})),m=f.handleChangeFor,h=f.data,v=f.valid,y=f.errors,g=f.isValid,b=f.triggerValidation,k=f.setSchema;zw((function(){k(u)}),[u.toString()]),zw((function(){h.phoneNumber&&m("phoneNumber","blur")(h.phoneNumber)}),[h.phonePrefix]),zw((function(){e.onChange({data:h,valid:v,errors:y,isValid:g})}),[h,v,y,g]),this.triggerValidation=b;var C=function(){var e=document.querySelector(".adyen-checkout-phone-input--new [uniqueid]");return e?e.getAttribute("uniqueid"):null},_=Uw((function(t){if(y[t]){var r="phoneNumber"===t?"phoneNumberErrorKey":"phonePrefixErrorKey",a=e[r]?e[r]:y[t].errorMessage,n=c.get(a);return n||null}return null}),[y]),N=Vw((function(){return gI("adyen-checkout-phonePrefix")}),[]);return JN("div",{className:"adyen-checkout-phone-input--new"},JN(kI,{name:"phoneNumber",label:e.phoneNumberKey?c.get(e.phoneNumberKey):c.get("telephoneNumber"),className:ww({"adyen-checkout-field":!0,"adyen-checkout-field--phone-input":!0}),inputWrapperModifiers:["phone-input"],isValid:v.phoneNumber,errorMessage:(y.phoneNumber||y.phonePrefix)&&!0,showValidIcon:!y.phonePrefix},JN("div",{className:ww({"adyen-checkout__input":!0,"adyen-checkout__input--invalid":!!y.phoneNumber||!!y.phonePrefix,"adyen-checkout__input--valid":(!d||v.phonePrefix)&&v.phoneNumber,"adyen-checkout-input":!0,"adyen-checkout-input-holder--phone-input":!0})},d&&NF("select",{className:"adyen-checkout-dropdown adyen-checkout-dropdown--countrycode-selector",items:e.items,onChange:m("phonePrefix"),placeholder:c.get("infix"),selected:h.phonePrefix,isCollatingErrors:s,uniqueId:N}),p&&JN("div",{className:"adyen-checkout-phone-number"},JN("input",{id:C(),type:"tel",value:h.phoneNumber,onInput:m("phoneNumber","input"),onBlur:m("phoneNumber","blur"),placeholder:e.placeholders.phoneNumber||"123456789",className:"adyen-checkout__input adyen-checkout-input adyen-checkout-input--phone-number",autoCorrect:"off","aria-required":!0,"aria-label":e.phoneNumberKey?c.get(e.phoneNumberKey):c.get("telephoneNumber"),"aria-invalid":!v.phoneNumber,"aria-describedby":Bb(n="".concat(C())).call(n,QD)})))),!s&&JN("div",{className:"adyen-checkout-phone-input__error-holder"},d&&_("phonePrefix")&&JN("span",{className:"adyen-checkout__error-text","aria-live":"polite",id:Bb(o="".concat(N)).call(o,QD)},_("phonePrefix")),p&&_("phoneNumber")&&JN("span",{className:"adyen-checkout__error-text","aria-live":"polite",id:Bb(i="".concat(C())).call(i,QD)},_("phoneNumber"))))}function s0(e){var t,r=$w(),a=r.i18n,n=r.loadingContext,o=Lw(null),i=e.allowedCountries,l=void 0===i?[]:i,c=tC(Bw("ready"),2),s=c[0],u=c[1];this.setStatus=u,this.showValidation=null==o||null===(t=o.current)||void 0===t?void 0:t.triggerValidation;var d=function(e){var t=e.allowedCountries,r=e.loadingContext,a=e.handleError,n=tC(Bw("loading"),2),o=n[0],i=n[1],l=tC(Bw([]),2),c=l[0],s=l[1];return Mw((function(){KB("phonenumbers",r).then((function(e){var r=t.length?nb(e).call(e,(function(e){return Eb(t).call(t,e.id)})):e,a=QC(r).call(r,(function(e){var t,r,a,n,o=QC(t=e.id.toUpperCase().split("")).call(t,(function(e){return 127397+e.charCodeAt(0)})),i=YJ?YJ.apply(String,rC(o))+"\xa0\xa0":"";return{id:e.prefix,name:Bb(r=Bb(a="".concat(i," ")).call(a,e.prefix," (")).call(r,e.id,")"),selectedOptionName:Bb(n="".concat(i," ")).call(n,e.prefix)}}));s(a||[]),i("ready")})).catch((function(e){s([]),i("ready"),null==a||a(new iA("ERROR",e))}))}),[]),{phonePrefixes:c,loadingStatus:o}}({allowedCountries:l,loadingContext:n,handleError:e.onError}),p=d.loadingStatus,f=d.phonePrefixes;return JN(_K,{status:p},JN("div",{className:"adyen-checkout__mb-way"},JN(c0,FN({},e,{items:f,ref:o,onChange:function(t){var r=t.data,a=t.valid,n=t.errors,o=t.isValid;e.onChange({data:r,valid:a,errors:n,isValid:o})},data:e.data})),e.showPayButton&&e.payButton({status:s,label:a.get("confirmPurchase")})))}c0.defaultProps={phoneLabel:"telephoneNumber"},s0.defaultProps={onChange:function(){},phoneNumberKey:"mobileNumber",phoneNumberErrorKey:"mobileNumber.invalid"};var u0=2e3,d0=15,p0=6e4,f0=1e4,m0="mbway",h0="mbway.confirmPayment",v0="await.waitForConfirmation",y0=!1,g0=["message"];function b0(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function k0(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=b0(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=b0(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}function C0(e){var t,r=this,a=$w(),n=a.i18n,o=a.loadingContext,i=tC(Bw(!1),2),l=i[0],c=i[1],s=tC(Bw(!1),2),u=s[0],d=s[1],p=tC(Bw(!0),2),f=p[0],m=p[1],h=tC(Bw(!1),2),v=h[0],y=h[1],g=tC(Bw(e.delay),2),b=g[0],k=g[1],C=tC(Bw(100),2),_=C[0],N=C[1],P=tC(Bw(0),2),w=P[0],S=P[1],x=tC(Bw(!1),2),E=x[0],A=x[1],D=tC(Bw(null),2),I=D[0],F=D[1],R=function(){var t=e.paymentData,a=e.clientKey;v||(e.onActionHandled({componentType:e.type,actionDescription:"polling-started"}),y(!0)),vZ(t,a,o).then(kZ).catch((function(e){var t=e.message,r=KP(e,g0);return{type:"network-error",props:k0(k0({},t&&{message:n.get(t)}),r)}})).then((function(t){switch(t.type){case"success":!function(t){if(t.props.payload){c(!0);var a={data:{details:{payload:t.props.payload},paymentData:e.paymentData}};return e.onComplete(a,r)}d(!0),e.onError(new iA("ERROR","successful result, but no payload in response"))}(t);break;case"error":!function(t){if(d(!0),t.props.payload){var a={data:{details:{payload:t.props.payload},paymentData:e.paymentData}};return e.onComplete(a,r)}e.onError(new iA("ERROR","error result with no payload in response"))}(t);break;default:m(!1)}}))};zw((function(){return R(),function(){clearTimeout(I)}}),[]),zw((function(){if(u)return clearTimeout(I);if(l)return clearTimeout(I);if(!f){F(hw((function(){R();var t=w+b;S(t),t>=e.throttleTime&&!E&&(k(e.throttleInterval),A(!0))}),b))}}),[f,u,l,w]);var O=function(e,t){return JN("div",{className:"adyen-checkout__await adyen-checkout__await--result"},JN("img",{className:"adyen-checkout__await__icon adyen-checkout__await__icon--result",src:GP({loadingContext:o,imageFolder:"components/"})(e),alt:n.get(t)}),JN("div",{className:"adyen-checkout__await__subtitle adyen-checkout__await__subtitle--result"},n.get(t)))};if(u)return O("error","error.subtitle.payment");if(l)return O("success","creditCard.success");if(f)return JN("div",{className:"adyen-checkout__await"},e.brandLogo&&JN("img",{src:e.brandLogo,alt:e.type,className:"adyen-checkout__await__brand-logo"}),JN(Sw,{inline:!1,size:"large"}));var T=n.get("wechatpay.timetopay").split("%@");return JN("div",{className:ww("adyen-checkout__await","adyen-checkout__await--".concat(e.type),QC(t=e.classNameModifiers).call(t,(function(e){return"adyen-checkout__await--".concat(e)})))},e.brandLogo&&JN("img",{src:e.brandLogo,alt:e.type,className:"adyen-checkout__await__brand-logo"}),JN("div",{className:"adyen-checkout__await__subtitle"},e.messageText),JN("div",{className:"adyen-checkout__await__indicator-holder"},JN("div",{className:"adyen-checkout__await__indicator-spinner"},JN(Sw,{inline:!1,size:"medium"})),JN("div",{className:"adyen-checkout__await__indicator-text"},e.awaitText)),e.showCountdownTimer&&JN("div",{className:"adyen-checkout__await__countdown-holder"},JN("div",{className:"adyen-checkout__await__progress"},JN("span",{className:"adyen-checkout__await__percentage",style:{width:"".concat(_,"%")}})),JN("div",{className:"adyen-checkout__await__countdown"},T[0],"\xa0",JN(hZ,{minutesFromNow:e.countdownTime,onTick:function(e){N(e.percentage)},onCompleted:function(){d(!0),clearTimeout(I),e.onError(new iA("ERROR","Payment Expired"))}}),"\xa0",T[1])),e.url&&JN("div",{className:"adyen-checkout__await__app-link"},JN(uM,null),JN(eS,{classNameModifiers:["await"],onClick:function(){return function(e){window.location.assign(e)}(e.url)},label:n.get("openApp")})))}function _0(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function N0(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=_0(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=_0(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}function P0(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}C0.defaultProps={countdownTime:15,onError:function(){},onComplete:function(){},onActionHandled:function(){},delay:2e3,throttleTime:6e4,throttleInterval:1e4,showCountdownTimer:!0,classNameModifiers:[],url:null};var w0=function(e){TN(r,e);var t=P0(r);function r(){return Bg(this,r),t.apply(this,arguments)}return qg(r,[{key:"formatProps",value:function(e){var t=e.data,r=void 0===t?{}:t,a=e.placeholders,n=void 0===a?{}:a;return N0(N0({},e),{},{data:{phoneNumber:r.telephoneNumber||r.phoneNumber,phonePrefix:r.phonePrefix||"+351"},placeholders:{phoneNumber:n.telephoneNumber||n.phoneNumber||"932123456"}})}},{key:"formatData",value:function(){var e;return{paymentMethod:N0({type:r.type},(null===(e=this.state.data)||void 0===e?void 0:e.phoneNumber)&&{telephoneNumber:this.state.data.phonePrefix+this.state.data.phoneNumber})}}},{key:"isValid",get:function(){return!!this.state.isValid}},{key:"displayName",get:function(){return this.props.name}},{key:"render",value:function(){var e=this;return this.props.paymentData?JN(Uj,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},JN(C0,{ref:function(t){e.componentRef=t},clientKey:this.props.clientKey,paymentData:this.props.paymentData,onError:this.props.onError,onComplete:this.onComplete,brandLogo:this.icon,type:m0,messageText:this.props.i18n.get(h0),awaitText:this.props.i18n.get(v0),showCountdownTimer:y0,delay:u0,countdownTime:d0,throttleTime:p0,throttleInterval:f0,onActionHandled:this.props.onActionHandled})):JN(Uj,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},JN(s0,FN({ref:function(t){e.componentRef=t}},this.props,{onChange:this.setState,onSubmit:this.submit,payButton:this.payButton})))}}]),r}(dA);Wg(w0,"type","mbway");var S0=function(e){return e.replace(/[^0-9]/g,"")};function x0(e){var t=this,r=$w(),a=r.i18n,n=r.loadingContext,o=QF({schema:["blikCode"],rules:{blikCode:{validate:function(e){return 6===(null==e?void 0:e.length)},errorMessage:"blik.invalid",modes:["blur"]}},formatters:{blikCode:S0}}),i=o.handleChangeFor,l=o.triggerValidation,c=o.data,s=o.valid,u=o.errors,d=o.isValid;zw((function(){e.onChange({data:c,errors:u,valid:s,isValid:d},t)}),[c,s,u,d]);var p=tC(Bw("ready"),2),f=p[0],m=p[1];return this.setStatus=m,this.showValidation=l,JN("div",{className:"adyen-checkout__blik"},JN("p",{className:"adyen-checkout__blik__helper"},a.get("blik.help")),JN(kI,{errorMessage:!!u.blikCode&&a.get(u.blikCode.errorMessage),label:a.get("blik.code"),classNameModifiers:["blikCode","50"],isValid:s.blikCode,dir:"ltr"},NF("text",{value:c.blikCode,name:"blikCode",spellcheck:!1,required:!0,autocorrect:"off",onInput:i("blikCode","input"),onBlur:i("blikCode","blur"),placeholder:"123456",inputMode:"numeric",maxLength:6})),e.showPayButton&&e.payButton({status:f,icon:GP({loadingContext:n,imageFolder:"components/"})("lock")}))}x0.defaultProps={data:{blikCode:""}};var E0=2e3,A0=15,D0=6e4,I0=1e4,F0="blik",R0="blik.confirmPayment",O0="await.waitForConfirmation",T0=!1;function B0(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function j0(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=B0(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=B0(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}function z0(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}var M0=function(e){TN(r,e);var t=z0(r);function r(){return Bg(this,r),t.apply(this,arguments)}return qg(r,[{key:"formatData",value:function(){var e,t,a=!!this.props.storedPaymentMethodId;return{paymentMethod:j0(j0({type:r.type},!a&&{blikCode:null===(e=this.state)||void 0===e||null===(t=e.data)||void 0===t?void 0:t.blikCode}),a&&{storedPaymentMethodId:this.props.storedPaymentMethodId})}}},{key:"isValid",get:function(){return!!this.props.storedPaymentMethodId||!!this.state.isValid}},{key:"render",value:function(){var e=this;return this.props.paymentData?JN(Uj,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},JN(C0,{ref:function(t){e.componentRef=t},clientKey:this.props.clientKey,paymentData:this.props.paymentData,onError:this.handleError,onComplete:this.onComplete,brandLogo:this.icon,type:F0,messageText:this.props.i18n.get(R0),awaitText:this.props.i18n.get(O0),showCountdownTimer:T0,delay:E0,countdownTime:A0,throttleTime:D0,throttleInterval:I0,onActionHandled:this.props.onActionHandled})):JN(Uj,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},this.props.storedPaymentMethodId?JN(NM,{name:this.displayName,amount:this.props.amount,payButton:this.payButton,onSubmit:this.submit,ref:function(t){e.componentRef=t}}):JN(x0,FN({ref:function(t){e.componentRef=t}},this.props,{onChange:this.setState,onSubmit:this.submit,payButton:this.payButton})))}}]),r}(dA);function L0(e){var t=e.reference,r=e.totalAmount,a=e.paymentMethodType,n=$w(),o=n.loadingContext,i=n.i18n;return JN(OG,{paymentMethodType:a,introduction:i.get("bankTransfer.instructions"),imageUrl:GP({loadingContext:o})(a),amount:r&&i.amount(r.value,r.currency),voucherDetails:[{label:i.get("bankTransfer.beneficiary"),value:e.beneficiary},{label:i.get("bankTransfer.iban"),value:e.iban},{label:i.get("bankTransfer.bic"),value:e.bic},{label:i.get("bankTransfer.reference"),value:t}]})}function V0(e){var t=$w().i18n,r=tC(Bw(!1),2),a=r[0],n=r[1],o=QF({schema:[],defaultData:e.data,rules:{shopperEmail:tR.shopperEmail}}),i=o.handleChangeFor,l=o.triggerValidation,c=o.data,s=o.valid,u=o.errors,d=o.isValid,p=o.setSchema;return zw((function(){p(a?["shopperEmail"]:[])}),[a]),this.showValidation=l,zw((function(){e.onChange({data:c,errors:u,valid:s,isValid:d})}),[c,s,u,a,d]),JN("div",{className:"adyen-checkout__bankTransfer"},JN("p",{className:"adyen-checkout__bankTransfer__introduction"},t.get("bankTransfer.introduction")),JN(n$,{classNames:"adyen-checkout__bankTransfer__emailField",value:c.shopperEmail,errors:u.shopperEmail,onToggle:function(){return n(!a)},onInput:i("shopperEmail","input"),onBlur:i("shopperEmail","blur")}))}function U0(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function K0(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}Wg(M0,"type","blik");var H0=function(e){TN(r,e);var t=K0(r);function r(){var e,a;Bg(this,r);for(var n=arguments.length,o=new Array(n),i=0;i<n;i++)o[i]=arguments[i];return Wg(RN(a=t.call.apply(t,Bb(e=[this]).call(e,o))),"state",{isValid:!a.props.showEmailAddress,data:{}}),Wg(RN(a),"handleRef",(function(e){a.componentRef=e})),a}return qg(r,[{key:"isValid",get:function(){return!!this.state.isValid}},{key:"formatData",value:function(){var e=this.state.data.shopperEmail;return function(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=U0(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=U0(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}({paymentMethod:{type:r.type}},e&&{shopperEmail:e})}},{key:"render",value:function(){return this.props.reference?JN(Uj,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},JN(L0,FN({ref:this.handleRef},this.props))):JN(Uj,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},this.props.showEmailAddress&&JN(V0,FN({ref:this.handleRef},this.props,{onChange:this.setState})),this.props.showPayButton&&JN(NM,FN({},this.props,{name:this.displayName,onSubmit:this.submit,payButton:this.payButton})))}}]),r}(dA);Wg(H0,"type","bankTransfer_IBAN"),Wg(H0,"defaultProps",{showPayButton:!0,showEmailAddress:!0});var q0=["CA","US"];function W0(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function Y0(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=W0(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=W0(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}function G0(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}var J0=function(e){TN(r,e);var t=G0(r);function r(){return Bg(this,r),t.apply(this,arguments)}return qg(r,[{key:"formatProps",value:function(e){return Y0(Y0({},oD(jN(r.prototype),"formatProps",this).call(this,e)),{},{allowedCountries:q0,personalDetailsRequiredFields:["firstName","lastName","telephoneNumber","shopperEmail"]})}}]),r}(Wj);Wg(J0,"type","affirm");var Q0={socialSecurityNumber:{validate:dU,errorMessage:"",modes:["blur"]},default:{validate:function(e){return!!e&&e.length>0},errorMessage:"",modes:["blur"]}},Z0={socialSecurityNumber:function(e){return uU(e)}};function $0(e){var t,r=e.name,a=e.data,n=e.personalDetailsRequired,o=e.showPayButton,i=void 0!==o&&o,l=e.onChange,c=e.payButton,s=$w().i18n,u=["firstName","lastName","socialSecurityNumber"],d=QF({schema:u,defaultData:a,rules:Q0,formatters:Z0}),p=d.handleChangeFor,f=d.triggerValidation,m=d.setSchema,h=d.data,v=d.valid,y=d.errors,g=d.isValid;zw((function(){var e,t=n?Bb(e=[]).call(e,u):[];m(t)}),[n]);var b=tC(Bw("ready"),2),k=b[0],C=b[1];this.setStatus=C,this.showValidation=function(){f()},zw((function(){l({data:h,valid:v,errors:y,isValid:g})}),[l,h,v,y]);var _=n?[]:["standalone"];return JN("div",{className:"adyen-checkout__pix-input__field",style:i||n?null:{display:"none"}},n&&JN(o$,{i18n:s,data:h,handleChangeFor:p,errors:y,valid:v}),i&&c({status:k,label:Bb(t="".concat(s.get("continueTo")," ")).call(t,r),classNameModifiers:_}))}function X0(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function e1(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=X0(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=X0(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}function t1(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}var r1=function(e){TN(r,e);var t=t1(r);function r(){return Bg(this,r),t.apply(this,arguments)}return qg(r,[{key:"isValid",get:function(){return!!this.state.isValid}},{key:"formatProps",value:function(e){return e1({copyBtn:!0,introduction:"pix.instructions"},oD(jN(r.prototype),"formatProps",this).call(this,e))}},{key:"formatData",value:function(){var e=this.state.data,t=void 0===e?{}:e,r=t.firstName,a=t.lastName,n=t.socialSecurityNumber,o=void 0===n?"":n;return e1(e1({paymentMethod:{type:this.props.type||this.constructor.type}},r&&a&&{shopperName:{firstName:r,lastName:a}}),o&&{socialSecurityNumber:sU(o)})}},{key:"render",value:function(){var e=this;return this.props.paymentData?this.renderQRCode():JN(Uj,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},JN($0,FN({ref:function(t){e.componentRef=t}},this.props,{showPayButton:this.props.showPayButton,personalDetailsRequired:this.props.personalDetailsRequired,name:this.displayName,onChange:this.setState,payButton:this.payButton})))}}]),r}(SZ);Wg(r1,"type","pix"),Wg(r1,"defaultProps",e1({showPayButton:!1,personalDetailsRequired:!1,countdownTime:15,delay:2e3},SZ.defaultProps));var a1=/^(\d){1,8}$/,n1=/^(\d){6}$/,o1={bankAccountNumber:{modes:["blur","input"],validate:function(e){return!!e&&a1.test(e)}},bankLocationId:[{modes:["input"],validate:function(e){return!!e&&/^(\d){1,6}$/.test(e)}},{modes:["blur"],validate:function(e){return!!e&&n1.test(e)}}],amountConsentCheckbox:{modes:["blur"],validate:function(e){return!!e}},accountConsentCheckbox:{modes:["blur"],validate:function(e){return!!e}},default:{modes:["blur"],validate:function(e){return!!e&&e.length>0}}},i1={bankAccountNumber:S0,bankLocationId:S0},l1="enter-data",c1="confirm-data";function s1(e){var t,r,a,n=this,o=$w().i18n,i=QF({schema:["holderName","bankAccountNumber","bankLocationId","shopperEmail","amountConsentCheckbox","accountConsentCheckbox"],defaultData:e.data,formatters:i1,rules:o1}),l=i.handleChangeFor,c=i.triggerValidation,s=i.data,u=i.valid,d=i.errors,p=i.isValid,f=tC(Bw(l1),2),m=f[0],h=f[1];this.setStatus=h,this.showValidation=c;return zw((function(){e.onChange({data:s,valid:u,errors:d,isValid:p})}),[s,u,d,p]),JN("div",{className:ww({"adyen-checkout__bacs":!0,"adyen-checkout__bacs--confirm":m===c1||"loading"===m})},m==c1&&JN("div",{className:ww({"adyen-checkout__bacs--edit":!0,"adyen-checkout__bacs--edit-dropin":e.isDropin})},NF("text",{name:"bacsEdit",className:"adyen-checkout__bacs--edit-button",value:o.get("edit"),"aria-label":o.get("edit"),readonly:!0,onClick:function(){return n.setStatus(l1)}})),JN(kI,{className:ww({"adyen-checkout__bacs--holder-name":!0,"adyen-checkout__field--inactive":m===c1||"loading"===m}),label:o.get("bacs.accountHolderName"),errorMessage:!!d.holderName&&o.get("bacs.accountHolderName.invalid"),isValid:u.holderName,name:"accountHolderName",i18n:o},NF("text",{name:"bacs.accountHolderName",className:"adyen-checkout__bacs-input--holder-name",placeholder:e.placeholders.holderName,value:s.holderName,"aria-invalid":!u.holderName,"aria-label":o.get("bacs.accountHolderName"),"aria-required":"true",required:!0,readonly:m===c1||"loading"===m,autocorrect:"off",onBlur:l("holderName","blur"),onInput:l("holderName","input")})),JN("div",{className:"adyen-checkout__bacs__num-id adyen-checkout__field-wrapper"},JN(kI,{errorMessage:!!d.bankAccountNumber&&o.get("bacs.accountNumber.invalid"),label:o.get("bacs.accountNumber"),className:ww({"adyen-checkout__bacs--bank-account-number":!0,"adyen-checkout__field--inactive":m===c1||"loading"===m}),classNameModifiers:["col-70"],isValid:u.bankAccountNumber,name:"bankAccountNumber",i18n:o},NF("text",{value:s.bankAccountNumber,className:"adyen-checkout__bacs-input--bank-account-number",placeholder:e.placeholders.bankAccountNumber,"aria-invalid":!u.bankAccountNumber,"aria-label":o.get("bacs.accountNumber"),"aria-required":"true",required:!0,readonly:m===c1||"loading"===m,autocorrect:"off",onBlur:l("bankAccountNumber","blur"),onInput:l("bankAccountNumber","input")})),JN(kI,{errorMessage:!!d.bankLocationId&&o.get("bacs.bankLocationId.invalid"),label:o.get("bacs.bankLocationId"),className:ww({"adyen-checkout__bacs--bank-location-id":!0,"adyen-checkout__field--inactive":m===c1||"loading"===m}),classNameModifiers:["col-30"],isValid:u.bankLocationId,name:"bankLocationId",i18n:o},NF("text",{value:s.bankLocationId,className:"adyen-checkout__bacs-input--bank-location-id",placeholder:e.placeholders.bankLocationId,"aria-invalid":!u.bankLocationId,"aria-label":o.get("bacs.bankLocationId"),"aria-required":"true",required:!0,readonly:m===c1||"loading"===m,autocorrect:"off",onBlur:l("bankLocationId","blur"),onInput:l("bankLocationId","input")}))),JN(kI,{errorMessage:!!d.shopperEmail&&o.get("shopperEmail.invalid"),label:o.get("shopperEmail"),className:ww({"adyen-checkout__bacs--shopper-email":!0,"adyen-checkout__field--inactive":m===c1||"loading"===m}),isValid:u.shopperEmail,name:"emailAddress",i18n:o},NF("emailAddress",{value:s.shopperEmail,name:"shopperEmail",className:"adyen-checkout__bacs-input--shopper-email",classNameModifiers:["large"],placeholder:e.placeholders.shopperEmail,spellcheck:!1,"aria-invalid":!u.shopperEmail,"aria-label":o.get("shopperEmail"),"aria-required":"true",required:!0,readonly:m===c1||"loading"===m,autocorrect:"off",onInput:l("shopperEmail","input"),onBlur:l("shopperEmail","blur")})),m===l1&&JN(gj,{classNameModifiers:["amountConsentCheckbox"],errorMessage:!!d.amountConsentCheckbox,label:o.get("bacs.consent.amount"),onChange:l("amountConsentCheckbox"),checked:!!s.amountConsentCheckbox,i18n:o}),m===l1&&JN(gj,{classNameModifiers:["accountConsentCheckbox"],errorMessage:!!d.accountConsentCheckbox,label:o.get("bacs.consent.account"),onChange:l("accountConsentCheckbox"),checked:!!s.accountConsentCheckbox,i18n:o}),e.showPayButton&&e.payButton({status:m,label:m===l1?o.get("continue"):Bb(t="".concat(o.get("bacs.confirm")," ")).call(t,null!==(r=e.amount)&&void 0!==r&&r.value&&null!==(a=e.amount)&&void 0!==a&&a.currency?o.amount(e.amount.value,e.amount.currency):""),icon:GP({loadingContext:e.loadingContext,imageFolder:"components/"})("lock"),onClick:function(){return p?m===l1?n.setStatus(c1):m===c1?e.onSubmit():void 0:n.showValidation()}}))}s1.defaultProps={data:{},placeholders:{}};var u1=function(e){var t=$w(),r=t.i18n,a=t.loadingContext,n=e.url,o=e.paymentMethodType;return JN(OG,{paymentMethodType:o,introduction:r.get("bacs.result.introduction"),imageUrl:GP({loadingContext:a})(o),downloadUrl:n,downloadButtonText:r.get("download.pdf")})};function d1(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function p1(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=d1(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=d1(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}function f1(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}var m1=function(e){TN(r,e);var t=f1(r);function r(){var e,a;Bg(this,r);for(var n=arguments.length,o=new Array(n),i=0;i<n;i++)o[i]=arguments[i];return Wg(RN(a=t.call.apply(t,Bb(e=[this]).call(e,o))),"payButton",(function(e){return JN(oS,FN({amount:a.props.amount,onClick:a.submit},e))})),a}return qg(r,[{key:"formatData",value:function(){var e,t,a,n;return p1({paymentMethod:p1(p1(p1({type:r.type},(null===(e=this.state.data)||void 0===e?void 0:e.holderName)&&{holderName:this.state.data.holderName}),(null===(t=this.state.data)||void 0===t?void 0:t.bankAccountNumber)&&{bankAccountNumber:this.state.data.bankAccountNumber}),(null===(a=this.state.data)||void 0===a?void 0:a.bankLocationId)&&{bankLocationId:this.state.data.bankLocationId})},(null===(n=this.state.data)||void 0===n?void 0:n.shopperEmail)&&{shopperEmail:this.state.data.shopperEmail})}},{key:"isValid",get:function(){return!!this.state.isValid}},{key:"render",value:function(){var e=this;return JN(Uj,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},this.props.url?JN(u1,{ref:function(t){e.componentRef=t},icon:this.icon,url:this.props.url,paymentMethodType:this.props.paymentMethodType}):JN(s1,FN({ref:function(t){e.componentRef=t}},this.props,{onChange:this.setState,payButton:this.payButton,onSubmit:this.submit})))}}]),r}(dA);function h1(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}Wg(m1,"type","directdebit_GB");var v1=function(e){TN(r,e);var t=h1(r);function r(){return Bg(this,r),t.apply(this,arguments)}return qg(r,[{key:"data",get:function(){return this.state.data}},{key:"isValid",get:function(){return!!this.state.isValid}},{key:"render",value:function(){return JN(Uj,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},JN(vj,FN({setComponentRef:this.setComponentRef},this.props,{onChange:this.setState},!1)))}}]),r}(dA);function y1(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}var g1=function(e){TN(r,e);var t=y1(r);function r(){return Bg(this,r),t.apply(this,arguments)}return qg(r,[{key:"data",get:function(){return this.state.data}},{key:"isValid",get:function(){return!!this.state.isValid}},{key:"render",value:function(){return JN(Uj,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},JN(uR,FN({setComponentRef:this.setComponentRef},this.props,{onChange:this.setState},!1)))}}]),r}(dA),b1="https://x.klarnacdn.net/kp/lib/v1/api.js",k1=["sdkData","paymentMethodType","payButton"];function C1(e){var t=e.sdkData;e.paymentMethodType;var r=e.payButton,a=KP(e,k1),n=Lw(null),o=tC(Bw("ready"),2),i=o[0],l=o[1],c=function(){l("error"),a.onComplete({data:{paymentData:a.paymentData,details:{}}})};return zw((function(){window.klarnaAsyncCallback=function(){window.Klarna.Payments.init({client_token:t.client_token}),window.Klarna.Payments.load({container:n.current,payment_method_category:t.payment_method_category},(function(e){e.show_form&&!e.error||c()}))};var e=new Rz(b1);return e.load(),function(){e.remove()}}),[]),"error"!==i&&"success"!==i?JN("div",{className:"adyen-checkout__klarna-widget"},JN("div",{ref:n}),r({status:i,disabled:"loading"===i,onClick:function(){l("loading");try{window.Klarna.Payments.authorize({payment_method_category:t.payment_method_category},(function(e){!0===e.approved&&!0===e.show_form?(l("success"),a.onComplete({data:{paymentData:a.paymentData,details:{token:e.authorization_token}}})):e.approved||!0!==e.show_form?c():(l("ready"),a.onError(e))}))}catch(e){c()}}})):null}function _1(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function N1(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=_1(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=_1(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}function P1(e){var t,r=tC(Bw({sdkData:e.sdkData,paymentMethodType:e.paymentMethodType,paymentData:e.paymentData}),2),a=r[0],n=r[1],o=tC(Bw("ready"),2),i=o[0],l=o[1];return this.setAction=n,this.setStatus=l,a.sdkData?JN(C1,{sdkData:a.sdkData,paymentMethodType:a.paymentMethodType,paymentData:a.paymentData,payButton:e.payButton,onComplete:e.onComplete,onError:e.onError}):e.showPayButton?e.payButton(N1(N1({},e),{},{status:i,disabled:"loading"===i,classNameModifiers:["standalone"],label:Bb(t="".concat(this.props.i18n.get("continueTo")," ")).call(t,e.displayName)})):null}function w1(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function S1(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=w1(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=w1(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}function x1(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}var E1=function(e){TN(r,e);var t=x1(r);function r(e){var a,n,o,i;return Bg(this,r),Wg(RN(i=t.call(this,e)),"payButton",(function(e){return JN(oS,FN({amount:i.props.amount,onClick:i.submit},e))})),i.onComplete=rk(a=i.onComplete).call(a,RN(i)),i.updateWithAction=rk(n=i.updateWithAction).call(n,RN(i)),i.submit=rk(o=i.submit).call(o,RN(i)),i}return qg(r,[{key:"isValid",get:function(){return!0}},{key:"formatData",value:function(){return{paymentMethod:S1({type:this.type},this.props.useKlarnaWidget?{subtype:"sdk"}:{})}}},{key:"updateWithAction",value:function(e){if(e.paymentMethodType!==this.type)throw new Error("Invalid Action");this.componentRef.setAction(e)}},{key:"render",value:function(){var e=this;return JN(Uj,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},JN(P1,FN({},this.props,{ref:function(t){e.componentRef=t},displayName:this.displayName,onComplete:function(t){return e.handleAdditionalDetails(t)},onError:this.props.onError,payButton:this.payButton})))}}]),r}(dA);function A1(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}Wg(E1,"type","klarna"),Wg(E1,"defaultProps",{useKlarnaWidget:!1});var D1=function(e){TN(r,e);var t=A1(r);function r(){var e,a;Bg(this,r);for(var n=arguments.length,o=new Array(n),i=0;i<n;i++)o[i]=arguments[i];return Wg(RN(a=t.call.apply(t,Bb(e=[this]).call(e,o))),"payButton",(function(e){return JN(oS,FN({},e,{label:a.payButtonLabel(),onClick:a.submit}))})),a}return qg(r,[{key:"displayName",get:function(){var e,t=this.props,r=t.i18n,a=t.name;return t.storedPaymentMethodId?Bb(e="".concat(a," ")).call(e,r.get("twint.saved")):a||this.constructor.type}},{key:"payButtonLabel",value:function(){var e,t=this.props,r=t.i18n,a=t.amount,n=t.storedPaymentMethodId,o=t.name;return n?rS(r,a):Bb(e="".concat(r.get("continueTo")," ")).call(e,o)}}]),r}(iG);Wg(D1,"type","twint"),Wg(D1,"defaultProps",{type:D1.type,showPayButton:!0});var I1=function(e){var t=e.i18n,r=e.sfpState,a=e.focusedElement,n=e.setFocusOn;return JN(kI,{label:t.get("creditCard.expiryDateField.title"),classNameModifiers:["expireDate","50"],errorMessage:r.errors.encryptedExpiryDate&&t.get(r.errors.encryptedExpiryDate),focused:"encryptedExpiryDate"===a,onFocusField:function(){return n("encryptedExpiryDate")},dir:"ltr",name:"encryptedExpiryDate"},JN(wK,{encryptedFieldType:"encryptedExpiryDate",className:ww("adyen-checkout__input","adyen-checkout__input--small","adyen-checkout__card__exp-date__input",[PK["adyen-checkout__input"]],{"adyen-checkout__input--error":r.errors.encryptedExpiryDate,"adyen-checkout__input--focus":"encryptedExpiryDate"===a,"adyen-checkout__input--valid":!!r.valid.encryptedExpiryMonth&&!!r.valid.encryptedExpiryYear})}))},F1=function(e){return JN("div",{ref:e.setRootNode},JN(R$,FN({},e,{classNameModifiers:["100"]})),JN("div",{className:"adyen-checkout__field-wrapper"},JN(I1,e),JN(O$,FN({},e,{classNameModifiers:["50"]}))))};function R1(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function O1(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=R1(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=R1(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}function T1(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}var B1=function(e){TN(r,e);var t=T1(r);function r(e){return Bg(this,r),t.call(this,O1(O1({},e),{},{pinRequired:!0,expiryDateRequired:!0,fieldsLayoutComponent:F1}))}return qg(r,[{key:"formatProps",value:function(e){return O1({brand:e.type},e)}},{key:"formatData",value:function(){var e,t,r,a;return{paymentMethod:{type:this.constructor.type,brand:this.props.brand,encryptedCardNumber:null===(e=this.state.data)||void 0===e?void 0:e.encryptedCardNumber,encryptedSecurityCode:null===(t=this.state.data)||void 0===t?void 0:t.encryptedSecurityCode,encryptedExpiryMonth:null===(r=this.state.data)||void 0===r?void 0:r.encryptedExpiryMonth,encryptedExpiryYear:null===(a=this.state.data)||void 0===a?void 0:a.encryptedExpiryYear}}}}]),r}(L$);function j1(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function z1(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=j1(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=j1(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}function M1(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}Wg(B1,"type","mealVoucher_FR");var L1=function(e){TN(r,e);var t=M1(r);function r(){return Bg(this,r),t.apply(this,arguments)}return qg(r,[{key:"formatProps",value:function(e){return z1(z1({},oD(jN(r.prototype),"formatProps",this).call(this,e)),{},{showImage:!1})}},{key:"formatData",value:function(){return z1(z1({},oD(jN(r.prototype),"formatData",this).call(this)),{},{browserInfo:this.browserInfo})}},{key:"browserInfo",get:function(){return lz()}}]),r}(xM);function V1(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}Wg(L1,"type","onlinebanking_IN");var U1=function(e){TN(r,e);var t=V1(r);function r(){return Bg(this,r),t.apply(this,arguments)}return qg(r)}(xM);function K1(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function H1(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=K1(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=K1(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}function q1(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}Wg(U1,"type","onlineBanking_PL");var W1=function(e){TN(r,e);var t=q1(r);function r(){return Bg(this,r),t.apply(this,arguments)}return qg(r,[{key:"formatProps",value:function(e){return H1(H1({},oD(jN(r.prototype),"formatProps",this).call(this,H1(H1({},e),{visibility:{bankAccount:"editable"}}))),{},{allowedCountries:e.countryCode?[e.countryCode]:Z$})}}]),r}(Wj);Wg(W1,"type","ratepay_directdebit");var Y1,G1={virtualPaymentAddress:{validate:function(e){return!!e&&e.length>0},errorMessage:"",modes:["blur"]},default:{validate:function(e){return!!e&&e.length>0},errorMessage:"",modes:["blur"]}},J1=function(e){var t=QF({schema:["virtualPaymentAddress"],defaultData:e.data,rules:G1}),r=t.handleChangeFor,a=t.triggerValidation,n=t.data,o=t.valid,i=t.errors,l=t.isValid,c=Lw({validateInput:null}),s=Uw((function(){a()}),[a]);return zw((function(){c.current.validateInput=s,e.onSetInputHandlers(c.current)}),[s,e.onSetInputHandlers]),zw((function(){e.onChange({data:n,valid:o,errors:i,isValid:l})}),[n,o,i,l]),JN(kI,{label:"Virtual Payment Address",errorMessage:!!i.virtualPaymentAddress,classNameModifiers:["vpa"],name:"virtualPaymentAddress"},NF("text",{name:"virtualPaymentAddress",autocorrect:"off",spellcheck:!1,disabled:e.disabled,value:n.virtualPaymentAddress,onInput:r("virtualPaymentAddress","input"),onBlur:r("virtualPaymentAddress","blur")}))};function Q1(e){var t,r=e.classNameModifiers,a=e.selectedValue,n=e.disabled,o=void 0!==n&&n,i=e.options,l=e.onChange;return i&&0!==i.length?JN("div",{className:ww.apply(void 0,Bb(t=["adyen-checkout__segmented-control",{"adyen-checkout__segmented-control--disabled":o}]).call(t,rC(QC(r).call(r,(function(e){return"adyen-checkout__segmented-control--".concat(e)}))))),role:"group"},QC(i).call(i,(function(e){var t=e.label,r=e.value,n=e.htmlProps;return JN("button",FN({disabled:o,key:r,onClick:function(e){return l(r,e)},className:ww("adyen-checkout__segmented-control-segment",{"adyen-checkout__segmented-control-segment--selected":a===r}),type:"button"},n),t)}))):null}!function(e){e.Vpa="vpa",e.QrCode="qrCode"}(Y1||(Y1={}));var Z1,$1={ButtonId:{VPA:"upi-button-".concat(Y1.Vpa),QR:"upi-button-".concat(Y1.QrCode)},AreaId:{VPA:"upi-area-".concat(Y1.Vpa),QR:"upi-area-".concat(Y1.QrCode)}};function X1(e){var t=e.defaultMode,r=e.onChange,a=e.onUpdateMode,n=e.payButton,o=e.showPayButton,i=$w(),l=i.i18n,c=i.loadingContext,s=tC(Bw(null),2),u=s[0],d=s[1],p=tC(Bw("ready"),2),f=p[0],m=p[1],h=tC(Bw(t),2),v=h[0],y=h[1];this.setStatus=function(e){m(e)},this.showValidation=function(){u.validateInput()};var g=Uw((function(e){d(e)}),[]),b=Uw((function(e){y(e),a(e)}),[a]);return JN(ZN,null,JN("p",{className:"adyen-checkout_upi-mode-selection-text"},l.get("upi.modeSelection")),JN(Q1,{onChange:b,selectedValue:v,disabled:"loading"===f,classNameModifiers:["upi-margin-bottom"],options:[{label:_Y()?"VPA":"Virtual Payment Address",value:Y1.Vpa,htmlProps:{id:$1.ButtonId.VPA,"aria-expanded":v===Y1.Vpa,"aria-controls":$1.AreaId.VPA}},{label:"QR Code",value:Y1.QrCode,htmlProps:{id:$1.ButtonId.QR,"aria-expanded":v===Y1.QrCode,"aria-controls":$1.AreaId.QR}}]}),v===Y1.Vpa?JN("div",{id:$1.AreaId.VPA,"aria-labelledby":$1.ButtonId.VPA,role:"region"},JN(J1,{disabled:"loading"===f,onChange:r,onSetInputHandlers:g}),o&&n({label:l.get("continue"),status:f})):JN("div",{id:$1.AreaId.QR,"aria-labelledby":$1.ButtonId.QR,role:"region"},o&&n({label:l.get("generateQRCode"),icon:GP({loadingContext:c,imageFolder:"components/"})("qr"),status:f})))}function e2(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function t2(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=e2(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=e2(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}function r2(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}!function(e){e.UpiCollect="upi_collect",e.UpiQr="upi_qr"}(Z1||(Z1={}));var a2=function(e){TN(r,e);var t=r2(r);function r(){var e,a;Bg(this,r);for(var n=arguments.length,o=new Array(n),i=0;i<n;i++)o[i]=arguments[i];return Wg(RN(a=t.call.apply(t,Bb(e=[this]).call(e,o))),"useQrCodeVariant",void 0),Wg(RN(a),"onUpdateMode",(function(e){e===Y1.QrCode?(a.useQrCodeVariant=!0,a.setState({data:{},valid:{},errors:{},isValid:!0})):a.useQrCodeVariant=!1})),a}return qg(r,[{key:"isValid",get:function(){return this.useQrCodeVariant||!!this.state.isValid}},{key:"formatData",value:function(){var e=this.state.data.virtualPaymentAddress;return{paymentMethod:t2({type:this.useQrCodeVariant?Z1.UpiQr:Z1.UpiCollect},e&&!this.useQrCodeVariant&&{virtualPaymentAddress:e})}}},{key:"renderContent",value:function(e){var t=this;switch(e){case"qrCode":return JN(_Z,FN({ref:function(e){t.componentRef=e}},this.props,{qrCodeData:this.props.qrCodeData?encodeURIComponent(this.props.qrCodeData):null,type:Z1.UpiQr,brandLogo:this.props.brandLogo||this.icon,onComplete:this.onComplete,introduction:this.props.i18n.get("upi.qrCodeWaitingMessage"),countdownTime:5,onActionHandled:this.props.onActionHandled}));case"await":return JN(C0,{ref:function(e){t.componentRef=e},onError:this.props.onError,clientKey:this.props.clientKey,paymentData:this.props.paymentData,onComplete:this.onComplete,brandLogo:this.icon,type:Z1.UpiCollect,messageText:this.props.i18n.get("upi.vpaWaitingMessage"),awaitText:this.props.i18n.get("await.waitForConfirmation"),showCountdownTimer:!0,countdownTime:5,onActionHandled:this.props.onActionHandled});default:return JN(X1,{ref:function(e){t.componentRef=e},payButton:this.payButton,onChange:this.setState,onUpdateMode:this.onUpdateMode,defaultMode:this.props.defaultMode,showPayButton:this.props.showPayButton})}}},{key:"render",value:function(){var e=this.props.type;return JN(Uj,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},this.renderContent(e))}}]),r}(dA);function n2(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function o2(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=n2(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=n2(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}function i2(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}Wg(a2,"type","upi"),Wg(a2,"defaultProps",{defaultMode:Y1.Vpa});var l2=function(e){TN(r,e);var t=i2(r);function r(){return Bg(this,r),t.apply(this,arguments)}return qg(r,[{key:"formatProps",value:function(e){return o2(o2({},oD(jN(r.prototype),"formatProps",this).call(this,e)),{},{showImage:!1})}},{key:"formatData",value:function(){return o2(o2({},oD(jN(r.prototype),"formatData",this).call(this)),{},{browserInfo:this.browserInfo})}},{key:"browserInfo",get:function(){return lz()}}]),r}(xM);function c2(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function s2(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=c2(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=c2(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}function u2(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}Wg(l2,"type","wallet_IN");var d2=function(e){TN(r,e);var t=u2(r);function r(){return Bg(this,r),t.apply(this,arguments)}return qg(r,[{key:"formatProps",value:function(e){return s2(s2({},oD(jN(r.prototype),"formatProps",this).call(this,e)),{},{showImage:!1,termsAndConditionsUrl:"https://static.payu.com/sites/terms/files/payu_privacy_policy_cs.pdf"})}},{key:"icon",get:function(){var e;return null!==(e=this.props.icon)&&void 0!==e?e:GP({loadingContext:this.props.loadingContext})("bankTransfer_IBAN")}}]),r}(xM);function p2(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function f2(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=p2(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=p2(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}function m2(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}Wg(d2,"type","onlineBanking_CZ");var h2=function(e){TN(r,e);var t=m2(r);function r(){return Bg(this,r),t.apply(this,arguments)}return qg(r,[{key:"formatProps",value:function(e){return f2(f2({},oD(jN(r.prototype),"formatProps",this).call(this,e)),{},{showImage:!1,termsAndConditionsUrl:"https://static.payu.com/sites/terms/files/payu_privacy_policy_sk.pdf"})}},{key:"icon",get:function(){var e;return null!==(e=this.props.icon)&&void 0!==e?e:GP({loadingContext:this.props.loadingContext})("bankTransfer_IBAN")}}]),r}(xM);function v2(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function y2(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=v2(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=v2(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}function g2(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}Wg(h2,"type","onlineBanking_SK");var b2=function(e){TN(r,e);var t=g2(r);function r(e){return Bg(this,r),t.call(this,y2(y2({},e),{},{showPaymentMethodItemImages:!0}))}return qg(r)}(xM);Wg(b2,"type","paybybank");function k2(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function C2(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}var _2=function(e){TN(r,e);var t=C2(r);function r(){return Bg(this,r),t.apply(this,arguments)}return qg(r,[{key:"formatProps",value:function(e){return function(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=k2(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=k2(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}({delay:2e3,countdownTime:1.5},oD(jN(r.prototype),"formatProps",this).call(this,e))}}]),r}(SZ);Wg(_2,"type","promptpay");function N2(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function P2(e){var t=function(){if("undefined"==typeof Reflect||!nN)return!1;if(nN.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(nN(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=jN(e);if(t){var n=jN(this).constructor;r=nN(a,arguments,n)}else r=a.apply(this,arguments);return BN(this,r)}}var w2=function(e){TN(r,e);var t=P2(r);function r(){return Bg(this,r),t.apply(this,arguments)}return qg(r,[{key:"formatProps",value:function(e){return function(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=N2(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=N2(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}({delay:2e3,countdownTime:1.5},oD(jN(r.prototype),"formatProps",this).call(this,e))}}]),r}(SZ);function S2(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function x2(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=S2(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=S2(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}Wg(w2,"type","duitnow");var E2={address:v1,bankTransfer_IBAN:H0,donation:XY,dropin:UX,personal_details:g1,amex:MY,bcmc:KY,card:MY,diners:MY,discover:MY,jcb:MY,kcp:MY,maestro:MY,mc:MY,scheme:MY,storedCard:MY,securedfields:uQ,threeDS2Challenge:zQ,threeDS2DeviceFingerprint:YQ,visa:MY,ach:t0,directdebit_GB:m1,sepadirectdebit:fQ,affirm:J0,afterpay:rz,afterpay_default:rz,afterpay_b2b:iz,atome:lM,facilypay_3x:HG,facilypay_4x:GG,facilypay_6x:$G,facilypay_10x:rJ,facilypay_12x:iJ,ratepay:tX,ratepay_directdebit:W1,amazonpay:Mz,applepay:$z,googlepay:SG,paypal:RJ,paywithgoogle:SG,qiwiwallet:rQ,boletobancario:f$,boletobancario_bancodobrasil:f$,boletobancario_bradesco:f$,boletobancario_hsbc:f$,boletobancario_itau:f$,boletobancario_santander:f$,doku:t$,doku_alfamart:t$,doku_permata_lite_atm:t$,doku_indomaret:t$,doku_atm_mandiri_va:t$,doku_sinarmas_va:t$,doku_mandiri_va:t$,doku_cimb_va:t$,doku_danamon_va:t$,doku_bri_va:t$,doku_bni_va:t$,doku_bca_va:t$,doku_wallet:t$,oxxo:g$,primeiropay_boleto:f$,billdesk_online:IM,billdesk_wallet:TM,dotpay:w$,entercash:EG,eps:A$,ideal:cJ,molpay_ebanking_fpx_MY:jZ,molpay_ebanking_TH:MZ,molpay_ebanking_VN:VZ,onlineBanking:w$,onlineBanking_CZ:d2,onlinebanking_IN:L1,onlineBanking_PL:U1,onlineBanking_SK:h2,paybybank:b2,payu_IN_cashcard:W$,payu_IN_nb:Q$,wallet_IN:l2,dragonpay_ebanking:JZ,dragonpay_otc_banking:JZ,dragonpay_otc_non_banking:JZ,dragonpay_otc_philippines:JZ,econtext_atm:MG,econtext_online:MG,econtext_seven_eleven:MG,econtext_stores:MG,giropay:uG,multibanco:N$,redirect:iG,twint:D1,vipps:U$,klarna:E1,klarna_account:E1,klarna_paynow:E1,bcmc_mobile:TZ,bcmc_mobile_QR:TZ,pix:r1,swish:nX,wechatpay:AZ,wechatpayQR:AZ,promptpay:_2,paynow:FZ,duitnow:w2,blik:M0,mbway:w0,upi:a2,upi_qr:a2,upi_collect:a2,giftcard:L$,mealVoucher_FR_natixis:B1,mealVoucher_FR_sodexo:B1,mealVoucher_FR_groupeup:B1,default:null},A2=function(e,t){var r,a=E2[e]||E2.default;return a?new a(x2(x2({},t),{},{id:Bb(r="".concat(e,"-")).call(r,CP())})):null},D2=function(e){var t=e;return"scheme"===e&&(t=arguments.length>2&&void 0!==arguments[2]&&arguments[2]?"storedCard":"card"),(arguments.length>1&&void 0!==arguments[1]?arguments[1]:{})[t]||{}};function I2(e){return!this.length||hC(this).call(this,e.type)>-1}function F2(e){return!this.length||hC(this).call(this,e.type)<0}function R2(e){var t;return!!e&&!!e.supportedShopperInteractions&&Eb(t=e.supportedShopperInteractions).call(t,"Ecommerce")}var O2=["scheme","blik","twint","ach"];function T2(e){return!!e&&!!e.type&&Eb(O2).call(O2,e.type)}function B2(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function j2(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=B2(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=B2(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}var z2=function(e){return j2(j2({},e),{},{storedPaymentMethodId:e.id})},M2=function(){function e(t){var r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};Bg(this,e),Wg(this,"paymentMethods",[]),Wg(this,"storedPaymentMethods",[]),function(e){var t,r;if("string"==typeof e)throw new Error('paymentMethodsResponse was provided but of an incorrect type (should be an object but a string was provided).Try JSON.parse("{...}") your paymentMethodsResponse.');if(e instanceof Array)throw new Error("paymentMethodsResponse was provided but of an incorrect type (should be an object but an array was provided).Please check you are passing the whole response.");!e||null!=e&&null!==(t=e.paymentMethods)&&void 0!==t&&t.length||null!=e&&null!==(r=e.storePaymentMethods)&&void 0!==r&&r.length||console.warn("paymentMethodsResponse was provided but no payment methods were found.")}(t),this.paymentMethods=t?function(e,t){var r,a=t.allowPaymentMethods,n=void 0===a?[]:a,o=t.removePaymentMethods,i=void 0===o?[]:o;return e?nb(r=nb(e).call(e,I2,n)).call(r,F2,i):[]}(t.paymentMethods,r):[],this.storedPaymentMethods=t?function(e,t){var r,a,n,o,i=t.allowPaymentMethods,l=void 0===i?[]:i,c=t.removePaymentMethods,s=void 0===c?[]:c;return e?QC(r=nb(a=nb(n=nb(o=nb(e).call(e,T2)).call(o,I2,l)).call(n,F2,s)).call(a,R2)).call(r,z2):[]}(t.storedPaymentMethods,r):[]}return qg(e,[{key:"mapCreatedComponentType",value:function(e){return"card"===e?"scheme":e}},{key:"has",value:function(e){var t,r=this;return Boolean(yk(t=this.paymentMethods).call(t,(function(t){return t.type===r.mapCreatedComponentType(e)})))}},{key:"find",value:function(e){var t,r=this;return yk(t=this.paymentMethods).call(t,(function(t){return t.type===r.mapCreatedComponentType(e)}))}}]),e}();function L2(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function V2(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=L2(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=L2(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}var U2=function(e){return function(t,r){return A2(t.paymentMethodType,V2(V2(V2({},r),t),{},{onComplete:r.onAdditionalDetails,onError:r.onError,statusType:e}))}},K2={redirect:function(e,t){return A2("redirect",V2(V2(V2({},t),e),{},{statusType:"redirect"}))},threeDS2Fingerprint:function(e,t){return A2("threeDS2DeviceFingerprint",V2(V2({createFromAction:t.createFromAction,token:e.token,paymentData:e.paymentData,onError:t.onError,showSpinner:!t.isDropin,isDropin:!!t.isDropin},t),{},{type:"IdentifyShopper",onComplete:t.onAdditionalDetails,statusType:"loading",useOriginalFlow:!0}))},threeDS2Challenge:function(e,t){var r;return A2("threeDS2Challenge",V2(V2({},t),{},{token:e.token,paymentData:e.paymentData,onComplete:t.onAdditionalDetails,onError:t.onError,size:null!==(r=t.size)&&void 0!==r?r:"02",isDropin:!!t.isDropin,type:"ChallengeShopper",statusType:"custom",useOriginalFlow:!0}))},threeDS2:function(e,t){var r="fingerprint"===e.subtype?"threeDS2DeviceFingerprint":"threeDS2Challenge",a="fingerprint"===e.subtype?e.paymentData:e.authorisationToken,n=V2({token:e.token,paymentData:a,onActionHandled:t.onActionHandled,onComplete:t.onAdditionalDetails,onError:t.onError,isDropin:!!t.isDropin,loadingContext:t.loadingContext,clientKey:t.clientKey,_parentInstance:t._parentInstance,paymentMethodType:t.paymentMethodType,challengeWindowSize:t.challengeWindowSize},function(e,t){if("fingerprint"===e){var r=BL(t.elementRef?DQ:IQ).from(t);return r.showSpinner=!t.isDropin,r.statusType="loading",r}return{statusType:"custom",i18n:t.i18n}}(e.subtype,t));return A2(r,n)},voucher:U2("custom"),qrCode:U2("custom"),await:U2("custom"),bankTransfer:U2("custom"),sdk:U2("custom")};function H2(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}var q2=function(e){return function(t){var r,a,n=function(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=H2(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=H2(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}({version:"5.36.0",payload_version:1,platform:"web",locale:e.locale},t),o=QC(r=Jy(n)).call(r,(function(e){var t;return Bb(t="".concat(encodeURIComponent(e),"=")).call(t,encodeURIComponent(n[e]))})).join("&");(new Image).src=Bb(a="".concat(e.loadingContext,"images/analytics.png?")).call(a,o)}};function W2(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}var Y2=function(e){return function(t){var r,a;if(!e.clientKey)return ok.reject();var n={errorLevel:"silent",loadingContext:e.loadingContext,path:"v2/analytics/log?clientKey=".concat(e.clientKey)},o=function(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=W2(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=W2(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}({amountValue:null===(r=e.amount)||void 0===r?void 0:r.value,amountCurrency:null===(a=e.amount)||void 0===a?void 0:a.currency,version:"5.36.0",channel:"Web",locale:e.locale,flavor:"components",userAgent:navigator.userAgent,referrer:window.location.href,screenWidth:window.screen.width},t);return UB(n,o)}},G2=function(){function e(){Bg(this,e),Wg(this,"storage",void 0),this.storage={}}return qg(e,[{key:"length",get:function(){return Jy(this.storage).length}},{key:"key",value:function(e){var t;return hC(t=Jy(this.storage)).call(t,e)}},{key:"getItem",value:function(e){return this.storage[e]||null}},{key:"setItem",value:function(e,t){return this.storage[e]=t}},{key:"removeItem",value:function(e){delete this.storage[e]}},{key:"clear",value:function(){this.storage={}}}]),e}(),J2=function(){function e(t,r){Bg(this,e),Wg(this,"prefix","adyen-checkout__"),Wg(this,"key",void 0),Wg(this,"storage",void 0);try{this.storage=r?window[r]:window.localStorage}catch(e){this.storage=new G2}this.key=this.prefix+t}return qg(e,[{key:"get",value:function(){try{return JSON.parse(this.storage.getItem(this.key))}catch(e){return null}}},{key:"set",value:function(e){this.storage.setItem(this.key,gA(e))}},{key:"remove",value:function(){this.storage.removeItem(this.key)}}]),e}();var Q2=function(e){var t,r=e.loadingContext,a=e.clientKey,n=e.experiments,o={errorLevel:"silent",loadingContext:r,path:"v2/analytics/id?clientKey=".concat(a)};return function(){if(t)return t;if(!a)return ok.reject();var e=new J2("checkout-attempt-id","sessionStorage"),r=e.get();return function(e){if(null==e||!e.id)return!1;var t=vI()-9e5;return e.timestamp>t}(r)?ok.resolve(r.id):t=UB(o,{experiments:n}).then((function(t){if(t.id)return e.set({id:t.id,timestamp:vI()}),t.id})).catch((function(){}))}},Z2=function(){function e(){Bg(this,e),Wg(this,"events",[])}return qg(e,[{key:"add",value:function(e){this.events.push(e)}},{key:"run",value:function(e){var t,r=QC(t=this.events).call(t,(function(t){return t(e)}));return this.events=[],ok.all(r)}}]),e}();function $2(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function X2(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=$2(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=$2(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}var e3=function(){function e(t){var r=t.loadingContext,a=t.locale,n=t.clientKey,o=t.analytics,i=t.amount;Bg(this,e),Wg(this,"checkoutAttemptId",null),Wg(this,"props",void 0),Wg(this,"logEvent",void 0),Wg(this,"logTelemetry",void 0),Wg(this,"queue",new Z2),Wg(this,"collectId",void 0),this.props=X2(X2({},e.defaultProps),o),this.logEvent=q2({loadingContext:r,locale:a}),this.logTelemetry=Y2({loadingContext:r,locale:a,clientKey:n,amount:i}),this.collectId=Q2({loadingContext:r,clientKey:n,experiments:this.props.experiments});var l=this.props,c=l.telemetry,s=l.enabled;!0===c&&!0===s&&this.props.checkoutAttemptId&&(this.checkoutAttemptId=this.props.checkoutAttemptId,this.queue.run(this.checkoutAttemptId))}return qg(e,[{key:"send",value:function(e){var t=this,r=this.props,a=r.enabled,n=r.payload,o=r.telemetry;if(!0===a){if(!0!==o||this.checkoutAttemptId||this.collectId().then((function(e){t.checkoutAttemptId=e,t.queue.run(t.checkoutAttemptId)})).catch((function(e){console.warn("Fetching checkoutAttemptId failed.".concat(e?" Error=".concat(e):""))})),!0===o){this.queue.add((function(r){return t.logTelemetry(X2(X2(X2({},e),n&&X2({},n)),{},{checkoutAttemptId:r})).catch((function(){}))})),this.checkoutAttemptId&&this.queue.run(this.checkoutAttemptId)}this.logEvent(e)}}}]),e}();function t3(e){var t;return DC(t=Jy(e)).call(t,(function(t,r){return Eb(qP).call(qP,r)&&(t[r]=e[r]),t}),{})}Wg(e3,"defaultProps",{enabled:!0,telemetry:!0,checkoutAttemptId:null,experiments:[]});var r3="v1";function a3(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function n3(e,t){var r,a,n=Bb(r=Bb(a="".concat(r3,"/sessions/")).call(a,t.id,"/payments?clientKey=")).call(r,t.clientKey),o=function(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=a3(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=a3(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}({sessionData:t.data},e);return UB({loadingContext:t.loadingContext,path:n,errorLevel:"fatal"},o)}function o3(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function i3(e,t){var r,a,n=Bb(r=Bb(a="".concat(r3,"/sessions/")).call(a,t.id,"/paymentDetails?clientKey=")).call(r,t.clientKey),o=function(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=o3(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=o3(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}({sessionData:t.data},e);return UB({loadingContext:t.loadingContext,path:n,errorLevel:"fatal"},o)}function l3(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function c3(e,t){var r,a,n=Bb(r=Bb(a="".concat(r3,"/sessions/")).call(a,e.id,"/setup?clientKey=")).call(r,e.clientKey),o=function(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=l3(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=l3(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}({sessionData:e.data},t.order?{order:{orderData:t.order.orderData,pspReference:t.order.pspReference}}:{});return UB({loadingContext:e.loadingContext,path:n,errorLevel:"fatal",errorMessage:"ERROR: Invalid ClientKey"},o)}function s3(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function u3(e,t){var r,a,n=Bb(r=Bb(a="".concat(r3,"/sessions/")).call(a,t.id,"/paymentMethodBalance?clientKey=")).call(r,t.clientKey),o=function(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=s3(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=s3(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}({sessionData:t.data},e);return UB({loadingContext:t.loadingContext,path:n,errorLevel:"fatal"},o)}function d3(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function p3(e){if(!e||!e.id)throw new Error("Invalid session");return function(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=d3(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=d3(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}({id:e.id},e.sessionData?{sessionData:e.sessionData}:{})}function f3(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}var m3=function(){function e(t,r,a){Bg(this,e),Wg(this,"session",void 0),Wg(this,"storage",void 0),Wg(this,"clientKey",void 0),Wg(this,"loadingContext",void 0),Wg(this,"configuration",void 0);var n=p3(t);if(!r)throw new Error("No clientKey available");this.storage=new J2("session","localStorage"),this.clientKey=r,this.loadingContext=a,this.session=n,this.session.sessionData?this.storeSession():this.session=this.getStoredSession()}return qg(e,[{key:"id",get:function(){return this.session.id}},{key:"data",get:function(){return this.session.sessionData}},{key:"updateSessionData",value:function(e){this.session.sessionData=e,this.storeSession()}},{key:"setupSession",value:function(e){var t=this;return c3(this,e).then((function(e){return e.configuration&&(t.configuration=function(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=f3(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=f3(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}({},e.configuration)),e}))}},{key:"submitPayment",value:function(e){var t=this;return n3(e,this).then((function(e){return e.sessionData&&t.updateSessionData(e.sessionData),e}))}},{key:"submitDetails",value:function(e){var t=this;return i3(e,this).then((function(e){return e.sessionData&&t.updateSessionData(e.sessionData),e}))}},{key:"checkBalance",value:function(e){var t=this;return u3(e,this).then((function(e){return e.sessionData&&t.updateSessionData(e.sessionData),e}))}},{key:"createOrder",value:function(){var e=this;return function(e){var t,r,a=Bb(t=Bb(r="".concat(r3,"/sessions/")).call(r,e.id,"/orders?clientKey=")).call(t,e.clientKey),n={sessionData:e.data};return UB({loadingContext:e.loadingContext,path:a,errorLevel:"fatal"},n)}(this).then((function(t){return t.sessionData&&e.updateSessionData(t.sessionData),t}))}},{key:"cancelOrder",value:function(e){var t=this;return function(e,t){var r,a,n=Bb(r=Bb(a="".concat(r3,"/sessions/")).call(a,t.id,"/orders/cancel?clientKey=")).call(r,t.clientKey),o={sessionData:t.data,order:e};return UB({loadingContext:t.loadingContext,path:n,errorLevel:"fatal"},o)}(e.order,this).then((function(e){return e.sessionData&&t.updateSessionData(e.sessionData),e}))}},{key:"getStoredSession",value:function(){var e=this.storage.get();return this.id===(null==e?void 0:e.id)?e:this.session}},{key:"storeSession",value:function(){this.storage.set({id:this.session.id,sessionData:this.session.sessionData})}},{key:"removeStoredSession",value:function(){this.storage.remove()}}]),e}();function h3(e,t){var r=Jy(e);if(Xy){var a=Xy(e);t&&(a=nb(a).call(a,(function(t){return pg(e,t).enumerable}))),r.push.apply(r,a)}return r}function v3(e){for(var t=1;t<arguments.length;t++){var r,a,n=null!=arguments[t]?arguments[t]:{};t%2?Jg(r=h3(Object(n),!0)).call(r,(function(t){Wg(e,t,n[t])})):kg?Ig(e,kg(n)):Jg(a=h3(Object(n))).call(a,(function(t){Og(e,t,pg(n,t))}))}return e}var y3=function(){function e(t){var r,a,n=this;Bg(this,e),Wg(this,"session",void 0),Wg(this,"paymentMethodsResponse",void 0),Wg(this,"modules",void 0),Wg(this,"options",void 0),Wg(this,"components",[]),Wg(this,"update",(function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};return n.setOptions(e),n.initialize().then((function(){var e;return Jg(e=n.components).call(e,(function(e){return e.update(n.getPropsForComponent(n.options))})),n}))})),Wg(this,"remove",(function(e){var t;return n.components=nb(t=n.components).call(t,(function(t){return t._id!==e._id})),e.unmount(),n})),Wg(this,"setOptions",(function(e){var t,r,a;lA(null==e?void 0:e.paymentMethodsConfiguration,"scheme")&&console.warn('WARNING: You cannot define a property "scheme" on the paymentMethodsConfiguration object - it should be defined as "card" otherwise it will be ignored'),n.options=v3(v3({},n.options),e),n.options.loadingContext=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"https://checkoutshopper-live.adyen.com/checkoutshopper/",t={test:"https://checkoutshopper-test.adyen.com/checkoutshopper/",live:"https://checkoutshopper-live.adyen.com/checkoutshopper/","live-us":"https://checkoutshopper-live-us.adyen.com/checkoutshopper/","live-au":"https://checkoutshopper-live-au.adyen.com/checkoutshopper/","live-apse":"https://checkoutshopper-live-apse.adyen.com/checkoutshopper/","live-in":"https://checkoutshopper-live-in.adyen.com/checkoutshopper/"};return t[e]||t[e.toLowerCase()]||e}(n.options.environment),n.options.locale=n.options.locale||n.options.shopperLocale,n.modules={risk:new MA(n.options),analytics:new e3(n.options),i18n:new L_(n.options.locale,n.options.translations)},n.paymentMethodsResponse=new M2(null!==(t=n.options.paymentMethodsResponse)&&void 0!==t?t:n.options.paymentMethods,n.options),delete n.options.paymentMethods;var o,i=null===(r=n.options.clientKey)||void 0===r?void 0:r.substr(0,4);if(("test"===i||"live"===i)&&!Eb(a=n.options.loadingContext).call(a,i))throw new Error(Bb(o="Error: you are using a ".concat(i," clientKey against the ")).call(o,n.options.environment," environment"));return n})),this.create=rk(r=this.create).call(r,this),this.createFromAction=rk(a=this.createFromAction).call(a,this),this.setOptions(t),window.adyenWebVersion=e.version.version}return qg(e,[{key:"initialize",value:function(){var e=this;return this.options.session?(this.session=new m3(this.options.session,this.options.clientKey,this.options.loadingContext),this.session.setupSession(this.options).then((function(t){var r=e.options.order?e.options.order.remainingAmount:t.amount;return e.setOptions(v3(v3({},t),{},{amount:r})),e})).catch((function(t){return e.options.onError&&e.options.onError(t),e}))):ok.resolve(this)}},{key:"submitPayment",value:function(e){var t=this;if(this.options.onSubmit)return this.options.onSubmit(e);this.session&&this.session.submitPayment(e).then((function(e){e.action?t.options.onPaymentSubmitted&&t.options.onPaymentSubmitted(e,t):t.options.onPaymentCompleted&&t.options.onPaymentCompleted(e,t)})).catch((function(e){t.options.onError&&t.options.onError(e)}))}},{key:"submitDetails",value:function(e){var t=this;if(this.options.onAdditionalDetails)return this.options.onAdditionalDetails(e);this.session&&this.session.submitDetails(e).then((function(e){t.options.onPaymentCompleted&&t.options.onPaymentCompleted(e,t)})).catch((function(e){t.options.onError&&t.options.onError(e,t)}))}},{key:"create",value:function(e,t){var r=this.getPropsForComponent(t);return e?this.handleCreate(e,r):this.handleCreateError()}},{key:"createFromAction",value:function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};if(!e||!e.type){if(lA(e,"action")&&lA(e,"resultCode"))throw new Error('createFromAction::Invalid Action - the passed action object itself has an "action" property and a "resultCode": have you passed in the whole response object by mistake?');throw new Error('createFromAction::Invalid Action - the passed action object does not have a "type" property')}if(e.type){var r=D2(e.type,this.options.paymentMethodsConfiguration);return function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=K2[e.type];if(r&&"function"==typeof r)return r(e,t);throw new Error("Invalid Action")}(e,v3(v3(v3({},t3(this.options)),r),this.getPropsForComponent(t)))}return this.handleCreateError()}},{key:"getPropsForComponent",value:function(e){return v3(v3({paymentMethods:this.paymentMethodsResponse.paymentMethods,storedPaymentMethods:this.paymentMethodsResponse.storedPaymentMethods},e),{},{i18n:this.modules.i18n,modules:this.modules,session:this.session,createFromAction:this.createFromAction,_parentInstance:this})}},{key:"handleCreate",value:function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};if(e.prototype instanceof dA){var r,a="dropin"!==t.type&&!t.isDropin,n=a&&!t.supportedShopperInteractions?yk(r=this.paymentMethodsResponse).call(r,t.type):{},o=a?D2(t.type,this.options.paymentMethodsConfiguration,!!t.storedPaymentMethodId):{},i=new e(v3(v3(v3(v3({},t3(this.options)),n),o),t));return t.isDropin||this.components.push(i),i}if("string"==typeof e&&E2[e])return this.handleCreate(E2[e],v3({type:e},t));if("string"==typeof e&&this.paymentMethodsResponse.has(e))return this.handleCreate(E2.redirect,v3({type:e},t));if("object"===Tg(e)&&"string"==typeof e.type){var l=D2(e.type,this.options.paymentMethodsConfiguration,!!e.storedPaymentMethodId);return this.handleCreate(e.type,v3(v3(v3({},e),t),l))}return this.handleCreateError(e)}},{key:"handleCreateError",value:function(e){var t=e&&e.name?e.name:"The passed payment method",r=e?"".concat(t," is not a valid Checkout Component"):"No Payment Method component was passed";throw new Error(r)}}]),e}();function g3(){return g3=$d(Ky.mark((function e(t){var r;return Ky.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return r=new y3(t),e.next=3,r.initialize();case 3:return e.abrupt("return",e.sent);case 4:case"end":return e.stop()}}),e)}))),g3.apply(this,arguments)}Wg(y3,"version",{version:"5.36.0",revision:"6e73d47",branch:"master",buildId:"@adyen/adyen-web-31d50ab6-92c0-4220-bda2-70ed95468725"});var b3=Object.freeze({__proto__:null,default:{payButton:"\u062f\u0641\u0639","payButton.redirecting":"\u062c\u0627\u0631\u0650 \u0625\u0639\u0627\u062f\u0629 \u0627\u0644\u062a\u0648\u062c\u064a\u0647...","payButton.with":"\u0627\u062f\u0641\u0639 %{value} \u0628\u0627\u0633\u062a\u062e\u062f\u0627\u0645 %{maskedData}",close:"\u0625\u063a\u0644\u0627\u0642",storeDetails:"\u062d\u0641\u0638 \u0644\u0645\u062f\u0641\u0648\u0639\u0627\u062a\u064a \u0627\u0644\u0642\u0627\u062f\u0645\u0629","creditCard.holderName":"\u0627\u0644\u0627\u0633\u0645 \u0639\u0644\u0649 \u0627\u0644\u0628\u0637\u0627\u0642\u0629","creditCard.holderName.placeholder":"\u062c\u0645\u064a\u0644 \u0633\u0639\u064a\u062f","creditCard.holderName.invalid":"\u0627\u0633\u0645 \u0635\u0627\u062d\u0628 \u0628\u0637\u0627\u0642\u0629 \u063a\u064a\u0631 \u0635\u062d\u064a\u062d","creditCard.numberField.title":"\u0631\u0642\u0645 \u0627\u0644\u0628\u0637\u0627\u0642\u0629","creditCard.numberField.placeholder":"3456 9012 5678 1234","creditCard.expiryDateField.title":"\u062a\u0627\u0631\u064a\u062e \u0627\u0644\u0627\u0646\u062a\u0647\u0627\u0621","creditCard.expiryDateField.placeholder":"\u0634\u0647\u0631/\u0633\u0646\u0629","creditCard.expiryDateField.month":"\u0634\u0647\u0631","creditCard.expiryDateField.month.placeholder":"\u0634\u0647\u0631","creditCard.expiryDateField.year.placeholder":"\u0633\u0646\u0629","creditCard.expiryDateField.year":"\u0633\u0646\u0629","creditCard.cvcField.title":"\u0631\u0645\u0632 CVC / CVV","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"\u0627\u062d\u062a\u0641\u0638 \u0628\u0627\u0644\u0628\u064a\u0627\u0646\u0627\u062a \u0644\u0644\u0645\u0631\u0629 \u0627\u0644\u0642\u0627\u062f\u0645\u0629","creditCard.cvcField.placeholder.4digits":"4 \u0623\u0631\u0642\u0627\u0645","creditCard.cvcField.placeholder.3digits":"3 \u0623\u0631\u0642\u0627\u0645","creditCard.taxNumber.placeholder":"\u064a\u0648\u0645 \u0634\u0647\u0631 \u0633\u0646\u0629 / 0123456789",installments:"\u0639\u062f\u062f \u0627\u0644\u0623\u0642\u0633\u0627\u0637",installmentOption:"%{times} x %{partialValue}",installmentOptionMonths:"%{times} \u0623\u0634\u0647\u0631","installments.oneTime":"\u0627\u0644\u062f\u0641\u0639 \u0645\u0631\u0629 \u0648\u0627\u062d\u062f\u0629","installments.installments":"\u0627\u0644\u062f\u0641\u0639 \u0639\u0644\u0649 \u0623\u0642\u0633\u0627\u0637","installments.revolving":"\u0627\u0644\u062f\u0641\u0639 \u0627\u0644\u062f\u0648\u0631\u064a","sepaDirectDebit.ibanField.invalid":"\u0631\u0642\u0645 \u062d\u0633\u0627\u0628 \u063a\u064a\u0631 \u0635\u062d\u064a\u062d","sepaDirectDebit.nameField.placeholder":"\u062c\u0645\u064a\u0644 \u0633\u0639\u064a\u062f","sepa.ownerName":"\u0635\u0627\u062d\u0628 \u0627\u0644\u062d\u0633\u0627\u0628","sepa.ibanNumber":"\u0631\u0642\u0645 \u0627\u0644\u062d\u0633\u0627\u0628 (IBAN)","error.title":"\u062e\u0637\u0623","error.subtitle.redirect":"\u0641\u0634\u0644 \u0625\u0639\u0627\u062f\u0629 \u0627\u0644\u062a\u0648\u062c\u064a\u0647","error.subtitle.payment":"\u0641\u0634\u0644 \u0627\u0644\u062f\u0641\u0639","error.subtitle.refused":"\u062a\u0645 \u0631\u0641\u0636 \u0627\u0644\u062f\u0641\u0639","error.message.unknown":"\u062d\u062f\u062b \u062e\u0637\u0623 \u063a\u064a\u0631 \u0645\u0639\u0631\u0648\u0641","errorPanel.title":"\u0627\u0644\u0623\u062e\u0637\u0627\u0621 \u0627\u0644\u0645\u0648\u062c\u0648\u062f\u0629","idealIssuer.selectField.title":"\u0627\u0644\u0628\u0646\u0643","idealIssuer.selectField.placeholder":"\u062d\u062f\u062f \u0627\u0644\u0628\u0646\u0643 \u0627\u0644\u0630\u064a \u062a\u062a\u0639\u0627\u0645\u0644 \u0645\u0639\u0647","creditCard.success":"\u0646\u062c\u062d \u0627\u0644\u062f\u0641\u0639",loading:"\u062c\u0627\u0631\u0650 \u0627\u0644\u062a\u062d\u0645\u064a\u0644...",continue:"\u0645\u062a\u0627\u0628\u0639\u0629",continueTo:"\u0645\u062a\u0627\u0628\u0639\u0629 \u0625\u0644\u0649","wechatpay.timetopay":"\u0644\u062f\u064a\u0643 %@ \u0644\u0644\u062f\u0641\u0639","wechatpay.scanqrcode":"\u0645\u0633\u062d \u0631\u0645\u0632 \u0627\u0644\u0627\u0633\u062a\u062c\u0627\u0628\u0629 \u0627\u0644\u0633\u0631\u064a\u0639\u0629",personalDetails:"\u0627\u0644\u0628\u064a\u0627\u0646\u0627\u062a \u0627\u0644\u0634\u062e\u0635\u064a\u0629",companyDetails:"\u0628\u064a\u0627\u0646\u0627\u062a \u0627\u0644\u0634\u0631\u0643\u0629","companyDetails.name":"\u0627\u0633\u0645 \u0627\u0644\u0634\u0631\u0643\u0629","companyDetails.registrationNumber":"\u0631\u0642\u0645 \u0627\u0644\u062a\u0633\u062c\u064a\u0644",socialSecurityNumber:"\u0631\u0642\u0645 \u0627\u0644\u0636\u0645\u0627\u0646 \u0627\u0644\u0627\u062c\u062a\u0645\u0627\u0639\u064a",firstName:"\u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0623\u0648\u0644","firstName.invalid":"\u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0623\u0648\u0644 \u063a\u064a\u0631 \u0635\u062d\u064a\u062d",infix:"\u0628\u0627\u062f\u0626\u0629",lastName:"\u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0623\u062e\u064a\u0631","lastName.invalid":"\u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0623\u062e\u064a\u0631 \u063a\u064a\u0631 \u0635\u062d\u064a\u062d",mobileNumber:"\u0631\u0642\u0645 \u0627\u0644\u062c\u0648\u0627\u0644","mobileNumber.invalid":"\u0631\u0642\u0645 \u062c\u0648\u0627\u0644 \u063a\u064a\u0631 \u0635\u062d\u064a\u062d",city:"\u0627\u0644\u0645\u062f\u064a\u0646\u0629",postalCode:"\u0627\u0644\u0631\u0645\u0632 \u0627\u0644\u0628\u0631\u064a\u062f\u064a","postalCode.optional":"\u0627\u0644\u0631\u0645\u0632 \u0627\u0644\u0628\u0631\u064a\u062f\u064a (\u0627\u062e\u062a\u064a\u0627\u0631\u064a)",countryCode:"\u0631\u0645\u0632 \u0627\u0644\u0628\u0644\u062f",telephoneNumber:"\u0631\u0642\u0645 \u0627\u0644\u0647\u0627\u062a\u0641",dateOfBirth:"\u062a\u0627\u0631\u064a\u062e \u0627\u0644\u0645\u064a\u0644\u0627\u062f",shopperEmail:"\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0628\u0631\u064a\u062f \u0627\u0644\u0625\u0644\u0643\u062a\u0631\u0648\u0646\u064a",gender:"\u0627\u0644\u0646\u0648\u0639",male:"\u0630\u0643\u0631",female:"\u0623\u0646\u062b\u0649",billingAddress:"\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0641\u0648\u0627\u062a\u064a\u0631",street:"\u0627\u0644\u0634\u0627\u0631\u0639",stateOrProvince:"\u0627\u0644\u0648\u0644\u0627\u064a\u0629 \u0623\u0648 \u0627\u0644\u0645\u0642\u0627\u0637\u0639\u0629",country:"\u0627\u0644\u0628\u0644\u062f",houseNumberOrName:"\u0631\u0642\u0645 \u0627\u0644\u0645\u0646\u0632\u0644",separateDeliveryAddress:"\u062d\u062f\u062f \u0639\u0646\u0648\u0627\u0646 \u062a\u0633\u0644\u064a\u0645 \u0645\u0646\u0641\u0635\u0644",deliveryAddress:"\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u062a\u0633\u0644\u064a\u0645",zipCode:"\u0627\u0644\u0631\u0645\u0632 \u0627\u0644\u0628\u0631\u064a\u062f\u064a",apartmentSuite:"\u0627\u0644\u0634\u0642\u0629 / \u0627\u0644\u062c\u0646\u0627\u062d",provinceOrTerritory:"\u0627\u0644\u0645\u0642\u0627\u0637\u0639\u0629 \u0623\u0648 \u0627\u0644\u0625\u0642\u0644\u064a\u0645",cityTown:"\u0627\u0644\u0645\u062f\u064a\u0646\u0629 / \u0627\u0644\u0628\u0644\u062f\u0629",address:"\u0627\u0644\u0639\u0646\u0648\u0627\u0646",state:"\u0627\u0644\u0648\u0644\u0627\u064a\u0629","field.title.optional":"(\u0627\u062e\u062a\u064a\u0627\u0631\u064a)","creditCard.cvcField.title.optional":"\u0631\u0645\u0632 CVC / CVV (\u0627\u062e\u062a\u064a\u0627\u0631\u064a)","issuerList.wallet.placeholder":"\u062d\u062f\u062f \u0645\u062d\u0641\u0638\u062a\u0643",privacyPolicy:"\u0633\u064a\u0627\u0633\u0629 \u0627\u0644\u062e\u0635\u0648\u0635\u064a\u0629","afterPay.agreement":"\u0623\u0648\u0627\u0641\u0642 \u0639\u0644\u0649 %@ \u0644\u0634\u0631\u0643\u0629 AfterPay",paymentConditions:"\u0634\u0631\u0648\u0637 \u0627\u0644\u062f\u0641\u0639",openApp:"\u0641\u062a\u062d \u0627\u0644\u062a\u0637\u0628\u064a\u0642","voucher.readInstructions":"\u0642\u0631\u0627\u0621\u0629 \u0627\u0644\u062a\u0639\u0644\u064a\u0645\u0627\u062a","voucher.introduction":"\u0634\u0643\u0631\u064b\u0627 \u0644\u0643 \u0639\u0644\u0649 \u0634\u0631\u0627\u0626\u0643\u060c \u064a\u0631\u062c\u0649 \u0627\u0633\u062a\u062e\u062f\u0627\u0645 \u0627\u0644\u0642\u0633\u064a\u0645\u0629 \u0627\u0644\u062a\u0627\u0644\u064a\u0629 \u0644\u0625\u062a\u0645\u0627\u0645 \u0639\u0645\u0644\u064a\u0629 \u0627\u0644\u062f\u0641\u0639.","voucher.expirationDate":"\u062a\u0627\u0631\u064a\u062e \u0627\u0644\u0627\u0646\u062a\u0647\u0627\u0621","voucher.alternativeReference":"\u0627\u0644\u0645\u0631\u062c\u0639 \u0627\u0644\u0628\u062f\u064a\u0644","dragonpay.voucher.non.bank.selectField.placeholder":"\u062d\u062f\u062f \u0645\u0642\u062f\u0645 \u0627\u0644\u062e\u062f\u0645\u0629","dragonpay.voucher.bank.selectField.placeholder":"\u062d\u062f\u062f \u0627\u0644\u0628\u0646\u0643 \u0627\u0644\u0630\u064a \u062a\u062a\u0639\u0627\u0645\u0644 \u0645\u0639\u0647","voucher.paymentReferenceLabel":"\u0645\u0631\u062c\u0639 \u0627\u0644\u062f\u0641\u0639","voucher.surcharge":"\u0628\u0645\u0627 \u0641\u064a \u0630\u0644\u0643 %@ \u0631\u0633\u0645\u064b\u0627 \u0625\u0636\u0627\u0641\u064a\u064b\u0627","voucher.introduction.doku":"\u0634\u0643\u0631\u064b\u0627 \u0644\u0643 \u0639\u0644\u0649 \u0634\u0631\u0627\u0626\u0643\u060c \u064a\u0631\u062c\u0649 \u0627\u0633\u062a\u062e\u062f\u0627\u0645 \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062a \u0627\u0644\u062a\u0627\u0644\u064a\u0629 \u0644\u0625\u062a\u0645\u0627\u0645 \u0639\u0645\u0644\u064a\u0629 \u0627\u0644\u062f\u0641\u0639.","voucher.shopperName":"\u0627\u0633\u0645 \u0627\u0644\u0645\u062a\u0633\u0648\u0642","voucher.merchantName":"\u0627\u0644\u062a\u0627\u062c\u0631","voucher.introduction.econtext":"\u0634\u0643\u0631\u064b\u0627 \u0644\u0643 \u0639\u0644\u0649 \u0634\u0631\u0627\u0626\u0643\u060c \u064a\u0631\u062c\u0649 \u0627\u0633\u062a\u062e\u062f\u0627\u0645 \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062a \u0627\u0644\u062a\u0627\u0644\u064a\u0629 \u0644\u0625\u062a\u0645\u0627\u0645 \u0639\u0645\u0644\u064a\u0629 \u0627\u0644\u062f\u0641\u0639.","voucher.telephoneNumber":"\u0631\u0642\u0645 \u0627\u0644\u0647\u0627\u062a\u0641","voucher.shopperReference":"\u0645\u0631\u062c\u0639 \u0627\u0644\u0645\u062a\u0633\u0648\u0642","voucher.collectionInstitutionNumber":"\u0631\u0642\u0645 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0627\u0644\u0645\u0643\u0644\u0641\u0629 \u0628\u0627\u0644\u062a\u062d\u0635\u064a\u0644","voucher.econtext.telephoneNumber.invalid":"\u064a\u062c\u0628 \u0623\u0646 \u064a\u0643\u0648\u0646 \u0631\u0642\u0645 \u0627\u0644\u0647\u0627\u062a\u0641 \u0628\u0637\u0648\u0644 10 \u0623\u0648 11 \u0631\u0642\u0645\u064b\u0627","boletobancario.btnLabel":"\u0625\u0646\u0634\u0627\u0621 \u0637\u0631\u064a\u0642\u0629 \u062f\u0641\u0639 Boleto","boleto.sendCopyToEmail":"\u0625\u0631\u0633\u0627\u0644 \u0646\u0633\u062e\u0629 \u0625\u0644\u0649 \u0628\u0631\u064a\u062f\u064a \u0627\u0644\u0625\u0644\u0643\u062a\u0631\u0648\u0646\u064a","button.copy":"\u0646\u0633\u062e","button.download":"\u062a\u0646\u0632\u064a\u0644","boleto.socialSecurityNumber.invalid":"\u0627\u0644\u062d\u0642\u0644 \u063a\u064a\u0631 \u0635\u062d\u064a\u062d","creditCard.storedCard.description.ariaLabel":"\u062a\u0646\u062a\u0647\u064a \u0627\u0644\u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0645\u062e\u0632\u0646\u0629 \u0641\u064a %@","voucher.entity":"\u0627\u0644\u0643\u064a\u0627\u0646",donateButton:"\u0627\u0644\u062a\u0628\u0631\u0639",notNowButton:"\u0644\u064a\u0633 \u0627\u0644\u0622\u0646",thanksForYourSupport:"\u0634\u0643\u0631\u064b\u0627 \u0639\u0644\u0649 \u062f\u0639\u0645\u0643!",preauthorizeWith:"\u062a\u0641\u0648\u064a\u0636 \u0645\u0633\u0628\u0642 \u0628\u0627\u0633\u062a\u062e\u062f\u0627\u0645",confirmPreauthorization:"\u062a\u0623\u0643\u064a\u062f \u0627\u0644\u062a\u0641\u0648\u064a\u0636 \u0627\u0644\u0645\u0633\u0628\u0642",confirmPurchase:"\u062a\u0623\u0643\u064a\u062f \u0627\u0644\u0634\u0631\u0627\u0621",applyGiftcard:"\u0627\u0633\u062a\u0631\u062f\u0627\u062f",giftcardBalance:"\u0631\u0635\u064a\u062f \u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0647\u062f\u0627\u064a\u0627",deductedBalance:"\u0627\u0644\u0631\u0635\u064a\u062f \u0627\u0644\u0645\u062e\u0635\u0648\u0645","creditCard.pin.title":"\u0631\u0642\u0645 \u0627\u0644\u062a\u0639\u0631\u064a\u0641 \u0627\u0644\u0634\u062e\u0635\u064a","creditCard.encryptedPassword.label":"\u0623\u0648\u0644 \u0631\u0642\u0645\u0627\u0646 \u0645\u0646 \u0643\u0644\u0645\u0629 \u0645\u0631\u0648\u0631 \u0627\u0644\u0628\u0637\u0627\u0642\u0629","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"\u0643\u0644\u0645\u0629 \u0645\u0631\u0648\u0631 \u063a\u064a\u0631 \u0635\u062d\u064a\u062d\u0629","creditCard.taxNumber":"\u062a\u0627\u0631\u064a\u062e \u0645\u064a\u0644\u0627\u062f \u062d\u0627\u0645\u0644 \u0627\u0644\u0628\u0637\u0627\u0642\u0629 \u0623\u0648 \u0631\u0642\u0645 \u062a\u0633\u062c\u064a\u0644 \u0627\u0644\u0634\u0631\u0643\u0629","creditCard.taxNumber.label":"\u062a\u0627\u0631\u064a\u062e \u0645\u064a\u0644\u0627\u062f \u062d\u0627\u0645\u0644 \u0627\u0644\u0628\u0637\u0627\u0642\u0629 (\u064a\u0648\u0645 \u0634\u0647\u0631 \u0633\u0646\u0629) \u0623\u0648 \u0631\u0642\u0645 \u062a\u0633\u062c\u064a\u0644 \u0627\u0644\u0634\u0631\u0643\u0629 (10 \u0623\u0631\u0642\u0627\u0645)","creditCard.taxNumber.labelAlt":"\u0631\u0642\u0645 \u062a\u0633\u062c\u064a\u0644 \u0627\u0644\u0634\u0631\u0643\u0629 (10 \u0623\u0631\u0642\u0627\u0645)","creditCard.taxNumber.invalid":"\u062a\u0627\u0631\u064a\u062e \u0645\u064a\u0644\u0627\u062f \u062d\u0627\u0645\u0644 \u0627\u0644\u0628\u0637\u0627\u0642\u0629 \u0623\u0648 \u0631\u0642\u0645 \u062a\u0633\u062c\u064a\u0644 \u0627\u0644\u0634\u0631\u0643\u0629 \u063a\u064a\u0631 \u0635\u062d\u064a\u062d","storedPaymentMethod.disable.button":"\u0625\u0632\u0627\u0644\u0629","storedPaymentMethod.disable.confirmation":"\u0625\u0632\u0627\u0644\u0629 \u0637\u0631\u064a\u0642\u0629 \u0627\u0644\u062f\u0641\u0639 \u0627\u0644\u0645\u062e\u0632\u0646\u0629","storedPaymentMethod.disable.confirmButton":"\u0646\u0639\u0645\u060c \u0623\u0631\u063a\u0628 \u0641\u064a \u0625\u0632\u0627\u0644\u062a\u0647\u0627","storedPaymentMethod.disable.cancelButton":"\u0625\u0644\u063a\u0627\u0621","ach.bankAccount":"\u0627\u0644\u062d\u0633\u0627\u0628 \u0627\u0644\u0628\u0646\u0643\u064a","ach.accountHolderNameField.title":"\u0627\u0633\u0645 \u0635\u0627\u062d\u0628 \u0627\u0644\u062d\u0633\u0627\u0628","ach.accountHolderNameField.placeholder":"\u062c\u0645\u064a\u0644 \u0633\u0639\u064a\u062f","ach.accountHolderNameField.invalid":"\u0627\u0633\u0645 \u0635\u0627\u062d\u0628 \u062d\u0633\u0627\u0628 \u063a\u064a\u0631 \u0635\u062d\u064a\u062d","ach.accountNumberField.title":"\u0631\u0642\u0645 \u0627\u0644\u062d\u0633\u0627\u0628","ach.accountNumberField.invalid":"\u0631\u0642\u0645 \u062d\u0633\u0627\u0628 \u063a\u064a\u0631 \u0635\u062d\u064a\u062d","ach.accountLocationField.title":"\u0631\u0642\u0645 \u062a\u0648\u062c\u064a\u0647 ABA","ach.accountLocationField.invalid":"\u0631\u0642\u0645 \u062a\u0648\u062c\u064a\u0647 ABA \u063a\u064a\u0631 \u0635\u062d\u064a\u062d","ach.savedBankAccount":"\u0627\u0644\u062d\u0633\u0627\u0628 \u0627\u0644\u0628\u0646\u0643\u064a \u0627\u0644\u0645\u062d\u0641\u0648\u0638","select.state":"\u062d\u062f\u062f \u0627\u0644\u0648\u0644\u0627\u064a\u0629","select.stateOrProvince":"\u062d\u062f\u062f \u0627\u0644\u0648\u0644\u0627\u064a\u0629 \u0623\u0648 \u0627\u0644\u0645\u0642\u0627\u0637\u0639\u0629","select.provinceOrTerritory":"\u062d\u062f\u062f \u0627\u0644\u0645\u0642\u0627\u0637\u0639\u0629 \u0623\u0648 \u0627\u0644\u0625\u0642\u0644\u064a\u0645","select.country":"\u062d\u062f\u062f \u0627\u0644\u0628\u0644\u062f","select.noOptionsFound":"\u0644\u0627 \u062a\u0648\u062c\u062f \u062e\u064a\u0627\u0631\u0627\u062a","select.filter.placeholder":"\u0628\u062d\u062b...","telephoneNumber.invalid":"\u0631\u0642\u0645 \u0647\u0627\u062a\u0641 \u063a\u064a\u0631 \u0635\u062d\u064a\u062d",qrCodeOrApp:"\u0623\u0648","paypal.processingPayment":"\u062c\u0627\u0631\u0650 \u0645\u0639\u0627\u0644\u062c\u0629 \u0627\u0644\u0645\u062f\u0641\u0648\u0639\u0627\u062a...",generateQRCode:"\u0625\u0646\u0634\u0627\u0621 \u0631\u0645\u0632 \u0627\u0633\u062a\u062c\u0627\u0628\u0629 \u0633\u0631\u064a\u0639\u0629","await.waitForConfirmation":"\u0641\u064a \u0627\u0646\u062a\u0638\u0627\u0631 \u0627\u0644\u062a\u0623\u0643\u064a\u062f","mbway.confirmPayment":"\u062a\u0623\u0643\u064a\u062f \u0627\u0644\u062f\u0641\u0639 \u0639\u0644\u0649 \u062a\u0637\u0628\u064a\u0642 MB WAY","shopperEmail.invalid":"\u0639\u0646\u0648\u0627\u0646 \u0628\u0631\u064a\u062f \u0625\u0644\u0643\u062a\u0631\u0648\u0646\u064a \u063a\u064a\u0631 \u0635\u062d\u064a\u062d","dateOfBirth.format":"\u064a\u0648\u0645/\u0634\u0647\u0631/\u0633\u0646\u0629","dateOfBirth.invalid":"\u064a\u062c\u0628 \u0623\u0644\u0627 \u064a\u0642\u0644 \u0639\u0645\u0631\u0643 \u0639\u0646 18 \u0639\u0627\u0645\u064b\u0627","blik.confirmPayment":"\u0627\u0641\u062a\u062d \u062a\u0637\u0628\u064a\u0642\u0643 \u0627\u0644\u0628\u0646\u0643\u064a \u0644\u062a\u0623\u0643\u064a\u062f \u0627\u0644\u062f\u0641\u0639.","blik.invalid":"\u0623\u062f\u062e\u0644 6 \u0623\u0631\u0642\u0627\u0645","blik.code":"\u0631\u0645\u0632 \u0645\u0643\u0648\u0646 \u0645\u0646 6 \u0623\u0631\u0642\u0627\u0645","blik.help":"\u0627\u062d\u0635\u0644 \u0639\u0644\u0649 \u0627\u0644\u0631\u0645\u0632 \u0645\u0646 \u062a\u0637\u0628\u064a\u0642\u0643 \u0627\u0644\u0628\u0646\u0643\u064a.","swish.pendingMessage":"\u0628\u0639\u062f \u0642\u064a\u0627\u0645\u0643 \u0628\u0645\u0633\u062d \u0631\u0645\u0632 \u0627\u0644\u0627\u0633\u062a\u062c\u0627\u0628\u0629 \u0627\u0644\u0633\u0631\u064a\u0639\u0629 \u0636\u0648\u0626\u064a\u064b\u0627\u060c \u064a\u0645\u0643\u0646 \u0623\u0646 \u062a\u0638\u0644 \u0627\u0644\u062d\u0627\u0644\u0629 \u0645\u0639\u0644\u0642\u0629 \u0644\u0645\u062f\u0629 \u062a\u0635\u0644 \u0625\u0644\u0649 10 \u062f\u0642\u0627\u0626\u0642. \u0642\u062f \u062a\u0624\u062f\u064a \u0645\u062d\u0627\u0648\u0644\u0629 \u0627\u0644\u062f\u0641\u0639 \u0645\u0631\u0629 \u0623\u062e\u0631\u0649 \u062e\u0644\u0627\u0644 \u0647\u0630\u0627 \u0627\u0644\u0648\u0642\u062a \u0625\u0644\u0649 \u0641\u0631\u0636 \u0631\u0633\u0648\u0645 \u0645\u062a\u0639\u062f\u062f\u0629.","field.valid":"\u062d\u0642\u0644 \u0635\u062d\u064a\u062d","field.invalid":"\u062d\u0642\u0644 \u063a\u064a\u0631 \u0635\u062d\u064a\u062d","error.va.gen.01":"\u062d\u0642\u0644 \u063a\u064a\u0631 \u0645\u0643\u062a\u0645\u0644","error.va.gen.02":"\u062d\u0642\u0644 \u063a\u064a\u0631 \u0635\u062d\u064a\u062d","error.va.sf-cc-num.01":"\u0631\u0642\u0645 \u0627\u0644\u0628\u0637\u0627\u0642\u0629 \u063a\u064a\u0631 \u0635\u062d\u064a\u062d","error.va.sf-cc-num.02":"\u062d\u0642\u0644 \u0631\u0642\u0645 \u0627\u0644\u0628\u0637\u0627\u0642\u0629 \u0641\u0627\u0631\u063a","error.va.sf-cc-num.03":"\u062a\u0645 \u0625\u062f\u062e\u0627\u0644 \u0631\u0642\u0645 \u0628\u0637\u0627\u0642\u0629 \u063a\u064a\u0631 \u0645\u062f\u0639\u0648\u0645\u0629","error.va.sf-cc-num.04":"\u0637\u0648\u0644 \u0631\u0642\u0645 \u0627\u0644\u0628\u0637\u0627\u0642\u0629 \u062e\u0637\u0623","error.va.sf-cc-dat.01":"\u062a\u0627\u0631\u064a\u062e \u0627\u0646\u062a\u0647\u0627\u0621 \u0627\u0644\u0635\u0644\u0627\u062d\u064a\u0629: \u0628\u0637\u0627\u0642\u0629 \u0642\u062f\u064a\u0645\u0629 \u0644\u0644\u063a\u0627\u064a\u0629","error.va.sf-cc-dat.02":"\u062a\u0627\u0631\u064a\u062e \u0627\u0646\u062a\u0647\u0627\u0621 \u0627\u0644\u0635\u0644\u0627\u062d\u064a\u0629: \u0627\u0644\u062a\u0627\u0631\u064a\u062e \u0628\u0639\u064a\u062f \u0644\u0644\u063a\u0627\u064a\u0629 \u0641\u064a \u0627\u0644\u0645\u0633\u062a\u0642\u0628\u0644","error.va.sf-cc-dat.03":"\u062a\u0627\u0631\u064a\u062e \u0627\u0646\u062a\u0647\u0627\u0621 \u0627\u0644\u0635\u0644\u0627\u062d\u064a\u0629: \u062a\u0646\u062a\u0647\u064a \u0635\u0644\u0627\u062d\u064a\u0629 \u0628\u0637\u0627\u0642\u062a\u0643 \u0642\u0628\u0644 \u062a\u0627\u0631\u064a\u062e \u0627\u0644\u0633\u062f\u0627\u062f","error.va.sf-cc-dat.04":"\u062d\u0642\u0644 \u062a\u0627\u0631\u064a\u062e \u0627\u0646\u062a\u0647\u0627\u0621 \u0627\u0644\u0635\u0644\u0627\u062d\u064a\u0629 \u0641\u0627\u0631\u063a","error.va.sf-cc-dat.05":"\u0637\u0648\u0644 \u062a\u0627\u0631\u064a\u062e \u0627\u0646\u062a\u0647\u0627\u0621 \u0627\u0644\u0635\u0644\u0627\u062d\u064a\u0629 \u062e\u0637\u0623","error.va.sf-cc-mth.01":"\u062d\u0642\u0644 \u0634\u0647\u0631 \u0627\u0646\u062a\u0647\u0627\u0621 \u0627\u0644\u0635\u0644\u0627\u062d\u064a\u0629 \u0641\u0627\u0631\u063a","error.va.sf-cc-yr.01":"\u062d\u0642\u0644 \u0633\u0646\u0629 \u0627\u0646\u062a\u0647\u0627\u0621 \u0627\u0644\u0635\u0644\u0627\u062d\u064a\u0629 \u0641\u0627\u0631\u063a","error.va.sf-cc-yr.02":"\u0637\u0648\u0644 \u0633\u0646\u0629 \u0627\u0646\u062a\u0647\u0627\u0621 \u0627\u0644\u0635\u0644\u0627\u062d\u064a\u0629 \u062e\u0637\u0623","error.va.sf-cc-cvc.01":"\u062d\u0642\u0644 \u0631\u0645\u0632 \u0627\u0644\u0623\u0645\u0627\u0646 \u0641\u0627\u0631\u063a","error.va.sf-cc-cvc.02":"\u0637\u0648\u0644 \u0631\u0645\u0632 \u0627\u0644\u0623\u0645\u0627\u0646 \u062e\u0637\u0623","error.va.sf-ach-num.01":"\u062d\u0642\u0644 \u0631\u0642\u0645 \u0627\u0644\u062d\u0633\u0627\u0628 \u0627\u0644\u0645\u0635\u0631\u0641\u064a \u0641\u0627\u0631\u063a","error.va.sf-ach-num.02":"\u0637\u0648\u0644 \u0631\u0642\u0645 \u0627\u0644\u062d\u0633\u0627\u0628 \u0627\u0644\u0645\u0635\u0631\u0641\u064a \u062e\u0637\u0623","error.va.sf-ach-loc.01":"\u062d\u0642\u0644 \u0631\u0642\u0645 \u0627\u0644\u062a\u0648\u062c\u064a\u0647 \u0627\u0644\u0628\u0646\u0643\u064a \u0641\u0627\u0631\u063a","error.va.sf-ach-loc.02":"\u0637\u0648\u0644 \u0631\u0642\u0645 \u0627\u0644\u062a\u0648\u062c\u064a\u0647 \u0627\u0644\u0628\u0646\u0643\u064a \u062e\u0637\u0623","error.va.sf-kcp-pwd.01":"\u062d\u0642\u0644 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u0641\u0627\u0631\u063a","error.va.sf-kcp-pwd.02":"\u0637\u0648\u0644 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u062e\u0637\u0623","error.giftcard.no-balance":"\u0644\u0627 \u064a\u0648\u062c\u062f \u0631\u0635\u064a\u062f \u0628\u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0647\u062f\u0627\u064a\u0627 \u0647\u0630\u0647","error.giftcard.card-error":"\u0644\u0627 \u062a\u0648\u062c\u062f \u0628\u0633\u062c\u0644\u0627\u062a\u0646\u0627 \u0628\u0637\u0627\u0642\u0629 \u0647\u062f\u0627\u064a\u0627 \u062a\u062d\u0645\u0644 \u0647\u0630\u0627 \u0627\u0644\u0631\u0642\u0645","error.giftcard.currency-error":"\u0644\u0627 \u062a\u0633\u0631\u064a \u0628\u0637\u0627\u0642\u0627\u062a \u0627\u0644\u0647\u062f\u0627\u064a\u0627 \u0625\u0644\u0627 \u0628\u0627\u0644\u0639\u0645\u0644\u0629 \u0627\u0644\u062a\u064a \u0635\u062f\u0631\u062a \u0628\u0647\u0627","amazonpay.signout":"\u062a\u0633\u062c\u064a\u0644 \u0627\u0644\u062e\u0631\u0648\u062c \u0645\u0646 \u0645\u0648\u0642\u0639 Amazon","amazonpay.changePaymentDetails":"\u062a\u063a\u064a\u064a\u0631 \u0628\u064a\u0627\u0646\u0627\u062a \u0627\u0644\u062f\u0641\u0639","partialPayment.warning":"\u062a\u062d\u062f\u064a\u062f \u0637\u0631\u064a\u0642\u0629 \u062f\u0641\u0639 \u0623\u062e\u0631\u0649 \u0644\u062a\u0633\u062f\u064a\u062f \u0627\u0644\u0645\u0628\u0644\u063a \u0627\u0644\u0645\u062a\u0628\u0642\u064a","partialPayment.remainingBalance":"\u0633\u064a\u0628\u0644\u063a \u0627\u0644\u0631\u0635\u064a\u062f \u0627\u0644\u0645\u062a\u0628\u0642\u064a %{amount}","bankTransfer.beneficiary":"\u0627\u0644\u0645\u0633\u062a\u0641\u064a\u062f","bankTransfer.iban":"IBAN","bankTransfer.bic":"\u0643\u0648\u062f \u0627\u0644\u062a\u0639\u0631\u064a\u0641 \u0627\u0644\u0628\u0646\u0643\u064a","bankTransfer.reference":"\u0627\u0644\u0645\u0631\u062c\u0639","bankTransfer.introduction":"\u0642\u0645 \u0628\u0627\u0644\u0645\u062a\u0627\u0628\u0639\u0629 \u0644\u0625\u0646\u0634\u0627\u0621 \u0645\u062f\u0641\u0648\u0639\u0627\u062a \u062a\u062d\u0648\u064a\u0644 \u0628\u0646\u0643\u064a\u0629 \u062c\u062f\u064a\u062f\u0629. \u064a\u0645\u0643\u0646\u0643 \u0627\u0633\u062a\u062e\u062f\u0627\u0645 \u0627\u0644\u0628\u064a\u0627\u0646\u0627\u062a \u0627\u0644\u0648\u0627\u0631\u062f\u0629 \u0641\u064a \u0627\u0644\u0634\u0627\u0634\u0629 \u0627\u0644\u062a\u0627\u0644\u064a\u0629 \u0644\u0625\u062a\u0645\u0627\u0645 \u0639\u0645\u0644\u064a\u0629 \u0627\u0644\u062f\u0641\u0639.","bankTransfer.instructions":"\u0634\u0643\u0631\u064b\u0627 \u0644\u0643 \u0639\u0644\u0649 \u0634\u0631\u0627\u0626\u0643\u060c \u064a\u0631\u062c\u0649 \u0627\u0633\u062a\u062e\u062f\u0627\u0645 \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062a \u0627\u0644\u062a\u0627\u0644\u064a\u0629 \u0644\u0625\u062a\u0645\u0627\u0645 \u0639\u0645\u0644\u064a\u0629 \u0627\u0644\u062f\u0641\u0639.","bacs.accountHolderName":"\u0627\u0633\u0645 \u0635\u0627\u062d\u0628 \u0627\u0644\u062d\u0633\u0627\u0628 \u0627\u0644\u0628\u0646\u0643\u064a","bacs.accountHolderName.invalid":"\u0627\u0633\u0645 \u0635\u0627\u062d\u0628 \u062d\u0633\u0627\u0628 \u0628\u0646\u0643\u064a \u063a\u064a\u0631 \u0635\u062d\u064a\u062d","bacs.accountNumber":"\u0631\u0642\u0645 \u0627\u0644\u062d\u0633\u0627\u0628 \u0627\u0644\u0628\u0646\u0643\u064a","bacs.accountNumber.invalid":"\u0631\u0642\u0645 \u062d\u0633\u0627\u0628 \u0628\u0646\u0643\u064a \u063a\u064a\u0631 \u0635\u062d\u064a\u062d","bacs.bankLocationId":"\u0631\u0645\u0632 \u062a\u0639\u0631\u064a\u0641 \u0627\u0644\u0628\u0646\u0643","bacs.bankLocationId.invalid":"\u0631\u0645\u0632 \u062a\u0639\u0631\u064a\u0641 \u0628\u0646\u0643 \u063a\u064a\u0631 \u0635\u062d\u064a\u062d","bacs.consent.amount":"\u0623\u0648\u0627\u0641\u0642 \u0639\u0644\u0649 \u062e\u0635\u0645 \u0627\u0644\u0645\u0628\u0644\u063a \u0623\u0639\u0644\u0627\u0647 \u0645\u0646 \u062d\u0633\u0627\u0628\u064a \u0627\u0644\u0628\u0646\u0643\u064a.","bacs.consent.account":"\u0623\u0624\u0643\u062f \u0623\u0646 \u0627\u0644\u062d\u0633\u0627\u0628 \u0628\u0627\u0633\u0645\u064a \u0648\u0623\u0646\u0627 \u0648\u062d\u062f\u064a \u0635\u0627\u062d\u0628 \u0627\u0644\u062a\u0648\u0642\u064a\u0639 \u0627\u0644\u0645\u0637\u0627\u0644\u0628 \u0628\u0627\u0644\u0625\u0630\u0646 \u0628\u0627\u0644\u062e\u0635\u0645 \u0627\u0644\u0645\u0628\u0627\u0634\u0631 \u0641\u064a \u0647\u0630\u0627 \u0627\u0644\u062d\u0633\u0627\u0628.",edit:"\u062a\u062d\u0631\u064a\u0631","bacs.confirm":"\u062a\u0623\u0643\u064a\u062f \u0648\u062f\u0641\u0639","bacs.result.introduction":"\u062a\u0646\u0632\u064a\u0644 \u062a\u0639\u0644\u064a\u0645\u0627\u062a \u0627\u0644\u062e\u0635\u0645 \u0627\u0644\u0645\u0628\u0627\u0634\u0631 (\u062a\u0639\u0644\u064a\u0645\u0627\u062a / \u062a\u0641\u0648\u064a\u0636 DDI)","download.pdf":"\u062a\u0646\u0632\u064a\u0644 \u0645\u0644\u0641 PDF","creditCard.encryptedCardNumber.aria.iframeTitle":"\u0627\u0644\u0625\u0637\u0627\u0631 \u0627\u0644\u0645\u0636\u0645\u0646 \u0644\u0631\u0642\u0645 \u0627\u0644\u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0645\u0624\u0645\u0646\u0629","creditCard.encryptedCardNumber.aria.label":"\u0631\u0642\u0645 \u0627\u0644\u0628\u0637\u0627\u0642\u0629","creditCard.encryptedExpiryDate.aria.iframeTitle":"\u0627\u0644\u0625\u0637\u0627\u0631 \u0627\u0644\u0645\u0636\u0645\u0646 \u0644\u062a\u0627\u0631\u064a\u062e \u0627\u0646\u062a\u0647\u0627\u0621 \u0627\u0644\u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0645\u0624\u0645\u0646\u0629","creditCard.encryptedExpiryDate.aria.label":"\u062a\u0627\u0631\u064a\u062e \u0627\u0644\u0627\u0646\u062a\u0647\u0627\u0621","creditCard.encryptedExpiryMonth.aria.iframeTitle":"\u0627\u0644\u0625\u0637\u0627\u0631 \u0627\u0644\u0645\u0636\u0645\u0646 \u0644\u0634\u0647\u0631 \u0627\u0646\u062a\u0647\u0627\u0621 \u0627\u0644\u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0645\u0624\u0645\u0646\u0629","creditCard.encryptedExpiryMonth.aria.label":"\u0634\u0647\u0631 \u0627\u0644\u0627\u0646\u062a\u0647\u0627\u0621","creditCard.encryptedExpiryYear.aria.iframeTitle":"\u0627\u0644\u0625\u0637\u0627\u0631 \u0627\u0644\u0645\u0636\u0645\u0646 \u0644\u0633\u0646\u0629 \u0627\u0646\u062a\u0647\u0627\u0621 \u0627\u0644\u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0645\u0624\u0645\u0646\u0629","creditCard.encryptedExpiryYear.aria.label":"\u0633\u0646\u0629 \u0627\u0644\u0627\u0646\u062a\u0647\u0627\u0621","creditCard.encryptedSecurityCode.aria.iframeTitle":"\u0627\u0644\u0625\u0637\u0627\u0631 \u0627\u0644\u0645\u0636\u0645\u0646 \u0644\u0631\u0645\u0632 \u0623\u0645\u0627\u0646 \u0627\u0644\u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0645\u0624\u0645\u0646\u0629","creditCard.encryptedSecurityCode.aria.label":"\u0631\u0645\u0632 \u0627\u0644\u0623\u0645\u0627\u0646","creditCard.encryptedPassword.aria.iframeTitle":"\u0627\u0644\u0625\u0637\u0627\u0631 \u0627\u0644\u0645\u0636\u0645\u0646 \u0644\u0643\u0644\u0645\u0629 \u0645\u0631\u0648\u0631 \u0627\u0644\u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0645\u0624\u0645\u0646\u0629","creditCard.encryptedPassword.aria.label":"\u0623\u0648\u0644 \u0631\u0642\u0645\u0627\u0646 \u0645\u0646 \u0643\u0644\u0645\u0629 \u0645\u0631\u0648\u0631 \u0627\u0644\u0628\u0637\u0627\u0642\u0629","giftcard.encryptedCardNumber.aria.iframeTitle":"\u0627\u0644\u0625\u0637\u0627\u0631 \u0627\u0644\u0645\u0636\u0645\u0646 \u0644\u0631\u0642\u0645 \u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0647\u062f\u0627\u064a\u0627 \u0627\u0644\u0645\u0624\u0645\u0646\u0629","giftcard.encryptedCardNumber.aria.label":"\u0631\u0642\u0645 \u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0647\u062f\u0627\u064a\u0627","giftcard.encryptedSecurityCode.aria.iframeTitle":"\u0627\u0644\u0625\u0637\u0627\u0631 \u0627\u0644\u0645\u0636\u0645\u0646 \u0644\u0631\u0645\u0632 \u0623\u0645\u0627\u0646 \u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0647\u062f\u0627\u064a\u0627 \u0627\u0644\u0645\u0624\u0645\u0646\u0629","giftcard.encryptedSecurityCode.aria.label":"\u0631\u0645\u0632 \u0623\u0645\u0627\u0646 \u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0647\u062f\u0627\u064a\u0627",giftcardTransactionLimit:"\u064a\u0633\u0645\u062d \u0641\u0642\u0637 \u0628\u062d\u062f \u0623\u0642\u0635\u0649 %{amount} \u0644\u0643\u0644 \u0645\u0639\u0627\u0645\u0644\u0629 \u0639\u0644\u0649 \u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0647\u062f\u0627\u064a\u0627 \u0647\u0630\u0647","ach.encryptedBankAccountNumber.aria.iframeTitle":"\u0627\u0644\u0625\u0637\u0627\u0631 \u0627\u0644\u0645\u0636\u0645\u0646 \u0644\u0631\u0642\u0645 \u0627\u0644\u062d\u0633\u0627\u0628 \u0627\u0644\u0628\u0646\u0643\u064a \u0627\u0644\u0645\u0624\u0645\u0646","ach.encryptedBankAccountNumber.aria.label":"\u0627\u0644\u062d\u0633\u0627\u0628 \u0627\u0644\u0628\u0646\u0643\u064a","ach.encryptedBankLocationId.aria.iframeTitle":"\u0627\u0644\u0625\u0637\u0627\u0631 \u0627\u0644\u0645\u0636\u0645\u0646 \u0644\u0631\u0642\u0645 \u0627\u0644\u062a\u0648\u062c\u064a\u0647 \u0627\u0644\u0628\u0646\u0643\u064a \u0627\u0644\u0645\u0624\u0645\u0646","ach.encryptedBankLocationId.aria.label":"\u0631\u0642\u0645 \u0627\u0644\u062a\u0648\u062c\u064a\u0647 \u0627\u0644\u0628\u0646\u0643\u064a","pix.instructions":"\u0627\u0641\u062a\u062d \u0627\u0644\u062a\u0637\u0628\u064a\u0642 \u0628\u0627\u0633\u062a\u062e\u062f\u0627\u0645 \u0645\u0641\u062a\u0627\u062d PIX \u0627\u0644\u0645\u0633\u062c\u0644\u060c \u0648\u0627\u062e\u062a\u0631 \u0627\u0644\u062f\u0641\u0639 \u0628\u0627\u0633\u062a\u062e\u062f\u0627\u0645 PIX \u0648\u0627\u0645\u0633\u062d \u0631\u0645\u0632 \u0627\u0644\u0627\u0633\u062a\u062c\u0627\u0628\u0629 \u0627\u0644\u0633\u0631\u064a\u0639\u0629 \u0636\u0648\u0626\u064a\u064b\u0627 \u0623\u0648 \u0627\u0646\u0633\u062e \u0627\u0644\u0631\u0645\u0632 \u0648\u0627\u0644\u0635\u0642\u0647","twint.saved":"\u0627\u0644\u0645\u062d\u0641\u0648\u0638\u0629",orPayWith:"\u0623\u0648 \u0627\u0644\u062f\u0641\u0639 \u0628\u0627\u0633\u062a\u062e\u062f\u0627\u0645",invalidFormatExpects:"\u062a\u0646\u0633\u064a\u0642 \u063a\u064a\u0631 \u0635\u0627\u0644\u062d. \u0627\u0644\u062a\u0646\u0633\u064a\u0642 \u0627\u0644\u0645\u062a\u0648\u0642\u0639: %{format}","upi.qrCodeWaitingMessage":"\u0627\u0645\u0633\u062d \u0631\u0645\u0632 \u0627\u0644\u0627\u0633\u062a\u062c\u0627\u0628\u0629 \u0627\u0644\u0633\u0631\u064a\u0639\u0629 \u0628\u0627\u0633\u062a\u062e\u062f\u0627\u0645 \u062a\u0637\u0628\u064a\u0642 UPI \u0627\u0644\u0630\u064a \u062a\u064f\u0641\u0636\u0644\u0647 \u0644\u0625\u062a\u0645\u0627\u0645 \u0627\u0644\u062f\u0641\u0639","upi.vpaWaitingMessage":"\u0627\u0641\u062a\u062d \u062a\u0637\u0628\u064a\u0642 UPI \u0644\u062a\u0623\u0643\u064a\u062f \u0627\u0644\u062f\u0641\u0639","upi.modeSelection":"\u062d\u062f\u062f \u0643\u064a\u0641 \u062a\u0631\u063a\u0628 \u0641\u064a \u0627\u0633\u062a\u062e\u062f\u0627\u0645 \u062a\u0637\u0628\u064a\u0642 UPI.","onlineBanking.termsAndConditions":"\u0628\u0627\u0644\u0645\u062a\u0627\u0628\u0639\u0629\u060c \u0641\u0625\u0646\u0643 \u062a\u0648\u0627\u0641\u0642 \u0639\u0644\u0649 %#\u0627\u0644\u0634\u0631\u0648\u0637 \u0648 \u0627\u0644\u0623\u062d\u0643\u0627\u0645%#","ctp.loading.poweredByCtp":"\u0628\u062f\u0639\u0645 \u0645\u0646 Click to Pay","ctp.loading.intro":"\u0646\u062a\u062d\u0642\u0642 \u0644\u0645\u0639\u0631\u0641\u0629 \u0645\u0627 \u0625\u0630\u0627 \u0643\u0627\u0646 \u0644\u062f\u064a\u0643 \u0623\u064a \u0628\u0637\u0627\u0642\u0627\u062a \u0645\u062d\u0641\u0648\u0638\u0629 \u0628\u0627\u0633\u062a\u062e\u062f\u0627\u0645 Click to Pay...","ctp.login.title":"\u062a\u0627\u0628\u0639 \u0625\u0644\u0649 Click to Pay","ctp.login.subtitle":"\u0623\u062f\u062e\u0644 \u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0628\u0631\u064a\u062f \u0627\u0644\u0625\u0644\u0643\u062a\u0631\u0648\u0646\u064a \u0627\u0644\u0645\u0642\u062a\u0631\u0646 \u0628\u0637\u0631\u064a\u0642\u0629 Click to Pay \u0644\u0644\u0645\u062a\u0627\u0628\u0639\u0629.","ctp.login.inputLabel":"\u0627\u0644\u0628\u0631\u064a\u062f \u0627\u0644\u0625\u0644\u0643\u062a\u0631\u0648\u0646\u064a","ctp.logout.notYou":"\u0644\u064a\u0633 \u0623\u0646\u062a\u061f","ctp.logout.notYourCards":"\u0644\u064a\u0633\u062a \u0628\u0637\u0627\u0642\u0627\u062a\u0643\u061f","ctp.logout.notYourCard":"\u0644\u064a\u0633\u062a \u0628\u0637\u0627\u0642\u062a\u0643\u061f","ctp.logout.notYourProfile":"\u0644\u064a\u0633 \u0645\u0644\u0641\u0643 \u0627\u0644\u062a\u0639\u0631\u064a\u0641\u064a\u061f","ctp.otp.fieldLabel":"\u0631\u0645\u0632 \u064a\u0633\u062a\u062e\u062f\u0645 \u0644\u0645\u0631\u0629 \u0648\u0627\u062d\u062f\u0629","ctp.otp.resendCode":"\u0625\u0639\u0627\u062f\u0629 \u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u0631\u0645\u0632","ctp.otp.codeResent":"\u062a\u0645 \u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u0631\u0645\u0632","ctp.otp.title":"\u062a\u0645\u062a\u0639 \u0628\u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0628\u0637\u0627\u0642\u0627\u062a Click to Pay \u0627\u0644\u062e\u0627\u0635\u0629 \u0628\u0643","ctp.otp.subtitle":"\u0623\u062f\u062e\u0644 \u0627\u0644\u0631\u0645\u0632 %@ \u0627\u0644\u0630\u064a \u0623\u0631\u0633\u0644\u0646\u0627\u0647 \u0625\u0644\u0649 \u066a@ \u0644\u0644\u062a\u062d\u0642\u0642 \u0645\u0646 \u0647\u0648\u064a\u062a\u0643.","ctp.emptyProfile.message":"\u0644\u0627 \u062a\u0648\u062c\u062f \u0628\u0637\u0627\u0642\u0627\u062a \u0645\u0633\u062c\u0644\u0629 \u0641\u064a \u0647\u0630\u0627 \u0627\u0644\u0645\u0644\u0641 \u0627\u0644\u062a\u0639\u0631\u064a\u0641\u064a \u0639\u0644\u0649 Click to Pay","ctp.separatorText":"\u0623\u0648 \u0627\u0633\u062a\u062e\u062f\u0645","ctp.cards.title":"\u0623\u0643\u0645\u0644 \u0627\u0644\u062f\u0641\u0639 \u0628\u0627\u0633\u062a\u062e\u062f\u0627\u0645 \u0628\u0637\u0627\u0642\u0629 Click to Pay","ctp.cards.subtitle":"\u062d\u062f\u062f \u0628\u0637\u0627\u0642\u0629 \u0644\u0627\u0633\u062a\u062e\u062f\u0627\u0645\u0647\u0627.","ctp.cards.expiredCard":"\u0645\u0646\u062a\u0647\u064a \u0627\u0644\u0635\u0644\u0627\u062d\u064a\u0629","ctp.manualCardEntry":"\u0627\u0644\u0625\u062f\u062e\u0627\u0644 \u0627\u0644\u064a\u062f\u0648\u064a \u0644\u0644\u0628\u0637\u0627\u0642\u0629","ctp.aria.infoModalButton":"\u0645\u0627 \u0627\u0644\u0645\u0642\u0635\u0648\u062f \u0628\u0628\u0637\u0627\u0642\u0629 Click to Pay\u061f","ctp.infoPopup.title":"\u062a\u062a\u064a\u062d \u0628\u0637\u0627\u0642\u0627\u062a Click to Pay \u0633\u0647\u0648\u0644\u0629 \u0627\u0644\u0628\u0637\u0627\u0642\u0627\u062a \u0627\u0644\u0644\u0627\u062a\u0644\u0627\u0645\u0633\u064a\u0629 \u0639\u0628\u0631 \u0627\u0644\u0625\u0646\u062a\u0631\u0646\u062a","ctp.infoPopup.subtitle":"\u0637\u0631\u064a\u0642\u0629 \u062f\u0641\u0639 \u0633\u0631\u064a\u0639\u0629 \u0648\u0622\u0645\u0646\u0629 \u0645\u062f\u0639\u0648\u0645\u0629 \u0645\u0646 Mastercard \u0648Visa \u0648\u0628\u0637\u0627\u0642\u0627\u062a \u0627\u0644\u062f\u0641\u0639 \u0627\u0644\u0623\u062e\u0631\u0649.","ctp.infoPopup.benefit1":"\u062a\u0633\u062a\u062e\u062f\u0645 \u0628\u0637\u0627\u0642\u0627\u062a Click to Pay \u0627\u0644\u062a\u0634\u0641\u064a\u0631 \u0644\u0644\u062d\u0641\u0627\u0638 \u0639\u0644\u0649 \u0623\u0645\u0646 \u0645\u0639\u0644\u0648\u0645\u0627\u062a\u0643 \u0648\u0633\u0644\u0627\u0645\u062a\u0647\u0627","ctp.infoPopup.benefit2":"\u0627\u0633\u062a\u062e\u062f\u0645\u0647\u0627 \u0644\u0644\u062f\u0641\u0639 \u0644\u0644\u062a\u062c\u0627\u0631 \u0641\u064a \u062c\u0645\u064a\u0639 \u0623\u0646\u062d\u0627\u0621 \u0627\u0644\u0639\u0627\u0644\u0645","ctp.infoPopup.benefit3":"\u0642\u0645 \u0628\u0627\u0644\u0625\u0639\u062f\u0627\u062f \u0645\u0631\u0629 \u0648\u0627\u062d\u062f\u0629 \u0644\u0625\u062c\u0631\u0627\u0621 \u0645\u062f\u0641\u0648\u0639\u0627\u062a \u062f\u0648\u0646 \u062a\u0639\u0642\u064a\u062f\u0627\u062a \u0641\u064a \u0627\u0644\u0645\u0633\u062a\u0642\u0628\u0644","ctp.errors.AUTH_INVALID":"\u0627\u0644\u0645\u0635\u0627\u062f\u0642\u0629 \u063a\u064a\u0631 \u0635\u062d\u064a\u062d\u0629","ctp.errors.NOT_FOUND":"\u0644\u0645 \u064a\u062a\u0645 \u0627\u0644\u0639\u062b\u0648\u0631 \u0639\u0644\u0649 \u062d\u0633\u0627\u0628\u060c \u0623\u062f\u062e\u0644 \u0628\u0631\u064a\u062f\u064b\u0627 \u0625\u0644\u0643\u062a\u0631\u0648\u0646\u064a\u064b\u0627 \u0635\u062d\u064a\u062d\u064b\u0627 \u0623\u0648 \u0627\u0633\u062a\u0645\u0631 \u0641\u064a \u0627\u0633\u062a\u062e\u062f\u0627\u0645 \u0627\u0644\u0625\u062f\u062e\u0627\u0644 \u0627\u0644\u064a\u062f\u0648\u064a \u0644\u0644\u0628\u0637\u0627\u0642\u0629","ctp.errors.ID_FORMAT_UNSUPPORTED":"\u0627\u0644\u062a\u0646\u0633\u064a\u0642 \u063a\u064a\u0631 \u0645\u062f\u0639\u0648\u0645","ctp.errors.FRAUD":"\u062a\u0645 \u0625\u063a\u0644\u0627\u0642 \u062d\u0633\u0627\u0628 \u0627\u0644\u0645\u0633\u062a\u062e\u062f\u0645 \u0623\u0648 \u062a\u0639\u0637\u064a\u0644\u0647","ctp.errors.CONSUMER_ID_MISSING":"\u0647\u0648\u064a\u0629 \u0627\u0644\u0645\u0633\u062a\u0647\u0644\u0643 \u063a\u064a\u0631 \u0645\u0648\u062c\u0648\u062f\u0629 \u0641\u064a \u0627\u0644\u0637\u0644\u0628","ctp.errors.ACCT_INACCESSIBLE":"\u0647\u0630\u0627 \u0627\u0644\u062d\u0633\u0627\u0628 \u063a\u064a\u0631 \u0645\u062a\u0627\u062d \u062d\u0627\u0644\u064a\u064b\u0627\u060c \u0639\u0644\u0649 \u0633\u0628\u064a\u0644 \u0627\u0644\u0645\u062b\u0627\u0644\u060c \u0627\u0644\u062d\u0633\u0627\u0628 \u0645\u063a\u0644\u0642","ctp.errors.CODE_INVALID":"\u0631\u0645\u0632 \u0627\u0644\u062a\u062d\u0642\u0642 \u063a\u064a\u0631 \u0635\u062d\u064a\u062d","ctp.errors.CODE_EXPIRED":"\u0627\u0646\u062a\u0647\u062a \u0635\u0644\u0627\u062d\u064a\u0629 \u0647\u0630\u0627 \u0627\u0644\u0631\u0645\u0632","ctp.errors.RETRIES_EXCEEDED":"\u062a\u0645 \u062a\u062c\u0627\u0648\u0632 \u0627\u0644\u062d\u062f \u0627\u0644\u0623\u0642\u0635\u0649 \u0644\u0639\u062f\u062f \u0639\u0645\u0644\u064a\u0627\u062a \u0625\u0639\u0627\u062f\u0629 \u0627\u0644\u0645\u062d\u0627\u0648\u0644\u0629 \u0644\u0625\u0646\u0634\u0627\u0621 \u0643\u0644\u0645\u0629 \u0645\u0631\u0648\u0631 \u0644\u0645\u0631\u0629 \u0648\u0627\u062d\u062f\u0629","ctp.errors.OTP_SEND_FAILED":"\u062a\u0639\u0630\u0631 \u0625\u0631\u0633\u0627\u0644 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u0644\u0645\u0631\u0629 \u0648\u0627\u062d\u062f\u0629 \u0625\u0644\u0649 \u0627\u0644\u0645\u0633\u062a\u0644\u0645","ctp.errors.REQUEST_TIMEOUT":"\u062d\u062f\u062b \u062e\u0637\u0623 \u0645\u0627\u060c \u062d\u0627\u0648\u0644 \u0645\u0631\u0629 \u0623\u062e\u0631\u0649 \u0623\u0648 \u0627\u0633\u062a\u062e\u062f\u0645 \u0627\u0644\u0625\u062f\u062e\u0627\u0644 \u0627\u0644\u064a\u062f\u0648\u064a \u0644\u0644\u0628\u0637\u0627\u0642\u0629","ctp.errors.UNKNOWN_ERROR":"\u062d\u062f\u062b \u062e\u0637\u0623 \u0645\u0627\u060c \u062d\u0627\u0648\u0644 \u0645\u0631\u0629 \u0623\u062e\u0631\u0649 \u0623\u0648 \u0627\u0633\u062a\u062e\u062f\u0645 \u0627\u0644\u0625\u062f\u062e\u0627\u0644 \u0627\u0644\u064a\u062f\u0648\u064a \u0644\u0644\u0628\u0637\u0627\u0642\u0629","ctp.errors.SERVICE_ERROR":"\u062d\u062f\u062b \u062e\u0637\u0623 \u0645\u0627\u060c \u062d\u0627\u0648\u0644 \u0645\u0631\u0629 \u0623\u062e\u0631\u0649 \u0623\u0648 \u0627\u0633\u062a\u062e\u062f\u0645 \u0627\u0644\u0625\u062f\u062e\u0627\u0644 \u0627\u0644\u064a\u062f\u0648\u064a \u0644\u0644\u0628\u0637\u0627\u0642\u0629","ctp.errors.SERVER_ERROR":"\u062d\u062f\u062b \u062e\u0637\u0623 \u0645\u0627\u060c \u062d\u0627\u0648\u0644 \u0645\u0631\u0629 \u0623\u062e\u0631\u0649 \u0623\u0648 \u0627\u0633\u062a\u062e\u062f\u0645 \u0627\u0644\u0625\u062f\u062e\u0627\u0644 \u0627\u0644\u064a\u062f\u0648\u064a \u0644\u0644\u0628\u0637\u0627\u0642\u0629","ctp.errors.INVALID_PARAMETER":"\u062d\u062f\u062b \u062e\u0637\u0623 \u0645\u0627\u060c \u062d\u0627\u0648\u0644 \u0645\u0631\u0629 \u0623\u062e\u0631\u0649 \u0623\u0648 \u0627\u0633\u062a\u062e\u062f\u0645 \u0627\u0644\u0625\u062f\u062e\u0627\u0644 \u0627\u0644\u064a\u062f\u0648\u064a \u0644\u0644\u0628\u0637\u0627\u0642\u0629","ctp.errors.AUTH_ERROR":"\u062d\u062f\u062b \u062e\u0637\u0623 \u0645\u0627\u060c \u062d\u0627\u0648\u0644 \u0645\u0631\u0629 \u0623\u062e\u0631\u0649 \u0623\u0648 \u0627\u0633\u062a\u062e\u062f\u0645 \u0627\u0644\u0625\u062f\u062e\u0627\u0644 \u0627\u0644\u064a\u062f\u0648\u064a \u0644\u0644\u0628\u0637\u0627\u0642\u0629","paymentMethodsList.aria.label":"\u0627\u062e\u062a\u0631 \u0637\u0631\u064a\u0642\u0629 \u062f\u0641\u0639"}}),k3=Object.freeze({__proto__:null,default:{payButton:"Zaplatit","payButton.redirecting":"P\u0159esm\u011brov\xe1n\xed...","payButton.with":"Zaplatit %{value} pomoc\xed %{maskedData}",close:"Zav\u0159\xedt",storeDetails:"Ulo\u017eit pro\xa0p\u0159\xed\u0161t\xed platby","creditCard.holderName":"Jm\xe9no na\xa0kart\u011b","creditCard.holderName.placeholder":"Jan Nov\xe1k","creditCard.holderName.invalid":"Neplatn\xe9 jm\xe9no dr\u017eitele karty","creditCard.numberField.title":"\u010c\xedslo karty","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"Konec platnosti","creditCard.expiryDateField.placeholder":"MM/RR","creditCard.expiryDateField.month":"M\u011bs\xedc","creditCard.expiryDateField.month.placeholder":"MM","creditCard.expiryDateField.year.placeholder":"RR","creditCard.expiryDateField.year":"Rok","creditCard.cvcField.title":"K\xf3d CVC/CVV","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"Zapamatovat si pro\xa0p\u0159\xed\u0161t\u011b","creditCard.cvcField.placeholder.4digits":"4 \u010d\xedslice","creditCard.cvcField.placeholder.3digits":"3 \u010d\xedslice","creditCard.taxNumber.placeholder":"RRMMDD / 0123456789",installments:"Po\u010det spl\xe1tek",installmentOption:"%{times}\xd7 %{partialValue}",installmentOptionMonths:"%{times} m\u011bs\xedc\u016f","installments.oneTime":"Jednor\xe1zov\xe1 platba","installments.installments":"Platba na\xa0spl\xe1tky","installments.revolving":"Opakuj\xedc\xed se platba","sepaDirectDebit.ibanField.invalid":"Neplatn\xe9 \u010d\xedslo \xfa\u010dtu","sepaDirectDebit.nameField.placeholder":"Jan Nov\xe1k","sepa.ownerName":"Jm\xe9no dr\u017eitele \xfa\u010dtu","sepa.ibanNumber":"\u010c\xedslo \xfa\u010dtu (IBAN)","error.title":"Chyba","error.subtitle.redirect":"P\u0159esm\u011brov\xe1n\xed selhalo","error.subtitle.payment":"Platba selhala","error.subtitle.refused":"Platba zam\xedtnuta","error.message.unknown":"Do\u0161lo k\xa0nezn\xe1m\xe9 chyb\u011b","errorPanel.title":"St\xe1vaj\xedc\xed chyby","idealIssuer.selectField.title":"Banka","idealIssuer.selectField.placeholder":"Vyberte svou banku","creditCard.success":"Platba prob\u011bhla \xfasp\u011b\u0161n\u011b",loading:"Na\u010d\xedt\xe1n\xed\u2026",continue:"Pokra\u010dovat",continueTo:"Pokra\u010dovat k","wechatpay.timetopay":"Na zaplacen\xed v\xe1m zb\xfdv\xe1 %@","wechatpay.scanqrcode":"Naskenovat QR k\xf3d",personalDetails:"Osobn\xed \xfadaje",companyDetails:"\xdadaje o\xa0spole\u010dnosti","companyDetails.name":"N\xe1zev spole\u010dnosti","companyDetails.registrationNumber":"Registra\u010dn\xed \u010d\xedslo",socialSecurityNumber:"Rodn\xe9 \u010d\xedslo",firstName:"Jm\xe9no","firstName.invalid":"K\u0159estn\xed jm\xe9no nen\xed platn\xe9",infix:"Prefix",lastName:"P\u0159\xedjmen\xed","lastName.invalid":"P\u0159\xedjmen\xed nen\xed platn\xe9",mobileNumber:"\u010c\xedslo na mobil","mobileNumber.invalid":"Neplatn\xe9 \u010d\xedslo mobiln\xedho telefonu",city:"M\u011bsto",postalCode:"PS\u010c","postalCode.optional":"Po\u0161tovn\xed sm\u011brovac\xed \u010d\xedslo (nepovinn\xe9)",countryCode:"K\xf3d zem\u011b",telephoneNumber:"Telefonn\xed \u010d\xedslo",dateOfBirth:"Datum narozen\xed",shopperEmail:"E-mailov\xe1 adresa",gender:"Pohlav\xed",male:"Mu\u017e",female:"\u017dena",billingAddress:"Faktura\u010dn\xed adresa",street:"Ulice",stateOrProvince:"Kraj nebo okres",country:"Zem\u011b",houseNumberOrName:"\u010c\xedslo popisn\xe9",separateDeliveryAddress:"Zadat dodac\xed adresu odli\u0161nou od faktura\u010dn\xed",deliveryAddress:"Dodac\xed adresa",zipCode:"PS\u010c",apartmentSuite:"Byt",provinceOrTerritory:"Provincie nebo teritorium",cityTown:"M\u011bsto",address:"Adresa",state:"St\xe1t","field.title.optional":"(nepovinn\xe9)","creditCard.cvcField.title.optional":"K\xf3d CVC/CVV (voliteln\xe9)","issuerList.wallet.placeholder":"Vyberte svou pen\u011b\u017eenku",privacyPolicy:"Z\xe1sady ochrany osobn\xedch \xfadaj\u016f","afterPay.agreement":"Souhlas\xedm s %@ spole\u010dnosti AfterPay",paymentConditions:"platebn\xedmi podm\xednkami",openApp:"Otev\u0159ete aplikaci","voucher.readInstructions":"P\u0159e\u010dt\u011bte si pokyny","voucher.introduction":"D\u011bkujeme za\xa0n\xe1kup. K\xa0dokon\u010den\xed platby pou\u017eijte pros\xedm n\xe1sleduj\xedc\xed kup\xf3n.","voucher.expirationDate":"Datum konce platnosti","voucher.alternativeReference":"N\xe1hradn\xed \u010d\xedslo","dragonpay.voucher.non.bank.selectField.placeholder":"Vyberte sv\xe9ho poskytovatele","dragonpay.voucher.bank.selectField.placeholder":"Vyberte svou banku","voucher.paymentReferenceLabel":"\u010c\xedslo platby","voucher.surcharge":"V\u010detn\u011b p\u0159ir\xe1\u017eky %@","voucher.introduction.doku":"D\u011bkujeme za n\xe1kup. K dokon\u010den\xed platby pou\u017eijte pros\xedm n\xe1sleduj\xedc\xed informace.","voucher.shopperName":"Jm\xe9no kupuj\xedc\xedho","voucher.merchantName":"Obchodn\xedk","voucher.introduction.econtext":"D\u011bkujeme za n\xe1kup. K dokon\u010den\xed platby pou\u017eijte pros\xedm n\xe1sleduj\xedc\xed informace.","voucher.telephoneNumber":"Telefonn\xed \u010d\xedslo","voucher.shopperReference":"\u010c\xedslo kupuj\xedc\xedho","voucher.collectionInstitutionNumber":"\u010c\xedslo inkasn\xed instituce","voucher.econtext.telephoneNumber.invalid":"Telefonn\xed \u010d\xedslo mus\xed obsahovat 10 nebo 11 \u010d\xedslic.","boletobancario.btnLabel":"Vygenerovat Boleto","boleto.sendCopyToEmail":"Poslat mi kopii na e-mail","button.copy":"Kop\xedrovat","button.download":"St\xe1hnout","boleto.socialSecurityNumber.invalid":"Pole nen\xed platn\xe9","creditCard.storedCard.description.ariaLabel":"Ulo\u017een\xe1 karta kon\u010d\xed na %@","voucher.entity":"Subjekt",donateButton:"P\u0159isp\u011bt",notNowButton:"Te\u010f ne",thanksForYourSupport:"D\u011bkujeme v\xe1m za podporu!",preauthorizeWith:"P\u0159edautorizovat pomoc\xed",confirmPreauthorization:"Potvrdit p\u0159edautorizaci",confirmPurchase:"Potvrdit n\xe1kup",applyGiftcard:"Uplatnit",giftcardBalance:"Z\u016fstatek na d\xe1rkov\xe9 kart\u011b",deductedBalance:"Ode\u010dten\xfd z\u016fstatek","creditCard.pin.title":"Pin","creditCard.encryptedPassword.label":"Prvn\xed 2 \u010d\xedslice hesla karty","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"Neplatn\xe9 heslo","creditCard.taxNumber":"Datum narozen\xed dr\u017eitele karty nebo registra\u010dn\xed \u010d\xedslo spole\u010dnosti","creditCard.taxNumber.label":"Datum narozen\xed dr\u017eitele karty (RRMMDD) nebo registra\u010dn\xed \u010d\xedslo spole\u010dnosti (10 \u010d\xedslic)","creditCard.taxNumber.labelAlt":"Registra\u010dn\xed \u010d\xedslo spole\u010dnosti (10 \u010d\xedslic)","creditCard.taxNumber.invalid":"Neplatn\xe9 datum narozen\xed dr\u017eitele karty nebo registra\u010dn\xed \u010d\xedslo spole\u010dnosti","storedPaymentMethod.disable.button":"Odebrat","storedPaymentMethod.disable.confirmation":"Odebrat ulo\u017een\xfd zp\u016fsob platby","storedPaymentMethod.disable.confirmButton":"Ano, odebrat","storedPaymentMethod.disable.cancelButton":"Zru\u0161it","ach.bankAccount":"Bankovn\xed \xfa\u010det","ach.accountHolderNameField.title":"Jm\xe9no dr\u017eitele \xfa\u010dtu","ach.accountHolderNameField.placeholder":"Jan Nov\xe1k","ach.accountHolderNameField.invalid":"Neplatn\xe9 jm\xe9no dr\u017eitele \xfa\u010dtu","ach.accountNumberField.title":"\u010c\xedslo \xfa\u010dtu","ach.accountNumberField.invalid":"Neplatn\xe9 \u010d\xedslo \xfa\u010dtu","ach.accountLocationField.title":"Sm\u011brovac\xed tranzitn\xed \u010d\xedslo ABA","ach.accountLocationField.invalid":"Neplatn\xe9 sm\u011brovac\xed tranzitn\xed \u010d\xedslo ABA","ach.savedBankAccount":"Ulo\u017een\xfd bankovn\xed \xfa\u010det","select.state":"Vyberte st\xe1t","select.stateOrProvince":"Vyberte kraj nebo okres","select.provinceOrTerritory":"Vyberte provincii nebo teritorium","select.country":"Vyberte zemi","select.noOptionsFound":"Nebyly nalezeny \u017e\xe1dn\xe9 mo\u017enosti","select.filter.placeholder":"Hledat...","telephoneNumber.invalid":"Neplatn\xe9 telefonn\xed \u010d\xedslo",qrCodeOrApp:"nebo","paypal.processingPayment":"Zpracov\xe1n\xed platby...",generateQRCode:"Vygenerovat QR k\xf3d","await.waitForConfirmation":"\u010cek\xe1 se na\xa0potvrzen\xed","mbway.confirmPayment":"Potvr\u010fte platbu v\xa0aplikaci MB WAY","shopperEmail.invalid":"Neplatn\xe1 e-mailov\xe1 adresa","dateOfBirth.format":"DD/MM/RRRR","dateOfBirth.invalid":"Mus\xed v\xe1m b\xfdt alespo\u0148 18 let","blik.confirmPayment":"Spus\u0165te bankovn\xed aplikaci a potvr\u010fte platbu.","blik.invalid":"Zadejte 6 \u010d\xedsel","blik.code":"\u0160estim\xedstn\xfd k\xf3d","blik.help":"Z\xedskejte k\xf3d z bankovn\xed aplikace.","swish.pendingMessage":"Po naskenov\xe1n\xed QR k\xf3du m\u016f\u017ee trvat a\u017e 10 minut, ne\u017e se stav zm\u011bn\xed. Pokud budete zkou\u0161et b\u011bhem t\xe9to doby platbu opakovat, m\u016f\u017ee b\xfdt \u010d\xe1stka zaplacena v\xedcekr\xe1t.","field.valid":"Platn\xe9 pole","field.invalid":"Pole nen\xed platn\xe9","error.va.gen.01":"Ne\xfapln\xe9 pole","error.va.gen.02":"Pole nen\xed platn\xe9","error.va.sf-cc-num.01":"\u010c\xedslo karty je neplatn\xe9","error.va.sf-cc-num.02":"Pole s \u010d\xedslem karty je pr\xe1zdn\xe9","error.va.sf-cc-num.03":"Zad\xe1no \u010d\xedslo nepodporovan\xe9 karty","error.va.sf-cc-num.04":"\u010c\xedslo karty m\xe1 nespr\xe1vnou d\xe9lku","error.va.sf-cc-dat.01":"Datum vypr\u0161en\xed platnosti: karta je p\u0159\xedli\u0161 star\xe1","error.va.sf-cc-dat.02":"Datum vypr\u0161en\xed platnosti: datum je p\u0159\xedli\u0161 daleko v budoucnosti","error.va.sf-cc-dat.03":"Datum vypr\u0161en\xed platnosti: platnost va\u0161\xed karty vypr\u0161\xed p\u0159ed datem vy\xfa\u010dtov\xe1n\xed","error.va.sf-cc-dat.04":"Pole data vypr\u0161en\xed platnosti je pr\xe1zdn\xe9","error.va.sf-cc-dat.05":"Datum vypr\u0161en\xed platnosti m\xe1 nespr\xe1vnou d\xe9lku","error.va.sf-cc-mth.01":"Pole m\u011bs\xedce vypr\u0161en\xed platnosti je pr\xe1zdn\xe9","error.va.sf-cc-yr.01":"Pole roku vypr\u0161en\xed platnosti je pr\xe1zdn\xe9","error.va.sf-cc-yr.02":"Rok vypr\u0161en\xed platnosti m\xe1 nespr\xe1vnou d\xe9lku","error.va.sf-cc-cvc.01":"Pole bezpe\u010dnostn\xedho k\xf3du je pr\xe1zdn\xe9","error.va.sf-cc-cvc.02":"Bezpe\u010dnostn\xed k\xf3d m\xe1 nespr\xe1vnou d\xe9lku","error.va.sf-ach-num.01":"Pole \u010d\xedsla bankovn\xedho \xfa\u010dtu je pr\xe1zdn\xe9","error.va.sf-ach-num.02":"\u010c\xedslo bankovn\xedho \xfa\u010dtu m\xe1 nespr\xe1vnou d\xe9lku","error.va.sf-ach-loc.01":"Pole bankovn\xedho sm\u011brovac\xedho \u010d\xedsla je pr\xe1zdn\xe9","error.va.sf-ach-loc.02":"Bankovn\xed sm\u011brovac\xed \u010d\xedslo m\xe1 nespr\xe1vnou d\xe9lku","error.va.sf-kcp-pwd.01":"Pole hesla je pr\xe1zdn\xe9","error.va.sf-kcp-pwd.02":"Heslo m\xe1 nespr\xe1vnou d\xe9lku","error.giftcard.no-balance":"Na d\xe1rkov\xe9 kart\u011b je nulov\xfd z\u016fstatek","error.giftcard.card-error":"V\xa0na\u0161ich z\xe1znamech nen\xed \u017e\xe1dn\xe1 d\xe1rkov\xe1 karta s\xa0t\xedmto \u010d\xedslem","error.giftcard.currency-error":"D\xe1rkov\xe9 karty jsou platn\xe9 jenom v\xa0m\u011bn\u011b, ve kter\xe9 byly vystaven\xe9","amazonpay.signout":"Odhl\xe1sit se z Amazonu","amazonpay.changePaymentDetails":"Zm\u011bnit \xfadaje o platb\u011b","partialPayment.warning":"Zvolte jin\xfd zp\u016fsob platby pro platbu zb\xfdvaj\xedc\xedch","partialPayment.remainingBalance":"Zb\xfdvaj\xedc\xed z\u016fstatek bude %{amount}","bankTransfer.beneficiary":"P\u0159\xedjemce","bankTransfer.iban":"IBAN","bankTransfer.bic":"BIC","bankTransfer.reference":"Odkaz","bankTransfer.introduction":"Vytvo\u0159te novou platbu bankovn\xedm p\u0159evodem. K dokon\u010den\xed t\xe9to platby m\u016f\u017eete pou\u017e\xedt \xfadaje na n\xe1sleduj\xedc\xed obrazovce.","bankTransfer.instructions":"D\u011bkujeme za n\xe1kup. K dokon\u010den\xed platby pou\u017eijte pros\xedm n\xe1sleduj\xedc\xed informace.","bacs.accountHolderName":"Jm\xe9no dr\u017eitele bankovn\xedho \xfa\u010dtu","bacs.accountHolderName.invalid":"Neplatn\xe9 jm\xe9no dr\u017eitele bankovn\xedho \xfa\u010dtu","bacs.accountNumber":"\u010c\xedslo bankovn\xedho \xfa\u010dtu","bacs.accountNumber.invalid":"Neplatn\xe9 \u010d\xedslo bankovn\xedho \xfa\u010dtu","bacs.bankLocationId":"K\xf3d Sort","bacs.bankLocationId.invalid":"Neplatn\xfd k\xf3d Sort","bacs.consent.amount":"Souhlas\xedm s\xa0t\xedm, \u017ee mi bude n\xe1sleduj\xedc\xed \u010d\xe1stka ode\u010dtena z\xa0bankovn\xedho \xfa\u010dtu.","bacs.consent.account":"Potvrzuji, \u017ee \xfa\u010det je veden na moje jm\xe9no a\xa0jsem jedin\xfdm disponentem, jeho\u017e podpis je nutn\xfd ke schv\xe1len\xed p\u0159\xedm\xe9ho inkasa.",edit:"Editovat","bacs.confirm":"Potvrdit a\xa0zaplatit","bacs.result.introduction":"St\xe1hn\u011bte si pokyny k\xa0p\u0159\xedm\xe9mu inkasu (DDI / podpisov\xe9 pr\xe1vo)","download.pdf":"St\xe1hnout PDF","creditCard.encryptedCardNumber.aria.iframeTitle":"Iframe pro \u010d\xedslo zabezpe\u010den\xe9 karty","creditCard.encryptedCardNumber.aria.label":"\u010c\xedslo karty","creditCard.encryptedExpiryDate.aria.iframeTitle":"Iframe pro datum vypr\u0161en\xed platnosti zabezpe\u010den\xe9 karty","creditCard.encryptedExpiryDate.aria.label":"Konec platnosti","creditCard.encryptedExpiryMonth.aria.iframeTitle":"Iframe pro m\u011bs\xedc vypr\u0161en\xed platnosti zabezpe\u010den\xe9 karty","creditCard.encryptedExpiryMonth.aria.label":"M\u011bs\xedc konce platnosti","creditCard.encryptedExpiryYear.aria.iframeTitle":"Iframe pro rok vypr\u0161en\xed platnosti zabezpe\u010den\xe9 karty","creditCard.encryptedExpiryYear.aria.label":"Rok konce platnosti","creditCard.encryptedSecurityCode.aria.iframeTitle":"Iframe pro bezpe\u010dnostn\xed k\xf3d zabezpe\u010den\xe9 karty","creditCard.encryptedSecurityCode.aria.label":"Bezpe\u010dnostn\xed k\xf3d","creditCard.encryptedPassword.aria.iframeTitle":"Iframe pro zabezpe\u010den\xe1 hesla karet","creditCard.encryptedPassword.aria.label":"Prvn\xed 2 \u010d\xedslice hesla karty","giftcard.encryptedCardNumber.aria.iframeTitle":"Iframe pro \u010d\xedslo zabezpe\u010den\xe9 d\xe1rkov\xe9 karty","giftcard.encryptedCardNumber.aria.label":"\u010c\xedslo d\xe1rkov\xe9 karty","giftcard.encryptedSecurityCode.aria.iframeTitle":"Iframe pro bezpe\u010dnostn\xed k\xf3d zabezpe\u010den\xe9 d\xe1rkov\xe9 karty","giftcard.encryptedSecurityCode.aria.label":"Bezpe\u010dnostn\xed k\xf3d d\xe1rkov\xe9 karty",giftcardTransactionLimit:"Maxim\xe1ln\xed povolen\xe1 \u010d\xe1stka za jednu transakci touto d\xe1rkovou kartou je %{amount}.","ach.encryptedBankAccountNumber.aria.iframeTitle":"Iframe pro \u010d\xedslo zabezpe\u010den\xe9ho bankovn\xedho \xfa\u010dtu","ach.encryptedBankAccountNumber.aria.label":"Bankovn\xed \xfa\u010det","ach.encryptedBankLocationId.aria.iframeTitle":"Iframe pro \u010d\xedslo zabezpe\u010den\xe9ho k\xf3du banky","ach.encryptedBankLocationId.aria.label":"Sm\u011brovac\xed k\xf3d banky","twint.saved":"ulo\u017eeno",orPayWith:"nebo zapla\u0165te pomoc\xed",invalidFormatExpects:"Neplatn\xfd form\xe1t. O\u010dek\xe1van\xfd form\xe1t: %{format}","upi.qrCodeWaitingMessage":"Platbu dokon\u010dete naskenov\xe1n\xedm QR k\xf3du ve\xa0sv\xe9 obl\xedben\xe9 platebn\xed UPI aplikaci","upi.vpaWaitingMessage":"Otev\u0159ete platebn\xed aplikaci UPI a potvr\u010fte platbu","upi.modeSelection":"Vyberte si, jak chcete platebn\xed aplikaci UPI pou\u017e\xedvat.","onlineBanking.termsAndConditions":"Pokra\u010dov\xe1n\xedm souhlas\xedte se %#smluvn\xedmi podm\xednkami%#","ctp.loading.poweredByCtp":"Prov\xe1d\u011bno prost\u0159ednictv\xedm Click to Pay","ctp.loading.intro":"Zji\u0161\u0165ujeme, zda m\xe1te ulo\u017een\xe9 karty s funkc\xed Click to Pay...","ctp.login.title":"Pokra\u010dujte na Click to Pay","ctp.login.subtitle":"Pro pokra\u010dov\xe1n\xed zadejte e-mailovou adresu, kter\xe1 je p\u0159ipojena k \xfa\u010dtu Click to Pay.","ctp.login.inputLabel":"E-mail","ctp.logout.notYou":"Nejste to vy?","ctp.logout.notYourCards":"Nejsou to va\u0161e karty?","ctp.logout.notYourCard":"Nen\xed to va\u0161e karta?","ctp.logout.notYourProfile":"Nen\xed to v\xe1\u0161 profil?","ctp.otp.fieldLabel":"Jednor\xe1zov\xfd k\xf3d","ctp.otp.resendCode":"Znovu odeslat k\xf3d","ctp.otp.codeResent":"K\xf3d odesl\xe1n","ctp.otp.title":"Z\xedskejte p\u0159\xedstup ke sv\xfdm kart\xe1m Click to Pay","ctp.otp.subtitle":"Zadejte k\xf3d %@, kter\xfd jsme v\xe1m odeslali na %@ a ov\u011b\u0159te sami sebe.","ctp.emptyProfile.message":"V tomto profilu Click to Pay nejsou zaregistrov\xe1ny \u017e\xe1dn\xe9 karty","ctp.separatorText":"nebo pou\u017eijte","ctp.cards.title":"Dokon\u010dete platbu pomoc\xed Click to Pay","ctp.cards.subtitle":"Vyberte kartu, kterou chcete pou\u017e\xedt.","ctp.cards.expiredCard":"Platnost vypr\u0161ela","ctp.manualCardEntry":"Ru\u010dn\xed zad\xe1v\xe1n\xed karty","ctp.aria.infoModalButton":"Co je Click to Pay","ctp.infoPopup.title":"Click to Pay p\u0159in\xe1\u0161\xed jednoduchost bezkontaktn\xed platby, online","ctp.infoPopup.subtitle":"Rychl\xfd a bezpe\u010dn\xfd zp\u016fsob platby podporovan\xfd kartami Mastercard, Visa a dal\u0161\xedmi platebn\xedmi kartami.","ctp.infoPopup.benefit1":"Slu\u017eba Click to Pay pou\u017e\xedv\xe1 \u0161ifrov\xe1n\xed, aby va\u0161e informace byly zabezpe\u010den\xe9.","ctp.infoPopup.benefit2":"Pou\u017e\xedvejte ji u obchodn\xedk\u016f po cel\xe9m sv\u011bt\u011b","ctp.infoPopup.benefit3":"Nastavte jednou pro bezprobl\xe9mov\xe9 platby v budoucnu","ctp.errors.AUTH_INVALID":"Ov\u011b\u0159ov\xe1n\xed neplatn\xe9","ctp.errors.NOT_FOUND":"Nebyl nalezen \u017e\xe1dn\xfd \xfa\u010det, zadejte platn\xfd e-mail nebo pokra\u010dujte ru\u010dn\xedm zad\xe1n\xedm karty.","ctp.errors.ID_FORMAT_UNSUPPORTED":"Form\xe1t nen\xed podporov\xe1n","ctp.errors.FRAUD":"U\u017eivatelsk\xfd \xfa\u010det byl uzam\u010den nebo vypnut","ctp.errors.CONSUMER_ID_MISSING":"V po\u017eadavku chyb\xed identita spot\u0159ebitele","ctp.errors.ACCT_INACCESSIBLE":"Tento \xfa\u010det je moment\xe1ln\u011b nedostupn\xfd, nap\u0159. je uzam\u010den","ctp.errors.CODE_INVALID":"Nespr\xe1vn\xfd ov\u011b\u0159ovac\xed k\xf3d","ctp.errors.CODE_EXPIRED":"Platnost tohoto k\xf3du vypr\u0161ela","ctp.errors.RETRIES_EXCEEDED":"Limit pro po\u010det opakov\xe1n\xed pro generov\xe1n\xed jednor\xe1zov\xe9ho hesla byl p\u0159ekro\u010den","ctp.errors.OTP_SEND_FAILED":"Jednor\xe1zov\xe9 heslo nebylo mo\u017en\xe9 odeslat p\u0159\xedjemci","ctp.errors.REQUEST_TIMEOUT":"N\u011bco se pokazilo, zkuste to znovu nebo kartu zadejte ru\u010dn\u011b","ctp.errors.UNKNOWN_ERROR":"N\u011bco se pokazilo, zkuste to znovu nebo kartu zadejte ru\u010dn\u011b","ctp.errors.SERVICE_ERROR":"N\u011bco se pokazilo, zkuste to znovu nebo kartu zadejte ru\u010dn\u011b","ctp.errors.SERVER_ERROR":"N\u011bco se pokazilo, zkuste to znovu nebo kartu zadejte ru\u010dn\u011b","ctp.errors.INVALID_PARAMETER":"N\u011bco se pokazilo, zkuste to znovu nebo kartu zadejte ru\u010dn\u011b","ctp.errors.AUTH_ERROR":"N\u011bco se pokazilo, zkuste to znovu nebo kartu zadejte ru\u010dn\u011b","paymentMethodsList.aria.label":"Zvolte zp\u016fsob platby"}}),C3=Object.freeze({__proto__:null,default:{payButton:"Betal","payButton.redirecting":"Omdirigerer ...","payButton.with":"Betal %{value} med %{maskedData}",close:"Luk",storeDetails:"Gem til min n\xe6ste betaling","creditCard.holderName":"Navn p\xe5 kort","creditCard.holderName.placeholder":"J. Hansen","creditCard.holderName.invalid":"Ugyldigt kortholdernavn","creditCard.numberField.title":"Kortnummer","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"Udl\xf8bsdato","creditCard.expiryDateField.placeholder":"MM/\xc5\xc5","creditCard.expiryDateField.month":"M\xe5ned","creditCard.expiryDateField.month.placeholder":"MM","creditCard.expiryDateField.year.placeholder":"\xc5\xc5","creditCard.expiryDateField.year":"\xc5r","creditCard.cvcField.title":"CVC / CVV","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"Husk til n\xe6ste gang","creditCard.cvcField.placeholder.4digits":"4 cifre","creditCard.cvcField.placeholder.3digits":"3 cifre","creditCard.taxNumber.placeholder":"\xc5\xc5MMDD/0123456789",installments:"Antal rater",installmentOption:"%{times}x %{partialValue}",installmentOptionMonths:"%{times} m\xe5neder","installments.oneTime":"Engangsbetaling","installments.installments":"Afdragsbetaling","installments.revolving":"L\xf8bende betaling","sepaDirectDebit.ibanField.invalid":"Ugyldigt kontonummer","sepaDirectDebit.nameField.placeholder":"J. Smith","sepa.ownerName":"Kontohavernavn","sepa.ibanNumber":"Kontonummer (IBAN)","error.title":"Fejl","error.subtitle.redirect":"Omdirigering fejlede","error.subtitle.payment":"Betaling fejlede","error.subtitle.refused":"Betaling afvist","error.message.unknown":"Der opstod en ukendt fejl","errorPanel.title":"Eksisterende fejl","idealIssuer.selectField.title":"Bank","idealIssuer.selectField.placeholder":"V\xe6lg din bank","creditCard.success":"Betaling gennemf\xf8rt",loading:"Indl\xe6ser\u2026",continue:"Forts\xe6t",continueTo:"Forts\xe6t til","wechatpay.timetopay":"Du har %@ at betale","wechatpay.scanqrcode":"Scan QR-kode",personalDetails:"Personlige oplysninger",companyDetails:"Virksomhedsoplysninger","companyDetails.name":"Virksomhedsnavn","companyDetails.registrationNumber":"CVR-nummer",socialSecurityNumber:"CPR-nummer",firstName:"Fornavn","firstName.invalid":"Fornavnet er ikke gyldigt",infix:"Pr\xe6fiks",lastName:"Efternavn","lastName.invalid":"Efternavnet er ikke gyldigt",mobileNumber:"Mobilnummer","mobileNumber.invalid":"Ugyldigt mobilnummer",city:"By",postalCode:"Postnummer","postalCode.optional":"Postnummer (valgfrit)",countryCode:"Landekode",telephoneNumber:"Telefonnummer",dateOfBirth:"F\xf8dselsdato",shopperEmail:"E-mailadresse",gender:"K\xf8n",male:"Mand",female:"Kvinde",billingAddress:"Faktureringsadresse",street:"Gade",stateOrProvince:"Region eller kommune",country:"Land",houseNumberOrName:"Husnummer",separateDeliveryAddress:"Angiv en separat leveringsadresse",deliveryAddress:"Leveringsadresse",zipCode:"Postnummer",apartmentSuite:"Lejlighed/suite",provinceOrTerritory:"Provins eller territorium",cityTown:"By",address:"Adresse",state:"Stat","field.title.optional":"(valgfrit)","creditCard.cvcField.title.optional":"CVC / CVV (valgfrit)","issuerList.wallet.placeholder":"V\xe6lg tegnebog",privacyPolicy:"Politik om privatlivets fred","afterPay.agreement":"Jeg accepterer AfterPays %@",paymentConditions:"betalingsbetingelser",openApp:"\xc5bn appen","voucher.readInstructions":"L\xe6s anvisningerne","voucher.introduction":"Tak for dit k\xf8b. Brug f\xf8lgende kupon til at gennemf\xf8re din betaling.","voucher.expirationDate":"Udl\xf8bsdato","voucher.alternativeReference":"Alternativ reference","dragonpay.voucher.non.bank.selectField.placeholder":"V\xe6lg din udbyder","dragonpay.voucher.bank.selectField.placeholder":"V\xe6lg din bank","voucher.paymentReferenceLabel":"Betalingsreference","voucher.surcharge":"Inkl. till\xe6gsbegyr p\xe5 %@","voucher.introduction.doku":"Tak for dit k\xf8b. Brug f\xf8lgende oplysninger til at gennemf\xf8re din betaling.","voucher.shopperName":"Kundenavn","voucher.merchantName":"S\xe6lger","voucher.introduction.econtext":"Tak for dit k\xf8b. Brug f\xf8lgende oplysninger til at gennemf\xf8re din betaling.","voucher.telephoneNumber":"Telefonnummer","voucher.shopperReference":"K\xf8bers reference","voucher.collectionInstitutionNumber":"Id-nummer til opkr\xe6vningsinstitution","voucher.econtext.telephoneNumber.invalid":"Telefonnummer skal best\xe5 af 10 eller 11 cifre","boletobancario.btnLabel":"Gener\xe9r Boleto","boleto.sendCopyToEmail":"Send en kopi til min e-mail","button.copy":"Kopi\xe9r","button.download":"Download","boleto.socialSecurityNumber":"CPF / CNPJ","boleto.socialSecurityNumber.invalid":"Feltet er ugyldigt","creditCard.storedCard.description.ariaLabel":"Gemt kort ender p\xe5 %@","voucher.entity":"Enhed",donateButton:"Giv et bidrag",notNowButton:"Ikke nu",thanksForYourSupport:"Tak for din st\xf8tte!",preauthorizeWith:"Forh\xe5ndsgodkend med",confirmPreauthorization:"Bekr\xe6ft forh\xe5ndsgodkendelse",confirmPurchase:"Bekr\xe6ft k\xf8b",applyGiftcard:"Indl\xf8s",giftcardBalance:"Saldo p\xe5 gavekort",deductedBalance:"Fratrukket saldo","creditCard.pin.title":"Pinkode","creditCard.encryptedPassword.label":"F\xf8rste 2 cifre i adgangskode til kort","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"Ugyldig adgangskode","creditCard.taxNumber":"Kortholders f\xf8dselsdag eller virksomhedsregistreringsnummer","creditCard.taxNumber.label":"Kortholders f\xf8dselsdato (\xc5\xc5MMDD) eller virksomheds registreringsnummer (10 cifre)","creditCard.taxNumber.labelAlt":"Virksomheds registreringsnummer (10 cifre)","creditCard.taxNumber.invalid":"Ugyldig f\xf8dselsdato for kortholder eller virksomheds registreringsnummer","storedPaymentMethod.disable.button":"Fjern","storedPaymentMethod.disable.confirmation":"Fjern gemt betalingsm\xe5de","storedPaymentMethod.disable.confirmButton":"Ja, fjern","storedPaymentMethod.disable.cancelButton":"Annuller","ach.bankAccount":"Bankkonto","ach.accountHolderNameField.title":"Kontohavers navn","ach.accountHolderNameField.placeholder":"J. Smith","ach.accountHolderNameField.invalid":"Ugyldigt kontohavernavn","ach.accountNumberField.title":"Kontonummer","ach.accountNumberField.invalid":"Ugyldigt kontonummer","ach.accountLocationField.title":"ABA-registreringsnummer","ach.accountLocationField.invalid":"Ugyldigt ABA-registreringsnummer","ach.savedBankAccount":"Gemt bankkonto","select.state":"V\xe6lg stat","select.stateOrProvince":"V\xe6lg region eller kommune","select.provinceOrTerritory":"V\xe6lg provins eller territorium","select.country":"V\xe6lg land","select.noOptionsFound":"Ingen muligheder fundet","select.filter.placeholder":"S\xf8g ...","telephoneNumber.invalid":"Ugyldigt telefonnummer",qrCodeOrApp:"eller","paypal.processingPayment":"Behandler betaling ...",generateQRCode:"Gener\xe9r QR-kode","await.waitForConfirmation":"Venter p\xe5 bekr\xe6ftelse","mbway.confirmPayment":"Bekr\xe6ft din betaling p\xe5 appen MB WAY","shopperEmail.invalid":"Ugyldig e-mailadresse","dateOfBirth.format":"DD/MM/\xc5\xc5\xc5\xc5","dateOfBirth.invalid":"Du skal v\xe6re mindst 18 \xe5r","blik.confirmPayment":"\xc5bn din bankapp for at bekr\xe6fte betalingen.","blik.invalid":"Indtast 6 tal","blik.code":"6-cifret kode","blik.help":"F\xe5 koden fra din bankapp.","swish.pendingMessage":"Visning af status kan tage op til 10 minutter efter scanning. Et nyt fors\xf8g p\xe5 betaling inden for dette tidsrum kan muligvis medf\xf8re flere gebyrer.","field.valid":"Gyldigt felt","field.invalid":"Ugyldigt felt","error.va.gen.01":"Felt ikke udfyldt","error.va.gen.02":"Ugyldigt felt","error.va.sf-cc-num.01":"Kortnummeret er ikke gyldigt","error.va.sf-cc-num.02":"Feltet til kortnummer er tomt","error.va.sf-cc-num.03":"Ikke-underst\xf8ttet kortnummer indtastet","error.va.sf-cc-num.04":"Kortnummeret har den forkerte l\xe6ngde","error.va.sf-cc-dat.01":"Udl\xf8bsdato: Kortet er for gammelt","error.va.sf-cc-dat.02":"Udl\xf8bsdato: Dato for langt ude i fremtiden","error.va.sf-cc-dat.03":"Udl\xf8bsdato: Dit kort udl\xf8ber f\xf8r betalingsdatoen","error.va.sf-cc-dat.04":"Feltet til udl\xf8bsdato er tomt","error.va.sf-cc-dat.05":"Udl\xf8bsdatoen har den forkerte l\xe6ngde","error.va.sf-cc-mth.01":"Feltet til udl\xf8bsm\xe5ned er tomt","error.va.sf-cc-yr.01":"Feltet til udl\xf8bs\xe5r er tomt","error.va.sf-cc-yr.02":"Udl\xf8bs\xe5ret har den forkerte l\xe6ngde","error.va.sf-cc-cvc.01":"Feltet til sikkerhedskode er tomt","error.va.sf-cc-cvc.02":"Sikkerhedskoden har den forkerte l\xe6ngde","error.va.sf-ach-num.01":"Feltet til bankkontonummer er tomt","error.va.sf-ach-num.02":"Bankkontonummer har den forkerte l\xe6ngde","error.va.sf-ach-loc.01":"Feltet til registreringsnummeret er tomt","error.va.sf-ach-loc.02":"Registreringsnummeret har den forkerte l\xe6ngde","error.va.sf-kcp-pwd.01":"Feltet til adgangskode er tomt","error.va.sf-kcp-pwd.02":"Adgangskoden har den forkerte l\xe6ngde","error.giftcard.no-balance":"Saldoen p\xe5 gavekortet er 0","error.giftcard.card-error":"Vi har ikke et gavekort med dette nummer i vores optegnelser","error.giftcard.currency-error":"Gavekort er kun gyldige i udstedelsesvalutaen","amazonpay.signout":"Log ud af Amazon","amazonpay.changePaymentDetails":"Skift betalingsoplysninger","partialPayment.warning":"V\xe6lg en anden betalingsm\xe5de til betaling af restbel\xf8bet","partialPayment.remainingBalance":"Restbel\xf8bet vil v\xe6re %{amount}","bankTransfer.beneficiary":"Betalingsmodtager","bankTransfer.iban":"IBAN","bankTransfer.bic":"BIC","bankTransfer.reference":"Reference","bankTransfer.introduction":"Forts\xe6t med at oprette ny betalingsoverf\xf8rsel via bank. Du kan bruge oplysningerne p\xe5 den f\xf8lgende sk\xe6rm til at afslutte betalingen.","bankTransfer.instructions":"Tak for dit k\xf8b. Brug f\xf8lgende oplysninger til at gennemf\xf8re din betaling.","bacs.accountHolderName":"Bankkontohavers navn","bacs.accountHolderName.invalid":"Ugyldigt navn p\xe5 bankkontohaver","bacs.accountNumber":"Bankkontonummer","bacs.accountNumber.invalid":"Ugyldigt bankkontonummer","bacs.bankLocationId":"Registreringsnummer","bacs.bankLocationId.invalid":"Ugyldigt registreringsnummer","bacs.consent.amount":"Jeg accepterer, at bel\xf8bet ovenfor tr\xe6kkes p\xe5 min bankkonto.","bacs.consent.account":"Jeg bekr\xe6fter, at kontoen er i mit navn, og at jeg er den eneste underskriver, der kr\xe6ves for at godkende direkte debitering af kontoen.",edit:"Rediger","bacs.confirm":"Bekr\xe6ft, og betal","bacs.result.introduction":"Download vejledningen til direkte debitering (fuldmagt til direkte debitering)","download.pdf":"Download PDF","creditCard.encryptedCardNumber.aria.iframeTitle":"Iframe til sikret kortnummer","creditCard.encryptedCardNumber.aria.label":"Kortnummer","creditCard.encryptedExpiryDate.aria.iframeTitle":"Iframe til udl\xf8bsdato for sikret kort","creditCard.encryptedExpiryDate.aria.label":"Udl\xf8bsdato","creditCard.encryptedExpiryMonth.aria.iframeTitle":"Iframe til udl\xf8bsm\xe5ned for sikret kort","creditCard.encryptedExpiryMonth.aria.label":"Udl\xf8bsm\xe5ned","creditCard.encryptedExpiryYear.aria.iframeTitle":"Iframe til udl\xf8bs\xe5r for sikret kort","creditCard.encryptedExpiryYear.aria.label":"Udl\xf8bs\xe5r","creditCard.encryptedSecurityCode.aria.iframeTitle":"Iframe til sikkerhedskode for sikret kort","creditCard.encryptedSecurityCode.aria.label":"Sikkerhedskode","creditCard.encryptedPassword.aria.iframeTitle":"Iframe til sikret adgangskode til kort","creditCard.encryptedPassword.aria.label":"F\xf8rste 2 cifre i adgangskode til kort","giftcard.encryptedCardNumber.aria.iframeTitle":"Iframe til nummer for sikret gavekort","giftcard.encryptedCardNumber.aria.label":"Gavekortnummer","giftcard.encryptedSecurityCode.aria.iframeTitle":"Iframe til sikkerhedskode for sikret gavekort","giftcard.encryptedSecurityCode.aria.label":"Sikkerhedskode p\xe5 gavekort",giftcardTransactionLimit:"Maks. %{amount} tilladt pr. transaktion p\xe5 dette gavekort","ach.encryptedBankAccountNumber.aria.iframeTitle":"Iframe til sikret bankkontonummer","ach.encryptedBankAccountNumber.aria.label":"Bankkonto","ach.encryptedBankLocationId.aria.iframeTitle":"Iframe til registreringsnummer for sikret bank","ach.encryptedBankLocationId.aria.label":"Bankregistreringsnummer","twint.saved":"gemt",orPayWith:"eller betal med",invalidFormatExpects:"Ugyldigt format. Forventet format: %{format}","upi.qrCodeWaitingMessage":"Scan QR-koden via din foretrukne UPI-app for at gennemf\xf8re betalingen","upi.vpaWaitingMessage":"\xc5bn din UPI-app for at bekr\xe6fte betalingen","upi.modeSelection":"Foretag et valg om, hvordan du vil bruge UPI.","onlineBanking.termsAndConditions":"Ved at forts\xe6tte accepterer du %#vilk\xe5r og betingelser%#","ctp.loading.poweredByCtp":"Drevet af Click to Pay","ctp.loading.intro":"Vi tjekker, om du har gemte kort med Click to Pay ...","ctp.login.title":"Forts\xe6t med Click to Pay","ctp.login.subtitle":"Indtast den e-mailadresse, der er knyttet til Click to Pay, for at forts\xe6tte.","ctp.login.inputLabel":"E-mail","ctp.logout.notYou":"Ikke dig?","ctp.logout.notYourCards":"Ikke dine kort?","ctp.logout.notYourCard":"Ikke dit kort?","ctp.logout.notYourProfile":"Ikke din profil?","ctp.otp.fieldLabel":"Engangskode","ctp.otp.resendCode":"Send kode igen","ctp.otp.codeResent":"Kode er sendt igen","ctp.otp.title":"F\xe5 adgang til dine Click to Pay-kort","ctp.otp.subtitle":"Indtast den kode, vi har sendt til %@ for at bekr\xe6fte, at det er dig.","ctp.emptyProfile.message":"Ingen kort registreret i denne Click to Pay-profil","ctp.separatorText":"eller brug","ctp.cards.title":"Gennemf\xf8r betaling med Click to Pay","ctp.cards.subtitle":"V\xe6lg et kort, der skal bruges.","ctp.cards.expiredCard":"Udl\xf8bet","ctp.manualCardEntry":"Manuel kortindtastning","ctp.aria.infoModalButton":"Hvad er Click to Pay?","ctp.infoPopup.title":"Med Click to Pay f\xe5r du letheden fra kontaktl\xf8s betaling, online","ctp.infoPopup.subtitle":"En hurtig og sikker betalingsmetode, der underst\xf8ttes af Mastercard, Visa og andre betalingskort.","ctp.infoPopup.benefit1":"Click to Pay bruger kryptering for at holde dine oplysninger sikre og beskyttede","ctp.infoPopup.benefit2":"Brug det med forhandlere i hele verden","ctp.infoPopup.benefit3":"Konfigurer \xe9n gang for betalinger uden problemer i fremtiden","ctp.errors.AUTH_INVALID":"Ugyldig godkendelse","ctp.errors.NOT_FOUND":"Ingen konto fundet, indtast en gyldig e-mail eller forts\xe6t med manuel kortindtastning","ctp.errors.ID_FORMAT_UNSUPPORTED":"Formatet er ikke underst\xf8ttet","ctp.errors.FRAUD":"Brugerkontoen er l\xe5st eller deaktiveret","ctp.errors.CONSUMER_ID_MISSING":"Forbrugeridentitet mangler i anmodningen","ctp.errors.ACCT_INACCESSIBLE":"Denne konto er i \xf8jeblikket ikke tilg\xe6ngelig, f.eks. fordi den er l\xe5st","ctp.errors.CODE_INVALID":"Forkert bekr\xe6ftelsekode","ctp.errors.CODE_EXPIRED":"Denne kode er udl\xf8bet","ctp.errors.RETRIES_EXCEEDED":"Gr\xe6nsen for antallet af fors\xf8g til generering af engangsadgangskode er overskredet","ctp.errors.OTP_SEND_FAILED":"Engangsadgangskoden kunne ikke sendes til modtageren","ctp.errors.REQUEST_TIMEOUT":"Noget gik galt, pr\xf8v igen, eller brug den manuelle kortindtastning","ctp.errors.UNKNOWN_ERROR":"Noget gik galt, pr\xf8v igen, eller brug den manuelle kortindtastning","ctp.errors.SERVICE_ERROR":"Noget gik galt, pr\xf8v igen, eller brug den manuelle kortindtastning","ctp.errors.SERVER_ERROR":"Noget gik galt, pr\xf8v igen, eller brug den manuelle kortindtastning","ctp.errors.INVALID_PARAMETER":"Noget gik galt, pr\xf8v igen, eller brug den manuelle kortindtastning","ctp.errors.AUTH_ERROR":"Noget gik galt, pr\xf8v igen, eller brug den manuelle kortindtastning","paymentMethodsList.aria.label":"V\xe6lg en betalingsmetode"}}),_3=Object.freeze({__proto__:null,default:{payButton:"Zahlen","payButton.redirecting":"Umleiten\xa0\u2026","payButton.with":"%{value} mit %{maskedData} zahlen",close:"Schlie\xdfen",storeDetails:"F\xfcr zuk\xfcnftige Zahlvorg\xe4nge speichern","creditCard.holderName":"Name auf der Karte","creditCard.holderName.placeholder":"A. M\xfcller","creditCard.holderName.invalid":"Ung\xfcltiger Karteninhabername","creditCard.numberField.title":"Kartennummer","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"Ablaufdatum","creditCard.expiryDateField.placeholder":"MM/JJ","creditCard.expiryDateField.month":"Monat","creditCard.expiryDateField.month.placeholder":"MM","creditCard.expiryDateField.year.placeholder":"JJ","creditCard.expiryDateField.year":"Jahr","creditCard.cvcField.title":"CVC / CVV","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"F\xfcr das n\xe4chste Mal speichern","creditCard.cvcField.placeholder.4digits":"4 Stellen","creditCard.cvcField.placeholder.3digits":"3 Stellen","creditCard.taxNumber.placeholder":"JJMMTT/0123456789",installments:"Anzahl der Raten",installmentOption:"%{times}x %{partialValue}",installmentOptionMonths:"%{times} Monate","installments.oneTime":"Einmalige Zahlung","installments.installments":"Ratenzahlung","installments.revolving":"Ratenzahlung","sepaDirectDebit.ibanField.invalid":"Ung\xfcltige Kontonummer","sepaDirectDebit.nameField.placeholder":"A. M\xfcller","sepa.ownerName":"Name des Kontoinhabers","sepa.ibanNumber":"Kontonummer (IBAN)","error.title":"Fehler","error.subtitle.redirect":"Weiterleitung fehlgeschlagen","error.subtitle.payment":"Zahlung fehlgeschlagen","error.subtitle.refused":"Zahlvorgang verweigert","error.message.unknown":"Es ist ein unbekannter Fehler aufgetreten.","errorPanel.title":"Bestehende Fehler","idealIssuer.selectField.title":"Bank","idealIssuer.selectField.placeholder":"Bank ausw\xe4hlen","creditCard.success":"Zahlung erfolgreich",loading:"Laden \u2026",continue:"Weiter",continueTo:"Weiter zu","wechatpay.timetopay":"Sie haben noch %@ um zu zahlen","wechatpay.scanqrcode":"QR-Code scannen",personalDetails:"Pers\xf6nliche Angaben",companyDetails:"Unternehmensdaten","companyDetails.name":"Unternehmensname","companyDetails.registrationNumber":"Registrierungsnummer",socialSecurityNumber:"Sozialversicherungsnummer",firstName:"Vorname","firstName.invalid":"Vorname ist ung\xfcltig",infix:"Vorwahl",lastName:"Nachname","lastName.invalid":"Nachname ist ung\xfcltig",mobileNumber:"Handynummer","mobileNumber.invalid":"Ung\xfcltige Handynummer",city:"Stadt",postalCode:"Postleitzahl","postalCode.optional":"Postleitzahl (optional)",countryCode:"Landesvorwahl",telephoneNumber:"Telefonnummer",dateOfBirth:"Geburtsdatum",shopperEmail:"E-Mail-Adresse",gender:"Geschlecht",male:"M\xe4nnlich",female:"Weiblich",billingAddress:"Rechnungsadresse",street:"Stra\xdfe",stateOrProvince:"Bundesland",country:"Land",houseNumberOrName:"Hausnummer",separateDeliveryAddress:"Abweichende Lieferadresse angeben",deliveryAddress:"Lieferadresse",zipCode:"PLZ",apartmentSuite:"Wohnung/Geschoss",provinceOrTerritory:"Provinz oder Territorium",cityTown:"Ort",address:"Stra\xdfe und Hausnummer",state:"Bundesstaat","field.title.optional":"(optional)","creditCard.cvcField.title.optional":"CVC / CVV (optional)","issuerList.wallet.placeholder":"Virtuelle Brieftasche ausw\xe4hlen",privacyPolicy:"Datenschutz","afterPay.agreement":"Ich bin mit den %@ von AfterPay einverstanden",paymentConditions:"Zahlungsbedingungen",openApp:"App \xf6ffnen","voucher.readInstructions":"Anweisungen lesen","voucher.introduction":"Vielen Dank f\xfcr Ihren Kauf. Bitte schlie\xdfen Sie Ihre Zahlung unter Verwendung des folgenden Gutscheins ab.","voucher.expirationDate":"G\xfcltig bis","voucher.alternativeReference":"Alternative Referenz","dragonpay.voucher.non.bank.selectField.placeholder":"Anbieter ausw\xe4hlen","dragonpay.voucher.bank.selectField.placeholder":"Bank ausw\xe4hlen","voucher.paymentReferenceLabel":"Zahlungsreferenz","voucher.surcharge":"Inkl. % @Zuschlag","voucher.introduction.doku":"Vielen Dank f\xfcr Ihren Kauf. Bitte schlie\xdfen Sie Ihre Zahlung unter Verwendung der folgenden Informationen ab.","voucher.shopperName":"Name des K\xe4ufers","voucher.merchantName":"H\xe4ndler","voucher.introduction.econtext":"Vielen Dank f\xfcr Ihren Kauf. Bitte schlie\xdfen Sie Ihre Zahlung unter Verwendung der folgenden Informationen ab.","voucher.telephoneNumber":"Telefonnummer","voucher.shopperReference":"Kundenreferenz","voucher.collectionInstitutionNumber":"Nummer der Zahlungsannahmestelle","voucher.econtext.telephoneNumber.invalid":"Die Telefonnummer muss 10- oder 11-stellig sein","boletobancario.btnLabel":"Boleto generieren","boleto.sendCopyToEmail":"Eine Kopie an meine E-Mail-Adresse senden","button.copy":"Kopieren","button.download":"Herunterladen","boleto.socialSecurityNumber.invalid":"Feld ist ung\xfcltig","creditCard.storedCard.description.ariaLabel":"Gespeicherte Karte endet auf %@","voucher.entity":"Entit\xe4t",donateButton:"Spenden",notNowButton:"Nicht jetzt",thanksForYourSupport:"Danke f\xfcr Ihre Unterst\xfctzung!",preauthorizeWith:"Vorautorisieren mit",confirmPreauthorization:"Vorautorisierung best\xe4tigen",confirmPurchase:"Kauf best\xe4tigen",applyGiftcard:"Einl\xf6sen",giftcardBalance:"Saldo der Geschenkkarte",deductedBalance:"Abgezogener Betrag","creditCard.pin.title":"PIN","creditCard.encryptedPassword.label":"Die ersten zwei Ziffern des Kartenpassworts","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"Ung\xfcltiges Passwort","creditCard.taxNumber":"Geburtsdatum des Karteninhabers oder der Unternehmensregistrierungsnummer","creditCard.taxNumber.label":"Geburtsdatum des Karteninhabers (JJMMTT) oder Unternehmensregistrierungsnummer (10-stellig)","creditCard.taxNumber.labelAlt":"Unternehmensregistrierungsnummer (10-stellig)","creditCard.taxNumber.invalid":"Ung\xfcltiges Geburtsdatum des Karteninhabers oder ung\xfcltige Unternehmensregistrierungsnummer","storedPaymentMethod.disable.button":"Entfernen","storedPaymentMethod.disable.confirmation":"Gespeicherte Zahlungsmethode entfernen","storedPaymentMethod.disable.confirmButton":"Ja, entfernen","storedPaymentMethod.disable.cancelButton":"Abbrechen","ach.bankAccount":"Bankkonto","ach.accountHolderNameField.title":"Name des Kontoinhabers","ach.accountHolderNameField.placeholder":"A. M\xfcller","ach.accountHolderNameField.invalid":"Ung\xfcltiger Kontoinhabername","ach.accountNumberField.title":"Kontonummer","ach.accountNumberField.invalid":"Ung\xfcltige Kontonummer","ach.accountLocationField.title":"ABA-Nummer","ach.accountLocationField.invalid":"Ung\xfcltige ABA-Nummer","ach.savedBankAccount":"Gespeichertes Bankkonto","select.state":"Bundesstaat ausw\xe4hlen","select.stateOrProvince":"Bundesland oder Provinz/Region ausw\xe4hlen","select.provinceOrTerritory":"Provinz oder Territorium ausw\xe4hlen","select.country":"Land ausw\xe4hlen","select.noOptionsFound":"Keine Optionen gefunden","select.filter.placeholder":"Suche\xa0\u2026","telephoneNumber.invalid":"Ung\xfcltige Telefonnummer",qrCodeOrApp:"oder","paypal.processingPayment":"Zahlung wird verarbeitet\xa0\u2026",generateQRCode:"QR-Code generieren","await.waitForConfirmation":"Warten auf Best\xe4tigung","mbway.confirmPayment":"Best\xe4tigen Sie Ihre Zahlung in der MB WAY-App","shopperEmail.invalid":"Ung\xfcltige E-Mail-Adresse","dateOfBirth.format":"TT.MM.JJJJ","dateOfBirth.invalid":"Sie m\xfcssen mindestens 18 Jahre alt sein","blik.confirmPayment":"\xd6ffnen Sie Ihre Banking-App, um die Zahlung zu best\xe4tigen.","blik.invalid":"6 Zahlen eingeben","blik.code":"6-stelliger Code","blik.help":"Rufen Sie den Code \xfcber Ihre Banking-App ab.","swish.pendingMessage":"Es kann sein, dass der Status bis zu 10 Minuten nach dem Scan \u201eausstehend\u201c lautet. Wenn Sie w\xe4hrenddessen einen neuen Zahlungsversuch unternehmen, kann es sein, dass Ihnen mehrere Betr\xe4ge in Rechnung gestellt werden.","field.valid":"Feld g\xfcltig","field.invalid":"Feld ung\xfcltig","error.va.gen.01":"Feld nicht ausgef\xfcllt","error.va.gen.02":"Feld ung\xfcltig","error.va.sf-cc-num.01":"Kartennummer ist ung\xfcltig","error.va.sf-cc-num.02":"Das Feld f\xfcr die Kartennummer ist leer","error.va.sf-cc-num.03":"Nicht unterst\xfctzte Kartennummer eingegeben","error.va.sf-cc-num.04":"Die Kartennummer hat die falsche L\xe4nge","error.va.sf-cc-dat.01":"Ablaufdatum: Karte zu alt","error.va.sf-cc-dat.02":"Ablaufdatum: Datum zu weit in der Zukunft","error.va.sf-cc-dat.03":"Ablaufdatum: Ihre Karte l\xe4uft vor dem Abreisedatum ab","error.va.sf-cc-dat.04":"Das Feld f\xfcr das Ablaufdatum ist leer","error.va.sf-cc-dat.05":"Das Ablaufdatum hat die falsche L\xe4nge","error.va.sf-cc-mth.01":"Das Feld f\xfcr den Ablaufmonat ist leer","error.va.sf-cc-yr.01":"Das Feld f\xfcr das Ablaufjahr ist leer","error.va.sf-cc-yr.02":"Das Ablaufjahr hat die falsche L\xe4nge","error.va.sf-cc-cvc.01":"Das Feld f\xfcr den Sicherheitscode ist leer","error.va.sf-cc-cvc.02":"Der Sicherheitscode hat die falsche L\xe4nge","error.va.sf-ach-num.01":"Das Feld f\xfcr die Bankkontonummer ist leer","error.va.sf-ach-num.02":"Die Bankkontonummer hat die falsche L\xe4nge","error.va.sf-ach-loc.01":"Das Feld f\xfcr die Bankleitzahl ist leer","error.va.sf-ach-loc.02":"Die Bankleitzahl hat die falsche L\xe4nge","error.va.sf-kcp-pwd.01":"Das Passwortfeld ist leer","error.va.sf-kcp-pwd.02":"Das Passwort hat die falsche L\xe4nge","error.giftcard.no-balance":"Auf dieser Geschenkkarte ist kein Guthaben vorhanden","error.giftcard.card-error":"Es gibt in unserem System keine Geschenkkarte mit dieser Nummer","error.giftcard.currency-error":"Geschenkkarten sind nur in der W\xe4hrung g\xfcltig, in der sie ausgestellt wurden","amazonpay.signout":"Von Amazon abmelden","amazonpay.changePaymentDetails":"Zahlungsinformationen \xe4ndern","partialPayment.warning":"W\xe4hlen Sie eine andere Zahlungsmethode zur Zahlung des Restbetrags","partialPayment.remainingBalance":"Es verbleibt ein Restbetrag von %{amount}","bankTransfer.beneficiary":"Empf\xe4nger","bankTransfer.iban":"IBAN","bankTransfer.bic":"BIC","bankTransfer.reference":"Referenz","bankTransfer.introduction":"Fortfahren, um eine neue Bank\xfcberweisungszahlung zu erstellen. Sie k\xf6nnen die Informationen auf dem n\xe4chsten Bildschirm verwenden, um diese Zahlung abzuschlie\xdfen.","bankTransfer.instructions":"Vielen Dank f\xfcr Ihren Kauf. Bitte schlie\xdfen Sie Ihre Zahlung unter Verwendung der folgenden Informationen ab.","bacs.accountHolderName":"Name des Bankkontoinhabers","bacs.accountHolderName.invalid":"Ung\xfcltiger Bankkontoinhabername","bacs.accountNumber":"Bankkontonummer","bacs.accountNumber.invalid":"Ung\xfcltige Bankkontonummer","bacs.bankLocationId":"Bankleitzahl","bacs.bankLocationId.invalid":"Ung\xfcltige Bankleitzahl","bacs.consent.amount":"Ich bin damit einverstanden, dass der oben genannte Betrag von meinem Bankkonto abgebucht wird.","bacs.consent.account":"Ich best\xe4tige, dass das Konto unter meinem Namen l\xe4uft und ich der einzige erforderliche Unterzeichner bin, um die Lastschrift f\xfcr dieses Konto zu autorisieren.",edit:"Bearbeiten","bacs.confirm":"Best\xe4tigen und bezahlen","bacs.result.introduction":"Laden Sie Ihre Lastschriftanweisung (DDI/Einzugserm\xe4chtigung) herunter","download.pdf":"PDF herunterladen","creditCard.encryptedCardNumber.aria.iframeTitle":"Iframe f\xfcr Nummer der gesicherten Karte","creditCard.encryptedCardNumber.aria.label":"Kartennummer","creditCard.encryptedExpiryDate.aria.iframeTitle":"Iframe f\xfcr Ablaufdatum der gesicherten Karte","creditCard.encryptedExpiryDate.aria.label":"Ablaufdatum","creditCard.encryptedExpiryMonth.aria.iframeTitle":"Iframe f\xfcr Monat des Ablaufdatums der gesicherten Karte","creditCard.encryptedExpiryMonth.aria.label":"Monat des Ablaufdatums","creditCard.encryptedExpiryYear.aria.iframeTitle":"Iframe f\xfcr Jahr des Ablaufdatums der gesicherten Karte","creditCard.encryptedExpiryYear.aria.label":"Jahr des Ablaufdatums","creditCard.encryptedSecurityCode.aria.iframeTitle":"Iframe f\xfcr Sicherheitscode der gesicherten Karte","creditCard.encryptedSecurityCode.aria.label":"Sicherheitscode","creditCard.encryptedPassword.aria.iframeTitle":"Iframe f\xfcr gesichertes Kartenpasswort","creditCard.encryptedPassword.aria.label":"Die ersten zwei Ziffern des Kartenpassworts","giftcard.encryptedCardNumber.aria.iframeTitle":"Iframe f\xfcr Geschenkkartennummer der gesicherten Karte","giftcard.encryptedCardNumber.aria.label":"Geschenkgutscheinnummer","giftcard.encryptedSecurityCode.aria.iframeTitle":"Iframe f\xfcr Sicherheitscode der gesicherten Geschenkkarte","giftcard.encryptedSecurityCode.aria.label":"Sicherheitscode des Geschenkgutscheins",giftcardTransactionLimit:"Der zul\xe4ssige H\xf6chstbetrag pro Transaktion f\xfcr diese Geschenkkarte ist %{amount}","ach.encryptedBankAccountNumber.aria.iframeTitle":"Iframe f\xfcr gesicherte Bankkontonummer","ach.encryptedBankAccountNumber.aria.label":"Bankkonto","ach.encryptedBankLocationId.aria.iframeTitle":"Iframe f\xfcr gesicherte BLZ","ach.encryptedBankLocationId.aria.label":"BLZ","twint.saved":"hinterlegt",orPayWith:"oder bezahlen Sie mit",invalidFormatExpects:"Ung\xfcltiges Format. Erwartetes Format: %{format}","upi.qrCodeWaitingMessage":"Scannen Sie den QR-Code mit Ihrer bevorzugten UPI-App, um die Zahlung abzuschlie\xdfen.","upi.vpaWaitingMessage":"\xd6ffnen Sie Ihre UPI-App, um die Zahlung zu best\xe4tigen.","upi.modeSelection":"Legen Sie fest, wie Sie UPI nutzen m\xf6chten.","onlineBanking.termsAndConditions":"Wenn Sie fortfahren, stimmen Sie den %#Allgemeinen Gesch\xe4ftsbedingungen%# zu","ctp.loading.poweredByCtp":"Unterst\xfctzt von Click to Pay","ctp.loading.intro":"Wir \xfcberpr\xfcfen gerade, ob Sie bereits gespeicherte Click-to-Pay-Karten haben\xa0\u2026","ctp.login.title":"Weiter zu Click to Pay","ctp.login.subtitle":"Geben Sie die mit Click to Pay verbundene E-Mail-Adresse ein, um fortzufahren.","ctp.login.inputLabel":"E-Mail-Adresse","ctp.logout.notYou":"Sind das nicht Sie?","ctp.logout.notYourCards":"Sind das nicht Ihre Karten?","ctp.logout.notYourCard":"Das ist nicht Ihre Karte?","ctp.logout.notYourProfile":"Das ist nicht Ihr Profil?","ctp.otp.fieldLabel":"Einmaliger Code","ctp.otp.resendCode":"Code erneut senden","ctp.otp.codeResent":"Code erneut gesendet","ctp.otp.title":"Zugriff auf Ihre Click-to-Pay-Karten","ctp.otp.subtitle":"Geben Sie den Code ein, der von %@ an %@ gesendet wurde, um Ihre Identit\xe4t zu best\xe4tigen.","ctp.emptyProfile.message":"In diesem Click-to-Pay-Profil sind keine Karten registriert","ctp.separatorText":"oder verwenden","ctp.cards.title":"Zahlung mit Click to Pay abschlie\xdfen","ctp.cards.subtitle":"W\xe4hlen Sie die Karte aus, die Sie verwenden m\xf6chten.","ctp.cards.expiredCard":"Abgelaufen","ctp.manualCardEntry":"Manuelle Karteneingabe","ctp.aria.infoModalButton":"Was ist Click to Pay?","ctp.infoPopup.title":"Click to Pay ist so einfach wie kontaktloses Bezahlen, nur online","ctp.infoPopup.subtitle":"Eine schnelle, sichere Zahlungsmethode mit Mastercard, Visa und anderen Zahlungskarten.","ctp.infoPopup.benefit1":"Click to Pay nutzt Verschl\xfcsselung zum Schutz Ihrer Daten","ctp.infoPopup.benefit2":"Verf\xfcgbar bei H\xe4ndlern auf der ganzen Welt","ctp.infoPopup.benefit3":"Nach einmaliger Einrichtung bezahlen Sie in Zukunft mit nur einem Klick.","ctp.errors.AUTH_INVALID":"Authentifizierung ung\xfcltig","ctp.errors.NOT_FOUND":"Kein Konto gefunden, geben Sie eine g\xfcltige E-Mail-Adresse ein oder fahren Sie mit der manuellen Karteneingabe fort.","ctp.errors.ID_FORMAT_UNSUPPORTED":"Format wird nicht unterst\xfctzt","ctp.errors.FRAUD":"Das Benutzerkonto wurde gesperrt oder deaktiviert","ctp.errors.CONSUMER_ID_MISSING":"Die Identit\xe4t des Verbrauchers fehlt in der Anfrage","ctp.errors.ACCT_INACCESSIBLE":"Dieses Konto ist derzeit nicht verf\xfcgbar; es kann z.\xa0B. gesperrt sein.","ctp.errors.CODE_INVALID":"Falscher Verifizierungscode","ctp.errors.CODE_EXPIRED":"Dieser Code ist abgelaufen","ctp.errors.RETRIES_EXCEEDED":"Das Limit f\xfcr die Anzahl der Wiederholungen f\xfcr das Generieren von Einmalpassw\xf6rtern (OTPs) wurde \xfcberschritten","ctp.errors.OTP_SEND_FAILED":"Das Einmalpasswort (OTP) konnte nicht an den Empf\xe4nger gesendet werden","ctp.errors.REQUEST_TIMEOUT":"Ein Fehler ist aufgetreten, versuchen Sie es erneut oder nutzen Sie die manuelle Karteneingabe.","ctp.errors.UNKNOWN_ERROR":"Ein Fehler ist aufgetreten, versuchen Sie es erneut oder nutzen Sie die manuelle Karteneingabe.","ctp.errors.SERVICE_ERROR":"Ein Fehler ist aufgetreten, versuchen Sie es erneut oder nutzen Sie die manuelle Karteneingabe.","ctp.errors.SERVER_ERROR":"Ein Fehler ist aufgetreten, versuchen Sie es erneut oder nutzen Sie die manuelle Karteneingabe.","ctp.errors.INVALID_PARAMETER":"Ein Fehler ist aufgetreten, versuchen Sie es erneut oder nutzen Sie die manuelle Karteneingabe.","ctp.errors.AUTH_ERROR":"Ein Fehler ist aufgetreten, versuchen Sie es erneut oder nutzen Sie die manuelle Karteneingabe.","paymentMethodsList.aria.label":"W\xe4hlen Sie eine Zahlungsmethode aus"}}),N3=Object.freeze({__proto__:null,default:{payButton:"\u03a0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae","payButton.redirecting":"\u0391\u03bd\u03b1\u03ba\u03b1\u03c4\u03b5\u03cd\u03b8\u03c5\u03bd\u03c3\u03b7...","payButton.with":"\u03a0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae %{value} \u03bc\u03b5 %{maskedData}",close:"\u039a\u03bb\u03b5\u03af\u03c3\u03b9\u03bc\u03bf",storeDetails:"\u0391\u03c0\u03bf\u03b8\u03ae\u03ba\u03b5\u03c5\u03c3\u03b7 \u03b3\u03b9\u03b1 \u03c4\u03b7\u03bd \u03b5\u03c0\u03cc\u03bc\u03b5\u03bd\u03b7 \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae \u03bc\u03bf\u03c5","creditCard.holderName":"\u038c\u03bd\u03bf\u03bc\u03b1 \u03c3\u03c4\u03b7\u03bd \u03ba\u03ac\u03c1\u03c4\u03b1","creditCard.holderName.placeholder":"\u0393. \u03a0\u03b1\u03c0\u03b1\u03b4\u03ac\u03ba\u03b7\u03c2","creditCard.holderName.invalid":"\u039c\u03b7 \u03ad\u03b3\u03ba\u03c5\u03c1\u03bf \u03cc\u03bd\u03bf\u03bc\u03b1 \u03ba\u03b1\u03c4\u03cc\u03c7\u03bf\u03c5 \u03ba\u03ac\u03c1\u03c4\u03b1\u03c2","creditCard.numberField.title":"\u0391\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03ba\u03ac\u03c1\u03c4\u03b1\u03c2","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"\u0397\u03bc\u03b5\u03c1\u03bf\u03bc\u03b7\u03bd\u03af\u03b1 \u03bb\u03ae\u03be\u03b7\u03c2","creditCard.expiryDateField.placeholder":"\u039c\u039c/\u0395\u0395","creditCard.expiryDateField.month":"\u039c\u03ae\u03bd\u03b1\u03c2","creditCard.expiryDateField.month.placeholder":"\u039c\u039c","creditCard.expiryDateField.year.placeholder":"\u0395\u0395","creditCard.expiryDateField.year":"\u0388\u03c4\u03bf\u03c2","creditCard.cvcField.title":"CVC/CVV","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"\u0391\u03c0\u03bf\u03bc\u03bd\u03b7\u03bc\u03cc\u03bd\u03b5\u03c5\u03c3\u03b7 \u03b3\u03b9\u03b1 \u03c4\u03b7\u03bd \u03b5\u03c0\u03cc\u03bc\u03b5\u03bd\u03b7 \u03c6\u03bf\u03c1\u03ac","creditCard.cvcField.placeholder.4digits":"4\u03c8\u03ae\u03c6\u03b9\u03bf\u03c2","creditCard.cvcField.placeholder.3digits":"3\u03c8\u03ae\u03c6\u03b9\u03bf\u03c2","creditCard.taxNumber.placeholder":"\u0395\u0395\u039c\u039c\u0397\u0397 / 0123456789",installments:"\u0391\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03b4\u03cc\u03c3\u03b5\u03c9\u03bd",installmentOption:"%{times}x %{partialValue}",installmentOptionMonths:"%{times} \u03bc\u03ae\u03bd\u03b5\u03c2","installments.oneTime":"\u0395\u03c6\u03ac\u03c0\u03b1\u03be \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae","installments.installments":"\u03a0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae \u03bc\u03b5 \u03b4\u03cc\u03c3\u03b5\u03b9\u03c2","installments.revolving":"\u0391\u03bd\u03b1\u03ba\u03c5\u03ba\u03bb\u03bf\u03cd\u03bc\u03b5\u03bd\u03b7 \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae","sepaDirectDebit.ibanField.invalid":"\u039c\u03b7 \u03ad\u03b3\u03ba\u03c5\u03c1\u03bf\u03c2 \u03b1\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03bb\u03bf\u03b3\u03b1\u03c1\u03b9\u03b1\u03c3\u03bc\u03bf\u03cd","sepaDirectDebit.nameField.placeholder":"\u0393. \u03a0\u03b1\u03c0\u03b1\u03b4\u03ac\u03ba\u03b7\u03c2","sepa.ownerName":"\u038c\u03bd\u03bf\u03bc\u03b1 \u03ba\u03b1\u03c4\u03cc\u03c7\u03bf\u03c5","sepa.ibanNumber":"\u0391\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03bb\u03bf\u03b3\u03b1\u03c1\u03b9\u03b1\u03c3\u03bc\u03bf\u03cd (IBAN)","error.title":"\u03a3\u03c6\u03ac\u03bb\u03bc\u03b1","error.subtitle.redirect":"\u0397 \u03b1\u03bd\u03b1\u03ba\u03b1\u03c4\u03b5\u03cd\u03b8\u03c5\u03bd\u03c3\u03b7 \u03b1\u03c0\u03ad\u03c4\u03c5\u03c7\u03b5","error.subtitle.payment":"\u0397 \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae \u03b1\u03c0\u03ad\u03c4\u03c5\u03c7\u03b5","error.subtitle.refused":"\u0397 \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae \u03b1\u03c0\u03bf\u03c1\u03c1\u03af\u03c6\u03b8\u03b7\u03ba\u03b5","error.message.unknown":"\u03a0\u03c1\u03bf\u03ad\u03ba\u03c5\u03c8\u03b5 \u03ac\u03b3\u03bd\u03c9\u03c3\u03c4\u03bf \u03c3\u03c6\u03ac\u03bb\u03bc\u03b1","errorPanel.title":"\u03a5\u03c0\u03ac\u03c1\u03c7\u03bf\u03bd\u03c4\u03b1 \u03c3\u03c6\u03ac\u03bb\u03bc\u03b1\u03c4\u03b1","idealIssuer.selectField.title":"\u03a4\u03c1\u03ac\u03c0\u03b5\u03b6\u03b1","idealIssuer.selectField.placeholder":"\u0395\u03c0\u03b9\u03bb\u03ad\u03be\u03c4\u03b5 \u03c4\u03b7\u03bd \u03c4\u03c1\u03ac\u03c0\u03b5\u03b6\u03ac \u03c3\u03b1\u03c2","creditCard.success":"\u0397 \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae \u03bf\u03bb\u03bf\u03ba\u03bb\u03b7\u03c1\u03ce\u03b8\u03b7\u03ba\u03b5 \u03b5\u03c0\u03b9\u03c4\u03c5\u03c7\u03ce\u03c2",loading:"\u03a6\u03cc\u03c1\u03c4\u03c9\u03c3\u03b7...",continue:"\u03a3\u03c5\u03bd\u03ad\u03c7\u03b5\u03b9\u03b1",continueTo:"\u039c\u03b5\u03c4\u03ac\u03b2\u03b1\u03c3\u03b7 \u03c3\u03c4\u03b7\u03bd","wechatpay.timetopay":"\u0388\u03c7\u03b5\u03c4\u03b5 \u03c3\u03c4\u03b7 \u03b4\u03b9\u03ac\u03b8\u03b5\u03c3\u03ae \u03c3\u03b1\u03c2 %@ \u03b3\u03b9\u03b1 \u03c4\u03b7\u03bd \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae","wechatpay.scanqrcode":"\u03a3\u03ac\u03c1\u03c9\u03c3\u03b7 \u03ba\u03c9\u03b4\u03b9\u03ba\u03bf\u03cd QR",personalDetails:"\u03a0\u03c1\u03bf\u03c3\u03c9\u03c0\u03b9\u03ba\u03ac \u03c3\u03c4\u03bf\u03b9\u03c7\u03b5\u03af\u03b1",companyDetails:"\u03a3\u03c4\u03bf\u03b9\u03c7\u03b5\u03af\u03b1 \u03b5\u03c4\u03b1\u03b9\u03c1\u03b5\u03af\u03b1\u03c2","companyDetails.name":"\u038c\u03bd\u03bf\u03bc\u03b1 \u03b5\u03c4\u03b1\u03b9\u03c1\u03b5\u03af\u03b1\u03c2","companyDetails.registrationNumber":"\u0391\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03bc\u03b7\u03c4\u03c1\u03ce\u03bf\u03c5",socialSecurityNumber:"\u0391\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03c6\u03bf\u03c1\u03bf\u03bb\u03bf\u03b3\u03b9\u03ba\u03bf\u03cd \u03bc\u03b7\u03c4\u03c1\u03ce\u03bf\u03c5",firstName:"\u038c\u03bd\u03bf\u03bc\u03b1","firstName.invalid":"\u03a4\u03bf \u03cc\u03bd\u03bf\u03bc\u03b1 \u03b4\u03b5\u03bd \u03b5\u03af\u03bd\u03b1\u03b9 \u03ad\u03b3\u03ba\u03c5\u03c1\u03bf",infix:"\u03a0\u03c1\u03cc\u03b8\u03b5\u03bc\u03b1",lastName:"\u0395\u03c0\u03ce\u03bd\u03c5\u03bc\u03bf","lastName.invalid":"\u03a4\u03bf \u03b5\u03c0\u03ce\u03bd\u03c5\u03bc\u03bf \u03b4\u03b5\u03bd \u03b5\u03af\u03bd\u03b1\u03b9 \u03ad\u03b3\u03ba\u03c5\u03c1\u03bf",mobileNumber:"\u0391\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03ba\u03b9\u03bd\u03b7\u03c4\u03bf\u03cd","mobileNumber.invalid":"\u039c\u03b7 \u03ad\u03b3\u03ba\u03c5\u03c1\u03bf\u03c2 \u03b1\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03ba\u03b9\u03bd\u03b7\u03c4\u03bf\u03cd",city:"\u03a0\u03cc\u03bb\u03b7",postalCode:"\u03a4\u03b1\u03c7\u03c5\u03b4\u03c1\u03bf\u03bc\u03b9\u03ba\u03cc\u03c2 \u03ba\u03c9\u03b4\u03b9\u03ba\u03cc\u03c2","postalCode.optional":"\u03a4\u03b1\u03c7\u03c5\u03b4\u03c1\u03bf\u03bc\u03b9\u03ba\u03cc\u03c2 \u03ba\u03c9\u03b4\u03b9\u03ba\u03cc\u03c2 (\u03c0\u03c1\u03bf\u03b1\u03b9\u03c1\u03b5\u03c4\u03b9\u03ba\u03cc)",countryCode:"\u039a\u03c9\u03b4\u03b9\u03ba\u03cc\u03c2 \u03c7\u03ce\u03c1\u03b1\u03c2",telephoneNumber:"\u0391\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03c4\u03b7\u03bb\u03b5\u03c6\u03ce\u03bd\u03bf\u03c5",dateOfBirth:"\u0397\u03bc\u03b5\u03c1\u03bf\u03bc\u03b7\u03bd\u03af\u03b1 \u03b3\u03ad\u03bd\u03bd\u03b7\u03c3\u03b7\u03c2",shopperEmail:"\u0394\u03b9\u03b5\u03cd\u03b8\u03c5\u03bd\u03c3\u03b7 email",gender:"\u03a6\u03cd\u03bb\u03bf",male:"\u0386\u03bd\u03c4\u03c1\u03b1\u03c2",female:"\u0393\u03c5\u03bd\u03b1\u03af\u03ba\u03b1",billingAddress:"\u0394\u03b9\u03b5\u03cd\u03b8\u03c5\u03bd\u03c3\u03b7 \u03c4\u03b9\u03bc\u03bf\u03bb\u03cc\u03b3\u03b7\u03c3\u03b7\u03c2",street:"\u039f\u03b4\u03cc\u03c2",stateOrProvince:"\u03a0\u03bf\u03bb\u03b9\u03c4\u03b5\u03af\u03b1 \u03ae \u03b5\u03c0\u03b1\u03c1\u03c7\u03af\u03b1",country:"\u03a7\u03ce\u03c1\u03b1",houseNumberOrName:"\u0391\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03bf\u03b9\u03ba\u03af\u03b1\u03c2",separateDeliveryAddress:"\u039a\u03b1\u03b8\u03bf\u03c1\u03af\u03c3\u03c4\u03b5 \u03bc\u03b9\u03b1 \u03be\u03b5\u03c7\u03c9\u03c1\u03b9\u03c3\u03c4\u03ae \u03b4\u03b9\u03b5\u03cd\u03b8\u03c5\u03bd\u03c3\u03b7 \u03c0\u03b1\u03c1\u03ac\u03b4\u03bf\u03c3\u03b7\u03c2",deliveryAddress:"\u0394\u03b9\u03b5\u03cd\u03b8\u03c5\u03bd\u03c3\u03b7 \u03c0\u03b1\u03c1\u03ac\u03b4\u03bf\u03c3\u03b7\u03c2",zipCode:"\u03a4\u03b1\u03c7\u03c5\u03b4\u03c1\u03bf\u03bc\u03b9\u03ba\u03cc\u03c2 \u03ba\u03ce\u03b4\u03b9\u03ba\u03b1\u03c2",apartmentSuite:"\u0394\u03b9\u03b1\u03bc\u03ad\u03c1\u03b9\u03c3\u03bc\u03b1/\u0393\u03c1\u03b1\u03c6\u03b5\u03af\u03bf",provinceOrTerritory:"\u0395\u03c0\u03b1\u03c1\u03c7\u03af\u03b1 \u03ae \u03c0\u03b5\u03c1\u03b9\u03c6\u03ad\u03c1\u03b5\u03b9\u03b1",cityTown:"\u03a0\u03cc\u03bb\u03b7 / \u039a\u03bf\u03b9\u03bd\u03cc\u03c4\u03b7\u03c4\u03b1",address:"\u0394\u03b9\u03b5\u03cd\u03b8\u03c5\u03bd\u03c3\u03b7",state:"\u03a0\u03bf\u03bb\u03b9\u03c4\u03b5\u03af\u03b1","field.title.optional":"(\u03c0\u03c1\u03bf\u03b1\u03b9\u03c1\u03b5\u03c4\u03b9\u03ba\u03cc)","creditCard.cvcField.title.optional":"CVC/CVV (\u03c0\u03c1\u03bf\u03b1\u03b9\u03c1\u03b5\u03c4\u03b9\u03ba\u03ac)","issuerList.wallet.placeholder":"\u0395\u03c0\u03b9\u03bb\u03ad\u03be\u03c4\u03b5 \u03c4\u03bf \u03c0\u03bf\u03c1\u03c4\u03bf\u03c6\u03cc\u03bb\u03b9 \u03c3\u03b1\u03c2",privacyPolicy:"\u03a0\u03bf\u03bb\u03b9\u03c4\u03b9\u03ba\u03ae \u03b1\u03c0\u03bf\u03c1\u03c1\u03ae\u03c4\u03bf\u03c5","afterPay.agreement":"\u0391\u03c0\u03bf\u03b4\u03ad\u03c7\u03bf\u03bc\u03b1\u03b9 \u03c4\u03bf\u03c5\u03c2 %@ \u03c4\u03bf\u03c5 AfterPay",paymentConditions:"\u03cc\u03c1\u03bf\u03c5\u03c2 \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae\u03c2",openApp:"\u0386\u03bd\u03bf\u03b9\u03b3\u03bc\u03b1 \u03c4\u03b7\u03c2 \u03b5\u03c6\u03b1\u03c1\u03bc\u03bf\u03b3\u03ae\u03c2","voucher.readInstructions":"\u0394\u03b9\u03b1\u03b2\u03ac\u03c3\u03c4\u03b5 \u03c4\u03b9\u03c2 \u03bf\u03b4\u03b7\u03b3\u03af\u03b5\u03c2","voucher.introduction":"\u03a3\u03b1\u03c2 \u03b5\u03c5\u03c7\u03b1\u03c1\u03b9\u03c3\u03c4\u03bf\u03cd\u03bc\u03b5 \u03b3\u03b9\u03b1 \u03c4\u03b7\u03bd \u03b1\u03b3\u03bf\u03c1\u03ac. \u03a7\u03c1\u03b7\u03c3\u03b9\u03bc\u03bf\u03c0\u03bf\u03b9\u03ae\u03c3\u03c4\u03b5 \u03c4\u03bf \u03c0\u03b1\u03c1\u03b1\u03ba\u03ac\u03c4\u03c9 \u03ba\u03bf\u03c5\u03c0\u03cc\u03bd\u03b9 \u03b3\u03b9\u03b1 \u03bd\u03b1 \u03bf\u03bb\u03bf\u03ba\u03bb\u03b7\u03c1\u03ce\u03c3\u03b5\u03c4\u03b5 \u03c4\u03b7\u03bd \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae.","voucher.expirationDate":"\u0397\u03bc\u03b5\u03c1\u03bf\u03bc\u03b7\u03bd\u03af\u03b1 \u03bb\u03ae\u03be\u03b7\u03c2","voucher.alternativeReference":"\u0395\u03bd\u03b1\u03bb\u03bb\u03b1\u03ba\u03c4\u03b9\u03ba\u03ae \u03b1\u03bd\u03b1\u03c6\u03bf\u03c1\u03ac","dragonpay.voucher.non.bank.selectField.placeholder":"\u0395\u03c0\u03b9\u03bb\u03ad\u03be\u03c4\u03b5 \u03c4\u03bf\u03bd \u03c0\u03ac\u03c1\u03bf\u03c7\u03cc \u03c3\u03b1\u03c2","dragonpay.voucher.bank.selectField.placeholder":"\u0395\u03c0\u03b9\u03bb\u03ad\u03be\u03c4\u03b5 \u03c4\u03b7\u03bd \u03c4\u03c1\u03ac\u03c0\u03b5\u03b6\u03ac \u03c3\u03b1\u03c2","voucher.paymentReferenceLabel":"\u0391\u03bd\u03b1\u03c6\u03bf\u03c1\u03ac \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae\u03c2","voucher.surcharge":"\u03a0\u03b5\u03c1\u03b9\u03bb\u03b1\u03bc\u03b2\u03ac\u03bd\u03b5\u03c4\u03b1\u03b9 \u03c0\u03c1\u03cc\u03c3\u03b8\u03b5\u03c4\u03b7 \u03c7\u03c1\u03ad\u03c9\u03c3\u03b7 %@","voucher.introduction.doku":"\u03a3\u03b1\u03c2 \u03b5\u03c5\u03c7\u03b1\u03c1\u03b9\u03c3\u03c4\u03bf\u03cd\u03bc\u03b5 \u03b3\u03b9\u03b1 \u03c4\u03b7\u03bd \u03b1\u03b3\u03bf\u03c1\u03ac. \u03a7\u03c1\u03b7\u03c3\u03b9\u03bc\u03bf\u03c0\u03bf\u03b9\u03ae\u03c3\u03c4\u03b5 \u03c4\u03b9\u03c2 \u03b1\u03ba\u03cc\u03bb\u03bf\u03c5\u03b8\u03b5\u03c2 \u03c0\u03bb\u03b7\u03c1\u03bf\u03c6\u03bf\u03c1\u03af\u03b5\u03c2 \u03b3\u03b9\u03b1 \u03bd\u03b1 \u03bf\u03bb\u03bf\u03ba\u03bb\u03b7\u03c1\u03ce\u03c3\u03b5\u03c4\u03b5 \u03c4\u03b7\u03bd \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae.","voucher.shopperName":"\u038c\u03bd\u03bf\u03bc\u03b1 \u03b1\u03b3\u03bf\u03c1\u03b1\u03c3\u03c4\u03ae","voucher.merchantName":"\u0388\u03bc\u03c0\u03bf\u03c1\u03bf\u03c2","voucher.introduction.econtext":"\u03a3\u03b1\u03c2 \u03b5\u03c5\u03c7\u03b1\u03c1\u03b9\u03c3\u03c4\u03bf\u03cd\u03bc\u03b5 \u03b3\u03b9\u03b1 \u03c4\u03b7\u03bd \u03b1\u03b3\u03bf\u03c1\u03ac. \u03a7\u03c1\u03b7\u03c3\u03b9\u03bc\u03bf\u03c0\u03bf\u03b9\u03ae\u03c3\u03c4\u03b5 \u03c4\u03b9\u03c2 \u03b1\u03ba\u03cc\u03bb\u03bf\u03c5\u03b8\u03b5\u03c2 \u03c0\u03bb\u03b7\u03c1\u03bf\u03c6\u03bf\u03c1\u03af\u03b5\u03c2 \u03b3\u03b9\u03b1 \u03bd\u03b1 \u03bf\u03bb\u03bf\u03ba\u03bb\u03b7\u03c1\u03ce\u03c3\u03b5\u03c4\u03b5 \u03c4\u03b7\u03bd \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae.","voucher.telephoneNumber":"\u0391\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03c4\u03b7\u03bb\u03b5\u03c6\u03ce\u03bd\u03bf\u03c5","voucher.shopperReference":"\u0391\u03bd\u03b1\u03c6\u03bf\u03c1\u03ac \u03b1\u03b3\u03bf\u03c1\u03b1\u03c3\u03c4\u03ae","voucher.collectionInstitutionNumber":"\u0391\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03c0\u03c1\u03b1\u03ba\u03c4\u03bf\u03c1\u03b5\u03af\u03bf\u03c5 \u03b5\u03b9\u03c3\u03c0\u03c1\u03ac\u03be\u03b5\u03c9\u03bd","voucher.econtext.telephoneNumber.invalid":"\u039f \u03b1\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03c4\u03b7\u03bb\u03b5\u03c6\u03ce\u03bd\u03bf\u03c5 \u03c0\u03c1\u03ad\u03c0\u03b5\u03b9 \u03bd\u03b1 \u03c0\u03b5\u03c1\u03b9\u03ad\u03c7\u03b5\u03b9 10 \u03ae 11 \u03c8\u03b7\u03c6\u03af\u03b1","boletobancario.btnLabel":"\u0394\u03b7\u03bc\u03b9\u03bf\u03c5\u03c1\u03b3\u03af\u03b1 Boleto","boleto.sendCopyToEmail":"\u0391\u03c0\u03bf\u03c3\u03c4\u03bf\u03bb\u03ae \u03b1\u03bd\u03c4\u03b9\u03b3\u03c1\u03ac\u03c6\u03bf\u03c5 \u03c3\u03c4\u03b7 \u03b4\u03b9\u03b5\u03cd\u03b8\u03c5\u03bd\u03c3\u03b7 email \u03bc\u03bf\u03c5","button.copy":"\u0391\u03bd\u03c4\u03b9\u03b3\u03c1\u03b1\u03c6\u03ae","button.download":"\u039b\u03ae\u03c8\u03b7","boleto.socialSecurityNumber.invalid":"\u03a4\u03bf \u03c0\u03b5\u03b4\u03af\u03bf \u03b4\u03b5\u03bd \u03b5\u03af\u03bd\u03b1\u03b9 \u03ad\u03b3\u03ba\u03c5\u03c1\u03bf","creditCard.storedCard.description.ariaLabel":"\u0397 \u03b1\u03c0\u03bf\u03b8\u03b7\u03ba\u03b5\u03c5\u03bc\u03ad\u03bd\u03b7 \u03ba\u03ac\u03c1\u03c4\u03b1 \u03c4\u03b5\u03bb\u03b5\u03b9\u03ce\u03bd\u03b5\u03b9 \u03c3\u03b5 %@","voucher.entity":"\u039f\u03bd\u03c4\u03cc\u03c4\u03b7\u03c4\u03b1",donateButton:"\u0394\u03c9\u03c1\u03b5\u03ac",notNowButton:"\u038c\u03c7\u03b9 \u03c4\u03ce\u03c1\u03b1",thanksForYourSupport:"\u03a3\u03b1\u03c2 \u03b5\u03c5\u03c7\u03b1\u03c1\u03b9\u03c3\u03c4\u03bf\u03cd\u03bc\u03b5 \u03b3\u03b9\u03b1 \u03c4\u03b7\u03bd \u03c5\u03c0\u03bf\u03c3\u03c4\u03ae\u03c1\u03b9\u03be\u03b7!",preauthorizeWith:"\u03a0\u03c1\u03bf\u03b5\u03be\u03bf\u03c5\u03c3\u03b9\u03bf\u03b4\u03cc\u03c4\u03b7\u03c3\u03b7 \u03bc\u03b5",confirmPreauthorization:"\u0395\u03c0\u03b9\u03b2\u03b5\u03b2\u03b1\u03af\u03c9\u03c3\u03b7 \u03c0\u03c1\u03bf\u03b5\u03be\u03bf\u03c5\u03c3\u03b9\u03bf\u03b4\u03cc\u03c4\u03b7\u03c3\u03b7\u03c2",confirmPurchase:"\u0395\u03c0\u03b9\u03b2\u03b5\u03b2\u03b1\u03af\u03c9\u03c3\u03b7 \u03b1\u03b3\u03bf\u03c1\u03ac\u03c2",applyGiftcard:"\u0395\u03be\u03b1\u03c1\u03b3\u03cd\u03c1\u03c9\u03c3\u03b7",giftcardBalance:"\u03a5\u03c0\u03cc\u03bb\u03bf\u03b9\u03c0\u03bf \u03b4\u03c9\u03c1\u03bf\u03ba\u03ac\u03c1\u03c4\u03b1\u03c2",deductedBalance:"\u03a5\u03c0\u03cc\u03bb\u03bf\u03b9\u03c0\u03bf \u03c0\u03bf\u03c5 \u03b1\u03c6\u03b1\u03b9\u03c1\u03ad\u03b8\u03b7\u03ba\u03b5","creditCard.pin.title":"\u039a\u03c9\u03b4\u03b9\u03ba\u03cc\u03c2 PIN","creditCard.encryptedPassword.label":"\u03a4\u03b1 \u03c0\u03c1\u03ce\u03c4\u03b1 2 \u03c8\u03b7\u03c6\u03af\u03b1 \u03c4\u03bf\u03c5 \u03ba\u03c9\u03b4\u03b9\u03ba\u03bf\u03cd \u03c0\u03c1\u03cc\u03c3\u03b2\u03b1\u03c3\u03b7\u03c2 \u03c4\u03b7\u03c2 \u03ba\u03ac\u03c1\u03c4\u03b1\u03c2","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"\u039c\u03b7 \u03ad\u03b3\u03ba\u03c5\u03c1\u03bf\u03c2 \u03ba\u03c9\u03b4\u03b9\u03ba\u03cc\u03c2 \u03c0\u03c1\u03cc\u03c3\u03b2\u03b1\u03c3\u03b7\u03c2","creditCard.taxNumber":"\u0397\u03bc\u03b5\u03c1\u03bf\u03bc\u03b7\u03bd\u03af\u03b1 \u03b3\u03ad\u03bd\u03bd\u03b7\u03c3\u03b7\u03c2 \u03ba\u03b1\u03c4\u03cc\u03c7\u03bf\u03c5 \u03ba\u03ac\u03c1\u03c4\u03b1\u03c2 \u03ae \u03b1\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03bc\u03b7\u03c4\u03c1\u03ce\u03bf\u03c5 \u03b5\u03c4\u03b1\u03b9\u03c1\u03b5\u03b9\u03ce\u03bd","creditCard.taxNumber.label":"\u0397\u03bc\u03b5\u03c1\u03bf\u03bc\u03b7\u03bd\u03af\u03b1 \u03b3\u03ad\u03bd\u03bd\u03b7\u03c3\u03b7\u03c2 \u03ba\u03b1\u03c4\u03cc\u03c7\u03bf\u03c5 \u03ba\u03ac\u03c1\u03c4\u03b1\u03c2 (YYMMDD) \u03ae \u03b1\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03bc\u03b7\u03c4\u03c1\u03ce\u03bf\u03c5 \u03b5\u03c4\u03b1\u03b9\u03c1\u03b5\u03b9\u03ce\u03bd (10 \u03c8\u03b7\u03c6\u03af\u03b1)","creditCard.taxNumber.labelAlt":"\u0391\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03bc\u03b7\u03c4\u03c1\u03ce\u03bf\u03c5 \u03b5\u03c4\u03b1\u03b9\u03c1\u03b5\u03b9\u03ce\u03bd (10 \u03c8\u03b7\u03c6\u03af\u03b1)","creditCard.taxNumber.invalid":"\u039c\u03b7 \u03ad\u03b3\u03ba\u03c5\u03c1\u03b7 \u03b7\u03bc\u03b5\u03c1\u03bf\u03bc\u03b7\u03bd\u03af\u03b1 \u03b3\u03ad\u03bd\u03bd\u03b7\u03c3\u03b7\u03c2 \u03ba\u03b1\u03c4\u03cc\u03c7\u03bf\u03c5 \u03ba\u03ac\u03c1\u03c4\u03b1\u03c2 \u03ae \u03b1\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03bc\u03b7\u03c4\u03c1\u03ce\u03bf\u03c5 \u03b5\u03c4\u03b1\u03b9\u03c1\u03b5\u03b9\u03ce\u03bd","storedPaymentMethod.disable.button":"\u0391\u03c6\u03b1\u03af\u03c1\u03b5\u03c3\u03b7","storedPaymentMethod.disable.confirmation":"\u0391\u03c6\u03b1\u03af\u03c1\u03b5\u03c3\u03b7 \u03b1\u03c0\u03bf\u03b8\u03b7\u03ba\u03b5\u03c5\u03bc\u03ad\u03bd\u03bf\u03c5 \u03c4\u03c1\u03cc\u03c0\u03bf\u03c5 \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae\u03c2","storedPaymentMethod.disable.confirmButton":"\u039d\u03b1\u03b9, \u03b1\u03c6\u03b1\u03af\u03c1\u03b5\u03c3\u03b7","storedPaymentMethod.disable.cancelButton":"\u0386\u03ba\u03c5\u03c1\u03bf","ach.bankAccount":"\u03a4\u03c1\u03b1\u03c0\u03b5\u03b6\u03b9\u03ba\u03cc\u03c2 \u03bb\u03bf\u03b3\u03b1\u03c1\u03b9\u03b1\u03c3\u03bc\u03cc\u03c2","ach.accountHolderNameField.title":"\u038c\u03bd\u03bf\u03bc\u03b1 \u03ba\u03b1\u03c4\u03cc\u03c7\u03bf\u03c5 \u03bb\u03bf\u03b3\u03b1\u03c1\u03b9\u03b1\u03c3\u03bc\u03bf\u03cd","ach.accountHolderNameField.placeholder":"\u0393. \u03a0\u03b1\u03c0\u03b1\u03b4\u03ac\u03ba\u03b7\u03c2","ach.accountHolderNameField.invalid":"\u039c\u03b7 \u03ad\u03b3\u03ba\u03c5\u03c1\u03bf \u03cc\u03bd\u03bf\u03bc\u03b1 \u03ba\u03b1\u03c4\u03cc\u03c7\u03bf\u03c5 \u03bb\u03bf\u03b3\u03b1\u03c1\u03b9\u03b1\u03c3\u03bc\u03bf\u03cd","ach.accountNumberField.title":"\u0391\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03bb\u03bf\u03b3\u03b1\u03c1\u03b9\u03b1\u03c3\u03bc\u03bf\u03cd","ach.accountNumberField.invalid":"\u039c\u03b7 \u03ad\u03b3\u03ba\u03c5\u03c1\u03bf\u03c2 \u03b1\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03bb\u03bf\u03b3\u03b1\u03c1\u03b9\u03b1\u03c3\u03bc\u03bf\u03cd","ach.accountLocationField.title":"\u0391\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03b4\u03c1\u03bf\u03bc\u03bf\u03bb\u03cc\u03b3\u03b7\u03c3\u03b7\u03c2 ABA","ach.accountLocationField.invalid":"\u039c\u03b7 \u03ad\u03b3\u03ba\u03c5\u03c1\u03bf\u03c2 \u03b1\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03b4\u03c1\u03bf\u03bc\u03bf\u03bb\u03cc\u03b3\u03b7\u03c3\u03b7\u03c2 ABA","ach.savedBankAccount":"\u0391\u03c0\u03bf\u03b8\u03b7\u03ba\u03b5\u03c5\u03bc\u03ad\u03bd\u03bf\u03c2 \u03c4\u03c1\u03b1\u03c0\u03b5\u03b6\u03b9\u03ba\u03cc\u03c2 \u03bb\u03bf\u03b3\u03b1\u03c1\u03b9\u03b1\u03c3\u03bc\u03cc\u03c2","select.state":"\u0395\u03c0\u03b9\u03bb\u03ad\u03be\u03c4\u03b5 \u03c0\u03bf\u03bb\u03b9\u03c4\u03b5\u03af\u03b1","select.stateOrProvince":"\u0395\u03c0\u03b9\u03bb\u03ad\u03be\u03c4\u03b5 \u03c0\u03bf\u03bb\u03b9\u03c4\u03b5\u03af\u03b1 \u03ae \u03b5\u03c0\u03b1\u03c1\u03c7\u03af\u03b1","select.provinceOrTerritory":"\u0395\u03c0\u03b9\u03bb\u03ad\u03be\u03c4\u03b5 \u03b5\u03c0\u03b1\u03c1\u03c7\u03af\u03b1 \u03ae \u03c0\u03b5\u03c1\u03b9\u03c6\u03ad\u03c1\u03b5\u03b9\u03b1","select.country":"\u0395\u03c0\u03b9\u03bb\u03ad\u03be\u03c4\u03b5 \u03c7\u03ce\u03c1\u03b1","select.noOptionsFound":"\u0394\u03b5\u03bd \u03b2\u03c1\u03ad\u03b8\u03b7\u03ba\u03b1\u03bd \u03b5\u03c0\u03b9\u03bb\u03bf\u03b3\u03ad\u03c2","select.filter.placeholder":"\u0391\u03bd\u03b1\u03b6\u03ae\u03c4\u03b7\u03c3\u03b7...","telephoneNumber.invalid":"\u039c\u03b7 \u03ad\u03b3\u03ba\u03c5\u03c1\u03bf\u03c2 \u03b1\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03c4\u03b7\u03bb\u03b5\u03c6\u03ce\u03bd\u03bf\u03c5",qrCodeOrApp:"\u03ae","paypal.processingPayment":"\u0395\u03c0\u03b5\u03be\u03b5\u03c1\u03b3\u03b1\u03c3\u03af\u03b1 \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae\u03c2...",generateQRCode:"\u0394\u03b7\u03bc\u03b9\u03bf\u03c5\u03c1\u03b3\u03af\u03b1 \u03ba\u03c9\u03b4\u03b9\u03ba\u03bf\u03cd QR","await.waitForConfirmation":"\u0391\u03bd\u03b1\u03bc\u03bf\u03bd\u03ae \u03b3\u03b9\u03b1 \u03b5\u03c0\u03b9\u03b2\u03b5\u03b2\u03b1\u03af\u03c9\u03c3\u03b7\u2026","mbway.confirmPayment":"\u0395\u03c0\u03b9\u03b2\u03b5\u03b2\u03b1\u03b9\u03ce\u03c3\u03c4\u03b5 \u03c4\u03b7\u03bd \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae \u03c3\u03c4\u03b7\u03bd \u03b5\u03c6\u03b1\u03c1\u03bc\u03bf\u03b3\u03ae MB WAY","shopperEmail.invalid":"\u039c\u03b7 \u03ad\u03b3\u03ba\u03c5\u03c1\u03b7 \u03b4\u03b9\u03b5\u03cd\u03b8\u03c5\u03bd\u03c3\u03b7 email","dateOfBirth.format":"\u0397\u0397/\u039c\u039c/\u0395\u0395\u0395\u0395","dateOfBirth.invalid":"\u03a0\u03c1\u03ad\u03c0\u03b5\u03b9 \u03bd\u03b1 \u03b5\u03af\u03c3\u03c4\u03b5 \u03c4\u03bf\u03c5\u03bb\u03ac\u03c7\u03b9\u03c3\u03c4\u03bf\u03bd 18 \u03b5\u03c4\u03ce\u03bd","blik.confirmPayment":"\u0391\u03bd\u03bf\u03af\u03be\u03c4\u03b5 \u03c4\u03b7\u03bd \u03b5\u03c6\u03b1\u03c1\u03bc\u03bf\u03b3\u03ae \u03c4\u03c1\u03b1\u03c0\u03b5\u03b6\u03b9\u03ba\u03ae\u03c2 \u03c3\u03b1\u03c2 \u03b3\u03b9\u03b1 \u03bd\u03b1 \u03b5\u03c0\u03b9\u03b2\u03b5\u03b2\u03b1\u03b9\u03ce\u03c3\u03b5\u03c4\u03b5 \u03c4\u03b7\u03bd \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae.","blik.invalid":"\u0395\u03b9\u03c3\u03b1\u03b3\u03ac\u03b3\u03b5\u03c4\u03b5 6 \u03c8\u03b7\u03c6\u03af\u03b1","blik.code":"6\u03c8\u03ae\u03c6\u03b9\u03bf\u03c2 \u03ba\u03c9\u03b4\u03b9\u03ba\u03cc\u03c2","blik.help":"\u039b\u03ac\u03b2\u03b5\u03c4\u03b5 \u03c4\u03bf\u03bd \u03ba\u03c9\u03b4\u03b9\u03ba\u03cc \u03b1\u03c0\u03cc \u03c4\u03b7\u03bd \u03b5\u03c6\u03b1\u03c1\u03bc\u03bf\u03b3\u03ae \u03c4\u03c1\u03b1\u03c0\u03b5\u03b6\u03b9\u03ba\u03ae\u03c2 \u03c3\u03b1\u03c2.","swish.pendingMessage":"\u039c\u03b5\u03c4\u03ac \u03c4\u03b7 \u03c3\u03ac\u03c1\u03c9\u03c3\u03b7, \u03b7 \u03ba\u03b1\u03c4\u03ac\u03c3\u03c4\u03b1\u03c3\u03b7 \u03bc\u03c0\u03bf\u03c1\u03b5\u03af \u03bd\u03b1 \u03b5\u03af\u03bd\u03b1\u03b9 \u03b5\u03ba\u03ba\u03c1\u03b5\u03bc\u03ae\u03c2 \u03b3\u03b9\u03b1 \u03ad\u03c9\u03c2 10 \u03bb\u03b5\u03c0\u03c4\u03ac. \u0397 \u03b1\u03c0\u03cc\u03c0\u03b5\u03b9\u03c1\u03b1 \u03b5\u03ba \u03bd\u03ad\u03bf\u03c5 \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae\u03c2 \u03b5\u03bd\u03c4\u03cc\u03c2 \u03b1\u03c5\u03c4\u03bf\u03cd \u03c4\u03bf\u03c5 \u03c7\u03c1\u03bf\u03bd\u03b9\u03ba\u03bf\u03cd \u03b4\u03b9\u03b1\u03c3\u03c4\u03ae\u03bc\u03b1\u03c4\u03bf\u03c2 \u03b5\u03bd\u03b4\u03ad\u03c7\u03b5\u03c4\u03b1\u03b9 \u03bd\u03b1 \u03c0\u03c1\u03bf\u03ba\u03b1\u03bb\u03ad\u03c3\u03b5\u03b9 \u03c0\u03c1\u03cc\u03c3\u03b8\u03b5\u03c4\u03b7 \u03c7\u03c1\u03ad\u03c9\u03c3\u03b7.","field.valid":"\u03a4\u03bf \u03c0\u03b5\u03b4\u03af\u03bf \u03b5\u03af\u03bd\u03b1\u03b9 \u03ad\u03b3\u03ba\u03c5\u03c1\u03bf","field.invalid":"\u03a4\u03bf \u03c0\u03b5\u03b4\u03af\u03bf \u03b4\u03b5\u03bd \u03b5\u03af\u03bd\u03b1\u03b9 \u03ad\u03b3\u03ba\u03c5\u03c1\u03bf","error.va.gen.01":"\u0395\u03bb\u03bb\u03b9\u03c0\u03ad\u03c2 \u03c0\u03b5\u03b4\u03af\u03bf","error.va.gen.02":"\u03a4\u03bf \u03c0\u03b5\u03b4\u03af\u03bf \u03b4\u03b5\u03bd \u03b5\u03af\u03bd\u03b1\u03b9 \u03ad\u03b3\u03ba\u03c5\u03c1\u03bf","error.va.sf-cc-num.01":"\u039f \u03b1\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03ba\u03ac\u03c1\u03c4\u03b1\u03c2 \u03b4\u03b5\u03bd \u03b5\u03af\u03bd\u03b1\u03b9 \u03ad\u03b3\u03ba\u03c5\u03c1\u03bf\u03c2","error.va.sf-cc-num.02":"\u03a4\u03bf \u03c0\u03b5\u03b4\u03af\u03bf \u03b1\u03c1\u03b9\u03b8\u03bc\u03bf\u03cd \u03ba\u03ac\u03c1\u03c4\u03b1\u03c2 \u03b5\u03af\u03bd\u03b1\u03b9 \u03ba\u03b5\u03bd\u03cc","error.va.sf-cc-num.03":"\u0395\u03b9\u03c3\u03ac\u03c7\u03b8\u03b7\u03ba\u03b5 \u03bc\u03b7 \u03c5\u03c0\u03bf\u03c3\u03c4\u03b7\u03c1\u03b9\u03b6\u03cc\u03bc\u03b5\u03bd\u03bf\u03c2 \u03b1\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03ba\u03ac\u03c1\u03c4\u03b1\u03c2","error.va.sf-cc-num.04":"\u039f \u03b1\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03ba\u03ac\u03c1\u03c4\u03b1\u03c2 \u03b4\u03b5\u03bd \u03c0\u03b5\u03c1\u03b9\u03ad\u03c7\u03b5\u03b9 \u03c4\u03bf\u03bd \u03c3\u03c9\u03c3\u03c4\u03cc \u03b1\u03c1\u03b9\u03b8\u03bc\u03cc \u03c7\u03b1\u03c1\u03b1\u03ba\u03c4\u03ae\u03c1\u03c9\u03bd","error.va.sf-cc-dat.01":"\u0397\u03bc\u03b5\u03c1\u03bf\u03bc\u03b7\u03bd\u03af\u03b1 \u03bb\u03ae\u03be\u03b7\u03c2: \u03b7 \u03ba\u03ac\u03c1\u03c4\u03b1 \u03b5\u03af\u03bd\u03b1\u03b9 \u03c0\u03bf\u03bb\u03cd \u03c0\u03b1\u03bb\u03b9\u03ac","error.va.sf-cc-dat.02":"\u0397\u03bc\u03b5\u03c1\u03bf\u03bc\u03b7\u03bd\u03af\u03b1 \u03bb\u03ae\u03be\u03b7\u03c2: \u03b7 \u03b7\u03bc\u03b5\u03c1\u03bf\u03bc\u03b7\u03bd\u03af\u03b1 \u03b5\u03af\u03bd\u03b1\u03b9 \u03c0\u03bf\u03bb\u03cd \u03bc\u03b1\u03ba\u03c1\u03b9\u03ac \u03c3\u03c4\u03bf \u03bc\u03ad\u03bb\u03bb\u03bf\u03bd","error.va.sf-cc-dat.03":"\u0397\u03bc\u03b5\u03c1\u03bf\u03bc\u03b7\u03bd\u03af\u03b1 \u03bb\u03ae\u03be\u03b7\u03c2: \u03b7 \u03ba\u03ac\u03c1\u03c4\u03b1 \u03c3\u03b1\u03c2 \u03bb\u03ae\u03b3\u03b5\u03b9 \u03c0\u03c1\u03b9\u03bd \u03b1\u03c0\u03cc \u03c4\u03b7\u03bd \u03b7\u03bc\u03b5\u03c1\u03bf\u03bc\u03b7\u03bd\u03af\u03b1 \u03b1\u03bd\u03b1\u03c7\u03ce\u03c1\u03b7\u03c3\u03b7\u03c2","error.va.sf-cc-dat.04":"\u03a4\u03bf \u03c0\u03b5\u03b4\u03af\u03bf \u03b7\u03bc\u03b5\u03c1\u03bf\u03bc\u03b7\u03bd\u03af\u03b1\u03c2 \u03bb\u03ae\u03be\u03b7\u03c2 \u03b5\u03af\u03bd\u03b1\u03b9 \u03ba\u03b5\u03bd\u03cc","error.va.sf-cc-dat.05":"\u0397 \u03b7\u03bc\u03b5\u03c1\u03bf\u03bc\u03b7\u03bd\u03af\u03b1 \u03bb\u03ae\u03be\u03b7\u03c2 \u03b4\u03b5\u03bd \u03c0\u03b5\u03c1\u03b9\u03ad\u03c7\u03b5\u03b9 \u03c4\u03bf\u03bd \u03c3\u03c9\u03c3\u03c4\u03cc \u03b1\u03c1\u03b9\u03b8\u03bc\u03cc \u03c7\u03b1\u03c1\u03b1\u03ba\u03c4\u03ae\u03c1\u03c9\u03bd","error.va.sf-cc-mth.01":"\u03a4\u03bf \u03c0\u03b5\u03b4\u03af\u03bf \u03bc\u03ae\u03bd\u03b1 \u03bb\u03ae\u03be\u03b7\u03c2 \u03b5\u03af\u03bd\u03b1\u03b9 \u03ba\u03b5\u03bd\u03cc","error.va.sf-cc-yr.01":"\u03a4\u03bf \u03c0\u03b5\u03b4\u03af\u03bf \u03ad\u03c4\u03bf\u03c5\u03c2 \u03bb\u03ae\u03be\u03b7\u03c2 \u03b5\u03af\u03bd\u03b1\u03b9 \u03ba\u03b5\u03bd\u03cc","error.va.sf-cc-yr.02":"\u03a4\u03bf \u03ad\u03c4\u03bf\u03c2 \u03bb\u03ae\u03be\u03b7\u03c2 \u03b4\u03b5\u03bd \u03c0\u03b5\u03c1\u03b9\u03ad\u03c7\u03b5\u03b9 \u03c4\u03bf\u03bd \u03c3\u03c9\u03c3\u03c4\u03cc \u03b1\u03c1\u03b9\u03b8\u03bc\u03cc \u03c7\u03b1\u03c1\u03b1\u03ba\u03c4\u03ae\u03c1\u03c9\u03bd","error.va.sf-cc-cvc.01":"\u03a4\u03bf \u03c0\u03b5\u03b4\u03af\u03bf \u03ba\u03c9\u03b4\u03b9\u03ba\u03bf\u03cd \u03b1\u03c3\u03c6\u03b1\u03bb\u03b5\u03af\u03b1\u03c2 \u03b5\u03af\u03bd\u03b1\u03b9 \u03ba\u03b5\u03bd\u03cc","error.va.sf-cc-cvc.02":"\u039f \u03ba\u03c9\u03b4\u03b9\u03ba\u03cc\u03c2 \u03b1\u03c3\u03c6\u03b1\u03bb\u03b5\u03af\u03b1\u03c2 \u03b4\u03b5\u03bd \u03c0\u03b5\u03c1\u03b9\u03ad\u03c7\u03b5\u03b9 \u03c4\u03bf\u03bd \u03c3\u03c9\u03c3\u03c4\u03cc \u03b1\u03c1\u03b9\u03b8\u03bc\u03cc \u03c7\u03b1\u03c1\u03b1\u03ba\u03c4\u03ae\u03c1\u03c9\u03bd","error.va.sf-ach-num.01":"\u03a4\u03bf \u03c0\u03b5\u03b4\u03af\u03bf \u03b1\u03c1\u03b9\u03b8\u03bc\u03bf\u03cd \u03c4\u03c1\u03b1\u03c0\u03b5\u03b6\u03b9\u03ba\u03bf\u03cd \u03bb\u03bf\u03b3\u03b1\u03c1\u03b9\u03b1\u03c3\u03bc\u03bf\u03cd \u03b5\u03af\u03bd\u03b1\u03b9 \u03ba\u03b5\u03bd\u03cc","error.va.sf-ach-num.02":"\u039f \u03b1\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03c4\u03c1\u03b1\u03c0\u03b5\u03b6\u03b9\u03ba\u03bf\u03cd \u03bb\u03bf\u03b3\u03b1\u03c1\u03b9\u03b1\u03c3\u03bc\u03bf\u03cd \u03b4\u03b5\u03bd \u03c0\u03b5\u03c1\u03b9\u03ad\u03c7\u03b5\u03b9 \u03c4\u03bf\u03bd \u03c3\u03c9\u03c3\u03c4\u03cc \u03b1\u03c1\u03b9\u03b8\u03bc\u03cc \u03c7\u03b1\u03c1\u03b1\u03ba\u03c4\u03ae\u03c1\u03c9\u03bd","error.va.sf-ach-loc.01":"\u03a4\u03bf \u03c0\u03b5\u03b4\u03af\u03bf \u03b1\u03c1\u03b9\u03b8\u03bc\u03bf\u03cd \u03b4\u03c1\u03bf\u03bc\u03bf\u03bb\u03cc\u03b3\u03b7\u03c3\u03b7\u03c2 \u03c4\u03c1\u03ac\u03c0\u03b5\u03b6\u03b1\u03c2 \u03b5\u03af\u03bd\u03b1\u03b9 \u03ba\u03b5\u03bd\u03cc","error.va.sf-ach-loc.02":"\u039f \u03b1\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03b4\u03c1\u03bf\u03bc\u03bf\u03bb\u03cc\u03b3\u03b7\u03c3\u03b7\u03c2 \u03c4\u03c1\u03ac\u03c0\u03b5\u03b6\u03b1\u03c2 \u03b4\u03b5\u03bd \u03c0\u03b5\u03c1\u03b9\u03ad\u03c7\u03b5\u03b9 \u03c4\u03bf\u03bd \u03c3\u03c9\u03c3\u03c4\u03cc \u03b1\u03c1\u03b9\u03b8\u03bc\u03cc \u03c7\u03b1\u03c1\u03b1\u03ba\u03c4\u03ae\u03c1\u03c9\u03bd","error.va.sf-kcp-pwd.01":"\u03a4\u03bf \u03c0\u03b5\u03b4\u03af\u03bf \u03ba\u03c9\u03b4\u03b9\u03ba\u03bf\u03cd \u03c0\u03c1\u03cc\u03c3\u03b2\u03b1\u03c3\u03b7\u03c2 \u03b5\u03af\u03bd\u03b1\u03b9 \u03ba\u03b5\u03bd\u03cc","error.va.sf-kcp-pwd.02":"\u039f \u03ba\u03c9\u03b4\u03b9\u03ba\u03cc\u03c2 \u03c0\u03c1\u03cc\u03c3\u03b2\u03b1\u03c3\u03b7\u03c2 \u03b4\u03b5\u03bd \u03c0\u03b5\u03c1\u03b9\u03ad\u03c7\u03b5\u03b9 \u03c4\u03bf\u03bd \u03c3\u03c9\u03c3\u03c4\u03cc \u03b1\u03c1\u03b9\u03b8\u03bc\u03cc \u03c7\u03b1\u03c1\u03b1\u03ba\u03c4\u03ae\u03c1\u03c9\u03bd","error.giftcard.no-balance":"\u0397 \u03c3\u03c5\u03b3\u03ba\u03b5\u03ba\u03c1\u03b9\u03bc\u03ad\u03bd\u03b7 \u03b4\u03c9\u03c1\u03bf\u03ba\u03ac\u03c1\u03c4\u03b1 \u03ad\u03c7\u03b5\u03b9 \u03bc\u03b7\u03b4\u03b5\u03bd\u03b9\u03ba\u03cc \u03c5\u03c0\u03cc\u03bb\u03bf\u03b9\u03c0\u03bf","error.giftcard.card-error":"\u03a3\u03c4\u03b1 \u03b1\u03c1\u03c7\u03b5\u03af\u03b1 \u03bc\u03b1\u03c2 \u03b4\u03b5\u03bd \u03c5\u03c0\u03ac\u03c1\u03c7\u03b5\u03b9 \u03b4\u03c9\u03c1\u03bf\u03ba\u03ac\u03c1\u03c4\u03b1 \u03bc\u03b5 \u03b1\u03c5\u03c4\u03cc\u03bd \u03c4\u03bf\u03bd \u03b1\u03c1\u03b9\u03b8\u03bc\u03cc","error.giftcard.currency-error":"\u039f\u03b9 \u03b4\u03c9\u03c1\u03bf\u03ba\u03ac\u03c1\u03c4\u03b5\u03c2 \u03b9\u03c3\u03c7\u03cd\u03bf\u03c5\u03bd \u03bc\u03cc\u03bd\u03bf \u03b3\u03b9\u03b1 \u03c4\u03bf \u03bd\u03cc\u03bc\u03b9\u03c3\u03bc\u03b1 \u03c3\u03c4\u03bf \u03bf\u03c0\u03bf\u03af\u03bf \u03b5\u03ba\u03b4\u03cc\u03b8\u03b7\u03ba\u03b1\u03bd","amazonpay.signout":"\u0391\u03c0\u03bf\u03c3\u03cd\u03bd\u03b4\u03b5\u03c3\u03b7 \u03b1\u03c0\u03cc \u03c4\u03bf Amazon","amazonpay.changePaymentDetails":"\u0391\u03bb\u03bb\u03b1\u03b3\u03ae \u03c3\u03c4\u03bf\u03b9\u03c7\u03b5\u03af\u03c9\u03bd \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae\u03c2","partialPayment.warning":"\u0395\u03c0\u03b9\u03bb\u03ad\u03be\u03c4\u03b5 \u03ad\u03bd\u03b1\u03bd \u03ac\u03bb\u03bb\u03bf \u03c4\u03c1\u03cc\u03c0\u03bf \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae\u03c2 \u03b3\u03b9\u03b1 \u03ba\u03b1\u03c4\u03b1\u03b2\u03bf\u03bb\u03ae \u03c4\u03bf\u03c5 \u03b5\u03bd\u03b1\u03c0\u03bf\u03bc\u03b5\u03af\u03bd\u03b1\u03bd\u03c4\u03bf\u03c2 \u03c0\u03bf\u03c3\u03bf\u03cd","partialPayment.remainingBalance":"\u03a4\u03bf \u03c5\u03c0\u03cc\u03bb\u03bf\u03b9\u03c0\u03bf \u03b8\u03b1 \u03b5\u03af\u03bd\u03b1\u03b9 %{amount}","bankTransfer.beneficiary":"\u0394\u03b9\u03ba\u03b1\u03b9\u03bf\u03cd\u03c7\u03bf\u03c2","bankTransfer.iban":"\u0399\u0392\u0391\u039d","bankTransfer.bic":"BIC","bankTransfer.reference":"\u0391\u03bd\u03b1\u03c6\u03bf\u03c1\u03ac","bankTransfer.introduction":"\u03a3\u03c5\u03bd\u03b5\u03c7\u03af\u03c3\u03c4\u03b5 \u03b3\u03b9\u03b1 \u03bd\u03b1 \u03b4\u03b7\u03bc\u03b9\u03bf\u03c5\u03c1\u03b3\u03ae\u03c3\u03b5\u03c4\u03b5 \u03bd\u03ad\u03b1 \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae \u03bc\u03ad\u03c3\u03c9 \u03c4\u03c1\u03b1\u03c0\u03b5\u03b6\u03b9\u03ba\u03ae\u03c2 \u03bc\u03b5\u03c4\u03b1\u03c6\u03bf\u03c1\u03ac\u03c2. \u039c\u03c0\u03bf\u03c1\u03b5\u03af\u03c4\u03b5 \u03bd\u03b1 \u03c7\u03c1\u03b7\u03c3\u03b9\u03bc\u03bf\u03c0\u03bf\u03b9\u03ae\u03c3\u03b5\u03c4\u03b5 \u03c4\u03b1 \u03c3\u03c4\u03bf\u03b9\u03c7\u03b5\u03af\u03b1 \u03c3\u03c4\u03b7\u03bd \u03b1\u03ba\u03cc\u03bb\u03bf\u03c5\u03b8\u03b7 \u03bf\u03b8\u03cc\u03bd\u03b7 \u03b3\u03b9\u03b1 \u03bd\u03b1 \u03bf\u03bb\u03bf\u03ba\u03bb\u03b7\u03c1\u03ce\u03c3\u03b5\u03c4\u03b5 \u03b1\u03c5\u03c4\u03ae\u03bd \u03c4\u03b7\u03bd \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae.","bankTransfer.instructions":"\u03a3\u03b1\u03c2 \u03b5\u03c5\u03c7\u03b1\u03c1\u03b9\u03c3\u03c4\u03bf\u03cd\u03bc\u03b5 \u03b3\u03b9\u03b1 \u03c4\u03b7\u03bd \u03b1\u03b3\u03bf\u03c1\u03ac. \u03a7\u03c1\u03b7\u03c3\u03b9\u03bc\u03bf\u03c0\u03bf\u03b9\u03ae\u03c3\u03c4\u03b5 \u03c4\u03b9\u03c2 \u03b1\u03ba\u03cc\u03bb\u03bf\u03c5\u03b8\u03b5\u03c2 \u03c0\u03bb\u03b7\u03c1\u03bf\u03c6\u03bf\u03c1\u03af\u03b5\u03c2 \u03b3\u03b9\u03b1 \u03bd\u03b1 \u03bf\u03bb\u03bf\u03ba\u03bb\u03b7\u03c1\u03ce\u03c3\u03b5\u03c4\u03b5 \u03c4\u03b7\u03bd \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae.","bacs.accountHolderName":"\u038c\u03bd\u03bf\u03bc\u03b1 \u03b4\u03b9\u03ba\u03b1\u03b9\u03bf\u03cd\u03c7\u03bf\u03c5 \u03c4\u03c1\u03b1\u03c0\u03b5\u03b6\u03b9\u03ba\u03bf\u03cd \u03bb\u03bf\u03b3\u03b1\u03c1\u03b9\u03b1\u03c3\u03bc\u03bf\u03cd","bacs.accountHolderName.invalid":"\u039c\u03b7 \u03ad\u03b3\u03ba\u03c5\u03c1\u03bf \u03cc\u03bd\u03bf\u03bc\u03b1 \u03b4\u03b9\u03ba\u03b1\u03b9\u03bf\u03cd\u03c7\u03bf\u03c5 \u03c4\u03c1\u03b1\u03c0\u03b5\u03b6\u03b9\u03ba\u03bf\u03cd \u03bb\u03bf\u03b3\u03b1\u03c1\u03b9\u03b1\u03c3\u03bc\u03bf\u03cd","bacs.accountNumber":"\u0391\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03c4\u03c1\u03b1\u03c0\u03b5\u03b6\u03b9\u03ba\u03bf\u03cd \u03bb\u03bf\u03b3\u03b1\u03c1\u03b9\u03b1\u03c3\u03bc\u03bf\u03cd","bacs.accountNumber.invalid":"\u039c\u03b7 \u03ad\u03b3\u03ba\u03c5\u03c1\u03bf\u03c2 \u03b1\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03c4\u03c1\u03b1\u03c0\u03b5\u03b6\u03b9\u03ba\u03bf\u03cd \u03bb\u03bf\u03b3\u03b1\u03c1\u03b9\u03b1\u03c3\u03bc\u03bf\u03cd","bacs.bankLocationId":"\u039a\u03c9\u03b4\u03b9\u03ba\u03cc\u03c2 \u03c4\u03c1\u03ac\u03c0\u03b5\u03b6\u03b1\u03c2","bacs.bankLocationId.invalid":"\u039c\u03b7 \u03ad\u03b3\u03ba\u03c5\u03c1\u03bf\u03c2 \u03ba\u03c9\u03b4\u03b9\u03ba\u03cc\u03c2 \u03c4\u03c1\u03ac\u03c0\u03b5\u03b6\u03b1\u03c2","bacs.consent.amount":"\u0391\u03c0\u03bf\u03b4\u03ad\u03c7\u03bf\u03bc\u03b1\u03b9 \u03cc\u03c4\u03b9 \u03c4\u03bf \u03c0\u03b9\u03bf \u03c0\u03ac\u03bd\u03c9 \u03c0\u03bf\u03c3\u03cc \u03b8\u03b1 \u03b1\u03c6\u03b1\u03b9\u03c1\u03b5\u03b8\u03b5\u03af \u03b1\u03c0\u03cc \u03c4\u03bf\u03bd \u03c4\u03c1\u03b1\u03c0\u03b5\u03b6\u03b9\u03ba\u03cc \u03bb\u03bf\u03b3\u03b1\u03c1\u03b9\u03b1\u03c3\u03bc\u03cc \u03bc\u03bf\u03c5.","bacs.consent.account":"\u0395\u03c0\u03b9\u03b2\u03b5\u03b2\u03b1\u03b9\u03ce\u03bd\u03c9 \u03cc\u03c4\u03b9 \u03bf \u03bb\u03bf\u03b3\u03b1\u03c1\u03b9\u03b1\u03c3\u03bc\u03cc\u03c2 \u03b5\u03af\u03bd\u03b1\u03b9 \u03c3\u03c4\u03bf \u03cc\u03bd\u03bf\u03bc\u03ac \u03bc\u03bf\u03c5 \u03ba\u03b1\u03b9 \u03c0\u03c9\u03c2 \u03b5\u03af\u03bc\u03b1\u03b9 \u03bf/\u03b7 \u03bc\u03bf\u03bd\u03b1\u03b4\u03b9\u03ba\u03cc\u03c2/\u03bc\u03bf\u03bd\u03b1\u03b4\u03b9\u03ba\u03ae \u03c5\u03c0\u03bf\u03b3\u03c1\u03ac\u03c6\u03c9\u03bd/\u03c5\u03c0\u03bf\u03b3\u03c1\u03ac\u03c6\u03bf\u03c5\u03c3\u03b1 \u03c0\u03bf\u03c5 \u03b1\u03c0\u03b1\u03b9\u03c4\u03b5\u03af\u03c4\u03b1\u03b9 \u03b3\u03b9\u03b1 \u03b5\u03be\u03bf\u03c5\u03c3\u03b9\u03bf\u03b4\u03cc\u03c4\u03b7\u03c3\u03b7 \u03c4\u03b7\u03c2 \u0386\u03bc\u03b5\u03c3\u03b7\u03c2 \u03a7\u03c1\u03ad\u03c9\u03c3\u03b7\u03c2 \u03c3\u03b5 \u03b1\u03c5\u03c4\u03cc\u03bd \u03c4\u03bf\u03bd \u03bb\u03bf\u03b3\u03b1\u03c1\u03b9\u03b1\u03c3\u03bc\u03cc.",edit:"\u0395\u03c0\u03b5\u03be\u03b5\u03c1\u03b3\u03b1\u03c3\u03af\u03b1","bacs.confirm":"\u0395\u03c0\u03b9\u03b2\u03b5\u03b2\u03b1\u03af\u03c9\u03c3\u03b7 \u03ba\u03b1\u03b9 \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae","bacs.result.introduction":"\u039a\u03b1\u03c4\u03b5\u03b2\u03ac\u03c3\u03c4\u03b5 \u03c4\u03b7\u03bd \u0395\u03bd\u03c4\u03bf\u03bb\u03ae \u0386\u03bc\u03b5\u03c3\u03b7\u03c2 \u03a7\u03c1\u03ad\u03c9\u03c3\u03b7\u03c2 (DDI/\u0395\u03bd\u03c4\u03bf\u03bb\u03ae)","download.pdf":"\u039b\u03ae\u03c8\u03b7 PDF","creditCard.encryptedCardNumber.aria.iframeTitle":"Iframe \u03b3\u03b9\u03b1 \u03b1\u03c3\u03c6\u03b1\u03bb\u03ae \u03b1\u03c1\u03b9\u03b8\u03bc\u03cc \u03ba\u03ac\u03c1\u03c4\u03b1\u03c2","creditCard.encryptedCardNumber.aria.label":"\u0391\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03ba\u03ac\u03c1\u03c4\u03b1\u03c2","creditCard.encryptedExpiryDate.aria.iframeTitle":"Iframe \u03b3\u03b9\u03b1 \u03b1\u03c3\u03c6\u03b1\u03bb\u03ae \u03b7\u03bc\u03b5\u03c1\u03bf\u03bc\u03b7\u03bd\u03af\u03b1 \u03bb\u03ae\u03be\u03b7\u03c2 \u03ba\u03ac\u03c1\u03c4\u03b1\u03c2","creditCard.encryptedExpiryDate.aria.label":"\u0397\u03bc\u03b5\u03c1\u03bf\u03bc\u03b7\u03bd\u03af\u03b1 \u03bb\u03ae\u03be\u03b7\u03c2","creditCard.encryptedExpiryMonth.aria.iframeTitle":"Iframe \u03b3\u03b9\u03b1 \u03b1\u03c3\u03c6\u03b1\u03bb\u03ae \u03bc\u03ae\u03bd\u03b1 \u03bb\u03ae\u03be\u03b7\u03c2 \u03ba\u03ac\u03c1\u03c4\u03b1\u03c2","creditCard.encryptedExpiryMonth.aria.label":"\u039c\u03ae\u03bd\u03b1\u03c2 \u03bb\u03ae\u03be\u03b7\u03c2","creditCard.encryptedExpiryYear.aria.iframeTitle":"Iframe \u03b3\u03b9\u03b1 \u03b1\u03c3\u03c6\u03b1\u03bb\u03ad\u03c2 \u03ad\u03c4\u03bf\u03c2 \u03bb\u03ae\u03be\u03b7\u03c2 \u03ba\u03ac\u03c1\u03c4\u03b1\u03c2","creditCard.encryptedExpiryYear.aria.label":"\u0388\u03c4\u03bf\u03c2 \u03bb\u03ae\u03be\u03b7\u03c2","creditCard.encryptedSecurityCode.aria.iframeTitle":"Iframe \u03b3\u03b9\u03b1 \u03b1\u03c3\u03c6\u03b1\u03bb\u03ae \u03ba\u03c9\u03b4\u03b9\u03ba\u03cc \u03b1\u03c3\u03c6\u03b1\u03bb\u03b5\u03af\u03b1\u03c2 \u03ba\u03ac\u03c1\u03c4\u03b1\u03c2","creditCard.encryptedSecurityCode.aria.label":"\u039a\u03c9\u03b4\u03b9\u03ba\u03cc\u03c2 \u03b1\u03c3\u03c6\u03b1\u03bb\u03b5\u03af\u03b1\u03c2","creditCard.encryptedPassword.aria.iframeTitle":"Iframe \u03b3\u03b9\u03b1 \u03b1\u03c3\u03c6\u03b1\u03bb\u03ae \u03ba\u03c9\u03b4\u03b9\u03ba\u03cc \u03c0\u03c1\u03cc\u03c3\u03b2\u03b1\u03c3\u03b7\u03c2 \u03ba\u03ac\u03c1\u03c4\u03b1\u03c2","creditCard.encryptedPassword.aria.label":"\u03a4\u03b1 \u03c0\u03c1\u03ce\u03c4\u03b1 2 \u03c8\u03b7\u03c6\u03af\u03b1 \u03c4\u03bf\u03c5 \u03ba\u03c9\u03b4\u03b9\u03ba\u03bf\u03cd \u03c0\u03c1\u03cc\u03c3\u03b2\u03b1\u03c3\u03b7\u03c2 \u03c4\u03b7\u03c2 \u03ba\u03ac\u03c1\u03c4\u03b1\u03c2","giftcard.encryptedCardNumber.aria.iframeTitle":"Iframe \u03b3\u03b9\u03b1 \u03b1\u03c3\u03c6\u03b1\u03bb\u03ae \u03b1\u03c1\u03b9\u03b8\u03bc\u03cc \u03b4\u03c9\u03c1\u03bf\u03ba\u03ac\u03c1\u03c4\u03b1\u03c2","giftcard.encryptedCardNumber.aria.label":"\u0391\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03b4\u03c9\u03c1\u03bf\u03ba\u03ac\u03c1\u03c4\u03b1\u03c2","giftcard.encryptedSecurityCode.aria.iframeTitle":"Iframe \u03b3\u03b9\u03b1 \u03b1\u03c3\u03c6\u03b1\u03bb\u03ae \u03ba\u03c9\u03b4\u03b9\u03ba\u03cc \u03b1\u03c3\u03c6\u03b1\u03bb\u03b5\u03af\u03b1\u03c2 \u03b4\u03c9\u03c1\u03bf\u03ba\u03ac\u03c1\u03c4\u03b1\u03c2","giftcard.encryptedSecurityCode.aria.label":"\u039a\u03c9\u03b4\u03b9\u03ba\u03cc\u03c2 \u03b1\u03c3\u03c6\u03b1\u03bb\u03b5\u03af\u03b1\u03c2 \u03b4\u03c9\u03c1\u03bf\u03ba\u03ac\u03c1\u03c4\u03b1\u03c2",giftcardTransactionLimit:"\u03a4\u03bf \u03bc\u03ad\u03b3\u03b9\u03c3\u03c4\u03bf \u03b5\u03c0\u03b9\u03c4\u03c1\u03b5\u03c0\u03cc\u03bc\u03b5\u03bd\u03bf \u03c0\u03bf\u03c3\u03cc \u03b1\u03bd\u03ac \u03c3\u03c5\u03bd\u03b1\u03bb\u03bb\u03b1\u03b3\u03ae \u03c3\u03b5 \u03b1\u03c5\u03c4\u03ae\u03bd \u03c4\u03b7 \u03b4\u03c9\u03c1\u03bf\u03ba\u03ac\u03c1\u03c4\u03b1 \u03b5\u03af\u03bd\u03b1\u03b9 %{amount}","ach.encryptedBankAccountNumber.aria.iframeTitle":"Iframe \u03b3\u03b9\u03b1 \u03b1\u03c3\u03c6\u03b1\u03bb\u03ae \u03b1\u03c1\u03b9\u03b8\u03bc\u03cc \u03c4\u03c1\u03b1\u03c0\u03b5\u03b6\u03b9\u03ba\u03bf\u03cd \u03bb\u03bf\u03b3\u03b1\u03c1\u03b9\u03b1\u03c3\u03bc\u03bf\u03cd","ach.encryptedBankAccountNumber.aria.label":"\u03a4\u03c1\u03b1\u03c0\u03b5\u03b6\u03b9\u03ba\u03cc\u03c2 \u03bb\u03bf\u03b3\u03b1\u03c1\u03b9\u03b1\u03c3\u03bc\u03cc\u03c2","ach.encryptedBankLocationId.aria.iframeTitle":"Iframe \u03b3\u03b9\u03b1 \u03b1\u03c3\u03c6\u03b1\u03bb\u03ae \u03b1\u03c1\u03b9\u03b8\u03bc\u03cc \u03ba\u03c9\u03b4\u03b9\u03ba\u03bf\u03cd \u03c5\u03c0\u03bf\u03ba\u03b1\u03c4\u03b1\u03c3\u03c4\u03ae\u03bc\u03b1\u03c4\u03bf\u03c2 \u03c4\u03c1\u03ac\u03c0\u03b5\u03b6\u03b1\u03c2","ach.encryptedBankLocationId.aria.label":"\u0391\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03b4\u03c1\u03bf\u03bc\u03bf\u03bb\u03cc\u03b3\u03b7\u03c3\u03b7\u03c2 \u03c4\u03c1\u03ac\u03c0\u03b5\u03b6\u03b1\u03c2","twint.saved":"\u03b1\u03c0\u03bf\u03b8\u03b7\u03ba\u03b5\u03cd\u03c4\u03b7\u03ba\u03b5",orPayWith:"\u03ae \u03c0\u03bb\u03b7\u03c1\u03ce\u03c3\u03c4\u03b5 \u03bc\u03b5",invalidFormatExpects:"\u039c\u03b7 \u03ad\u03b3\u03ba\u03c5\u03c1\u03b7 \u03bc\u03bf\u03c1\u03c6\u03ae. \u0391\u03bd\u03b1\u03bc\u03b5\u03bd\u03cc\u03bc\u03b5\u03bd\u03b7 \u03bc\u03bf\u03c1\u03c6\u03ae: %{format}","upi.qrCodeWaitingMessage":"\u03a3\u03b1\u03c1\u03ce\u03c3\u03c4\u03b5 \u03c4\u03bf\u03bd \u03ba\u03c9\u03b4\u03b9\u03ba\u03cc QR \u03c7\u03c1\u03b7\u03c3\u03b9\u03bc\u03bf\u03c0\u03bf\u03b9\u03ce\u03bd\u03c4\u03b1\u03c2 \u03c4\u03b7\u03bd \u03c0\u03c1\u03bf\u03c4\u03b9\u03bc\u03ce\u03bc\u03b5\u03bd\u03b7 \u03b5\u03c6\u03b1\u03c1\u03bc\u03bf\u03b3\u03ae UPI \u03b3\u03b9\u03b1 \u03bf\u03bb\u03bf\u03ba\u03bb\u03ae\u03c1\u03c9\u03c3\u03b7 \u03c4\u03b7\u03c2 \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae\u03c2","upi.vpaWaitingMessage":"\u0391\u03bd\u03bf\u03af\u03be\u03c4\u03b5 \u03c4\u03b7\u03bd \u03b5\u03c6\u03b1\u03c1\u03bc\u03bf\u03b3\u03ae UPI \u03b3\u03b9\u03b1 \u03b5\u03c0\u03b9\u03b2\u03b5\u03b2\u03b1\u03af\u03c9\u03c3\u03b7 \u03c4\u03b7\u03c2 \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae\u03c2","upi.modeSelection":"\u0395\u03c0\u03b9\u03bb\u03ad\u03be\u03c4\u03b5 \u03bc\u03b9\u03b1 \u03c1\u03cd\u03b8\u03bc\u03b9\u03c3\u03b7 \u03b3\u03b9\u03b1 \u03c4\u03bf\u03bd \u03c4\u03c1\u03cc\u03c0\u03bf \u03c7\u03c1\u03ae\u03c3\u03b7\u03c2 \u03c4\u03bf\u03c5 UPI.","onlineBanking.termsAndConditions":"\u0391\u03bd \u03c3\u03c5\u03bd\u03b5\u03c7\u03af\u03c3\u03b5\u03c4\u03b5, \u03c3\u03c5\u03bd\u03b5\u03c0\u03ac\u03b3\u03b5\u03c4\u03b1\u03b9 \u03cc\u03c4\u03b9 \u03b1\u03c0\u03bf\u03b4\u03ad\u03c7\u03b5\u03c3\u03c4\u03b5 \u03c4\u03bf\u03c5\u03c2 %#\u038c\u03c1\u03bf\u03c5\u03c2 \u03ba\u03b1\u03b9 \u03c0\u03c1\u03bf\u03cb\u03c0\u03bf\u03b8\u03ad\u03c3\u03b5\u03b9\u03c2%#","ctp.loading.poweredByCtp":"\u039c\u03b5 \u03c4\u03b7\u03bd \u03c5\u03c0\u03bf\u03c3\u03c4\u03ae\u03c1\u03b9\u03be\u03b7 \u03c4\u03bf\u03c5 Click to Pay","ctp.loading.intro":"\u0388\u03bb\u03b5\u03b3\u03c7\u03bf\u03c2 \u03b3\u03b9\u03b1 \u03bd\u03b1 \u03b4\u03b9\u03b1\u03c0\u03b9\u03c3\u03c4\u03c9\u03b8\u03b5\u03af \u03b1\u03bd \u03c5\u03c0\u03ac\u03c1\u03c7\u03bf\u03c5\u03bd \u03b1\u03c0\u03bf\u03b8\u03b7\u03ba\u03b5\u03c5\u03bc\u03ad\u03bd\u03b5\u03c2 \u03ba\u03ac\u03c1\u03c4\u03b5\u03c2 \u03bc\u03b5 Click to Pay...","ctp.login.title":"\u03a3\u03c5\u03bd\u03ad\u03c7\u03b5\u03b9\u03b1 \u03c3\u03c4\u03bf Click to Pay","ctp.login.subtitle":"\u0395\u03b9\u03c3\u03b1\u03b3\u03ac\u03b3\u03b5\u03c4\u03b5 \u03c4\u03b7 \u03b4\u03b9\u03b5\u03cd\u03b8\u03c5\u03bd\u03c3\u03b7 email \u03c0\u03bf\u03c5 \u03b5\u03af\u03bd\u03b1\u03b9 \u03c3\u03c5\u03bd\u03b4\u03b5\u03b4\u03b5\u03bc\u03ad\u03bd\u03b7 \u03bc\u03b5 \u03c4\u03bf Click to Pay \u03b3\u03b9\u03b1 \u03bd\u03b1 \u03c3\u03c5\u03bd\u03b5\u03c7\u03af\u03c3\u03b5\u03c4\u03b5.","ctp.login.inputLabel":"Email","ctp.logout.notYou":"\u0394\u03b5\u03bd \u03b5\u03af\u03c3\u03c4\u03b5 \u03b5\u03c3\u03b5\u03af\u03c2 \u03b1\u03c5\u03c4\u03cc \u03c4\u03bf \u03ac\u03c4\u03bf\u03bc\u03bf;","ctp.logout.notYourCards":"\u0391\u03c5\u03c4\u03ad\u03c2 \u03b4\u03b5\u03bd \u03b5\u03af\u03bd\u03b1\u03b9 \u03bf\u03b9 \u03ba\u03ac\u03c1\u03c4\u03b5\u03c2 \u03c3\u03b1\u03c2;","ctp.logout.notYourCard":"\u0394\u03b5\u03bd \u03b5\u03af\u03bd\u03b1\u03b9 \u03b7 \u03ba\u03ac\u03c1\u03c4\u03b1 \u03c3\u03b1\u03c2;","ctp.logout.notYourProfile":"\u0394\u03b5\u03bd \u03b5\u03af\u03bd\u03b1\u03b9 \u03c4\u03bf \u03c0\u03c1\u03bf\u03c6\u03af\u03bb \u03c3\u03b1\u03c2;","ctp.otp.fieldLabel":"\u039a\u03c9\u03b4\u03b9\u03ba\u03cc\u03c2 \u03bc\u03b9\u03b1\u03c2 \u03c7\u03c1\u03ae\u03c3\u03b7\u03c2","ctp.otp.resendCode":"\u0395\u03ba \u03bd\u03ad\u03bf\u03c5 \u03b1\u03c0\u03bf\u03c3\u03c4\u03bf\u03bb\u03ae \u03ba\u03c9\u03b4\u03b9\u03ba\u03bf\u03cd","ctp.otp.codeResent":"\u039f \u03ba\u03c9\u03b4\u03b9\u03ba\u03cc\u03c2 \u03c3\u03c4\u03ac\u03bb\u03b8\u03b7\u03ba\u03b5 \u03b5\u03ba \u03bd\u03ad\u03bf\u03c5","ctp.otp.title":"\u03a0\u03c1\u03cc\u03c3\u03b2\u03b1\u03c3\u03b7 \u03c3\u03c4\u03b9\u03c2 \u03ba\u03ac\u03c1\u03c4\u03b5\u03c2 Click to Pay \u03c3\u03b1\u03c2","ctp.otp.subtitle":"\u0395\u03b9\u03c3\u03b1\u03b3\u03ac\u03b3\u03b5\u03c4\u03b5 \u03c4\u03bf\u03bd \u03ba\u03c9\u03b4\u03b9\u03ba\u03cc %@ \u03c0\u03bf\u03c5 \u03c3\u03c4\u03ac\u03bb\u03b8\u03b7\u03ba\u03b5 \u03c3\u03c4\u03bf %@ \u03b3\u03b9\u03b1 \u03bd\u03b1 \u03b5\u03c0\u03b1\u03bb\u03b7\u03b8\u03b5\u03cd\u03c3\u03b5\u03c4\u03b5 \u03cc\u03c4\u03b9 \u03b5\u03af\u03c3\u03c4\u03b5 \u03b5\u03c3\u03b5\u03af\u03c2.","ctp.emptyProfile.message":"\u0394\u03b5\u03bd \u03c5\u03c0\u03ac\u03c1\u03c7\u03bf\u03c5\u03bd \u03ba\u03b1\u03c4\u03b1\u03c7\u03c9\u03c1\u03b9\u03c3\u03bc\u03ad\u03bd\u03b5\u03c2 \u03ba\u03ac\u03c1\u03c4\u03b5\u03c2 \u03c3\u03b5 \u03b1\u03c5\u03c4\u03cc \u03c4\u03bf \u03c0\u03c1\u03bf\u03c6\u03af\u03bb Click to Pay","ctp.separatorText":"\u03ae \u03c7\u03c1\u03b7\u03c3\u03b9\u03bc\u03bf\u03c0\u03bf\u03b9\u03ae\u03c3\u03c4\u03b5 \u03c4\u03bf","ctp.cards.title":"\u039f\u03bb\u03bf\u03ba\u03bb\u03b7\u03c1\u03ce\u03c3\u03c4\u03b5 \u03c4\u03b7\u03bd \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae \u03bc\u03b5 \u03c4\u03bf Click to Pay","ctp.cards.subtitle":"\u0395\u03c0\u03b9\u03bb\u03ad\u03be\u03c4\u03b5 \u03bc\u03b9\u03b1 \u03ba\u03ac\u03c1\u03c4\u03b1 \u03c0\u03c1\u03bf\u03c2 \u03c7\u03c1\u03ae\u03c3\u03b7.","ctp.cards.expiredCard":"\u0388\u03bb\u03b7\u03be\u03b5","ctp.manualCardEntry":"\u03a7\u03b5\u03b9\u03c1\u03bf\u03ba\u03af\u03bd\u03b7\u03c4\u03b7 \u03ba\u03b1\u03c4\u03b1\u03c7\u03ce\u03c1\u03b9\u03c3\u03b7 \u03ba\u03ac\u03c1\u03c4\u03b1\u03c2","ctp.aria.infoModalButton":"\u03a4\u03b9 \u03b5\u03af\u03bd\u03b1\u03b9 \u03c4\u03bf Click to Pay","ctp.infoPopup.title":"\u03a4\u03bf Click to Pay \u03c0\u03c1\u03bf\u03c3\u03c6\u03ad\u03c1\u03b5\u03b9 \u03c4\u03b7\u03bd \u03b5\u03c5\u03ba\u03bf\u03bb\u03af\u03b1 \u03b1\u03bd\u03ad\u03c0\u03b1\u03c6\u03c9\u03bd \u03b4\u03b9\u03b1\u03b4\u03b9\u03ba\u03c4\u03c5\u03b1\u03ba\u03ce\u03bd","ctp.infoPopup.subtitle":"\u0388\u03bd\u03b1\u03c2 \u03b3\u03c1\u03ae\u03b3\u03bf\u03c1\u03bf\u03c2, \u03b1\u03c3\u03c6\u03b1\u03bb\u03ae\u03c2 \u03c4\u03c1\u03cc\u03c0\u03bf\u03c2 \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae\u03c2 \u03c0\u03bf\u03c5 \u03c5\u03c0\u03bf\u03c3\u03c4\u03b7\u03c1\u03af\u03b6\u03b5\u03c4\u03b1\u03b9 \u03b1\u03c0\u03cc \u03c4\u03b9\u03c2 \u03ba\u03ac\u03c1\u03c4\u03b5\u03c2 Mastercard, Visa \u03ba\u03b1\u03b9 \u03ac\u03bb\u03bb\u03b5\u03c2 \u03ba\u03ac\u03c1\u03c4\u03b5\u03c2 \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ce\u03bd.","ctp.infoPopup.benefit1":"\u03a4\u03bf Click to Pay \u03c7\u03c1\u03b7\u03c3\u03b9\u03bc\u03bf\u03c0\u03bf\u03b9\u03b5\u03af \u03ba\u03c1\u03c5\u03c0\u03c4\u03bf\u03b3\u03c1\u03ac\u03c6\u03b7\u03c3\u03b7 \u03b3\u03b9\u03b1 \u03bd\u03b1 \u03b4\u03b9\u03b1\u03c4\u03b7\u03c1\u03b5\u03af \u03c4\u03b9\u03c2 \u03c0\u03bb\u03b7\u03c1\u03bf\u03c6\u03bf\u03c1\u03af\u03b5\u03c2 \u03c3\u03b1\u03c2 \u03b1\u03c3\u03c6\u03b1\u03bb\u03b5\u03af\u03c2","ctp.infoPopup.benefit2":"\u03a7\u03c1\u03b7\u03c3\u03b9\u03bc\u03bf\u03c0\u03bf\u03b9\u03ae\u03c3\u03c4\u03b5 \u03c4\u03b7 \u03b4\u03c5\u03bd\u03b1\u03c4\u03cc\u03c4\u03b7\u03c4\u03b1 \u03c3\u03b5 \u03b5\u03bc\u03c0\u03cc\u03c1\u03bf\u03c5\u03c2 \u03b1\u03bd\u03ac \u03c4\u03bf\u03bd \u03ba\u03cc\u03c3\u03bc\u03bf","ctp.infoPopup.benefit3":"\u0395\u03cd\u03ba\u03bf\u03bb\u03b7 \u03b4\u03b9\u03b1\u03bc\u03cc\u03c1\u03c6\u03c9\u03c3\u03b7 \u03b3\u03b9\u03b1 \u03ac\u03bd\u03b5\u03c4\u03b5\u03c2 \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ad\u03c2 \u03b1\u03bd\u03ac \u03c0\u03ac\u03c3\u03b1 \u03c3\u03c4\u03b9\u03b3\u03bc\u03ae","ctp.errors.AUTH_INVALID":"\u039f \u03ad\u03bb\u03b5\u03b3\u03c7\u03bf\u03c2 \u03c4\u03b1\u03c5\u03c4\u03cc\u03c4\u03b7\u03c4\u03b1\u03c2 \u03b4\u03b5\u03bd \u03ae\u03c4\u03b1\u03bd \u03ad\u03b3\u03ba\u03c5\u03c1\u03bf\u03c2","ctp.errors.NOT_FOUND":"\u0394\u03b5\u03bd \u03b2\u03c1\u03ad\u03b8\u03b7\u03ba\u03b5 \u03bb\u03bf\u03b3\u03b1\u03c1\u03b9\u03b1\u03c3\u03bc\u03cc\u03c2, \u03b5\u03b9\u03c3\u03b1\u03b3\u03ac\u03b3\u03b5\u03c4\u03b5 \u03bc\u03b9\u03b1 \u03ad\u03b3\u03ba\u03c5\u03c1\u03b7 \u03b4\u03b9\u03b5\u03cd\u03b8\u03c5\u03bd\u03c3\u03b7 email \u03ae \u03c3\u03c5\u03bd\u03b5\u03c7\u03af\u03c3\u03c4\u03b5 \u03b3\u03b9\u03b1 \u03c7\u03b5\u03b9\u03c1\u03bf\u03ba\u03af\u03bd\u03b7\u03c4\u03b7 \u03b5\u03b9\u03c3\u03b1\u03b3\u03c9\u03b3\u03ae \u03ba\u03ac\u03c1\u03c4\u03b1\u03c2","ctp.errors.ID_FORMAT_UNSUPPORTED":"\u0397 \u03bc\u03bf\u03c1\u03c6\u03ae \u03b4\u03b5\u03bd \u03c5\u03c0\u03bf\u03c3\u03c4\u03b7\u03c1\u03af\u03b6\u03b5\u03c4\u03b1\u03b9","ctp.errors.FRAUD":"\u039f \u03bb\u03bf\u03b3\u03b1\u03c1\u03b9\u03b1\u03c3\u03bc\u03cc\u03c2 \u03c7\u03c1\u03ae\u03c3\u03c4\u03b7 \u03ba\u03bb\u03b5\u03b9\u03b4\u03ce\u03b8\u03b7\u03ba\u03b5 \u03ae \u03b1\u03c0\u03b5\u03bd\u03b5\u03c1\u03b3\u03bf\u03c0\u03bf\u03b9\u03ae\u03b8\u03b7\u03ba\u03b5","ctp.errors.CONSUMER_ID_MISSING":"\u0397 \u03c4\u03b1\u03c5\u03c4\u03cc\u03c4\u03b7\u03c4\u03b1 \u03ba\u03b1\u03c4\u03b1\u03bd\u03b1\u03bb\u03c9\u03c4\u03ae \u03bb\u03b5\u03af\u03c0\u03b5\u03b9 \u03c3\u03c4\u03bf \u03b1\u03af\u03c4\u03b7\u03bc\u03b1","ctp.errors.ACCT_INACCESSIBLE":"\u0391\u03c5\u03c4\u03cc\u03c2 \u03bf \u03bb\u03bf\u03b3\u03b1\u03c1\u03b9\u03b1\u03c3\u03bc\u03cc\u03c2 \u03b4\u03b5\u03bd \u03b5\u03af\u03bd\u03b1\u03b9 \u03b4\u03b9\u03b1\u03b8\u03ad\u03c3\u03b9\u03bc\u03bf\u03c2 \u03c4\u03ce\u03c1\u03b1, \u03c0.\u03c7. \u03b5\u03af\u03bd\u03b1\u03b9 \u03ba\u03bb\u03b5\u03b9\u03b4\u03c9\u03bc\u03ad\u03bd\u03bf\u03c2","ctp.errors.CODE_INVALID":"\u039b\u03b1\u03bd\u03b8\u03b1\u03c3\u03bc\u03ad\u03bd\u03bf\u03c2 \u03ba\u03c9\u03b4\u03b9\u03ba\u03cc\u03c2 \u03b5\u03c0\u03b1\u03bb\u03ae\u03b8\u03b5\u03c5\u03c3\u03b7\u03c2","ctp.errors.CODE_EXPIRED":"\u0391\u03c5\u03c4\u03cc\u03c2 \u03bf \u03ba\u03c9\u03b4\u03b9\u03ba\u03cc\u03c2 \u03ad\u03c7\u03b5\u03b9 \u03bb\u03ae\u03be\u03b5\u03b9","ctp.errors.RETRIES_EXCEEDED":"\u03a3\u03b7\u03bc\u03b5\u03b9\u03ce\u03b8\u03b7\u03ba\u03b5 \u03c5\u03c0\u03ad\u03c1\u03b2\u03b1\u03c3\u03b7 \u03c4\u03bf\u03c5 \u03b1\u03c1\u03b9\u03b8\u03bc\u03bf\u03cd \u03bd\u03ad\u03c9\u03bd \u03b1\u03c0\u03bf\u03c0\u03b5\u03b9\u03c1\u03ce\u03bd \u03b4\u03b7\u03bc\u03b9\u03bf\u03c5\u03c1\u03b3\u03af\u03b1\u03c2 OTP","ctp.errors.OTP_SEND_FAILED":"\u0394\u03b5\u03bd \u03ae\u03c4\u03b1\u03bd \u03b4\u03c5\u03bd\u03b1\u03c4\u03ae \u03b7 \u03b1\u03c0\u03bf\u03c3\u03c4\u03bf\u03bb\u03ae \u03c4\u03bf\u03c5 OTP \u03c3\u03c4\u03bf\u03bd \u03c0\u03b1\u03c1\u03b1\u03bb\u03ae\u03c0\u03c4\u03b7","ctp.errors.REQUEST_TIMEOUT":"\u03a0\u03b1\u03c1\u03bf\u03c5\u03c3\u03b9\u03ac\u03c3\u03c4\u03b7\u03ba\u03b5 \u03ba\u03ac\u03c0\u03bf\u03b9\u03bf \u03c0\u03c1\u03cc\u03b2\u03bb\u03b7\u03bc\u03b1, \u03b4\u03bf\u03ba\u03b9\u03bc\u03ac\u03c3\u03c4\u03b5 \u03be\u03b1\u03bd\u03ac \u03ae \u03c7\u03c1\u03b7\u03c3\u03b9\u03bc\u03bf\u03c0\u03bf\u03b9\u03ae\u03c3\u03c4\u03b5 \u03c4\u03b7 \u03c7\u03b5\u03b9\u03c1\u03bf\u03ba\u03af\u03bd\u03b7\u03c4\u03b7 \u03b5\u03b9\u03c3\u03b1\u03b3\u03c9\u03b3\u03ae \u03ba\u03ac\u03c1\u03c4\u03b1\u03c2","ctp.errors.UNKNOWN_ERROR":"\u03a0\u03b1\u03c1\u03bf\u03c5\u03c3\u03b9\u03ac\u03c3\u03c4\u03b7\u03ba\u03b5 \u03ba\u03ac\u03c0\u03bf\u03b9\u03bf \u03c0\u03c1\u03cc\u03b2\u03bb\u03b7\u03bc\u03b1, \u03b4\u03bf\u03ba\u03b9\u03bc\u03ac\u03c3\u03c4\u03b5 \u03be\u03b1\u03bd\u03ac \u03ae \u03c7\u03c1\u03b7\u03c3\u03b9\u03bc\u03bf\u03c0\u03bf\u03b9\u03ae\u03c3\u03c4\u03b5 \u03c4\u03b7 \u03c7\u03b5\u03b9\u03c1\u03bf\u03ba\u03af\u03bd\u03b7\u03c4\u03b7 \u03b5\u03b9\u03c3\u03b1\u03b3\u03c9\u03b3\u03ae \u03ba\u03ac\u03c1\u03c4\u03b1\u03c2","ctp.errors.SERVICE_ERROR":"\u03a0\u03b1\u03c1\u03bf\u03c5\u03c3\u03b9\u03ac\u03c3\u03c4\u03b7\u03ba\u03b5 \u03ba\u03ac\u03c0\u03bf\u03b9\u03bf \u03c0\u03c1\u03cc\u03b2\u03bb\u03b7\u03bc\u03b1, \u03b4\u03bf\u03ba\u03b9\u03bc\u03ac\u03c3\u03c4\u03b5 \u03be\u03b1\u03bd\u03ac \u03ae \u03c7\u03c1\u03b7\u03c3\u03b9\u03bc\u03bf\u03c0\u03bf\u03b9\u03ae\u03c3\u03c4\u03b5 \u03c4\u03b7 \u03c7\u03b5\u03b9\u03c1\u03bf\u03ba\u03af\u03bd\u03b7\u03c4\u03b7 \u03b5\u03b9\u03c3\u03b1\u03b3\u03c9\u03b3\u03ae \u03ba\u03ac\u03c1\u03c4\u03b1\u03c2","ctp.errors.SERVER_ERROR":"\u03a0\u03b1\u03c1\u03bf\u03c5\u03c3\u03b9\u03ac\u03c3\u03c4\u03b7\u03ba\u03b5 \u03ba\u03ac\u03c0\u03bf\u03b9\u03bf \u03c0\u03c1\u03cc\u03b2\u03bb\u03b7\u03bc\u03b1, \u03b4\u03bf\u03ba\u03b9\u03bc\u03ac\u03c3\u03c4\u03b5 \u03be\u03b1\u03bd\u03ac \u03ae \u03c7\u03c1\u03b7\u03c3\u03b9\u03bc\u03bf\u03c0\u03bf\u03b9\u03ae\u03c3\u03c4\u03b5 \u03c4\u03b7 \u03c7\u03b5\u03b9\u03c1\u03bf\u03ba\u03af\u03bd\u03b7\u03c4\u03b7 \u03b5\u03b9\u03c3\u03b1\u03b3\u03c9\u03b3\u03ae \u03ba\u03ac\u03c1\u03c4\u03b1\u03c2","ctp.errors.INVALID_PARAMETER":"\u03a0\u03b1\u03c1\u03bf\u03c5\u03c3\u03b9\u03ac\u03c3\u03c4\u03b7\u03ba\u03b5 \u03ba\u03ac\u03c0\u03bf\u03b9\u03bf \u03c0\u03c1\u03cc\u03b2\u03bb\u03b7\u03bc\u03b1, \u03b4\u03bf\u03ba\u03b9\u03bc\u03ac\u03c3\u03c4\u03b5 \u03be\u03b1\u03bd\u03ac \u03ae \u03c7\u03c1\u03b7\u03c3\u03b9\u03bc\u03bf\u03c0\u03bf\u03b9\u03ae\u03c3\u03c4\u03b5 \u03c4\u03b7 \u03c7\u03b5\u03b9\u03c1\u03bf\u03ba\u03af\u03bd\u03b7\u03c4\u03b7 \u03b5\u03b9\u03c3\u03b1\u03b3\u03c9\u03b3\u03ae \u03ba\u03ac\u03c1\u03c4\u03b1\u03c2","ctp.errors.AUTH_ERROR":"\u03a0\u03b1\u03c1\u03bf\u03c5\u03c3\u03b9\u03ac\u03c3\u03c4\u03b7\u03ba\u03b5 \u03ba\u03ac\u03c0\u03bf\u03b9\u03bf \u03c0\u03c1\u03cc\u03b2\u03bb\u03b7\u03bc\u03b1, \u03b4\u03bf\u03ba\u03b9\u03bc\u03ac\u03c3\u03c4\u03b5 \u03be\u03b1\u03bd\u03ac \u03ae \u03c7\u03c1\u03b7\u03c3\u03b9\u03bc\u03bf\u03c0\u03bf\u03b9\u03ae\u03c3\u03c4\u03b5 \u03c4\u03b7 \u03c7\u03b5\u03b9\u03c1\u03bf\u03ba\u03af\u03bd\u03b7\u03c4\u03b7 \u03b5\u03b9\u03c3\u03b1\u03b3\u03c9\u03b3\u03ae \u03ba\u03ac\u03c1\u03c4\u03b1\u03c2","paymentMethodsList.aria.label":"\u0395\u03c0\u03b9\u03bb\u03ad\u03be\u03c4\u03b5 \u03ad\u03bd\u03b1\u03bd \u03c4\u03c1\u03cc\u03c0\u03bf \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae\u03c2"}}),P3=Object.freeze({__proto__:null,default:{payButton:"Pagar","payButton.redirecting":"Redirigiendo...","payButton.with":"Pague %{value} con %{maskedData}",close:"Cerrar",storeDetails:"Recordar para mi pr\xf3ximo pago","creditCard.holderName":"Nombre en la tarjeta","creditCard.holderName.placeholder":"Juan P\xe9rez","creditCard.holderName.invalid":"Nombre del titular de tarjeta no v\xe1lido","creditCard.numberField.title":"N\xfamero de tarjeta","creditCard.expiryDateField.title":"Fecha de expiraci\xf3n","creditCard.expiryDateField.placeholder":"MM/AA","creditCard.expiryDateField.month":"Mes","creditCard.expiryDateField.month.placeholder":"MM","creditCard.expiryDateField.year.placeholder":"AA","creditCard.expiryDateField.year":"A\xf1o","creditCard.cvcField.title":"CVC / CVV","creditCard.storeDetailsButton":"Recordar para la pr\xf3xima vez","creditCard.cvcField.placeholder.4digits":"4 d\xedgitos","creditCard.cvcField.placeholder.3digits":"3 d\xedgitos","creditCard.taxNumber.placeholder":"AAMMDD / 0123456789",installments:"N\xfamero de plazos",installmentOption:"%{times}x %{partialValue}",installmentOptionMonths:"%{times}\xa0meses","installments.oneTime":"Pago \xfanico","installments.installments":"Pago fraccionado","installments.revolving":"Pago rotativo","sepaDirectDebit.ibanField.invalid":"N\xfamero de cuenta no v\xe1lido","sepaDirectDebit.nameField.placeholder":"J. Smith","sepa.ownerName":"Nombre del titular de cuenta","sepa.ibanNumber":"N\xfamero de cuenta (IBAN)","error.title":"Error","error.subtitle.redirect":"Redirecci\xf3n fallida","error.subtitle.payment":"Pago fallido","error.subtitle.refused":"Pago rechazado","error.message.unknown":"Se ha producido un error desconocido","errorPanel.title":"Errores existentes","idealIssuer.selectField.title":"Banco","idealIssuer.selectField.placeholder":"Seleccione su banco","creditCard.success":"Pago realizado correctamente",loading:"Cargando...",continue:"Continuar",continueTo:"Continuar a","wechatpay.timetopay":"Tiene %@ para pagar","wechatpay.scanqrcode":"Escanear c\xf3digo QR",personalDetails:"Datos personales",companyDetails:"Datos de la empresa","companyDetails.name":"Nombre de la empresa","companyDetails.registrationNumber":"N\xfamero de registro",socialSecurityNumber:"N\xfamero de seguridad social",firstName:"Nombre","firstName.invalid":"El nombre no es v\xe1lido",infix:"Prefijo",lastName:"Apellidos","lastName.invalid":"El apellido no es v\xe1lido",mobileNumber:"Tel\xe9fono m\xf3vil","mobileNumber.invalid":"N\xfamero de m\xf3vil no v\xe1lido",city:"Ciudad",postalCode:"C\xf3digo postal","postalCode.optional":"C\xf3digo postal (opcional)",countryCode:"Prefijo internacional",telephoneNumber:"N\xfamero de tel\xe9fono",dateOfBirth:"Fecha de nacimiento",shopperEmail:"Direcci\xf3n de correo electr\xf3nico",gender:"G\xe9nero",male:"Masculino",female:"Femenino",billingAddress:"Direcci\xf3n de facturaci\xf3n",street:"Calle",stateOrProvince:"Provincia o estado",country:"Pa\xeds",houseNumberOrName:"N\xfamero de vivienda",separateDeliveryAddress:"Especificar otra direcci\xf3n de env\xedo",deliveryAddress:"Direcci\xf3n de env\xedo",zipCode:"C\xf3digo postal",apartmentSuite:"Apartamento/suite",provinceOrTerritory:"Provincia o territorio",cityTown:"Ciudad/poblaci\xf3n",address:"Direcci\xf3n",state:"Estado","field.title.optional":"(opcional)","creditCard.cvcField.title.optional":"CVC / CVV (opcional)","issuerList.wallet.placeholder":"Seleccione su monedero electr\xf3nico",privacyPolicy:"Pol\xedtica de privacidad","afterPay.agreement":"S\xed, acepto las %@ de AfterPay",paymentConditions:"condiciones de pago",openApp:"Abrir la aplicaci\xf3n","voucher.readInstructions":"Leer instrucciones","voucher.introduction":"Gracias por su compra. Use el siguiente cup\xf3n para completar su pago.","voucher.expirationDate":"Fecha de caducidad","voucher.alternativeReference":"Referencia alternativa","dragonpay.voucher.non.bank.selectField.placeholder":"Seleccione su proveedor","dragonpay.voucher.bank.selectField.placeholder":"Seleccione su banco","voucher.paymentReferenceLabel":"Referencia de pago","voucher.surcharge":"Incluye recargo de %@","voucher.introduction.doku":"Gracias por su compra. Use la informaci\xf3n siguiente para completar su pago.","voucher.shopperName":"Nombre del comprador","voucher.merchantName":"Vendedor","voucher.introduction.econtext":"Gracias por su compra. Use la informaci\xf3n siguiente para completar su pago.","voucher.telephoneNumber":"N\xfamero de tel\xe9fono","voucher.shopperReference":"Referencia cliente","voucher.collectionInstitutionNumber":"N\xfamero de instituci\xf3n de cobro","voucher.econtext.telephoneNumber.invalid":"El n\xfamero de tel\xe9fono debe tener 10 u 11 d\xedgitos","boletobancario.btnLabel":"Generar Boleto","boleto.sendCopyToEmail":"Enviar copia a mi correo electr\xf3nico","button.copy":"Copiar","button.download":"Descargar","boleto.socialSecurityNumber.invalid":"Campo no v\xe1lido","creditCard.storedCard.description.ariaLabel":"La tarjeta almacenada termina en %@","voucher.entity":"Entidad",donateButton:"Donar",notNowButton:"Ahora no",thanksForYourSupport:"\xa1Gracias por su contribuci\xf3n!",preauthorizeWith:"Preautorizar con",confirmPreauthorization:"Confirmar preautorizaci\xf3n",confirmPurchase:"Confirmar compra",applyGiftcard:"Canjear",giftcardBalance:"Saldo de la tarjeta regalo",deductedBalance:"Saldo deducido","creditCard.pin.title":"PIN","creditCard.encryptedPassword.label":"Primeros 2 d\xedgitos de la contrase\xf1a de la tarjeta","creditCard.encryptedPassword.invalid":"Contrase\xf1a incorrecta","creditCard.taxNumber":"Fecha de nacimiento del titular o n\xfamero de registro comercial","creditCard.taxNumber.label":"Fecha de nacimiento del titular de la tarjeta (AAMMDD) o n\xfamero de registro comercial (10 d\xedgitos)","creditCard.taxNumber.labelAlt":"N\xfamero de registro comercial (10 d\xedgitos)","creditCard.taxNumber.invalid":"Fecha de nacimiento del titular o n\xfamero de registro comercial incorrectos","storedPaymentMethod.disable.button":"Eliminar","storedPaymentMethod.disable.confirmation":"Eliminar m\xe9todo de pago almacenado","storedPaymentMethod.disable.confirmButton":"S\xed, eliminar","storedPaymentMethod.disable.cancelButton":"Cancelar","ach.bankAccount":"Cuenta bancaria","ach.accountHolderNameField.title":"Nombre del titular de la cuenta","ach.accountHolderNameField.placeholder":"Juan P\xe9rez","ach.accountHolderNameField.invalid":"El nombre del titular de la cuenta no es v\xe1lido","ach.accountNumberField.title":"N\xfamero de cuenta","ach.accountNumberField.invalid":"N\xfamero de cuenta no v\xe1lido","ach.accountLocationField.title":"N\xfamero de ruta ABA","ach.accountLocationField.invalid":"El n\xfamero de ruta ABA no es v\xe1lido","ach.savedBankAccount":"Se ha guardado la cuenta bancaria","select.state":"Seleccione el estado","select.stateOrProvince":"Seleccione el estado o provincia","select.provinceOrTerritory":"Seleccione la provincia o territorio","select.country":"Seleccione el pa\xeds","select.noOptionsFound":"No se encontraron opciones","select.filter.placeholder":"Buscar...","telephoneNumber.invalid":"El n\xfamero de tel\xe9fono no es v\xe1lido",qrCodeOrApp:"o","paypal.processingPayment":"Procesando pago...",generateQRCode:"Generar c\xf3digo QR","await.waitForConfirmation":"Esperando confirmaci\xf3n","mbway.confirmPayment":"Confirme su pago en la aplicaci\xf3n MB WAY","shopperEmail.invalid":"La direcci\xf3n de correo electr\xf3nico no es v\xe1lida","dateOfBirth.format":"DD/MM/AAAA","dateOfBirth.invalid":"Debe ser mayor de 18 a\xf1os","blik.confirmPayment":"Abra la aplicaci\xf3n de su banco para confirmar el pago.","blik.invalid":"Introduzca 6 d\xedgitos","blik.code":"C\xf3digo de 6 d\xedgitos","blik.help":"Consiga el c\xf3digo en la aplicaci\xf3n de su banco.","swish.pendingMessage":"Tras escanearlo, su estado puede seguir en pendiente hasta 10\xa0minutos. Podr\xedan realizarse varios cargos si se intenta pagar de nuevo durante este periodo.","field.valid":"Campo v\xe1lido","field.invalid":"Campo no v\xe1lido","error.va.gen.01":"Campo incompleto","error.va.gen.02":"Campo no v\xe1lido","error.va.sf-cc-num.01":"El n\xfamero de tarjeta no es v\xe1lido","error.va.sf-cc-num.02":"El campo del n\xfamero de tarjeta est\xe1 vac\xedo","error.va.sf-cc-num.03":"Se ha introducido un n\xfamero de tarjeta no admitido","error.va.sf-cc-num.04":"El n\xfamero de tarjeta no tiene la longitud correcta","error.va.sf-cc-dat.01":"Fecha de caducidad: la tarjeta es demasiado antigua","error.va.sf-cc-dat.02":"Fecha de caducidad: la fecha es demasiado lejana","error.va.sf-cc-dat.03":"Fecha de caducidad: tu tarjeta caduca antes de la fecha de pago","error.va.sf-cc-dat.04":"El campo de la fecha de caducidad est\xe1 vac\xedo","error.va.sf-cc-dat.05":"La fecha de caducidad no tiene la longitud correcta","error.va.sf-cc-mth.01":"El campo del mes de caducidad est\xe1 vac\xedo","error.va.sf-cc-yr.01":"El campo del a\xf1o de caducidad est\xe1 vac\xedo","error.va.sf-cc-yr.02":"El a\xf1o de caducidad no tiene la longitud correcta","error.va.sf-cc-cvc.01":"El campo del c\xf3digo de seguridad est\xe1 vac\xedo","error.va.sf-cc-cvc.02":"El c\xf3digo de seguridad no tiene la longitud correcta","error.va.sf-ach-num.01":"El campo del n\xfamero de cuenta bancaria est\xe1 vac\xedo","error.va.sf-ach-num.02":"El n\xfamero de cuenta bancaria no tiene la longitud correcta","error.va.sf-ach-loc.01":"El campo del n\xfamero de ruta bancaria est\xe1 vac\xedo","error.va.sf-ach-loc.02":"El n\xfamero de ruta bancaria no tiene la longitud correcta","error.va.sf-kcp-pwd.01":"El campo de la contrase\xf1a est\xe1 vac\xedo","error.va.sf-kcp-pwd.02":"La contrase\xf1a no tiene la longitud correcta","error.giftcard.no-balance":"Esta tarjeta regalo no tiene saldo","error.giftcard.card-error":"No tenemos ninguna tarjeta regalo con este n\xfamero en nuestros registros.","error.giftcard.currency-error":"Las tarjetas regalo solo son v\xe1lidas en la moneda en que fueron emitidas","amazonpay.signout":"Salir de Amazon","amazonpay.changePaymentDetails":"Cambiar detalles de pago","partialPayment.warning":"Seleccione otro m\xe9todo de pago para pagar la cantidad restante","partialPayment.remainingBalance":"El saldo restante ser\xe1 %{amount}","bankTransfer.beneficiary":"Beneficiario","bankTransfer.reference":"referencia","bankTransfer.introduction":"Contin\xfae para crear un nuevo pago mediante transferencia bancaria. Puede utilizar los detalles en la siguiente pantalla para finalizar este pago.","bankTransfer.instructions":"Gracias por su compra. Use la siguiente informaci\xf3n para completar su pago.","bacs.accountHolderName":"Nombre del titular de la cuenta bancaria","bacs.accountHolderName.invalid":"El nombre del titular de la cuenta bancaria no es v\xe1lido","bacs.accountNumber":"N\xfamero de cuenta bancaria","bacs.accountNumber.invalid":"El n\xfamero de cuenta bancaria no es v\xe1lido","bacs.bankLocationId":"C\xf3digo de sucursal","bacs.bankLocationId.invalid":"El c\xf3digo de sucursal no es v\xe1lido","bacs.consent.amount":"Estoy de acuerdo con que la cantidad anterior se deduzca de mi cuenta bancaria.","bacs.consent.account":"Confirmo que la cuenta est\xe1 a mi nombre y soy el \xfanico firmante necesario para autorizar d\xe9bitos directos en esta cuenta.",edit:"Editar","bacs.confirm":"Confirmar y pagar","bacs.result.introduction":"Descargue su instrucci\xf3n de d\xe9bito directo (IDD/mandato)","download.pdf":"Descargar PDF","creditCard.encryptedCardNumber.aria.iframeTitle":"Iframe del n\xfamero de tarjeta asegurada","creditCard.encryptedCardNumber.aria.label":"N\xfamero de tarjeta","creditCard.encryptedExpiryDate.aria.iframeTitle":"Iframe de la fecha de caducidad de la tarjeta asegurada","creditCard.encryptedExpiryDate.aria.label":"Fecha de expiraci\xf3n","creditCard.encryptedExpiryMonth.aria.iframeTitle":"Iframe del mes de caducidad de tarjeta asegurada","creditCard.encryptedExpiryMonth.aria.label":"Mes de caducidad","creditCard.encryptedExpiryYear.aria.iframeTitle":"Iframe del a\xf1o de caducidad de la tarjeta asegurada","creditCard.encryptedExpiryYear.aria.label":"A\xf1o de caducidad","creditCard.encryptedSecurityCode.aria.iframeTitle":"Iframe del c\xf3digo de seguridad de la tarjeta asegurada","creditCard.encryptedSecurityCode.aria.label":"C\xf3digo de seguridad","creditCard.encryptedPassword.aria.iframeTitle":"Iframe de la contrase\xf1a de tarjeta asegurada","creditCard.encryptedPassword.aria.label":"Primeros 2 d\xedgitos de la contrase\xf1a de la tarjeta","giftcard.encryptedCardNumber.aria.iframeTitle":"Iframe del n\xfamero de la tarjeta de regalo asegurada","giftcard.encryptedCardNumber.aria.label":"N\xfamero de la tarjeta regalo","giftcard.encryptedSecurityCode.aria.iframeTitle":"Iframe del c\xf3digo de seguridad de la tarjeta de regalo asegurada","giftcard.encryptedSecurityCode.aria.label":"C\xf3digo de seguridad de la tarjeta de regalo",giftcardTransactionLimit:"Se permite un m\xe1ximo de %{amount} por transacci\xf3n en esta tarjeta regalo","ach.encryptedBankAccountNumber.aria.iframeTitle":"Iframe del n\xfamero de la cuenta bancaria asegurada","ach.encryptedBankAccountNumber.aria.label":"Cuenta bancaria","ach.encryptedBankLocationId.aria.iframeTitle":"Iframe del n\xfamero de ruta del banco asegurado","ach.encryptedBankLocationId.aria.label":"N\xfamero de ruta del banco","twint.saved":"guardado",orPayWith:"o pague con",invalidFormatExpects:"Formato no v\xe1lido. Formato correcto: %{format}","upi.qrCodeWaitingMessage":"Escanee el c\xf3digo QR con la aplicaci\xf3n UPI que prefiera para completar el pago","upi.vpaWaitingMessage":"Abra la aplicaci\xf3n UPI para confirmar el pago","upi.modeSelection":"Seleccione c\xf3mo le gustar\xeda usar UPI.","onlineBanking.termsAndConditions":"Al continuar, usted acepta los %#T\xe9rminos y condiciones%#","ctp.loading.poweredByCtp":"Con tecnolog\xeda de Click to Pay","ctp.loading.intro":"Estamos comprobando si tiene alguna tarjeta guardada con Click to Pay...","ctp.login.title":"Contin\xfae con Click to Pay","ctp.login.subtitle":"Introduzca la direcci\xf3n de correo electr\xf3nico que tiene conectada a Click to Pay para continuar.","ctp.login.inputLabel":"Correo electr\xf3nico","ctp.logout.notYou":"\xbfNo es usted?","ctp.logout.notYourCards":"\xbfNo son sus tarjetas?","ctp.logout.notYourCard":"\xbfNo es su tarjeta?","ctp.logout.notYourProfile":"\xbfNo es su perfil?","ctp.otp.fieldLabel":"C\xf3digo \xfanico","ctp.otp.resendCode":"Reenviar c\xf3digo","ctp.otp.codeResent":"C\xf3digo reenviado","ctp.otp.title":"Acceda a sus tarjetas Click to Pay","ctp.otp.subtitle":"Introduzca el c\xf3digo %@ que le hemos enviado a %@ para verificar que es usted.","ctp.emptyProfile.message":"No hay tarjetas registradas en este perfil de Click to Pay","ctp.separatorText":"o utilice","ctp.cards.title":"Completar el pago con Click to Pay","ctp.cards.subtitle":"Seleccione una tarjeta para usar.","ctp.cards.expiredCard":"Caducada","ctp.manualCardEntry":"Introducci\xf3n manual de tarjeta","ctp.aria.infoModalButton":"Qu\xe9 es Click to Pay","ctp.infoPopup.title":"Click to Pay ofrece la comodidad de la funci\xf3n sin contacto en internet","ctp.infoPopup.subtitle":"Un m\xe9todo de pago r\xe1pido y seguro compatible con Mastercard, Visa y otras tarjetas de pago.","ctp.infoPopup.benefit1":"Click to Pay utiliza cifrado para mantener su informaci\xf3n segura y protegida","ctp.infoPopup.benefit2":"Util\xedcelo con vendedores de todo el mundo","ctp.infoPopup.benefit3":"Config\xfarela una vez para realizar pagos sin complicaciones en el futuro","ctp.errors.AUTH_INVALID":"Autenticaci\xf3n no v\xe1lida","ctp.errors.NOT_FOUND":"No se ha encontrado ninguna cuenta, escriba un correo electr\xf3nico v\xe1lido o contin\xfae usando la escritura manual de la tarjeta","ctp.errors.ID_FORMAT_UNSUPPORTED":"Formato no compatible","ctp.errors.FRAUD":"Se ha bloqueado o desactivado la cuenta de usuario","ctp.errors.CONSUMER_ID_MISSING":"Falta la identidad del consumidor en la solicitud","ctp.errors.ACCT_INACCESSIBLE":"Esta cuenta no est\xe1 disponible en este momento, por ejemplo, est\xe1 bloqueada","ctp.errors.CODE_INVALID":"C\xf3digo de verificaci\xf3n incorrecto","ctp.errors.CODE_EXPIRED":"Este c\xf3digo ha caducado","ctp.errors.RETRIES_EXCEEDED":"Se ha excedido el l\xedmite de reintentos para la generaci\xf3n de una contrase\xf1a de un solo uso","ctp.errors.OTP_SEND_FAILED":"No se ha podido enviar la contrase\xf1a de un solo uso al destinatario","ctp.errors.REQUEST_TIMEOUT":"Se ha producido un error, int\xe9ntelo de nuevo o utilice la escritura manual de la tarjeta","ctp.errors.UNKNOWN_ERROR":"Se ha producido un error, int\xe9ntelo de nuevo o utilice la escritura manual de la tarjeta","ctp.errors.SERVICE_ERROR":"Se ha producido un error, int\xe9ntelo de nuevo o utilice la escritura manual de la tarjeta","ctp.errors.SERVER_ERROR":"Se ha producido un error, int\xe9ntelo de nuevo o utilice la escritura manual de la tarjeta","ctp.errors.INVALID_PARAMETER":"Se ha producido un error, int\xe9ntelo de nuevo o utilice la escritura manual de la tarjeta","ctp.errors.AUTH_ERROR":"Se ha producido un error, int\xe9ntelo de nuevo o utilice la escritura manual de la tarjeta","paymentMethodsList.aria.label":"Elija un m\xe9todo de pago"}}),w3=Object.freeze({__proto__:null,default:{payButton:"Maksa","payButton.redirecting":"Uudelleenohjataan ...","payButton.with":"Maksa %{value} k\xe4ytt\xe4en maksutapaa %{maskedData}",close:"Sulje",storeDetails:"Tallenna seuraavaa maksuani varten","creditCard.holderName":"Nimi kortilla","creditCard.holderName.placeholder":"J. Smith","creditCard.holderName.invalid":"Ei-kelvollinen kortinhaltijan nimi","creditCard.numberField.title":"Kortin numero","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"Voimassaolop\xe4iv\xe4m\xe4\xe4r\xe4","creditCard.expiryDateField.placeholder":"KK / VV","creditCard.expiryDateField.month":"Kuukausi","creditCard.expiryDateField.month.placeholder":"KK","creditCard.expiryDateField.year.placeholder":"VV","creditCard.expiryDateField.year":"Vuosi","creditCard.cvcField.title":"CVC / CVV","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"Muista seuraavalla kerralla","creditCard.cvcField.placeholder.4digits":"4 lukua","creditCard.cvcField.placeholder.3digits":"3 lukua","creditCard.taxNumber.placeholder":"VVKKPP / 0123456789",installments:"Asennusten m\xe4\xe4r\xe4",installmentOption:"% {kertaa} x% {osittainenarvo}",installmentOptionMonths:"% {kertaa} kuukautta","installments.oneTime":"Kertamaksu","installments.installments":"Er\xe4maksu","installments.revolving":"Toistuva maksu","sepaDirectDebit.ibanField.invalid":"V\xe4\xe4r\xe4 tilin numero","sepaDirectDebit.nameField.placeholder":"J. Smith","sepa.ownerName":"Haltijan nimi","sepa.ibanNumber":"Tilinumero (IBAN)","error.title":"Virhe","error.subtitle.redirect":"Uuteen kohteeseen siirto ep\xe4onnistui","error.subtitle.payment":"Maksu ep\xe4nnistui","error.subtitle.refused":"Maksu hyl\xe4tty","error.message.unknown":"Tapahtui tuntematon virhe","errorPanel.title":"Olemassa olevat virheet","idealIssuer.selectField.title":"Pankki","idealIssuer.selectField.placeholder":"Valitse pankkisi","creditCard.success":"Maksu onnistui",loading:"Ladataan...",continue:"Jatka",continueTo:"Jatka kohteeseen","wechatpay.timetopay":"Sinulla on %@ maksettavana","wechatpay.scanqrcode":"Skannaa QR-koodi",personalDetails:"Henkil\xf6tiedot",companyDetails:"Yhti\xf6n tiedot","companyDetails.name":"Yhti\xf6n nimi","companyDetails.registrationNumber":"Rekisterinumero",socialSecurityNumber:"Sosiaaliturvatunnus",firstName:"Etunimi","firstName.invalid":"Etunimi ei ole kelvollinen",infix:"Etuliite",lastName:"Sukunimi","lastName.invalid":"Sukunimi ei ole kelvollinen",mobileNumber:"Matkapuhelinnumero","mobileNumber.invalid":"Ei-kelvollinen matkapuhelinnumero",city:"Kaupunki",postalCode:"Postinumero","postalCode.optional":"Postinumero (valinnainen)",countryCode:"Maakoodi",telephoneNumber:"Puhelinnumero",dateOfBirth:"Syntym\xe4aika",shopperEmail:"S\xe4hk\xf6postiosoite",gender:"Sukupuoli",male:"Mies",female:"Nainen",billingAddress:"Laskutusosoite",street:"Katu",stateOrProvince:"Osavaltio tai l\xe4\xe4ni",country:"Maa",houseNumberOrName:"Talon numero",separateDeliveryAddress:"M\xe4\xe4rit\xe4 erillinen toimitusosoite",deliveryAddress:"Toimitusosoite",zipCode:"Postinumero",apartmentSuite:"Huoneisto / sviitti",provinceOrTerritory:"Maakunta tai alue",cityTown:"Kaupunki / taajama",address:"Osoite",state:"Osavaltio","field.title.optional":"(valinnainen)","creditCard.cvcField.title.optional":"CVC / CVV (valinnainen)","issuerList.wallet.placeholder":"Valitse lompakkosi",privacyPolicy:"Tietosuojamenettely","afterPay.agreement":"Hyv\xe4ksyn AfterPayn %@",paymentConditions:"maksuehdot",openApp:"Avaa sovellus","voucher.readInstructions":"Lue ohjeet","voucher.introduction":"Kiitos hankinnastasi, k\xe4yt\xe4 seuraavaa kuponkia vied\xe4ksesi maksusi p\xe4\xe4t\xf6kseen.","voucher.expirationDate":"Vanhenemisp\xe4iv\xe4m\xe4\xe4r\xe4","voucher.alternativeReference":"Vaihtoehtoinen viite","dragonpay.voucher.non.bank.selectField.placeholder":"Valitse toimittajasi","dragonpay.voucher.bank.selectField.placeholder":"Valitse pankkisi","voucher.paymentReferenceLabel":"Maksun viite","voucher.surcharge":"Sis. %@ lis\xe4maksun","voucher.introduction.doku":"Kiitos hankinnastasi, k\xe4yt\xe4 seuraavia tietoja p\xe4\xe4tt\xe4\xe4ksesi maksusi.","voucher.shopperName":"Ostajan nimi","voucher.merchantName":"Kauppias","voucher.introduction.econtext":"Kiitos hankinnastasi, k\xe4yt\xe4 seuraavia tietoja p\xe4\xe4tt\xe4\xe4ksesi maksusi.","voucher.telephoneNumber":"Puhelinnumero","voucher.shopperReference":"Ostajan viite","voucher.collectionInstitutionNumber":"Ker\xe4\xe4v\xe4n laitoksen numero","voucher.econtext.telephoneNumber.invalid":"Puhelinnumeron on oltava 10 tai 11 numeroa pitk\xe4","boletobancario.btnLabel":"Luo Boleto","boleto.sendCopyToEmail":"L\xe4het\xe4 kopio s\xe4hk\xf6postiini","button.copy":"Kopio","button.download":"Lataa","boleto.socialSecurityNumber.invalid":"Kentt\xe4 ei kelpaa","creditCard.storedCard.description.ariaLabel":"Tallennetun kortin viimeiset luvut ovat %@","voucher.entity":"Kokonaisuus",donateButton:"Lahjoita",notNowButton:"Ei nyt",thanksForYourSupport:"Kiitos tuestasi!",preauthorizeWith:"Ennkkolupa k\xe4ytt\xe4j\xe4n kanssa",confirmPreauthorization:"Vahvista ennakkolupa",confirmPurchase:"Vahvista hankinta",applyGiftcard:"Lunasta",giftcardBalance:"Lahjakortin saldo",deductedBalance:"V\xe4hennetty saldo","creditCard.pin.title":"Pin-tunnus","creditCard.encryptedPassword.label":"Kortin salasanan ensimm\xe4iset 2 lukua","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"Kelpaamaton salasana","creditCard.taxNumber":"Kortinhaltijan syntym\xe4p\xe4iv\xe4 (VVKKPP) tai yrityksen rekisterinumero","creditCard.taxNumber.label":"Kortinhaltijan syntym\xe4p\xe4iv\xe4 (VVKKPP) tai yrityksen rekisterinumero (10 lukua)","creditCard.taxNumber.labelAlt":"Yrityksen rekisterinumero (10 lukua)","creditCard.taxNumber.invalid":"Kelpaamaton kortinhaltijan syntym\xe4p\xe4iv\xe4 (VVKKPP) tai yrityksen rekisterinumero","storedPaymentMethod.disable.button":"Poista","storedPaymentMethod.disable.confirmation":"Poista tallennettu maksutapa","storedPaymentMethod.disable.confirmButton":"Kyll\xe4, poista","storedPaymentMethod.disable.cancelButton":"Peruuta","ach.bankAccount":"Pankkitili","ach.accountHolderNameField.title":"Tilinhaltijan nimi","ach.accountHolderNameField.placeholder":"J. Smith","ach.accountHolderNameField.invalid":"Ei-kelvollinen tilinhaltijan nimi","ach.accountNumberField.title":"Tilinumero","ach.accountNumberField.invalid":"V\xe4\xe4r\xe4 tilin numero","ach.accountLocationField.title":"ABA-reititysnumero","ach.accountLocationField.invalid":"Ei-kelvollinen ABA-reititysnumero","ach.savedBankAccount":"Tallennettu pankkitili","select.state":"Valitse osavaltio","select.stateOrProvince":"Valitse osavaltio tai l\xe4\xe4ni","select.provinceOrTerritory":"Valitse maakunta tai alue","select.country":"Valitse maa","select.noOptionsFound":"Vaihtoehtoja ei l\xf6ytynyt","select.filter.placeholder":"Hae...","telephoneNumber.invalid":"Ei-kelvollinen puhelinnumero",qrCodeOrApp:"tai","paypal.processingPayment":"Maksua k\xe4sitell\xe4\xe4n...",generateQRCode:"Tuota QR-koodi","await.waitForConfirmation":"Odottaa vahvistusta","mbway.confirmPayment":"Vahvista maksusi MB WAY -sovelluksella","shopperEmail.invalid":"Ei-kelvollinen s\xe4hk\xf6postiosoite","dateOfBirth.format":"PP/KK/VVVV","dateOfBirth.invalid":"Sinun on oltava v\xe4hint\xe4\xe4n 18-vuotias","blik.confirmPayment":"Avaa pankkisovelluksesi vahvistaaksesi maksun.","blik.invalid":"Sy\xf6t\xe4 6 lukua","blik.code":"6-numeroinen koodi","blik.help":"Hanki koodi pankkisovelluksestasi.","swish.pendingMessage":"Skannattuasi, tila voi odottaa jopa 10 minuuttia. Yritys maksaa uudelleen t\xe4ss\xe4 ajassa voi tuottaa moninkertaisia maksuja.","field.valid":"Kentt\xe4 kelvollinen","field.invalid":"Kentt\xe4 ei kelpaa","error.va.gen.01":"T\xe4ydent\xe4m\xe4t\xf6n kentt\xe4","error.va.gen.02":"Kentt\xe4 ei kelpaa","error.va.sf-cc-num.01":"Kortin numero ei ole kelvollinen","error.va.sf-cc-num.02":"Kortin numero -kentt\xe4 on tyhj\xe4","error.va.sf-cc-num.03":"Annettu kortin numero, jota ei tueta","error.va.sf-cc-num.04":"Kortin numero on v\xe4\xe4r\xe4n pituinen","error.va.sf-cc-dat.01":"Vanhenemisp\xe4iv\xe4: kortti liian vanha","error.va.sf-cc-dat.02":"Vanhenemisp\xe4iv\xe4: p\xe4iv\xe4m\xe4\xe4r\xe4 liian kaukana tulevaisuudessa","error.va.sf-cc-dat.03":"Vanhenemisp\xe4iv\xe4: korttisi vanhenee ennen uloskirjautumisp\xe4iv\xe4\xe4","error.va.sf-cc-dat.04":"Vanhenemisp\xe4iv\xe4-kentt\xe4 on tyhj\xe4","error.va.sf-cc-dat.05":"Vanhenemisp\xe4iv\xe4 on v\xe4\xe4r\xe4n pituinen","error.va.sf-cc-mth.01":"Vanhenemiskuukausi-kentt\xe4 on tyhj\xe4","error.va.sf-cc-yr.01":"Vanhenemisvuosi-kentt\xe4 on tyhj\xe4","error.va.sf-cc-yr.02":"Vanhenemisvuosi on v\xe4\xe4r\xe4n pituinen","error.va.sf-cc-cvc.01":"Turvakoodikentt\xe4 on tyhj\xe4","error.va.sf-cc-cvc.02":"Turvakoodi on v\xe4\xe4r\xe4n pituinen","error.va.sf-ach-num.01":"Pankkitilin numero -kentt\xe4 on tyhj\xe4","error.va.sf-ach-num.02":"Pankkitilin numero on v\xe4\xe4r\xe4n pituinen","error.va.sf-ach-loc.01":"Pankin reititysnumeron kentt\xe4 on tyhj\xe4","error.va.sf-ach-loc.02":"Pankin reititysnumero on v\xe4\xe4r\xe4n pituinen","error.va.sf-kcp-pwd.01":"Salasanakentt\xe4 on tyhj\xe4","error.va.sf-kcp-pwd.02":"Salasana on v\xe4\xe4r\xe4n pituinen","error.giftcard.no-balance":"Lahjakortin saldo on nolla","error.giftcard.card-error":"Asiakirjoissamme ei ole t\xe4m\xe4n numeron lahjakorttia","error.giftcard.currency-error":"Gift cards are only valid in the currency they were issued in","amazonpay.signout":"Kirjaudu ulos Amazonista","amazonpay.changePaymentDetails":"Muuta maksutietoja","partialPayment.warning":"Valitse toinen maksutapa j\xe4\xe4nn\xf6ksen maksamiseksi","partialPayment.remainingBalance":"J\xe4ljell\xe4 oleva saldo on %{summa}","bankTransfer.beneficiary":"Edunsaaja","bankTransfer.iban":"IBAN","bankTransfer.bic":"BIC","bankTransfer.reference":"Viite","bankTransfer.introduction":"Jatka uuden pankkisiirtomaksun luomista. Voit viimeistell\xe4 t\xe4m\xe4n maksun seuraavan n\xe4yt\xf6n tietojen avulla.","bankTransfer.instructions":"Kiitos hankinnastasi, k\xe4yt\xe4 seuraavia tietoja p\xe4\xe4tt\xe4\xe4ksesi maksusi.","bacs.accountHolderName":"Tilinhaltijan nimi","bacs.accountHolderName.invalid":"Ei-kelvollinen tilinhaltijan nimi","bacs.accountNumber":"Pankkitilinumero","bacs.accountNumber.invalid":"V\xe4\xe4r\xe4 tilin numero","bacs.bankLocationId":"Lajittelukoodi","bacs.bankLocationId.invalid":"Ei-kelvollinen lajittelukoodi","bacs.consent.amount":"Hyv\xe4ksyn, ett\xe4 alla oleva summa veloitetaan pankkitililt\xe4ni.","bacs.consent.account":"Vahvistan, ett\xe4 tili on nimess\xe4ni ja olen ainoa allekirjoittaja, joka vaaditaan valtuuttamaan suoraveloitus t\xe4ll\xe4 tilill\xe4.",edit:"Muokkaa","bacs.confirm":"Vahvista ja maksa","bacs.result.introduction":"Lataa suoraveloitusohjeet (DDI / Mandate)","download.pdf":"Lataa PDF","creditCard.encryptedCardNumber.aria.iframeTitle":"Iframe suojatulle kortin numerolle","creditCard.encryptedCardNumber.aria.label":"Kortin numero","creditCard.encryptedExpiryDate.aria.iframeTitle":"Iframe suojatulle kortin viimeiselle k\xe4ytt\xf6p\xe4iv\xe4lle","creditCard.encryptedExpiryDate.aria.label":"Voimassaolop\xe4iv\xe4m\xe4\xe4r\xe4","creditCard.encryptedExpiryMonth.aria.iframeTitle":"Iframe suojatulle kortin viimeiselle k\xe4ytt\xf6kuukaudelle","creditCard.encryptedExpiryMonth.aria.label":"Vanhenemiskuukausi","creditCard.encryptedExpiryYear.aria.iframeTitle":"Iframe suojatulle kortin viimeiselle voimassaolovuodelle","creditCard.encryptedExpiryYear.aria.label":"Vanhenemisvuosi","creditCard.encryptedSecurityCode.aria.iframeTitle":"Iframe suojatulle kortin turvakoodille","creditCard.encryptedSecurityCode.aria.label":"Turvakoodi","creditCard.encryptedPassword.aria.iframeTitle":"Iframe suojatulle kortin salasanalle","creditCard.encryptedPassword.aria.label":"Kortin salasanan ensimm\xe4iset 2 lukua","giftcard.encryptedCardNumber.aria.iframeTitle":"Iframe suojatulle lahjakortin numerolle","giftcard.encryptedCardNumber.aria.label":"Lahjakorttinumero","giftcard.encryptedSecurityCode.aria.iframeTitle":"Iframe suojatulle lahjakortin turvakoodille","giftcard.encryptedSecurityCode.aria.label":"Lahjakortin turvakoodi",giftcardTransactionLimit:"Maks. % {summa} sallittu tapahtumaa kohti t\xe4ll\xe4 lahjakortilla","ach.encryptedBankAccountNumber.aria.iframeTitle":"Iframe suojatulle pankkitilinumerolle","ach.encryptedBankAccountNumber.aria.label":"Pankkitili","ach.encryptedBankLocationId.aria.iframeTitle":"Iframe suojatulle pankin reititysnumerolle","ach.encryptedBankLocationId.aria.label":"Pankin reititysnumero","twint.saved":"tallennettu",orPayWith:"tai maksa",invalidFormatExpects:"Ei-kelvollinen muoto. Odotettu muoto: %{format}","upi.qrCodeWaitingMessage":"Suorita maksu loppuun skannaamalla QR-koodi haluamallasi UPI-sovelluksella","upi.vpaWaitingMessage":"Avaa UPI-sovellus vahvistaaksesi maksun","upi.modeSelection":"Valitse, kuinka haluat k\xe4ytt\xe4\xe4 UPI-sovellusta.","onlineBanking.termsAndConditions":"Jatkamalla hyv\xe4ksyt %#k\xe4ytt\xf6ehdot%#","ctp.loading.poweredByCtp":"Palvelun tarjoaa Click to Pay","ctp.loading.intro":"Tarkistamme, onko sinulla tallennettuja Click to Pay -kortteja...","ctp.login.title":"Jatka Click to Pay -palveluun","ctp.login.subtitle":"Jatka antamalla Click to Pay -palveluun liitetty s\xe4hk\xf6postiosoite.","ctp.login.inputLabel":"S\xe4hk\xf6posti","ctp.logout.notYou":"Etk\xf6 t\xe4m\xe4 ole sin\xe4?","ctp.logout.notYourCards":"Eik\xf6 t\xe4m\xe4 ole korttisi?","ctp.logout.notYourCard":"Eik\xf6 t\xe4m\xe4 ole korttisi?","ctp.logout.notYourProfile":"Eik\xf6 t\xe4m\xe4 ole profiilisi?","ctp.otp.fieldLabel":"Kertakoodi","ctp.otp.resendCode":"L\xe4het\xe4 koodi uudelleen","ctp.otp.codeResent":"Koodi l\xe4hetetty uudelleen","ctp.otp.title":"Hanki p\xe4\xe4sy Click to Pay -kortteihisi","ctp.otp.subtitle":"Sy\xf6t\xe4 koodi, jonka %@ l\xe4hetti osoitteeseen %@ vahvistaaksesi, ett\xe4 kyseess\xe4 olet sin\xe4.","ctp.emptyProfile.message":"T\xe4h\xe4n Click to Pay -profiiliin ei ole rekister\xf6ity kortteja","ctp.separatorText":"tai k\xe4yt\xe4","ctp.cards.title":"Suorita maksu Click to Paylla","ctp.cards.subtitle":"Valitse k\xe4ytett\xe4v\xe4 kortti.","ctp.cards.expiredCard":"Vanhentunut","ctp.manualCardEntry":"Manuaalinen kortin sy\xf6tt\xf6","ctp.aria.infoModalButton":"Mik\xe4 on Click to Pay","ctp.infoPopup.title":"Click to Pay tuo l\xe4himaksujen helppouden verkkoon","ctp.infoPopup.subtitle":"Nopea ja turvallinen maksutapa, jota tukevat Mastercard, Visa ja muut maksukortit.","ctp.infoPopup.benefit1":"Click to Pay k\xe4ytt\xe4\xe4 salausta tietojesi turvaamiseen","ctp.infoPopup.benefit2":"K\xe4yt\xe4 sit\xe4 kauppiailla kaikkialla maailmassa","ctp.infoPopup.benefit3":"M\xe4\xe4rit\xe4 kerran, jotta voit maksaa vaivattomasti jatkossa","ctp.errors.AUTH_INVALID":"Virheellinen todennus","ctp.errors.NOT_FOUND":"Tili\xe4 ei l\xf6ytynyt. Anna kelvollinen s\xe4hk\xf6postiosoite tai jatka manuaalista kortin sy\xf6tt\xf6\xe4","ctp.errors.ID_FORMAT_UNSUPPORTED":"Muoto ei tuettu","ctp.errors.FRAUD":"K\xe4ytt\xe4j\xe4tili oli lukittu tai poistettu k\xe4yt\xf6st\xe4","ctp.errors.CONSUMER_ID_MISSING":"Pyynn\xf6st\xe4 puuttuu kuluttajan henkil\xf6llisyys","ctp.errors.ACCT_INACCESSIBLE":"T\xe4m\xe4 tili ei ole t\xe4ll\xe4 hetkell\xe4 k\xe4ytett\xe4viss\xe4, se voi esimerkiksi olla lukittu","ctp.errors.CODE_INVALID":"Virheellinen vahvistuskoodi","ctp.errors.CODE_EXPIRED":"T\xe4m\xe4 koodi on vanhentunut","ctp.errors.RETRIES_EXCEEDED":"Kertak\xe4ytt\xf6isen salasanan luomisen uusintayritysten m\xe4\xe4r\xe4 ylittyi","ctp.errors.OTP_SEND_FAILED":"Kertak\xe4ytt\xf6ist\xe4 salasanaa ei voitu l\xe4hett\xe4\xe4 vastaanottajalle","ctp.errors.REQUEST_TIMEOUT":"Jokin meni vikaan. Yrit\xe4 uudelleen tai k\xe4yt\xe4 manuaalista kortin sy\xf6tt\xf6\xe4","ctp.errors.UNKNOWN_ERROR":"Jokin meni vikaan. Yrit\xe4 uudelleen tai k\xe4yt\xe4 manuaalista kortin sy\xf6tt\xf6\xe4","ctp.errors.SERVICE_ERROR":"Jokin meni vikaan. Yrit\xe4 uudelleen tai k\xe4yt\xe4 manuaalista kortin sy\xf6tt\xf6\xe4","ctp.errors.SERVER_ERROR":"Jokin meni vikaan. Yrit\xe4 uudelleen tai k\xe4yt\xe4 manuaalista kortin sy\xf6tt\xf6\xe4","ctp.errors.INVALID_PARAMETER":"Jokin meni vikaan. Yrit\xe4 uudelleen tai k\xe4yt\xe4 manuaalista kortin sy\xf6tt\xf6\xe4","ctp.errors.AUTH_ERROR":"Jokin meni vikaan. Yrit\xe4 uudelleen tai k\xe4yt\xe4 manuaalista kortin sy\xf6tt\xf6\xe4","paymentMethodsList.aria.label":"Valitse maksutapa"}}),S3=Object.freeze({__proto__:null,default:{payButton:"Payer","payButton.redirecting":"Redirection...","payButton.with":"Payer %{value} avec %{maskedData}",close:"Fermer",storeDetails:"Sauvegarder pour mon prochain paiement","creditCard.holderName":"Nom sur la carte","creditCard.holderName.placeholder":"J. Smith","creditCard.holderName.invalid":"Nom du porteur de carte incorrect","creditCard.numberField.title":"Num\xe9ro de la carte","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"Date d'expiration","creditCard.expiryDateField.placeholder":"MM/AA","creditCard.expiryDateField.month":"Mois","creditCard.expiryDateField.month.placeholder":"MM","creditCard.expiryDateField.year.placeholder":"AA","creditCard.expiryDateField.year":"Ann\xe9e","creditCard.cvcField.title":"CVC / CVV","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"Enregistrer pour la prochaine fois","creditCard.cvcField.placeholder.4digits":"4\xa0chiffres","creditCard.cvcField.placeholder.3digits":"3\xa0chiffres","creditCard.taxNumber.placeholder":"AAMMJJ / 0123456789",installments:"Nombre de versements",installmentOption:"%{times}x %{partialValue}",installmentOptionMonths:"%{times}\xa0mois","installments.oneTime":"Paiement unique","installments.installments":"Paiement \xe9chelonn\xe9","installments.revolving":"Paiement en plusieurs fois","sepaDirectDebit.ibanField.invalid":"Num\xe9ro de compte non valide","sepaDirectDebit.nameField.placeholder":"N. Bernard","sepa.ownerName":"Au nom de","sepa.ibanNumber":"Num\xe9ro de compte (IBAN)","error.title":"Erreur","error.subtitle.redirect":"\xc9chec de la redirection","error.subtitle.payment":"\xc9chec du paiement","error.subtitle.refused":"Paiement refus\xe9","error.message.unknown":"Une erreur inconnue s'est produite","errorPanel.title":"Erreurs existantes","idealIssuer.selectField.title":"Banque","idealIssuer.selectField.placeholder":"S\xe9lectionnez votre banque","creditCard.success":"Paiement r\xe9ussi",loading:"Chargement en cours...",continue:"Continuer",continueTo:"Poursuivre vers","wechatpay.timetopay":"Vous avez %@ pour payer cette somme","wechatpay.scanqrcode":"Scanner le code QR",personalDetails:"Informations personnelles",companyDetails:"Coordonn\xe9es de l'entreprise","companyDetails.name":"Nom de l'entreprise","companyDetails.registrationNumber":"Num\xe9ro d'enregistrement",socialSecurityNumber:"Num\xe9ro de s\xe9curit\xe9 sociale",firstName:"Pr\xe9nom","firstName.invalid":"Le pr\xe9nom n'est pas valide",infix:"Pr\xe9fixe",lastName:"Nom de famille","lastName.invalid":"Le nom n'est pas valide",mobileNumber:"Num\xe9ro de portable","mobileNumber.invalid":"Num\xe9ro de portable non valide",city:"Ville",postalCode:"Code postal","postalCode.optional":"Code postal (facultatif)",countryCode:"Code pays",telephoneNumber:"Num\xe9ro de t\xe9l\xe9phone",dateOfBirth:"Date de naissance",shopperEmail:"Adresse e-mail",gender:"Sexe",male:"Homme",female:"Femme",billingAddress:"Adresse de facturation",street:"Rue",stateOrProvince:"\xc9tat ou province",country:"Pays",houseNumberOrName:"Num\xe9ro de rue",separateDeliveryAddress:"Indiquer une adresse de livraison distincte",deliveryAddress:"Adresse de livraison",zipCode:"Code postal",apartmentSuite:"Appartement",provinceOrTerritory:"Province ou territoire",cityTown:"Ville",address:"Adresse",state:"\xc9tat","field.title.optional":"(facultatif)","creditCard.cvcField.title.optional":"CVC / CVV (facultatif)","issuerList.wallet.placeholder":"S\xe9lectionnez votre portefeuille",privacyPolicy:"Politique de confidentialit\xe9","afterPay.agreement":"J'accepte les %@ de AfterPay",paymentConditions:"conditions de paiement",openApp:"Ouvrir l'application","voucher.readInstructions":"Lire les instructions","voucher.introduction":"Merci pour votre achat, veuillez utiliser le coupon suivant pour finaliser votre paiement.","voucher.expirationDate":"Date d'expiration","voucher.alternativeReference":"Autre r\xe9f\xe9rence","dragonpay.voucher.non.bank.selectField.placeholder":"S\xe9lectionnez votre fournisseur","dragonpay.voucher.bank.selectField.placeholder":"S\xe9lectionnez votre banque","voucher.paymentReferenceLabel":"R\xe9f\xe9rence du paiement","voucher.surcharge":"Comprend une surcharge de %@","voucher.introduction.doku":"Nous vous remercions de votre achat. Veuillez finaliser votre paiement \xe0 l'aide des informations suivantes.","voucher.shopperName":"Nom de l'acheteur","voucher.merchantName":"Marchand","voucher.introduction.econtext":"Nous vous remercions de votre achat. Veuillez finaliser votre paiement \xe0 l'aide des informations suivantes.","voucher.telephoneNumber":"Num\xe9ro de t\xe9l\xe9phone","voucher.shopperReference":"R\xe9f\xe9rence client","voucher.collectionInstitutionNumber":"Num\xe9ro du point de paiement","voucher.econtext.telephoneNumber.invalid":"Le num\xe9ro de t\xe9l\xe9phone doit comporter 10 ou 11\xa0chiffres","boletobancario.btnLabel":"G\xe9n\xe9rer un Boleto","boleto.sendCopyToEmail":"Envoyer une copie \xe0 mon adresse e-mail","button.copy":"Copier","button.download":"T\xe9l\xe9charger","boleto.socialSecurityNumber.invalid":"Champ non valide","creditCard.storedCard.description.ariaLabel":"La carte enregistr\xe9e se termine en %@","voucher.entity":"Entit\xe9",donateButton:"Faire un don",notNowButton:"Pas maintenant",thanksForYourSupport:"Merci de votre soutien\xa0!",preauthorizeWith:"Pr\xe9-autoriser avec",confirmPreauthorization:"Confirmer la pr\xe9-autorisation",confirmPurchase:"Confirmer l'achat",applyGiftcard:"Utiliser",giftcardBalance:"Solde de la carte cadeau",deductedBalance:"Solde d\xe9duit","creditCard.pin.title":"PIN","creditCard.encryptedPassword.label":"Les deux premiers chiffres du code de votre carte","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"Code incorrect","creditCard.taxNumber":"Date de naissance du porteur de carte ou num\xe9ro d'identification de l'entreprise","creditCard.taxNumber.label":"Date de naissance du porteur de carte (au format AAMMJJ) ou num\xe9ro d'identification de l'entreprise (\xe0 10\xa0chiffres)","creditCard.taxNumber.labelAlt":"Num\xe9ro d'identification de l'entreprise (\xe0 10\xa0chiffres)","creditCard.taxNumber.invalid":"Date de naissance du porteur de carte ou num\xe9ro d'identification de l'entreprise incorrect(e)","storedPaymentMethod.disable.button":"Supprimer","storedPaymentMethod.disable.confirmation":"Supprimer le mode de paiement enregistr\xe9","storedPaymentMethod.disable.confirmButton":"Oui, supprimer","storedPaymentMethod.disable.cancelButton":"Annuler","ach.bankAccount":"Compte bancaire","ach.accountHolderNameField.title":"Nom du titulaire du compte","ach.accountHolderNameField.placeholder":"J. Smith","ach.accountHolderNameField.invalid":"Nom du titulaire du compte incorrect","ach.accountNumberField.title":"Num\xe9ro du compte","ach.accountNumberField.invalid":"Num\xe9ro du compte incorrect","ach.accountLocationField.title":"Code ABA","ach.accountLocationField.invalid":"Code ABA incorrect","ach.savedBankAccount":"Compte bancaire enregistr\xe9","select.state":"S\xe9lectionnez l'\xc9tat","select.stateOrProvince":"S\xe9lectionnez l'\xc9tat ou la province","select.provinceOrTerritory":"S\xe9lectionnez la province ou le territoire","select.country":"S\xe9lectionnez le pays","select.noOptionsFound":"Aucune option trouv\xe9e","select.filter.placeholder":"Recherche...","telephoneNumber.invalid":"Num\xe9ro de t\xe9l\xe9phone incorrect",qrCodeOrApp:"ou","paypal.processingPayment":"Traitement du paiement en cours...",generateQRCode:"G\xe9n\xe9rer un code QR","await.waitForConfirmation":"En attente de confirmation","mbway.confirmPayment":"Confirmez votre paiement sur l'application MB WAY","shopperEmail.invalid":"Adresse e-mail incorrecte","dateOfBirth.format":"JJ/MM/AAAA","dateOfBirth.invalid":"Vous devez \xeatre \xe2g\xe9(e) d'au moins 18\xa0ans","blik.confirmPayment":"Ouvrez votre application bancaire pour confirmer le paiement.","blik.invalid":"Saisissez les 6\xa0chiffres","blik.code":"Code \xe0 6\xa0chiffres","blik.help":"Ouvrez votre application bancaire pour obtenir le code.","swish.pendingMessage":"Apr\xe8s avoir scann\xe9 le code QR, la mise \xe0 jour du statut de paiement peut prendre jusqu'\xe0 10\xa0minutes. Si vous effectuez une nouvelle tentative de paiement dans ce d\xe9lai, cela pourrait occasionner plusieurs d\xe9bits.","field.valid":"Champ valide","field.invalid":"Champ non valide","error.va.gen.01":"Champ incomplet","error.va.gen.02":"Champ non valide","error.va.sf-cc-num.01":"Num\xe9ro de carte non valide","error.va.sf-cc-num.02":"Veuillez renseigner un num\xe9ro de carte","error.va.sf-cc-num.03":"Num\xe9ro de carte non pris en charge","error.va.sf-cc-num.04":"Longueur du num\xe9ro de carte incorrecte","error.va.sf-cc-dat.01":"Date d'expiration\xa0: carte trop ancienne","error.va.sf-cc-dat.02":"Date d'expiration\xa0: la date doit \xeatre plus proche","error.va.sf-cc-dat.03":"Date d'expiration\xa0: votre carte expire avant la date de paiement","error.va.sf-cc-dat.04":"Veuillez renseigner une date d'expiration","error.va.sf-cc-dat.05":"Longueur de la date d'expiration incorrecte","error.va.sf-cc-mth.01":"Veuillez renseigner un mois d'expiration","error.va.sf-cc-yr.01":"Veuillez renseigner une ann\xe9e d'expiration","error.va.sf-cc-yr.02":"Longueur de l'ann\xe9e d'expiration incorrecte","error.va.sf-cc-cvc.01":"Veuillez renseigner un code de s\xe9curit\xe9","error.va.sf-cc-cvc.02":"Longueur du code de s\xe9curit\xe9 incorrecte","error.va.sf-ach-num.01":"Veuillez renseigner un num\xe9ro de compte bancaire","error.va.sf-ach-num.02":"Longueur du num\xe9ro de compte bancaire incorrecte","error.va.sf-ach-loc.01":"Veuillez renseigner un num\xe9ro de routage","error.va.sf-ach-loc.02":"Longueur du num\xe9ro de routage incorrecte","error.va.sf-kcp-pwd.01":"Veuillez renseigner un mot de passe","error.va.sf-kcp-pwd.02":"Longueur du mot de passe incorrecte","error.giftcard.no-balance":"Aucun solde n'est disponible sur cette carte cadeau","error.giftcard.card-error":"Aucune carte cadeau ne correspond \xe0 ce num\xe9ro","error.giftcard.currency-error":"Les cartes cadeaux sont valables uniquement dans la devise dans laquelle elles ont \xe9t\xe9 \xe9mises","amazonpay.signout":"Se d\xe9connecter d'Amazon","amazonpay.changePaymentDetails":"Modifier les informations de paiement","partialPayment.warning":"S\xe9lectionnez un autre mode de paiement pour r\xe9gler le solde","partialPayment.remainingBalance":"Le solde restant sera de %{amount}","bankTransfer.beneficiary":"B\xe9n\xe9ficiaire","bankTransfer.iban":"IBAN","bankTransfer.bic":"BIC","bankTransfer.reference":"R\xe9f\xe9rence","bankTransfer.introduction":"Continuez \xe0 cr\xe9er un nouveau paiement par virement bancaire. Utilisez les informations de l'\xe9cran suivant pour finaliser ce paiement.","bankTransfer.instructions":"Merci pour votre achat\xa0! Veuillez utiliser les informations suivantes pour finaliser votre paiement.","bacs.accountHolderName":"Nom du titulaire du compte bancaire","bacs.accountHolderName.invalid":"Nom du titulaire du compte bancaire incorrect","bacs.accountNumber":"Num\xe9ro du compte bancaire","bacs.accountNumber.invalid":"Num\xe9ro du compte bancaire incorrect","bacs.bankLocationId":"Code de tri (sort code)","bacs.bankLocationId.invalid":"Code de tri (sort code) non valide","bacs.consent.amount":"J'accepte que le montant ci-dessus soit d\xe9duit de mon compte bancaire.","bacs.consent.account":"Je confirme \xeatre le titulaire du compte et qu'aucune autre signature que la mienne n'est requise pour autoriser un pr\xe9l\xe8vement sur ce compte.",edit:"Modifier","bacs.confirm":"Confirmer et payer","bacs.result.introduction":"T\xe9l\xe9chargez votre mandat de pr\xe9l\xe8vement (DDI)","download.pdf":"T\xe9l\xe9charger le PDF","creditCard.encryptedCardNumber.aria.iframeTitle":"Iframe pour le num\xe9ro de carte avec garantie","creditCard.encryptedCardNumber.aria.label":"Num\xe9ro de la carte","creditCard.encryptedExpiryDate.aria.iframeTitle":"Iframe pour la date d'expiration de la carte avec garantie","creditCard.encryptedExpiryDate.aria.label":"Date d'expiration","creditCard.encryptedExpiryMonth.aria.iframeTitle":"Iframe pour le mois d'expiration de la carte avec garantie","creditCard.encryptedExpiryMonth.aria.label":"Mois d'expiration","creditCard.encryptedExpiryYear.aria.iframeTitle":"Iframe pour l'ann\xe9e d'expiration de la carte avec garantie","creditCard.encryptedExpiryYear.aria.label":"Ann\xe9e d'expiration","creditCard.encryptedSecurityCode.aria.iframeTitle":"Iframe pour le code de s\xe9curit\xe9 de la carte avec garantie","creditCard.encryptedSecurityCode.aria.label":"Code de s\xe9curit\xe9","creditCard.encryptedPassword.aria.iframeTitle":"Iframe pour le mot de passe de la carte s\xe9curis\xe9e","creditCard.encryptedPassword.aria.label":"Les deux premiers chiffres du code de votre carte","giftcard.encryptedCardNumber.aria.iframeTitle":"Iframe pour le num\xe9ro de la carte-cadeau avec garantie","giftcard.encryptedCardNumber.aria.label":"Num\xe9ro de la carte cadeau","giftcard.encryptedSecurityCode.aria.iframeTitle":"Iframe pour le code de s\xe9curit\xe9 de la carte-cadeau avec garantie","giftcard.encryptedSecurityCode.aria.label":"Code de s\xe9curit\xe9 de la carte cadeau",giftcardTransactionLimit:"Montant maximum autoris\xe9 par transaction avec cette carte cadeau\xa0: %{amount}","ach.encryptedBankAccountNumber.aria.iframeTitle":"Iframe pour le num\xe9ro du compte bancaire avec garantie","ach.encryptedBankAccountNumber.aria.label":"Compte bancaire","ach.encryptedBankLocationId.aria.iframeTitle":"Iframe pour le num\xe9ro de routage du compte avec garantie","ach.encryptedBankLocationId.aria.label":"Num\xe9ro de routage","twint.saved":"stock\xe9",orPayWith:"ou payez avec",invalidFormatExpects:"Format non valide. Format requis\xa0: %{format}","upi.qrCodeWaitingMessage":"Scannez le code QR \xe0 l'aide de votre application UPI pr\xe9f\xe9r\xe9e pour effectuer le paiement","upi.vpaWaitingMessage":"Ouvrez votre application UPI pour confirmer le paiement","upi.modeSelection":"Choisissez la fa\xe7on dont vous souhaitez utiliser l'application UPI.","onlineBanking.termsAndConditions":"En continuant, vous acceptez les %#conditions g\xe9n\xe9rales%#","ctp.loading.poweredByCtp":"Avec la technologie Click to Pay","ctp.loading.intro":"Nous v\xe9rifions si vous avez des cartes enregistr\xe9es avec Click to Pay...","ctp.login.title":"Acc\xe9der \xe0 Click to Pay","ctp.login.subtitle":"Saisissez l'adresse e-mail de votre profil Click to Pay pour continuer.","ctp.login.inputLabel":"E-mail","ctp.logout.notYou":"Ce n'est pas votre compte\xa0?","ctp.logout.notYourCards":"Ce ne sont pas vos cartes\xa0?","ctp.logout.notYourCard":"Ce n'est pas votre carte\xa0?","ctp.logout.notYourProfile":"Ce n'est pas votre profil\xa0?","ctp.otp.fieldLabel":"Code \xe0 usage unique","ctp.otp.resendCode":"Renvoyer le code","ctp.otp.codeResent":"Code renvoy\xe9","ctp.otp.title":"Acc\xe9dez \xe0 vos cartes Click to Pay","ctp.otp.subtitle":"Saisissez le code %@ envoy\xe9 \xe0 %@ pour v\xe9rifier votre identit\xe9.","ctp.emptyProfile.message":"Aucune carte enregistr\xe9e dans ce profil Click to Pay","ctp.separatorText":"ou utilisez","ctp.cards.title":"Terminez le paiement avec Click to Pay","ctp.cards.subtitle":"S\xe9lectionnez la carte \xe0 utiliser.","ctp.cards.expiredCard":"Expir\xe9","ctp.manualCardEntry":"Saisie manuelle de la carte","ctp.aria.infoModalButton":"Qu'est-ce que Click to Pay\xa0?","ctp.infoPopup.title":"Click to Pay offre la simplicit\xe9 du sans contact sur Internet","ctp.infoPopup.subtitle":"Un mode de paiement rapide et s\xe9curis\xe9 compatible avec les cartes Mastercard, Visa et autres fournisseurs.","ctp.infoPopup.benefit1":"Click to Pay utilise le chiffrement pour assurer la s\xe9curit\xe9 de vos informations","ctp.infoPopup.benefit2":"Utilisez-le pour vos achats dans le monde entier","ctp.infoPopup.benefit3":"Enregistrez votre carte une fois et simplifiez vos paiements pour toujours","ctp.errors.AUTH_INVALID":"Authentification non valide","ctp.errors.NOT_FOUND":"Aucun compte trouv\xe9, v\xe9rifiez l'adresse e-mail ou saisissez manuellement les informations de votre carte","ctp.errors.ID_FORMAT_UNSUPPORTED":"Format non pris en charge","ctp.errors.FRAUD":"Le compte utilisateur a \xe9t\xe9 verrouill\xe9 ou d\xe9sactiv\xe9","ctp.errors.CONSUMER_ID_MISSING":"L'identit\xe9 du client n'est pas indiqu\xe9e dans la demande","ctp.errors.ACCT_INACCESSIBLE":"Ce compte n'est pas disponible actuellement car il est verrouill\xe9","ctp.errors.CODE_INVALID":"Code de v\xe9rification incorrect","ctp.errors.CODE_EXPIRED":"Ce code a expir\xe9","ctp.errors.RETRIES_EXCEEDED":"La limite du nombre de tentatives pour la g\xe9n\xe9ration de l'OTP a \xe9t\xe9 d\xe9pass\xe9e","ctp.errors.OTP_SEND_FAILED":"Impossible d'envoyer l'OTP au destinataire","ctp.errors.REQUEST_TIMEOUT":"Une erreur s'est produite, r\xe9essayez ou saisissez manuellement les informations de votre carte","ctp.errors.UNKNOWN_ERROR":"Une erreur s'est produite, r\xe9essayez ou saisissez manuellement les informations de votre carte","ctp.errors.SERVICE_ERROR":"Une erreur s'est produite, r\xe9essayez ou saisissez manuellement les informations de votre carte","ctp.errors.SERVER_ERROR":"Une erreur s'est produite, r\xe9essayez ou saisissez manuellement les informations de votre carte","ctp.errors.INVALID_PARAMETER":"Une erreur s'est produite, r\xe9essayez ou saisissez manuellement les informations de votre carte","ctp.errors.AUTH_ERROR":"Une erreur s'est produite, r\xe9essayez ou saisissez manuellement les informations de votre carte","paymentMethodsList.aria.label":"Choisissez un mode de paiement"}}),x3=Object.freeze({__proto__:null,default:{payButton:"Platiti","payButton.redirecting":"Preusmjeravanje...","payButton.with":"Platite iznos od %{value} uporabom stavke %{maskedData}",close:"Zatvori",storeDetails:"Pohrani za moje sljede\u0107e pla\u0107anje","creditCard.holderName":"Ime na kartici","creditCard.holderName.placeholder":"J. Smith","creditCard.holderName.invalid":"Neva\u017ee\u0107e ime vlasnika kartice","creditCard.numberField.title":"Broj kartice","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"Datum isteka","creditCard.expiryDateField.placeholder":"MM/GG","creditCard.expiryDateField.month":"Mjesec","creditCard.expiryDateField.month.placeholder":"MM","creditCard.expiryDateField.year.placeholder":"GG","creditCard.expiryDateField.year":"Godina","creditCard.cvcField.title":"CVC/CVV","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"Zapamtiti za sljede\u0107i put","creditCard.cvcField.placeholder.4digits":"4 znamenke","creditCard.cvcField.placeholder.3digits":"3 znamenke","creditCard.taxNumber.placeholder":"YYMMDD / 0123456789",installments:"Broj rata",installmentOption:"%{times} x %{partialValue}",installmentOptionMonths:"Mjeseci: %{times}","installments.oneTime":"Jednokratno pla\u0107anje","installments.installments":"Pla\u0107anje na rate","installments.revolving":"Obnovljivo pla\u0107anje","sepaDirectDebit.ibanField.invalid":"Neva\u017ee\u0107i broj ra\u010duna","sepaDirectDebit.nameField.placeholder":"J. Smith","sepa.ownerName":"Ime vlasnika","sepa.ibanNumber":"Broj ra\u010duna (IBAN)","error.title":"Gre\u0161ka","error.subtitle.redirect":"Preusmjeravanje nije uspjelo","error.subtitle.payment":"Pla\u0107anje nije uspjelo","error.subtitle.refused":"Pla\u0107anje odbijeno","error.message.unknown":"Dogodila se nepoznata gre\u0161ka","errorPanel.title":"Postoje\u0107e gre\u0161ke","idealIssuer.selectField.title":"Banka","idealIssuer.selectField.placeholder":"Odaberite banku","creditCard.success":"Pla\u0107anje uspje\u0161no",loading:"U\u010ditavanje\u2026",continue:"Nastavi",continueTo:"Nastavi na","wechatpay.timetopay":"Imate %@ za pla\u0107anje","wechatpay.scanqrcode":"Skeniraj QR k\xf4d",personalDetails:"Osobni podatci",companyDetails:"Detalji tvrtke","companyDetails.name":"Naziv tvrtke","companyDetails.registrationNumber":"Mati\u010dni broj",socialSecurityNumber:"Broj socijalnog osiguranja",firstName:"Ime","firstName.invalid":"Ime nije valjano",infix:"Prefiks",lastName:"Prezime","lastName.invalid":"Prezime nije valjano",mobileNumber:"Broj mobilnog telefona","mobileNumber.invalid":"Neva\u017ee\u0107i broj mobilnog telefona",city:"Grad",postalCode:"Po\u0161tanski broj","postalCode.optional":"Po\u0161tanski broj (nije obvezno)",countryCode:"Pozivni broj dr\u017eave",telephoneNumber:"Telefonski broj",dateOfBirth:"Datum ro\u0111enja",shopperEmail:"Adresa e-po\u0161te",gender:"Spol",male:"Mu\u0161karac",female:"\u017dena",billingAddress:"Adresa za ra\u010dun",street:"Ulica",stateOrProvince:"Dr\u017eava ili pokrajina",country:"Zemlja",houseNumberOrName:"Ku\u0107ni broj",separateDeliveryAddress:"Navedite zasebnu adresu za dostavu",deliveryAddress:"Adresa za dostavu",zipCode:"Po\u0161tanski broj",apartmentSuite:"Stan/apartman",provinceOrTerritory:"Pokrajina ili teritorij",cityTown:"Grad",address:"Adresa",state:"Savezna dr\u017eava","field.title.optional":"(neobavezno)","creditCard.cvcField.title.optional":"CVC/CVV (nije obavezno)","issuerList.wallet.placeholder":"Odaberite svoju nov\u010danik",privacyPolicy:"Politika privatnosti","afterPay.agreement":"Sla\u017eem se s %@ usluge AfterPay",paymentConditions:"uvjetima pla\u0107anja",openApp:"Otvorite aplikaciju","voucher.readInstructions":"Pro\u010ditajte upute","voucher.introduction":"Zahvaljujemo na kupnji, upotrijebite sljede\u0107i kupon za dovr\u0161etak pla\u0107anja.","voucher.expirationDate":"Datum isteka","voucher.alternativeReference":"Alternativna referenca","dragonpay.voucher.non.bank.selectField.placeholder":"Odaberite davatelja usluge","dragonpay.voucher.bank.selectField.placeholder":"Odaberite banku","voucher.paymentReferenceLabel":"Referenca za pla\u0107anje","voucher.surcharge":"Uklju\u010duje %@ nadoplate","voucher.introduction.doku":"Zahvaljujemo na kupnji, upotrijebite sljede\u0107e podatke za dovr\u0161etak pla\u0107anja.","voucher.shopperName":"Ime kupca","voucher.merchantName":"Trgovac","voucher.introduction.econtext":"Zahvaljujemo na kupnji, upotrijebite sljede\u0107e podatke za dovr\u0161etak pla\u0107anja.","voucher.telephoneNumber":"Broj telefona","voucher.shopperReference":"Referenca kupca","voucher.collectionInstitutionNumber":"Broj ustanove za prikupljanje","voucher.econtext.telephoneNumber.invalid":"Telefonski broj mora imati 10 ili 11 znamenki","boletobancario.btnLabel":"Generiraj Boleto","boleto.sendCopyToEmail":"Po\u0161alji kopiju na moju e-po\u0161tu","button.copy":"Kopiraj","button.download":"Preuzmi","boleto.socialSecurityNumber.invalid":"Polje je neva\u017ee\u0107e","creditCard.storedCard.description.ariaLabel":"Pohranjena kartica zavr\u0161ava na %@","voucher.entity":"Entitet",donateButton:"Doniraj",notNowButton:"Ne sada",thanksForYourSupport:"Hvala na podr\u0161ci!",preauthorizeWith:"Prethodno odobri s",confirmPreauthorization:"Potvrdite prethodno odobrenje",confirmPurchase:"Potvrdite kupnju",applyGiftcard:"Iskoristite",giftcardBalance:"Stanje na poklon-kartici",deductedBalance:"Potro\u0161eni iznos","creditCard.pin.title":"Pin","creditCard.encryptedPassword.label":"Prve 2 znamenke lozinke kartice","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"Lozinka je neto\u010dna","creditCard.taxNumber":"Datum ro\u0111enja vlasnika kartice ili registracijski broj tvrtke","creditCard.taxNumber.label":"Datum ro\u0111enja vlasnika kartice (GGMMDD) ili registracijski broj tvrtke (10 znamenki)","creditCard.taxNumber.labelAlt":"Registracijski broj tvrtke (10 znamenki)","creditCard.taxNumber.invalid":"Neto\u010dan datum ro\u0111enja vlasnika kartice (GGMMDD) ili registracijski broj tvrtke (10 znamenki)","storedPaymentMethod.disable.button":"Ukloni","storedPaymentMethod.disable.confirmation":"Uklonite pohranjeni na\u010din pla\u0107anja","storedPaymentMethod.disable.confirmButton":"Da, ukloni","storedPaymentMethod.disable.cancelButton":"Otka\u017ei","ach.bankAccount":"Bankovni ra\u010dun","ach.accountHolderNameField.title":"Ime vlasnika ra\u010duna","ach.accountHolderNameField.placeholder":"J. Smith","ach.accountHolderNameField.invalid":"Neva\u017ee\u0107e ime vlasnika ra\u010duna","ach.accountNumberField.title":"Broj ra\u010duna","ach.accountNumberField.invalid":"Neva\u017ee\u0107i broj ra\u010duna","ach.accountLocationField.title":"ABA identifikacijski broj","ach.accountLocationField.invalid":"Neva\u017ee\u0107i ABA identifikacijski broj","ach.savedBankAccount":"Spremljeni bankovni ra\u010dun","select.state":"Odaberite saveznu dr\u017eavu","select.stateOrProvince":"Odaberite dr\u017eavu ili provinciju","select.provinceOrTerritory":"Odaberite provinciju ili teritorij","select.country":"Odaberite dr\u017eavu","select.noOptionsFound":"Nije prona\u0111ena nijedna opcija","select.filter.placeholder":"Tra\u017ei...","telephoneNumber.invalid":"Neva\u017ee\u0107i telefonski broj",qrCodeOrApp:"ili","paypal.processingPayment":"Obrada pla\u0107anja u tijeku...",generateQRCode:"Generirajte QR k\xf4d","await.waitForConfirmation":"\u010ceka se potvrda","mbway.confirmPayment":"Potvrdite uplatu u aplikaciji MB WAY","shopperEmail.invalid":"Neva\u017ee\u0107a adresa e-po\u0161te","dateOfBirth.format":"DD/MM/GGGG","dateOfBirth.invalid":"Morate imati najmanje 18 godina","blik.confirmPayment":"Otvorite svoju bankovnu aplikaciju kako biste potvrdili pla\u0107anje.","blik.invalid":"Unesite 6 znamenki","blik.code":"6-znamenkasti k\xf4d","blik.help":"Preuzmite k\xf4d iz bankovne aplikacije.","swish.pendingMessage":"Nakon skeniranja status mo\u017ee biti na \u010dekanju do 10 minuta. Poku\u0161aj ponovnog pla\u0107anja u istom periodu mo\u017ee rezultirati vi\u0161estrukim naplatama.","field.valid":"Valjano polje","field.invalid":"Neva\u017ee\u0107e polje","error.va.gen.01":"Nepotpuno polje","error.va.gen.02":"Neva\u017ee\u0107e polje","error.va.sf-cc-num.01":"Nevaljan broj kartice","error.va.sf-cc-num.02":"Polje za broj kartice je prazno","error.va.sf-cc-num.03":"Upisan nepodr\u017eani broj kartice","error.va.sf-cc-num.04":"Broj je kartice pogre\u0161ne duljine","error.va.sf-cc-dat.01":"Datum isteka: kartica prestara","error.va.sf-cc-dat.02":"Datum isteka: datum je predaleko u budu\u0107nosti","error.va.sf-cc-dat.03":"Datum isteka: va\u0161a kartica isti\u010de prije datuma odjave","error.va.sf-cc-dat.04":"Polje za datum isteka je prazno","error.va.sf-cc-dat.05":"Datum je isteka pogre\u0161ne duljine","error.va.sf-cc-mth.01":"Polje za mjesec isteka je prazno","error.va.sf-cc-yr.01":"Polje za godinu isteka je prazno","error.va.sf-cc-yr.02":"Godina je isteka pogre\u0161ne duljine","error.va.sf-cc-cvc.01":"Polje je sigurnosnog k\xf4da prazno","error.va.sf-cc-cvc.02":"Sigurnosni je k\xf4d pogre\u0161ne duljine","error.va.sf-ach-num.01":"Polje za broj bankovnog ra\u010duna je prazno","error.va.sf-ach-num.02":"Broj je bankovnog ra\u010duna pogre\u0161ne duljine","error.va.sf-ach-loc.01":"Polje je broja usmjeravanja prazno","error.va.sf-ach-loc.02":"Broj je usmjeravanja pogre\u0161ne duljine","error.va.sf-kcp-pwd.01":"Polje je lozinke prazno","error.va.sf-kcp-pwd.02":"Lozinka je pogre\u0161ne duljine","error.giftcard.no-balance":"Stanje na ovoj poklon-kartici iznosi nula","error.giftcard.card-error":"U na\u0161oj evidenciji nemamo poklon-karticu s ovim brojem","error.giftcard.currency-error":"Poklon-kartice vrijede samo u valuti u kojoj su izdane","amazonpay.signout":"Odjava iz Amazona","amazonpay.changePaymentDetails":"Promijenite pojedinosti o pla\u0107anju","partialPayment.warning":"Odaberite drugi na\u010din pla\u0107anja da biste platili preostali iznos","partialPayment.remainingBalance":"Preostalo stanje na ra\u010dunu iznosit \u0107e %{amount}","bankTransfer.beneficiary":"Primatelj","bankTransfer.iban":"IBAN","bankTransfer.bic":"BIC","bankTransfer.reference":"Referenca","bankTransfer.introduction":"Nastavite da biste kreirali novu uplatu putem bankovne transakcije. Za finaliziranje ovog pla\u0107anja mo\u017eete se koristiti pojedinostima na sljede\u0107em zaslonu.","bankTransfer.instructions":"Zahvaljujemo na kupnji, upotrijebite sljede\u0107e podatke za dovr\u0161etak pla\u0107anja.","bacs.accountHolderName":"Ime vlasnika bankovnog ra\u010duna","bacs.accountHolderName.invalid":"Neva\u017ee\u0107e ime vlasnika bankovnog ra\u010duna","bacs.accountNumber":"Broj bankovnog ra\u010duna","bacs.accountNumber.invalid":"Neva\u017ee\u0107i broj bankovnog ra\u010duna","bacs.bankLocationId":"Identifikacijski k\xf4d banke (UK)","bacs.bankLocationId.invalid":"Neva\u017ee\u0107i identifikacijski k\xf4d banke (UK)","bacs.consent.amount":"Sla\u017eem se da se gore navedeni iznos oduzme s mog bankovnog ra\u010duna.","bacs.consent.account":"Potvr\u0111ujem da je ra\u010dun na moje ime i da sam jedini potpisnik potreban za autorizaciju izravnog tere\u0107enja na ovom ra\u010dunu.",edit:"Uredi","bacs.confirm":"Potvrdi i plati","bacs.result.introduction":"Preuzmite upute za izravno tere\u0107enje (DDI / mandat)","download.pdf":"Preuzmite PDF","creditCard.encryptedCardNumber.aria.iframeTitle":"Iframe za broj prepaid kartice","creditCard.encryptedCardNumber.aria.label":"Broj kartice","creditCard.encryptedExpiryDate.aria.iframeTitle":"Iframe za datum isteka prepaid kartice","creditCard.encryptedExpiryDate.aria.label":"Datum isteka","creditCard.encryptedExpiryMonth.aria.iframeTitle":"Iframe za mjesec isteka prepaid kartice","creditCard.encryptedExpiryMonth.aria.label":"Mjesec isteka","creditCard.encryptedExpiryYear.aria.iframeTitle":"Iframe za godinu isteka prepaid kartice","creditCard.encryptedExpiryYear.aria.label":"Godina isteka","creditCard.encryptedSecurityCode.aria.iframeTitle":"Iframe za sigurnosni k\xf4d prepaid kartice","creditCard.encryptedSecurityCode.aria.label":"Sigurnosni k\xf4d","creditCard.encryptedPassword.aria.iframeTitle":"Iframe za sigurnu lozinku kartice","creditCard.encryptedPassword.aria.label":"Prve 2 znamenke lozinke kartice","giftcard.encryptedCardNumber.aria.iframeTitle":"Iframe za broj prepaid poklon-kartice","giftcard.encryptedCardNumber.aria.label":"Broj poklon-kartice","giftcard.encryptedSecurityCode.aria.iframeTitle":"Iframe za sigurnosni k\xf4d prepaid poklon-kartice","giftcard.encryptedSecurityCode.aria.label":"Sigurnosni k\xf4d poklon-kartice",giftcardTransactionLimit:"Na ovoj je poklon-kartici maks. dopu\u0161teno %{amount} po transakciji","ach.encryptedBankAccountNumber.aria.iframeTitle":"Iframe za prepaid broj bankovnog ra\u010duna","ach.encryptedBankAccountNumber.aria.label":"Bankovni ra\u010dun","ach.encryptedBankLocationId.aria.iframeTitle":"Iframe za identifikacijski broj prepaid banke","ach.encryptedBankLocationId.aria.label":"Identifikacijski broj banke","twint.saved":"spremljeno",orPayWith:"ili platite s",invalidFormatExpects:"Neva\u017ee\u0107i format. O\u010dekivani format: %{format}","upi.qrCodeWaitingMessage":"Skenirajte QR k\xf4d pomo\u0107u \u017eeljene UPI aplikacije kako biste dovr\u0161ili pla\u0107anje","upi.vpaWaitingMessage":"Otvorite svoju UPI aplikaciju kako biste potvrdili pla\u0107anje","upi.modeSelection":"Odaberite kako \u017eelite koristiti UPI.","onlineBanking.termsAndConditions":"Nastavkom prihva\u0107ate %#uvjete i odredbe%#","ctp.loading.poweredByCtp":"Pokre\u0107e se uslugom Click to Pay","ctp.loading.intro":"Provjeravamo imate li spremljenih kartica u sklopu usluge Click to Pay...","ctp.login.title":"Nastavite na uslugu Click to Pay","ctp.login.subtitle":"Za nastavak upi\u0161ite adresu e-po\u0161te koja je povezana s uslugom Click to Pay.","ctp.login.inputLabel":"E-po\u0161ta","ctp.logout.notYou":"Niste vi?","ctp.logout.notYourCards":"Nisu va\u0161e kartice?","ctp.logout.notYourCard":"Nije va\u0161a kartica?","ctp.logout.notYourProfile":"Nije va\u0161 profil?","ctp.otp.fieldLabel":"Jednokratni k\xf4d","ctp.otp.resendCode":"Ponovno po\u0161alji k\xf4d","ctp.otp.codeResent":"K\xf4d je ponovno poslan","ctp.otp.title":"Pristupite svojim karticama za uslugu Click to Pay","ctp.otp.subtitle":"Upi\u0161ite k\xf4d %@ koji smo poslali na %@ da bismo potvrdili da ste to vi.","ctp.emptyProfile.message":"Nema kartica registriranih u sklopu ovog profila usluge Click to Pay","ctp.separatorText":"ili upotrijebite","ctp.cards.title":"Dovr\u0161i pla\u0107anje uslugom Click to Pay","ctp.cards.subtitle":"Odaberite karticu za upotrebu.","ctp.cards.expiredCard":"Istekla","ctp.manualCardEntry":"Ru\u010dni upis kartice","ctp.aria.infoModalButton":"\u0160to je usluga Click to Pay","ctp.infoPopup.title":"Uslugom Click to Pay nudi se jednostavnost mre\u017enog beskontaktnog pla\u0107anja","ctp.infoPopup.subtitle":"Brza i sigurna metoda pla\u0107anja koja se podr\u017eava platnim karticama Mastercard, Visa i drugim.","ctp.infoPopup.benefit1":"Uslugom Click to Pay upotrebljava se \u0161ifriranje da bi va\u0161i podatci bili sigurni i za\u0161ti\u0107eni","ctp.infoPopup.benefit2":"Upotrebljavajte je za trgovce diljem svijeta","ctp.infoPopup.benefit3":"Postavljanje obavite samo jednom za nesmetana pla\u0107anja u budu\u0107nosti","ctp.errors.AUTH_INVALID":"Neva\u017ee\u0107a provjera autenti\u010dnosti","ctp.errors.NOT_FOUND":"Ra\u010dun nije prona\u0111en, upi\u0161ite valjanu adresu e-po\u0161te ili nastavite s ru\u010dnim upisom kartice","ctp.errors.ID_FORMAT_UNSUPPORTED":"Nepodr\u017ean format","ctp.errors.FRAUD":"Korisni\u010dki je ra\u010dun zaklju\u010dan ili onemogu\u0107en","ctp.errors.CONSUMER_ID_MISSING":"Identitet potro\u0161a\u010da nedostaje u zahtjevu","ctp.errors.ACCT_INACCESSIBLE":"Ovaj ra\u010dun trenuta\u010dno nije dostupan, npr. zaklju\u010dan je","ctp.errors.CODE_INVALID":"Neispravan kontrolni k\xf4d","ctp.errors.CODE_EXPIRED":"Ovaj je k\xf4d istekao","ctp.errors.RETRIES_EXCEEDED":"Prekora\u010deno je ograni\u010denje broja ponovnih poku\u0161aja za stvaranje jednokratne lozinke","ctp.errors.OTP_SEND_FAILED":"Jednokratna se lozinka nije mogla poslati primatelju","ctp.errors.REQUEST_TIMEOUT":"Ne\u0161to nije u redu, poku\u0161ajte ponovno ili upotrijebite ru\u010dni upis kartice","ctp.errors.UNKNOWN_ERROR":"Ne\u0161to nije u redu, poku\u0161ajte ponovno ili upotrijebite ru\u010dni upis kartice","ctp.errors.SERVICE_ERROR":"Ne\u0161to nije u redu, poku\u0161ajte ponovno ili upotrijebite ru\u010dni upis kartice","ctp.errors.SERVER_ERROR":"Ne\u0161to nije u redu, poku\u0161ajte ponovno ili upotrijebite ru\u010dni upis kartice","ctp.errors.INVALID_PARAMETER":"Ne\u0161to nije u redu, poku\u0161ajte ponovno ili upotrijebite ru\u010dni upis kartice","ctp.errors.AUTH_ERROR":"Ne\u0161to nije u redu, poku\u0161ajte ponovno ili upotrijebite ru\u010dni upis kartice","paymentMethodsList.aria.label":"Odaberi na\u010din pla\u0107anja"}}),E3=Object.freeze({__proto__:null,default:{payButton:"Fizet\xe9s","payButton.redirecting":"\xc1tir\xe1ny\xedt\xe1s...","payButton.with":"%{value} fizet\xe9se a k\xf6vetkez\u0151vel: %{maskedData}",close:"Bez\xe1r\xe1s",storeDetails:"Ment\xe9s a k\xf6vetkez\u0151 fizet\xe9shez","creditCard.holderName":"A k\xe1rty\xe1n szerepl\u0151 n\xe9v","creditCard.holderName.placeholder":"Gipsz Jakab","creditCard.holderName.invalid":"A k\xe1rtyatulajdonos neve \xe9rv\xe9nytelen","creditCard.numberField.title":"K\xe1rtyasz\xe1m","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"Lej\xe1rati d\xe1tum","creditCard.expiryDateField.placeholder":"HH/\xc9\xc9","creditCard.expiryDateField.month":"H\xf3nap","creditCard.expiryDateField.month.placeholder":"HH","creditCard.expiryDateField.year.placeholder":"\xc9\xc9","creditCard.expiryDateField.year":"\xc9v","creditCard.cvcField.title":"CVC/CVV","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"Megjegyz\xe9s a k\xf6vetkez\u0151 alkalomra","creditCard.cvcField.placeholder.4digits":"4 sz\xe1mjegy\u0171","creditCard.cvcField.placeholder.3digits":"3 sz\xe1mjegy\u0171","creditCard.taxNumber.placeholder":"\xc9\xc9HHNN / 0123456789",installments:"R\xe9szletek sz\xe1ma",installmentOption:"%{times} x %{partialValue}",installmentOptionMonths:"%{times} h\xf3nap","installments.oneTime":"Egy\xf6sszeg\u0171 fizet\xe9s","installments.installments":"R\xe9szletfizet\xe9s","installments.revolving":"T\xf6bb\xf6sszeg\u0171 fizet\xe9s","sepaDirectDebit.ibanField.invalid":"\xc9rv\xe9nytelen sz\xe1mlasz\xe1m","sepaDirectDebit.nameField.placeholder":"Gipsz Jakab","sepa.ownerName":"Sz\xe1mlatulajdonos neve","sepa.ibanNumber":"Sz\xe1mlasz\xe1m (IBAN)","error.title":"Hiba","error.subtitle.redirect":"Sikertelen \xe1tir\xe1ny\xedt\xe1s","error.subtitle.payment":"Sikertelen fizet\xe9s","error.subtitle.refused":"A fizet\xe9s elutas\xedtva","error.message.unknown":"Ismeretlen hiba t\xf6rt\xe9nt","errorPanel.title":"Megl\xe9v\u0151 hib\xe1k","idealIssuer.selectField.title":"Bank","idealIssuer.selectField.placeholder":"Bank kiv\xe1laszt\xe1sa","creditCard.success":"Sikeres fizet\xe9s",loading:"Bet\xf6lt\xe9s\u2026",continue:"Folytat\xe1s",continueTo:"Folytat\xe1s a k\xf6vetkez\u0151vel:","wechatpay.timetopay":"Fizet\xe9shez rendelkez\xe9sre \xe1ll\xf3 id\u0151: %@","wechatpay.scanqrcode":"QR-k\xf3d beolvas\xe1sa",personalDetails:"Szem\xe9lyes adatok",companyDetails:"C\xe9g adatai","companyDetails.name":"C\xe9gn\xe9v","companyDetails.registrationNumber":"C\xe9gjegyz\xe9ksz\xe1m",socialSecurityNumber:"Szem\xe9lyi igazolv\xe1ny sz\xe1ma",firstName:"Keresztn\xe9v","firstName.invalid":"A keresztn\xe9v nem \xe9rv\xe9nyes",infix:"El\u0151tag",lastName:"Vezet\xe9kn\xe9v","lastName.invalid":"A vezet\xe9kn\xe9v nem \xe9rv\xe9nyes",mobileNumber:"Mobiltelefonsz\xe1m","mobileNumber.invalid":"\xc9rv\xe9nytelen mobilsz\xe1m",city:"V\xe1ros",postalCode:"Ir\xe1ny\xedt\xf3sz\xe1m","postalCode.optional":"Ir\xe1ny\xedt\xf3sz\xe1m (nem k\xf6telez\u0151)",countryCode:"Orsz\xe1gk\xf3d",telephoneNumber:"Telefonsz\xe1m",dateOfBirth:"Sz\xfclet\xe9si d\xe1tum",shopperEmail:"E-mail-c\xedm",gender:"Nem",male:"F\xe9rfi",female:"N\u0151",billingAddress:"Sz\xe1ml\xe1z\xe1si c\xedm",street:"Utca",stateOrProvince:"\xc1llam vagy tartom\xe1ny",country:"Orsz\xe1g",houseNumberOrName:"H\xe1zsz\xe1m",separateDeliveryAddress:"Elt\xe9r\u0151 sz\xe1ll\xedt\xe1si c\xedm megad\xe1sa",deliveryAddress:"Sz\xe1ll\xedt\xe1si c\xedm",zipCode:"Ir\xe1ny\xedt\xf3sz\xe1m",apartmentSuite:"Lak\xe1s/ajt\xf3sz\xe1m",provinceOrTerritory:"Tartom\xe1ny vagy ter\xfclet",cityTown:"V\xe1ros",address:"C\xedm",state:"\xc1llam","field.title.optional":"(nem k\xf6telez\u0151)","creditCard.cvcField.title.optional":"CVC/CVV (opcion\xe1lis)","issuerList.wallet.placeholder":"P\xe9nzt\xe1rca kiv\xe1laszt\xe1sa",privacyPolicy:"Adatv\xe9delmi szab\xe1lyzat","afterPay.agreement":"Elfogadom az AfterPay %@",paymentConditions:"fizet\xe9si felt\xe9teleit",openApp:"Alkalmaz\xe1s megnyit\xe1sa","voucher.readInstructions":"Olvassa el az utas\xedt\xe1sokat","voucher.introduction":"K\xf6sz\xf6nj\xfck a v\xe1s\xe1rl\xe1st! K\xe9rj\xfck, a fizet\xe9shez haszn\xe1lja a k\xf6vetkez\u0151 kupont.","voucher.expirationDate":"Lej\xe1rati d\xe1tum","voucher.alternativeReference":"Alternat\xedv hivatkoz\xe1s","dragonpay.voucher.non.bank.selectField.placeholder":"Szolg\xe1ltat\xf3 kiv\xe1laszt\xe1sa","dragonpay.voucher.bank.selectField.placeholder":"Bank kiv\xe1laszt\xe1sa","voucher.paymentReferenceLabel":"Fizet\xe9si referencia","voucher.surcharge":"%@ p\xf3td\xedjat tartalmaz","voucher.introduction.doku":"K\xf6sz\xf6nj\xfck a v\xe1s\xe1rl\xe1st! K\xe9rj\xfck, a fizet\xe9shez haszn\xe1lja a k\xf6vetkez\u0151 inform\xe1ci\xf3t.","voucher.shopperName":"V\xe1s\xe1rl\xf3 neve","voucher.merchantName":"Keresked\u0151","voucher.introduction.econtext":"K\xf6sz\xf6nj\xfck a v\xe1s\xe1rl\xe1st! K\xe9rj\xfck, a fizet\xe9shez haszn\xe1lja a k\xf6vetkez\u0151 inform\xe1ci\xf3t.","voucher.telephoneNumber":"Telefonsz\xe1m","voucher.shopperReference":"V\xe1s\xe1rl\xf3i referencia","voucher.collectionInstitutionNumber":"Beszed\u0151 c\xe9g sz\xe1ma","voucher.econtext.telephoneNumber.invalid":"A telefonsz\xe1mnak 10 vagy 11 sz\xe1mjegyb\u0151l kell \xe1llnia","boletobancario.btnLabel":"Boleto l\xe9trehoz\xe1sa","boleto.sendCopyToEmail":"M\xe1solat k\xfcld\xe9se az e-mail-c\xedmemre","button.copy":"M\xe1sol\xe1s","button.download":"Let\xf6lt\xe9s","boleto.socialSecurityNumber.invalid":"\xc9rv\xe9nytelen mez\u0151","creditCard.storedCard.description.ariaLabel":"A t\xe1rolt k\xe1rtya sz\xe1m\xe1nak v\xe9gz\u0151d\xe9se: %@","voucher.entity":"Entit\xe1s",donateButton:"Adom\xe1nyoz\xe1s",notNowButton:"Most nem",thanksForYourSupport:"K\xf6sz\xf6nj\xfck a t\xe1mogat\xe1s\xe1t!",preauthorizeWith:"El\u0151zetes meghatalmaz\xe1s a k\xf6vetkez\u0151vel:",confirmPreauthorization:"El\u0151zetes meghatalmaz\xe1s j\xf3v\xe1hagy\xe1sa",confirmPurchase:"Fizet\xe9s j\xf3v\xe1hagy\xe1sa",applyGiftcard:"Bev\xe1lt\xe1s",giftcardBalance:"Aj\xe1nd\xe9kk\xe1rtya egyenlege",deductedBalance:"Levont egyenleg","creditCard.pin.title":"PIN-k\xf3d","creditCard.encryptedPassword.label":"K\xe1rtya jelszav\xe1nak els\u0151 2 sz\xe1mjegye","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"\xc9rv\xe9nytelen jelsz\xf3","creditCard.taxNumber":"K\xe1rtyatulajdonos sz\xfclet\xe9si d\xe1tuma vagy c\xe9gjegyz\xe9ksz\xe1m","creditCard.taxNumber.label":"K\xe1rtyatulajdonos sz\xfclet\xe9si d\xe1tuma (\xc9\xc9HHNN) vagy c\xe9gjegyz\xe9ksz\xe1m (10 sz\xe1mjegy\u0171)","creditCard.taxNumber.labelAlt":"C\xe9gjegyz\xe9ksz\xe1m (10 sz\xe1mjegy\u0171)","creditCard.taxNumber.invalid":"A k\xe1rtyatulajdonos sz\xfclet\xe9si d\xe1tuma vagy a c\xe9gjegyz\xe9ksz\xe1m \xe9rv\xe9nytelen","storedPaymentMethod.disable.button":"Elt\xe1vol\xedt\xe1s","storedPaymentMethod.disable.confirmation":"T\xe1rolt fizet\xe9si m\xf3d elt\xe1vol\xedt\xe1sa","storedPaymentMethod.disable.confirmButton":"Igen, elt\xe1vol\xedtom","storedPaymentMethod.disable.cancelButton":"M\xe9gse","ach.bankAccount":"Banksz\xe1mla","ach.accountHolderNameField.title":"Sz\xe1mlatulajdonos neve","ach.accountHolderNameField.placeholder":"Gipsz Jakab","ach.accountHolderNameField.invalid":"A sz\xe1mlatulajdonos neve \xe9rv\xe9nytelen","ach.accountNumberField.title":"Sz\xe1mlasz\xe1m","ach.accountNumberField.invalid":"\xc9rv\xe9nytelen sz\xe1mlasz\xe1m","ach.accountLocationField.title":"ABA-ir\xe1ny\xedt\xf3sz\xe1m","ach.accountLocationField.invalid":"\xc9rv\xe9nytelen ABA-ir\xe1ny\xedt\xf3sz\xe1m","ach.savedBankAccount":"Mentett banksz\xe1mla","select.state":"\xc1llam kiv\xe1laszt\xe1sa","select.stateOrProvince":"\xc1llam vagy tartom\xe1ny kiv\xe1laszt\xe1sa","select.provinceOrTerritory":"Tartom\xe1ny vagy ter\xfclet kiv\xe1laszt\xe1sa","select.country":"Orsz\xe1g kiv\xe1laszt\xe1sa","select.noOptionsFound":"Nincsenek tal\xe1latok","select.filter.placeholder":"Keres\xe9s...","telephoneNumber.invalid":"\xc9rv\xe9nytelen telefonsz\xe1m",qrCodeOrApp:"vagy","paypal.processingPayment":"Fizet\xe9s feldolgoz\xe1sa\u2026",generateQRCode:"QR-k\xf3d l\xe9trehoz\xe1sa","await.waitForConfirmation":"V\xe1rakoz\xe1s a j\xf3v\xe1hagy\xe1sra","mbway.confirmPayment":"Fizet\xe9s j\xf3v\xe1hagy\xe1sa az MB WAY alkalmaz\xe1sban","shopperEmail.invalid":"\xc9rv\xe9nytelen e-mail-c\xedm","dateOfBirth.format":"NN/HH/\xc9\xc9\xc9\xc9","dateOfBirth.invalid":"Legal\xe1bb 18 \xe9vesnek kell lennie","blik.confirmPayment":"A fizet\xe9s j\xf3v\xe1hagy\xe1s\xe1hoz nyissa meg a banki alkalmaz\xe1st.","blik.invalid":"Adjon meg 6 sz\xe1mjegyet","blik.code":"6 sz\xe1mjegy\u0171 k\xf3d","blik.help":"K\xf3d lek\xe9r\xe9se a banki alkalmaz\xe1sb\xf3l.","swish.pendingMessage":"A QR-k\xf3d beolvas\xe1s\xe1t k\xf6vet\u0151en az \xe1llapot ak\xe1r 10 percig is f\xfcgg\u0151ben lehet. Ha ek\xf6zben \xfajb\xf3l fizet\xe9st k\xeds\xe9rel meg, az t\xf6bbsz\xf6ri fizet\xe9st eredm\xe9nyezhet.","field.valid":"\xc9rv\xe9nyes mez\u0151","field.invalid":"\xc9rv\xe9nytelen mez\u0151","error.va.gen.01":"Hi\xe1nyos mez\u0151","error.va.gen.02":"\xc9rv\xe9nytelen mez\u0151","error.va.sf-cc-num.01":"\xc9rv\xe9nytelen k\xe1rtyasz\xe1m","error.va.sf-cc-num.02":"\xdcres k\xe1rtyasz\xe1mmez\u0151","error.va.sf-cc-num.03":"A megadott k\xe1rtyasz\xe1m nem t\xe1mogatott","error.va.sf-cc-num.04":"A k\xe1rtyasz\xe1m nem megfelel\u0151 hossz\xfas\xe1g\xfa","error.va.sf-cc-dat.01":"Lej\xe1rati d\xe1tum: a k\xe1rtya t\xfal r\xe9gi","error.va.sf-cc-dat.02":"Lej\xe1rati d\xe1tum: t\xfal messzi j\xf6v\u0151beli d\xe1tum","error.va.sf-cc-dat.03":"Lej\xe1rati d\xe1tum: a k\xe1rtya lej\xe1r a fizet\xe9s d\xe1tum el\u0151tt","error.va.sf-cc-dat.04":"A lej\xe1rati d\xe1tum mez\u0151je \xfcres","error.va.sf-cc-dat.05":"A lej\xe1rati d\xe1tum nem megfelel\u0151 hossz\xfas\xe1g\xfa","error.va.sf-cc-mth.01":"A lej\xe1rati h\xf3nap mez\u0151je \xfcres","error.va.sf-cc-yr.01":"A lej\xe1rati \xe9v mez\u0151je \xfcres","error.va.sf-cc-yr.02":"A lej\xe1rati \xe9v nem megfelel\u0151 hossz\xfas\xe1g\xfa","error.va.sf-cc-cvc.01":"A biztons\xe1gi k\xf3d mez\u0151je \xfcres","error.va.sf-cc-cvc.02":"A biztons\xe1gi k\xf3d nem megfelel\u0151 hossz\xfas\xe1g\xfa","error.va.sf-ach-num.01":"A banksz\xe1mlasz\xe1m mez\u0151je \xfcres","error.va.sf-ach-num.02":"A banksz\xe1mlasz\xe1m nem megfelel\u0151 hossz\xfas\xe1g\xfa","error.va.sf-ach-loc.01":"A bankazonos\xedt\xf3 k\xf3d mez\u0151je \xfcres","error.va.sf-ach-loc.02":"A bankazonos\xedt\xf3 k\xf3d nem megfelel\u0151 hossz\xfas\xe1g\xfa","error.va.sf-kcp-pwd.01":"A jelsz\xf3 mez\u0151je \xfcres","error.va.sf-kcp-pwd.02":"A jelsz\xf3 nem megfelel\u0151 hossz\xfas\xe1g\xfa","error.giftcard.no-balance":"Az aj\xe1nd\xe9kk\xe1rtya egyenlege nulla","error.giftcard.card-error":"Nyilv\xe1ntart\xe1sunkban nem szerepel ilyen sz\xe1m\xfa aj\xe1nd\xe9kk\xe1rtya","error.giftcard.currency-error":"Az aj\xe1nd\xe9kk\xe1rty\xe1k csak abban a p\xe9nznemben \xe9rv\xe9nyesek, amelyre ki\xe1ll\xedtott\xe1k azokat","amazonpay.signout":"Kijelentkez\xe9s az Amazonr\xf3l","amazonpay.changePaymentDetails":"Fizet\xe9si adatok m\xf3dos\xedt\xe1sa","partialPayment.warning":"M\xe1sik fizet\xe9si m\xf3d v\xe1laszt\xe1sa a fennmarad\xf3 r\xe9sz fizet\xe9s\xe9hez","partialPayment.remainingBalance":"A fennmarad\xf3 egyenleg %{amount} lesz","bankTransfer.beneficiary":"Kedvezm\xe9nyezett","bankTransfer.iban":"IBAN","bankTransfer.bic":"BIC","bankTransfer.reference":"Referencia","bankTransfer.introduction":"Folytassa, hogy elind\xedtson egy \xfaj banki \xe1tutal\xe1sos fizet\xe9st. A fizet\xe9s v\xe9gleges\xedt\xe9s\xe9hez felhaszn\xe1lhatja a k\xf6vetkez\u0151 k\xe9perny\u0151n megjelen\u0151 adatokat.","bankTransfer.instructions":"K\xf6sz\xf6nj\xfck a v\xe1s\xe1rl\xe1st! K\xe9rj\xfck, a fizet\xe9shez haszn\xe1lja a k\xf6vetkez\u0151 inform\xe1ci\xf3t.","bacs.accountHolderName":"Banksz\xe1mla-tulajdonos neve","bacs.accountHolderName.invalid":"A banksz\xe1mla-tulajdonos neve \xe9rv\xe9nytelen","bacs.accountNumber":"Banksz\xe1mlasz\xe1m","bacs.accountNumber.invalid":"\xc9rv\xe9nytelen banksz\xe1mlasz\xe1m","bacs.bankLocationId":"Banki azonos\xedt\xf3","bacs.bankLocationId.invalid":"\xc9rv\xe9nytelen banki azonos\xedt\xf3","bacs.consent.amount":"Elfogadom, hogy a fenti \xf6sszeget levonj\xe1k a banksz\xe1ml\xe1mr\xf3l.","bacs.consent.account":"Meger\u0151s\xedtem, hogy a banksz\xe1mla az \xe9n nevemen van, \xe9s \xe9n vagyok a banksz\xe1ml\xe1t \xe9rint\u0151 beszed\xe9si megb\xedz\xe1s j\xf3v\xe1hagy\xe1s\xe1hoz sz\xfcks\xe9ges egyetlen al\xe1\xedr\xf3.",edit:"Szerkeszt\xe9s","bacs.confirm":"Meger\u0151s\xedt\xe9s \xe9s fizet\xe9s","bacs.result.introduction":"Beszed\xe9si megb\xedz\xe1si utas\xedt\xe1s (meghatalmaz\xe1s) let\xf6lt\xe9se","download.pdf":"PDF let\xf6lt\xe9se","creditCard.encryptedCardNumber.aria.iframeTitle":"Iframe a biztons\xe1gos k\xe1rtyasz\xe1mhoz","creditCard.encryptedCardNumber.aria.label":"K\xe1rtyasz\xe1m","creditCard.encryptedExpiryDate.aria.iframeTitle":"Iframe a biztons\xe1gos k\xe1rtyalej\xe1rati d\xe1tumhoz","creditCard.encryptedExpiryDate.aria.label":"Lej\xe1rati d\xe1tum","creditCard.encryptedExpiryMonth.aria.iframeTitle":"Iframe a biztons\xe1gos k\xe1rtyalej\xe1rati h\xf3naphoz","creditCard.encryptedExpiryMonth.aria.label":"Lej\xe1rati h\xf3nap","creditCard.encryptedExpiryYear.aria.iframeTitle":"Iframe a biztons\xe1gos k\xe1rtyalej\xe1rati \xe9vhez","creditCard.encryptedExpiryYear.aria.label":"Lej\xe1rati \xe9v","creditCard.encryptedSecurityCode.aria.iframeTitle":"Iframe a biztons\xe1gos k\xe1rtyabiztons\xe1gi k\xf3dhoz","creditCard.encryptedSecurityCode.aria.label":"Biztons\xe1gi k\xf3d","creditCard.encryptedPassword.aria.iframeTitle":"Iframe a biztons\xe1gos k\xe1rtyajelsz\xf3hoz","creditCard.encryptedPassword.aria.label":"K\xe1rtya jelszav\xe1nak els\u0151 2 sz\xe1mjegye","giftcard.encryptedCardNumber.aria.iframeTitle":"Iframe a biztons\xe1gos aj\xe1nd\xe9kk\xe1rtyasz\xe1mhoz","giftcard.encryptedCardNumber.aria.label":"Aj\xe1nd\xe9kk\xe1rtyasz\xe1m","giftcard.encryptedSecurityCode.aria.iframeTitle":"Iframe a biztons\xe1gos aj\xe1nd\xe9kk\xe1rtya biztons\xe1gi k\xf3dhoz","giftcard.encryptedSecurityCode.aria.label":"Aj\xe1nd\xe9kk\xe1rtya biztons\xe1gi k\xf3dja",giftcardTransactionLimit:"Ezen az aj\xe1nd\xe9kk\xe1rty\xe1n a tranzakci\xf3nk\xe9nt enged\xe9lyezett maxim\xe1lis \xf6sszeg %{amount}","ach.encryptedBankAccountNumber.aria.iframeTitle":"Iframe a biztons\xe1gos banksz\xe1mlasz\xe1mhoz","ach.encryptedBankAccountNumber.aria.label":"Banksz\xe1mla","ach.encryptedBankLocationId.aria.iframeTitle":"Iframe a biztons\xe1gos bankazonos\xedt\xf3 k\xf3dhoz","ach.encryptedBankLocationId.aria.label":"Bankazonos\xedt\xf3 k\xf3d","twint.saved":"mentve",orPayWith:"vagy fizessen ezzel:",invalidFormatExpects:"\xc9rv\xe9nytelen form\xe1tum. V\xe1rt form\xe1tum: %{format}","upi.qrCodeWaitingMessage":"A fizet\xe9s befejez\xe9s\xe9hez olvassa be a QR-k\xf3dot a k\xedv\xe1nt UPI-alkalmaz\xe1ssal","upi.vpaWaitingMessage":"A fizet\xe9s meger\u0151s\xedt\xe9s\xe9hez nyissa meg UPI-alkalmaz\xe1st","upi.modeSelection":"Jel\xf6lje meg, hogyan szeretn\xe9 haszn\xe1lni az UPI-t.","onlineBanking.termsAndConditions":"A folytat\xe1ssal elfogadja az %#\xe1ltal\xe1nos szerz\u0151d\xe9si felt\xe9teleket%#","ctp.loading.poweredByCtp":"Szolg\xe1ltat\xf3: Click to Pay","ctp.loading.intro":"Ellen\u0151rizz\xfck, hogy van-e mentett Click\xa0to\xa0Pay-k\xe1rty\xe1ja\u2026","ctp.login.title":"Tov\xe1bb a Click to Pay fel\xfclet\xe9re","ctp.login.subtitle":"A folytat\xe1shoz adja meg a Click to Payhez kapcsol\xf3d\xf3 e-mail-c\xedmet.","ctp.login.inputLabel":"E-mail-c\xedm","ctp.logout.notYou":"Nem \xd6n az?","ctp.logout.notYourCards":"Nem az \xd6n k\xe1rty\xe1i?","ctp.logout.notYourCard":"Nem az \xd6n k\xe1rty\xe1ja?","ctp.logout.notYourProfile":"Nem az \xd6n profilja?","ctp.otp.fieldLabel":"Egyszeri k\xf3d","ctp.otp.resendCode":"K\xf3d \xfajrak\xfcld\xe9se","ctp.otp.codeResent":"K\xf3d \xfajrak\xfcldve","ctp.otp.title":"Hozz\xe1f\xe9r\xe9s a Click to Pay-k\xe1rty\xe1ihoz","ctp.otp.subtitle":"\xcdrja be a k\xf3dot, amit a(z) %@ k\xfcld\xf6tt %@ r\xe9sz\xe9re ellen\u0151rz\xe9s c\xe9lj\xe1b\xf3l.","ctp.emptyProfile.message":"Ebben a Click to Pay-profilban nincs regisztr\xe1lt k\xe1rtya","ctp.separatorText":"vagy haszn\xe1lja a k\xf6vetkez\u0151t","ctp.cards.title":"Fizet\xe9s Click to Pay haszn\xe1lat\xe1val","ctp.cards.subtitle":"V\xe1lassza ki a haszn\xe1lni k\xedv\xe1nt k\xe1rty\xe1t.","ctp.cards.expiredCard":"Lej\xe1rt","ctp.manualCardEntry":"K\xe1rtya adatainak k\xe9zi megad\xe1sa","ctp.aria.infoModalButton":"Mi az a Click to Pay","ctp.infoPopup.title":"A Click to Pay megk\xf6nny\xedti az \xe9rint\xe9s n\xe9lk\xfcli online fizet\xe9st","ctp.infoPopup.subtitle":"A Mastercard, a Visa \xe9s m\xe1s fizet\xe9si k\xe1rty\xe1k \xe1ltal t\xe1mogatott gyors \xe9s biztons\xe1gos fizet\xe9si m\xf3d.","ctp.infoPopup.benefit1":"A Click to Pay az adatok biztons\xe1ga \xe9rdek\xe9ben titkos\xedt\xe1st haszn\xe1l","ctp.infoPopup.benefit2":"Vil\xe1gszerte haszn\xe1lhat\xf3 a keresked\u0151kn\xe9l","ctp.infoPopup.benefit3":"Egyszer kell be\xe1ll\xedtani, hogy a j\xf6v\u0151ben probl\xe9mamentesen fizethessen","ctp.errors.AUTH_INVALID":"\xc9rv\xe9nytelen hiteles\xedt\xe9s","ctp.errors.NOT_FOUND":"Nem tal\xe1lhat\xf3 fi\xf3k, adjon meg egy \xe9rv\xe9nyes e-mail-c\xedmet, vagy folytassa a k\xe1rtyaadatok manu\xe1lis bevitel\xe9vel","ctp.errors.ID_FORMAT_UNSUPPORTED":"Nem t\xe1mogatott form\xe1tum","ctp.errors.FRAUD":"A felhaszn\xe1l\xf3i fi\xf3k z\xe1rolva volt vagy le volt tiltva","ctp.errors.CONSUMER_ID_MISSING":"A k\xe9r\xe9sb\u0151l hi\xe1nyzik az \xfcgyf\xe9l-azonos\xedt\xf3","ctp.errors.ACCT_INACCESSIBLE":"A fi\xf3k jelenleg nem \xe9rhet\u0151 el, pl. az\xe9rt, mert z\xe1rolva van","ctp.errors.CODE_INVALID":"Helytelen ellen\u0151rz\u0151 k\xf3d","ctp.errors.CODE_EXPIRED":"A k\xf3d lej\xe1rt","ctp.errors.RETRIES_EXCEEDED":"T\xfall\xe9pte az egyszeri jelsz\xf3 l\xe9trehoz\xe1s\xe1ra tett lehets\xe9ges pr\xf3b\xe1lkoz\xe1sok maxim\xe1lis sz\xe1m\xe1t","ctp.errors.OTP_SEND_FAILED":"Az egyszeri jelsz\xf3t nem siker\xfclt elk\xfcldeni a c\xedmzettnek","ctp.errors.REQUEST_TIMEOUT":"Hiba t\xf6rt\xe9nt, pr\xf3b\xe1lkozzon \xfajra, vagy manu\xe1lisan vigye be a k\xe1rty\xe1t","ctp.errors.UNKNOWN_ERROR":"Hiba t\xf6rt\xe9nt, pr\xf3b\xe1lkozzon \xfajra, vagy manu\xe1lisan adja meg a k\xe1rtyaadatokat","ctp.errors.SERVICE_ERROR":"Hiba t\xf6rt\xe9nt, pr\xf3b\xe1lkozzon \xfajra, vagy manu\xe1lisan adja meg a k\xe1rtyaadatokat","ctp.errors.SERVER_ERROR":"Hiba t\xf6rt\xe9nt, pr\xf3b\xe1lkozzon \xfajra, vagy manu\xe1lisan adja meg a k\xe1rtyaadatokat","ctp.errors.INVALID_PARAMETER":"Hiba t\xf6rt\xe9nt, pr\xf3b\xe1lkozzon \xfajra, vagy manu\xe1lisan adja meg a k\xe1rtyaadatokat","ctp.errors.AUTH_ERROR":"Hiba t\xf6rt\xe9nt, pr\xf3b\xe1lkozzon \xfajra, vagy manu\xe1lisan adja meg a k\xe1rtyaadatokat","paymentMethodsList.aria.label":"V\xe1lasszon fizet\xe9si m\xf3dot"}}),A3=Object.freeze({__proto__:null,default:{payButton:"Paga","payButton.redirecting":"Reindirizzamento...","payButton.with":"Paga %{value} con %{maskedData}",close:"Chiudi",storeDetails:"Salva per il prossimo pagamento","creditCard.holderName":"Titolare carta","creditCard.holderName.placeholder":"J. Smith","creditCard.holderName.invalid":"Nome del titolare della carta non valido","creditCard.numberField.title":"Numero carta","creditCard.expiryDateField.title":"Data di scadenza","creditCard.expiryDateField.placeholder":"MM/AA","creditCard.expiryDateField.month":"Mese","creditCard.expiryDateField.month.placeholder":"MM","creditCard.expiryDateField.year.placeholder":"AA","creditCard.expiryDateField.year":"Anno","creditCard.cvcField.title":"CVC/CVV","creditCard.storeDetailsButton":"Ricorda per la prossima volta","creditCard.cvcField.placeholder.4digits":"4 cifre","creditCard.cvcField.placeholder.3digits":"3 cifre","creditCard.taxNumber.placeholder":"AAMMGG/0123456789",installments:"Numero di rate",installmentOption:"%{partialValue} x%{times}",installmentOptionMonths:"%{times} mesi","installments.oneTime":"Pagamento una tantum","installments.installments":"Pagamento rateale","installments.revolving":"Pagamento ricorrente","sepaDirectDebit.ibanField.invalid":"Numero di conto non valido","sepaDirectDebit.nameField.placeholder":"A. Bianchi","sepa.ownerName":"Nome Intestatario Conto","sepa.ibanNumber":"Numero di conto (IBAN)","error.title":"Errore","error.subtitle.redirect":"Reindirizzamento non riuscito","error.subtitle.payment":"Pagamento non riuscito","error.subtitle.refused":"Pagamento respinto","error.message.unknown":"Si \xe8 verificato un errore sconosciuto","errorPanel.title":"Errori presenti","idealIssuer.selectField.title":"Banca","idealIssuer.selectField.placeholder":"Seleziona la banca","creditCard.success":"Pagamento riuscito",loading:"Caricamento in corso...",continue:"Continua",continueTo:"Procedi verso","wechatpay.timetopay":"Devi pagare %@","wechatpay.scanqrcode":"Scansiona il codice QR",personalDetails:"Dati personali",companyDetails:"Informazioni dell'azienda","companyDetails.name":"Ragione sociale","companyDetails.registrationNumber":"Numero di registrazione",socialSecurityNumber:"Numero di previdenza sociale",firstName:"Nome","firstName.invalid":"Nome non valido",infix:"Prefisso",lastName:"Cognome","lastName.invalid":"Cognome non valido",mobileNumber:"Numero di cellulare","mobileNumber.invalid":"Numero di cellulare non valido",city:"Citt\xe0",postalCode:"Codice postale","postalCode.optional":"Codice postale (facoltativo)",countryCode:"Codice nazionale",telephoneNumber:"Numero di telefono",dateOfBirth:"Data di nascita",shopperEmail:"Indirizzo e-mail",gender:"Sesso",male:"Uomo",female:"Donna",billingAddress:"Indirizzo di fatturazione",street:"Via",stateOrProvince:"Stato o provincia",country:"Paese",houseNumberOrName:"Numero civico",separateDeliveryAddress:"Specifica un indirizzo di consegna alternativo",deliveryAddress:"Indirizzo di consegna",zipCode:"CAP",apartmentSuite:"Appartamento/suite",provinceOrTerritory:"Provincia o territorio",cityTown:"Citt\xe0",address:"Indirizzo",state:"Stato","field.title.optional":"(facoltativo)","creditCard.cvcField.title.optional":"CVC/CVV (facoltativo)","issuerList.wallet.placeholder":"Seleziona il tuo portafoglio",privacyPolicy:"Informativa sulla privacy","afterPay.agreement":"Accetto i %@ di AfterPay",paymentConditions:"termini di pagamento",openApp:"Apri l'app","voucher.readInstructions":"Leggi le istruzioni","voucher.introduction":"Grazie per il tuo acquisto, utilizza il seguente coupon per completare il pagamento.","voucher.expirationDate":"Data di scadenza","voucher.alternativeReference":"Riferimento alternativo","dragonpay.voucher.non.bank.selectField.placeholder":"Seleziona il tuo fornitore","dragonpay.voucher.bank.selectField.placeholder":"Seleziona la banca","voucher.paymentReferenceLabel":"Riferimento del pagamento","voucher.surcharge":"Include un sovrapprezzo di %@","voucher.introduction.doku":"Grazie per il tuo acquisto, utilizza i seguenti dati per completare il pagamento.","voucher.shopperName":"Nome dell'acquirente","voucher.merchantName":"Esercente","voucher.introduction.econtext":"Grazie per il tuo acquisto, utilizza i seguenti dati per completare il pagamento.","voucher.telephoneNumber":"Numero di telefono","voucher.shopperReference":"Riferimento dell'acquirente","voucher.collectionInstitutionNumber":"Codice identificativo del negozio","voucher.econtext.telephoneNumber.invalid":"Il numero di telefono deve essere di 10 o 11 cifre","boletobancario.btnLabel":"Genera Boleto","boleto.sendCopyToEmail":"Invia una copia alla mia e-mail","button.copy":"Copia","button.download":"Scarica","boleto.socialSecurityNumber.invalid":"Il campo non \xe8 valido","creditCard.storedCard.description.ariaLabel":"La carta memorizzata termina in %@","voucher.entity":"Entit\xe0",donateButton:"Dona",notNowButton:"Non ora",thanksForYourSupport:"Grazie per il tuo sostegno!",preauthorizeWith:"Preautorizza con",confirmPreauthorization:"Conferma preautorizzazione",confirmPurchase:"Conferma acquisto",applyGiftcard:"Riscatta",giftcardBalance:"Saldo del buono",deductedBalance:"Importo detratto","creditCard.pin.title":"Pin","creditCard.encryptedPassword.label":"Prime 2 cifre della password della carta","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"Password non valida","creditCard.taxNumber":"Data di nascita del titolare della carta o numero di registrazione aziendale","creditCard.taxNumber.label":"Data di nascita del titolare della carta (AAMMGG) o numero di registrazione aziendale (10 cifre)","creditCard.taxNumber.labelAlt":"Numero di registrazione aziendale (10 cifre)","creditCard.taxNumber.invalid":"Data di nascita del titolare della carta o numero di registrazione aziendale non validi","storedPaymentMethod.disable.button":"Rimuovi","storedPaymentMethod.disable.confirmation":"Rimuovi il metodo di pagamento archiviato","storedPaymentMethod.disable.confirmButton":"S\xec, rimuoverli","storedPaymentMethod.disable.cancelButton":"Cancella","ach.bankAccount":"Conto bancario","ach.accountHolderNameField.title":"Nome del titolare del conto","ach.accountHolderNameField.placeholder":"J. Smith","ach.accountHolderNameField.invalid":"Nome del titolare del conto non valido","ach.accountNumberField.title":"Numero di conto","ach.accountNumberField.invalid":"Numero di conto non valido","ach.accountLocationField.title":"Codice ABA","ach.accountLocationField.invalid":"Codice ABA non valido","ach.savedBankAccount":"Conto corrente salvato","select.state":"Seleziona stato","select.stateOrProvince":"Seleziona stato o provincia","select.provinceOrTerritory":"Seleziona provincia o territorio","select.country":"Seleziona paese","select.noOptionsFound":"Nessuna opzione trovata","select.filter.placeholder":"Cerca...","telephoneNumber.invalid":"Numero di telefono non valido",qrCodeOrApp:"o","paypal.processingPayment":"Elaborazione del pagamento in corso...",generateQRCode:"Genera codice QR","await.waitForConfirmation":"In attesa di conferma","mbway.confirmPayment":"Conferma il pagamento con l'app MB WAY","shopperEmail.invalid":"Indirizzo e-mail non valido","dateOfBirth.format":"GG/MM/AAAA","dateOfBirth.invalid":"Devi avere almeno 18 anni","blik.confirmPayment":"Apri l'app della tua banca per confermare il pagamento.","blik.invalid":"Inserisci 6 numeri","blik.code":"Codice a 6 cifre","blik.help":"Ottieni il codice dalla app della tua banca.","swish.pendingMessage":"In seguito alla scansione, lo stato della transazione pu\xf2 rimanere in sospeso per un massimo di 10 minuti. Un nuovo tentativo di pagamento durante questo lasso di tempo pu\xf2 comportare pagamenti multipli.","field.valid":"Campo valido","field.invalid":"Campo non valido","error.va.gen.01":"Campo incompleto","error.va.gen.02":"Campo non valido","error.va.sf-cc-num.01":"Il numero della carta non \xe8 valido","error.va.sf-cc-num.02":"Il campo Numero carta \xe8 vuoto","error.va.sf-cc-num.03":"\xc8 stato inserito un numero di carta non supportato","error.va.sf-cc-num.04":"La lunghezza del numero della carta non \xe8 corretta","error.va.sf-cc-dat.01":"Data di scadenza: carta troppo vecchia","error.va.sf-cc-dat.02":"Data di scadenza: data troppo lontana nel tempo","error.va.sf-cc-dat.03":"Data di scadenza: la carta scade prima della data di checkout","error.va.sf-cc-dat.04":"Il campo Data di scadenza \xe8 vuoto","error.va.sf-cc-dat.05":"La lunghezza della data di scadenza non \xe8 corretta","error.va.sf-cc-mth.01":"Il campo Mese di scadenza \xe8 vuoto","error.va.sf-cc-yr.01":"Il campo Anno di scadenza \xe8 vuoto","error.va.sf-cc-yr.02":"La lunghezza dell'anno di scadenza non \xe8 corretta","error.va.sf-cc-cvc.01":"Il campo Codice di sicurezza \xe8 vuoto","error.va.sf-cc-cvc.02":"La lunghezza del codice di sicurezza non \xe8 corretta","error.va.sf-ach-num.01":"Il campo Numero di conto corrente bancario \xe8 vuoto","error.va.sf-ach-num.02":"La lunghezza del numero di conto corrente bancario non \xe8 corretta","error.va.sf-ach-loc.01":"Il campo Numero di routing bancario \xe8 vuoto","error.va.sf-ach-loc.02":"La lunghezza del numero di routing bancario non \xe8 corretta","error.va.sf-kcp-pwd.01":"Il campo Password \xe8 vuoto","error.va.sf-kcp-pwd.02":"La lunghezza della password non \xe8 corretta","error.giftcard.no-balance":"Questo buono regalo ha un saldo pari a zero","error.giftcard.card-error":"Non abbiamo alcun buono regalo con questo numero nei nostri archivi","error.giftcard.currency-error":"I buono regalo sono validi solo nella valuta in cui sono state emessi","amazonpay.signout":"Esci da Amazon","amazonpay.changePaymentDetails":"Modifica i dettagli di pagamento","partialPayment.warning":"Seleziona un altro metodo di pagamento per pagare l'importo rimanente","partialPayment.remainingBalance":"Il saldo rimanente sar\xe0 di %{amount}","bankTransfer.beneficiary":"Beneficiario","bankTransfer.iban":"IBAN","bankTransfer.bic":"BIC","bankTransfer.reference":"Riferimento","bankTransfer.introduction":"Continua per creare un nuovo pagamento tramite bonifico bancario. Puoi utilizzare i dettagli nella schermata seguente per completare l'operazione.","bankTransfer.instructions":"Grazie per il tuo acquisto, utilizza i seguenti dati per completare il pagamento.","bacs.accountHolderName":"Nome del titolare del conto bancario","bacs.accountHolderName.invalid":"Nome del titolare del conto bancario non valido","bacs.accountNumber":"Numero di conto bancario","bacs.accountNumber.invalid":"Numero di conto bancario non valido","bacs.bankLocationId":"Sort code","bacs.bankLocationId.invalid":"Sort code non valido","bacs.consent.amount":"Accetto che l'importo sopra indicato venga detratto dal mio conto bancario.","bacs.consent.account":"Confermo che il conto \xe8 intestato al sottoscritto e che sono l'unico firmatario a dover autorizzare l'addebito diretto su questo conto.",edit:"Modifica","bacs.confirm":"Conferma e paga","bacs.result.introduction":"Scarica le Istruzioni per l'addebito diretto (DDI / Mandato)","download.pdf":"Scarica PDF","creditCard.encryptedCardNumber.aria.iframeTitle":"Iframe per numero di carta protetta","creditCard.encryptedCardNumber.aria.label":"Numero carta","creditCard.encryptedExpiryDate.aria.iframeTitle":"Iframe data di scadenza per numero di carta protetta","creditCard.encryptedExpiryDate.aria.label":"Data di scadenza","creditCard.encryptedExpiryMonth.aria.iframeTitle":"Iframe mese di scadenza per numero di carta protetta","creditCard.encryptedExpiryMonth.aria.label":"Mese di scadenza","creditCard.encryptedExpiryYear.aria.iframeTitle":"Iframe anno di scadenza per numero di carta protetta","creditCard.encryptedExpiryYear.aria.label":"Anno di scadenza","creditCard.encryptedSecurityCode.aria.iframeTitle":"Iframe per codice di sicurezza della carta protetta","creditCard.encryptedSecurityCode.aria.label":"Codice di sicurezza","creditCard.encryptedPassword.aria.iframeTitle":"Iframe per la password della carta protetta","creditCard.encryptedPassword.aria.label":"Prime 2 cifre della password della carta","giftcard.encryptedCardNumber.aria.iframeTitle":"Iframe per numero di carta regalo protetta","giftcard.encryptedCardNumber.aria.label":"Numero del buono regalo","giftcard.encryptedSecurityCode.aria.iframeTitle":"Iframe per codice di sicurezza della carta regalo protetta","giftcard.encryptedSecurityCode.aria.label":"Codice di sicurezza del buono regalo",giftcardTransactionLimit:"Importo massimo di %{amount} per transazione su questo buono regalo","ach.encryptedBankAccountNumber.aria.iframeTitle":"Iframe per numero di numero di conto bancario protetto","ach.encryptedBankAccountNumber.aria.label":"Conto bancario","ach.encryptedBankLocationId.aria.iframeTitle":"Iframe per numero di routing bancario sicuro","ach.encryptedBankLocationId.aria.label":"Numero di routing della banca","twint.saved":"memorizzato",orPayWith:"oppure paga con",invalidFormatExpects:"Formato non valido. Formato previsto: %{format}","upi.qrCodeWaitingMessage":"Per completare il pagamento, scansiona il codice QR utilizzando la tua app UPI preferita","upi.vpaWaitingMessage":"Apri l'app UPI per confermare il pagamento","upi.modeSelection":"Scegli la modalit\xe0 di utilizzo di UPI.","onlineBanking.termsAndConditions":"Facendo clic, accetti i %#termini e le condizioni%#","ctp.loading.poweredByCtp":"Realizzato da Click to Pay","ctp.loading.intro":"Stiamo verificando se hai delle carte salvate con Click to Pay...","ctp.login.title":"Continua su Click to Pay","ctp.login.subtitle":"Per continuare, inserisci l'indirizzo e-mail collegato a Click to Pay.","ctp.login.inputLabel":"E-mail","ctp.logout.notYou":"Non sei tu?","ctp.logout.notYourCards":"Non sono le tue carte?","ctp.logout.notYourCard":"Non \xe8 la tua carta?","ctp.logout.notYourProfile":"Non \xe8 il tuo profilo?","ctp.otp.fieldLabel":"Codice monouso","ctp.otp.resendCode":"Invia nuovamente il codice","ctp.otp.codeResent":"Codice inviato","ctp.otp.title":"Accedi alle tue carte Click to Pay","ctp.otp.subtitle":"Inserisci il codice che %@ ha inviato a %@ per verificare la tua identit\xe0.","ctp.emptyProfile.message":"Non esistono carte registrate in questo profilo Click to Pay","ctp.separatorText":"o utilizza","ctp.cards.title":"Completa il pagamento con Click to Pay","ctp.cards.subtitle":"Seleziona una carta da utilizzare.","ctp.cards.expiredCard":"Scaduta","ctp.manualCardEntry":"Inserimento manuale della carta","ctp.aria.infoModalButton":"Che cos'\xe8 Click to Pay","ctp.infoPopup.title":"Click to Pay offre la facilit\xe0 del contactless online","ctp.infoPopup.subtitle":"Un metodo di pagamento veloce e sicuro supportato da Mastercard, Visa e altre carte di pagamento.","ctp.infoPopup.benefit1":"Click to Pay si avvale della crittografia per garantire la sicurezza delle tue informazioni","ctp.infoPopup.benefit2":"Usa questo strumento con i commercianti di tutto il mondo","ctp.infoPopup.benefit3":"Effettua una sola configurazione per avere la possibilit\xe0 di effettuare pagamenti pi\xf9 agevoli in futuro","ctp.errors.AUTH_INVALID":"Autenticazione non valida","ctp.errors.NOT_FOUND":"Nessun account trovato. Inserisci un'e-mail valida o procedi con l'inserimento manuale della carta.","ctp.errors.ID_FORMAT_UNSUPPORTED":"Formato non supportato","ctp.errors.FRAUD":"L'account utente \xe8 stato bloccato o disattivato","ctp.errors.CONSUMER_ID_MISSING":"L'identit\xe0 del consumatore non \xe8 presente nella richiesta","ctp.errors.ACCT_INACCESSIBLE":"Questo account non \xe8 attualmente disponibile, ad esempio perch\xe9 \xe8 bloccato","ctp.errors.CODE_INVALID":"Codice di verifica non corretto","ctp.errors.CODE_EXPIRED":"Questo codice \xe8 scaduto","ctp.errors.RETRIES_EXCEEDED":"\xc8 stato superato il limite di tentativi per la generazione del codice OTP","ctp.errors.OTP_SEND_FAILED":"Impossibile inviare il codice OTP al destinatario","ctp.errors.REQUEST_TIMEOUT":"Si \xe8 verificato un errore. Riprova o inserisci manualmente la carta","ctp.errors.UNKNOWN_ERROR":"Si \xe8 verificato un errore. Riprova o inserisci manualmente la carta","ctp.errors.SERVICE_ERROR":"Si \xe8 verificato un errore. Riprova o inserisci manualmente la carta","ctp.errors.SERVER_ERROR":"Si \xe8 verificato un errore. Riprova o inserisci manualmente la carta","ctp.errors.INVALID_PARAMETER":"Si \xe8 verificato un errore. Riprova o inserisci manualmente la carta","ctp.errors.AUTH_ERROR":"Si \xe8 verificato un errore. Riprova o inserisci manualmente la carta","paymentMethodsList.aria.label":"Scegli un metodo di pagamento"}}),D3=Object.freeze({__proto__:null,default:{payButton:"\u652f\u6255\u3046","payButton.redirecting":"\u30ea\u30c0\u30a4\u30ec\u30af\u30c8\u3057\u3066\u3044\u307e\u3059...","payButton.with":"%{value}\u3092%{maskedData}\u3067\u652f\u6255\u3046",close:"\u7d42\u4e86",storeDetails:"\u6b21\u56de\u306e\u304a\u652f\u6255\u3044\u306e\u305f\u3081\u8a73\u7d30\u3092\u4fdd\u5b58","creditCard.holderName":"\u30ab\u30fc\u30c9\u4e0a\u306e\u540d\u524d","creditCard.holderName.placeholder":"Taro Yamada","creditCard.holderName.invalid":"\u7121\u52b9\u306a\u30ab\u30fc\u30c9\u6240\u6709\u8005\u540d","creditCard.numberField.title":"\u30ab\u30fc\u30c9\u756a\u53f7","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"\u6709\u52b9\u671f\u9650","creditCard.expiryDateField.placeholder":"MM/YY","creditCard.expiryDateField.month":"\u6708","creditCard.expiryDateField.month.placeholder":"MM","creditCard.expiryDateField.year.placeholder":"YY","creditCard.expiryDateField.year":"\u5e74","creditCard.cvcField.title":"\u30bb\u30ad\u30e5\u30ea\u30c6\u30a3\u30fc\u30b3\u30fc\u30c9 (CVC)","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"\u6b21\u56de\u306e\u305f\u3081\u306b\u4fdd\u5b58\u3057\u307e\u3059","creditCard.cvcField.placeholder.4digits":"4\u6841","creditCard.cvcField.placeholder.3digits":"3\u6841","creditCard.taxNumber.placeholder":"\u5e74\u6708\u65e5\uff08YYMMDD\uff09/ 0123456789",installments:"\u5206\u5272\u56de\u6570",installmentOption:"%{times}x %{partialValue}",installmentOptionMonths:"%{times}\u304b\u6708","installments.oneTime":"\u4e00\u62ec\u6255\u3044","installments.installments":"\u5206\u5272\u6255\u3044","installments.revolving":"\u30ea\u30dc\u6255\u3044","sepaDirectDebit.ibanField.invalid":"\u53e3\u5ea7\u756a\u53f7\u306e\u5165\u529b\u9593\u9055\u3044","sepaDirectDebit.nameField.placeholder":"J. Smith","sepa.ownerName":"\u540d\u7fa9","sepa.ibanNumber":"\u53e3\u5ea7\u756a\u53f7 (IBAN)","error.title":"\u30a8\u30e9\u30fc","error.subtitle.redirect":"\u753b\u9762\u306e\u5207\u308a\u66ff\u3048\u5931\u6557\u306b\u3057\u307e\u3057\u305f","error.subtitle.payment":"\u652f\u6255\u3067\u304d\u307e\u305b\u3093\u3067\u3057\u305f","error.subtitle.refused":"\u30ab\u30fc\u30c9\u4f1a\u793e\u3067\u53d6\u5f15\u304c\u627f\u8a8d\u3055\u308c\u307e\u305b\u3093\u3067\u3057\u305f\u3002","error.message.unknown":"\u4e0d\u660e\u306a\u30a8\u30e9\u30fc\u304c\u767a\u751f\u3057\u307e\u3057\u305f","errorPanel.title":"\u65e2\u5b58\u306e\u30a8\u30e9\u30fc","idealIssuer.selectField.title":"\u9280\u884c","idealIssuer.selectField.placeholder":"\u9280\u884c\u3092\u9078\u629e\u3057\u3066\u304f\u3060\u3055\u3044","creditCard.success":"\u8a8d\u8a3c\u304c\u6210\u529f\u3057\u307e\u3057\u305f",loading:"\u8aad\u307f\u8fbc\u3093\u3067\u3044\u307e\u3059...",continue:"\u7d9a\u3051\u308b",continueTo:"\u6b21\u3078\u9032\u3080\uff1a","wechatpay.timetopay":"%@\u3092\u304a\u652f\u6255\u3044\u4e0b\u3055\u3044\u3002","wechatpay.scanqrcode":"QR \u30b3\u30fc\u30c9\u3092\u30b9\u30ad\u30e3\u30f3\u3059\u308b",personalDetails:"\u500b\u4eba\u60c5\u5831",companyDetails:"\u4f1a\u793e\u60c5\u5831","companyDetails.name":"\u4f1a\u793e\u540d","companyDetails.registrationNumber":"\u767b\u9332\u756a\u53f7",socialSecurityNumber:"\u30bd\u30fc\u30b7\u30e3\u30eb\u30bb\u30ad\u30e5\u30ea\u30c6\u30a3\u30fc\u756a\u53f7",firstName:"\u540d","firstName.invalid":"\u540d\u304c\u7121\u52b9\u3067\u3059",infix:"\u656c\u79f0",lastName:"\u59d3","lastName.invalid":"\u59d3\u304c\u7121\u52b9\u3067\u3059",mobileNumber:"\u643a\u5e2f\u756a\u53f7","mobileNumber.invalid":"\u7121\u52b9\u306a\u643a\u5e2f\u96fb\u8a71\u756a\u53f7",city:"\u5e02\u533a",postalCode:"\u90f5\u4fbf\u756a\u53f7","postalCode.optional":"\u90f5\u4fbf\u756a\u53f7 (\u4efb\u610f)",countryCode:"\u56fd\u30b3\u30fc\u30c9",telephoneNumber:"\u96fb\u8a71\u756a\u53f7",dateOfBirth:"\u751f\u5e74\u6708\u65e5",shopperEmail:"E\u30e1\u30fc\u30eb\u30a2\u30c9\u30ec\u30b9",gender:"\u6027\u5225",male:"\u7537\u6027",female:"\u5973\u6027",billingAddress:"\u3054\u8acb\u6c42\u4f4f\u6240",street:"\u756a\u5730",stateOrProvince:"\u90fd\u9053\u5e9c\u770c",country:"\u56fd",houseNumberOrName:"\u90e8\u5c4b\u756a\u53f7",separateDeliveryAddress:"\u5225\u306e\u914d\u9001\u5148\u4f4f\u6240\u3092\u6307\u5b9a\u3057\u3066\u304f\u3060\u3055\u3044",deliveryAddress:"\u914d\u9001\u5148\u4f4f\u6240",zipCode:"\u90f5\u4fbf\u756a\u53f7",apartmentSuite:"\u30a2\u30d1\u30fc\u30c8\u540d/\u90e8\u5c4b\u540d",provinceOrTerritory:"\u5dde\u307e\u305f\u306f\u6e96\u5dde",cityTown:"\u5e02\u533a\u753a\u6751",address:"\u4f4f\u6240",state:"\u90fd\u9053\u5e9c\u770c","field.title.optional":"\uff08\u4efb\u610f\uff09","creditCard.cvcField.title.optional":"\u30bb\u30ad\u30e5\u30ea\u30c6\u30a3\u30fc\u30b3\u30fc\u30c9(\u4efb\u610f)","issuerList.wallet.placeholder":"\u30a6\u30a9\u30ec\u30c3\u30c8\u3092\u9078\u629e\u3057\u3066\u304f\u3060\u3055\u3044",privacyPolicy:"\u30d7\u30e9\u30a4\u30d0\u30b7\u30fc\u30dd\u30ea\u30b7\u30fc","afterPay.agreement":"AfterPay\u306e%@\u3067\u540c\u610f",paymentConditions:"\u652f\u6255\u6761\u4ef6",openApp:"\u30a2\u30d7\u30ea\u3092\u958b\u304f","voucher.readInstructions":"\u624b\u9806\u3092\u53c2\u7167\u3057\u3066\u304f\u3060\u3055\u3044","voucher.introduction":"\u304a\u8cb7\u3044\u4e0a\u3052\u3042\u308a\u304c\u3068\u3046\u3054\u3056\u3044\u307e\u3059\u3002\u4ee5\u4e0b\u306e\u30af\u30fc\u30dd\u30f3\u3092\u4f7f\u7528\u3057\u3066\u3001\u304a\u652f\u6255\u3044\u3092\u5b8c\u4e86\u3057\u3066\u304f\u3060\u3055\u3044\u3002","voucher.expirationDate":"\u6709\u52b9\u671f\u9650","voucher.alternativeReference":"\u5225\u306e\u53c2\u7167","dragonpay.voucher.non.bank.selectField.placeholder":"\u30d7\u30ed\u30d0\u30a4\u30c0\u30fc\u3092\u9078\u629e\u3057\u3066\u304f\u3060\u3055\u3044","dragonpay.voucher.bank.selectField.placeholder":"\u9280\u884c\u3092\u9078\u629e\u3057\u3066\u304f\u3060\u3055\u3044","voucher.paymentReferenceLabel":"\u652f\u6255\u3044\u306e\u53c2\u7167","voucher.surcharge":"%@ \u306e\u8ffd\u52a0\u6599\u91d1\u3092\u542b\u3080","voucher.introduction.doku":"\u304a\u8cb7\u3044\u4e0a\u3052\u3042\u308a\u304c\u3068\u3046\u3054\u3056\u3044\u307e\u3059\u3002\u4ee5\u4e0b\u306e\u60c5\u5831\u3092\u4f7f\u7528\u3057\u3066\u3001\u304a\u652f\u6255\u3044\u3092\u5b8c\u4e86\u3057\u3066\u304f\u3060\u3055\u3044\u3002","voucher.shopperName":"\u8cfc\u5165\u8005\u6c0f\u540d","voucher.merchantName":"\u696d\u8005","voucher.introduction.econtext":"\u304a\u8cb7\u3044\u4e0a\u3052\u3042\u308a\u304c\u3068\u3046\u3054\u3056\u3044\u307e\u3059\u3002\u4ee5\u4e0b\u306e\u60c5\u5831\u3092\u4f7f\u7528\u3057\u3066\u3001\u304a\u652f\u6255\u3044\u3092\u5b8c\u4e86\u3057\u3066\u304f\u3060\u3055\u3044\u3002","voucher.telephoneNumber":"\u96fb\u8a71\u756a\u53f7","voucher.shopperReference":"\u8cfc\u5165\u8005\u5411\u3051\u53c2\u8003\u60c5\u5831","voucher.collectionInstitutionNumber":"\u53ce\u7d0d\u6a5f\u95a2\u756a\u53f7","voucher.econtext.telephoneNumber.invalid":"\u96fb\u8a71\u756a\u53f7\u306f10\u6841\u307e\u305f\u306f11\u6841\u306b\u3057\u3066\u304f\u3060\u3055\u3044","boletobancario.btnLabel":"Boleto\u3092\u751f\u6210\u3059\u308b","boleto.sendCopyToEmail":"\u81ea\u5206\u306e\u30e1\u30fc\u30eb\u30a2\u30c9\u30ec\u30b9\u306b\u30b3\u30d4\u30fc\u3092\u9001\u4fe1\u3059\u308b","button.copy":"\u30b3\u30d4\u30fc","button.download":"\u30c0\u30a6\u30f3\u30ed\u30fc\u30c9","boleto.socialSecurityNumber.invalid":"\u30d5\u30a3\u30fc\u30eb\u30c9\u304c\u7121\u52b9\u3067\u3059","creditCard.storedCard.description.ariaLabel":"\u4fdd\u5b58\u3055\u308c\u305f\u30ab\u30fc\u30c9\u306f\uff05@\u306b\u7d42\u4e86\u3057\u307e\u3059","voucher.entity":"\u30a8\u30f3\u30c6\u30a3\u30c6\u30a3",donateButton:"\u5bc4\u4ed8\u3059\u308b",notNowButton:"\u4eca\u306f\u3057\u306a\u3044",thanksForYourSupport:"\u3054\u652f\u63f4\u3044\u305f\u3060\u304d\u3042\u308a\u304c\u3068\u3046\u3054\u3056\u3044\u307e\u3059\u3002",preauthorizeWith:"\u6b21\u3067\u4e8b\u524d\u8a8d\u8a3c\u3059\u308b\uff1a",confirmPreauthorization:"\u4e8b\u524d\u627f\u8a8d\u3092\u78ba\u8a8d\u3059\u308b",confirmPurchase:"\u8cfc\u5165\u3092\u78ba\u8a8d\u3059\u308b",applyGiftcard:"\u5229\u7528\u3059\u308b",giftcardBalance:"\u30ae\u30d5\u30c8\u30ab\u30fc\u30c9\u306e\u6b8b\u9ad8",deductedBalance:"\u5dee\u3057\u5f15\u304d\u5f8c\u6b8b\u9ad8","creditCard.pin.title":"PIN","creditCard.encryptedPassword.label":"\u30ab\u30fc\u30c9\u306e\u30d1\u30b9\u30ef\u30fc\u30c9\u306e\u6700\u521d\u306e2\u6841","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"\u30d1\u30b9\u30ef\u30fc\u30c9\u304c\u7121\u52b9\u3067\u3059","creditCard.taxNumber":"\u30ab\u30fc\u30c9\u6240\u6709\u8005\u306e\u751f\u5e74\u6708\u65e5\u307e\u305f\u306f\u6cd5\u4eba\u767b\u9332\u756a\u53f7","creditCard.taxNumber.label":"\u30ab\u30fc\u30c9\u6240\u6709\u8005\u306e\u751f\u5e74\u6708\u65e5\uff08YYMMDD\uff09\u307e\u305f\u306f\u6cd5\u4eba\u767b\u9332\u756a\u53f7\uff0810\u6841\uff09","creditCard.taxNumber.labelAlt":"\u6cd5\u4eba\u767b\u9332\u756a\u53f7\uff0810\u6841\uff09","creditCard.taxNumber.invalid":"\u30ab\u30fc\u30c9\u6240\u6709\u8005\u306e\u751f\u5e74\u6708\u65e5\u307e\u305f\u306f\u6cd5\u4eba\u767b\u9332\u756a\u53f7\u304c\u7121\u52b9\u3067\u3059","storedPaymentMethod.disable.button":"\u524a\u9664","storedPaymentMethod.disable.confirmation":"\u4fdd\u5b58\u3055\u308c\u3066\u3044\u308b\u652f\u6255\u65b9\u6cd5\u3092\u524a\u9664\u3059\u308b","storedPaymentMethod.disable.confirmButton":"\u306f\u3044\u3001\u524a\u9664\u3057\u307e\u3059","storedPaymentMethod.disable.cancelButton":"\u30ad\u30e3\u30f3\u30bb\u30eb","ach.bankAccount":"\u9280\u884c\u53e3\u5ea7","ach.accountHolderNameField.title":"\u53e3\u5ea7\u540d\u7fa9","ach.accountHolderNameField.placeholder":"Taro Yamada","ach.accountHolderNameField.invalid":"\u7121\u52b9\u306a\u53e3\u5ea7\u540d\u7fa9","ach.accountNumberField.title":"\u53e3\u5ea7\u756a\u53f7","ach.accountNumberField.invalid":"\u53e3\u5ea7\u756a\u53f7\u306e\u5165\u529b\u9593\u9055\u3044","ach.accountLocationField.title":"ABA\u30ca\u30f3\u30d0\u30fc","ach.accountLocationField.invalid":"\u7121\u52b9\u306aABA\u30ca\u30f3\u30d0\u30fc","ach.savedBankAccount":"\u4fdd\u5b58\u6e08\u307f\u306e\u9280\u884c\u53e3\u5ea7","select.state":"\u90fd\u9053\u5e9c\u770c\u3092\u9078\u629e\u3057\u3066\u304f\u3060\u3055\u3044","select.stateOrProvince":"\u90fd\u9053\u5e9c\u770c\u3092\u9078\u629e\u3057\u3066\u304f\u3060\u3055\u3044","select.provinceOrTerritory":"\u5dde\u307e\u305f\u306f\u6e96\u5dde\u3092\u9078\u629e\u3057\u3066\u304f\u3060\u3055\u3044","select.country":"\u56fd\u3092\u9078\u629e\u3057\u3066\u304f\u3060\u3055\u3044","select.noOptionsFound":"\u30aa\u30d7\u30b7\u30e7\u30f3\u304c\u898b\u3064\u304b\u308a\u307e\u305b\u3093\u3067\u3057\u305f","select.filter.placeholder":"\u691c\u7d22...","telephoneNumber.invalid":"\u7121\u52b9\u306a\u96fb\u8a71\u756a\u53f7",qrCodeOrApp:"\u307e\u305f\u306f","paypal.processingPayment":"\u652f\u6255\u3044\u3092\u51e6\u7406\u3057\u3066\u3044\u307e\u3059...",generateQRCode:"QR\u30b3\u30fc\u30c9\u3092\u751f\u6210\u3059\u308b","await.waitForConfirmation":"\u78ba\u8a8d\u3092\u5f85\u3063\u3066\u3044\u307e\u3059","mbway.confirmPayment":"MB WAY\u30a2\u30d7\u30ea\u3067\u652f\u6255\u3092\u78ba\u8a8d\u3059\u308b","shopperEmail.invalid":"E\u30e1\u30fc\u30eb\u30a2\u30c9\u30ec\u30b9\u304c\u7121\u52b9\u3067\u3059","dateOfBirth.format":"DD/MM/YYYY","dateOfBirth.invalid":"18\u6b73\u4ee5\u4e0a\u306e\u65b9\u306e\u307f\u3054\u5229\u7528\u3044\u305f\u3060\u3051\u307e\u3059","blik.confirmPayment":"\u30d0\u30f3\u30ad\u30f3\u30b0\u30a2\u30d7\u30ea\u3092\u958b\u3044\u3066\u3001\u652f\u6255\u3092\u78ba\u8a8d\u3057\u3066\u304f\u3060\u3055\u3044\u3002","blik.invalid":"6\u3064\u306e\u6570\u5b57\u3092\u5165\u529b\u3057\u3066\u304f\u3060\u3055\u3044","blik.code":"6\u6841\u306e\u30b3\u30fc\u30c9","blik.help":"\u30d0\u30f3\u30ad\u30f3\u30b0\u30a2\u30d7\u30ea\u304b\u3089\u30b3\u30fc\u30c9\u3092\u53d6\u5f97\u3057\u3066\u304f\u3060\u3055\u3044\u3002","swish.pendingMessage":"\u30b9\u30ad\u30e3\u30f3\u5f8c\u3001\u30b9\u30c6\u30fc\u30bf\u30b9\u306f\u6700\u592710\u5206\u9593\u4fdd\u7559\u72b6\u614b\u306b\u306a\u308a\u307e\u3059\u3002\u3053\u306e\u9593\u306b\u518d\u5ea6\u304a\u652f\u6255\u3044\u3044\u305f\u3060\u3053\u3046\u3068\u3059\u308b\u3068\u3001\u8907\u6570\u306e\u8acb\u6c42\u304c\u767a\u751f\u3059\u308b\u5834\u5408\u304c\u3042\u308a\u307e\u3059\u3002","field.valid":"\u30d5\u30a3\u30fc\u30eb\u30c9\u304c\u6709\u52b9\u3067\u3059","field.invalid":"\u30d5\u30a3\u30fc\u30eb\u30c9\u304c\u7121\u52b9\u3067\u3059","error.va.gen.01":"\u4e0d\u5b8c\u5168\u306a\u30d5\u30a3\u30fc\u30eb\u30c9","error.va.gen.02":"\u30d5\u30a3\u30fc\u30eb\u30c9\u304c\u7121\u52b9\u3067\u3059","error.va.sf-cc-num.01":"\u30ab\u30fc\u30c9\u756a\u53f7\u304c\u7121\u52b9\u3067\u3059","error.va.sf-cc-num.02":"\u30ab\u30fc\u30c9\u756a\u53f7\u30d5\u30a3\u30fc\u30eb\u30c9\u304c\u7a7a\u3067\u3059","error.va.sf-cc-num.03":"\u30b5\u30dd\u30fc\u30c8\u3055\u308c\u3066\u3044\u306a\u3044\u30ab\u30fc\u30c9\u756a\u53f7\u304c\u5165\u529b\u3055\u308c\u307e\u3057\u305f","error.va.sf-cc-num.04":"\u30ab\u30fc\u30c9\u756a\u53f7\u306e\u9577\u3055\u304c\u4e0d\u6b63\u3067\u3059","error.va.sf-cc-dat.01":"\u6709\u52b9\u671f\u9650\uff1a\u30ab\u30fc\u30c9\u304c\u53e4\u3059\u304e\u307e\u3059","error.va.sf-cc-dat.02":"\u6709\u52b9\u671f\u9650\uff1a\u672a\u6765\u306e\u65e5\u4ed8\u304c\u5148\u3059\u304e\u3067\u3059","error.va.sf-cc-dat.03":"\u6709\u52b9\u671f\u9650\uff1a\u30c1\u30a7\u30c3\u30af\u30a2\u30a6\u30c8\u65e5\u3088\u308a\u524d\u306b\u30ab\u30fc\u30c9\u306e\u6709\u52b9\u671f\u9650\u304c\u5207\u308c\u307e\u3059","error.va.sf-cc-dat.04":"\u6709\u52b9\u671f\u9650\u30d5\u30a3\u30fc\u30eb\u30c9\u304c\u7a7a\u3067\u3059","error.va.sf-cc-dat.05":"\u6709\u52b9\u671f\u9650\u306e\u9577\u3055\u304c\u4e0d\u6b63\u3067\u3059","error.va.sf-cc-mth.01":"\u6709\u52b9\u671f\u9650\u6708\u30d5\u30a3\u30fc\u30eb\u30c9\u304c\u7a7a\u3067\u3059","error.va.sf-cc-yr.01":"\u6709\u52b9\u671f\u9650\u5e74\u30d5\u30a3\u30fc\u30eb\u30c9\u304c\u7a7a\u3067\u3059","error.va.sf-cc-yr.02":"\u6709\u52b9\u671f\u9650\u5e74\u306e\u9577\u3055\u304c\u4e0d\u6b63\u3067\u3059","error.va.sf-cc-cvc.01":"\u30bb\u30ad\u30e5\u30ea\u30c6\u30a3\u30b3\u30fc\u30c9\u30d5\u30a3\u30fc\u30eb\u30c9\u304c\u7a7a\u3067\u3059","error.va.sf-cc-cvc.02":"\u30bb\u30ad\u30e5\u30ea\u30c6\u30a3\u30b3\u30fc\u30c9\u306e\u9577\u3055\u304c\u4e0d\u6b63\u3067\u3059","error.va.sf-ach-num.01":"\u9280\u884c\u53e3\u5ea7\u756a\u53f7\u30d5\u30a3\u30fc\u30eb\u30c9\u304c\u7a7a\u3067\u3059","error.va.sf-ach-num.02":"\u9280\u884c\u53e3\u5ea7\u756a\u53f7\u306e\u9577\u3055\u304c\u4e0d\u6b63\u3067\u3059","error.va.sf-ach-loc.01":"\u9280\u884c\u652f\u5e97\u756a\u53f7\u30d5\u30a3\u30fc\u30eb\u30c9\u304c\u7a7a\u3067\u3059","error.va.sf-ach-loc.02":"\u9280\u884c\u652f\u5e97\u756a\u53f7\u306e\u9577\u3055\u304c\u4e0d\u6b63\u3067\u3059","error.va.sf-kcp-pwd.01":"\u30d1\u30b9\u30ef\u30fc\u30c9\u30d5\u30a3\u30fc\u30eb\u30c9\u304c\u7a7a\u3067\u3059","error.va.sf-kcp-pwd.02":"\u30d1\u30b9\u30ef\u30fc\u30c9\u306e\u9577\u3055\u304c\u4e0d\u6b63\u3067\u3059","error.giftcard.no-balance":"\u3053\u306e\u30ae\u30d5\u30c8\u30ab\u30fc\u30c9\u306e\u6b8b\u9ad8\u306f\u30bc\u30ed\u3067\u3059","error.giftcard.card-error":"\u8a18\u9332\u3067\u306f\u3001\u3053\u306e\u756a\u53f7\u306e\u30ae\u30d5\u30c8\u30ab\u30fc\u30c9\u306f\u3042\u308a\u307e\u305b\u3093","error.giftcard.currency-error":"\u30ae\u30d5\u30c8\u30ab\u30fc\u30c9\u306f\u3001\u767a\u884c\u3055\u308c\u305f\u901a\u8ca8\u3067\u306e\u307f\u6709\u52b9\u3067\u3059\u3002","amazonpay.signout":"Amazon\u304b\u3089\u30b5\u30a4\u30f3\u30a2\u30a6\u30c8\u3059\u308b","amazonpay.changePaymentDetails":"\u652f\u6255\u660e\u7d30\u3092\u5909\u66f4\u3059\u308b","partialPayment.warning":"\u6b8b\u91d1\u3092\u652f\u6255\u3046\u5225\u306e\u652f\u6255\u65b9\u6cd5\u3092\u9078\u629e\u3057\u3066\u304f\u3060\u3055\u3044","partialPayment.remainingBalance":"\u6b8b\u308a\u306e\u6b8b\u9ad8\u306f%{amount}\u306b\u306a\u308a\u307e\u3059","bankTransfer.beneficiary":"\u53d7\u76ca\u8005","bankTransfer.iban":"IBAN","bankTransfer.bic":"BIC","bankTransfer.reference":"\u53c2\u7167","bankTransfer.introduction":"\u65b0\u3057\u3044\u9280\u884c\u632f\u8fbc\u306b\u3088\u308b\u304a\u652f\u6255\u306e\u4f5c\u6210\u3092\u7d9a\u884c\u3057\u307e\u3059\u3002\u6b21\u306e\u753b\u9762\u306e\u8a73\u7d30\u3092\u4f7f\u7528\u3057\u3066\u3001\u3053\u306e\u304a\u652f\u6255\u3044\u3092\u78ba\u5b9a\u3067\u304d\u307e\u3059\u3002","bankTransfer.instructions":"\u304a\u8cb7\u3044\u4e0a\u3052\u3042\u308a\u304c\u3068\u3046\u3054\u3056\u3044\u307e\u3059\u3002\u4ee5\u4e0b\u306e\u60c5\u5831\u3092\u4f7f\u7528\u3057\u3066\u3001\u304a\u652f\u6255\u3044\u3092\u5b8c\u4e86\u3057\u3066\u304f\u3060\u3055\u3044\u3002","bacs.accountHolderName":"\u9280\u884c\u53e3\u5ea7\u540d\u7fa9","bacs.accountHolderName.invalid":"\u9280\u884c\u53e3\u5ea7\u540d\u7fa9\u304c\u7121\u52b9\u3067\u3059","bacs.accountNumber":"\u9280\u884c\u53e3\u5ea7\u756a\u53f7","bacs.accountNumber.invalid":"\u9280\u884c\u53e3\u5ea7\u756a\u53f7\u304c\u7121\u52b9\u3067\u3059","bacs.bankLocationId":"\u30bd\u30fc\u30c8\u30b3\u30fc\u30c9","bacs.bankLocationId.invalid":"\u30bd\u30fc\u30c8\u30b3\u30fc\u30c9\u304c\u7121\u52b9\u3067\u3059","bacs.consent.amount":"\u4e0a\u8a18\u306e\u91d1\u984d\u304c\u79c1\u306e\u9280\u884c\u53e3\u5ea7\u304b\u3089\u5f15\u304d\u843d\u3068\u3055\u308c\u308b\u3053\u3068\u306b\u540c\u610f\u3057\u307e\u3059\u3002","bacs.consent.account":"\u53e3\u5ea7\u304c\u79c1\u306e\u540d\u7fa9\u3067\u3042\u308b\u3053\u3068\u3092\u78ba\u8a8d\u3057\u3001\u3053\u306e\u53e3\u5ea7\u304b\u3089\u306e\u81ea\u52d5\u5f15\u304d\u843d\u3068\u3057\u3092\u627f\u8a8d\u3059\u308b\u305f\u3081\u306b\u5fc5\u8981\u306a\u552f\u4e00\u306e\u7f72\u540d\u8005\u3067\u3042\u308b\u3053\u3068\u3092\u78ba\u8a8d\u3057\u307e\u3059\u3002",edit:"\u7de8\u96c6","bacs.confirm":"\u78ba\u8a8d\u3057\u3066\u652f\u6255\u3046","bacs.result.introduction":"\u81ea\u52d5\u5f15\u304d\u843d\u3068\u3057\u306e\u8aac\u660e (DDI/\u59d4\u4efb\u72b6) \u3092\u30c0\u30a6\u30f3\u30ed\u30fc\u30c9\u3059\u308b","download.pdf":"PDF\u3092\u30c0\u30a6\u30f3\u30ed\u30fc\u30c9","creditCard.encryptedCardNumber.aria.iframeTitle":"\u4fdd\u8b77\u3055\u308c\u305f\u30ab\u30fc\u30c9\u756a\u53f7\u306e iframe","creditCard.encryptedCardNumber.aria.label":"\u30ab\u30fc\u30c9\u756a\u53f7","creditCard.encryptedExpiryDate.aria.iframeTitle":"\u4fdd\u8b77\u3055\u308c\u305f\u30ab\u30fc\u30c9\u306e\u6709\u52b9\u671f\u9650\u65e5\u306e iframe","creditCard.encryptedExpiryDate.aria.label":"\u6709\u52b9\u671f\u9650","creditCard.encryptedExpiryMonth.aria.iframeTitle":"\u4fdd\u8b77\u3055\u308c\u305f\u30ab\u30fc\u30c9\u306e\u6709\u52b9\u671f\u9650\u6708\u306e iframe","creditCard.encryptedExpiryMonth.aria.label":"\u6709\u52b9\u671f\u9650\u6708","creditCard.encryptedExpiryYear.aria.iframeTitle":"\u4fdd\u8b77\u3055\u308c\u305f\u30ab\u30fc\u30c9\u306e\u6709\u52b9\u671f\u9650\u5e74\u306e iframe","creditCard.encryptedExpiryYear.aria.label":"\u6709\u52b9\u671f\u9650\u5e74","creditCard.encryptedSecurityCode.aria.iframeTitle":"\u4fdd\u8b77\u3055\u308c\u305f\u30ab\u30fc\u30c9\u306e\u30bb\u30ad\u30e5\u30ea\u30c6\u30a3\u30b3\u30fc\u30c9\u306e iframe","creditCard.encryptedSecurityCode.aria.label":"\u30bb\u30ad\u30e5\u30ea\u30c6\u30a3\u30b3\u30fc\u30c9","creditCard.encryptedPassword.aria.iframeTitle":"\u4fdd\u8b77\u3055\u308c\u305f\u30ab\u30fc\u30c9\u306e\u30d1\u30b9\u30ef\u30fc\u30c9\u306eiframe","creditCard.encryptedPassword.aria.label":"\u30ab\u30fc\u30c9\u306e\u30d1\u30b9\u30ef\u30fc\u30c9\u306e\u6700\u521d\u306e2\u6841","giftcard.encryptedCardNumber.aria.iframeTitle":"\u4fdd\u8b77\u3055\u308c\u305f\u30ae\u30d5\u30c8\u30ab\u30fc\u30c9\u756a\u53f7\u306e iframe","giftcard.encryptedCardNumber.aria.label":"\u30ae\u30d5\u30c8\u30ab\u30fc\u30c9\u756a\u53f7","giftcard.encryptedSecurityCode.aria.iframeTitle":"\u4fdd\u8b77\u3055\u308c\u305f\u30ae\u30d5\u30c8\u30ab\u30fc\u30c9\u306e\u30bb\u30ad\u30e5\u30ea\u30c6\u30a3\u30b3\u30fc\u30c9\u306e iframe","giftcard.encryptedSecurityCode.aria.label":"\u30ae\u30d5\u30c8\u30ab\u30fc\u30c9\u306e\u30bb\u30ad\u30e5\u30ea\u30c6\u30a3\u30b3\u30fc\u30c9",giftcardTransactionLimit:"\u3053\u306e\u30ae\u30d5\u30c8\u30ab\u30fc\u30c9\u3067\u306e\u53d6\u5f15\u3054\u3068\u306b\u8a31\u53ef\u3055\u308c\u308b\u6700\u5927%{amount}","ach.encryptedBankAccountNumber.aria.iframeTitle":"\u4fdd\u8b77\u3055\u308c\u305f\u9280\u884c\u53e3\u5ea7\u756a\u53f7\u306e iframe","ach.encryptedBankAccountNumber.aria.label":"\u9280\u884c\u53e3\u5ea7","ach.encryptedBankLocationId.aria.iframeTitle":"\u4fdd\u8b77\u3055\u308c\u305f\u9280\u884c\u652f\u5e97\u756a\u53f7\u306e iframe","ach.encryptedBankLocationId.aria.label":"\u9280\u884c\u652f\u5e97\u756a\u53f7","twint.saved":"\u3092\u4fdd\u5b58\u3057\u307e\u3057\u305f",orPayWith:"\u307e\u305f\u306f\u6b21\u306e\u65b9\u6cd5\u3067\u652f\u6255\u3046",invalidFormatExpects:"\u7121\u52b9\u306a\u5f62\u5f0f\u3067\u3059\u3002\u671f\u5f85\u3055\u308c\u308b\u5f62\u5f0f\uff1a %{format}","upi.qrCodeWaitingMessage":"\u304a\u597d\u307f\u306eUPI\u30a2\u30d7\u30ea\u3092\u4f7f\u7528\u3057\u3066QR\u30b3\u30fc\u30c9\u3092\u30b9\u30ad\u30e3\u30f3\u3057\u3001\u652f\u6255\u3092\u5b8c\u4e86\u3057\u3066\u304f\u3060\u3055\u3044","upi.vpaWaitingMessage":"UPI\u30a2\u30d7\u30ea\u3092\u958b\u3044\u3066\u3001\u652f\u6255\u3092\u78ba\u8a8d\u3057\u3066\u304f\u3060\u3055\u3044","upi.modeSelection":"UPI\u306e\u4f7f\u7528\u65b9\u6cd5\u3092\u9078\u629e\u3057\u307e\u3059\u3002","onlineBanking.termsAndConditions":"\u7d9a\u884c\u3059\u308b\u3068\u3001%#\u5229\u7528\u898f\u7d04%#\u306b\u540c\u610f\u3057\u305f\u3053\u3068\u306b\u306a\u308a\u307e\u3059","ctp.loading.poweredByCtp":"Click to Pay\u63d0\u4f9b","ctp.loading.intro":"Click to Pay\u306b\u30ab\u30fc\u30c9\u304c\u4fdd\u5b58\u3055\u308c\u3066\u3044\u308b\u304b\u3069\u3046\u304b\u3092\u78ba\u8a8d\u3057\u3066\u3044\u307e\u3059...","ctp.login.title":"Click to Pay\u306b\u9032\u3080","ctp.login.subtitle":"\u7d9a\u884c\u3059\u308b\u306b\u306f\u3001Click to Pay\u306b\u9023\u643a\u3055\u308c\u3066\u3044\u308b\u30e1\u30fc\u30eb\u30a2\u30c9\u30ec\u30b9\u3092\u5165\u529b\u3057\u3066\u304f\u3060\u3055\u3044\u3002","ctp.login.inputLabel":"\u30e1\u30fc\u30eb\u30a2\u30c9\u30ec\u30b9","ctp.logout.notYou":"\u3054\u81ea\u5206\u3067\u306f\u3042\u308a\u307e\u305b\u3093\u304b\uff1f","ctp.logout.notYourCards":"\u3054\u81ea\u5206\u306e\u30ab\u30fc\u30c9\u3067\u306f\u3042\u308a\u307e\u305b\u3093\u304b\uff1f","ctp.logout.notYourCard":"\u3054\u81ea\u5206\u306e\u30ab\u30fc\u30c9\u3067\u306f\u3042\u308a\u307e\u305b\u3093\u304b\uff1f","ctp.logout.notYourProfile":"\u3054\u81ea\u5206\u306e\u30d7\u30ed\u30d5\u30a3\u30fc\u30eb\u3067\u306f\u3042\u308a\u307e\u305b\u3093\u304b\uff1f","ctp.otp.fieldLabel":"\u30ef\u30f3\u30bf\u30a4\u30e0\u30b3\u30fc\u30c9","ctp.otp.resendCode":"\u30b3\u30fc\u30c9\u3092\u518d\u9001\u4fe1\u3059\u308b","ctp.otp.codeResent":"\u30b3\u30fc\u30c9\u304c\u518d\u9001\u4fe1\u3055\u308c\u307e\u3057\u305f","ctp.otp.title":"Click to Pay\u30ab\u30fc\u30c9\u306b\u30a2\u30af\u30bb\u30b9\u3059\u308b","ctp.otp.subtitle":"%@\u304b\u3089%@\u306b\u9001\u4fe1\u3055\u308c\u305f\u30b3\u30fc\u30c9\u3092\u5165\u529b\u3057\u3066\u3001\u3054\u672c\u4eba\u3067\u3042\u308b\u3053\u3068\u3092\u78ba\u8a8d\u3057\u3066\u304f\u3060\u3055\u3044\u3002","ctp.emptyProfile.message":"\u3053\u306eClick to Pay\u30d7\u30ed\u30d5\u30a3\u30fc\u30eb\u306b\u767b\u9332\u3055\u308c\u3066\u3044\u308b\u30ab\u30fc\u30c9\u306f\u3042\u308a\u307e\u305b\u3093\u3002","ctp.separatorText":"\u307e\u305f\u306f\u4ee5\u4e0b\u3092\u4f7f\u7528","ctp.cards.title":"Click to Pay\u3067\u652f\u6255\u3044\u3092\u5b8c\u4e86\u3059\u308b","ctp.cards.subtitle":"\u4f7f\u7528\u3059\u308b\u30ab\u30fc\u30c9\u3092\u9078\u629e\u3057\u3066\u304f\u3060\u3055\u3044\u3002","ctp.cards.expiredCard":"\u671f\u9650\u5207\u308c","ctp.manualCardEntry":"\u624b\u52d5\u30ab\u30fc\u30c9\u5165\u529b","ctp.aria.infoModalButton":"Click to Pay\u3068\u306f","ctp.infoPopup.title":"Click to Pay\u306f\u30aa\u30f3\u30e9\u30a4\u30f3\u3067\u975e\u63a5\u89e6\u578b\u30ab\u30fc\u30c9\u306e\u4f7f\u3044\u3084\u3059\u3055\u3092\u5b9f\u73fe\u3057\u307e\u3059","ctp.infoPopup.subtitle":"Mastercard\u3001Visa\u3001\u305d\u306e\u4ed6\u306e\u652f\u6255\u30ab\u30fc\u30c9\u3067\u30b5\u30dd\u30fc\u30c8\u3055\u308c\u3066\u3044\u308b\u9ad8\u901f\u3067\u5b89\u5168\u306a\u652f\u6255\u65b9\u6cd5\u3002","ctp.infoPopup.benefit1":"Click to Pay\u306f\u6697\u53f7\u5316\u3092\u4f7f\u7528\u3057\u3066\u60c5\u5831\u3092\u5b89\u5168\u306b\u4fdd\u8b77\u3057\u307e\u3059","ctp.infoPopup.benefit2":"\u4e16\u754c\u4e2d\u306e\u696d\u8005\u3067\u4f7f\u7528\u3067\u304d\u307e\u3059","ctp.infoPopup.benefit3":"\u4e00\u5ea6\u8a2d\u5b9a\u3059\u308b\u3060\u3051\u3067\u3001\u4eca\u5f8c\u306e\u652f\u6255\u3044\u304c\u7c21\u5358\u306b\u306a\u308a\u307e\u3059","ctp.errors.AUTH_INVALID":"\u8a8d\u8a3c\u304c\u7121\u52b9\u3067\u3059","ctp.errors.NOT_FOUND":"\u30a2\u30ab\u30a6\u30f3\u30c8\u304c\u898b\u3064\u304b\u308a\u307e\u305b\u3093\u3002\u6709\u52b9\u306a\u30e1\u30fc\u30eb\u30a2\u30c9\u30ec\u30b9\u3092\u5165\u529b\u3059\u308b\u304b\u3001\u30ab\u30fc\u30c9\u60c5\u5831\u3092\u624b\u52d5\u3067\u5165\u529b\u3057\u3066\u304f\u3060\u3055\u3044","ctp.errors.ID_FORMAT_UNSUPPORTED":"\u30b5\u30dd\u30fc\u30c8\u3055\u308c\u3066\u306a\u3044\u5f62\u5f0f\u3067\u3059","ctp.errors.FRAUD":"\u30e6\u30fc\u30b6\u30fc\u30a2\u30ab\u30a6\u30f3\u30c8\u304c\u30ed\u30c3\u30af\u3055\u308c\u3066\u3044\u308b\u304b\u7121\u52b9\u306b\u306a\u3063\u3066\u3044\u307e\u3059","ctp.errors.CONSUMER_ID_MISSING":"\u30ea\u30af\u30a8\u30b9\u30c8\u306b\u30b3\u30f3\u30b7\u30e5\u30fc\u30de\u30fcID\u304c\u3042\u308a\u307e\u305b\u3093","ctp.errors.ACCT_INACCESSIBLE":"\u30ed\u30c3\u30af\u3055\u308c\u3066\u3044\u308b\u306a\u3069\u306e\u7406\u7531\u306b\u3088\u308a\u3001\u3053\u306e\u30a2\u30ab\u30a6\u30f3\u30c8\u306f\u73fe\u5728\u5229\u7528\u3067\u304d\u307e\u305b\u3093\u3002","ctp.errors.CODE_INVALID":"\u78ba\u8a8d\u30b3\u30fc\u30c9\u304c\u6b63\u3057\u304f\u3042\u308a\u307e\u305b\u3093","ctp.errors.CODE_EXPIRED":"\u3053\u306e\u30b3\u30fc\u30c9\u306e\u6709\u52b9\u671f\u9650\u304c\u5207\u308c\u3066\u3044\u307e\u3059","ctp.errors.RETRIES_EXCEEDED":"\u30ef\u30f3\u30bf\u30a4\u30e0\u30d1\u30b9\u30ef\u30fc\u30c9\u751f\u6210\u306e\u30ea\u30c8\u30e9\u30a4\u56de\u6570\u304c\u4e0a\u9650\u3092\u8d85\u3048\u307e\u3057\u305f","ctp.errors.OTP_SEND_FAILED":"\u30ef\u30f3\u30bf\u30a4\u30e0\u30d1\u30b9\u30ef\u30fc\u30c9\u3092\u53d7\u4fe1\u8005\u306b\u9001\u4fe1\u3067\u304d\u307e\u305b\u3093\u3067\u3057\u305f","ctp.errors.REQUEST_TIMEOUT":"\u554f\u984c\u304c\u767a\u751f\u3057\u307e\u3057\u305f\u3002\u518d\u5ea6\u304a\u8a66\u3057\u3044\u305f\u3060\u304f\u304b\u3001\u30ab\u30fc\u30c9\u60c5\u5831\u3092\u624b\u52d5\u3067\u5165\u529b\u3057\u3066\u304f\u3060\u3055\u3044\u3002","ctp.errors.UNKNOWN_ERROR":"\u554f\u984c\u304c\u767a\u751f\u3057\u307e\u3057\u305f\u3002\u518d\u5ea6\u304a\u8a66\u3057\u3044\u305f\u3060\u304f\u304b\u3001\u30ab\u30fc\u30c9\u60c5\u5831\u3092\u624b\u52d5\u3067\u5165\u529b\u3057\u3066\u304f\u3060\u3055\u3044\u3002","ctp.errors.SERVICE_ERROR":"\u554f\u984c\u304c\u767a\u751f\u3057\u307e\u3057\u305f\u3002\u518d\u5ea6\u304a\u8a66\u3057\u3044\u305f\u3060\u304f\u304b\u3001\u30ab\u30fc\u30c9\u60c5\u5831\u3092\u624b\u52d5\u3067\u5165\u529b\u3057\u3066\u304f\u3060\u3055\u3044\u3002","ctp.errors.SERVER_ERROR":"\u554f\u984c\u304c\u767a\u751f\u3057\u307e\u3057\u305f\u3002\u518d\u5ea6\u304a\u8a66\u3057\u3044\u305f\u3060\u304f\u304b\u3001\u30ab\u30fc\u30c9\u60c5\u5831\u3092\u624b\u52d5\u3067\u5165\u529b\u3057\u3066\u304f\u3060\u3055\u3044\u3002","ctp.errors.INVALID_PARAMETER":"\u554f\u984c\u304c\u767a\u751f\u3057\u307e\u3057\u305f\u3002\u518d\u5ea6\u304a\u8a66\u3057\u3044\u305f\u3060\u304f\u304b\u3001\u30ab\u30fc\u30c9\u60c5\u5831\u3092\u624b\u52d5\u3067\u5165\u529b\u3057\u3066\u304f\u3060\u3055\u3044\u3002","ctp.errors.AUTH_ERROR":"\u554f\u984c\u304c\u767a\u751f\u3057\u307e\u3057\u305f\u3002\u518d\u5ea6\u304a\u8a66\u3057\u3044\u305f\u3060\u304f\u304b\u3001\u30ab\u30fc\u30c9\u60c5\u5831\u3092\u624b\u52d5\u3067\u5165\u529b\u3057\u3066\u304f\u3060\u3055\u3044\u3002","paymentMethodsList.aria.label":"\u304a\u652f\u6255\u3044\u65b9\u6cd5\u3092\u9078\u629e\u3057\u3066\u304f\u3060\u3055\u3044"}}),I3=Object.freeze({__proto__:null,default:{payButton:"\uacb0\uc81c","payButton.redirecting":"\ub9ac\ub514\ub809\uc158 \uc911...","payButton.with":"%{maskedData}(\uc73c)\ub85c %{value} \uacb0\uc81c",close:"\ub2eb\uae30",storeDetails:"\ub2e4\uc74c \uacb0\uc81c\ub97c \uc704\ud574 \uc774 \uc218\ub2e8 \uc800\uc7a5","creditCard.holderName":"\uce74\ub4dc\uc0c1\uc758 \uc774\ub984","creditCard.holderName.placeholder":"J. Smith","creditCard.holderName.invalid":"\uc720\ud6a8\ud558\uc9c0 \uc54a\uc740 \uce74\ub4dc \uc18c\uc720\uc790 \uc774\ub984","creditCard.numberField.title":"\uce74\ub4dc \ubc88\ud638","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"\ub9cc\ub8cc\uc77c","creditCard.expiryDateField.placeholder":"MM/YY","creditCard.expiryDateField.month":"\uc6d4","creditCard.expiryDateField.month.placeholder":"MM","creditCard.expiryDateField.year.placeholder":"YY","creditCard.expiryDateField.year":"\uc5f0\ub3c4","creditCard.cvcField.title":"CVC / CVV","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"\ub2e4\uc74c\uc744 \uc704\ud574 \uc800\uc7a5","creditCard.cvcField.placeholder.4digits":"4\uc790\ub9ac","creditCard.cvcField.placeholder.3digits":"3\uc790\ub9ac","creditCard.taxNumber.placeholder":"YYMMDD / 0123456789",installments:"\ud560\ubd80 \uac1c\uc6d4 \uc218",installmentOption:"%{times}x %{partialValue}",installmentOptionMonths:"%{times}\uac1c\uc6d4","installments.oneTime":"\uc77c\uc2dc\ubd88 \uacb0\uc81c","installments.installments":"\ud560\ubd80 \uacb0\uc81c","installments.revolving":"\ub9ac\ubcfc\ube59 \uacb0\uc81c","sepaDirectDebit.ibanField.invalid":"\uc720\ud6a8\ud558\uc9c0 \uc54a\uc740 \uacc4\uc88c \ubc88\ud638","sepaDirectDebit.nameField.placeholder":"J. Smith","sepa.ownerName":"\uc18c\uc720\uc790 \uc774\ub984","sepa.ibanNumber":"\uacc4\uc88c \ubc88\ud638(IBAN)","error.title":"\uc624\ub958","error.subtitle.redirect":"\ub9ac\ub514\ub809\uc158 \uc2e4\ud328","error.subtitle.payment":"\uacb0\uc81c \uc2e4\ud328","error.subtitle.refused":"\uacb0\uc81c \uac70\ubd80","error.message.unknown":"\uc54c \uc218 \uc5c6\ub294 \uc624\ub958 \ubc1c\uc0dd","errorPanel.title":"\uae30\uc874 \uc624\ub958","idealIssuer.selectField.title":"\uc740\ud589","idealIssuer.selectField.placeholder":"\uc740\ud589 \uc120\ud0dd","creditCard.success":"\uacb0\uc81c \uc131\uacf5",loading:"\ub85c\ub4dc \uc911\u2026",continue:"\uacc4\uc18d",continueTo:"\ub2e4\uc74c\uc73c\ub85c \uacc4\uc18d:","wechatpay.timetopay":"\ub0a8\uc740 \uacb0\uc81c \uc2dc\ud55c: %@","wechatpay.scanqrcode":"QR \ucf54\ub4dc \uc2a4\uce94",personalDetails:"\uac1c\uc778 \uc815\ubcf4",companyDetails:"\ud68c\uc0ac \uc815\ubcf4","companyDetails.name":"\ud68c\uc0ac\uba85","companyDetails.registrationNumber":"\ub4f1\ub85d \ubc88\ud638",socialSecurityNumber:"\uc0ac\ud68c \ubcf4\uc7a5 \ubc88\ud638(\uc8fc\ubbfc\ub4f1\ub85d\ubc88\ud638)",firstName:"\uc774\ub984","firstName.invalid":"\uc774\ub984\uc774 \uc62c\ubc14\ub974\uc9c0 \uc54a\uc2b5\ub2c8\ub2e4",infix:"\uba85\uce6d",lastName:"\uc131","lastName.invalid":"\uc131\uc774 \uc62c\ubc14\ub974\uc9c0 \uc54a\uc2b5\ub2c8\ub2e4",mobileNumber:"\ud734\ub300\ud3f0 \ubc88\ud638","mobileNumber.invalid":"\uc720\ud6a8\ud558\uc9c0 \uc54a\uc740 \ud734\ub300\ud3f0 \ubc88\ud638",city:"\uc2dc",postalCode:"\uc6b0\ud3b8\ubc88\ud638","postalCode.optional":"\uc6b0\ud3b8\ubc88\ud638(\uc120\ud0dd \uc0ac\ud56d)",countryCode:"\uad6d\uac00 \ucf54\ub4dc",telephoneNumber:"\uc804\ud654\ubc88\ud638",dateOfBirth:"\uc0dd\ub144\uc6d4\uc77c",shopperEmail:"\uc774\uba54\uc77c \uc8fc\uc18c",gender:"\uc131\ubcc4",male:"\ub0a8\uc131",female:"\uc5ec\uc131",billingAddress:"\uccad\uad6c\uc9c0 \uc8fc\uc18c",street:"\ub3c4\ub85c\uba85",stateOrProvince:"\uc8fc/\ub3c4",country:"\uad6d\uac00",houseNumberOrName:"\uc9d1 \uc804\ud654\ubc88\ud638",separateDeliveryAddress:"\ubc30\uc1a1 \uc8fc\uc18c \ubcc4\ub3c4 \uc9c0\uc815",deliveryAddress:"\ubc30\uc1a1 \uc8fc\uc18c",zipCode:"\uc6b0\ud3b8\ubc88\ud638",apartmentSuite:"\uc544\ud30c\ud2b8/\uac74\ubb3c",provinceOrTerritory:"\ub3c4",cityTown:"\uc2dc/\uad6c",address:"\uc8fc\uc18c",state:"\uc8fc","field.title.optional":"(\uc120\ud0dd \uc0ac\ud56d)","creditCard.cvcField.title.optional":"CVC / CVV (\uc120\ud0dd)","issuerList.wallet.placeholder":"\uc804\uc790 \uc9c0\uac11 \uc120\ud0dd",privacyPolicy:"\uac1c\uc778\uc815\ubcf4 \ubcf4\ud638\uc815\ucc45","afterPay.agreement":"AfterPay\uc758 %@\uc5d0 \ub3d9\uc758\ud569\ub2c8\ub2e4.",paymentConditions:"\uacb0\uc81c \uc870\uac74",openApp:"\uc571 \uc5f4\uae30","voucher.readInstructions":"\uc548\ub0b4 \uc77d\uae30","voucher.introduction":"\uad6c\ub9e4\ud574 \uc8fc\uc154\uc11c \uac10\uc0ac\ud569\ub2c8\ub2e4. \ub2e4\uc74c \ucfe0\ud3f0\uc744 \uc0ac\uc6a9\ud558\uc5ec \uacb0\uc81c\ub97c \uc644\ub8cc\ud558\uc2ed\uc2dc\uc624.","voucher.expirationDate":"\ub9cc\ub8cc\uc77c","voucher.alternativeReference":"\ub300\uccb4 \ucc38\uc870\ubc88\ud638","dragonpay.voucher.non.bank.selectField.placeholder":"\uc81c\uacf5 \uc5c5\uccb4 \uc120\ud0dd","dragonpay.voucher.bank.selectField.placeholder":"\uc740\ud589 \uc120\ud0dd","voucher.paymentReferenceLabel":"\uacb0\uc81c \ucc38\uc870\ubc88\ud638","voucher.surcharge":"%@ \ud560\uc99d\ub8cc \ud3ec\ud568","voucher.introduction.doku":"\uad6c\ub9e4\ud574 \uc8fc\uc154\uc11c \uac10\uc0ac\ud569\ub2c8\ub2e4. \ub2e4\uc74c \uc815\ubcf4\ub97c \uc774\uc6a9\ud558\uc5ec \uacb0\uc81c\ub97c \uc644\ub8cc\ud558\uc2ed\uc2dc\uc624.","voucher.shopperName":"\uad6c\ub9e4\uc790 \uc774\ub984","voucher.merchantName":"\uac00\ub9f9\uc810","voucher.introduction.econtext":"\uad6c\ub9e4\ud574 \uc8fc\uc154\uc11c \uac10\uc0ac\ud569\ub2c8\ub2e4. \ub2e4\uc74c \uc815\ubcf4\ub97c \uc774\uc6a9\ud558\uc5ec \uacb0\uc81c\ub97c \uc644\ub8cc\ud558\uc2ed\uc2dc\uc624.","voucher.telephoneNumber":"\uc804\ud654\ubc88\ud638","voucher.shopperReference":"\uad6c\ub9e4\uc790 \ucc38\uc870\ubc88\ud638","voucher.collectionInstitutionNumber":"\uc218\uae08 \uae30\uad00 \ubc88\ud638","voucher.econtext.telephoneNumber.invalid":"\uc804\ud654\ubc88\ud638\ub294 10\uc790\ub9ac \ub610\ub294 11\uc790\ub9ac \uc22b\uc790\uc5ec\uc57c \ud569\ub2c8\ub2e4","boletobancario.btnLabel":"Boleto \uc0dd\uc131","boleto.sendCopyToEmail":"\ub0b4 \uc774\uba54\uc77c\ub85c \uc0ac\ubcf8 \ubcf4\ub0b4\uae30","button.copy":"\ubcf5\uc0ac","button.download":"\ub2e4\uc6b4\ub85c\ub4dc","boleto.socialSecurityNumber.invalid":"\uc720\ud6a8\ud558\uc9c0 \uc54a\uc740 \ud544\ub4dc\uc785\ub2c8\ub2e4","creditCard.storedCard.description.ariaLabel":"\uc800\uc7a5\ub41c \uce74\ub4dc\ub294 %@ \ud6c4 \uc885\ub8cc\ub429\ub2c8\ub2e4.","voucher.entity":"\ubc1c\uae09\uc0ac",donateButton:"\uae30\ubd80\ud558\uae30",notNowButton:"\ub2e4\uc74c\uc5d0 \ud558\uae30",thanksForYourSupport:"\ub3c4\uc640\uc8fc\uc154\uc11c \uac10\uc0ac\ud569\ub2c8\ub2e4!",preauthorizeWith:"\uc0ac\uc804 \uc2b9\uc778 \ubc29\ubc95:",confirmPreauthorization:"\uc0ac\uc804 \uc2b9\uc778 \ud655\uc778",confirmPurchase:"\uad6c\ub9e4 \ud655\uc778",applyGiftcard:"\uae30\ud504\ud2b8 \uce74\ub4dc\ub85c \uacb0\uc81c",giftcardBalance:"\uae30\ud504\ud2b8 \uce74\ub4dc \uc794\uc561",deductedBalance:"\uacf5\uc81c \uc794\uc561","creditCard.pin.title":"\ube44\ubc00\ubc88\ud638","creditCard.encryptedPassword.label":"\uce74\ub4dc \ube44\ubc00\ubc88\ud638 \uccab 2\uc790\ub9ac","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"\uc720\ud6a8\ud558\uc9c0 \uc54a\uc740 \ubc88\ud638","creditCard.taxNumber":"\uce74\ub4dc \uc18c\uc720\uc790 \uc0dd\ub144\uc6d4\uc77c \ub610\ub294 \ubc95\uc778 \ub4f1\ub85d \ubc88\ud638","creditCard.taxNumber.label":"\uce74\ub4dc \uc18c\uc720\uc790 \uc0dd\ub144\uc6d4\uc77c(\uc608: 870130) \ub610\ub294 \ubc95\uc778 \ub4f1\ub85d \ubc88\ud638(10\uc790\ub9ac)","creditCard.taxNumber.labelAlt":"\ubc95\uc778 \ub4f1\ub85d \ubc88\ud638(10\uc790\ub9ac)","creditCard.taxNumber.invalid":"\uc720\ud6a8\ud558\uc9c0 \uc54a\uc740 \uce74\ub4dc \uc18c\uc720\uc790 \uc0dd\ub144\uc6d4\uc77c \ub610\ub294 \ubc95\uc778 \ub4f1\ub85d \ubc88\ud638","storedPaymentMethod.disable.button":"\uc0ad\uc81c","storedPaymentMethod.disable.confirmation":"\uc800\uc7a5\ub41c \uacb0\uc81c \uc218\ub2e8 \uc0ad\uc81c","storedPaymentMethod.disable.confirmButton":"\uc608, \uc0ad\uc81c\ud569\ub2c8\ub2e4","storedPaymentMethod.disable.cancelButton":"\ucde8\uc18c","ach.bankAccount":"\uc740\ud589 \uacc4\uc88c","ach.accountHolderNameField.title":"\uacc4\uc88c \uc18c\uc720\uc790 \uc774\ub984","ach.accountHolderNameField.placeholder":"J. Smith","ach.accountHolderNameField.invalid":"\uc720\ud6a8\ud558\uc9c0 \uc54a\uc740 \uacc4\uc88c \uc18c\uc720\uc790 \uc774\ub984","ach.accountNumberField.title":"\uacc4\uc88c \ubc88\ud638","ach.accountNumberField.invalid":"\uc720\ud6a8\ud558\uc9c0 \uc54a\uc740 \uacc4\uc88c \ubc88\ud638","ach.accountLocationField.title":"ABA \ub77c\uc6b0\ud305 \ubc88\ud638","ach.accountLocationField.invalid":"\uc720\ud6a8\ud558\uc9c0 \uc54a\uc740 ABA \ub77c\uc6b0\ud305 \ubc88\ud638","ach.savedBankAccount":"\uc800\uc7a5\ub41c \uc740\ud589 \uacc4\uc88c","select.state":"\uc8fc \uc120\ud0dd","select.stateOrProvince":"\uc8fc/\ub3c4 \uc120\ud0dd","select.provinceOrTerritory":"\ub3c4 \uc120\ud0dd","select.country":"\uad6d\uac00 \uc120\ud0dd","select.noOptionsFound":"\uac80\uc0c9\ub41c \uc635\uc158 \uc5c6\uc74c","select.filter.placeholder":"\uac80\uc0c9...","telephoneNumber.invalid":"\uc720\ud6a8\ud558\uc9c0 \uc54a\uc740 \uc804\ud654\ubc88\ud638",qrCodeOrApp:"\ub610\ub294","paypal.processingPayment":"\uacb0\uc81c \ucc98\ub9ac \uc911...",generateQRCode:"QR \ucf54\ub4dc \uc0dd\uc131","await.waitForConfirmation":"\ud655\uc778 \ub300\uae30\uc911","mbway.confirmPayment":"MB WAY \uc571\uc5d0\uc11c \uacb0\uc81c\ub97c \ud655\uc778\ud558\uc2ed\uc2dc\uc624","shopperEmail.invalid":"\uc720\ud6a8\ud558\uc9c0 \uc54a\uc740 \uc774\uba54\uc77c \uc8fc\uc18c","dateOfBirth.format":"DD(\uc77c)/MM(\uc6d4)/YYYY(\uc5f0\ub3c4)","dateOfBirth.invalid":"\ucd5c\uc18c 18\uc138 \uc774\uc0c1\uc774\uc5b4\uc57c \ud569\ub2c8\ub2e4","blik.confirmPayment":"\ubc45\ud0b9 \uc571\uc744 \uc5f4\uc5b4\uc11c \uacb0\uc81c\ub97c \ud655\uc778\ud558\uc138\uc694.","blik.invalid":"6\uc790\ub9ac \uc22b\uc790 \uc785\ub825","blik.code":"6\uc790\ub9ac \ucf54\ub4dc","blik.help":"\ubc45\ud0b9 \uc571\uc5d0\uc11c \ucf54\ub4dc\ub97c \uac00\uc838\uc624\uc138\uc694.","swish.pendingMessage":"\uc2a4\uce94 \ud6c4 \ucd5c\ub300 10\ubd84 \ub3d9\uc548 \uc0c1\ud0dc\uac00 \ubcf4\ub958\ub420 \uc218 \uc788\uc2b5\ub2c8\ub2e4. 10\ubd84 \ub0b4\uc5d0 \ub2e4\uc2dc \uc2dc\ub3c4\ud560 \uacbd\uc6b0 \uae08\uc561\uc774 \uc5ec\ub7ec \ubc88 \uccad\uad6c\ub420 \uc218 \uc788\uc2b5\ub2c8\ub2e4.","field.valid":"\ud544\ub4dc\uac00 \uc720\ud6a8\ud569\ub2c8\ub2e4","field.invalid":"\ud544\ub4dc\uac00 \uc720\ud6a8\ud558\uc9c0 \uc54a\uc2b5\ub2c8\ub2e4","error.va.gen.01":"\ubbf8\uc644\ub8cc \ud544\ub4dc","error.va.gen.02":"\ud544\ub4dc\uac00 \uc720\ud6a8\ud558\uc9c0 \uc54a\uc2b5\ub2c8\ub2e4","error.va.sf-cc-num.01":"\uce74\ub4dc \ubc88\ud638\uac00 \uc720\ud6a8\ud558\uc9c0 \uc54a\uc2b5\ub2c8\ub2e4","error.va.sf-cc-num.02":"\uce74\ub4dc \ubc88\ud638 \uc785\ub825\ub780\uc774 \ube44\uc5b4 \uc788\uc2b5\ub2c8\ub2e4","error.va.sf-cc-num.03":"\uc9c0\uc6d0\ub418\uc9c0 \uc54a\ub294 \uce74\ub4dc \ubc88\ud638\ub97c \uc785\ub825\ud558\uc600\uc2b5\ub2c8\ub2e4","error.va.sf-cc-num.04":"\uce74\ub4dc \ubc88\ud638 \uae38\uc774\uac00 \uc815\ud655\ud558\uc9c0 \uc54a\uc2b5\ub2c8\ub2e4","error.va.sf-cc-dat.01":"\ub9cc\ub8cc \ub0a0\uc9dc: \uc774\ubbf8 \ub9cc\ub8cc\ub41c \uce74\ub4dc\uc785\ub2c8\ub2e4","error.va.sf-cc-dat.02":"\ub9cc\ub8cc \ub0a0\uc9dc: \ud604\uc7ac\ub85c\ubd80\ud130 \ub108\ubb34 \uba3c \ub0a0\uc9dc\uc785\ub2c8\ub2e4","error.va.sf-cc-dat.03":"\ub9cc\ub8cc \ub0a0\uc9dc: \uadc0\ud558\uc758 \uce74\ub4dc\uac00 \uacb0\uc81c\uc77c \uc804\uc5d0 \ub9cc\ub8cc\ub429\ub2c8\ub2e4","error.va.sf-cc-dat.04":"\ub9cc\ub8cc \ub0a0\uc9dc \uc785\ub825\ub780\uc774 \ube44\uc5b4 \uc788\uc2b5\ub2c8\ub2e4","error.va.sf-cc-dat.05":"\ub9cc\ub8cc \ub0a0\uc9dc \uae38\uc774\uac00 \uc815\ud655\ud558\uc9c0 \uc54a\uc2b5\ub2c8\ub2e4","error.va.sf-cc-mth.01":"\ub9cc\ub8cc \uc6d4 \uc785\ub825\ub780\uc774 \ube44\uc5b4 \uc788\uc2b5\ub2c8\ub2e4","error.va.sf-cc-yr.01":"\ub9cc\ub8cc \uc5f0\ub3c4 \uc785\ub825\ub780\uc774 \ube44\uc5b4 \uc788\uc2b5\ub2c8\ub2e4","error.va.sf-cc-yr.02":"\ub9cc\ub8cc \uc5f0\ub3c4 \uae38\uc774\uac00 \uc815\ud655\ud558\uc9c0 \uc54a\uc2b5\ub2c8\ub2e4","error.va.sf-cc-cvc.01":"\ubcf4\uc548 \ucf54\ub4dc \uc785\ub825\ub780\uc774 \ube44\uc5b4 \uc788\uc2b5\ub2c8\ub2e4","error.va.sf-cc-cvc.02":"\ubcf4\uc548 \ucf54\ub4dc \uae38\uc774\uac00 \uc815\ud655\ud558\uc9c0 \uc54a\uc2b5\ub2c8\ub2e4","error.va.sf-ach-num.01":"\uacc4\uc88c \ubc88\ud638 \uc785\ub825\ub780\uc774 \ube44\uc5b4 \uc788\uc2b5\ub2c8\ub2e4","error.va.sf-ach-num.02":"\uacc4\uc88c \ubc88\ud638 \uae38\uc774\uac00 \uc815\ud655\ud558\uc9c0 \uc54a\uc2b5\ub2c8\ub2e4","error.va.sf-ach-loc.01":"\uc740\ud589 \ub77c\uc6b0\ud305 \ubc88\ud638 \uc785\ub825\ub780\uc774 \ube44\uc5b4 \uc788\uc2b5\ub2c8\ub2e4","error.va.sf-ach-loc.02":"\uc740\ud589 \ub77c\uc6b0\ud305 \ubc88\ud638 \uae38\uc774\uac00 \uc815\ud655\ud558\uc9c0 \uc54a\uc2b5\ub2c8\ub2e4","error.va.sf-kcp-pwd.01":"\ube44\ubc00\ubc88\ud638 \uc785\ub825\ub780\uc774 \ube44\uc5b4 \uc788\uc2b5\ub2c8\ub2e4","error.va.sf-kcp-pwd.02":"\ube44\ubc00\ubc88\ud638 \uae38\uc774\uac00 \uc798\ubabb\ub418\uc5c8\uc2b5\ub2c8\ub2e4","error.giftcard.no-balance":"\uc774 \uae30\ud504\ud2b8 \uce74\ub4dc\uc5d0\ub294 \uc794\uc561\uc774 \uc5c6\uc2b5\ub2c8\ub2e4","error.giftcard.card-error":"\uc774 \uae30\ud504\ud2b8 \uce74\ub4dc \ubc88\ud638\ub294 \ub2f9\uc0ac\uc5d0 \ub4f1\ub85d\ub418\uc5b4 \uc788\uc9c0 \uc54a\uc2b5\ub2c8\ub2e4","error.giftcard.currency-error":"\uae30\ud504\ud2b8 \uce74\ub4dc\ub294 \ubc1c\uae09\ub41c \ud1b5\ud654\ub85c\ub9cc \uc0ac\uc6a9\ud558\uc2e4 \uc218 \uc788\uc2b5\ub2c8\ub2e4","amazonpay.signout":"Amazon\uc5d0\uc11c \ub85c\uadf8\uc544\uc6c3","amazonpay.changePaymentDetails":"\uacb0\uc81c \uc815\ubcf4 \ubcc0\uacbd","partialPayment.warning":"\ub098\uba38\uc9c0 \ube44\uc6a9 \uc9c0\ubd88\uc5d0 \uc0ac\uc6a9\ud560 \ub2e4\ub978 \uacb0\uc81c \uc218\ub2e8 \uc120\ud0dd\ud558\uae30","partialPayment.remainingBalance":"\ub0a8\uc740 \uc794\uc561\uc740 %{amount}\uc785\ub2c8\ub2e4","bankTransfer.beneficiary":"\uc218\ub839\uc778","bankTransfer.iban":"IBAN","bankTransfer.bic":"BIC","bankTransfer.reference":"\ucc38\uc870 \ubc88\ud638","bankTransfer.introduction":"\uc0c8 \uacc4\uc88c \uc774\uccb4 \uac74\uc744 \uacc4\uc18d \uc9c4\ud589\ud569\ub2c8\ub2e4. \ub2e4\uc74c \ud654\uba74\uc5d0 \ub098\uc624\ub294 \uc815\ubcf4\ub97c \uc774\uc6a9\ud574 \uc774\uccb4\ub97c \uc644\ub8cc\ud558\uc2e4 \uc218 \uc788\uc2b5\ub2c8\ub2e4.","bankTransfer.instructions":"\uad6c\ub9e4\ud574 \uc8fc\uc154\uc11c \uac10\uc0ac\ud569\ub2c8\ub2e4. \ub2e4\uc74c \uc815\ubcf4\ub97c \uc774\uc6a9\ud558\uc5ec \uacb0\uc81c\ub97c \uc644\ub8cc\ud558\uc2ed\uc2dc\uc624.","bacs.accountHolderName":"\uc608\uae08\uc8fc \uc774\ub984","bacs.accountHolderName.invalid":"\uc608\uae08\uc8fc \uc774\ub984\uc774 \uc720\ud6a8\ud558\uc9c0 \uc54a\uc2b5\ub2c8\ub2e4","bacs.accountNumber":"\uacc4\uc88c \ubc88\ud638","bacs.accountNumber.invalid":"\uacc4\uc88c \ubc88\ud638\uac00 \uc720\ud6a8\ud558\uc9c0 \uc54a\uc2b5\ub2c8\ub2e4","bacs.bankLocationId":"\uc740\ud589 \uc2dd\ubcc4 \ucf54\ub4dc","bacs.bankLocationId.invalid":"\uc740\ud589 \uc2dd\ubcc4 \ucf54\ub4dc\uac00 \uc720\ud6a8\ud558\uc9c0 \uc54a\uc2b5\ub2c8\ub2e4","bacs.consent.amount":"\uacc4\uc88c\uc5d0\uc11c \uc704\uc758 \uae08\uc561\uc744 \uc774\uccb4\ud558\ub294 \uac83\uc5d0 \ub3d9\uc758\ud569\ub2c8\ub2e4.","bacs.consent.account":"\ubcf8\uc778\uc774 \uc774 \uacc4\uc88c\uc758 \uc608\uae08\uc8fc\uc774\uba70, \uc774 \uacc4\uc88c\uc5d0\uc11c\uc758 \uc790\ub3d9 \uc774\uccb4\ub97c \uc2b9\uc778\ud558\uae30 \uc704\ud574 \ud544\uc694\ud55c \uc720\uc77c\ud55c \uc11c\uba85\uc778\uc785\ub2c8\ub2e4.",edit:"\uc218\uc815","bacs.confirm":"\ud655\uc778 \ubc0f \uacb0\uc81c","bacs.result.introduction":"\uc790\ub3d9 \uc774\uccb4 \uc548\ub0b4(DDI/\ud544\uc218) \ub2e4\uc6b4\ub85c\ub4dc","download.pdf":"PDF \ub2e4\uc6b4\ub85c\ub4dc","creditCard.encryptedCardNumber.aria.iframeTitle":"\uce74\ub4dc \ubc88\ud638 \ubcf4\uc548\uc744 \uc704\ud55c Iframe","creditCard.encryptedCardNumber.aria.label":"\uce74\ub4dc \ubc88\ud638","creditCard.encryptedExpiryDate.aria.iframeTitle":"\uce74\ub4dc \ub9cc\ub8cc \ub0a0\uc9dc \ubcf4\uc548\uc744 \uc704\ud55c Iframe","creditCard.encryptedExpiryDate.aria.label":"\ub9cc\ub8cc\uc77c","creditCard.encryptedExpiryMonth.aria.iframeTitle":"\uce74\ub4dc \ub9cc\ub8cc \uc6d4 \ubcf4\uc548\uc744 \uc704\ud55c Iframe","creditCard.encryptedExpiryMonth.aria.label":"\ub9cc\ub8cc \uc6d4","creditCard.encryptedExpiryYear.aria.iframeTitle":"\uce74\ub4dc \ub9cc\ub8cc \uc5f0\ub3c4 \ubcf4\uc548\uc744 \uc704\ud55c Iframe","creditCard.encryptedExpiryYear.aria.label":"\ub9cc\ub8cc \uc5f0\ub3c4","creditCard.encryptedSecurityCode.aria.iframeTitle":"\uce74\ub4dc \ubcf4\uc548 \ucf54\ub4dc \ubcf4\uc548\uc744 \uc704\ud55c Iframe","creditCard.encryptedSecurityCode.aria.label":"\ubcf4\uc548 \ucf54\ub4dc","creditCard.encryptedPassword.aria.iframeTitle":"\ubcf4\uc548 \uce74\ub4dc \ube44\ubc00\ubc88\ud638\uc6a9 Iframe","creditCard.encryptedPassword.aria.label":"\uce74\ub4dc \ube44\ubc00\ubc88\ud638 \uccab 2\uc790\ub9ac","giftcard.encryptedCardNumber.aria.iframeTitle":"\uae30\ud504\ud2b8 \uce74\ub4dc \ubc88\ud638 \ubcf4\uc548\uc744 \uc704\ud55c Iframe","giftcard.encryptedCardNumber.aria.label":"\uae30\ud504\ud2b8 \uce74\ub4dc \ubc88\ud638","giftcard.encryptedSecurityCode.aria.iframeTitle":"\uae30\ud504\ud2b8 \uce74\ub4dc \ubcf4\uc548 \ucf54\ub4dc \ubcf4\uc548\uc744 \uc704\ud55c Iframe","giftcard.encryptedSecurityCode.aria.label":"\uae30\ud504\ud2b8 \uce74\ub4dc \ubcf4\uc548 \ucf54\ub4dc",giftcardTransactionLimit:"\uc774 \uae30\ud504\ud2b8\uce74\ub4dc\ub85c \uac74\ub2f9 \uacb0\uc81c \uac00\ub2a5\ud55c \ucd5c\uace0 \uc561\uc218\ub294 %{amount}","ach.encryptedBankAccountNumber.aria.iframeTitle":"\uc740\ud589 \uacc4\uc88c \ubc88\ud638 \ubcf4\uc548\uc744 \uc704\ud55c Iframe","ach.encryptedBankAccountNumber.aria.label":"\uc740\ud589 \uacc4\uc88c","ach.encryptedBankLocationId.aria.iframeTitle":"\uc740\ud589 \ub77c\uc6b0\ud305 \ubc88\ud638 \ubcf4\uc548\uc744 \uc704\ud55c Iframe","ach.encryptedBankLocationId.aria.label":"\uc740\ud589 \ub77c\uc6b0\ud305 \ubc88\ud638","twint.saved":"\uc800\uc7a5\ub428",orPayWith:"\uae30\ud0c0 \uacb0\uc81c \uc218\ub2e8:",invalidFormatExpects:"\uc720\ud6a8\ud558\uc9c0 \uc54a\uc740 \ud615\uc2dd\uc785\ub2c8\ub2e4. \uc608\uc0c1 \ud615\uc2dd: %{format}","upi.qrCodeWaitingMessage":"\uc990\uaca8 \uc4f0\ub294 UPI \uc571\uc73c\ub85c QR \ucf54\ub4dc\ub97c \uc2a4\uce94\ud558\uc5ec \uacb0\uc81c\ud558\uc138\uc694","upi.vpaWaitingMessage":"UPI \uc571\uc744 \uc5f4\uc5b4 \uacb0\uc81c\ub97c \ud655\uc778\ud558\uc138\uc694","upi.modeSelection":"UPI\ub97c \uc0ac\uc6a9\ud560 \ubc29\uc2dd\uc744 \uc120\ud0dd\ud558\uc138\uc694.","onlineBanking.termsAndConditions":"\uacc4\uc18d \uc9c4\ud589\ud558\ub294 \uacbd\uc6b0 %#\uc774\uc6a9\uc57d\uad00%#\uc5d0 \ub3d9\uc758\ud558\uac8c \ub429\ub2c8\ub2e4.","ctp.loading.poweredByCtp":"Click to Pay \uc81c\uacf5","ctp.loading.intro":"Click to Pay\ub85c \uc800\uc7a5\ub41c \uce74\ub4dc\uac00 \uc788\ub294\uc9c0 \ud655\uc778 \uc911\uc785\ub2c8\ub2e4...","ctp.login.title":"Click to Pay \uacc4\uc18d \uc9c4\ud589","ctp.login.subtitle":"\uacc4\uc18d\ud558\ub824\uba74 Click to Pay\uc5d0 \uc5f0\uacb0\ub41c \uc774\uba54\uc77c \uc8fc\uc18c\ub97c \uc785\ub825\ud558\uc138\uc694.","ctp.login.inputLabel":"\uc774\uba54\uc77c","ctp.logout.notYou":"\ubcf8\uc778\uc774 \uc544\ub2c8\uc2e0\uac00\uc694?","ctp.logout.notYourCards":"\ubcf8\uc778\uc758 \uce74\ub4dc\uac00 \uc544\ub2cc\uac00\uc694?","ctp.logout.notYourCard":"\ubcf8\uc778\uc758 \uce74\ub4dc\uac00 \uc544\ub2cc\uac00\uc694?","ctp.logout.notYourProfile":"\ubcf8\uc778\uc758 \ud504\ub85c\ud544\uc774 \uc544\ub2cc\uac00\uc694?","ctp.otp.fieldLabel":"\uc77c\ud68c\uc131 \ucf54\ub4dc","ctp.otp.resendCode":"\ucf54\ub4dc \uc7ac\uc804\uc1a1","ctp.otp.codeResent":"\ucf54\ub4dc \uc7ac\uc804\uc1a1\ub428","ctp.otp.title":"Click to Pay \uce74\ub4dc\uc5d0 \uc811\uadfc","ctp.otp.subtitle":"%@\ub85c \uc804\uc1a1\ub41c %@ \ucf54\ub4dc\ub97c \uc785\ub825\ud558\uc5ec \ubcf8\uc778 \uc778\uc99d\uc744 \uc9c4\ud589\ud569\ub2c8\ub2e4.","ctp.emptyProfile.message":"\ud574\ub2f9 Click to Pay \ud504\ub85c\ud544\uc5d0 \ub4f1\ub85d\ub41c \uce74\ub4dc\uac00 \uc5c6\uc2b5\ub2c8\ub2e4","ctp.separatorText":"\ub610\ub294 \uc0ac\uc6a9","ctp.cards.title":"Click to Pay\ub85c \uacb0\uc81c \uc644\ub8cc","ctp.cards.subtitle":"\uc0ac\uc6a9\ud560 \uce74\ub4dc\ub97c \uc120\ud0dd\ud558\uc138\uc694.","ctp.cards.expiredCard":"\ub9cc\ub8cc\ub428","ctp.manualCardEntry":"\uce74\ub4dc \uc9c1\uc811 \uc785\ub825","ctp.aria.infoModalButton":"Click to Pay\ub780?","ctp.infoPopup.title":"Click to Pay\ub294 \ube44\uc811\ucd09 \uacb0\uc81c\uc758 \ud3b8\ub9ac\ud568\uc744 \uc628\ub77c\uc778\uc73c\ub85c \uac00\uc838\uc628 \uc11c\ube44\uc2a4\uc785\ub2c8\ub2e4","ctp.infoPopup.subtitle":"Mastercard, Visa, \uae30\ud0c0 \uacb0\uc81c \uce74\ub4dc\ub97c \uc9c0\uc6d0\ud558\ub294 \ube60\ub974\uace0 \uc548\uc804\ud55c \uacb0\uc81c \uc218\ub2e8\uc785\ub2c8\ub2e4.","ctp.infoPopup.benefit1":"Click to Pay\ub294 \uc554\ud638\ud654\ub97c \ud1b5\ud574 \uc815\ubcf4\ub97c \uc548\uc804\ud558\uac8c \ubcf4\ud638\ud569\ub2c8\ub2e4","ctp.infoPopup.benefit2":"\uc804 \uc138\uacc4 \uac00\ub9f9\uc810\uc5d0\uc11c \uc0ac\uc6a9\ud558\uc138\uc694","ctp.infoPopup.benefit3":"\ud55c \ubc88\ub9cc \uc124\uc815\ud558\uba74 \uc55e\uc73c\ub85c\uc758 \uacb0\uc81c\uac00 \uac04\ud3b8\ud574\uc9d1\ub2c8\ub2e4","ctp.errors.AUTH_INVALID":"\uc720\ud6a8\ud558\uc9c0 \uc54a\uc740 \uc778\uc99d\uc785\ub2c8\ub2e4","ctp.errors.NOT_FOUND":"\uacc4\uc815\uc744 \ucc3e\uc744 \uc218 \uc5c6\uc2b5\ub2c8\ub2e4. \uc720\ud6a8\ud55c \uc774\uba54\uc77c\uc744 \uc785\ub825\ud558\uac70\ub098 \uce74\ub4dc \uc815\ubcf4\ub97c \uc9c1\uc811 \uc785\ub825\ud558\uc5ec \uc9c4\ud589\ud558\uc138\uc694.","ctp.errors.ID_FORMAT_UNSUPPORTED":"\uc9c0\uc6d0\ub418\uc9c0 \uc54a\ub294 \ud615\uc2dd\uc785\ub2c8\ub2e4","ctp.errors.FRAUD":"\uc0ac\uc6a9\uc790 \uacc4\uc815\uc774 \uc7a0\uaca8 \uc788\uac70\ub098 \ube44\ud65c\uc131\ud654\ub418\uc5c8\uc2b5\ub2c8\ub2e4","ctp.errors.CONSUMER_ID_MISSING":"\uc694\uccad\uc5d0 \uc18c\ube44\uc790 ID\uac00 \ub204\ub77d\ub418\uc5b4 \uc788\uc2b5\ub2c8\ub2e4","ctp.errors.ACCT_INACCESSIBLE":"\uc774 \uacc4\uc815\uc740 \ud604\uc7ac \uc0ac\uc6a9\ud560 \uc218 \uc5c6\uc2b5\ub2c8\ub2e4(\uc608: \uc7a0\uaca8 \uc788\uc74c).","ctp.errors.CODE_INVALID":"\uc798\ubabb\ub41c \uc778\uc99d \ucf54\ub4dc\uc785\ub2c8\ub2e4","ctp.errors.CODE_EXPIRED":"\ub9cc\ub8cc\ub41c \ucf54\ub4dc\uc785\ub2c8\ub2e4","ctp.errors.RETRIES_EXCEEDED":"OTP \uc0dd\uc131 \uc7ac\uc2dc\ub3c4 \ud69f\uc218 \uc81c\ud55c\uc744 \ucd08\uacfc\ud588\uc2b5\ub2c8\ub2e4","ctp.errors.OTP_SEND_FAILED":"OTP\ub97c \uc218\uc2e0\uc778\uc5d0\uac8c \uc804\uc1a1\ud560 \uc218 \uc5c6\uc2b5\ub2c8\ub2e4","ctp.errors.REQUEST_TIMEOUT":"\ubb38\uc81c\uac00 \ubc1c\uc0dd\ud588\uc2b5\ub2c8\ub2e4. \ub2e4\uc2dc \uc2dc\ub3c4\ud558\uac70\ub098 \uce74\ub4dc \uc815\ubcf4\ub97c \uc9c1\uc811 \uc785\ub825\ud558\uc138\uc694.","ctp.errors.UNKNOWN_ERROR":"\ubb38\uc81c\uac00 \ubc1c\uc0dd\ud588\uc2b5\ub2c8\ub2e4. \ub2e4\uc2dc \uc2dc\ub3c4\ud558\uac70\ub098 \uce74\ub4dc \uc815\ubcf4\ub97c \uc9c1\uc811 \uc785\ub825\ud558\uc138\uc694.","ctp.errors.SERVICE_ERROR":"\ubb38\uc81c\uac00 \ubc1c\uc0dd\ud588\uc2b5\ub2c8\ub2e4. \ub2e4\uc2dc \uc2dc\ub3c4\ud558\uac70\ub098 \uce74\ub4dc \uc815\ubcf4\ub97c \uc9c1\uc811 \uc785\ub825\ud558\uc138\uc694.","ctp.errors.SERVER_ERROR":"\ubb38\uc81c\uac00 \ubc1c\uc0dd\ud588\uc2b5\ub2c8\ub2e4. \ub2e4\uc2dc \uc2dc\ub3c4\ud558\uac70\ub098 \uce74\ub4dc \uc815\ubcf4\ub97c \uc9c1\uc811 \uc785\ub825\ud558\uc138\uc694.","ctp.errors.INVALID_PARAMETER":"\ubb38\uc81c\uac00 \ubc1c\uc0dd\ud588\uc2b5\ub2c8\ub2e4. \ub2e4\uc2dc \uc2dc\ub3c4\ud558\uac70\ub098 \uce74\ub4dc \uc815\ubcf4\ub97c \uc9c1\uc811 \uc785\ub825\ud558\uc138\uc694.","ctp.errors.AUTH_ERROR":"\ubb38\uc81c\uac00 \ubc1c\uc0dd\ud588\uc2b5\ub2c8\ub2e4. \ub2e4\uc2dc \uc2dc\ub3c4\ud558\uac70\ub098 \uce74\ub4dc \uc815\ubcf4\ub97c \uc9c1\uc811 \uc785\ub825\ud558\uc138\uc694.","paymentMethodsList.aria.label":"\uacb0\uc81c \uc218\ub2e8\uc744 \uc120\ud0dd\ud558\uc138\uc694"}}),F3=Object.freeze({__proto__:null,default:{payButton:"Betaal","payButton.redirecting":"U wordt doorverwezen...","payButton.with":"Betaal %{value} met %{maskedData}",close:"Sluiten",storeDetails:"Bewaar voor mijn volgende betaling","creditCard.holderName":"Naam op kaart","creditCard.holderName.placeholder":"J. Janssen","creditCard.holderName.invalid":"Ongeldige naam kaarthouder","creditCard.numberField.title":"Kaartnummer","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"Vervaldatum","creditCard.expiryDateField.placeholder":"MM/JJ","creditCard.expiryDateField.month":"Maand","creditCard.expiryDateField.month.placeholder":"MM","creditCard.expiryDateField.year.placeholder":"JJ","creditCard.expiryDateField.year":"Jaar","creditCard.cvcField.title":"CVC / CVV","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"Onthouden voor de volgende keer","creditCard.cvcField.placeholder.4digits":"4 cijfers","creditCard.cvcField.placeholder.3digits":"3 cijfers","creditCard.taxNumber.placeholder":"JJMMDD / 0123456789",installments:"Aantal termijnen",installmentOption:"%{times}x %{partialValue}",installmentOptionMonths:"%{times} maanden","installments.oneTime":"Eenmalige betaling","installments.installments":"Betaling termijnen","installments.revolving":"Terugkerende betaling","sepaDirectDebit.ibanField.invalid":"Ongeldig rekeningnummer","sepaDirectDebit.nameField.placeholder":"J. Janssen","sepa.ownerName":"Ten name van","sepa.ibanNumber":"Rekeningnummer (IBAN)","error.title":"Fout","error.subtitle.redirect":"Doorsturen niet gelukt","error.subtitle.payment":"Betaling is niet geslaagd","error.subtitle.refused":"Betaling geweigerd","error.message.unknown":"Er is een onbekende fout opgetreden","errorPanel.title":"Bestaande fouten","idealIssuer.selectField.title":"Bank","idealIssuer.selectField.placeholder":"Selecteer uw bank","creditCard.success":"Betaling geslaagd",loading:"Laden....",continue:"Doorgaan",continueTo:"Doorgaan naar","wechatpay.timetopay":"U heeft %@ om te betalen","wechatpay.scanqrcode":"QR-code scannen",personalDetails:"Persoonlijke gegevens",companyDetails:"Bedrijfsgegevens","companyDetails.name":"Bedrijfsnaam","companyDetails.registrationNumber":"Registratienummer",socialSecurityNumber:"Burgerservicenummer",firstName:"Voornaam","firstName.invalid":"Voornaam is niet geldig",infix:"Voorvoegsel",lastName:"Achternaam","lastName.invalid":"Achternaam is niet geldig",mobileNumber:"Telefoonnummer mobiel","mobileNumber.invalid":"Ongeldig mobiel nummer",city:"Stad",postalCode:"Postcode","postalCode.optional":"Postcode (optioneel)",countryCode:"Landcode",telephoneNumber:"Telefoonnummer",dateOfBirth:"Geboortedatum",shopperEmail:"E-mailadres",gender:"Geslacht",male:"Man",female:"Vrouw",billingAddress:"Factuuradres",street:"Straatnaam",stateOrProvince:"Staat of provincie",country:"Land",houseNumberOrName:"Huisnummer",separateDeliveryAddress:"Een afwijkend bezorgadres opgeven",deliveryAddress:"Bezorgadres",zipCode:"Postcode",apartmentSuite:"Appartement/Suite",provinceOrTerritory:"Provincie of territorium",cityTown:"Stad",address:"Adres",state:"Staat","field.title.optional":"(optioneel)","creditCard.cvcField.title.optional":"CVC / CVV (optioneel)","issuerList.wallet.placeholder":"Selecteer uw portemonnee",privacyPolicy:"Privacybeleid","afterPay.agreement":"Ik ga akkoord met de %@ van AfterPay",paymentConditions:"betalingsvoorwaarden",openApp:"Open de app","voucher.readInstructions":"Instructies lezen","voucher.introduction":"Bedankt voor uw aankoop. Gebruik deze coupon om uw betaling te voltooien.","voucher.expirationDate":"Vervaldatum","voucher.alternativeReference":"Alternatieve referentie","dragonpay.voucher.non.bank.selectField.placeholder":"Selecteer uw aanbieder","dragonpay.voucher.bank.selectField.placeholder":"Selecteer uw bank","voucher.paymentReferenceLabel":"Betalingsreferentie","voucher.surcharge":"Inclusief %@ toeslag","voucher.introduction.doku":"Bedankt voor uw aankoop. Gebruik de volgende informatie om uw betaling te voltooien.","voucher.shopperName":"Klantnaam","voucher.merchantName":"Verkoper","voucher.introduction.econtext":"Bedankt voor uw aankoop. Gebruik de volgende informatie om uw betaling te voltooien.","voucher.telephoneNumber":"Telefoonnummer","voucher.shopperReference":"Klant referentie","voucher.collectionInstitutionNumber":"Nummer ophaallocatie","voucher.econtext.telephoneNumber.invalid":"Het telefoonnummer moet uit 10 of 11 cijfers bestaan","boletobancario.btnLabel":"Boleto genereren","boleto.sendCopyToEmail":"Stuur een kopie naar mijn e-mailadres","button.copy":"Kopi\xebren","button.download":"Downloaden","boleto.socialSecurityNumber.invalid":"Veld niet geldig","creditCard.storedCard.description.ariaLabel":"Opgeslagen kaart eindigt op %@","voucher.entity":"Entiteit",donateButton:"Doneren",notNowButton:"Niet nu",thanksForYourSupport:"Bedankt voor uw donatie!",preauthorizeWith:"Preautorisatie uitvoeren met",confirmPreauthorization:"Preautorisatie bevestigen",confirmPurchase:"Aankoop bevestigen",applyGiftcard:"Inwisselen",giftcardBalance:"Saldo cadeaukaart",deductedBalance:"Afgetrokken bedrag","creditCard.pin.title":"PIN","creditCard.encryptedPassword.label":"Eerste twee cijfers van het wachtwoord van de kaart","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"Ongeldig wachtwoord","creditCard.taxNumber":"Geboortedatum of bedrijfsregistratienummer van kaarthouder","creditCard.taxNumber.label":"Geboortedatum (JJ-MM-DD) of bedrijfsregistratienummer (10 cijfers) van kaarthouder","creditCard.taxNumber.labelAlt":"Bedrijfsregistratienummer (10 cijfers)","creditCard.taxNumber.invalid":"Geboortedatum of bedrijfsregistratienummer van kaarthouder is ongeldig","storedPaymentMethod.disable.button":"Verwijderen","storedPaymentMethod.disable.confirmation":"Opgeslagen betalingsmethode verwijderen","storedPaymentMethod.disable.confirmButton":"Ja, verwijderen","storedPaymentMethod.disable.cancelButton":"Annuleren","ach.bankAccount":"Bankrekening","ach.accountHolderNameField.title":"Naam rekeninghouder","ach.accountHolderNameField.placeholder":"J. Janssen","ach.accountHolderNameField.invalid":"Ongeldige naam rekeninghouder","ach.accountNumberField.title":"Rekeningnummer","ach.accountNumberField.invalid":"Ongeldig rekeningnummer","ach.accountLocationField.title":"Routingnummer (ABA)","ach.accountLocationField.invalid":"Ongeldig routingnummer (ABA)","ach.savedBankAccount":"Opgeslagen bankrekening","select.state":"Selecteer staat","select.stateOrProvince":"Selecteer staat of provincie","select.provinceOrTerritory":"Selecteer provincie of territorium","select.country":"Selecteer land","select.noOptionsFound":"Geen opties gevonden","select.filter.placeholder":"Zoeken...","telephoneNumber.invalid":"Ongeldig telefoonnummer",qrCodeOrApp:"of","paypal.processingPayment":"Betaling wordt verwerkt...",generateQRCode:"Genereer QR-code","await.waitForConfirmation":"Wacht op bevestiging","mbway.confirmPayment":"Bevestig uw betaling via de MB WAY-app","shopperEmail.invalid":"Ongeldig e-mailadres","dateOfBirth.format":"DD/MM/JJJJ","dateOfBirth.invalid":"U moet minimaal 18 jaar oud zijn","blik.confirmPayment":"Open uw bankapp om de betaling te bevestigen.","blik.invalid":"Voer 6 cijfers in","blik.code":"6-cijferige code","blik.help":"Haal de code op in uw bankapp.","swish.pendingMessage":"Nadat u hebt gescand, kan de status maximaal 10 minuten in behandeling zijn. Als u binnen deze periode opnieuw probeert te betalen, kunnen er meerdere keren kosten in rekening worden gebracht.","field.valid":"Geldig veld","field.invalid":"Veld niet geldig","error.va.gen.01":"Onvolledig veld","error.va.gen.02":"Veld niet geldig","error.va.sf-cc-num.01":"Ongeldig kaartnummer","error.va.sf-cc-num.02":"Leeg veld voor kaartnummer","error.va.sf-cc-num.03":"Niet-ondersteund kaartnummer ingevoerd","error.va.sf-cc-num.04":"Kaartnummer heeft de verkeerde lengte","error.va.sf-cc-dat.01":"Vervaldatum: kaart is verlopen","error.va.sf-cc-dat.02":"Vervaldatum: datum te ver in de toekomst","error.va.sf-cc-dat.03":"Vervaldatum: uw kaart verloopt voor de betaaldatum","error.va.sf-cc-dat.04":"Leeg veld voor vervaldatum","error.va.sf-cc-dat.05":"Vervaldatum heeft de verkeerde lengte","error.va.sf-cc-mth.01":"Leeg veld voor vervalmaand","error.va.sf-cc-yr.01":"Leeg veld voor vervaljaar","error.va.sf-cc-yr.02":"Vervaljaar heeft de verkeerde lengte","error.va.sf-cc-cvc.01":"Leeg veld voor beveiligingscode","error.va.sf-cc-cvc.02":"Beveiligingscode heeft de verkeerde lengte","error.va.sf-ach-num.01":"Leeg veld voor bankrekeningnummer","error.va.sf-ach-num.02":"Bankrekeningnummer heeft de verkeerde lengte","error.va.sf-ach-loc.01":"Leeg veld voor swiftcode van de bank","error.va.sf-ach-loc.02":"Swiftcode van de bank heeft de verkeerde lengte","error.va.sf-kcp-pwd.01":"Leeg wachtwoordveld","error.va.sf-kcp-pwd.02":"Wachtwoord heeft de verkeerde lengte","error.giftcard.no-balance":"Deze cadeaukaart heeft geen saldo","error.giftcard.card-error":"We hebben geen cadeaukaart met dit nummer in onze administratie","error.giftcard.currency-error":"Cadeaukaarten zijn alleen geldig in de valuta waarin ze zijn uitgegeven","amazonpay.signout":"Afmelden bij Amazon","amazonpay.changePaymentDetails":"Betalingsgegevens wijzigen","partialPayment.warning":"Selecteer een andere betaalmethode om het resterende deel te betalen","partialPayment.remainingBalance":"Het resterende saldo is %{amount}","bankTransfer.beneficiary":"Begunstigde","bankTransfer.iban":"IBAN","bankTransfer.bic":"BIC","bankTransfer.reference":"Referentie","bankTransfer.introduction":"Ga door om een nieuwe overschrijving aan te maken. U kunt de gegevens in het volgende scherm gebruiken om deze betaling af te ronden.","bankTransfer.instructions":"Bedankt voor uw aankoop. Gebruik de volgende informatie om uw betaling te voltooien.","bacs.accountHolderName":"Naam bankrekeninghouder","bacs.accountHolderName.invalid":"Ongeldige naam bankrekeninghouder","bacs.accountNumber":"Bankrekeningnummer","bacs.accountNumber.invalid":"Ongeldig bankrekeningnummer","bacs.bankLocationId":"Bankcode","bacs.bankLocationId.invalid":"Ongeldige bankcode","bacs.consent.amount":"Ik ga ermee akkoord dat het bovengenoemde bedrag van mijn bankrekening wordt afgeschreven.","bacs.consent.account":"Ik bevestig dat de rekening op mijn naam staat en dat ik de enige ondertekenaar ben die toestemming kan geven voor automatische incasso's vanaf deze rekening.",edit:"Bewerken","bacs.confirm":"Bevestigen en betalen","bacs.result.introduction":"Download uw machtiging automatische incasso","download.pdf":"PDF downloaden","creditCard.encryptedCardNumber.aria.iframeTitle":"Iframe voor beveiligd kaartnummer","creditCard.encryptedCardNumber.aria.label":"Kaartnummer","creditCard.encryptedExpiryDate.aria.iframeTitle":"Iframe voor vervaldatum beveiligde kaart","creditCard.encryptedExpiryDate.aria.label":"Vervaldatum","creditCard.encryptedExpiryMonth.aria.iframeTitle":"Iframe voor vervalmaand beveiligde kaart","creditCard.encryptedExpiryMonth.aria.label":"Vervalmaand","creditCard.encryptedExpiryYear.aria.iframeTitle":"Iframe voor vervaljaar beveiligde kaart","creditCard.encryptedExpiryYear.aria.label":"Vervaljaar","creditCard.encryptedSecurityCode.aria.iframeTitle":"Iframe voor beveiligingscode beveiligde kaart","creditCard.encryptedSecurityCode.aria.label":"Beveiligingscode","creditCard.encryptedPassword.aria.iframeTitle":"Iframe voor beveiligd kaartwachtwoord","creditCard.encryptedPassword.aria.label":"Eerste twee cijfers van het wachtwoord van de kaart","giftcard.encryptedCardNumber.aria.iframeTitle":"Iframe voor beveiligd cadeaubonnummer","giftcard.encryptedCardNumber.aria.label":"Cadeaubonnummer","giftcard.encryptedSecurityCode.aria.iframeTitle":"Iframe voor beveiligingscode beveiligde cadeaubon","giftcard.encryptedSecurityCode.aria.label":"Beveiligingscode cadeaubon",giftcardTransactionLimit:"Max. %{amount} toegestaan per transactie met deze cadeaubon","ach.encryptedBankAccountNumber.aria.iframeTitle":"Iframe voor beveiligd bankrekeningnummer","ach.encryptedBankAccountNumber.aria.label":"Bankrekening","ach.encryptedBankLocationId.aria.iframeTitle":"Iframe voor beveiligde BIC-code","ach.encryptedBankLocationId.aria.label":"Routingnummer bank","twint.saved":"opgeslagen",orPayWith:"of betaal met",invalidFormatExpects:"Ongeldige indeling. Verwachte indeling: %{format}","upi.qrCodeWaitingMessage":"Scan de QR-code met je favoriete UPI-app om de betaling te voltooien","upi.vpaWaitingMessage":"Open je UPI-app om de betaling te bevestigen","upi.modeSelection":"Maak een selectie over hoe u UPI wilt gebruiken.","onlineBanking.termsAndConditions":"Door verder te gaan gaat u akkoord met de %#algemene voorwaarden%#","ctp.loading.poweredByCtp":"Mogelijk gemaakt door Click to Pay","ctp.loading.intro":"We controleren of u opgeslagen kaarten heeft bij Click to Pay...","ctp.login.title":"Ga verder naar Click to Pay","ctp.login.subtitle":"Voer het aan Click to Pay gekoppelde e-mailadres in om verder te gaan.","ctp.login.inputLabel":"E-mail","ctp.logout.notYou":"Bent u dit niet?","ctp.logout.notYourCards":"Niet uw kaarten?","ctp.logout.notYourCard":"Niet uw kaart?","ctp.logout.notYourProfile":"Niet uw profiel?","ctp.otp.fieldLabel":"Eenmalige code","ctp.otp.resendCode":"Code opnieuw verzenden","ctp.otp.codeResent":"Code opnieuw verzonden","ctp.otp.title":"Ga naar uw Click to Pay-kaarten","ctp.otp.subtitle":"Voer de code %@ in die naar %@ is gestuurd, zodat we kunnen verifi\xebren dat u het bent.","ctp.emptyProfile.message":"Geen kaarten geregistreerd voor dit Click to Pay-profiel","ctp.separatorText":"of gebruik","ctp.cards.title":"Voltooi de betaling met Click to Pay","ctp.cards.subtitle":"Selecteer een kaart om te gebruiken.","ctp.cards.expiredCard":"Verlopen","ctp.manualCardEntry":"Handmatige kaartinvoer","ctp.aria.infoModalButton":"Wat is Click to Pay?","ctp.infoPopup.title":"Met Click to Pay betaalt u nu ook contactloos online","ctp.infoPopup.subtitle":"Een snelle en veilige betaalmethode, ondersteund door Mastercard, Visa en andere betaalkaarten.","ctp.infoPopup.benefit1":"Click to Pay maakt gebruik van versleuteling om uw informatie veilig te houden","ctp.infoPopup.benefit2":"Gebruik het bij winkeliers over de hele wereld","ctp.infoPopup.benefit3":"E\xe9n keer instellen voor probleemloze betalingen","ctp.errors.AUTH_INVALID":"Authenticatie ongeldig","ctp.errors.NOT_FOUND":"Geen account gevonden, voer een geldig e-mailadres in of ga door met het handmatig invoeren van kaarten","ctp.errors.ID_FORMAT_UNSUPPORTED":"Formaat wordt niet ondersteund","ctp.errors.FRAUD":"Gebruikersaccount vergrendeld of uitgeschakeld","ctp.errors.CONSUMER_ID_MISSING":"Identiteit van de consument ontbreekt in het verzoek","ctp.errors.ACCT_INACCESSIBLE":"Dit account is momenteel niet beschikbaar, omdat het bijvoorbeeld is vergrendeld","ctp.errors.CODE_INVALID":"Onjuiste verificatiecode","ctp.errors.CODE_EXPIRED":"Deze code is verlopen","ctp.errors.RETRIES_EXCEEDED":"De limiet voor het aantal pogingen voor het genereren van een OTP is overschreden","ctp.errors.OTP_SEND_FAILED":"Het OTP kan niet naar de ontvanger worden verzonden","ctp.errors.REQUEST_TIMEOUT":"Er is iets fout gegaan, probeer het opnieuw of gebruik de handmatige kaartinvoer","ctp.errors.UNKNOWN_ERROR":"Er is iets fout gegaan, probeer het opnieuw of gebruik de handmatige kaartinvoer","ctp.errors.SERVICE_ERROR":"Er is iets fout gegaan, probeer het opnieuw of gebruik de handmatige kaartinvoer","ctp.errors.SERVER_ERROR":"Er is iets fout gegaan, probeer het opnieuw of gebruik de handmatige kaartinvoer","ctp.errors.INVALID_PARAMETER":"Er is iets fout gegaan, probeer het opnieuw of gebruik de handmatige kaartinvoer","ctp.errors.AUTH_ERROR":"Er is iets fout gegaan, probeer het opnieuw of gebruik de handmatige kaartinvoer","paymentMethodsList.aria.label":"Kies een betaalmethode"}}),R3=Object.freeze({__proto__:null,default:{payButton:"Betal","payButton.redirecting":"Omdirigerer...","payButton.with":"Betal %{value} med %{maskedData}",close:"Lukk",storeDetails:"Lagre til min neste betaling","creditCard.holderName":"Navn p\xe5 kortet","creditCard.holderName.placeholder":"O. Nordmann","creditCard.holderName.invalid":"Ugyldig navn p\xe5 kortholder","creditCard.numberField.title":"Kortnummer","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"Utl\xf8psdato","creditCard.expiryDateField.placeholder":"MM/\xc5\xc5","creditCard.expiryDateField.month":"M\xe5ned","creditCard.expiryDateField.month.placeholder":"MM","creditCard.expiryDateField.year.placeholder":"\xc5\xc5","creditCard.expiryDateField.year":"\xc5r","creditCard.cvcField.title":"CVC / CVV","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"Husk til neste gang","creditCard.cvcField.placeholder.4digits":"4 siffer","creditCard.cvcField.placeholder.3digits":"3 siffer","creditCard.taxNumber.placeholder":"YYMMDD / 0123456789",installments:"Antall avdrag",installmentOption:"%{times}x %{partialValue}",installmentOptionMonths:"%{times} m\xe5neder","installments.oneTime":"Engangsbetaling","installments.installments":"Avdragsbetaling","installments.revolving":"Gjentakende betaling","sepaDirectDebit.ibanField.invalid":"Ugyldig kontonummer","sepaDirectDebit.nameField.placeholder":"O. Nordmann","sepa.ownerName":"Kortholders navn","sepa.ibanNumber":"Kontonummer (IBAN)","error.title":"Feil","error.subtitle.redirect":"Videresending feilet","error.subtitle.payment":"Betaling feilet","error.subtitle.refused":"Betaling avvist","error.message.unknown":"En ukjent feil oppstod","errorPanel.title":"Eksisterende feil","idealIssuer.selectField.title":"Bank","idealIssuer.selectField.placeholder":"Velg din bank","creditCard.success":"Betalingen var vellykket",loading:"Laster...",continue:"Fortsett",continueTo:"Fortsett til","wechatpay.timetopay":"Du har %@ igjen til \xe5 betale","wechatpay.scanqrcode":"Skann QR-kode",personalDetails:"Personopplysninger",companyDetails:"Firmadetaljer","companyDetails.name":"Firmanavn","companyDetails.registrationNumber":"Registreringsnummer",socialSecurityNumber:"Personnummer",firstName:"Fornavn","firstName.invalid":"Fornavnet er ikke gyldig",infix:"Prefiks",lastName:"Etternavn","lastName.invalid":"Etternavnet er ikke gyldig",mobileNumber:"Mobilnummer","mobileNumber.invalid":"Ugyldig mobilnummer",city:"Poststed",postalCode:"Postnummer","postalCode.optional":"Postnummer (valgfritt)",countryCode:"Landkode",telephoneNumber:"Telefonnummer",dateOfBirth:"F\xf8dselsdato",shopperEmail:"E-postadresse",gender:"Kj\xf8nn",male:"Mann",female:"Kvinne",billingAddress:"Faktureringsadresse",street:"Gate",stateOrProvince:"Fylke",country:"Land",houseNumberOrName:"Husnummer",separateDeliveryAddress:"Spesifiser en separat leveringsadresse",deliveryAddress:"Leveringsadresse",zipCode:"Postnummer",apartmentSuite:"Leilighet/suite",provinceOrTerritory:"Provins eller territorium",cityTown:"By",address:"Adresse",state:"Delstat","field.title.optional":"(valgfritt)","creditCard.cvcField.title.optional":"CVC / CVV (valgfritt)","issuerList.wallet.placeholder":"Velg lommebok",privacyPolicy:"Retningslinjer for personvern","afterPay.agreement":"Jeg godtar AfterPays %@",paymentConditions:"betalingsbetingelser",openApp:"\xc5pne appen","voucher.readInstructions":"Les instruksjoner","voucher.introduction":"Takk for ditt kj\xf8p. Vennligst bruk den f\xf8lgende kupongen til \xe5 fullf\xf8re betalingen.","voucher.expirationDate":"Utl\xf8psdato","voucher.alternativeReference":"Alternativ referanse","dragonpay.voucher.non.bank.selectField.placeholder":"Velg din leverand\xf8r","dragonpay.voucher.bank.selectField.placeholder":"Velg din bank","voucher.paymentReferenceLabel":"Betalingsreferanse","voucher.surcharge":"Inkl. %@ tilleggsavgift","voucher.introduction.doku":"Takk for ditt kj\xf8p, vennligst bruk den f\xf8lgende informasjonen for \xe5 fullf\xf8re betalingen.","voucher.shopperName":"Kundenavn","voucher.merchantName":"Forhandler","voucher.introduction.econtext":"Takk for ditt kj\xf8p, vennligst bruk den f\xf8lgende informasjonen for \xe5 fullf\xf8re betalingen.","voucher.telephoneNumber":"Telefonnummer","voucher.shopperReference":"Kundereferanse","voucher.collectionInstitutionNumber":"Innbetalingslokasjonsnummer","voucher.econtext.telephoneNumber.invalid":"Telefonnummeret m\xe5 v\xe6re 10 eller 11 sifre langt","boletobancario.btnLabel":"Generer Boleto","boleto.sendCopyToEmail":"Send meg en kopi p\xe5 e-post","button.copy":"Kopier","button.download":"Last ned","boleto.socialSecurityNumber.invalid":"Feltet er ikke gyldig","creditCard.storedCard.description.ariaLabel":"Lagret kort slutter p\xe5 %@","voucher.entity":"Enhet",donateButton:"Don\xe9r",notNowButton:"Ikke n\xe5",thanksForYourSupport:"Takk for din st\xf8tte!",preauthorizeWith:"Forh\xe5ndsgodkjenn med",confirmPreauthorization:"Bekreft forh\xe5ndsgodkjenning",confirmPurchase:"Bekreft kj\xf8p",applyGiftcard:"L\xf8s inn",giftcardBalance:"Gavekortsaldo",deductedBalance:"Fratrukket bel\xf8p","creditCard.pin.title":"PIN","creditCard.encryptedPassword.label":"F\xf8rste 2 sifre av kortpassord","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"Ugyldig passord","creditCard.taxNumber":"Kortholders f\xf8dselsdato eller bedriftsregistreringsnummer","creditCard.taxNumber.label":"Kortholders f\xf8dselsdato (YYMMDD) eller bedriftsregistreringsnummer (10 siffer)","creditCard.taxNumber.labelAlt":"Bedriftsregistreringsnummer (10 siffer)","creditCard.taxNumber.invalid":"Ugyldig kortholders f\xf8dselsdato eller bedriftsregistreringsnummer","storedPaymentMethod.disable.button":"Fjern","storedPaymentMethod.disable.confirmation":"Fjern lagret betalingsmetode","storedPaymentMethod.disable.confirmButton":"Ja, fjern","storedPaymentMethod.disable.cancelButton":"Avbryt","ach.bankAccount":"Bankkonto","ach.accountHolderNameField.title":"Kontoholders navn","ach.accountHolderNameField.placeholder":"O. Nordmann","ach.accountHolderNameField.invalid":"Ugyldig navn p\xe5 kontoholder","ach.accountNumberField.title":"Kontonummer","ach.accountNumberField.invalid":"Ugyldig kontonummer","ach.accountLocationField.title":"ABA-dirigeringsnummer","ach.accountLocationField.invalid":"Ugyldig ABA-dirigeringsnummer","ach.savedBankAccount":"Lagret bankkonto","select.state":"Velg delstat","select.stateOrProvince":"Velg delstat eller provins","select.provinceOrTerritory":"Velg provins eller territorium","select.country":"Velg land","select.noOptionsFound":"Ingen alternativer funnet","select.filter.placeholder":"S\xf8k\xa0\u2026","telephoneNumber.invalid":"Ugyldig telefonnummer",qrCodeOrApp:"eller","paypal.processingPayment":"Behandler betaling \u2026",generateQRCode:"Generer QR-kode","await.waitForConfirmation":"Venter p\xe5 bekreftelse","mbway.confirmPayment":"Bekreft betalingen din i MB WAY-appen","shopperEmail.invalid":"Ugyldig e-postadresse","dateOfBirth.format":"DD/MM/\xc5\xc5\xc5\xc5","dateOfBirth.invalid":"Du m\xe5 v\xe6re minst 18 \xe5r gammel","blik.confirmPayment":"\xc5pne bank-appen din for \xe5 bekrefte betalingen.","blik.invalid":"Tast inn 6 tall","blik.code":"6-sifret kode","blik.help":"Hent koden fra bank-appen din.","swish.pendingMessage":"Etter at du har skannet koden kan det ta opptil 10 minutter f\xf8r betalingen vises som bekreftet. Fors\xf8k p\xe5 \xe5 betale igjen kan f\xf8re til flere innbetalinger.","field.valid":"Feltet er gyldig","field.invalid":"Feltet er ikke gyldig","error.va.gen.01":"Ufullstendig felt","error.va.gen.02":"Feltet er ikke gyldig","error.va.sf-cc-num.01":"Kortnummeret er ikke gyldig","error.va.sf-cc-num.02":"Kortnummerfeltet er tomt","error.va.sf-cc-num.03":"Det angitte kortnummeret st\xf8ttes ikke","error.va.sf-cc-num.04":"Kortnummeret har feil lengde","error.va.sf-cc-dat.01":"Utl\xf8psdato: Kortet er for gammelt","error.va.sf-cc-dat.02":"Utl\xf8psdato: Datoen er for langt frem i tid","error.va.sf-cc-dat.03":"Utl\xf8psdato: Kortet utl\xf8per f\xf8r betalingsdatoen","error.va.sf-cc-dat.04":"Feltet for utl\xf8psdato er tomt","error.va.sf-cc-dat.05":"Utl\xf8psdatoen har feil lengde","error.va.sf-cc-mth.01":"Feltet for utl\xf8psm\xe5ned er tomt","error.va.sf-cc-yr.01":"Feltet for utl\xf8ps\xe5r er tomt","error.va.sf-cc-yr.02":"Utl\xf8ps\xe5ret har feil lengde","error.va.sf-cc-cvc.01":"Feltet for sikkerhetskode er tomt","error.va.sf-cc-cvc.02":"Sikkerhetskoden har feil lengde","error.va.sf-ach-num.01":"Feltet for bankkontonummer er tomt","error.va.sf-ach-num.02":"Bankkontonummeret har feil lengde","error.va.sf-ach-loc.01":"Feltet for bankens routingnummer er tomt","error.va.sf-ach-loc.02":"Bankens routingnummer har feil lengde","error.va.sf-kcp-pwd.01":"Passordfeltet er tomt","error.va.sf-kcp-pwd.02":"Passordet har feil lengde","error.giftcard.no-balance":"Dette gavekortet har en saldo p\xe5 null","error.giftcard.card-error":"Vi har ikke noe gavekort med dette nummeret i registrene v\xe5re","error.giftcard.currency-error":"Gavekort er kun gyldige i den valutaen de ble utstedt i","amazonpay.signout":"Logg ut av Amazon","amazonpay.changePaymentDetails":"Endre betalingsdetaljer","partialPayment.warning":"Velg en annen betalingsmetode for \xe5 betale det gjenv\xe6rende","partialPayment.remainingBalance":"Gjenv\xe6rende saldo vil v\xe6re %{amount}","bankTransfer.beneficiary":"Mottaker","bankTransfer.iban":"IBAN","bankTransfer.bic":"BIC","bankTransfer.reference":"referanse","bankTransfer.introduction":"Fortsett for \xe5 opprette en ny betaling via bankoverf\xf8ring. Du kan bruke detaljene i det f\xf8lgende skjermbildet for \xe5 fullf\xf8re betalingen.","bankTransfer.instructions":"Takk for kj\xf8pet. Vennligst benytt den f\xf8lgende informasjonen til \xe5 fullf\xf8re betalingen.","bacs.accountHolderName":"Kontoholders navn","bacs.accountHolderName.invalid":"Ugyldig kontoholdernavn","bacs.accountNumber":"Bankkontonummer","bacs.accountNumber.invalid":"Ugyldig bankkontonummer","bacs.bankLocationId":"Sorteringskode","bacs.bankLocationId.invalid":"Ugyldig sorteringskode","bacs.consent.amount":"Jeg samtykker til at bel\xf8pet ovenfor blir trukket fra bankkontoen min.","bacs.consent.account":"Jeg bekrefter at kontoen st\xe5r i mitt navn, og at jeg er den eneste signataren som kreves for \xe5 autorisere direktebelastningen p\xe5 denne kontoen.",edit:"Endre","bacs.confirm":"Bekreft og betal","bacs.result.introduction":"Last ned instruksjoner for direktebelastning (DDI/ mandat)","download.pdf":"Last ned PDF","creditCard.encryptedCardNumber.aria.iframeTitle":"Iframe for sikret kortnummer","creditCard.encryptedCardNumber.aria.label":"Kortnummer","creditCard.encryptedExpiryDate.aria.iframeTitle":"Iframe for sikret kortutl\xf8psdato","creditCard.encryptedExpiryDate.aria.label":"Utl\xf8psdato","creditCard.encryptedExpiryMonth.aria.iframeTitle":"Iframe for sikret kortutl\xf8psm\xe5ned","creditCard.encryptedExpiryMonth.aria.label":"Utl\xf8psm\xe5ned","creditCard.encryptedExpiryYear.aria.iframeTitle":"Iframe for sikret kortutl\xf8ps\xe5r","creditCard.encryptedExpiryYear.aria.label":"Utl\xf8ps\xe5r","creditCard.encryptedSecurityCode.aria.iframeTitle":"Iframe for sikret kortsikkerhetskode","creditCard.encryptedSecurityCode.aria.label":"Sikkerhetskode","creditCard.encryptedPassword.aria.iframeTitle":"Iframe for sikret kortpassord","creditCard.encryptedPassword.aria.label":"F\xf8rste 2 sifre av kortpassord","giftcard.encryptedCardNumber.aria.iframeTitle":"Iframe for sikret gavekortnummer","giftcard.encryptedCardNumber.aria.label":"Gavekortnummer","giftcard.encryptedSecurityCode.aria.iframeTitle":"Iframe for sikret gavekort-sikkerhetskode","giftcard.encryptedSecurityCode.aria.label":"Sikkerhetskode for gavekort",giftcardTransactionLimit:"Maksimalt %{amount} per transaksjon er tillatt p\xe5 dette gavekortet","ach.encryptedBankAccountNumber.aria.iframeTitle":"Iframe for sikret bankkontonummer","ach.encryptedBankAccountNumber.aria.label":"Bankkonto","ach.encryptedBankLocationId.aria.iframeTitle":"Iframe for sikret bankdirigeringsnummer","ach.encryptedBankLocationId.aria.label":"Bankens routingnummer","twint.saved":"lagret",orPayWith:"eller betal med",invalidFormatExpects:"Ugyldig format. Forventet format: %{format}","upi.qrCodeWaitingMessage":"Skann QR-koden ved \xe5 bruke din foretrukne UPI-app for \xe5 fullf\xf8re betalingen","upi.vpaWaitingMessage":"\xc5pne UPI-appen for \xe5 bekrefte betalingen","upi.modeSelection":"Velg hvordan du vil bruke UPI.","onlineBanking.termsAndConditions":"Ved \xe5 fortsette godtar du %#terms and conditions%#","ctp.loading.poweredByCtp":"Drevet av Click to Pay","ctp.loading.intro":"Vi sjekker om du har noen lagrede kort med Click to Pay \u2026","ctp.login.title":"Fortsett til Click to Pay","ctp.login.subtitle":"Skriv inn e-postadressen som er tilknyttet Click to Pay, for \xe5 fortsette.","ctp.login.inputLabel":"E-postadresse","ctp.logout.notYou":"Ikke deg?","ctp.logout.notYourCards":"Ikke dine kort?","ctp.logout.notYourCard":"Ikke ditt kort?","ctp.logout.notYourProfile":"Ikke din profil?","ctp.otp.fieldLabel":"Engangskode","ctp.otp.resendCode":"Send kode p\xe5 nytt","ctp.otp.codeResent":"Kode er sendt p\xe5 nytt","ctp.otp.title":"F\xe5 tilgang til Click to Pay-kortene dine","ctp.otp.subtitle":"Tast inn koden vi sendte til %@, for \xe5 verifisere at det er deg.","ctp.emptyProfile.message":"Ingen kort er registrert i denne Click to Pay-profilen","ctp.separatorText":"eller bruk","ctp.cards.title":"Fullf\xf8r betalingen med Click to Pay","ctp.cards.subtitle":"Velg et kort du vil bruke.","ctp.cards.expiredCard":"Utl\xf8pt","ctp.manualCardEntry":"Manuell inntasting av kort","ctp.aria.infoModalButton":"Hva er Click to Pay","ctp.infoPopup.title":"Click to Pay gj\xf8r kontaktl\xf8st mulig ogs\xe5 p\xe5 nettet","ctp.infoPopup.subtitle":"En rask, sikker betalingsmetode st\xf8ttet av Mastercard, Visa og andre betalingskort.","ctp.infoPopup.benefit1":"Click to Pay bruker kryptering for \xe5 holde informasjonen din sikker","ctp.infoPopup.benefit2":"Bruk den hos forhandlere over hele verden","ctp.infoPopup.benefit3":"Konfigurer \xe9n gang for lettvinte betalinger i fremtiden","ctp.errors.AUTH_INVALID":"Autentiseringen er ugyldig","ctp.errors.NOT_FOUND":"Vi finner ingen konto. Skriv inn en gyldig e-postadresse eller fortsett ved hjelp av manuell kortinntasting","ctp.errors.ID_FORMAT_UNSUPPORTED":"Formatet st\xf8ttes ikke","ctp.errors.FRAUD":"Brukerkontoen er l\xe5st eller deaktivert","ctp.errors.CONSUMER_ID_MISSING":"Forbrukerens identitet mangler i foresp\xf8rselen","ctp.errors.ACCT_INACCESSIBLE":"Denne kontoen er for \xf8yeblikket ikke tilgjengelig, f.eks. kan den v\xe6re l\xe5st","ctp.errors.CODE_INVALID":"Feil verifiseringskode","ctp.errors.CODE_EXPIRED":"Denne koden er utl\xf8pt","ctp.errors.RETRIES_EXCEEDED":"Grensen for antall fors\xf8k p\xe5 generering av engangspassord er overskredet","ctp.errors.OTP_SEND_FAILED":"Engangspassordet kunne ikke sendes til mottakeren","ctp.errors.REQUEST_TIMEOUT":"Noe gikk galt, pr\xf8v igjen eller bruk den manuelle kortinntastingen","ctp.errors.UNKNOWN_ERROR":"Noe gikk galt, pr\xf8v igjen eller bruk den manuelle kortinntastingen","ctp.errors.SERVICE_ERROR":"Noe gikk galt, pr\xf8v igjen eller bruk den manuelle kortinntastingen","ctp.errors.SERVER_ERROR":"Noe gikk galt, pr\xf8v igjen eller bruk den manuelle kortinntastingen","ctp.errors.INVALID_PARAMETER":"Noe gikk galt, pr\xf8v igjen eller bruk den manuelle kortinntastingen","ctp.errors.AUTH_ERROR":"Noe gikk galt, pr\xf8v igjen eller bruk den manuelle kortinntastingen","paymentMethodsList.aria.label":"Velg en betalingsmetode"}}),O3=Object.freeze({__proto__:null,default:{payButton:"Zap\u0142a\u0107","payButton.redirecting":"Przekierowywanie...","payButton.with":"Zap\u0142a\u0107 %{value} za pomoc\u0105 %{maskedData}",close:"Zamknij",storeDetails:"Zapisz na potrzeby nast\u0119pnej p\u0142atno\u015bci","creditCard.holderName":"Imi\u0119 i nazwisko na karcie","creditCard.holderName.placeholder":"J. Kowalski","creditCard.holderName.invalid":"Nieprawid\u0142owe imi\u0119 i nazwisko posiadacza karty","creditCard.numberField.title":"Numer karty ","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"Data wa\u017cno\u015bci","creditCard.expiryDateField.placeholder":"MM/RR","creditCard.expiryDateField.month":"Miesi\u0105c","creditCard.expiryDateField.month.placeholder":"MM","creditCard.expiryDateField.year.placeholder":"RR","creditCard.expiryDateField.year":"Rok","creditCard.cvcField.title":"CVC / CVV","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"Zapami\u0119taj na przysz\u0142o\u015b\u0107","creditCard.cvcField.placeholder.4digits":"4 cyfry","creditCard.cvcField.placeholder.3digits":"3 cyfry","creditCard.taxNumber.placeholder":"RRMMDD / 0123456789",installments:"Liczba rat",installmentOption:"%{times}x %{partialValue}",installmentOptionMonths:"%{times} miesi\u0119cy","installments.oneTime":"P\u0142atno\u015b\u0107 jednorazowa","installments.installments":"P\u0142atno\u015b\u0107 ratalna","installments.revolving":"P\u0142atno\u015b\u0107 odnawialna","sepaDirectDebit.ibanField.invalid":"Nieprawid\u0142owy numer rachunku","sepaDirectDebit.nameField.placeholder":"J. Kowalski","sepa.ownerName":"Imi\u0119 i nazwisko posiadacza karty","sepa.ibanNumber":"Numer rachunku (IBAN)","error.title":"B\u0142\u0105d","error.subtitle.redirect":"Przekierowanie nie powiod\u0142o si\u0119","error.subtitle.payment":"P\u0142atno\u015b\u0107 nie powiod\u0142a si\u0119","error.subtitle.refused":"P\u0142atno\u015b\u0107 zosta\u0142a odrzucona","error.message.unknown":"Wyst\u0105pi\u0142 nieoczekiwany b\u0142\u0105d","errorPanel.title":"Istniej\u0105ce b\u0142\u0119dy","idealIssuer.selectField.title":"Bank","idealIssuer.selectField.placeholder":"Wybierz sw\xf3j bank","creditCard.success":"P\u0142atno\u015b\u0107 zako\u0144czona sukcesem",loading:"\u0141adowanie...",continue:"Kontynuuj",continueTo:"Przejd\u017a do","wechatpay.timetopay":"Masz do zap\u0142acenia %@","wechatpay.scanqrcode":"Zeskanuj kod QR",personalDetails:"Dane osobowe",companyDetails:"Dane firmy","companyDetails.name":"Nazwa firmy","companyDetails.registrationNumber":"Numer w rejestrze",socialSecurityNumber:"Numer dowodu osobistego",firstName:"Imi\u0119","firstName.invalid":"Imi\u0119 jest nieprawid\u0142owe",infix:"Prefiks",lastName:"Nazwisko","lastName.invalid":"Nazwisko jest nieprawid\u0142owe",mobileNumber:"Numer telefonu kom\xf3rkowego","mobileNumber.invalid":"Nieprawid\u0142owy numer telefonu kom\xf3rkowego",city:"Miasto",postalCode:"Kod pocztowy","postalCode.optional":"Kod pocztowy (opcjonalnie)",countryCode:"Kod kraju",telephoneNumber:"Numer telefonu",dateOfBirth:"Data urodzenia",shopperEmail:"Adres e-mail",gender:"P\u0142e\u0107",male:"M\u0119\u017cczyzna",female:"Kobieta",billingAddress:"Adres rozliczeniowy",street:"Ulica",stateOrProvince:"Wojew\xf3dztwo",country:"Kraj",houseNumberOrName:"Numer domu i mieszkania",separateDeliveryAddress:"Podaj osobny adres dostawy",deliveryAddress:"Adres dostawy",zipCode:"Kod pocztowy",apartmentSuite:"Numer domu/mieszkania",provinceOrTerritory:"Region lub terytorium",cityTown:"Miejscowo\u015b\u0107",address:"Adres",state:"Stan","field.title.optional":"(opcjonalnie)","creditCard.cvcField.title.optional":"CVC / CVV (opcjonalnie)","issuerList.wallet.placeholder":"Wybierz sw\xf3j portfel",privacyPolicy:"Polityka prywatno\u015bci.","afterPay.agreement":"Zgadzam si\u0119 z dokumentem %@ AfterPay",paymentConditions:"warunki p\u0142atno\u015bci",openApp:"Otw\xf3rz aplikacj\u0119","voucher.readInstructions":"Przeczytaj instrukcje","voucher.introduction":"Dzi\u0119kujemy za zakup, doko\u0144cz p\u0142atno\u015b\u0107 przy u\u017cyciu tego kuponu.","voucher.expirationDate":"Data wa\u017cno\u015bci","voucher.alternativeReference":"Dodatkowy numer referencyjny","dragonpay.voucher.non.bank.selectField.placeholder":"Wybierz dostawc\u0119","dragonpay.voucher.bank.selectField.placeholder":"Wybierz sw\xf3j bank","voucher.paymentReferenceLabel":"Nr referencyjny p\u0142atno\u015bci","voucher.surcharge":"Zawiera %@ op\u0142aty dodatkowej","voucher.introduction.doku":"Dzi\u0119kujemy za zakup. Doko\u0144cz p\u0142atno\u015b\u0107 przy u\u017cyciu poni\u017cszych informacji.","voucher.shopperName":"Imi\u0119 i nazwisko klienta","voucher.merchantName":"Sprzedaj\u0105cy","voucher.introduction.econtext":"Dzi\u0119kujemy za zakup. Doko\u0144cz p\u0142atno\u015b\u0107 przy u\u017cyciu poni\u017cszych informacji.","voucher.telephoneNumber":"Numer telefonu","voucher.shopperReference":"Dane referencyjne kupuj\u0105cych","voucher.collectionInstitutionNumber":"Numer instytucji pobieraj\u0105cej op\u0142at\u0119","voucher.econtext.telephoneNumber.invalid":"Numer telefonu musi mie\u0107 10 lub 11 cyfr","boletobancario.btnLabel":"Wygeneruj p\u0142atno\u015b\u0107 Boleto","boleto.sendCopyToEmail":"Wy\u015blij kopi\u0119 na m\xf3j e-mail","button.copy":"Kopiuj","button.download":"Pobierz","boleto.socialSecurityNumber.invalid":"Pole jest nieprawid\u0142owe","creditCard.storedCard.description.ariaLabel":"Zapisana karta ko\u0144czy si\u0119 na % @","voucher.entity":"Pozycja",donateButton:"Przeka\u017c darowizn\u0119",notNowButton:"Nie teraz",thanksForYourSupport:"Dzi\u0119kujemy za wsparcie!",preauthorizeWith:"Autoryzuj wst\u0119pnie za pomoc\u0105:",confirmPreauthorization:"Potwierd\u017a autoryzacj\u0119 wst\u0119pn\u0105",confirmPurchase:"Potwierd\u017a zakup",applyGiftcard:"Wykorzystaj",giftcardBalance:"Saldo karty podarunkowej",deductedBalance:"Saldo potr\u0105cone","creditCard.pin.title":"PIN","creditCard.encryptedPassword.label":"Pierwsze 2 cyfry has\u0142a karty","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"Nieprawid\u0142owe has\u0142o","creditCard.taxNumber":"Data urodzenia posiadacza karty lub firmowy numer rejestracyjny","creditCard.taxNumber.label":"Data urodzenia posiadacza karty (RRMMDD) lub firmowy numer rejestracyjny (10 cyfr)","creditCard.taxNumber.labelAlt":"Firmowy numer rejestracyjny (10 cyfr)","creditCard.taxNumber.invalid":"Nieprawid\u0142owa data urodzenia posiadacza karty lub nieprawid\u0142owy firmowy numer rejestracyjny","storedPaymentMethod.disable.button":"Usu\u0144","storedPaymentMethod.disable.confirmation":"Usu\u0144 zapisan\u0105 metod\u0119 p\u0142atno\u015bci","storedPaymentMethod.disable.confirmButton":"Tak, usu\u0144","storedPaymentMethod.disable.cancelButton":"Anuluj","ach.bankAccount":"Rachunek bankowy","ach.accountHolderNameField.title":"Imi\u0119 i nazwisko posiadacza rachunku","ach.accountHolderNameField.placeholder":"J. Kowalski","ach.accountHolderNameField.invalid":"Nieprawid\u0142owe imi\u0119 i nazwisko posiadacza rachunku","ach.accountNumberField.title":"Numer rachunku","ach.accountNumberField.invalid":"Nieprawid\u0142owy numer rachunku","ach.accountLocationField.title":"Kod bankowy ABA Routing Number","ach.accountLocationField.invalid":"Nieprawid\u0142owy kod bankowy ABA Routing Number","ach.savedBankAccount":"Zapisane konto bankowe","select.state":"Wybierz stan","select.stateOrProvince":"Wybierz stan/wojew\xf3dztwo","select.provinceOrTerritory":"Wybierz region/terytorium","select.country":"Wybierz kraj","select.noOptionsFound":"Nie znaleziono opcji","select.filter.placeholder":"Szukaj...","telephoneNumber.invalid":"Nieprawid\u0142owy numer telefonu",qrCodeOrApp:"lub","paypal.processingPayment":"Przetwarzanie p\u0142atno\u015bci...",generateQRCode:"Wygeneruj kod QR","await.waitForConfirmation":"Oczekiwanie na potwierdzenie","mbway.confirmPayment":"Potwierd\u017a p\u0142atno\u015b\u0107 w aplikacji MB WAY","shopperEmail.invalid":"Niepoprawny adres email","dateOfBirth.format":"DD/MM/RRRR","dateOfBirth.invalid":"Musisz mie\u0107 co najmniej 18 lat","blik.confirmPayment":"Otw\xf3rz aplikacj\u0119 bankow\u0105, aby potwierdzi\u0107 p\u0142atno\u015b\u0107.","blik.invalid":"Wpisz 6 cyfr","blik.code":"6-cyfrowy kod","blik.help":"Uzyskaj kod ze swojej aplikacji bankowej.","swish.pendingMessage":"Po zeskanowaniu transakcja mo\u017ce mie\u0107 status \u201eOczekuj\u0105ca\u201d do 10 minut. Pr\xf3ba ponownego dokonania p\u0142atno\u015bci w tym czasie mo\u017ce spowodowa\u0107 wielokrotne naliczenie op\u0142aty.","field.valid":"Pole prawid\u0142owe","field.invalid":"Dane w polu s\u0105 nieprawid\u0142owe","error.va.gen.01":"Niekompletne dane w polu","error.va.gen.02":"Dane w polu s\u0105 nieprawid\u0142owe","error.va.sf-cc-num.01":"Numer karty jest nieprawid\u0142owy","error.va.sf-cc-num.02":"Pole Numer karty jest puste","error.va.sf-cc-num.03":"Wprowadzono nieobs\u0142ugiwany numer karty","error.va.sf-cc-num.04":"Numer karty ma nieprawid\u0142ow\u0105 d\u0142ugo\u015b\u0107","error.va.sf-cc-dat.01":"Data wa\u017cno\u015bci: up\u0142yn\u0105\u0142 termin wa\u017cno\u015bci karty","error.va.sf-cc-dat.02":"Data wa\u017cno\u015bci: data jest w zbyt odleg\u0142ej przysz\u0142o\u015bci","error.va.sf-cc-dat.03":"Data wa\u017cno\u015bci: karta traci wa\u017cno\u015b\u0107 przed dat\u0105 p\u0142atno\u015bci","error.va.sf-cc-dat.04":"Pole Data wa\u017cno\u015bci jest puste","error.va.sf-cc-dat.05":"Data wa\u017cno\u015bci ma nieprawid\u0142ow\u0105 d\u0142ugo\u015b\u0107","error.va.sf-cc-mth.01":"Pole Data wa\u017cno\u015bci \u2013 miesi\u0105c jest puste","error.va.sf-cc-yr.01":"Pole Data wa\u017cno\u015bci \u2013 rok jest puste","error.va.sf-cc-yr.02":"Rok w dacie wa\u017cno\u015bci ma nieprawid\u0142ow\u0105 d\u0142ugo\u015b\u0107","error.va.sf-cc-cvc.01":"Pole Kod zabezpieczaj\u0105cy jest puste","error.va.sf-cc-cvc.02":"Kod zabezpieczaj\u0105cy ma nieprawid\u0142ow\u0105 d\u0142ugo\u015b\u0107","error.va.sf-ach-num.01":"Pole Numer rachunku jest puste","error.va.sf-ach-num.02":"Numer rachunku ma nieprawid\u0142ow\u0105 d\u0142ugo\u015b\u0107","error.va.sf-ach-loc.01":"Pole Numer rozliczeniowy banku jest puste","error.va.sf-ach-loc.02":"Numer rozliczeniowy banku ma nieprawid\u0142ow\u0105 d\u0142ugo\u015b\u0107","error.va.sf-kcp-pwd.01":"Pole Has\u0142o jest puste","error.va.sf-kcp-pwd.02":"Has\u0142o ma nieprawid\u0142ow\u0105 d\u0142ugo\u015b\u0107","error.giftcard.no-balance":"Saldo karty podarunkowej jest puste","error.giftcard.card-error":"W naszych rejestrach nie ma karty podarunkowej o tym numerze","error.giftcard.currency-error":"Karty podarunkowe s\u0105 wa\u017cne tylko w walucie, w kt\xf3rej zosta\u0142y wydane","amazonpay.signout":"Wyloguj si\u0119 z Amazon","amazonpay.changePaymentDetails":"Zmie\u0144 szczeg\xf3\u0142y p\u0142atno\u015bci","partialPayment.warning":"Wybierz inn\u0105 metod\u0119 p\u0142atno\u015bci, aby zap\u0142aci\u0107 pozosta\u0142\u0105 kwot\u0119","partialPayment.remainingBalance":"Pozosta\u0142e saldo wynosi %{kwota}","bankTransfer.beneficiary":"Beneficjent","bankTransfer.iban":"IBAN","bankTransfer.bic":"BIC","bankTransfer.reference":"Ref. sprze.","bankTransfer.introduction":"Kontynuuj tworzenie nowej p\u0142atno\u015bci przelewem bankowym. Mo\u017cesz u\u017cy\u0107 szczeg\xf3\u0142\xf3w na nast\u0119pnym ekranie, aby sfinalizowa\u0107 t\u0119 p\u0142atno\u015b\u0107.","bankTransfer.instructions":"Dzi\u0119kujemy za zakup. Doko\u0144cz p\u0142atno\u015b\u0107 przy u\u017cyciu poni\u017cszych informacji.","bacs.accountHolderName":"Imi\u0119 i nazwisko posiadacza rachunku","bacs.accountHolderName.invalid":"Nieprawid\u0142owe imi\u0119 i nazwisko posiadacza rachunku","bacs.accountNumber":"Numer rachunku","bacs.accountNumber.invalid":"Nieprawid\u0142owy numer rachunku","bacs.bankLocationId":"Numer rozliczeniowy SORT","bacs.bankLocationId.invalid":"Nieprawid\u0142owy numer rozliczeniowy SORT","bacs.consent.amount":"Wyra\u017cam zgod\u0119 na pobranie powy\u017cszej kwoty z mojego rachunku bankowego.","bacs.consent.account":"Potwierdzam, \u017ce konto jest zarejestrowane na moje nazwisko i jestem jedynym sygnatariuszem wymaganym do autoryzacji polecenia zap\u0142aty na tym koncie.",edit:"Edytuj","bacs.confirm":"Potwierd\u017a i zap\u0142a\u0107","bacs.result.introduction":"Pobierz dyspozycj\u0119 polecenia zap\u0142aty (DDI/upowa\u017cnienie)","download.pdf":"Pobierz PDF","creditCard.encryptedCardNumber.aria.iframeTitle":"Element Iframe dla numeru zabezpieczonej karty","creditCard.encryptedCardNumber.aria.label":"Numer karty ","creditCard.encryptedExpiryDate.aria.iframeTitle":"Element Iframe dla daty wa\u017cno\u015bci zabezpieczonej karty","creditCard.encryptedExpiryDate.aria.label":"Data wa\u017cno\u015bci","creditCard.encryptedExpiryMonth.aria.iframeTitle":"Element Iframe dla miesi\u0105ca wyga\u015bni\u0119cia zabezpieczonej karty","creditCard.encryptedExpiryMonth.aria.label":"Data wa\u017cno\u015bci - miesi\u0105c","creditCard.encryptedExpiryYear.aria.iframeTitle":"Element Iframe dla roku wyga\u015bni\u0119cia zabezpieczonej karty","creditCard.encryptedExpiryYear.aria.label":"Data wa\u017cno\u015bci - rok","creditCard.encryptedSecurityCode.aria.iframeTitle":"Element Iframe dla kodu bezpiecze\u0144stwa zabezpieczonej karty","creditCard.encryptedSecurityCode.aria.label":"Kod zabezpieczaj\u0105cy","creditCard.encryptedPassword.aria.iframeTitle":"Element Iframe dla karty zabezpieczonej has\u0142em","creditCard.encryptedPassword.aria.label":"Pierwsze 2 cyfry has\u0142a karty","giftcard.encryptedCardNumber.aria.iframeTitle":"Element Iframe dla numeru zabezpieczonej karty podarunkowej","giftcard.encryptedCardNumber.aria.label":"Numer karty podarunkowej","giftcard.encryptedSecurityCode.aria.iframeTitle":"Element Iframe dla kodu bezpiecze\u0144stwa zabezpieczonej karty podarunkowej","giftcard.encryptedSecurityCode.aria.label":"Kod zabezpieczaj\u0105cy karty podarunkowej",giftcardTransactionLimit:"Maks. dozwolona kwota (%{amount}) na transakcj\u0119 t\u0105 kart\u0105 upominkow\u0105","ach.encryptedBankAccountNumber.aria.iframeTitle":"Element Iframe dla zabezpieczonego numeru rachunku bankowego","ach.encryptedBankAccountNumber.aria.label":"Rachunek bankowy","ach.encryptedBankLocationId.aria.iframeTitle":"Element Iframe dla zabezpieczonego kodu bankowego (Bank Routing Number)","ach.encryptedBankLocationId.aria.label":"Numer rozliczeniowy banku","twint.saved":"zapisano",orPayWith:"lub zap\u0142a\u0107",invalidFormatExpects:"Niepoprawny format. Oczekiwany format: %{format}","upi.qrCodeWaitingMessage":"Zeskanuj kod QR za pomoc\u0105 preferowanej aplikacji UPI, aby doko\u0144czy\u0107 p\u0142atno\u015b\u0107","upi.vpaWaitingMessage":"Otw\xf3rz aplikacj\u0119 UPI, aby potwierdzi\u0107 p\u0142atno\u015b\u0107","upi.modeSelection":"Dokonaj wyboru sposobu korzystania z UPI.","onlineBanking.termsAndConditions":"Kontynuuj\u0105c, zgadzasz si\u0119 z %#Warunkami \u015bwiadczenia us\u0142ug%#.","ctp.loading.poweredByCtp":"Dzia\u0142a w oparciu o us\u0142ug\u0119 Click to Pay","ctp.loading.intro":"Sprawdzamy, czy masz zapisane karty Click to Pay...","ctp.login.title":"Przejd\u017a do Click to Pay","ctp.login.subtitle":"Wprowad\u017a adres e-mail po\u0142\u0105czony z Click to Pay, aby kontynuowa\u0107.","ctp.login.inputLabel":"E-mail","ctp.logout.notYou":"To nie Ty?","ctp.logout.notYourCards":"To nie Twoje karty?","ctp.logout.notYourCard":"To nie Twoja karta?","ctp.logout.notYourProfile":"To nie Tw\xf3j profil?","ctp.otp.fieldLabel":"Kod jednorazowy","ctp.otp.resendCode":"Ponowne wys\u0142anie kodu","ctp.otp.codeResent":"Wys\u0142ano kod ponownie","ctp.otp.title":"Przejd\u017a do kart Click to Pay","ctp.otp.subtitle":"Wprowad\u017a kod %@ wys\u0142any na adres %@, aby potwierdzi\u0107 swoj\u0105 to\u017csamo\u015b\u0107.","ctp.emptyProfile.message":"W tym profilu Click to Pay nie zarejestrowano \u017cadnych kart","ctp.separatorText":"lub przypadk\xf3w jej u\u017cycia","ctp.cards.title":"Doko\u0144cz p\u0142atno\u015b\u0107 za pomoc\u0105 funkcji Click to Pay","ctp.cards.subtitle":"Wybierz kart\u0119, kt\xf3rej chcesz u\u017cy\u0107.","ctp.cards.expiredCard":"Okres wa\u017cno\u015bci min\u0105\u0142","ctp.manualCardEntry":"R\u0119czne wprowadzanie kart","ctp.aria.infoModalButton":"Co to jest Click to Pay","ctp.infoPopup.title":"Click to Pay zapewnia wygod\u0119 p\u0142atno\u015bci zbli\u017ceniowych w Internecie","ctp.infoPopup.subtitle":"Szybka i bezpieczna metoda p\u0142atno\u015bci obs\u0142ugiwana przez karty p\u0142atnicze Mastercard, Visa i inne.","ctp.infoPopup.benefit1":"Click to Pay zabezpiecza Twoje informacje za pomoc\u0105 szyfrowania","ctp.infoPopup.benefit2":"U\u017cywaj tej funkcji u sprzedawc\xf3w na ca\u0142ym \u015bwiecie","ctp.infoPopup.benefit3":"Skonfiguruj raz i p\u0142a\u0107 bezproblemowo w przysz\u0142o\u015bci","ctp.errors.AUTH_INVALID":"Nieprawid\u0142owe dane uwierzytelniaj\u0105ce","ctp.errors.NOT_FOUND":"Nie znaleziono konta, wprowad\u017a prawid\u0142owy adres e-mail lub kontynuuj, r\u0119cznie wprowadzaj\u0105c kart\u0119","ctp.errors.ID_FORMAT_UNSUPPORTED":"Format nie jest obs\u0142ugiwany","ctp.errors.FRAUD":"Konto u\u017cytkownika zosta\u0142o zablokowane lub wy\u0142\u0105czone","ctp.errors.CONSUMER_ID_MISSING":"We wniosku brakuje danych dotycz\u0105cych to\u017csamo\u015bci konsumenta","ctp.errors.ACCT_INACCESSIBLE":"To konto jest obecnie niedost\u0119pne, np. jest zablokowane","ctp.errors.CODE_INVALID":"Nieprawid\u0142owy kod weryfikacyjny","ctp.errors.CODE_EXPIRED":"Kod wygas\u0142","ctp.errors.RETRIES_EXCEEDED":"Przekroczono limit pr\xf3b generowania has\u0142a jednorazowego","ctp.errors.OTP_SEND_FAILED":"Nie uda\u0142o si\u0119 wys\u0142a\u0107 has\u0142a jednorazowego do odbiorcy","ctp.errors.REQUEST_TIMEOUT":"Co\u015b posz\u0142o nie tak, spr\xf3buj ponownie lub skorzystaj z r\u0119cznego wprowadzania karty","ctp.errors.UNKNOWN_ERROR":"Co\u015b posz\u0142o nie tak, spr\xf3buj ponownie lub skorzystaj z r\u0119cznego wprowadzania karty","ctp.errors.SERVICE_ERROR":"Co\u015b posz\u0142o nie tak, spr\xf3buj ponownie lub skorzystaj z r\u0119cznego wprowadzania karty","ctp.errors.SERVER_ERROR":"Co\u015b posz\u0142o nie tak, spr\xf3buj ponownie lub skorzystaj z r\u0119cznego wprowadzania karty","ctp.errors.INVALID_PARAMETER":"Co\u015b posz\u0142o nie tak, spr\xf3buj ponownie lub skorzystaj z r\u0119cznego wprowadzania karty","ctp.errors.AUTH_ERROR":"Co\u015b posz\u0142o nie tak, spr\xf3buj ponownie lub skorzystaj z r\u0119cznego wprowadzania karty","paymentMethodsList.aria.label":"Wybierz metod\u0119 p\u0142atno\u015bci"}}),T3=Object.freeze({__proto__:null,default:{payButton:"Pagar","payButton.redirecting":"Redirecionando...","payButton.with":"Pague %{value} com %{maskedData}",close:"Fechar",storeDetails:"Salvar para meu pr\xf3ximo pagamento","creditCard.holderName":"Nome no cart\xe3o","creditCard.holderName.placeholder":"J. Smith","creditCard.holderName.invalid":"Nome do titular do cart\xe3o inv\xe1lido","creditCard.numberField.title":"N\xfamero do cart\xe3o","creditCard.expiryDateField.title":"Data de validade","creditCard.expiryDateField.placeholder":"MM/AA","creditCard.expiryDateField.month":"M\xeas","creditCard.expiryDateField.month.placeholder":"MM","creditCard.expiryDateField.year.placeholder":"AA","creditCard.expiryDateField.year":"Ano","creditCard.cvcField.title":"CVC/CVV","creditCard.storeDetailsButton":"Lembrar para a pr\xf3xima vez","creditCard.cvcField.placeholder.4digits":"4 d\xedgitos","creditCard.cvcField.placeholder.3digits":"3 d\xedgitos","creditCard.taxNumber.placeholder":"AAAMMDD / 0123456789",installments:"Op\xe7\xf5es de Parcelamento",installmentOption:"%{times}x %{partialValue}",installmentOptionMonths:"%{times} meses","installments.oneTime":"Pagamento \xe0 vista","installments.installments":"Pagamento parcelado","installments.revolving":"Pagamento rotativo","sepaDirectDebit.ibanField.invalid":"N\xfamero de conta inv\xe1lido","sepaDirectDebit.nameField.placeholder":"J. Silva","sepa.ownerName":"Nome do titular da conta banc\xe1ria","sepa.ibanNumber":"N\xfamero de conta (NIB)","error.title":"Erro","error.subtitle.redirect":"Falha no redirecionamento","error.subtitle.payment":"Falha no pagamento","error.subtitle.refused":"Pagamento recusado","error.message.unknown":"Ocorreu um erro desconhecido","errorPanel.title":"Erros existentes","idealIssuer.selectField.title":"Banco","idealIssuer.selectField.placeholder":"Selecione seu banco","creditCard.success":"Pagamento bem-sucedido",loading:"Carregando...",continue:"Continuar",continueTo:"Continuar para","wechatpay.timetopay":"Voc\xea tem %@ para pagar","wechatpay.scanqrcode":"Escanear c\xf3digo QR",personalDetails:"Informa\xe7\xf5es pessoais",companyDetails:"Dados da empresa","companyDetails.name":"Nome da empresa","companyDetails.registrationNumber":"N\xfamero de registro",socialSecurityNumber:"CPF",firstName:"Nome","firstName.invalid":"Este n\xe3o \xe9 um nome v\xe1lido",infix:"Prefixo",lastName:"Sobrenome","lastName.invalid":"Este n\xe3o \xe9 um sobrenome v\xe1lido",mobileNumber:"Celular","mobileNumber.invalid":"N\xfamero de celular inv\xe1lido",city:"Cidade",postalCode:"CEP","postalCode.optional":"C\xf3digo postal (opcional)",countryCode:"C\xf3digo do pa\xeds",telephoneNumber:"N\xfamero de telefone",dateOfBirth:"Data de nascimento",shopperEmail:"Endere\xe7o de e-mail",gender:"G\xeanero",male:"Masculino",female:"Feminino",billingAddress:"Endere\xe7o de cobran\xe7a",street:"Rua",stateOrProvince:"Estado ou prov\xedncia",country:"Pa\xeds",houseNumberOrName:"N\xfamero da casa",separateDeliveryAddress:"Especificar um endere\xe7o de entrega separado",deliveryAddress:"Endere\xe7o de entrega",zipCode:"C\xf3digo postal",apartmentSuite:"Apartamento/Conjunto",provinceOrTerritory:"Prov\xedncia ou territ\xf3rio",cityTown:"Cidade",address:"Endere\xe7o",state:"Estado","field.title.optional":"(opcional)","creditCard.cvcField.title.optional":"CVC / CVV (opcional)","issuerList.wallet.placeholder":"Selecione uma carteira",privacyPolicy:"Pol\xedtica de Privacidade","afterPay.agreement":"Eu concordo com as %@ do AfterPay",paymentConditions:"condi\xe7\xf5es de pagamento",openApp:"Abrir o aplicativo","voucher.readInstructions":"Leia as instru\xe7\xf5es","voucher.introduction":"Obrigado pela sua compra, use o cupom a seguir para concluir o seu pagamento.","voucher.expirationDate":"Data de validade","voucher.alternativeReference":"Refer\xeancia alternativa","dragonpay.voucher.non.bank.selectField.placeholder":"Selecione o seu fornecedor","dragonpay.voucher.bank.selectField.placeholder":"Selecione seu banco","voucher.paymentReferenceLabel":"Refer\xeancia de pagamento","voucher.surcharge":"Inclui %@ de sobretaxa","voucher.introduction.doku":"Obrigado pela sua compra, use a informa\xe7\xe3o a seguir para concluir o seu pagamento.","voucher.shopperName":"Nome do consumidor","voucher.merchantName":"Comerciante online","voucher.introduction.econtext":"Obrigado pela sua compra, use a informa\xe7\xe3o a seguir para concluir o seu pagamento.","voucher.telephoneNumber":"N\xfamero de telefone","voucher.shopperReference":"Refer\xeancia do consumidor","voucher.collectionInstitutionNumber":"N\xfamero da institui\xe7\xe3o de cobran\xe7a","voucher.econtext.telephoneNumber.invalid":"O n\xfamero de telefone deve ter 10 ou 11 d\xedgitos","boletobancario.btnLabel":"Gerar Boleto","boleto.sendCopyToEmail":"Enviar uma c\xf3pia por e-mail","button.copy":"Copiar","button.download":"Baixar","boleto.socialSecurityNumber.invalid":"O campo n\xe3o \xe9 v\xe1lido","creditCard.storedCard.description.ariaLabel":"O cart\xe3o armazenado termina em %@","voucher.entity":"Entidade",donateButton:"Doar",notNowButton:"Agora n\xe3o",thanksForYourSupport:"Obrigado pelo apoio!",preauthorizeWith:"Pr\xe9-autorizar com",confirmPreauthorization:"Confirmar pr\xe9-autoriza\xe7\xe3o",confirmPurchase:"Confirmar compra",applyGiftcard:"Resgatar",giftcardBalance:"Saldo do vale-presente",deductedBalance:"Saldo debitado","creditCard.pin.title":"Pin","creditCard.encryptedPassword.label":"Primeiros dois d\xedgitos da senha do cart\xe3o","creditCard.encryptedPassword.invalid":"Senha inv\xe1lida","creditCard.taxNumber":"Data de nascimento do titular do cart\xe3o ou n\xfamero de registro corporativo","creditCard.taxNumber.label":"Data de nascimento do titular do cart\xe3o (AAMMDD) ou n\xfamero de registro corporativo (10 d\xedgitos)","creditCard.taxNumber.labelAlt":"N\xfamero de registro corporativo (10 d\xedgitos)","creditCard.taxNumber.invalid":"Data de nascimento do titular do cart\xe3o ou n\xfamero de registro corporativo inv\xe1lidos","storedPaymentMethod.disable.button":"Remover","storedPaymentMethod.disable.confirmation":"Remover m\xe9todo de pagamento armazenado","storedPaymentMethod.disable.confirmButton":"Sim, remover","storedPaymentMethod.disable.cancelButton":"Cancelar","ach.bankAccount":"Conta banc\xe1ria","ach.accountHolderNameField.title":"Nome do titular da conta","ach.accountHolderNameField.placeholder":"J. Smith","ach.accountHolderNameField.invalid":"Nome do titular da conta inv\xe1lido","ach.accountNumberField.title":"N\xfamero da conta","ach.accountNumberField.invalid":"N\xfamero de conta inv\xe1lido","ach.accountLocationField.title":"N\xfamero de roteamento ABA","ach.accountLocationField.invalid":"N\xfamero de roteamento ABA inv\xe1lido","ach.savedBankAccount":"Conta banc\xe1ria cadastrada","select.state":"Selecionar estado","select.stateOrProvince":"Selecione estado ou prov\xedncia","select.provinceOrTerritory":"Selecionar prov\xedncia ou territ\xf3rio","select.country":"Selecione o pa\xeds","select.noOptionsFound":"Nenhuma op\xe7\xe3o encontrada","select.filter.placeholder":"Pesquisar...","telephoneNumber.invalid":"N\xfamero de telefone inv\xe1lido",qrCodeOrApp:"ou","paypal.processingPayment":"Processando pagamento...",generateQRCode:"Gerar c\xf3digo QR","await.waitForConfirmation":"Aguardando confirma\xe7\xe3o","mbway.confirmPayment":"Confirme seu pagamento no aplicativo MB WAY","shopperEmail.invalid":"Endere\xe7o de e-mail inv\xe1lido","dateOfBirth.format":"DD/MM/AAAA","dateOfBirth.invalid":"Voc\xea deve ter pelo menos 18 anos","blik.confirmPayment":"Abra o aplicativo do seu banco para confirmar o pagamento.","blik.invalid":"Digite 6 n\xfameros","blik.code":"C\xf3digo de 6 d\xedgitos","blik.help":"Obtenha o c\xf3digo no aplicativo do seu banco.","swish.pendingMessage":"Depois de escanear o QR, o status pode ficar pendente por at\xe9 10 minutos. N\xe3o tente refazer o pagamento antes desse per\xedodo para evitar cobran\xe7a duplicada.","field.valid":"Campo v\xe1lido","field.invalid":"Campo inv\xe1lido","error.va.gen.01":"Campo incompleto","error.va.gen.02":"Campo inv\xe1lido","error.va.sf-cc-num.01":"O n\xfamero do cart\xe3o \xe9 inv\xe1lido","error.va.sf-cc-num.02":"O campo do n\xfamero do cart\xe3o est\xe1 vazio","error.va.sf-cc-num.03":"O n\xfamero do cart\xe3o inserido n\xe3o \xe9 v\xe1lido","error.va.sf-cc-num.04":"O n\xfamero do cart\xe3o tem o comprimento errado","error.va.sf-cc-dat.01":"Data de vencimento: cart\xe3o muito antigo","error.va.sf-cc-dat.02":"Data de vencimento: data muito distante no futuro","error.va.sf-cc-dat.03":"Data de vencimento: o cart\xe3o vence antes da data de pagamento","error.va.sf-cc-dat.04":"O campo da data de vencimento est\xe1 vazio","error.va.sf-cc-dat.05":"A data de vencimento tem o comprimento errado","error.va.sf-cc-mth.01":"O campo do m\xeas de vencimento est\xe1 vazio","error.va.sf-cc-yr.01":"O campo do ano de vencimento est\xe1 vazio","error.va.sf-cc-yr.02":"O ano de vencimento tem o comprimento errado","error.va.sf-cc-cvc.01":"O campo do c\xf3digo de seguran\xe7a est\xe1 vazio","error.va.sf-cc-cvc.02":"O c\xf3digo de seguran\xe7a tem o comprimento errado","error.va.sf-ach-num.01":"O campo do n\xfamero da conta banc\xe1ria est\xe1 vazio","error.va.sf-ach-num.02":"O n\xfamero da conta banc\xe1ria tem o comprimento errado","error.va.sf-ach-loc.01":"O campo do n\xfamero de identifica\xe7\xe3o do banco est\xe1 vazio","error.va.sf-ach-loc.02":"O n\xfamero de identifica\xe7\xe3o do banco tem o comprimento errado","error.va.sf-kcp-pwd.01":"O campo da senha est\xe1 vazio","error.va.sf-kcp-pwd.02":"A senha tem o comprimento errado","error.giftcard.no-balance":"Este vale-presente tem saldo zero","error.giftcard.card-error":"N\xe3o existe um vale-presente com esse n\xfamero em nossos registros","error.giftcard.currency-error":"Os vales-presente s\xe3o v\xe1lidos somente na moeda em que foram emitidos","amazonpay.signout":"Sair do Amazon","amazonpay.changePaymentDetails":"Alterar dados de pagamento","partialPayment.warning":"Selecione outro m\xe9todo de pagamento para pagar o restante","partialPayment.remainingBalance":"O saldo restante ser\xe1 %{amount}","bankTransfer.beneficiary":"Benefici\xe1rio","bankTransfer.iban":"IBAN","bankTransfer.bic":"BIC","bankTransfer.reference":"Refer\xeancia","bankTransfer.introduction":"Continue criando o novo pagamento por transfer\xeancia banc\xe1ria. Use as informa\xe7\xf5es na tela a seguir para conclu\xed-lo.","bankTransfer.instructions":"Obrigado pela sua compra, use a informa\xe7\xe3o a seguir para concluir o seu pagamento.","bacs.accountHolderName":"Nome do titular da conta banc\xe1ria","bacs.accountHolderName.invalid":"Nome do titular da conta banc\xe1ria inv\xe1lido","bacs.accountNumber":"N\xfamero da conta banc\xe1ria","bacs.accountNumber.invalid":"N\xfamero da conta banc\xe1ria inv\xe1lido","bacs.bankLocationId":"C\xf3digo de classifica\xe7\xe3o","bacs.bankLocationId.invalid":"C\xf3digo de classifica\xe7\xe3o inv\xe1lido","bacs.consent.amount":"Concordo que o valor acima seja deduzido da minha conta banc\xe1ria.","bacs.consent.account":"Confirmo que a conta est\xe1 em meu nome e que sou o \xfanico signat\xe1rio que deve autorizar o d\xe9bito direto nessa conta.",edit:"Editar","bacs.confirm":"Confirmar e pagar","bacs.result.introduction":"Baixar instru\xe7\xe3o de d\xe9bito direto (DDI)","download.pdf":"Baixar PDF","creditCard.encryptedCardNumber.aria.iframeTitle":"Iframe para n\xfamero de cart\xe3o seguro","creditCard.encryptedCardNumber.aria.label":"N\xfamero do cart\xe3o","creditCard.encryptedExpiryDate.aria.iframeTitle":"Iframe para data de validade do cart\xe3o seguro","creditCard.encryptedExpiryDate.aria.label":"Data de validade","creditCard.encryptedExpiryMonth.aria.iframeTitle":"Iframe para m\xeas de validade do cart\xe3o seguro","creditCard.encryptedExpiryMonth.aria.label":"M\xeas de vencimento","creditCard.encryptedExpiryYear.aria.iframeTitle":"Iframe para ano de validade do cart\xe3o seguro","creditCard.encryptedExpiryYear.aria.label":"Ano de vencimento","creditCard.encryptedSecurityCode.aria.iframeTitle":"Iframe para c\xf3digo de seguran\xe7a do cart\xe3o seguro","creditCard.encryptedSecurityCode.aria.label":"C\xf3digo de seguran\xe7a","creditCard.encryptedPassword.aria.iframeTitle":"Iframe para senha segura do cart\xe3o","creditCard.encryptedPassword.aria.label":"Primeiros dois d\xedgitos da senha do cart\xe3o","giftcard.encryptedCardNumber.aria.iframeTitle":"Iframe para n\xfamero de cart\xe3o-presente seguro","giftcard.encryptedCardNumber.aria.label":"N\xfamero do vale-presente","giftcard.encryptedSecurityCode.aria.iframeTitle":"Iframe para c\xf3digo de seguran\xe7a do cart\xe3o-presente seguro","giftcard.encryptedSecurityCode.aria.label":"C\xf3digo de seguran\xe7a do vale-presente",giftcardTransactionLimit:"M\xe1ximo de %{amount} permitido por transa\xe7\xe3o neste cart\xe3o-presente","ach.encryptedBankAccountNumber.aria.iframeTitle":"Iframe para n\xfamero de conta banc\xe1ria segura","ach.encryptedBankAccountNumber.aria.label":"Conta banc\xe1ria","ach.encryptedBankLocationId.aria.iframeTitle":"Iframe para n\xfamero de roteamento banc\xe1rio seguro","ach.encryptedBankLocationId.aria.label":"N\xfamero de roteamento do banco","pix.instructions":"Abra o app com sua chave PIX cadastrada, escolha Pagar com Pix e escaneie o QR Code ou copie e cole o c\xf3digo","twint.saved":"salvo",orPayWith:"ou pague com",invalidFormatExpects:"Formato inv\xe1lido. Formato esperado: %{format}","upi.qrCodeWaitingMessage":"Escaneie o QR code com o aplicativo UPI de sua prefer\xeancia para concluir o pagamento","upi.vpaWaitingMessage":"Abra o aplicativo UPI para confirmar o pagamento","upi.modeSelection":"Selecione como voc\xea gostaria de usar o UPI.","onlineBanking.termsAndConditions":"Ao continuar, voc\xea concorda com os %#termos e condi\xe7\xf5es%#","ctp.loading.poweredByCtp":"Desenvolvido por Click to Pay","ctp.loading.intro":"Estamos verificando se voc\xea tem algum cart\xe3o salvo no Click to Pay...","ctp.login.title":"Continuar para o Click to Pay","ctp.login.subtitle":"Digite o endere\xe7o de e-mail associado ao Click to Pay para continuar.","ctp.login.inputLabel":"E-mail","ctp.logout.notYou":"N\xe3o \xe9 voc\xea?","ctp.logout.notYourCards":"N\xe3o \xe9 o seu cart\xe3o?","ctp.logout.notYourCard":"N\xe3o \xe9 o seu cart\xe3o?","ctp.logout.notYourProfile":"N\xe3o \xe9 o seu perfil?","ctp.otp.fieldLabel":"C\xf3digo de acesso \xfanico","ctp.otp.resendCode":"Reenviar c\xf3digo","ctp.otp.codeResent":"C\xf3digo reenviado","ctp.otp.title":"Acesse seus cart\xf5es Click to Pay","ctp.otp.subtitle":"Digite o c\xf3digo %@ enviado para %@ para confirmar que \xe9 voc\xea.","ctp.emptyProfile.message":"N\xe3o h\xe1 nenhum cart\xe3o cadastrado neste perfil do Click to Pay","ctp.separatorText":"ou use","ctp.cards.title":"Concluir o pagamento com o Click to Pay","ctp.cards.subtitle":"Selecione um cart\xe3o para usar.","ctp.cards.expiredCard":"Vencido","ctp.manualCardEntry":"Entrada manual do cart\xe3o","ctp.aria.infoModalButton":"O que \xe9 Click to Pay","ctp.infoPopup.title":"O Click to Pay traz a facilidade do pagamento online sem contato","ctp.infoPopup.subtitle":"Um m\xe9todo de pagamento r\xe1pido e seguro, compat\xedvel com Mastercard, Visa e outros cart\xf5es.","ctp.infoPopup.benefit1":"O Click to Pay usa criptografia para manter suas informa\xe7\xf5es seguras e protegidas","ctp.infoPopup.benefit2":"Use com comerciantes no mundo todo","ctp.infoPopup.benefit3":"Configure apenas uma vez e simplifique seus pagamentos no futuro","ctp.errors.AUTH_INVALID":"Autentica\xe7\xe3o inv\xe1lida","ctp.errors.NOT_FOUND":"Nenhuma conta foi encontrada. Informe um e-mail v\xe1lido ou continue inserindo os dados do cart\xe3o manualmente","ctp.errors.ID_FORMAT_UNSUPPORTED":"Formato n\xe3o compat\xedvel","ctp.errors.FRAUD":"A conta do usu\xe1rio foi bloqueada ou desativada","ctp.errors.CONSUMER_ID_MISSING":"A identidade do consumidor est\xe1 ausente na solicita\xe7\xe3o","ctp.errors.ACCT_INACCESSIBLE":"Esta conta n\xe3o est\xe1 dispon\xedvel no momento. Ela pode estar bloqueada, por exemplo","ctp.errors.CODE_INVALID":"C\xf3digo de verifica\xe7\xe3o incorreto","ctp.errors.CODE_EXPIRED":"Esse c\xf3digo expirou","ctp.errors.RETRIES_EXCEEDED":"O limite de tentativas para gerar a senha de uso \xfanico foi excedido","ctp.errors.OTP_SEND_FAILED":"N\xe3o foi poss\xedvel enviar a senha de uso \xfanico ao destinat\xe1rio","ctp.errors.REQUEST_TIMEOUT":"Algo deu errado. Tente de novo ou insira os dados do cart\xe3o manualmente","ctp.errors.UNKNOWN_ERROR":"Algo deu errado. Tente de novo ou insira os dados do cart\xe3o manualmente","ctp.errors.SERVICE_ERROR":"Algo deu errado. Tente de novo ou insira os dados do cart\xe3o manualmente","ctp.errors.SERVER_ERROR":"Algo deu errado. Tente de novo ou insira os dados do cart\xe3o manualmente","ctp.errors.INVALID_PARAMETER":"Algo deu errado. Tente de novo ou insira os dados do cart\xe3o manualmente","ctp.errors.AUTH_ERROR":"Algo deu errado. Tente de novo ou insira os dados do cart\xe3o manualmente","paymentMethodsList.aria.label":"Escolha um m\xe9todo de pagamento"}}),B3=Object.freeze({__proto__:null,default:{payButton:"Pagar","payButton.redirecting":"Redirecionar...","payButton.with":"Pagar %{value} com %{maskedData}",close:"Fechar",storeDetails:"Guardar para o meu pr\xf3ximo pagamento","creditCard.holderName":"Nome no cart\xe3o","creditCard.holderName.placeholder":"J. Smith","creditCard.holderName.invalid":"Nome do titular do cart\xe3o inv\xe1lido","creditCard.numberField.title":"N\xfamero de cart\xe3o","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"Data de validade","creditCard.expiryDateField.placeholder":"MM/AA","creditCard.expiryDateField.month":"M\xeas","creditCard.expiryDateField.month.placeholder":"MM","creditCard.expiryDateField.year.placeholder":"AA","creditCard.expiryDateField.year":"Ano","creditCard.cvcField.title":"CVC / CVV","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"Lembre-se para a pr\xf3xima vez","creditCard.cvcField.placeholder.4digits":"4 d\xedgitos","creditCard.cvcField.placeholder.3digits":"3 d\xedgitos","creditCard.taxNumber.placeholder":"AAMMDD / 0123456789",installments:"N\xfamero de presta\xe7\xf5es",installmentOption:"%{times}x %{partialValue}",installmentOptionMonths:"%{times} meses","installments.oneTime":"Pagamento \xfanico","installments.installments":"Pagamento em presta\xe7\xf5es","installments.revolving":"Pagamento rotativo","sepaDirectDebit.ibanField.invalid":"N\xfamero de conta inv\xe1lido","sepaDirectDebit.nameField.placeholder":"J. Smith","sepa.ownerName":"Nome do Titular","sepa.ibanNumber":"N\xfamero da conta (IBAN)","error.title":"Erro","error.subtitle.redirect":"Falha ao redirecionar","error.subtitle.payment":"O pagamento falhou","error.subtitle.refused":"Pagamento recusado","error.message.unknown":"Ocorreu um erro desconhecido","errorPanel.title":"Erros existentes","idealIssuer.selectField.title":"Banco","idealIssuer.selectField.placeholder":"Selecione o seu banco","creditCard.success":"Pagamento bem-sucedido",loading:"A carregar",continue:"Continuar",continueTo:"Continuar para","wechatpay.timetopay":"Tem %@ para pagar","wechatpay.scanqrcode":"Digitalizar c\xf3digo QR",personalDetails:"Detalhes pessoais",companyDetails:"Detalhes da empresa","companyDetails.name":"Nome da empresa","companyDetails.registrationNumber":"N\xfamero de registo",socialSecurityNumber:"N\xfamero de previd\xeancia social",firstName:"Nome pr\xf3prio","firstName.invalid":"O nome pr\xf3prio n\xe3o \xe9 v\xe1lido",infix:"Prefixo",lastName:"Apelido","lastName.invalid":"O apelido n\xe3o \xe9 v\xe1lido",mobileNumber:"N\xfamero de telem\xf3vel","mobileNumber.invalid":"N\xfamero de telem\xf3vel inv\xe1lido",city:"Cidade",postalCode:"C\xf3digo postal","postalCode.optional":"C\xf3digo postal (opcional)",countryCode:"C\xf3digo do pa\xeds",telephoneNumber:"N\xfamero de telefone",dateOfBirth:"Data de nascimento",shopperEmail:"Endere\xe7o de correio eletr\xf3nico",gender:"G\xe9nero",male:"Homem",female:"Feminino",billingAddress:"Morada de cobran\xe7a",street:"Rua",stateOrProvince:"Estado ou prov\xedncia",country:"Pa\xeds",houseNumberOrName:"N\xfamero de porta",separateDeliveryAddress:"Especifique uma morada de entrega separada",deliveryAddress:"Morada de entrega",zipCode:"C\xf3digo postal",apartmentSuite:"Apartamento/Suite",provinceOrTerritory:"Prov\xedncia ou Territ\xf3rio",cityTown:"Cidade/cidade",address:"Morada",state:"Estado","field.title.optional":"(opcional)","creditCard.cvcField.title.optional":"CVC / CVV (opcional)","issuerList.wallet.placeholder":"Selecione a sua carteira",privacyPolicy:"Pol\xedtica de Privacidade","afterPay.agreement":"Concordo com o %@ do AfterPay",paymentConditions:"condi\xe7\xf5es de pagamento",openApp:"Abra a aplica\xe7\xe3o","voucher.readInstructions":"Ler instru\xe7\xf5es","voucher.introduction":"Obrigado pela sua compra, utilize o seguinte cup\xe3o para completar o seu pagamento.","voucher.expirationDate":"Data de validade","voucher.alternativeReference":"Refer\xeancia alternativa","dragonpay.voucher.non.bank.selectField.placeholder":"Selecione seu fornecedor","dragonpay.voucher.bank.selectField.placeholder":"Selecione o seu banco","voucher.paymentReferenceLabel":"Refer\xeancia de pagamento","voucher.surcharge":"Incl. %@ sobretaxa","voucher.introduction.doku":"Obrigado pela sua compra, use as seguintes informa\xe7\xf5es para concluir o seu pagamento.","voucher.shopperName":"Nome do comprador","voucher.merchantName":"Comerciante","voucher.introduction.econtext":"Obrigado pela sua compra, use as seguintes informa\xe7\xf5es para concluir o seu pagamento.","voucher.telephoneNumber":"N\xfamero de telefone","voucher.shopperReference":"Refer\xeancia do consumidor","voucher.collectionInstitutionNumber":"N\xfamero da institui\xe7\xe3o de recolha","voucher.econtext.telephoneNumber.invalid":"O n\xfamero de telefone deve ter 10 ou 11 d\xedgitos","boletobancario.btnLabel":"Gerar comprovativo","boleto.sendCopyToEmail":"Enviar uma c\xf3pia para o meu e-mail","button.copy":"Copiar","button.download":"Download","boleto.socialSecurityNumber":"CPF/CNPJ","boleto.socialSecurityNumber.invalid":"O campo n\xe3o \xe9 v\xe1lido","creditCard.storedCard.description.ariaLabel":"O cart\xe3o armazenado termina em %@","voucher.entity":"Entidade",donateButton:"Doar",notNowButton:"Agora n\xe3o",thanksForYourSupport:"Obrigado pelo seu apoio!",preauthorizeWith:"Pr\xe9-autorizar com",confirmPreauthorization:"Confirmar pr\xe9-autoriza\xe7\xe3o",confirmPurchase:"Confirmar compra",applyGiftcard:"Resgatar",giftcardBalance:"Saldo do cart\xe3o-presente",deductedBalance:"Saldo deduzido","creditCard.pin.title":"Pin","creditCard.encryptedPassword.label":"Primeiros 2 d\xedgitos da palavra-passe do cart\xe3o","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"Palavra-passe inv\xe1lida","creditCard.taxNumber":"Data de nascimento do titular do cart\xe3o ou n\xfamero de registo da Empresa","creditCard.taxNumber.label":"Data de nascimento do titular do cart\xe3o (AAMMDD) ou n\xfamero de registo da Empresa (10 d\xedgitos)","creditCard.taxNumber.labelAlt":"N\xfamero de registo da empresa (10 d\xedgitos)","creditCard.taxNumber.invalid":"Data de nascimento do titular do cart\xe3o ou n\xfamero de registo empresarial inv\xe1lido","storedPaymentMethod.disable.button":"Remover","storedPaymentMethod.disable.confirmation":"Remover m\xe9todo de pagamento guardado","storedPaymentMethod.disable.confirmButton":"Sim, remover","storedPaymentMethod.disable.cancelButton":"Cancelar","ach.bankAccount":"Conta banc\xe1ria","ach.accountHolderNameField.title":"Nome do titular da conta","ach.accountHolderNameField.placeholder":"J. Smith","ach.accountHolderNameField.invalid":"Nome do titular da conta inv\xe1lido","ach.accountNumberField.title":"N\xfamero da conta","ach.accountNumberField.invalid":"N\xfamero de conta inv\xe1lido","ach.accountLocationField.title":"N\xfamero de encaminhamento da ABA","ach.accountLocationField.invalid":"N\xfamero de encaminhamento ABA inv\xe1lido","ach.savedBankAccount":"Conta banc\xe1ria guardada","select.state":"Selecione estado","select.stateOrProvince":"Selecione estado ou prov\xedncia","select.provinceOrTerritory":"Selecionar prov\xedncia ou territ\xf3rio","select.country":"Selecionar pa\xeds","select.noOptionsFound":"Nenhuma op\xe7\xe3o encontrada","select.filter.placeholder":"Pesquisar...","telephoneNumber.invalid":"N\xfamero de telefone inv\xe1lido",qrCodeOrApp:"ou","paypal.processingPayment":"A processar pagamento...",generateQRCode:"Gerar c\xf3digo QR","await.waitForConfirmation":"A aguardar confirma\xe7\xe3o","mbway.confirmPayment":"Confirme o seu pagamento na aplica\xe7\xe3o MB WAY","shopperEmail.invalid":"Endere\xe7o de e-mail inv\xe1lido","dateOfBirth.format":"DD/MM/AAAA","dateOfBirth.invalid":"Deve ter pelo menos 18 anos","blik.confirmPayment":"Abra a sua aplica\xe7\xe3o banc\xe1ria para confirmar o pagamento.","blik.invalid":"Digite 6 n\xfameros","blik.code":"C\xf3digo de 6 d\xedgitos","blik.help":"Obtenha o c\xf3digo da sua aplica\xe7\xe3o banc\xe1ria.","swish.pendingMessage":"Ap\xf3s a leitura, o estado pode estar pendente por at\xe9 10 minutos. Tentar pagar novamente dentro desse prazo pode resultar em v\xe1rias cobran\xe7as.","field.valid":"Campo v\xe1lido","field.invalid":"Campo inv\xe1lido","error.va.gen.01":"Campo incompleto","error.va.gen.02":"Campo inv\xe1lido","error.va.sf-cc-num.01":"O n\xfamero do cart\xe3o n\xe3o \xe9 v\xe1lido","error.va.sf-cc-num.02":"O campo n\xfamero do cart\xe3o est\xe1 vazio","error.va.sf-cc-num.03":"N\xfamero de cart\xe3o n\xe3o suportado inserido","error.va.sf-cc-num.04":"O n\xfamero do cart\xe3o tem o comprimento errado","error.va.sf-cc-dat.01":"Data de validade: cart\xe3o muito antigo","error.va.sf-cc-dat.02":"Data de validade: data muito distante no futuro","error.va.sf-cc-dat.03":"Data de validade: o seu cart\xe3o expira antes da data de check-out","error.va.sf-cc-dat.04":"O campo de data de validade est\xe1 vazio","error.va.sf-cc-dat.05":"A data de validade tem o comprimento errado","error.va.sf-cc-mth.01":"O campo do m\xeas de validade est\xe1 vazio","error.va.sf-cc-yr.01":"O campo de ano de validade est\xe1 vazio","error.va.sf-cc-yr.02":"O ano de validade tem o comprimento errado","error.va.sf-cc-cvc.01":"O campo do c\xf3digo de seguran\xe7a est\xe1 vazio","error.va.sf-cc-cvc.02":"O c\xf3digo de seguran\xe7a tem o comprimento errado","error.va.sf-ach-num.01":"O campo de n\xfamero da conta banc\xe1ria est\xe1 vazio","error.va.sf-ach-num.02":"O n\xfamero da conta banc\xe1ria tem o comprimento errado","error.va.sf-ach-loc.01":"O campo do n\xfamero de encaminhamento banc\xe1rio est\xe1 vazio","error.va.sf-ach-loc.02":"O n\xfamero de identifica\xe7\xe3o banc\xe1ria tem o comprimento errado","error.va.sf-kcp-pwd.01":"O campo de palavra-passe est\xe1 vazio","error.va.sf-kcp-pwd.02":"A palavra-passe tem o comprimento errado","error.giftcard.no-balance":"Este cart\xe3o oferta tem saldo zero","error.giftcard.card-error":"Nos nossos registos n\xe3o temos qualquer cart\xe3o oferta com este n\xfamero","error.giftcard.currency-error":"Os cart\xf5es oferta s\xf3 s\xe3o v\xe1lidos na moeda em que foram emitidos","amazonpay.signout":"Sair da Amazon","amazonpay.changePaymentDetails":"Alterar detalhes de pagamento","partialPayment.warning":"Selecione outro m\xe9todo de pagamento para pagar o restante","partialPayment.remainingBalance":"O saldo restante ser\xe1 de %{amount}","bankTransfer.beneficiary":"Benefici\xe1rio(a)","bankTransfer.iban":"IBAN","bankTransfer.bic":"BIC","bankTransfer.reference":"Refer\xeancia","bankTransfer.introduction":"Continue para criar um novo pagamento de transfer\xeancia banc\xe1ria. Pode usar os detalhes no ecr\xe3 a seguir para finalizar este pagamento.","bankTransfer.instructions":"Obrigado pela sua compra, use as seguintes informa\xe7\xf5es para concluir o seu pagamento.","bacs.accountHolderName":"Nome do titular da conta banc\xe1ria","bacs.accountHolderName.invalid":"Nome do titular da conta banc\xe1ria inv\xe1lido","bacs.accountNumber":"N\xfamero da conta banc\xe1ria","bacs.accountNumber.invalid":"N\xfamero de conta banc\xe1ria inv\xe1lido","bacs.bankLocationId":"C\xf3digo de classifica\xe7\xe3o","bacs.bankLocationId.invalid":"C\xf3digo de classifica\xe7\xe3o inv\xe1lido","bacs.consent.amount":"Concordo que o valor acima seja deduzido da minha conta banc\xe1ria.","bacs.consent.account":"Confirmo que a conta est\xe1 em meu nome e sou o \xfanico signat\xe1rio necess\xe1rio para autorizar o d\xe9bito autom\xe1tico nesta conta.",edit:"Editar","bacs.confirm":"Confirmar e pagar","bacs.result.introduction":"Descarregue a sua Instru\xe7\xe3o de D\xe9bito Direto (DDI / Mandato)","download.pdf":"Descarregar PDF","creditCard.encryptedCardNumber.aria.iframeTitle":"Iframe para n\xfamero de cart\xe3o seguro","creditCard.encryptedCardNumber.aria.label":"N\xfamero de cart\xe3o","creditCard.encryptedExpiryDate.aria.iframeTitle":"Iframe para data de validade segura do cart\xe3o","creditCard.encryptedExpiryDate.aria.label":"Data de validade","creditCard.encryptedExpiryMonth.aria.iframeTitle":"Iframe para o m\xeas de vencimento do cart\xe3o seguro","creditCard.encryptedExpiryMonth.aria.label":"M\xeas de validade","creditCard.encryptedExpiryYear.aria.iframeTitle":"Iframe para ano de validade do cart\xe3o seguro","creditCard.encryptedExpiryYear.aria.label":"Ano de validade","creditCard.encryptedSecurityCode.aria.iframeTitle":"Iframe para c\xf3digo de seguran\xe7a do cart\xe3o seguro","creditCard.encryptedSecurityCode.aria.label":"C\xf3digo de seguran\xe7a","creditCard.encryptedPassword.aria.iframeTitle":"Iframe para palavra-passe segura do cart\xe3o","creditCard.encryptedPassword.aria.label":"Primeiros 2 d\xedgitos da palavra-passe do cart\xe3o","giftcard.encryptedCardNumber.aria.iframeTitle":"Iframe para n\xfamero de cart\xe3o oferta seguro","giftcard.encryptedCardNumber.aria.label":"N\xfamero do cart\xe3o presente","giftcard.encryptedSecurityCode.aria.iframeTitle":"Iframe para c\xf3digo de seguran\xe7a de cart\xe3o oferta seguro","giftcard.encryptedSecurityCode.aria.label":"C\xf3digo de seguran\xe7a do cart\xe3o presente",giftcardTransactionLimit:"M\xe1ximo de %{amount} permitido por transa\xe7\xe3o neste cart\xe3o presente","ach.encryptedBankAccountNumber.aria.iframeTitle":"Iframe para n\xfamero de conta banc\xe1ria seguro","ach.encryptedBankAccountNumber.aria.label":"Conta banc\xe1ria","ach.encryptedBankLocationId.aria.iframeTitle":"Iframe para n\xfamero de encaminhamento banc\xe1rio seguro","ach.encryptedBankLocationId.aria.label":"N\xfamero de identifica\xe7\xe3o banc\xe1ria","pix.instructions":"Abra a aplica\xe7\xe3o com a chave registada PIX, escolha Pagar com PIX e digitalize o QR Code ou copie e cole o c\xf3digo","twint.saved":"salvou",orPayWith:"ou pague com",invalidFormatExpects:"Formato inv\xe1lido. Formato esperado: %{format}","upi.qrCodeWaitingMessage":"Digitalize o c\xf3digo QR usando a sua aplica\xe7\xe3o UPI preferida para concluir o pagamento","upi.vpaWaitingMessage":"Abra a aplica\xe7\xe3o UPI para confirmar o pagamento","upi.modeSelection":"Fa\xe7a uma sele\xe7\xe3o de como gostaria de usar a UPI.","onlineBanking.termsAndConditions":"Ao continuar, concorda com os %#termos e condi\xe7\xf5es%#","ctp.loading.poweredByCtp":"Fornecido pelo Click to Pay","ctp.loading.intro":"Estamos a verificar se tem algum cart\xe3o Click to Pay guardado ...","ctp.login.title":"Continuar para o Click to Pay","ctp.login.subtitle":"Introduza o endere\xe7o de e-mail associado ao Click to Pay para continuar.","ctp.login.inputLabel":"E-mail","ctp.logout.notYou":"N\xe3o \xe9 voc\xea?","ctp.logout.notYourCards":"N\xe3o s\xe3o os seus cart\xf5es?","ctp.logout.notYourCard":"N\xe3o \xe9 o seu cart\xe3o?","ctp.logout.notYourProfile":"N\xe3o \xe9 o seu perfil?","ctp.otp.fieldLabel":"C\xf3digo \xfanico","ctp.otp.resendCode":"Reenviar c\xf3digo","ctp.otp.codeResent":"C\xf3digo reenviado","ctp.otp.title":"Aceda aos seus cart\xf5es Click to Pay","ctp.otp.subtitle":"Introduza o c\xf3digo %@ enviado para %@ para verificar se \xe9 voc\xea.","ctp.emptyProfile.message":"Nenhum cart\xe3o registado neste perfil Click to Pay","ctp.separatorText":"ou utilize","ctp.cards.title":"Pagamento completo com Click to Pay","ctp.cards.subtitle":"Selecione um cart\xe3o para usar.","ctp.cards.expiredCard":"Expirado","ctp.manualCardEntry":"Introdu\xe7\xe3o manual do cart\xe3o","ctp.aria.infoModalButton":"O que \xe9 Click to Pay","ctp.infoPopup.title":"O Click to Pay traz a facilidade do contactless online","ctp.infoPopup.subtitle":"Um m\xe9todo de pagamento r\xe1pido e seguro suportado pela Mastercard, Visa e outros cart\xf5es de pagamento.","ctp.infoPopup.benefit1":"Click to Pay utiliza encripta\xe7\xe3o para manter as suas informa\xe7\xf5es seguras","ctp.infoPopup.benefit2":"Use-o com comerciantes em todo o mundo","ctp.infoPopup.benefit3":"Configure uma vez para pagamentos sem complica\xe7\xf5es no futuro","ctp.errors.AUTH_INVALID":"Autentica\xe7\xe3o inv\xe1lida","ctp.errors.NOT_FOUND":"Nenhuma conta encontrada, insira um e-mail v\xe1lido ou continue usando a entrada manual do cart\xe3o","ctp.errors.ID_FORMAT_UNSUPPORTED":"Formato n\xe3o suportado","ctp.errors.FRAUD":"A conta de utilizador foi bloqueada ou desativada","ctp.errors.CONSUMER_ID_MISSING":"A identidade do consumidor est\xe1 em falta no pedido","ctp.errors.ACCT_INACCESSIBLE":"Esta conta n\xe3o est\xe1 atualmente dispon\xedvel, por exemplo, est\xe1 bloqueada","ctp.errors.CODE_INVALID":"C\xf3digo de verifica\xe7\xe3o incorreto","ctp.errors.CODE_EXPIRED":"Este c\xf3digo expirou","ctp.errors.RETRIES_EXCEEDED":"Ultrapassou o limite para o n\xfamero de tentativas para a gera\xe7\xe3o OTP.","ctp.errors.OTP_SEND_FAILED":"N\xe3o foi poss\xedvel enviar a OTP ao destinat\xe1rio","ctp.errors.REQUEST_TIMEOUT":"Algo correu mal, tente de novo ou use a entrada do cart\xe3o manual","ctp.errors.UNKNOWN_ERROR":"Algo correu mal, tente de novo ou use a entrada do cart\xe3o manual","ctp.errors.SERVICE_ERROR":"Algo correu mal, tente de novo ou use a entrada do cart\xe3o manual","ctp.errors.SERVER_ERROR":"Algo correu mal, tente de novo ou use a entrada do cart\xe3o manual","ctp.errors.INVALID_PARAMETER":"Algo correu mal, tente de novo ou use a entrada do cart\xe3o manual","ctp.errors.AUTH_ERROR":"Algo correu mal, tente de novo ou use a entrada do cart\xe3o manual","paymentMethodsList.aria.label":"Escolha um m\xe9todo de pagamento"}}),j3=Object.freeze({__proto__:null,default:{payButton:"Pl\u0103ti\u021bi","payButton.redirecting":"Se redirec\u021bioneaz\u0103...","payButton.with":"Pl\u0103ti\u021bi %{value} cu %{maskedData}",close:"\xcenchidere",storeDetails:"Salveaz\u0103 pentru urm\u0103toarea mea plat\u0103","creditCard.holderName":"Numele de pe card","creditCard.holderName.placeholder":"J. Smith","creditCard.holderName.invalid":"Numele posesorului de card este incorect","creditCard.numberField.title":"Num\u0103r card","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"Data expir\u0103rii","creditCard.expiryDateField.placeholder":"LL/AA","creditCard.expiryDateField.month":"Lun\u0103","creditCard.expiryDateField.month.placeholder":"LL","creditCard.expiryDateField.year.placeholder":"AA","creditCard.expiryDateField.year":"An","creditCard.cvcField.title":"CVC/CVV","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"Re\u021bine pentru data viitoare","creditCard.cvcField.placeholder.4digits":"4 cifre","creditCard.cvcField.placeholder.3digits":"3 cifre","creditCard.taxNumber.placeholder":"AALLZZ / 0123456789",installments:"Num\u0103r de rate",installmentOption:"%{times}x %{partialValue}",installmentOptionMonths:"%{times} luni","installments.oneTime":"Plat\u0103 unic\u0103","installments.installments":"Plat\u0103 \xeen rate","installments.revolving":"Plat\u0103 recurent\u0103","sepaDirectDebit.ibanField.invalid":"Num\u0103rul de cont este incorect","sepaDirectDebit.nameField.placeholder":"J. Smith","sepa.ownerName":"Nume posesor","sepa.ibanNumber":"Num\u0103r cont (IBAN)","error.title":"Eroare","error.subtitle.redirect":"Redirec\u021bionare e\u0219uat\u0103","error.subtitle.payment":"Plat\u0103 e\u0219uat\u0103","error.subtitle.refused":"Plat\u0103 refuzat\u0103","error.message.unknown":"S-a produs o eroare necunoscut\u0103","errorPanel.title":"Erori existente","idealIssuer.selectField.title":"Banc\u0103","idealIssuer.selectField.placeholder":"Selecta\u021bi-v\u0103 banca","creditCard.success":"Plat\u0103 reu\u0219it\u0103",loading:"Se \xeencarc\u0103...",continue:"Continuare",continueTo:"Continua\u021bi c\u0103tre","wechatpay.timetopay":"Trebuie s\u0103 achita\u021bi %@","wechatpay.scanqrcode":"Scana\u021bi codul QR",personalDetails:"Informa\u021bii personale",companyDetails:"Informa\u021bii societate","companyDetails.name":"Denumirea societ\u0103\u021bii","companyDetails.registrationNumber":"Num\u0103r de \xeenregistrare",socialSecurityNumber:"Cod numeric personal",firstName:"Prenume","firstName.invalid":"Prenumele nu este valabil",infix:"Titulatur\u0103",lastName:"Nume de familie","lastName.invalid":"Numele de familie nu este valabil",mobileNumber:"Num\u0103r de mobil","mobileNumber.invalid":"Num\u0103r de telefon mobil incorect",city:"Ora\u0219",postalCode:"Cod po\u0219tal","postalCode.optional":"Cod po\u0219tal (op\u021bional)",countryCode:"Codul \u021b\u0103rii",telephoneNumber:"Num\u0103r de telefon",dateOfBirth:"Data na\u0219terii",shopperEmail:"Adres\u0103 de e-mail",gender:"Gen",male:"B\u0103rbat",female:"Femeie",billingAddress:"Adresa de facturare",street:"Strada",stateOrProvince:"Jude\u021b sau provincie",country:"\u021aar\u0103",houseNumberOrName:"Num\u0103r",separateDeliveryAddress:"Specifica\u021bi o adres\u0103 de livrare separat\u0103",deliveryAddress:"Adres\u0103 de livrare",zipCode:"Cod po\u0219tal",apartmentSuite:"Apartament",provinceOrTerritory:"Provincie sau teritoriu",cityTown:"Ora\u0219/localitate",address:"Adres\u0103",state:"Stat","field.title.optional":"(op\u021bional)","creditCard.cvcField.title.optional":"CVC/CVV (op\u021bional)","issuerList.wallet.placeholder":"Selecta\u021bi-v\u0103 portofelul",privacyPolicy:"Politica de confiden\u021bialitate","afterPay.agreement":"Sunt de acord cu %@ apar\u021bin\xe2nd AfterPay",paymentConditions:"condi\u021bii de plat\u0103",openApp:"Deschide\u021bi aplica\u021bia","voucher.readInstructions":"Citi\u021bi instruc\u021biunile","voucher.introduction":"V\u0103 mul\u021bumim pentru cump\u0103r\u0103turi, v\u0103 rug\u0103m s\u0103 utiliza\u021bi urm\u0103torul cupon pentru a v\u0103 finaliza plata.","voucher.expirationDate":"Data de expirare","voucher.alternativeReference":"Referin\u021b\u0103 alternativ\u0103","dragonpay.voucher.non.bank.selectField.placeholder":"Selecta\u021bi furnizorul dvs.","dragonpay.voucher.bank.selectField.placeholder":"Selecta\u021bi banca dvs.","voucher.paymentReferenceLabel":"Referin\u021ba pl\u0103\u021bii","voucher.surcharge":"Include suprataxa de %@","voucher.introduction.doku":"V\u0103 mul\u021bumim pentru cump\u0103r\u0103turi, v\u0103 rug\u0103m s\u0103 utiliza\u021bi urm\u0103toarele informa\u021bii pentru a v\u0103 finaliza plata.","voucher.shopperName":"Nume cump\u0103r\u0103tor","voucher.merchantName":"Comerciant","voucher.introduction.econtext":"V\u0103 mul\u021bumim pentru cump\u0103r\u0103turi, v\u0103 rug\u0103m s\u0103 utiliza\u021bi urm\u0103toarele informa\u021bii pentru a v\u0103 finaliza plata.","voucher.telephoneNumber":"Num\u0103r de telefon","voucher.shopperReference":"Referin\u021b\u0103 cump\u0103r\u0103tor","voucher.collectionInstitutionNumber":"Num\u0103r institu\u021bie de colectare","voucher.econtext.telephoneNumber.invalid":"Num\u0103rul de telefon trebuie s\u0103 aib\u0103 10 sau 11 cifre","boletobancario.btnLabel":"Generare Boleto","boleto.sendCopyToEmail":"Trimite o copie la adresa mea de e-mail","button.copy":"Copiere","button.download":"Desc\u0103rcare","boleto.socialSecurityNumber.invalid":"C\xe2mpul nu este valid","creditCard.storedCard.description.ariaLabel":"Cardul memorat se termin\u0103 \xeen %@","voucher.entity":"Entitate",donateButton:"Dona\u021bi",notNowButton:"Nu acum",thanksForYourSupport:"V\u0103 mul\u021bumim pentru sprijin!",preauthorizeWith:"Preautorizare cu",confirmPreauthorization:"Confirma\u021bi preautorizarea",confirmPurchase:"Confirma\u021bi achizi\u021bia",applyGiftcard:"Valorificare",giftcardBalance:"Soldul de pe cardul cadou",deductedBalance:"Sold sc\u0103zut","creditCard.pin.title":"PIN","creditCard.encryptedPassword.label":"Primele 2 cifre ale parolei aferente cardului","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"Parol\u0103 incorect\u0103","creditCard.taxNumber":"Data de na\u0219tere a posesorului de card sau codul unic de \xeenregistrare al societ\u0103\u021bii","creditCard.taxNumber.label":"Data de na\u0219tere a posesorului de card (AALLZZ) sau num\u0103rul de \xeenregistrare al societ\u0103\u021bii (10 cifre).","creditCard.taxNumber.labelAlt":"Num\u0103rul de \xeenregistrare al societ\u0103\u021bii (10 cifre)","creditCard.taxNumber.invalid":"Data de na\u0219tere a posesorului de card sau num\u0103rul de \xeenregistrare al societ\u0103\u021bii este incorect","storedPaymentMethod.disable.button":"\u0218tergere","storedPaymentMethod.disable.confirmation":"\u0218terge\u021bi metoda de plat\u0103 memorat\u0103","storedPaymentMethod.disable.confirmButton":"Da, \u0219terge","storedPaymentMethod.disable.cancelButton":"Anulare","ach.bankAccount":"Cont bancar","ach.accountHolderNameField.title":"Numele titularului de cont","ach.accountHolderNameField.placeholder":"J. Smith","ach.accountHolderNameField.invalid":"Numele titularului de cont este incorect","ach.accountNumberField.title":"Num\u0103r de cont","ach.accountNumberField.invalid":"Num\u0103rul de cont este incorect","ach.accountLocationField.title":"Num\u0103r de direc\u021bionare ABA","ach.accountLocationField.invalid":"Num\u0103r de direc\u021bionare ABA incorect","ach.savedBankAccount":"Cont bancar salvat","select.state":"Selecta\u021bi statul","select.stateOrProvince":"Selecta\u021bi jude\u021bul sau provincia","select.provinceOrTerritory":"Selecta\u021bi provincia sau teritoriul","select.country":"Selecta\u021bi \u021bara","select.noOptionsFound":"Nu s-a g\u0103sit nicio op\u021biune","select.filter.placeholder":"C\u0103utare...","telephoneNumber.invalid":"Num\u0103r de telefon incorect",qrCodeOrApp:"sau","paypal.processingPayment":"Se prelucreaz\u0103 plata...",generateQRCode:"Genera\u021bi codul QR","await.waitForConfirmation":"Se a\u0219teapt\u0103 confirmarea","mbway.confirmPayment":"Confirma\u021bi plata \xeen aplica\u021bia MB WAY","shopperEmail.invalid":"Adres\u0103 de e-mail incorect\u0103","dateOfBirth.format":"ZZ/LL/AAAA","dateOfBirth.invalid":"Trebuie s\u0103 ave\u021bi minimum 18 ani","blik.confirmPayment":"Deschide\u021bi aplica\u021bia dvs. de banking pentru a confirma plata.","blik.invalid":"Introduce\u021bi 6 cifre","blik.code":"Cod din 6 cifre","blik.help":"Ob\u021bine\u021bi codul din aplica\u021bia dvs. de banking.","swish.pendingMessage":"Dup\u0103 ce scana\u021bi, starea poate fi \u201e\xeen a\u0219teptare\u201d timp de maximum 10 minute. \xcencerc\u0103rile de a pl\u0103ti din nou \xeen acest r\u0103stimp pot genera prelev\u0103ri multiple de fonduri.","field.valid":"C\xe2mp valid","field.invalid":"C\xe2mp incorect","error.va.gen.01":"C\xe2mp incomplet","error.va.gen.02":"C\xe2mp incorect","error.va.sf-cc-num.01":"Num\u0103rul de card nu este valabil","error.va.sf-cc-num.02":"C\xe2mpul pentru num\u0103rul de card este necompletat","error.va.sf-cc-num.03":"A fost completat un num\u0103r de card neacceptat","error.va.sf-cc-num.04":"Num\u0103rul de card are lungime gre\u0219it\u0103","error.va.sf-cc-dat.01":"Data de expirare: card prea vechi","error.va.sf-cc-dat.02":"Data de expirare: dat\u0103 prea \xeendep\u0103rtat\u0103 \xeen viitor","error.va.sf-cc-dat.03":"Data de expirare: cardul dvs. expir\u0103 \xeenainte de data valid\u0103rii comenzii","error.va.sf-cc-dat.04":"C\xe2mpul pentru data de expirare este necompletat","error.va.sf-cc-dat.05":"Data de expirare are o lungime gre\u0219it\u0103","error.va.sf-cc-mth.01":"C\xe2mpul pentru luna de expirare este necompletat","error.va.sf-cc-yr.01":"C\xe2mpul pentru anul de expirare este necompletat","error.va.sf-cc-yr.02":"Anul de expirare este o lungime gre\u0219it\u0103","error.va.sf-cc-cvc.01":"C\xe2mpul codului de securitate este necompletat","error.va.sf-cc-cvc.02":"Codul de securitate are lungimea gre\u0219it\u0103","error.va.sf-ach-num.01":"C\xe2mpul pentru num\u0103rul de cont bancar este necompletat","error.va.sf-ach-num.02":"Num\u0103rul contului bancar are lungimea gre\u0219it\u0103","error.va.sf-ach-loc.01":"C\xe2mpul pentru num\u0103rul de rutare al b\u0103ncii este necompletat","error.va.sf-ach-loc.02":"Num\u0103rul de rutare al b\u0103ncii are lungimea gre\u0219it\u0103","error.va.sf-kcp-pwd.01":"C\xe2mpul pentru parol\u0103 este necompletat","error.va.sf-kcp-pwd.02":"Parola are lungimea gre\u0219it\u0103","error.giftcard.no-balance":"Acest card cadou are soldul zero","error.giftcard.card-error":"\xcen eviden\u021bele noastre nu figureaz\u0103 niciun card cadou cu acest num\u0103r","error.giftcard.currency-error":"Cardurile cadou sunt valabile numai \xeen moneda \xeen care au fost emise","amazonpay.signout":"Deconecta\u021bi-v\u0103 de pe platforma Amazon","amazonpay.changePaymentDetails":"Modifica\u021bi detaliile de plat\u0103","partialPayment.warning":"Pentru a achita suma r\u0103mas\u0103, selecta\u021bi o alt\u0103 metod\u0103 de plat\u0103","partialPayment.remainingBalance":"Soldul r\u0103mas va fi de %{amount}","bankTransfer.beneficiary":"Beneficiar","bankTransfer.iban":"IBAN","bankTransfer.bic":"BIC","bankTransfer.reference":"Referin\u0163\u0103","bankTransfer.introduction":"Continua\u021bi s\u0103 crea\u021bi o nou\u0103 plat\u0103 prin transfer bancar. Pute\u021bi utiliza detaliile din ecranul urm\u0103tor pentru a finaliza aceast\u0103 plat\u0103.","bankTransfer.instructions":"V\u0103 mul\u021bumim pentru cump\u0103r\u0103turi, v\u0103 rug\u0103m s\u0103 utiliza\u021bi urm\u0103toarele informa\u021bii pentru a v\u0103 finaliza plata.","bacs.accountHolderName":"Numele titularului contului bancar","bacs.accountHolderName.invalid":"Numele titularului contului bancar este incorect","bacs.accountNumber":"Num\u0103rul contului bancar","bacs.accountNumber.invalid":"Num\u0103rul contului bancar este incorect","bacs.bankLocationId":"Cod de identificare bancar\u0103","bacs.bankLocationId.invalid":"Cod de identificare bancar\u0103 incorect","bacs.consent.amount":"Sunt de acord ca suma men\u021bionat\u0103 mai sus s\u0103 fie dedus\u0103 din contul meu bancar.","bacs.consent.account":"Confirm c\u0103 sunt titularul acestui cont \u0219i c\u0103 sunt singurul semnatar necesar pentru autorizarea debitului direct pentru acest cont.",edit:"Editare","bacs.confirm":"Confirma\u021bi \u0219i pl\u0103ti\u021bi","bacs.result.introduction":"Desc\u0103rca\u021bi instruc\u021biunile de debitare direct\u0103 (DDI/mandat)","download.pdf":"Desc\u0103rca\u021bi PDF","creditCard.encryptedCardNumber.aria.iframeTitle":"Iframe pentru num\u0103rul cardului securizat","creditCard.encryptedCardNumber.aria.label":"Num\u0103r card","creditCard.encryptedExpiryDate.aria.iframeTitle":"Iframe pentru data de expirare a cardului securizat","creditCard.encryptedExpiryDate.aria.label":"Data expir\u0103rii","creditCard.encryptedExpiryMonth.aria.iframeTitle":"Iframe pentru luna de expirare a cardului securizat","creditCard.encryptedExpiryMonth.aria.label":"Luna de expirare","creditCard.encryptedExpiryYear.aria.iframeTitle":"Iframe pentru anul de expirare a cardului securizat","creditCard.encryptedExpiryYear.aria.label":"Anul de expirare","creditCard.encryptedSecurityCode.aria.iframeTitle":"Iframe pentru codul de securitate al cardului securizat","creditCard.encryptedSecurityCode.aria.label":"Cod de securitate","creditCard.encryptedPassword.aria.iframeTitle":"Iframe pentru parola cardului securizat","creditCard.encryptedPassword.aria.label":"Primele 2 cifre ale parolei aferente cardului","giftcard.encryptedCardNumber.aria.iframeTitle":"Iframe pentru num\u0103rul cardului cadou securizat","giftcard.encryptedCardNumber.aria.label":"Num\u0103rul cardului cadou","giftcard.encryptedSecurityCode.aria.iframeTitle":"Iframe pentru codul de securitate al cardului cadou securizat","giftcard.encryptedSecurityCode.aria.label":"Codul de securitate al cardului cadou",giftcardTransactionLimit:"Pentru acest card cadou, suma maxim\u0103 permis\u0103 per tranzac\u021bie este de %{amount}","ach.encryptedBankAccountNumber.aria.iframeTitle":"Iframe pentru num\u0103rul contului bancar securizat","ach.encryptedBankAccountNumber.aria.label":"Cont bancar","ach.encryptedBankLocationId.aria.iframeTitle":"Iframe pentru num\u0103rul securizat de direc\u021bionare bancar\u0103 (routing number)","ach.encryptedBankLocationId.aria.label":"Codul SWIFT al b\u0103ncii","twint.saved":"salvat",orPayWith:"sau pl\u0103ti\u021bi cu",invalidFormatExpects:"Format nevalid. Format solicitat: %{format}","upi.qrCodeWaitingMessage":"Scana\u021bi codul QR folosind aplica\u021bia UPI preferat\u0103 pentru a finaliza plata","upi.vpaWaitingMessage":"Deschide\u021bi aplica\u021bia UPI pentru a confirma plata","upi.modeSelection":"Selecta\u021bi modul \xeen care dori\u021bi s\u0103 utiliza\u021bi UPI.","onlineBanking.termsAndConditions":"Continu\xe2nd, sunte\u021bi de acord cu %#terms and conditions%#","ctp.loading.poweredByCtp":"Sus\u021binut de Click to Pay","ctp.loading.intro":"Verific\u0103m dac\u0103 ave\u021bi vreun card salvat cu Click to Pay...","ctp.login.title":"Continua\u021bi c\u0103tre Click to Pay","ctp.login.subtitle":"Introduce\u021bi adresa de e-mail care este conectat\u0103 la Click to Pay pentru a continua.","ctp.login.inputLabel":"E-mail","ctp.logout.notYou":"Nu sunte\u021bi dvs.?","ctp.logout.notYourCards":"Nu sunt cardurile dvs.?","ctp.logout.notYourCard":"Nu este cardul dvs.?","ctp.logout.notYourProfile":"Nu este profilul dvs.?","ctp.otp.fieldLabel":"Cod unic","ctp.otp.resendCode":"Retrimite\u021bi codul","ctp.otp.codeResent":"Cod retrimis","ctp.otp.title":"Accesa\u021bi-v\u0103 cardurile Click to Pay","ctp.otp.subtitle":"Introduce\u021bi codul %@ pe care l-am trimis la %@ pentru a confirma c\u0103 sunte\u021bi dvs.","ctp.emptyProfile.message":"Niciun card \xeenregistrat \xeen acest profil Click to Pay","ctp.separatorText":"sau folosi\u021bi","ctp.cards.title":"Finaliza\u021bi plata cu Click to Pay","ctp.cards.subtitle":"Selecta\u021bi un card pe care s\u0103 \xeel utiliza\u021bi.","ctp.cards.expiredCard":"Expirat","ctp.manualCardEntry":"Introducere manual\u0103 a cardului","ctp.aria.infoModalButton":"Ce este Click to Pay","ctp.infoPopup.title":"Click to Pay v\u0103 ofer\u0103 facilit\u0103\u021bile contactless, online","ctp.infoPopup.subtitle":"O metod\u0103 de plat\u0103 rapid\u0103 \u0219i sigur\u0103, compatibil\u0103 cu Mastercard, Visa \u0219i alte carduri de plat\u0103.","ctp.infoPopup.benefit1":"Click to Pay folose\u0219te criptarea pentru a v\u0103 p\u0103stra informa\u021biile \xeen siguran\u021b\u0103","ctp.infoPopup.benefit2":"Utiliza\u021bi-l la comercian\u021bii din \xeentreaga lume","ctp.infoPopup.benefit3":"Configura\u021bi o dat\u0103 pentru a pl\u0103ti f\u0103r\u0103 probleme \xeen viitor","ctp.errors.AUTH_INVALID":"Autentificare incorect\u0103","ctp.errors.NOT_FOUND":"Nu s-a g\u0103sit niciun cont; introduce\u021bi o adres\u0103 de e-mail valabil\u0103 sau continua\u021bi complet\xe2nd manual cardul","ctp.errors.ID_FORMAT_UNSUPPORTED":"Format neacceptat","ctp.errors.FRAUD":"Contul de utilizator a fost blocat sau dezactivat","ctp.errors.CONSUMER_ID_MISSING":"Identitatea consumatorului lipse\u0219te din solicitare","ctp.errors.ACCT_INACCESSIBLE":"Acest cont nu este disponibil \xeen prezent, de exemplu, este blocat.","ctp.errors.CODE_INVALID":"Cod de verificare incorect","ctp.errors.CODE_EXPIRED":"Acest cod a expirat","ctp.errors.RETRIES_EXCEEDED":"A fost dep\u0103\u0219it\u0103 limita num\u0103rului de \xeencerc\u0103ri pentru generarea parolei unice","ctp.errors.OTP_SEND_FAILED":"Parola unic\u0103 nu a putut fi trimis\u0103 destinatarului","ctp.errors.REQUEST_TIMEOUT":"Ceva nu a mers bine, \xeencerca\u021bi din nou sau introduce\u021bi manual cardul","ctp.errors.UNKNOWN_ERROR":"Ceva nu a mers bine, \xeencerca\u021bi din nou sau introduce\u021bi manual cardul","ctp.errors.SERVICE_ERROR":"Ceva nu a mers bine, \xeencerca\u021bi din nou sau introduce\u021bi manual cardul","ctp.errors.SERVER_ERROR":"Ceva nu a mers bine, \xeencerca\u021bi din nou sau introduce\u021bi manual cardul","ctp.errors.INVALID_PARAMETER":"Ceva nu a mers bine, \xeencerca\u021bi din nou sau introduce\u021bi manual cardul","ctp.errors.AUTH_ERROR":"Ceva nu a mers bine, \xeencerca\u021bi din nou sau introduce\u021bi manual cardul","paymentMethodsList.aria.label":"Alege\u021bi o metod\u0103 de plat\u0103"}}),z3=Object.freeze({__proto__:null,default:{payButton:"\u0417\u0430\u043f\u043b\u0430\u0442\u0438\u0442\u044c","payButton.redirecting":"\u041f\u0435\u0440\u0435\u043d\u0430\u043f\u0440\u0430\u0432\u043b\u0435\u043d\u0438\u0435...","payButton.with":"\u041e\u043f\u043b\u0430\u0442\u0438\u0442\u044c %{value} %{maskedData}",close:"\u0417\u0430\u043a\u0440\u044b\u0442\u044c",storeDetails:"\u0421\u043e\u0445\u0440\u0430\u043d\u0438\u0442\u044c \u0434\u043b\u044f \u0441\u043b\u0435\u0434\u0443\u044e\u0449\u0435\u0433\u043e \u043f\u043b\u0430\u0442\u0435\u0436\u0430","creditCard.holderName":"\u0418\u043c\u044f \u043d\u0430 \u043a\u0430\u0440\u0442\u0435","creditCard.holderName.placeholder":"\u0418. \u041f\u0435\u0442\u0440\u043e\u0432","creditCard.holderName.invalid":"\u041d\u0435\u0432\u0435\u0440\u043d\u043e\u0435 \u0438\u043c\u044f \u0432\u043b\u0430\u0434\u0435\u043b\u044c\u0446\u0430 \u043a\u0430\u0440\u0442\u044b","creditCard.numberField.title":"\u041d\u043e\u043c\u0435\u0440 \u043a\u0430\u0440\u0442\u044b","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"\u0421\u0440\u043e\u043a \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044f","creditCard.expiryDateField.placeholder":"\u041c\u041c/\u0413\u0413","creditCard.expiryDateField.month":"\u041c\u0435\u0441\u044f\u0446","creditCard.expiryDateField.month.placeholder":"\u041c\u041c","creditCard.expiryDateField.year.placeholder":"\u0413\u0413","creditCard.expiryDateField.year":"\u0413\u043e\u0434","creditCard.cvcField.title":"CVC / CVV","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"\u0417\u0430\u043f\u043e\u043c\u043d\u0438\u0442\u044c \u043d\u0430 \u0441\u043b\u0435\u0434\u0443\u044e\u0449\u0438\u0439 \u0440\u0430\u0437","creditCard.cvcField.placeholder.4digits":"4 \u0446\u0438\u0444\u0440\u044b","creditCard.cvcField.placeholder.3digits":"3 \u0446\u0438\u0444\u0440\u044b","creditCard.taxNumber.placeholder":"\u0413\u0413\u041c\u041c\u0414\u0414 / 0123456789",installments:"\u041a\u043e\u043b\u0438\u0447\u0435\u0441\u0442\u0432\u043e \u043f\u043b\u0430\u0442\u0435\u0436\u0435\u0439",installmentOption:"%{times}\xd7 %{partialValue}",installmentOptionMonths:"%{times} \u043c\u0435\u0441.","installments.oneTime":"\u041e\u0434\u043d\u043e\u0440\u0430\u0437\u043e\u0432\u044b\u0439 \u043f\u043b\u0430\u0442\u0435\u0436","installments.installments":"\u0420\u0430\u0441\u0441\u0440\u043e\u0447\u043a\u0430","installments.revolving":"\u041f\u043e\u0432\u0442\u043e\u0440\u044f\u044e\u0449\u0430\u044f\u0441\u044f \u043e\u043f\u043b\u0430\u0442\u0430","sepaDirectDebit.ibanField.invalid":"\u041d\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043b\u044c\u043d\u044b\u0439 \u043d\u043e\u043c\u0435\u0440 \u0441\u0447\u0435\u0442\u0430","sepaDirectDebit.nameField.placeholder":"\u0418. \u041f\u0435\u0442\u0440\u043e\u0432","sepa.ownerName":"\u0418\u043c\u044f \u0432\u043b\u0430\u0434\u0435\u043b\u044c\u0446\u0430","sepa.ibanNumber":"\u041d\u043e\u043c\u0435\u0440 \u0441\u0447\u0435\u0442\u0430 (IBAN)","error.title":"\u041e\u0448\u0438\u0431\u043a\u0430","error.subtitle.redirect":"\u0421\u0431\u043e\u0439 \u043f\u0435\u0440\u0435\u043d\u0430\u043f\u0440\u0430\u0432\u043b\u0435\u043d\u0438\u044f","error.subtitle.payment":"\u0421\u0431\u043e\u0439 \u043e\u043f\u043b\u0430\u0442\u044b","error.subtitle.refused":"\u041e\u043f\u043b\u0430\u0442\u0430 \u043e\u0442\u043a\u043b\u043e\u043d\u0435\u043d\u0430","error.message.unknown":"\u0412\u043e\u0437\u043d\u0438\u043a\u043b\u0430 \u043d\u0435\u0438\u0437\u0432\u0435\u0441\u0442\u043d\u0430\u044f \u043e\u0448\u0438\u0431\u043a\u0430","errorPanel.title":"\u0418\u043c\u0435\u044e\u0449\u0438\u0435\u0441\u044f \u043e\u0448\u0438\u0431\u043a\u0438","idealIssuer.selectField.title":"\u0411\u0430\u043d\u043a","idealIssuer.selectField.placeholder":"\u0412\u044b\u0431\u0435\u0440\u0438\u0442\u0435 \u0431\u0430\u043d\u043a","creditCard.success":"\u041f\u043b\u0430\u0442\u0435\u0436 \u0443\u0441\u043f\u0435\u0448\u043d\u043e \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043d",loading:"\u0417\u0430\u0433\u0440\u0443\u0437\u043a\u0430\u2026",continue:"\u041f\u0440\u043e\u0434\u043e\u043b\u0436\u0438\u0442\u044c",continueTo:"\u041f\u0435\u0440\u0435\u0439\u0442\u0438 \u043a","wechatpay.timetopay":"\u0423 \u0432\u0430\u0441 %@ \u043d\u0430 \u043e\u043f\u043b\u0430\u0442\u0443","wechatpay.scanqrcode":"\u0421\u043a\u0430\u043d\u0438\u0440\u043e\u0432\u0430\u0442\u044c QR-\u043a\u043e\u0434",personalDetails:"\u041b\u0438\u0447\u043d\u044b\u0435 \u0434\u0430\u043d\u043d\u044b\u0435",companyDetails:"\u0414\u0430\u043d\u043d\u044b\u0435 \u043a\u043e\u043c\u043f\u0430\u043d\u0438\u0438","companyDetails.name":"\u041d\u0430\u0437\u0432\u0430\u043d\u0438\u0435 \u043a\u043e\u043c\u043f\u0430\u043d\u0438\u0438","companyDetails.registrationNumber":"\u0420\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u043e\u043d\u043d\u044b\u0439 \u043d\u043e\u043c\u0435\u0440",socialSecurityNumber:"\u041d\u043e\u043c\u0435\u0440 \u0441\u043e\u0446\u0438\u0430\u043b\u044c\u043d\u043e\u0433\u043e \u0441\u0442\u0440\u0430\u0445\u043e\u0432\u0430\u043d\u0438\u044f \u0438\u043b\u0438 \u0418\u041d\u041d",firstName:"\u0418\u043c\u044f","firstName.invalid":"\u041d\u0435\u0432\u0435\u0440\u043d\u043e\u0435 \u0438\u043c\u044f",infix:"\u041f\u0440\u0438\u0441\u0442\u0430\u0432\u043a\u0430",lastName:"\u0424\u0430\u043c\u0438\u043b\u0438\u044f","lastName.invalid":"\u041d\u0435\u0432\u0435\u0440\u043d\u0430\u044f \u0444\u0430\u043c\u0438\u043b\u0438\u044f",mobileNumber:"\u041c\u043e\u0431\u0438\u043b\u044c\u043d\u044b\u0439 \u0442\u0435\u043b\u0435\u0444\u043e\u043d","mobileNumber.invalid":"\u041d\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043b\u044c\u043d\u043e\u0439 \u043d\u043e\u043c\u0435\u0440 \u043c\u043e\u0431\u0438\u043b\u044c\u043d\u043e\u0433\u043e",city:"\u0413\u043e\u0440\u043e\u0434",postalCode:"\u041f\u043e\u0447\u0442\u043e\u0432\u044b\u0439 \u0438\u043d\u0434\u0435\u043a\u0441","postalCode.optional":"\u041f\u043e\u0447\u0442\u043e\u0432\u044b\u0439 \u0438\u043d\u0434\u0435\u043a\u0441 (\u043d\u0435\u043e\u0431\u044f\u0437\u0430\u0442\u0435\u043b\u044c\u043d\u043e)",countryCode:"\u041a\u043e\u0434 \u0441\u0442\u0440\u0430\u043d\u044b",telephoneNumber:"\u041d\u043e\u043c\u0435\u0440 \u0442\u0435\u043b\u0435\u0444\u043e\u043d\u0430",dateOfBirth:"\u0414\u0430\u0442\u0430 \u0440\u043e\u0436\u0434\u0435\u043d\u0438\u044f",shopperEmail:"\u0410\u0434\u0440\u0435\u0441 \u044d\u043b. \u043f\u043e\u0447\u0442\u044b",gender:"\u041f\u043e\u043b",male:"\u041c\u0443\u0436\u0447\u0438\u043d\u0430",female:"\u0416\u0435\u043d\u0449\u0438\u043d\u0430",billingAddress:"\u041f\u043b\u0430\u0442\u0435\u0436\u043d\u044b\u0439 \u0430\u0434\u0440\u0435\u0441",street:"\u0423\u043b\u0438\u0446\u0430",stateOrProvince:"\u0420\u0435\u0433\u0438\u043e\u043d",country:"\u0421\u0442\u0440\u0430\u043d\u0430",houseNumberOrName:"\u041d\u043e\u043c\u0435\u0440 \u0434\u043e\u043c\u0430",separateDeliveryAddress:"\u0423\u043a\u0430\u0436\u0438\u0442\u0435 \u043e\u0442\u0434\u0435\u043b\u044c\u043d\u044b\u0439 \u0430\u0434\u0440\u0435\u0441 \u0434\u043e\u0441\u0442\u0430\u0432\u043a\u0438",deliveryAddress:"\u0410\u0434\u0440\u0435\u0441 \u0434\u043e\u0441\u0442\u0430\u0432\u043a\u0438",zipCode:"\u041f\u043e\u0447\u0442\u043e\u0432\u044b\u0439 \u0438\u043d\u0434\u0435\u043a\u0441",apartmentSuite:"\u041a\u0432\u0430\u0440\u0442\u0438\u0440\u0430 / \u043f\u043e\u043c\u0435\u0449\u0435\u043d\u0438\u0435",provinceOrTerritory:"\u041f\u0440\u043e\u0432\u0438\u043d\u0446\u0438\u044f \u0438\u043b\u0438 \u0442\u0435\u0440\u0440\u0438\u0442\u043e\u0440\u0438\u044f",cityTown:"\u0413\u043e\u0440\u043e\u0434",address:"\u0410\u0434\u0440\u0435\u0441",state:"\u0428\u0442\u0430\u0442","field.title.optional":"(\u043d\u0435\u043e\u0431\u044f\u0437\u0430\u0442\u0435\u043b\u044c\u043d\u043e)","creditCard.cvcField.title.optional":"CVC / CVV (\u043d\u0435\u043e\u0431\u044f\u0437\u0430\u0442\u0435\u043b\u044c\u043d\u043e)","issuerList.wallet.placeholder":"\u0412\u044b\u0431\u0435\u0440\u0438\u0442\u0435 \u043a\u043e\u0448\u0435\u043b\u0435\u043a",privacyPolicy:"\u041f\u043e\u043b\u0438\u0442\u0438\u043a\u0430 \u043a\u043e\u043d\u0444\u0438\u0434\u0435\u043d\u0446\u0438\u0430\u043b\u044c\u043d\u043e\u0441\u0442\u0438","afterPay.agreement":"\u042f \u043f\u0440\u0438\u043d\u0438\u043c\u0430\u044e %@ AfterPay",paymentConditions:"\u0443\u0441\u043b\u043e\u0432\u0438\u044f \u043e\u043f\u043b\u0430\u0442\u044b",openApp:"\u041e\u0442\u043a\u0440\u044b\u0442\u044c \u043f\u0440\u0438\u043b\u043e\u0436\u0435\u043d\u0438\u0435","voucher.readInstructions":"\u041f\u0440\u043e\u0447\u0438\u0442\u0430\u0439\u0442\u0435 \u0438\u043d\u0441\u0442\u0440\u0443\u043a\u0446\u0438\u0438","voucher.introduction":"\u0411\u043b\u0430\u0433\u043e\u0434\u0430\u0440\u0438\u043c \u0437\u0430 \u043f\u043e\u043a\u0443\u043f\u043a\u0443. \u0414\u043b\u044f \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043d\u0438\u044f \u043e\u043f\u043b\u0430\u0442\u044b \u0438\u0441\u043f\u043e\u043b\u044c\u0437\u0443\u0439\u0442\u0435 \u0441\u043b\u0435\u0434\u0443\u044e\u0449\u0438\u0439 \u043a\u0443\u043f\u043e\u043d.","voucher.expirationDate":"\u0421\u0440\u043e\u043a \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044f","voucher.alternativeReference":"\u0414\u0440\u0443\u0433\u043e\u0439 \u043a\u043e\u0434","dragonpay.voucher.non.bank.selectField.placeholder":"\u0412\u044b\u0431\u0435\u0440\u0438\u0442\u0435 \u0441\u0432\u043e\u0435\u0433\u043e \u043e\u043f\u0435\u0440\u0430\u0442\u043e\u0440\u0430","dragonpay.voucher.bank.selectField.placeholder":"\u0412\u044b\u0431\u0435\u0440\u0438\u0442\u0435 \u0431\u0430\u043d\u043a","voucher.paymentReferenceLabel":"\u041a\u043e\u0434 \u043e\u043f\u043b\u0430\u0442\u044b","voucher.surcharge":"\u0412\u043a\u043b. \u043a\u043e\u043c\u0438\u0441\u0441\u0438\u044e %@","voucher.introduction.doku":"\u0411\u043b\u0430\u0433\u043e\u0434\u0430\u0440\u0438\u043c \u0437\u0430 \u043f\u043e\u043a\u0443\u043f\u043a\u0443. \u0414\u043b\u044f \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043d\u0438\u044f \u043e\u043f\u043b\u0430\u0442\u044b \u0438\u0441\u043f\u043e\u043b\u044c\u0437\u0443\u0439\u0442\u0435 \u0441\u043b\u0435\u0434\u0443\u044e\u0449\u0438\u0435 \u0441\u0432\u0435\u0434\u0435\u043d\u0438\u044f.","voucher.shopperName":"\u0418\u043c\u044f \u043f\u043e\u043a\u0443\u043f\u0430\u0442\u0435\u043b\u044f","voucher.merchantName":"\u041f\u0440\u043e\u0434\u0430\u0432\u0435\u0446","voucher.introduction.econtext":"\u0411\u043b\u0430\u0433\u043e\u0434\u0430\u0440\u0438\u043c \u0437\u0430 \u043f\u043e\u043a\u0443\u043f\u043a\u0443. \u0414\u043b\u044f \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043d\u0438\u044f \u043e\u043f\u043b\u0430\u0442\u044b \u0438\u0441\u043f\u043e\u043b\u044c\u0437\u0443\u0439\u0442\u0435 \u0441\u043b\u0435\u0434\u0443\u044e\u0449\u0438\u0435 \u0441\u0432\u0435\u0434\u0435\u043d\u0438\u044f.","voucher.telephoneNumber":"\u041d\u043e\u043c\u0435\u0440 \u0442\u0435\u043b\u0435\u0444\u043e\u043d\u0430","voucher.shopperReference":"\u0418\u0434\u0435\u043d\u0442\u0438\u0444\u0438\u043a\u0430\u0442\u043e\u0440 \u043f\u043e\u043a\u0443\u043f\u0430\u0442\u0435\u043b\u044f","voucher.collectionInstitutionNumber":"\u041d\u043e\u043c\u0435\u0440 \u043f\u043e\u043b\u0443\u0447\u0430\u0442\u0435\u043b\u044f \u0441\u0440\u0435\u0434\u0441\u0442\u0432","voucher.econtext.telephoneNumber.invalid":"\u041d\u043e\u043c\u0435\u0440 \u0442\u0435\u043b\u0435\u0444\u043e\u043d\u0430 \u0434\u043e\u043b\u0436\u0435\u043d \u0431\u044b\u0442\u044c \u0434\u043b\u0438\u043d\u043e\u0439 10 \u0438\u043b\u0438 11 \u0446\u0438\u0444\u0440","boletobancario.btnLabel":"\u0421\u043e\u0437\u0434\u0430\u0442\u044c Boleto","boleto.sendCopyToEmail":"\u041e\u0442\u043f\u0440\u0430\u0432\u0438\u0442\u044c \u043c\u043d\u0435 \u043a\u043e\u043f\u0438\u044e \u043d\u0430 \u044d\u043b. \u043f\u043e\u0447\u0442\u0443","button.copy":"\u041a\u043e\u043f\u0438\u044f","button.download":"\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044c","boleto.socialSecurityNumber.invalid":"\u041d\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043b\u044c\u043d\u043e\u0435 \u043f\u043e\u043b\u0435","creditCard.storedCard.description.ariaLabel":"\u0421\u043e\u0445\u0440\u0430\u043d\u0435\u043d\u043d\u0430\u044f \u043a\u0430\u0440\u0442\u0430 \u0437\u0430\u043a\u0430\u043d\u0447\u0438\u0432\u0430\u0435\u0442\u0441\u044f \u043d\u0430 %@","voucher.entity":"\u041e\u0431\u044a\u0435\u043a\u0442",donateButton:"\u041f\u043e\u0436\u0435\u0440\u0442\u0432\u043e\u0432\u0430\u0442\u044c",notNowButton:"\u041f\u043e\u0437\u0436\u0435",thanksForYourSupport:"\u0411\u043b\u0430\u0433\u043e\u0434\u0430\u0440\u0438\u043c \u0437\u0430 \u043f\u043e\u0434\u0434\u0435\u0440\u0436\u043a\u0443!",preauthorizeWith:"\u041f\u0440\u0435\u0434\u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u044f \u0432",confirmPreauthorization:"\u041f\u043e\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044c \u043f\u0440\u0435\u0434\u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u044e",confirmPurchase:"\u041f\u043e\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044c \u043f\u043e\u043a\u0443\u043f\u043a\u0443",applyGiftcard:"\u0418\u0441\u043f\u043e\u043b\u044c\u0437\u043e\u0432\u0430\u0442\u044c",giftcardBalance:"\u0411\u0430\u043b\u0430\u043d\u0441 \u043f\u043e\u0434\u0430\u0440\u043e\u0447\u043d\u043e\u0439 \u043a\u0430\u0440\u0442\u044b",deductedBalance:"\u0411\u0430\u043b\u0430\u043d\u0441 \u0441\u043f\u0438\u0441\u0430\u043d\u0438\u0439","creditCard.pin.title":"PIN-\u043a\u043e\u0434","creditCard.encryptedPassword.label":"\u041f\u0435\u0440\u0432\u044b\u0435 2 \u0446\u0438\u0444\u0440\u044b \u043f\u0430\u0440\u043e\u043b\u044f \u043a\u0430\u0440\u0442\u044b","creditCard.encryptedPassword.invalid":"\u041d\u0435\u0432\u0435\u0440\u043d\u044b\u0439 \u043f\u0430\u0440\u043e\u043b\u044c","creditCard.taxNumber":"\u0414\u0430\u0442\u0430 \u0440\u043e\u0436\u0434\u0435\u043d\u0438\u044f \u0432\u043b\u0430\u0434\u0435\u043b\u044c\u0446\u0430 \u043a\u0430\u0440\u0442\u044b \u0438\u043b\u0438 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u043e\u043d\u043d\u044b\u0439 \u043d\u043e\u043c\u0435\u0440 \u043f\u0440\u0435\u0434\u043f\u0440\u0438\u044f\u0442\u0438\u044f","creditCard.taxNumber.label":"\u0414\u0430\u0442\u0430 \u0440\u043e\u0436\u0434\u0435\u043d\u0438\u044f \u0432\u043b\u0430\u0434\u0435\u043b\u044c\u0446\u0430 \u043a\u0430\u0440\u0442\u044b (\u0413\u0413\u041c\u041c\u0414\u0414) \u0438\u043b\u0438 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u043e\u043d\u043d\u044b\u0439 \u043d\u043e\u043c\u0435\u0440 \u043f\u0440\u0435\u0434\u043f\u0440\u0438\u044f\u0442\u0438\u044f (10 \u0446\u0438\u0444\u0440)","creditCard.taxNumber.labelAlt":"\u0420\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u043e\u043d\u043d\u044b\u0439 \u043d\u043e\u043c\u0435\u0440 \u043f\u0440\u0435\u0434\u043f\u0440\u0438\u044f\u0442\u0438\u044f (10 \u0446\u0438\u0444\u0440)","creditCard.taxNumber.invalid":"\u041d\u0435\u0432\u0435\u0440\u043d\u0430\u044f \u0434\u0430\u0442\u0430 \u0440\u043e\u0436\u0434\u0435\u043d\u0438\u044f \u0432\u043b\u0430\u0434\u0435\u043b\u044c\u0446\u0430 \u043a\u0430\u0440\u0442\u044b \u0438\u043b\u0438 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u043e\u043d\u043d\u044b\u0439 \u043d\u043e\u043c\u0435\u0440 \u043f\u0440\u0435\u0434\u043f\u0440\u0438\u044f\u0442\u0438\u044f","storedPaymentMethod.disable.button":"\u0423\u0434\u0430\u043b\u0438\u0442\u044c","storedPaymentMethod.disable.confirmation":"\u0423\u0434\u0430\u043b\u0438\u0442\u044c \u0441\u043e\u0445\u0440\u0430\u043d\u0435\u043d\u043d\u044b\u0439 \u0441\u043f\u043e\u0441\u043e\u0431 \u043e\u043f\u043b\u0430\u0442\u044b","storedPaymentMethod.disable.confirmButton":"\u0414\u0430, \u0443\u0434\u0430\u043b\u0438\u0442\u044c","storedPaymentMethod.disable.cancelButton":"\u041e\u0442\u043c\u0435\u043d\u0438\u0442\u044c","ach.bankAccount":"\u0411\u0430\u043d\u043a\u043e\u0432\u0441\u043a\u0438\u0439 \u0441\u0447\u0435\u0442","ach.accountHolderNameField.title":"\u0418\u043c\u044f \u0432\u043b\u0430\u0434\u0435\u043b\u044c\u0446\u0430 \u043a\u0430\u0440\u0442\u044b","ach.accountHolderNameField.placeholder":"\u0418. \u041f\u0435\u0442\u0440\u043e\u0432","ach.accountHolderNameField.invalid":"\u041d\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043b\u044c\u043d\u043e\u0435 \u0438\u043c\u044f \u0432\u043b\u0430\u0434\u0435\u043b\u044c\u0446\u0430 \u043a\u0430\u0440\u0442\u044b","ach.accountNumberField.title":"\u041d\u043e\u043c\u0435\u0440 \u0441\u0447\u0435\u0442\u0430","ach.accountNumberField.invalid":"\u041d\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043b\u044c\u043d\u044b\u0439 \u043d\u043e\u043c\u0435\u0440 \u0441\u0447\u0435\u0442\u0430","ach.accountLocationField.title":"\u041c\u0430\u0440\u0448\u0440\u0443\u0442\u043d\u044b\u0439 \u043d\u043e\u043c\u0435\u0440 ABA","ach.accountLocationField.invalid":"\u041d\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043b\u044c\u043d\u044b\u0439 \u043c\u0430\u0440\u0448\u0440\u0443\u0442\u043d\u044b\u0439 \u043d\u043e\u043c\u0435\u0440 ABA","ach.savedBankAccount":"\u0421\u043e\u0445\u0440\u0430\u043d\u0435\u043d\u043d\u044b\u0439 \u0431\u0430\u043d\u043a\u043e\u0432\u0441\u043a\u0438\u0439 \u0441\u0447\u0435\u0442","select.state":"\u0412\u044b\u0431\u0435\u0440\u0438\u0442\u0435 \u0448\u0442\u0430\u0442","select.stateOrProvince":"\u0412\u044b\u0431\u0435\u0440\u0438\u0442\u0435 \u0448\u0442\u0430\u0442 \u0438\u043b\u0438 \u043e\u0431\u043b\u0430\u0441\u0442\u044c","select.provinceOrTerritory":"\u0412\u044b\u0431\u0435\u0440\u0438\u0442\u0435 \u043f\u0440\u043e\u0432\u0438\u043d\u0446\u0438\u044e \u0438\u043b\u0438 \u0442\u0435\u0440\u0440\u0438\u0442\u043e\u0440\u0438\u044e","select.country":"\u0412\u044b\u0431\u0435\u0440\u0438\u0442\u0435 \u0441\u0442\u0440\u0430\u043d\u0443","select.noOptionsFound":"\u0412\u0430\u0440\u0438\u0430\u043d\u0442\u043e\u0432 \u043d\u0435 \u043d\u0430\u0439\u0434\u0435\u043d\u043e","select.filter.placeholder":"\u041f\u043e\u0438\u0441\u043a\u2026","telephoneNumber.invalid":"\u041d\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043b\u044c\u043d\u044b\u0439 \u043d\u043e\u043c\u0435\u0440 \u0442\u0435\u043b\u0435\u0444\u043e\u043d\u0430",qrCodeOrApp:"\u0438\u043b\u0438","paypal.processingPayment":"\u041f\u043b\u0430\u0442\u0435\u0436 \u043e\u0431\u0440\u0430\u0431\u0430\u0442\u044b\u0432\u0430\u0435\u0442\u0441\u044f\u2026",generateQRCode:"\u0421\u043e\u0437\u0434\u0430\u0442\u044c QR-\u043a\u043e\u0434","await.waitForConfirmation":"\u041e\u0436\u0438\u0434\u0430\u043d\u0438\u0435 \u043f\u043e\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043d\u0438\u044f","mbway.confirmPayment":"\u041f\u043e\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0435 \u043e\u043f\u043b\u0430\u0442\u0443 \u0432 \u043f\u0440\u0438\u043b\u043e\u0436\u0435\u043d\u0438\u0438 MB WAY","shopperEmail.invalid":"\u041d\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043b\u044c\u043d\u044b\u0439 \u0430\u0434\u0440\u0435\u0441 \u044d\u043b. \u043f\u043e\u0447\u0442\u044b","dateOfBirth.format":"\u0414\u0414/\u041c\u041c/\u0413\u0413\u0413\u0413","dateOfBirth.invalid":"\u0412\u0430\u043c \u0434\u043e\u043b\u0436\u043d\u043e \u0431\u044b\u0442\u044c 18 \u043b\u0435\u0442 \u0438\u043b\u0438 \u0431\u043e\u043b\u044c\u0448\u0435","blik.confirmPayment":"\u0414\u043b\u044f \u043f\u043e\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043d\u0438\u044f \u043e\u043f\u043b\u0430\u0442\u044b \u043e\u0442\u043a\u0440\u043e\u0439\u0442\u0435 \u043f\u0440\u0438\u043b\u043e\u0436\u0435\u043d\u0438\u0435 \u0431\u0430\u043d\u043a\u0430.","blik.invalid":"\u0412\u0432\u0435\u0434\u0438\u0442\u0435 6 \u0446\u0438\u0444\u0440","blik.code":"6-\u0437\u043d\u0430\u0447\u043d\u044b\u0439 \u043a\u043e\u0434","blik.help":"\u041f\u043e\u043b\u0443\u0447\u0438\u0442\u0435 \u043a\u043e\u0434 \u0438\u0437 \u043f\u0440\u0438\u043b\u043e\u0436\u0435\u043d\u0438\u044f \u0432\u0430\u0448\u0435\u0433\u043e \u0431\u0430\u043d\u043a\u0430.","swish.pendingMessage":"\u041e\u0431\u0440\u0430\u0431\u043e\u0442\u043a\u0430 \u043e\u043f\u043b\u0430\u0442\u044b \u043f\u043e\u0441\u043b\u0435 \u0441\u043a\u0430\u043d\u0438\u0440\u043e\u0432\u0430\u043d\u0438\u044f \u043c\u043e\u0436\u0435\u0442 \u0437\u0430\u043d\u044f\u0442\u044c 10 \u043c\u0438\u043d\u0443\u0442. \u041f\u043e\u043f\u044b\u0442\u043a\u0430 \u043f\u0440\u043e\u0432\u0435\u0441\u0442\u0438 \u043e\u043f\u043b\u0430\u0442\u0443 \u043f\u043e\u0432\u0442\u043e\u0440\u043d\u043e \u0432 \u0442\u0435\u0447\u0435\u043d\u0438\u0435 \u0443\u043a\u0430\u0437\u0430\u043d\u043d\u043e\u0433\u043e \u0432\u0440\u0435\u043c\u0435\u043d\u0438 \u043c\u043e\u0436\u0435\u0442 \u043f\u0440\u0438\u0432\u0435\u0441\u0442\u0438 \u043a \u043d\u0435\u0441\u043a\u043e\u043b\u044c\u043a\u0438\u043c \u0441\u043f\u0438\u0441\u0430\u043d\u0438\u044f\u043c \u0441\u043e \u0441\u0447\u0435\u0442\u0430.","field.valid":"\u0414\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043b\u044c\u043d\u043e\u0435 \u043f\u043e\u043b\u0435","field.invalid":"\u041d\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043b\u044c\u043d\u043e\u0435 \u043f\u043e\u043b\u0435","error.va.gen.01":"\u041d\u0435\u0437\u0430\u043f\u043e\u043b\u043d\u0435\u043d\u043d\u043e\u0435 \u043f\u043e\u043b\u0435","error.va.gen.02":"\u041d\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043b\u044c\u043d\u043e\u0435 \u043f\u043e\u043b\u0435","error.va.sf-cc-num.01":"\u041d\u043e\u043c\u0435\u0440 \u043a\u0430\u0440\u0442\u044b \u043d\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043b\u0435\u043d","error.va.sf-cc-num.02":"\u041f\u043e\u043b\u0435 \u043d\u043e\u043c\u0435\u0440\u0430 \u043a\u0430\u0440\u0442\u044b \u043d\u0435 \u0437\u0430\u043f\u043e\u043b\u043d\u0435\u043d\u043e","error.va.sf-cc-num.03":"\u0412\u0432\u0435\u0434\u0435\u043d \u043d\u043e\u043c\u0435\u0440 \u043d\u0435\u043f\u043e\u0434\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0435\u043c\u044b\u0439 \u043a\u0430\u0440\u0442\u044b","error.va.sf-cc-num.04":"\u041d\u043e\u043c\u0435\u0440 \u043a\u0430\u0440\u0442\u044b \u0438\u043c\u0435\u0435\u0442 \u043d\u0435\u043f\u0440\u0430\u0432\u0438\u043b\u044c\u043d\u0443\u044e \u0434\u043b\u0438\u043d\u0443","error.va.sf-cc-dat.01":"\u0421\u0440\u043e\u043a \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044f: \u043a\u0430\u0440\u0442\u0430 \u0443\u0441\u0442\u0430\u0440\u0435\u043b\u0430","error.va.sf-cc-dat.02":"\u0421\u0440\u043e\u043a \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044f: \u0434\u0430\u0442\u0430 \u0441\u043b\u0438\u0448\u043a\u043e\u043c \u0434\u0430\u043b\u0435\u043a\u043e \u0432 \u0431\u0443\u0434\u0443\u0449\u0435\u043c","error.va.sf-cc-dat.03":"\u0421\u0440\u043e\u043a \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044f: \u0441\u0440\u043e\u043a \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044f \u043a\u0430\u0440\u0442\u044b \u0438\u0441\u0442\u0435\u043a\u0430\u0435\u0442 \u0440\u0430\u043d\u044c\u0448\u0435 \u0434\u0430\u0442\u044b \u043f\u043b\u0430\u0442\u0435\u0436\u0430","error.va.sf-cc-dat.04":"\u041f\u043e\u043b\u0435 \u0441\u0440\u043e\u043a\u0430 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044f \u043d\u0435 \u0437\u0430\u043f\u043e\u043b\u043d\u0435\u043d\u043e","error.va.sf-cc-dat.05":"\u0421\u0440\u043e\u043a \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044f \u0438\u043c\u0435\u0435\u0442 \u043d\u0435\u043f\u0440\u0430\u0432\u0438\u043b\u044c\u043d\u0443\u044e \u0434\u043b\u0438\u043d\u0443","error.va.sf-cc-mth.01":"\u041f\u043e\u043b\u0435 \u043c\u0435\u0441\u044f\u0446\u0430 \u0441\u0440\u043e\u043a\u0430 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044f \u043d\u0435 \u0437\u0430\u043f\u043e\u043b\u043d\u0435\u043d\u043e","error.va.sf-cc-yr.01":"\u041f\u043e\u043b\u0435 \u0433\u043e\u0434\u0430 \u0441\u0440\u043e\u043a\u0430 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044f \u043d\u0435 \u0437\u0430\u043f\u043e\u043b\u043d\u0435\u043d\u043e","error.va.sf-cc-yr.02":"\u0413\u043e\u0434 \u0441\u0440\u043e\u043a\u0430 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044f \u0438\u043c\u0435\u0435\u0442 \u043d\u0435\u043f\u0440\u0430\u0432\u0438\u043b\u044c\u043d\u0443\u044e \u0434\u043b\u0438\u043d\u0443","error.va.sf-cc-cvc.01":"\u041f\u043e\u043b\u0435 \u0437\u0430\u0449\u0438\u0442\u043d\u043e\u0433\u043e \u043a\u043e\u0434\u0430 \u043d\u0435 \u0437\u0430\u043f\u043e\u043b\u043d\u0435\u043d\u043e","error.va.sf-cc-cvc.02":"\u0417\u0430\u0449\u0438\u0442\u043d\u044b\u0439 \u043a\u043e\u0434 \u0438\u043c\u0435\u0435\u0442 \u043d\u0435\u043f\u0440\u0430\u0432\u0438\u043b\u044c\u043d\u0443\u044e \u0434\u043b\u0438\u043d\u0443","error.va.sf-ach-num.01":"\u041f\u043e\u043b\u0435 \u043d\u043e\u043c\u0435\u0440\u0430 \u0431\u0430\u043d\u043a\u043e\u0432\u0441\u043a\u043e\u0433\u043e \u0441\u0447\u0435\u0442\u0430 \u043d\u0435 \u0437\u0430\u043f\u043e\u043b\u043d\u0435\u043d\u043e","error.va.sf-ach-num.02":"\u041d\u043e\u043c\u0435\u0440 \u0431\u0430\u043d\u043a\u043e\u0432\u0441\u043a\u043e\u0433\u043e \u0441\u0447\u0435\u0442\u0430 \u0438\u043c\u0435\u0435\u0442 \u043d\u0435\u043f\u0440\u0430\u0432\u0438\u043b\u044c\u043d\u0443\u044e \u0434\u043b\u0438\u043d\u0443","error.va.sf-ach-loc.01":"\u041f\u043e\u043b\u0435 \u043c\u0430\u0440\u0448\u0440\u0443\u0442\u043d\u043e\u0433\u043e \u043d\u043e\u043c\u0435\u0440\u0430 \u0431\u0430\u043d\u043a\u0430 \u043d\u0435 \u0437\u0430\u043f\u043e\u043b\u043d\u0435\u043d\u043e","error.va.sf-ach-loc.02":"\u041c\u0430\u0440\u0448\u0440\u0443\u0442\u043d\u044b\u0439 \u043d\u043e\u043c\u0435\u0440 \u0431\u0430\u043d\u043a\u0430 \u0438\u043c\u0435\u0435\u0442 \u043d\u0435\u043f\u0440\u0430\u0432\u0438\u043b\u044c\u043d\u0443\u044e \u0434\u043b\u0438\u043d\u0443","error.va.sf-kcp-pwd.01":"\u041f\u043e\u043b\u0435 \u043f\u0430\u0440\u043e\u043b\u044f \u043d\u0435 \u0437\u0430\u043f\u043e\u043b\u043d\u0435\u043d\u043e","error.va.sf-kcp-pwd.02":"\u041f\u0430\u0440\u043e\u043b\u044c \u0438\u043c\u0435\u0435\u0442 \u043d\u0435\u043f\u0440\u0430\u0432\u0438\u043b\u044c\u043d\u0443\u044e \u0434\u043b\u0438\u043d\u0443","error.giftcard.no-balance":"\u041d\u0430 \u044d\u0442\u043e\u0439 \u043f\u043e\u0434\u0430\u0440\u043e\u0447\u043d\u043e\u0439 \u043a\u0430\u0440\u0442\u0435 \u043d\u0435\u0442 \u0441\u0440\u0435\u0434\u0441\u0442\u0432","error.giftcard.card-error":"\u0423 \u043d\u0430\u0441 \u043d\u0435 \u0437\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043e\u0432\u0430\u043d\u0430 \u043a\u0430\u0440\u0442\u0430 \u0441 \u0442\u0430\u043a\u0438\u043c \u043d\u043e\u043c\u0435\u0440\u043e\u043c","error.giftcard.currency-error":"\u041f\u0440\u0438\u043d\u0438\u043c\u0430\u044e\u0442\u0441\u044f \u0442\u043e\u043b\u044c\u043a\u043e \u043f\u043e\u0434\u0430\u0440\u043e\u0447\u043d\u044b\u0435 \u043a\u0430\u0440\u0442\u044b \u0441\u043e\u043e\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u044e\u0449\u0435\u0439 \u0432\u0430\u043b\u044e\u0442\u044b","amazonpay.signout":"\u0412\u044b\u0439\u0442\u0438 \u0438\u0437 Amazon","amazonpay.changePaymentDetails":"\u0418\u0437\u043c\u0435\u043d\u0438\u0442\u044c \u0438\u043d\u0444\u043e\u0440\u043c\u0430\u0446\u0438\u044e \u043e\u0431 \u043e\u043f\u043b\u0430\u0442\u0435","partialPayment.warning":"\u0412\u044b\u0431\u0440\u0430\u0442\u044c \u0434\u0440\u0443\u0433\u043e\u0439 \u0441\u043f\u043e\u0441\u043e\u0431 \u043e\u043f\u043b\u0430\u0442\u044b \u043e\u0441\u0442\u0430\u0442\u043a\u0430","partialPayment.remainingBalance":"\u041e\u0441\u0442\u0430\u0442\u043e\u043a \u043d\u0430 \u0431\u0430\u043b\u0430\u043d\u0441\u0435 \u0441\u043e\u0441\u0442\u0430\u0432\u0438\u0442 %{amount}","bankTransfer.beneficiary":"\u041f\u043e\u043b\u0443\u0447\u0430\u0442\u0435\u043b\u044c","bankTransfer.reference":"\u0421\u0441\u044b\u043b\u043a\u0430","bankTransfer.introduction":"\u0414\u043b\u044f \u0441\u043e\u0437\u0434\u0430\u043d\u0438\u044f \u043d\u043e\u0432\u043e\u0433\u043e \u0431\u0430\u043d\u043a\u043e\u0432\u0441\u043a\u043e\u0433\u043e \u043f\u0435\u0440\u0435\u0447\u0438\u0441\u043b\u0435\u043d\u0438\u044f \u043f\u0435\u0440\u0435\u0439\u0434\u0438\u0442\u0435 \u0434\u0430\u043b\u0435\u0435. \u0414\u043b\u044f \u043e\u043a\u043e\u043d\u0447\u0430\u0442\u0435\u043b\u044c\u043d\u043e\u0433\u043e \u043e\u0444\u043e\u0440\u043c\u043b\u0435\u043d\u0438\u044f \u043f\u043b\u0430\u0442\u0435\u0436\u0430 \u0438\u0441\u043f\u043e\u043b\u044c\u0437\u0443\u0439\u0442\u0435 \u0441\u0432\u0435\u0434\u0435\u043d\u0438\u044f \u043d\u0430 \u0441\u043b\u0435\u0434\u0443\u044e\u0449\u0435\u043c \u044d\u043a\u0440\u0430\u043d\u0435.","bankTransfer.instructions":"\u0411\u043b\u0430\u0433\u043e\u0434\u0430\u0440\u0438\u043c \u0437\u0430 \u043f\u043e\u043a\u0443\u043f\u043a\u0443. \u0414\u043b\u044f \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043d\u0438\u044f \u043e\u043f\u043b\u0430\u0442\u044b \u0438\u0441\u043f\u043e\u043b\u044c\u0437\u0443\u0439\u0442\u0435 \u0441\u043b\u0435\u0434\u0443\u044e\u0449\u0438\u0435 \u0441\u0432\u0435\u0434\u0435\u043d\u0438\u044f.","bacs.accountHolderName":"\u0418\u043c\u044f \u0432\u043b\u0430\u0434\u0435\u043b\u044c\u0446\u0430 \u0431\u0430\u043d\u043a\u043e\u0432\u0441\u043a\u043e\u0433\u043e \u0441\u0447\u0435\u0442\u0430","bacs.accountHolderName.invalid":"\u041d\u0435\u0432\u0435\u0440\u043d\u043e\u0435 \u0438\u043c\u044f \u0432\u043b\u0430\u0434\u0435\u043b\u044c\u0446\u0430 \u0431\u0430\u043d\u043a\u043e\u0432\u0441\u043a\u043e\u0433\u043e \u0441\u0447\u0435\u0442\u0430","bacs.accountNumber":"\u041d\u043e\u043c\u0435\u0440 \u0431\u0430\u043d\u043a\u043e\u0432\u0441\u043a\u043e\u0433\u043e \u0441\u0447\u0435\u0442\u0430","bacs.accountNumber.invalid":"\u041d\u0435\u0432\u0435\u0440\u043d\u044b\u0439 \u043d\u043e\u043c\u0435\u0440 \u0431\u0430\u043d\u043a\u043e\u0432\u0441\u043a\u043e\u0433\u043e \u0441\u0447\u0435\u0442\u0430","bacs.bankLocationId":"\u041a\u043e\u0434 \u0431\u0430\u043d\u043a\u0430","bacs.bankLocationId.invalid":"\u041d\u0435\u0432\u0435\u0440\u043d\u044b\u0439 \u043a\u043e\u0434 \u0431\u0430\u043d\u043a\u0430","bacs.consent.amount":"\u0412\u044b\u0440\u0430\u0436\u0430\u044e \u0441\u043e\u0433\u043b\u0430\u0441\u0438\u0435 \u043d\u0430 \u0441\u043f\u0438\u0441\u0430\u043d\u0438\u0435 \u0432\u044b\u0448\u0435\u0443\u043a\u0430\u0437\u0430\u043d\u043d\u043e\u0439 \u0441\u0443\u043c\u043c\u044b \u0441 \u043c\u043e\u0435\u0433\u043e \u0431\u0430\u043d\u043a\u043e\u0432\u0441\u043a\u043e\u0433\u043e \u0441\u0447\u0435\u0442\u0430.","bacs.consent.account":"\u041f\u043e\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0430\u044e, \u0447\u0442\u043e \u0441\u0447\u0435\u0442 \u043e\u0444\u043e\u0440\u043c\u043b\u0435\u043d \u043d\u0430 \u043c\u043e\u0435 \u0438\u043c\u044f \u0438 \u0447\u0442\u043e \u044f \u2013 \u0435\u0434\u0438\u043d\u0441\u0442\u0432\u0435\u043d\u043d\u043e\u0435 \u043b\u0438\u0446\u043e, \u0438\u043c\u0435\u044e\u0449\u0435\u0435 \u043f\u0440\u0430\u0432\u043e \u043f\u043e\u0434\u043f\u0438\u0441\u0438, \u0440\u0430\u0437\u0440\u0435\u0448\u0430\u044e\u0449\u0435\u0439 \u043f\u0440\u044f\u043c\u043e\u0435 \u0434\u0435\u0431\u0435\u0442\u043e\u0432\u0430\u043d\u0438\u0435 \u0441\u0440\u0435\u0434\u0441\u0442\u0432 \u0441\u043e \u0441\u0447\u0435\u0442\u0430.",edit:"\u0418\u0437\u043c\u0435\u043d\u0438\u0442\u044c","bacs.confirm":"\u041f\u043e\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044c \u0438 \u043e\u043f\u043b\u0430\u0442\u0438\u0442\u044c","bacs.result.introduction":"\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044c \u0440\u0430\u0441\u043f\u043e\u0440\u044f\u0436\u0435\u043d\u0438\u0435 \u043f\u0440\u044f\u043c\u043e\u0433\u043e \u0434\u0435\u0431\u0435\u0442\u043e\u0432\u0430\u043d\u0438\u044f (DDI / \u043f\u043e\u0440\u0443\u0447\u0435\u043d\u0438\u0435)","download.pdf":"\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044c PDF","creditCard.encryptedCardNumber.aria.iframeTitle":"Iframe \u0434\u043b\u044f \u0437\u0430\u0449\u0438\u0442\u044b \u043d\u043e\u043c\u0435\u0440\u0430 \u043a\u0430\u0440\u0442\u044b","creditCard.encryptedCardNumber.aria.label":"\u041d\u043e\u043c\u0435\u0440 \u043a\u0430\u0440\u0442\u044b","creditCard.encryptedExpiryDate.aria.iframeTitle":"Iframe \u0434\u043b\u044f \u0437\u0430\u0449\u0438\u0442\u044b \u0434\u0430\u0442\u044b \u0441\u0440\u043e\u043a\u0430 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044f \u043a\u0430\u0440\u0442\u044b","creditCard.encryptedExpiryDate.aria.label":"\u0421\u0440\u043e\u043a \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044f","creditCard.encryptedExpiryMonth.aria.iframeTitle":"Iframe \u0434\u043b\u044f \u0437\u0430\u0449\u0438\u0442\u044b \u0434\u0430\u043d\u043d\u044b\u0445 \u043c\u0435\u0441\u044f\u0446\u0430 \u0441\u0440\u043e\u043a\u0430 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044f \u043a\u0430\u0440\u0442\u044b","creditCard.encryptedExpiryMonth.aria.label":"\u041c\u0435\u0441\u044f\u0446 \u0441\u0440\u043e\u043a\u0430 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044f","creditCard.encryptedExpiryYear.aria.iframeTitle":"Iframe \u0434\u043b\u044f \u0437\u0430\u0449\u0438\u0442\u044b \u0434\u0430\u043d\u043d\u044b\u0445 \u0433\u043e\u0434\u0430 \u0441\u0440\u043e\u043a\u0430 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044f \u043a\u0430\u0440\u0442\u044b","creditCard.encryptedExpiryYear.aria.label":"\u0413\u043e\u0434 \u0441\u0440\u043e\u043a\u0430 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044f","creditCard.encryptedSecurityCode.aria.iframeTitle":"Iframe \u0434\u043b\u044f \u0437\u0430\u0449\u0438\u0442\u044b \u0437\u0430\u0449\u0438\u0442\u043d\u043e\u0433\u043e \u043a\u043e\u0434\u0430","creditCard.encryptedSecurityCode.aria.label":"\u0417\u0430\u0449\u0438\u0442\u043d\u044b\u0439 \u043a\u043e\u0434","creditCard.encryptedPassword.aria.iframeTitle":"Iframe \u0434\u043b\u044f \u0437\u0430\u0449\u0438\u0442\u044b \u043f\u0430\u0440\u043e\u043b\u044f \u043a\u0430\u0440\u0442\u044b","creditCard.encryptedPassword.aria.label":"\u041f\u0435\u0440\u0432\u044b\u0435 2 \u0446\u0438\u0444\u0440\u044b \u043f\u0430\u0440\u043e\u043b\u044f \u043a\u0430\u0440\u0442\u044b","giftcard.encryptedCardNumber.aria.iframeTitle":"Iframe \u0434\u043b\u044f \u0437\u0430\u0449\u0438\u0442\u044b \u043d\u043e\u043c\u0435\u0440\u0430 \u043f\u043e\u0434\u0430\u0440\u043e\u0447\u043d\u043e\u0439 \u043a\u0430\u0440\u0442\u044b","giftcard.encryptedCardNumber.aria.label":"\u041d\u043e\u043c\u0435\u0440 \u043f\u043e\u0434\u0430\u0440\u043e\u0447\u043d\u043e\u0439 \u043a\u0430\u0440\u0442\u044b","giftcard.encryptedSecurityCode.aria.iframeTitle":"Iframe \u0434\u043b\u044f \u0437\u0430\u0449\u0438\u0442\u044b \u0437\u0430\u0449\u0438\u0442\u043d\u043e\u0433\u043e \u043a\u043e\u0434\u0430 \u043f\u043e\u0434\u0430\u0440\u043e\u0447\u043d\u043e\u0439 \u043a\u0430\u0440\u0442\u044b","giftcard.encryptedSecurityCode.aria.label":"\u0417\u0430\u0449\u0438\u0442\u043d\u044b\u0439 \u043a\u043e\u0434 \u043f\u043e\u0434\u0430\u0440\u043e\u0447\u043d\u043e\u0439 \u043a\u0430\u0440\u0442\u044b",giftcardTransactionLimit:"\u041c\u0430\u043a\u0441\u0438\u043c\u0430\u043b\u044c\u043d\u0430\u044f \u0441\u0443\u043c\u043c\u0430 \u043e\u043f\u0435\u0440\u0430\u0446\u0438\u0438 \u043f\u043e \u044d\u0442\u043e\u0439 \u043f\u043e\u0434\u0430\u0440\u043e\u0447\u043d\u043e\u0439 \u043a\u0430\u0440\u0442\u0435: %{amount}","ach.encryptedBankAccountNumber.aria.iframeTitle":"Iframe \u0434\u043b\u044f \u0437\u0430\u0449\u0438\u0442\u044b \u043d\u043e\u043c\u0435\u0440\u0430 \u0431\u0430\u043d\u043a\u043e\u0432\u0441\u043a\u043e\u0433\u043e \u0441\u0447\u0435\u0442\u0430","ach.encryptedBankAccountNumber.aria.label":"\u0411\u0430\u043d\u043a\u043e\u0432\u0441\u043a\u0438\u0439 \u0441\u0447\u0435\u0442","ach.encryptedBankLocationId.aria.iframeTitle":"Iframe \u0434\u043b\u044f \u0437\u0430\u0449\u0438\u0442\u044b \u043c\u0430\u0440\u0448\u0440\u0443\u0442\u043d\u043e\u0433\u043e \u043d\u043e\u043c\u0435\u0440\u0430 \u0431\u0430\u043d\u043a\u0430","ach.encryptedBankLocationId.aria.label":"\u041c\u0430\u0440\u0448\u0440\u0443\u0442\u043d\u044b\u0439 \u043d\u043e\u043c\u0435\u0440 \u0431\u0430\u043d\u043a\u0430","twint.saved":"\u0441\u043e\u0445\u0440\u0430\u043d\u0435\u043d\u043e",orPayWith:"\u0438\u043b\u0438 \u0437\u0430\u043f\u043b\u0430\u0442\u0438\u0442\u0435 \u0447\u0435\u0440\u0435\u0437",invalidFormatExpects:"\u041d\u0435\u0432\u0435\u0440\u043d\u044b\u0439 \u0444\u043e\u0440\u043c\u0430\u0442. \u041e\u0436\u0438\u0434\u0430\u0435\u043c\u044b\u0439 \u0444\u043e\u0440\u043c\u0430\u0442: %{format}","upi.qrCodeWaitingMessage":"\u0414\u043b\u044f \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043d\u0438\u044f \u043f\u043b\u0430\u0442\u0435\u0436\u0430 \u043e\u0442\u0441\u043a\u0430\u043d\u0438\u0440\u0443\u0439\u0442\u0435 QR-\u043a\u043e\u0434 \u0441 \u043f\u043e\u043c\u043e\u0449\u044c\u044e \u043f\u0440\u0435\u0434\u043f\u043e\u0447\u0438\u0442\u0430\u0435\u043c\u043e\u0433\u043e \u043f\u0440\u0438\u043b\u043e\u0436\u0435\u043d\u0438\u044f UPI","upi.vpaWaitingMessage":"\u041e\u0442\u043a\u0440\u043e\u0439\u0442\u0435 \u043f\u0440\u0438\u043b\u043e\u0436\u0435\u043d\u0438\u0435 UPI \u0434\u043b\u044f \u043f\u043e\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043d\u0438\u044f \u043f\u043b\u0430\u0442\u0435\u0436\u0430","upi.modeSelection":"\u0423\u043a\u0430\u0436\u0438\u0442\u0435, \u043a\u0430\u043a \u0432\u044b \u0441\u043e\u0431\u0438\u0440\u0430\u0435\u0442\u0435\u0441\u044c \u0438\u0441\u043f\u043e\u043b\u044c\u0437\u043e\u0432\u0430\u0442\u044c UPI.","onlineBanking.termsAndConditions":"\u041f\u0440\u043e\u0434\u043e\u043b\u0436\u0430\u044f, \u0432\u044b \u0442\u0435\u043c \u0441\u0430\u043c\u044b\u043c \u0441\u043e\u0433\u043b\u0430\u0448\u0430\u0435\u0442\u0435\u0441\u044c \u0441 %#\u0443\u0441\u043b\u043e\u0432\u0438\u044f\u043c\u0438%#","ctp.loading.poweredByCtp":"\u041d\u0430 \u043f\u043b\u0430\u0442\u0444\u043e\u0440\u043c\u0435 Click to Pay","ctp.loading.intro":"\u041f\u0440\u043e\u0432\u0435\u0440\u043a\u0430 \u043d\u0430\u043b\u0438\u0447\u0438\u044f \u0441\u043e\u0445\u0440\u0430\u043d\u0435\u043d\u043d\u044b\u0445 \u043a\u0430\u0440\u0442 Click to Pay\u2026","ctp.login.title":"\u041f\u0435\u0440\u0435\u0439\u0442\u0438 \u043d\u0430 Click to Pay","ctp.login.subtitle":"\u0414\u043b\u044f \u043f\u0440\u043e\u0434\u043e\u043b\u0436\u0435\u043d\u0438\u044f \u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u0430\u0434\u0440\u0435\u0441 \u044d\u043b. \u043f\u043e\u0447\u0442\u044b, \u0441\u0432\u044f\u0437\u0430\u043d\u043d\u044b\u0439 \u0441 Click to Pay.","ctp.login.inputLabel":"\u042d\u043b. \u043f\u043e\u0447\u0442\u0430","ctp.logout.notYou":"\u042d\u0442\u043e \u043d\u0435 \u0432\u044b?","ctp.logout.notYourCards":"\u041d\u0435 \u0432\u0430\u0448\u0438 \u043f\u043b\u0430\u0442\u0435\u0436\u043d\u044b\u0435 \u043a\u0430\u0440\u0442\u044b?","ctp.logout.notYourCard":"\u041d\u0435 \u0432\u0430\u0448\u0430 \u043a\u0430\u0440\u0442\u0430?","ctp.logout.notYourProfile":"\u041d\u0435 \u0432\u0430\u0448 \u043f\u0440\u043e\u0444\u0438\u043b\u044c?","ctp.otp.fieldLabel":"\u041e\u0434\u043d\u043e\u0440\u0430\u0437\u043e\u0432\u044b\u0439 \u043a\u043e\u0434","ctp.otp.resendCode":"\u041e\u0442\u043f\u0440\u0430\u0432\u0438\u0442\u044c \u043a\u043e\u0434 \u043f\u043e\u0432\u0442\u043e\u0440\u043d\u043e","ctp.otp.codeResent":"\u041a\u043e\u0434 \u043e\u0442\u043f\u0440\u0430\u0432\u043b\u0435\u043d \u043f\u043e\u0432\u0442\u043e\u0440\u043d\u043e","ctp.otp.title":"\u041f\u043e\u043b\u0443\u0447\u0438\u0442\u0435 \u0434\u043e\u0441\u0442\u0443\u043f \u043a \u0441\u0432\u043e\u0438\u043c \u043a\u0430\u0440\u0442\u0430\u043c Click to Pay","ctp.otp.subtitle":"\u0414\u043b\u044f \u043f\u043e\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043d\u0438\u044f \u0441\u0432\u043e\u0435\u0439 \u043b\u0438\u0447\u043d\u043e\u0441\u0442\u0438 \u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u043a\u043e\u0434 %@, \u043e\u0442\u043f\u0440\u0430\u0432\u043b\u0435\u043d\u043d\u044b\u0439 %@.","ctp.emptyProfile.message":"\u0412 \u0434\u0430\u043d\u043d\u043e\u043c \u043f\u0440\u043e\u0444\u0438\u043b\u0435 Click to Pay \u043d\u0435\u0442 \u0437\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043e\u0432\u0430\u043d\u043d\u044b\u0445 \u043a\u0430\u0440\u0442","ctp.separatorText":"\u0438\u043b\u0438 \u0438\u0441\u043f\u043e\u043b\u044c\u0437\u0443\u0439\u0442\u0435","ctp.cards.title":"\u041e\u0444\u043e\u0440\u043c\u0438\u0442\u0435 \u043e\u043f\u043b\u0430\u0442\u0443 \u0441 \u043f\u043e\u043c\u043e\u0449\u044c\u044e Click to Pay","ctp.cards.subtitle":"\u0412\u044b\u0431\u0435\u0440\u0438\u0442\u0435 \u043a\u0430\u0440\u0442\u0443.","ctp.cards.expiredCard":"\u041f\u0440\u043e\u0441\u0440\u043e\u0447\u0435\u043d\u0430","ctp.manualCardEntry":"\u0412\u0432\u043e\u0434 \u0434\u0430\u043d\u043d\u044b\u0445 \u043a\u0430\u0440\u0442\u044b \u0432\u0440\u0443\u0447\u043d\u0443\u044e","ctp.aria.infoModalButton":"\u0427\u0442\u043e \u0442\u0430\u043a\u043e\u0435 Click to Pay","ctp.infoPopup.title":"Click to Pay \u2013 \u0443\u0434\u043e\u0431\u043d\u0430\u044f \u0431\u0435\u0441\u043a\u043e\u043d\u0442\u0430\u043a\u0442\u043d\u0430\u044f \u043e\u043f\u043b\u0430\u0442\u0430 \u043e\u043d\u043b\u0430\u0439\u043d","ctp.infoPopup.subtitle":"\u0411\u044b\u0441\u0442\u0440\u044b\u0439 \u0431\u0435\u0437\u043e\u043f\u0430\u0441\u043d\u044b\u0439 \u0441\u043f\u043e\u0441\u043e\u0431 \u043e\u043f\u043b\u0430\u0442\u044b, \u043f\u043e\u0434\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0435\u043c\u044b\u0439 Mastercard, Visa \u0438 \u0434\u0440\u0443\u0433\u0438\u043c\u0438 \u043f\u043b\u0430\u0442\u0435\u0436\u043d\u044b\u043c\u0438 \u043a\u0430\u0440\u0442\u0430\u043c\u0438.","ctp.infoPopup.benefit1":"\u0414\u043b\u044f \u043e\u0431\u0435\u0441\u043f\u0435\u0447\u0435\u043d\u0438\u044f \u0431\u0435\u0437\u043e\u043f\u0430\u0441\u043d\u043e\u0441\u0442\u0438 \u0432\u0430\u0448\u0438\u0445 \u0434\u0430\u043d\u043d\u044b\u0445 Click to Pay \u0438\u0441\u043f\u043e\u043b\u044c\u0437\u0443\u0435\u0442 \u0448\u0438\u0444\u0440\u043e\u0432\u0430\u043d\u0438\u0435","ctp.infoPopup.benefit2":"\u0418\u0441\u043f\u043e\u043b\u044c\u0437\u0443\u0439\u0442\u0435 \u0435\u0433\u043e \u0432 \u043c\u0430\u0433\u0430\u0437\u0438\u043d\u0430\u0445 \u043f\u043e \u0432\u0441\u0435\u043c\u0443 \u043c\u0438\u0440\u0443","ctp.infoPopup.benefit3":"\u0411\u0435\u0441\u043f\u0440\u043e\u0431\u043b\u0435\u043c\u043d\u044b\u0435 \u043f\u043b\u0430\u0442\u0435\u0436\u0438 \u0432 \u0431\u0443\u0434\u0443\u0449\u0435\u043c \u2014 \u043d\u0430\u0441\u0442\u0440\u043e\u0439\u043a\u0430 \u0442\u0440\u0435\u0431\u0443\u0435\u0442\u0441\u044f \u0442\u043e\u043b\u044c\u043a\u043e \u043e\u0434\u0438\u043d \u0440\u0430\u0437","ctp.errors.AUTH_INVALID":"\u0410\u0443\u0442\u0435\u043d\u0442\u0438\u0444\u0438\u043a\u0430\u0446\u0438\u044f \u043d\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043b\u044c\u043d\u0430","ctp.errors.NOT_FOUND":"\u0423\u0447\u0435\u0442\u043d\u0430\u044f \u0437\u0430\u043f\u0438\u0441\u044c \u043d\u0435 \u043d\u0430\u0439\u0434\u0435\u043d\u0430. \u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043b\u044c\u043d\u044b\u0439 \u0430\u0434\u0440\u0435\u0441 \u044d\u043b. \u043f\u043e\u0447\u0442\u044b \u0438\u043b\u0438 \u043f\u0440\u043e\u0434\u043e\u043b\u0436\u0438\u0442\u0435 \u0432\u0432\u043e\u0434 \u043a\u0430\u0440\u0442\u044b \u0432\u0440\u0443\u0447\u043d\u0443\u044e","ctp.errors.ID_FORMAT_UNSUPPORTED":"\u0424\u043e\u0440\u043c\u0430\u0442 \u043d\u0435 \u043f\u043e\u0434\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0435\u0442\u0441\u044f","ctp.errors.FRAUD":"\u0423\u0447. \u0437\u0430\u043f\u0438\u0441\u044c \u043f\u043e\u043b\u044c\u0437\u043e\u0432\u0430\u0442\u0435\u043b\u044f \u0437\u0430\u0431\u043b\u043e\u043a\u0438\u0440\u043e\u0432\u0430\u043d\u0430 \u0438\u043b\u0438 \u043e\u0442\u043a\u043b\u044e\u0447\u0435\u043d\u0430","ctp.errors.CONSUMER_ID_MISSING":"\u0418\u0434\u0435\u043d\u0442\u0438\u0444\u0438\u043a\u0430\u0442\u043e\u0440 \u043f\u043e\u0442\u0440\u0435\u0431\u0438\u0442\u0435\u043b\u044f \u043e\u0442\u0441\u0443\u0442\u0441\u0442\u0432\u0443\u0435\u0442 \u0432 \u0437\u0430\u043f\u0440\u043e\u0441\u0435","ctp.errors.ACCT_INACCESSIBLE":"\u042d\u0442\u0430 \u0443\u0447\u0435\u0442\u043d\u0430\u044f \u0437\u0430\u043f\u0438\u0441\u044c \u0441\u0435\u0439\u0447\u0430\u0441 \u043d\u0435\u0434\u043e\u0441\u0442\u0443\u043f\u043d\u0430 (\u043e\u043d\u0430 \u043c\u043e\u0436\u0435\u0442 \u0431\u044b\u0442\u044c, \u043d\u0430\u043f\u0440\u0438\u043c\u0435\u0440, \u0437\u0430\u0431\u043b\u043e\u043a\u0438\u0440\u043e\u0432\u0430\u043d\u0430)","ctp.errors.CODE_INVALID":"\u041d\u0435\u0432\u0435\u0440\u043d\u044b\u0439 \u043a\u043e\u0434 \u043f\u043e\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043d\u0438\u044f","ctp.errors.CODE_EXPIRED":"\u0421\u0440\u043e\u043a \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044f \u043a\u043e\u0434\u0430 \u0438\u0441\u0442\u0435\u043a","ctp.errors.RETRIES_EXCEEDED":"\u041f\u0440\u0435\u0432\u044b\u0448\u0435\u043d \u043b\u0438\u043c\u0438\u0442 \u043f\u043e\u043f\u044b\u0442\u043e\u043a \u0441\u043e\u0437\u0434\u0430\u043d\u0438\u044f \u043e\u0434\u043d\u043e\u0440\u0430\u0437\u043e\u0432\u043e\u0433\u043e \u043f\u0430\u0440\u043e\u043b\u044f","ctp.errors.OTP_SEND_FAILED":"\u041d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u043e\u0442\u043f\u0440\u0430\u0432\u0438\u0442\u044c \u043f\u043e\u043b\u0443\u0447\u0430\u0442\u0435\u043b\u044e \u043e\u0434\u043d\u043e\u0440\u0430\u0437\u043e\u0432\u044b\u0439 \u043f\u0430\u0440\u043e\u043b\u044c","ctp.errors.REQUEST_TIMEOUT":"\u0412\u043e\u0437\u043d\u0438\u043a \u0441\u0431\u043e\u0439. \u041f\u043e\u0432\u0442\u043e\u0440\u0438\u0442\u0435 \u043f\u043e\u043f\u044b\u0442\u043a\u0443 \u0438\u043b\u0438 \u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u043d\u043e\u043c\u0435\u0440 \u043a\u0430\u0440\u0442\u044b \u0432\u0440\u0443\u0447\u043d\u0443\u044e","ctp.errors.UNKNOWN_ERROR":"\u0412\u043e\u0437\u043d\u0438\u043a \u0441\u0431\u043e\u0439. \u041f\u043e\u0432\u0442\u043e\u0440\u0438\u0442\u0435 \u043f\u043e\u043f\u044b\u0442\u043a\u0443 \u0438\u043b\u0438 \u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u043d\u043e\u043c\u0435\u0440 \u043a\u0430\u0440\u0442\u044b \u0432\u0440\u0443\u0447\u043d\u0443\u044e","ctp.errors.SERVICE_ERROR":"\u0412\u043e\u0437\u043d\u0438\u043a \u0441\u0431\u043e\u0439. \u041f\u043e\u0432\u0442\u043e\u0440\u0438\u0442\u0435 \u043f\u043e\u043f\u044b\u0442\u043a\u0443 \u0438\u043b\u0438 \u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u043d\u043e\u043c\u0435\u0440 \u043a\u0430\u0440\u0442\u044b \u0432\u0440\u0443\u0447\u043d\u0443\u044e","ctp.errors.SERVER_ERROR":"\u0412\u043e\u0437\u043d\u0438\u043a \u0441\u0431\u043e\u0439. \u041f\u043e\u0432\u0442\u043e\u0440\u0438\u0442\u0435 \u043f\u043e\u043f\u044b\u0442\u043a\u0443 \u0438\u043b\u0438 \u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u043d\u043e\u043c\u0435\u0440 \u043a\u0430\u0440\u0442\u044b \u0432\u0440\u0443\u0447\u043d\u0443\u044e","ctp.errors.INVALID_PARAMETER":"\u0412\u043e\u0437\u043d\u0438\u043a \u0441\u0431\u043e\u0439. \u041f\u043e\u0432\u0442\u043e\u0440\u0438\u0442\u0435 \u043f\u043e\u043f\u044b\u0442\u043a\u0443 \u0438\u043b\u0438 \u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u043d\u043e\u043c\u0435\u0440 \u043a\u0430\u0440\u0442\u044b \u0432\u0440\u0443\u0447\u043d\u0443\u044e","ctp.errors.AUTH_ERROR":"\u0412\u043e\u0437\u043d\u0438\u043a \u0441\u0431\u043e\u0439. \u041f\u043e\u0432\u0442\u043e\u0440\u0438\u0442\u0435 \u043f\u043e\u043f\u044b\u0442\u043a\u0443 \u0438\u043b\u0438 \u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u043d\u043e\u043c\u0435\u0440 \u043a\u0430\u0440\u0442\u044b \u0432\u0440\u0443\u0447\u043d\u0443\u044e","paymentMethodsList.aria.label":"\u0412\u044b\u0431\u0435\u0440\u0438\u0442\u0435 \u0441\u043f\u043e\u0441\u043e\u0431 \u043e\u043f\u043b\u0430\u0442\u044b"}}),M3=Object.freeze({__proto__:null,default:{payButton:"Zaplati\u0165","payButton.redirecting":"Prebieha presmerovanie ...","payButton.with":"Zaplati\u0165 %{value} pomocou %{maskedData}",close:"Zavrie\u0165",storeDetails:"Ulo\u017ei\u0165 pre moju \u010fal\u0161iu platbu","creditCard.holderName":"Meno na karte","creditCard.holderName.placeholder":"J. Nov\xe1k","creditCard.holderName.invalid":"Neplatn\xe9 meno dr\u017eite\u013ea karty","creditCard.numberField.title":"\u010c\xedslo karty","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"Koniec platnosti","creditCard.expiryDateField.placeholder":"MM/RR","creditCard.expiryDateField.month":"Mesiac","creditCard.expiryDateField.month.placeholder":"MM","creditCard.expiryDateField.year.placeholder":"RR","creditCard.expiryDateField.year":"Rok","creditCard.cvcField.title":"CVC/CVV","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"Zapam\xe4ta\u0165 na bud\xface pou\u017eitie","creditCard.cvcField.placeholder.4digits":"4 \u010d\xedslice","creditCard.cvcField.placeholder.3digits":"3 \u010d\xedslice","creditCard.taxNumber.placeholder":"RRMMDD/0123456789",installments:"Po\u010det spl\xe1tok",installmentOption:"% {times} x % {partialValue}",installmentOptionMonths:"%{times} mesiace/-ov","installments.oneTime":"Jednorazov\xe1 platba","installments.installments":"Platba po spl\xe1tkach","installments.revolving":"Revolvingov\xe1 platba","sepaDirectDebit.ibanField.invalid":"Neplatn\xe9 \u010d\xedslo \xfa\u010dtu","sepaDirectDebit.nameField.placeholder":"J. Nov\xe1k","sepa.ownerName":"Meno dr\u017eite\u013ea","sepa.ibanNumber":"\u010c\xedslo \xfa\u010dtu (IBAN)","error.title":"Chyba","error.subtitle.redirect":"Nepodarilo sa presmerova\u0165","error.subtitle.payment":"Platba zlyhala","error.subtitle.refused":"Platba bola zamietnut\xe1","error.message.unknown":"Vyskytla sa nezn\xe1ma chyba","errorPanel.title":"Existuj\xface chyby","idealIssuer.selectField.title":"Banka","idealIssuer.selectField.placeholder":"Vyberte svoju banku","creditCard.success":"Platba bola \xfaspe\u0161n\xe1",loading:"Na\u010d\xedtava sa\u2026",continue:"Pokra\u010dova\u0165",continueTo:"Pokra\u010dova\u0165 do","wechatpay.timetopay":"Na zaplatenie m\xe1te %@","wechatpay.scanqrcode":"Naskenujte QR k\xf3d",personalDetails:"Osobn\xe9 \xfadaje",companyDetails:"\xdadaje o spolo\u010dnosti","companyDetails.name":"N\xe1zov spolo\u010dnosti","companyDetails.registrationNumber":"Identifika\u010dn\xe9 \u010d\xedslo",socialSecurityNumber:"Rodn\xe9 \u010d\xedslo",firstName:"Krstn\xe9 meno","firstName.invalid":"Meno nie je platn\xe9",infix:"Predpona k priezvisku (ak existuje)",lastName:"Priezvisko","lastName.invalid":"Priezvisko nie je platn\xe9",mobileNumber:"Mobiln\xe9 telef\xf3nne \u010d\xedslo","mobileNumber.invalid":"Neplatn\xe9 \u010d\xedslo na mobil",city:"Mesto",postalCode:"PS\u010c","postalCode.optional":"Po\u0161tov\xe9 smerovacie \u010d\xedslo (nepovinn\xe9)",countryCode:"K\xf3d krajiny",telephoneNumber:"Telef\xf3nne \u010d\xedslo",dateOfBirth:"D\xe1tum narodenia",shopperEmail:"E-mailov\xe1 adresa",gender:"Pohlavie",male:"Mu\u017e",female:"\u017dena",billingAddress:"Faktura\u010dn\xe1 adresa",street:"Ulica",stateOrProvince:"Kraj",country:"Krajina",houseNumberOrName:"\u010c\xedslo domu",separateDeliveryAddress:"Zadajte samostatn\xfa dodaciu adresu",deliveryAddress:"Dodacia adresa",zipCode:"PS\u010c",apartmentSuite:"Byt/apartm\xe1n",provinceOrTerritory:"Okres alebo \xfazemie",cityTown:"Mesto/obec",address:"Adresa",state:"\u0160t\xe1t","field.title.optional":"(volite\u013en\xe9)","creditCard.cvcField.title.optional":"CVC/CVV (volite\u013en\xe9)","issuerList.wallet.placeholder":"Vyberte si pe\u0148a\u017eenku",privacyPolicy:"Z\xe1sady ochrany osobn\xfdch \xfadajov","afterPay.agreement":"S\xfahlas\xedm s %@ AfterPay",paymentConditions:"podmienkami platby",openApp:"Otvorte aplik\xe1ciu","voucher.readInstructions":"Pre\u010d\xedtajte si pokyny","voucher.introduction":"\u010eakujeme v\xe1m za n\xe1kup; na dokon\u010denie platby pou\u017eite nasleduj\xfaci kup\xf3n.","voucher.expirationDate":"D\xe1tum vypr\u0161ania platnosti","voucher.alternativeReference":"Alternat\xedvny odkaz","dragonpay.voucher.non.bank.selectField.placeholder":"Vyberte si poskytovate\u013ea","dragonpay.voucher.bank.selectField.placeholder":"Vyberte svoju banku","voucher.paymentReferenceLabel":"Platobn\xe1 referencia","voucher.surcharge":"Vr\xe1tane poplatku vo v\xfd\u0161ke %@","voucher.introduction.doku":"\u010eakujeme v\xe1m za n\xe1kup. Na dokon\u010denie platby pou\u017eite nasleduj\xface inform\xe1cie.","voucher.shopperName":"Meno kupuj\xfaceho","voucher.merchantName":"Predajca","voucher.introduction.econtext":"\u010eakujeme v\xe1m za n\xe1kup. Na dokon\u010denie platby pou\u017eite nasleduj\xface inform\xe1cie.","voucher.telephoneNumber":"Telef\xf3nne \u010d\xedslo","voucher.shopperReference":"Referencia kupuj\xfaceho","voucher.collectionInstitutionNumber":"\u010c\xedslo inkasnej in\u0161tit\xfacie","voucher.econtext.telephoneNumber.invalid":"Telef\xf3nne \u010d\xedslo mus\xed ma\u0165 10 alebo 11 \u010d\xedslic","boletobancario.btnLabel":"Generova\u0165 Boleto","boleto.sendCopyToEmail":"Zasla\u0165 k\xf3piu na m\xf4j e-mail","button.copy":"Kop\xedrova\u0165","button.download":"Stiahnu\u0165","boleto.socialSecurityNumber.invalid":"Pole je neplatn\xe9","creditCard.storedCard.description.ariaLabel":"Platnos\u0165 ulo\u017eenej karty kon\u010d\xed o %@","voucher.entity":"Subjekt",donateButton:"Prispie\u0165",notNowButton:"Teraz nie",thanksForYourSupport:"\u010eakujeme za podporu!",preauthorizeWith:"Predbe\u017ene autorizova\u0165 pomocou",confirmPreauthorization:"Potvr\u010fte predbe\u017en\xfa autoriz\xe1ciu",confirmPurchase:"Potvr\u010fte n\xe1kup",applyGiftcard:"Uplatni\u0165",giftcardBalance:"Zostatok na dar\u010dekovej karte",deductedBalance:"Zn\xed\u017een\xfd zostatok","creditCard.pin.title":"K\xf3d PIN","creditCard.encryptedPassword.label":"Prv\xe9 2 \u010d\xedslice hesla karty","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"Neplan\xe9 heslo","creditCard.taxNumber":"D\xe1tum narodenia dr\u017eite\u013ea karty alebo identifika\u010dn\xe9 \u010d\xedslo organiz\xe1cie","creditCard.taxNumber.label":"D\xe1tum narodenia dr\u017eite\u013ea karty (RRRMMDD) alebo identifika\u010dn\xe9 \u010d\xedslo organiz\xe1cie (10 \u010d\xedslic)","creditCard.taxNumber.labelAlt":"Identifika\u010dn\xe9 \u010d\xedslo organiz\xe1cie (10 \u010d\xedslic)","creditCard.taxNumber.invalid":"Neplatn\xfd d\xe1tum narodenia dr\u017eite\u013ea karty alebo identifika\u010dn\xe9 \u010d\xedslo organiz\xe1cie","storedPaymentMethod.disable.button":"Odstr\xe1ni\u0165","storedPaymentMethod.disable.confirmation":"Odstr\xe1ni\u0165 ulo\u017een\xfd sp\xf4sob platby","storedPaymentMethod.disable.confirmButton":"\xc1no, odstr\xe1ni\u0165","storedPaymentMethod.disable.cancelButton":"Zru\u0161i\u0165","ach.bankAccount":"Bankov\xfd \xfa\u010det","ach.accountHolderNameField.title":"Meno majite\u013ea \xfa\u010dtu","ach.accountHolderNameField.placeholder":"J. Nov\xe1k","ach.accountHolderNameField.invalid":"Neplatn\xe9 meno majite\u013ea \xfa\u010dtu","ach.accountNumberField.title":"\u010c\xedslo \xfa\u010dtu","ach.accountNumberField.invalid":"Neplatn\xe9 \u010d\xedslo \xfa\u010dtu","ach.accountLocationField.title":"Smerovacie \u010d\xedslo ABA","ach.accountLocationField.invalid":"Neplatn\xe9 smerovacie \u010d\xedslo ABA","ach.savedBankAccount":"Ulo\u017een\xfd bankov\xfd \xfa\u010det","select.state":"Vyberte kraj","select.stateOrProvince":"Vyberte kraj alebo okres","select.provinceOrTerritory":"Vyberte okres alebo \xfazemie","select.country":"Vyberte krajinu","select.noOptionsFound":"Neboli n\xe1jden\xe9 \u017eiadne mo\u017enosti","select.filter.placeholder":"Vyh\u013ead\xe1vanie...","telephoneNumber.invalid":"Neplatn\xe9 telef\xf3nne \u010d\xedslo",qrCodeOrApp:"alebo","paypal.processingPayment":"Platba sa sprac\xfava.",generateQRCode:"Generova\u0165 QR k\xf3d","await.waitForConfirmation":"\u010cak\xe1 sa na potvrdenie","mbway.confirmPayment":"Potvr\u010fte svoju platbu v aplik\xe1cii MB WAY","shopperEmail.invalid":"Neplatn\xe1 emailov\xe1 adresa","dateOfBirth.format":"DD/MM/RRRR","dateOfBirth.invalid":"Mus\xedte ma\u0165 aspo\u0148 18 rokov","blik.confirmPayment":"Otvorte svoju bankov\xfa aplik\xe1ciu a potvr\u010fte platbu.","blik.invalid":"Zadajte 6 \u010d\xedslic","blik.code":"6-cifern\xfd k\xf3d","blik.help":"Z\xedskajte k\xf3d zo svojej bankovej aplik\xe1cie.","swish.pendingMessage":"Po nasn\xedman\xed m\xf4\u017ee spracovanie trva\u0165 a\u017e 10 min\xfat. Pokus o op\xe4tovn\xe9 zaplatenie v tejto lehote m\xf4\u017ee vies\u0165 k nieko\u013ek\xfdm poplatkom.","field.valid":"Pole je platn\xe9","field.invalid":"Pole je neplatn\xe9","error.va.gen.01":"Ne\xfapln\xe9 pole","error.va.gen.02":"Pole je neplatn\xe9","error.va.sf-cc-num.01":"\u010c\xedslo karty nie je platn\xe9","error.va.sf-cc-num.02":"Pole na zadanie \u010d\xedsla karty je pr\xe1zdne","error.va.sf-cc-num.03":"Zadali ste \u010d\xedslo nepodporovanej karty","error.va.sf-cc-num.04":"\u010c\xedslo karty m\xe1 nespr\xe1vnu d\u013a\u017eku","error.va.sf-cc-dat.01":"D\xe1tum uplynutia platnosti: karta je pr\xedli\u0161 star\xe1","error.va.sf-cc-dat.02":"D\xe1tum uplynutia platnosti: d\xe1tum je pr\xedli\u0161 \u010faleko v bud\xfacnosti","error.va.sf-cc-dat.03":"D\xe1tum uplynutia platnosti: platnos\u0165 va\u0161ej karty uplynie pred d\xe1tumom platby","error.va.sf-cc-dat.04":"Pole na zadanie d\xe1tumu uplynutia platnosti je pr\xe1zdne","error.va.sf-cc-dat.05":"D\xe1tum uplynutia platnosti m\xe1 nespr\xe1vnu d\u013a\u017eku","error.va.sf-cc-mth.01":"Pole na zadanie mesiaca platnosti je pr\xe1zdne","error.va.sf-cc-yr.01":"Pole na zadanie roku uplynutia platnosti je pr\xe1zdne","error.va.sf-cc-yr.02":"Rok uplynutia platnosti m\xe1 nespr\xe1vnu d\u013a\u017eku","error.va.sf-cc-cvc.01":"Pole na zadanie bezpe\u010dnostn\xe9ho k\xf3du je pr\xe1zdne","error.va.sf-cc-cvc.02":"Bezpe\u010dnostn\xfd k\xf3d m\xe1 nespr\xe1vnu d\u013a\u017eku","error.va.sf-ach-num.01":"Pole na zadanie \u010d\xedsla bankov\xe9ho \xfa\u010dtu je pr\xe1zdne","error.va.sf-ach-num.02":"\u010c\xedslo bankov\xe9ho \xfa\u010dtu m\xe1 nespr\xe1vnu d\u013a\u017eku","error.va.sf-ach-loc.01":"Pole na zadanie smerov\xe9ho \u010d\xedsla banky je pr\xe1zdne","error.va.sf-ach-loc.02":"Smerov\xe9 \u010d\xedslo banky m\xe1 nespr\xe1vnu d\u013a\u017eku","error.va.sf-kcp-pwd.01":"Pole na zadanie hesla je pr\xe1zdne","error.va.sf-kcp-pwd.02":"Heslo m\xe1 nespr\xe1vnu d\u013a\u017eku","error.giftcard.no-balance":"T\xe1to dar\u010dekov\xe1 karta m\xe1 nulov\xfd zostatok","error.giftcard.card-error":"V na\u0161ich z\xe1znamoch nem\xe1me \u017eiadnu dar\u010dekov\xfa kartu s t\xfdmto \u010d\xedslom","error.giftcard.currency-error":"Dar\u010dekov\xe9 karty s\xfa platn\xe9 iba v mene, v ktorej boli vydan\xe9","amazonpay.signout":"Odhl\xe1si\u0165 sa z Amazonu","amazonpay.changePaymentDetails":"Zmeni\u0165 podrobnosti o platbe","partialPayment.warning":"Ak chcete zaplati\u0165 zostatok, vyberte in\xfd sp\xf4sob platby","partialPayment.remainingBalance":"Zvy\u0161n\xfd zostatok bude %{amount}","bankTransfer.beneficiary":"Pr\xedjemca","bankTransfer.iban":"IBAN","bankTransfer.bic":"BIC","bankTransfer.reference":"Referencie","bankTransfer.introduction":"Pokra\u010dujte vo vytv\xe1ran\xed novej platby bankov\xfdm prevodom. T\xfato platbu m\xf4\u017eete dokon\u010di\u0165 pomocou inform\xe1ci\xed na nasleduj\xfacej obrazovke.","bankTransfer.instructions":"\u010eakujeme v\xe1m za n\xe1kup. Na dokon\u010denie platby pou\u017eite nasleduj\xface inform\xe1cie.","bacs.accountHolderName":"Meno majite\u013ea bankov\xe9ho \xfa\u010dtu","bacs.accountHolderName.invalid":"Neplatn\xe9 meno majite\u013ea bankov\xe9ho \xfa\u010dtu","bacs.accountNumber":"\u010c\xedslo bankov\xe9ho \xfa\u010dtu","bacs.accountNumber.invalid":"Neplatn\xe9 \u010d\xedslo bankov\xe9ho \xfa\u010dtu","bacs.bankLocationId":"Variabiln\xfd symbol","bacs.bankLocationId.invalid":"Neplatn\xfd variabiln\xfd symbol","bacs.consent.amount":"S\xfahlas\xedm s t\xfdm, \u017ee ni\u017e\u0161ie uveden\xe1 \u010diastka bude odp\xedsan\xe1 z m\xf4jho bankov\xe9ho \xfa\u010dtu.","bacs.consent.account":"Potvrdzujem, \u017ee \xfa\u010det je na moje meno a som jedin\xfd podpisovate\u013e, ktor\xfd je povinn\xfd autorizova\u0165 inkaso v tomto \xfa\u010dte.",edit:"Upravi\u0165","bacs.confirm":"Potvrdi\u0165 a zaplati\u0165","bacs.result.introduction":"Stiahnite si pokyny k inkasu (DDI/Mand\xe1t)","download.pdf":"Stiahnu\u0165 vo form\xe1te PDF","creditCard.encryptedCardNumber.aria.iframeTitle":"Iframe pre zabezpe\u010den\xe9 \u010d\xedslo karty","creditCard.encryptedCardNumber.aria.label":"\u010c\xedslo karty","creditCard.encryptedExpiryDate.aria.iframeTitle":"Iframe pre de\u0148 konca platnosti zabezpe\u010denej karty","creditCard.encryptedExpiryDate.aria.label":"Koniec platnosti","creditCard.encryptedExpiryMonth.aria.iframeTitle":"Iframe pre mesiac konca platnosti zabezpe\u010denej karty","creditCard.encryptedExpiryMonth.aria.label":"Mesiac skon\u010denia platnosti","creditCard.encryptedExpiryYear.aria.iframeTitle":"Iframe pre rok konca platnosti zabezpe\u010denej karty","creditCard.encryptedExpiryYear.aria.label":"Rok skon\u010denia platnosti","creditCard.encryptedSecurityCode.aria.iframeTitle":"Iframe pre bezpe\u010dnostn\xfd k\xf3d zabezpe\u010denej karty","creditCard.encryptedSecurityCode.aria.label":"Bezpe\u010dnostn\xfd k\xf3d","creditCard.encryptedPassword.aria.iframeTitle":"Iframe pre zabezpe\u010den\xe9 heslo karty","creditCard.encryptedPassword.aria.label":"Prv\xe9 2 \u010d\xedslice hesla karty","giftcard.encryptedCardNumber.aria.iframeTitle":"Iframe pre \u010d\xedslo zabezpe\u010denej dar\u010dekovej karty","giftcard.encryptedCardNumber.aria.label":"\u010c\xedslo dar\u010dekovej karty","giftcard.encryptedSecurityCode.aria.iframeTitle":"Iframe pre bezpe\u010dnostn\xfd k\xf3d zabezpe\u010denej dar\u010dekovej karty","giftcard.encryptedSecurityCode.aria.label":"Bezpe\u010dnostn\xfd k\xf3d dar\u010dekovej karty",giftcardTransactionLimit:"Pre transakciu s touto dar\u010dekovou kartou je povolen\xe9 maximum %{amount}","ach.encryptedBankAccountNumber.aria.iframeTitle":"Iframe pre \u010d\xedslo zabezpe\u010den\xe9ho bankov\xe9ho \xfa\u010dtu","ach.encryptedBankAccountNumber.aria.label":"Bankov\xfd \xfa\u010det","ach.encryptedBankLocationId.aria.iframeTitle":"Iframe pre zabezpe\u010den\xe9 smerovacie \u010d\xedslo banky","ach.encryptedBankLocationId.aria.label":"Smerovacie \u010d\xedslo banky","twint.saved":"ulo\u017een\xe9",orPayWith:"alebo zaplati\u0165 pomocou",invalidFormatExpects:"Neplatn\xfd form\xe1t. O\u010dak\xe1van\xfd form\xe1t: %{format}","upi.qrCodeWaitingMessage":"Naskenujte QR k\xf3d pomocou preferovanej aplik\xe1cie UPI a dokon\u010dite platbu","upi.vpaWaitingMessage":"Otvorte aplik\xe1ciu UPI a potvr\u010fte platbu","upi.modeSelection":"Vyberte si, ako by ste chceli pou\u017e\xedva\u0165 UPI.","onlineBanking.termsAndConditions":"Pokra\u010dovan\xedm s\xfahlas\xedte so %#zmluvn\xfdmi podmienkami%#","ctp.loading.poweredByCtp":"Vyu\u017e\xedva technol\xf3giu Click to Pay","ctp.loading.intro":"Zis\u0165ujeme, \u010di m\xe1te ulo\u017een\xe9 nejak\xe9 karty v\xa0slu\u017ebe Click to Pay...","ctp.login.title":"Pokra\u010dova\u0165 do slu\u017eby Click to Pay","ctp.login.subtitle":"Na pokra\u010dovanie zadajte e-mailov\xfa adresu, ktor\xe1 je pripojen\xe1 k slu\u017ebe Click to Pay.","ctp.login.inputLabel":"E-mail","ctp.logout.notYou":"Nie ste to vy?","ctp.logout.notYourCards":"Nie s\xfa to va\u0161e karty?","ctp.logout.notYourCard":"Nie je to va\u0161a karta?","ctp.logout.notYourProfile":"Nie je to v\xe1\u0161 profil?","ctp.otp.fieldLabel":"Jednorazov\xfd k\xf3d","ctp.otp.resendCode":"Znova odosla\u0165 k\xf3d","ctp.otp.codeResent":"K\xf3d bol znova odoslan\xfd","ctp.otp.title":"Z\xedskajte pr\xedstup k va\u0161im kart\xe1m v\xa0slu\u017ebe Click to Pay","ctp.otp.subtitle":"Zadajte k\xf3d %@, ktor\xfd sme poslali na adresu %@, aby sme overili, \u017ee ste to vy.","ctp.emptyProfile.message":"V\xa0tomto profile Click to Pay nie s\xfa registrovan\xe9 \u017eiadne karty","ctp.separatorText":"alebo pou\u017eite","ctp.cards.title":"Dokon\u010dite platbu v\xa0slu\u017ebe Click to Pay","ctp.cards.subtitle":"Vyberte kartu, ktor\xfa chcete pou\u017ei\u0165.","ctp.cards.expiredCard":"Platnos\u0165 uplynula","ctp.manualCardEntry":"Manu\xe1lne zadanie karty","ctp.aria.infoModalButton":"\u010co znamen\xe1 Click to Pay","ctp.infoPopup.title":"Click to Pay prin\xe1\u0161a jednoduchos\u0165 bezkontaktn\xfdch platieb online","ctp.infoPopup.subtitle":"R\xfdchly a\xa0bezpe\u010dn\xfd sp\xf4sob platby podporovan\xfd platobn\xfdmi kartami Mastercard, Visa a\xa0\u010fal\u0161\xedmi.","ctp.infoPopup.benefit1":"Click to Pay pou\u017e\xedva \u0161ifrovanie, aby boli va\u0161e \xfadaje v\xa0bezpe\u010d\xed","ctp.infoPopup.benefit2":"Pou\u017e\xedvajte ju u\xa0obchodn\xedkov po celom svete","ctp.infoPopup.benefit3":"Jedno nastavenie pre pohodln\xe9 platby v\xa0bud\xfacnosti","ctp.errors.AUTH_INVALID":"Overenie bolo neplatn\xe9","ctp.errors.NOT_FOUND":"Nena\u0161iel sa \u017eiadny \xfa\u010det. Zadajte platn\xfd e-mail alebo pokra\u010dujte manu\xe1lnym zadan\xedm karty.","ctp.errors.ID_FORMAT_UNSUPPORTED":"Form\xe1t nie je podporovan\xfd","ctp.errors.FRAUD":"Pou\u017e\xedvate\u013esk\xfd \xfa\u010det bol uzamknut\xfd alebo zak\xe1zan\xfd","ctp.errors.CONSUMER_ID_MISSING":"V \u017eiadosti ch\xfdba identita spotrebite\u013ea","ctp.errors.ACCT_INACCESSIBLE":"Tento \xfa\u010det je moment\xe1lne nedostupn\xfd (napr. je zamknut\xfd)","ctp.errors.CODE_INVALID":"Nespr\xe1vny overovac\xed k\xf3d","ctp.errors.CODE_EXPIRED":"Platnos\u0165 tohto k\xf3du uplynula","ctp.errors.RETRIES_EXCEEDED":"Limit po\u010dtu opakovan\xed pre generovanie jednorazov\xe9ho hesla bol prekro\u010den\xfd","ctp.errors.OTP_SEND_FAILED":"Jednorazov\xe9 heslo nebolo mo\u017en\xe9 odosla\u0165 pr\xedjemcovi","ctp.errors.REQUEST_TIMEOUT":"Do\u0161lo k chybe. Sk\xfaste to znova alebo kartu zadajte ru\u010dne.","ctp.errors.UNKNOWN_ERROR":"Do\u0161lo k chybe. Sk\xfaste to znova alebo kartu zadajte ru\u010dne.","ctp.errors.SERVICE_ERROR":"Do\u0161lo k chybe. Sk\xfaste to znova alebo kartu zadajte ru\u010dne.","ctp.errors.SERVER_ERROR":"Do\u0161lo k chybe. Sk\xfaste to znova alebo kartu zadajte ru\u010dne.","ctp.errors.INVALID_PARAMETER":"Do\u0161lo k chybe. Sk\xfaste to znova alebo kartu zadajte ru\u010dne.","ctp.errors.AUTH_ERROR":"Do\u0161lo k chybe. Sk\xfaste to znova alebo kartu zadajte ru\u010dne.","paymentMethodsList.aria.label":"V\xfdber sp\xf4sobu platby"}}),L3=Object.freeze({__proto__:null,default:{payButton:"Pla\u010dilo","payButton.redirecting":"Preusmerjanje ...","payButton.with":"Pla\u010dajte %{value} z %{maskedData}",close:"Zapri",storeDetails:"Shrani za moje naslednje pla\u010dilo","creditCard.holderName":"Ime na kartici","creditCard.holderName.placeholder":"J. Novak","creditCard.holderName.invalid":"Neveljavno ime imetnika kartice","creditCard.numberField.title":"\u0160tevilka kartice","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"Datum veljavnosti","creditCard.expiryDateField.placeholder":"MM/LL","creditCard.expiryDateField.month":"Mesec","creditCard.expiryDateField.month.placeholder":"MM","creditCard.expiryDateField.year.placeholder":"LL","creditCard.expiryDateField.year":"Leto","creditCard.cvcField.title":"CVC/CVV","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"Zapomni si za prihodnji\u010d","creditCard.cvcField.placeholder.4digits":"4 \u0161tevke","creditCard.cvcField.placeholder.3digits":"3 \u0161tevke","creditCard.taxNumber.placeholder":"LLMMDD / 0123456789",installments:"\u0160tevilo obrokov",installmentOption:"%{times} \xd7 %{partialValue}",installmentOptionMonths:"\u0160t. mesecev: %{times}","installments.oneTime":"Enkratno pla\u010dilo","installments.installments":"Obro\u010dno pla\u010dilo","installments.revolving":"Revolving pla\u010dilo","sepaDirectDebit.ibanField.invalid":"Neveljavna \u0161tevilka ra\u010duna","sepaDirectDebit.nameField.placeholder":"J. Novak","sepa.ownerName":"Ime imetnika","sepa.ibanNumber":"\u0160tevilka ra\u010duna (IBAN)","error.title":"Napaka","error.subtitle.redirect":"Preusmeritev ni uspela","error.subtitle.payment":"Pla\u010dilo ni uspelo","error.subtitle.refused":"Pla\u010dilo je bilo zavrnjeno","error.message.unknown":"Pri\u0161lo je do neznane napake","errorPanel.title":"Obstoje\u010de napake","idealIssuer.selectField.title":"Banka","idealIssuer.selectField.placeholder":"Izberite svojo banko","creditCard.success":"Pla\u010dilo je bilo uspe\u0161no",loading:"Nalaganje \u2026",continue:"Nadaljuj",continueTo:"Nadaljujte na","wechatpay.timetopay":"Pla\u010dati morate %@","wechatpay.scanqrcode":"Opti\u010dno preberite kodo QR",personalDetails:"Osebni podatki",companyDetails:"Podrobnosti o podjetju","companyDetails.name":"Ime podjetja","companyDetails.registrationNumber":"Mati\u010dna \u0161tevilka podjetja",socialSecurityNumber:"\u0160tevilka socialnega zavarovanja",firstName:"Ime","firstName.invalid":"Ime ni veljavno",infix:"Naziv",lastName:"Priimek","lastName.invalid":"Priimek ni veljaven",mobileNumber:"\u0160tevilka mobilnega telefona","mobileNumber.invalid":"Neveljavna \u0161tevilka mobilnega telefona",city:"Mesto",postalCode:"Po\u0161tna \u0161tevilka","postalCode.optional":"Po\u0161tna \u0161tevilka (neobvezno)",countryCode:"Koda dr\u017eave",telephoneNumber:"Telefonska \u0161tevilka",dateOfBirth:"Datum rojstva",shopperEmail:"Elektronski naslov",gender:"Spol",male:"Mo\u0161ki",female:"\u017denski",billingAddress:"Naslov za ra\u010dun",street:"Ulica",stateOrProvince:"Dr\u017eava ali provinca",country:"Dr\u017eava",houseNumberOrName:"Hi\u0161na \u0161tevilka",separateDeliveryAddress:"Navedite lo\u010den naslov za dostavo",deliveryAddress:"Naslov za dostavo",zipCode:"Po\u0161tna \u0161tevilka",apartmentSuite:"\u0160t. apartmaja/stanovanja",provinceOrTerritory:"Obmo\u010dje ali ozemlje",cityTown:"Mesto",address:"Naslov",state:"Dr\u017eava","field.title.optional":"(izbirno)","creditCard.cvcField.title.optional":"CVC/CVV (neobvezno)","issuerList.wallet.placeholder":"Izberite svojo denarnico",privacyPolicy:"Pravilnik o zasebnosti","afterPay.agreement":"Strinjam se s %@ ponudnika AfterPay",paymentConditions:"pla\u010dilnimi pogoji",openApp:"Odprite aplikacijo","voucher.readInstructions":"Preberite navodila","voucher.introduction":"Zahvaljujemo se vam za nakup. Za dokon\u010danje pla\u010dila uporabite naslednji kupon.","voucher.expirationDate":"Datum poteka veljavnosti","voucher.alternativeReference":"Druga referen\u010dna \u0161tevilka","dragonpay.voucher.non.bank.selectField.placeholder":"Izberite svojega ponudnika","dragonpay.voucher.bank.selectField.placeholder":"Izberite svojo banko","voucher.paymentReferenceLabel":"Referen\u010dna \u0161tevilka pla\u010dila","voucher.surcharge":"Vklj. %@ dopla\u010dila","voucher.introduction.doku":"Zahvaljujemo se vam za nakup. Za dokon\u010danje pla\u010dila uporabite naslednji kupon.","voucher.shopperName":"Ime kupca","voucher.merchantName":"Trgovec","voucher.introduction.econtext":"Zahvaljujemo se vam za nakup. Za dokon\u010danje pla\u010dila uporabite naslednji kupon.","voucher.telephoneNumber":"Telefonska \u0161tevilka","voucher.shopperReference":"Referen\u010dna \u0161tevilka kupca","voucher.collectionInstitutionNumber":"\u0160tevilka ustanove za zbiranje","voucher.econtext.telephoneNumber.invalid":"Telefonska \u0161tevilka mora vsebovati 10 ali 11 \u0161tevk","boletobancario.btnLabel":"Ustvari Boleto","boleto.sendCopyToEmail":"Po\u0161lji kopijo na moj elektronski naslov","button.copy":"Kopiraj","button.download":"Prenesi","boleto.socialSecurityNumber.invalid":"Polje ni veljavno","creditCard.storedCard.description.ariaLabel":"Shranjena kartica se kon\u010da na %@","voucher.entity":"Entiteta",donateButton:"Donirajte",notNowButton:"Ne zdaj",thanksForYourSupport:"Zahvaljujemo se vam za podporo!",preauthorizeWith:"Predhodna odobritev s/z:",confirmPreauthorization:"Potrdi predhodno odobritev",confirmPurchase:"Potrditev nakupa",applyGiftcard:"Unov\u010di",giftcardBalance:"Stanje na darilni kartici",deductedBalance:"Odbiti znesek","creditCard.pin.title":"PIN","creditCard.encryptedPassword.label":"Prvi dve \u0161tevki gesla za kartico","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"Neveljavno geslo","creditCard.taxNumber":"Datum rojstva imetnika kartice ali mati\u010dna \u0161tevilka podjetja","creditCard.taxNumber.label":"Datum rojstva imetnika kartice (LLMMDD) ali registracijska \u0161tevilka podjetja (10 \u0161tevk)","creditCard.taxNumber.labelAlt":"Mati\u010dna \u0161tevilka podjetja (10 \u0161tevk)","creditCard.taxNumber.invalid":"Neveljaven datum rojstva imetnika kartice ali mati\u010dna \u0161tevilka podjetja","storedPaymentMethod.disable.button":"Odstrani","storedPaymentMethod.disable.confirmation":"Odstrani shranjen na\u010din pla\u010dila","storedPaymentMethod.disable.confirmButton":"Da, odstrani","storedPaymentMethod.disable.cancelButton":"Prekli\u010di","ach.bankAccount":"Ban\u010dni ra\u010dun","ach.accountHolderNameField.title":"Ime imetnika ra\u010duna","ach.accountHolderNameField.placeholder":"J. Novak","ach.accountHolderNameField.invalid":"Neveljavno ime imetnika ra\u010duna","ach.accountNumberField.title":"\u0160tevilka ra\u010duna","ach.accountNumberField.invalid":"Neveljavna \u0161tevilka ra\u010duna","ach.accountLocationField.title":"Koda banke ABA","ach.accountLocationField.invalid":"Neveljavna koda banke ABA","ach.savedBankAccount":"Shranjen ban\u010dni ra\u010dun","select.state":"Izberite dr\u017eavo","select.stateOrProvince":"Izberite dr\u017eavo ali provinco","select.provinceOrTerritory":"Izberite obmo\u010dje ali ozemlje","select.country":"Izberite dr\u017eavo","select.noOptionsFound":"Ni najdenih mo\u017enosti","select.filter.placeholder":"Iskanje ...","telephoneNumber.invalid":"Neveljavna telefonska \u0161tevilka",qrCodeOrApp:"ali","paypal.processingPayment":"Obdelava pla\u010dila ...",generateQRCode:"Ustvari kodo QR","await.waitForConfirmation":"\u010cakanje na potrditev","mbway.confirmPayment":"Potrdite svoje pla\u010dilo v aplikaciji MB WAY","shopperEmail.invalid":"Neveljaven elektronski naslov","dateOfBirth.format":"DD/MM/LLLL","dateOfBirth.invalid":"Imeti morate najmanj 18 let","blik.confirmPayment":"Za potrditev pla\u010dila odprite svojo ban\u010dno aplikacijo.","blik.invalid":"Vnesite 6 \u0161tevilk","blik.code":"6-mestna koda","blik.help":"Pridobite kodo iz ban\u010dne aplikacije.","swish.pendingMessage":"Ko opti\u010dno preberete, lahko \u010dakanje traja do 10 minut. Poskus ponovnega pla\u010dila v tem \u010dasu lahko povzro\u010di ve\u010d odtegljajev.","field.valid":"Polje je veljavno","field.invalid":"Polje ni veljavno","error.va.gen.01":"Nepopolno polje","error.va.gen.02":"Polje ni veljavno","error.va.sf-cc-num.01":"\u0160tevilka kartice ni veljavna","error.va.sf-cc-num.02":"Polje s \u0161tevilko kartice je prazno","error.va.sf-cc-num.03":"Vnesena je nepodprta \u0161tevilka kartice","error.va.sf-cc-num.04":"\u0160tevilka kartice je napa\u010dne dol\u017eine","error.va.sf-cc-dat.01":"Datum poteka veljavnosti: kartica je prestara","error.va.sf-cc-dat.02":"Datum poteka veljavnosti: datum je predale\u010d v prihodnosti","error.va.sf-cc-dat.03":"Datum poteka veljavnosti: va\u0161a kartica pote\u010de pred datumom odjave","error.va.sf-cc-dat.04":"Polje z datumom poteka veljavnosti je prazno","error.va.sf-cc-dat.05":"Datum poteka veljavnosti je napa\u010dne dol\u017eine","error.va.sf-cc-mth.01":"Polje z mesecem poteka veljavnosti je prazno","error.va.sf-cc-yr.01":"Polje z letom poteka veljavnosti je prazno","error.va.sf-cc-yr.02":"Leto poteka veljavnosti je napa\u010dne dol\u017eine","error.va.sf-cc-cvc.01":"Polje z varnostno kodo je prazno","error.va.sf-cc-cvc.02":"Varnostna koda je napa\u010dne dol\u017eine","error.va.sf-ach-num.01":"Polje s \u0161tevilko ban\u010dnega ra\u010duna je prazno","error.va.sf-ach-num.02":"\u0160tevilka ban\u010dnega ra\u010duna je napa\u010dne dol\u017eine","error.va.sf-ach-loc.01":"Polje z ban\u010dno usmerjevalno \u0161tevilko je prazno","error.va.sf-ach-loc.02":"Ban\u010dna usmerjevalna \u0161tevilka je napa\u010dne dol\u017eine","error.va.sf-kcp-pwd.01":"Polje z geslom je prazno","error.va.sf-kcp-pwd.02":"Geslo je napa\u010dne dol\u017eine","error.giftcard.no-balance":"Na tej darilni kartici ni sredstev","error.giftcard.card-error":"V na\u0161i evidenci nimamo darilne kartice s to \u0161tevilko","error.giftcard.currency-error":"Darilne kartice so veljavne samo za valuto, za katero so bile izdane","amazonpay.signout":"Odjava iz Amazona","amazonpay.changePaymentDetails":"Sprememba podrobnosti pla\u010dila","partialPayment.warning":"Izberite drugo vrsto pla\u010dila za pla\u010dilo ostanka","partialPayment.remainingBalance":"Preostalo stanje bo %{amount}","bankTransfer.beneficiary":"Upravi\u010denec","bankTransfer.iban":"IBAN","bankTransfer.bic":"BIC","bankTransfer.reference":"Referenca","bankTransfer.introduction":"Nadaljujte ustvarjanje novega pla\u010dila z ban\u010dnim nakazilom. Za dokon\u010danje tega pla\u010dila lahko uporabite podatke na naslednjem zaslonu.","bankTransfer.instructions":"Zahvaljujemo se vam za nakup. Za dokon\u010danje pla\u010dila uporabite naslednji kupon.","bacs.accountHolderName":"Ime imetnika ban\u010dnega ra\u010duna","bacs.accountHolderName.invalid":"Neveljavno ime imetnika ra\u010duna","bacs.accountNumber":"\u0160tevilka ban\u010dnega ra\u010duna","bacs.accountNumber.invalid":"Neveljavna \u0161tevilka ban\u010dnega ra\u010duna","bacs.bankLocationId":"\u0160tevilka banke","bacs.bankLocationId.invalid":"Neveljavna \u0161tevilka banke","bacs.consent.amount":"Sogla\u0161am s tem, da bo zgornji znesek odtegnjen z mojega ban\u010dnega ra\u010duna.","bacs.consent.account":"Potrjujem, da je ra\u010dun ustvarjen v mojem imenu in sem edini podpisnik za odobritev neposredne bremenitve za ta ra\u010dun.",edit:"Uredi","bacs.confirm":"Potrdi in pla\u010daj","bacs.result.introduction":"Prenesite navodila za neposredno bremenitev (DDI/mandat)","download.pdf":"Prenos datoteke PDF","creditCard.encryptedCardNumber.aria.iframeTitle":"Iframe za zavarovano \u0161tevilko kartice","creditCard.encryptedCardNumber.aria.label":"\u0160tevilka kartice","creditCard.encryptedExpiryDate.aria.iframeTitle":"Iframe za zavarovan potek veljavnosti kartice","creditCard.encryptedExpiryDate.aria.label":"Datum veljavnosti","creditCard.encryptedExpiryMonth.aria.iframeTitle":"Iframe za zavarovan mesec poteka veljavnosti kartice","creditCard.encryptedExpiryMonth.aria.label":"Mesec poteka","creditCard.encryptedExpiryYear.aria.iframeTitle":"Iframe za zavarovano leto poteka veljavnosti kartice","creditCard.encryptedExpiryYear.aria.label":"Leto poteka","creditCard.encryptedSecurityCode.aria.iframeTitle":"Iframe za zavarovano varnostno kodo kartice","creditCard.encryptedSecurityCode.aria.label":"Varnostna koda","creditCard.encryptedPassword.aria.iframeTitle":"Iframe za zavarovano geslo kartice","creditCard.encryptedPassword.aria.label":"Prvi dve \u0161tevki gesla za kartico","giftcard.encryptedCardNumber.aria.iframeTitle":"Iframe za zavarovano \u0161tevilko darilne kartice","giftcard.encryptedCardNumber.aria.label":"\u0160tevilka darilne kartice","giftcard.encryptedSecurityCode.aria.iframeTitle":"Iframe za zavarovano varnostno kodo darilne kartice","giftcard.encryptedSecurityCode.aria.label":"Varnostna koda darilne kartice",giftcardTransactionLimit:"Za posamezno transakcijo na tej darilni kartici je dovoljeno najve\u010d %{amount}","ach.encryptedBankAccountNumber.aria.iframeTitle":"Iframe za zavarovano \u0161tevilko ban\u010dnega ra\u010duna","ach.encryptedBankAccountNumber.aria.label":"Ban\u010dni ra\u010dun","ach.encryptedBankLocationId.aria.iframeTitle":"Iframe za zavarovano kodo banke","ach.encryptedBankLocationId.aria.label":"Usmerjevalna \u0161tevilka banke","twint.saved":"shranjeno",orPayWith:"ali pla\u010dajte s/z",invalidFormatExpects:"Neveljavna oblika zapisa. Pri\u010dakovana oblika zapisa: %{format}","upi.qrCodeWaitingMessage":"Za dokon\u010danje pla\u010dila opti\u010dno preberite kodo QR z \u017eeleno aplikacijo UPI","upi.vpaWaitingMessage":"Za potrditev pla\u010dila odprite svojo aplikacijo UPI","upi.modeSelection":"Izberite, kako \u017eelite uporabljati aplikacijo UPI.","onlineBanking.termsAndConditions":"Z nadaljevanjem se strinjate s %#pogoji%#","ctp.loading.poweredByCtp":"Omogo\u010da storitev Click to Pay","ctp.loading.intro":"Preverjamo, ali imate shranjene kartice v storitvi Click to Pay ...","ctp.login.title":"Nadaljuj na storitev Click to Pay","ctp.login.subtitle":"Za nadaljevanje vnesite e-po\u0161tni naslov, ki je povezan s storitvijo Click to Pay.","ctp.login.inputLabel":"E-po\u0161ta","ctp.logout.notYou":"To niste vi?","ctp.logout.notYourCards":"To niso va\u0161e kartice?","ctp.logout.notYourCard":"To ni va\u0161a kartica?","ctp.logout.notYourProfile":"To ni va\u0161 profil?","ctp.otp.fieldLabel":"Enkratna koda","ctp.otp.resendCode":"Znova po\u0161lji kodo","ctp.otp.codeResent":"Koda je bila znova poslana","ctp.otp.title":"Dostop do va\u0161ih kartic Click to Pay","ctp.otp.subtitle":"Vnesite kodo %@, ki smo jo poslali na %@, da potrdite, da ste to res vi.","ctp.emptyProfile.message":"V tem profilu Click to Pay ni registriranih nobenih kartic","ctp.separatorText":"ali uporabite","ctp.cards.title":"Dokon\u010dajte pla\u010dilo s storitvijo Click to Pay","ctp.cards.subtitle":"Izberite kartico, ki jo \u017eelite uporabiti.","ctp.cards.expiredCard":"Veljavnost potekla","ctp.manualCardEntry":"Ro\u010dni vnos kartice","ctp.aria.infoModalButton":"Kaj je storitev Click to Pay","ctp.infoPopup.title":"Storitev Click to Pay prina\u0161a enostavnost brezsti\u010dnega pla\u010devanja v spletno okolje","ctp.infoPopup.subtitle":"Hiter in varen na\u010din pla\u010dila, ki ga podpirajo Mastercard, Visa in druge pla\u010dilne kartice.","ctp.infoPopup.benefit1":"Storitev Click to Pay s \u0161ifriranjem poskrbi, da so va\u0161i podatki varni in za\u0161\u010diteni","ctp.infoPopup.benefit2":"Uporabljate jo lahko pri prodajalcih po vsem svetu","ctp.infoPopup.benefit3":"Enkratna nastavitev za brezskrbno pla\u010devanje v prihodnje","ctp.errors.AUTH_INVALID":"Preverjanje pristnosti ni veljavno","ctp.errors.NOT_FOUND":"Ra\u010duna ni bilo mogo\u010de najti, vnesite veljaven e-po\u0161tni naslov ali nadaljujte z uporabo ro\u010dnega vnosa kartice","ctp.errors.ID_FORMAT_UNSUPPORTED":"Oblika zapisa ni podprta","ctp.errors.FRAUD":"Uporabni\u0161ki ra\u010dun je bil zaklenjen ali onemogo\u010den","ctp.errors.CONSUMER_ID_MISSING":"V zahtevi manjka identiteta potro\u0161nika","ctp.errors.ACCT_INACCESSIBLE":"Ta ra\u010dun trenutno ni na voljo, npr. morda je zaklenjen","ctp.errors.CODE_INVALID":"Koda za preverjanje ni pravilna","ctp.errors.CODE_EXPIRED":"Ta koda je potekla","ctp.errors.RETRIES_EXCEEDED":"Omejitev \u0161tevila ponovnih poskusov za generiranje gesla OTP je bila prese\u017eena","ctp.errors.OTP_SEND_FAILED":"Gesla OTP ni bilo mogo\u010de poslati prejemniku","ctp.errors.REQUEST_TIMEOUT":"Nekaj je \u0161lo narobe, poskusite znova ali uporabite ro\u010dni vnos kartice","ctp.errors.UNKNOWN_ERROR":"Nekaj je \u0161lo narobe, poskusite znova ali uporabite ro\u010dni vnos kartice","ctp.errors.SERVICE_ERROR":"Nekaj je \u0161lo narobe, poskusite znova ali uporabite ro\u010dni vnos kartice","ctp.errors.SERVER_ERROR":"Nekaj je \u0161lo narobe, poskusite znova ali uporabite ro\u010dni vnos kartice","ctp.errors.INVALID_PARAMETER":"Nekaj je \u0161lo narobe, poskusite znova ali uporabite ro\u010dni vnos kartice","ctp.errors.AUTH_ERROR":"Nekaj je \u0161lo narobe, poskusite znova ali uporabite ro\u010dni vnos kartice","paymentMethodsList.aria.label":"Izberite na\u010din pla\u010dila"}}),V3=Object.freeze({__proto__:null,default:{payButton:"Betala","payButton.redirecting":"Omdirigerar\u2026","payButton.with":"Betala %{value} med %{maskedData}",close:"St\xe4ng",storeDetails:"Spara till min n\xe4sta betalning","creditCard.holderName":"Namn p\xe5 kort","creditCard.holderName.placeholder":"A. Andersson","creditCard.holderName.invalid":"Kortinnehavarens namn \xe4r ogiltigt","creditCard.numberField.title":"Kortnummer","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"Utg\xe5ngsdatum","creditCard.expiryDateField.placeholder":"MM/\xc5\xc5","creditCard.expiryDateField.month":"M\xe5nad","creditCard.expiryDateField.month.placeholder":"MM","creditCard.expiryDateField.year.placeholder":"\xc5\xc5","creditCard.expiryDateField.year":"\xc5r","creditCard.cvcField.title":"CVC / CVV","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"Spara kortuppgifter","creditCard.cvcField.placeholder.4digits":"4 siffror","creditCard.cvcField.placeholder.3digits":"3 siffror","creditCard.taxNumber.placeholder":"\xc5\xc5MMDD / 0123456789",installments:"Antal delbetalningar",installmentOption:"%{times} x %{partialValue}",installmentOptionMonths:"%{times} m\xe5nader","installments.oneTime":"Eng\xe5ngsbetalning","installments.installments":"Delbetalningar","installments.revolving":"Uppdelad betalning","sepaDirectDebit.ibanField.invalid":"Ogiltigt kontonummer","sepaDirectDebit.nameField.placeholder":"A. Andersson","sepa.ownerName":"K\xe4nt av kontoinnehavaren","sepa.ibanNumber":"Kontonummer (IBAN)","error.title":"Fel","error.subtitle.redirect":"Omdirigering misslyckades","error.subtitle.payment":"Betalning misslyckades","error.subtitle.refused":"Betalning avvisad","error.message.unknown":"Ett ok\xe4nt fel uppstod","errorPanel.title":"Befintliga fel","idealIssuer.selectField.title":"Bank","idealIssuer.selectField.placeholder":"V\xe4lj din bank","creditCard.success":"Betalning lyckades",loading:"Laddar\u2026",continue:"Forts\xe4tt",continueTo:"Forts\xe4tt till","wechatpay.timetopay":"Du har %@ att betala","wechatpay.scanqrcode":"Skanna QR-kod",personalDetails:"Personuppgifter",companyDetails:"F\xf6retagsinformation","companyDetails.name":"F\xf6retagsnamn","companyDetails.registrationNumber":"Registreringsnummer",socialSecurityNumber:"Personnummer",firstName:"F\xf6rnamn","firstName.invalid":"F\xf6rnamnet \xe4r inte giltigt",infix:"Prefix",lastName:"Efternamn","lastName.invalid":"Efternamnet \xe4r inte giltigt",mobileNumber:"Mobilnummer","mobileNumber.invalid":"Ogiltigt mobilnummer",city:"Stad",postalCode:"Postnummer","postalCode.optional":"Postnummer (valfritt)",countryCode:"Landskod",telephoneNumber:"Telefonnummer",dateOfBirth:"F\xf6delsedatum",shopperEmail:"E-postadress",gender:"K\xf6n",male:"Man",female:"Kvinna",billingAddress:"Faktureringsadress",street:"Gatuadress",stateOrProvince:"Delstat eller region",country:"Land",houseNumberOrName:"Husnummer",separateDeliveryAddress:"Ange en separat leveransadress",deliveryAddress:"Leveransadress",zipCode:"Postnummer",apartmentSuite:"L\xe4genhetsnummer",provinceOrTerritory:"Provins eller territorium",cityTown:"Ort",address:"Adress",state:"Delstat","field.title.optional":"(valfritt)","creditCard.cvcField.title.optional":"CVC/CVV (tillval)","issuerList.wallet.placeholder":"V\xe4j din pl\xe5nbok",privacyPolicy:"Sekretesspolicy","afterPay.agreement":"Jag godk\xe4nner AfterPays %@",paymentConditions:"betalvillkor",openApp:"\xd6ppna appen","voucher.readInstructions":"L\xe4s instruktionerna","voucher.introduction":"Tack f\xf6r ditt k\xf6p, v\xe4nligen anv\xe4nd f\xf6ljande kupong f\xf6r att slutf\xf6ra din betalning.","voucher.expirationDate":"Utg\xe5ngsdatum","voucher.alternativeReference":"Alternativ referens","dragonpay.voucher.non.bank.selectField.placeholder":"V\xe4lj din leverant\xf6r","dragonpay.voucher.bank.selectField.placeholder":"V\xe4lj din bank","voucher.paymentReferenceLabel":"Betalreferens","voucher.surcharge":"Inklusive %@ i avgift","voucher.introduction.doku":"Tack f\xf6r ditt k\xf6p, v\xe4nligen anv\xe4nd f\xf6ljande information f\xf6r att slutf\xf6ra din betalning.","voucher.shopperName":"Konsumentens namn","voucher.merchantName":"Handlare","voucher.introduction.econtext":"Tack f\xf6r ditt k\xf6p, v\xe4nligen anv\xe4nd f\xf6ljande information f\xf6r att slutf\xf6ra din betalning.","voucher.telephoneNumber":"Telefonnummer","voucher.shopperReference":"K\xf6parreferens","voucher.collectionInstitutionNumber":"Nummer p\xe5 upph\xe4mtningsplats","voucher.econtext.telephoneNumber.invalid":"Telefonnumret m\xe5ste inneh\xe5lla 10 eller 11 siffror","boletobancario.btnLabel":"Generera Boleto","boleto.sendCopyToEmail":"Skicka en kopia till min e-post","button.copy":"Kopiera","button.download":"Ladda ner","boleto.socialSecurityNumber.invalid":"F\xe4ltet \xe4r ogiltigt","creditCard.storedCard.description.ariaLabel":"Sparat kort slutar p\xe5 %@","voucher.entity":"Enhet",donateButton:"Donera",notNowButton:"Inte nu",thanksForYourSupport:"Tack f\xf6r ditt st\xf6d!",preauthorizeWith:"F\xf6rauktorisera med",confirmPreauthorization:"Bekr\xe4fta f\xf6rauktorisering",confirmPurchase:"Bekr\xe4fta k\xf6p",applyGiftcard:"L\xf6s in",giftcardBalance:"Presentkortssaldo",deductedBalance:"Avdraget saldo","creditCard.pin.title":"PIN-kod","creditCard.encryptedPassword.label":"De tv\xe5 f\xf6rsta siffrorna i kortets l\xf6senord","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"Ogiltigt l\xf6senord","creditCard.taxNumber":"Kortinnehavarens f\xf6delsedatum eller f\xf6retagets organisationsnummer","creditCard.taxNumber.label":"Kortinnehavarens f\xf6delsedatum (\xc5\xc5MMDD) eller f\xf6retagets organisationsnummer (10 siffror)","creditCard.taxNumber.labelAlt":"F\xf6retagets organisationsnummer (10 siffror)","creditCard.taxNumber.invalid":"Ogiltigt f\xf6delsedatum eller organisationsnummer","storedPaymentMethod.disable.button":"Ta bort","storedPaymentMethod.disable.confirmation":"Ta bort sparat betalningss\xe4tt","storedPaymentMethod.disable.confirmButton":"Ja, ta bort","storedPaymentMethod.disable.cancelButton":"Avbryt","ach.bankAccount":"Bankkonto","ach.accountHolderNameField.title":"Kontoinnehavarens namn","ach.accountHolderNameField.placeholder":"A. Andersson","ach.accountHolderNameField.invalid":"Kontoinnehavarens namn \xe4r ogiltigt","ach.accountNumberField.title":"Kontonummer","ach.accountNumberField.invalid":"Ogiltigt kontonummer","ach.accountLocationField.title":"ABA-nummer","ach.accountLocationField.invalid":"Ogiltigt ABA-nummer","ach.savedBankAccount":"Sparat bankkonto","select.state":"V\xe4lj delstat","select.stateOrProvince":"V\xe4lj delstat eller provins","select.provinceOrTerritory":"V\xe4lj provins eller territorium","select.country":"V\xe4lj land","select.noOptionsFound":"Inga alternativ hittades","select.filter.placeholder":"S\xf6k efter\u2026","telephoneNumber.invalid":"Ogiltigt telefonnummer",qrCodeOrApp:"eller","paypal.processingPayment":"Behandlar betalning \u2026",generateQRCode:"Generera QR-kod","await.waitForConfirmation":"V\xe4ntar p\xe5 bekr\xe4ftelse","mbway.confirmPayment":"Bekr\xe4fta din betalning i appen MB WAY","shopperEmail.invalid":"Ogiltig e-postadress","dateOfBirth.format":"DD/MM/\xc5\xc5\xc5\xc5","dateOfBirth.invalid":"Du m\xe5ste vara minst 18 \xe5r","blik.confirmPayment":"\xd6ppna din bankapp f\xf6r att bekr\xe4fta betalningen.","blik.invalid":"Ange 6 siffror","blik.code":"Sexsiffrig kod","blik.help":"H\xe4mta koden fr\xe5n din bankapp.","swish.pendingMessage":"N\xe4r du har skannat kan statusen vara v\xe4ntande i upp till tio minuter. Att f\xf6rs\xf6ka betala igen inom denna tid kan leda till flera debiteringar.","field.valid":"F\xe4ltet \xe4r giltigt","field.invalid":"F\xe4ltet ogiltigt","error.va.gen.01":"Ofullst\xe4ndigt f\xe4lt","error.va.gen.02":"F\xe4ltet ogiltigt","error.va.sf-cc-num.01":"Kortnumret \xe4r inte giltigt","error.va.sf-cc-num.02":"F\xe4ltet f\xf6r kortnummer \xe4r tomt","error.va.sf-cc-num.03":"Det angivna kortnumret st\xf6ds inte","error.va.sf-cc-num.04":"Kortnumret har fel l\xe4ngd","error.va.sf-cc-dat.01":"Utg\xe5ngsdatum: kortet \xe4r f\xf6r gammalt","error.va.sf-cc-dat.02":"Utg\xe5ngsdatum: datumet ligger f\xf6r l\xe5ngt fram i tiden","error.va.sf-cc-dat.03":"Utg\xe5ngsdatum: ditt kort g\xe5r ut f\xf6re utcheckningsdatum","error.va.sf-cc-dat.04":"F\xe4ltet f\xf6r utg\xe5ngsdatum \xe4r tomt","error.va.sf-cc-dat.05":"Utg\xe5ngsdatumet har fel l\xe4ngd","error.va.sf-cc-mth.01":"F\xe4ltet f\xf6r utg\xe5ngsm\xe5nad \xe4r tomt","error.va.sf-cc-yr.01":"F\xe4ltet f\xf6r utg\xe5ngs\xe5r \xe4r tomt","error.va.sf-cc-yr.02":"Utg\xe5ngs\xe5ret har fel l\xe4ngd","error.va.sf-cc-cvc.01":"F\xe4ltet f\xf6r s\xe4kerhetskod \xe4r tomt","error.va.sf-cc-cvc.02":"S\xe4kerhetskoden har fel l\xe4ngd","error.va.sf-ach-num.01":"F\xe4ltet f\xf6r bankkontonummer \xe4r tomt","error.va.sf-ach-num.02":"Bankkontonumret har fel l\xe4ngd","error.va.sf-ach-loc.01":"F\xe4ltet f\xf6r clearingnummer \xe4r tomt","error.va.sf-ach-loc.02":"Clearingnumret har fel l\xe4ngd","error.va.sf-kcp-pwd.01":"F\xe4ltet f\xf6r l\xf6senord \xe4r tomt","error.va.sf-kcp-pwd.02":"L\xf6senordet har fel l\xe4ngd","error.giftcard.no-balance":"Saldot f\xf6r detta presentkort \xe4r noll","error.giftcard.card-error":"Vi har inte registrerat n\xe5got presentkort med det numret","error.giftcard.currency-error":"Presentkort \xe4r endast giltiga i den valuta som de utf\xe4rdades i","amazonpay.signout":"Logga ut fr\xe5n Amazon","amazonpay.changePaymentDetails":"\xc4ndra betalningsuppgifter","partialPayment.warning":"V\xe4lj ett annat betalningss\xe4tt f\xf6r att betala det \xe5terst\xe5ende","partialPayment.remainingBalance":"\xc5terst\xe5ende saldo blir %{amount}","bankTransfer.beneficiary":"Mottagare","bankTransfer.iban":"IBAN","bankTransfer.bic":"BIC","bankTransfer.reference":"referens","bankTransfer.introduction":"Forts\xe4tt f\xf6r att skapa en ny bank\xf6verf\xf6ring. Du kan anv\xe4nda informationen p\xe5 f\xf6ljande sk\xe4rm f\xf6r att slutf\xf6ra denna betalning.","bankTransfer.instructions":"Tack f\xf6r ditt k\xf6p! Anv\xe4nd f\xf6ljande information f\xf6r att slutf\xf6ra din betalning.","bacs.accountHolderName":"Bankkontoinnehavarens namn","bacs.accountHolderName.invalid":"Ogiltigt namn p\xe5 bankkontoinnehavare","bacs.accountNumber":"Bankkontonummer","bacs.accountNumber.invalid":"Ogiltigt bankkontonummer","bacs.bankLocationId":"Clearingnummer","bacs.bankLocationId.invalid":"Ogiltigt clearingnummer","bacs.consent.amount":"Jag godk\xe4nner att ovanst\xe5ende belopp dras fr\xe5n mitt bankkonto.","bacs.consent.account":"Jag bekr\xe4ftar att jag \xe4r kontoinnehavare och att jag \xe4r den enda person vars godk\xe4nnande kr\xe4vs f\xf6r att auktorisera autogiro fr\xe5n detta konto.",edit:"Redigera","bacs.confirm":"Bekr\xe4fta och betala","bacs.result.introduction":"Ladda ner din instruktion f\xf6r autogiro/direktdebitering (DDI / Mandate)","download.pdf":"Ladda ner PDF","creditCard.encryptedCardNumber.aria.iframeTitle":"Iframe f\xf6r s\xe4krat kortnummer","creditCard.encryptedCardNumber.aria.label":"Kortnummer","creditCard.encryptedExpiryDate.aria.iframeTitle":"Iframe f\xf6r s\xe4krat utg\xe5ngsdatum f\xf6r kort","creditCard.encryptedExpiryDate.aria.label":"Utg\xe5ngsdatum","creditCard.encryptedExpiryMonth.aria.iframeTitle":"Iframe f\xf6r s\xe4krad utg\xe5ngsm\xe5nad f\xf6r kort","creditCard.encryptedExpiryMonth.aria.label":"Utg\xe5ngsm\xe5nad","creditCard.encryptedExpiryYear.aria.iframeTitle":"Iframe f\xf6r s\xe4krat utg\xe5ngs\xe5r f\xf6r kort","creditCard.encryptedExpiryYear.aria.label":"Utg\xe5ngs\xe5r","creditCard.encryptedSecurityCode.aria.iframeTitle":"Iframe f\xf6r s\xe4krad s\xe4kerhetskod f\xf6r kort","creditCard.encryptedSecurityCode.aria.label":"S\xe4kerhetskod","creditCard.encryptedPassword.aria.iframeTitle":"Iframe f\xf6r s\xe4krat kortl\xf6senord","creditCard.encryptedPassword.aria.label":"De tv\xe5 f\xf6rsta siffrorna i kortets l\xf6senord","giftcard.encryptedCardNumber.aria.iframeTitle":"Iframe f\xf6r s\xe4krat presentkortsnummer","giftcard.encryptedCardNumber.aria.label":"Presentkortsnummer","giftcard.encryptedSecurityCode.aria.iframeTitle":"Iframe f\xf6r s\xe4krad s\xe4kerhetskod f\xf6r presentkort","giftcard.encryptedSecurityCode.aria.label":"S\xe4kerhetskod f\xf6r presentkort",giftcardTransactionLimit:"Maximalt %{amount} per transaktion \xe4r till\xe5tet p\xe5 detta presentkort","ach.encryptedBankAccountNumber.aria.iframeTitle":"Iframe f\xf6r s\xe4krat bankkontonummer","ach.encryptedBankAccountNumber.aria.label":"Bankkonto","ach.encryptedBankLocationId.aria.iframeTitle":"Iframe f\xf6r s\xe4krat clearingnummer","ach.encryptedBankLocationId.aria.label":"Clearingnummer","twint.saved":"sparat",orPayWith:"eller betala med",invalidFormatExpects:"Ogiltigt format. F\xf6rv\xe4ntat format: %{format}","upi.qrCodeWaitingMessage":"Skanna QR-koden med valfri UPI-app f\xf6r att slutf\xf6ra betalningen","upi.vpaWaitingMessage":"\xd6ppna din UPI-app f\xf6r att bekr\xe4fta betalningen","upi.modeSelection":"V\xe4lj hur du vill anv\xe4nda UPI.","onlineBanking.termsAndConditions":"Genom att forts\xe4tta godk\xe4nner du %#villkoren%#","ctp.loading.poweredByCtp":"Drivs av Click to Pay","ctp.loading.intro":"Vi kontrollerar om du har n\xe5gra sparade kort med Click to Pay...","ctp.login.title":"Forts\xe4tt till Click to Pay","ctp.login.subtitle":"Ange den e-postadress som \xe4r ansluten till Click to Pay f\xf6r att forts\xe4tta.","ctp.login.inputLabel":"E-postadress","ctp.logout.notYou":"Inte du?","ctp.logout.notYourCards":"Inte dina kort?","ctp.logout.notYourCard":"Inte ditt kort?","ctp.logout.notYourProfile":"Inte din profil?","ctp.otp.fieldLabel":"Eng\xe5ngskod","ctp.otp.resendCode":"Skicka koden igen","ctp.otp.codeResent":"Koden skickad igen","ctp.otp.title":"F\xe5 tillg\xe5ng till dina Click to Pay-kort","ctp.otp.subtitle":"Ange koden som %@ skickade till %@ f\xf6r att verifiera att det \xe4r du.","ctp.emptyProfile.message":"Inga kort registrerade i denna Click to Pay-profil","ctp.separatorText":"eller anv\xe4nd","ctp.cards.title":"Slutf\xf6r betalningen med Click to Pay","ctp.cards.subtitle":"V\xe4lj ett kort att anv\xe4nda.","ctp.cards.expiredCard":"Utg\xe5ngna","ctp.manualCardEntry":"Manuell kortinmatning","ctp.aria.infoModalButton":"Vad \xe4r Click to Pay?","ctp.infoPopup.title":"Click to Pay \u2013 lika enkelt som kontaktl\xf6s betalning, fast online","ctp.infoPopup.subtitle":"En snabb och s\xe4ker betalningsmetod som st\xf6ds av Mastercard, Visa och andra betalkort.","ctp.infoPopup.benefit1":"Click to Pay anv\xe4nder kryptering f\xf6r att h\xe5lla din information s\xe4ker och trygg","ctp.infoPopup.benefit2":"Anv\xe4nd den hos handlare \xf6ver hela v\xe4rlden","ctp.infoPopup.benefit3":"Konfigurera en g\xe5ng f\xf6r problemfria betalningar i framtiden","ctp.errors.AUTH_INVALID":"Autentisering ogiltig","ctp.errors.NOT_FOUND":"Inget konto hittades, ange en giltig e-postadress eller forts\xe4tt med manuell kortinmatning","ctp.errors.ID_FORMAT_UNSUPPORTED":"Formatet st\xf6ds inte","ctp.errors.FRAUD":"Anv\xe4ndarkontot var l\xe5st eller inaktiverat","ctp.errors.CONSUMER_ID_MISSING":"Konsumentidentitet saknas i beg\xe4ran","ctp.errors.ACCT_INACCESSIBLE":"Det h\xe4r kontot \xe4r f\xf6r n\xe4rvarande inte tillg\xe4ngligt, det kanske \xe4r l\xe5st","ctp.errors.CODE_INVALID":"Felaktig verifieringskod","ctp.errors.CODE_EXPIRED":"Denna kod har g\xe5tt ut","ctp.errors.RETRIES_EXCEEDED":"Gr\xe4nsen f\xf6r antalet f\xf6rs\xf6k till OTP-generering har \xf6verskridits","ctp.errors.OTP_SEND_FAILED":"OTP kunde inte skickas till mottagaren","ctp.errors.REQUEST_TIMEOUT":"N\xe5got gick fel, f\xf6rs\xf6k igen eller anv\xe4nd den manuella kortinmatningen","ctp.errors.UNKNOWN_ERROR":"N\xe5got gick fel, f\xf6rs\xf6k igen eller anv\xe4nd manuell kortinmatning","ctp.errors.SERVICE_ERROR":"N\xe5got gick fel, f\xf6rs\xf6k igen eller anv\xe4nd manuell kortinmatning","ctp.errors.SERVER_ERROR":"N\xe5got gick fel, f\xf6rs\xf6k igen eller anv\xe4nd manuell kortinmatning","ctp.errors.INVALID_PARAMETER":"N\xe5got gick fel, f\xf6rs\xf6k igen eller anv\xe4nd manuell kortinmatning","ctp.errors.AUTH_ERROR":"N\xe5got gick fel, f\xf6rs\xf6k igen eller anv\xe4nd manuell kortinmatning","paymentMethodsList.aria.label":"V\xe4lj en betalningsmetod"}}),U3=Object.freeze({__proto__:null,default:{payButton:"\u652f\u4ed8","payButton.redirecting":"\u6b63\u5728\u91cd\u5b9a\u5411...","payButton.with":"\u4f7f\u7528 %{maskedData} \u652f\u4ed8 %{value}",close:"\u5173\u95ed",storeDetails:"\u4fdd\u5b58\u4ee5\u4fbf\u4e0b\u6b21\u652f\u4ed8\u4f7f\u7528","creditCard.holderName":"\u5361\u7247\u4e0a\u7684\u59d3\u540d","creditCard.holderName.placeholder":"J. Smith","creditCard.holderName.invalid":"\u65e0\u6548\u7684\u6301\u5361\u4eba\u59d3\u540d","creditCard.numberField.title":"\u5361\u53f7","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"\u6709\u6548\u671f","creditCard.expiryDateField.placeholder":"\u6708\u6708/\u5e74\u5e74","creditCard.expiryDateField.month":"\u6708","creditCard.expiryDateField.month.placeholder":"\u6708\u6708","creditCard.expiryDateField.year.placeholder":"\u5e74\u5e74","creditCard.expiryDateField.year":"\u5e74","creditCard.cvcField.title":"CVC / CVV","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"\u8bb0\u4f4f\u4ee5\u4fbf\u4e0b\u6b21\u4f7f\u7528","creditCard.cvcField.placeholder.4digits":"4 \u4f4d\u6570","creditCard.cvcField.placeholder.3digits":"3 \u4f4d\u6570","creditCard.taxNumber.placeholder":"\u5e74\u6708\u65e5 / 0123456789",installments:"\u5206\u671f\u4ed8\u6b3e\u671f\u6570",installmentOption:"%{times}x %{partialValue}",installmentOptionMonths:"%{times} \u4e2a\u6708","installments.oneTime":"\u5168\u6b3e\u652f\u4ed8","installments.installments":"\u5206\u671f\u652f\u4ed8","installments.revolving":"\u5faa\u73af\u652f\u4ed8","sepaDirectDebit.ibanField.invalid":"\u65e0\u6548\u7684\u8d26\u53f7","sepaDirectDebit.nameField.placeholder":"J. Smith","sepa.ownerName":"\u6301\u5361\u4eba\u59d3\u540d","sepa.ibanNumber":"\u8d26\u53f7 (IBAN)","error.title":"\u9519\u8bef","error.subtitle.redirect":"\u91cd\u5b9a\u5411\u5931\u8d25","error.subtitle.payment":"\u652f\u4ed8\u5931\u8d25","error.subtitle.refused":"\u652f\u4ed8\u88ab\u62d2","error.message.unknown":"\u53d1\u751f\u672a\u77e5\u9519\u8bef","errorPanel.title":"\u73b0\u6709\u9519\u8bef","idealIssuer.selectField.title":"\u94f6\u884c","idealIssuer.selectField.placeholder":"\u9009\u62e9\u60a8\u7684\u94f6\u884c","creditCard.success":"\u652f\u4ed8\u6210\u529f",loading:"\u6b63\u5728\u52a0\u8f7d...",continue:"\u7ee7\u7eed",continueTo:"\u7ee7\u7eed\u81f3","wechatpay.timetopay":"\u60a8\u9700\u8981\u652f\u4ed8 %@","wechatpay.scanqrcode":"\u626b\u63cf\u4e8c\u7ef4\u7801",personalDetails:"\u4e2a\u4eba\u8be6\u7ec6\u4fe1\u606f",companyDetails:"\u516c\u53f8\u8be6\u60c5","companyDetails.name":"\u516c\u53f8\u540d\u79f0","companyDetails.registrationNumber":"\u6ce8\u518c\u53f7",socialSecurityNumber:"\u793e\u4f1a\u4fdd\u9669\u53f7\u7801",firstName:"\u540d\u5b57","firstName.invalid":"\u540d\u5b57\u65e0\u6548",infix:"\u524d\u7f00",lastName:"\u59d3\u6c0f","lastName.invalid":"\u59d3\u6c0f\u65e0\u6548",mobileNumber:"\u624b\u673a\u53f7","mobileNumber.invalid":"\u65e0\u6548\u7684\u624b\u673a\u53f7\u7801",city:"\u57ce\u5e02",postalCode:"\u90ae\u653f\u7f16\u7801","postalCode.optional":"\u90ae\u653f\u7f16\u7801\uff08\u53ef\u9009\uff09",countryCode:"\u56fd\u5bb6\u4ee3\u7801",telephoneNumber:"\u7535\u8bdd\u53f7\u7801",dateOfBirth:"\u51fa\u751f\u65e5\u671f",shopperEmail:"\u7535\u5b50\u90ae\u4ef6\u5730\u5740",gender:"\u6027\u522b",male:"\u7537",female:"\u5973",billingAddress:"\u8d26\u5355\u5730\u5740",street:"\u8857\u9053",stateOrProvince:"\u5dde\u6216\u7701",country:"\u56fd\u5bb6/\u5730\u533a",houseNumberOrName:"\u95e8\u724c\u53f7",separateDeliveryAddress:"\u6307\u5b9a\u4e00\u4e2a\u5355\u72ec\u7684\u5bc4\u9001\u5730\u5740",deliveryAddress:"\u5bc4\u9001\u5730\u5740",zipCode:"\u90ae\u653f\u7f16\u7801",apartmentSuite:"\u516c\u5bd3 / \u5957\u623f",provinceOrTerritory:"\u7701\u6216\u5730\u533a",cityTown:"\u5e02 / \u9547",address:"\u5730\u5740",state:"\u5dde","field.title.optional":"\uff08\u53ef\u9009\uff09","creditCard.cvcField.title.optional":"CVC / CVV\uff08\u53ef\u9009\uff09","issuerList.wallet.placeholder":"\u9009\u62e9\u60a8\u7684\u94b1\u5305",privacyPolicy:"\u9690\u79c1\u653f\u7b56","afterPay.agreement":"\u6211\u540c\u610f AfterPay \u7684 %@",paymentConditions:"\u652f\u4ed8\u6761\u4ef6",openApp:"\u6253\u5f00\u5e94\u7528","voucher.readInstructions":"\u9605\u8bfb\u8bf4\u660e","voucher.introduction":"\u611f\u8c22\u60a8\u7684\u8d2d\u4e70\uff0c\u8bf7\u4f7f\u7528\u4ee5\u4e0b\u4f18\u60e0\u5238\u5b8c\u6210\u652f\u4ed8\u3002","voucher.expirationDate":"\u6709\u6548\u671f","voucher.alternativeReference":"\u5907\u9009\u4ee3\u7801","dragonpay.voucher.non.bank.selectField.placeholder":"\u9009\u62e9\u60a8\u7684\u63d0\u4f9b\u5546","dragonpay.voucher.bank.selectField.placeholder":"\u9009\u62e9\u60a8\u7684\u94f6\u884c","voucher.paymentReferenceLabel":"\u4ea4\u6613\u53f7","voucher.surcharge":"\u5305\u62ec %@ \u7684\u9644\u52a0\u8d39","voucher.introduction.doku":"\u611f\u8c22\u60a8\u7684\u8d2d\u4e70\uff0c\u8bf7\u4f7f\u7528\u4ee5\u4e0b\u4fe1\u606f\u5b8c\u6210\u652f\u4ed8\u3002","voucher.shopperName":"\u987e\u5ba2\u59d3\u540d","voucher.merchantName":"\u5546\u6237","voucher.introduction.econtext":"\u611f\u8c22\u60a8\u7684\u8d2d\u4e70\uff0c\u8bf7\u4f7f\u7528\u4ee5\u4e0b\u4fe1\u606f\u5b8c\u6210\u652f\u4ed8\u3002","voucher.telephoneNumber":"\u7535\u8bdd\u53f7\u7801","voucher.shopperReference":"\u987e\u5ba2\u53c2\u8003","voucher.collectionInstitutionNumber":"\u6536\u6b3e\u673a\u6784\u7f16\u53f7","voucher.econtext.telephoneNumber.invalid":"\u7535\u8bdd\u53f7\u7801\u5fc5\u987b\u4e3a 10 \u6216 11 \u4f4d\u6570\u5b57","boletobancario.btnLabel":"\u751f\u6210 Boleto","boleto.sendCopyToEmail":"\u5c06\u526f\u672c\u53d1\u9001\u5230\u6211\u7684\u7535\u5b50\u90ae\u7bb1","button.copy":"\u590d\u5236","button.download":"\u4e0b\u8f7d","boleto.socialSecurityNumber.invalid":"\u5b57\u6bb5\u65e0\u6548","creditCard.storedCard.description.ariaLabel":"\u5b58\u50a8\u7684\u5361\u7247\u4ee5 \uff05@ \u7ed3\u5c3e","voucher.entity":"\u5b9e\u4f53",donateButton:"\u6350\u8d60",notNowButton:"\u6682\u4e0d",thanksForYourSupport:"\u611f\u8c22\u60a8\u7684\u652f\u6301\uff01",preauthorizeWith:"\u9884\u5148\u6388\u6743",confirmPreauthorization:"\u786e\u8ba4\u9884\u5148\u6388\u6743",confirmPurchase:"\u786e\u8ba4\u8d2d\u4e70",applyGiftcard:"\u5151\u6362",giftcardBalance:"\u793c\u54c1\u5361\u4f59\u989d",deductedBalance:"\u6263\u51cf\u4f59\u989d","creditCard.pin.title":"Pin","creditCard.encryptedPassword.label":"\u5361\u7247\u5bc6\u7801\u7684\u524d 2 \u4f4d\u6570","creditCard.encryptedPassword.invalid":"\u65e0\u6548\u7684\u5bc6\u7801","creditCard.taxNumber":"\u6301\u5361\u4eba\u751f\u65e5\u6216\u516c\u53f8\u6ce8\u518c\u53f7","creditCard.taxNumber.label":"\u6301\u5361\u4eba\u751f\u65e5 (YYMMDD) \u6216\u516c\u53f8\u6ce8\u518c\u53f7\uff0810 \u4f4d\u6570\uff09","creditCard.taxNumber.labelAlt":"\u516c\u53f8\u6ce8\u518c\u53f7\uff0810 \u4f4d\u6570\uff09","creditCard.taxNumber.invalid":"\u65e0\u6548\u7684\u6301\u5361\u4eba\u751f\u65e5\u6216\u516c\u53f8\u6ce8\u518c\u53f7","storedPaymentMethod.disable.button":"\u5220\u9664","storedPaymentMethod.disable.confirmation":"\u5220\u9664\u5b58\u50a8\u7684\u652f\u4ed8\u65b9\u5f0f","storedPaymentMethod.disable.confirmButton":"\u662f\uff0c\u5220\u9664","storedPaymentMethod.disable.cancelButton":"\u53d6\u6d88","ach.bankAccount":"\u94f6\u884c\u8d26\u6237","ach.accountHolderNameField.title":"\u8d26\u6237\u6301\u6709\u4eba\u59d3\u540d","ach.accountHolderNameField.placeholder":"J. Smith","ach.accountHolderNameField.invalid":"\u65e0\u6548\u7684\u8d26\u6237\u6301\u6709\u4eba\u59d3\u540d","ach.accountNumberField.title":"\u8d26\u53f7","ach.accountNumberField.invalid":"\u65e0\u6548\u7684\u8d26\u53f7","ach.accountLocationField.title":"ABA \u8def\u7531\u7535\u6c47\u7f16\u7801","ach.accountLocationField.invalid":"\u65e0\u6548\u7684 ABA \u8def\u7531\u7535\u6c47\u7f16\u7801","ach.savedBankAccount":"\u5df2\u4fdd\u5b58\u7684\u94f6\u884c\u8d26\u6237","select.state":"\u9009\u62e9\u5dde","select.stateOrProvince":"\u9009\u62e9\u5dde\u6216\u7701","select.provinceOrTerritory":"\u9009\u62e9\u7701\u6216\u5730\u533a","select.country":"\u9009\u62e9\u56fd\u5bb6/\u5730\u533a","select.noOptionsFound":"\u672a\u627e\u5230\u4efb\u4f55\u9009\u9879","select.filter.placeholder":"\u641c\u7d22\u2026\u2026","telephoneNumber.invalid":"\u65e0\u6548\u7684\u7535\u8bdd\u53f7\u7801",qrCodeOrApp:"\u6216\u8005","paypal.processingPayment":"\u6b63\u5728\u5904\u7406\u4ed8\u6b3e...",generateQRCode:"\u751f\u6210\u4e8c\u7ef4\u7801","await.waitForConfirmation":"\u7b49\u5f85\u786e\u8ba4","mbway.confirmPayment":"\u5728 MB WAY \u5e94\u7528\u4e0a\u786e\u8ba4\u60a8\u7684\u4ed8\u6b3e","shopperEmail.invalid":"\u65e0\u6548\u7684\u90ae\u4ef6\u5730\u5740","dateOfBirth.format":"DD/MM/YYYY","dateOfBirth.invalid":"\u60a8\u5fc5\u987b\u5e74\u6ee1 18 \u5468\u5c81","blik.confirmPayment":"\u6253\u5f00\u60a8\u7684\u94f6\u884c\u5e94\u7528\u4ee5\u786e\u8ba4\u652f\u4ed8\u3002","blik.invalid":"\u8f93\u5165 6 \u4f4d\u6570","blik.code":"6 \u4f4d\u6570\u4ee3\u7801","blik.help":"\u4ece\u60a8\u7684\u94f6\u884c\u5e94\u7528\u4e2d\u83b7\u53d6\u4ee3\u7801\u3002","swish.pendingMessage":"\u626b\u63cf\u540e\uff0c\u72b6\u6001\u53ef\u80fd\u4f1a\u4fdd\u6301\u6700\u591a 10 \u5206\u949f\u3002\u5728\u6b64\u65f6\u95f4\u5185\u518d\u6b21\u5c1d\u8bd5\u4ed8\u6b3e\u53ef\u80fd\u4f1a\u5bfc\u81f4\u591a\u6b21\u6536\u8d39\u3002","field.valid":"\u5b57\u6bb5\u6709\u6548","field.invalid":"\u65e0\u6548\u5b57\u6bb5","error.va.gen.01":"\u4e0d\u5b8c\u6574\u5b57\u6bb5","error.va.gen.02":"\u65e0\u6548\u5b57\u6bb5","error.va.sf-cc-num.01":"\u5361\u53f7\u65e0\u6548","error.va.sf-cc-num.02":"\u5361\u53f7\u5b57\u6bb5\u4e3a\u7a7a","error.va.sf-cc-num.03":"\u4e0d\u652f\u6301\u8f93\u5165\u7684\u5361\u53f7","error.va.sf-cc-num.04":"\u5361\u53f7\u957f\u5ea6\u4e0d\u6b63\u786e","error.va.sf-cc-dat.01":"\u5230\u671f\u65e5\u671f\uff1a\u5361\u592a\u65e7","error.va.sf-cc-dat.02":"\u5230\u671f\u65e5\u671f\uff1a\u672a\u6765\u65e5\u671f\u592a\u8fdc","error.va.sf-cc-dat.03":"\u5230\u671f\u65e5\u671f\uff1a\u60a8\u7684\u7247\u5728\u7ed3\u8d26\u65e5\u671f\u524d\u5df2\u8fc7\u671f","error.va.sf-cc-dat.04":"\u5230\u671f\u65e5\u671f\u5b57\u6bb5\u4e3a\u7a7a","error.va.sf-cc-dat.05":"\u5230\u671f\u65e5\u671f\u957f\u5ea6\u4e0d\u6b63\u786e","error.va.sf-cc-mth.01":"\u5230\u671f\u6708\u4efd\u5b57\u6bb5\u4e3a\u7a7a","error.va.sf-cc-yr.01":"\u5230\u671f\u5e74\u4efd\u5b57\u6bb5\u4e3a\u7a7a","error.va.sf-cc-yr.02":"\u5230\u671f\u5e74\u4efd\u957f\u5ea6\u4e0d\u6b63\u786e","error.va.sf-cc-cvc.01":"\u5b89\u5168\u4ee3\u7801\u5b57\u6bb5\u4e3a\u7a7a","error.va.sf-cc-cvc.02":"\u5b89\u5168\u4ee3\u7801\u957f\u5ea6\u9519\u8bef","error.va.sf-ach-num.01":"\u94f6\u884c\u8d26\u53f7\u5b57\u6bb5\u4e3a\u7a7a","error.va.sf-ach-num.02":"\u94f6\u884c\u8d26\u53f7\u957f\u5ea6\u4e0d\u6b63\u786e","error.va.sf-ach-loc.01":"\u94f6\u884c\u8def\u7531\u53f7\u7801\u5b57\u6bb5\u4e3a\u7a7a","error.va.sf-ach-loc.02":"\u94f6\u884c\u8def\u7531\u53f7\u7801\u957f\u5ea6\u4e0d\u6b63\u786e","error.va.sf-kcp-pwd.01":"\u5bc6\u7801\u5b57\u6bb5\u4e3a\u7a7a","error.va.sf-kcp-pwd.02":"\u5bc6\u7801\u957f\u5ea6\u4e0d\u6b63\u786e","error.giftcard.no-balance":"\u793c\u54c1\u5361\u4f59\u989d\u4e3a\u96f6","error.giftcard.card-error":"\u6211\u4eec\u7684\u6570\u636e\u5e93\u4e2d\u6ca1\u6709\u8fd9\u4e2a\u53f7\u7801\u7684\u793c\u54c1\u5361","error.giftcard.currency-error":"\u793c\u54c1\u5361\u4ec5\u4ee5\u5176\u53d1\u884c\u7684\u8d27\u5e01\u4e3a\u6709\u6548\u8d27\u5e01","amazonpay.signout":"\u9000\u51fa Amazon","amazonpay.changePaymentDetails":"\u66f4\u6539\u652f\u4ed8\u8be6\u60c5","partialPayment.warning":"\u8bf7\u9009\u62e9\u5176\u4ed6\u652f\u4ed8\u65b9\u5f0f\u652f\u4ed8\u5269\u4f59\u6b3e\u9879","partialPayment.remainingBalance":"\u5269\u4f59\u989d\u5ea6\u4e3a %{amount}","bankTransfer.beneficiary":"\u6536\u6b3e\u4eba","bankTransfer.iban":"IBAN","bankTransfer.bic":"\u4e2d\u56fd\u5de5\u5546\u94f6\u884c","bankTransfer.reference":"\u53c2\u8003","bankTransfer.introduction":"\u7ee7\u7eed\u65b0\u5efa\u94f6\u884c\u8f6c\u8d26\u4ed8\u6b3e\u3002\u60a8\u53ef\u4ee5\u4f7f\u7528\u4ee5\u4e0b\u5c4f\u5e55\u4e2d\u7684\u8be6\u7ec6\u4fe1\u606f\u6765\u5b8c\u6210\u8fd9\u7b14\u4ed8\u6b3e\u3002","bankTransfer.instructions":"\u611f\u8c22\u60a8\u7684\u8d2d\u4e70\uff0c\u8bf7\u4f7f\u7528\u4ee5\u4e0b\u4fe1\u606f\u5b8c\u6210\u652f\u4ed8\u3002","bacs.accountHolderName":"\u94f6\u884c\u8d26\u6237\u6301\u6709\u4eba\u59d3\u540d","bacs.accountHolderName.invalid":"\u65e0\u6548\u7684\u94f6\u884c\u8d26\u6237\u6301\u6709\u4eba\u59d3\u540d","bacs.accountNumber":"\u94f6\u884c\u8d26\u53f7","bacs.accountNumber.invalid":"\u65e0\u6548\u7684\u94f6\u884c\u8d26\u53f7","bacs.bankLocationId":"\u5206\u7c7b\u4ee3\u7801","bacs.bankLocationId.invalid":"\u65e0\u6548\u7684\u5206\u7c7b\u4ee3\u7801","bacs.consent.amount":"\u6211\u540c\u610f\u4ece\u94f6\u884c\u8d26\u6237\u4e2d\u6263\u9664\u4e0a\u8ff0\u91d1\u989d\u3002","bacs.consent.account":"\u6211\u786e\u8ba4\u8be5\u8d26\u6237\u4e3a\u6211\u540d\u4e0b\u7684\u8d26\u6237\uff0c\u5e76\u4e14\u6211\u662f\u6388\u6743\u8be5\u8d26\u6237\u76f4\u63a5\u501f\u8bb0\u7684\u552f\u4e00\u7b7e\u7f72\u4eba\u3002",edit:"\u7f16\u8f91","bacs.confirm":"\u786e\u8ba4\u5e76\u652f\u4ed8","bacs.result.introduction":"\u4e0b\u8f7d\u60a8\u7684\u76f4\u63a5\u501f\u8bb0\u6307\u793a\uff08DDI/\u59d4\u6258\uff09","download.pdf":"\u4e0b\u8f7d PDF \u6587\u4ef6","creditCard.encryptedCardNumber.aria.iframeTitle":"\u5b89\u5168\u5361\u53f7 Iframe","creditCard.encryptedCardNumber.aria.label":"\u5361\u53f7","creditCard.encryptedExpiryDate.aria.iframeTitle":"\u5b89\u5168\u5361\u7247\u8fc7\u671f\u65e5\u671f Iframe","creditCard.encryptedExpiryDate.aria.label":"\u6709\u6548\u671f","creditCard.encryptedExpiryMonth.aria.iframeTitle":"\u5b89\u5168\u5361\u7247\u8fc7\u671f\u6708\u4efd Iframe","creditCard.encryptedExpiryMonth.aria.label":"\u8fc7\u671f\u6708\u4efd","creditCard.encryptedExpiryYear.aria.iframeTitle":"\u5b89\u5168\u5361\u7247\u8fc7\u671f\u5e74\u4efd Iframe","creditCard.encryptedExpiryYear.aria.label":"\u8fc7\u671f\u5e74\u4efd","creditCard.encryptedSecurityCode.aria.iframeTitle":"\u5b89\u5168\u5361\u7247\u5b89\u5168\u7801 Iframe","creditCard.encryptedSecurityCode.aria.label":"\u5b89\u5168\u7801","creditCard.encryptedPassword.aria.iframeTitle":"\u7528\u4e8e\u5b89\u5168\u5361\u5bc6\u7801\u7684 Iframe","creditCard.encryptedPassword.aria.label":"\u5361\u7247\u5bc6\u7801\u7684\u524d 2 \u4f4d\u6570","giftcard.encryptedCardNumber.aria.iframeTitle":"\u5b89\u5168\u793c\u54c1\u5361\u53f7 Iframe","giftcard.encryptedCardNumber.aria.label":"\u793c\u54c1\u5361\u53f7","giftcard.encryptedSecurityCode.aria.iframeTitle":"\u5b89\u5168\u793c\u54c1\u5361\u5b89\u5168\u7801 Iframe","giftcard.encryptedSecurityCode.aria.label":"\u793c\u54c1\u5361\u5b89\u5168\u7801",giftcardTransactionLimit:"\u6b64\u793c\u54c1\u5361\u4e0a\u6bcf\u7b14\u4ea4\u6613\u5141\u8bb8\u7684\u6700\u5927\u91d1\u989d\u4e3a %{amount}","ach.encryptedBankAccountNumber.aria.iframeTitle":"\u5b89\u5168\u94f6\u884c\u8d26\u53f7 Iframe","ach.encryptedBankAccountNumber.aria.label":"\u94f6\u884c\u8d26\u6237","ach.encryptedBankLocationId.aria.iframeTitle":"\u5b89\u5168\u94f6\u884c\u8def\u7531\u7535\u6c47\u7f16\u7801 Iframe","ach.encryptedBankLocationId.aria.label":"\u94f6\u884c\u8def\u7531\u7535\u6c47\u7f16\u7801","twint.saved":"\u5df2\u4fdd\u5b58",orPayWith:"\u6216\u4f7f\u7528\u4ee5\u4e0b\u65b9\u5f0f\u652f\u4ed8",invalidFormatExpects:"\u65e0\u6548\u7684\u683c\u5f0f\u3002\u9884\u671f\u683c\u5f0f\uff1a%{format}","upi.qrCodeWaitingMessage":"\u4f7f\u7528\u60a8\u9996\u9009\u7684 UPI \u5e94\u7528\u626b\u63cf\u4e8c\u7ef4\u7801\u4ee5\u5b8c\u6210\u4ed8\u6b3e","upi.vpaWaitingMessage":"\u6253\u5f00\u60a8\u7684 UPI \u5e94\u7528\u4ee5\u786e\u8ba4\u4ed8\u6b3e","upi.modeSelection":"\u8bf7\u9009\u62e9\u60a8\u5e0c\u671b\u5982\u4f55\u4f7f\u7528 UPI\u3002","onlineBanking.termsAndConditions":"\u7ee7\u7eed\uff0c\u5373\u8868\u793a\u60a8\u540c\u610f%#\u6761\u6b3e\u548c\u7ec6\u5219%#","ctp.loading.poweredByCtp":"\u7531 Click to Pay \u63d0\u4f9b\u6280\u672f\u652f\u6301","ctp.loading.intro":"\u6211\u4eec\u6b63\u5728\u68c0\u67e5\u60a8\u662f\u5426\u62e5\u6709\u4efb\u4f55\u901a\u8fc7 Click to Pay \u4fdd\u5b58\u7684\u5361\u7247\u2026","ctp.login.title":"\u7ee7\u7eed\u4f7f\u7528 Click to Pay \u529f\u80fd","ctp.login.subtitle":"\u8f93\u5165\u5173\u8054\u81f3 Click to Pay \u7684\u7535\u5b50\u90ae\u4ef6\u5730\u5740\u4ee5\u7ee7\u7eed\u3002","ctp.login.inputLabel":"\u7535\u5b50\u90ae\u4ef6","ctp.logout.notYou":"\u4e0d\u662f\u60a8\u672c\u4eba\uff1f","ctp.logout.notYourCards":"\u4e0d\u662f\u60a8\u7684\u5361\uff1f","ctp.logout.notYourCard":"\u4e0d\u662f\u60a8\u7684\u5361\u7247\uff1f","ctp.logout.notYourProfile":"\u4e0d\u662f\u60a8\u7684\u4e2a\u4eba\u8d44\u6599\uff1f","ctp.otp.fieldLabel":"\u4e00\u6b21\u6027\u4ee3\u7801","ctp.otp.resendCode":"\u91cd\u65b0\u53d1\u9001\u4ee3\u7801","ctp.otp.codeResent":"\u4ee3\u7801\u5df2\u91cd\u65b0\u53d1\u9001","ctp.otp.title":"\u8bbf\u95ee\u60a8\u7684 Click to Pay \u5361","ctp.otp.subtitle":"\u8bf7\u8f93\u5165\u6211\u4eec\u53d1\u9001\u81f3 %@ \u7684\u4ee3\u7801 (%@)\uff0c\u4ee5\u9a8c\u8bc1\u662f\u60a8\u672c\u4eba\u3002","ctp.emptyProfile.message":"\u6b64 Click to Pay \u4e2a\u4eba\u8d44\u6599\u4e2d\u5c1a\u672a\u6ce8\u518c\u4efb\u4f55\u5361\u7247","ctp.separatorText":"\u6216\u4f7f\u7528","ctp.cards.title":"\u501f\u52a9 Click to Pay \u5b8c\u6210\u4ed8\u6b3e","ctp.cards.subtitle":"\u9009\u62e9\u8981\u4f7f\u7528\u7684\u5361\u7247\u3002","ctp.cards.expiredCard":"\u5df2\u8fc7\u671f","ctp.manualCardEntry":"\u624b\u52a8\u5361\u7247\u5f55\u5165","ctp.aria.infoModalButton":"\u4ec0\u4e48\u662f Click to Pay","ctp.infoPopup.title":"Click to Pay \u5e26\u6765\u975e\u63a5\u89e6\u5f0f\u7684\u5728\u7ebf\u4fbf\u6377\u4f53\u9a8c","ctp.infoPopup.subtitle":"Mastercard\u3001Visa \u548c\u5176\u4ed6\u652f\u4ed8\u5361\u652f\u6301\u7684\u5feb\u901f\u3001\u5b89\u5168\u7684\u652f\u4ed8\u65b9\u5f0f\u3002","ctp.infoPopup.benefit1":"Click to Pay \u4f7f\u7528\u52a0\u5bc6\u6280\u672f\uff0c\u786e\u4fdd\u60a8\u7684\u4fe1\u606f\u5b89\u5168","ctp.infoPopup.benefit2":"\u4e0e\u5168\u7403\u5546\u6237\u4e00\u8d77\u4f7f\u7528","ctp.infoPopup.benefit3":"\u8bbe\u7f6e\u4e00\u6b21\uff0c\u652f\u4ed8\u65e0\u5fe7","ctp.errors.AUTH_INVALID":"\u8eab\u4efd\u9a8c\u8bc1\u65e0\u6548","ctp.errors.NOT_FOUND":"\u672a\u627e\u5230\u5e10\u6237\uff0c\u8bf7\u8f93\u5165\u6709\u6548\u7684\u7535\u5b50\u90ae\u4ef6\u6216\u7ee7\u7eed\u4f7f\u7528\u624b\u52a8\u5361\u7247\u8f93\u5165","ctp.errors.ID_FORMAT_UNSUPPORTED":"\u4e0d\u652f\u6301\u683c\u5f0f","ctp.errors.FRAUD":"\u7528\u6237\u8d26\u6237\u5df2\u9501\u5b9a\u6216\u7981\u7528","ctp.errors.CONSUMER_ID_MISSING":"\u8bf7\u6c42\u4e2d\u7f3a\u5c11\u4f7f\u7528\u8005\u6807\u8bc6","ctp.errors.ACCT_INACCESSIBLE":"\u6b64\u5e10\u6237\u5f53\u524d\u4e0d\u53ef\u7528\uff08\u4f8b\u5982\uff0c\u5df2\u9501\u5b9a\uff09","ctp.errors.CODE_INVALID":"\u9a8c\u8bc1\u7801\u4e0d\u6b63\u786e","ctp.errors.CODE_EXPIRED":"\u6b64\u4ee3\u7801\u5df2\u8fc7\u671f","ctp.errors.RETRIES_EXCEEDED":"\u5df2\u8d85\u51fa OTP \u751f\u6210\u7684\u91cd\u8bd5\u6b21\u6570\u9650\u5236","ctp.errors.OTP_SEND_FAILED":"OTP \u65e0\u6cd5\u53d1\u9001\u81f3\u6536\u4ef6\u4eba","ctp.errors.REQUEST_TIMEOUT":"\u53d1\u751f\u9519\u8bef\uff0c\u8bf7\u91cd\u8bd5\u6216\u4f7f\u7528\u624b\u52a8\u5361\u7247\u8f93\u5165","ctp.errors.UNKNOWN_ERROR":"\u53d1\u751f\u9519\u8bef\uff0c\u8bf7\u91cd\u8bd5\u6216\u4f7f\u7528\u624b\u52a8\u5361\u7247\u8f93\u5165","ctp.errors.SERVICE_ERROR":"\u53d1\u751f\u9519\u8bef\uff0c\u8bf7\u91cd\u8bd5\u6216\u4f7f\u7528\u624b\u52a8\u5361\u7247\u8f93\u5165","ctp.errors.SERVER_ERROR":"\u53d1\u751f\u9519\u8bef\uff0c\u8bf7\u91cd\u8bd5\u6216\u4f7f\u7528\u624b\u52a8\u5361\u7247\u8f93\u5165","ctp.errors.INVALID_PARAMETER":"\u53d1\u751f\u9519\u8bef\uff0c\u8bf7\u91cd\u8bd5\u6216\u4f7f\u7528\u624b\u52a8\u5361\u7247\u8f93\u5165","ctp.errors.AUTH_ERROR":"\u53d1\u751f\u9519\u8bef\uff0c\u8bf7\u91cd\u8bd5\u6216\u4f7f\u7528\u624b\u52a8\u5361\u7247\u8f93\u5165","paymentMethodsList.aria.label":"\u9009\u62e9\u652f\u4ed8\u65b9\u5f0f"}}),K3=Object.freeze({__proto__:null,default:{payButton:"\u652f\u4ed8","payButton.redirecting":"\u91cd\u65b0\u5c0e\u5411\u4e2d......","payButton.with":"\u7528 %{maskedData} \u652f\u4ed8 %{value}",close:"\u95dc\u9589",storeDetails:"\u5132\u5b58\u4ee5\u4f9b\u4e0b\u6b21\u4ed8\u6b3e\u4f7f\u7528","creditCard.holderName":"\u4fe1\u7528\u5361\u4e0a\u7684\u59d3\u540d","creditCard.holderName.placeholder":"J. Smith","creditCard.holderName.invalid":"\u6301\u5361\u4eba\u59d3\u540d\u7121\u6548","creditCard.numberField.title":"\u4fe1\u7528\u5361\u865f\u78bc","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"\u5230\u671f\u65e5\u671f","creditCard.expiryDateField.placeholder":"MM/YY","creditCard.expiryDateField.month":"\u6708\u4efd","creditCard.expiryDateField.month.placeholder":"MM","creditCard.expiryDateField.year.placeholder":"YY","creditCard.expiryDateField.year":"\u5e74\u4efd","creditCard.cvcField.title":"\u4fe1\u7528\u5361\u9a57\u8b49\u78bc / \u4fe1\u7528\u5361\u5b89\u5168\u78bc","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"\u8a18\u4f4f\u4f9b\u4e0b\u6b21\u4f7f\u7528","creditCard.cvcField.placeholder.4digits":"4 \u4f4d\u6578","creditCard.cvcField.placeholder.3digits":"3 \u4f4d\u6578","creditCard.taxNumber.placeholder":"\u5e74\u6708\u65e5\uff0f0123456789",installments:"\u5206\u671f\u4ed8\u6b3e\u7684\u671f\u6578",installmentOption:"%{times}x %{partialValue}",installmentOptionMonths:"%{times} \u500b\u6708","installments.oneTime":"\u4e00\u6b21\u6027\u4ed8\u6b3e","installments.installments":"\u5206\u671f\u4ed8\u6b3e","installments.revolving":"\u5ef6\u671f\u4ed8\u6b3e","sepaDirectDebit.ibanField.invalid":"\u5e33\u6236\u865f\u78bc\u7121\u6548","sepaDirectDebit.nameField.placeholder":"J. Smith","sepa.ownerName":"\u6301\u6709\u4eba\u540d\u7a31","sepa.ibanNumber":"\u5e33\u6236\u865f\u78bc (IBAN)","error.title":"\u932f\u8aa4","error.subtitle.redirect":"\u7121\u6cd5\u91cd\u65b0\u5c0e\u5411","error.subtitle.payment":"\u4ed8\u6b3e\u5931\u6557","error.subtitle.refused":"\u4ed8\u6b3e\u906d\u62d2\u7d55","error.message.unknown":"\u767c\u751f\u672a\u77e5\u932f\u8aa4","errorPanel.title":"\u73fe\u6709\u932f\u8aa4","idealIssuer.selectField.title":"\u9280\u884c","idealIssuer.selectField.placeholder":"\u9078\u53d6\u60a8\u7684\u9280\u884c","creditCard.success":"\u4ed8\u6b3e\u6210\u529f",loading:"\u6b63\u5728\u8f09\u5165...",continue:"\u7e7c\u7e8c",continueTo:"\u7e7c\u7e8c\u524d\u5f80","wechatpay.timetopay":"\u60a8\u6709 %@ \u53ef\u4ee5\u652f\u4ed8","wechatpay.scanqrcode":"\u6383\u63cf QR \u4ee3\u78bc",personalDetails:"\u500b\u4eba\u8a73\u7d30\u8cc7\u6599",companyDetails:"\u516c\u53f8\u8a73\u60c5","companyDetails.name":"\u516c\u53f8\u540d\u7a31","companyDetails.registrationNumber":"\u8a3b\u518a\u865f\u78bc",socialSecurityNumber:"\u793e\u6703\u5b89\u5168\u78bc",firstName:"\u540d\u5b57","firstName.invalid":"\u540d\u5b57\u7121\u6548",infix:"\u524d\u7db4",lastName:"\u59d3\u6c0f","lastName.invalid":"\u59d3\u6c0f\u7121\u6548",mobileNumber:"\u884c\u52d5\u96fb\u8a71\u865f\u78bc","mobileNumber.invalid":"\u624b\u6a5f\u865f\u78bc\u7121\u6548",city:"\u57ce\u5e02",postalCode:"\u90f5\u905e\u5340\u865f","postalCode.optional":"\u90f5\u905e\u5340\u865f\uff08\u9078\u7528\uff09",countryCode:"\u570b\u5bb6\u4ee3\u78bc",telephoneNumber:"\u96fb\u8a71\u865f\u78bc",dateOfBirth:"\u51fa\u751f\u65e5\u671f",shopperEmail:"\u96fb\u5b50\u90f5\u4ef6\u5730\u5740",gender:"\u6027\u5225",male:"\u7537",female:"\u5973",billingAddress:"\u5e33\u55ae\u5730\u5740",street:"\u8857\u9053",stateOrProvince:"\u5dde/\u7e23/\u5e02",country:"\u570b\u5bb6/\u5730\u5340",houseNumberOrName:"\u9580\u724c\u865f",separateDeliveryAddress:"\u6307\u5b9a\u53e6\u4e00\u500b\u6d3e\u9001\u5730\u5740",deliveryAddress:"\u6d3e\u9001\u5730\u5740",zipCode:"\u90f5\u905e\u5340\u865f",apartmentSuite:"\u516c\u5bd3\uff0f\u5957\u623f",provinceOrTerritory:"\u7701\u6216\u5730\u5340",cityTown:"\u5e02\uff0f\u93ae",address:"\u5730\u5740",state:"\u5dde","field.title.optional":"\uff08\u9078\u7528\uff09","creditCard.cvcField.title.optional":"CVC / CVV (\u53ef\u9078)","issuerList.wallet.placeholder":"\u9078\u53d6\u60a8\u7684\u96fb\u5b50\u9322\u5305",privacyPolicy:"\u96b1\u79c1\u6b0a\u653f\u7b56","afterPay.agreement":"\u6211\u540c\u610f AfterPay \u7684%@",paymentConditions:"\u4ed8\u6b3e\u7d30\u5247",openApp:"\u958b\u555f\u61c9\u7528\u7a0b\u5f0f","voucher.readInstructions":"\u95b1\u89bd\u8aaa\u660e","voucher.introduction":"\u591a\u8b1d\u60e0\u9867\uff0c\u8acb\u4f7f\u7528\u4ee5\u4e0b\u512a\u60e0\u5238\u5b8c\u6210\u4ed8\u6b3e\u3002","voucher.expirationDate":"\u5230\u671f\u65e5\u671f","voucher.alternativeReference":"\u5099\u9078\u53c3\u7167","dragonpay.voucher.non.bank.selectField.placeholder":"\u9078\u64c7\u60a8\u7684\u4f9b\u61c9\u5546","dragonpay.voucher.bank.selectField.placeholder":"\u9078\u53d6\u60a8\u7684\u9280\u884c","voucher.paymentReferenceLabel":"\u4ed8\u6b3e\u53c3\u7167\u865f\u78bc","voucher.surcharge":"\u5305\u542b %@ \u9644\u52a0\u8cbb","voucher.introduction.doku":"\u591a\u8b1d\u60e0\u9867\uff0c\u8acb\u4f7f\u7528\u4ee5\u4e0b\u8cc7\u8a0a\u5b8c\u6210\u4ed8\u6b3e\u3002","voucher.shopperName":"\u8cfc\u7269\u8005\u59d3\u540d","voucher.merchantName":"\u5546\u5bb6","voucher.introduction.econtext":"\u591a\u8b1d\u60e0\u9867\uff0c\u8acb\u4f7f\u7528\u4ee5\u4e0b\u8cc7\u8a0a\u5b8c\u6210\u4ed8\u6b3e\u3002","voucher.telephoneNumber":"\u96fb\u8a71\u865f\u78bc","voucher.shopperReference":"\u8cfc\u7269\u8005\u53c3\u8003","voucher.collectionInstitutionNumber":"\u6536\u6b3e\u6a5f\u69cb\u7de8\u865f","voucher.econtext.telephoneNumber.invalid":"\u96fb\u8a71\u865f\u78bc\u7684\u9577\u5ea6\u5fc5\u9808\u70ba 10 \u6216 11 \u4f4d\u6578","boletobancario.btnLabel":"\u7522\u751f Boleto","boleto.sendCopyToEmail":"\u5c07\u8907\u672c\u50b3\u9001\u81f3\u6211\u7684\u96fb\u5b50\u90f5\u4ef6","button.copy":"\u8907\u88fd","button.download":"\u4e0b\u8f09","boleto.socialSecurityNumber.invalid":"\u6b04\u4f4d\u7121\u6548","creditCard.storedCard.description.ariaLabel":"\u5df2\u5132\u5b58\u4ee5 %@ \u7d50\u5c3e\u7684\u4fe1\u7528\u5361","voucher.entity":"\u5be6\u9ad4",donateButton:"\u6350\u8d08",notNowButton:"\u7a0d\u5f8c\u518d\u8aaa",thanksForYourSupport:"\u611f\u8b1d\u60a8\u7684\u652f\u6301\uff01",preauthorizeWith:"\u900f\u904e\u4ee5\u4e0b\u65b9\u5f0f\u9032\u884c\u9810\u5148\u6388\u6b0a\uff1a",confirmPreauthorization:"\u78ba\u8a8d\u9810\u5148\u6388\u6b0a",confirmPurchase:"\u78ba\u8a8d\u8cfc\u8cb7",applyGiftcard:"\u514c\u63db",giftcardBalance:"\u79ae\u54c1\u5361\u9918\u984d",deductedBalance:"\u6263\u9664\u9918\u984d","creditCard.pin.title":"\u6578\u5b57\u5bc6\u78bc","creditCard.encryptedPassword.label":"\u5361\u5bc6\u78bc\u7684\u524d 2 \u4f4d\u6578\u5b57","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"\u5bc6\u78bc\u7121\u6548","creditCard.taxNumber":"\u6301\u5361\u4eba\u751f\u65e5\u6216\u516c\u53f8\u8a3b\u518a\u865f\u78bc","creditCard.taxNumber.label":"\u6301\u5361\u4eba\u751f\u65e5\uff08\u5e74\u6708\u65e5\uff09\u6216\u516c\u53f8\u8a3b\u518a\u865f\u78bc\uff0810 \u4f4d\u6578\uff09","creditCard.taxNumber.labelAlt":"\u516c\u53f8\u8a3b\u518a\u865f\u78bc\uff0810 \u4f4d\u6578\uff09","creditCard.taxNumber.invalid":"\u6301\u5361\u4eba\u751f\u65e5\u6216\u516c\u53f8\u8a3b\u518a\u865f\u78bc\u7121\u6548","storedPaymentMethod.disable.button":"\u79fb\u9664","storedPaymentMethod.disable.confirmation":"\u79fb\u9664\u5df2\u5132\u5b58\u4ed8\u6b3e\u65b9\u5f0f","storedPaymentMethod.disable.confirmButton":"\u662f\uff0c\u8acb\u79fb\u9664","storedPaymentMethod.disable.cancelButton":"\u53d6\u6d88","ach.bankAccount":"\u9280\u884c\u5e33\u6236","ach.accountHolderNameField.title":"\u5e33\u6236\u6301\u6709\u4eba\u59d3\u540d","ach.accountHolderNameField.placeholder":"J. Smith","ach.accountHolderNameField.invalid":"\u5e33\u6236\u6301\u6709\u4eba\u59d3\u540d\u7121\u6548","ach.accountNumberField.title":"\u5e33\u6236\u865f\u78bc","ach.accountNumberField.invalid":"\u5e33\u6236\u865f\u78bc\u7121\u6548","ach.accountLocationField.title":"ABA \u532f\u6b3e\u8def\u5f91\u7de8\u865f","ach.accountLocationField.invalid":"ABA \u532f\u6b3e\u8def\u5f91\u7de8\u865f\u7121\u6548","ach.savedBankAccount":"\u5132\u5b58\u7684\u9280\u884c\u5e33\u6236","select.state":"\u9078\u53d6\u5dde","select.stateOrProvince":"\u9078\u64c7\u5dde\u6216\u7701","select.provinceOrTerritory":"\u9078\u53d6\u7701\u6216\u5730\u5340","select.country":"\u9078\u64c7\u570b\u5bb6\uff0f\u5730\u5340","select.noOptionsFound":"\u627e\u4e0d\u5230\u4efb\u4f55\u9078\u9805","select.filter.placeholder":"\u641c\u5c0b\u2026\u2026","telephoneNumber.invalid":"\u96fb\u8a71\u865f\u78bc\u7121\u6548",qrCodeOrApp:"\u6216","paypal.processingPayment":"\u6b63\u5728\u8655\u7406\u4ed8\u6b3e\u2026\u2026",generateQRCode:"\u7522\u751f QR \u4ee3\u78bc","await.waitForConfirmation":"\u6b63\u5728\u7b49\u5019\u78ba\u8a8d","mbway.confirmPayment":"\u5728 MB WAY \u61c9\u7528\u7a0b\u5f0f\u4e0a\u78ba\u8a8d\u60a8\u7684\u4ed8\u6b3e","shopperEmail.invalid":"\u96fb\u5b50\u90f5\u4ef6\u5730\u5740\u7121\u6548","dateOfBirth.format":"\u65e5\uff0f\u6708\uff0f\u5e74","dateOfBirth.invalid":"\u60a8\u5fc5\u9808\u5e74\u6eff 18 \u6b72","blik.confirmPayment":"\u958b\u555f\u60a8\u7684\u9280\u884c\u61c9\u7528\u7a0b\u5f0f\u4ee5\u78ba\u8a8d\u4ed8\u6b3e\u3002","blik.invalid":"\u8f38\u5165 6 \u500b\u6578\u5b57","blik.code":"6 \u4f4d\u6578\u4ee3\u78bc","blik.help":"\u5f9e\u60a8\u7684\u9280\u884c\u61c9\u7528\u7a0b\u5f0f\u4e2d\u7372\u53d6\u4ee3\u78bc\u3002","swish.pendingMessage":"\u6383\u63cf\u5f8c\uff0c\u8a72\u5f85\u5b8c\u6210\u72c0\u614b\u53ef\u80fd\u6301\u7e8c\u9577\u9054 10 \u5206\u9418\u3002\u8a66\u5716\u5728\u9019\u6bb5\u6642\u9593\u5167\u518d\u6b21\u4ed8\u6b3e\u53ef\u80fd\u6703\u5c0e\u81f4\u591a\u91cd\u6536\u8cbb\u3002","field.valid":"\u6b04\u4f4d\u6709\u6548","field.invalid":"\u6b04\u4f4d\u7121\u6548","error.va.gen.01":"\u4e0d\u5b8c\u6574\u6b04\u4f4d","error.va.gen.02":"\u6b04\u4f4d\u7121\u6548","error.va.sf-cc-num.01":"\u5361\u865f\u7121\u6548","error.va.sf-cc-num.02":"\u5361\u865f\u6b04\u4f4d\u73fe\u70ba\u7a7a\u767d","error.va.sf-cc-num.03":"\u4e0d\u652f\u63f4\u6240\u8f38\u5165\u7684\u5361\u865f","error.va.sf-cc-num.04":"\u5361\u865f\u9577\u5ea6\u6709\u8aa4","error.va.sf-cc-dat.01":"\u5230\u671f\u65e5\uff1a\u5361\u592a\u820a","error.va.sf-cc-dat.02":"\u5230\u671f\u65e5\uff1a\u672a\u4f86\u65e5\u671f\u8ddd\u4eca\u592a\u4e45","error.va.sf-cc-dat.03":"\u5230\u671f\u65e5\uff1a\u60a8\u7684\u5361\u5728\u4ed8\u6b3e\u65e5\u671f\u524d\u5230\u671f","error.va.sf-cc-dat.04":"\u5230\u671f\u65e5\u6b04\u4f4d\u73fe\u70ba\u7a7a\u767d","error.va.sf-cc-dat.05":"\u5230\u671f\u65e5\u9577\u5ea6\u6709\u8aa4","error.va.sf-cc-mth.01":"\u5230\u671f\u6708\u4efd\u6b04\u4f4d\u73fe\u70ba\u7a7a\u767d","error.va.sf-cc-yr.01":"\u5230\u671f\u5e74\u4efd\u6b04\u4f4d\u73fe\u70ba\u7a7a\u767d","error.va.sf-cc-yr.02":"\u5230\u671f\u5e74\u4efd\u9577\u5ea6\u6709\u8aa4","error.va.sf-cc-cvc.01":"\u5b89\u5168\u78bc\u6b04\u4f4d\u73fe\u70ba\u7a7a\u767d","error.va.sf-cc-cvc.02":"\u5b89\u5168\u78bc\u9577\u5ea6\u6709\u8aa4","error.va.sf-ach-num.01":"\u9280\u884c\u5e33\u6236\u865f\u78bc\u6b04\u4f4d\u73fe\u70ba\u7a7a\u767d","error.va.sf-ach-num.02":"\u9280\u884c\u5e33\u6236\u865f\u78bc\u9577\u5ea6\u6709\u8aa4","error.va.sf-ach-loc.01":"\u9280\u884c\u532f\u6b3e\u8def\u5f91\u7de8\u865f\u6b04\u4f4d\u73fe\u70ba\u7a7a\u767d","error.va.sf-ach-loc.02":"\u9280\u884c\u532f\u6b3e\u8def\u5f91\u7de8\u865f\u9577\u5ea6\u6709\u8aa4","error.va.sf-kcp-pwd.01":"\u5bc6\u78bc\u6b04\u4f4d\u73fe\u70ba\u7a7a\u767d","error.va.sf-kcp-pwd.02":"\u5bc6\u78bc\u9577\u5ea6\u6709\u8aa4","error.giftcard.no-balance":"\u6b64\u79ae\u54c1\u5361\u7684\u9918\u984d\u70ba\u96f6","error.giftcard.card-error":"\u6211\u5011\u7684\u8a18\u9304\u4e2d\u4e26\u6c92\u6709\u9019\u500b\u865f\u78bc\u7684\u79ae\u54c1\u5361","error.giftcard.currency-error":"\u79ae\u54c1\u5361\u53ea\u80fd\u4ee5\u5176\u7c3d\u767c\u6642\u6240\u4f7f\u7528\u7684\u8ca8\u5e63\u9032\u884c\u7d50\u7b97","amazonpay.signout":"\u5f9e Amazon \u767b\u51fa","amazonpay.changePaymentDetails":"\u8b8a\u66f4\u4ed8\u6b3e\u660e\u7d30","partialPayment.warning":"\u9078\u53d6\u5176\u4ed6\u4ed8\u6b3e\u65b9\u5f0f\u4f86\u652f\u4ed8\u9918\u984d","partialPayment.remainingBalance":"\u9918\u984d\u5c07\u70ba %{amount}","bankTransfer.beneficiary":"\u53d7\u6b3e\u4eba","bankTransfer.iban":"IBAN","bankTransfer.bic":"BIC","bankTransfer.reference":"\u53c3\u7167","bankTransfer.introduction":"\u7e7c\u7e8c\u5efa\u7acb\u65b0\u7684\u9280\u884c\u8f49\u5e33\u4ed8\u6b3e\u3002\u60a8\u53ef\u4ee5\u4f7f\u7528\u4ee5\u4e0b\u87a2\u5e55\u4e2d\u7684\u8a73\u7d30\u8cc7\u8a0a\u4f86\u5b8c\u6210\u6b64\u9805\u4ed8\u6b3e\u3002","bankTransfer.instructions":"\u591a\u8b1d\u60e0\u9867\uff0c\u8acb\u4f7f\u7528\u4ee5\u4e0b\u8cc7\u8a0a\u5b8c\u6210\u4ed8\u6b3e\u3002","bacs.accountHolderName":"\u9280\u884c\u5e33\u6236\u6301\u6709\u4eba\u59d3\u540d","bacs.accountHolderName.invalid":"\u9280\u884c\u5e33\u6236\u6301\u6709\u4eba\u59d3\u540d\u7121\u6548","bacs.accountNumber":"\u9280\u884c\u5e33\u6236\u865f\u78bc","bacs.accountNumber.invalid":"\u9280\u884c\u5e33\u6236\u865f\u78bc\u7121\u6548","bacs.bankLocationId":"\u9280\u884c\u4ee3\u78bc","bacs.bankLocationId.invalid":"\u9280\u884c\u4ee3\u78bc\u7121\u6548","bacs.consent.amount":"\u6211\u540c\u610f\u5f9e\u6211\u7684\u9280\u884c\u5e33\u6236\u6263\u9664\u4e0a\u8ff0\u91d1\u984d\u3002","bacs.consent.account":"\u6211\u78ba\u8a8d\u8a72\u5e33\u6236\u4ee5\u6211\u7684\u540d\u7fa9\u958b\u8a2d\uff0c\u4e26\u4e14\u6211\u662f\u6388\u6b0a\u5f9e\u8a72\u5e33\u6236\u76f4\u63a5\u6263\u6b3e\u7684\u552f\u4e00\u7c3d\u7f72\u4eba\u3002",edit:"\u7de8\u8f2f","bacs.confirm":"\u78ba\u8a8d\u4e26\u652f\u4ed8","bacs.result.introduction":"\u4e0b\u8f09\u60a8\u7684\u76f4\u63a5\u6263\u6b3e\u6307\u793a\uff08DDI\uff0f\u6388\u6b0a\uff09","download.pdf":"\u4e0b\u8f09 PDF","creditCard.encryptedCardNumber.aria.iframeTitle":"\u5b89\u5168\u5361\u865f\u7684 IFrame","creditCard.encryptedCardNumber.aria.label":"\u4fe1\u7528\u5361\u865f\u78bc","creditCard.encryptedExpiryDate.aria.iframeTitle":"\u5b89\u5168\u5361\u5230\u671f\u65e5\u671f\u7684 IFrame","creditCard.encryptedExpiryDate.aria.label":"\u5230\u671f\u65e5\u671f","creditCard.encryptedExpiryMonth.aria.iframeTitle":"\u5b89\u5168\u5361\u5230\u671f\u6708\u4efd\u7684 IFrame","creditCard.encryptedExpiryMonth.aria.label":"\u5230\u671f\u6708\u4efd","creditCard.encryptedExpiryYear.aria.iframeTitle":"\u5b89\u5168\u5361\u5230\u671f\u5e74\u4efd\u7684 IFrame","creditCard.encryptedExpiryYear.aria.label":"\u5230\u671f\u5e74\u4efd","creditCard.encryptedSecurityCode.aria.iframeTitle":"\u5b89\u5168\u5361\u5b89\u5168\u78bc\u7684 IFrame","creditCard.encryptedSecurityCode.aria.label":"\u5b89\u5168\u78bc","creditCard.encryptedPassword.aria.iframeTitle":"\u5b89\u5168\u5361\u5bc6\u78bc\u7684 IFrame","creditCard.encryptedPassword.aria.label":"\u5361\u5bc6\u78bc\u7684\u524d 2 \u4f4d\u6578\u5b57","giftcard.encryptedCardNumber.aria.iframeTitle":"\u5b89\u5168\u79ae\u54c1\u5361\u865f\u7684 IFrame","giftcard.encryptedCardNumber.aria.label":"\u79ae\u54c1\u5361\u865f","giftcard.encryptedSecurityCode.aria.iframeTitle":"\u5b89\u5168\u79ae\u54c1\u5361\u5b89\u5168\u78bc\u7684 IFrame","giftcard.encryptedSecurityCode.aria.label":"\u79ae\u54c1\u5361\u5b89\u5168\u78bc",giftcardTransactionLimit:"\u6b64\u79ae\u54c1\u5361\u6bcf\u7b46\u4ea4\u6613\u7684\u91d1\u984d\u4e0a\u9650\u70ba %{amount}","ach.encryptedBankAccountNumber.aria.iframeTitle":"\u5b89\u5168\u9280\u884c\u5e33\u6236\u865f\u78bc\u7684 IFrame","ach.encryptedBankAccountNumber.aria.label":"\u9280\u884c\u5e33\u6236","ach.encryptedBankLocationId.aria.iframeTitle":"\u5b89\u5168\u9280\u884c\u532f\u6b3e\u8def\u5f91\u7de8\u865f\u7684 IFrame","ach.encryptedBankLocationId.aria.label":"\u9280\u884c\u532f\u6b3e\u8def\u5f91\u7de8\u865f","twint.saved":"\u5132\u5b58\u7684",orPayWith:"\u6216\u900f\u904e\u4ee5\u4e0b\u65b9\u5f0f\u652f\u4ed8\uff1a",invalidFormatExpects:"\u683c\u5f0f\u7121\u6548\u3002\u683c\u5f0f\u5fc5\u9808\u70ba\uff1a%{format}","upi.qrCodeWaitingMessage":"\u4f7f\u7528\u60a8\u504f\u597d\u7684 UPI \u61c9\u7528\u7a0b\u5f0f\u6383\u63cf QR \u4ee3\u78bc\u4ee5\u5b8c\u6210\u4ed8\u6b3e","upi.vpaWaitingMessage":"\u958b\u555f\u60a8\u7684 UPI \u61c9\u7528\u7a0b\u5f0f\u4ee5\u78ba\u8a8d\u4ed8\u6b3e","upi.modeSelection":"\u9078\u64c7\u6240\u9700\u7684 UPI \u4f7f\u7528\u65b9\u5f0f\u3002","onlineBanking.termsAndConditions":"\u7e7c\u7e8c\u64cd\u4f5c\u5373\u8868\u793a\u60a8\u540c\u610f%#\u689d\u6b3e\u53ca\u7d30\u5247%#","ctp.loading.poweredByCtp":"\u7531 Click to Pay \u63d0\u4f9b\u6280\u8853\u652f\u63f4","ctp.loading.intro":"\u6211\u5011\u6b63\u5728\u6aa2\u67e5\u60a8\u662f\u5426\u6709\u4efb\u4f55\u4f9b Click to Pay \u4f7f\u7528\u7684\u5df2\u5132\u5b58\u5361\u2026\u2026","ctp.login.title":"\u7e7c\u7e8c\u4f7f\u7528 Click to Pay","ctp.login.subtitle":"\u8f38\u5165\u9023\u63a5\u5230 Click to Pay \u7684\u96fb\u5b50\u90f5\u4ef6\u5730\u5740\u4ee5\u7e7c\u7e8c\u3002","ctp.login.inputLabel":"\u96fb\u5b50\u90f5\u4ef6","ctp.logout.notYou":"\u4e0d\u662f\u60a8\u672c\u4eba\uff1f","ctp.logout.notYourCards":"\u4e0d\u662f\u60a8\u7684\u5361\uff1f","ctp.logout.notYourCard":"\u4e0d\u662f\u60a8\u7684\u5361\uff1f","ctp.logout.notYourProfile":"\u4e0d\u662f\u60a8\u7684\u500b\u4eba\u8cc7\u6599\uff1f","ctp.otp.fieldLabel":"\u4e00\u6b21\u6027\u9a57\u8b49\u78bc","ctp.otp.resendCode":"\u91cd\u65b0\u50b3\u9001\u9a57\u8b49\u78bc","ctp.otp.codeResent":"\u5df2\u91cd\u65b0\u50b3\u9001\u9a57\u8b49\u78bc","ctp.otp.title":"\u5b58\u53d6\u60a8\u7684 Click to Pay \u5361","ctp.otp.subtitle":"\u8acb\u8f38\u5165\u6211\u5011\u50b3\u9001\u81f3 %@ \u7684\u9a57\u8b49\u78bc %@\uff0c\u4ee5\u9a57\u8b49\u662f\u60a8\u672c\u4eba\u3002","ctp.emptyProfile.message":"\u6b64 Click to Pay \u500b\u4eba\u8cc7\u6599\u4e2d\u672a\u8a3b\u518a\u4efb\u4f55\u5361","ctp.separatorText":"\u6216\u4f7f\u7528","ctp.cards.title":"\u4f7f\u7528 Click to Pay \u5b8c\u6210\u4ed8\u6b3e","ctp.cards.subtitle":"\u9078\u53d6\u8981\u4f7f\u7528\u7684\u5361\u3002","ctp.cards.expiredCard":"\u5df2\u904e\u671f","ctp.manualCardEntry":"\u624b\u52d5\u5361\u8f38\u5165","ctp.aria.infoModalButton":"\u4ec0\u9ebc\u662f Click to Pay","ctp.infoPopup.title":"Click to Pay \u63d0\u4f9b\u4fbf\u6377\u7684\u7dda\u4e0a\u975e\u63a5\u89f8\u5f0f\u652f\u4ed8\u65b9\u5f0f","ctp.infoPopup.subtitle":"Mastercard\u3001Visa \u548c\u5176\u4ed6\u652f\u4ed8\u5361\u652f\u63f4\u7684\u5b89\u5168\u5feb\u6377\u652f\u4ed8\u65b9\u5f0f\u3002","ctp.infoPopup.benefit1":"Click to Pay \u4f7f\u7528\u52a0\u5bc6\u6280\u8853\uff0c\u78ba\u4fdd\u60a8\u7684\u8cc7\u6599\u5b89\u5168\u7121\u865e","ctp.infoPopup.benefit2":"\u8207\u5168\u7403\u5546\u5bb6\u4e00\u8d77\u4f7f\u7528","ctp.infoPopup.benefit3":"\u53ea\u9700\u8a2d\u5b9a\u4e00\u6b21\uff0c\u5373\u53ef\u8f15\u9b06\u652f\u4ed8","ctp.errors.AUTH_INVALID":"\u9a57\u8b49\u7121\u6548","ctp.errors.NOT_FOUND":"\u627e\u4e0d\u5230\u5e33\u6236\uff0c\u8acb\u8f38\u5165\u6709\u6548\u7684\u96fb\u5b50\u90f5\u4ef6\u6216\u7e7c\u7e8c\u624b\u52d5\u8f38\u5165\u5361\u8cc7\u6599","ctp.errors.ID_FORMAT_UNSUPPORTED":"\u4e0d\u652f\u63f4\u6b64\u683c\u5f0f","ctp.errors.FRAUD":"\u4f7f\u7528\u8005\u5e33\u6236\u5df2\u9396\u5b9a\u6216\u505c\u7528","ctp.errors.CONSUMER_ID_MISSING":"\u8acb\u6c42\u4e2d\u907a\u6f0f\u53d6\u7528\u8005\u8eab\u4efd\u8b58\u5225","ctp.errors.ACCT_INACCESSIBLE":"\u76ee\u524d\u7121\u6cd5\u4f7f\u7528\u6b64\u5e33\u6236\uff0c\u4f8b\u5982\u5df2\u9396\u5b9a","ctp.errors.CODE_INVALID":"\u9a57\u8b49\u78bc\u6709\u8aa4","ctp.errors.CODE_EXPIRED":"\u6b64\u9a57\u8b49\u78bc\u5df2\u904e\u671f","ctp.errors.RETRIES_EXCEEDED":"\u8d85\u51fa\u4e86\u7522\u751f OTP \u7684\u91cd\u8a66\u6b21\u6578\u4e0a\u9650","ctp.errors.OTP_SEND_FAILED":"OTP \u7121\u6cd5\u50b3\u9001\u7d66\u6536\u4ef6\u8005","ctp.errors.REQUEST_TIMEOUT":"\u51fa\u4e86\u4e00\u4e9b\u554f\u984c\uff0c\u8acb\u91cd\u8a66\u6216\u624b\u52d5\u8f38\u5165\u5361\u8cc7\u6599","ctp.errors.UNKNOWN_ERROR":"\u51fa\u4e86\u4e00\u4e9b\u554f\u984c\uff0c\u8acb\u91cd\u8a66\u6216\u624b\u52d5\u8f38\u5165\u5361\u8cc7\u6599","ctp.errors.SERVICE_ERROR":"\u51fa\u4e86\u4e00\u4e9b\u554f\u984c\uff0c\u8acb\u91cd\u8a66\u6216\u624b\u52d5\u8f38\u5165\u5361\u8cc7\u6599","ctp.errors.SERVER_ERROR":"\u51fa\u4e86\u4e00\u4e9b\u554f\u984c\uff0c\u8acb\u91cd\u8a66\u6216\u624b\u52d5\u8f38\u5165\u5361\u8cc7\u6599","ctp.errors.INVALID_PARAMETER":"\u51fa\u4e86\u4e00\u4e9b\u554f\u984c\uff0c\u8acb\u91cd\u8a66\u6216\u624b\u52d5\u8f38\u5165\u5361\u8cc7\u6599","ctp.errors.AUTH_ERROR":"\u51fa\u4e86\u4e00\u4e9b\u554f\u984c\uff0c\u8acb\u91cd\u8a66\u6216\u624b\u52d5\u8f38\u5165\u5361\u8cc7\u6599","paymentMethodsList.aria.label":"\u9078\u64c7\u4ed8\u6b3e\u65b9\u5f0f"}});return function(e){return g3.apply(this,arguments)}}));


}).call(this)}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"_process":127}],108:[function(require,module,exports){
var _typeof = require("./typeof.js")["default"];
function _regeneratorRuntime() {
  "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  module.exports = _regeneratorRuntime = function _regeneratorRuntime() {
    return exports;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  var exports = {},
    Op = Object.prototype,
    hasOwn = Op.hasOwnProperty,
    defineProperty = Object.defineProperty || function (obj, key, desc) {
      obj[key] = desc.value;
    },
    $Symbol = "function" == typeof Symbol ? Symbol : {},
    iteratorSymbol = $Symbol.iterator || "@@iterator",
    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }
  try {
    define({}, "");
  } catch (err) {
    define = function define(obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
      generator = Object.create(protoGenerator.prototype),
      context = new Context(tryLocsList || []);
    return defineProperty(generator, "_invoke", {
      value: makeInvokeMethod(innerFn, self, context)
    }), generator;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ("throw" !== record.type) {
        var result = record.arg,
          value = result.value;
        return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    defineProperty(this, "_invoke", {
      value: function value(method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(innerFn, self, context) {
    var state = "suspendedStart";
    return function (method, arg) {
      if ("executing" === state) throw new Error("Generator is already running");
      if ("completed" === state) {
        if ("throw" === method) throw arg;
        return doneResult();
      }
      for (context.method = method, context.arg = arg;;) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
          if ("suspendedStart" === state) throw state = "completed", context.arg;
          context.dispatchException(context.arg);
        } else "return" === context.method && context.abrupt("return", context.arg);
        state = "executing";
        var record = tryCatch(innerFn, self, context);
        if ("normal" === record.type) {
          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
          return {
            value: record.arg,
            done: context.done
          };
        }
        "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
      }
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method,
      method = delegate.iterator[methodName];
    if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
            return next.value = undefined, next.done = !0, next;
          };
        return next.next = next;
      }
    }
    return {
      next: doneResult
    };
  }
  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), defineProperty(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (val) {
    var object = Object(val),
      keys = [];
    for (var key in object) keys.push(key);
    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function stop() {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(exception) {
      if (this.done) throw exception;
      var context = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
          record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
            hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function complete(record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function finish(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    "catch": function _catch(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}
module.exports = _regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{"./typeof.js":109}],109:[function(require,module,exports){
function _typeof(obj) {
  "@babel/helpers - typeof";

  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(obj);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{}],110:[function(require,module,exports){
// TODO(Babel 8): Remove this file.

var runtime = require("../helpers/regeneratorRuntime")();
module.exports = runtime;

// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}

},{"../helpers/regeneratorRuntime":108}],111:[function(require,module,exports){
"use strict";

// rawAsap provides everything we need except exception management.
var rawAsap = require("./raw");
// RawTasks are recycled to reduce GC churn.
var freeTasks = [];
// We queue errors to ensure they are thrown in right order (FIFO).
// Array-as-queue is good enough here, since we are just dealing with exceptions.
var pendingErrors = [];
var requestErrorThrow = rawAsap.makeRequestCallFromTimer(throwFirstError);

function throwFirstError() {
    if (pendingErrors.length) {
        throw pendingErrors.shift();
    }
}

/**
 * Calls a task as soon as possible after returning, in its own event, with priority
 * over other events like animation, reflow, and repaint. An error thrown from an
 * event will not interrupt, nor even substantially slow down the processing of
 * other events, but will be rather postponed to a lower priority event.
 * @param {{call}} task A callable object, typically a function that takes no
 * arguments.
 */
module.exports = asap;
function asap(task) {
    var rawTask;
    if (freeTasks.length) {
        rawTask = freeTasks.pop();
    } else {
        rawTask = new RawTask();
    }
    rawTask.task = task;
    rawAsap(rawTask);
}

// We wrap tasks with recyclable task objects.  A task object implements
// `call`, just like a function.
function RawTask() {
    this.task = null;
}

// The sole purpose of wrapping the task is to catch the exception and recycle
// the task object after its single use.
RawTask.prototype.call = function () {
    try {
        this.task.call();
    } catch (error) {
        if (asap.onerror) {
            // This hook exists purely for testing purposes.
            // Its name will be periodically randomized to break any code that
            // depends on its existence.
            asap.onerror(error);
        } else {
            // In a web browser, exceptions are not fatal. However, to avoid
            // slowing down the queue of pending tasks, we rethrow the error in a
            // lower priority turn.
            pendingErrors.push(error);
            requestErrorThrow();
        }
    } finally {
        this.task = null;
        freeTasks[freeTasks.length] = this;
    }
};

},{"./raw":112}],112:[function(require,module,exports){
(function (global){(function (){
"use strict";

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],113:[function(require,module,exports){

},{}],114:[function(require,module,exports){
(function (global){(function (){
/*! https://mths.be/punycode v1.4.1 by @mathias */
;(function(root) {

	/** Detect free variables */
	var freeExports = typeof exports == 'object' && exports &&
		!exports.nodeType && exports;
	var freeModule = typeof module == 'object' && module &&
		!module.nodeType && module;
	var freeGlobal = typeof global == 'object' && global;
	if (
		freeGlobal.global === freeGlobal ||
		freeGlobal.window === freeGlobal ||
		freeGlobal.self === freeGlobal
	) {
		root = freeGlobal;
	}

	/**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */
	var punycode,

	/** Highest positive signed 32-bit float value */
	maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1

	/** Bootstring parameters */
	base = 36,
	tMin = 1,
	tMax = 26,
	skew = 38,
	damp = 700,
	initialBias = 72,
	initialN = 128, // 0x80
	delimiter = '-', // '\x2D'

	/** Regular expressions */
	regexPunycode = /^xn--/,
	regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
	regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators

	/** Error messages */
	errors = {
		'overflow': 'Overflow: input needs wider integers to process',
		'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
		'invalid-input': 'Invalid input'
	},

	/** Convenience shortcuts */
	baseMinusTMin = base - tMin,
	floor = Math.floor,
	stringFromCharCode = String.fromCharCode,

	/** Temporary variable */
	key;

	/*--------------------------------------------------------------------------*/

	/**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */
	function error(type) {
		throw new RangeError(errors[type]);
	}

	/**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */
	function map(array, fn) {
		var length = array.length;
		var result = [];
		while (length--) {
			result[length] = fn(array[length]);
		}
		return result;
	}

	/**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */
	function mapDomain(string, fn) {
		var parts = string.split('@');
		var result = '';
		if (parts.length > 1) {
			// In email addresses, only the domain name should be punycoded. Leave
			// the local part (i.e. everything up to `@`) intact.
			result = parts[0] + '@';
			string = parts[1];
		}
		// Avoid `split(regex)` for IE8 compatibility. See #17.
		string = string.replace(regexSeparators, '\x2E');
		var labels = string.split('.');
		var encoded = map(labels, fn).join('.');
		return result + encoded;
	}

	/**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */
	function ucs2decode(string) {
		var output = [],
		    counter = 0,
		    length = string.length,
		    value,
		    extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) { // low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	/**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */
	function ucs2encode(array) {
		return map(array, function(value) {
			var output = '';
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
			return output;
		}).join('');
	}

	/**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */
	function basicToDigit(codePoint) {
		if (codePoint - 48 < 10) {
			return codePoint - 22;
		}
		if (codePoint - 65 < 26) {
			return codePoint - 65;
		}
		if (codePoint - 97 < 26) {
			return codePoint - 97;
		}
		return base;
	}

	/**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */
	function digitToBasic(digit, flag) {
		//  0..25 map to ASCII a..z or A..Z
		// 26..35 map to ASCII 0..9
		return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
	}

	/**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */
	function adapt(delta, numPoints, firstTime) {
		var k = 0;
		delta = firstTime ? floor(delta / damp) : delta >> 1;
		delta += floor(delta / numPoints);
		for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
			delta = floor(delta / baseMinusTMin);
		}
		return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
	}

	/**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */
	function decode(input) {
		// Don't use UCS-2
		var output = [],
		    inputLength = input.length,
		    out,
		    i = 0,
		    n = initialN,
		    bias = initialBias,
		    basic,
		    j,
		    index,
		    oldi,
		    w,
		    k,
		    digit,
		    t,
		    /** Cached calculation results */
		    baseMinusT;

		// Handle the basic code points: let `basic` be the number of input code
		// points before the last delimiter, or `0` if there is none, then copy
		// the first basic code points to the output.

		basic = input.lastIndexOf(delimiter);
		if (basic < 0) {
			basic = 0;
		}

		for (j = 0; j < basic; ++j) {
			// if it's not a basic code point
			if (input.charCodeAt(j) >= 0x80) {
				error('not-basic');
			}
			output.push(input.charCodeAt(j));
		}

		// Main decoding loop: start just after the last delimiter if any basic code
		// points were copied; start at the beginning otherwise.

		for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {

			// `index` is the index of the next character to be consumed.
			// Decode a generalized variable-length integer into `delta`,
			// which gets added to `i`. The overflow checking is easier
			// if we increase `i` as we go, then subtract off its starting
			// value at the end to obtain `delta`.
			for (oldi = i, w = 1, k = base; /* no condition */; k += base) {

				if (index >= inputLength) {
					error('invalid-input');
				}

				digit = basicToDigit(input.charCodeAt(index++));

				if (digit >= base || digit > floor((maxInt - i) / w)) {
					error('overflow');
				}

				i += digit * w;
				t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);

				if (digit < t) {
					break;
				}

				baseMinusT = base - t;
				if (w > floor(maxInt / baseMinusT)) {
					error('overflow');
				}

				w *= baseMinusT;

			}

			out = output.length + 1;
			bias = adapt(i - oldi, out, oldi == 0);

			// `i` was supposed to wrap around from `out` to `0`,
			// incrementing `n` each time, so we'll fix that now:
			if (floor(i / out) > maxInt - n) {
				error('overflow');
			}

			n += floor(i / out);
			i %= out;

			// Insert `n` at position `i` of the output
			output.splice(i++, 0, n);

		}

		return ucs2encode(output);
	}

	/**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */
	function encode(input) {
		var n,
		    delta,
		    handledCPCount,
		    basicLength,
		    bias,
		    j,
		    m,
		    q,
		    k,
		    t,
		    currentValue,
		    output = [],
		    /** `inputLength` will hold the number of code points in `input`. */
		    inputLength,
		    /** Cached calculation results */
		    handledCPCountPlusOne,
		    baseMinusT,
		    qMinusT;

		// Convert the input in UCS-2 to Unicode
		input = ucs2decode(input);

		// Cache the length
		inputLength = input.length;

		// Initialize the state
		n = initialN;
		delta = 0;
		bias = initialBias;

		// Handle the basic code points
		for (j = 0; j < inputLength; ++j) {
			currentValue = input[j];
			if (currentValue < 0x80) {
				output.push(stringFromCharCode(currentValue));
			}
		}

		handledCPCount = basicLength = output.length;

		// `handledCPCount` is the number of code points that have been handled;
		// `basicLength` is the number of basic code points.

		// Finish the basic string - if it is not empty - with a delimiter
		if (basicLength) {
			output.push(delimiter);
		}

		// Main encoding loop:
		while (handledCPCount < inputLength) {

			// All non-basic code points < n have been handled already. Find the next
			// larger one:
			for (m = maxInt, j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue >= n && currentValue < m) {
					m = currentValue;
				}
			}

			// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
			// but guard against overflow
			handledCPCountPlusOne = handledCPCount + 1;
			if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
				error('overflow');
			}

			delta += (m - n) * handledCPCountPlusOne;
			n = m;

			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];

				if (currentValue < n && ++delta > maxInt) {
					error('overflow');
				}

				if (currentValue == n) {
					// Represent delta as a generalized variable-length integer
					for (q = delta, k = base; /* no condition */; k += base) {
						t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
						if (q < t) {
							break;
						}
						qMinusT = q - t;
						baseMinusT = base - t;
						output.push(
							stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
						);
						q = floor(qMinusT / baseMinusT);
					}

					output.push(stringFromCharCode(digitToBasic(q, 0)));
					bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
					delta = 0;
					++handledCPCount;
				}
			}

			++delta;
			++n;

		}
		return output.join('');
	}

	/**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */
	function toUnicode(input) {
		return mapDomain(input, function(string) {
			return regexPunycode.test(string)
				? decode(string.slice(4).toLowerCase())
				: string;
		});
	}

	/**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */
	function toASCII(input) {
		return mapDomain(input, function(string) {
			return regexNonASCII.test(string)
				? 'xn--' + encode(string)
				: string;
		});
	}

	/*--------------------------------------------------------------------------*/

	/** Define the public API */
	punycode = {
		/**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */
		'version': '1.4.1',
		/**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */
		'ucs2': {
			'decode': ucs2decode,
			'encode': ucs2encode
		},
		'decode': decode,
		'encode': encode,
		'toASCII': toASCII,
		'toUnicode': toUnicode
	};

	/** Expose `punycode` */
	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		typeof define == 'function' &&
		typeof define.amd == 'object' &&
		define.amd
	) {
		define('punycode', function() {
			return punycode;
		});
	} else if (freeExports && freeModule) {
		if (module.exports == freeExports) {
			// in Node.js, io.js, or RingoJS v0.8.0+
			freeModule.exports = punycode;
		} else {
			// in Narwhal or RingoJS v0.7.0-
			for (key in punycode) {
				punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
			}
		}
	} else {
		// in Rhino or a web browser
		root.punycode = punycode;
	}

}(this));

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],115:[function(require,module,exports){
'use strict';

var GetIntrinsic = require('get-intrinsic');

var callBind = require('./');

var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));

module.exports = function callBoundIntrinsic(name, allowMissing) {
	var intrinsic = GetIntrinsic(name, !!allowMissing);
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBind(intrinsic);
	}
	return intrinsic;
};

},{"./":116,"get-intrinsic":120}],116:[function(require,module,exports){
'use strict';

var bind = require('function-bind');
var GetIntrinsic = require('get-intrinsic');

var $apply = GetIntrinsic('%Function.prototype.apply%');
var $call = GetIntrinsic('%Function.prototype.call%');
var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);

var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);
var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);
var $max = GetIntrinsic('%Math.max%');

if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = null;
	}
}

module.exports = function callBind(originalFunction) {
	var func = $reflectApply(bind, $call, arguments);
	if ($gOPD && $defineProperty) {
		var desc = $gOPD(func, 'length');
		if (desc.configurable) {
			// original length, plus the receiver, minus any additional arguments (after the receiver)
			$defineProperty(
				func,
				'length',
				{ value: 1 + $max(0, originalFunction.length - (arguments.length - 1)) }
			);
		}
	}
	return func;
};

var applyBind = function applyBind() {
	return $reflectApply(bind, $apply, arguments);
};

if ($defineProperty) {
	$defineProperty(module.exports, 'apply', { value: applyBind });
} else {
	module.exports.apply = applyBind;
}

},{"function-bind":119,"get-intrinsic":120}],117:[function(require,module,exports){
/**
 * EvEmitter v1.1.0
 * Lil' event emitter
 * MIT License
 */

/* jshint unused: true, undef: true, strict: true */

( function( global, factory ) {
  // universal module definition
  /* jshint strict: false */ /* globals define, module, window */
  if ( typeof define == 'function' && define.amd ) {
    // AMD - RequireJS
    define( factory );
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS - Browserify, Webpack
    module.exports = factory();
  } else {
    // Browser globals
    global.EvEmitter = factory();
  }

}( typeof window != 'undefined' ? window : this, function() {

"use strict";

function EvEmitter() {}

var proto = EvEmitter.prototype;

proto.on = function( eventName, listener ) {
  if ( !eventName || !listener ) {
    return;
  }
  // set events hash
  var events = this._events = this._events || {};
  // set listeners array
  var listeners = events[ eventName ] = events[ eventName ] || [];
  // only add once
  if ( listeners.indexOf( listener ) == -1 ) {
    listeners.push( listener );
  }

  return this;
};

proto.once = function( eventName, listener ) {
  if ( !eventName || !listener ) {
    return;
  }
  // add event
  this.on( eventName, listener );
  // set once flag
  // set onceEvents hash
  var onceEvents = this._onceEvents = this._onceEvents || {};
  // set onceListeners object
  var onceListeners = onceEvents[ eventName ] = onceEvents[ eventName ] || {};
  // set flag
  onceListeners[ listener ] = true;

  return this;
};

proto.off = function( eventName, listener ) {
  var listeners = this._events && this._events[ eventName ];
  if ( !listeners || !listeners.length ) {
    return;
  }
  var index = listeners.indexOf( listener );
  if ( index != -1 ) {
    listeners.splice( index, 1 );
  }

  return this;
};

proto.emitEvent = function( eventName, args ) {
  var listeners = this._events && this._events[ eventName ];
  if ( !listeners || !listeners.length ) {
    return;
  }
  // copy over to avoid interference if .off() in listener
  listeners = listeners.slice(0);
  args = args || [];
  // once stuff
  var onceListeners = this._onceEvents && this._onceEvents[ eventName ];

  for ( var i=0; i < listeners.length; i++ ) {
    var listener = listeners[i]
    var isOnce = onceListeners && onceListeners[ listener ];
    if ( isOnce ) {
      // remove listener
      // remove before trigger to prevent recursion
      this.off( eventName, listener );
      // unset once flag
      delete onceListeners[ listener ];
    }
    // trigger listener
    listener.apply( this, args );
  }

  return this;
};

proto.allOff = function() {
  delete this._events;
  delete this._onceEvents;
};

return EvEmitter;

}));

},{}],118:[function(require,module,exports){
'use strict';

/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var slice = Array.prototype.slice;
var toStr = Object.prototype.toString;
var funcType = '[object Function]';

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slice.call(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                args.concat(slice.call(arguments))
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        } else {
            return target.apply(
                that,
                args.concat(slice.call(arguments))
            );
        }
    };

    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs.push('$' + i);
    }

    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};

},{}],119:[function(require,module,exports){
'use strict';

var implementation = require('./implementation');

module.exports = Function.prototype.bind || implementation;

},{"./implementation":118}],120:[function(require,module,exports){
'use strict';

var undefined;

var $SyntaxError = SyntaxError;
var $Function = Function;
var $TypeError = TypeError;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) {
	try {
		$gOPD({}, '');
	} catch (e) {
		$gOPD = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError = function () {
	throw new $TypeError();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = require('has-symbols')();

var getProto = Object.getPrototypeOf || function (x) { return x.__proto__; }; // eslint-disable-line no-proto

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols ? getProto([][Symbol.iterator]()) : undefined,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
	'%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
	'%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': EvalError,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': Object,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': RangeError,
	'%ReferenceError%': ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols ? getProto(''[Symbol.iterator]()) : undefined,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%URIError%': URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
};

try {
	null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
	// https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
	var errorProto = getProto(getProto(e));
	INTRINSICS['%Error.prototype%'] = errorProto;
}

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = require('function-bind');
var hasOwn = require('has');
var $concat = bind.call(Function.call, Array.prototype.concat);
var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
var $replace = bind.call(Function.call, String.prototype.replace);
var $strSlice = bind.call(Function.call, String.prototype.slice);
var $exec = bind.call(Function.call, RegExp.prototype.exec);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError('"allowMissing" argument must be a boolean');
	}

	if ($exec(/^%?[^%]*%?$/, name) === null) {
		throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
	}
	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};

},{"function-bind":119,"has":123,"has-symbols":121}],121:[function(require,module,exports){
'use strict';

var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = require('./shams');

module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};

},{"./shams":122}],122:[function(require,module,exports){
'use strict';

/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};

},{}],123:[function(require,module,exports){
'use strict';

var bind = require('function-bind');

module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);

},{"function-bind":119}],124:[function(require,module,exports){
/*!
 * imagesLoaded v4.1.4
 * JavaScript is all like "You images are done yet or what?"
 * MIT License
 */

( function( window, factory ) { 'use strict';
  // universal module definition

  /*global define: false, module: false, require: false */

  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( [
      'ev-emitter/ev-emitter'
    ], function( EvEmitter ) {
      return factory( window, EvEmitter );
    });
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      window,
      require('ev-emitter')
    );
  } else {
    // browser global
    window.imagesLoaded = factory(
      window,
      window.EvEmitter
    );
  }

})( typeof window !== 'undefined' ? window : this,

// --------------------------  factory -------------------------- //

function factory( window, EvEmitter ) {

'use strict';

var $ = window.jQuery;
var console = window.console;

// -------------------------- helpers -------------------------- //

// extend objects
function extend( a, b ) {
  for ( var prop in b ) {
    a[ prop ] = b[ prop ];
  }
  return a;
}

var arraySlice = Array.prototype.slice;

// turn element or nodeList into an array
function makeArray( obj ) {
  if ( Array.isArray( obj ) ) {
    // use object if already an array
    return obj;
  }

  var isArrayLike = typeof obj == 'object' && typeof obj.length == 'number';
  if ( isArrayLike ) {
    // convert nodeList to array
    return arraySlice.call( obj );
  }

  // array of single index
  return [ obj ];
}

// -------------------------- imagesLoaded -------------------------- //

/**
 * @param {Array, Element, NodeList, String} elem
 * @param {Object or Function} options - if function, use as callback
 * @param {Function} onAlways - callback function
 */
function ImagesLoaded( elem, options, onAlways ) {
  // coerce ImagesLoaded() without new, to be new ImagesLoaded()
  if ( !( this instanceof ImagesLoaded ) ) {
    return new ImagesLoaded( elem, options, onAlways );
  }
  // use elem as selector string
  var queryElem = elem;
  if ( typeof elem == 'string' ) {
    queryElem = document.querySelectorAll( elem );
  }
  // bail if bad element
  if ( !queryElem ) {
    console.error( 'Bad element for imagesLoaded ' + ( queryElem || elem ) );
    return;
  }

  this.elements = makeArray( queryElem );
  this.options = extend( {}, this.options );
  // shift arguments if no options set
  if ( typeof options == 'function' ) {
    onAlways = options;
  } else {
    extend( this.options, options );
  }

  if ( onAlways ) {
    this.on( 'always', onAlways );
  }

  this.getImages();

  if ( $ ) {
    // add jQuery Deferred object
    this.jqDeferred = new $.Deferred();
  }

  // HACK check async to allow time to bind listeners
  setTimeout( this.check.bind( this ) );
}

ImagesLoaded.prototype = Object.create( EvEmitter.prototype );

ImagesLoaded.prototype.options = {};

ImagesLoaded.prototype.getImages = function() {
  this.images = [];

  // filter & find items if we have an item selector
  this.elements.forEach( this.addElementImages, this );
};

/**
 * @param {Node} element
 */
ImagesLoaded.prototype.addElementImages = function( elem ) {
  // filter siblings
  if ( elem.nodeName == 'IMG' ) {
    this.addImage( elem );
  }
  // get background image on element
  if ( this.options.background === true ) {
    this.addElementBackgroundImages( elem );
  }

  // find children
  // no non-element nodes, #143
  var nodeType = elem.nodeType;
  if ( !nodeType || !elementNodeTypes[ nodeType ] ) {
    return;
  }
  var childImgs = elem.querySelectorAll('img');
  // concat childElems to filterFound array
  for ( var i=0; i < childImgs.length; i++ ) {
    var img = childImgs[i];
    this.addImage( img );
  }

  // get child background images
  if ( typeof this.options.background == 'string' ) {
    var children = elem.querySelectorAll( this.options.background );
    for ( i=0; i < children.length; i++ ) {
      var child = children[i];
      this.addElementBackgroundImages( child );
    }
  }
};

var elementNodeTypes = {
  1: true,
  9: true,
  11: true
};

ImagesLoaded.prototype.addElementBackgroundImages = function( elem ) {
  var style = getComputedStyle( elem );
  if ( !style ) {
    // Firefox returns null if in a hidden iframe https://bugzil.la/548397
    return;
  }
  // get url inside url("...")
  var reURL = /url\((['"])?(.*?)\1\)/gi;
  var matches = reURL.exec( style.backgroundImage );
  while ( matches !== null ) {
    var url = matches && matches[2];
    if ( url ) {
      this.addBackground( url, elem );
    }
    matches = reURL.exec( style.backgroundImage );
  }
};

/**
 * @param {Image} img
 */
ImagesLoaded.prototype.addImage = function( img ) {
  var loadingImage = new LoadingImage( img );
  this.images.push( loadingImage );
};

ImagesLoaded.prototype.addBackground = function( url, elem ) {
  var background = new Background( url, elem );
  this.images.push( background );
};

ImagesLoaded.prototype.check = function() {
  var _this = this;
  this.progressedCount = 0;
  this.hasAnyBroken = false;
  // complete if no images
  if ( !this.images.length ) {
    this.complete();
    return;
  }

  function onProgress( image, elem, message ) {
    // HACK - Chrome triggers event before object properties have changed. #83
    setTimeout( function() {
      _this.progress( image, elem, message );
    });
  }

  this.images.forEach( function( loadingImage ) {
    loadingImage.once( 'progress', onProgress );
    loadingImage.check();
  });
};

ImagesLoaded.prototype.progress = function( image, elem, message ) {
  this.progressedCount++;
  this.hasAnyBroken = this.hasAnyBroken || !image.isLoaded;
  // progress event
  this.emitEvent( 'progress', [ this, image, elem ] );
  if ( this.jqDeferred && this.jqDeferred.notify ) {
    this.jqDeferred.notify( this, image );
  }
  // check if completed
  if ( this.progressedCount == this.images.length ) {
    this.complete();
  }

  if ( this.options.debug && console ) {
    console.log( 'progress: ' + message, image, elem );
  }
};

ImagesLoaded.prototype.complete = function() {
  var eventName = this.hasAnyBroken ? 'fail' : 'done';
  this.isComplete = true;
  this.emitEvent( eventName, [ this ] );
  this.emitEvent( 'always', [ this ] );
  if ( this.jqDeferred ) {
    var jqMethod = this.hasAnyBroken ? 'reject' : 'resolve';
    this.jqDeferred[ jqMethod ]( this );
  }
};

// --------------------------  -------------------------- //

function LoadingImage( img ) {
  this.img = img;
}

LoadingImage.prototype = Object.create( EvEmitter.prototype );

LoadingImage.prototype.check = function() {
  // If complete is true and browser supports natural sizes,
  // try to check for image status manually.
  var isComplete = this.getIsImageComplete();
  if ( isComplete ) {
    // report based on naturalWidth
    this.confirm( this.img.naturalWidth !== 0, 'naturalWidth' );
    return;
  }

  // If none of the checks above matched, simulate loading on detached element.
  this.proxyImage = new Image();
  this.proxyImage.addEventListener( 'load', this );
  this.proxyImage.addEventListener( 'error', this );
  // bind to image as well for Firefox. #191
  this.img.addEventListener( 'load', this );
  this.img.addEventListener( 'error', this );
  this.proxyImage.src = this.img.src;
};

LoadingImage.prototype.getIsImageComplete = function() {
  // check for non-zero, non-undefined naturalWidth
  // fixes Safari+InfiniteScroll+Masonry bug infinite-scroll#671
  return this.img.complete && this.img.naturalWidth;
};

LoadingImage.prototype.confirm = function( isLoaded, message ) {
  this.isLoaded = isLoaded;
  this.emitEvent( 'progress', [ this, this.img, message ] );
};

// ----- events ----- //

// trigger specified handler for event type
LoadingImage.prototype.handleEvent = function( event ) {
  var method = 'on' + event.type;
  if ( this[ method ] ) {
    this[ method ]( event );
  }
};

LoadingImage.prototype.onload = function() {
  this.confirm( true, 'onload' );
  this.unbindEvents();
};

LoadingImage.prototype.onerror = function() {
  this.confirm( false, 'onerror' );
  this.unbindEvents();
};

LoadingImage.prototype.unbindEvents = function() {
  this.proxyImage.removeEventListener( 'load', this );
  this.proxyImage.removeEventListener( 'error', this );
  this.img.removeEventListener( 'load', this );
  this.img.removeEventListener( 'error', this );
};

// -------------------------- Background -------------------------- //

function Background( url, element ) {
  this.url = url;
  this.element = element;
  this.img = new Image();
}

// inherit LoadingImage prototype
Background.prototype = Object.create( LoadingImage.prototype );

Background.prototype.check = function() {
  this.img.addEventListener( 'load', this );
  this.img.addEventListener( 'error', this );
  this.img.src = this.url;
  // check if image is already complete
  var isComplete = this.getIsImageComplete();
  if ( isComplete ) {
    this.confirm( this.img.naturalWidth !== 0, 'naturalWidth' );
    this.unbindEvents();
  }
};

Background.prototype.unbindEvents = function() {
  this.img.removeEventListener( 'load', this );
  this.img.removeEventListener( 'error', this );
};

Background.prototype.confirm = function( isLoaded, message ) {
  this.isLoaded = isLoaded;
  this.emitEvent( 'progress', [ this, this.element, message ] );
};

// -------------------------- jQuery -------------------------- //

ImagesLoaded.makeJQueryPlugin = function( jQuery ) {
  jQuery = jQuery || window.jQuery;
  if ( !jQuery ) {
    return;
  }
  // set local variable
  $ = jQuery;
  // $().imagesLoaded()
  $.fn.imagesLoaded = function( options, callback ) {
    var instance = new ImagesLoaded( this, options, callback );
    return instance.jqDeferred.promise( $(this) );
  };
};
// try making plugin
ImagesLoaded.makeJQueryPlugin();

// --------------------------  -------------------------- //

return ImagesLoaded;

});

},{"ev-emitter":117}],125:[function(require,module,exports){
(function (global){(function (){
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.21';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function',
      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading whitespace. */
  var reTrimStart = /^\s+/;

  /** Used to match a single whitespace character. */
  var reWhitespace = /\s/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */
  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */
  function baseTrim(string) {
    return string
      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
      : string;
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedEndIndex(string) {
    var index = string.length;

    while (index-- && reWhitespace.test(string.charAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            }
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Throw an error if a forbidden character was found in `variable`, to prevent
      // potential command injection attacks.
      else if (reForbiddenIdentifierChars.test(variable)) {
        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
      }

      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return baseTrim(string);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.slice(0, trimmedEndIndex(string) + 1);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    define(function() {
      return _;
    });
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],126:[function(require,module,exports){
var hasMap = typeof Map === 'function' && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === 'function' && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var $match = String.prototype.match;
var $slice = String.prototype.slice;
var $replace = String.prototype.replace;
var $toUpperCase = String.prototype.toUpperCase;
var $toLowerCase = String.prototype.toLowerCase;
var $test = RegExp.prototype.test;
var $concat = Array.prototype.concat;
var $join = Array.prototype.join;
var $arrSlice = Array.prototype.slice;
var $floor = Math.floor;
var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? 'object' : 'symbol')
    ? Symbol.toStringTag
    : null;
var isEnumerable = Object.prototype.propertyIsEnumerable;

var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || (
    [].__proto__ === Array.prototype // eslint-disable-line no-proto
        ? function (O) {
            return O.__proto__; // eslint-disable-line no-proto
        }
        : null
);

function addNumericSeparator(num, str) {
    if (
        num === Infinity
        || num === -Infinity
        || num !== num
        || (num && num > -1000 && num < 1000)
        || $test.call(/e/, str)
    ) {
        return str;
    }
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$floor(-num) : $floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $slice.call(str, intStr.length + 1);
            return $replace.call(intStr, sepRegex, '$&_') + '.' + $replace.call($replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $replace.call(str, sepRegex, '$&_');
}

var utilInspect = require('./util.inspect');
var inspectCustom = utilInspect.custom;
var inspectSymbol = isSymbol(inspectCustom) ? inspectCustom : null;

module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};

    if (has(opts, 'quoteStyle') && (opts.quoteStyle !== 'single' && opts.quoteStyle !== 'double')) {
        throw new TypeError('option "quoteStyle" must be "single" or "double"');
    }
    if (
        has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number'
            ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity
            : opts.maxStringLength !== null
        )
    ) {
        throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    }
    var customInspect = has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') {
        throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    }

    if (
        has(opts, 'indent')
        && opts.indent !== null
        && opts.indent !== '\t'
        && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)
    ) {
        throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    }
    if (has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') {
        throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    }
    var numericSeparator = opts.numericSeparator;

    if (typeof obj === 'undefined') {
        return 'undefined';
    }
    if (obj === null) {
        return 'null';
    }
    if (typeof obj === 'boolean') {
        return obj ? 'true' : 'false';
    }

    if (typeof obj === 'string') {
        return inspectString(obj, opts);
    }
    if (typeof obj === 'number') {
        if (obj === 0) {
            return Infinity / obj > 0 ? '0' : '-0';
        }
        var str = String(obj);
        return numericSeparator ? addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }

    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') { depth = 0; }
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') {
        return isArray(obj) ? '[Array]' : '[Object]';
    }

    var indent = getIndent(opts, depth);

    if (typeof seen === 'undefined') {
        seen = [];
    } else if (indexOf(seen, obj) >= 0) {
        return '[Circular]';
    }

    function inspect(value, from, noIndent) {
        if (from) {
            seen = $arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if (has(opts, 'quoteStyle')) {
                newOpts.quoteStyle = opts.quoteStyle;
            }
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }

    if (typeof obj === 'function' && !isRegExp(obj)) { // in older engines, regexes are callable
        var name = nameOf(obj);
        var keys = arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $join.call(keys, ', ') + ' }' : '');
    }
    if (isSymbol(obj)) {
        var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
        return typeof obj === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
    }
    if (isElement(obj)) {
        var s = '<' + $toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for (var i = 0; i < attrs.length; i++) {
            s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
        }
        s += '>';
        if (obj.childNodes && obj.childNodes.length) { s += '...'; }
        s += '</' + $toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if (isArray(obj)) {
        if (obj.length === 0) { return '[]'; }
        var xs = arrObjKeys(obj, inspect);
        if (indent && !singleLineValues(xs)) {
            return '[' + indentedJoin(xs, indent) + ']';
        }
        return '[ ' + $join.call(xs, ', ') + ' ]';
    }
    if (isError(obj)) {
        var parts = arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !isEnumerable.call(obj, 'cause')) {
            return '{ [' + String(obj) + '] ' + $join.call($concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        }
        if (parts.length === 0) { return '[' + String(obj) + ']'; }
        return '{ [' + String(obj) + '] ' + $join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if (inspectSymbol && typeof obj[inspectSymbol] === 'function' && utilInspect) {
            return utilInspect(obj, { depth: maxDepth - depth });
        } else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') {
            return obj.inspect();
        }
    }
    if (isMap(obj)) {
        var mapParts = [];
        if (mapForEach) {
            mapForEach.call(obj, function (value, key) {
                mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
            });
        }
        return collectionOf('Map', mapSize.call(obj), mapParts, indent);
    }
    if (isSet(obj)) {
        var setParts = [];
        if (setForEach) {
            setForEach.call(obj, function (value) {
                setParts.push(inspect(value, obj));
            });
        }
        return collectionOf('Set', setSize.call(obj), setParts, indent);
    }
    if (isWeakMap(obj)) {
        return weakCollectionOf('WeakMap');
    }
    if (isWeakSet(obj)) {
        return weakCollectionOf('WeakSet');
    }
    if (isWeakRef(obj)) {
        return weakCollectionOf('WeakRef');
    }
    if (isNumber(obj)) {
        return markBoxed(inspect(Number(obj)));
    }
    if (isBigInt(obj)) {
        return markBoxed(inspect(bigIntValueOf.call(obj)));
    }
    if (isBoolean(obj)) {
        return markBoxed(booleanValueOf.call(obj));
    }
    if (isString(obj)) {
        return markBoxed(inspect(String(obj)));
    }
    if (!isDate(obj) && !isRegExp(obj)) {
        var ys = arrObjKeys(obj, inspect);
        var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $join.call($concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) { return tag + '{}'; }
        if (indent) {
            return tag + '{' + indentedJoin(ys, indent) + '}';
        }
        return tag + '{ ' + $join.call(ys, ', ') + ' }';
    }
    return String(obj);
};

function wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === 'double' ? '"' : "'";
    return quoteChar + s + quoteChar;
}

function quote(s) {
    return $replace.call(String(s), /"/g, '&quot;');
}

function isArray(obj) { return toStr(obj) === '[object Array]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isDate(obj) { return toStr(obj) === '[object Date]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isRegExp(obj) { return toStr(obj) === '[object RegExp]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isError(obj) { return toStr(obj) === '[object Error]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isString(obj) { return toStr(obj) === '[object String]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isNumber(obj) { return toStr(obj) === '[object Number]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isBoolean(obj) { return toStr(obj) === '[object Boolean]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }

// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function isSymbol(obj) {
    if (hasShammedSymbols) {
        return obj && typeof obj === 'object' && obj instanceof Symbol;
    }
    if (typeof obj === 'symbol') {
        return true;
    }
    if (!obj || typeof obj !== 'object' || !symToString) {
        return false;
    }
    try {
        symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}

function isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !bigIntValueOf) {
        return false;
    }
    try {
        bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}

var hasOwn = Object.prototype.hasOwnProperty || function (key) { return key in this; };
function has(obj, key) {
    return hasOwn.call(obj, key);
}

function toStr(obj) {
    return objectToString.call(obj);
}

function nameOf(f) {
    if (f.name) { return f.name; }
    var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) { return m[1]; }
    return null;
}

function indexOf(xs, x) {
    if (xs.indexOf) { return xs.indexOf(x); }
    for (var i = 0, l = xs.length; i < l; i++) {
        if (xs[i] === x) { return i; }
    }
    return -1;
}

function isMap(x) {
    if (!mapSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        mapSize.call(x);
        try {
            setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakMap(x) {
    if (!weakMapHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakMapHas.call(x, weakMapHas);
        try {
            weakSetHas.call(x, weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakRef(x) {
    if (!weakRefDeref || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}

function isSet(x) {
    if (!setSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        setSize.call(x);
        try {
            mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakSet(x) {
    if (!weakSetHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakSetHas.call(x, weakSetHas);
        try {
            weakMapHas.call(x, weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isElement(x) {
    if (!x || typeof x !== 'object') { return false; }
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
        return true;
    }
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}

function inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = $replace.call($replace.call(str, /(['\\])/g, '\\$1'), /[\x00-\x1f]/g, lowbyte);
    return wrapQuotes(s, 'single', opts);
}

function lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) { return '\\' + x; }
    return '\\x' + (n < 0x10 ? '0' : '') + $toUpperCase.call(n.toString(16));
}

function markBoxed(str) {
    return 'Object(' + str + ')';
}

function weakCollectionOf(type) {
    return type + ' { ? }';
}

function collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}

function singleLineValues(xs) {
    for (var i = 0; i < xs.length; i++) {
        if (indexOf(xs[i], '\n') >= 0) {
            return false;
        }
    }
    return true;
}

function getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') {
        baseIndent = '\t';
    } else if (typeof opts.indent === 'number' && opts.indent > 0) {
        baseIndent = $join.call(Array(opts.indent + 1), ' ');
    } else {
        return null;
    }
    return {
        base: baseIndent,
        prev: $join.call(Array(depth + 1), baseIndent)
    };
}

function indentedJoin(xs, indent) {
    if (xs.length === 0) { return ''; }
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}

function arrObjKeys(obj, inspect) {
    var isArr = isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for (var i = 0; i < obj.length; i++) {
            xs[i] = has(obj, i) ? inspect(obj[i], obj) : '';
        }
    }
    var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
    var symMap;
    if (hasShammedSymbols) {
        symMap = {};
        for (var k = 0; k < syms.length; k++) {
            symMap['$' + syms[k]] = syms[k];
        }
    }

    for (var key in obj) { // eslint-disable-line no-restricted-syntax
        if (!has(obj, key)) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) {
            // this is to prevent shammed Symbols, which are stored as strings, from being included in the string key section
            continue; // eslint-disable-line no-restricted-syntax, no-continue
        } else if ($test.call(/[^\w$]/, key)) {
            xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        } else {
            xs.push(key + ': ' + inspect(obj[key], obj));
        }
    }
    if (typeof gOPS === 'function') {
        for (var j = 0; j < syms.length; j++) {
            if (isEnumerable.call(obj, syms[j])) {
                xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
            }
        }
    }
    return xs;
}

},{"./util.inspect":113}],127:[function(require,module,exports){
// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };

},{}],128:[function(require,module,exports){
'use strict';

module.exports = require('./lib')

},{"./lib":133}],129:[function(require,module,exports){
'use strict';

var asap = require('asap/raw');

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._x = 0;
  this._y = 0;
  this._z = null;
  this._A = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._B = null;
Promise._C = null;
Promise._D = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._y === 3) {
    self = self._z;
  }
  if (Promise._B) {
    Promise._B(self);
  }
  if (self._y === 0) {
    if (self._x === 0) {
      self._x = 1;
      self._A = deferred;
      return;
    }
    if (self._x === 1) {
      self._x = 2;
      self._A = [self._A, deferred];
      return;
    }
    self._A.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._y === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._y === 1) {
        resolve(deferred.promise, self._z);
      } else {
        reject(deferred.promise, self._z);
      }
      return;
    }
    var ret = tryCallOne(cb, self._z);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._y = 3;
      self._z = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._y = 1;
  self._z = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._y = 2;
  self._z = newValue;
  if (Promise._C) {
    Promise._C(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._x === 1) {
    handle(self, self._A);
    self._A = null;
  }
  if (self._x === 2) {
    for (var i = 0; i < self._A.length; i++) {
      handle(self, self._A[i]);
    }
    self._A = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}

},{"asap/raw":112}],130:[function(require,module,exports){
'use strict';

var Promise = require('./core.js');

module.exports = Promise;
Promise.prototype.done = function (onFulfilled, onRejected) {
  var self = arguments.length ? this.then.apply(this, arguments) : this;
  self.then(null, function (err) {
    setTimeout(function () {
      throw err;
    }, 0);
  });
};

},{"./core.js":129}],131:[function(require,module,exports){
'use strict';

//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = require('./core.js');

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._D);
  p._y = 1;
  p._z = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

var iterableToArray = function (iterable) {
  if (typeof Array.from === 'function') {
    // ES2015+, iterables exist
    iterableToArray = Array.from;
    return Array.from(iterable);
  }

  // ES5, only arrays and array-likes exist
  iterableToArray = function (x) { return Array.prototype.slice.call(x); };
  return Array.prototype.slice.call(iterable);
}

Promise.all = function (arr) {
  var args = iterableToArray(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._y === 3) {
            val = val._z;
          }
          if (val._y === 1) return res(i, val._z);
          if (val._y === 2) reject(val._z);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

function onSettledFulfill(value) {
  return { status: 'fulfilled', value: value };
}
function onSettledReject(reason) {
  return { status: 'rejected', reason: reason };
}
function mapAllSettled(item) {
  if(item && (typeof item === 'object' || typeof item === 'function')){
    if(item instanceof Promise && item.then === Promise.prototype.then){
      return item.then(onSettledFulfill, onSettledReject);
    }
    var then = item.then;
    if (typeof then === 'function') {
      return new Promise(then.bind(item)).then(onSettledFulfill, onSettledReject)
    }
  }

  return onSettledFulfill(item);
}
Promise.allSettled = function (iterable) {
  return Promise.all(iterableToArray(iterable).map(mapAllSettled));
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    iterableToArray(values).forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};

function getAggregateError(errors){
  if(typeof AggregateError === 'function'){
    return new AggregateError(errors,'All promises were rejected');
  }

  var error = new Error('All promises were rejected');

  error.name = 'AggregateError';
  error.errors = errors;

  return error;
}

Promise.any = function promiseAny(values) {
  return new Promise(function(resolve, reject) {
    var promises = iterableToArray(values);
    var hasResolved = false;
    var rejectionReasons = [];

    function resolveOnce(value) {
      if (!hasResolved) {
        hasResolved = true;
        resolve(value);
      }
    }

    function rejectionCheck(reason) {
      rejectionReasons.push(reason);

      if (rejectionReasons.length === promises.length) {
        reject(getAggregateError(rejectionReasons));
      }
    }

    if(promises.length === 0){
      reject(getAggregateError(rejectionReasons));
    } else {
      promises.forEach(function(value){
        Promise.resolve(value).then(resolveOnce, rejectionCheck);
      });
    }
  });
};

},{"./core.js":129}],132:[function(require,module,exports){
'use strict';

var Promise = require('./core.js');

module.exports = Promise;
Promise.prototype.finally = function (f) {
  return this.then(function (value) {
    return Promise.resolve(f()).then(function () {
      return value;
    });
  }, function (err) {
    return Promise.resolve(f()).then(function () {
      throw err;
    });
  });
};

},{"./core.js":129}],133:[function(require,module,exports){
'use strict';

module.exports = require('./core.js');
require('./done.js');
require('./finally.js');
require('./es6-extensions.js');
require('./node-extensions.js');
require('./synchronous.js');

},{"./core.js":129,"./done.js":130,"./es6-extensions.js":131,"./finally.js":132,"./node-extensions.js":134,"./synchronous.js":135}],134:[function(require,module,exports){
'use strict';

// This file contains then/promise specific extensions that are only useful
// for node.js interop

var Promise = require('./core.js');
var asap = require('asap');

module.exports = Promise;

/* Static Functions */

Promise.denodeify = function (fn, argumentCount) {
  if (
    typeof argumentCount === 'number' && argumentCount !== Infinity
  ) {
    return denodeifyWithCount(fn, argumentCount);
  } else {
    return denodeifyWithoutCount(fn);
  }
};

var callbackFn = (
  'function (err, res) {' +
  'if (err) { rj(err); } else { rs(res); }' +
  '}'
);
function denodeifyWithCount(fn, argumentCount) {
  var args = [];
  for (var i = 0; i < argumentCount; i++) {
    args.push('a' + i);
  }
  var body = [
    'return function (' + args.join(',') + ') {',
    'var self = this;',
    'return new Promise(function (rs, rj) {',
    'var res = fn.call(',
    ['self'].concat(args).concat([callbackFn]).join(','),
    ');',
    'if (res &&',
    '(typeof res === "object" || typeof res === "function") &&',
    'typeof res.then === "function"',
    ') {rs(res);}',
    '});',
    '};'
  ].join('');
  return Function(['Promise', 'fn'], body)(Promise, fn);
}
function denodeifyWithoutCount(fn) {
  var fnLength = Math.max(fn.length - 1, 3);
  var args = [];
  for (var i = 0; i < fnLength; i++) {
    args.push('a' + i);
  }
  var body = [
    'return function (' + args.join(',') + ') {',
    'var self = this;',
    'var args;',
    'var argLength = arguments.length;',
    'if (arguments.length > ' + fnLength + ') {',
    'args = new Array(arguments.length + 1);',
    'for (var i = 0; i < arguments.length; i++) {',
    'args[i] = arguments[i];',
    '}',
    '}',
    'return new Promise(function (rs, rj) {',
    'var cb = ' + callbackFn + ';',
    'var res;',
    'switch (argLength) {',
    args.concat(['extra']).map(function (_, index) {
      return (
        'case ' + (index) + ':' +
        'res = fn.call(' + ['self'].concat(args.slice(0, index)).concat('cb').join(',') + ');' +
        'break;'
      );
    }).join(''),
    'default:',
    'args[argLength] = cb;',
    'res = fn.apply(self, args);',
    '}',
    
    'if (res &&',
    '(typeof res === "object" || typeof res === "function") &&',
    'typeof res.then === "function"',
    ') {rs(res);}',
    '});',
    '};'
  ].join('');

  return Function(
    ['Promise', 'fn'],
    body
  )(Promise, fn);
}

Promise.nodeify = function (fn) {
  return function () {
    var args = Array.prototype.slice.call(arguments);
    var callback =
      typeof args[args.length - 1] === 'function' ? args.pop() : null;
    var ctx = this;
    try {
      return fn.apply(this, arguments).nodeify(callback, ctx);
    } catch (ex) {
      if (callback === null || typeof callback == 'undefined') {
        return new Promise(function (resolve, reject) {
          reject(ex);
        });
      } else {
        asap(function () {
          callback.call(ctx, ex);
        })
      }
    }
  }
};

Promise.prototype.nodeify = function (callback, ctx) {
  if (typeof callback != 'function') return this;

  this.then(function (value) {
    asap(function () {
      callback.call(ctx, null, value);
    });
  }, function (err) {
    asap(function () {
      callback.call(ctx, err);
    });
  });
};

},{"./core.js":129,"asap":111}],135:[function(require,module,exports){
'use strict';

var Promise = require('./core.js');

module.exports = Promise;
Promise.enableSynchronous = function () {
  Promise.prototype.isPending = function() {
    return this.getState() == 0;
  };

  Promise.prototype.isFulfilled = function() {
    return this.getState() == 1;
  };

  Promise.prototype.isRejected = function() {
    return this.getState() == 2;
  };

  Promise.prototype.getValue = function () {
    if (this._y === 3) {
      return this._z.getValue();
    }

    if (!this.isFulfilled()) {
      throw new Error('Cannot get a value of an unfulfilled promise.');
    }

    return this._z;
  };

  Promise.prototype.getReason = function () {
    if (this._y === 3) {
      return this._z.getReason();
    }

    if (!this.isRejected()) {
      throw new Error('Cannot get a rejection reason of a non-rejected promise.');
    }

    return this._z;
  };

  Promise.prototype.getState = function () {
    if (this._y === 3) {
      return this._z.getState();
    }
    if (this._y === -1 || this._y === -2) {
      return 0;
    }

    return this._y;
  };
};

Promise.disableSynchronous = function() {
  Promise.prototype.isPending = undefined;
  Promise.prototype.isFulfilled = undefined;
  Promise.prototype.isRejected = undefined;
  Promise.prototype.getValue = undefined;
  Promise.prototype.getReason = undefined;
  Promise.prototype.getState = undefined;
};

},{"./core.js":129}],136:[function(require,module,exports){
'use strict';

var replace = String.prototype.replace;
var percentTwenties = /%20/g;

var Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};

module.exports = {
    'default': Format.RFC3986,
    formatters: {
        RFC1738: function (value) {
            return replace.call(value, percentTwenties, '+');
        },
        RFC3986: function (value) {
            return String(value);
        }
    },
    RFC1738: Format.RFC1738,
    RFC3986: Format.RFC3986
};

},{}],137:[function(require,module,exports){
'use strict';

var stringify = require('./stringify');
var parse = require('./parse');
var formats = require('./formats');

module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};

},{"./formats":136,"./parse":138,"./stringify":139}],138:[function(require,module,exports){
'use strict';

var utils = require('./utils');

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var defaults = {
    allowDots: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decoder: utils.decode,
    delimiter: '&',
    depth: 5,
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictNullHandling: false
};

var interpretNumericEntities = function (str) {
    return str.replace(/&#(\d+);/g, function ($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};

var parseArrayValue = function (val, options) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
        return val.split(',');
    }

    return val;
};

// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')

// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')

var parseValues = function parseQueryStringValues(str, options) {
    var obj = {};
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;

    var charset = options.charset;
    if (options.charsetSentinel) {
        for (i = 0; i < parts.length; ++i) {
            if (parts[i].indexOf('utf8=') === 0) {
                if (parts[i] === charsetSentinel) {
                    charset = 'utf-8';
                } else if (parts[i] === isoSentinel) {
                    charset = 'iso-8859-1';
                }
                skipIndex = i;
                i = parts.length; // The eslint settings do not allow break;
            }
        }
    }

    for (i = 0; i < parts.length; ++i) {
        if (i === skipIndex) {
            continue;
        }
        var part = parts[i];

        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;

        var key, val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder, charset, 'key');
            val = utils.maybeMap(
                parseArrayValue(part.slice(pos + 1), options),
                function (encodedVal) {
                    return options.decoder(encodedVal, defaults.decoder, charset, 'value');
                }
            );
        }

        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
            val = interpretNumericEntities(val);
        }

        if (part.indexOf('[]=') > -1) {
            val = isArray(val) ? [val] : val;
        }

        if (has.call(obj, key)) {
            obj[key] = utils.combine(obj[key], val);
        } else {
            obj[key] = val;
        }
    }

    return obj;
};

var parseObject = function (chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : parseArrayValue(val, options);

    for (var i = chain.length - 1; i >= 0; --i) {
        var obj;
        var root = chain[i];

        if (root === '[]' && options.parseArrays) {
            obj = [].concat(leaf);
        } else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);
            if (!options.parseArrays && cleanRoot === '') {
                obj = { 0: leaf };
            } else if (
                !isNaN(index)
                && root !== cleanRoot
                && String(index) === cleanRoot
                && index >= 0
                && (options.parseArrays && index <= options.arrayLimit)
            ) {
                obj = [];
                obj[index] = leaf;
            } else if (cleanRoot !== '__proto__') {
                obj[cleanRoot] = leaf;
            }
        }

        leaf = obj;
    }

    return leaf;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) {
        return;
    }

    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

    // The regex chunks

    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;

    // Get the parent

    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;

    // Stash the parent if it exists

    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(parent);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while (options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;
        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) {
                return;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, just add whatever is left

    if (segment) {
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return parseObject(keys, val, options, valuesParsed);
};

var normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }
    var charset = typeof opts.charset === 'undefined' ? defaults.charset : opts.charset;

    return {
        allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : defaults.comma,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: (typeof opts.depth === 'number' || opts.depth === false) ? +opts.depth : defaults.depth,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults.plainObjects,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (str, opts) {
    var options = normalizeParseOptions(opts);

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? Object.create(null) : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = utils.merge(obj, newObj, options);
    }

    if (options.allowSparse === true) {
        return obj;
    }

    return utils.compact(obj);
};

},{"./utils":140}],139:[function(require,module,exports){
'use strict';

var getSideChannel = require('side-channel');
var utils = require('./utils');
var formats = require('./formats');
var has = Object.prototype.hasOwnProperty;

var arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};

var isArray = Array.isArray;
var push = Array.prototype.push;
var pushToArray = function (arr, valueOrArray) {
    push.apply(arr, isArray(valueOrArray) ? valueOrArray : [valueOrArray]);
};

var toISO = Date.prototype.toISOString;

var defaultFormat = formats['default'];
var defaults = {
    addQueryPrefix: false,
    allowDots: false,
    charset: 'utf-8',
    charsetSentinel: false,
    delimiter: '&',
    encode: true,
    encoder: utils.encode,
    encodeValuesOnly: false,
    format: defaultFormat,
    formatter: formats.formatters[defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};

var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string'
        || typeof v === 'number'
        || typeof v === 'boolean'
        || typeof v === 'symbol'
        || typeof v === 'bigint';
};

var sentinel = {};

var stringify = function stringify(
    object,
    prefix,
    generateArrayPrefix,
    commaRoundTrip,
    strictNullHandling,
    skipNulls,
    encoder,
    filter,
    sort,
    allowDots,
    serializeDate,
    format,
    formatter,
    encodeValuesOnly,
    charset,
    sideChannel
) {
    var obj = object;

    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while ((tmpSc = tmpSc.get(sentinel)) !== void undefined && !findFlag) {
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) {
                throw new RangeError('Cyclic object value');
            } else {
                findFlag = true; // Break while
            }
        }
        if (typeof tmpSc.get(sentinel) === 'undefined') {
            step = 0;
        }
    }

    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    } else if (obj instanceof Date) {
        obj = serializeDate(obj);
    } else if (generateArrayPrefix === 'comma' && isArray(obj)) {
        obj = utils.maybeMap(obj, function (value) {
            if (value instanceof Date) {
                return serializeDate(value);
            }
            return value;
        });
    }

    if (obj === null) {
        if (strictNullHandling) {
            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset, 'key', format) : prefix;
        }

        obj = '';
    }

    if (isNonNullishPrimitive(obj) || utils.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset, 'key', format);
            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder, charset, 'value', format))];
        }
        return [formatter(prefix) + '=' + formatter(String(obj))];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (generateArrayPrefix === 'comma' && isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) {
            obj = utils.maybeMap(obj, encoder);
        }
        objKeys = [{ value: obj.length > 0 ? obj.join(',') || null : void undefined }];
    } else if (isArray(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    var adjustedPrefix = commaRoundTrip && isArray(obj) && obj.length === 1 ? prefix + '[]' : prefix;

    for (var j = 0; j < objKeys.length; ++j) {
        var key = objKeys[j];
        var value = typeof key === 'object' && typeof key.value !== 'undefined' ? key.value : obj[key];

        if (skipNulls && value === null) {
            continue;
        }

        var keyPrefix = isArray(obj)
            ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, key) : adjustedPrefix
            : adjustedPrefix + (allowDots ? '.' + key : '[' + key + ']');

        sideChannel.set(object, step);
        var valueSideChannel = getSideChannel();
        valueSideChannel.set(sentinel, sideChannel);
        pushToArray(values, stringify(
            value,
            keyPrefix,
            generateArrayPrefix,
            commaRoundTrip,
            strictNullHandling,
            skipNulls,
            generateArrayPrefix === 'comma' && encodeValuesOnly && isArray(obj) ? null : encoder,
            filter,
            sort,
            allowDots,
            serializeDate,
            format,
            formatter,
            encodeValuesOnly,
            charset,
            valueSideChannel
        ));
    }

    return values;
};

var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') {
        throw new TypeError('Encoder has to be a function.');
    }

    var charset = opts.charset || defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }

    var format = formats['default'];
    if (typeof opts.format !== 'undefined') {
        if (!has.call(formats.formatters, opts.format)) {
            throw new TypeError('Unknown format option provided.');
        }
        format = opts.format;
    }
    var formatter = formats.formatters[format];

    var filter = defaults.filter;
    if (typeof opts.filter === 'function' || isArray(opts.filter)) {
        filter = opts.filter;
    }

    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults.addQueryPrefix,
        allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        delimiter: typeof opts.delimiter === 'undefined' ? defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : defaults.encode,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (object, opts) {
    var obj = object;
    var options = normalizeStringifyOptions(opts);

    var objKeys;
    var filter;

    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }

    var keys = [];

    if (typeof obj !== 'object' || obj === null) {
        return '';
    }

    var arrayFormat;
    if (opts && opts.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = opts.arrayFormat;
    } else if (opts && 'indices' in opts) {
        arrayFormat = opts.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = 'indices';
    }

    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];
    if (opts && 'commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') {
        throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
    }
    var commaRoundTrip = generateArrayPrefix === 'comma' && opts && opts.commaRoundTrip;

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (options.sort) {
        objKeys.sort(options.sort);
    }

    var sideChannel = getSideChannel();
    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (options.skipNulls && obj[key] === null) {
            continue;
        }
        pushToArray(keys, stringify(
            obj[key],
            key,
            generateArrayPrefix,
            commaRoundTrip,
            options.strictNullHandling,
            options.skipNulls,
            options.encode ? options.encoder : null,
            options.filter,
            options.sort,
            options.allowDots,
            options.serializeDate,
            options.format,
            options.formatter,
            options.encodeValuesOnly,
            options.charset,
            sideChannel
        ));
    }

    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';

    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') {
            // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
            prefix += 'utf8=%26%2310003%3B&';
        } else {
            // encodeURIComponent('✓')
            prefix += 'utf8=%E2%9C%93&';
        }
    }

    return joined.length > 0 ? prefix + joined : '';
};

},{"./formats":136,"./utils":140,"side-channel":144}],140:[function(require,module,exports){
'use strict';

var formats = require('./formats');

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var hexTable = (function () {
    var array = [];
    for (var i = 0; i < 256; ++i) {
        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    }

    return array;
}());

var compactQueue = function compactQueue(queue) {
    while (queue.length > 1) {
        var item = queue.pop();
        var obj = item.obj[item.prop];

        if (isArray(obj)) {
            var compacted = [];

            for (var j = 0; j < obj.length; ++j) {
                if (typeof obj[j] !== 'undefined') {
                    compacted.push(obj[j]);
                }
            }

            item.obj[item.prop] = compacted;
        }
    }
};

var arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

var merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */
    if (!source) {
        return target;
    }

    if (typeof source !== 'object') {
        if (isArray(target)) {
            target.push(source);
        } else if (target && typeof target === 'object') {
            if ((options && (options.plainObjects || options.allowPrototypes)) || !has.call(Object.prototype, source)) {
                target[source] = true;
            }
        } else {
            return [target, source];
        }

        return target;
    }

    if (!target || typeof target !== 'object') {
        return [target].concat(source);
    }

    var mergeTarget = target;
    if (isArray(target) && !isArray(source)) {
        mergeTarget = arrayToObject(target, options);
    }

    if (isArray(target) && isArray(source)) {
        source.forEach(function (item, i) {
            if (has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') {
                    target[i] = merge(targetItem, item, options);
                } else {
                    target.push(item);
                }
            } else {
                target[i] = item;
            }
        });
        return target;
    }

    return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (has.call(acc, key)) {
            acc[key] = merge(acc[key], value, options);
        } else {
            acc[key] = value;
        }
        return acc;
    }, mergeTarget);
};

var assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function (acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};

var decode = function (str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') {
        // unescape never throws, no try...catch needed:
        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    }
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};

var encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = str;
    if (typeof str === 'symbol') {
        string = Symbol.prototype.toString.call(str);
    } else if (typeof str !== 'string') {
        string = String(str);
    }

    if (charset === 'iso-8859-1') {
        return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
            return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
        });
    }

    var out = '';
    for (var i = 0; i < string.length; ++i) {
        var c = string.charCodeAt(i);

        if (
            c === 0x2D // -
            || c === 0x2E // .
            || c === 0x5F // _
            || c === 0x7E // ~
            || (c >= 0x30 && c <= 0x39) // 0-9
            || (c >= 0x41 && c <= 0x5A) // a-z
            || (c >= 0x61 && c <= 0x7A) // A-Z
            || (format === formats.RFC1738 && (c === 0x28 || c === 0x29)) // ( )
        ) {
            out += string.charAt(i);
            continue;
        }

        if (c < 0x80) {
            out = out + hexTable[c];
            continue;
        }

        if (c < 0x800) {
            out = out + (hexTable[0xC0 | (c >> 6)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        if (c < 0xD800 || c >= 0xE000) {
            out = out + (hexTable[0xE0 | (c >> 12)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        i += 1;
        c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
        /* eslint operator-linebreak: [2, "before"] */
        out += hexTable[0xF0 | (c >> 18)]
            + hexTable[0x80 | ((c >> 12) & 0x3F)]
            + hexTable[0x80 | ((c >> 6) & 0x3F)]
            + hexTable[0x80 | (c & 0x3F)];
    }

    return out;
};

var compact = function compact(value) {
    var queue = [{ obj: { o: value }, prop: 'o' }];
    var refs = [];

    for (var i = 0; i < queue.length; ++i) {
        var item = queue[i];
        var obj = item.obj[item.prop];

        var keys = Object.keys(obj);
        for (var j = 0; j < keys.length; ++j) {
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({ obj: obj, prop: key });
                refs.push(val);
            }
        }
    }

    compactQueue(queue);

    return value;
};

var isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

var isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') {
        return false;
    }

    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};

var combine = function combine(a, b) {
    return [].concat(a, b);
};

var maybeMap = function maybeMap(val, fn) {
    if (isArray(val)) {
        var mapped = [];
        for (var i = 0; i < val.length; i += 1) {
            mapped.push(fn(val[i]));
        }
        return mapped;
    }
    return fn(val);
};

module.exports = {
    arrayToObject: arrayToObject,
    assign: assign,
    combine: combine,
    compact: compact,
    decode: decode,
    encode: encode,
    isBuffer: isBuffer,
    isRegExp: isRegExp,
    maybeMap: maybeMap,
    merge: merge
};

},{"./formats":136}],141:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

'use strict';

// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

module.exports = function(qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr, vstr, k, v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};

},{}],142:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

'use strict';

var stringifyPrimitive = function(v) {
  switch (typeof v) {
    case 'string':
      return v;

    case 'boolean':
      return v ? 'true' : 'false';

    case 'number':
      return isFinite(v) ? v : '';

    default:
      return '';
  }
};

module.exports = function(obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }

  if (typeof obj === 'object') {
    return map(objectKeys(obj), function(k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (isArray(obj[k])) {
        return map(obj[k], function(v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).join(sep);

  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq +
         encodeURIComponent(stringifyPrimitive(obj));
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};

function map (xs, f) {
  if (xs.map) return xs.map(f);
  var res = [];
  for (var i = 0; i < xs.length; i++) {
    res.push(f(xs[i], i));
  }
  return res;
}

var objectKeys = Object.keys || function (obj) {
  var res = [];
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
  }
  return res;
};

},{}],143:[function(require,module,exports){
'use strict';

exports.decode = exports.parse = require('./decode');
exports.encode = exports.stringify = require('./encode');

},{"./decode":141,"./encode":142}],144:[function(require,module,exports){
'use strict';

var GetIntrinsic = require('get-intrinsic');
var callBound = require('call-bind/callBound');
var inspect = require('object-inspect');

var $TypeError = GetIntrinsic('%TypeError%');
var $WeakMap = GetIntrinsic('%WeakMap%', true);
var $Map = GetIntrinsic('%Map%', true);

var $weakMapGet = callBound('WeakMap.prototype.get', true);
var $weakMapSet = callBound('WeakMap.prototype.set', true);
var $weakMapHas = callBound('WeakMap.prototype.has', true);
var $mapGet = callBound('Map.prototype.get', true);
var $mapSet = callBound('Map.prototype.set', true);
var $mapHas = callBound('Map.prototype.has', true);

/*
 * This function traverses the list returning the node corresponding to the
 * given key.
 *
 * That node is also moved to the head of the list, so that if it's accessed
 * again we don't need to traverse the whole list. By doing so, all the recently
 * used nodes can be accessed relatively quickly.
 */
var listGetNode = function (list, key) { // eslint-disable-line consistent-return
	for (var prev = list, curr; (curr = prev.next) !== null; prev = curr) {
		if (curr.key === key) {
			prev.next = curr.next;
			curr.next = list.next;
			list.next = curr; // eslint-disable-line no-param-reassign
			return curr;
		}
	}
};

var listGet = function (objects, key) {
	var node = listGetNode(objects, key);
	return node && node.value;
};
var listSet = function (objects, key, value) {
	var node = listGetNode(objects, key);
	if (node) {
		node.value = value;
	} else {
		// Prepend the new node to the beginning of the list
		objects.next = { // eslint-disable-line no-param-reassign
			key: key,
			next: objects.next,
			value: value
		};
	}
};
var listHas = function (objects, key) {
	return !!listGetNode(objects, key);
};

module.exports = function getSideChannel() {
	var $wm;
	var $m;
	var $o;
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		get: function (key) { // eslint-disable-line consistent-return
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if ($wm) {
					return $weakMapGet($wm, key);
				}
			} else if ($Map) {
				if ($m) {
					return $mapGet($m, key);
				}
			} else {
				if ($o) { // eslint-disable-line no-lonely-if
					return listGet($o, key);
				}
			}
		},
		has: function (key) {
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if ($wm) {
					return $weakMapHas($wm, key);
				}
			} else if ($Map) {
				if ($m) {
					return $mapHas($m, key);
				}
			} else {
				if ($o) { // eslint-disable-line no-lonely-if
					return listHas($o, key);
				}
			}
			return false;
		},
		set: function (key, value) {
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if (!$wm) {
					$wm = new $WeakMap();
				}
				$weakMapSet($wm, key, value);
			} else if ($Map) {
				if (!$m) {
					$m = new $Map();
				}
				$mapSet($m, key, value);
			} else {
				if (!$o) {
					/*
					 * Initialize the linked list as an empty node, so that we don't have
					 * to special-case handling of the first node: we can always refer to
					 * it as (previous node).next, instead of something like (list).head
					 */
					$o = { key: {}, next: null };
				}
				listSet($o, key, value);
			}
		}
	};
	return channel;
};

},{"call-bind/callBound":115,"get-intrinsic":120,"object-inspect":126}],145:[function(require,module,exports){
/**
 * Swiper 3.4.2
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * 
 * http://www.idangero.us/swiper/
 * 
 * Copyright 2017, Vladimir Kharlampidi
 * The iDangero.us
 * http://www.idangero.us/
 * 
 * Licensed under MIT
 * 
 * Released on: March 10, 2017
 */
(function () {
    'use strict';
    var $;

    /*===========================
    Swiper
    ===========================*/
    var Swiper = function (container, params) {
        if (!(this instanceof Swiper)) return new Swiper(container, params);
    

        var defaults = {
            direction: 'horizontal',
            touchEventsTarget: 'container',
            initialSlide: 0,
            speed: 300,
            // autoplay
            autoplay: false,
            autoplayDisableOnInteraction: true,
            autoplayStopOnLast: false,
            // To support iOS's swipe-to-go-back gesture (when being used in-app, with UIWebView).
            iOSEdgeSwipeDetection: false,
            iOSEdgeSwipeThreshold: 20,
            // Free mode
            freeMode: false,
            freeModeMomentum: true,
            freeModeMomentumRatio: 1,
            freeModeMomentumBounce: true,
            freeModeMomentumBounceRatio: 1,
            freeModeMomentumVelocityRatio: 1,
            freeModeSticky: false,
            freeModeMinimumVelocity: 0.02,
            // Autoheight
            autoHeight: false,
            // Set wrapper width
            setWrapperSize: false,
            // Virtual Translate
            virtualTranslate: false,
            // Effects
            effect: 'slide', // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
            coverflow: {
                rotate: 50,
                stretch: 0,
                depth: 100,
                modifier: 1,
                slideShadows : true
            },
            flip: {
                slideShadows : true,
                limitRotation: true
            },
            cube: {
                slideShadows: true,
                shadow: true,
                shadowOffset: 20,
                shadowScale: 0.94
            },
            fade: {
                crossFade: false
            },
            // Parallax
            parallax: false,
            // Zoom
            zoom: false,
            zoomMax: 3,
            zoomMin: 1,
            zoomToggle: true,
            // Scrollbar
            scrollbar: null,
            scrollbarHide: true,
            scrollbarDraggable: false,
            scrollbarSnapOnRelease: false,
            // Keyboard Mousewheel
            keyboardControl: false,
            mousewheelControl: false,
            mousewheelReleaseOnEdges: false,
            mousewheelInvert: false,
            mousewheelForceToAxis: false,
            mousewheelSensitivity: 1,
            mousewheelEventsTarged: 'container',
            // Hash Navigation
            hashnav: false,
            hashnavWatchState: false,
            // History
            history: false,
            // Commong Nav State
            replaceState: false,
            // Breakpoints
            breakpoints: undefined,
            // Slides grid
            spaceBetween: 0,
            slidesPerView: 1,
            slidesPerColumn: 1,
            slidesPerColumnFill: 'column',
            slidesPerGroup: 1,
            centeredSlides: false,
            slidesOffsetBefore: 0, // in px
            slidesOffsetAfter: 0, // in px
            // Round length
            roundLengths: false,
            // Touches
            touchRatio: 1,
            touchAngle: 45,
            simulateTouch: true,
            shortSwipes: true,
            longSwipes: true,
            longSwipesRatio: 0.5,
            longSwipesMs: 300,
            followFinger: true,
            onlyExternal: false,
            threshold: 0,
            touchMoveStopPropagation: true,
            touchReleaseOnEdges: false,
            // Unique Navigation Elements
            uniqueNavElements: true,
            // Pagination
            pagination: null,
            paginationElement: 'span',
            paginationClickable: false,
            paginationHide: false,
            paginationBulletRender: null,
            paginationProgressRender: null,
            paginationFractionRender: null,
            paginationCustomRender: null,
            paginationType: 'bullets', // 'bullets' or 'progress' or 'fraction' or 'custom'
            // Resistance
            resistance: true,
            resistanceRatio: 0.85,
            // Next/prev buttons
            nextButton: null,
            prevButton: null,
            // Progress
            watchSlidesProgress: false,
            watchSlidesVisibility: false,
            // Cursor
            grabCursor: false,
            // Clicks
            preventClicks: true,
            preventClicksPropagation: true,
            slideToClickedSlide: false,
            // Lazy Loading
            lazyLoading: false,
            lazyLoadingInPrevNext: false,
            lazyLoadingInPrevNextAmount: 1,
            lazyLoadingOnTransitionStart: false,
            // Images
            preloadImages: true,
            updateOnImagesReady: true,
            // loop
            loop: false,
            loopAdditionalSlides: 0,
            loopedSlides: null,
            // Control
            control: undefined,
            controlInverse: false,
            controlBy: 'slide', //or 'container'
            normalizeSlideIndex: true,
            // Swiping/no swiping
            allowSwipeToPrev: true,
            allowSwipeToNext: true,
            swipeHandler: null, //'.swipe-handler',
            noSwiping: true,
            noSwipingClass: 'swiper-no-swiping',
            // Passive Listeners
            passiveListeners: true,
            // NS
            containerModifierClass: 'swiper-container-', // NEW
            slideClass: 'swiper-slide',
            slideActiveClass: 'swiper-slide-active',
            slideDuplicateActiveClass: 'swiper-slide-duplicate-active',
            slideVisibleClass: 'swiper-slide-visible',
            slideDuplicateClass: 'swiper-slide-duplicate',
            slideNextClass: 'swiper-slide-next',
            slideDuplicateNextClass: 'swiper-slide-duplicate-next',
            slidePrevClass: 'swiper-slide-prev',
            slideDuplicatePrevClass: 'swiper-slide-duplicate-prev',
            wrapperClass: 'swiper-wrapper',
            bulletClass: 'swiper-pagination-bullet',
            bulletActiveClass: 'swiper-pagination-bullet-active',
            buttonDisabledClass: 'swiper-button-disabled',
            paginationCurrentClass: 'swiper-pagination-current',
            paginationTotalClass: 'swiper-pagination-total',
            paginationHiddenClass: 'swiper-pagination-hidden',
            paginationProgressbarClass: 'swiper-pagination-progressbar',
            paginationClickableClass: 'swiper-pagination-clickable', // NEW
            paginationModifierClass: 'swiper-pagination-', // NEW
            lazyLoadingClass: 'swiper-lazy',
            lazyStatusLoadingClass: 'swiper-lazy-loading',
            lazyStatusLoadedClass: 'swiper-lazy-loaded',
            lazyPreloaderClass: 'swiper-lazy-preloader',
            notificationClass: 'swiper-notification',
            preloaderClass: 'preloader',
            zoomContainerClass: 'swiper-zoom-container',
        
            // Observer
            observer: false,
            observeParents: false,
            // Accessibility
            a11y: false,
            prevSlideMessage: 'Previous slide',
            nextSlideMessage: 'Next slide',
            firstSlideMessage: 'This is the first slide',
            lastSlideMessage: 'This is the last slide',
            paginationBulletMessage: 'Go to slide {{index}}',
            // Callbacks
            runCallbacksOnInit: true
            /*
            Callbacks:
            onInit: function (swiper)
            onDestroy: function (swiper)
            onBeforeResize: function (swiper)
            onAfterResize: function (swiper)
            onClick: function (swiper, e)
            onTap: function (swiper, e)
            onDoubleTap: function (swiper, e)
            onSliderMove: function (swiper, e)
            onSlideChangeStart: function (swiper)
            onSlideChangeEnd: function (swiper)
            onTransitionStart: function (swiper)
            onTransitionEnd: function (swiper)
            onImagesReady: function (swiper)
            onProgress: function (swiper, progress)
            onTouchStart: function (swiper, e)
            onTouchMove: function (swiper, e)
            onTouchMoveOpposite: function (swiper, e)
            onTouchEnd: function (swiper, e)
            onReachBeginning: function (swiper)
            onReachEnd: function (swiper)
            onSetTransition: function (swiper, duration)
            onSetTranslate: function (swiper, translate)
            onAutoplayStart: function (swiper)
            onAutoplayStop: function (swiper),
            onLazyImageLoad: function (swiper, slide, image)
            onLazyImageReady: function (swiper, slide, image)
            onKeyPress: function (swiper, keyCode)
            */
        
        };
        var initialVirtualTranslate = params && params.virtualTranslate;
        
        params = params || {};
        var originalParams = {};
        for (var param in params) {
            if (typeof params[param] === 'object' && params[param] !== null && !(params[param].nodeType || params[param] === window || params[param] === document || (typeof Dom7 !== 'undefined' && params[param] instanceof Dom7) || (typeof jQuery !== 'undefined' && params[param] instanceof jQuery))) {
                originalParams[param] = {};
                for (var deepParam in params[param]) {
                    originalParams[param][deepParam] = params[param][deepParam];
                }
            }
            else {
                originalParams[param] = params[param];
            }
        }
        for (var def in defaults) {
            if (typeof params[def] === 'undefined') {
                params[def] = defaults[def];
            }
            else if (typeof params[def] === 'object') {
                for (var deepDef in defaults[def]) {
                    if (typeof params[def][deepDef] === 'undefined') {
                        params[def][deepDef] = defaults[def][deepDef];
                    }
                }
            }
        }
        
        // Swiper
        var s = this;
        
        // Params
        s.params = params;
        s.originalParams = originalParams;
        
        // Classname
        s.classNames = [];
        /*=========================
          Dom Library and plugins
          ===========================*/
        if (typeof $ !== 'undefined' && typeof Dom7 !== 'undefined'){
            $ = Dom7;
        }
        if (typeof $ === 'undefined') {
            if (typeof Dom7 === 'undefined') {
                $ = window.Dom7 || window.Zepto || window.jQuery;
            }
            else {
                $ = Dom7;
            }
            if (!$) return;
        }
        // Export it to Swiper instance
        s.$ = $;
        
        /*=========================
          Breakpoints
          ===========================*/
        s.currentBreakpoint = undefined;
        s.getActiveBreakpoint = function () {
            //Get breakpoint for window width
            if (!s.params.breakpoints) return false;
            var breakpoint = false;
            var points = [], point;
            for ( point in s.params.breakpoints ) {
                if (s.params.breakpoints.hasOwnProperty(point)) {
                    points.push(point);
                }
            }
            points.sort(function (a, b) {
                return parseInt(a, 10) > parseInt(b, 10);
            });
            for (var i = 0; i < points.length; i++) {
                point = points[i];
                if (point >= window.innerWidth && !breakpoint) {
                    breakpoint = point;
                }
            }
            return breakpoint || 'max';
        };
        s.setBreakpoint = function () {
            //Set breakpoint for window width and update parameters
            var breakpoint = s.getActiveBreakpoint();
            if (breakpoint && s.currentBreakpoint !== breakpoint) {
                var breakPointsParams = breakpoint in s.params.breakpoints ? s.params.breakpoints[breakpoint] : s.originalParams;
                var needsReLoop = s.params.loop && (breakPointsParams.slidesPerView !== s.params.slidesPerView);
                for ( var param in breakPointsParams ) {
                    s.params[param] = breakPointsParams[param];
                }
                s.currentBreakpoint = breakpoint;
                if(needsReLoop && s.destroyLoop) {
                    s.reLoop(true);
                }
            }
        };
        // Set breakpoint on load
        if (s.params.breakpoints) {
            s.setBreakpoint();
        }
        
        /*=========================
          Preparation - Define Container, Wrapper and Pagination
          ===========================*/
        s.container = $(container);
        if (s.container.length === 0) return;
        if (s.container.length > 1) {
            var swipers = [];
            s.container.each(function () {
                var container = this;
                swipers.push(new Swiper(this, params));
            });
            return swipers;
        }
        
        // Save instance in container HTML Element and in data
        s.container[0].swiper = s;
        s.container.data('swiper', s);
        
        s.classNames.push(s.params.containerModifierClass + s.params.direction);
        
        if (s.params.freeMode) {
            s.classNames.push(s.params.containerModifierClass + 'free-mode');
        }
        if (!s.support.flexbox) {
            s.classNames.push(s.params.containerModifierClass + 'no-flexbox');
            s.params.slidesPerColumn = 1;
        }
        if (s.params.autoHeight) {
            s.classNames.push(s.params.containerModifierClass + 'autoheight');
        }
        // Enable slides progress when required
        if (s.params.parallax || s.params.watchSlidesVisibility) {
            s.params.watchSlidesProgress = true;
        }
        // Max resistance when touchReleaseOnEdges
        if (s.params.touchReleaseOnEdges) {
            s.params.resistanceRatio = 0;
        }
        // Coverflow / 3D
        if (['cube', 'coverflow', 'flip'].indexOf(s.params.effect) >= 0) {
            if (s.support.transforms3d) {
                s.params.watchSlidesProgress = true;
                s.classNames.push(s.params.containerModifierClass + '3d');
            }
            else {
                s.params.effect = 'slide';
            }
        }
        if (s.params.effect !== 'slide') {
            s.classNames.push(s.params.containerModifierClass + s.params.effect);
        }
        if (s.params.effect === 'cube') {
            s.params.resistanceRatio = 0;
            s.params.slidesPerView = 1;
            s.params.slidesPerColumn = 1;
            s.params.slidesPerGroup = 1;
            s.params.centeredSlides = false;
            s.params.spaceBetween = 0;
            s.params.virtualTranslate = true;
        }
        if (s.params.effect === 'fade' || s.params.effect === 'flip') {
            s.params.slidesPerView = 1;
            s.params.slidesPerColumn = 1;
            s.params.slidesPerGroup = 1;
            s.params.watchSlidesProgress = true;
            s.params.spaceBetween = 0;
            if (typeof initialVirtualTranslate === 'undefined') {
                s.params.virtualTranslate = true;
            }
        }
        
        // Grab Cursor
        if (s.params.grabCursor && s.support.touch) {
            s.params.grabCursor = false;
        }
        
        // Wrapper
        s.wrapper = s.container.children('.' + s.params.wrapperClass);
        
        // Pagination
        if (s.params.pagination) {
            s.paginationContainer = $(s.params.pagination);
            if (s.params.uniqueNavElements && typeof s.params.pagination === 'string' && s.paginationContainer.length > 1 && s.container.find(s.params.pagination).length === 1) {
                s.paginationContainer = s.container.find(s.params.pagination);
            }
        
            if (s.params.paginationType === 'bullets' && s.params.paginationClickable) {
                s.paginationContainer.addClass(s.params.paginationModifierClass + 'clickable');
            }
            else {
                s.params.paginationClickable = false;
            }
            s.paginationContainer.addClass(s.params.paginationModifierClass + s.params.paginationType);
        }
        // Next/Prev Buttons
        if (s.params.nextButton || s.params.prevButton) {
            if (s.params.nextButton) {
                s.nextButton = $(s.params.nextButton);
                if (s.params.uniqueNavElements && typeof s.params.nextButton === 'string' && s.nextButton.length > 1 && s.container.find(s.params.nextButton).length === 1) {
                    s.nextButton = s.container.find(s.params.nextButton);
                }
            }
            if (s.params.prevButton) {
                s.prevButton = $(s.params.prevButton);
                if (s.params.uniqueNavElements && typeof s.params.prevButton === 'string' && s.prevButton.length > 1 && s.container.find(s.params.prevButton).length === 1) {
                    s.prevButton = s.container.find(s.params.prevButton);
                }
            }
        }
        
        // Is Horizontal
        s.isHorizontal = function () {
            return s.params.direction === 'horizontal';
        };
        // s.isH = isH;
        
        // RTL
        s.rtl = s.isHorizontal() && (s.container[0].dir.toLowerCase() === 'rtl' || s.container.css('direction') === 'rtl');
        if (s.rtl) {
            s.classNames.push(s.params.containerModifierClass + 'rtl');
        }
        
        // Wrong RTL support
        if (s.rtl) {
            s.wrongRTL = s.wrapper.css('display') === '-webkit-box';
        }
        
        // Columns
        if (s.params.slidesPerColumn > 1) {
            s.classNames.push(s.params.containerModifierClass + 'multirow');
        }
        
        // Check for Android
        if (s.device.android) {
            s.classNames.push(s.params.containerModifierClass + 'android');
        }
        
        // Add classes
        s.container.addClass(s.classNames.join(' '));
        
        // Translate
        s.translate = 0;
        
        // Progress
        s.progress = 0;
        
        // Velocity
        s.velocity = 0;
        
        /*=========================
          Locks, unlocks
          ===========================*/
        s.lockSwipeToNext = function () {
            s.params.allowSwipeToNext = false;
            if (s.params.allowSwipeToPrev === false && s.params.grabCursor) {
                s.unsetGrabCursor();
            }
        };
        s.lockSwipeToPrev = function () {
            s.params.allowSwipeToPrev = false;
            if (s.params.allowSwipeToNext === false && s.params.grabCursor) {
                s.unsetGrabCursor();
            }
        };
        s.lockSwipes = function () {
            s.params.allowSwipeToNext = s.params.allowSwipeToPrev = false;
            if (s.params.grabCursor) s.unsetGrabCursor();
        };
        s.unlockSwipeToNext = function () {
            s.params.allowSwipeToNext = true;
            if (s.params.allowSwipeToPrev === true && s.params.grabCursor) {
                s.setGrabCursor();
            }
        };
        s.unlockSwipeToPrev = function () {
            s.params.allowSwipeToPrev = true;
            if (s.params.allowSwipeToNext === true && s.params.grabCursor) {
                s.setGrabCursor();
            }
        };
        s.unlockSwipes = function () {
            s.params.allowSwipeToNext = s.params.allowSwipeToPrev = true;
            if (s.params.grabCursor) s.setGrabCursor();
        };
        
        /*=========================
          Round helper
          ===========================*/
        function round(a) {
            return Math.floor(a);
        }
        /*=========================
          Set grab cursor
          ===========================*/
        s.setGrabCursor = function(moving) {
            s.container[0].style.cursor = 'move';
            s.container[0].style.cursor = moving ? '-webkit-grabbing' : '-webkit-grab';
            s.container[0].style.cursor = moving ? '-moz-grabbin' : '-moz-grab';
            s.container[0].style.cursor = moving ? 'grabbing': 'grab';
        };
        s.unsetGrabCursor = function () {
            s.container[0].style.cursor = '';
        };
        if (s.params.grabCursor) {
            s.setGrabCursor();
        }
        /*=========================
          Update on Images Ready
          ===========================*/
        s.imagesToLoad = [];
        s.imagesLoaded = 0;
        
        s.loadImage = function (imgElement, src, srcset, sizes, checkForComplete, callback) {
            var image;
            function onReady () {
                if (callback) callback();
            }
            if (!imgElement.complete || !checkForComplete) {
                if (src) {
                    image = new window.Image();
                    image.onload = onReady;
                    image.onerror = onReady;
                    if (sizes) {
                        image.sizes = sizes;
                    }
                    if (srcset) {
                        image.srcset = srcset;
                    }
                    if (src) {
                        image.src = src;
                    }
                } else {
                    onReady();
                }
        
            } else {//image already loaded...
                onReady();
            }
        };
        s.preloadImages = function () {
            s.imagesToLoad = s.container.find('img');
            function _onReady() {
                if (typeof s === 'undefined' || s === null || !s) return;
                if (s.imagesLoaded !== undefined) s.imagesLoaded++;
                if (s.imagesLoaded === s.imagesToLoad.length) {
                    if (s.params.updateOnImagesReady) s.update();
                    s.emit('onImagesReady', s);
                }
            }
            for (var i = 0; i < s.imagesToLoad.length; i++) {
                s.loadImage(s.imagesToLoad[i], (s.imagesToLoad[i].currentSrc || s.imagesToLoad[i].getAttribute('src')), (s.imagesToLoad[i].srcset || s.imagesToLoad[i].getAttribute('srcset')), s.imagesToLoad[i].sizes || s.imagesToLoad[i].getAttribute('sizes'), true, _onReady);
            }
        };
        
        /*=========================
          Autoplay
          ===========================*/
        s.autoplayTimeoutId = undefined;
        s.autoplaying = false;
        s.autoplayPaused = false;
        function autoplay() {
            var autoplayDelay = s.params.autoplay;
            var activeSlide = s.slides.eq(s.activeIndex);
            if (activeSlide.attr('data-swiper-autoplay')) {
                autoplayDelay = activeSlide.attr('data-swiper-autoplay') || s.params.autoplay;
            }
            s.autoplayTimeoutId = setTimeout(function () {
                if (s.params.loop) {
                    s.fixLoop();
                    s._slideNext();
                    s.emit('onAutoplay', s);
                }
                else {
                    if (!s.isEnd) {
                        s._slideNext();
                        s.emit('onAutoplay', s);
                    }
                    else {
                        if (!params.autoplayStopOnLast) {
                            s._slideTo(0);
                            s.emit('onAutoplay', s);
                        }
                        else {
                            s.stopAutoplay();
                        }
                    }
                }
            }, autoplayDelay);
        }
        s.startAutoplay = function () {
            if (typeof s.autoplayTimeoutId !== 'undefined') return false;
            if (!s.params.autoplay) return false;
            if (s.autoplaying) return false;
            s.autoplaying = true;
            s.emit('onAutoplayStart', s);
            autoplay();
        };
        s.stopAutoplay = function (internal) {
            if (!s.autoplayTimeoutId) return;
            if (s.autoplayTimeoutId) clearTimeout(s.autoplayTimeoutId);
            s.autoplaying = false;
            s.autoplayTimeoutId = undefined;
            s.emit('onAutoplayStop', s);
        };
        s.pauseAutoplay = function (speed) {
            if (s.autoplayPaused) return;
            if (s.autoplayTimeoutId) clearTimeout(s.autoplayTimeoutId);
            s.autoplayPaused = true;
            if (speed === 0) {
                s.autoplayPaused = false;
                autoplay();
            }
            else {
                s.wrapper.transitionEnd(function () {
                    if (!s) return;
                    s.autoplayPaused = false;
                    if (!s.autoplaying) {
                        s.stopAutoplay();
                    }
                    else {
                        autoplay();
                    }
                });
            }
        };
        /*=========================
          Min/Max Translate
          ===========================*/
        s.minTranslate = function () {
            return (-s.snapGrid[0]);
        };
        s.maxTranslate = function () {
            return (-s.snapGrid[s.snapGrid.length - 1]);
        };
        /*=========================
          Slider/slides sizes
          ===========================*/
        s.updateAutoHeight = function () {
            var activeSlides = [];
            var newHeight = 0;
            var i;
        
            // Find slides currently in view
            if(s.params.slidesPerView !== 'auto' && s.params.slidesPerView > 1) {
                for (i = 0; i < Math.ceil(s.params.slidesPerView); i++) {
                    var index = s.activeIndex + i;
                    if(index > s.slides.length) break;
                    activeSlides.push(s.slides.eq(index)[0]);
                }
            } else {
                activeSlides.push(s.slides.eq(s.activeIndex)[0]);
            }
        
            // Find new height from heighest slide in view
            for (i = 0; i < activeSlides.length; i++) {
                if (typeof activeSlides[i] !== 'undefined') {
                    var height = activeSlides[i].offsetHeight;
                    newHeight = height > newHeight ? height : newHeight;
                }
            }
        
            // Update Height
            if (newHeight) s.wrapper.css('height', newHeight + 'px');
        };
        s.updateContainerSize = function () {
            var width, height;
            if (typeof s.params.width !== 'undefined') {
                width = s.params.width;
            }
            else {
                width = s.container[0].clientWidth;
            }
            if (typeof s.params.height !== 'undefined') {
                height = s.params.height;
            }
            else {
                height = s.container[0].clientHeight;
            }
            if (width === 0 && s.isHorizontal() || height === 0 && !s.isHorizontal()) {
                return;
            }
        
            //Subtract paddings
            width = width - parseInt(s.container.css('padding-left'), 10) - parseInt(s.container.css('padding-right'), 10);
            height = height - parseInt(s.container.css('padding-top'), 10) - parseInt(s.container.css('padding-bottom'), 10);
        
            // Store values
            s.width = width;
            s.height = height;
            s.size = s.isHorizontal() ? s.width : s.height;
        };
        
        s.updateSlidesSize = function () {
            s.slides = s.wrapper.children('.' + s.params.slideClass);
            s.snapGrid = [];
            s.slidesGrid = [];
            s.slidesSizesGrid = [];
        
            var spaceBetween = s.params.spaceBetween,
                slidePosition = -s.params.slidesOffsetBefore,
                i,
                prevSlideSize = 0,
                index = 0;
            if (typeof s.size === 'undefined') return;
            if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
                spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * s.size;
            }
        
            s.virtualSize = -spaceBetween;
            // reset margins
            if (s.rtl) s.slides.css({marginLeft: '', marginTop: ''});
            else s.slides.css({marginRight: '', marginBottom: ''});
        
            var slidesNumberEvenToRows;
            if (s.params.slidesPerColumn > 1) {
                if (Math.floor(s.slides.length / s.params.slidesPerColumn) === s.slides.length / s.params.slidesPerColumn) {
                    slidesNumberEvenToRows = s.slides.length;
                }
                else {
                    slidesNumberEvenToRows = Math.ceil(s.slides.length / s.params.slidesPerColumn) * s.params.slidesPerColumn;
                }
                if (s.params.slidesPerView !== 'auto' && s.params.slidesPerColumnFill === 'row') {
                    slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, s.params.slidesPerView * s.params.slidesPerColumn);
                }
            }
        
            // Calc slides
            var slideSize;
            var slidesPerColumn = s.params.slidesPerColumn;
            var slidesPerRow = slidesNumberEvenToRows / slidesPerColumn;
            var numFullColumns = slidesPerRow - (s.params.slidesPerColumn * slidesPerRow - s.slides.length);
            for (i = 0; i < s.slides.length; i++) {
                slideSize = 0;
                var slide = s.slides.eq(i);
                if (s.params.slidesPerColumn > 1) {
                    // Set slides order
                    var newSlideOrderIndex;
                    var column, row;
                    if (s.params.slidesPerColumnFill === 'column') {
                        column = Math.floor(i / slidesPerColumn);
                        row = i - column * slidesPerColumn;
                        if (column > numFullColumns || (column === numFullColumns && row === slidesPerColumn-1)) {
                            if (++row >= slidesPerColumn) {
                                row = 0;
                                column++;
                            }
                        }
                        newSlideOrderIndex = column + row * slidesNumberEvenToRows / slidesPerColumn;
                        slide
                            .css({
                                '-webkit-box-ordinal-group': newSlideOrderIndex,
                                '-moz-box-ordinal-group': newSlideOrderIndex,
                                '-ms-flex-order': newSlideOrderIndex,
                                '-webkit-order': newSlideOrderIndex,
                                'order': newSlideOrderIndex
                            });
                    }
                    else {
                        row = Math.floor(i / slidesPerRow);
                        column = i - row * slidesPerRow;
                    }
                    slide
                        .css(
                            'margin-' + (s.isHorizontal() ? 'top' : 'left'),
                            (row !== 0 && s.params.spaceBetween) && (s.params.spaceBetween + 'px')
                        )
                        .attr('data-swiper-column', column)
                        .attr('data-swiper-row', row);
        
                }
                if (slide.css('display') === 'none') continue;
                if (s.params.slidesPerView === 'auto') {
                    slideSize = s.isHorizontal() ? slide.outerWidth(true) : slide.outerHeight(true);
                    if (s.params.roundLengths) slideSize = round(slideSize);
                }
                else {
                    slideSize = (s.size - (s.params.slidesPerView - 1) * spaceBetween) / s.params.slidesPerView;
                    if (s.params.roundLengths) slideSize = round(slideSize);
        
                    if (s.isHorizontal()) {
                        s.slides[i].style.width = slideSize + 'px';
                    }
                    else {
                        s.slides[i].style.height = slideSize + 'px';
                    }
                }
                s.slides[i].swiperSlideSize = slideSize;
                s.slidesSizesGrid.push(slideSize);
        
        
                if (s.params.centeredSlides) {
                    slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
                    if(prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - s.size / 2 - spaceBetween;
                    if (i === 0) slidePosition = slidePosition - s.size / 2 - spaceBetween;
                    if (Math.abs(slidePosition) < 1 / 1000) slidePosition = 0;
                    if ((index) % s.params.slidesPerGroup === 0) s.snapGrid.push(slidePosition);
                    s.slidesGrid.push(slidePosition);
                }
                else {
                    if ((index) % s.params.slidesPerGroup === 0) s.snapGrid.push(slidePosition);
                    s.slidesGrid.push(slidePosition);
                    slidePosition = slidePosition + slideSize + spaceBetween;
                }
        
                s.virtualSize += slideSize + spaceBetween;
        
                prevSlideSize = slideSize;
        
                index ++;
            }
            s.virtualSize = Math.max(s.virtualSize, s.size) + s.params.slidesOffsetAfter;
            var newSlidesGrid;
        
            if (
                s.rtl && s.wrongRTL && (s.params.effect === 'slide' || s.params.effect === 'coverflow')) {
                s.wrapper.css({width: s.virtualSize + s.params.spaceBetween + 'px'});
            }
            if (!s.support.flexbox || s.params.setWrapperSize) {
                if (s.isHorizontal()) s.wrapper.css({width: s.virtualSize + s.params.spaceBetween + 'px'});
                else s.wrapper.css({height: s.virtualSize + s.params.spaceBetween + 'px'});
            }
        
            if (s.params.slidesPerColumn > 1) {
                s.virtualSize = (slideSize + s.params.spaceBetween) * slidesNumberEvenToRows;
                s.virtualSize = Math.ceil(s.virtualSize / s.params.slidesPerColumn) - s.params.spaceBetween;
                if (s.isHorizontal()) s.wrapper.css({width: s.virtualSize + s.params.spaceBetween + 'px'});
                else s.wrapper.css({height: s.virtualSize + s.params.spaceBetween + 'px'});
                if (s.params.centeredSlides) {
                    newSlidesGrid = [];
                    for (i = 0; i < s.snapGrid.length; i++) {
                        if (s.snapGrid[i] < s.virtualSize + s.snapGrid[0]) newSlidesGrid.push(s.snapGrid[i]);
                    }
                    s.snapGrid = newSlidesGrid;
                }
            }
        
            // Remove last grid elements depending on width
            if (!s.params.centeredSlides) {
                newSlidesGrid = [];
                for (i = 0; i < s.snapGrid.length; i++) {
                    if (s.snapGrid[i] <= s.virtualSize - s.size) {
                        newSlidesGrid.push(s.snapGrid[i]);
                    }
                }
                s.snapGrid = newSlidesGrid;
                if (Math.floor(s.virtualSize - s.size) - Math.floor(s.snapGrid[s.snapGrid.length - 1]) > 1) {
                    s.snapGrid.push(s.virtualSize - s.size);
                }
            }
            if (s.snapGrid.length === 0) s.snapGrid = [0];
        
            if (s.params.spaceBetween !== 0) {
                if (s.isHorizontal()) {
                    if (s.rtl) s.slides.css({marginLeft: spaceBetween + 'px'});
                    else s.slides.css({marginRight: spaceBetween + 'px'});
                }
                else s.slides.css({marginBottom: spaceBetween + 'px'});
            }
            if (s.params.watchSlidesProgress) {
                s.updateSlidesOffset();
            }
        };
        s.updateSlidesOffset = function () {
            for (var i = 0; i < s.slides.length; i++) {
                s.slides[i].swiperSlideOffset = s.isHorizontal() ? s.slides[i].offsetLeft : s.slides[i].offsetTop;
            }
        };
        
        /*=========================
          Dynamic Slides Per View
          ===========================*/
        s.currentSlidesPerView = function () {
            var spv = 1, i, j;
            if (s.params.centeredSlides) {
                var size = s.slides[s.activeIndex].swiperSlideSize;
                var breakLoop;
                for (i = s.activeIndex + 1; i < s.slides.length; i++) {
                    if (s.slides[i] && !breakLoop) {
                        size += s.slides[i].swiperSlideSize;
                        spv ++;
                        if (size > s.size) breakLoop = true;
                    }
                }
                for (j = s.activeIndex - 1; j >= 0; j--) {
                    if (s.slides[j] && !breakLoop) {
                        size += s.slides[j].swiperSlideSize;
                        spv ++;
                        if (size > s.size) breakLoop = true;
                    }
                }
            }
            else {
                for (i = s.activeIndex + 1; i < s.slides.length; i++) {
                    if (s.slidesGrid[i] - s.slidesGrid[s.activeIndex] < s.size) {
                        spv++;
                    }
                }
            }
            return spv;
        };
        /*=========================
          Slider/slides progress
          ===========================*/
        s.updateSlidesProgress = function (translate) {
            if (typeof translate === 'undefined') {
                translate = s.translate || 0;
            }
            if (s.slides.length === 0) return;
            if (typeof s.slides[0].swiperSlideOffset === 'undefined') s.updateSlidesOffset();
        
            var offsetCenter = -translate;
            if (s.rtl) offsetCenter = translate;
        
            // Visible Slides
            s.slides.removeClass(s.params.slideVisibleClass);
            for (var i = 0; i < s.slides.length; i++) {
                var slide = s.slides[i];
                var slideProgress = (offsetCenter + (s.params.centeredSlides ? s.minTranslate() : 0) - slide.swiperSlideOffset) / (slide.swiperSlideSize + s.params.spaceBetween);
                if (s.params.watchSlidesVisibility) {
                    var slideBefore = -(offsetCenter - slide.swiperSlideOffset);
                    var slideAfter = slideBefore + s.slidesSizesGrid[i];
                    var isVisible =
                        (slideBefore >= 0 && slideBefore < s.size) ||
                        (slideAfter > 0 && slideAfter <= s.size) ||
                        (slideBefore <= 0 && slideAfter >= s.size);
                    if (isVisible) {
                        s.slides.eq(i).addClass(s.params.slideVisibleClass);
                    }
                }
                slide.progress = s.rtl ? -slideProgress : slideProgress;
            }
        };
        s.updateProgress = function (translate) {
            if (typeof translate === 'undefined') {
                translate = s.translate || 0;
            }
            var translatesDiff = s.maxTranslate() - s.minTranslate();
            var wasBeginning = s.isBeginning;
            var wasEnd = s.isEnd;
            if (translatesDiff === 0) {
                s.progress = 0;
                s.isBeginning = s.isEnd = true;
            }
            else {
                s.progress = (translate - s.minTranslate()) / (translatesDiff);
                s.isBeginning = s.progress <= 0;
                s.isEnd = s.progress >= 1;
            }
            if (s.isBeginning && !wasBeginning) s.emit('onReachBeginning', s);
            if (s.isEnd && !wasEnd) s.emit('onReachEnd', s);
        
            if (s.params.watchSlidesProgress) s.updateSlidesProgress(translate);
            s.emit('onProgress', s, s.progress);
        };
        s.updateActiveIndex = function () {
            var translate = s.rtl ? s.translate : -s.translate;
            var newActiveIndex, i, snapIndex;
            for (i = 0; i < s.slidesGrid.length; i ++) {
                if (typeof s.slidesGrid[i + 1] !== 'undefined') {
                    if (translate >= s.slidesGrid[i] && translate < s.slidesGrid[i + 1] - (s.slidesGrid[i + 1] - s.slidesGrid[i]) / 2) {
                        newActiveIndex = i;
                    }
                    else if (translate >= s.slidesGrid[i] && translate < s.slidesGrid[i + 1]) {
                        newActiveIndex = i + 1;
                    }
                }
                else {
                    if (translate >= s.slidesGrid[i]) {
                        newActiveIndex = i;
                    }
                }
            }
            // Normalize slideIndex
            if(s.params.normalizeSlideIndex){
                if (newActiveIndex < 0 || typeof newActiveIndex === 'undefined') newActiveIndex = 0;
            }
            // for (i = 0; i < s.slidesGrid.length; i++) {
                // if (- translate >= s.slidesGrid[i]) {
                    // newActiveIndex = i;
                // }
            // }
            snapIndex = Math.floor(newActiveIndex / s.params.slidesPerGroup);
            if (snapIndex >= s.snapGrid.length) snapIndex = s.snapGrid.length - 1;
        
            if (newActiveIndex === s.activeIndex) {
                return;
            }
            s.snapIndex = snapIndex;
            s.previousIndex = s.activeIndex;
            s.activeIndex = newActiveIndex;
            s.updateClasses();
            s.updateRealIndex();
        };
        s.updateRealIndex = function(){
            s.realIndex = parseInt(s.slides.eq(s.activeIndex).attr('data-swiper-slide-index') || s.activeIndex, 10);
        };
        
        /*=========================
          Classes
          ===========================*/
        s.updateClasses = function () {
            s.slides.removeClass(s.params.slideActiveClass + ' ' + s.params.slideNextClass + ' ' + s.params.slidePrevClass + ' ' + s.params.slideDuplicateActiveClass + ' ' + s.params.slideDuplicateNextClass + ' ' + s.params.slideDuplicatePrevClass);
            var activeSlide = s.slides.eq(s.activeIndex);
            // Active classes
            activeSlide.addClass(s.params.slideActiveClass);
            if (params.loop) {
                // Duplicate to all looped slides
                if (activeSlide.hasClass(s.params.slideDuplicateClass)) {
                    s.wrapper.children('.' + s.params.slideClass + ':not(.' + s.params.slideDuplicateClass + ')[data-swiper-slide-index="' + s.realIndex + '"]').addClass(s.params.slideDuplicateActiveClass);
                }
                else {
                    s.wrapper.children('.' + s.params.slideClass + '.' + s.params.slideDuplicateClass + '[data-swiper-slide-index="' + s.realIndex + '"]').addClass(s.params.slideDuplicateActiveClass);
                }
            }
            // Next Slide
            var nextSlide = activeSlide.next('.' + s.params.slideClass).addClass(s.params.slideNextClass);
            if (s.params.loop && nextSlide.length === 0) {
                nextSlide = s.slides.eq(0);
                nextSlide.addClass(s.params.slideNextClass);
            }
            // Prev Slide
            var prevSlide = activeSlide.prev('.' + s.params.slideClass).addClass(s.params.slidePrevClass);
            if (s.params.loop && prevSlide.length === 0) {
                prevSlide = s.slides.eq(-1);
                prevSlide.addClass(s.params.slidePrevClass);
            }
            if (params.loop) {
                // Duplicate to all looped slides
                if (nextSlide.hasClass(s.params.slideDuplicateClass)) {
                    s.wrapper.children('.' + s.params.slideClass + ':not(.' + s.params.slideDuplicateClass + ')[data-swiper-slide-index="' + nextSlide.attr('data-swiper-slide-index') + '"]').addClass(s.params.slideDuplicateNextClass);
                }
                else {
                    s.wrapper.children('.' + s.params.slideClass + '.' + s.params.slideDuplicateClass + '[data-swiper-slide-index="' + nextSlide.attr('data-swiper-slide-index') + '"]').addClass(s.params.slideDuplicateNextClass);
                }
                if (prevSlide.hasClass(s.params.slideDuplicateClass)) {
                    s.wrapper.children('.' + s.params.slideClass + ':not(.' + s.params.slideDuplicateClass + ')[data-swiper-slide-index="' + prevSlide.attr('data-swiper-slide-index') + '"]').addClass(s.params.slideDuplicatePrevClass);
                }
                else {
                    s.wrapper.children('.' + s.params.slideClass + '.' + s.params.slideDuplicateClass + '[data-swiper-slide-index="' + prevSlide.attr('data-swiper-slide-index') + '"]').addClass(s.params.slideDuplicatePrevClass);
                }
            }
        
            // Pagination
            if (s.paginationContainer && s.paginationContainer.length > 0) {
                // Current/Total
                var current,
                    total = s.params.loop ? Math.ceil((s.slides.length - s.loopedSlides * 2) / s.params.slidesPerGroup) : s.snapGrid.length;
                if (s.params.loop) {
                    current = Math.ceil((s.activeIndex - s.loopedSlides)/s.params.slidesPerGroup);
                    if (current > s.slides.length - 1 - s.loopedSlides * 2) {
                        current = current - (s.slides.length - s.loopedSlides * 2);
                    }
                    if (current > total - 1) current = current - total;
                    if (current < 0 && s.params.paginationType !== 'bullets') current = total + current;
                }
                else {
                    if (typeof s.snapIndex !== 'undefined') {
                        current = s.snapIndex;
                    }
                    else {
                        current = s.activeIndex || 0;
                    }
                }
                // Types
                if (s.params.paginationType === 'bullets' && s.bullets && s.bullets.length > 0) {
                    s.bullets.removeClass(s.params.bulletActiveClass);
                    if (s.paginationContainer.length > 1) {
                        s.bullets.each(function () {
                            if ($(this).index() === current) $(this).addClass(s.params.bulletActiveClass);
                        });
                    }
                    else {
                        s.bullets.eq(current).addClass(s.params.bulletActiveClass);
                    }
                }
                if (s.params.paginationType === 'fraction') {
                    s.paginationContainer.find('.' + s.params.paginationCurrentClass).text(current + 1);
                    s.paginationContainer.find('.' + s.params.paginationTotalClass).text(total);
                }
                if (s.params.paginationType === 'progress') {
                    var scale = (current + 1) / total,
                        scaleX = scale,
                        scaleY = 1;
                    if (!s.isHorizontal()) {
                        scaleY = scale;
                        scaleX = 1;
                    }
                    s.paginationContainer.find('.' + s.params.paginationProgressbarClass).transform('translate3d(0,0,0) scaleX(' + scaleX + ') scaleY(' + scaleY + ')').transition(s.params.speed);
                }
                if (s.params.paginationType === 'custom' && s.params.paginationCustomRender) {
                    s.paginationContainer.html(s.params.paginationCustomRender(s, current + 1, total));
                    s.emit('onPaginationRendered', s, s.paginationContainer[0]);
                }
            }
        
            // Next/active buttons
            if (!s.params.loop) {
                if (s.params.prevButton && s.prevButton && s.prevButton.length > 0) {
                    if (s.isBeginning) {
                        s.prevButton.addClass(s.params.buttonDisabledClass);
                        if (s.params.a11y && s.a11y) s.a11y.disable(s.prevButton);
                    }
                    else {
                        s.prevButton.removeClass(s.params.buttonDisabledClass);
                        if (s.params.a11y && s.a11y) s.a11y.enable(s.prevButton);
                    }
                }
                if (s.params.nextButton && s.nextButton && s.nextButton.length > 0) {
                    if (s.isEnd) {
                        s.nextButton.addClass(s.params.buttonDisabledClass);
                        if (s.params.a11y && s.a11y) s.a11y.disable(s.nextButton);
                    }
                    else {
                        s.nextButton.removeClass(s.params.buttonDisabledClass);
                        if (s.params.a11y && s.a11y) s.a11y.enable(s.nextButton);
                    }
                }
            }
        };
        
        /*=========================
          Pagination
          ===========================*/
        s.updatePagination = function () {
            if (!s.params.pagination) return;
            if (s.paginationContainer && s.paginationContainer.length > 0) {
                var paginationHTML = '';
                if (s.params.paginationType === 'bullets') {
                    var numberOfBullets = s.params.loop ? Math.ceil((s.slides.length - s.loopedSlides * 2) / s.params.slidesPerGroup) : s.snapGrid.length;
                    for (var i = 0; i < numberOfBullets; i++) {
                        if (s.params.paginationBulletRender) {
                            paginationHTML += s.params.paginationBulletRender(s, i, s.params.bulletClass);
                        }
                        else {
                            paginationHTML += '<' + s.params.paginationElement+' class="' + s.params.bulletClass + '"></' + s.params.paginationElement + '>';
                        }
                    }
                    s.paginationContainer.html(paginationHTML);
                    s.bullets = s.paginationContainer.find('.' + s.params.bulletClass);
                    if (s.params.paginationClickable && s.params.a11y && s.a11y) {
                        s.a11y.initPagination();
                    }
                }
                if (s.params.paginationType === 'fraction') {
                    if (s.params.paginationFractionRender) {
                        paginationHTML = s.params.paginationFractionRender(s, s.params.paginationCurrentClass, s.params.paginationTotalClass);
                    }
                    else {
                        paginationHTML =
                            '<span class="' + s.params.paginationCurrentClass + '"></span>' +
                            ' / ' +
                            '<span class="' + s.params.paginationTotalClass+'"></span>';
                    }
                    s.paginationContainer.html(paginationHTML);
                }
                if (s.params.paginationType === 'progress') {
                    if (s.params.paginationProgressRender) {
                        paginationHTML = s.params.paginationProgressRender(s, s.params.paginationProgressbarClass);
                    }
                    else {
                        paginationHTML = '<span class="' + s.params.paginationProgressbarClass + '"></span>';
                    }
                    s.paginationContainer.html(paginationHTML);
                }
                if (s.params.paginationType !== 'custom') {
                    s.emit('onPaginationRendered', s, s.paginationContainer[0]);
                }
            }
        };
        /*=========================
          Common update method
          ===========================*/
        s.update = function (updateTranslate) {
            if (!s) return;
            s.updateContainerSize();
            s.updateSlidesSize();
            s.updateProgress();
            s.updatePagination();
            s.updateClasses();
            if (s.params.scrollbar && s.scrollbar) {
                s.scrollbar.set();
            }
            var newTranslate;
            function forceSetTranslate() {
                var translate = s.rtl ? -s.translate : s.translate;
                newTranslate = Math.min(Math.max(s.translate, s.maxTranslate()), s.minTranslate());
                s.setWrapperTranslate(newTranslate);
                s.updateActiveIndex();
                s.updateClasses();
            }
            if (updateTranslate) {
                var translated;
                if (s.controller && s.controller.spline) {
                    s.controller.spline = undefined;
                }
                if (s.params.freeMode) {
                    forceSetTranslate();
                    if (s.params.autoHeight) {
                        s.updateAutoHeight();
                    }
                }
                else {
                    if ((s.params.slidesPerView === 'auto' || s.params.slidesPerView > 1) && s.isEnd && !s.params.centeredSlides) {
                        translated = s.slideTo(s.slides.length - 1, 0, false, true);
                    }
                    else {
                        translated = s.slideTo(s.activeIndex, 0, false, true);
                    }
                    if (!translated) {
                        forceSetTranslate();
                    }
                }
            }
            else if (s.params.autoHeight) {
                s.updateAutoHeight();
            }
        };
        
        /*=========================
          Resize Handler
          ===========================*/
        s.onResize = function (forceUpdatePagination) {
            if (s.params.onBeforeResize) s.params.onBeforeResize(s);
            //Breakpoints
            if (s.params.breakpoints) {
                s.setBreakpoint();
            }
        
            // Disable locks on resize
            var allowSwipeToPrev = s.params.allowSwipeToPrev;
            var allowSwipeToNext = s.params.allowSwipeToNext;
            s.params.allowSwipeToPrev = s.params.allowSwipeToNext = true;
        
            s.updateContainerSize();
            s.updateSlidesSize();
            if (s.params.slidesPerView === 'auto' || s.params.freeMode || forceUpdatePagination) s.updatePagination();
            if (s.params.scrollbar && s.scrollbar) {
                s.scrollbar.set();
            }
            if (s.controller && s.controller.spline) {
                s.controller.spline = undefined;
            }
            var slideChangedBySlideTo = false;
            if (s.params.freeMode) {
                var newTranslate = Math.min(Math.max(s.translate, s.maxTranslate()), s.minTranslate());
                s.setWrapperTranslate(newTranslate);
                s.updateActiveIndex();
                s.updateClasses();
        
                if (s.params.autoHeight) {
                    s.updateAutoHeight();
                }
            }
            else {
                s.updateClasses();
                if ((s.params.slidesPerView === 'auto' || s.params.slidesPerView > 1) && s.isEnd && !s.params.centeredSlides) {
                    slideChangedBySlideTo = s.slideTo(s.slides.length - 1, 0, false, true);
                }
                else {
                    slideChangedBySlideTo = s.slideTo(s.activeIndex, 0, false, true);
                }
            }
            if (s.params.lazyLoading && !slideChangedBySlideTo && s.lazy) {
                s.lazy.load();
            }
            // Return locks after resize
            s.params.allowSwipeToPrev = allowSwipeToPrev;
            s.params.allowSwipeToNext = allowSwipeToNext;
            if (s.params.onAfterResize) s.params.onAfterResize(s);
        };
        
        /*=========================
          Events
          ===========================*/
        
        //Define Touch Events
        s.touchEventsDesktop = {start: 'mousedown', move: 'mousemove', end: 'mouseup'};
        if (window.navigator.pointerEnabled) s.touchEventsDesktop = {start: 'pointerdown', move: 'pointermove', end: 'pointerup'};
        else if (window.navigator.msPointerEnabled) s.touchEventsDesktop = {start: 'MSPointerDown', move: 'MSPointerMove', end: 'MSPointerUp'};
        s.touchEvents = {
            start : s.support.touch || !s.params.simulateTouch  ? 'touchstart' : s.touchEventsDesktop.start,
            move : s.support.touch || !s.params.simulateTouch ? 'touchmove' : s.touchEventsDesktop.move,
            end : s.support.touch || !s.params.simulateTouch ? 'touchend' : s.touchEventsDesktop.end
        };
        
        
        // WP8 Touch Events Fix
        if (window.navigator.pointerEnabled || window.navigator.msPointerEnabled) {
            (s.params.touchEventsTarget === 'container' ? s.container : s.wrapper).addClass('swiper-wp8-' + s.params.direction);
        }
        
        // Attach/detach events
        s.initEvents = function (detach) {
            var actionDom = detach ? 'off' : 'on';
            var action = detach ? 'removeEventListener' : 'addEventListener';
            var touchEventsTarget = s.params.touchEventsTarget === 'container' ? s.container[0] : s.wrapper[0];
            var target = s.support.touch ? touchEventsTarget : document;
        
            var moveCapture = s.params.nested ? true : false;
        
            //Touch Events
            if (s.browser.ie) {
                touchEventsTarget[action](s.touchEvents.start, s.onTouchStart, false);
                target[action](s.touchEvents.move, s.onTouchMove, moveCapture);
                target[action](s.touchEvents.end, s.onTouchEnd, false);
            }
            else {
                if (s.support.touch) {
                    var passiveListener = s.touchEvents.start === 'touchstart' && s.support.passiveListener && s.params.passiveListeners ? {passive: true, capture: false} : false;
                    touchEventsTarget[action](s.touchEvents.start, s.onTouchStart, passiveListener);
                    touchEventsTarget[action](s.touchEvents.move, s.onTouchMove, moveCapture);
                    touchEventsTarget[action](s.touchEvents.end, s.onTouchEnd, passiveListener);
                }
                if ((params.simulateTouch && !s.device.ios && !s.device.android) || (params.simulateTouch && !s.support.touch && s.device.ios)) {
                    touchEventsTarget[action]('mousedown', s.onTouchStart, false);
                    document[action]('mousemove', s.onTouchMove, moveCapture);
                    document[action]('mouseup', s.onTouchEnd, false);
                }
            }
            window[action]('resize', s.onResize);
        
            // Next, Prev, Index
            if (s.params.nextButton && s.nextButton && s.nextButton.length > 0) {
                s.nextButton[actionDom]('click', s.onClickNext);
                if (s.params.a11y && s.a11y) s.nextButton[actionDom]('keydown', s.a11y.onEnterKey);
            }
            if (s.params.prevButton && s.prevButton && s.prevButton.length > 0) {
                s.prevButton[actionDom]('click', s.onClickPrev);
                if (s.params.a11y && s.a11y) s.prevButton[actionDom]('keydown', s.a11y.onEnterKey);
            }
            if (s.params.pagination && s.params.paginationClickable) {
                s.paginationContainer[actionDom]('click', '.' + s.params.bulletClass, s.onClickIndex);
                if (s.params.a11y && s.a11y) s.paginationContainer[actionDom]('keydown', '.' + s.params.bulletClass, s.a11y.onEnterKey);
            }
        
            // Prevent Links Clicks
            if (s.params.preventClicks || s.params.preventClicksPropagation) touchEventsTarget[action]('click', s.preventClicks, true);
        };
        s.attachEvents = function () {
            s.initEvents();
        };
        s.detachEvents = function () {
            s.initEvents(true);
        };
        
        /*=========================
          Handle Clicks
          ===========================*/
        // Prevent Clicks
        s.allowClick = true;
        s.preventClicks = function (e) {
            if (!s.allowClick) {
                if (s.params.preventClicks) e.preventDefault();
                if (s.params.preventClicksPropagation && s.animating) {
                    e.stopPropagation();
                    e.stopImmediatePropagation();
                }
            }
        };
        // Clicks
        s.onClickNext = function (e) {
            e.preventDefault();
            if (s.isEnd && !s.params.loop) return;
            s.slideNext();
        };
        s.onClickPrev = function (e) {
            e.preventDefault();
            if (s.isBeginning && !s.params.loop) return;
            s.slidePrev();
        };
        s.onClickIndex = function (e) {
            e.preventDefault();
            var index = $(this).index() * s.params.slidesPerGroup;
            if (s.params.loop) index = index + s.loopedSlides;
            s.slideTo(index);
        };
        
        /*=========================
          Handle Touches
          ===========================*/
        function findElementInEvent(e, selector) {
            var el = $(e.target);
            if (!el.is(selector)) {
                if (typeof selector === 'string') {
                    el = el.parents(selector);
                }
                else if (selector.nodeType) {
                    var found;
                    el.parents().each(function (index, _el) {
                        if (_el === selector) found = selector;
                    });
                    if (!found) return undefined;
                    else return selector;
                }
            }
            if (el.length === 0) {
                return undefined;
            }
            return el[0];
        }
        s.updateClickedSlide = function (e) {
            var slide = findElementInEvent(e, '.' + s.params.slideClass);
            var slideFound = false;
            if (slide) {
                for (var i = 0; i < s.slides.length; i++) {
                    if (s.slides[i] === slide) slideFound = true;
                }
            }
        
            if (slide && slideFound) {
                s.clickedSlide = slide;
                s.clickedIndex = $(slide).index();
            }
            else {
                s.clickedSlide = undefined;
                s.clickedIndex = undefined;
                return;
            }
            if (s.params.slideToClickedSlide && s.clickedIndex !== undefined && s.clickedIndex !== s.activeIndex) {
                var slideToIndex = s.clickedIndex,
                    realIndex,
                    duplicatedSlides,
                    slidesPerView = s.params.slidesPerView === 'auto' ? s.currentSlidesPerView() : s.params.slidesPerView;
                if (s.params.loop) {
                    if (s.animating) return;
                    realIndex = parseInt($(s.clickedSlide).attr('data-swiper-slide-index'), 10);
                    if (s.params.centeredSlides) {
                        if ((slideToIndex < s.loopedSlides - slidesPerView/2) || (slideToIndex > s.slides.length - s.loopedSlides + slidesPerView/2)) {
                            s.fixLoop();
                            slideToIndex = s.wrapper.children('.' + s.params.slideClass + '[data-swiper-slide-index="' + realIndex + '"]:not(.' + s.params.slideDuplicateClass + ')').eq(0).index();
                            setTimeout(function () {
                                s.slideTo(slideToIndex);
                            }, 0);
                        }
                        else {
                            s.slideTo(slideToIndex);
                        }
                    }
                    else {
                        if (slideToIndex > s.slides.length - slidesPerView) {
                            s.fixLoop();
                            slideToIndex = s.wrapper.children('.' + s.params.slideClass + '[data-swiper-slide-index="' + realIndex + '"]:not(.' + s.params.slideDuplicateClass + ')').eq(0).index();
                            setTimeout(function () {
                                s.slideTo(slideToIndex);
                            }, 0);
                        }
                        else {
                            s.slideTo(slideToIndex);
                        }
                    }
                }
                else {
                    s.slideTo(slideToIndex);
                }
            }
        };
        
        var isTouched,
            isMoved,
            allowTouchCallbacks,
            touchStartTime,
            isScrolling,
            currentTranslate,
            startTranslate,
            allowThresholdMove,
            // Form elements to match
            formElements = 'input, select, textarea, button, video',
            // Last click time
            lastClickTime = Date.now(), clickTimeout,
            //Velocities
            velocities = [],
            allowMomentumBounce;
        
        // Animating Flag
        s.animating = false;
        
        // Touches information
        s.touches = {
            startX: 0,
            startY: 0,
            currentX: 0,
            currentY: 0,
            diff: 0
        };
        
        // Touch handlers
        var isTouchEvent, startMoving;
        s.onTouchStart = function (e) {
            if (e.originalEvent) e = e.originalEvent;
            isTouchEvent = e.type === 'touchstart';
            if (!isTouchEvent && 'which' in e && e.which === 3) return;
            if (s.params.noSwiping && findElementInEvent(e, '.' + s.params.noSwipingClass)) {
                s.allowClick = true;
                return;
            }
            if (s.params.swipeHandler) {
                if (!findElementInEvent(e, s.params.swipeHandler)) return;
            }
        
            var startX = s.touches.currentX = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
            var startY = s.touches.currentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
        
            // Do NOT start if iOS edge swipe is detected. Otherwise iOS app (UIWebView) cannot swipe-to-go-back anymore
            if(s.device.ios && s.params.iOSEdgeSwipeDetection && startX <= s.params.iOSEdgeSwipeThreshold) {
                return;
            }
        
            isTouched = true;
            isMoved = false;
            allowTouchCallbacks = true;
            isScrolling = undefined;
            startMoving = undefined;
            s.touches.startX = startX;
            s.touches.startY = startY;
            touchStartTime = Date.now();
            s.allowClick = true;
            s.updateContainerSize();
            s.swipeDirection = undefined;
            if (s.params.threshold > 0) allowThresholdMove = false;
            if (e.type !== 'touchstart') {
                var preventDefault = true;
                if ($(e.target).is(formElements)) preventDefault = false;
                if (document.activeElement && $(document.activeElement).is(formElements)) {
                    document.activeElement.blur();
                }
                if (preventDefault) {
                    e.preventDefault();
                }
            }
            s.emit('onTouchStart', s, e);
        };
        
        s.onTouchMove = function (e) {
            if (e.originalEvent) e = e.originalEvent;
            if (isTouchEvent && e.type === 'mousemove') return;
            if (e.preventedByNestedSwiper) {
                s.touches.startX = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
                s.touches.startY = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
                return;
            }
            if (s.params.onlyExternal) {
                // isMoved = true;
                s.allowClick = false;
                if (isTouched) {
                    s.touches.startX = s.touches.currentX = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
                    s.touches.startY = s.touches.currentY = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
                    touchStartTime = Date.now();
                }
                return;
            }
            if (isTouchEvent && s.params.touchReleaseOnEdges && !s.params.loop) {
                if (!s.isHorizontal()) {
                    // Vertical
                    if (
                        (s.touches.currentY < s.touches.startY && s.translate <= s.maxTranslate()) ||
                        (s.touches.currentY > s.touches.startY && s.translate >= s.minTranslate())
                        ) {
                        return;
                    }
                }
                else {
                    if (
                        (s.touches.currentX < s.touches.startX && s.translate <= s.maxTranslate()) ||
                        (s.touches.currentX > s.touches.startX && s.translate >= s.minTranslate())
                        ) {
                        return;
                    }
                }
            }
            if (isTouchEvent && document.activeElement) {
                if (e.target === document.activeElement && $(e.target).is(formElements)) {
                    isMoved = true;
                    s.allowClick = false;
                    return;
                }
            }
            if (allowTouchCallbacks) {
                s.emit('onTouchMove', s, e);
            }
            if (e.targetTouches && e.targetTouches.length > 1) return;
        
            s.touches.currentX = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
            s.touches.currentY = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
        
            if (typeof isScrolling === 'undefined') {
                var touchAngle;
                if (s.isHorizontal() && s.touches.currentY === s.touches.startY || !s.isHorizontal() && s.touches.currentX === s.touches.startX) {
                    isScrolling = false;
                }
                else {
                    touchAngle = Math.atan2(Math.abs(s.touches.currentY - s.touches.startY), Math.abs(s.touches.currentX - s.touches.startX)) * 180 / Math.PI;
                    isScrolling = s.isHorizontal() ? touchAngle > s.params.touchAngle : (90 - touchAngle > s.params.touchAngle);
                }
            }
            if (isScrolling) {
                s.emit('onTouchMoveOpposite', s, e);
            }
            if (typeof startMoving === 'undefined') {
                if (s.touches.currentX !== s.touches.startX || s.touches.currentY !== s.touches.startY) {
                    startMoving = true;
                }
            }
            if (!isTouched) return;
            if (isScrolling)  {
                isTouched = false;
                return;
            }
            if (!startMoving) {
                return;
            }
            s.allowClick = false;
            s.emit('onSliderMove', s, e);
            e.preventDefault();
            if (s.params.touchMoveStopPropagation && !s.params.nested) {
                e.stopPropagation();
            }
        
            if (!isMoved) {
                if (params.loop) {
                    s.fixLoop();
                }
                startTranslate = s.getWrapperTranslate();
                s.setWrapperTransition(0);
                if (s.animating) {
                    s.wrapper.trigger('webkitTransitionEnd transitionend oTransitionEnd MSTransitionEnd msTransitionEnd');
                }
                if (s.params.autoplay && s.autoplaying) {
                    if (s.params.autoplayDisableOnInteraction) {
                        s.stopAutoplay();
                    }
                    else {
                        s.pauseAutoplay();
                    }
                }
                allowMomentumBounce = false;
                //Grab Cursor
                if (s.params.grabCursor && (s.params.allowSwipeToNext === true || s.params.allowSwipeToPrev === true)) {
                    s.setGrabCursor(true);
                }
            }
            isMoved = true;
        
            var diff = s.touches.diff = s.isHorizontal() ? s.touches.currentX - s.touches.startX : s.touches.currentY - s.touches.startY;
        
            diff = diff * s.params.touchRatio;
            if (s.rtl) diff = -diff;
        
            s.swipeDirection = diff > 0 ? 'prev' : 'next';
            currentTranslate = diff + startTranslate;
        
            var disableParentSwiper = true;
            if ((diff > 0 && currentTranslate > s.minTranslate())) {
                disableParentSwiper = false;
                if (s.params.resistance) currentTranslate = s.minTranslate() - 1 + Math.pow(-s.minTranslate() + startTranslate + diff, s.params.resistanceRatio);
            }
            else if (diff < 0 && currentTranslate < s.maxTranslate()) {
                disableParentSwiper = false;
                if (s.params.resistance) currentTranslate = s.maxTranslate() + 1 - Math.pow(s.maxTranslate() - startTranslate - diff, s.params.resistanceRatio);
            }
        
            if (disableParentSwiper) {
                e.preventedByNestedSwiper = true;
            }
        
            // Directions locks
            if (!s.params.allowSwipeToNext && s.swipeDirection === 'next' && currentTranslate < startTranslate) {
                currentTranslate = startTranslate;
            }
            if (!s.params.allowSwipeToPrev && s.swipeDirection === 'prev' && currentTranslate > startTranslate) {
                currentTranslate = startTranslate;
            }
        
        
            // Threshold
            if (s.params.threshold > 0) {
                if (Math.abs(diff) > s.params.threshold || allowThresholdMove) {
                    if (!allowThresholdMove) {
                        allowThresholdMove = true;
                        s.touches.startX = s.touches.currentX;
                        s.touches.startY = s.touches.currentY;
                        currentTranslate = startTranslate;
                        s.touches.diff = s.isHorizontal() ? s.touches.currentX - s.touches.startX : s.touches.currentY - s.touches.startY;
                        return;
                    }
                }
                else {
                    currentTranslate = startTranslate;
                    return;
                }
            }
        
            if (!s.params.followFinger) return;
        
            // Update active index in free mode
            if (s.params.freeMode || s.params.watchSlidesProgress) {
                s.updateActiveIndex();
            }
            if (s.params.freeMode) {
                //Velocity
                if (velocities.length === 0) {
                    velocities.push({
                        position: s.touches[s.isHorizontal() ? 'startX' : 'startY'],
                        time: touchStartTime
                    });
                }
                velocities.push({
                    position: s.touches[s.isHorizontal() ? 'currentX' : 'currentY'],
                    time: (new window.Date()).getTime()
                });
            }
            // Update progress
            s.updateProgress(currentTranslate);
            // Update translate
            s.setWrapperTranslate(currentTranslate);
        };
        s.onTouchEnd = function (e) {
            if (e.originalEvent) e = e.originalEvent;
            if (allowTouchCallbacks) {
                s.emit('onTouchEnd', s, e);
            }
            allowTouchCallbacks = false;
            if (!isTouched) return;
            //Return Grab Cursor
            if (s.params.grabCursor && isMoved && isTouched  && (s.params.allowSwipeToNext === true || s.params.allowSwipeToPrev === true)) {
                s.setGrabCursor(false);
            }
        
            // Time diff
            var touchEndTime = Date.now();
            var timeDiff = touchEndTime - touchStartTime;
        
            // Tap, doubleTap, Click
            if (s.allowClick) {
                s.updateClickedSlide(e);
                s.emit('onTap', s, e);
                if (timeDiff < 300 && (touchEndTime - lastClickTime) > 300) {
                    if (clickTimeout) clearTimeout(clickTimeout);
                    clickTimeout = setTimeout(function () {
                        if (!s) return;
                        if (s.params.paginationHide && s.paginationContainer.length > 0 && !$(e.target).hasClass(s.params.bulletClass)) {
                            s.paginationContainer.toggleClass(s.params.paginationHiddenClass);
                        }
                        s.emit('onClick', s, e);
                    }, 300);
        
                }
                if (timeDiff < 300 && (touchEndTime - lastClickTime) < 300) {
                    if (clickTimeout) clearTimeout(clickTimeout);
                    s.emit('onDoubleTap', s, e);
                }
            }
        
            lastClickTime = Date.now();
            setTimeout(function () {
                if (s) s.allowClick = true;
            }, 0);
        
            if (!isTouched || !isMoved || !s.swipeDirection || s.touches.diff === 0 || currentTranslate === startTranslate) {
                isTouched = isMoved = false;
                return;
            }
            isTouched = isMoved = false;
        
            var currentPos;
            if (s.params.followFinger) {
                currentPos = s.rtl ? s.translate : -s.translate;
            }
            else {
                currentPos = -currentTranslate;
            }
            if (s.params.freeMode) {
                if (currentPos < -s.minTranslate()) {
                    s.slideTo(s.activeIndex);
                    return;
                }
                else if (currentPos > -s.maxTranslate()) {
                    if (s.slides.length < s.snapGrid.length) {
                        s.slideTo(s.snapGrid.length - 1);
                    }
                    else {
                        s.slideTo(s.slides.length - 1);
                    }
                    return;
                }
        
                if (s.params.freeModeMomentum) {
                    if (velocities.length > 1) {
                        var lastMoveEvent = velocities.pop(), velocityEvent = velocities.pop();
        
                        var distance = lastMoveEvent.position - velocityEvent.position;
                        var time = lastMoveEvent.time - velocityEvent.time;
                        s.velocity = distance / time;
                        s.velocity = s.velocity / 2;
                        if (Math.abs(s.velocity) < s.params.freeModeMinimumVelocity) {
                            s.velocity = 0;
                        }
                        // this implies that the user stopped moving a finger then released.
                        // There would be no events with distance zero, so the last event is stale.
                        if (time > 150 || (new window.Date().getTime() - lastMoveEvent.time) > 300) {
                            s.velocity = 0;
                        }
                    } else {
                        s.velocity = 0;
                    }
                    s.velocity = s.velocity * s.params.freeModeMomentumVelocityRatio;
        
                    velocities.length = 0;
                    var momentumDuration = 1000 * s.params.freeModeMomentumRatio;
                    var momentumDistance = s.velocity * momentumDuration;
        
                    var newPosition = s.translate + momentumDistance;
                    if (s.rtl) newPosition = - newPosition;
                    var doBounce = false;
                    var afterBouncePosition;
                    var bounceAmount = Math.abs(s.velocity) * 20 * s.params.freeModeMomentumBounceRatio;
                    if (newPosition < s.maxTranslate()) {
                        if (s.params.freeModeMomentumBounce) {
                            if (newPosition + s.maxTranslate() < -bounceAmount) {
                                newPosition = s.maxTranslate() - bounceAmount;
                            }
                            afterBouncePosition = s.maxTranslate();
                            doBounce = true;
                            allowMomentumBounce = true;
                        }
                        else {
                            newPosition = s.maxTranslate();
                        }
                    }
                    else if (newPosition > s.minTranslate()) {
                        if (s.params.freeModeMomentumBounce) {
                            if (newPosition - s.minTranslate() > bounceAmount) {
                                newPosition = s.minTranslate() + bounceAmount;
                            }
                            afterBouncePosition = s.minTranslate();
                            doBounce = true;
                            allowMomentumBounce = true;
                        }
                        else {
                            newPosition = s.minTranslate();
                        }
                    }
                    else if (s.params.freeModeSticky) {
                        var j = 0,
                            nextSlide;
                        for (j = 0; j < s.snapGrid.length; j += 1) {
                            if (s.snapGrid[j] > -newPosition) {
                                nextSlide = j;
                                break;
                            }
        
                        }
                        if (Math.abs(s.snapGrid[nextSlide] - newPosition) < Math.abs(s.snapGrid[nextSlide - 1] - newPosition) || s.swipeDirection === 'next') {
                            newPosition = s.snapGrid[nextSlide];
                        } else {
                            newPosition = s.snapGrid[nextSlide - 1];
                        }
                        if (!s.rtl) newPosition = - newPosition;
                    }
                    //Fix duration
                    if (s.velocity !== 0) {
                        if (s.rtl) {
                            momentumDuration = Math.abs((-newPosition - s.translate) / s.velocity);
                        }
                        else {
                            momentumDuration = Math.abs((newPosition - s.translate) / s.velocity);
                        }
                    }
                    else if (s.params.freeModeSticky) {
                        s.slideReset();
                        return;
                    }
        
                    if (s.params.freeModeMomentumBounce && doBounce) {
                        s.updateProgress(afterBouncePosition);
                        s.setWrapperTransition(momentumDuration);
                        s.setWrapperTranslate(newPosition);
                        s.onTransitionStart();
                        s.animating = true;
                        s.wrapper.transitionEnd(function () {
                            if (!s || !allowMomentumBounce) return;
                            s.emit('onMomentumBounce', s);
        
                            s.setWrapperTransition(s.params.speed);
                            s.setWrapperTranslate(afterBouncePosition);
                            s.wrapper.transitionEnd(function () {
                                if (!s) return;
                                s.onTransitionEnd();
                            });
                        });
                    } else if (s.velocity) {
                        s.updateProgress(newPosition);
                        s.setWrapperTransition(momentumDuration);
                        s.setWrapperTranslate(newPosition);
                        s.onTransitionStart();
                        if (!s.animating) {
                            s.animating = true;
                            s.wrapper.transitionEnd(function () {
                                if (!s) return;
                                s.onTransitionEnd();
                            });
                        }
        
                    } else {
                        s.updateProgress(newPosition);
                    }
        
                    s.updateActiveIndex();
                }
                if (!s.params.freeModeMomentum || timeDiff >= s.params.longSwipesMs) {
                    s.updateProgress();
                    s.updateActiveIndex();
                }
                return;
            }
        
            // Find current slide
            var i, stopIndex = 0, groupSize = s.slidesSizesGrid[0];
            for (i = 0; i < s.slidesGrid.length; i += s.params.slidesPerGroup) {
                if (typeof s.slidesGrid[i + s.params.slidesPerGroup] !== 'undefined') {
                    if (currentPos >= s.slidesGrid[i] && currentPos < s.slidesGrid[i + s.params.slidesPerGroup]) {
                        stopIndex = i;
                        groupSize = s.slidesGrid[i + s.params.slidesPerGroup] - s.slidesGrid[i];
                    }
                }
                else {
                    if (currentPos >= s.slidesGrid[i]) {
                        stopIndex = i;
                        groupSize = s.slidesGrid[s.slidesGrid.length - 1] - s.slidesGrid[s.slidesGrid.length - 2];
                    }
                }
            }
        
            // Find current slide size
            var ratio = (currentPos - s.slidesGrid[stopIndex]) / groupSize;
        
            if (timeDiff > s.params.longSwipesMs) {
                // Long touches
                if (!s.params.longSwipes) {
                    s.slideTo(s.activeIndex);
                    return;
                }
                if (s.swipeDirection === 'next') {
                    if (ratio >= s.params.longSwipesRatio) s.slideTo(stopIndex + s.params.slidesPerGroup);
                    else s.slideTo(stopIndex);
        
                }
                if (s.swipeDirection === 'prev') {
                    if (ratio > (1 - s.params.longSwipesRatio)) s.slideTo(stopIndex + s.params.slidesPerGroup);
                    else s.slideTo(stopIndex);
                }
            }
            else {
                // Short swipes
                if (!s.params.shortSwipes) {
                    s.slideTo(s.activeIndex);
                    return;
                }
                if (s.swipeDirection === 'next') {
                    s.slideTo(stopIndex + s.params.slidesPerGroup);
        
                }
                if (s.swipeDirection === 'prev') {
                    s.slideTo(stopIndex);
                }
            }
        };
        /*=========================
          Transitions
          ===========================*/
        s._slideTo = function (slideIndex, speed) {
            return s.slideTo(slideIndex, speed, true, true);
        };
        s.slideTo = function (slideIndex, speed, runCallbacks, internal) {
            if (typeof runCallbacks === 'undefined') runCallbacks = true;
            if (typeof slideIndex === 'undefined') slideIndex = 0;
            if (slideIndex < 0) slideIndex = 0;
            s.snapIndex = Math.floor(slideIndex / s.params.slidesPerGroup);
            if (s.snapIndex >= s.snapGrid.length) s.snapIndex = s.snapGrid.length - 1;
        
            var translate = - s.snapGrid[s.snapIndex];
            // Stop autoplay
            if (s.params.autoplay && s.autoplaying) {
                if (internal || !s.params.autoplayDisableOnInteraction) {
                    s.pauseAutoplay(speed);
                }
                else {
                    s.stopAutoplay();
                }
            }
            // Update progress
            s.updateProgress(translate);
        
            // Normalize slideIndex
            if(s.params.normalizeSlideIndex){
                for (var i = 0; i < s.slidesGrid.length; i++) {
                    if (- Math.floor(translate * 100) >= Math.floor(s.slidesGrid[i] * 100)) {
                        slideIndex = i;
                    }
                }
            }
        
            // Directions locks
            if (!s.params.allowSwipeToNext && translate < s.translate && translate < s.minTranslate()) {
                return false;
            }
            if (!s.params.allowSwipeToPrev && translate > s.translate && translate > s.maxTranslate()) {
                if ((s.activeIndex || 0) !== slideIndex ) return false;
            }
        
            // Update Index
            if (typeof speed === 'undefined') speed = s.params.speed;
            s.previousIndex = s.activeIndex || 0;
            s.activeIndex = slideIndex;
            s.updateRealIndex();
            if ((s.rtl && -translate === s.translate) || (!s.rtl && translate === s.translate)) {
                // Update Height
                if (s.params.autoHeight) {
                    s.updateAutoHeight();
                }
                s.updateClasses();
                if (s.params.effect !== 'slide') {
                    s.setWrapperTranslate(translate);
                }
                return false;
            }
            s.updateClasses();
            s.onTransitionStart(runCallbacks);
        
            if (speed === 0 || s.browser.lteIE9) {
                s.setWrapperTranslate(translate);
                s.setWrapperTransition(0);
                s.onTransitionEnd(runCallbacks);
            }
            else {
                s.setWrapperTranslate(translate);
                s.setWrapperTransition(speed);
                if (!s.animating) {
                    s.animating = true;
                    s.wrapper.transitionEnd(function () {
                        if (!s) return;
                        s.onTransitionEnd(runCallbacks);
                    });
                }
        
            }
        
            return true;
        };
        
        s.onTransitionStart = function (runCallbacks) {
            if (typeof runCallbacks === 'undefined') runCallbacks = true;
            if (s.params.autoHeight) {
                s.updateAutoHeight();
            }
            if (s.lazy) s.lazy.onTransitionStart();
            if (runCallbacks) {
                s.emit('onTransitionStart', s);
                if (s.activeIndex !== s.previousIndex) {
                    s.emit('onSlideChangeStart', s);
                    if (s.activeIndex > s.previousIndex) {
                        s.emit('onSlideNextStart', s);
                    }
                    else {
                        s.emit('onSlidePrevStart', s);
                    }
                }
        
            }
        };
        s.onTransitionEnd = function (runCallbacks) {
            s.animating = false;
            s.setWrapperTransition(0);
            if (typeof runCallbacks === 'undefined') runCallbacks = true;
            if (s.lazy) s.lazy.onTransitionEnd();
            if (runCallbacks) {
                s.emit('onTransitionEnd', s);
                if (s.activeIndex !== s.previousIndex) {
                    s.emit('onSlideChangeEnd', s);
                    if (s.activeIndex > s.previousIndex) {
                        s.emit('onSlideNextEnd', s);
                    }
                    else {
                        s.emit('onSlidePrevEnd', s);
                    }
                }
            }
            if (s.params.history && s.history) {
                s.history.setHistory(s.params.history, s.activeIndex);
            }
            if (s.params.hashnav && s.hashnav) {
                s.hashnav.setHash();
            }
        
        };
        s.slideNext = function (runCallbacks, speed, internal) {
            if (s.params.loop) {
                if (s.animating) return false;
                s.fixLoop();
                var clientLeft = s.container[0].clientLeft;
                return s.slideTo(s.activeIndex + s.params.slidesPerGroup, speed, runCallbacks, internal);
            }
            else return s.slideTo(s.activeIndex + s.params.slidesPerGroup, speed, runCallbacks, internal);
        };
        s._slideNext = function (speed) {
            return s.slideNext(true, speed, true);
        };
        s.slidePrev = function (runCallbacks, speed, internal) {
            if (s.params.loop) {
                if (s.animating) return false;
                s.fixLoop();
                var clientLeft = s.container[0].clientLeft;
                return s.slideTo(s.activeIndex - 1, speed, runCallbacks, internal);
            }
            else return s.slideTo(s.activeIndex - 1, speed, runCallbacks, internal);
        };
        s._slidePrev = function (speed) {
            return s.slidePrev(true, speed, true);
        };
        s.slideReset = function (runCallbacks, speed, internal) {
            return s.slideTo(s.activeIndex, speed, runCallbacks);
        };
        
        s.disableTouchControl = function () {
            s.params.onlyExternal = true;
            return true;
        };
        s.enableTouchControl = function () {
            s.params.onlyExternal = false;
            return true;
        };
        
        /*=========================
          Translate/transition helpers
          ===========================*/
        s.setWrapperTransition = function (duration, byController) {
            s.wrapper.transition(duration);
            if (s.params.effect !== 'slide' && s.effects[s.params.effect]) {
                s.effects[s.params.effect].setTransition(duration);
            }
            if (s.params.parallax && s.parallax) {
                s.parallax.setTransition(duration);
            }
            if (s.params.scrollbar && s.scrollbar) {
                s.scrollbar.setTransition(duration);
            }
            if (s.params.control && s.controller) {
                s.controller.setTransition(duration, byController);
            }
            s.emit('onSetTransition', s, duration);
        };
        s.setWrapperTranslate = function (translate, updateActiveIndex, byController) {
            var x = 0, y = 0, z = 0;
            if (s.isHorizontal()) {
                x = s.rtl ? -translate : translate;
            }
            else {
                y = translate;
            }
        
            if (s.params.roundLengths) {
                x = round(x);
                y = round(y);
            }
        
            if (!s.params.virtualTranslate) {
                if (s.support.transforms3d) s.wrapper.transform('translate3d(' + x + 'px, ' + y + 'px, ' + z + 'px)');
                else s.wrapper.transform('translate(' + x + 'px, ' + y + 'px)');
            }
        
            s.translate = s.isHorizontal() ? x : y;
        
            // Check if we need to update progress
            var progress;
            var translatesDiff = s.maxTranslate() - s.minTranslate();
            if (translatesDiff === 0) {
                progress = 0;
            }
            else {
                progress = (translate - s.minTranslate()) / (translatesDiff);
            }
            if (progress !== s.progress) {
                s.updateProgress(translate);
            }
        
            if (updateActiveIndex) s.updateActiveIndex();
            if (s.params.effect !== 'slide' && s.effects[s.params.effect]) {
                s.effects[s.params.effect].setTranslate(s.translate);
            }
            if (s.params.parallax && s.parallax) {
                s.parallax.setTranslate(s.translate);
            }
            if (s.params.scrollbar && s.scrollbar) {
                s.scrollbar.setTranslate(s.translate);
            }
            if (s.params.control && s.controller) {
                s.controller.setTranslate(s.translate, byController);
            }
            s.emit('onSetTranslate', s, s.translate);
        };
        
        s.getTranslate = function (el, axis) {
            var matrix, curTransform, curStyle, transformMatrix;
        
            // automatic axis detection
            if (typeof axis === 'undefined') {
                axis = 'x';
            }
        
            if (s.params.virtualTranslate) {
                return s.rtl ? -s.translate : s.translate;
            }
        
            curStyle = window.getComputedStyle(el, null);
            if (window.WebKitCSSMatrix) {
                curTransform = curStyle.transform || curStyle.webkitTransform;
                if (curTransform.split(',').length > 6) {
                    curTransform = curTransform.split(', ').map(function(a){
                        return a.replace(',','.');
                    }).join(', ');
                }
                // Some old versions of Webkit choke when 'none' is passed; pass
                // empty string instead in this case
                transformMatrix = new window.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
            }
            else {
                transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform  || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
                matrix = transformMatrix.toString().split(',');
            }
        
            if (axis === 'x') {
                //Latest Chrome and webkits Fix
                if (window.WebKitCSSMatrix)
                    curTransform = transformMatrix.m41;
                //Crazy IE10 Matrix
                else if (matrix.length === 16)
                    curTransform = parseFloat(matrix[12]);
                //Normal Browsers
                else
                    curTransform = parseFloat(matrix[4]);
            }
            if (axis === 'y') {
                //Latest Chrome and webkits Fix
                if (window.WebKitCSSMatrix)
                    curTransform = transformMatrix.m42;
                //Crazy IE10 Matrix
                else if (matrix.length === 16)
                    curTransform = parseFloat(matrix[13]);
                //Normal Browsers
                else
                    curTransform = parseFloat(matrix[5]);
            }
            if (s.rtl && curTransform) curTransform = -curTransform;
            return curTransform || 0;
        };
        s.getWrapperTranslate = function (axis) {
            if (typeof axis === 'undefined') {
                axis = s.isHorizontal() ? 'x' : 'y';
            }
            return s.getTranslate(s.wrapper[0], axis);
        };
        
        /*=========================
          Observer
          ===========================*/
        s.observers = [];
        function initObserver(target, options) {
            options = options || {};
            // create an observer instance
            var ObserverFunc = window.MutationObserver || window.WebkitMutationObserver;
            var observer = new ObserverFunc(function (mutations) {
                mutations.forEach(function (mutation) {
                    s.onResize(true);
                    s.emit('onObserverUpdate', s, mutation);
                });
            });
        
            observer.observe(target, {
                attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
                childList: typeof options.childList === 'undefined' ? true : options.childList,
                characterData: typeof options.characterData === 'undefined' ? true : options.characterData
            });
        
            s.observers.push(observer);
        }
        s.initObservers = function () {
            if (s.params.observeParents) {
                var containerParents = s.container.parents();
                for (var i = 0; i < containerParents.length; i++) {
                    initObserver(containerParents[i]);
                }
            }
        
            // Observe container
            initObserver(s.container[0], {childList: false});
        
            // Observe wrapper
            initObserver(s.wrapper[0], {attributes: false});
        };
        s.disconnectObservers = function () {
            for (var i = 0; i < s.observers.length; i++) {
                s.observers[i].disconnect();
            }
            s.observers = [];
        };
        /*=========================
          Loop
          ===========================*/
        // Create looped slides
        s.createLoop = function () {
            // Remove duplicated slides
            s.wrapper.children('.' + s.params.slideClass + '.' + s.params.slideDuplicateClass).remove();
        
            var slides = s.wrapper.children('.' + s.params.slideClass);
        
            if(s.params.slidesPerView === 'auto' && !s.params.loopedSlides) s.params.loopedSlides = slides.length;
        
            s.loopedSlides = parseInt(s.params.loopedSlides || s.params.slidesPerView, 10);
            s.loopedSlides = s.loopedSlides + s.params.loopAdditionalSlides;
            if (s.loopedSlides > slides.length) {
                s.loopedSlides = slides.length;
            }
        
            var prependSlides = [], appendSlides = [], i;
            slides.each(function (index, el) {
                var slide = $(this);
                if (index < s.loopedSlides) appendSlides.push(el);
                if (index < slides.length && index >= slides.length - s.loopedSlides) prependSlides.push(el);
                slide.attr('data-swiper-slide-index', index);
            });
            for (i = 0; i < appendSlides.length; i++) {
                s.wrapper.append($(appendSlides[i].cloneNode(true)).addClass(s.params.slideDuplicateClass));
            }
            for (i = prependSlides.length - 1; i >= 0; i--) {
                s.wrapper.prepend($(prependSlides[i].cloneNode(true)).addClass(s.params.slideDuplicateClass));
            }
        };
        s.destroyLoop = function () {
            s.wrapper.children('.' + s.params.slideClass + '.' + s.params.slideDuplicateClass).remove();
            s.slides.removeAttr('data-swiper-slide-index');
        };
        s.reLoop = function (updatePosition) {
            var oldIndex = s.activeIndex - s.loopedSlides;
            s.destroyLoop();
            s.createLoop();
            s.updateSlidesSize();
            if (updatePosition) {
                s.slideTo(oldIndex + s.loopedSlides, 0, false);
            }
        
        };
        s.fixLoop = function () {
            var newIndex;
            //Fix For Negative Oversliding
            if (s.activeIndex < s.loopedSlides) {
                newIndex = s.slides.length - s.loopedSlides * 3 + s.activeIndex;
                newIndex = newIndex + s.loopedSlides;
                s.slideTo(newIndex, 0, false, true);
            }
            //Fix For Positive Oversliding
            else if ((s.params.slidesPerView === 'auto' && s.activeIndex >= s.loopedSlides * 2) || (s.activeIndex > s.slides.length - s.params.slidesPerView * 2)) {
                newIndex = -s.slides.length + s.activeIndex + s.loopedSlides;
                newIndex = newIndex + s.loopedSlides;
                s.slideTo(newIndex, 0, false, true);
            }
        };
        /*=========================
          Append/Prepend/Remove Slides
          ===========================*/
        s.appendSlide = function (slides) {
            if (s.params.loop) {
                s.destroyLoop();
            }
            if (typeof slides === 'object' && slides.length) {
                for (var i = 0; i < slides.length; i++) {
                    if (slides[i]) s.wrapper.append(slides[i]);
                }
            }
            else {
                s.wrapper.append(slides);
            }
            if (s.params.loop) {
                s.createLoop();
            }
            if (!(s.params.observer && s.support.observer)) {
                s.update(true);
            }
        };
        s.prependSlide = function (slides) {
            if (s.params.loop) {
                s.destroyLoop();
            }
            var newActiveIndex = s.activeIndex + 1;
            if (typeof slides === 'object' && slides.length) {
                for (var i = 0; i < slides.length; i++) {
                    if (slides[i]) s.wrapper.prepend(slides[i]);
                }
                newActiveIndex = s.activeIndex + slides.length;
            }
            else {
                s.wrapper.prepend(slides);
            }
            if (s.params.loop) {
                s.createLoop();
            }
            if (!(s.params.observer && s.support.observer)) {
                s.update(true);
            }
            s.slideTo(newActiveIndex, 0, false);
        };
        s.removeSlide = function (slidesIndexes) {
            if (s.params.loop) {
                s.destroyLoop();
                s.slides = s.wrapper.children('.' + s.params.slideClass);
            }
            var newActiveIndex = s.activeIndex,
                indexToRemove;
            if (typeof slidesIndexes === 'object' && slidesIndexes.length) {
                for (var i = 0; i < slidesIndexes.length; i++) {
                    indexToRemove = slidesIndexes[i];
                    if (s.slides[indexToRemove]) s.slides.eq(indexToRemove).remove();
                    if (indexToRemove < newActiveIndex) newActiveIndex--;
                }
                newActiveIndex = Math.max(newActiveIndex, 0);
            }
            else {
                indexToRemove = slidesIndexes;
                if (s.slides[indexToRemove]) s.slides.eq(indexToRemove).remove();
                if (indexToRemove < newActiveIndex) newActiveIndex--;
                newActiveIndex = Math.max(newActiveIndex, 0);
            }
        
            if (s.params.loop) {
                s.createLoop();
            }
        
            if (!(s.params.observer && s.support.observer)) {
                s.update(true);
            }
            if (s.params.loop) {
                s.slideTo(newActiveIndex + s.loopedSlides, 0, false);
            }
            else {
                s.slideTo(newActiveIndex, 0, false);
            }
        
        };
        s.removeAllSlides = function () {
            var slidesIndexes = [];
            for (var i = 0; i < s.slides.length; i++) {
                slidesIndexes.push(i);
            }
            s.removeSlide(slidesIndexes);
        };
        

        /*=========================
          Effects
          ===========================*/
        s.effects = {
            fade: {
                setTranslate: function () {
                    for (var i = 0; i < s.slides.length; i++) {
                        var slide = s.slides.eq(i);
                        var offset = slide[0].swiperSlideOffset;
                        var tx = -offset;
                        if (!s.params.virtualTranslate) tx = tx - s.translate;
                        var ty = 0;
                        if (!s.isHorizontal()) {
                            ty = tx;
                            tx = 0;
                        }
                        var slideOpacity = s.params.fade.crossFade ?
                                Math.max(1 - Math.abs(slide[0].progress), 0) :
                                1 + Math.min(Math.max(slide[0].progress, -1), 0);
                        slide
                            .css({
                                opacity: slideOpacity
                            })
                            .transform('translate3d(' + tx + 'px, ' + ty + 'px, 0px)');
        
                    }
        
                },
                setTransition: function (duration) {
                    s.slides.transition(duration);
                    if (s.params.virtualTranslate && duration !== 0) {
                        var eventTriggered = false;
                        s.slides.transitionEnd(function () {
                            if (eventTriggered) return;
                            if (!s) return;
                            eventTriggered = true;
                            s.animating = false;
                            var triggerEvents = ['webkitTransitionEnd', 'transitionend', 'oTransitionEnd', 'MSTransitionEnd', 'msTransitionEnd'];
                            for (var i = 0; i < triggerEvents.length; i++) {
                                s.wrapper.trigger(triggerEvents[i]);
                            }
                        });
                    }
                }
            },
            flip: {
                setTranslate: function () {
                    for (var i = 0; i < s.slides.length; i++) {
                        var slide = s.slides.eq(i);
                        var progress = slide[0].progress;
                        if (s.params.flip.limitRotation) {
                            progress = Math.max(Math.min(slide[0].progress, 1), -1);
                        }
                        var offset = slide[0].swiperSlideOffset;
                        var rotate = -180 * progress,
                            rotateY = rotate,
                            rotateX = 0,
                            tx = -offset,
                            ty = 0;
                        if (!s.isHorizontal()) {
                            ty = tx;
                            tx = 0;
                            rotateX = -rotateY;
                            rotateY = 0;
                        }
                        else if (s.rtl) {
                            rotateY = -rotateY;
                        }
        
                        slide[0].style.zIndex = -Math.abs(Math.round(progress)) + s.slides.length;
        
                        if (s.params.flip.slideShadows) {
                            //Set shadows
                            var shadowBefore = s.isHorizontal() ? slide.find('.swiper-slide-shadow-left') : slide.find('.swiper-slide-shadow-top');
                            var shadowAfter = s.isHorizontal() ? slide.find('.swiper-slide-shadow-right') : slide.find('.swiper-slide-shadow-bottom');
                            if (shadowBefore.length === 0) {
                                shadowBefore = $('<div class="swiper-slide-shadow-' + (s.isHorizontal() ? 'left' : 'top') + '"></div>');
                                slide.append(shadowBefore);
                            }
                            if (shadowAfter.length === 0) {
                                shadowAfter = $('<div class="swiper-slide-shadow-' + (s.isHorizontal() ? 'right' : 'bottom') + '"></div>');
                                slide.append(shadowAfter);
                            }
                            if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
                            if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
                        }
        
                        slide
                            .transform('translate3d(' + tx + 'px, ' + ty + 'px, 0px) rotateX(' + rotateX + 'deg) rotateY(' + rotateY + 'deg)');
                    }
                },
                setTransition: function (duration) {
                    s.slides.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
                    if (s.params.virtualTranslate && duration !== 0) {
                        var eventTriggered = false;
                        s.slides.eq(s.activeIndex).transitionEnd(function () {
                            if (eventTriggered) return;
                            if (!s) return;
                            if (!$(this).hasClass(s.params.slideActiveClass)) return;
                            eventTriggered = true;
                            s.animating = false;
                            var triggerEvents = ['webkitTransitionEnd', 'transitionend', 'oTransitionEnd', 'MSTransitionEnd', 'msTransitionEnd'];
                            for (var i = 0; i < triggerEvents.length; i++) {
                                s.wrapper.trigger(triggerEvents[i]);
                            }
                        });
                    }
                }
            },
            cube: {
                setTranslate: function () {
                    var wrapperRotate = 0, cubeShadow;
                    if (s.params.cube.shadow) {
                        if (s.isHorizontal()) {
                            cubeShadow = s.wrapper.find('.swiper-cube-shadow');
                            if (cubeShadow.length === 0) {
                                cubeShadow = $('<div class="swiper-cube-shadow"></div>');
                                s.wrapper.append(cubeShadow);
                            }
                            cubeShadow.css({height: s.width + 'px'});
                        }
                        else {
                            cubeShadow = s.container.find('.swiper-cube-shadow');
                            if (cubeShadow.length === 0) {
                                cubeShadow = $('<div class="swiper-cube-shadow"></div>');
                                s.container.append(cubeShadow);
                            }
                        }
                    }
                    for (var i = 0; i < s.slides.length; i++) {
                        var slide = s.slides.eq(i);
                        var slideAngle = i * 90;
                        var round = Math.floor(slideAngle / 360);
                        if (s.rtl) {
                            slideAngle = -slideAngle;
                            round = Math.floor(-slideAngle / 360);
                        }
                        var progress = Math.max(Math.min(slide[0].progress, 1), -1);
                        var tx = 0, ty = 0, tz = 0;
                        if (i % 4 === 0) {
                            tx = - round * 4 * s.size;
                            tz = 0;
                        }
                        else if ((i - 1) % 4 === 0) {
                            tx = 0;
                            tz = - round * 4 * s.size;
                        }
                        else if ((i - 2) % 4 === 0) {
                            tx = s.size + round * 4 * s.size;
                            tz = s.size;
                        }
                        else if ((i - 3) % 4 === 0) {
                            tx = - s.size;
                            tz = 3 * s.size + s.size * 4 * round;
                        }
                        if (s.rtl) {
                            tx = -tx;
                        }
        
                        if (!s.isHorizontal()) {
                            ty = tx;
                            tx = 0;
                        }
        
                        var transform = 'rotateX(' + (s.isHorizontal() ? 0 : -slideAngle) + 'deg) rotateY(' + (s.isHorizontal() ? slideAngle : 0) + 'deg) translate3d(' + tx + 'px, ' + ty + 'px, ' + tz + 'px)';
                        if (progress <= 1 && progress > -1) {
                            wrapperRotate = i * 90 + progress * 90;
                            if (s.rtl) wrapperRotate = -i * 90 - progress * 90;
                        }
                        slide.transform(transform);
                        if (s.params.cube.slideShadows) {
                            //Set shadows
                            var shadowBefore = s.isHorizontal() ? slide.find('.swiper-slide-shadow-left') : slide.find('.swiper-slide-shadow-top');
                            var shadowAfter = s.isHorizontal() ? slide.find('.swiper-slide-shadow-right') : slide.find('.swiper-slide-shadow-bottom');
                            if (shadowBefore.length === 0) {
                                shadowBefore = $('<div class="swiper-slide-shadow-' + (s.isHorizontal() ? 'left' : 'top') + '"></div>');
                                slide.append(shadowBefore);
                            }
                            if (shadowAfter.length === 0) {
                                shadowAfter = $('<div class="swiper-slide-shadow-' + (s.isHorizontal() ? 'right' : 'bottom') + '"></div>');
                                slide.append(shadowAfter);
                            }
                            if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
                            if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
                        }
                    }
                    s.wrapper.css({
                        '-webkit-transform-origin': '50% 50% -' + (s.size / 2) + 'px',
                        '-moz-transform-origin': '50% 50% -' + (s.size / 2) + 'px',
                        '-ms-transform-origin': '50% 50% -' + (s.size / 2) + 'px',
                        'transform-origin': '50% 50% -' + (s.size / 2) + 'px'
                    });
        
                    if (s.params.cube.shadow) {
                        if (s.isHorizontal()) {
                            cubeShadow.transform('translate3d(0px, ' + (s.width / 2 + s.params.cube.shadowOffset) + 'px, ' + (-s.width / 2) + 'px) rotateX(90deg) rotateZ(0deg) scale(' + (s.params.cube.shadowScale) + ')');
                        }
                        else {
                            var shadowAngle = Math.abs(wrapperRotate) - Math.floor(Math.abs(wrapperRotate) / 90) * 90;
                            var multiplier = 1.5 - (Math.sin(shadowAngle * 2 * Math.PI / 360) / 2 + Math.cos(shadowAngle * 2 * Math.PI / 360) / 2);
                            var scale1 = s.params.cube.shadowScale,
                                scale2 = s.params.cube.shadowScale / multiplier,
                                offset = s.params.cube.shadowOffset;
                            cubeShadow.transform('scale3d(' + scale1 + ', 1, ' + scale2 + ') translate3d(0px, ' + (s.height / 2 + offset) + 'px, ' + (-s.height / 2 / scale2) + 'px) rotateX(-90deg)');
                        }
                    }
                    var zFactor = (s.isSafari || s.isUiWebView) ? (-s.size / 2) : 0;
                    s.wrapper.transform('translate3d(0px,0,' + zFactor + 'px) rotateX(' + (s.isHorizontal() ? 0 : wrapperRotate) + 'deg) rotateY(' + (s.isHorizontal() ? -wrapperRotate : 0) + 'deg)');
                },
                setTransition: function (duration) {
                    s.slides.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
                    if (s.params.cube.shadow && !s.isHorizontal()) {
                        s.container.find('.swiper-cube-shadow').transition(duration);
                    }
                }
            },
            coverflow: {
                setTranslate: function () {
                    var transform = s.translate;
                    var center = s.isHorizontal() ? -transform + s.width / 2 : -transform + s.height / 2;
                    var rotate = s.isHorizontal() ? s.params.coverflow.rotate: -s.params.coverflow.rotate;
                    var translate = s.params.coverflow.depth;
                    //Each slide offset from center
                    for (var i = 0, length = s.slides.length; i < length; i++) {
                        var slide = s.slides.eq(i);
                        var slideSize = s.slidesSizesGrid[i];
                        var slideOffset = slide[0].swiperSlideOffset;
                        var offsetMultiplier = (center - slideOffset - slideSize / 2) / slideSize * s.params.coverflow.modifier;
        
                        var rotateY = s.isHorizontal() ? rotate * offsetMultiplier : 0;
                        var rotateX = s.isHorizontal() ? 0 : rotate * offsetMultiplier;
                        // var rotateZ = 0
                        var translateZ = -translate * Math.abs(offsetMultiplier);
        
                        var translateY = s.isHorizontal() ? 0 : s.params.coverflow.stretch * (offsetMultiplier);
                        var translateX = s.isHorizontal() ? s.params.coverflow.stretch * (offsetMultiplier) : 0;
        
                        //Fix for ultra small values
                        if (Math.abs(translateX) < 0.001) translateX = 0;
                        if (Math.abs(translateY) < 0.001) translateY = 0;
                        if (Math.abs(translateZ) < 0.001) translateZ = 0;
                        if (Math.abs(rotateY) < 0.001) rotateY = 0;
                        if (Math.abs(rotateX) < 0.001) rotateX = 0;
        
                        var slideTransform = 'translate3d(' + translateX + 'px,' + translateY + 'px,' + translateZ + 'px)  rotateX(' + rotateX + 'deg) rotateY(' + rotateY + 'deg)';
        
                        slide.transform(slideTransform);
                        slide[0].style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
                        if (s.params.coverflow.slideShadows) {
                            //Set shadows
                            var shadowBefore = s.isHorizontal() ? slide.find('.swiper-slide-shadow-left') : slide.find('.swiper-slide-shadow-top');
                            var shadowAfter = s.isHorizontal() ? slide.find('.swiper-slide-shadow-right') : slide.find('.swiper-slide-shadow-bottom');
                            if (shadowBefore.length === 0) {
                                shadowBefore = $('<div class="swiper-slide-shadow-' + (s.isHorizontal() ? 'left' : 'top') + '"></div>');
                                slide.append(shadowBefore);
                            }
                            if (shadowAfter.length === 0) {
                                shadowAfter = $('<div class="swiper-slide-shadow-' + (s.isHorizontal() ? 'right' : 'bottom') + '"></div>');
                                slide.append(shadowAfter);
                            }
                            if (shadowBefore.length) shadowBefore[0].style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0;
                            if (shadowAfter.length) shadowAfter[0].style.opacity = (-offsetMultiplier) > 0 ? -offsetMultiplier : 0;
                        }
                    }
        
                    //Set correct perspective for IE10
                    if (s.browser.ie) {
                        var ws = s.wrapper[0].style;
                        ws.perspectiveOrigin = center + 'px 50%';
                    }
                },
                setTransition: function (duration) {
                    s.slides.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
                }
            }
        };
        

        /*=========================
          Images Lazy Loading
          ===========================*/
        s.lazy = {
            initialImageLoaded: false,
            loadImageInSlide: function (index, loadInDuplicate) {
                if (typeof index === 'undefined') return;
                if (typeof loadInDuplicate === 'undefined') loadInDuplicate = true;
                if (s.slides.length === 0) return;
        
                var slide = s.slides.eq(index);
                var img = slide.find('.' + s.params.lazyLoadingClass + ':not(.' + s.params.lazyStatusLoadedClass + '):not(.' + s.params.lazyStatusLoadingClass + ')');
                if (slide.hasClass(s.params.lazyLoadingClass) && !slide.hasClass(s.params.lazyStatusLoadedClass) && !slide.hasClass(s.params.lazyStatusLoadingClass)) {
                    img = img.add(slide[0]);
                }
                if (img.length === 0) return;
        
                img.each(function () {
                    var _img = $(this);
                    _img.addClass(s.params.lazyStatusLoadingClass);
                    var background = _img.attr('data-background');
                    var src = _img.attr('data-src'),
                        srcset = _img.attr('data-srcset'),
                        sizes = _img.attr('data-sizes');
                    s.loadImage(_img[0], (src || background), srcset, sizes, false, function () {
                        if (typeof s === 'undefined' || s === null || !s) return;
                        if (background) {
                            _img.css('background-image', 'url("' + background + '")');
                            _img.removeAttr('data-background');
                        }
                        else {
                            if (srcset) {
                                _img.attr('srcset', srcset);
                                _img.removeAttr('data-srcset');
                            }
                            if (sizes) {
                                _img.attr('sizes', sizes);
                                _img.removeAttr('data-sizes');
                            }
                            if (src) {
                                _img.attr('src', src);
                                _img.removeAttr('data-src');
                            }
        
                        }
        
                        _img.addClass(s.params.lazyStatusLoadedClass).removeClass(s.params.lazyStatusLoadingClass);
                        slide.find('.' + s.params.lazyPreloaderClass + ', .' + s.params.preloaderClass).remove();
                        if (s.params.loop && loadInDuplicate) {
                            var slideOriginalIndex = slide.attr('data-swiper-slide-index');
                            if (slide.hasClass(s.params.slideDuplicateClass)) {
                                var originalSlide = s.wrapper.children('[data-swiper-slide-index="' + slideOriginalIndex + '"]:not(.' + s.params.slideDuplicateClass + ')');
                                s.lazy.loadImageInSlide(originalSlide.index(), false);
                            }
                            else {
                                var duplicatedSlide = s.wrapper.children('.' + s.params.slideDuplicateClass + '[data-swiper-slide-index="' + slideOriginalIndex + '"]');
                                s.lazy.loadImageInSlide(duplicatedSlide.index(), false);
                            }
                        }
                        s.emit('onLazyImageReady', s, slide[0], _img[0]);
                    });
        
                    s.emit('onLazyImageLoad', s, slide[0], _img[0]);
                });
        
            },
            load: function () {
                var i;
                var slidesPerView = s.params.slidesPerView;
                if (slidesPerView === 'auto') {
                    slidesPerView = 0;
                }
                if (!s.lazy.initialImageLoaded) s.lazy.initialImageLoaded = true;
                if (s.params.watchSlidesVisibility) {
                    s.wrapper.children('.' + s.params.slideVisibleClass).each(function () {
                        s.lazy.loadImageInSlide($(this).index());
                    });
                }
                else {
                    if (slidesPerView > 1) {
                        for (i = s.activeIndex; i < s.activeIndex + slidesPerView ; i++) {
                            if (s.slides[i]) s.lazy.loadImageInSlide(i);
                        }
                    }
                    else {
                        s.lazy.loadImageInSlide(s.activeIndex);
                    }
                }
                if (s.params.lazyLoadingInPrevNext) {
                    if (slidesPerView > 1 || (s.params.lazyLoadingInPrevNextAmount && s.params.lazyLoadingInPrevNextAmount > 1)) {
                        var amount = s.params.lazyLoadingInPrevNextAmount;
                        var spv = slidesPerView;
                        var maxIndex = Math.min(s.activeIndex + spv + Math.max(amount, spv), s.slides.length);
                        var minIndex = Math.max(s.activeIndex - Math.max(spv, amount), 0);
                        // Next Slides
                        for (i = s.activeIndex + slidesPerView; i < maxIndex; i++) {
                            if (s.slides[i]) s.lazy.loadImageInSlide(i);
                        }
                        // Prev Slides
                        for (i = minIndex; i < s.activeIndex ; i++) {
                            if (s.slides[i]) s.lazy.loadImageInSlide(i);
                        }
                    }
                    else {
                        var nextSlide = s.wrapper.children('.' + s.params.slideNextClass);
                        if (nextSlide.length > 0) s.lazy.loadImageInSlide(nextSlide.index());
        
                        var prevSlide = s.wrapper.children('.' + s.params.slidePrevClass);
                        if (prevSlide.length > 0) s.lazy.loadImageInSlide(prevSlide.index());
                    }
                }
            },
            onTransitionStart: function () {
                if (s.params.lazyLoading) {
                    if (s.params.lazyLoadingOnTransitionStart || (!s.params.lazyLoadingOnTransitionStart && !s.lazy.initialImageLoaded)) {
                        s.lazy.load();
                    }
                }
            },
            onTransitionEnd: function () {
                if (s.params.lazyLoading && !s.params.lazyLoadingOnTransitionStart) {
                    s.lazy.load();
                }
            }
        };
        

        /*=========================
          Scrollbar
          ===========================*/
        s.scrollbar = {
            isTouched: false,
            setDragPosition: function (e) {
                var sb = s.scrollbar;
                var x = 0, y = 0;
                var translate;
                var pointerPosition = s.isHorizontal() ?
                    ((e.type === 'touchstart' || e.type === 'touchmove') ? e.targetTouches[0].pageX : e.pageX || e.clientX) :
                    ((e.type === 'touchstart' || e.type === 'touchmove') ? e.targetTouches[0].pageY : e.pageY || e.clientY) ;
                var position = (pointerPosition) - sb.track.offset()[s.isHorizontal() ? 'left' : 'top'] - sb.dragSize / 2;
                var positionMin = -s.minTranslate() * sb.moveDivider;
                var positionMax = -s.maxTranslate() * sb.moveDivider;
                if (position < positionMin) {
                    position = positionMin;
                }
                else if (position > positionMax) {
                    position = positionMax;
                }
                position = -position / sb.moveDivider;
                s.updateProgress(position);
                s.setWrapperTranslate(position, true);
            },
            dragStart: function (e) {
                var sb = s.scrollbar;
                sb.isTouched = true;
                e.preventDefault();
                e.stopPropagation();
        
                sb.setDragPosition(e);
                clearTimeout(sb.dragTimeout);
        
                sb.track.transition(0);
                if (s.params.scrollbarHide) {
                    sb.track.css('opacity', 1);
                }
                s.wrapper.transition(100);
                sb.drag.transition(100);
                s.emit('onScrollbarDragStart', s);
            },
            dragMove: function (e) {
                var sb = s.scrollbar;
                if (!sb.isTouched) return;
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
                sb.setDragPosition(e);
                s.wrapper.transition(0);
                sb.track.transition(0);
                sb.drag.transition(0);
                s.emit('onScrollbarDragMove', s);
            },
            dragEnd: function (e) {
                var sb = s.scrollbar;
                if (!sb.isTouched) return;
                sb.isTouched = false;
                if (s.params.scrollbarHide) {
                    clearTimeout(sb.dragTimeout);
                    sb.dragTimeout = setTimeout(function () {
                        sb.track.css('opacity', 0);
                        sb.track.transition(400);
                    }, 1000);
        
                }
                s.emit('onScrollbarDragEnd', s);
                if (s.params.scrollbarSnapOnRelease) {
                    s.slideReset();
                }
            },
            draggableEvents: (function () {
                if ((s.params.simulateTouch === false && !s.support.touch)) return s.touchEventsDesktop;
                else return s.touchEvents;
            })(),
            enableDraggable: function () {
                var sb = s.scrollbar;
                var target = s.support.touch ? sb.track : document;
                $(sb.track).on(sb.draggableEvents.start, sb.dragStart);
                $(target).on(sb.draggableEvents.move, sb.dragMove);
                $(target).on(sb.draggableEvents.end, sb.dragEnd);
            },
            disableDraggable: function () {
                var sb = s.scrollbar;
                var target = s.support.touch ? sb.track : document;
                $(sb.track).off(sb.draggableEvents.start, sb.dragStart);
                $(target).off(sb.draggableEvents.move, sb.dragMove);
                $(target).off(sb.draggableEvents.end, sb.dragEnd);
            },
            set: function () {
                if (!s.params.scrollbar) return;
                var sb = s.scrollbar;
                sb.track = $(s.params.scrollbar);
                if (s.params.uniqueNavElements && typeof s.params.scrollbar === 'string' && sb.track.length > 1 && s.container.find(s.params.scrollbar).length === 1) {
                    sb.track = s.container.find(s.params.scrollbar);
                }
                sb.drag = sb.track.find('.swiper-scrollbar-drag');
                if (sb.drag.length === 0) {
                    sb.drag = $('<div class="swiper-scrollbar-drag"></div>');
                    sb.track.append(sb.drag);
                }
                sb.drag[0].style.width = '';
                sb.drag[0].style.height = '';
                sb.trackSize = s.isHorizontal() ? sb.track[0].offsetWidth : sb.track[0].offsetHeight;
        
                sb.divider = s.size / s.virtualSize;
                sb.moveDivider = sb.divider * (sb.trackSize / s.size);
                sb.dragSize = sb.trackSize * sb.divider;
        
                if (s.isHorizontal()) {
                    sb.drag[0].style.width = sb.dragSize + 'px';
                }
                else {
                    sb.drag[0].style.height = sb.dragSize + 'px';
                }
        
                if (sb.divider >= 1) {
                    sb.track[0].style.display = 'none';
                }
                else {
                    sb.track[0].style.display = '';
                }
                if (s.params.scrollbarHide) {
                    sb.track[0].style.opacity = 0;
                }
            },
            setTranslate: function () {
                if (!s.params.scrollbar) return;
                var diff;
                var sb = s.scrollbar;
                var translate = s.translate || 0;
                var newPos;
        
                var newSize = sb.dragSize;
                newPos = (sb.trackSize - sb.dragSize) * s.progress;
                if (s.rtl && s.isHorizontal()) {
                    newPos = -newPos;
                    if (newPos > 0) {
                        newSize = sb.dragSize - newPos;
                        newPos = 0;
                    }
                    else if (-newPos + sb.dragSize > sb.trackSize) {
                        newSize = sb.trackSize + newPos;
                    }
                }
                else {
                    if (newPos < 0) {
                        newSize = sb.dragSize + newPos;
                        newPos = 0;
                    }
                    else if (newPos + sb.dragSize > sb.trackSize) {
                        newSize = sb.trackSize - newPos;
                    }
                }
                if (s.isHorizontal()) {
                    if (s.support.transforms3d) {
                        sb.drag.transform('translate3d(' + (newPos) + 'px, 0, 0)');
                    }
                    else {
                        sb.drag.transform('translateX(' + (newPos) + 'px)');
                    }
                    sb.drag[0].style.width = newSize + 'px';
                }
                else {
                    if (s.support.transforms3d) {
                        sb.drag.transform('translate3d(0px, ' + (newPos) + 'px, 0)');
                    }
                    else {
                        sb.drag.transform('translateY(' + (newPos) + 'px)');
                    }
                    sb.drag[0].style.height = newSize + 'px';
                }
                if (s.params.scrollbarHide) {
                    clearTimeout(sb.timeout);
                    sb.track[0].style.opacity = 1;
                    sb.timeout = setTimeout(function () {
                        sb.track[0].style.opacity = 0;
                        sb.track.transition(400);
                    }, 1000);
                }
            },
            setTransition: function (duration) {
                if (!s.params.scrollbar) return;
                s.scrollbar.drag.transition(duration);
            }
        };
        

        /*=========================
          Controller
          ===========================*/
        s.controller = {
            LinearSpline: function (x, y) {
                var binarySearch = (function() {
                    var maxIndex, minIndex, guess;
                    return function(array, val) {
                        minIndex = -1;
                        maxIndex = array.length;
                        while (maxIndex - minIndex > 1)
                            if (array[guess = maxIndex + minIndex >> 1] <= val) {
                                minIndex = guess;
                            } else {
                                maxIndex = guess;
                            }
                        return maxIndex;
                    };
                })();
                this.x = x;
                this.y = y;
                this.lastIndex = x.length - 1;
                // Given an x value (x2), return the expected y2 value:
                // (x1,y1) is the known point before given value,
                // (x3,y3) is the known point after given value.
                var i1, i3;
                var l = this.x.length;
        
                this.interpolate = function (x2) {
                    if (!x2) return 0;
        
                    // Get the indexes of x1 and x3 (the array indexes before and after given x2):
                    i3 = binarySearch(this.x, x2);
                    i1 = i3 - 1;
        
                    // We have our indexes i1 & i3, so we can calculate already:
                    // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
                    return ((x2 - this.x[i1]) * (this.y[i3] - this.y[i1])) / (this.x[i3] - this.x[i1]) + this.y[i1];
                };
            },
            //xxx: for now i will just save one spline function to to
            getInterpolateFunction: function(c){
                if(!s.controller.spline) s.controller.spline = s.params.loop ?
                    new s.controller.LinearSpline(s.slidesGrid, c.slidesGrid) :
                    new s.controller.LinearSpline(s.snapGrid, c.snapGrid);
            },
            setTranslate: function (translate, byController) {
               var controlled = s.params.control;
               var multiplier, controlledTranslate;
               function setControlledTranslate(c) {
                    // this will create an Interpolate function based on the snapGrids
                    // x is the Grid of the scrolled scroller and y will be the controlled scroller
                    // it makes sense to create this only once and recall it for the interpolation
                    // the function does a lot of value caching for performance
                    translate = c.rtl && c.params.direction === 'horizontal' ? -s.translate : s.translate;
                    if (s.params.controlBy === 'slide') {
                        s.controller.getInterpolateFunction(c);
                        // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
                        // but it did not work out
                        controlledTranslate = -s.controller.spline.interpolate(-translate);
                    }
        
                    if(!controlledTranslate || s.params.controlBy === 'container'){
                        multiplier = (c.maxTranslate() - c.minTranslate()) / (s.maxTranslate() - s.minTranslate());
                        controlledTranslate = (translate - s.minTranslate()) * multiplier + c.minTranslate();
                    }
        
                    if (s.params.controlInverse) {
                        controlledTranslate = c.maxTranslate() - controlledTranslate;
                    }
                    c.updateProgress(controlledTranslate);
                    c.setWrapperTranslate(controlledTranslate, false, s);
                    c.updateActiveIndex();
               }
               if (Array.isArray(controlled)) {
                   for (var i = 0; i < controlled.length; i++) {
                       if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
                           setControlledTranslate(controlled[i]);
                       }
                   }
               }
               else if (controlled instanceof Swiper && byController !== controlled) {
        
                   setControlledTranslate(controlled);
               }
            },
            setTransition: function (duration, byController) {
                var controlled = s.params.control;
                var i;
                function setControlledTransition(c) {
                    c.setWrapperTransition(duration, s);
                    if (duration !== 0) {
                        c.onTransitionStart();
                        c.wrapper.transitionEnd(function(){
                            if (!controlled) return;
                            if (c.params.loop && s.params.controlBy === 'slide') {
                                c.fixLoop();
                            }
                            c.onTransitionEnd();
        
                        });
                    }
                }
                if (Array.isArray(controlled)) {
                    for (i = 0; i < controlled.length; i++) {
                        if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
                            setControlledTransition(controlled[i]);
                        }
                    }
                }
                else if (controlled instanceof Swiper && byController !== controlled) {
                    setControlledTransition(controlled);
                }
            }
        };
        

        /*=========================
          Hash Navigation
          ===========================*/
        s.hashnav = {
            onHashCange: function (e, a) {
                var newHash = document.location.hash.replace('#', '');
                var activeSlideHash = s.slides.eq(s.activeIndex).attr('data-hash');
                if (newHash !== activeSlideHash) {
                    s.slideTo(s.wrapper.children('.' + s.params.slideClass + '[data-hash="' + (newHash) + '"]').index());
                }
            },
            attachEvents: function (detach) {
                var action = detach ? 'off' : 'on';
                $(window)[action]('hashchange', s.hashnav.onHashCange);
            },
            setHash: function () {
                if (!s.hashnav.initialized || !s.params.hashnav) return;
                if (s.params.replaceState && window.history && window.history.replaceState) {
                    window.history.replaceState(null, null, ('#' + s.slides.eq(s.activeIndex).attr('data-hash') || ''));
                } else {
                    var slide = s.slides.eq(s.activeIndex);
                    var hash = slide.attr('data-hash') || slide.attr('data-history');
                    document.location.hash = hash || '';
                }
            },
            init: function () {
                if (!s.params.hashnav || s.params.history) return;
                s.hashnav.initialized = true;
                var hash = document.location.hash.replace('#', '');
                if (hash) {
                    var speed = 0;
                    for (var i = 0, length = s.slides.length; i < length; i++) {
                        var slide = s.slides.eq(i);
                        var slideHash = slide.attr('data-hash') || slide.attr('data-history');
                        if (slideHash === hash && !slide.hasClass(s.params.slideDuplicateClass)) {
                            var index = slide.index();
                            s.slideTo(index, speed, s.params.runCallbacksOnInit, true);
                        }
                    }
                }
                if (s.params.hashnavWatchState) s.hashnav.attachEvents();
            },
            destroy: function () {
                if (s.params.hashnavWatchState) s.hashnav.attachEvents(true);
            }
        };
        

        /*=========================
          History Api with fallback to Hashnav
          ===========================*/
        s.history = {
            init: function () {
                if (!s.params.history) return;
                if (!window.history || !window.history.pushState) {
                    s.params.history = false;
                    s.params.hashnav = true;
                    return;
                }
                s.history.initialized = true;
                this.paths = this.getPathValues();
                if (!this.paths.key && !this.paths.value) return;
                this.scrollToSlide(0, this.paths.value, s.params.runCallbacksOnInit);
                if (!s.params.replaceState) {
                    window.addEventListener('popstate', this.setHistoryPopState);
                }
            },
            setHistoryPopState: function() {
                s.history.paths = s.history.getPathValues();
                s.history.scrollToSlide(s.params.speed, s.history.paths.value, false);
            },
            getPathValues: function() {
                var pathArray = window.location.pathname.slice(1).split('/');
                var total = pathArray.length;
                var key = pathArray[total - 2];
                var value = pathArray[total - 1];
                return { key: key, value: value };
            },
            setHistory: function (key, index) {
                if (!s.history.initialized || !s.params.history) return;
                var slide = s.slides.eq(index);
                var value = this.slugify(slide.attr('data-history'));
                if (!window.location.pathname.includes(key)) {
                    value = key + '/' + value;
                }
                if (s.params.replaceState) {
                    window.history.replaceState(null, null, value);
                } else {
                    window.history.pushState(null, null, value);
                }
            },
            slugify: function(text) {
                return text.toString().toLowerCase()
                    .replace(/\s+/g, '-')
                    .replace(/[^\w\-]+/g, '')
                    .replace(/\-\-+/g, '-')
                    .replace(/^-+/, '')
                    .replace(/-+$/, '');
            },
            scrollToSlide: function(speed, value, runCallbacks) {
                if (value) {
                    for (var i = 0, length = s.slides.length; i < length; i++) {
                        var slide = s.slides.eq(i);
                        var slideHistory = this.slugify(slide.attr('data-history'));
                        if (slideHistory === value && !slide.hasClass(s.params.slideDuplicateClass)) {
                            var index = slide.index();
                            s.slideTo(index, speed, runCallbacks);
                        }
                    }
                } else {
                    s.slideTo(0, speed, runCallbacks);
                }
            }
        };
        

        /*=========================
          Keyboard Control
          ===========================*/
        function handleKeyboard(e) {
            if (e.originalEvent) e = e.originalEvent; //jquery fix
            var kc = e.keyCode || e.charCode;
            // Directions locks
            if (!s.params.allowSwipeToNext && (s.isHorizontal() && kc === 39 || !s.isHorizontal() && kc === 40)) {
                return false;
            }
            if (!s.params.allowSwipeToPrev && (s.isHorizontal() && kc === 37 || !s.isHorizontal() && kc === 38)) {
                return false;
            }
            if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) {
                return;
            }
            if (document.activeElement && document.activeElement.nodeName && (document.activeElement.nodeName.toLowerCase() === 'input' || document.activeElement.nodeName.toLowerCase() === 'textarea')) {
                return;
            }
            if (kc === 37 || kc === 39 || kc === 38 || kc === 40) {
                var inView = false;
                //Check that swiper should be inside of visible area of window
                if (s.container.parents('.' + s.params.slideClass).length > 0 && s.container.parents('.' + s.params.slideActiveClass).length === 0) {
                    return;
                }
                var windowScroll = {
                    left: window.pageXOffset,
                    top: window.pageYOffset
                };
                var windowWidth = window.innerWidth;
                var windowHeight = window.innerHeight;
                var swiperOffset = s.container.offset();
                if (s.rtl) swiperOffset.left = swiperOffset.left - s.container[0].scrollLeft;
                var swiperCoord = [
                    [swiperOffset.left, swiperOffset.top],
                    [swiperOffset.left + s.width, swiperOffset.top],
                    [swiperOffset.left, swiperOffset.top + s.height],
                    [swiperOffset.left + s.width, swiperOffset.top + s.height]
                ];
                for (var i = 0; i < swiperCoord.length; i++) {
                    var point = swiperCoord[i];
                    if (
                        point[0] >= windowScroll.left && point[0] <= windowScroll.left + windowWidth &&
                        point[1] >= windowScroll.top && point[1] <= windowScroll.top + windowHeight
                    ) {
                        inView = true;
                    }
        
                }
                if (!inView) return;
            }
            if (s.isHorizontal()) {
                if (kc === 37 || kc === 39) {
                    if (e.preventDefault) e.preventDefault();
                    else e.returnValue = false;
                }
                if ((kc === 39 && !s.rtl) || (kc === 37 && s.rtl)) s.slideNext();
                if ((kc === 37 && !s.rtl) || (kc === 39 && s.rtl)) s.slidePrev();
            }
            else {
                if (kc === 38 || kc === 40) {
                    if (e.preventDefault) e.preventDefault();
                    else e.returnValue = false;
                }
                if (kc === 40) s.slideNext();
                if (kc === 38) s.slidePrev();
            }
            s.emit('onKeyPress', s, kc);
        }
        s.disableKeyboardControl = function () {
            s.params.keyboardControl = false;
            $(document).off('keydown', handleKeyboard);
        };
        s.enableKeyboardControl = function () {
            s.params.keyboardControl = true;
            $(document).on('keydown', handleKeyboard);
        };
        

        /*=========================
          Mousewheel Control
          ===========================*/
        s.mousewheel = {
            event: false,
            lastScrollTime: (new window.Date()).getTime()
        };
        function isEventSupported() {
            var eventName = 'onwheel';
            var isSupported = eventName in document;
        
            if (!isSupported) {
                var element = document.createElement('div');
                element.setAttribute(eventName, 'return;');
                isSupported = typeof element[eventName] === 'function';
            }
        
            if (!isSupported &&
                document.implementation &&
                document.implementation.hasFeature &&
                    // always returns true in newer browsers as per the standard.
                    // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
                document.implementation.hasFeature('', '') !== true ) {
                // This is the only way to test support for the `wheel` event in IE9+.
                isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
            }
        
            return isSupported;
        }
        /**
         * Mouse wheel (and 2-finger trackpad) support on the web sucks.  It is
         * complicated, thus this doc is long and (hopefully) detailed enough to answer
         * your questions.
         *
         * If you need to react to the mouse wheel in a predictable way, this code is
         * like your bestest friend. * hugs *
         *
         * As of today, there are 4 DOM event types you can listen to:
         *
         *   'wheel'                -- Chrome(31+), FF(17+), IE(9+)
         *   'mousewheel'           -- Chrome, IE(6+), Opera, Safari
         *   'MozMousePixelScroll'  -- FF(3.5 only!) (2010-2013) -- don't bother!
         *   'DOMMouseScroll'       -- FF(0.9.7+) since 2003
         *
         * So what to do?  The is the best:
         *
         *   normalizeWheel.getEventType();
         *
         * In your event callback, use this code to get sane interpretation of the
         * deltas.  This code will return an object with properties:
         *
         *   spinX   -- normalized spin speed (use for zoom) - x plane
         *   spinY   -- " - y plane
         *   pixelX  -- normalized distance (to pixels) - x plane
         *   pixelY  -- " - y plane
         *
         * Wheel values are provided by the browser assuming you are using the wheel to
         * scroll a web page by a number of lines or pixels (or pages).  Values can vary
         * significantly on different platforms and browsers, forgetting that you can
         * scroll at different speeds.  Some devices (like trackpads) emit more events
         * at smaller increments with fine granularity, and some emit massive jumps with
         * linear speed or acceleration.
         *
         * This code does its best to normalize the deltas for you:
         *
         *   - spin is trying to normalize how far the wheel was spun (or trackpad
         *     dragged).  This is super useful for zoom support where you want to
         *     throw away the chunky scroll steps on the PC and make those equal to
         *     the slow and smooth tiny steps on the Mac. Key data: This code tries to
         *     resolve a single slow step on a wheel to 1.
         *
         *   - pixel is normalizing the desired scroll delta in pixel units.  You'll
         *     get the crazy differences between browsers, but at least it'll be in
         *     pixels!
         *
         *   - positive value indicates scrolling DOWN/RIGHT, negative UP/LEFT.  This
         *     should translate to positive value zooming IN, negative zooming OUT.
         *     This matches the newer 'wheel' event.
         *
         * Why are there spinX, spinY (or pixels)?
         *
         *   - spinX is a 2-finger side drag on the trackpad, and a shift + wheel turn
         *     with a mouse.  It results in side-scrolling in the browser by default.
         *
         *   - spinY is what you expect -- it's the classic axis of a mouse wheel.
         *
         *   - I dropped spinZ/pixelZ.  It is supported by the DOM 3 'wheel' event and
         *     probably is by browsers in conjunction with fancy 3D controllers .. but
         *     you know.
         *
         * Implementation info:
         *
         * Examples of 'wheel' event if you scroll slowly (down) by one step with an
         * average mouse:
         *
         *   OS X + Chrome  (mouse)     -    4   pixel delta  (wheelDelta -120)
         *   OS X + Safari  (mouse)     -  N/A   pixel delta  (wheelDelta  -12)
         *   OS X + Firefox (mouse)     -    0.1 line  delta  (wheelDelta  N/A)
         *   Win8 + Chrome  (mouse)     -  100   pixel delta  (wheelDelta -120)
         *   Win8 + Firefox (mouse)     -    3   line  delta  (wheelDelta -120)
         *
         * On the trackpad:
         *
         *   OS X + Chrome  (trackpad)  -    2   pixel delta  (wheelDelta   -6)
         *   OS X + Firefox (trackpad)  -    1   pixel delta  (wheelDelta  N/A)
         *
         * On other/older browsers.. it's more complicated as there can be multiple and
         * also missing delta values.
         *
         * The 'wheel' event is more standard:
         *
         * http://www.w3.org/TR/DOM-Level-3-Events/#events-wheelevents
         *
         * The basics is that it includes a unit, deltaMode (pixels, lines, pages), and
         * deltaX, deltaY and deltaZ.  Some browsers provide other values to maintain
         * backward compatibility with older events.  Those other values help us
         * better normalize spin speed.  Example of what the browsers provide:
         *
         *                          | event.wheelDelta | event.detail
         *        ------------------+------------------+--------------
         *          Safari v5/OS X  |       -120       |       0
         *          Safari v5/Win7  |       -120       |       0
         *         Chrome v17/OS X  |       -120       |       0
         *         Chrome v17/Win7  |       -120       |       0
         *                IE9/Win7  |       -120       |   undefined
         *         Firefox v4/OS X  |     undefined    |       1
         *         Firefox v4/Win7  |     undefined    |       3
         *
         */
        function normalizeWheel( /*object*/ event ) /*object*/ {
            // Reasonable defaults
            var PIXEL_STEP = 10;
            var LINE_HEIGHT = 40;
            var PAGE_HEIGHT = 800;
        
            var sX = 0, sY = 0,       // spinX, spinY
                pX = 0, pY = 0;       // pixelX, pixelY
        
            // Legacy
            if( 'detail' in event ) {
                sY = event.detail;
            }
            if( 'wheelDelta' in event ) {
                sY = -event.wheelDelta / 120;
            }
            if( 'wheelDeltaY' in event ) {
                sY = -event.wheelDeltaY / 120;
            }
            if( 'wheelDeltaX' in event ) {
                sX = -event.wheelDeltaX / 120;
            }
        
            // side scrolling on FF with DOMMouseScroll
            if( 'axis' in event && event.axis === event.HORIZONTAL_AXIS ) {
                sX = sY;
                sY = 0;
            }
        
            pX = sX * PIXEL_STEP;
            pY = sY * PIXEL_STEP;
        
            if( 'deltaY' in event ) {
                pY = event.deltaY;
            }
            if( 'deltaX' in event ) {
                pX = event.deltaX;
            }
        
            if( (pX || pY) && event.deltaMode ) {
                if( event.deltaMode === 1 ) {          // delta in LINE units
                    pX *= LINE_HEIGHT;
                    pY *= LINE_HEIGHT;
                } else {                             // delta in PAGE units
                    pX *= PAGE_HEIGHT;
                    pY *= PAGE_HEIGHT;
                }
            }
        
            // Fall-back if spin cannot be determined
            if( pX && !sX ) {
                sX = (pX < 1) ? -1 : 1;
            }
            if( pY && !sY ) {
                sY = (pY < 1) ? -1 : 1;
            }
        
            return {
                spinX: sX,
                spinY: sY,
                pixelX: pX,
                pixelY: pY
            };
        }
        if (s.params.mousewheelControl) {
            /**
             * The best combination if you prefer spinX + spinY normalization.  It favors
             * the older DOMMouseScroll for Firefox, as FF does not include wheelDelta with
             * 'wheel' event, making spin speed determination impossible.
             */
            s.mousewheel.event = (navigator.userAgent.indexOf('firefox') > -1) ?
                'DOMMouseScroll' :
                isEventSupported() ?
                    'wheel' : 'mousewheel';
        }
        function handleMousewheel(e) {
            if (e.originalEvent) e = e.originalEvent; //jquery fix
            var delta = 0;
            var rtlFactor = s.rtl ? -1 : 1;
        
            var data = normalizeWheel( e );
        
            if (s.params.mousewheelForceToAxis) {
                if (s.isHorizontal()) {
                    if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) delta = data.pixelX * rtlFactor;
                    else return;
                }
                else {
                    if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) delta = data.pixelY;
                    else return;
                }
            }
            else {
                delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? - data.pixelX * rtlFactor : - data.pixelY;
            }
        
            if (delta === 0) return;
        
            if (s.params.mousewheelInvert) delta = -delta;
        
            if (!s.params.freeMode) {
                if ((new window.Date()).getTime() - s.mousewheel.lastScrollTime > 60) {
                    if (delta < 0) {
                        if ((!s.isEnd || s.params.loop) && !s.animating) {
                            s.slideNext();
                            s.emit('onScroll', s, e);
                        }
                        else if (s.params.mousewheelReleaseOnEdges) return true;
                    }
                    else {
                        if ((!s.isBeginning || s.params.loop) && !s.animating) {
                            s.slidePrev();
                            s.emit('onScroll', s, e);
                        }
                        else if (s.params.mousewheelReleaseOnEdges) return true;
                    }
                }
                s.mousewheel.lastScrollTime = (new window.Date()).getTime();
        
            }
            else {
                //Freemode or scrollContainer:
                var position = s.getWrapperTranslate() + delta * s.params.mousewheelSensitivity;
                var wasBeginning = s.isBeginning,
                    wasEnd = s.isEnd;
        
                if (position >= s.minTranslate()) position = s.minTranslate();
                if (position <= s.maxTranslate()) position = s.maxTranslate();
        
                s.setWrapperTransition(0);
                s.setWrapperTranslate(position);
                s.updateProgress();
                s.updateActiveIndex();
        
                if (!wasBeginning && s.isBeginning || !wasEnd && s.isEnd) {
                    s.updateClasses();
                }
        
                if (s.params.freeModeSticky) {
                    clearTimeout(s.mousewheel.timeout);
                    s.mousewheel.timeout = setTimeout(function () {
                        s.slideReset();
                    }, 300);
                }
                else {
                    if (s.params.lazyLoading && s.lazy) {
                        s.lazy.load();
                    }
                }
                // Emit event
                s.emit('onScroll', s, e);
        
                // Stop autoplay
                if (s.params.autoplay && s.params.autoplayDisableOnInteraction) s.stopAutoplay();
        
                // Return page scroll on edge positions
                if (position === 0 || position === s.maxTranslate()) return;
            }
        
            if (e.preventDefault) e.preventDefault();
            else e.returnValue = false;
            return false;
        }
        s.disableMousewheelControl = function () {
            if (!s.mousewheel.event) return false;
            var target = s.container;
            if (s.params.mousewheelEventsTarged !== 'container') {
                target = $(s.params.mousewheelEventsTarged);
            }
            target.off(s.mousewheel.event, handleMousewheel);
            s.params.mousewheelControl = false;
            return true;
        };
        
        s.enableMousewheelControl = function () {
            if (!s.mousewheel.event) return false;
            var target = s.container;
            if (s.params.mousewheelEventsTarged !== 'container') {
                target = $(s.params.mousewheelEventsTarged);
            }
            target.on(s.mousewheel.event, handleMousewheel);
            s.params.mousewheelControl = true;
            return true;
        };
        

        /*=========================
          Parallax
          ===========================*/
        function setParallaxTransform(el, progress) {
            el = $(el);
            var p, pX, pY;
            var rtlFactor = s.rtl ? -1 : 1;
        
            p = el.attr('data-swiper-parallax') || '0';
            pX = el.attr('data-swiper-parallax-x');
            pY = el.attr('data-swiper-parallax-y');
            if (pX || pY) {
                pX = pX || '0';
                pY = pY || '0';
            }
            else {
                if (s.isHorizontal()) {
                    pX = p;
                    pY = '0';
                }
                else {
                    pY = p;
                    pX = '0';
                }
            }
        
            if ((pX).indexOf('%') >= 0) {
                pX = parseInt(pX, 10) * progress * rtlFactor + '%';
            }
            else {
                pX = pX * progress * rtlFactor + 'px' ;
            }
            if ((pY).indexOf('%') >= 0) {
                pY = parseInt(pY, 10) * progress + '%';
            }
            else {
                pY = pY * progress + 'px' ;
            }
        
            el.transform('translate3d(' + pX + ', ' + pY + ',0px)');
        }
        s.parallax = {
            setTranslate: function () {
                s.container.children('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]').each(function(){
                    setParallaxTransform(this, s.progress);
        
                });
                s.slides.each(function () {
                    var slide = $(this);
                    slide.find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]').each(function () {
                        var progress = Math.min(Math.max(slide[0].progress, -1), 1);
                        setParallaxTransform(this, progress);
                    });
                });
            },
            setTransition: function (duration) {
                if (typeof duration === 'undefined') duration = s.params.speed;
                s.container.find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]').each(function(){
                    var el = $(this);
                    var parallaxDuration = parseInt(el.attr('data-swiper-parallax-duration'), 10) || duration;
                    if (duration === 0) parallaxDuration = 0;
                    el.transition(parallaxDuration);
                });
            }
        };
        

        /*=========================
          Zoom
          ===========================*/
        s.zoom = {
            // "Global" Props
            scale: 1,
            currentScale: 1,
            isScaling: false,
            gesture: {
                slide: undefined,
                slideWidth: undefined,
                slideHeight: undefined,
                image: undefined,
                imageWrap: undefined,
                zoomMax: s.params.zoomMax
            },
            image: {
                isTouched: undefined,
                isMoved: undefined,
                currentX: undefined,
                currentY: undefined,
                minX: undefined,
                minY: undefined,
                maxX: undefined,
                maxY: undefined,
                width: undefined,
                height: undefined,
                startX: undefined,
                startY: undefined,
                touchesStart: {},
                touchesCurrent: {}
            },
            velocity: {
                x: undefined,
                y: undefined,
                prevPositionX: undefined,
                prevPositionY: undefined,
                prevTime: undefined
            },
            // Calc Scale From Multi-touches
            getDistanceBetweenTouches: function (e) {
                if (e.targetTouches.length < 2) return 1;
                var x1 = e.targetTouches[0].pageX,
                    y1 = e.targetTouches[0].pageY,
                    x2 = e.targetTouches[1].pageX,
                    y2 = e.targetTouches[1].pageY;
                var distance = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
                return distance;
            },
            // Events
            onGestureStart: function (e) {
                var z = s.zoom;
                if (!s.support.gestures) {
                    if (e.type !== 'touchstart' || e.type === 'touchstart' && e.targetTouches.length < 2) {
                        return;
                    }
                    z.gesture.scaleStart = z.getDistanceBetweenTouches(e);
                }
                if (!z.gesture.slide || !z.gesture.slide.length) {
                    z.gesture.slide = $(this);
                    if (z.gesture.slide.length === 0) z.gesture.slide = s.slides.eq(s.activeIndex);
                    z.gesture.image = z.gesture.slide.find('img, svg, canvas');
                    z.gesture.imageWrap = z.gesture.image.parent('.' + s.params.zoomContainerClass);
                    z.gesture.zoomMax = z.gesture.imageWrap.attr('data-swiper-zoom') || s.params.zoomMax ;
                    if (z.gesture.imageWrap.length === 0) {
                        z.gesture.image = undefined;
                        return;
                    }
                }
                z.gesture.image.transition(0);
                z.isScaling = true;
            },
            onGestureChange: function (e) {
                var z = s.zoom;
                if (!s.support.gestures) {
                    if (e.type !== 'touchmove' || e.type === 'touchmove' && e.targetTouches.length < 2) {
                        return;
                    }
                    z.gesture.scaleMove = z.getDistanceBetweenTouches(e);
                }
                if (!z.gesture.image || z.gesture.image.length === 0) return;
                if (s.support.gestures) {
                    z.scale = e.scale * z.currentScale;
                }
                else {
                    z.scale = (z.gesture.scaleMove / z.gesture.scaleStart) * z.currentScale;
                }
                if (z.scale > z.gesture.zoomMax) {
                    z.scale = z.gesture.zoomMax - 1 + Math.pow((z.scale - z.gesture.zoomMax + 1), 0.5);
                }
                if (z.scale < s.params.zoomMin) {
                    z.scale =  s.params.zoomMin + 1 - Math.pow((s.params.zoomMin - z.scale + 1), 0.5);
                }
                z.gesture.image.transform('translate3d(0,0,0) scale(' + z.scale + ')');
            },
            onGestureEnd: function (e) {
                var z = s.zoom;
                if (!s.support.gestures) {
                    if (e.type !== 'touchend' || e.type === 'touchend' && e.changedTouches.length < 2) {
                        return;
                    }
                }
                if (!z.gesture.image || z.gesture.image.length === 0) return;
                z.scale = Math.max(Math.min(z.scale, z.gesture.zoomMax), s.params.zoomMin);
                z.gesture.image.transition(s.params.speed).transform('translate3d(0,0,0) scale(' + z.scale + ')');
                z.currentScale = z.scale;
                z.isScaling = false;
                if (z.scale === 1) z.gesture.slide = undefined;
            },
            onTouchStart: function (s, e) {
                var z = s.zoom;
                if (!z.gesture.image || z.gesture.image.length === 0) return;
                if (z.image.isTouched) return;
                if (s.device.os === 'android') e.preventDefault();
                z.image.isTouched = true;
                z.image.touchesStart.x = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
                z.image.touchesStart.y = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
            },
            onTouchMove: function (e) {
                var z = s.zoom;
                if (!z.gesture.image || z.gesture.image.length === 0) return;
                s.allowClick = false;
                if (!z.image.isTouched || !z.gesture.slide) return;
        
                if (!z.image.isMoved) {
                    z.image.width = z.gesture.image[0].offsetWidth;
                    z.image.height = z.gesture.image[0].offsetHeight;
                    z.image.startX = s.getTranslate(z.gesture.imageWrap[0], 'x') || 0;
                    z.image.startY = s.getTranslate(z.gesture.imageWrap[0], 'y') || 0;
                    z.gesture.slideWidth = z.gesture.slide[0].offsetWidth;
                    z.gesture.slideHeight = z.gesture.slide[0].offsetHeight;
                    z.gesture.imageWrap.transition(0);
                    if (s.rtl) z.image.startX = -z.image.startX;
                    if (s.rtl) z.image.startY = -z.image.startY;
                }
                // Define if we need image drag
                var scaledWidth = z.image.width * z.scale;
                var scaledHeight = z.image.height * z.scale;
        
                if (scaledWidth < z.gesture.slideWidth && scaledHeight < z.gesture.slideHeight) return;
        
                z.image.minX = Math.min((z.gesture.slideWidth / 2 - scaledWidth / 2), 0);
                z.image.maxX = -z.image.minX;
                z.image.minY = Math.min((z.gesture.slideHeight / 2 - scaledHeight / 2), 0);
                z.image.maxY = -z.image.minY;
        
                z.image.touchesCurrent.x = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
                z.image.touchesCurrent.y = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
        
                if (!z.image.isMoved && !z.isScaling) {
                    if (s.isHorizontal() &&
                        (Math.floor(z.image.minX) === Math.floor(z.image.startX) && z.image.touchesCurrent.x < z.image.touchesStart.x) ||
                        (Math.floor(z.image.maxX) === Math.floor(z.image.startX) && z.image.touchesCurrent.x > z.image.touchesStart.x)
                        ) {
                        z.image.isTouched = false;
                        return;
                    }
                    else if (!s.isHorizontal() &&
                        (Math.floor(z.image.minY) === Math.floor(z.image.startY) && z.image.touchesCurrent.y < z.image.touchesStart.y) ||
                        (Math.floor(z.image.maxY) === Math.floor(z.image.startY) && z.image.touchesCurrent.y > z.image.touchesStart.y)
                        ) {
                        z.image.isTouched = false;
                        return;
                    }
                }
                e.preventDefault();
                e.stopPropagation();
        
                z.image.isMoved = true;
                z.image.currentX = z.image.touchesCurrent.x - z.image.touchesStart.x + z.image.startX;
                z.image.currentY = z.image.touchesCurrent.y - z.image.touchesStart.y + z.image.startY;
        
                if (z.image.currentX < z.image.minX) {
                    z.image.currentX =  z.image.minX + 1 - Math.pow((z.image.minX - z.image.currentX + 1), 0.8);
                }
                if (z.image.currentX > z.image.maxX) {
                    z.image.currentX = z.image.maxX - 1 + Math.pow((z.image.currentX - z.image.maxX + 1), 0.8);
                }
        
                if (z.image.currentY < z.image.minY) {
                    z.image.currentY =  z.image.minY + 1 - Math.pow((z.image.minY - z.image.currentY + 1), 0.8);
                }
                if (z.image.currentY > z.image.maxY) {
                    z.image.currentY = z.image.maxY - 1 + Math.pow((z.image.currentY - z.image.maxY + 1), 0.8);
                }
        
                //Velocity
                if (!z.velocity.prevPositionX) z.velocity.prevPositionX = z.image.touchesCurrent.x;
                if (!z.velocity.prevPositionY) z.velocity.prevPositionY = z.image.touchesCurrent.y;
                if (!z.velocity.prevTime) z.velocity.prevTime = Date.now();
                z.velocity.x = (z.image.touchesCurrent.x - z.velocity.prevPositionX) / (Date.now() - z.velocity.prevTime) / 2;
                z.velocity.y = (z.image.touchesCurrent.y - z.velocity.prevPositionY) / (Date.now() - z.velocity.prevTime) / 2;
                if (Math.abs(z.image.touchesCurrent.x - z.velocity.prevPositionX) < 2) z.velocity.x = 0;
                if (Math.abs(z.image.touchesCurrent.y - z.velocity.prevPositionY) < 2) z.velocity.y = 0;
                z.velocity.prevPositionX = z.image.touchesCurrent.x;
                z.velocity.prevPositionY = z.image.touchesCurrent.y;
                z.velocity.prevTime = Date.now();
        
                z.gesture.imageWrap.transform('translate3d(' + z.image.currentX + 'px, ' + z.image.currentY + 'px,0)');
            },
            onTouchEnd: function (s, e) {
                var z = s.zoom;
                if (!z.gesture.image || z.gesture.image.length === 0) return;
                if (!z.image.isTouched || !z.image.isMoved) {
                    z.image.isTouched = false;
                    z.image.isMoved = false;
                    return;
                }
                z.image.isTouched = false;
                z.image.isMoved = false;
                var momentumDurationX = 300;
                var momentumDurationY = 300;
                var momentumDistanceX = z.velocity.x * momentumDurationX;
                var newPositionX = z.image.currentX + momentumDistanceX;
                var momentumDistanceY = z.velocity.y * momentumDurationY;
                var newPositionY = z.image.currentY + momentumDistanceY;
        
                //Fix duration
                if (z.velocity.x !== 0) momentumDurationX = Math.abs((newPositionX - z.image.currentX) / z.velocity.x);
                if (z.velocity.y !== 0) momentumDurationY = Math.abs((newPositionY - z.image.currentY) / z.velocity.y);
                var momentumDuration = Math.max(momentumDurationX, momentumDurationY);
        
                z.image.currentX = newPositionX;
                z.image.currentY = newPositionY;
        
                // Define if we need image drag
                var scaledWidth = z.image.width * z.scale;
                var scaledHeight = z.image.height * z.scale;
                z.image.minX = Math.min((z.gesture.slideWidth / 2 - scaledWidth / 2), 0);
                z.image.maxX = -z.image.minX;
                z.image.minY = Math.min((z.gesture.slideHeight / 2 - scaledHeight / 2), 0);
                z.image.maxY = -z.image.minY;
                z.image.currentX = Math.max(Math.min(z.image.currentX, z.image.maxX), z.image.minX);
                z.image.currentY = Math.max(Math.min(z.image.currentY, z.image.maxY), z.image.minY);
        
                z.gesture.imageWrap.transition(momentumDuration).transform('translate3d(' + z.image.currentX + 'px, ' + z.image.currentY + 'px,0)');
            },
            onTransitionEnd: function (s) {
                var z = s.zoom;
                if (z.gesture.slide && s.previousIndex !== s.activeIndex) {
                    z.gesture.image.transform('translate3d(0,0,0) scale(1)');
                    z.gesture.imageWrap.transform('translate3d(0,0,0)');
                    z.gesture.slide = z.gesture.image = z.gesture.imageWrap = undefined;
                    z.scale = z.currentScale = 1;
                }
            },
            // Toggle Zoom
            toggleZoom: function (s, e) {
                var z = s.zoom;
                if (!z.gesture.slide) {
                    z.gesture.slide = s.clickedSlide ? $(s.clickedSlide) : s.slides.eq(s.activeIndex);
                    z.gesture.image = z.gesture.slide.find('img, svg, canvas');
                    z.gesture.imageWrap = z.gesture.image.parent('.' + s.params.zoomContainerClass);
                }
                if (!z.gesture.image || z.gesture.image.length === 0) return;
        
                var touchX, touchY, offsetX, offsetY, diffX, diffY, translateX, translateY, imageWidth, imageHeight, scaledWidth, scaledHeight, translateMinX, translateMinY, translateMaxX, translateMaxY, slideWidth, slideHeight;
        
                if (typeof z.image.touchesStart.x === 'undefined' && e) {
                    touchX = e.type === 'touchend' ? e.changedTouches[0].pageX : e.pageX;
                    touchY = e.type === 'touchend' ? e.changedTouches[0].pageY : e.pageY;
                }
                else {
                    touchX = z.image.touchesStart.x;
                    touchY = z.image.touchesStart.y;
                }
        
                if (z.scale && z.scale !== 1) {
                    // Zoom Out
                    z.scale = z.currentScale = 1;
                    z.gesture.imageWrap.transition(300).transform('translate3d(0,0,0)');
                    z.gesture.image.transition(300).transform('translate3d(0,0,0) scale(1)');
                    z.gesture.slide = undefined;
                }
                else {
                    // Zoom In
                    z.scale = z.currentScale = z.gesture.imageWrap.attr('data-swiper-zoom') || s.params.zoomMax;
                    if (e) {
                        slideWidth = z.gesture.slide[0].offsetWidth;
                        slideHeight = z.gesture.slide[0].offsetHeight;
                        offsetX = z.gesture.slide.offset().left;
                        offsetY = z.gesture.slide.offset().top;
                        diffX = offsetX + slideWidth/2 - touchX;
                        diffY = offsetY + slideHeight/2 - touchY;
        
                        imageWidth = z.gesture.image[0].offsetWidth;
                        imageHeight = z.gesture.image[0].offsetHeight;
                        scaledWidth = imageWidth * z.scale;
                        scaledHeight = imageHeight * z.scale;
        
                        translateMinX = Math.min((slideWidth / 2 - scaledWidth / 2), 0);
                        translateMinY = Math.min((slideHeight / 2 - scaledHeight / 2), 0);
                        translateMaxX = -translateMinX;
                        translateMaxY = -translateMinY;
        
                        translateX = diffX * z.scale;
                        translateY = diffY * z.scale;
        
                        if (translateX < translateMinX) {
                            translateX =  translateMinX;
                        }
                        if (translateX > translateMaxX) {
                            translateX = translateMaxX;
                        }
        
                        if (translateY < translateMinY) {
                            translateY =  translateMinY;
                        }
                        if (translateY > translateMaxY) {
                            translateY = translateMaxY;
                        }
                    }
                    else {
                        translateX = 0;
                        translateY = 0;
                    }
                    z.gesture.imageWrap.transition(300).transform('translate3d(' + translateX + 'px, ' + translateY + 'px,0)');
                    z.gesture.image.transition(300).transform('translate3d(0,0,0) scale(' + z.scale + ')');
                }
            },
            // Attach/Detach Events
            attachEvents: function (detach) {
                var action = detach ? 'off' : 'on';
        
                if (s.params.zoom) {
                    var target = s.slides;
                    var passiveListener = s.touchEvents.start === 'touchstart' && s.support.passiveListener && s.params.passiveListeners ? {passive: true, capture: false} : false;
                    // Scale image
                    if (s.support.gestures) {
                        s.slides[action]('gesturestart', s.zoom.onGestureStart, passiveListener);
                        s.slides[action]('gesturechange', s.zoom.onGestureChange, passiveListener);
                        s.slides[action]('gestureend', s.zoom.onGestureEnd, passiveListener);
                    }
                    else if (s.touchEvents.start === 'touchstart') {
                        s.slides[action](s.touchEvents.start, s.zoom.onGestureStart, passiveListener);
                        s.slides[action](s.touchEvents.move, s.zoom.onGestureChange, passiveListener);
                        s.slides[action](s.touchEvents.end, s.zoom.onGestureEnd, passiveListener);
                    }
        
                    // Move image
                    s[action]('touchStart', s.zoom.onTouchStart);
                    s.slides.each(function (index, slide){
                        if ($(slide).find('.' + s.params.zoomContainerClass).length > 0) {
                            $(slide)[action](s.touchEvents.move, s.zoom.onTouchMove);
                        }
                    });
                    s[action]('touchEnd', s.zoom.onTouchEnd);
        
                    // Scale Out
                    s[action]('transitionEnd', s.zoom.onTransitionEnd);
                    if (s.params.zoomToggle) {
                        s.on('doubleTap', s.zoom.toggleZoom);
                    }
                }
            },
            init: function () {
                s.zoom.attachEvents();
            },
            destroy: function () {
                s.zoom.attachEvents(true);
            }
        };
        

        /*=========================
          Plugins API. Collect all and init all plugins
          ===========================*/
        s._plugins = [];
        for (var plugin in s.plugins) {
            var p = s.plugins[plugin](s, s.params[plugin]);
            if (p) s._plugins.push(p);
        }
        // Method to call all plugins event/method
        s.callPlugins = function (eventName) {
            for (var i = 0; i < s._plugins.length; i++) {
                if (eventName in s._plugins[i]) {
                    s._plugins[i][eventName](arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]);
                }
            }
        };
        

        /*=========================
          Events/Callbacks/Plugins Emitter
          ===========================*/
        function normalizeEventName (eventName) {
            if (eventName.indexOf('on') !== 0) {
                if (eventName[0] !== eventName[0].toUpperCase()) {
                    eventName = 'on' + eventName[0].toUpperCase() + eventName.substring(1);
                }
                else {
                    eventName = 'on' + eventName;
                }
            }
            return eventName;
        }
        s.emitterEventListeners = {
        
        };
        s.emit = function (eventName) {
            // Trigger callbacks
            if (s.params[eventName]) {
                s.params[eventName](arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]);
            }
            var i;
            // Trigger events
            if (s.emitterEventListeners[eventName]) {
                for (i = 0; i < s.emitterEventListeners[eventName].length; i++) {
                    s.emitterEventListeners[eventName][i](arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]);
                }
            }
            // Trigger plugins
            if (s.callPlugins) s.callPlugins(eventName, arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]);
        };
        s.on = function (eventName, handler) {
            eventName = normalizeEventName(eventName);
            if (!s.emitterEventListeners[eventName]) s.emitterEventListeners[eventName] = [];
            s.emitterEventListeners[eventName].push(handler);
            return s;
        };
        s.off = function (eventName, handler) {
            var i;
            eventName = normalizeEventName(eventName);
            if (typeof handler === 'undefined') {
                // Remove all handlers for such event
                s.emitterEventListeners[eventName] = [];
                return s;
            }
            if (!s.emitterEventListeners[eventName] || s.emitterEventListeners[eventName].length === 0) return;
            for (i = 0; i < s.emitterEventListeners[eventName].length; i++) {
                if(s.emitterEventListeners[eventName][i] === handler) s.emitterEventListeners[eventName].splice(i, 1);
            }
            return s;
        };
        s.once = function (eventName, handler) {
            eventName = normalizeEventName(eventName);
            var _handler = function () {
                handler(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4]);
                s.off(eventName, _handler);
            };
            s.on(eventName, _handler);
            return s;
        };
        

        // Accessibility tools
        s.a11y = {
            makeFocusable: function ($el) {
                $el.attr('tabIndex', '0');
                return $el;
            },
            addRole: function ($el, role) {
                $el.attr('role', role);
                return $el;
            },
        
            addLabel: function ($el, label) {
                $el.attr('aria-label', label);
                return $el;
            },
        
            disable: function ($el) {
                $el.attr('aria-disabled', true);
                return $el;
            },
        
            enable: function ($el) {
                $el.attr('aria-disabled', false);
                return $el;
            },
        
            onEnterKey: function (event) {
                if (event.keyCode !== 13) return;
                if ($(event.target).is(s.params.nextButton)) {
                    s.onClickNext(event);
                    if (s.isEnd) {
                        s.a11y.notify(s.params.lastSlideMessage);
                    }
                    else {
                        s.a11y.notify(s.params.nextSlideMessage);
                    }
                }
                else if ($(event.target).is(s.params.prevButton)) {
                    s.onClickPrev(event);
                    if (s.isBeginning) {
                        s.a11y.notify(s.params.firstSlideMessage);
                    }
                    else {
                        s.a11y.notify(s.params.prevSlideMessage);
                    }
                }
                if ($(event.target).is('.' + s.params.bulletClass)) {
                    $(event.target)[0].click();
                }
            },
        
            liveRegion: $('<span class="' + s.params.notificationClass + '" aria-live="assertive" aria-atomic="true"></span>'),
        
            notify: function (message) {
                var notification = s.a11y.liveRegion;
                if (notification.length === 0) return;
                notification.html('');
                notification.html(message);
            },
            init: function () {
                // Setup accessibility
                if (s.params.nextButton && s.nextButton && s.nextButton.length > 0) {
                    s.a11y.makeFocusable(s.nextButton);
                    s.a11y.addRole(s.nextButton, 'button');
                    s.a11y.addLabel(s.nextButton, s.params.nextSlideMessage);
                }
                if (s.params.prevButton && s.prevButton && s.prevButton.length > 0) {
                    s.a11y.makeFocusable(s.prevButton);
                    s.a11y.addRole(s.prevButton, 'button');
                    s.a11y.addLabel(s.prevButton, s.params.prevSlideMessage);
                }
        
                $(s.container).append(s.a11y.liveRegion);
            },
            initPagination: function () {
                if (s.params.pagination && s.params.paginationClickable && s.bullets && s.bullets.length) {
                    s.bullets.each(function () {
                        var bullet = $(this);
                        s.a11y.makeFocusable(bullet);
                        s.a11y.addRole(bullet, 'button');
                        s.a11y.addLabel(bullet, s.params.paginationBulletMessage.replace(/{{index}}/, bullet.index() + 1));
                    });
                }
            },
            destroy: function () {
                if (s.a11y.liveRegion && s.a11y.liveRegion.length > 0) s.a11y.liveRegion.remove();
            }
        };
        

        /*=========================
          Init/Destroy
          ===========================*/
        s.init = function () {
            if (s.params.loop) s.createLoop();
            s.updateContainerSize();
            s.updateSlidesSize();
            s.updatePagination();
            if (s.params.scrollbar && s.scrollbar) {
                s.scrollbar.set();
                if (s.params.scrollbarDraggable) {
                    s.scrollbar.enableDraggable();
                }
            }
            if (s.params.effect !== 'slide' && s.effects[s.params.effect]) {
                if (!s.params.loop) s.updateProgress();
                s.effects[s.params.effect].setTranslate();
            }
            if (s.params.loop) {
                s.slideTo(s.params.initialSlide + s.loopedSlides, 0, s.params.runCallbacksOnInit);
            }
            else {
                s.slideTo(s.params.initialSlide, 0, s.params.runCallbacksOnInit);
                if (s.params.initialSlide === 0) {
                    if (s.parallax && s.params.parallax) s.parallax.setTranslate();
                    if (s.lazy && s.params.lazyLoading) {
                        s.lazy.load();
                        s.lazy.initialImageLoaded = true;
                    }
                }
            }
            s.attachEvents();
            if (s.params.observer && s.support.observer) {
                s.initObservers();
            }
            if (s.params.preloadImages && !s.params.lazyLoading) {
                s.preloadImages();
            }
            if (s.params.zoom && s.zoom) {
                s.zoom.init();
            }
            if (s.params.autoplay) {
                s.startAutoplay();
            }
            if (s.params.keyboardControl) {
                if (s.enableKeyboardControl) s.enableKeyboardControl();
            }
            if (s.params.mousewheelControl) {
                if (s.enableMousewheelControl) s.enableMousewheelControl();
            }
            // Deprecated hashnavReplaceState changed to replaceState for use in hashnav and history
            if (s.params.hashnavReplaceState) {
                s.params.replaceState = s.params.hashnavReplaceState;
            }
            if (s.params.history) {
                if (s.history) s.history.init();
            }
            if (s.params.hashnav) {
                if (s.hashnav) s.hashnav.init();
            }
            if (s.params.a11y && s.a11y) s.a11y.init();
            s.emit('onInit', s);
        };
        
        // Cleanup dynamic styles
        s.cleanupStyles = function () {
            // Container
            s.container.removeClass(s.classNames.join(' ')).removeAttr('style');
        
            // Wrapper
            s.wrapper.removeAttr('style');
        
            // Slides
            if (s.slides && s.slides.length) {
                s.slides
                    .removeClass([
                      s.params.slideVisibleClass,
                      s.params.slideActiveClass,
                      s.params.slideNextClass,
                      s.params.slidePrevClass
                    ].join(' '))
                    .removeAttr('style')
                    .removeAttr('data-swiper-column')
                    .removeAttr('data-swiper-row');
            }
        
            // Pagination/Bullets
            if (s.paginationContainer && s.paginationContainer.length) {
                s.paginationContainer.removeClass(s.params.paginationHiddenClass);
            }
            if (s.bullets && s.bullets.length) {
                s.bullets.removeClass(s.params.bulletActiveClass);
            }
        
            // Buttons
            if (s.params.prevButton) $(s.params.prevButton).removeClass(s.params.buttonDisabledClass);
            if (s.params.nextButton) $(s.params.nextButton).removeClass(s.params.buttonDisabledClass);
        
            // Scrollbar
            if (s.params.scrollbar && s.scrollbar) {
                if (s.scrollbar.track && s.scrollbar.track.length) s.scrollbar.track.removeAttr('style');
                if (s.scrollbar.drag && s.scrollbar.drag.length) s.scrollbar.drag.removeAttr('style');
            }
        };
        
        // Destroy
        s.destroy = function (deleteInstance, cleanupStyles) {
            // Detach evebts
            s.detachEvents();
            // Stop autoplay
            s.stopAutoplay();
            // Disable draggable
            if (s.params.scrollbar && s.scrollbar) {
                if (s.params.scrollbarDraggable) {
                    s.scrollbar.disableDraggable();
                }
            }
            // Destroy loop
            if (s.params.loop) {
                s.destroyLoop();
            }
            // Cleanup styles
            if (cleanupStyles) {
                s.cleanupStyles();
            }
            // Disconnect observer
            s.disconnectObservers();
        
            // Destroy zoom
            if (s.params.zoom && s.zoom) {
                s.zoom.destroy();
            }
            // Disable keyboard/mousewheel
            if (s.params.keyboardControl) {
                if (s.disableKeyboardControl) s.disableKeyboardControl();
            }
            if (s.params.mousewheelControl) {
                if (s.disableMousewheelControl) s.disableMousewheelControl();
            }
            // Disable a11y
            if (s.params.a11y && s.a11y) s.a11y.destroy();
            // Delete history popstate
            if (s.params.history && !s.params.replaceState) {
                window.removeEventListener('popstate', s.history.setHistoryPopState);
            }
            if (s.params.hashnav && s.hashnav)  {
                s.hashnav.destroy();
            }
            // Destroy callback
            s.emit('onDestroy');
            // Delete instance
            if (deleteInstance !== false) s = null;
        };
        
        s.init();
        

    
        // Return swiper instance
        return s;
    };
    

    /*==================================================
        Prototype
    ====================================================*/
    Swiper.prototype = {
        isSafari: (function () {
            var ua = window.navigator.userAgent.toLowerCase();
            return (ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0);
        })(),
        isUiWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window.navigator.userAgent),
        isArray: function (arr) {
            return Object.prototype.toString.apply(arr) === '[object Array]';
        },
        /*==================================================
        Browser
        ====================================================*/
        browser: {
            ie: window.navigator.pointerEnabled || window.navigator.msPointerEnabled,
            ieTouch: (window.navigator.msPointerEnabled && window.navigator.msMaxTouchPoints > 1) || (window.navigator.pointerEnabled && window.navigator.maxTouchPoints > 1),
            lteIE9: (function() {
                // create temporary DIV
                var div = document.createElement('div');
                // add content to tmp DIV which is wrapped into the IE HTML conditional statement
                div.innerHTML = '<!--[if lte IE 9]><i></i><![endif]-->';
                // return true / false value based on what will browser render
                return div.getElementsByTagName('i').length === 1;
            })()
        },
        /*==================================================
        Devices
        ====================================================*/
        device: (function () {
            var ua = window.navigator.userAgent;
            var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/);
            var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
            var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
            var iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
            return {
                ios: ipad || iphone || ipod,
                android: android
            };
        })(),
        /*==================================================
        Feature Detection
        ====================================================*/
        support: {
            touch : (window.Modernizr && Modernizr.touch === true) || (function () {
                return !!(('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch);
            })(),
    
            transforms3d : (window.Modernizr && Modernizr.csstransforms3d === true) || (function () {
                var div = document.createElement('div').style;
                return ('webkitPerspective' in div || 'MozPerspective' in div || 'OPerspective' in div || 'MsPerspective' in div || 'perspective' in div);
            })(),
    
            flexbox: (function () {
                var div = document.createElement('div').style;
                var styles = ('alignItems webkitAlignItems webkitBoxAlign msFlexAlign mozBoxAlign webkitFlexDirection msFlexDirection mozBoxDirection mozBoxOrient webkitBoxDirection webkitBoxOrient').split(' ');
                for (var i = 0; i < styles.length; i++) {
                    if (styles[i] in div) return true;
                }
            })(),
    
            observer: (function () {
                return ('MutationObserver' in window || 'WebkitMutationObserver' in window);
            })(),
    
            passiveListener: (function () {
                var supportsPassive = false;
                try {
                    var opts = Object.defineProperty({}, 'passive', {
                        get: function() {
                            supportsPassive = true;
                        }
                    });
                    window.addEventListener('testPassiveListener', null, opts);
                } catch (e) {}
                return supportsPassive;
            })(),
    
            gestures: (function () {
                return 'ongesturestart' in window;
            })()
        },
        /*==================================================
        Plugins
        ====================================================*/
        plugins: {}
    };
    

    /*===========================
    Dom7 Library
    ===========================*/
    var Dom7 = (function () {
        var Dom7 = function (arr) {
            var _this = this, i = 0;
            // Create array-like object
            for (i = 0; i < arr.length; i++) {
                _this[i] = arr[i];
            }
            _this.length = arr.length;
            // Return collection with methods
            return this;
        };
        var $ = function (selector, context) {
            var arr = [], i = 0;
            if (selector && !context) {
                if (selector instanceof Dom7) {
                    return selector;
                }
            }
            if (selector) {
                // String
                if (typeof selector === 'string') {
                    var els, tempParent, html = selector.trim();
                    if (html.indexOf('<') >= 0 && html.indexOf('>') >= 0) {
                        var toCreate = 'div';
                        if (html.indexOf('<li') === 0) toCreate = 'ul';
                        if (html.indexOf('<tr') === 0) toCreate = 'tbody';
                        if (html.indexOf('<td') === 0 || html.indexOf('<th') === 0) toCreate = 'tr';
                        if (html.indexOf('<tbody') === 0) toCreate = 'table';
                        if (html.indexOf('<option') === 0) toCreate = 'select';
                        tempParent = document.createElement(toCreate);
                        tempParent.innerHTML = selector;
                        for (i = 0; i < tempParent.childNodes.length; i++) {
                            arr.push(tempParent.childNodes[i]);
                        }
                    }
                    else {
                        if (!context && selector[0] === '#' && !selector.match(/[ .<>:~]/)) {
                            // Pure ID selector
                            els = [document.getElementById(selector.split('#')[1])];
                        }
                        else {
                            // Other selectors
                            els = (context || document).querySelectorAll(selector);
                        }
                        for (i = 0; i < els.length; i++) {
                            if (els[i]) arr.push(els[i]);
                        }
                    }
                }
                // Node/element
                else if (selector.nodeType || selector === window || selector === document) {
                    arr.push(selector);
                }
                //Array of elements or instance of Dom
                else if (selector.length > 0 && selector[0].nodeType) {
                    for (i = 0; i < selector.length; i++) {
                        arr.push(selector[i]);
                    }
                }
            }
            return new Dom7(arr);
        };
        Dom7.prototype = {
            // Classes and attriutes
            addClass: function (className) {
                if (typeof className === 'undefined') {
                    return this;
                }
                var classes = className.split(' ');
                for (var i = 0; i < classes.length; i++) {
                    for (var j = 0; j < this.length; j++) {
                        this[j].classList.add(classes[i]);
                    }
                }
                return this;
            },
            removeClass: function (className) {
                var classes = className.split(' ');
                for (var i = 0; i < classes.length; i++) {
                    for (var j = 0; j < this.length; j++) {
                        this[j].classList.remove(classes[i]);
                    }
                }
                return this;
            },
            hasClass: function (className) {
                if (!this[0]) return false;
                else return this[0].classList.contains(className);
            },
            toggleClass: function (className) {
                var classes = className.split(' ');
                for (var i = 0; i < classes.length; i++) {
                    for (var j = 0; j < this.length; j++) {
                        this[j].classList.toggle(classes[i]);
                    }
                }
                return this;
            },
            attr: function (attrs, value) {
                if (arguments.length === 1 && typeof attrs === 'string') {
                    // Get attr
                    if (this[0]) return this[0].getAttribute(attrs);
                    else return undefined;
                }
                else {
                    // Set attrs
                    for (var i = 0; i < this.length; i++) {
                        if (arguments.length === 2) {
                            // String
                            this[i].setAttribute(attrs, value);
                        }
                        else {
                            // Object
                            for (var attrName in attrs) {
                                this[i][attrName] = attrs[attrName];
                                this[i].setAttribute(attrName, attrs[attrName]);
                            }
                        }
                    }
                    return this;
                }
            },
            removeAttr: function (attr) {
                for (var i = 0; i < this.length; i++) {
                    this[i].removeAttribute(attr);
                }
                return this;
            },
            data: function (key, value) {
                if (typeof value === 'undefined') {
                    // Get value
                    if (this[0]) {
                        var dataKey = this[0].getAttribute('data-' + key);
                        if (dataKey) return dataKey;
                        else if (this[0].dom7ElementDataStorage && (key in this[0].dom7ElementDataStorage)) return this[0].dom7ElementDataStorage[key];
                        else return undefined;
                    }
                    else return undefined;
                }
                else {
                    // Set value
                    for (var i = 0; i < this.length; i++) {
                        var el = this[i];
                        if (!el.dom7ElementDataStorage) el.dom7ElementDataStorage = {};
                        el.dom7ElementDataStorage[key] = value;
                    }
                    return this;
                }
            },
            // Transforms
            transform : function (transform) {
                for (var i = 0; i < this.length; i++) {
                    var elStyle = this[i].style;
                    elStyle.webkitTransform = elStyle.MsTransform = elStyle.msTransform = elStyle.MozTransform = elStyle.OTransform = elStyle.transform = transform;
                }
                return this;
            },
            transition: function (duration) {
                if (typeof duration !== 'string') {
                    duration = duration + 'ms';
                }
                for (var i = 0; i < this.length; i++) {
                    var elStyle = this[i].style;
                    elStyle.webkitTransitionDuration = elStyle.MsTransitionDuration = elStyle.msTransitionDuration = elStyle.MozTransitionDuration = elStyle.OTransitionDuration = elStyle.transitionDuration = duration;
                }
                return this;
            },
            //Events
            on: function (eventName, targetSelector, listener, capture) {
                function handleLiveEvent(e) {
                    var target = e.target;
                    if ($(target).is(targetSelector)) listener.call(target, e);
                    else {
                        var parents = $(target).parents();
                        for (var k = 0; k < parents.length; k++) {
                            if ($(parents[k]).is(targetSelector)) listener.call(parents[k], e);
                        }
                    }
                }
                var events = eventName.split(' ');
                var i, j;
                for (i = 0; i < this.length; i++) {
                    if (typeof targetSelector === 'function' || targetSelector === false) {
                        // Usual events
                        if (typeof targetSelector === 'function') {
                            listener = arguments[1];
                            capture = arguments[2] || false;
                        }
                        for (j = 0; j < events.length; j++) {
                            this[i].addEventListener(events[j], listener, capture);
                        }
                    }
                    else {
                        //Live events
                        for (j = 0; j < events.length; j++) {
                            if (!this[i].dom7LiveListeners) this[i].dom7LiveListeners = [];
                            this[i].dom7LiveListeners.push({listener: listener, liveListener: handleLiveEvent});
                            this[i].addEventListener(events[j], handleLiveEvent, capture);
                        }
                    }
                }
    
                return this;
            },
            off: function (eventName, targetSelector, listener, capture) {
                var events = eventName.split(' ');
                for (var i = 0; i < events.length; i++) {
                    for (var j = 0; j < this.length; j++) {
                        if (typeof targetSelector === 'function' || targetSelector === false) {
                            // Usual events
                            if (typeof targetSelector === 'function') {
                                listener = arguments[1];
                                capture = arguments[2] || false;
                            }
                            this[j].removeEventListener(events[i], listener, capture);
                        }
                        else {
                            // Live event
                            if (this[j].dom7LiveListeners) {
                                for (var k = 0; k < this[j].dom7LiveListeners.length; k++) {
                                    if (this[j].dom7LiveListeners[k].listener === listener) {
                                        this[j].removeEventListener(events[i], this[j].dom7LiveListeners[k].liveListener, capture);
                                    }
                                }
                            }
                        }
                    }
                }
                return this;
            },
            once: function (eventName, targetSelector, listener, capture) {
                var dom = this;
                if (typeof targetSelector === 'function') {
                    targetSelector = false;
                    listener = arguments[1];
                    capture = arguments[2];
                }
                function proxy(e) {
                    listener(e);
                    dom.off(eventName, targetSelector, proxy, capture);
                }
                dom.on(eventName, targetSelector, proxy, capture);
            },
            trigger: function (eventName, eventData) {
                for (var i = 0; i < this.length; i++) {
                    var evt;
                    try {
                        evt = new window.CustomEvent(eventName, {detail: eventData, bubbles: true, cancelable: true});
                    }
                    catch (e) {
                        evt = document.createEvent('Event');
                        evt.initEvent(eventName, true, true);
                        evt.detail = eventData;
                    }
                    this[i].dispatchEvent(evt);
                }
                return this;
            },
            transitionEnd: function (callback) {
                var events = ['webkitTransitionEnd', 'transitionend', 'oTransitionEnd', 'MSTransitionEnd', 'msTransitionEnd'],
                    i, j, dom = this;
                function fireCallBack(e) {
                    /*jshint validthis:true */
                    if (e.target !== this) return;
                    callback.call(this, e);
                    for (i = 0; i < events.length; i++) {
                        dom.off(events[i], fireCallBack);
                    }
                }
                if (callback) {
                    for (i = 0; i < events.length; i++) {
                        dom.on(events[i], fireCallBack);
                    }
                }
                return this;
            },
            // Sizing/Styles
            width: function () {
                if (this[0] === window) {
                    return window.innerWidth;
                }
                else {
                    if (this.length > 0) {
                        return parseFloat(this.css('width'));
                    }
                    else {
                        return null;
                    }
                }
            },
            outerWidth: function (includeMargins) {
                if (this.length > 0) {
                    if (includeMargins)
                        return this[0].offsetWidth + parseFloat(this.css('margin-right')) + parseFloat(this.css('margin-left'));
                    else
                        return this[0].offsetWidth;
                }
                else return null;
            },
            height: function () {
                if (this[0] === window) {
                    return window.innerHeight;
                }
                else {
                    if (this.length > 0) {
                        return parseFloat(this.css('height'));
                    }
                    else {
                        return null;
                    }
                }
            },
            outerHeight: function (includeMargins) {
                if (this.length > 0) {
                    if (includeMargins)
                        return this[0].offsetHeight + parseFloat(this.css('margin-top')) + parseFloat(this.css('margin-bottom'));
                    else
                        return this[0].offsetHeight;
                }
                else return null;
            },
            offset: function () {
                if (this.length > 0) {
                    var el = this[0];
                    var box = el.getBoundingClientRect();
                    var body = document.body;
                    var clientTop  = el.clientTop  || body.clientTop  || 0;
                    var clientLeft = el.clientLeft || body.clientLeft || 0;
                    var scrollTop  = window.pageYOffset || el.scrollTop;
                    var scrollLeft = window.pageXOffset || el.scrollLeft;
                    return {
                        top: box.top  + scrollTop  - clientTop,
                        left: box.left + scrollLeft - clientLeft
                    };
                }
                else {
                    return null;
                }
            },
            css: function (props, value) {
                var i;
                if (arguments.length === 1) {
                    if (typeof props === 'string') {
                        if (this[0]) return window.getComputedStyle(this[0], null).getPropertyValue(props);
                    }
                    else {
                        for (i = 0; i < this.length; i++) {
                            for (var prop in props) {
                                this[i].style[prop] = props[prop];
                            }
                        }
                        return this;
                    }
                }
                if (arguments.length === 2 && typeof props === 'string') {
                    for (i = 0; i < this.length; i++) {
                        this[i].style[props] = value;
                    }
                    return this;
                }
                return this;
            },
    
            //Dom manipulation
            each: function (callback) {
                for (var i = 0; i < this.length; i++) {
                    callback.call(this[i], i, this[i]);
                }
                return this;
            },
            html: function (html) {
                if (typeof html === 'undefined') {
                    return this[0] ? this[0].innerHTML : undefined;
                }
                else {
                    for (var i = 0; i < this.length; i++) {
                        this[i].innerHTML = html;
                    }
                    return this;
                }
            },
            text: function (text) {
                if (typeof text === 'undefined') {
                    if (this[0]) {
                        return this[0].textContent.trim();
                    }
                    else return null;
                }
                else {
                    for (var i = 0; i < this.length; i++) {
                        this[i].textContent = text;
                    }
                    return this;
                }
            },
            is: function (selector) {
                if (!this[0]) return false;
                var compareWith, i;
                if (typeof selector === 'string') {
                    var el = this[0];
                    if (el === document) return selector === document;
                    if (el === window) return selector === window;
    
                    if (el.matches) return el.matches(selector);
                    else if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
                    else if (el.mozMatchesSelector) return el.mozMatchesSelector(selector);
                    else if (el.msMatchesSelector) return el.msMatchesSelector(selector);
                    else {
                        compareWith = $(selector);
                        for (i = 0; i < compareWith.length; i++) {
                            if (compareWith[i] === this[0]) return true;
                        }
                        return false;
                    }
                }
                else if (selector === document) return this[0] === document;
                else if (selector === window) return this[0] === window;
                else {
                    if (selector.nodeType || selector instanceof Dom7) {
                        compareWith = selector.nodeType ? [selector] : selector;
                        for (i = 0; i < compareWith.length; i++) {
                            if (compareWith[i] === this[0]) return true;
                        }
                        return false;
                    }
                    return false;
                }
    
            },
            index: function () {
                if (this[0]) {
                    var child = this[0];
                    var i = 0;
                    while ((child = child.previousSibling) !== null) {
                        if (child.nodeType === 1) i++;
                    }
                    return i;
                }
                else return undefined;
            },
            eq: function (index) {
                if (typeof index === 'undefined') return this;
                var length = this.length;
                var returnIndex;
                if (index > length - 1) {
                    return new Dom7([]);
                }
                if (index < 0) {
                    returnIndex = length + index;
                    if (returnIndex < 0) return new Dom7([]);
                    else return new Dom7([this[returnIndex]]);
                }
                return new Dom7([this[index]]);
            },
            append: function (newChild) {
                var i, j;
                for (i = 0; i < this.length; i++) {
                    if (typeof newChild === 'string') {
                        var tempDiv = document.createElement('div');
                        tempDiv.innerHTML = newChild;
                        while (tempDiv.firstChild) {
                            this[i].appendChild(tempDiv.firstChild);
                        }
                    }
                    else if (newChild instanceof Dom7) {
                        for (j = 0; j < newChild.length; j++) {
                            this[i].appendChild(newChild[j]);
                        }
                    }
                    else {
                        this[i].appendChild(newChild);
                    }
                }
                return this;
            },
            prepend: function (newChild) {
                var i, j;
                for (i = 0; i < this.length; i++) {
                    if (typeof newChild === 'string') {
                        var tempDiv = document.createElement('div');
                        tempDiv.innerHTML = newChild;
                        for (j = tempDiv.childNodes.length - 1; j >= 0; j--) {
                            this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
                        }
                        // this[i].insertAdjacentHTML('afterbegin', newChild);
                    }
                    else if (newChild instanceof Dom7) {
                        for (j = 0; j < newChild.length; j++) {
                            this[i].insertBefore(newChild[j], this[i].childNodes[0]);
                        }
                    }
                    else {
                        this[i].insertBefore(newChild, this[i].childNodes[0]);
                    }
                }
                return this;
            },
            insertBefore: function (selector) {
                var before = $(selector);
                for (var i = 0; i < this.length; i++) {
                    if (before.length === 1) {
                        before[0].parentNode.insertBefore(this[i], before[0]);
                    }
                    else if (before.length > 1) {
                        for (var j = 0; j < before.length; j++) {
                            before[j].parentNode.insertBefore(this[i].cloneNode(true), before[j]);
                        }
                    }
                }
            },
            insertAfter: function (selector) {
                var after = $(selector);
                for (var i = 0; i < this.length; i++) {
                    if (after.length === 1) {
                        after[0].parentNode.insertBefore(this[i], after[0].nextSibling);
                    }
                    else if (after.length > 1) {
                        for (var j = 0; j < after.length; j++) {
                            after[j].parentNode.insertBefore(this[i].cloneNode(true), after[j].nextSibling);
                        }
                    }
                }
            },
            next: function (selector) {
                if (this.length > 0) {
                    if (selector) {
                        if (this[0].nextElementSibling && $(this[0].nextElementSibling).is(selector)) return new Dom7([this[0].nextElementSibling]);
                        else return new Dom7([]);
                    }
                    else {
                        if (this[0].nextElementSibling) return new Dom7([this[0].nextElementSibling]);
                        else return new Dom7([]);
                    }
                }
                else return new Dom7([]);
            },
            nextAll: function (selector) {
                var nextEls = [];
                var el = this[0];
                if (!el) return new Dom7([]);
                while (el.nextElementSibling) {
                    var next = el.nextElementSibling;
                    if (selector) {
                        if($(next).is(selector)) nextEls.push(next);
                    }
                    else nextEls.push(next);
                    el = next;
                }
                return new Dom7(nextEls);
            },
            prev: function (selector) {
                if (this.length > 0) {
                    if (selector) {
                        if (this[0].previousElementSibling && $(this[0].previousElementSibling).is(selector)) return new Dom7([this[0].previousElementSibling]);
                        else return new Dom7([]);
                    }
                    else {
                        if (this[0].previousElementSibling) return new Dom7([this[0].previousElementSibling]);
                        else return new Dom7([]);
                    }
                }
                else return new Dom7([]);
            },
            prevAll: function (selector) {
                var prevEls = [];
                var el = this[0];
                if (!el) return new Dom7([]);
                while (el.previousElementSibling) {
                    var prev = el.previousElementSibling;
                    if (selector) {
                        if($(prev).is(selector)) prevEls.push(prev);
                    }
                    else prevEls.push(prev);
                    el = prev;
                }
                return new Dom7(prevEls);
            },
            parent: function (selector) {
                var parents = [];
                for (var i = 0; i < this.length; i++) {
                    if (selector) {
                        if ($(this[i].parentNode).is(selector)) parents.push(this[i].parentNode);
                    }
                    else {
                        parents.push(this[i].parentNode);
                    }
                }
                return $($.unique(parents));
            },
            parents: function (selector) {
                var parents = [];
                for (var i = 0; i < this.length; i++) {
                    var parent = this[i].parentNode;
                    while (parent) {
                        if (selector) {
                            if ($(parent).is(selector)) parents.push(parent);
                        }
                        else {
                            parents.push(parent);
                        }
                        parent = parent.parentNode;
                    }
                }
                return $($.unique(parents));
            },
            find : function (selector) {
                var foundElements = [];
                for (var i = 0; i < this.length; i++) {
                    var found = this[i].querySelectorAll(selector);
                    for (var j = 0; j < found.length; j++) {
                        foundElements.push(found[j]);
                    }
                }
                return new Dom7(foundElements);
            },
            children: function (selector) {
                var children = [];
                for (var i = 0; i < this.length; i++) {
                    var childNodes = this[i].childNodes;
    
                    for (var j = 0; j < childNodes.length; j++) {
                        if (!selector) {
                            if (childNodes[j].nodeType === 1) children.push(childNodes[j]);
                        }
                        else {
                            if (childNodes[j].nodeType === 1 && $(childNodes[j]).is(selector)) children.push(childNodes[j]);
                        }
                    }
                }
                return new Dom7($.unique(children));
            },
            remove: function () {
                for (var i = 0; i < this.length; i++) {
                    if (this[i].parentNode) this[i].parentNode.removeChild(this[i]);
                }
                return this;
            },
            add: function () {
                var dom = this;
                var i, j;
                for (i = 0; i < arguments.length; i++) {
                    var toAdd = $(arguments[i]);
                    for (j = 0; j < toAdd.length; j++) {
                        dom[dom.length] = toAdd[j];
                        dom.length++;
                    }
                }
                return dom;
            }
        };
        $.fn = Dom7.prototype;
        $.unique = function (arr) {
            var unique = [];
            for (var i = 0; i < arr.length; i++) {
                if (unique.indexOf(arr[i]) === -1) unique.push(arr[i]);
            }
            return unique;
        };
    
        return $;
    })();
    

    /*===========================
     Get Dom libraries
     ===========================*/
    var swiperDomPlugins = ['jQuery', 'Zepto', 'Dom7'];
    for (var i = 0; i < swiperDomPlugins.length; i++) {
    	if (window[swiperDomPlugins[i]]) {
    		addLibraryPlugin(window[swiperDomPlugins[i]]);
    	}
    }
    // Required DOM Plugins
    var domLib;
    if (typeof Dom7 === 'undefined') {
    	domLib = window.Dom7 || window.Zepto || window.jQuery;
    }
    else {
    	domLib = Dom7;
    }
    

    /*===========================
    Add .swiper plugin from Dom libraries
    ===========================*/
    function addLibraryPlugin(lib) {
        lib.fn.swiper = function (params) {
            var firstInstance;
            lib(this).each(function () {
                var s = new Swiper(this, params);
                if (!firstInstance) firstInstance = s;
            });
            return firstInstance;
        };
    }
    
    if (domLib) {
        if (!('transitionEnd' in domLib.fn)) {
            domLib.fn.transitionEnd = function (callback) {
                var events = ['webkitTransitionEnd', 'transitionend', 'oTransitionEnd', 'MSTransitionEnd', 'msTransitionEnd'],
                    i, j, dom = this;
                function fireCallBack(e) {
                    /*jshint validthis:true */
                    if (e.target !== this) return;
                    callback.call(this, e);
                    for (i = 0; i < events.length; i++) {
                        dom.off(events[i], fireCallBack);
                    }
                }
                if (callback) {
                    for (i = 0; i < events.length; i++) {
                        dom.on(events[i], fireCallBack);
                    }
                }
                return this;
            };
        }
        if (!('transform' in domLib.fn)) {
            domLib.fn.transform = function (transform) {
                for (var i = 0; i < this.length; i++) {
                    var elStyle = this[i].style;
                    elStyle.webkitTransform = elStyle.MsTransform = elStyle.msTransform = elStyle.MozTransform = elStyle.OTransform = elStyle.transform = transform;
                }
                return this;
            };
        }
        if (!('transition' in domLib.fn)) {
            domLib.fn.transition = function (duration) {
                if (typeof duration !== 'string') {
                    duration = duration + 'ms';
                }
                for (var i = 0; i < this.length; i++) {
                    var elStyle = this[i].style;
                    elStyle.webkitTransitionDuration = elStyle.MsTransitionDuration = elStyle.msTransitionDuration = elStyle.MozTransitionDuration = elStyle.OTransitionDuration = elStyle.transitionDuration = duration;
                }
                return this;
            };
        }
        if (!('outerWidth' in domLib.fn)) {
            domLib.fn.outerWidth = function (includeMargins) {
                if (this.length > 0) {
                    if (includeMargins)
                        return this[0].offsetWidth + parseFloat(this.css('margin-right')) + parseFloat(this.css('margin-left'));
                    else
                        return this[0].offsetWidth;
                }
                else return null;
            };
        }
    }
    

    window.Swiper = Swiper;
})();

/*===========================
Swiper AMD Export
===========================*/
if (typeof(module) !== 'undefined')
{
    module.exports = window.Swiper;
}
else if (typeof define === 'function' && define.amd) {
    define([], function () {
        'use strict';
        return window.Swiper;
    });
}



},{}],146:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

'use strict';

var punycode = require('punycode');
var util = require('./util');

exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;

exports.Url = Url;

function Url() {
  this.protocol = null;
  this.slashes = null;
  this.auth = null;
  this.host = null;
  this.port = null;
  this.hostname = null;
  this.hash = null;
  this.search = null;
  this.query = null;
  this.pathname = null;
  this.path = null;
  this.href = null;
}

// Reference: RFC 3986, RFC 1808, RFC 2396

// define these here so at least they only have to be
// compiled once on the first module load.
var protocolPattern = /^([a-z0-9.+-]+:)/i,
    portPattern = /:[0-9]*$/,

    // Special case for a simple path URL
    simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,

    // RFC 2396: characters reserved for delimiting URLs.
    // We actually just auto-escape these.
    delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],

    // RFC 2396: characters not allowed for various reasons.
    unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),

    // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
    autoEscape = ['\''].concat(unwise),
    // Characters that are never ever allowed in a hostname.
    // Note that any invalid chars are also handled, but these
    // are the ones that are *expected* to be seen, so we fast-path
    // them.
    nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
    hostEndingChars = ['/', '?', '#'],
    hostnameMaxLen = 255,
    hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
    hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
    // protocols that can allow "unsafe" and "unwise" chars.
    unsafeProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that never have a hostname.
    hostlessProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that always contain a // bit.
    slashedProtocol = {
      'http': true,
      'https': true,
      'ftp': true,
      'gopher': true,
      'file': true,
      'http:': true,
      'https:': true,
      'ftp:': true,
      'gopher:': true,
      'file:': true
    },
    querystring = require('querystring');

function urlParse(url, parseQueryString, slashesDenoteHost) {
  if (url && util.isObject(url) && url instanceof Url) return url;

  var u = new Url;
  u.parse(url, parseQueryString, slashesDenoteHost);
  return u;
}

Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
  if (!util.isString(url)) {
    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
  }

  // Copy chrome, IE, opera backslash-handling behavior.
  // Back slashes before the query string get converted to forward slashes
  // See: https://code.google.com/p/chromium/issues/detail?id=25916
  var queryIndex = url.indexOf('?'),
      splitter =
          (queryIndex !== -1 && queryIndex < url.indexOf('#')) ? '?' : '#',
      uSplit = url.split(splitter),
      slashRegex = /\\/g;
  uSplit[0] = uSplit[0].replace(slashRegex, '/');
  url = uSplit.join(splitter);

  var rest = url;

  // trim before proceeding.
  // This is to support parse stuff like "  http://foo.com  \n"
  rest = rest.trim();

  if (!slashesDenoteHost && url.split('#').length === 1) {
    // Try fast path regexp
    var simplePath = simplePathPattern.exec(rest);
    if (simplePath) {
      this.path = rest;
      this.href = rest;
      this.pathname = simplePath[1];
      if (simplePath[2]) {
        this.search = simplePath[2];
        if (parseQueryString) {
          this.query = querystring.parse(this.search.substr(1));
        } else {
          this.query = this.search.substr(1);
        }
      } else if (parseQueryString) {
        this.search = '';
        this.query = {};
      }
      return this;
    }
  }

  var proto = protocolPattern.exec(rest);
  if (proto) {
    proto = proto[0];
    var lowerProto = proto.toLowerCase();
    this.protocol = lowerProto;
    rest = rest.substr(proto.length);
  }

  // figure out if it's got a host
  // user@server is *always* interpreted as a hostname, and url
  // resolution will treat //foo/bar as host=foo,path=bar because that's
  // how the browser resolves relative URLs.
  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
    var slashes = rest.substr(0, 2) === '//';
    if (slashes && !(proto && hostlessProtocol[proto])) {
      rest = rest.substr(2);
      this.slashes = true;
    }
  }

  if (!hostlessProtocol[proto] &&
      (slashes || (proto && !slashedProtocol[proto]))) {

    // there's a hostname.
    // the first instance of /, ?, ;, or # ends the host.
    //
    // If there is an @ in the hostname, then non-host chars *are* allowed
    // to the left of the last @ sign, unless some host-ending character
    // comes *before* the @-sign.
    // URLs are obnoxious.
    //
    // ex:
    // http://a@b@c/ => user:a@b host:c
    // http://a@b?@c => user:a host:c path:/?@c

    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
    // Review our test case against browsers more comprehensively.

    // find the first instance of any hostEndingChars
    var hostEnd = -1;
    for (var i = 0; i < hostEndingChars.length; i++) {
      var hec = rest.indexOf(hostEndingChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }

    // at this point, either we have an explicit point where the
    // auth portion cannot go past, or the last @ char is the decider.
    var auth, atSign;
    if (hostEnd === -1) {
      // atSign can be anywhere.
      atSign = rest.lastIndexOf('@');
    } else {
      // atSign must be in auth portion.
      // http://a@b/c@d => host:b auth:a path:/c@d
      atSign = rest.lastIndexOf('@', hostEnd);
    }

    // Now we have a portion which is definitely the auth.
    // Pull that off.
    if (atSign !== -1) {
      auth = rest.slice(0, atSign);
      rest = rest.slice(atSign + 1);
      this.auth = decodeURIComponent(auth);
    }

    // the host is the remaining to the left of the first non-host char
    hostEnd = -1;
    for (var i = 0; i < nonHostChars.length; i++) {
      var hec = rest.indexOf(nonHostChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }
    // if we still have not hit it, then the entire thing is a host.
    if (hostEnd === -1)
      hostEnd = rest.length;

    this.host = rest.slice(0, hostEnd);
    rest = rest.slice(hostEnd);

    // pull out port.
    this.parseHost();

    // we've indicated that there is a hostname,
    // so even if it's empty, it has to be present.
    this.hostname = this.hostname || '';

    // if hostname begins with [ and ends with ]
    // assume that it's an IPv6 address.
    var ipv6Hostname = this.hostname[0] === '[' &&
        this.hostname[this.hostname.length - 1] === ']';

    // validate a little.
    if (!ipv6Hostname) {
      var hostparts = this.hostname.split(/\./);
      for (var i = 0, l = hostparts.length; i < l; i++) {
        var part = hostparts[i];
        if (!part) continue;
        if (!part.match(hostnamePartPattern)) {
          var newpart = '';
          for (var j = 0, k = part.length; j < k; j++) {
            if (part.charCodeAt(j) > 127) {
              // we replace non-ASCII char with a temporary placeholder
              // we need this to make sure size of hostname is not
              // broken by replacing non-ASCII by nothing
              newpart += 'x';
            } else {
              newpart += part[j];
            }
          }
          // we test again with ASCII char only
          if (!newpart.match(hostnamePartPattern)) {
            var validParts = hostparts.slice(0, i);
            var notHost = hostparts.slice(i + 1);
            var bit = part.match(hostnamePartStart);
            if (bit) {
              validParts.push(bit[1]);
              notHost.unshift(bit[2]);
            }
            if (notHost.length) {
              rest = '/' + notHost.join('.') + rest;
            }
            this.hostname = validParts.join('.');
            break;
          }
        }
      }
    }

    if (this.hostname.length > hostnameMaxLen) {
      this.hostname = '';
    } else {
      // hostnames are always lower case.
      this.hostname = this.hostname.toLowerCase();
    }

    if (!ipv6Hostname) {
      // IDNA Support: Returns a punycoded representation of "domain".
      // It only converts parts of the domain name that
      // have non-ASCII characters, i.e. it doesn't matter if
      // you call it with a domain that already is ASCII-only.
      this.hostname = punycode.toASCII(this.hostname);
    }

    var p = this.port ? ':' + this.port : '';
    var h = this.hostname || '';
    this.host = h + p;
    this.href += this.host;

    // strip [ and ] from the hostname
    // the host field still retains them, though
    if (ipv6Hostname) {
      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
      if (rest[0] !== '/') {
        rest = '/' + rest;
      }
    }
  }

  // now rest is set to the post-host stuff.
  // chop off any delim chars.
  if (!unsafeProtocol[lowerProto]) {

    // First, make 100% sure that any "autoEscape" chars get
    // escaped, even if encodeURIComponent doesn't think they
    // need to be.
    for (var i = 0, l = autoEscape.length; i < l; i++) {
      var ae = autoEscape[i];
      if (rest.indexOf(ae) === -1)
        continue;
      var esc = encodeURIComponent(ae);
      if (esc === ae) {
        esc = escape(ae);
      }
      rest = rest.split(ae).join(esc);
    }
  }


  // chop off from the tail first.
  var hash = rest.indexOf('#');
  if (hash !== -1) {
    // got a fragment string.
    this.hash = rest.substr(hash);
    rest = rest.slice(0, hash);
  }
  var qm = rest.indexOf('?');
  if (qm !== -1) {
    this.search = rest.substr(qm);
    this.query = rest.substr(qm + 1);
    if (parseQueryString) {
      this.query = querystring.parse(this.query);
    }
    rest = rest.slice(0, qm);
  } else if (parseQueryString) {
    // no query string, but parseQueryString still requested
    this.search = '';
    this.query = {};
  }
  if (rest) this.pathname = rest;
  if (slashedProtocol[lowerProto] &&
      this.hostname && !this.pathname) {
    this.pathname = '/';
  }

  //to support http.request
  if (this.pathname || this.search) {
    var p = this.pathname || '';
    var s = this.search || '';
    this.path = p + s;
  }

  // finally, reconstruct the href based on what has been validated.
  this.href = this.format();
  return this;
};

// format a parsed object into a url string
function urlFormat(obj) {
  // ensure it's an object, and not a string url.
  // If it's an obj, this is a no-op.
  // this way, you can call url_format() on strings
  // to clean up potentially wonky urls.
  if (util.isString(obj)) obj = urlParse(obj);
  if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
  return obj.format();
}

Url.prototype.format = function() {
  var auth = this.auth || '';
  if (auth) {
    auth = encodeURIComponent(auth);
    auth = auth.replace(/%3A/i, ':');
    auth += '@';
  }

  var protocol = this.protocol || '',
      pathname = this.pathname || '',
      hash = this.hash || '',
      host = false,
      query = '';

  if (this.host) {
    host = auth + this.host;
  } else if (this.hostname) {
    host = auth + (this.hostname.indexOf(':') === -1 ?
        this.hostname :
        '[' + this.hostname + ']');
    if (this.port) {
      host += ':' + this.port;
    }
  }

  if (this.query &&
      util.isObject(this.query) &&
      Object.keys(this.query).length) {
    query = querystring.stringify(this.query);
  }

  var search = this.search || (query && ('?' + query)) || '';

  if (protocol && protocol.substr(-1) !== ':') protocol += ':';

  // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
  // unless they had them to begin with.
  if (this.slashes ||
      (!protocol || slashedProtocol[protocol]) && host !== false) {
    host = '//' + (host || '');
    if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
  } else if (!host) {
    host = '';
  }

  if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
  if (search && search.charAt(0) !== '?') search = '?' + search;

  pathname = pathname.replace(/[?#]/g, function(match) {
    return encodeURIComponent(match);
  });
  search = search.replace('#', '%23');

  return protocol + host + pathname + search + hash;
};

function urlResolve(source, relative) {
  return urlParse(source, false, true).resolve(relative);
}

Url.prototype.resolve = function(relative) {
  return this.resolveObject(urlParse(relative, false, true)).format();
};

function urlResolveObject(source, relative) {
  if (!source) return relative;
  return urlParse(source, false, true).resolveObject(relative);
}

Url.prototype.resolveObject = function(relative) {
  if (util.isString(relative)) {
    var rel = new Url();
    rel.parse(relative, false, true);
    relative = rel;
  }

  var result = new Url();
  var tkeys = Object.keys(this);
  for (var tk = 0; tk < tkeys.length; tk++) {
    var tkey = tkeys[tk];
    result[tkey] = this[tkey];
  }

  // hash is always overridden, no matter what.
  // even href="" will remove it.
  result.hash = relative.hash;

  // if the relative url is empty, then there's nothing left to do here.
  if (relative.href === '') {
    result.href = result.format();
    return result;
  }

  // hrefs like //foo/bar always cut to the protocol.
  if (relative.slashes && !relative.protocol) {
    // take everything except the protocol from relative
    var rkeys = Object.keys(relative);
    for (var rk = 0; rk < rkeys.length; rk++) {
      var rkey = rkeys[rk];
      if (rkey !== 'protocol')
        result[rkey] = relative[rkey];
    }

    //urlParse appends trailing / to urls like http://www.example.com
    if (slashedProtocol[result.protocol] &&
        result.hostname && !result.pathname) {
      result.path = result.pathname = '/';
    }

    result.href = result.format();
    return result;
  }

  if (relative.protocol && relative.protocol !== result.protocol) {
    // if it's a known url protocol, then changing
    // the protocol does weird things
    // first, if it's not file:, then we MUST have a host,
    // and if there was a path
    // to begin with, then we MUST have a path.
    // if it is file:, then the host is dropped,
    // because that's known to be hostless.
    // anything else is assumed to be absolute.
    if (!slashedProtocol[relative.protocol]) {
      var keys = Object.keys(relative);
      for (var v = 0; v < keys.length; v++) {
        var k = keys[v];
        result[k] = relative[k];
      }
      result.href = result.format();
      return result;
    }

    result.protocol = relative.protocol;
    if (!relative.host && !hostlessProtocol[relative.protocol]) {
      var relPath = (relative.pathname || '').split('/');
      while (relPath.length && !(relative.host = relPath.shift()));
      if (!relative.host) relative.host = '';
      if (!relative.hostname) relative.hostname = '';
      if (relPath[0] !== '') relPath.unshift('');
      if (relPath.length < 2) relPath.unshift('');
      result.pathname = relPath.join('/');
    } else {
      result.pathname = relative.pathname;
    }
    result.search = relative.search;
    result.query = relative.query;
    result.host = relative.host || '';
    result.auth = relative.auth;
    result.hostname = relative.hostname || relative.host;
    result.port = relative.port;
    // to support http.request
    if (result.pathname || result.search) {
      var p = result.pathname || '';
      var s = result.search || '';
      result.path = p + s;
    }
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
  }

  var isSourceAbs = (result.pathname && result.pathname.charAt(0) === '/'),
      isRelAbs = (
          relative.host ||
          relative.pathname && relative.pathname.charAt(0) === '/'
      ),
      mustEndAbs = (isRelAbs || isSourceAbs ||
                    (result.host && relative.pathname)),
      removeAllDots = mustEndAbs,
      srcPath = result.pathname && result.pathname.split('/') || [],
      relPath = relative.pathname && relative.pathname.split('/') || [],
      psychotic = result.protocol && !slashedProtocol[result.protocol];

  // if the url is a non-slashed url, then relative
  // links like ../.. should be able
  // to crawl up to the hostname, as well.  This is strange.
  // result.protocol has already been set by now.
  // Later on, put the first path part into the host field.
  if (psychotic) {
    result.hostname = '';
    result.port = null;
    if (result.host) {
      if (srcPath[0] === '') srcPath[0] = result.host;
      else srcPath.unshift(result.host);
    }
    result.host = '';
    if (relative.protocol) {
      relative.hostname = null;
      relative.port = null;
      if (relative.host) {
        if (relPath[0] === '') relPath[0] = relative.host;
        else relPath.unshift(relative.host);
      }
      relative.host = null;
    }
    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
  }

  if (isRelAbs) {
    // it's absolute.
    result.host = (relative.host || relative.host === '') ?
                  relative.host : result.host;
    result.hostname = (relative.hostname || relative.hostname === '') ?
                      relative.hostname : result.hostname;
    result.search = relative.search;
    result.query = relative.query;
    srcPath = relPath;
    // fall through to the dot-handling below.
  } else if (relPath.length) {
    // it's relative
    // throw away the existing file, and take the new path instead.
    if (!srcPath) srcPath = [];
    srcPath.pop();
    srcPath = srcPath.concat(relPath);
    result.search = relative.search;
    result.query = relative.query;
  } else if (!util.isNullOrUndefined(relative.search)) {
    // just pull out the search.
    // like href='?foo'.
    // Put this after the other two cases because it simplifies the booleans
    if (psychotic) {
      result.hostname = result.host = srcPath.shift();
      //occationaly the auth can get stuck only in host
      //this especially happens in cases like
      //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
      var authInHost = result.host && result.host.indexOf('@') > 0 ?
                       result.host.split('@') : false;
      if (authInHost) {
        result.auth = authInHost.shift();
        result.host = result.hostname = authInHost.shift();
      }
    }
    result.search = relative.search;
    result.query = relative.query;
    //to support http.request
    if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
      result.path = (result.pathname ? result.pathname : '') +
                    (result.search ? result.search : '');
    }
    result.href = result.format();
    return result;
  }

  if (!srcPath.length) {
    // no path at all.  easy.
    // we've already handled the other stuff above.
    result.pathname = null;
    //to support http.request
    if (result.search) {
      result.path = '/' + result.search;
    } else {
      result.path = null;
    }
    result.href = result.format();
    return result;
  }

  // if a url ENDs in . or .., then it must get a trailing slash.
  // however, if it ends in anything else non-slashy,
  // then it must NOT get a trailing slash.
  var last = srcPath.slice(-1)[0];
  var hasTrailingSlash = (
      (result.host || relative.host || srcPath.length > 1) &&
      (last === '.' || last === '..') || last === '');

  // strip single dots, resolve double dots to parent dir
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = srcPath.length; i >= 0; i--) {
    last = srcPath[i];
    if (last === '.') {
      srcPath.splice(i, 1);
    } else if (last === '..') {
      srcPath.splice(i, 1);
      up++;
    } else if (up) {
      srcPath.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (!mustEndAbs && !removeAllDots) {
    for (; up--; up) {
      srcPath.unshift('..');
    }
  }

  if (mustEndAbs && srcPath[0] !== '' &&
      (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
    srcPath.unshift('');
  }

  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
    srcPath.push('');
  }

  var isAbsolute = srcPath[0] === '' ||
      (srcPath[0] && srcPath[0].charAt(0) === '/');

  // put the host back
  if (psychotic) {
    result.hostname = result.host = isAbsolute ? '' :
                                    srcPath.length ? srcPath.shift() : '';
    //occationaly the auth can get stuck only in host
    //this especially happens in cases like
    //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
    var authInHost = result.host && result.host.indexOf('@') > 0 ?
                     result.host.split('@') : false;
    if (authInHost) {
      result.auth = authInHost.shift();
      result.host = result.hostname = authInHost.shift();
    }
  }

  mustEndAbs = mustEndAbs || (result.host && srcPath.length);

  if (mustEndAbs && !isAbsolute) {
    srcPath.unshift('');
  }

  if (!srcPath.length) {
    result.pathname = null;
    result.path = null;
  } else {
    result.pathname = srcPath.join('/');
  }

  //to support request.http
  if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
    result.path = (result.pathname ? result.pathname : '') +
                  (result.search ? result.search : '');
  }
  result.auth = relative.auth || result.auth;
  result.slashes = result.slashes || relative.slashes;
  result.href = result.format();
  return result;
};

Url.prototype.parseHost = function() {
  var host = this.host;
  var port = portPattern.exec(host);
  if (port) {
    port = port[0];
    if (port !== ':') {
      this.port = port.substr(1);
    }
    host = host.substr(0, host.length - port.length);
  }
  if (host) this.hostname = host;
};

},{"./util":147,"punycode":114,"querystring":143}],147:[function(require,module,exports){
'use strict';

module.exports = {
  isString: function(arg) {
    return typeof(arg) === 'string';
  },
  isObject: function(arg) {
    return typeof(arg) === 'object' && arg !== null;
  },
  isNull: function(arg) {
    return arg === null;
  },
  isNullOrUndefined: function(arg) {
    return arg == null;
  }
};

},{}]},{},[5]);
